import * as W3 from "react";
import y, { useState as W1, useEffect as G3, useRef as m4, useMemo as m3, Fragment as a2, useLayoutEffect as os, useId as am, useContext as as, createContext as Qm } from "react";
import wd from "react-dom";
import { styled as M1, useTheme as $9 } from "styled-components";
var b = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Tm(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var A0 = {}, Z9 = {};
Object.defineProperty(Z9, "__esModule", { value: !0 });
Z9.VERSION = void 0;
Z9.VERSION = "3.2.2";
var W9 = {}, F5 = {};
Object.defineProperty(F5, "__esModule", { value: !0 });
F5.PrioritizedList = void 0;
var sm = function() {
  function e() {
    this.items = [], this.items = [];
  }
  return e.prototype[Symbol.iterator] = function() {
    var t = 0, r = this.items;
    return {
      next: function() {
        return { value: r[t++], done: t > r.length };
      }
    };
  }, e.prototype.add = function(t, r) {
    r === void 0 && (r = e.DEFAULTPRIORITY);
    var n = this.items.length;
    do
      n--;
    while (n >= 0 && r < this.items[n].priority);
    return this.items.splice(n + 1, 0, { item: t, priority: r }), t;
  }, e.prototype.remove = function(t) {
    var r = this.items.length;
    do
      r--;
    while (r >= 0 && this.items[r].item !== t);
    r >= 0 && this.items.splice(r, 1);
  }, e.DEFAULTPRIORITY = 5, e;
}();
F5.PrioritizedList = sm;
var lm = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), um = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(W9, "__esModule", { value: !0 });
W9.HandlerList = void 0;
var cm = F5, fm = function(e) {
  lm(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.register = function(r) {
    return this.add(r, r.priority);
  }, t.prototype.unregister = function(r) {
    this.remove(r);
  }, t.prototype.handlesDocument = function(r) {
    var n, i;
    try {
      for (var o = um(this), a = o.next(); !a.done; a = o.next()) {
        var T = a.value, s = T.item;
        if (s.handlesDocument(r))
          return s;
      }
    } catch (Q) {
      n = { error: Q };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    throw new Error("Can't find handler for document");
  }, t.prototype.document = function(r, n) {
    return n === void 0 && (n = null), this.handlesDocument(r).create(r, n);
  }, t;
}(cm.PrioritizedList);
W9.HandlerList = fm;
var We = {};
Object.defineProperty(We, "__esModule", { value: !0 });
We.retryAfter = We.handleRetriesFor = void 0;
function dm(e) {
  return new Promise(function t(r, n) {
    try {
      r(e());
    } catch (i) {
      i.retry && i.retry instanceof Promise ? i.retry.then(function() {
        return t(r, n);
      }).catch(function(o) {
        return n(o);
      }) : i.restart && i.restart.isCallback ? MathJax.Callback.After(function() {
        return t(r, n);
      }, i.restart) : n(i);
    }
  });
}
We.handleRetriesFor = dm;
function hm(e) {
  var t = new Error("MathJax retry");
  throw t.retry = e, t;
}
We.retryAfter = hm;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.mathjax = void 0;
  var t = Z9, r = W9, n = We;
  e.mathjax = {
    version: t.VERSION,
    handlers: new r.HandlerList(),
    document: function(i, o) {
      return e.mathjax.handlers.document(i, o);
    },
    handleRetriesFor: n.handleRetriesFor,
    retryAfter: n.retryAfter,
    asyncLoad: null
  };
})(A0);
var Qs = {}, D0 = {}, r4 = {};
(function(e) {
  var t = b && b.__values || function(H) {
    var E = typeof Symbol == "function" && Symbol.iterator, M = E && H[E], C = 0;
    if (M)
      return M.call(H);
    if (H && typeof H.length == "number")
      return {
        next: function() {
          return H && C >= H.length && (H = void 0), { value: H && H[C++], done: !H };
        }
      };
    throw new TypeError(E ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = b && b.__read || function(H, E) {
    var M = typeof Symbol == "function" && H[Symbol.iterator];
    if (!M)
      return H;
    var C = M.call(H), w, S = [], D;
    try {
      for (; (E === void 0 || E-- > 0) && !(w = C.next()).done; )
        S.push(w.value);
    } catch (k) {
      D = { error: k };
    } finally {
      try {
        w && !w.done && (M = C.return) && M.call(C);
      } finally {
        if (D)
          throw D.error;
      }
    }
    return S;
  }, n = b && b.__spreadArray || function(H, E, M) {
    if (M || arguments.length === 2)
      for (var C = 0, w = E.length, S; C < w; C++)
        (S || !(C in E)) && (S || (S = Array.prototype.slice.call(E, 0, C)), S[C] = E[C]);
    return H.concat(S || Array.prototype.slice.call(E));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.lookup = e.separateOptions = e.selectOptionsFromKeys = e.selectOptions = e.userOptions = e.defaultOptions = e.insert = e.copy = e.keys = e.makeArray = e.expandable = e.Expandable = e.OPTIONS = e.REMOVE = e.APPEND = e.isObject = void 0;
  var i = {}.constructor;
  function o(H) {
    return typeof H == "object" && H !== null && (H.constructor === i || H.constructor === a);
  }
  e.isObject = o, e.APPEND = "[+]", e.REMOVE = "[-]", e.OPTIONS = {
    invalidOption: "warn",
    optionError: function(H, E) {
      if (e.OPTIONS.invalidOption === "fatal")
        throw new Error(H);
      console.warn("MathJax: " + H);
    }
  };
  var a = /* @__PURE__ */ function() {
    function H() {
    }
    return H;
  }();
  e.Expandable = a;
  function T(H) {
    return Object.assign(Object.create(a.prototype), H);
  }
  e.expandable = T;
  function s(H) {
    return Array.isArray(H) ? H : [H];
  }
  e.makeArray = s;
  function Q(H) {
    return H ? Object.keys(H).concat(Object.getOwnPropertySymbols(H)) : [];
  }
  e.keys = Q;
  function u(H) {
    var E, M, C = {};
    try {
      for (var w = t(Q(H)), S = w.next(); !S.done; S = w.next()) {
        var D = S.value, k = Object.getOwnPropertyDescriptor(H, D), $ = k.value;
        Array.isArray($) ? k.value = l([], $, !1) : o($) && (k.value = u($)), k.enumerable && (C[D] = k);
      }
    } catch (z) {
      E = { error: z };
    } finally {
      try {
        S && !S.done && (M = w.return) && M.call(w);
      } finally {
        if (E)
          throw E.error;
      }
    }
    return Object.defineProperties(H.constructor === a ? T({}) : {}, C);
  }
  e.copy = u;
  function l(H, E, M) {
    var C, w;
    M === void 0 && (M = !0);
    var S = function(z) {
      if (M && H[z] === void 0 && H.constructor !== a)
        return typeof z == "symbol" && (z = z.toString()), e.OPTIONS.optionError('Invalid option "'.concat(z, '" (no default value).'), z), "continue";
      var j = E[z], J = H[z];
      if (o(j) && J !== null && (typeof J == "object" || typeof J == "function")) {
        var i1 = Q(j);
        Array.isArray(J) && (i1.length === 1 && (i1[0] === e.APPEND || i1[0] === e.REMOVE) && Array.isArray(j[i1[0]]) || i1.length === 2 && i1.sort().join(",") === e.APPEND + "," + e.REMOVE && Array.isArray(j[e.APPEND]) && Array.isArray(j[e.REMOVE])) ? (j[e.REMOVE] && (J = H[z] = J.filter(function(t1) {
          return j[e.REMOVE].indexOf(t1) < 0;
        })), j[e.APPEND] && (H[z] = n(n([], r(J), !1), r(j[e.APPEND]), !1))) : l(J, j, M);
      } else
        Array.isArray(j) ? (H[z] = [], l(H[z], j, !1)) : o(j) ? H[z] = u(j) : H[z] = j;
    };
    try {
      for (var D = t(Q(E)), k = D.next(); !k.done; k = D.next()) {
        var $ = k.value;
        S($);
      }
    } catch (z) {
      C = { error: z };
    } finally {
      try {
        k && !k.done && (w = D.return) && w.call(D);
      } finally {
        if (C)
          throw C.error;
      }
    }
    return H;
  }
  e.insert = l;
  function c(H) {
    for (var E = [], M = 1; M < arguments.length; M++)
      E[M - 1] = arguments[M];
    return E.forEach(function(C) {
      return l(H, C, !1);
    }), H;
  }
  e.defaultOptions = c;
  function f(H) {
    for (var E = [], M = 1; M < arguments.length; M++)
      E[M - 1] = arguments[M];
    return E.forEach(function(C) {
      return l(H, C, !0);
    }), H;
  }
  e.userOptions = f;
  function d(H) {
    for (var E, M, C = [], w = 1; w < arguments.length; w++)
      C[w - 1] = arguments[w];
    var S = {};
    try {
      for (var D = t(C), k = D.next(); !k.done; k = D.next()) {
        var $ = k.value;
        H.hasOwnProperty($) && (S[$] = H[$]);
      }
    } catch (z) {
      E = { error: z };
    } finally {
      try {
        k && !k.done && (M = D.return) && M.call(D);
      } finally {
        if (E)
          throw E.error;
      }
    }
    return S;
  }
  e.selectOptions = d;
  function m(H, E) {
    return d.apply(void 0, n([H], r(Object.keys(E)), !1));
  }
  e.selectOptionsFromKeys = m;
  function p(H) {
    for (var E, M, C, w, S = [], D = 1; D < arguments.length; D++)
      S[D - 1] = arguments[D];
    var k = [];
    try {
      for (var $ = t(S), z = $.next(); !z.done; z = $.next()) {
        var j = z.value, J = {}, i1 = {};
        try {
          for (var t1 = (C = void 0, t(Object.keys(H || {}))), T1 = t1.next(); !T1.done; T1 = t1.next()) {
            var X = T1.value;
            (j[X] === void 0 ? i1 : J)[X] = H[X];
          }
        } catch (f1) {
          C = { error: f1 };
        } finally {
          try {
            T1 && !T1.done && (w = t1.return) && w.call(t1);
          } finally {
            if (C)
              throw C.error;
          }
        }
        k.push(J), H = i1;
      }
    } catch (f1) {
      E = { error: f1 };
    } finally {
      try {
        z && !z.done && (M = $.return) && M.call($);
      } finally {
        if (E)
          throw E.error;
      }
    }
    return k.unshift(H), k;
  }
  e.separateOptions = p;
  function v(H, E, M) {
    return M === void 0 && (M = null), E.hasOwnProperty(H) ? E[H] : M;
  }
  e.lookup = v;
})(r4);
var j5 = {}, pm = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mm = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, vl = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Ll = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(j5, "__esModule", { value: !0 });
j5.FunctionList = void 0;
var vm = F5, Lm = function(e) {
  pm(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.execute = function() {
    for (var r, n, i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    try {
      for (var a = mm(this), T = a.next(); !T.done; T = a.next()) {
        var s = T.value, Q = s.item.apply(s, Ll([], vl(i), !1));
        if (Q === !1)
          return !1;
      }
    } catch (u) {
      r = { error: u };
    } finally {
      try {
        T && !T.done && (n = a.return) && n.call(a);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return !0;
  }, t.prototype.asyncExecute = function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    var i = -1, o = this.items;
    return new Promise(function(a, T) {
      (function s() {
        for (var Q; ++i < o.length; ) {
          var u = (Q = o[i]).item.apply(Q, Ll([], vl(r), !1));
          if (u instanceof Promise) {
            u.then(s).catch(function(l) {
              return T(l);
            });
            return;
          }
          if (u === !1) {
            a(!1);
            return;
          }
        }
        a(!0);
      })();
    });
  }, t;
}(vm.PrioritizedList);
j5.FunctionList = Lm;
Object.defineProperty(D0, "__esModule", { value: !0 });
D0.AbstractInputJax = void 0;
var yl = r4, gl = j5, ym = function() {
  function e(t) {
    t === void 0 && (t = {}), this.adaptor = null, this.mmlFactory = null;
    var r = this.constructor;
    this.options = (0, yl.userOptions)((0, yl.defaultOptions)({}, r.OPTIONS), t), this.preFilters = new gl.FunctionList(), this.postFilters = new gl.FunctionList();
  }
  return Object.defineProperty(e.prototype, "name", {
    get: function() {
      return this.constructor.NAME;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.setAdaptor = function(t) {
    this.adaptor = t;
  }, e.prototype.setMmlFactory = function(t) {
    this.mmlFactory = t;
  }, e.prototype.initialize = function() {
  }, e.prototype.reset = function() {
  }, Object.defineProperty(e.prototype, "processStrings", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.findMath = function(t, r) {
    return [];
  }, e.prototype.executeFilters = function(t, r, n, i) {
    var o = { math: r, document: n, data: i };
    return t.execute(o), o.data;
  }, e.NAME = "generic", e.OPTIONS = {}, e;
}();
D0.AbstractInputJax = ym;
var G9 = {}, Rr = {};
Object.defineProperty(Rr, "__esModule", { value: !0 });
Rr.AbstractFindMath = void 0;
var xl = r4, gm = function() {
  function e(t) {
    var r = this.constructor;
    this.options = (0, xl.userOptions)((0, xl.defaultOptions)({}, r.OPTIONS), t);
  }
  return e.OPTIONS = {}, e;
}();
Rr.AbstractFindMath = gm;
var Q3 = {}, xm = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Hm = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(Q3, "__esModule", { value: !0 });
Q3.split = Q3.isPercent = Q3.unicodeString = Q3.unicodeChars = Q3.quotePattern = Q3.sortLength = void 0;
function Em(e, t) {
  return e.length !== t.length ? t.length - e.length : e === t ? 0 : e < t ? -1 : 1;
}
Q3.sortLength = Em;
function bm(e) {
  return e.replace(/([\^$(){}+*?\-|\[\]\:\\])/g, "\\$1");
}
Q3.quotePattern = bm;
function Mm(e) {
  return Array.from(e).map(function(t) {
    return t.codePointAt(0);
  });
}
Q3.unicodeChars = Mm;
function wm(e) {
  return String.fromCodePoint.apply(String, Hm([], xm(e), !1));
}
Q3.unicodeString = wm;
function Sm(e) {
  return !!e.match(/%\s*$/);
}
Q3.isPercent = Sm;
function Cm(e) {
  return e.trim().split(/\s+/);
}
Q3.split = Cm;
var tt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.newState = e.STATE = e.AbstractMathItem = e.protoItem = void 0;
  function t(i, o, a, T, s, Q, u) {
    u === void 0 && (u = null);
    var l = {
      open: i,
      math: o,
      close: a,
      n: T,
      start: { n: s },
      end: { n: Q },
      display: u
    };
    return l;
  }
  e.protoItem = t;
  var r = function() {
    function i(o, a, T, s, Q) {
      T === void 0 && (T = !0), s === void 0 && (s = { i: 0, n: 0, delim: "" }), Q === void 0 && (Q = { i: 0, n: 0, delim: "" }), this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {}, this._state = e.STATE.UNPROCESSED, this.math = o, this.inputJax = a, this.display = T, this.start = s, this.end = Q, this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {};
    }
    return Object.defineProperty(i.prototype, "isEscaped", {
      get: function() {
        return this.display === null;
      },
      enumerable: !1,
      configurable: !0
    }), i.prototype.render = function(o) {
      o.renderActions.renderMath(this, o);
    }, i.prototype.rerender = function(o, a) {
      a === void 0 && (a = e.STATE.RERENDER), this.state() >= a && this.state(a - 1), o.renderActions.renderMath(this, o, a);
    }, i.prototype.convert = function(o, a) {
      a === void 0 && (a = e.STATE.LAST), o.renderActions.renderConvert(this, o, a);
    }, i.prototype.compile = function(o) {
      this.state() < e.STATE.COMPILED && (this.root = this.inputJax.compile(this, o), this.state(e.STATE.COMPILED));
    }, i.prototype.typeset = function(o) {
      this.state() < e.STATE.TYPESET && (this.typesetRoot = o.outputJax[this.isEscaped ? "escaped" : "typeset"](this, o), this.state(e.STATE.TYPESET));
    }, i.prototype.updateDocument = function(o) {
    }, i.prototype.removeFromDocument = function(o) {
    }, i.prototype.setMetrics = function(o, a, T, s, Q) {
      this.metrics = {
        em: o,
        ex: a,
        containerWidth: T,
        lineWidth: s,
        scale: Q
      };
    }, i.prototype.state = function(o, a) {
      return o === void 0 && (o = null), a === void 0 && (a = !1), o != null && (o < e.STATE.INSERTED && this._state >= e.STATE.INSERTED && this.removeFromDocument(a), o < e.STATE.TYPESET && this._state >= e.STATE.TYPESET && (this.outputData = {}), o < e.STATE.COMPILED && this._state >= e.STATE.COMPILED && (this.inputData = {}), this._state = o), this._state;
    }, i.prototype.reset = function(o) {
      o === void 0 && (o = !1), this.state(e.STATE.UNPROCESSED, o);
    }, i;
  }();
  e.AbstractMathItem = r, e.STATE = {
    UNPROCESSED: 0,
    FINDMATH: 10,
    COMPILED: 20,
    CONVERT: 100,
    METRICS: 110,
    RERENDER: 125,
    TYPESET: 150,
    INSERTED: 200,
    LAST: 1e4
  };
  function n(i, o) {
    if (i in e.STATE)
      throw Error("State " + i + " already exists");
    e.STATE[i] = o;
  }
  e.newState = n;
})(tt);
var Vm = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Hl = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
};
Object.defineProperty(G9, "__esModule", { value: !0 });
G9.FindTeX = void 0;
var _m = Rr, sn = Q3, oQ = tt, Om = function(e) {
  Vm(t, e);
  function t(r) {
    var n = e.call(this, r) || this;
    return n.getPatterns(), n;
  }
  return t.prototype.getPatterns = function() {
    var r = this, n = this.options, i = [], o = [], a = [];
    this.end = {}, this.env = this.sub = 0;
    var T = 1;
    n.inlineMath.forEach(function(s) {
      return r.addPattern(i, s, !1);
    }), n.displayMath.forEach(function(s) {
      return r.addPattern(i, s, !0);
    }), i.length && o.push(i.sort(sn.sortLength).join("|")), n.processEnvironments && (o.push("\\\\begin\\s*\\{([^}]*)\\}"), this.env = T, T++), n.processEscapes && a.push("\\\\([\\\\$])"), n.processRefs && a.push("(\\\\(?:eq)?ref\\s*\\{[^}]*\\})"), a.length && (o.push("(" + a.join("|") + ")"), this.sub = T), this.start = new RegExp(o.join("|"), "g"), this.hasPatterns = o.length > 0;
  }, t.prototype.addPattern = function(r, n, i) {
    var o = Hl(n, 2), a = o[0], T = o[1];
    r.push((0, sn.quotePattern)(a)), this.end[a] = [T, i, this.endPattern(T)];
  }, t.prototype.endPattern = function(r, n) {
    return new RegExp((n || (0, sn.quotePattern)(r)) + "|\\\\(?:[a-zA-Z]|.)|[{}]", "g");
  }, t.prototype.findEnd = function(r, n, i, o) {
    for (var a = Hl(o, 3), T = a[0], s = a[1], Q = a[2], u = Q.lastIndex = i.index + i[0].length, l, c = 0; l = Q.exec(r); ) {
      if ((l[1] || l[0]) === T && c === 0)
        return (0, oQ.protoItem)(i[0], r.substr(u, l.index - u), l[0], n, i.index, l.index + l[0].length, s);
      l[0] === "{" ? c++ : l[0] === "}" && c && c--;
    }
    return null;
  }, t.prototype.findMathInString = function(r, n, i) {
    var o, a;
    for (this.start.lastIndex = 0; o = this.start.exec(i); ) {
      if (o[this.env] !== void 0 && this.env) {
        var T = "\\\\end\\s*(\\{" + (0, sn.quotePattern)(o[this.env]) + "\\})";
        a = this.findEnd(i, n, o, ["{" + o[this.env] + "}", !0, this.endPattern(null, T)]), a && (a.math = a.open + a.math + a.close, a.open = a.close = "");
      } else if (o[this.sub] !== void 0 && this.sub) {
        var s = o[this.sub], T = o.index + o[this.sub].length;
        s.length === 2 ? a = (0, oQ.protoItem)("", s.substr(1), "", n, o.index, T) : a = (0, oQ.protoItem)("", s, "", n, o.index, T, !1);
      } else
        a = this.findEnd(i, n, o, this.end[o[0]]);
      a && (r.push(a), this.start.lastIndex = a.end.n);
    }
  }, t.prototype.findMath = function(r) {
    var n = [];
    if (this.hasPatterns)
      for (var i = 0, o = r.length; i < o; i++)
        this.findMathInString(n, i, r[i]);
    return n;
  }, t.OPTIONS = {
    inlineMath: [
      ["\\(", "\\)"]
    ],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"]
    ],
    processEscapes: !0,
    processEnvironments: !0,
    processRefs: !0
  }, t;
}(_m.AbstractFindMath);
G9.FindTeX = Om;
var Ts = {}, T2 = {}, k0 = {};
(function(e) {
  var t = b && b.__values || function(n) {
    var i = typeof Symbol == "function" && Symbol.iterator, o = i && n[i], a = 0;
    if (o)
      return o.call(n);
    if (n && typeof n.length == "number")
      return {
        next: function() {
          return n && a >= n.length && (n = void 0), { value: n && n[a++], done: !n };
        }
      };
    throw new TypeError(i ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Attributes = e.INHERIT = void 0, e.INHERIT = "_inherit_";
  var r = function() {
    function n(i, o) {
      this.global = o, this.defaults = Object.create(o), this.inherited = Object.create(this.defaults), this.attributes = Object.create(this.inherited), Object.assign(this.defaults, i);
    }
    return n.prototype.set = function(i, o) {
      this.attributes[i] = o;
    }, n.prototype.setList = function(i) {
      Object.assign(this.attributes, i);
    }, n.prototype.get = function(i) {
      var o = this.attributes[i];
      return o === e.INHERIT && (o = this.global[i]), o;
    }, n.prototype.getExplicit = function(i) {
      if (this.attributes.hasOwnProperty(i))
        return this.attributes[i];
    }, n.prototype.getList = function() {
      for (var i, o, a = [], T = 0; T < arguments.length; T++)
        a[T] = arguments[T];
      var s = {};
      try {
        for (var Q = t(a), u = Q.next(); !u.done; u = Q.next()) {
          var l = u.value;
          s[l] = this.get(l);
        }
      } catch (c) {
        i = { error: c };
      } finally {
        try {
          u && !u.done && (o = Q.return) && o.call(Q);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return s;
    }, n.prototype.setInherited = function(i, o) {
      this.inherited[i] = o;
    }, n.prototype.getInherited = function(i) {
      return this.inherited[i];
    }, n.prototype.getDefault = function(i) {
      return this.defaults[i];
    }, n.prototype.isSet = function(i) {
      return this.attributes.hasOwnProperty(i) || this.inherited.hasOwnProperty(i);
    }, n.prototype.hasDefault = function(i) {
      return i in this.defaults;
    }, n.prototype.getExplicitNames = function() {
      return Object.keys(this.attributes);
    }, n.prototype.getInheritedNames = function() {
      return Object.keys(this.inherited);
    }, n.prototype.getDefaultNames = function() {
      return Object.keys(this.defaults);
    }, n.prototype.getGlobalNames = function() {
      return Object.keys(this.global);
    }, n.prototype.getAllAttributes = function() {
      return this.attributes;
    }, n.prototype.getAllInherited = function() {
      return this.inherited;
    }, n.prototype.getAllDefaults = function() {
      return this.defaults;
    }, n.prototype.getAllGlobals = function() {
      return this.global;
    }, n;
  }();
  e.Attributes = r;
})(k0);
var H0 = {}, Am = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), aT = b && b.__assign || function() {
  return aT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, aT.apply(this, arguments);
}, B7 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(H0, "__esModule", { value: !0 });
H0.AbstractEmptyNode = H0.AbstractNode = void 0;
var Cd = function() {
  function e(t, r, n) {
    var i, o;
    r === void 0 && (r = {}), n === void 0 && (n = []), this.factory = t, this.parent = null, this.properties = {}, this.childNodes = [];
    try {
      for (var a = B7(Object.keys(r)), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        this.setProperty(s, r[s]);
      }
    } catch (Q) {
      i = { error: Q };
    } finally {
      try {
        T && !T.done && (o = a.return) && o.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
    n.length && this.setChildren(n);
  }
  return Object.defineProperty(e.prototype, "kind", {
    get: function() {
      return "unknown";
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.setProperty = function(t, r) {
    this.properties[t] = r;
  }, e.prototype.getProperty = function(t) {
    return this.properties[t];
  }, e.prototype.getPropertyNames = function() {
    return Object.keys(this.properties);
  }, e.prototype.getAllProperties = function() {
    return this.properties;
  }, e.prototype.removeProperty = function() {
    for (var t, r, n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    try {
      for (var o = B7(n), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        delete this.properties[T];
      }
    } catch (s) {
      t = { error: s };
    } finally {
      try {
        a && !a.done && (r = o.return) && r.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
  }, e.prototype.isKind = function(t) {
    return this.factory.nodeIsKind(this, t);
  }, e.prototype.setChildren = function(t) {
    var r, n;
    this.childNodes = [];
    try {
      for (var i = B7(t), o = i.next(); !o.done; o = i.next()) {
        var a = o.value;
        this.appendChild(a);
      }
    } catch (T) {
      r = { error: T };
    } finally {
      try {
        o && !o.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, e.prototype.appendChild = function(t) {
    return this.childNodes.push(t), t.parent = this, t;
  }, e.prototype.replaceChild = function(t, r) {
    var n = this.childIndex(r);
    return n !== null && (this.childNodes[n] = t, t.parent = this, r.parent = null), t;
  }, e.prototype.removeChild = function(t) {
    var r = this.childIndex(t);
    return r !== null && (this.childNodes.splice(r, 1), t.parent = null), t;
  }, e.prototype.childIndex = function(t) {
    var r = this.childNodes.indexOf(t);
    return r === -1 ? null : r;
  }, e.prototype.copy = function() {
    var t, r, n = this.factory.create(this.kind);
    n.properties = aT({}, this.properties);
    try {
      for (var i = B7(this.childNodes || []), o = i.next(); !o.done; o = i.next()) {
        var a = o.value;
        a && n.appendChild(a.copy());
      }
    } catch (T) {
      t = { error: T };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (t)
          throw t.error;
      }
    }
    return n;
  }, e.prototype.findNodes = function(t) {
    var r = [];
    return this.walkTree(function(n) {
      n.isKind(t) && r.push(n);
    }), r;
  }, e.prototype.walkTree = function(t, r) {
    var n, i;
    t(this, r);
    try {
      for (var o = B7(this.childNodes), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        T && T.walkTree(t, r);
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return r;
  }, e.prototype.toString = function() {
    return this.kind + "(" + this.childNodes.join(",") + ")";
  }, e;
}();
H0.AbstractNode = Cd;
var Dm = function(e) {
  Am(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.setChildren = function(r) {
  }, t.prototype.appendChild = function(r) {
    return r;
  }, t.prototype.replaceChild = function(r, n) {
    return n;
  }, t.prototype.childIndex = function(r) {
    return null;
  }, t.prototype.walkTree = function(r, n) {
    return r(this, n), n;
  }, t.prototype.toString = function() {
    return this.kind;
  }, t;
}(Cd);
H0.AbstractEmptyNode = Dm;
(function(e) {
  var t = b && b.__extends || /* @__PURE__ */ function() {
    var p = function(v, H) {
      return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, M) {
        E.__proto__ = M;
      } || function(E, M) {
        for (var C in M)
          Object.prototype.hasOwnProperty.call(M, C) && (E[C] = M[C]);
      }, p(v, H);
    };
    return function(v, H) {
      if (typeof H != "function" && H !== null)
        throw new TypeError("Class extends value " + String(H) + " is not a constructor or null");
      p(v, H);
      function E() {
        this.constructor = v;
      }
      v.prototype = H === null ? Object.create(H) : (E.prototype = H.prototype, new E());
    };
  }(), r = b && b.__assign || function() {
    return r = Object.assign || function(p) {
      for (var v, H = 1, E = arguments.length; H < E; H++) {
        v = arguments[H];
        for (var M in v)
          Object.prototype.hasOwnProperty.call(v, M) && (p[M] = v[M]);
      }
      return p;
    }, r.apply(this, arguments);
  }, n = b && b.__values || function(p) {
    var v = typeof Symbol == "function" && Symbol.iterator, H = v && p[v], E = 0;
    if (H)
      return H.call(p);
    if (p && typeof p.length == "number")
      return {
        next: function() {
          return p && E >= p.length && (p = void 0), { value: p && p[E++], done: !p };
        }
      };
    throw new TypeError(v ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, i = b && b.__read || function(p, v) {
    var H = typeof Symbol == "function" && p[Symbol.iterator];
    if (!H)
      return p;
    var E = H.call(p), M, C = [], w;
    try {
      for (; (v === void 0 || v-- > 0) && !(M = E.next()).done; )
        C.push(M.value);
    } catch (S) {
      w = { error: S };
    } finally {
      try {
        M && !M.done && (H = E.return) && H.call(E);
      } finally {
        if (w)
          throw w.error;
      }
    }
    return C;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.XMLNode = e.TextNode = e.AbstractMmlEmptyNode = e.AbstractMmlBaseNode = e.AbstractMmlLayoutNode = e.AbstractMmlTokenNode = e.AbstractMmlNode = e.indentAttributes = e.TEXCLASSNAMES = e.TEXCLASS = void 0;
  var o = k0, a = H0;
  e.TEXCLASS = {
    ORD: 0,
    OP: 1,
    BIN: 2,
    REL: 3,
    OPEN: 4,
    CLOSE: 5,
    PUNCT: 6,
    INNER: 7,
    VCENTER: 8,
    NONE: -1
  }, e.TEXCLASSNAMES = ["ORD", "OP", "BIN", "REL", "OPEN", "CLOSE", "PUNCT", "INNER", "VCENTER"];
  var T = ["", "thinmathspace", "mediummathspace", "thickmathspace"], s = [
    [0, -1, 2, 3, 0, 0, 0, 1],
    [-1, -1, 0, 3, 0, 0, 0, 1],
    [2, 2, 0, 0, 2, 0, 0, 2],
    [3, 3, 0, 0, 3, 0, 0, 3],
    [0, 0, 0, 0, 0, 0, 0, 0],
    [0, -1, 2, 3, 0, 0, 0, 1],
    [1, 1, 0, 1, 1, 1, 1, 1],
    [1, -1, 2, 3, 1, 0, 1, 1]
  ];
  e.indentAttributes = [
    "indentalign",
    "indentalignfirst",
    "indentshift",
    "indentshiftfirst"
  ];
  var Q = function(p) {
    t(v, p);
    function v(H, E, M) {
      E === void 0 && (E = {}), M === void 0 && (M = []);
      var C = p.call(this, H) || this;
      return C.prevClass = null, C.prevLevel = null, C.texclass = null, C.arity < 0 && (C.childNodes = [H.create("inferredMrow")], C.childNodes[0].parent = C), C.setChildren(M), C.attributes = new o.Attributes(H.getNodeClass(C.kind).defaults, H.getNodeClass("math").defaults), C.attributes.setList(E), C;
    }
    return v.prototype.copy = function(H) {
      var E, M, C, w;
      H === void 0 && (H = !1);
      var S = this.factory.create(this.kind);
      if (S.properties = r({}, this.properties), this.attributes) {
        var D = this.attributes.getAllAttributes();
        try {
          for (var k = n(Object.keys(D)), $ = k.next(); !$.done; $ = k.next()) {
            var z = $.value;
            (z !== "id" || H) && S.attributes.set(z, D[z]);
          }
        } catch (T1) {
          E = { error: T1 };
        } finally {
          try {
            $ && !$.done && (M = k.return) && M.call(k);
          } finally {
            if (E)
              throw E.error;
          }
        }
      }
      if (this.childNodes && this.childNodes.length) {
        var j = this.childNodes;
        j.length === 1 && j[0].isInferred && (j = j[0].childNodes);
        try {
          for (var J = n(j), i1 = J.next(); !i1.done; i1 = J.next()) {
            var t1 = i1.value;
            t1 ? S.appendChild(t1.copy()) : S.childNodes.push(null);
          }
        } catch (T1) {
          C = { error: T1 };
        } finally {
          try {
            i1 && !i1.done && (w = J.return) && w.call(J);
          } finally {
            if (C)
              throw C.error;
          }
        }
      }
      return S;
    }, Object.defineProperty(v.prototype, "texClass", {
      get: function() {
        return this.texclass;
      },
      set: function(H) {
        this.texclass = H;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isToken", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isEmbellished", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isSpacelike", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "linebreakContainer", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "hasNewLine", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "arity", {
      get: function() {
        return 1 / 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isInferred", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "Parent", {
      get: function() {
        for (var H = this.parent; H && H.notParent; )
          H = H.Parent;
        return H;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "notParent", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.setChildren = function(H) {
      return this.arity < 0 ? this.childNodes[0].setChildren(H) : p.prototype.setChildren.call(this, H);
    }, v.prototype.appendChild = function(H) {
      var E, M, C = this;
      if (this.arity < 0)
        return this.childNodes[0].appendChild(H), H;
      if (H.isInferred) {
        if (this.arity === 1 / 0)
          return H.childNodes.forEach(function($) {
            return p.prototype.appendChild.call(C, $);
          }), H;
        var w = H;
        H = this.factory.create("mrow"), H.setChildren(w.childNodes), H.attributes = w.attributes;
        try {
          for (var S = n(w.getPropertyNames()), D = S.next(); !D.done; D = S.next()) {
            var k = D.value;
            H.setProperty(k, w.getProperty(k));
          }
        } catch ($) {
          E = { error: $ };
        } finally {
          try {
            D && !D.done && (M = S.return) && M.call(S);
          } finally {
            if (E)
              throw E.error;
          }
        }
      }
      return p.prototype.appendChild.call(this, H);
    }, v.prototype.replaceChild = function(H, E) {
      return this.arity < 0 ? (this.childNodes[0].replaceChild(H, E), H) : p.prototype.replaceChild.call(this, H, E);
    }, v.prototype.core = function() {
      return this;
    }, v.prototype.coreMO = function() {
      return this;
    }, v.prototype.coreIndex = function() {
      return 0;
    }, v.prototype.childPosition = function() {
      for (var H, E, M = this, C = M.parent; C && C.notParent; )
        M = C, C = C.parent;
      if (C) {
        var w = 0;
        try {
          for (var S = n(C.childNodes), D = S.next(); !D.done; D = S.next()) {
            var k = D.value;
            if (k === M)
              return w;
            w++;
          }
        } catch ($) {
          H = { error: $ };
        } finally {
          try {
            D && !D.done && (E = S.return) && E.call(S);
          } finally {
            if (H)
              throw H.error;
          }
        }
      }
      return null;
    }, v.prototype.setTeXclass = function(H) {
      return this.getPrevClass(H), this.texClass != null ? this : H;
    }, v.prototype.updateTeXclass = function(H) {
      H && (this.prevClass = H.prevClass, this.prevLevel = H.prevLevel, H.prevClass = H.prevLevel = null, this.texClass = H.texClass);
    }, v.prototype.getPrevClass = function(H) {
      H && (this.prevClass = H.texClass, this.prevLevel = H.attributes.get("scriptlevel"));
    }, v.prototype.texSpacing = function() {
      var H = this.prevClass != null ? this.prevClass : e.TEXCLASS.NONE, E = this.texClass || e.TEXCLASS.ORD;
      if (H === e.TEXCLASS.NONE || E === e.TEXCLASS.NONE)
        return "";
      H === e.TEXCLASS.VCENTER && (H = e.TEXCLASS.ORD), E === e.TEXCLASS.VCENTER && (E = e.TEXCLASS.ORD);
      var M = s[H][E];
      return (this.prevLevel > 0 || this.attributes.get("scriptlevel") > 0) && M >= 0 ? "" : T[Math.abs(M)];
    }, v.prototype.hasSpacingAttributes = function() {
      return this.isEmbellished && this.coreMO().hasSpacingAttributes();
    }, v.prototype.setInheritedAttributes = function(H, E, M, C) {
      var w, S;
      H === void 0 && (H = {}), E === void 0 && (E = !1), M === void 0 && (M = 0), C === void 0 && (C = !1);
      var D = this.attributes.getAllDefaults();
      try {
        for (var k = n(Object.keys(H)), $ = k.next(); !$.done; $ = k.next()) {
          var z = $.value;
          if (D.hasOwnProperty(z) || v.alwaysInherit.hasOwnProperty(z)) {
            var j = i(H[z], 2), J = j[0], i1 = j[1], t1 = (v.noInherit[J] || {})[this.kind] || {};
            t1[z] || this.attributes.setInherited(z, i1);
          }
        }
      } catch (s1) {
        w = { error: s1 };
      } finally {
        try {
          $ && !$.done && (S = k.return) && S.call(k);
        } finally {
          if (w)
            throw w.error;
        }
      }
      var T1 = this.attributes.getExplicit("displaystyle");
      T1 === void 0 && this.attributes.setInherited("displaystyle", E);
      var X = this.attributes.getExplicit("scriptlevel");
      X === void 0 && this.attributes.setInherited("scriptlevel", M), C && this.setProperty("texprimestyle", C);
      var f1 = this.arity;
      if (f1 >= 0 && f1 !== 1 / 0 && (f1 === 1 && this.childNodes.length === 0 || f1 !== 1 && this.childNodes.length !== f1))
        if (f1 < this.childNodes.length)
          this.childNodes = this.childNodes.slice(0, f1);
        else
          for (; this.childNodes.length < f1; )
            this.appendChild(this.factory.create("mrow"));
      this.setChildInheritedAttributes(H, E, M, C);
    }, v.prototype.setChildInheritedAttributes = function(H, E, M, C) {
      var w, S;
      try {
        for (var D = n(this.childNodes), k = D.next(); !k.done; k = D.next()) {
          var $ = k.value;
          $.setInheritedAttributes(H, E, M, C);
        }
      } catch (z) {
        w = { error: z };
      } finally {
        try {
          k && !k.done && (S = D.return) && S.call(D);
        } finally {
          if (w)
            throw w.error;
        }
      }
    }, v.prototype.addInheritedAttributes = function(H, E) {
      var M, C, w = r({}, H);
      try {
        for (var S = n(Object.keys(E)), D = S.next(); !D.done; D = S.next()) {
          var k = D.value;
          k !== "displaystyle" && k !== "scriptlevel" && k !== "style" && (w[k] = [this.kind, E[k]]);
        }
      } catch ($) {
        M = { error: $ };
      } finally {
        try {
          D && !D.done && (C = S.return) && C.call(S);
        } finally {
          if (M)
            throw M.error;
        }
      }
      return w;
    }, v.prototype.inheritAttributesFrom = function(H) {
      var E = H.attributes, M = E.get("displaystyle"), C = E.get("scriptlevel"), w = E.isSet("mathsize") ? {
        mathsize: ["math", E.get("mathsize")]
      } : {}, S = H.getProperty("texprimestyle") || !1;
      this.setInheritedAttributes(w, M, C, S);
    }, v.prototype.verifyTree = function(H) {
      if (H === void 0 && (H = null), H !== null) {
        this.verifyAttributes(H);
        var E = this.arity;
        H.checkArity && E >= 0 && E !== 1 / 0 && (E === 1 && this.childNodes.length === 0 || E !== 1 && this.childNodes.length !== E) && this.mError('Wrong number of children for "' + this.kind + '" node', H, !0), this.verifyChildren(H);
      }
    }, v.prototype.verifyAttributes = function(H) {
      var E, M;
      if (H.checkAttributes) {
        var C = this.attributes, w = [];
        try {
          for (var S = n(C.getExplicitNames()), D = S.next(); !D.done; D = S.next()) {
            var k = D.value;
            k.substr(0, 5) !== "data-" && C.getDefault(k) === void 0 && !k.match(/^(?:class|style|id|(?:xlink:)?href)$/) && w.push(k);
          }
        } catch ($) {
          E = { error: $ };
        } finally {
          try {
            D && !D.done && (M = S.return) && M.call(S);
          } finally {
            if (E)
              throw E.error;
          }
        }
        w.length && this.mError("Unknown attributes for " + this.kind + " node: " + w.join(", "), H);
      }
    }, v.prototype.verifyChildren = function(H) {
      var E, M;
      try {
        for (var C = n(this.childNodes), w = C.next(); !w.done; w = C.next()) {
          var S = w.value;
          S.verifyTree(H);
        }
      } catch (D) {
        E = { error: D };
      } finally {
        try {
          w && !w.done && (M = C.return) && M.call(C);
        } finally {
          if (E)
            throw E.error;
        }
      }
    }, v.prototype.mError = function(H, E, M) {
      if (M === void 0 && (M = !1), this.parent && this.parent.isKind("merror"))
        return null;
      var C = this.factory.create("merror");
      if (C.attributes.set("data-mjx-message", H), E.fullErrors || M) {
        var w = this.factory.create("mtext"), S = this.factory.create("text");
        S.setText(E.fullErrors ? H : this.kind), w.appendChild(S), C.appendChild(w), this.parent.replaceChild(C, this);
      } else
        this.parent.replaceChild(C, this), C.appendChild(this);
      return C;
    }, v.defaults = {
      mathbackground: o.INHERIT,
      mathcolor: o.INHERIT,
      mathsize: o.INHERIT,
      dir: o.INHERIT
    }, v.noInherit = {
      mstyle: {
        mpadded: { width: !0, height: !0, depth: !0, lspace: !0, voffset: !0 },
        mtable: { width: !0, height: !0, depth: !0, align: !0 }
      },
      maligngroup: {
        mrow: { groupalign: !0 },
        mtable: { groupalign: !0 }
      }
    }, v.alwaysInherit = {
      scriptminsize: !0,
      scriptsizemultiplier: !0
    }, v.verifyDefaults = {
      checkArity: !0,
      checkAttributes: !1,
      fullErrors: !1,
      fixMmultiscripts: !0,
      fixMtables: !0
    }, v;
  }(a.AbstractNode);
  e.AbstractMmlNode = Q;
  var u = function(p) {
    t(v, p);
    function v() {
      return p !== null && p.apply(this, arguments) || this;
    }
    return Object.defineProperty(v.prototype, "isToken", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.getText = function() {
      var H, E, M = "";
      try {
        for (var C = n(this.childNodes), w = C.next(); !w.done; w = C.next()) {
          var S = w.value;
          S instanceof d && (M += S.getText());
        }
      } catch (D) {
        H = { error: D };
      } finally {
        try {
          w && !w.done && (E = C.return) && E.call(C);
        } finally {
          if (H)
            throw H.error;
        }
      }
      return M;
    }, v.prototype.setChildInheritedAttributes = function(H, E, M, C) {
      var w, S;
      try {
        for (var D = n(this.childNodes), k = D.next(); !k.done; k = D.next()) {
          var $ = k.value;
          $ instanceof Q && $.setInheritedAttributes(H, E, M, C);
        }
      } catch (z) {
        w = { error: z };
      } finally {
        try {
          k && !k.done && (S = D.return) && S.call(D);
        } finally {
          if (w)
            throw w.error;
        }
      }
    }, v.prototype.walkTree = function(H, E) {
      var M, C;
      H(this, E);
      try {
        for (var w = n(this.childNodes), S = w.next(); !S.done; S = w.next()) {
          var D = S.value;
          D instanceof Q && D.walkTree(H, E);
        }
      } catch (k) {
        M = { error: k };
      } finally {
        try {
          S && !S.done && (C = w.return) && C.call(w);
        } finally {
          if (M)
            throw M.error;
        }
      }
      return E;
    }, v.defaults = r(r({}, Q.defaults), { mathvariant: "normal", mathsize: o.INHERIT }), v;
  }(Q);
  e.AbstractMmlTokenNode = u;
  var l = function(p) {
    t(v, p);
    function v() {
      return p !== null && p.apply(this, arguments) || this;
    }
    return Object.defineProperty(v.prototype, "isSpacelike", {
      get: function() {
        return this.childNodes[0].isSpacelike;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isEmbellished", {
      get: function() {
        return this.childNodes[0].isEmbellished;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "arity", {
      get: function() {
        return -1;
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.core = function() {
      return this.childNodes[0];
    }, v.prototype.coreMO = function() {
      return this.childNodes[0].coreMO();
    }, v.prototype.setTeXclass = function(H) {
      return H = this.childNodes[0].setTeXclass(H), this.updateTeXclass(this.childNodes[0]), H;
    }, v.defaults = Q.defaults, v;
  }(Q);
  e.AbstractMmlLayoutNode = l;
  var c = function(p) {
    t(v, p);
    function v() {
      return p !== null && p.apply(this, arguments) || this;
    }
    return Object.defineProperty(v.prototype, "isEmbellished", {
      get: function() {
        return this.childNodes[0].isEmbellished;
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.core = function() {
      return this.childNodes[0];
    }, v.prototype.coreMO = function() {
      return this.childNodes[0].coreMO();
    }, v.prototype.setTeXclass = function(H) {
      var E, M;
      this.getPrevClass(H), this.texClass = e.TEXCLASS.ORD;
      var C = this.childNodes[0];
      C ? this.isEmbellished || C.isKind("mi") ? (H = C.setTeXclass(H), this.updateTeXclass(this.core())) : (C.setTeXclass(null), H = this) : H = this;
      try {
        for (var w = n(this.childNodes.slice(1)), S = w.next(); !S.done; S = w.next()) {
          var D = S.value;
          D && D.setTeXclass(null);
        }
      } catch (k) {
        E = { error: k };
      } finally {
        try {
          S && !S.done && (M = w.return) && M.call(w);
        } finally {
          if (E)
            throw E.error;
        }
      }
      return H;
    }, v.defaults = Q.defaults, v;
  }(Q);
  e.AbstractMmlBaseNode = c;
  var f = function(p) {
    t(v, p);
    function v() {
      return p !== null && p.apply(this, arguments) || this;
    }
    return Object.defineProperty(v.prototype, "isToken", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isEmbellished", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isSpacelike", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "linebreakContainer", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "hasNewLine", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "arity", {
      get: function() {
        return 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "isInferred", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "notParent", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "Parent", {
      get: function() {
        return this.parent;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "texClass", {
      get: function() {
        return e.TEXCLASS.NONE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "prevClass", {
      get: function() {
        return e.TEXCLASS.NONE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "prevLevel", {
      get: function() {
        return 0;
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.hasSpacingAttributes = function() {
      return !1;
    }, Object.defineProperty(v.prototype, "attributes", {
      get: function() {
        return null;
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.core = function() {
      return this;
    }, v.prototype.coreMO = function() {
      return this;
    }, v.prototype.coreIndex = function() {
      return 0;
    }, v.prototype.childPosition = function() {
      return 0;
    }, v.prototype.setTeXclass = function(H) {
      return H;
    }, v.prototype.texSpacing = function() {
      return "";
    }, v.prototype.setInheritedAttributes = function(H, E, M, C) {
    }, v.prototype.inheritAttributesFrom = function(H) {
    }, v.prototype.verifyTree = function(H) {
    }, v.prototype.mError = function(H, E, M) {
      return null;
    }, v;
  }(a.AbstractEmptyNode);
  e.AbstractMmlEmptyNode = f;
  var d = function(p) {
    t(v, p);
    function v() {
      var H = p !== null && p.apply(this, arguments) || this;
      return H.text = "", H;
    }
    return Object.defineProperty(v.prototype, "kind", {
      get: function() {
        return "text";
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.getText = function() {
      return this.text;
    }, v.prototype.setText = function(H) {
      return this.text = H, this;
    }, v.prototype.copy = function() {
      return this.factory.create(this.kind).setText(this.getText());
    }, v.prototype.toString = function() {
      return this.text;
    }, v;
  }(f);
  e.TextNode = d;
  var m = function(p) {
    t(v, p);
    function v() {
      var H = p !== null && p.apply(this, arguments) || this;
      return H.xml = null, H.adaptor = null, H;
    }
    return Object.defineProperty(v.prototype, "kind", {
      get: function() {
        return "XML";
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.getXML = function() {
      return this.xml;
    }, v.prototype.setXML = function(H, E) {
      return E === void 0 && (E = null), this.xml = H, this.adaptor = E, this;
    }, v.prototype.getSerializedXML = function() {
      return this.adaptor.serializeXML(this.xml);
    }, v.prototype.copy = function() {
      return this.factory.create(this.kind).setXML(this.adaptor.clone(this.xml));
    }, v.prototype.toString = function() {
      return "XML data";
    }, v;
  }(f);
  e.XMLNode = m;
})(T2);
var F4 = {}, rt = {}, ss = {};
(function(e) {
  var t = b && b.__values || function(o) {
    var a = typeof Symbol == "function" && Symbol.iterator, T = a && o[a], s = 0;
    if (T)
      return T.call(o);
    if (o && typeof o.length == "number")
      return {
        next: function() {
          return o && s >= o.length && (o = void 0), { value: o && o[s++], done: !o };
        }
      };
    throw new TypeError(a ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.OPTABLE = e.MMLSPACING = e.getRange = e.RANGES = e.MO = e.OPDEF = void 0;
  var r = T2;
  function n(o, a, T, s) {
    return T === void 0 && (T = r.TEXCLASS.BIN), s === void 0 && (s = null), [o, a, T, s];
  }
  e.OPDEF = n, e.MO = {
    ORD: n(0, 0, r.TEXCLASS.ORD),
    ORD11: n(1, 1, r.TEXCLASS.ORD),
    ORD21: n(2, 1, r.TEXCLASS.ORD),
    ORD02: n(0, 2, r.TEXCLASS.ORD),
    ORD55: n(5, 5, r.TEXCLASS.ORD),
    NONE: n(0, 0, r.TEXCLASS.NONE),
    OP: n(1, 2, r.TEXCLASS.OP, { largeop: !0, movablelimits: !0, symmetric: !0 }),
    OPFIXED: n(1, 2, r.TEXCLASS.OP, { largeop: !0, movablelimits: !0 }),
    INTEGRAL: n(0, 1, r.TEXCLASS.OP, { largeop: !0, symmetric: !0 }),
    INTEGRAL2: n(1, 2, r.TEXCLASS.OP, { largeop: !0, symmetric: !0 }),
    BIN3: n(3, 3, r.TEXCLASS.BIN),
    BIN4: n(4, 4, r.TEXCLASS.BIN),
    BIN01: n(0, 1, r.TEXCLASS.BIN),
    BIN5: n(5, 5, r.TEXCLASS.BIN),
    TALLBIN: n(4, 4, r.TEXCLASS.BIN, { stretchy: !0 }),
    BINOP: n(4, 4, r.TEXCLASS.BIN, { largeop: !0, movablelimits: !0 }),
    REL: n(5, 5, r.TEXCLASS.REL),
    REL1: n(1, 1, r.TEXCLASS.REL, { stretchy: !0 }),
    REL4: n(4, 4, r.TEXCLASS.REL),
    RELSTRETCH: n(5, 5, r.TEXCLASS.REL, { stretchy: !0 }),
    RELACCENT: n(5, 5, r.TEXCLASS.REL, { accent: !0 }),
    WIDEREL: n(5, 5, r.TEXCLASS.REL, { accent: !0, stretchy: !0 }),
    OPEN: n(0, 0, r.TEXCLASS.OPEN, { fence: !0, stretchy: !0, symmetric: !0 }),
    CLOSE: n(0, 0, r.TEXCLASS.CLOSE, { fence: !0, stretchy: !0, symmetric: !0 }),
    INNER: n(0, 0, r.TEXCLASS.INNER),
    PUNCT: n(0, 3, r.TEXCLASS.PUNCT),
    ACCENT: n(0, 0, r.TEXCLASS.ORD, { accent: !0 }),
    WIDEACCENT: n(0, 0, r.TEXCLASS.ORD, { accent: !0, stretchy: !0 })
  }, e.RANGES = [
    [32, 127, r.TEXCLASS.REL, "mo"],
    [160, 191, r.TEXCLASS.ORD, "mo"],
    [192, 591, r.TEXCLASS.ORD, "mi"],
    [688, 879, r.TEXCLASS.ORD, "mo"],
    [880, 6688, r.TEXCLASS.ORD, "mi"],
    [6832, 6911, r.TEXCLASS.ORD, "mo"],
    [6912, 7615, r.TEXCLASS.ORD, "mi"],
    [7616, 7679, r.TEXCLASS.ORD, "mo"],
    [7680, 8191, r.TEXCLASS.ORD, "mi"],
    [8192, 8303, r.TEXCLASS.ORD, "mo"],
    [8304, 8351, r.TEXCLASS.ORD, "mo"],
    [8448, 8527, r.TEXCLASS.ORD, "mi"],
    [8528, 8591, r.TEXCLASS.ORD, "mn"],
    [8592, 8703, r.TEXCLASS.REL, "mo"],
    [8704, 8959, r.TEXCLASS.BIN, "mo"],
    [8960, 9215, r.TEXCLASS.ORD, "mo"],
    [9312, 9471, r.TEXCLASS.ORD, "mn"],
    [9472, 10223, r.TEXCLASS.ORD, "mo"],
    [10224, 10239, r.TEXCLASS.REL, "mo"],
    [10240, 10495, r.TEXCLASS.ORD, "mtext"],
    [10496, 10623, r.TEXCLASS.REL, "mo"],
    [10624, 10751, r.TEXCLASS.ORD, "mo"],
    [10752, 11007, r.TEXCLASS.BIN, "mo"],
    [11008, 11055, r.TEXCLASS.ORD, "mo"],
    [11056, 11087, r.TEXCLASS.REL, "mo"],
    [11088, 11263, r.TEXCLASS.ORD, "mo"],
    [11264, 11744, r.TEXCLASS.ORD, "mi"],
    [11776, 11903, r.TEXCLASS.ORD, "mo"],
    [11904, 12255, r.TEXCLASS.ORD, "mi", "normal"],
    [12272, 12351, r.TEXCLASS.ORD, "mo"],
    [12352, 42143, r.TEXCLASS.ORD, "mi", "normal"],
    [42192, 43055, r.TEXCLASS.ORD, "mi"],
    [43056, 43071, r.TEXCLASS.ORD, "mn"],
    [43072, 55295, r.TEXCLASS.ORD, "mi"],
    [63744, 64255, r.TEXCLASS.ORD, "mi", "normal"],
    [64256, 65023, r.TEXCLASS.ORD, "mi"],
    [65024, 65135, r.TEXCLASS.ORD, "mo"],
    [65136, 65791, r.TEXCLASS.ORD, "mi"],
    [65792, 65935, r.TEXCLASS.ORD, "mn"],
    [65936, 74751, r.TEXCLASS.ORD, "mi", "normal"],
    [74752, 74879, r.TEXCLASS.ORD, "mn"],
    [74880, 113823, r.TEXCLASS.ORD, "mi", "normal"],
    [113824, 119391, r.TEXCLASS.ORD, "mo"],
    [119648, 119679, r.TEXCLASS.ORD, "mn"],
    [119808, 120781, r.TEXCLASS.ORD, "mi"],
    [120782, 120831, r.TEXCLASS.ORD, "mn"],
    [122624, 129023, r.TEXCLASS.ORD, "mo"],
    [129024, 129279, r.TEXCLASS.REL, "mo"],
    [129280, 129535, r.TEXCLASS.ORD, "mo"],
    [131072, 195103, r.TEXCLASS.ORD, "mi", "normnal"]
  ];
  function i(o) {
    var a, T, s = o.codePointAt(0);
    try {
      for (var Q = t(e.RANGES), u = Q.next(); !u.done; u = Q.next()) {
        var l = u.value;
        if (s <= l[1]) {
          if (s >= l[0])
            return l;
          break;
        }
      }
    } catch (c) {
      a = { error: c };
    } finally {
      try {
        u && !u.done && (T = Q.return) && T.call(Q);
      } finally {
        if (a)
          throw a.error;
      }
    }
    return null;
  }
  e.getRange = i, e.MMLSPACING = [
    [0, 0],
    [1, 2],
    [3, 3],
    [4, 4],
    [0, 0],
    [0, 0],
    [0, 3]
  ], e.OPTABLE = {
    prefix: {
      "(": e.MO.OPEN,
      "+": e.MO.BIN01,
      "-": e.MO.BIN01,
      "[": e.MO.OPEN,
      "{": e.MO.OPEN,
      "|": e.MO.OPEN,
      "||": [0, 0, r.TEXCLASS.BIN, { fence: !0, stretchy: !0, symmetric: !0 }],
      "|||": [0, 0, r.TEXCLASS.ORD, { fence: !0, stretchy: !0, symmetric: !0 }],
      "¬": e.MO.ORD21,
      "±": e.MO.BIN01,
      "‖": [0, 0, r.TEXCLASS.ORD, { fence: !0, stretchy: !0 }],
      "‘": [0, 0, r.TEXCLASS.OPEN, { fence: !0 }],
      "“": [0, 0, r.TEXCLASS.OPEN, { fence: !0 }],
      "ⅅ": e.MO.ORD21,
      "ⅆ": n(2, 0, r.TEXCLASS.ORD),
      "∀": e.MO.ORD21,
      "∂": e.MO.ORD21,
      "∃": e.MO.ORD21,
      "∄": e.MO.ORD21,
      "∇": e.MO.ORD21,
      "∏": e.MO.OP,
      "∐": e.MO.OP,
      "∑": e.MO.OP,
      "−": e.MO.BIN01,
      "∓": e.MO.BIN01,
      "√": [1, 1, r.TEXCLASS.ORD, { stretchy: !0 }],
      "∛": e.MO.ORD11,
      "∜": e.MO.ORD11,
      "∠": e.MO.ORD,
      "∡": e.MO.ORD,
      "∢": e.MO.ORD,
      "∫": e.MO.INTEGRAL,
      "∬": e.MO.INTEGRAL,
      "∭": e.MO.INTEGRAL,
      "∮": e.MO.INTEGRAL,
      "∯": e.MO.INTEGRAL,
      "∰": e.MO.INTEGRAL,
      "∱": e.MO.INTEGRAL,
      "∲": e.MO.INTEGRAL,
      "∳": e.MO.INTEGRAL,
      "⋀": e.MO.OP,
      "⋁": e.MO.OP,
      "⋂": e.MO.OP,
      "⋃": e.MO.OP,
      "⌈": e.MO.OPEN,
      "⌊": e.MO.OPEN,
      "〈": e.MO.OPEN,
      "❲": e.MO.OPEN,
      "⟦": e.MO.OPEN,
      "⟨": e.MO.OPEN,
      "⟪": e.MO.OPEN,
      "⟬": e.MO.OPEN,
      "⟮": e.MO.OPEN,
      "⦀": [0, 0, r.TEXCLASS.ORD, { fence: !0, stretchy: !0 }],
      "⦃": e.MO.OPEN,
      "⦅": e.MO.OPEN,
      "⦇": e.MO.OPEN,
      "⦉": e.MO.OPEN,
      "⦋": e.MO.OPEN,
      "⦍": e.MO.OPEN,
      "⦏": e.MO.OPEN,
      "⦑": e.MO.OPEN,
      "⦓": e.MO.OPEN,
      "⦕": e.MO.OPEN,
      "⦗": e.MO.OPEN,
      "⧼": e.MO.OPEN,
      "⨀": e.MO.OP,
      "⨁": e.MO.OP,
      "⨂": e.MO.OP,
      "⨃": e.MO.OP,
      "⨄": e.MO.OP,
      "⨅": e.MO.OP,
      "⨆": e.MO.OP,
      "⨇": e.MO.OP,
      "⨈": e.MO.OP,
      "⨉": e.MO.OP,
      "⨊": e.MO.OP,
      "⨋": e.MO.INTEGRAL2,
      "⨌": e.MO.INTEGRAL,
      "⨍": e.MO.INTEGRAL2,
      "⨎": e.MO.INTEGRAL2,
      "⨏": e.MO.INTEGRAL2,
      "⨐": e.MO.OP,
      "⨑": e.MO.OP,
      "⨒": e.MO.OP,
      "⨓": e.MO.OP,
      "⨔": e.MO.OP,
      "⨕": e.MO.INTEGRAL2,
      "⨖": e.MO.INTEGRAL2,
      "⨗": e.MO.INTEGRAL2,
      "⨘": e.MO.INTEGRAL2,
      "⨙": e.MO.INTEGRAL2,
      "⨚": e.MO.INTEGRAL2,
      "⨛": e.MO.INTEGRAL2,
      "⨜": e.MO.INTEGRAL2,
      "⫼": e.MO.OP,
      "⫿": e.MO.OP
    },
    postfix: {
      "!!": n(1, 0),
      "!": [1, 0, r.TEXCLASS.CLOSE, null],
      '"': e.MO.ACCENT,
      "&": e.MO.ORD,
      ")": e.MO.CLOSE,
      "++": n(0, 0),
      "--": n(0, 0),
      "..": n(0, 0),
      "...": e.MO.ORD,
      "'": e.MO.ACCENT,
      "]": e.MO.CLOSE,
      "^": e.MO.WIDEACCENT,
      _: e.MO.WIDEACCENT,
      "`": e.MO.ACCENT,
      "|": e.MO.CLOSE,
      "}": e.MO.CLOSE,
      "~": e.MO.WIDEACCENT,
      "||": [0, 0, r.TEXCLASS.BIN, { fence: !0, stretchy: !0, symmetric: !0 }],
      "|||": [0, 0, r.TEXCLASS.ORD, { fence: !0, stretchy: !0, symmetric: !0 }],
      "¨": e.MO.ACCENT,
      ª: e.MO.ACCENT,
      "¯": e.MO.WIDEACCENT,
      "°": e.MO.ORD,
      "²": e.MO.ACCENT,
      "³": e.MO.ACCENT,
      "´": e.MO.ACCENT,
      "¸": e.MO.ACCENT,
      "¹": e.MO.ACCENT,
      º: e.MO.ACCENT,
      "ˆ": e.MO.WIDEACCENT,
      "ˇ": e.MO.WIDEACCENT,
      "ˉ": e.MO.WIDEACCENT,
      "ˊ": e.MO.ACCENT,
      "ˋ": e.MO.ACCENT,
      "ˍ": e.MO.WIDEACCENT,
      "˘": e.MO.ACCENT,
      "˙": e.MO.ACCENT,
      "˚": e.MO.ACCENT,
      "˜": e.MO.WIDEACCENT,
      "˝": e.MO.ACCENT,
      "˷": e.MO.WIDEACCENT,
      "̂": e.MO.WIDEACCENT,
      "̑": e.MO.ACCENT,
      "϶": e.MO.REL,
      "‖": [0, 0, r.TEXCLASS.ORD, { fence: !0, stretchy: !0 }],
      "’": [0, 0, r.TEXCLASS.CLOSE, { fence: !0 }],
      "‚": e.MO.ACCENT,
      "‛": e.MO.ACCENT,
      "”": [0, 0, r.TEXCLASS.CLOSE, { fence: !0 }],
      "„": e.MO.ACCENT,
      "‟": e.MO.ACCENT,
      "′": e.MO.ORD,
      "″": e.MO.ACCENT,
      "‴": e.MO.ACCENT,
      "‵": e.MO.ACCENT,
      "‶": e.MO.ACCENT,
      "‷": e.MO.ACCENT,
      "‾": e.MO.WIDEACCENT,
      "⁗": e.MO.ACCENT,
      "⃛": e.MO.ACCENT,
      "⃜": e.MO.ACCENT,
      "⌉": e.MO.CLOSE,
      "⌋": e.MO.CLOSE,
      "〉": e.MO.CLOSE,
      "⎴": e.MO.WIDEACCENT,
      "⎵": e.MO.WIDEACCENT,
      "⏜": e.MO.WIDEACCENT,
      "⏝": e.MO.WIDEACCENT,
      "⏞": e.MO.WIDEACCENT,
      "⏟": e.MO.WIDEACCENT,
      "⏠": e.MO.WIDEACCENT,
      "⏡": e.MO.WIDEACCENT,
      "■": e.MO.BIN3,
      "□": e.MO.BIN3,
      "▪": e.MO.BIN3,
      "▫": e.MO.BIN3,
      "▭": e.MO.BIN3,
      "▮": e.MO.BIN3,
      "▯": e.MO.BIN3,
      "▰": e.MO.BIN3,
      "▱": e.MO.BIN3,
      "▲": e.MO.BIN4,
      "▴": e.MO.BIN4,
      "▶": e.MO.BIN4,
      "▷": e.MO.BIN4,
      "▸": e.MO.BIN4,
      "▼": e.MO.BIN4,
      "▾": e.MO.BIN4,
      "◀": e.MO.BIN4,
      "◁": e.MO.BIN4,
      "◂": e.MO.BIN4,
      "◄": e.MO.BIN4,
      "◅": e.MO.BIN4,
      "◆": e.MO.BIN4,
      "◇": e.MO.BIN4,
      "◈": e.MO.BIN4,
      "◉": e.MO.BIN4,
      "◌": e.MO.BIN4,
      "◍": e.MO.BIN4,
      "◎": e.MO.BIN4,
      "●": e.MO.BIN4,
      "◖": e.MO.BIN4,
      "◗": e.MO.BIN4,
      "◦": e.MO.BIN4,
      "♭": e.MO.ORD02,
      "♮": e.MO.ORD02,
      "♯": e.MO.ORD02,
      "❳": e.MO.CLOSE,
      "⟧": e.MO.CLOSE,
      "⟩": e.MO.CLOSE,
      "⟫": e.MO.CLOSE,
      "⟭": e.MO.CLOSE,
      "⟯": e.MO.CLOSE,
      "⦀": [0, 0, r.TEXCLASS.ORD, { fence: !0, stretchy: !0 }],
      "⦄": e.MO.CLOSE,
      "⦆": e.MO.CLOSE,
      "⦈": e.MO.CLOSE,
      "⦊": e.MO.CLOSE,
      "⦌": e.MO.CLOSE,
      "⦎": e.MO.CLOSE,
      "⦐": e.MO.CLOSE,
      "⦒": e.MO.CLOSE,
      "⦔": e.MO.CLOSE,
      "⦖": e.MO.CLOSE,
      "⦘": e.MO.CLOSE,
      "⧽": e.MO.CLOSE
    },
    infix: {
      "!=": e.MO.BIN4,
      "#": e.MO.ORD,
      $: e.MO.ORD,
      "%": [3, 3, r.TEXCLASS.ORD, null],
      "&&": e.MO.BIN4,
      "": e.MO.ORD,
      "*": e.MO.BIN3,
      "**": n(1, 1),
      "*=": e.MO.BIN4,
      "+": e.MO.BIN4,
      "+=": e.MO.BIN4,
      ",": [0, 3, r.TEXCLASS.PUNCT, { linebreakstyle: "after", separator: !0 }],
      "-": e.MO.BIN4,
      "-=": e.MO.BIN4,
      "->": e.MO.BIN5,
      ".": [0, 3, r.TEXCLASS.PUNCT, { separator: !0 }],
      "/": e.MO.ORD11,
      "//": n(1, 1),
      "/=": e.MO.BIN4,
      ":": [1, 2, r.TEXCLASS.REL, null],
      ":=": e.MO.BIN4,
      ";": [0, 3, r.TEXCLASS.PUNCT, { linebreakstyle: "after", separator: !0 }],
      "<": e.MO.REL,
      "<=": e.MO.BIN5,
      "<>": n(1, 1),
      "=": e.MO.REL,
      "==": e.MO.BIN4,
      ">": e.MO.REL,
      ">=": e.MO.BIN5,
      "?": [1, 1, r.TEXCLASS.CLOSE, null],
      "@": e.MO.ORD11,
      "\\": e.MO.ORD,
      "^": e.MO.ORD11,
      _: e.MO.ORD11,
      "|": [2, 2, r.TEXCLASS.ORD, { fence: !0, stretchy: !0, symmetric: !0 }],
      "||": [2, 2, r.TEXCLASS.BIN, { fence: !0, stretchy: !0, symmetric: !0 }],
      "|||": [2, 2, r.TEXCLASS.ORD, { fence: !0, stretchy: !0, symmetric: !0 }],
      "±": e.MO.BIN4,
      "·": e.MO.BIN4,
      "×": e.MO.BIN4,
      "÷": e.MO.BIN4,
      "ʹ": e.MO.ORD,
      "̀": e.MO.ACCENT,
      "́": e.MO.ACCENT,
      "̃": e.MO.WIDEACCENT,
      "̄": e.MO.ACCENT,
      "̆": e.MO.ACCENT,
      "̇": e.MO.ACCENT,
      "̈": e.MO.ACCENT,
      "̌": e.MO.ACCENT,
      "̲": e.MO.WIDEACCENT,
      "̸": e.MO.REL4,
      "―": [0, 0, r.TEXCLASS.ORD, { stretchy: !0 }],
      "‗": [0, 0, r.TEXCLASS.ORD, { stretchy: !0 }],
      "†": e.MO.BIN3,
      "‡": e.MO.BIN3,
      "•": e.MO.BIN4,
      "…": e.MO.INNER,
      "⁃": e.MO.BIN4,
      "⁄": e.MO.TALLBIN,
      "⁡": e.MO.NONE,
      "⁢": e.MO.NONE,
      "⁣": [0, 0, r.TEXCLASS.NONE, { linebreakstyle: "after", separator: !0 }],
      "⁤": e.MO.NONE,
      "⃗": e.MO.ACCENT,
      ℑ: e.MO.ORD,
      ℓ: e.MO.ORD,
      "℘": e.MO.ORD,
      ℜ: e.MO.ORD,
      "←": e.MO.WIDEREL,
      "↑": e.MO.RELSTRETCH,
      "→": e.MO.WIDEREL,
      "↓": e.MO.RELSTRETCH,
      "↔": e.MO.WIDEREL,
      "↕": e.MO.RELSTRETCH,
      "↖": e.MO.RELSTRETCH,
      "↗": e.MO.RELSTRETCH,
      "↘": e.MO.RELSTRETCH,
      "↙": e.MO.RELSTRETCH,
      "↚": e.MO.RELACCENT,
      "↛": e.MO.RELACCENT,
      "↜": e.MO.WIDEREL,
      "↝": e.MO.WIDEREL,
      "↞": e.MO.WIDEREL,
      "↟": e.MO.WIDEREL,
      "↠": e.MO.WIDEREL,
      "↡": e.MO.RELSTRETCH,
      "↢": e.MO.WIDEREL,
      "↣": e.MO.WIDEREL,
      "↤": e.MO.WIDEREL,
      "↥": e.MO.RELSTRETCH,
      "↦": e.MO.WIDEREL,
      "↧": e.MO.RELSTRETCH,
      "↨": e.MO.RELSTRETCH,
      "↩": e.MO.WIDEREL,
      "↪": e.MO.WIDEREL,
      "↫": e.MO.WIDEREL,
      "↬": e.MO.WIDEREL,
      "↭": e.MO.WIDEREL,
      "↮": e.MO.RELACCENT,
      "↯": e.MO.RELSTRETCH,
      "↰": e.MO.RELSTRETCH,
      "↱": e.MO.RELSTRETCH,
      "↲": e.MO.RELSTRETCH,
      "↳": e.MO.RELSTRETCH,
      "↴": e.MO.RELSTRETCH,
      "↵": e.MO.RELSTRETCH,
      "↶": e.MO.RELACCENT,
      "↷": e.MO.RELACCENT,
      "↸": e.MO.REL,
      "↹": e.MO.WIDEREL,
      "↺": e.MO.REL,
      "↻": e.MO.REL,
      "↼": e.MO.WIDEREL,
      "↽": e.MO.WIDEREL,
      "↾": e.MO.RELSTRETCH,
      "↿": e.MO.RELSTRETCH,
      "⇀": e.MO.WIDEREL,
      "⇁": e.MO.WIDEREL,
      "⇂": e.MO.RELSTRETCH,
      "⇃": e.MO.RELSTRETCH,
      "⇄": e.MO.WIDEREL,
      "⇅": e.MO.RELSTRETCH,
      "⇆": e.MO.WIDEREL,
      "⇇": e.MO.WIDEREL,
      "⇈": e.MO.RELSTRETCH,
      "⇉": e.MO.WIDEREL,
      "⇊": e.MO.RELSTRETCH,
      "⇋": e.MO.WIDEREL,
      "⇌": e.MO.WIDEREL,
      "⇍": e.MO.RELACCENT,
      "⇎": e.MO.RELACCENT,
      "⇏": e.MO.RELACCENT,
      "⇐": e.MO.WIDEREL,
      "⇑": e.MO.RELSTRETCH,
      "⇒": e.MO.WIDEREL,
      "⇓": e.MO.RELSTRETCH,
      "⇔": e.MO.WIDEREL,
      "⇕": e.MO.RELSTRETCH,
      "⇖": e.MO.RELSTRETCH,
      "⇗": e.MO.RELSTRETCH,
      "⇘": e.MO.RELSTRETCH,
      "⇙": e.MO.RELSTRETCH,
      "⇚": e.MO.WIDEREL,
      "⇛": e.MO.WIDEREL,
      "⇜": e.MO.WIDEREL,
      "⇝": e.MO.WIDEREL,
      "⇞": e.MO.REL,
      "⇟": e.MO.REL,
      "⇠": e.MO.WIDEREL,
      "⇡": e.MO.RELSTRETCH,
      "⇢": e.MO.WIDEREL,
      "⇣": e.MO.RELSTRETCH,
      "⇤": e.MO.WIDEREL,
      "⇥": e.MO.WIDEREL,
      "⇦": e.MO.WIDEREL,
      "⇧": e.MO.RELSTRETCH,
      "⇨": e.MO.WIDEREL,
      "⇩": e.MO.RELSTRETCH,
      "⇪": e.MO.RELSTRETCH,
      "⇫": e.MO.RELSTRETCH,
      "⇬": e.MO.RELSTRETCH,
      "⇭": e.MO.RELSTRETCH,
      "⇮": e.MO.RELSTRETCH,
      "⇯": e.MO.RELSTRETCH,
      "⇰": e.MO.WIDEREL,
      "⇱": e.MO.REL,
      "⇲": e.MO.REL,
      "⇳": e.MO.RELSTRETCH,
      "⇴": e.MO.RELACCENT,
      "⇵": e.MO.RELSTRETCH,
      "⇶": e.MO.WIDEREL,
      "⇷": e.MO.RELACCENT,
      "⇸": e.MO.RELACCENT,
      "⇹": e.MO.RELACCENT,
      "⇺": e.MO.RELACCENT,
      "⇻": e.MO.RELACCENT,
      "⇼": e.MO.RELACCENT,
      "⇽": e.MO.WIDEREL,
      "⇾": e.MO.WIDEREL,
      "⇿": e.MO.WIDEREL,
      "∁": n(1, 2, r.TEXCLASS.ORD),
      "∅": e.MO.ORD,
      "∆": e.MO.BIN3,
      "∈": e.MO.REL,
      "∉": e.MO.REL,
      "∊": e.MO.REL,
      "∋": e.MO.REL,
      "∌": e.MO.REL,
      "∍": e.MO.REL,
      "∎": e.MO.BIN3,
      "−": e.MO.BIN4,
      "∓": e.MO.BIN4,
      "∔": e.MO.BIN4,
      "∕": e.MO.TALLBIN,
      "∖": e.MO.BIN4,
      "∗": e.MO.BIN4,
      "∘": e.MO.BIN4,
      "∙": e.MO.BIN4,
      "∝": e.MO.REL,
      "∞": e.MO.ORD,
      "∟": e.MO.REL,
      "∣": e.MO.REL,
      "∤": e.MO.REL,
      "∥": e.MO.REL,
      "∦": e.MO.REL,
      "∧": e.MO.BIN4,
      "∨": e.MO.BIN4,
      "∩": e.MO.BIN4,
      "∪": e.MO.BIN4,
      "∴": e.MO.REL,
      "∵": e.MO.REL,
      "∶": e.MO.REL,
      "∷": e.MO.REL,
      "∸": e.MO.BIN4,
      "∹": e.MO.REL,
      "∺": e.MO.BIN4,
      "∻": e.MO.REL,
      "∼": e.MO.REL,
      "∽": e.MO.REL,
      "∽̱": e.MO.BIN3,
      "∾": e.MO.REL,
      "∿": e.MO.BIN3,
      "≀": e.MO.BIN4,
      "≁": e.MO.REL,
      "≂": e.MO.REL,
      "≂̸": e.MO.REL,
      "≃": e.MO.REL,
      "≄": e.MO.REL,
      "≅": e.MO.REL,
      "≆": e.MO.REL,
      "≇": e.MO.REL,
      "≈": e.MO.REL,
      "≉": e.MO.REL,
      "≊": e.MO.REL,
      "≋": e.MO.REL,
      "≌": e.MO.REL,
      "≍": e.MO.REL,
      "≎": e.MO.REL,
      "≎̸": e.MO.REL,
      "≏": e.MO.REL,
      "≏̸": e.MO.REL,
      "≐": e.MO.REL,
      "≑": e.MO.REL,
      "≒": e.MO.REL,
      "≓": e.MO.REL,
      "≔": e.MO.REL,
      "≕": e.MO.REL,
      "≖": e.MO.REL,
      "≗": e.MO.REL,
      "≘": e.MO.REL,
      "≙": e.MO.REL,
      "≚": e.MO.REL,
      "≛": e.MO.REL,
      "≜": e.MO.REL,
      "≝": e.MO.REL,
      "≞": e.MO.REL,
      "≟": e.MO.REL,
      "≠": e.MO.REL,
      "≡": e.MO.REL,
      "≢": e.MO.REL,
      "≣": e.MO.REL,
      "≤": e.MO.REL,
      "≥": e.MO.REL,
      "≦": e.MO.REL,
      "≦̸": e.MO.REL,
      "≧": e.MO.REL,
      "≨": e.MO.REL,
      "≩": e.MO.REL,
      "≪": e.MO.REL,
      "≪̸": e.MO.REL,
      "≫": e.MO.REL,
      "≫̸": e.MO.REL,
      "≬": e.MO.REL,
      "≭": e.MO.REL,
      "≮": e.MO.REL,
      "≯": e.MO.REL,
      "≰": e.MO.REL,
      "≱": e.MO.REL,
      "≲": e.MO.REL,
      "≳": e.MO.REL,
      "≴": e.MO.REL,
      "≵": e.MO.REL,
      "≶": e.MO.REL,
      "≷": e.MO.REL,
      "≸": e.MO.REL,
      "≹": e.MO.REL,
      "≺": e.MO.REL,
      "≻": e.MO.REL,
      "≼": e.MO.REL,
      "≽": e.MO.REL,
      "≾": e.MO.REL,
      "≿": e.MO.REL,
      "≿̸": e.MO.REL,
      "⊀": e.MO.REL,
      "⊁": e.MO.REL,
      "⊂": e.MO.REL,
      "⊂⃒": e.MO.REL,
      "⊃": e.MO.REL,
      "⊃⃒": e.MO.REL,
      "⊄": e.MO.REL,
      "⊅": e.MO.REL,
      "⊆": e.MO.REL,
      "⊇": e.MO.REL,
      "⊈": e.MO.REL,
      "⊉": e.MO.REL,
      "⊊": e.MO.REL,
      "⊋": e.MO.REL,
      "⊌": e.MO.BIN4,
      "⊍": e.MO.BIN4,
      "⊎": e.MO.BIN4,
      "⊏": e.MO.REL,
      "⊏̸": e.MO.REL,
      "⊐": e.MO.REL,
      "⊐̸": e.MO.REL,
      "⊑": e.MO.REL,
      "⊒": e.MO.REL,
      "⊓": e.MO.BIN4,
      "⊔": e.MO.BIN4,
      "⊕": e.MO.BIN4,
      "⊖": e.MO.BIN4,
      "⊗": e.MO.BIN4,
      "⊘": e.MO.BIN4,
      "⊙": e.MO.BIN4,
      "⊚": e.MO.BIN4,
      "⊛": e.MO.BIN4,
      "⊜": e.MO.BIN4,
      "⊝": e.MO.BIN4,
      "⊞": e.MO.BIN4,
      "⊟": e.MO.BIN4,
      "⊠": e.MO.BIN4,
      "⊡": e.MO.BIN4,
      "⊢": e.MO.REL,
      "⊣": e.MO.REL,
      "⊤": e.MO.ORD55,
      "⊥": e.MO.REL,
      "⊦": e.MO.REL,
      "⊧": e.MO.REL,
      "⊨": e.MO.REL,
      "⊩": e.MO.REL,
      "⊪": e.MO.REL,
      "⊫": e.MO.REL,
      "⊬": e.MO.REL,
      "⊭": e.MO.REL,
      "⊮": e.MO.REL,
      "⊯": e.MO.REL,
      "⊰": e.MO.REL,
      "⊱": e.MO.REL,
      "⊲": e.MO.REL,
      "⊳": e.MO.REL,
      "⊴": e.MO.REL,
      "⊵": e.MO.REL,
      "⊶": e.MO.REL,
      "⊷": e.MO.REL,
      "⊸": e.MO.REL,
      "⊹": e.MO.REL,
      "⊺": e.MO.BIN4,
      "⊻": e.MO.BIN4,
      "⊼": e.MO.BIN4,
      "⊽": e.MO.BIN4,
      "⊾": e.MO.BIN3,
      "⊿": e.MO.BIN3,
      "⋄": e.MO.BIN4,
      "⋅": e.MO.BIN4,
      "⋆": e.MO.BIN4,
      "⋇": e.MO.BIN4,
      "⋈": e.MO.REL,
      "⋉": e.MO.BIN4,
      "⋊": e.MO.BIN4,
      "⋋": e.MO.BIN4,
      "⋌": e.MO.BIN4,
      "⋍": e.MO.REL,
      "⋎": e.MO.BIN4,
      "⋏": e.MO.BIN4,
      "⋐": e.MO.REL,
      "⋑": e.MO.REL,
      "⋒": e.MO.BIN4,
      "⋓": e.MO.BIN4,
      "⋔": e.MO.REL,
      "⋕": e.MO.REL,
      "⋖": e.MO.REL,
      "⋗": e.MO.REL,
      "⋘": e.MO.REL,
      "⋙": e.MO.REL,
      "⋚": e.MO.REL,
      "⋛": e.MO.REL,
      "⋜": e.MO.REL,
      "⋝": e.MO.REL,
      "⋞": e.MO.REL,
      "⋟": e.MO.REL,
      "⋠": e.MO.REL,
      "⋡": e.MO.REL,
      "⋢": e.MO.REL,
      "⋣": e.MO.REL,
      "⋤": e.MO.REL,
      "⋥": e.MO.REL,
      "⋦": e.MO.REL,
      "⋧": e.MO.REL,
      "⋨": e.MO.REL,
      "⋩": e.MO.REL,
      "⋪": e.MO.REL,
      "⋫": e.MO.REL,
      "⋬": e.MO.REL,
      "⋭": e.MO.REL,
      "⋮": e.MO.ORD55,
      "⋯": e.MO.INNER,
      "⋰": e.MO.REL,
      "⋱": [5, 5, r.TEXCLASS.INNER, null],
      "⋲": e.MO.REL,
      "⋳": e.MO.REL,
      "⋴": e.MO.REL,
      "⋵": e.MO.REL,
      "⋶": e.MO.REL,
      "⋷": e.MO.REL,
      "⋸": e.MO.REL,
      "⋹": e.MO.REL,
      "⋺": e.MO.REL,
      "⋻": e.MO.REL,
      "⋼": e.MO.REL,
      "⋽": e.MO.REL,
      "⋾": e.MO.REL,
      "⋿": e.MO.REL,
      "⌅": e.MO.BIN3,
      "⌆": e.MO.BIN3,
      "⌢": e.MO.REL4,
      "⌣": e.MO.REL4,
      "〈": e.MO.OPEN,
      "〉": e.MO.CLOSE,
      "⎪": e.MO.ORD,
      "⎯": [0, 0, r.TEXCLASS.ORD, { stretchy: !0 }],
      "⎰": e.MO.OPEN,
      "⎱": e.MO.CLOSE,
      "─": e.MO.ORD,
      "△": e.MO.BIN4,
      "▵": e.MO.BIN4,
      "▹": e.MO.BIN4,
      "▽": e.MO.BIN4,
      "▿": e.MO.BIN4,
      "◃": e.MO.BIN4,
      "◯": e.MO.BIN3,
      "♠": e.MO.ORD,
      "♡": e.MO.ORD,
      "♢": e.MO.ORD,
      "♣": e.MO.ORD,
      "❘": e.MO.REL,
      "⟰": e.MO.RELSTRETCH,
      "⟱": e.MO.RELSTRETCH,
      "⟵": e.MO.WIDEREL,
      "⟶": e.MO.WIDEREL,
      "⟷": e.MO.WIDEREL,
      "⟸": e.MO.WIDEREL,
      "⟹": e.MO.WIDEREL,
      "⟺": e.MO.WIDEREL,
      "⟻": e.MO.WIDEREL,
      "⟼": e.MO.WIDEREL,
      "⟽": e.MO.WIDEREL,
      "⟾": e.MO.WIDEREL,
      "⟿": e.MO.WIDEREL,
      "⤀": e.MO.RELACCENT,
      "⤁": e.MO.RELACCENT,
      "⤂": e.MO.RELACCENT,
      "⤃": e.MO.RELACCENT,
      "⤄": e.MO.RELACCENT,
      "⤅": e.MO.RELACCENT,
      "⤆": e.MO.RELACCENT,
      "⤇": e.MO.RELACCENT,
      "⤈": e.MO.REL,
      "⤉": e.MO.REL,
      "⤊": e.MO.RELSTRETCH,
      "⤋": e.MO.RELSTRETCH,
      "⤌": e.MO.WIDEREL,
      "⤍": e.MO.WIDEREL,
      "⤎": e.MO.WIDEREL,
      "⤏": e.MO.WIDEREL,
      "⤐": e.MO.WIDEREL,
      "⤑": e.MO.RELACCENT,
      "⤒": e.MO.RELSTRETCH,
      "⤓": e.MO.RELSTRETCH,
      "⤔": e.MO.RELACCENT,
      "⤕": e.MO.RELACCENT,
      "⤖": e.MO.RELACCENT,
      "⤗": e.MO.RELACCENT,
      "⤘": e.MO.RELACCENT,
      "⤙": e.MO.RELACCENT,
      "⤚": e.MO.RELACCENT,
      "⤛": e.MO.RELACCENT,
      "⤜": e.MO.RELACCENT,
      "⤝": e.MO.RELACCENT,
      "⤞": e.MO.RELACCENT,
      "⤟": e.MO.RELACCENT,
      "⤠": e.MO.RELACCENT,
      "⤡": e.MO.RELSTRETCH,
      "⤢": e.MO.RELSTRETCH,
      "⤣": e.MO.REL,
      "⤤": e.MO.REL,
      "⤥": e.MO.REL,
      "⤦": e.MO.REL,
      "⤧": e.MO.REL,
      "⤨": e.MO.REL,
      "⤩": e.MO.REL,
      "⤪": e.MO.REL,
      "⤫": e.MO.REL,
      "⤬": e.MO.REL,
      "⤭": e.MO.REL,
      "⤮": e.MO.REL,
      "⤯": e.MO.REL,
      "⤰": e.MO.REL,
      "⤱": e.MO.REL,
      "⤲": e.MO.REL,
      "⤳": e.MO.RELACCENT,
      "⤴": e.MO.REL,
      "⤵": e.MO.REL,
      "⤶": e.MO.REL,
      "⤷": e.MO.REL,
      "⤸": e.MO.REL,
      "⤹": e.MO.REL,
      "⤺": e.MO.RELACCENT,
      "⤻": e.MO.RELACCENT,
      "⤼": e.MO.RELACCENT,
      "⤽": e.MO.RELACCENT,
      "⤾": e.MO.REL,
      "⤿": e.MO.REL,
      "⥀": e.MO.REL,
      "⥁": e.MO.REL,
      "⥂": e.MO.RELACCENT,
      "⥃": e.MO.RELACCENT,
      "⥄": e.MO.RELACCENT,
      "⥅": e.MO.RELACCENT,
      "⥆": e.MO.RELACCENT,
      "⥇": e.MO.RELACCENT,
      "⥈": e.MO.RELACCENT,
      "⥉": e.MO.REL,
      "⥊": e.MO.RELACCENT,
      "⥋": e.MO.RELACCENT,
      "⥌": e.MO.REL,
      "⥍": e.MO.REL,
      "⥎": e.MO.WIDEREL,
      "⥏": e.MO.RELSTRETCH,
      "⥐": e.MO.WIDEREL,
      "⥑": e.MO.RELSTRETCH,
      "⥒": e.MO.WIDEREL,
      "⥓": e.MO.WIDEREL,
      "⥔": e.MO.RELSTRETCH,
      "⥕": e.MO.RELSTRETCH,
      "⥖": e.MO.RELSTRETCH,
      "⥗": e.MO.RELSTRETCH,
      "⥘": e.MO.RELSTRETCH,
      "⥙": e.MO.RELSTRETCH,
      "⥚": e.MO.WIDEREL,
      "⥛": e.MO.WIDEREL,
      "⥜": e.MO.RELSTRETCH,
      "⥝": e.MO.RELSTRETCH,
      "⥞": e.MO.WIDEREL,
      "⥟": e.MO.WIDEREL,
      "⥠": e.MO.RELSTRETCH,
      "⥡": e.MO.RELSTRETCH,
      "⥢": e.MO.RELACCENT,
      "⥣": e.MO.REL,
      "⥤": e.MO.RELACCENT,
      "⥥": e.MO.REL,
      "⥦": e.MO.RELACCENT,
      "⥧": e.MO.RELACCENT,
      "⥨": e.MO.RELACCENT,
      "⥩": e.MO.RELACCENT,
      "⥪": e.MO.RELACCENT,
      "⥫": e.MO.RELACCENT,
      "⥬": e.MO.RELACCENT,
      "⥭": e.MO.RELACCENT,
      "⥮": e.MO.RELSTRETCH,
      "⥯": e.MO.RELSTRETCH,
      "⥰": e.MO.RELACCENT,
      "⥱": e.MO.RELACCENT,
      "⥲": e.MO.RELACCENT,
      "⥳": e.MO.RELACCENT,
      "⥴": e.MO.RELACCENT,
      "⥵": e.MO.RELACCENT,
      "⥶": e.MO.RELACCENT,
      "⥷": e.MO.RELACCENT,
      "⥸": e.MO.RELACCENT,
      "⥹": e.MO.RELACCENT,
      "⥺": e.MO.RELACCENT,
      "⥻": e.MO.RELACCENT,
      "⥼": e.MO.RELACCENT,
      "⥽": e.MO.RELACCENT,
      "⥾": e.MO.REL,
      "⥿": e.MO.REL,
      "⦁": e.MO.BIN3,
      "⦂": e.MO.BIN3,
      "⦙": e.MO.BIN3,
      "⦚": e.MO.BIN3,
      "⦛": e.MO.BIN3,
      "⦜": e.MO.BIN3,
      "⦝": e.MO.BIN3,
      "⦞": e.MO.BIN3,
      "⦟": e.MO.BIN3,
      "⦠": e.MO.BIN3,
      "⦡": e.MO.BIN3,
      "⦢": e.MO.BIN3,
      "⦣": e.MO.BIN3,
      "⦤": e.MO.BIN3,
      "⦥": e.MO.BIN3,
      "⦦": e.MO.BIN3,
      "⦧": e.MO.BIN3,
      "⦨": e.MO.BIN3,
      "⦩": e.MO.BIN3,
      "⦪": e.MO.BIN3,
      "⦫": e.MO.BIN3,
      "⦬": e.MO.BIN3,
      "⦭": e.MO.BIN3,
      "⦮": e.MO.BIN3,
      "⦯": e.MO.BIN3,
      "⦰": e.MO.BIN3,
      "⦱": e.MO.BIN3,
      "⦲": e.MO.BIN3,
      "⦳": e.MO.BIN3,
      "⦴": e.MO.BIN3,
      "⦵": e.MO.BIN3,
      "⦶": e.MO.BIN4,
      "⦷": e.MO.BIN4,
      "⦸": e.MO.BIN4,
      "⦹": e.MO.BIN4,
      "⦺": e.MO.BIN4,
      "⦻": e.MO.BIN4,
      "⦼": e.MO.BIN4,
      "⦽": e.MO.BIN4,
      "⦾": e.MO.BIN4,
      "⦿": e.MO.BIN4,
      "⧀": e.MO.REL,
      "⧁": e.MO.REL,
      "⧂": e.MO.BIN3,
      "⧃": e.MO.BIN3,
      "⧄": e.MO.BIN4,
      "⧅": e.MO.BIN4,
      "⧆": e.MO.BIN4,
      "⧇": e.MO.BIN4,
      "⧈": e.MO.BIN4,
      "⧉": e.MO.BIN3,
      "⧊": e.MO.BIN3,
      "⧋": e.MO.BIN3,
      "⧌": e.MO.BIN3,
      "⧍": e.MO.BIN3,
      "⧎": e.MO.REL,
      "⧏": e.MO.REL,
      "⧏̸": e.MO.REL,
      "⧐": e.MO.REL,
      "⧐̸": e.MO.REL,
      "⧑": e.MO.REL,
      "⧒": e.MO.REL,
      "⧓": e.MO.REL,
      "⧔": e.MO.REL,
      "⧕": e.MO.REL,
      "⧖": e.MO.BIN4,
      "⧗": e.MO.BIN4,
      "⧘": e.MO.BIN3,
      "⧙": e.MO.BIN3,
      "⧛": e.MO.BIN3,
      "⧜": e.MO.BIN3,
      "⧝": e.MO.BIN3,
      "⧞": e.MO.REL,
      "⧟": e.MO.BIN3,
      "⧠": e.MO.BIN3,
      "⧡": e.MO.REL,
      "⧢": e.MO.BIN4,
      "⧣": e.MO.REL,
      "⧤": e.MO.REL,
      "⧥": e.MO.REL,
      "⧦": e.MO.REL,
      "⧧": e.MO.BIN3,
      "⧨": e.MO.BIN3,
      "⧩": e.MO.BIN3,
      "⧪": e.MO.BIN3,
      "⧫": e.MO.BIN3,
      "⧬": e.MO.BIN3,
      "⧭": e.MO.BIN3,
      "⧮": e.MO.BIN3,
      "⧯": e.MO.BIN3,
      "⧰": e.MO.BIN3,
      "⧱": e.MO.BIN3,
      "⧲": e.MO.BIN3,
      "⧳": e.MO.BIN3,
      "⧴": e.MO.REL,
      "⧵": e.MO.BIN4,
      "⧶": e.MO.BIN4,
      "⧷": e.MO.BIN4,
      "⧸": e.MO.BIN3,
      "⧹": e.MO.BIN3,
      "⧺": e.MO.BIN3,
      "⧻": e.MO.BIN3,
      "⧾": e.MO.BIN4,
      "⧿": e.MO.BIN4,
      "⨝": e.MO.BIN3,
      "⨞": e.MO.BIN3,
      "⨟": e.MO.BIN3,
      "⨠": e.MO.BIN3,
      "⨡": e.MO.BIN3,
      "⨢": e.MO.BIN4,
      "⨣": e.MO.BIN4,
      "⨤": e.MO.BIN4,
      "⨥": e.MO.BIN4,
      "⨦": e.MO.BIN4,
      "⨧": e.MO.BIN4,
      "⨨": e.MO.BIN4,
      "⨩": e.MO.BIN4,
      "⨪": e.MO.BIN4,
      "⨫": e.MO.BIN4,
      "⨬": e.MO.BIN4,
      "⨭": e.MO.BIN4,
      "⨮": e.MO.BIN4,
      "⨯": e.MO.BIN4,
      "⨰": e.MO.BIN4,
      "⨱": e.MO.BIN4,
      "⨲": e.MO.BIN4,
      "⨳": e.MO.BIN4,
      "⨴": e.MO.BIN4,
      "⨵": e.MO.BIN4,
      "⨶": e.MO.BIN4,
      "⨷": e.MO.BIN4,
      "⨸": e.MO.BIN4,
      "⨹": e.MO.BIN4,
      "⨺": e.MO.BIN4,
      "⨻": e.MO.BIN4,
      "⨼": e.MO.BIN4,
      "⨽": e.MO.BIN4,
      "⨾": e.MO.BIN4,
      "⨿": e.MO.BIN4,
      "⩀": e.MO.BIN4,
      "⩁": e.MO.BIN4,
      "⩂": e.MO.BIN4,
      "⩃": e.MO.BIN4,
      "⩄": e.MO.BIN4,
      "⩅": e.MO.BIN4,
      "⩆": e.MO.BIN4,
      "⩇": e.MO.BIN4,
      "⩈": e.MO.BIN4,
      "⩉": e.MO.BIN4,
      "⩊": e.MO.BIN4,
      "⩋": e.MO.BIN4,
      "⩌": e.MO.BIN4,
      "⩍": e.MO.BIN4,
      "⩎": e.MO.BIN4,
      "⩏": e.MO.BIN4,
      "⩐": e.MO.BIN4,
      "⩑": e.MO.BIN4,
      "⩒": e.MO.BIN4,
      "⩓": e.MO.BIN4,
      "⩔": e.MO.BIN4,
      "⩕": e.MO.BIN4,
      "⩖": e.MO.BIN4,
      "⩗": e.MO.BIN4,
      "⩘": e.MO.BIN4,
      "⩙": e.MO.REL,
      "⩚": e.MO.BIN4,
      "⩛": e.MO.BIN4,
      "⩜": e.MO.BIN4,
      "⩝": e.MO.BIN4,
      "⩞": e.MO.BIN4,
      "⩟": e.MO.BIN4,
      "⩠": e.MO.BIN4,
      "⩡": e.MO.BIN4,
      "⩢": e.MO.BIN4,
      "⩣": e.MO.BIN4,
      "⩤": e.MO.BIN4,
      "⩥": e.MO.BIN4,
      "⩦": e.MO.REL,
      "⩧": e.MO.REL,
      "⩨": e.MO.REL,
      "⩩": e.MO.REL,
      "⩪": e.MO.REL,
      "⩫": e.MO.REL,
      "⩬": e.MO.REL,
      "⩭": e.MO.REL,
      "⩮": e.MO.REL,
      "⩯": e.MO.REL,
      "⩰": e.MO.REL,
      "⩱": e.MO.BIN4,
      "⩲": e.MO.BIN4,
      "⩳": e.MO.REL,
      "⩴": e.MO.REL,
      "⩵": e.MO.REL,
      "⩶": e.MO.REL,
      "⩷": e.MO.REL,
      "⩸": e.MO.REL,
      "⩹": e.MO.REL,
      "⩺": e.MO.REL,
      "⩻": e.MO.REL,
      "⩼": e.MO.REL,
      "⩽": e.MO.REL,
      "⩽̸": e.MO.REL,
      "⩾": e.MO.REL,
      "⩾̸": e.MO.REL,
      "⩿": e.MO.REL,
      "⪀": e.MO.REL,
      "⪁": e.MO.REL,
      "⪂": e.MO.REL,
      "⪃": e.MO.REL,
      "⪄": e.MO.REL,
      "⪅": e.MO.REL,
      "⪆": e.MO.REL,
      "⪇": e.MO.REL,
      "⪈": e.MO.REL,
      "⪉": e.MO.REL,
      "⪊": e.MO.REL,
      "⪋": e.MO.REL,
      "⪌": e.MO.REL,
      "⪍": e.MO.REL,
      "⪎": e.MO.REL,
      "⪏": e.MO.REL,
      "⪐": e.MO.REL,
      "⪑": e.MO.REL,
      "⪒": e.MO.REL,
      "⪓": e.MO.REL,
      "⪔": e.MO.REL,
      "⪕": e.MO.REL,
      "⪖": e.MO.REL,
      "⪗": e.MO.REL,
      "⪘": e.MO.REL,
      "⪙": e.MO.REL,
      "⪚": e.MO.REL,
      "⪛": e.MO.REL,
      "⪜": e.MO.REL,
      "⪝": e.MO.REL,
      "⪞": e.MO.REL,
      "⪟": e.MO.REL,
      "⪠": e.MO.REL,
      "⪡": e.MO.REL,
      "⪡̸": e.MO.REL,
      "⪢": e.MO.REL,
      "⪢̸": e.MO.REL,
      "⪣": e.MO.REL,
      "⪤": e.MO.REL,
      "⪥": e.MO.REL,
      "⪦": e.MO.REL,
      "⪧": e.MO.REL,
      "⪨": e.MO.REL,
      "⪩": e.MO.REL,
      "⪪": e.MO.REL,
      "⪫": e.MO.REL,
      "⪬": e.MO.REL,
      "⪭": e.MO.REL,
      "⪮": e.MO.REL,
      "⪯": e.MO.REL,
      "⪯̸": e.MO.REL,
      "⪰": e.MO.REL,
      "⪰̸": e.MO.REL,
      "⪱": e.MO.REL,
      "⪲": e.MO.REL,
      "⪳": e.MO.REL,
      "⪴": e.MO.REL,
      "⪵": e.MO.REL,
      "⪶": e.MO.REL,
      "⪷": e.MO.REL,
      "⪸": e.MO.REL,
      "⪹": e.MO.REL,
      "⪺": e.MO.REL,
      "⪻": e.MO.REL,
      "⪼": e.MO.REL,
      "⪽": e.MO.REL,
      "⪾": e.MO.REL,
      "⪿": e.MO.REL,
      "⫀": e.MO.REL,
      "⫁": e.MO.REL,
      "⫂": e.MO.REL,
      "⫃": e.MO.REL,
      "⫄": e.MO.REL,
      "⫅": e.MO.REL,
      "⫆": e.MO.REL,
      "⫇": e.MO.REL,
      "⫈": e.MO.REL,
      "⫉": e.MO.REL,
      "⫊": e.MO.REL,
      "⫋": e.MO.REL,
      "⫌": e.MO.REL,
      "⫍": e.MO.REL,
      "⫎": e.MO.REL,
      "⫏": e.MO.REL,
      "⫐": e.MO.REL,
      "⫑": e.MO.REL,
      "⫒": e.MO.REL,
      "⫓": e.MO.REL,
      "⫔": e.MO.REL,
      "⫕": e.MO.REL,
      "⫖": e.MO.REL,
      "⫗": e.MO.REL,
      "⫘": e.MO.REL,
      "⫙": e.MO.REL,
      "⫚": e.MO.REL,
      "⫛": e.MO.REL,
      "⫝": e.MO.REL,
      "⫝̸": e.MO.REL,
      "⫞": e.MO.REL,
      "⫟": e.MO.REL,
      "⫠": e.MO.REL,
      "⫡": e.MO.REL,
      "⫢": e.MO.REL,
      "⫣": e.MO.REL,
      "⫤": e.MO.REL,
      "⫥": e.MO.REL,
      "⫦": e.MO.REL,
      "⫧": e.MO.REL,
      "⫨": e.MO.REL,
      "⫩": e.MO.REL,
      "⫪": e.MO.REL,
      "⫫": e.MO.REL,
      "⫬": e.MO.REL,
      "⫭": e.MO.REL,
      "⫮": e.MO.REL,
      "⫯": e.MO.REL,
      "⫰": e.MO.REL,
      "⫱": e.MO.REL,
      "⫲": e.MO.REL,
      "⫳": e.MO.REL,
      "⫴": e.MO.BIN4,
      "⫵": e.MO.BIN4,
      "⫶": e.MO.BIN4,
      "⫷": e.MO.REL,
      "⫸": e.MO.REL,
      "⫹": e.MO.REL,
      "⫺": e.MO.REL,
      "⫻": e.MO.BIN4,
      "⫽": e.MO.BIN4,
      "⫾": e.MO.BIN3,
      "⭅": e.MO.RELSTRETCH,
      "⭆": e.MO.RELSTRETCH,
      "〈": e.MO.OPEN,
      "〉": e.MO.CLOSE,
      "︷": e.MO.WIDEACCENT,
      "︸": e.MO.WIDEACCENT
    }
  }, e.OPTABLE.infix["^"] = e.MO.WIDEREL, e.OPTABLE.infix._ = e.MO.WIDEREL, e.OPTABLE.infix["⫝̸"] = e.MO.REL;
})(ss);
var km = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), n9 = b && b.__assign || function() {
  return n9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, n9.apply(this, arguments);
}, El = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Im = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(rt, "__esModule", { value: !0 });
rt.MmlMo = void 0;
var W2 = T2, aQ = ss, bl = Q3, Rm = function(e) {
  km(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r._texClass = null, r.lspace = 5 / 18, r.rspace = 5 / 18, r;
  }
  return Object.defineProperty(t.prototype, "texClass", {
    get: function() {
      if (this._texClass === null) {
        var r = this.getText(), n = El(this.handleExplicitForm(this.getForms()), 3), i = n[0], o = n[1], a = n[2], T = this.constructor.OPTABLE, s = T[i][r] || T[o][r] || T[a][r];
        return s ? s[2] : W2.TEXCLASS.REL;
      }
      return this._texClass;
    },
    set: function(r) {
      this._texClass = r;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mo";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isEmbellished", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "hasNewLine", {
    get: function() {
      return this.attributes.get("linebreak") === "newline";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.coreParent = function() {
    for (var r = this, n = this, i = this.factory.getNodeClass("math"); n && n.isEmbellished && n.coreMO() === this && !(n instanceof i); )
      r = n, n = n.parent;
    return r;
  }, t.prototype.coreText = function(r) {
    if (!r)
      return "";
    if (r.isEmbellished)
      return r.coreMO().getText();
    for (; ((r.isKind("mrow") || r.isKind("TeXAtom") && r.texClass !== W2.TEXCLASS.VCENTER || r.isKind("mstyle") || r.isKind("mphantom")) && r.childNodes.length === 1 || r.isKind("munderover")) && r.childNodes[0]; )
      r = r.childNodes[0];
    return r.isToken ? r.getText() : "";
  }, t.prototype.hasSpacingAttributes = function() {
    return this.attributes.isSet("lspace") || this.attributes.isSet("rspace");
  }, Object.defineProperty(t.prototype, "isAccent", {
    get: function() {
      var r = !1, n = this.coreParent().parent;
      if (n) {
        var i = n.isKind("mover") ? n.childNodes[n.over].coreMO() ? "accent" : "" : n.isKind("munder") ? n.childNodes[n.under].coreMO() ? "accentunder" : "" : n.isKind("munderover") ? this === n.childNodes[n.over].coreMO() ? "accent" : this === n.childNodes[n.under].coreMO() ? "accentunder" : "" : "";
        if (i) {
          var o = n.attributes.getExplicit(i);
          r = o !== void 0 ? r : this.attributes.get("accent");
        }
      }
      return r;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    var n = this.attributes.getList("form", "fence"), i = n.form, o = n.fence;
    return this.getProperty("texClass") === void 0 && (this.attributes.isSet("lspace") || this.attributes.isSet("rspace")) ? null : (o && this.texClass === W2.TEXCLASS.REL && (i === "prefix" && (this.texClass = W2.TEXCLASS.OPEN), i === "postfix" && (this.texClass = W2.TEXCLASS.CLOSE)), this.adjustTeXclass(r));
  }, t.prototype.adjustTeXclass = function(r) {
    var n = this.texClass, i = this.prevClass;
    if (n === W2.TEXCLASS.NONE)
      return r;
    if (r ? (r.getProperty("autoOP") && (n === W2.TEXCLASS.BIN || n === W2.TEXCLASS.REL) && (i = r.texClass = W2.TEXCLASS.ORD), i = this.prevClass = r.texClass || W2.TEXCLASS.ORD, this.prevLevel = this.attributes.getInherited("scriptlevel")) : i = this.prevClass = W2.TEXCLASS.NONE, n === W2.TEXCLASS.BIN && (i === W2.TEXCLASS.NONE || i === W2.TEXCLASS.BIN || i === W2.TEXCLASS.OP || i === W2.TEXCLASS.REL || i === W2.TEXCLASS.OPEN || i === W2.TEXCLASS.PUNCT))
      this.texClass = W2.TEXCLASS.ORD;
    else if (i === W2.TEXCLASS.BIN && (n === W2.TEXCLASS.REL || n === W2.TEXCLASS.CLOSE || n === W2.TEXCLASS.PUNCT))
      r.texClass = this.prevClass = W2.TEXCLASS.ORD;
    else if (n === W2.TEXCLASS.BIN) {
      for (var o = this, a = this.parent; a && a.parent && a.isEmbellished && (a.childNodes.length === 1 || !a.isKind("mrow") && a.core() === o); )
        o = a, a = a.parent;
      a.childNodes[a.childNodes.length - 1] === o && (this.texClass = W2.TEXCLASS.ORD);
    }
    return this;
  }, t.prototype.setInheritedAttributes = function(r, n, i, o) {
    r === void 0 && (r = {}), n === void 0 && (n = !1), i === void 0 && (i = 0), o === void 0 && (o = !1), e.prototype.setInheritedAttributes.call(this, r, n, i, o);
    var a = this.getText();
    this.checkOperatorTable(a), this.checkPseudoScripts(a), this.checkPrimes(a), this.checkMathAccent(a);
  }, t.prototype.checkOperatorTable = function(r) {
    var n, i, o = El(this.handleExplicitForm(this.getForms()), 3), a = o[0], T = o[1], s = o[2];
    this.attributes.setInherited("form", a);
    var Q = this.constructor.OPTABLE, u = Q[a][r] || Q[T][r] || Q[s][r];
    if (u) {
      this.getProperty("texClass") === void 0 && (this.texClass = u[2]);
      try {
        for (var l = Im(Object.keys(u[3] || {})), c = l.next(); !c.done; c = l.next()) {
          var f = c.value;
          this.attributes.setInherited(f, u[3][f]);
        }
      } catch (p) {
        n = { error: p };
      } finally {
        try {
          c && !c.done && (i = l.return) && i.call(l);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this.lspace = (u[0] + 1) / 18, this.rspace = (u[1] + 1) / 18;
    } else {
      var d = (0, aQ.getRange)(r);
      if (d) {
        this.getProperty("texClass") === void 0 && (this.texClass = d[2]);
        var m = this.constructor.MMLSPACING[d[2]];
        this.lspace = (m[0] + 1) / 18, this.rspace = (m[1] + 1) / 18;
      }
    }
  }, t.prototype.getForms = function() {
    for (var r = this, n = this.parent, i = this.Parent; i && i.isEmbellished; )
      r = n, n = i.parent, i = i.Parent;
    if (n && n.isKind("mrow") && n.nonSpaceLength() !== 1) {
      if (n.firstNonSpace() === r)
        return ["prefix", "infix", "postfix"];
      if (n.lastNonSpace() === r)
        return ["postfix", "infix", "prefix"];
    }
    return ["infix", "prefix", "postfix"];
  }, t.prototype.handleExplicitForm = function(r) {
    if (this.attributes.isSet("form")) {
      var n = this.attributes.get("form");
      r = [n].concat(r.filter(function(i) {
        return i !== n;
      }));
    }
    return r;
  }, t.prototype.checkPseudoScripts = function(r) {
    var n = this.constructor.pseudoScripts;
    if (r.match(n)) {
      var i = this.coreParent().Parent, o = !i || !(i.isKind("msubsup") && !i.isKind("msub"));
      this.setProperty("pseudoscript", o), o && (this.attributes.setInherited("lspace", 0), this.attributes.setInherited("rspace", 0));
    }
  }, t.prototype.checkPrimes = function(r) {
    var n = this.constructor.primes;
    if (r.match(n)) {
      var i = this.constructor.remapPrimes, o = (0, bl.unicodeString)((0, bl.unicodeChars)(r).map(function(a) {
        return i[a];
      }));
      this.setProperty("primes", o);
    }
  }, t.prototype.checkMathAccent = function(r) {
    var n = this.Parent;
    if (!(this.getProperty("mathaccent") !== void 0 || !n || !n.isKind("munderover"))) {
      var i = n.childNodes[0];
      if (!(i.isEmbellished && i.coreMO() === this)) {
        var o = this.constructor.mathaccents;
        r.match(o) && this.setProperty("mathaccent", !0);
      }
    }
  }, t.defaults = n9(n9({}, W2.AbstractMmlTokenNode.defaults), { form: "infix", fence: !1, separator: !1, lspace: "thickmathspace", rspace: "thickmathspace", stretchy: !1, symmetric: !1, maxsize: "infinity", minsize: "0em", largeop: !1, movablelimits: !1, accent: !1, linebreak: "auto", lineleading: "1ex", linebreakstyle: "before", indentalign: "auto", indentshift: "0", indenttarget: "", indentalignfirst: "indentalign", indentshiftfirst: "indentshift", indentalignlast: "indentalign", indentshiftlast: "indentshift" }), t.MMLSPACING = aQ.MMLSPACING, t.OPTABLE = aQ.OPTABLE, t.pseudoScripts = new RegExp([
    "^[\"'*`",
    "ª",
    "°",
    "²-´",
    "¹",
    "º",
    "‘-‟",
    "′-‷⁗",
    "⁰ⁱ",
    "⁴-ⁿ",
    "₀-₎",
    "]+$"
  ].join("")), t.primes = new RegExp([
    "^[\"'`",
    "‘-‟",
    "]+$"
  ].join("")), t.remapPrimes = {
    34: 8243,
    39: 8242,
    96: 8245,
    8216: 8245,
    8217: 8242,
    8218: 8242,
    8219: 8245,
    8220: 8246,
    8221: 8243,
    8222: 8243,
    8223: 8246
  }, t.mathaccents = new RegExp([
    "^[",
    "´́ˊ",
    "`̀ˋ",
    "¨̈",
    "~̃˜",
    "¯̄ˉ",
    "˘̆",
    "ˇ̌",
    "^̂ˆ",
    "→⃗",
    "˙̇",
    "˚̊",
    "⃛",
    "⃜",
    "]$"
  ].join("")), t;
}(W2.AbstractMmlTokenNode);
rt.MmlMo = Rm;
var QQ = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Nm = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Pm = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(F4, "__esModule", { value: !0 });
var Ml = T2, Bm = rt, QT;
(function(e) {
  var t = /* @__PURE__ */ new Map([
    ["autoOP", !0],
    ["fnOP", !0],
    ["movesupsub", !0],
    ["subsupOK", !0],
    ["texprimestyle", !0],
    ["useHeight", !0],
    ["variantForm", !0],
    ["withDelims", !0],
    ["mathaccent", !0],
    ["open", !0],
    ["close", !0]
  ]);
  function r(S) {
    return String.fromCodePoint(parseInt(S, 16));
  }
  e.createEntity = r;
  function n(S) {
    return S.childNodes;
  }
  e.getChildren = n;
  function i(S) {
    return S.getText();
  }
  e.getText = i;
  function o(S, D) {
    var k, $;
    try {
      for (var z = QQ(D), j = z.next(); !j.done; j = z.next()) {
        var J = j.value;
        S.appendChild(J);
      }
    } catch (i1) {
      k = { error: i1 };
    } finally {
      try {
        j && !j.done && ($ = z.return) && $.call(z);
      } finally {
        if (k)
          throw k.error;
      }
    }
  }
  e.appendChildren = o;
  function a(S, D, k) {
    S.attributes.set(D, k);
  }
  e.setAttribute = a;
  function T(S, D, k) {
    S.setProperty(D, k);
  }
  e.setProperty = T;
  function s(S, D) {
    var k, $;
    try {
      for (var z = QQ(Object.keys(D)), j = z.next(); !j.done; j = z.next()) {
        var J = j.value, i1 = D[J];
        J === "texClass" ? (S.texClass = i1, S.setProperty(J, i1)) : J === "movablelimits" ? (S.setProperty("movablelimits", i1), (S.isKind("mo") || S.isKind("mstyle")) && S.attributes.set("movablelimits", i1)) : J === "inferred" || (t.has(J) ? S.setProperty(J, i1) : S.attributes.set(J, i1));
      }
    } catch (t1) {
      k = { error: t1 };
    } finally {
      try {
        j && !j.done && ($ = z.return) && $.call(z);
      } finally {
        if (k)
          throw k.error;
      }
    }
  }
  e.setProperties = s;
  function Q(S, D) {
    return S.getProperty(D);
  }
  e.getProperty = Q;
  function u(S, D) {
    return S.attributes.get(D);
  }
  e.getAttribute = u;
  function l(S) {
    for (var D = [], k = 1; k < arguments.length; k++)
      D[k - 1] = arguments[k];
    S.removeProperty.apply(S, Pm([], Nm(D), !1));
  }
  e.removeProperties = l;
  function c(S, D) {
    return S.childNodes[D];
  }
  e.getChildAt = c;
  function f(S, D, k) {
    var $ = S.childNodes;
    $[D] = k, k && (k.parent = S);
  }
  e.setChild = f;
  function d(S, D) {
    for (var k = S.childNodes, $ = 0; $ < k.length; $++)
      f(D, $, k[$]);
  }
  e.copyChildren = d;
  function m(S, D) {
    D.attributes = S.attributes, s(D, S.getAllProperties());
  }
  e.copyAttributes = m;
  function p(S, D) {
    return S.isKind(D);
  }
  e.isType = p;
  function v(S) {
    return S.isEmbellished;
  }
  e.isEmbellished = v;
  function H(S) {
    return S.texClass;
  }
  e.getTexClass = H;
  function E(S) {
    return S.coreMO();
  }
  e.getCoreMO = E;
  function M(S) {
    return S instanceof Ml.AbstractMmlNode || S instanceof Ml.AbstractMmlEmptyNode;
  }
  e.isNode = M;
  function C(S) {
    return S.isInferred;
  }
  e.isInferred = C;
  function w(S) {
    var D, k;
    if (!p(S, "mo"))
      return null;
    var $ = S, z = $.getForms();
    try {
      for (var j = QQ(z), J = j.next(); !J.done; J = j.next()) {
        var i1 = J.value, t1 = Bm.MmlMo.OPTABLE[i1][$.getText()];
        if (t1)
          return t1;
      }
    } catch (T1) {
      D = { error: T1 };
    } finally {
      try {
        J && !J.done && (k = j.return) && k.call(j);
      } finally {
        if (D)
          throw D.error;
      }
    }
    return null;
  }
  e.getForm = w;
})(QT || (QT = {}));
F4.default = QT;
var Me = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Fm = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ts, "__esModule", { value: !0 });
var wl = T2, F3 = Fm(F4), TT;
(function(e) {
  e.cleanStretchy = function(o) {
    var a, T, s = o.data;
    try {
      for (var Q = Me(s.getList("fixStretchy")), u = Q.next(); !u.done; u = Q.next()) {
        var l = u.value;
        if (F3.default.getProperty(l, "fixStretchy")) {
          var c = F3.default.getForm(l);
          c && c[3] && c[3].stretchy && F3.default.setAttribute(l, "stretchy", !1);
          var f = l.parent;
          if (!F3.default.getTexClass(l) && (!c || !c[2])) {
            var d = s.nodeFactory.create("node", "TeXAtom", [l]);
            f.replaceChild(d, l), d.inheritAttributesFrom(l);
          }
          F3.default.removeProperties(l, "fixStretchy");
        }
      }
    } catch (m) {
      a = { error: m };
    } finally {
      try {
        u && !u.done && (T = Q.return) && T.call(Q);
      } finally {
        if (a)
          throw a.error;
      }
    }
  }, e.cleanAttributes = function(o) {
    var a = o.data.root;
    a.walkTree(function(T, s) {
      var Q, u, l = T.attributes;
      if (l) {
        var c = new Set((l.get("mjx-keep-attrs") || "").split(/ /));
        delete l.getAllAttributes()["mjx-keep-attrs"];
        try {
          for (var f = Me(l.getExplicitNames()), d = f.next(); !d.done; d = f.next()) {
            var m = d.value;
            !c.has(m) && l.attributes[m] === T.attributes.getInherited(m) && delete l.attributes[m];
          }
        } catch (p) {
          Q = { error: p };
        } finally {
          try {
            d && !d.done && (u = f.return) && u.call(f);
          } finally {
            if (Q)
              throw Q.error;
          }
        }
      }
    }, {});
  }, e.combineRelations = function(o) {
    var a, T, s, Q, u = [];
    try {
      for (var l = Me(o.data.getList("mo")), c = l.next(); !c.done; c = l.next()) {
        var f = c.value;
        if (!(f.getProperty("relationsCombined") || !f.parent || f.parent && !F3.default.isType(f.parent, "mrow") || F3.default.getTexClass(f) !== wl.TEXCLASS.REL)) {
          for (var d = f.parent, m = void 0, p = d.childNodes, v = p.indexOf(f) + 1, H = F3.default.getProperty(f, "variantForm"); v < p.length && (m = p[v]) && F3.default.isType(m, "mo") && F3.default.getTexClass(m) === wl.TEXCLASS.REL; )
            if (H === F3.default.getProperty(m, "variantForm") && r(f, m)) {
              F3.default.appendChildren(f, F3.default.getChildren(m)), t(["stretchy", "rspace"], f, m);
              try {
                for (var E = (s = void 0, Me(m.getPropertyNames())), M = E.next(); !M.done; M = E.next()) {
                  var C = M.value;
                  f.setProperty(C, m.getProperty(C));
                }
              } catch (w) {
                s = { error: w };
              } finally {
                try {
                  M && !M.done && (Q = E.return) && Q.call(E);
                } finally {
                  if (s)
                    throw s.error;
                }
              }
              p.splice(v, 1), u.push(m), m.parent = null, m.setProperty("relationsCombined", !0);
            } else {
              f.attributes.getExplicit("rspace") == null && F3.default.setAttribute(f, "rspace", "0pt"), m.attributes.getExplicit("lspace") == null && F3.default.setAttribute(m, "lspace", "0pt");
              break;
            }
          f.attributes.setInherited("form", f.getForms()[0]);
        }
      }
    } catch (w) {
      a = { error: w };
    } finally {
      try {
        c && !c.done && (T = l.return) && T.call(l);
      } finally {
        if (a)
          throw a.error;
      }
    }
    o.data.removeFromList("mo", u);
  };
  var t = function(o, a, T) {
    var s = a.attributes, Q = T.attributes;
    o.forEach(function(u) {
      var l = Q.getExplicit(u);
      l != null && s.set(u, l);
    });
  }, r = function(o, a) {
    var T, s, Q = function(v, H) {
      var E = v.getExplicitNames();
      return E.filter(function(M) {
        return M !== H && (M !== "stretchy" || v.getExplicit("stretchy"));
      });
    }, u = o.attributes, l = a.attributes, c = Q(u, "lspace"), f = Q(l, "rspace");
    if (c.length !== f.length)
      return !1;
    try {
      for (var d = Me(c), m = d.next(); !m.done; m = d.next()) {
        var p = m.value;
        if (u.getExplicit(p) !== l.getExplicit(p))
          return !1;
      }
    } catch (v) {
      T = { error: v };
    } finally {
      try {
        m && !m.done && (s = d.return) && s.call(d);
      } finally {
        if (T)
          throw T.error;
      }
    }
    return !0;
  }, n = function(o, a, T) {
    var s, Q, u = [];
    try {
      for (var l = Me(o.getList("m" + a + T)), c = l.next(); !c.done; c = l.next()) {
        var f = c.value, d = f.childNodes;
        if (!(d[f[a]] && d[f[T]])) {
          var m = f.parent, p = d[f[a]] ? o.nodeFactory.create("node", "m" + a, [d[f.base], d[f[a]]]) : o.nodeFactory.create("node", "m" + T, [d[f.base], d[f[T]]]);
          F3.default.copyAttributes(f, p), m ? m.replaceChild(p, f) : o.root = p, u.push(f);
        }
      }
    } catch (v) {
      s = { error: v };
    } finally {
      try {
        c && !c.done && (Q = l.return) && Q.call(l);
      } finally {
        if (s)
          throw s.error;
      }
    }
    o.removeFromList("m" + a + T, u);
  };
  e.cleanSubSup = function(o) {
    var a = o.data;
    a.error || (n(a, "sub", "sup"), n(a, "under", "over"));
  };
  var i = function(o, a, T) {
    var s, Q, u = [];
    try {
      for (var l = Me(o.getList(a)), c = l.next(); !c.done; c = l.next()) {
        var f = c.value;
        if (!f.attributes.get("displaystyle")) {
          var d = f.childNodes[f.base], m = d.coreMO();
          if (d.getProperty("movablelimits") && !m.attributes.getExplicit("movablelimits")) {
            var p = o.nodeFactory.create("node", T, f.childNodes);
            F3.default.copyAttributes(f, p), f.parent ? f.parent.replaceChild(p, f) : o.root = p, u.push(f);
          }
        }
      }
    } catch (v) {
      s = { error: v };
    } finally {
      try {
        c && !c.done && (Q = l.return) && Q.call(l);
      } finally {
        if (s)
          throw s.error;
      }
    }
    o.removeFromList(a, u);
  };
  e.moveLimits = function(o) {
    var a = o.data;
    i(a, "munderover", "msubsup"), i(a, "munder", "msub"), i(a, "mover", "msup");
  }, e.setInherited = function(o) {
    o.data.root.setInheritedAttributes({}, o.math.display, 0, !1);
  };
})(TT || (TT = {}));
Ts.default = TT;
var ln = {}, un = {}, i5 = {};
Object.defineProperty(i5, "__esModule", { value: !0 });
var jm = function() {
  function e(t, r) {
    for (var n = [], i = 2; i < arguments.length; i++)
      n[i - 2] = arguments[i];
    this.id = t, this.message = e.processString(r, n);
  }
  return e.processString = function(t, r) {
    for (var n = t.split(e.pattern), i = 1, o = n.length; i < o; i += 2) {
      var a = n[i].charAt(0);
      if (a >= "0" && a <= "9")
        n[i] = r[parseInt(n[i], 10) - 1], typeof n[i] == "number" && (n[i] = n[i].toString());
      else if (a === "{")
        if (a = n[i].substr(1), a >= "0" && a <= "9")
          n[i] = r[parseInt(n[i].substr(1, n[i].length - 2), 10) - 1], typeof n[i] == "number" && (n[i] = n[i].toString());
        else {
          var T = n[i].match(/^\{([a-z]+):%(\d+)\|(.*)\}$/);
          T && (n[i] = "%" + n[i]);
        }
      n[i] == null && (n[i] = "???");
    }
    return n.join("");
  }, e.pattern = /%(\d+|\{\d+\}|\{[a-z]+:\%\d+(?:\|(?:%\{\d+\}|%.|[^\}])*)+\}|.)/g, e;
}();
i5.default = jm;
var Nr = {}, z9 = {};
Object.defineProperty(z9, "__esModule", { value: !0 });
z9.asyncLoad = void 0;
var Sl = A0;
function $m(e) {
  return Sl.mathjax.asyncLoad ? new Promise(function(t, r) {
    var n = Sl.mathjax.asyncLoad(e);
    n instanceof Promise ? n.then(function(i) {
      return t(i);
    }).catch(function(i) {
      return r(i);
    }) : t(n);
  }) : Promise.reject("Can't load '".concat(e, "': No asyncLoad method specified"));
}
z9.asyncLoad = $m;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.numeric = e.translate = e.remove = e.add = e.entities = e.options = void 0;
  var t = We, r = z9;
  e.options = {
    loadMissingEntities: !0
  }, e.entities = {
    ApplyFunction: "⁡",
    Backslash: "∖",
    Because: "∵",
    Breve: "˘",
    Cap: "⋒",
    CenterDot: "·",
    CircleDot: "⊙",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    Congruent: "≡",
    ContourIntegral: "∮",
    Coproduct: "∐",
    Cross: "⨯",
    Cup: "⋓",
    CupCap: "≍",
    Dagger: "‡",
    Del: "∇",
    Delta: "Δ",
    Diamond: "⋄",
    DifferentialD: "ⅆ",
    DotEqual: "≐",
    DoubleDot: "¨",
    DoubleRightTee: "⊨",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    DownLeftVector: "↽",
    DownRightVector: "⇁",
    DownTee: "⊤",
    Downarrow: "⇓",
    Element: "∈",
    EqualTilde: "≂",
    Equilibrium: "⇌",
    Exists: "∃",
    ExponentialE: "ⅇ",
    FilledVerySmallSquare: "▪",
    ForAll: "∀",
    Gamma: "Γ",
    Gg: "⋙",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Hacek: "ˇ",
    Hat: "^",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    Im: "ℑ",
    ImaginaryI: "ⅈ",
    Integral: "∫",
    Intersection: "⋂",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    Lambda: "Λ",
    Larr: "↞",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    LeftArrowRightArrow: "⇆",
    LeftCeiling: "⌈",
    LeftDownVector: "⇃",
    LeftFloor: "⌊",
    LeftRightArrow: "↔",
    LeftTee: "⊣",
    LeftTriangle: "⊲",
    LeftTriangleEqual: "⊴",
    LeftUpVector: "↿",
    LeftVector: "↼",
    Leftarrow: "⇐",
    Leftrightarrow: "⇔",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    Ll: "⋘",
    Lleftarrow: "⇚",
    LongLeftArrow: "⟵",
    LongLeftRightArrow: "⟷",
    LongRightArrow: "⟶",
    Longleftarrow: "⟸",
    Longleftrightarrow: "⟺",
    Longrightarrow: "⟹",
    Lsh: "↰",
    MinusPlus: "∓",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotLeftTriangle: "⋪",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotPrecedes: "⊀",
    NotPrecedesSlantEqual: "⋠",
    NotRightTriangle: "⋫",
    NotRightTriangleEqual: "⋭",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsSlantEqual: "⋡",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotVerticalBar: "∤",
    Omega: "Ω",
    OverBar: "‾",
    OverBrace: "⏞",
    PartialD: "∂",
    Phi: "Φ",
    Pi: "Π",
    PlusMinus: "±",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    Product: "∏",
    Proportional: "∝",
    Psi: "Ψ",
    Rarr: "↠",
    Re: "ℜ",
    ReverseEquilibrium: "⇋",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    RightArrowLeftArrow: "⇄",
    RightCeiling: "⌉",
    RightDownVector: "⇂",
    RightFloor: "⌋",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTriangle: "⊳",
    RightTriangleEqual: "⊵",
    RightUpVector: "↾",
    RightVector: "⇀",
    Rightarrow: "⇒",
    Rrightarrow: "⇛",
    Rsh: "↱",
    Sigma: "Σ",
    SmallCircle: "∘",
    Sqrt: "√",
    Square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    Star: "⋆",
    Subset: "⋐",
    SubsetEqual: "⊆",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    SuchThat: "∋",
    Sum: "∑",
    Superset: "⊃",
    SupersetEqual: "⊇",
    Supset: "⋑",
    Therefore: "∴",
    Theta: "Θ",
    Tilde: "∼",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    UnderBar: "_",
    UnderBrace: "⏟",
    Union: "⋃",
    UnionPlus: "⊎",
    UpArrow: "↑",
    UpDownArrow: "↕",
    UpTee: "⊥",
    Uparrow: "⇑",
    Updownarrow: "⇕",
    Upsilon: "Υ",
    Vdash: "⊩",
    Vee: "⋁",
    VerticalBar: "∣",
    VerticalTilde: "≀",
    Vvdash: "⊪",
    Wedge: "⋀",
    Xi: "Ξ",
    amp: "&",
    acute: "´",
    aleph: "ℵ",
    alpha: "α",
    amalg: "⨿",
    and: "∧",
    ang: "∠",
    angmsd: "∡",
    angsph: "∢",
    ape: "≊",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    bigcirc: "◯",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    blacklozenge: "⧫",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    bowtie: "⋈",
    boxdl: "┐",
    boxdr: "┌",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxul: "┘",
    boxur: "└",
    bsol: "\\",
    bull: "•",
    cap: "∩",
    check: "✓",
    chi: "χ",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledR: "®",
    circledS: "Ⓢ",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    clubs: "♣",
    colon: ":",
    comp: "∁",
    ctdot: "⋯",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cup: "∪",
    curarr: "↷",
    curlyvee: "⋎",
    curlywedge: "⋏",
    dagger: "†",
    daleth: "ℸ",
    ddarr: "⇊",
    deg: "°",
    delta: "δ",
    digamma: "ϝ",
    div: "÷",
    divideontimes: "⋇",
    dot: "˙",
    doteqdot: "≑",
    dotplus: "∔",
    dotsquare: "⊡",
    dtdot: "⋱",
    ecir: "≖",
    efDot: "≒",
    egs: "⪖",
    ell: "ℓ",
    els: "⪕",
    empty: "∅",
    epsi: "ε",
    epsiv: "ϵ",
    erDot: "≓",
    eta: "η",
    eth: "ð",
    flat: "♭",
    fork: "⋔",
    frown: "⌢",
    gEl: "⪌",
    gamma: "γ",
    gap: "⪆",
    gimel: "ℷ",
    gnE: "≩",
    gnap: "⪊",
    gne: "⪈",
    gnsim: "⋧",
    gt: ">",
    gtdot: "⋗",
    harrw: "↭",
    hbar: "ℏ",
    hellip: "…",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    imath: "ı",
    infin: "∞",
    intcal: "⊺",
    iota: "ι",
    jmath: "ȷ",
    kappa: "κ",
    kappav: "ϰ",
    lEg: "⪋",
    lambda: "λ",
    lap: "⪅",
    larrlp: "↫",
    larrtl: "↢",
    lbrace: "{",
    lbrack: "[",
    le: "≤",
    leftleftarrows: "⇇",
    leftthreetimes: "⋋",
    lessdot: "⋖",
    lmoust: "⎰",
    lnE: "≨",
    lnap: "⪉",
    lne: "⪇",
    lnsim: "⋦",
    longmapsto: "⟼",
    looparrowright: "↬",
    lowast: "∗",
    loz: "◊",
    lt: "<",
    ltimes: "⋉",
    ltri: "◃",
    macr: "¯",
    malt: "✠",
    mho: "℧",
    mu: "μ",
    multimap: "⊸",
    nLeftarrow: "⇍",
    nLeftrightarrow: "⇎",
    nRightarrow: "⇏",
    nVDash: "⊯",
    nVdash: "⊮",
    natur: "♮",
    nearr: "↗",
    nharr: "↮",
    nlarr: "↚",
    not: "¬",
    nrarr: "↛",
    nu: "ν",
    nvDash: "⊭",
    nvdash: "⊬",
    nwarr: "↖",
    omega: "ω",
    omicron: "ο",
    or: "∨",
    osol: "⊘",
    period: ".",
    phi: "φ",
    phiv: "ϕ",
    pi: "π",
    piv: "ϖ",
    prap: "⪷",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    prime: "′",
    psi: "ψ",
    quot: '"',
    rarrtl: "↣",
    rbrace: "}",
    rbrack: "]",
    rho: "ρ",
    rhov: "ϱ",
    rightrightarrows: "⇉",
    rightthreetimes: "⋌",
    ring: "˚",
    rmoust: "⎱",
    rtimes: "⋊",
    rtri: "▹",
    scap: "⪸",
    scnE: "⪶",
    scnap: "⪺",
    scnsim: "⋩",
    sdot: "⋅",
    searr: "↘",
    sect: "§",
    sharp: "♯",
    sigma: "σ",
    sigmav: "ς",
    simne: "≆",
    smile: "⌣",
    spades: "♠",
    sub: "⊂",
    subE: "⫅",
    subnE: "⫋",
    subne: "⊊",
    supE: "⫆",
    supnE: "⫌",
    supne: "⊋",
    swarr: "↙",
    tau: "τ",
    theta: "θ",
    thetav: "ϑ",
    tilde: "˜",
    times: "×",
    triangle: "▵",
    triangleq: "≜",
    upsi: "υ",
    upuparrows: "⇈",
    veebar: "⊻",
    vellip: "⋮",
    weierp: "℘",
    xi: "ξ",
    yen: "¥",
    zeta: "ζ",
    zigrarr: "⇝",
    nbsp: " ",
    rsquo: "’",
    lsquo: "‘"
  };
  var n = {};
  function i(Q, u) {
    Object.assign(e.entities, Q), n[u] = !0;
  }
  e.add = i;
  function o(Q) {
    delete e.entities[Q];
  }
  e.remove = o;
  function a(Q) {
    return Q.replace(/&([a-z][a-z0-9]*|#(?:[0-9]+|x[0-9a-f]+));/ig, T);
  }
  e.translate = a;
  function T(Q, u) {
    if (u.charAt(0) === "#")
      return s(u.slice(1));
    if (e.entities[u])
      return e.entities[u];
    if (e.options.loadMissingEntities) {
      var l = u.match(/^[a-zA-Z](fr|scr|opf)$/) ? RegExp.$1 : u.charAt(0).toLowerCase();
      n[l] || (n[l] = !0, (0, t.retryAfter)((0, r.asyncLoad)("./util/entities/" + l + ".js")));
    }
    return Q;
  }
  function s(Q) {
    var u = Q.charAt(0) === "x" ? parseInt(Q.slice(1), 16) : parseInt(Q);
    return String.fromCodePoint(u);
  }
  e.numeric = s;
})(Nr);
var Cl;
function Pr() {
  if (Cl)
    return un;
  Cl = 1;
  var e = b && b.__read || function(Q, u) {
    var l = typeof Symbol == "function" && Q[Symbol.iterator];
    if (!l)
      return Q;
    var c = l.call(Q), f, d = [], m;
    try {
      for (; (u === void 0 || u-- > 0) && !(f = c.next()).done; )
        d.push(f.value);
    } catch (p) {
      m = { error: p };
    } finally {
      try {
        f && !f.done && (l = c.return) && l.call(c);
      } finally {
        if (m)
          throw m.error;
      }
    }
    return d;
  }, t = b && b.__values || function(Q) {
    var u = typeof Symbol == "function" && Symbol.iterator, l = u && Q[u], c = 0;
    if (l)
      return l.call(Q);
    if (Q && typeof Q.length == "number")
      return {
        next: function() {
          return Q && c >= Q.length && (Q = void 0), { value: Q && Q[c++], done: !Q };
        }
      };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = b && b.__importDefault || function(Q) {
    return Q && Q.__esModule ? Q : { default: Q };
  };
  Object.defineProperty(un, "__esModule", { value: !0 });
  var n = T2, i = r(F4), o = r(U9()), a = r(i5), T = Nr, s;
  return function(Q) {
    var u = 7.2, l = 72, c = {
      em: function(l1) {
        return l1;
      },
      ex: function(l1) {
        return l1 * 0.43;
      },
      pt: function(l1) {
        return l1 / 10;
      },
      pc: function(l1) {
        return l1 * 1.2;
      },
      px: function(l1) {
        return l1 * u / l;
      },
      in: function(l1) {
        return l1 * u;
      },
      cm: function(l1) {
        return l1 * u / 2.54;
      },
      mm: function(l1) {
        return l1 * u / 25.4;
      },
      mu: function(l1) {
        return l1 / 18;
      }
    }, f = "([-+]?([.,]\\d+|\\d+([.,]\\d*)?))", d = "(pt|em|ex|mu|px|mm|cm|in|pc)", m = RegExp("^\\s*" + f + "\\s*" + d + "\\s*$"), p = RegExp("^\\s*" + f + "\\s*" + d + " ?");
    function v(l1, u1) {
      u1 === void 0 && (u1 = !1);
      var H1 = l1.match(u1 ? p : m);
      return H1 ? H([H1[1].replace(/,/, "."), H1[4], H1[0].length]) : [null, null, 0];
    }
    Q.matchDimen = v;
    function H(l1) {
      var u1 = e(l1, 3), H1 = u1[0], D1 = u1[1], w1 = u1[2];
      if (D1 !== "mu")
        return [H1, D1, w1];
      var E1 = M(c[D1](parseFloat(H1 || "1")));
      return [E1.slice(0, -2), "em", w1];
    }
    function E(l1) {
      var u1 = e(v(l1), 2), H1 = u1[0], D1 = u1[1], w1 = parseFloat(H1 || "1"), E1 = c[D1];
      return E1 ? E1(w1) : 0;
    }
    Q.dimen2em = E;
    function M(l1) {
      return Math.abs(l1) < 6e-4 ? "0em" : l1.toFixed(3).replace(/\.?0+$/, "") + "em";
    }
    Q.Em = M;
    function C() {
      for (var l1 = [], u1 = 0; u1 < arguments.length; u1++)
        l1[u1] = arguments[u1];
      return l1.map(function(H1) {
        return M(H1);
      }).join(" ");
    }
    Q.cols = C;
    function w(l1, u1, H1, D1, w1, E1) {
      w1 === void 0 && (w1 = ""), E1 === void 0 && (E1 = "");
      var A1 = l1.nodeFactory, R1 = A1.create("node", "mrow", [], { open: u1, close: D1, texClass: n.TEXCLASS.INNER }), Z1;
      if (w1)
        Z1 = new o.default("\\" + w1 + "l" + u1, l1.parser.stack.env, l1).mml();
      else {
        var r2 = A1.create("text", u1);
        Z1 = A1.create("node", "mo", [], { fence: !0, stretchy: !0, symmetric: !0, texClass: n.TEXCLASS.OPEN }, r2);
      }
      if (i.default.appendChildren(R1, [Z1, H1]), w1)
        Z1 = new o.default("\\" + w1 + "r" + D1, l1.parser.stack.env, l1).mml();
      else {
        var I2 = A1.create("text", D1);
        Z1 = A1.create("node", "mo", [], { fence: !0, stretchy: !0, symmetric: !0, texClass: n.TEXCLASS.CLOSE }, I2);
      }
      return E1 && Z1.attributes.set("mathcolor", E1), i.default.appendChildren(R1, [Z1]), R1;
    }
    Q.fenced = w;
    function S(l1, u1, H1, D1) {
      var w1 = l1.nodeFactory.create("node", "mrow", [], { open: u1, close: D1, texClass: n.TEXCLASS.ORD });
      return u1 && i.default.appendChildren(w1, [D(l1, u1, "l")]), i.default.isType(H1, "mrow") ? i.default.appendChildren(w1, i.default.getChildren(H1)) : i.default.appendChildren(w1, [H1]), D1 && i.default.appendChildren(w1, [D(l1, D1, "r")]), w1;
    }
    Q.fixedFence = S;
    function D(l1, u1, H1) {
      (u1 === "{" || u1 === "}") && (u1 = "\\" + u1);
      var D1 = "{\\bigg" + H1 + " " + u1 + "}", w1 = "{\\big" + H1 + " " + u1 + "}";
      return new o.default("\\mathchoice" + D1 + w1 + w1 + w1, {}, l1).mml();
    }
    Q.mathPalette = D;
    function k(l1, u1) {
      for (var H1 = 0, D1 = u1.length; H1 < D1; H1++) {
        var w1 = u1[H1];
        if (w1 && !i.default.isType(w1, "mspace") && (!i.default.isType(w1, "TeXAtom") || i.default.getChildren(w1)[0] && i.default.getChildren(i.default.getChildren(w1)[0]).length)) {
          if (i.default.isEmbellished(w1) || i.default.isType(w1, "TeXAtom") && i.default.getTexClass(w1) === n.TEXCLASS.REL) {
            var E1 = l1.nodeFactory.create("node", "mi");
            u1.unshift(E1);
          }
          break;
        }
      }
    }
    Q.fixInitialMO = k;
    function $(l1, u1, H1, D1) {
      if (l1.configuration.options.internalMath)
        return l1.configuration.options.internalMath(l1, u1, H1, D1);
      var w1 = D1 || l1.stack.env.font, E1 = w1 ? { mathvariant: w1 } : {}, A1 = [], R1 = 0, Z1 = 0, r2, I2, X1 = "", x2 = 0;
      if (u1.match(/\\?[${}\\]|\\\(|\\(eq)?ref\s*\{/)) {
        for (; R1 < u1.length; )
          if (r2 = u1.charAt(R1++), r2 === "$")
            X1 === "$" && x2 === 0 ? (I2 = l1.create("node", "TeXAtom", [new o.default(u1.slice(Z1, R1 - 1), {}, l1.configuration).mml()]), A1.push(I2), X1 = "", Z1 = R1) : X1 === "" && (Z1 < R1 - 1 && A1.push(z(l1, u1.slice(Z1, R1 - 1), E1)), X1 = "$", Z1 = R1);
          else if (r2 === "{" && X1 !== "")
            x2++;
          else if (r2 === "}")
            if (X1 === "}" && x2 === 0) {
              var R2 = new o.default(u1.slice(Z1, R1), {}, l1.configuration).mml();
              I2 = l1.create("node", "TeXAtom", [R2], E1), A1.push(I2), X1 = "", Z1 = R1;
            } else
              X1 !== "" && x2 && x2--;
          else if (r2 === "\\")
            if (X1 === "" && u1.substr(R1).match(/^(eq)?ref\s*\{/)) {
              var f3 = RegExp["$&"].length;
              Z1 < R1 - 1 && A1.push(z(l1, u1.slice(Z1, R1 - 1), E1)), X1 = "}", Z1 = R1 - 1, R1 += f3;
            } else
              r2 = u1.charAt(R1++), r2 === "(" && X1 === "" ? (Z1 < R1 - 2 && A1.push(z(l1, u1.slice(Z1, R1 - 2), E1)), X1 = ")", Z1 = R1) : r2 === ")" && X1 === ")" && x2 === 0 ? (I2 = l1.create("node", "TeXAtom", [new o.default(u1.slice(Z1, R1 - 2), {}, l1.configuration).mml()]), A1.push(I2), X1 = "", Z1 = R1) : r2.match(/[${}\\]/) && X1 === "" && (R1--, u1 = u1.substr(0, R1 - 1) + u1.substr(R1));
        if (X1 !== "")
          throw new a.default("MathNotTerminated", "Math not terminated in text box");
      }
      return Z1 < u1.length && A1.push(z(l1, u1.slice(Z1), E1)), H1 != null ? A1 = [l1.create("node", "mstyle", A1, { displaystyle: !1, scriptlevel: H1 })] : A1.length > 1 && (A1 = [l1.create("node", "mrow", A1)]), A1;
    }
    Q.internalMath = $;
    function z(l1, u1, H1) {
      u1 = u1.replace(/^\s+/, T.entities.nbsp).replace(/\s+$/, T.entities.nbsp);
      var D1 = l1.create("text", u1);
      return l1.create("node", "mtext", [], H1, D1);
    }
    Q.internalText = z;
    function j(l1, u1, H1, D1, w1) {
      if (Q.checkMovableLimits(u1), i.default.isType(u1, "munderover") && i.default.isEmbellished(u1)) {
        i.default.setProperties(i.default.getCoreMO(u1), { lspace: 0, rspace: 0 });
        var E1 = l1.create("node", "mo", [], { rspace: 0 });
        u1 = l1.create("node", "mrow", [E1, u1]);
      }
      var A1 = l1.create("node", "munderover", [u1]);
      i.default.setChild(A1, D1 === "over" ? A1.over : A1.under, H1);
      var R1 = A1;
      return w1 && (R1 = l1.create("node", "TeXAtom", [A1], { texClass: n.TEXCLASS.OP, movesupsub: !0 })), i.default.setProperty(R1, "subsupOK", !0), R1;
    }
    Q.underOver = j;
    function J(l1) {
      var u1 = i.default.isType(l1, "mo") ? i.default.getForm(l1) : null;
      (i.default.getProperty(l1, "movablelimits") || u1 && u1[3] && u1[3].movablelimits) && i.default.setProperties(l1, { movablelimits: !1 });
    }
    Q.checkMovableLimits = J;
    function i1(l1) {
      if (typeof l1 != "string")
        return l1;
      var u1 = l1.trim();
      return u1.match(/\\$/) && l1.match(/ $/) && (u1 += " "), u1;
    }
    Q.trimSpaces = i1;
    function t1(l1, u1) {
      return u1 = Q.trimSpaces(u1 || ""), u1 === "t" ? l1.arraydef.align = "baseline 1" : u1 === "b" ? l1.arraydef.align = "baseline -1" : u1 === "c" ? l1.arraydef.align = "axis" : u1 && (l1.arraydef.align = u1), l1;
    }
    Q.setArrayAlign = t1;
    function T1(l1, u1, H1) {
      for (var D1 = "", w1 = "", E1 = 0; E1 < H1.length; ) {
        var A1 = H1.charAt(E1++);
        if (A1 === "\\")
          D1 += A1 + H1.charAt(E1++);
        else if (A1 === "#")
          if (A1 = H1.charAt(E1++), A1 === "#")
            D1 += A1;
          else {
            if (!A1.match(/[1-9]/) || parseInt(A1, 10) > u1.length)
              throw new a.default("IllegalMacroParam", "Illegal macro parameter reference");
            w1 = X(l1, X(l1, w1, D1), u1[parseInt(A1, 10) - 1]), D1 = "";
          }
        else
          D1 += A1;
      }
      return X(l1, w1, D1);
    }
    Q.substituteArgs = T1;
    function X(l1, u1, H1) {
      if (H1.match(/^[a-z]/i) && u1.match(/(^|[^\\])(\\\\)*\\[a-z]+$/i) && (u1 += " "), u1.length + H1.length > l1.configuration.options.maxBuffer)
        throw new a.default("MaxBufferSize", "MathJax internal buffer size exceeded; is there a recursive macro call?");
      return u1 + H1;
    }
    Q.addArgs = X;
    function f1(l1, u1) {
      if (u1 === void 0 && (u1 = !0), !(++l1.macroCount <= l1.configuration.options.maxMacros))
        throw u1 ? new a.default("MaxMacroSub1", "MathJax maximum macro substitution count exceeded; is here a recursive macro call?") : new a.default("MaxMacroSub2", "MathJax maximum substitution count exceeded; is there a recursive latex environment?");
    }
    Q.checkMaxMacros = f1;
    function s1(l1) {
      if (l1.stack.global.eqnenv)
        throw new a.default("ErroneousNestingEq", "Erroneous nesting of equation structures");
      l1.stack.global.eqnenv = !0;
    }
    Q.checkEqnEnv = s1;
    function Z(l1, u1) {
      var H1 = l1.copy(), D1 = u1.configuration;
      return H1.walkTree(function(w1) {
        var E1, A1;
        D1.addNode(w1.kind, w1);
        var R1 = (w1.getProperty("in-lists") || "").split(/,/);
        try {
          for (var Z1 = t(R1), r2 = Z1.next(); !r2.done; r2 = Z1.next()) {
            var I2 = r2.value;
            I2 && D1.addNode(I2, w1);
          }
        } catch (X1) {
          E1 = { error: X1 };
        } finally {
          try {
            r2 && !r2.done && (A1 = Z1.return) && A1.call(Z1);
          } finally {
            if (E1)
              throw E1.error;
          }
        }
      }), H1;
    }
    Q.copyNode = Z;
    function L1(l1, u1, H1) {
      return H1;
    }
    Q.MmlFilterAttribute = L1;
    function C1(l1) {
      var u1 = l1.stack.env.font;
      return u1 ? { mathvariant: u1 } : {};
    }
    Q.getFontDef = C1;
    function q(l1, u1, H1) {
      var D1, w1;
      u1 === void 0 && (u1 = null), H1 === void 0 && (H1 = !1);
      var E1 = N1(l1);
      if (u1)
        try {
          for (var A1 = t(Object.keys(E1)), R1 = A1.next(); !R1.done; R1 = A1.next()) {
            var Z1 = R1.value;
            if (!u1.hasOwnProperty(Z1)) {
              if (H1)
                throw new a.default("InvalidOption", "Invalid option: %1", Z1);
              delete E1[Z1];
            }
          }
        } catch (r2) {
          D1 = { error: r2 };
        } finally {
          try {
            R1 && !R1.done && (w1 = A1.return) && w1.call(A1);
          } finally {
            if (D1)
              throw D1.error;
          }
        }
      return E1;
    }
    Q.keyvalOptions = q;
    function N1(l1) {
      for (var u1, H1, D1 = {}, w1 = l1, E1, A1, R1; w1; )
        u1 = e(x1(w1, ["=", ","]), 3), A1 = u1[0], E1 = u1[1], w1 = u1[2], E1 === "=" ? (H1 = e(x1(w1, [","]), 3), R1 = H1[0], E1 = H1[1], w1 = H1[2], R1 = R1 === "false" || R1 === "true" ? JSON.parse(R1) : R1, D1[A1] = R1) : A1 && (D1[A1] = !0);
      return D1;
    }
    function O1(l1, u1) {
      for (; u1 > 0; )
        l1 = l1.trim().slice(1, -1), u1--;
      return l1.trim();
    }
    function x1(l1, u1) {
      for (var H1 = l1.length, D1 = 0, w1 = "", E1 = 0, A1 = 0, R1 = !0, Z1 = !1; E1 < H1; ) {
        var r2 = l1[E1++];
        switch (r2) {
          case " ":
            break;
          case "{":
            R1 ? A1++ : (Z1 = !1, A1 > D1 && (A1 = D1)), D1++;
            break;
          case "}":
            D1 && D1--, (R1 || Z1) && (A1--, Z1 = !0), R1 = !1;
            break;
          default:
            if (!D1 && u1.indexOf(r2) !== -1)
              return [Z1 ? "true" : O1(w1, A1), r2, l1.slice(E1)];
            R1 = !1, Z1 = !1;
        }
        w1 += r2;
      }
      if (D1)
        throw new a.default("ExtraOpenMissingClose", "Extra open brace or missing close brace");
      return [Z1 ? "true" : O1(w1, A1), "", l1.slice(E1)];
    }
  }(s || (s = {})), un.default = s, un;
}
var ls = {}, Zm = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vl = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Wm = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Gm = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ls, "__esModule", { value: !0 });
var zm = Gm(F4), Um = function() {
  function e(t, r, n) {
    this._factory = t, this._env = r, this.global = {}, this.stack = [], this.global = { isInner: n }, this.stack = [this._factory.create("start", this.global)], r && (this.stack[0].env = r), this.env = this.stack[0].env;
  }
  return Object.defineProperty(e.prototype, "env", {
    get: function() {
      return this._env;
    },
    set: function(t) {
      this._env = t;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.Push = function() {
    for (var t, r, n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    try {
      for (var o = Zm(n), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        if (T) {
          var s = zm.default.isNode(T) ? this._factory.create("mml", T) : T;
          s.global = this.global;
          var Q = Vl(this.stack.length ? this.Top().checkItem(s) : [null, !0], 2), u = Q[0], l = Q[1];
          if (l) {
            if (u) {
              this.Pop(), this.Push.apply(this, Wm([], Vl(u), !1));
              continue;
            }
            this.stack.push(s), s.env ? (s.copyEnv && Object.assign(s.env, this.env), this.env = s.env) : s.env = this.env;
          }
        }
      }
    } catch (c) {
      t = { error: c };
    } finally {
      try {
        a && !a.done && (r = o.return) && r.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
  }, e.prototype.Pop = function() {
    var t = this.stack.pop();
    return t.isOpen || delete t.env, this.env = this.stack.length ? this.Top().env : {}, t;
  }, e.prototype.Top = function(t) {
    return t === void 0 && (t = 1), this.stack.length < t ? null : this.stack[this.stack.length - t];
  }, e.prototype.Prev = function(t) {
    var r = this.Top();
    return t ? r.First : r.Pop();
  }, e.prototype.toString = function() {
    return `stack[
  ` + this.stack.join(`
  `) + `
]`;
  }, e;
}();
ls.default = Um;
var _l;
function U9() {
  if (_l)
    return ln;
  _l = 1;
  var e = b && b.__values || function(Q) {
    var u = typeof Symbol == "function" && Symbol.iterator, l = u && Q[u], c = 0;
    if (l)
      return l.call(Q);
    if (Q && typeof Q.length == "number")
      return {
        next: function() {
          return Q && c >= Q.length && (Q = void 0), { value: Q && Q[c++], done: !Q };
        }
      };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, t = b && b.__read || function(Q, u) {
    var l = typeof Symbol == "function" && Q[Symbol.iterator];
    if (!l)
      return Q;
    var c = l.call(Q), f, d = [], m;
    try {
      for (; (u === void 0 || u-- > 0) && !(f = c.next()).done; )
        d.push(f.value);
    } catch (p) {
      m = { error: p };
    } finally {
      try {
        f && !f.done && (l = c.return) && l.call(c);
      } finally {
        if (m)
          throw m.error;
      }
    }
    return d;
  }, r = b && b.__spreadArray || function(Q, u, l) {
    if (l || arguments.length === 2)
      for (var c = 0, f = u.length, d; c < f; c++)
        (d || !(c in u)) && (d || (d = Array.prototype.slice.call(u, 0, c)), d[c] = u[c]);
    return Q.concat(d || Array.prototype.slice.call(u));
  }, n = b && b.__importDefault || function(Q) {
    return Q && Q.__esModule ? Q : { default: Q };
  };
  Object.defineProperty(ln, "__esModule", { value: !0 });
  var i = n(Pr()), o = n(ls), a = n(i5), T = T2, s = function() {
    function Q(u, l, c) {
      var f, d;
      this._string = u, this.configuration = c, this.macroCount = 0, this.i = 0, this.currentCS = "";
      var m = l.hasOwnProperty("isInner"), p = l.isInner;
      delete l.isInner;
      var v;
      if (l) {
        v = {};
        try {
          for (var H = e(Object.keys(l)), E = H.next(); !E.done; E = H.next()) {
            var M = E.value;
            v[M] = l[M];
          }
        } catch (C) {
          f = { error: C };
        } finally {
          try {
            E && !E.done && (d = H.return) && d.call(H);
          } finally {
            if (f)
              throw f.error;
          }
        }
      }
      this.configuration.pushParser(this), this.stack = new o.default(this.itemFactory, v, m ? p : !0), this.Parse(), this.Push(this.itemFactory.create("stop"));
    }
    return Object.defineProperty(Q.prototype, "options", {
      get: function() {
        return this.configuration.options;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Q.prototype, "itemFactory", {
      get: function() {
        return this.configuration.itemFactory;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Q.prototype, "tags", {
      get: function() {
        return this.configuration.tags;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Q.prototype, "string", {
      get: function() {
        return this._string;
      },
      set: function(u) {
        this._string = u;
      },
      enumerable: !1,
      configurable: !0
    }), Q.prototype.parse = function(u, l) {
      return this.configuration.handlers.get(u).parse(l);
    }, Q.prototype.lookup = function(u, l) {
      return this.configuration.handlers.get(u).lookup(l);
    }, Q.prototype.contains = function(u, l) {
      return this.configuration.handlers.get(u).contains(l);
    }, Q.prototype.toString = function() {
      var u, l, c = "";
      try {
        for (var f = e(Array.from(this.configuration.handlers.keys())), d = f.next(); !d.done; d = f.next()) {
          var m = d.value;
          c += m + ": " + this.configuration.handlers.get(m) + `
`;
        }
      } catch (p) {
        u = { error: p };
      } finally {
        try {
          d && !d.done && (l = f.return) && l.call(f);
        } finally {
          if (u)
            throw u.error;
        }
      }
      return c;
    }, Q.prototype.Parse = function() {
      for (var u; this.i < this.string.length; )
        u = this.getCodePoint(), this.i += u.length, this.parse("character", [this, u]);
    }, Q.prototype.Push = function(u) {
      u instanceof T.AbstractMmlNode && u.isInferred ? this.PushAll(u.childNodes) : this.stack.Push(u);
    }, Q.prototype.PushAll = function(u) {
      var l, c;
      try {
        for (var f = e(u), d = f.next(); !d.done; d = f.next()) {
          var m = d.value;
          this.stack.Push(m);
        }
      } catch (p) {
        l = { error: p };
      } finally {
        try {
          d && !d.done && (c = f.return) && c.call(f);
        } finally {
          if (l)
            throw l.error;
        }
      }
    }, Q.prototype.mml = function() {
      if (!this.stack.Top().isKind("mml"))
        return null;
      var u = this.stack.Top().First;
      return this.configuration.popParser(), u;
    }, Q.prototype.convertDelimiter = function(u) {
      var l = this.lookup("delimiter", u);
      return l ? l.char : null;
    }, Q.prototype.getCodePoint = function() {
      var u = this.string.codePointAt(this.i);
      return u === void 0 ? "" : String.fromCodePoint(u);
    }, Q.prototype.nextIsSpace = function() {
      return !!this.string.charAt(this.i).match(/\s/);
    }, Q.prototype.GetNext = function() {
      for (; this.nextIsSpace(); )
        this.i++;
      return this.getCodePoint();
    }, Q.prototype.GetCS = function() {
      var u = this.string.slice(this.i).match(/^(([a-z]+) ?|[\uD800-\uDBFF].|.)/i);
      return u ? (this.i += u[0].length, u[2] || u[1]) : (this.i++, " ");
    }, Q.prototype.GetArgument = function(u, l) {
      switch (this.GetNext()) {
        case "":
          if (!l)
            throw new a.default("MissingArgFor", "Missing argument for %1", this.currentCS);
          return null;
        case "}":
          if (!l)
            throw new a.default("ExtraCloseMissingOpen", "Extra close brace or missing open brace");
          return null;
        case "\\":
          return this.i++, "\\" + this.GetCS();
        case "{":
          for (var c = ++this.i, f = 1; this.i < this.string.length; )
            switch (this.string.charAt(this.i++)) {
              case "\\":
                this.i++;
                break;
              case "{":
                f++;
                break;
              case "}":
                if (--f === 0)
                  return this.string.slice(c, this.i - 1);
                break;
            }
          throw new a.default("MissingCloseBrace", "Missing close brace");
      }
      var d = this.getCodePoint();
      return this.i += d.length, d;
    }, Q.prototype.GetBrackets = function(u, l) {
      if (this.GetNext() !== "[")
        return l;
      for (var c = ++this.i, f = 0; this.i < this.string.length; )
        switch (this.string.charAt(this.i++)) {
          case "{":
            f++;
            break;
          case "\\":
            this.i++;
            break;
          case "}":
            if (f-- <= 0)
              throw new a.default("ExtraCloseLooking", "Extra close brace while looking for %1", "']'");
            break;
          case "]":
            if (f === 0)
              return this.string.slice(c, this.i - 1);
            break;
        }
      throw new a.default("MissingCloseBracket", "Could not find closing ']' for argument to %1", this.currentCS);
    }, Q.prototype.GetDelimiter = function(u, l) {
      var c = this.GetNext();
      if (this.i += c.length, this.i <= this.string.length && (c === "\\" ? c += this.GetCS() : c === "{" && l && (this.i--, c = this.GetArgument(u).trim()), this.contains("delimiter", c)))
        return this.convertDelimiter(c);
      throw new a.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
    }, Q.prototype.GetDimen = function(u) {
      if (this.GetNext() === "{") {
        var l = this.GetArgument(u), c = t(i.default.matchDimen(l), 2), f = c[0], d = c[1];
        if (f)
          return f + d;
      } else {
        var l = this.string.slice(this.i), m = t(i.default.matchDimen(l, !0), 3), f = m[0], d = m[1], p = m[2];
        if (f)
          return this.i += p, f + d;
      }
      throw new a.default("MissingDimOrUnits", "Missing dimension or its units for %1", this.currentCS);
    }, Q.prototype.GetUpTo = function(u, l) {
      for (; this.nextIsSpace(); )
        this.i++;
      for (var c = this.i, f = 0; this.i < this.string.length; ) {
        var d = this.i, m = this.GetNext();
        switch (this.i += m.length, m) {
          case "\\":
            m += this.GetCS();
            break;
          case "{":
            f++;
            break;
          case "}":
            if (f === 0)
              throw new a.default("ExtraCloseLooking", "Extra close brace while looking for %1", l);
            f--;
            break;
        }
        if (f === 0 && m === l)
          return this.string.slice(c, d);
      }
      throw new a.default("TokenNotFoundForCommand", "Could not find %1 for %2", l, this.currentCS);
    }, Q.prototype.ParseArg = function(u) {
      return new Q(this.GetArgument(u), this.stack.env, this.configuration).mml();
    }, Q.prototype.ParseUpTo = function(u, l) {
      return new Q(this.GetUpTo(u, l), this.stack.env, this.configuration).mml();
    }, Q.prototype.GetDelimiterArg = function(u) {
      var l = i.default.trimSpaces(this.GetArgument(u));
      if (l === "")
        return null;
      if (this.contains("delimiter", l))
        return l;
      throw new a.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
    }, Q.prototype.GetStar = function() {
      var u = this.GetNext() === "*";
      return u && this.i++, u;
    }, Q.prototype.create = function(u) {
      for (var l, c = [], f = 1; f < arguments.length; f++)
        c[f - 1] = arguments[f];
      return (l = this.configuration.nodeFactory).create.apply(l, r([u], t(c), !1));
    }, Q;
  }();
  return ln.default = s, ln;
}
var us = {}, cs = {}, Ge = {}, Xm = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), sT = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Ol = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, qm = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Jm = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ge, "__esModule", { value: !0 });
Ge.BaseItem = Ge.MmlStack = void 0;
var Al = Jm(i5), Vd = function() {
  function e(t) {
    this._nodes = t;
  }
  return Object.defineProperty(e.prototype, "nodes", {
    get: function() {
      return this._nodes;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.Push = function() {
    for (var t, r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    (t = this._nodes).push.apply(t, Ol([], sT(r), !1));
  }, e.prototype.Pop = function() {
    return this._nodes.pop();
  }, Object.defineProperty(e.prototype, "First", {
    get: function() {
      return this._nodes[this.Size() - 1];
    },
    set: function(t) {
      this._nodes[this.Size() - 1] = t;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "Last", {
    get: function() {
      return this._nodes[0];
    },
    set: function(t) {
      this._nodes[0] = t;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.Peek = function(t) {
    return t == null && (t = 1), this._nodes.slice(this.Size() - t);
  }, e.prototype.Size = function() {
    return this._nodes.length;
  }, e.prototype.Clear = function() {
    this._nodes = [];
  }, e.prototype.toMml = function(t, r) {
    return t === void 0 && (t = !0), this._nodes.length === 1 && !r ? this.First : this.create("node", t ? "inferredMrow" : "mrow", this._nodes, {});
  }, e.prototype.create = function(t) {
    for (var r, n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    return (r = this.factory.configuration.nodeFactory).create.apply(r, Ol([t], sT(n), !1));
  }, e;
}();
Ge.MmlStack = Vd;
var Ym = function(e) {
  Xm(t, e);
  function t(r) {
    for (var n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    var o = e.call(this, n) || this;
    return o.factory = r, o.global = {}, o._properties = {}, o.isOpen && (o._env = {}), o;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "base";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "env", {
    get: function() {
      return this._env;
    },
    set: function(r) {
      this._env = r;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "copyEnv", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getProperty = function(r) {
    return this._properties[r];
  }, t.prototype.setProperty = function(r, n) {
    return this._properties[r] = n, this;
  }, Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isFinal", {
    get: function() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.isKind = function(r) {
    return r === this.kind;
  }, t.prototype.checkItem = function(r) {
    if (r.isKind("over") && this.isOpen && (r.setProperty("num", this.toMml(!1)), this.Clear()), r.isKind("cell") && this.isOpen) {
      if (r.getProperty("linebreak"))
        return t.fail;
      throw new Al.default("Misplaced", "Misplaced %1", r.getName());
    }
    if (r.isClose && this.getErrors(r.kind)) {
      var n = sT(this.getErrors(r.kind), 2), i = n[0], o = n[1];
      throw new Al.default(i, o, r.getName());
    }
    return r.isFinal ? (this.Push(r.First), t.fail) : t.success;
  }, t.prototype.clearEnv = function() {
    var r, n;
    try {
      for (var i = qm(Object.keys(this.env)), o = i.next(); !o.done; o = i.next()) {
        var a = o.value;
        delete this.env[a];
      }
    } catch (T) {
      r = { error: T };
    } finally {
      try {
        o && !o.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, t.prototype.setProperties = function(r) {
    return Object.assign(this._properties, r), this;
  }, t.prototype.getName = function() {
    return this.getProperty("name");
  }, t.prototype.toString = function() {
    return this.kind + "[" + this.nodes.join("; ") + "]";
  }, t.prototype.getErrors = function(r) {
    var n = this.constructor;
    return (n.errors || {})[r] || t.errors[r];
  }, t.fail = [null, !1], t.success = [null, !0], t.errors = {
    end: ["MissingBeginExtraEnd", "Missing \\begin{%1} or extra \\end{%1}"],
    close: ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"],
    right: ["MissingLeftExtraRight", "Missing \\left or extra \\right"],
    middle: ["ExtraMiddle", "Extra \\middle"]
  }, t;
}(Vd);
Ge.BaseItem = Ym;
var I0 = {}, Km = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Dl = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, kl = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(I0, "__esModule", { value: !0 });
I0.AbstractFactory = void 0;
var ev = function() {
  function e(t) {
    var r, n;
    t === void 0 && (t = null), this.defaultKind = "unknown", this.nodeMap = /* @__PURE__ */ new Map(), this.node = {}, t === null && (t = this.constructor.defaultNodes);
    try {
      for (var i = Km(Object.keys(t)), o = i.next(); !o.done; o = i.next()) {
        var a = o.value;
        this.setNodeClass(a, t[a]);
      }
    } catch (T) {
      r = { error: T };
    } finally {
      try {
        o && !o.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }
  return e.prototype.create = function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    return (this.node[t] || this.node[this.defaultKind]).apply(void 0, kl([], Dl(r), !1));
  }, e.prototype.setNodeClass = function(t, r) {
    this.nodeMap.set(t, r);
    var n = this, i = this.nodeMap.get(t);
    this.node[t] = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      return new (i.bind.apply(i, kl([void 0, n], Dl(o), !1)))();
    };
  }, e.prototype.getNodeClass = function(t) {
    return this.nodeMap.get(t);
  }, e.prototype.deleteNodeClass = function(t) {
    this.nodeMap.delete(t), delete this.node[t];
  }, e.prototype.nodeIsKind = function(t, r) {
    return t instanceof this.getNodeClass(r);
  }, e.prototype.getKinds = function() {
    return Array.from(this.nodeMap.keys());
  }, e.defaultNodes = {}, e;
}();
I0.AbstractFactory = ev;
var _d = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), TQ;
Object.defineProperty(cs, "__esModule", { value: !0 });
var tv = Ge, rv = I0, Il = function(e) {
  _d(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t;
}(tv.BaseItem), nv = function(e) {
  _d(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.defaultKind = "dummy", r.configuration = null, r;
  }
  return t.DefaultStackItems = (TQ = {}, TQ[Il.prototype.kind] = Il, TQ), t;
}(rv.AbstractFactory);
cs.default = nv;
var X9 = {}, iv = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, ov = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, av = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(X9, "__esModule", { value: !0 });
X9.NodeFactory = void 0;
var Qv = av(F4), Tv = function() {
  function e() {
    this.mmlFactory = null, this.factory = {
      node: e.createNode,
      token: e.createToken,
      text: e.createText,
      error: e.createError
    };
  }
  return e.createNode = function(t, r, n, i, o) {
    n === void 0 && (n = []), i === void 0 && (i = {});
    var a = t.mmlFactory.create(r);
    return a.setChildren(n), o && a.appendChild(o), Qv.default.setProperties(a, i), a;
  }, e.createToken = function(t, r, n, i) {
    n === void 0 && (n = {}), i === void 0 && (i = "");
    var o = t.create("text", i);
    return t.create("node", r, [], n, o);
  }, e.createText = function(t, r) {
    return r == null ? null : t.mmlFactory.create("text").setText(r);
  }, e.createError = function(t, r) {
    var n = t.create("text", r), i = t.create("node", "mtext", [], {}, n), o = t.create("node", "merror", [i], { "data-mjx-error": r });
    return o;
  }, e.prototype.setMmlFactory = function(t) {
    this.mmlFactory = t;
  }, e.prototype.set = function(t, r) {
    this.factory[t] = r;
  }, e.prototype.setCreators = function(t) {
    for (var r in t)
      this.set(r, t[r]);
  }, e.prototype.create = function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    var i = this.factory[t] || this.factory.node, o = i.apply(void 0, ov([this, r[0]], iv(r.slice(1)), !1));
    return t === "node" && this.configuration.addNode(r[0], o), o;
  }, e.prototype.get = function(t) {
    return this.factory[t];
  }, e;
}();
X9.NodeFactory = Tv;
var sv = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, lv = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Rl = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Od = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(us, "__esModule", { value: !0 });
var uv = Od(cs), cv = X9, Nl = Od(F4), Pl = r4, fv = function() {
  function e(t, r) {
    r === void 0 && (r = []), this.options = {}, this.packageData = /* @__PURE__ */ new Map(), this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.handlers = t.handlers, this.nodeFactory = new cv.NodeFactory(), this.nodeFactory.configuration = this, this.nodeFactory.setCreators(t.nodes), this.itemFactory = new uv.default(t.items), this.itemFactory.configuration = this, Pl.defaultOptions.apply(void 0, lv([this.options], sv(r), !1)), (0, Pl.defaultOptions)(this.options, t.options);
  }
  return e.prototype.pushParser = function(t) {
    this.parsers.unshift(t);
  }, e.prototype.popParser = function() {
    this.parsers.shift();
  }, Object.defineProperty(e.prototype, "parser", {
    get: function() {
      return this.parsers[0];
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.clear = function() {
    this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.tags.resetTag();
  }, e.prototype.addNode = function(t, r) {
    var n = this.nodeLists[t];
    if (n || (n = this.nodeLists[t] = []), n.push(r), r.kind !== t) {
      var i = Nl.default.getProperty(r, "in-lists") || "", o = (i ? i.split(/,/) : []).concat(t).join(",");
      Nl.default.setProperty(r, "in-lists", o);
    }
  }, e.prototype.getList = function(t) {
    var r, n, i = this.nodeLists[t] || [], o = [];
    try {
      for (var a = Rl(i), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        this.inTree(s) && o.push(s);
      }
    } catch (Q) {
      r = { error: Q };
    } finally {
      try {
        T && !T.done && (n = a.return) && n.call(a);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return this.nodeLists[t] = o, o;
  }, e.prototype.removeFromList = function(t, r) {
    var n, i, o = this.nodeLists[t] || [];
    try {
      for (var a = Rl(r), T = a.next(); !T.done; T = a.next()) {
        var s = T.value, Q = o.indexOf(s);
        Q >= 0 && o.splice(Q, 1);
      }
    } catch (u) {
      n = { error: u };
    } finally {
      try {
        T && !T.done && (i = a.return) && i.call(a);
      } finally {
        if (n)
          throw n.error;
      }
    }
  }, e.prototype.inTree = function(t) {
    for (; t && t !== this.root; )
      t = t.parent;
    return !!t;
  }, e;
}();
us.default = fv;
var Br = {};
(function(e) {
  var t = b && b.__extends || /* @__PURE__ */ function() {
    var u = function(l, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var m in d)
          Object.prototype.hasOwnProperty.call(d, m) && (f[m] = d[m]);
      }, u(l, c);
    };
    return function(l, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
      u(l, c);
      function f() {
        this.constructor = l;
      }
      l.prototype = c === null ? Object.create(c) : (f.prototype = c.prototype, new f());
    };
  }(), r = b && b.__values || function(u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = l && u[l], f = 0;
    if (c)
      return c.call(u);
    if (u && typeof u.length == "number")
      return {
        next: function() {
          return u && f >= u.length && (u = void 0), { value: u && u[f++], done: !u };
        }
      };
    throw new TypeError(l ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, n = b && b.__importDefault || function(u) {
    return u && u.__esModule ? u : { default: u };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TagsFactory = e.AllTags = e.NoTags = e.AbstractTags = e.TagInfo = e.Label = void 0;
  var i = n(U9()), o = /* @__PURE__ */ function() {
    function u(l, c) {
      l === void 0 && (l = "???"), c === void 0 && (c = ""), this.tag = l, this.id = c;
    }
    return u;
  }();
  e.Label = o;
  var a = /* @__PURE__ */ function() {
    function u(l, c, f, d, m, p, v, H) {
      l === void 0 && (l = ""), c === void 0 && (c = !1), f === void 0 && (f = !1), d === void 0 && (d = null), m === void 0 && (m = ""), p === void 0 && (p = ""), v === void 0 && (v = !1), H === void 0 && (H = ""), this.env = l, this.taggable = c, this.defaultTags = f, this.tag = d, this.tagId = m, this.tagFormat = p, this.noTag = v, this.labelId = H;
    }
    return u;
  }();
  e.TagInfo = a;
  var T = function() {
    function u() {
      this.counter = 0, this.allCounter = 0, this.configuration = null, this.ids = {}, this.allIds = {}, this.labels = {}, this.allLabels = {}, this.redo = !1, this.refUpdate = !1, this.currentTag = new a(), this.history = [], this.stack = [], this.enTag = function(l, c) {
        var f = this.configuration.nodeFactory, d = f.create("node", "mtd", [l]), m = f.create("node", "mlabeledtr", [c, d]), p = f.create("node", "mtable", [m], {
          side: this.configuration.options.tagSide,
          minlabelspacing: this.configuration.options.tagIndent,
          displaystyle: !0
        });
        return p;
      };
    }
    return u.prototype.start = function(l, c, f) {
      this.currentTag && this.stack.push(this.currentTag), this.currentTag = new a(l, c, f);
    }, Object.defineProperty(u.prototype, "env", {
      get: function() {
        return this.currentTag.env;
      },
      enumerable: !1,
      configurable: !0
    }), u.prototype.end = function() {
      this.history.push(this.currentTag), this.currentTag = this.stack.pop();
    }, u.prototype.tag = function(l, c) {
      this.currentTag.tag = l, this.currentTag.tagFormat = c ? l : this.formatTag(l), this.currentTag.noTag = !1;
    }, u.prototype.notag = function() {
      this.tag("", !0), this.currentTag.noTag = !0;
    }, Object.defineProperty(u.prototype, "noTag", {
      get: function() {
        return this.currentTag.noTag;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(u.prototype, "label", {
      get: function() {
        return this.currentTag.labelId;
      },
      set: function(l) {
        this.currentTag.labelId = l;
      },
      enumerable: !1,
      configurable: !0
    }), u.prototype.formatUrl = function(l, c) {
      return c + "#" + encodeURIComponent(l);
    }, u.prototype.formatTag = function(l) {
      return "(" + l + ")";
    }, u.prototype.formatId = function(l) {
      return "mjx-eqn:" + l.replace(/\s/g, "_");
    }, u.prototype.formatNumber = function(l) {
      return l.toString();
    }, u.prototype.autoTag = function() {
      this.currentTag.tag == null && (this.counter++, this.tag(this.formatNumber(this.counter), !1));
    }, u.prototype.clearTag = function() {
      this.label = "", this.tag(null, !0), this.currentTag.tagId = "";
    }, u.prototype.getTag = function(l) {
      if (l === void 0 && (l = !1), l)
        return this.autoTag(), this.makeTag();
      var c = this.currentTag;
      return c.taggable && !c.noTag && (c.defaultTags && this.autoTag(), c.tag) ? this.makeTag() : null;
    }, u.prototype.resetTag = function() {
      this.history = [], this.redo = !1, this.refUpdate = !1, this.clearTag();
    }, u.prototype.reset = function(l) {
      l === void 0 && (l = 0), this.resetTag(), this.counter = this.allCounter = l, this.allLabels = {}, this.allIds = {};
    }, u.prototype.startEquation = function(l) {
      this.history = [], this.stack = [], this.clearTag(), this.currentTag = new a("", void 0, void 0), this.labels = {}, this.ids = {}, this.counter = this.allCounter, this.redo = !1;
      var c = l.inputData.recompile;
      c && (this.refUpdate = !0, this.counter = c.counter);
    }, u.prototype.finishEquation = function(l) {
      this.redo && (l.inputData.recompile = {
        state: l.state(),
        counter: this.allCounter
      }), this.refUpdate || (this.allCounter = this.counter), Object.assign(this.allIds, this.ids), Object.assign(this.allLabels, this.labels);
    }, u.prototype.finalize = function(l, c) {
      if (!c.display || this.currentTag.env || this.currentTag.tag == null)
        return l;
      var f = this.makeTag(), d = this.enTag(l, f);
      return d;
    }, u.prototype.makeId = function() {
      this.currentTag.tagId = this.formatId(this.configuration.options.useLabelIds ? this.label || this.currentTag.tag : this.currentTag.tag);
    }, u.prototype.makeTag = function() {
      this.makeId(), this.label && (this.labels[this.label] = new o(this.currentTag.tag, this.currentTag.tagId));
      var l = new i.default("\\text{" + this.currentTag.tagFormat + "}", {}, this.configuration).mml();
      return this.configuration.nodeFactory.create("node", "mtd", [l], { id: this.currentTag.tagId });
    }, u;
  }();
  e.AbstractTags = T;
  var s = function(u) {
    t(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.prototype.autoTag = function() {
    }, l.prototype.getTag = function() {
      return this.currentTag.tag ? u.prototype.getTag.call(this) : null;
    }, l;
  }(T);
  e.NoTags = s;
  var Q = function(u) {
    t(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.prototype.finalize = function(c, f) {
      if (!f.display || this.history.find(function(m) {
        return m.taggable;
      }))
        return c;
      var d = this.getTag(!0);
      return this.enTag(c, d);
    }, l;
  }(T);
  e.AllTags = Q, function(u) {
    var l = /* @__PURE__ */ new Map([
      ["none", s],
      ["all", Q]
    ]), c = "none";
    u.OPTIONS = {
      tags: c,
      tagSide: "right",
      tagIndent: "0.8em",
      useLabelIds: !0,
      ignoreDuplicateLabels: !1
    }, u.add = function(f, d) {
      l.set(f, d);
    }, u.addTags = function(f) {
      var d, m;
      try {
        for (var p = r(Object.keys(f)), v = p.next(); !v.done; v = p.next()) {
          var H = v.value;
          u.add(H, f[H]);
        }
      } catch (E) {
        d = { error: E };
      } finally {
        try {
          v && !v.done && (m = p.return) && m.call(p);
        } finally {
          if (d)
            throw d.error;
        }
      }
    }, u.create = function(f) {
      var d = l.get(f) || l.get(c);
      if (!d)
        throw Error("Unknown tags class");
      return new d();
    }, u.setDefault = function(f) {
      c = f;
    }, u.getDefault = function() {
      return u.create(c);
    };
  }(e.TagsFactory || (e.TagsFactory = {}));
})(Br);
var fs = {}, Fr = {};
(function(e) {
  var t = b && b.__values || function(s) {
    var Q = typeof Symbol == "function" && Symbol.iterator, u = Q && s[Q], l = 0;
    if (u)
      return u.call(s);
    if (s && typeof s.length == "number")
      return {
        next: function() {
          return s && l >= s.length && (s = void 0), { value: s && s[l++], done: !s };
        }
      };
    throw new TypeError(Q ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = b && b.__read || function(s, Q) {
    var u = typeof Symbol == "function" && s[Symbol.iterator];
    if (!u)
      return s;
    var l = u.call(s), c, f = [], d;
    try {
      for (; (Q === void 0 || Q-- > 0) && !(c = l.next()).done; )
        f.push(c.value);
    } catch (m) {
      d = { error: m };
    } finally {
      try {
        c && !c.done && (u = l.return) && u.call(l);
      } finally {
        if (d)
          throw d.error;
      }
    }
    return f;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SubHandlers = e.SubHandler = e.MapHandler = void 0;
  var n = F5, i = j5, o;
  (function(s) {
    var Q = /* @__PURE__ */ new Map();
    s.register = function(u) {
      Q.set(u.name, u);
    }, s.getMap = function(u) {
      return Q.get(u);
    };
  })(o = e.MapHandler || (e.MapHandler = {}));
  var a = function() {
    function s() {
      this._configuration = new n.PrioritizedList(), this._fallback = new i.FunctionList();
    }
    return s.prototype.add = function(Q, u, l) {
      var c, f;
      l === void 0 && (l = n.PrioritizedList.DEFAULTPRIORITY);
      try {
        for (var d = t(Q.slice().reverse()), m = d.next(); !m.done; m = d.next()) {
          var p = m.value, v = o.getMap(p);
          if (!v) {
            this.warn("Configuration " + p + " not found! Omitted.");
            return;
          }
          this._configuration.add(v, l);
        }
      } catch (H) {
        c = { error: H };
      } finally {
        try {
          m && !m.done && (f = d.return) && f.call(d);
        } finally {
          if (c)
            throw c.error;
        }
      }
      u && this._fallback.add(u, l);
    }, s.prototype.parse = function(Q) {
      var u, l;
      try {
        for (var c = t(this._configuration), f = c.next(); !f.done; f = c.next()) {
          var d = f.value.item, m = d.parse(Q);
          if (m)
            return m;
        }
      } catch (E) {
        u = { error: E };
      } finally {
        try {
          f && !f.done && (l = c.return) && l.call(c);
        } finally {
          if (u)
            throw u.error;
        }
      }
      var p = r(Q, 2), v = p[0], H = p[1];
      Array.from(this._fallback)[0].item(v, H);
    }, s.prototype.lookup = function(Q) {
      var u = this.applicable(Q);
      return u ? u.lookup(Q) : null;
    }, s.prototype.contains = function(Q) {
      return !!this.applicable(Q);
    }, s.prototype.toString = function() {
      var Q, u, l = [];
      try {
        for (var c = t(this._configuration), f = c.next(); !f.done; f = c.next()) {
          var d = f.value.item;
          l.push(d.name);
        }
      } catch (m) {
        Q = { error: m };
      } finally {
        try {
          f && !f.done && (u = c.return) && u.call(c);
        } finally {
          if (Q)
            throw Q.error;
        }
      }
      return l.join(", ");
    }, s.prototype.applicable = function(Q) {
      var u, l;
      try {
        for (var c = t(this._configuration), f = c.next(); !f.done; f = c.next()) {
          var d = f.value.item;
          if (d.contains(Q))
            return d;
        }
      } catch (m) {
        u = { error: m };
      } finally {
        try {
          f && !f.done && (l = c.return) && l.call(c);
        } finally {
          if (u)
            throw u.error;
        }
      }
      return null;
    }, s.prototype.retrieve = function(Q) {
      var u, l;
      try {
        for (var c = t(this._configuration), f = c.next(); !f.done; f = c.next()) {
          var d = f.value.item;
          if (d.name === Q)
            return d;
        }
      } catch (m) {
        u = { error: m };
      } finally {
        try {
          f && !f.done && (l = c.return) && l.call(c);
        } finally {
          if (u)
            throw u.error;
        }
      }
      return null;
    }, s.prototype.warn = function(Q) {
      console.log("TexParser Warning: " + Q);
    }, s;
  }();
  e.SubHandler = a;
  var T = function() {
    function s() {
      this.map = /* @__PURE__ */ new Map();
    }
    return s.prototype.add = function(Q, u, l) {
      var c, f;
      l === void 0 && (l = n.PrioritizedList.DEFAULTPRIORITY);
      try {
        for (var d = t(Object.keys(Q)), m = d.next(); !m.done; m = d.next()) {
          var p = m.value, v = p, H = this.get(v);
          H || (H = new a(), this.set(v, H)), H.add(Q[v], u[v], l);
        }
      } catch (E) {
        c = { error: E };
      } finally {
        try {
          m && !m.done && (f = d.return) && f.call(d);
        } finally {
          if (c)
            throw c.error;
        }
      }
    }, s.prototype.set = function(Q, u) {
      this.map.set(Q, u);
    }, s.prototype.get = function(Q) {
      return this.map.get(Q);
    }, s.prototype.retrieve = function(Q) {
      var u, l;
      try {
        for (var c = t(this.map.values()), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, m = d.retrieve(Q);
          if (m)
            return m;
        }
      } catch (p) {
        u = { error: p };
      } finally {
        try {
          f && !f.done && (l = c.return) && l.call(c);
        } finally {
          if (u)
            throw u.error;
        }
      }
      return null;
    }, s.prototype.keys = function() {
      return this.map.keys();
    }, s;
  }();
  e.SubHandlers = T;
})(Fr);
(function(e) {
  var t = b && b.__values || function(l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = c && l[c], d = 0;
    if (f)
      return f.call(l);
    if (l && typeof l.length == "number")
      return {
        next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        }
      };
    throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = b && b.__read || function(l, c) {
    var f = typeof Symbol == "function" && l[Symbol.iterator];
    if (!f)
      return l;
    var d = f.call(l), m, p = [], v;
    try {
      for (; (c === void 0 || c-- > 0) && !(m = d.next()).done; )
        p.push(m.value);
    } catch (H) {
      v = { error: H };
    } finally {
      try {
        m && !m.done && (f = d.return) && f.call(d);
      } finally {
        if (v)
          throw v.error;
      }
    }
    return p;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ParserConfiguration = e.ConfigurationHandler = e.Configuration = void 0;
  var n = r4, i = Fr, o = j5, a = F5, T = Br, s = function() {
    function l(c, f, d, m, p, v, H, E, M, C, w, S, D) {
      f === void 0 && (f = {}), d === void 0 && (d = {}), m === void 0 && (m = {}), p === void 0 && (p = {}), v === void 0 && (v = {}), H === void 0 && (H = {}), E === void 0 && (E = []), M === void 0 && (M = []), C === void 0 && (C = null), w === void 0 && (w = null), this.name = c, this.handler = f, this.fallback = d, this.items = m, this.tags = p, this.options = v, this.nodes = H, this.preprocessors = E, this.postprocessors = M, this.initMethod = C, this.configMethod = w, this.priority = S, this.parser = D, this.handler = Object.assign({ character: [], delimiter: [], macro: [], environment: [] }, f);
    }
    return l.makeProcessor = function(c, f) {
      return Array.isArray(c) ? c : [c, f];
    }, l._create = function(c, f) {
      var d = this;
      f === void 0 && (f = {});
      var m = f.priority || a.PrioritizedList.DEFAULTPRIORITY, p = f.init ? this.makeProcessor(f.init, m) : null, v = f.config ? this.makeProcessor(f.config, m) : null, H = (f.preprocessors || []).map(function(C) {
        return d.makeProcessor(C, m);
      }), E = (f.postprocessors || []).map(function(C) {
        return d.makeProcessor(C, m);
      }), M = f.parser || "tex";
      return new l(c, f.handler || {}, f.fallback || {}, f.items || {}, f.tags || {}, f.options || {}, f.nodes || {}, H, E, p, v, m, M);
    }, l.create = function(c, f) {
      f === void 0 && (f = {});
      var d = l._create(c, f);
      return Q.set(c, d), d;
    }, l.local = function(c) {
      return c === void 0 && (c = {}), l._create("", c);
    }, Object.defineProperty(l.prototype, "init", {
      get: function() {
        return this.initMethod ? this.initMethod[0] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(l.prototype, "config", {
      get: function() {
        return this.configMethod ? this.configMethod[0] : null;
      },
      enumerable: !1,
      configurable: !0
    }), l;
  }();
  e.Configuration = s;
  var Q;
  (function(l) {
    var c = /* @__PURE__ */ new Map();
    l.set = function(f, d) {
      c.set(f, d);
    }, l.get = function(f) {
      return c.get(f);
    }, l.keys = function() {
      return c.keys();
    };
  })(Q = e.ConfigurationHandler || (e.ConfigurationHandler = {}));
  var u = function() {
    function l(c, f) {
      var d, m, p, v;
      f === void 0 && (f = ["tex"]), this.initMethod = new o.FunctionList(), this.configMethod = new o.FunctionList(), this.configurations = new a.PrioritizedList(), this.parsers = [], this.handlers = new i.SubHandlers(), this.items = {}, this.tags = {}, this.options = {}, this.nodes = {}, this.parsers = f;
      try {
        for (var H = t(c.slice().reverse()), E = H.next(); !E.done; E = H.next()) {
          var M = E.value;
          this.addPackage(M);
        }
      } catch ($) {
        d = { error: $ };
      } finally {
        try {
          E && !E.done && (m = H.return) && m.call(H);
        } finally {
          if (d)
            throw d.error;
        }
      }
      try {
        for (var C = t(this.configurations), w = C.next(); !w.done; w = C.next()) {
          var S = w.value, D = S.item, k = S.priority;
          this.append(D, k);
        }
      } catch ($) {
        p = { error: $ };
      } finally {
        try {
          w && !w.done && (v = C.return) && v.call(C);
        } finally {
          if (p)
            throw p.error;
        }
      }
    }
    return l.prototype.init = function() {
      this.initMethod.execute(this);
    }, l.prototype.config = function(c) {
      var f, d;
      this.configMethod.execute(this, c);
      try {
        for (var m = t(this.configurations), p = m.next(); !p.done; p = m.next()) {
          var v = p.value;
          this.addFilters(c, v.item);
        }
      } catch (H) {
        f = { error: H };
      } finally {
        try {
          p && !p.done && (d = m.return) && d.call(m);
        } finally {
          if (f)
            throw f.error;
        }
      }
    }, l.prototype.addPackage = function(c) {
      var f = typeof c == "string" ? c : c[0], d = this.getPackage(f);
      d && this.configurations.add(d, typeof c == "string" ? d.priority : c[1]);
    }, l.prototype.add = function(c, f, d) {
      var m, p;
      d === void 0 && (d = {});
      var v = this.getPackage(c);
      this.append(v), this.configurations.add(v, v.priority), this.init();
      var H = f.parseOptions;
      H.nodeFactory.setCreators(v.nodes);
      try {
        for (var E = t(Object.keys(v.items)), M = E.next(); !M.done; M = E.next()) {
          var C = M.value;
          H.itemFactory.setNodeClass(C, v.items[C]);
        }
      } catch (w) {
        m = { error: w };
      } finally {
        try {
          M && !M.done && (p = E.return) && p.call(E);
        } finally {
          if (m)
            throw m.error;
        }
      }
      T.TagsFactory.addTags(v.tags), (0, n.defaultOptions)(H.options, v.options), (0, n.userOptions)(H.options, d), this.addFilters(f, v), v.config && v.config(this, f);
    }, l.prototype.getPackage = function(c) {
      var f = Q.get(c);
      if (f && this.parsers.indexOf(f.parser) < 0)
        throw Error("Package ".concat(c, " doesn't target the proper parser"));
      return f;
    }, l.prototype.append = function(c, f) {
      f = f || c.priority, c.initMethod && this.initMethod.add(c.initMethod[0], c.initMethod[1]), c.configMethod && this.configMethod.add(c.configMethod[0], c.configMethod[1]), this.handlers.add(c.handler, c.fallback, f), Object.assign(this.items, c.items), Object.assign(this.tags, c.tags), (0, n.defaultOptions)(this.options, c.options), Object.assign(this.nodes, c.nodes);
    }, l.prototype.addFilters = function(c, f) {
      var d, m, p, v;
      try {
        for (var H = t(f.preprocessors), E = H.next(); !E.done; E = H.next()) {
          var M = r(E.value, 2), C = M[0], w = M[1];
          c.preFilters.add(C, w);
        }
      } catch (z) {
        d = { error: z };
      } finally {
        try {
          E && !E.done && (m = H.return) && m.call(H);
        } finally {
          if (d)
            throw d.error;
        }
      }
      try {
        for (var S = t(f.postprocessors), D = S.next(); !D.done; D = S.next()) {
          var k = r(D.value, 2), $ = k[0], w = k[1];
          c.postFilters.add($, w);
        }
      } catch (z) {
        p = { error: z };
      } finally {
        try {
          D && !D.done && (v = S.return) && v.call(S);
        } finally {
          if (p)
            throw p.error;
        }
      }
    }, l;
  }();
  e.ParserConfiguration = u;
})(fs);
var Fe = {}, h3 = {}, E0 = {};
Object.defineProperty(E0, "__esModule", { value: !0 });
E0.Macro = E0.Symbol = void 0;
var dv = function() {
  function e(t, r, n) {
    this._symbol = t, this._char = r, this._attributes = n;
  }
  return Object.defineProperty(e.prototype, "symbol", {
    get: function() {
      return this._symbol;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "char", {
    get: function() {
      return this._char;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "attributes", {
    get: function() {
      return this._attributes;
    },
    enumerable: !1,
    configurable: !0
  }), e;
}();
E0.Symbol = dv;
var hv = function() {
  function e(t, r, n) {
    n === void 0 && (n = []), this._symbol = t, this._func = r, this._args = n;
  }
  return Object.defineProperty(e.prototype, "symbol", {
    get: function() {
      return this._symbol;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "func", {
    get: function() {
      return this._func;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "args", {
    get: function() {
      return this._args;
    },
    enumerable: !1,
    configurable: !0
  }), e;
}();
E0.Macro = hv;
var nt = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), K6 = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Ad = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Dd = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(h3, "__esModule", { value: !0 });
h3.EnvironmentMap = h3.CommandMap = h3.MacroMap = h3.DelimiterMap = h3.CharacterMap = h3.AbstractParseMap = h3.RegExpMap = h3.AbstractSymbolMap = h3.parseResult = void 0;
var kd = E0, pv = Fr;
function jr(e) {
  return e === void 0 ? !0 : e;
}
h3.parseResult = jr;
var ds = function() {
  function e(t, r) {
    this._name = t, this._parser = r, pv.MapHandler.register(this);
  }
  return Object.defineProperty(e.prototype, "name", {
    get: function() {
      return this._name;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.parserFor = function(t) {
    return this.contains(t) ? this.parser : null;
  }, e.prototype.parse = function(t) {
    var r = K6(t, 2), n = r[0], i = r[1], o = this.parserFor(i), a = this.lookup(i);
    return o && a ? jr(o(n, a)) : null;
  }, Object.defineProperty(e.prototype, "parser", {
    get: function() {
      return this._parser;
    },
    set: function(t) {
      this._parser = t;
    },
    enumerable: !1,
    configurable: !0
  }), e;
}();
h3.AbstractSymbolMap = ds;
var mv = function(e) {
  nt(t, e);
  function t(r, n, i) {
    var o = e.call(this, r, n) || this;
    return o._regExp = i, o;
  }
  return t.prototype.contains = function(r) {
    return this._regExp.test(r);
  }, t.prototype.lookup = function(r) {
    return this.contains(r) ? r : null;
  }, t;
}(ds);
h3.RegExpMap = mv;
var hs = function(e) {
  nt(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.map = /* @__PURE__ */ new Map(), r;
  }
  return t.prototype.lookup = function(r) {
    return this.map.get(r);
  }, t.prototype.contains = function(r) {
    return this.map.has(r);
  }, t.prototype.add = function(r, n) {
    this.map.set(r, n);
  }, t.prototype.remove = function(r) {
    this.map.delete(r);
  }, t;
}(ds);
h3.AbstractParseMap = hs;
var Id = function(e) {
  nt(t, e);
  function t(r, n, i) {
    var o, a, T = e.call(this, r, n) || this;
    try {
      for (var s = Ad(Object.keys(i)), Q = s.next(); !Q.done; Q = s.next()) {
        var u = Q.value, l = i[u], c = K6(typeof l == "string" ? [l, null] : l, 2), f = c[0], d = c[1], m = new kd.Symbol(u, f, d);
        T.add(u, m);
      }
    } catch (p) {
      o = { error: p };
    } finally {
      try {
        Q && !Q.done && (a = s.return) && a.call(s);
      } finally {
        if (o)
          throw o.error;
      }
    }
    return T;
  }
  return t;
}(hs);
h3.CharacterMap = Id;
var vv = function(e) {
  nt(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.parse = function(r) {
    var n = K6(r, 2), i = n[0], o = n[1];
    return e.prototype.parse.call(this, [i, "\\" + o]);
  }, t;
}(Id);
h3.DelimiterMap = vv;
var ps = function(e) {
  nt(t, e);
  function t(r, n, i) {
    var o, a, T = e.call(this, r, null) || this;
    try {
      for (var s = Ad(Object.keys(n)), Q = s.next(); !Q.done; Q = s.next()) {
        var u = Q.value, l = n[u], c = K6(typeof l == "string" ? [l] : l), f = c[0], d = c.slice(1), m = new kd.Macro(u, i[f], d);
        T.add(u, m);
      }
    } catch (p) {
      o = { error: p };
    } finally {
      try {
        Q && !Q.done && (a = s.return) && a.call(s);
      } finally {
        if (o)
          throw o.error;
      }
    }
    return T;
  }
  return t.prototype.parserFor = function(r) {
    var n = this.lookup(r);
    return n ? n.func : null;
  }, t.prototype.parse = function(r) {
    var n = K6(r, 2), i = n[0], o = n[1], a = this.lookup(o), T = this.parserFor(o);
    return !a || !T ? null : jr(T.apply(void 0, Dd([i, a.symbol], K6(a.args), !1)));
  }, t;
}(hs);
h3.MacroMap = ps;
var Lv = function(e) {
  nt(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.parse = function(r) {
    var n = K6(r, 2), i = n[0], o = n[1], a = this.lookup(o), T = this.parserFor(o);
    if (!a || !T)
      return null;
    var s = i.currentCS;
    i.currentCS = "\\" + o;
    var Q = T.apply(void 0, Dd([i, "\\" + a.symbol], K6(a.args), !1));
    return i.currentCS = s, jr(Q);
  }, t;
}(ps);
h3.CommandMap = Lv;
var yv = function(e) {
  nt(t, e);
  function t(r, n, i, o) {
    var a = e.call(this, r, i, o) || this;
    return a.parser = n, a;
  }
  return t.prototype.parse = function(r) {
    var n = K6(r, 2), i = n[0], o = n[1], a = this.lookup(o), T = this.parserFor(o);
    return !a || !T ? null : jr(this.parser(i, a.symbol, T, a.args));
  }, t;
}(ps);
h3.EnvironmentMap = yv;
var o2 = {}, T3 = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), i9 = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, lT = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ms = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(o2, "__esModule", { value: !0 });
o2.EquationItem = o2.EqnArrayItem = o2.ArrayItem = o2.DotsItem = o2.NonscriptItem = o2.NotItem = o2.FnItem = o2.MmlItem = o2.CellItem = o2.PositionItem = o2.StyleItem = o2.EndItem = o2.BeginItem = o2.RightItem = o2.Middle = o2.LeftItem = o2.OverItem = o2.SubsupItem = o2.PrimeItem = o2.CloseItem = o2.OpenItem = o2.StopItem = o2.StartItem = void 0;
var gv = Fr, xv = Nr, b0 = T2, N5 = ms(i5), O5 = ms(Pr()), C2 = ms(F4), A2 = Ge, Hv = function(e) {
  T3(t, e);
  function t(r, n) {
    var i = e.call(this, r) || this;
    return i.global = n, i;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "start";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("stop")) {
      var n = this.toMml();
      return this.global.isInner || (n = this.factory.configuration.tags.finalize(n, this.env)), [[this.factory.create("mml", n)], !0];
    }
    return e.prototype.checkItem.call(this, r);
  }, t;
}(A2.BaseItem);
o2.StartItem = Hv;
var Ev = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "stop";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.StopItem = Ev;
var bv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "open";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("close")) {
      var n = this.toMml(), i = this.create("node", "TeXAtom", [n]);
      return [[this.factory.create("mml", i)], !0];
    }
    return e.prototype.checkItem.call(this, r);
  }, t.errors = Object.assign(Object.create(A2.BaseItem.errors), {
    stop: [
      "ExtraOpenMissingClose",
      "Extra open brace or missing close brace"
    ]
  }), t;
}(A2.BaseItem);
o2.OpenItem = bv;
var Mv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "close";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.CloseItem = Mv;
var wv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "prime";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    var n = i9(this.Peek(2), 2), i = n[0], o = n[1];
    if (!C2.default.isType(i, "msubsup") || C2.default.isType(i, "msup")) {
      var a = this.create("node", "msup", [i, o]);
      return [[a, r], !0];
    }
    return C2.default.setChild(i, i.sup, o), [[i, r], !0];
  }, t;
}(A2.BaseItem);
o2.PrimeItem = wv;
var Sv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "subsup";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("open") || r.isKind("left"))
      return A2.BaseItem.success;
    var n = this.First, i = this.getProperty("position");
    if (r.isKind("mml")) {
      if (this.getProperty("primes"))
        if (i !== 2)
          C2.default.setChild(n, 2, this.getProperty("primes"));
        else {
          C2.default.setProperty(this.getProperty("primes"), "variantForm", !0);
          var o = this.create("node", "mrow", [this.getProperty("primes"), r.First]);
          r.First = o;
        }
      C2.default.setChild(n, i, r.First), this.getProperty("movesupsub") != null && C2.default.setProperty(n, "movesupsub", this.getProperty("movesupsub"));
      var a = this.factory.create("mml", n);
      return [[a], !0];
    }
    if (e.prototype.checkItem.call(this, r)[1]) {
      var T = this.getErrors(["", "sub", "sup"][i]);
      throw new (N5.default.bind.apply(N5.default, lT([void 0, T[0], T[1]], i9(T.splice(2)), !1)))();
    }
    return null;
  }, t.errors = Object.assign(Object.create(A2.BaseItem.errors), {
    stop: [
      "MissingScript",
      "Missing superscript or subscript argument"
    ],
    sup: [
      "MissingOpenForSup",
      "Missing open brace for superscript"
    ],
    sub: [
      "MissingOpenForSub",
      "Missing open brace for subscript"
    ]
  }), t;
}(A2.BaseItem);
o2.SubsupItem = Sv;
var Cv = function(e) {
  T3(t, e);
  function t(r) {
    var n = e.call(this, r) || this;
    return n.setProperty("name", "\\over"), n;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "over";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("over"))
      throw new N5.default("AmbiguousUseOf", "Ambiguous use of %1", r.getName());
    if (r.isClose) {
      var n = this.create("node", "mfrac", [this.getProperty("num"), this.toMml(!1)]);
      return this.getProperty("thickness") != null && C2.default.setAttribute(n, "linethickness", this.getProperty("thickness")), (this.getProperty("open") || this.getProperty("close")) && (C2.default.setProperty(n, "withDelims", !0), n = O5.default.fixedFence(this.factory.configuration, this.getProperty("open"), n, this.getProperty("close"))), [[this.factory.create("mml", n), r], !0];
    }
    return e.prototype.checkItem.call(this, r);
  }, t.prototype.toString = function() {
    return "over[" + this.getProperty("num") + " / " + this.nodes.join("; ") + "]";
  }, t;
}(A2.BaseItem);
o2.OverItem = Cv;
var Vv = function(e) {
  T3(t, e);
  function t(r, n) {
    var i = e.call(this, r) || this;
    return i.setProperty("delim", n), i;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "left";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("right"))
      return [[this.factory.create("mml", O5.default.fenced(this.factory.configuration, this.getProperty("delim"), this.toMml(), r.getProperty("delim"), "", r.getProperty("color")))], !0];
    if (r.isKind("middle")) {
      var n = { stretchy: !0 };
      return r.getProperty("color") && (n.mathcolor = r.getProperty("color")), this.Push(this.create("node", "TeXAtom", [], { texClass: b0.TEXCLASS.CLOSE }), this.create("token", "mo", n, r.getProperty("delim")), this.create("node", "TeXAtom", [], { texClass: b0.TEXCLASS.OPEN })), this.env = {}, [[this], !0];
    }
    return e.prototype.checkItem.call(this, r);
  }, t.errors = Object.assign(Object.create(A2.BaseItem.errors), {
    stop: [
      "ExtraLeftMissingRight",
      "Extra \\left or missing \\right"
    ]
  }), t;
}(A2.BaseItem);
o2.LeftItem = Vv;
var _v = function(e) {
  T3(t, e);
  function t(r, n, i) {
    var o = e.call(this, r) || this;
    return o.setProperty("delim", n), i && o.setProperty("color", i), o;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "middle";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.Middle = _v;
var Ov = function(e) {
  T3(t, e);
  function t(r, n, i) {
    var o = e.call(this, r) || this;
    return o.setProperty("delim", n), i && o.setProperty("color", i), o;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "right";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.RightItem = Ov;
var Av = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "begin";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("end")) {
      if (r.getName() !== this.getName())
        throw new N5.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), r.getName());
      return this.getProperty("end") ? A2.BaseItem.fail : [[this.factory.create("mml", this.toMml())], !0];
    }
    if (r.isKind("stop"))
      throw new N5.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
    return e.prototype.checkItem.call(this, r);
  }, t;
}(A2.BaseItem);
o2.BeginItem = Av;
var Dv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "end";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.EndItem = Dv;
var kv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "style";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (!r.isClose)
      return e.prototype.checkItem.call(this, r);
    var n = this.create("node", "mstyle", this.nodes, this.getProperty("styles"));
    return [[this.factory.create("mml", n), r], !0];
  }, t;
}(A2.BaseItem);
o2.StyleItem = kv;
var Iv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "position";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isClose)
      throw new N5.default("MissingBoxFor", "Missing box for %1", this.getName());
    if (r.isFinal) {
      var n = r.toMml();
      switch (this.getProperty("move")) {
        case "vertical":
          return n = this.create("node", "mpadded", [n], {
            height: this.getProperty("dh"),
            depth: this.getProperty("dd"),
            voffset: this.getProperty("dh")
          }), [[this.factory.create("mml", n)], !0];
        case "horizontal":
          return [[
            this.factory.create("mml", this.getProperty("left")),
            r,
            this.factory.create("mml", this.getProperty("right"))
          ], !0];
      }
    }
    return e.prototype.checkItem.call(this, r);
  }, t;
}(A2.BaseItem);
o2.PositionItem = Iv;
var Rv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "cell";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isClose", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.CellItem = Rv;
var Nv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "isFinal", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mml";
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(A2.BaseItem);
o2.MmlItem = Nv;
var Pv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "fn";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    var n = this.First;
    if (n) {
      if (r.isOpen)
        return A2.BaseItem.success;
      if (!r.isKind("fn")) {
        var i = r.First;
        if (!r.isKind("mml") || !i)
          return [[n, r], !0];
        if (C2.default.isType(i, "mstyle") && i.childNodes.length && C2.default.isType(i.childNodes[0].childNodes[0], "mspace") || C2.default.isType(i, "mspace"))
          return [[n, r], !0];
        C2.default.isEmbellished(i) && (i = C2.default.getCoreMO(i));
        var o = C2.default.getForm(i);
        if (o != null && [0, 0, 1, 1, 0, 1, 1, 0, 0, 0][o[2]])
          return [[n, r], !0];
      }
      var a = this.create("token", "mo", { texClass: b0.TEXCLASS.NONE }, xv.entities.ApplyFunction);
      return [[n, a, r], !0];
    }
    return e.prototype.checkItem.apply(this, arguments);
  }, t;
}(A2.BaseItem);
o2.FnItem = Pv;
var Bv = function(e) {
  T3(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.remap = gv.MapHandler.getMap("not_remap"), r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "not";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    var n, i, o;
    if (r.isKind("open") || r.isKind("left"))
      return A2.BaseItem.success;
    if (r.isKind("mml") && (C2.default.isType(r.First, "mo") || C2.default.isType(r.First, "mi") || C2.default.isType(r.First, "mtext")) && (n = r.First, i = C2.default.getText(n), i.length === 1 && !C2.default.getProperty(n, "movesupsub") && C2.default.getChildren(n).length === 1))
      return this.remap.contains(i) ? (o = this.create("text", this.remap.lookup(i).char), C2.default.setChild(n, 0, o)) : (o = this.create("text", "̸"), C2.default.appendChildren(n, [o])), [[r], !0];
    o = this.create("text", "⧸");
    var a = this.create("node", "mtext", [], {}, o), T = this.create("node", "mpadded", [a], { width: 0 });
    return n = this.create("node", "TeXAtom", [T], { texClass: b0.TEXCLASS.REL }), [[n, r], !0];
  }, t;
}(A2.BaseItem);
o2.NotItem = Bv;
var Fv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "nonscript";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("mml") && r.Size() === 1) {
      var n = r.First;
      if (n.isKind("mstyle") && n.notParent && (n = C2.default.getChildren(C2.default.getChildren(n)[0])[0]), n.isKind("mspace")) {
        if (n !== r.First) {
          var i = this.create("node", "mrow", [r.Pop()]);
          r.Push(i);
        }
        this.factory.configuration.addNode("nonscript", r.First);
      }
    }
    return [[r], !0];
  }, t;
}(A2.BaseItem);
o2.NonscriptItem = Fv;
var jv = function(e) {
  T3(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "dots";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("open") || r.isKind("left"))
      return A2.BaseItem.success;
    var n = this.getProperty("ldots"), i = r.First;
    if (r.isKind("mml") && C2.default.isEmbellished(i)) {
      var o = C2.default.getTexClass(C2.default.getCoreMO(i));
      (o === b0.TEXCLASS.BIN || o === b0.TEXCLASS.REL) && (n = this.getProperty("cdots"));
    }
    return [[n, r], !0];
  }, t;
}(A2.BaseItem);
o2.DotsItem = jv;
var Rd = function(e) {
  T3(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.table = [], r.row = [], r.frame = [], r.hfill = [], r.arraydef = {}, r.dashed = !1, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "array";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "copyEnv", {
    get: function() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isClose && !r.isKind("over")) {
      if (r.getProperty("isEntry"))
        return this.EndEntry(), this.clearEnv(), A2.BaseItem.fail;
      if (r.getProperty("isCR"))
        return this.EndEntry(), this.EndRow(), this.clearEnv(), A2.BaseItem.fail;
      this.EndTable(), this.clearEnv();
      var n = this.factory.create("mml", this.createMml());
      if (this.getProperty("requireClose")) {
        if (r.isKind("close"))
          return [[n], !0];
        throw new N5.default("MissingCloseBrace", "Missing close brace");
      }
      return [[n, r], !0];
    }
    return e.prototype.checkItem.call(this, r);
  }, t.prototype.createMml = function() {
    var r = this.arraydef.scriptlevel;
    delete this.arraydef.scriptlevel;
    var n = this.create("node", "mtable", this.table, this.arraydef);
    return r && n.setProperty("scriptlevel", r), this.frame.length === 4 ? C2.default.setAttribute(n, "frame", this.dashed ? "dashed" : "solid") : this.frame.length && (this.arraydef.rowlines && (this.arraydef.rowlines = this.arraydef.rowlines.replace(/none( none)+$/, "none")), C2.default.setAttribute(n, "frame", ""), n = this.create("node", "menclose", [n], { notation: this.frame.join(" ") }), ((this.arraydef.columnlines || "none") !== "none" || (this.arraydef.rowlines || "none") !== "none") && C2.default.setAttribute(n, "data-padding", 0)), (this.getProperty("open") || this.getProperty("close")) && (n = O5.default.fenced(this.factory.configuration, this.getProperty("open"), n, this.getProperty("close"))), n;
  }, t.prototype.EndEntry = function() {
    var r = this.create("node", "mtd", this.nodes);
    this.hfill.length && (this.hfill[0] === 0 && C2.default.setAttribute(r, "columnalign", "right"), this.hfill[this.hfill.length - 1] === this.Size() && C2.default.setAttribute(r, "columnalign", C2.default.getAttribute(r, "columnalign") ? "center" : "left")), this.row.push(r), this.Clear(), this.hfill = [];
  }, t.prototype.EndRow = function() {
    var r;
    this.getProperty("isNumbered") && this.row.length === 3 ? (this.row.unshift(this.row.pop()), r = this.create("node", "mlabeledtr", this.row)) : r = this.create("node", "mtr", this.row), this.table.push(r), this.row = [];
  }, t.prototype.EndTable = function() {
    (this.Size() || this.row.length) && (this.EndEntry(), this.EndRow()), this.checkLines();
  }, t.prototype.checkLines = function() {
    if (this.arraydef.rowlines) {
      var r = this.arraydef.rowlines.split(/ /);
      r.length === this.table.length ? (this.frame.push("bottom"), r.pop(), this.arraydef.rowlines = r.join(" ")) : r.length < this.table.length - 1 && (this.arraydef.rowlines += " none");
    }
    if (this.getProperty("rowspacing")) {
      for (var n = this.arraydef.rowspacing.split(/ /); n.length < this.table.length; )
        n.push(this.getProperty("rowspacing") + "em");
      this.arraydef.rowspacing = n.join(" ");
    }
  }, t.prototype.addRowSpacing = function(r) {
    if (this.arraydef.rowspacing) {
      var n = this.arraydef.rowspacing.split(/ /);
      if (!this.getProperty("rowspacing")) {
        var i = O5.default.dimen2em(n[0]);
        this.setProperty("rowspacing", i);
      }
      for (var o = this.getProperty("rowspacing"); n.length < this.table.length; )
        n.push(O5.default.Em(o));
      n[this.table.length - 1] = O5.default.Em(Math.max(0, o + O5.default.dimen2em(r))), this.arraydef.rowspacing = n.join(" ");
    }
  }, t;
}(A2.BaseItem);
o2.ArrayItem = Rd;
var $v = function(e) {
  T3(t, e);
  function t(r) {
    for (var n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    var o = e.call(this, r) || this;
    return o.maxrow = 0, o.factory.configuration.tags.start(n[0], n[2], n[1]), o;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "eqnarray";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.EndEntry = function() {
    this.row.length && O5.default.fixInitialMO(this.factory.configuration, this.nodes);
    var r = this.create("node", "mtd", this.nodes);
    this.row.push(r), this.Clear();
  }, t.prototype.EndRow = function() {
    this.row.length > this.maxrow && (this.maxrow = this.row.length);
    var r = "mtr", n = this.factory.configuration.tags.getTag();
    n && (this.row = [n].concat(this.row), r = "mlabeledtr"), this.factory.configuration.tags.clearTag();
    var i = this.create("node", r, this.row);
    this.table.push(i), this.row = [];
  }, t.prototype.EndTable = function() {
    e.prototype.EndTable.call(this), this.factory.configuration.tags.end(), this.extendArray("columnalign", this.maxrow), this.extendArray("columnwidth", this.maxrow), this.extendArray("columnspacing", this.maxrow - 1);
  }, t.prototype.extendArray = function(r, n) {
    if (this.arraydef[r]) {
      var i = this.arraydef[r].split(/ /), o = lT([], i9(i), !1);
      if (o.length > 1) {
        for (; o.length < n; )
          o.push.apply(o, lT([], i9(i), !1));
        this.arraydef[r] = o.slice(0, n).join(" ");
      }
    }
  }, t;
}(Rd);
o2.EqnArrayItem = $v;
var Zv = function(e) {
  T3(t, e);
  function t(r) {
    for (var n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    var o = e.call(this, r) || this;
    return o.factory.configuration.tags.start("equation", !0, n[0]), o;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "equation";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isOpen", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.checkItem = function(r) {
    if (r.isKind("end")) {
      var n = this.toMml(), i = this.factory.configuration.tags.getTag();
      return this.factory.configuration.tags.end(), [[i ? this.factory.configuration.tags.enTag(n, i) : n, r], !0];
    }
    if (r.isKind("stop"))
      throw new N5.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
    return e.prototype.checkItem.call(this, r);
  }, t;
}(A2.BaseItem);
o2.EquationItem = Zv;
var q9 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TexConstant = void 0, function(t) {
    t.Variant = {
      NORMAL: "normal",
      BOLD: "bold",
      ITALIC: "italic",
      BOLDITALIC: "bold-italic",
      DOUBLESTRUCK: "double-struck",
      FRAKTUR: "fraktur",
      BOLDFRAKTUR: "bold-fraktur",
      SCRIPT: "script",
      BOLDSCRIPT: "bold-script",
      SANSSERIF: "sans-serif",
      BOLDSANSSERIF: "bold-sans-serif",
      SANSSERIFITALIC: "sans-serif-italic",
      SANSSERIFBOLDITALIC: "sans-serif-bold-italic",
      MONOSPACE: "monospace",
      INITIAL: "inital",
      TAILED: "tailed",
      LOOPED: "looped",
      STRETCHED: "stretched",
      CALLIGRAPHIC: "-tex-calligraphic",
      BOLDCALLIGRAPHIC: "-tex-bold-calligraphic",
      OLDSTYLE: "-tex-oldstyle",
      BOLDOLDSTYLE: "-tex-bold-oldstyle",
      MATHITALIC: "-tex-mathit"
    }, t.Form = {
      PREFIX: "prefix",
      INFIX: "infix",
      POSTFIX: "postfix"
    }, t.LineBreak = {
      AUTO: "auto",
      NEWLINE: "newline",
      NOBREAK: "nobreak",
      GOODBREAK: "goodbreak",
      BADBREAK: "badbreak"
    }, t.LineBreakStyle = {
      BEFORE: "before",
      AFTER: "after",
      DUPLICATE: "duplicate",
      INFIXLINBREAKSTYLE: "infixlinebreakstyle"
    }, t.IndentAlign = {
      LEFT: "left",
      CENTER: "center",
      RIGHT: "right",
      AUTO: "auto",
      ID: "id",
      INDENTALIGN: "indentalign"
    }, t.IndentShift = {
      INDENTSHIFT: "indentshift"
    }, t.LineThickness = {
      THIN: "thin",
      MEDIUM: "medium",
      THICK: "thick"
    }, t.Notation = {
      LONGDIV: "longdiv",
      ACTUARIAL: "actuarial",
      PHASORANGLE: "phasorangle",
      RADICAL: "radical",
      BOX: "box",
      ROUNDEDBOX: "roundedbox",
      CIRCLE: "circle",
      LEFT: "left",
      RIGHT: "right",
      TOP: "top",
      BOTTOM: "bottom",
      UPDIAGONALSTRIKE: "updiagonalstrike",
      DOWNDIAGONALSTRIKE: "downdiagonalstrike",
      VERTICALSTRIKE: "verticalstrike",
      HORIZONTALSTRIKE: "horizontalstrike",
      NORTHEASTARROW: "northeastarrow",
      MADRUWB: "madruwb",
      UPDIAGONALARROW: "updiagonalarrow"
    }, t.Align = {
      TOP: "top",
      BOTTOM: "bottom",
      CENTER: "center",
      BASELINE: "baseline",
      AXIS: "axis",
      LEFT: "left",
      RIGHT: "right"
    }, t.Lines = {
      NONE: "none",
      SOLID: "solid",
      DASHED: "dashed"
    }, t.Side = {
      LEFT: "left",
      RIGHT: "right",
      LEFTOVERLAP: "leftoverlap",
      RIGHTOVERLAP: "rightoverlap"
    }, t.Width = {
      AUTO: "auto",
      FIT: "fit"
    }, t.Actiontype = {
      TOGGLE: "toggle",
      STATUSLINE: "statusline",
      TOOLTIP: "tooltip",
      INPUT: "input"
    }, t.Overflow = {
      LINBREAK: "linebreak",
      SCROLL: "scroll",
      ELIDE: "elide",
      TRUNCATE: "truncate",
      SCALE: "scale"
    }, t.Unit = {
      EM: "em",
      EX: "ex",
      PX: "px",
      IN: "in",
      CM: "cm",
      MM: "mm",
      PT: "pt",
      PC: "pc"
    };
  }(e.TexConstant || (e.TexConstant = {}));
})(q9);
var vs = {}, it = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.px = e.emRounded = e.em = e.percent = e.length2em = e.MATHSPACE = e.RELUNITS = e.UNITS = e.BIGDIMEN = void 0, e.BIGDIMEN = 1e6, e.UNITS = {
    px: 1,
    in: 96,
    cm: 96 / 2.54,
    mm: 96 / 25.4
  }, e.RELUNITS = {
    em: 1,
    ex: 0.431,
    pt: 1 / 10,
    pc: 12 / 10,
    mu: 1 / 18
  }, e.MATHSPACE = {
    veryverythinmathspace: 1 / 18,
    verythinmathspace: 2 / 18,
    thinmathspace: 3 / 18,
    mediummathspace: 4 / 18,
    thickmathspace: 5 / 18,
    verythickmathspace: 6 / 18,
    veryverythickmathspace: 7 / 18,
    negativeveryverythinmathspace: -1 / 18,
    negativeverythinmathspace: -2 / 18,
    negativethinmathspace: -3 / 18,
    negativemediummathspace: -4 / 18,
    negativethickmathspace: -5 / 18,
    negativeverythickmathspace: -6 / 18,
    negativeveryverythickmathspace: -7 / 18,
    thin: 0.04,
    medium: 0.06,
    thick: 0.1,
    normal: 1,
    big: 2,
    small: 1 / Math.sqrt(2),
    infinity: e.BIGDIMEN
  };
  function t(a, T, s, Q) {
    if (T === void 0 && (T = 0), s === void 0 && (s = 1), Q === void 0 && (Q = 16), typeof a != "string" && (a = String(a)), a === "" || a == null)
      return T;
    if (e.MATHSPACE[a])
      return e.MATHSPACE[a];
    var u = a.match(/^\s*([-+]?(?:\.\d+|\d+(?:\.\d*)?))?(pt|em|ex|mu|px|pc|in|mm|cm|%)?/);
    if (!u)
      return T;
    var l = parseFloat(u[1] || "1"), c = u[2];
    return e.UNITS.hasOwnProperty(c) ? l * e.UNITS[c] / Q / s : e.RELUNITS.hasOwnProperty(c) ? l * e.RELUNITS[c] : c === "%" ? l / 100 * T : l * T;
  }
  e.length2em = t;
  function r(a) {
    return (100 * a).toFixed(1).replace(/\.?0+$/, "") + "%";
  }
  e.percent = r;
  function n(a) {
    return Math.abs(a) < 1e-3 ? "0" : a.toFixed(3).replace(/\.?0+$/, "") + "em";
  }
  e.em = n;
  function i(a, T) {
    return T === void 0 && (T = 16), a = (Math.round(a * T) + 0.05) / T, Math.abs(a) < 1e-3 ? "0em" : a.toFixed(3).replace(/\.?0+$/, "") + "em";
  }
  e.emRounded = i;
  function o(a, T, s) {
    return T === void 0 && (T = -e.BIGDIMEN), s === void 0 && (s = 16), a *= s, T && a < T && (a = T), Math.abs(a) < 0.1 ? "0" : a.toFixed(1).replace(/\.0$/, "") + "px";
  }
  e.px = o;
})(it);
var M0 = b && b.__assign || function() {
  return M0 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, M0.apply(this, arguments);
}, Wv = b && b.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), Gv = b && b.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), zv = b && b.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && Wv(t, e, r);
  return Gv(t, e), t;
}, Ls = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, J9 = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(vs, "__esModule", { value: !0 });
var ys = zv(o2), j1 = J9(F4), w3 = J9(i5), Y9 = J9(U9()), gs = q9, L3 = J9(Pr()), R0 = T2, Nd = Br, Pd = it, uT = Nr, Uv = r4, G1 = {}, Xv = 1.2 / 0.85, qv = {
  fontfamily: 1,
  fontsize: 1,
  fontweight: 1,
  fontstyle: 1,
  color: 1,
  background: 1,
  id: 1,
  class: 1,
  href: 1,
  style: 1
};
G1.Open = function(e, t) {
  e.Push(e.itemFactory.create("open"));
};
G1.Close = function(e, t) {
  e.Push(e.itemFactory.create("close"));
};
G1.Tilde = function(e, t) {
  e.Push(e.create("token", "mtext", {}, uT.entities.nbsp));
};
G1.Space = function(e, t) {
};
G1.Superscript = function(e, t) {
  var r;
  e.GetNext().match(/\d/) && (e.string = e.string.substr(0, e.i + 1) + " " + e.string.substr(e.i + 1));
  var n, i, o = e.stack.Top();
  o.isKind("prime") ? (r = Ls(o.Peek(2), 2), i = r[0], n = r[1], e.stack.Pop()) : (i = e.stack.Prev(), i || (i = e.create("token", "mi", {}, "")));
  var a = j1.default.getProperty(i, "movesupsub"), T = j1.default.isType(i, "msubsup") ? i.sup : i.over;
  if (j1.default.isType(i, "msubsup") && !j1.default.isType(i, "msup") && j1.default.getChildAt(i, i.sup) || j1.default.isType(i, "munderover") && !j1.default.isType(i, "mover") && j1.default.getChildAt(i, i.over) && !j1.default.getProperty(i, "subsupOK"))
    throw new w3.default("DoubleExponent", "Double exponent: use braces to clarify");
  (!j1.default.isType(i, "msubsup") || j1.default.isType(i, "msup")) && (a ? ((!j1.default.isType(i, "munderover") || j1.default.isType(i, "mover") || j1.default.getChildAt(i, i.over)) && (i = e.create("node", "munderover", [i], { movesupsub: !0 })), T = i.over) : (i = e.create("node", "msubsup", [i]), T = i.sup)), e.Push(e.itemFactory.create("subsup", i).setProperties({
    position: T,
    primes: n,
    movesupsub: a
  }));
};
G1.Subscript = function(e, t) {
  var r;
  e.GetNext().match(/\d/) && (e.string = e.string.substr(0, e.i + 1) + " " + e.string.substr(e.i + 1));
  var n, i, o = e.stack.Top();
  o.isKind("prime") ? (r = Ls(o.Peek(2), 2), i = r[0], n = r[1], e.stack.Pop()) : (i = e.stack.Prev(), i || (i = e.create("token", "mi", {}, "")));
  var a = j1.default.getProperty(i, "movesupsub"), T = j1.default.isType(i, "msubsup") ? i.sub : i.under;
  if (j1.default.isType(i, "msubsup") && !j1.default.isType(i, "msup") && j1.default.getChildAt(i, i.sub) || j1.default.isType(i, "munderover") && !j1.default.isType(i, "mover") && j1.default.getChildAt(i, i.under) && !j1.default.getProperty(i, "subsupOK"))
    throw new w3.default("DoubleSubscripts", "Double subscripts: use braces to clarify");
  (!j1.default.isType(i, "msubsup") || j1.default.isType(i, "msup")) && (a ? ((!j1.default.isType(i, "munderover") || j1.default.isType(i, "mover") || j1.default.getChildAt(i, i.under)) && (i = e.create("node", "munderover", [i], { movesupsub: !0 })), T = i.under) : (i = e.create("node", "msubsup", [i]), T = i.sub)), e.Push(e.itemFactory.create("subsup", i).setProperties({
    position: T,
    primes: n,
    movesupsub: a
  }));
};
G1.Prime = function(e, t) {
  var r = e.stack.Prev();
  if (r || (r = e.create("node", "mi")), j1.default.isType(r, "msubsup") && !j1.default.isType(r, "msup") && j1.default.getChildAt(r, r.sup))
    throw new w3.default("DoubleExponentPrime", "Prime causes double exponent: use braces to clarify");
  var n = "";
  e.i--;
  do
    n += uT.entities.prime, e.i++, t = e.GetNext();
  while (t === "'" || t === uT.entities.rsquo);
  n = ["", "′", "″", "‴", "⁗"][n.length] || n;
  var i = e.create("token", "mo", { variantForm: !0 }, n);
  e.Push(e.itemFactory.create("prime", r, i));
};
G1.Comment = function(e, t) {
  for (; e.i < e.string.length && e.string.charAt(e.i) !== `
`; )
    e.i++;
};
G1.Hash = function(e, t) {
  throw new w3.default("CantUseHash1", "You can't use 'macro parameter character #' in math mode");
};
G1.MathFont = function(e, t, r) {
  var n = e.GetArgument(t), i = new Y9.default(n, M0(M0({}, e.stack.env), { font: r, multiLetterIdentifiers: /^[a-zA-Z]+/, noAutoOP: !0 }), e.configuration).mml();
  e.Push(e.create("node", "TeXAtom", [i]));
};
G1.SetFont = function(e, t, r) {
  e.stack.env.font = r;
};
G1.SetStyle = function(e, t, r, n, i) {
  e.stack.env.style = r, e.stack.env.level = i, e.Push(e.itemFactory.create("style").setProperty("styles", { displaystyle: n, scriptlevel: i }));
};
G1.SetSize = function(e, t, r) {
  e.stack.env.size = r, e.Push(e.itemFactory.create("style").setProperty("styles", { mathsize: (0, Pd.em)(r) }));
};
G1.Spacer = function(e, t, r) {
  var n = e.create("node", "mspace", [], { width: (0, Pd.em)(r) }), i = e.create("node", "mstyle", [n], { scriptlevel: 0 });
  e.Push(i);
};
G1.LeftRight = function(e, t) {
  var r = t.substr(1);
  e.Push(e.itemFactory.create(r, e.GetDelimiter(t), e.stack.env.color));
};
G1.NamedFn = function(e, t, r) {
  r || (r = t.substr(1));
  var n = e.create("token", "mi", { texClass: R0.TEXCLASS.OP }, r);
  e.Push(e.itemFactory.create("fn", n));
};
G1.NamedOp = function(e, t, r) {
  r || (r = t.substr(1)), r = r.replace(/&thinsp;/, " ");
  var n = e.create("token", "mo", {
    movablelimits: !0,
    movesupsub: !0,
    form: gs.TexConstant.Form.PREFIX,
    texClass: R0.TEXCLASS.OP
  }, r);
  e.Push(n);
};
G1.Limits = function(e, t, r) {
  var n = e.stack.Prev(!0);
  if (!n || j1.default.getTexClass(j1.default.getCoreMO(n)) !== R0.TEXCLASS.OP && j1.default.getProperty(n, "movesupsub") == null)
    throw new w3.default("MisplacedLimits", "%1 is allowed only on operators", e.currentCS);
  var i = e.stack.Top(), o;
  j1.default.isType(n, "munderover") && !r ? (o = e.create("node", "msubsup"), j1.default.copyChildren(n, o), n = i.Last = o) : j1.default.isType(n, "msubsup") && r && (o = e.create("node", "munderover"), j1.default.copyChildren(n, o), n = i.Last = o), j1.default.setProperty(n, "movesupsub", !!r), j1.default.setProperties(j1.default.getCoreMO(n), { movablelimits: !1 }), (j1.default.getAttribute(n, "movablelimits") || j1.default.getProperty(n, "movablelimits")) && j1.default.setProperties(n, { movablelimits: !1 });
};
G1.Over = function(e, t, r, n) {
  var i = e.itemFactory.create("over").setProperty("name", e.currentCS);
  r || n ? (i.setProperty("open", r), i.setProperty("close", n)) : t.match(/withdelims$/) && (i.setProperty("open", e.GetDelimiter(t)), i.setProperty("close", e.GetDelimiter(t))), t.match(/^\\above/) ? i.setProperty("thickness", e.GetDimen(t)) : (t.match(/^\\atop/) || r || n) && i.setProperty("thickness", 0), e.Push(i);
};
G1.Frac = function(e, t) {
  var r = e.ParseArg(t), n = e.ParseArg(t), i = e.create("node", "mfrac", [r, n]);
  e.Push(i);
};
G1.Sqrt = function(e, t) {
  var r = e.GetBrackets(t), n = e.GetArgument(t);
  n === "\\frac" && (n += "{" + e.GetArgument(n) + "}{" + e.GetArgument(n) + "}");
  var i = new Y9.default(n, e.stack.env, e.configuration).mml();
  r ? i = e.create("node", "mroot", [i, Bd(e, r)]) : i = e.create("node", "msqrt", [i]), e.Push(i);
};
function Bd(e, t) {
  var r = e.stack.env, n = r.inRoot;
  r.inRoot = !0;
  var i = new Y9.default(t, r, e.configuration), o = i.mml(), a = i.stack.global;
  if (a.leftRoot || a.upRoot) {
    var T = {};
    a.leftRoot && (T.width = a.leftRoot), a.upRoot && (T.voffset = a.upRoot, T.height = a.upRoot), o = e.create("node", "mpadded", [o], T);
  }
  return r.inRoot = n, o;
}
G1.Root = function(e, t) {
  var r = e.GetUpTo(t, "\\of"), n = e.ParseArg(t), i = e.create("node", "mroot", [n, Bd(e, r)]);
  e.Push(i);
};
G1.MoveRoot = function(e, t, r) {
  if (!e.stack.env.inRoot)
    throw new w3.default("MisplacedMoveRoot", "%1 can appear only within a root", e.currentCS);
  if (e.stack.global[r])
    throw new w3.default("MultipleMoveRoot", "Multiple use of %1", e.currentCS);
  var n = e.GetArgument(t);
  if (!n.match(/-?[0-9]+/))
    throw new w3.default("IntegerArg", "The argument to %1 must be an integer", e.currentCS);
  n = parseInt(n, 10) / 15 + "em", n.substr(0, 1) !== "-" && (n = "+" + n), e.stack.global[r] = n;
};
G1.Accent = function(e, t, r, n) {
  var i = e.ParseArg(t), o = M0(M0({}, L3.default.getFontDef(e)), { accent: !0, mathaccent: !0 }), a = j1.default.createEntity(r), T = e.create("token", "mo", o, a), s = T;
  j1.default.setAttribute(s, "stretchy", !!n);
  var Q = j1.default.isEmbellished(i) ? j1.default.getCoreMO(i) : i;
  (j1.default.isType(Q, "mo") || j1.default.getProperty(Q, "movablelimits")) && j1.default.setProperties(Q, { movablelimits: !1 });
  var u = e.create("node", "munderover");
  j1.default.setChild(u, 0, i), j1.default.setChild(u, 1, null), j1.default.setChild(u, 2, s);
  var l = e.create("node", "TeXAtom", [u]);
  e.Push(l);
};
G1.UnderOver = function(e, t, r, n) {
  var i = j1.default.createEntity(r), o = e.create("token", "mo", { stretchy: !0, accent: !0 }, i), a = t.charAt(1) === "o" ? "over" : "under", T = e.ParseArg(t);
  e.Push(L3.default.underOver(e, T, o, a, n));
};
G1.Overset = function(e, t) {
  var r = e.ParseArg(t), n = e.ParseArg(t);
  L3.default.checkMovableLimits(n), r.isKind("mo") && j1.default.setAttribute(r, "accent", !1);
  var i = e.create("node", "mover", [n, r]);
  e.Push(i);
};
G1.Underset = function(e, t) {
  var r = e.ParseArg(t), n = e.ParseArg(t);
  L3.default.checkMovableLimits(n), r.isKind("mo") && j1.default.setAttribute(r, "accent", !1);
  var i = e.create("node", "munder", [n, r], { accentunder: !1 });
  e.Push(i);
};
G1.Overunderset = function(e, t) {
  var r = e.ParseArg(t), n = e.ParseArg(t), i = e.ParseArg(t);
  L3.default.checkMovableLimits(i), r.isKind("mo") && j1.default.setAttribute(r, "accent", !1), n.isKind("mo") && j1.default.setAttribute(n, "accent", !1);
  var o = e.create("node", "munderover", [i, n, r], { accent: !1, accentunder: !1 });
  e.Push(o);
};
G1.TeXAtom = function(e, t, r) {
  var n = { texClass: r }, i, o, a;
  if (r === R0.TEXCLASS.OP) {
    n.movesupsub = n.movablelimits = !0;
    var T = e.GetArgument(t), s = T.match(/^\s*\\rm\s+([a-zA-Z0-9 ]+)$/);
    s ? (n.mathvariant = gs.TexConstant.Variant.NORMAL, o = e.create("token", "mi", n, s[1])) : (a = new Y9.default(T, e.stack.env, e.configuration).mml(), o = e.create("node", "TeXAtom", [a], n)), i = e.itemFactory.create("fn", o);
  } else
    a = e.ParseArg(t), i = e.create("node", "TeXAtom", [a], n);
  e.Push(i);
};
G1.MmlToken = function(e, t) {
  var r = e.GetArgument(t), n = e.GetBrackets(t, "").replace(/^\s+/, ""), i = e.GetArgument(t), o = {}, a = [], T;
  try {
    T = e.create("node", r);
  } catch {
    T = null;
  }
  if (!T || !T.isToken)
    throw new w3.default("NotMathMLToken", "%1 is not a token element", r);
  for (; n !== ""; ) {
    var s = n.match(/^([a-z]+)\s*=\s*('[^']*'|"[^"]*"|[^ ,]*)\s*,?\s*/i);
    if (!s)
      throw new w3.default("InvalidMathMLAttr", "Invalid MathML attribute: %1", n);
    if (!T.attributes.hasDefault(s[1]) && !qv[s[1]])
      throw new w3.default("UnknownAttrForElement", "%1 is not a recognized attribute for %2", s[1], r);
    var Q = L3.default.MmlFilterAttribute(e, s[1], s[2].replace(/^(['"])(.*)\1$/, "$2"));
    Q && (Q.toLowerCase() === "true" ? Q = !0 : Q.toLowerCase() === "false" && (Q = !1), o[s[1]] = Q, a.push(s[1])), n = n.substr(s[0].length);
  }
  a.length && (o["mjx-keep-attrs"] = a.join(" "));
  var u = e.create("text", i);
  T.appendChild(u), j1.default.setProperties(T, o), e.Push(T);
};
G1.Strut = function(e, t) {
  var r = e.create("node", "mrow"), n = e.create("node", "mpadded", [r], { height: "8.6pt", depth: "3pt", width: 0 });
  e.Push(n);
};
G1.Phantom = function(e, t, r, n) {
  var i = e.create("node", "mphantom", [e.ParseArg(t)]);
  (r || n) && (i = e.create("node", "mpadded", [i]), n && (j1.default.setAttribute(i, "height", 0), j1.default.setAttribute(i, "depth", 0)), r && j1.default.setAttribute(i, "width", 0));
  var o = e.create("node", "TeXAtom", [i]);
  e.Push(o);
};
G1.Smash = function(e, t) {
  var r = L3.default.trimSpaces(e.GetBrackets(t, "")), n = e.create("node", "mpadded", [e.ParseArg(t)]);
  switch (r) {
    case "b":
      j1.default.setAttribute(n, "depth", 0);
      break;
    case "t":
      j1.default.setAttribute(n, "height", 0);
      break;
    default:
      j1.default.setAttribute(n, "height", 0), j1.default.setAttribute(n, "depth", 0);
  }
  var i = e.create("node", "TeXAtom", [n]);
  e.Push(i);
};
G1.Lap = function(e, t) {
  var r = e.create("node", "mpadded", [e.ParseArg(t)], { width: 0 });
  t === "\\llap" && j1.default.setAttribute(r, "lspace", "-1width");
  var n = e.create("node", "TeXAtom", [r]);
  e.Push(n);
};
G1.RaiseLower = function(e, t) {
  var r = e.GetDimen(t), n = e.itemFactory.create("position").setProperties({ name: e.currentCS, move: "vertical" });
  r.charAt(0) === "-" && (r = r.slice(1), t = t.substr(1) === "raise" ? "\\lower" : "\\raise"), t === "\\lower" ? (n.setProperty("dh", "-" + r), n.setProperty("dd", "+" + r)) : (n.setProperty("dh", "+" + r), n.setProperty("dd", "-" + r)), e.Push(n);
};
G1.MoveLeftRight = function(e, t) {
  var r = e.GetDimen(t), n = r.charAt(0) === "-" ? r.slice(1) : "-" + r;
  if (t === "\\moveleft") {
    var i = r;
    r = n, n = i;
  }
  e.Push(e.itemFactory.create("position").setProperties({
    name: e.currentCS,
    move: "horizontal",
    left: e.create("node", "mspace", [], { width: r }),
    right: e.create("node", "mspace", [], { width: n })
  }));
};
G1.Hskip = function(e, t) {
  var r = e.create("node", "mspace", [], { width: e.GetDimen(t) });
  e.Push(r);
};
G1.Nonscript = function(e, t) {
  e.Push(e.itemFactory.create("nonscript"));
};
G1.Rule = function(e, t, r) {
  var n = e.GetDimen(t), i = e.GetDimen(t), o = e.GetDimen(t), a = { width: n, height: i, depth: o };
  r !== "blank" && (a.mathbackground = e.stack.env.color || "black");
  var T = e.create("node", "mspace", [], a);
  e.Push(T);
};
G1.rule = function(e, t) {
  var r = e.GetBrackets(t), n = e.GetDimen(t), i = e.GetDimen(t), o = e.create("node", "mspace", [], {
    width: n,
    height: i,
    mathbackground: e.stack.env.color || "black"
  });
  r && (o = e.create("node", "mpadded", [o], { voffset: r }), r.match(/^\-/) ? (j1.default.setAttribute(o, "height", r), j1.default.setAttribute(o, "depth", "+" + r.substr(1))) : j1.default.setAttribute(o, "height", "+" + r)), e.Push(o);
};
G1.MakeBig = function(e, t, r, n) {
  n *= Xv;
  var i = String(n).replace(/(\.\d\d\d).+/, "$1") + "em", o = e.GetDelimiter(t, !0), a = e.create("token", "mo", {
    minsize: i,
    maxsize: i,
    fence: !0,
    stretchy: !0,
    symmetric: !0
  }, o), T = e.create("node", "TeXAtom", [a], { texClass: r });
  e.Push(T);
};
G1.BuildRel = function(e, t) {
  var r = e.ParseUpTo(t, "\\over"), n = e.ParseArg(t), i = e.create("node", "munderover");
  j1.default.setChild(i, 0, n), j1.default.setChild(i, 1, null), j1.default.setChild(i, 2, r);
  var o = e.create("node", "TeXAtom", [i], { texClass: R0.TEXCLASS.REL });
  e.Push(o);
};
G1.HBox = function(e, t, r, n) {
  e.PushAll(L3.default.internalMath(e, e.GetArgument(t), r, n));
};
G1.FBox = function(e, t) {
  var r = L3.default.internalMath(e, e.GetArgument(t)), n = e.create("node", "menclose", r, { notation: "box" });
  e.Push(n);
};
G1.FrameBox = function(e, t) {
  var r = e.GetBrackets(t), n = e.GetBrackets(t) || "c", i = L3.default.internalMath(e, e.GetArgument(t));
  r && (i = [e.create("node", "mpadded", i, {
    width: r,
    "data-align": (0, Uv.lookup)(n, { l: "left", r: "right" }, "center")
  })]);
  var o = e.create("node", "TeXAtom", [e.create("node", "menclose", i, { notation: "box" })], { texClass: R0.TEXCLASS.ORD });
  e.Push(o);
};
G1.Not = function(e, t) {
  e.Push(e.itemFactory.create("not"));
};
G1.Dots = function(e, t) {
  var r = j1.default.createEntity("2026"), n = j1.default.createEntity("22EF"), i = e.create("token", "mo", { stretchy: !1 }, r), o = e.create("token", "mo", { stretchy: !1 }, n);
  e.Push(e.itemFactory.create("dots").setProperties({
    ldots: i,
    cdots: o
  }));
};
G1.Matrix = function(e, t, r, n, i, o, a, T, s, Q) {
  var u = e.GetNext();
  if (u === "")
    throw new w3.default("MissingArgFor", "Missing argument for %1", e.currentCS);
  u === "{" ? e.i++ : (e.string = u + "}" + e.string.slice(e.i + 1), e.i = 0);
  var l = e.itemFactory.create("array").setProperty("requireClose", !0);
  l.arraydef = {
    rowspacing: a || "4pt",
    columnspacing: o || "1em"
  }, s && l.setProperty("isCases", !0), Q && (l.setProperty("isNumbered", !0), l.arraydef.side = Q), (r || n) && (l.setProperty("open", r), l.setProperty("close", n)), T === "D" && (l.arraydef.displaystyle = !0), i != null && (l.arraydef.columnalign = i), e.Push(l);
};
G1.Entry = function(e, t) {
  e.Push(e.itemFactory.create("cell").setProperties({ isEntry: !0, name: t }));
  var r = e.stack.Top(), n = r.getProperty("casesEnv"), i = r.getProperty("isCases");
  if (!(!i && !n)) {
    for (var o = e.string, a = 0, T = -1, s = e.i, Q = o.length, u = n ? new RegExp("^\\\\end\\s*\\{".concat(n.replace(/\*/, "\\*"), "\\}")) : null; s < Q; ) {
      var l = o.charAt(s);
      if (l === "{")
        a++, s++;
      else if (l === "}")
        a === 0 ? Q = 0 : (a--, a === 0 && T < 0 && (T = s - e.i), s++);
      else {
        if (l === "&" && a === 0)
          throw new w3.default("ExtraAlignTab", "Extra alignment tab in \\cases text");
        if (l === "\\") {
          var c = o.substr(s);
          c.match(/^((\\cr)[^a-zA-Z]|\\\\)/) || u && c.match(u) ? Q = 0 : s += 2;
        } else
          s++;
      }
    }
    var f = o.substr(e.i, s - e.i);
    if (!f.match(/^\s*\\text[^a-zA-Z]/) || T !== f.replace(/\s+$/, "").length - 1) {
      var d = L3.default.internalMath(e, L3.default.trimSpaces(f), 0);
      e.PushAll(d), e.i = s;
    }
  }
};
G1.Cr = function(e, t) {
  e.Push(e.itemFactory.create("cell").setProperties({ isCR: !0, name: t }));
};
G1.CrLaTeX = function(e, t, r) {
  r === void 0 && (r = !1);
  var n;
  if (!r && (e.string.charAt(e.i) === "*" && e.i++, e.string.charAt(e.i) === "[")) {
    var i = e.GetBrackets(t, ""), o = Ls(L3.default.matchDimen(i), 2), a = o[0], T = o[1];
    if (i && !a)
      throw new w3.default("BracketMustBeDimension", "Bracket argument to %1 must be a dimension", e.currentCS);
    n = a + T;
  }
  e.Push(e.itemFactory.create("cell").setProperties({ isCR: !0, name: t, linebreak: !0 }));
  var s = e.stack.Top(), Q;
  s instanceof ys.ArrayItem ? n && s.addRowSpacing(n) : (n && (Q = e.create("node", "mspace", [], { depth: n }), e.Push(Q)), Q = e.create("node", "mspace", [], { linebreak: gs.TexConstant.LineBreak.NEWLINE }), e.Push(Q));
};
G1.HLine = function(e, t, r) {
  r == null && (r = "solid");
  var n = e.stack.Top();
  if (!(n instanceof ys.ArrayItem) || n.Size())
    throw new w3.default("Misplaced", "Misplaced %1", e.currentCS);
  if (!n.table.length)
    n.frame.push("top");
  else {
    for (var i = n.arraydef.rowlines ? n.arraydef.rowlines.split(/ /) : []; i.length < n.table.length; )
      i.push("none");
    i[n.table.length - 1] = r, n.arraydef.rowlines = i.join(" ");
  }
};
G1.HFill = function(e, t) {
  var r = e.stack.Top();
  if (r instanceof ys.ArrayItem)
    r.hfill.push(r.Size());
  else
    throw new w3.default("UnsupportedHFill", "Unsupported use of %1", e.currentCS);
};
G1.BeginEnd = function(e, t) {
  var r = e.GetArgument(t);
  if (r.match(/\\/i))
    throw new w3.default("InvalidEnv", "Invalid environment name '%1'", r);
  var n = e.configuration.handlers.get("environment").lookup(r);
  if (n && t === "\\end") {
    if (!n.args[0]) {
      var i = e.itemFactory.create("end").setProperty("name", r);
      e.Push(i);
      return;
    }
    e.stack.env.closing = r;
  }
  L3.default.checkMaxMacros(e, !1), e.parse("environment", [e, r]);
};
G1.Array = function(e, t, r, n, i, o, a, T, s) {
  i || (i = e.GetArgument("\\begin{" + t.getName() + "}"));
  var Q = ("c" + i).replace(/[^clr|:]/g, "").replace(/[^|:]([|:])+/g, "$1");
  i = i.replace(/[^clr]/g, "").split("").join(" "), i = i.replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
  var u = e.itemFactory.create("array");
  return u.arraydef = {
    columnalign: i,
    columnspacing: o || "1em",
    rowspacing: a || "4pt"
  }, Q.match(/[|:]/) && (Q.charAt(0).match(/[|:]/) && (u.frame.push("left"), u.dashed = Q.charAt(0) === ":"), Q.charAt(Q.length - 1).match(/[|:]/) && u.frame.push("right"), Q = Q.substr(1, Q.length - 2), u.arraydef.columnlines = Q.split("").join(" ").replace(/[^|: ]/g, "none").replace(/\|/g, "solid").replace(/:/g, "dashed")), r && u.setProperty("open", e.convertDelimiter(r)), n && u.setProperty("close", e.convertDelimiter(n)), (T || "").charAt(1) === "'" && (u.arraydef["data-cramped"] = !0, T = T.charAt(0)), T === "D" ? u.arraydef.displaystyle = !0 : T && (u.arraydef.displaystyle = !1), T === "S" && (u.arraydef.scriptlevel = 1), s && (u.arraydef.useHeight = !1), e.Push(t), u;
};
G1.AlignedArray = function(e, t) {
  var r = e.GetBrackets("\\begin{" + t.getName() + "}"), n = G1.Array(e, t);
  return L3.default.setArrayAlign(n, r);
};
G1.Equation = function(e, t, r) {
  return e.Push(t), L3.default.checkEqnEnv(e), e.itemFactory.create("equation", r).setProperty("name", t.getName());
};
G1.EqnArray = function(e, t, r, n, i, o) {
  e.Push(t), n && L3.default.checkEqnEnv(e), i = i.replace(/[^clr]/g, "").split("").join(" "), i = i.replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
  var a = e.itemFactory.create("eqnarray", t.getName(), r, n, e.stack.global);
  return a.arraydef = {
    displaystyle: !0,
    columnalign: i,
    columnspacing: o || "1em",
    rowspacing: "3pt",
    side: e.options.tagSide,
    minlabelspacing: e.options.tagIndent
  }, a;
};
G1.HandleNoTag = function(e, t) {
  e.tags.notag();
};
G1.HandleLabel = function(e, t) {
  var r = e.GetArgument(t);
  if (r !== "" && !e.tags.refUpdate) {
    if (e.tags.label)
      throw new w3.default("MultipleCommand", "Multiple %1", e.currentCS);
    if (e.tags.label = r, (e.tags.allLabels[r] || e.tags.labels[r]) && !e.options.ignoreDuplicateLabels)
      throw new w3.default("MultipleLabel", "Label '%1' multiply defined", r);
    e.tags.labels[r] = new Nd.Label();
  }
};
G1.HandleRef = function(e, t, r) {
  var n = e.GetArgument(t), i = e.tags.allLabels[n] || e.tags.labels[n];
  i || (e.tags.refUpdate || (e.tags.redo = !0), i = new Nd.Label());
  var o = i.tag;
  r && (o = e.tags.formatTag(o));
  var a = e.create("node", "mrow", L3.default.internalMath(e, o), {
    href: e.tags.formatUrl(i.id, e.options.baseURL),
    class: "MathJax_ref"
  });
  e.Push(a);
};
G1.Macro = function(e, t, r, n, i) {
  if (n) {
    var o = [];
    if (i != null) {
      var a = e.GetBrackets(t);
      o.push(a ?? i);
    }
    for (var T = o.length; T < n; T++)
      o.push(e.GetArgument(t));
    r = L3.default.substituteArgs(e, o, r);
  }
  e.string = L3.default.addArgs(e, r, e.string.slice(e.i)), e.i = 0, L3.default.checkMaxMacros(e);
};
G1.MathChoice = function(e, t) {
  var r = e.ParseArg(t), n = e.ParseArg(t), i = e.ParseArg(t), o = e.ParseArg(t);
  e.Push(e.create("node", "MathChoice", [r, n, i, o]));
};
vs.default = G1;
var xs = {}, Jv = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Yv = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Fd = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xs, "__esModule", { value: !0 });
var Kv = Fd(F4), sQ = q9, Bl = Fd(Pr()), cT;
(function(e) {
  function t(Q, u) {
    var l = Bl.default.getFontDef(Q), c = Q.stack.env;
    c.multiLetterIdentifiers && c.font !== "" && (u = Q.string.substr(Q.i - 1).match(c.multiLetterIdentifiers)[0], Q.i += u.length - 1, l.mathvariant === sQ.TexConstant.Variant.NORMAL && c.noAutoOP && u.length > 1 && (l.autoOP = !1));
    var f = Q.create("token", "mi", l, u);
    Q.Push(f);
  }
  e.variable = t;
  function r(Q, u) {
    var l, c = Q.configuration.options.digits, f = Q.string.slice(Q.i - 1).match(c), d = Bl.default.getFontDef(Q);
    f ? (l = Q.create("token", "mn", d, f[0].replace(/[{}]/g, "")), Q.i += f[0].length - 1) : l = Q.create("token", "mo", d, u), Q.Push(l);
  }
  e.digit = r;
  function n(Q, u) {
    var l = Q.GetCS();
    Q.parse("macro", [Q, l]);
  }
  e.controlSequence = n;
  function i(Q, u) {
    var l = u.attributes || { mathvariant: sQ.TexConstant.Variant.ITALIC }, c = Q.create("token", "mi", l, u.char);
    Q.Push(c);
  }
  e.mathchar0mi = i;
  function o(Q, u) {
    var l = u.attributes || {};
    l.stretchy = !1;
    var c = Q.create("token", "mo", l, u.char);
    Kv.default.setProperty(c, "fixStretchy", !0), Q.configuration.addNode("fixStretchy", c), Q.Push(c);
  }
  e.mathchar0mo = o;
  function a(Q, u) {
    var l = u.attributes || { mathvariant: sQ.TexConstant.Variant.NORMAL };
    Q.stack.env.font && (l.mathvariant = Q.stack.env.font);
    var c = Q.create("token", "mi", l, u.char);
    Q.Push(c);
  }
  e.mathchar7 = a;
  function T(Q, u) {
    var l = u.attributes || {};
    l = Object.assign({ fence: !1, stretchy: !1 }, l);
    var c = Q.create("token", "mo", l, u.char);
    Q.Push(c);
  }
  e.delimiter = T;
  function s(Q, u, l, c) {
    var f = c[0], d = Q.itemFactory.create("begin").setProperties({ name: u, end: f });
    d = l.apply(void 0, Yv([Q, d], Jv(c.slice(1)), !1)), Q.Push(d);
  }
  e.environment = s;
})(cT || (cT = {}));
xs.default = cT;
var eL = b && b.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), tL = b && b.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), rL = b && b.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && eL(t, e, r);
  return tL(t, e), t;
}, Hs = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, o6 = rL(h3), B1 = q9, Es = Hs(vs), $5 = Hs(xs), nL = Hs(Pr()), i2 = T2, c4 = it;
new o6.RegExpMap("letter", $5.default.variable, /[a-z]/i);
new o6.RegExpMap("digit", $5.default.digit, /[0-9.,]/);
new o6.RegExpMap("command", $5.default.controlSequence, /^\\/);
new o6.MacroMap("special", {
  "{": "Open",
  "}": "Close",
  "~": "Tilde",
  "^": "Superscript",
  _: "Subscript",
  " ": "Space",
  "	": "Space",
  "\r": "Space",
  "\n": "Space",
  "'": "Prime",
  "%": "Comment",
  "&": "Entry",
  "#": "Hash",
  " ": "Space",
  "’": "Prime"
}, Es.default);
new o6.CharacterMap("mathchar0mi", $5.default.mathchar0mi, {
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ϵ",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "ϕ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  varepsilon: "ε",
  vartheta: "ϑ",
  varpi: "ϖ",
  varrho: "ϱ",
  varsigma: "ς",
  varphi: "φ",
  S: ["§", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  aleph: ["ℵ", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  hbar: ["ℏ", { variantForm: !0 }],
  imath: "ı",
  jmath: "ȷ",
  ell: "ℓ",
  wp: ["℘", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  Re: ["ℜ", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  Im: ["ℑ", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  partial: ["∂", { mathvariant: B1.TexConstant.Variant.ITALIC }],
  infty: ["∞", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  prime: ["′", { variantForm: !0 }],
  emptyset: ["∅", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  nabla: ["∇", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  top: ["⊤", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  bot: ["⊥", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  angle: ["∠", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  triangle: ["△", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  backslash: ["∖", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  forall: ["∀", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  exists: ["∃", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  neg: ["¬", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  lnot: ["¬", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  flat: ["♭", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  natural: ["♮", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  sharp: ["♯", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  clubsuit: ["♣", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  diamondsuit: ["♢", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  heartsuit: ["♡", { mathvariant: B1.TexConstant.Variant.NORMAL }],
  spadesuit: ["♠", { mathvariant: B1.TexConstant.Variant.NORMAL }]
});
new o6.CharacterMap("mathchar0mo", $5.default.mathchar0mo, {
  surd: "√",
  coprod: ["∐", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigvee: ["⋁", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigwedge: ["⋀", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  biguplus: ["⨄", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigcap: ["⋂", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigcup: ["⋃", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  int: ["∫", { texClass: i2.TEXCLASS.OP }],
  intop: ["∫", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0,
    movablelimits: !0
  }],
  iint: ["∬", { texClass: i2.TEXCLASS.OP }],
  iiint: ["∭", { texClass: i2.TEXCLASS.OP }],
  prod: ["∏", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  sum: ["∑", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigotimes: ["⨂", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigoplus: ["⨁", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  bigodot: ["⨀", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  oint: ["∮", { texClass: i2.TEXCLASS.OP }],
  bigsqcup: ["⨆", {
    texClass: i2.TEXCLASS.OP,
    movesupsub: !0
  }],
  smallint: ["∫", { largeop: !1 }],
  triangleleft: "◃",
  triangleright: "▹",
  bigtriangleup: "△",
  bigtriangledown: "▽",
  wedge: "∧",
  land: "∧",
  vee: "∨",
  lor: "∨",
  cap: "∩",
  cup: "∪",
  ddagger: "‡",
  dagger: "†",
  sqcap: "⊓",
  sqcup: "⊔",
  uplus: "⊎",
  amalg: "⨿",
  diamond: "⋄",
  bullet: "∙",
  wr: "≀",
  div: "÷",
  divsymbol: "÷",
  odot: ["⊙", { largeop: !1 }],
  oslash: ["⊘", { largeop: !1 }],
  otimes: ["⊗", { largeop: !1 }],
  ominus: ["⊖", { largeop: !1 }],
  oplus: ["⊕", { largeop: !1 }],
  mp: "∓",
  pm: "±",
  circ: "∘",
  bigcirc: "◯",
  setminus: "∖",
  cdot: "⋅",
  ast: "∗",
  times: "×",
  star: "⋆",
  propto: "∝",
  sqsubseteq: "⊑",
  sqsupseteq: "⊒",
  parallel: "∥",
  mid: "∣",
  dashv: "⊣",
  vdash: "⊢",
  leq: "≤",
  le: "≤",
  geq: "≥",
  ge: "≥",
  lt: "<",
  gt: ">",
  succ: "≻",
  prec: "≺",
  approx: "≈",
  succeq: "⪰",
  preceq: "⪯",
  supset: "⊃",
  subset: "⊂",
  supseteq: "⊇",
  subseteq: "⊆",
  in: "∈",
  ni: "∋",
  notin: "∉",
  owns: "∋",
  gg: "≫",
  ll: "≪",
  sim: "∼",
  simeq: "≃",
  perp: "⊥",
  equiv: "≡",
  asymp: "≍",
  smile: "⌣",
  frown: "⌢",
  ne: "≠",
  neq: "≠",
  cong: "≅",
  doteq: "≐",
  bowtie: "⋈",
  models: "⊨",
  notChar: "⧸",
  Leftrightarrow: "⇔",
  Leftarrow: "⇐",
  Rightarrow: "⇒",
  leftrightarrow: "↔",
  leftarrow: "←",
  gets: "←",
  rightarrow: "→",
  to: ["→", { accent: !1 }],
  mapsto: "↦",
  leftharpoonup: "↼",
  leftharpoondown: "↽",
  rightharpoonup: "⇀",
  rightharpoondown: "⇁",
  nearrow: "↗",
  searrow: "↘",
  nwarrow: "↖",
  swarrow: "↙",
  rightleftharpoons: "⇌",
  hookrightarrow: "↪",
  hookleftarrow: "↩",
  longleftarrow: "⟵",
  Longleftarrow: "⟸",
  longrightarrow: "⟶",
  Longrightarrow: "⟹",
  Longleftrightarrow: "⟺",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  ldots: "…",
  cdots: "⋯",
  vdots: "⋮",
  ddots: "⋱",
  dotsc: "…",
  dotsb: "⋯",
  dotsm: "⋯",
  dotsi: "⋯",
  dotso: "…",
  ldotp: [".", { texClass: i2.TEXCLASS.PUNCT }],
  cdotp: ["⋅", { texClass: i2.TEXCLASS.PUNCT }],
  colon: [":", { texClass: i2.TEXCLASS.PUNCT }]
});
new o6.CharacterMap("mathchar7", $5.default.mathchar7, {
  Gamma: "Γ",
  Delta: "Δ",
  Theta: "Θ",
  Lambda: "Λ",
  Xi: "Ξ",
  Pi: "Π",
  Sigma: "Σ",
  Upsilon: "Υ",
  Phi: "Φ",
  Psi: "Ψ",
  Omega: "Ω",
  _: "_",
  "#": "#",
  $: "$",
  "%": "%",
  "&": "&",
  And: "&"
});
new o6.DelimiterMap("delimiter", $5.default.delimiter, {
  "(": "(",
  ")": ")",
  "[": "[",
  "]": "]",
  "<": "⟨",
  ">": "⟩",
  "\\lt": "⟨",
  "\\gt": "⟩",
  "/": "/",
  "|": ["|", { texClass: i2.TEXCLASS.ORD }],
  ".": "",
  "\\\\": "\\",
  "\\lmoustache": "⎰",
  "\\rmoustache": "⎱",
  "\\lgroup": "⟮",
  "\\rgroup": "⟯",
  "\\arrowvert": "⏐",
  "\\Arrowvert": "‖",
  "\\bracevert": "⎪",
  "\\Vert": ["‖", { texClass: i2.TEXCLASS.ORD }],
  "\\|": ["‖", { texClass: i2.TEXCLASS.ORD }],
  "\\vert": ["|", { texClass: i2.TEXCLASS.ORD }],
  "\\uparrow": "↑",
  "\\downarrow": "↓",
  "\\updownarrow": "↕",
  "\\Uparrow": "⇑",
  "\\Downarrow": "⇓",
  "\\Updownarrow": "⇕",
  "\\backslash": "\\",
  "\\rangle": "⟩",
  "\\langle": "⟨",
  "\\rbrace": "}",
  "\\lbrace": "{",
  "\\}": "}",
  "\\{": "{",
  "\\rceil": "⌉",
  "\\lceil": "⌈",
  "\\rfloor": "⌋",
  "\\lfloor": "⌊",
  "\\lbrack": "[",
  "\\rbrack": "]"
});
new o6.CommandMap("macros", {
  displaystyle: ["SetStyle", "D", !0, 0],
  textstyle: ["SetStyle", "T", !1, 0],
  scriptstyle: ["SetStyle", "S", !1, 1],
  scriptscriptstyle: ["SetStyle", "SS", !1, 2],
  rm: ["SetFont", B1.TexConstant.Variant.NORMAL],
  mit: ["SetFont", B1.TexConstant.Variant.ITALIC],
  oldstyle: ["SetFont", B1.TexConstant.Variant.OLDSTYLE],
  cal: ["SetFont", B1.TexConstant.Variant.CALLIGRAPHIC],
  it: ["SetFont", B1.TexConstant.Variant.MATHITALIC],
  bf: ["SetFont", B1.TexConstant.Variant.BOLD],
  bbFont: ["SetFont", B1.TexConstant.Variant.DOUBLESTRUCK],
  scr: ["SetFont", B1.TexConstant.Variant.SCRIPT],
  frak: ["SetFont", B1.TexConstant.Variant.FRAKTUR],
  sf: ["SetFont", B1.TexConstant.Variant.SANSSERIF],
  tt: ["SetFont", B1.TexConstant.Variant.MONOSPACE],
  mathrm: ["MathFont", B1.TexConstant.Variant.NORMAL],
  mathup: ["MathFont", B1.TexConstant.Variant.NORMAL],
  mathnormal: ["MathFont", ""],
  mathbf: ["MathFont", B1.TexConstant.Variant.BOLD],
  mathbfup: ["MathFont", B1.TexConstant.Variant.BOLD],
  mathit: ["MathFont", B1.TexConstant.Variant.MATHITALIC],
  mathbfit: ["MathFont", B1.TexConstant.Variant.BOLDITALIC],
  mathbb: ["MathFont", B1.TexConstant.Variant.DOUBLESTRUCK],
  Bbb: ["MathFont", B1.TexConstant.Variant.DOUBLESTRUCK],
  mathfrak: ["MathFont", B1.TexConstant.Variant.FRAKTUR],
  mathbffrak: ["MathFont", B1.TexConstant.Variant.BOLDFRAKTUR],
  mathscr: ["MathFont", B1.TexConstant.Variant.SCRIPT],
  mathbfscr: ["MathFont", B1.TexConstant.Variant.BOLDSCRIPT],
  mathsf: ["MathFont", B1.TexConstant.Variant.SANSSERIF],
  mathsfup: ["MathFont", B1.TexConstant.Variant.SANSSERIF],
  mathbfsf: ["MathFont", B1.TexConstant.Variant.BOLDSANSSERIF],
  mathbfsfup: ["MathFont", B1.TexConstant.Variant.BOLDSANSSERIF],
  mathsfit: ["MathFont", B1.TexConstant.Variant.SANSSERIFITALIC],
  mathbfsfit: ["MathFont", B1.TexConstant.Variant.SANSSERIFBOLDITALIC],
  mathtt: ["MathFont", B1.TexConstant.Variant.MONOSPACE],
  mathcal: ["MathFont", B1.TexConstant.Variant.CALLIGRAPHIC],
  mathbfcal: ["MathFont", B1.TexConstant.Variant.BOLDCALLIGRAPHIC],
  symrm: ["MathFont", B1.TexConstant.Variant.NORMAL],
  symup: ["MathFont", B1.TexConstant.Variant.NORMAL],
  symnormal: ["MathFont", ""],
  symbf: ["MathFont", B1.TexConstant.Variant.BOLD],
  symbfup: ["MathFont", B1.TexConstant.Variant.BOLD],
  symit: ["MathFont", B1.TexConstant.Variant.ITALIC],
  symbfit: ["MathFont", B1.TexConstant.Variant.BOLDITALIC],
  symbb: ["MathFont", B1.TexConstant.Variant.DOUBLESTRUCK],
  symfrak: ["MathFont", B1.TexConstant.Variant.FRAKTUR],
  symbffrak: ["MathFont", B1.TexConstant.Variant.BOLDFRAKTUR],
  symscr: ["MathFont", B1.TexConstant.Variant.SCRIPT],
  symbfscr: ["MathFont", B1.TexConstant.Variant.BOLDSCRIPT],
  symsf: ["MathFont", B1.TexConstant.Variant.SANSSERIF],
  symsfup: ["MathFont", B1.TexConstant.Variant.SANSSERIF],
  symbfsf: ["MathFont", B1.TexConstant.Variant.BOLDSANSSERIF],
  symbfsfup: ["MathFont", B1.TexConstant.Variant.BOLDSANSSERIF],
  symsfit: ["MathFont", B1.TexConstant.Variant.SANSSERIFITALIC],
  symbfsfit: ["MathFont", B1.TexConstant.Variant.SANSSERIFBOLDITALIC],
  symtt: ["MathFont", B1.TexConstant.Variant.MONOSPACE],
  symcal: ["MathFont", B1.TexConstant.Variant.CALLIGRAPHIC],
  symbfcal: ["MathFont", B1.TexConstant.Variant.BOLDCALLIGRAPHIC],
  textrm: ["HBox", null, B1.TexConstant.Variant.NORMAL],
  textup: ["HBox", null, B1.TexConstant.Variant.NORMAL],
  textnormal: ["HBox"],
  textit: ["HBox", null, B1.TexConstant.Variant.ITALIC],
  textbf: ["HBox", null, B1.TexConstant.Variant.BOLD],
  textsf: ["HBox", null, B1.TexConstant.Variant.SANSSERIF],
  texttt: ["HBox", null, B1.TexConstant.Variant.MONOSPACE],
  tiny: ["SetSize", 0.5],
  Tiny: ["SetSize", 0.6],
  scriptsize: ["SetSize", 0.7],
  small: ["SetSize", 0.85],
  normalsize: ["SetSize", 1],
  large: ["SetSize", 1.2],
  Large: ["SetSize", 1.44],
  LARGE: ["SetSize", 1.73],
  huge: ["SetSize", 2.07],
  Huge: ["SetSize", 2.49],
  arcsin: "NamedFn",
  arccos: "NamedFn",
  arctan: "NamedFn",
  arg: "NamedFn",
  cos: "NamedFn",
  cosh: "NamedFn",
  cot: "NamedFn",
  coth: "NamedFn",
  csc: "NamedFn",
  deg: "NamedFn",
  det: "NamedOp",
  dim: "NamedFn",
  exp: "NamedFn",
  gcd: "NamedOp",
  hom: "NamedFn",
  inf: "NamedOp",
  ker: "NamedFn",
  lg: "NamedFn",
  lim: "NamedOp",
  liminf: ["NamedOp", "lim&thinsp;inf"],
  limsup: ["NamedOp", "lim&thinsp;sup"],
  ln: "NamedFn",
  log: "NamedFn",
  max: "NamedOp",
  min: "NamedOp",
  Pr: "NamedOp",
  sec: "NamedFn",
  sin: "NamedFn",
  sinh: "NamedFn",
  sup: "NamedOp",
  tan: "NamedFn",
  tanh: "NamedFn",
  limits: ["Limits", 1],
  nolimits: ["Limits", 0],
  overline: ["UnderOver", "2015"],
  underline: ["UnderOver", "2015"],
  overbrace: ["UnderOver", "23DE", 1],
  underbrace: ["UnderOver", "23DF", 1],
  overparen: ["UnderOver", "23DC"],
  underparen: ["UnderOver", "23DD"],
  overrightarrow: ["UnderOver", "2192"],
  underrightarrow: ["UnderOver", "2192"],
  overleftarrow: ["UnderOver", "2190"],
  underleftarrow: ["UnderOver", "2190"],
  overleftrightarrow: ["UnderOver", "2194"],
  underleftrightarrow: ["UnderOver", "2194"],
  overset: "Overset",
  underset: "Underset",
  overunderset: "Overunderset",
  stackrel: ["Macro", "\\mathrel{\\mathop{#2}\\limits^{#1}}", 2],
  stackbin: ["Macro", "\\mathbin{\\mathop{#2}\\limits^{#1}}", 2],
  over: "Over",
  overwithdelims: "Over",
  atop: "Over",
  atopwithdelims: "Over",
  above: "Over",
  abovewithdelims: "Over",
  brace: ["Over", "{", "}"],
  brack: ["Over", "[", "]"],
  choose: ["Over", "(", ")"],
  frac: "Frac",
  sqrt: "Sqrt",
  root: "Root",
  uproot: ["MoveRoot", "upRoot"],
  leftroot: ["MoveRoot", "leftRoot"],
  left: "LeftRight",
  right: "LeftRight",
  middle: "LeftRight",
  llap: "Lap",
  rlap: "Lap",
  raise: "RaiseLower",
  lower: "RaiseLower",
  moveleft: "MoveLeftRight",
  moveright: "MoveLeftRight",
  ",": ["Spacer", c4.MATHSPACE.thinmathspace],
  ":": ["Spacer", c4.MATHSPACE.mediummathspace],
  ">": ["Spacer", c4.MATHSPACE.mediummathspace],
  ";": ["Spacer", c4.MATHSPACE.thickmathspace],
  "!": ["Spacer", c4.MATHSPACE.negativethinmathspace],
  enspace: ["Spacer", 0.5],
  quad: ["Spacer", 1],
  qquad: ["Spacer", 2],
  thinspace: ["Spacer", c4.MATHSPACE.thinmathspace],
  negthinspace: ["Spacer", c4.MATHSPACE.negativethinmathspace],
  hskip: "Hskip",
  hspace: "Hskip",
  kern: "Hskip",
  mskip: "Hskip",
  mspace: "Hskip",
  mkern: "Hskip",
  rule: "rule",
  Rule: ["Rule"],
  Space: ["Rule", "blank"],
  nonscript: "Nonscript",
  big: ["MakeBig", i2.TEXCLASS.ORD, 0.85],
  Big: ["MakeBig", i2.TEXCLASS.ORD, 1.15],
  bigg: ["MakeBig", i2.TEXCLASS.ORD, 1.45],
  Bigg: ["MakeBig", i2.TEXCLASS.ORD, 1.75],
  bigl: ["MakeBig", i2.TEXCLASS.OPEN, 0.85],
  Bigl: ["MakeBig", i2.TEXCLASS.OPEN, 1.15],
  biggl: ["MakeBig", i2.TEXCLASS.OPEN, 1.45],
  Biggl: ["MakeBig", i2.TEXCLASS.OPEN, 1.75],
  bigr: ["MakeBig", i2.TEXCLASS.CLOSE, 0.85],
  Bigr: ["MakeBig", i2.TEXCLASS.CLOSE, 1.15],
  biggr: ["MakeBig", i2.TEXCLASS.CLOSE, 1.45],
  Biggr: ["MakeBig", i2.TEXCLASS.CLOSE, 1.75],
  bigm: ["MakeBig", i2.TEXCLASS.REL, 0.85],
  Bigm: ["MakeBig", i2.TEXCLASS.REL, 1.15],
  biggm: ["MakeBig", i2.TEXCLASS.REL, 1.45],
  Biggm: ["MakeBig", i2.TEXCLASS.REL, 1.75],
  mathord: ["TeXAtom", i2.TEXCLASS.ORD],
  mathop: ["TeXAtom", i2.TEXCLASS.OP],
  mathopen: ["TeXAtom", i2.TEXCLASS.OPEN],
  mathclose: ["TeXAtom", i2.TEXCLASS.CLOSE],
  mathbin: ["TeXAtom", i2.TEXCLASS.BIN],
  mathrel: ["TeXAtom", i2.TEXCLASS.REL],
  mathpunct: ["TeXAtom", i2.TEXCLASS.PUNCT],
  mathinner: ["TeXAtom", i2.TEXCLASS.INNER],
  vcenter: ["TeXAtom", i2.TEXCLASS.VCENTER],
  buildrel: "BuildRel",
  hbox: ["HBox", 0],
  text: "HBox",
  mbox: ["HBox", 0],
  fbox: "FBox",
  boxed: ["Macro", "\\fbox{$\\displaystyle{#1}$}", 1],
  framebox: "FrameBox",
  strut: "Strut",
  mathstrut: ["Macro", "\\vphantom{(}"],
  phantom: "Phantom",
  vphantom: ["Phantom", 1, 0],
  hphantom: ["Phantom", 0, 1],
  smash: "Smash",
  acute: ["Accent", "00B4"],
  grave: ["Accent", "0060"],
  ddot: ["Accent", "00A8"],
  tilde: ["Accent", "007E"],
  bar: ["Accent", "00AF"],
  breve: ["Accent", "02D8"],
  check: ["Accent", "02C7"],
  hat: ["Accent", "005E"],
  vec: ["Accent", "2192"],
  dot: ["Accent", "02D9"],
  widetilde: ["Accent", "007E", 1],
  widehat: ["Accent", "005E", 1],
  matrix: "Matrix",
  array: "Matrix",
  pmatrix: ["Matrix", "(", ")"],
  cases: [
    "Matrix",
    "{",
    "",
    "left left",
    null,
    ".1em",
    null,
    !0
  ],
  eqalign: [
    "Matrix",
    null,
    null,
    "right left",
    (0, c4.em)(c4.MATHSPACE.thickmathspace),
    ".5em",
    "D"
  ],
  displaylines: ["Matrix", null, null, "center", null, ".5em", "D"],
  cr: "Cr",
  "\\": "CrLaTeX",
  newline: ["CrLaTeX", !0],
  hline: ["HLine", "solid"],
  hdashline: ["HLine", "dashed"],
  eqalignno: [
    "Matrix",
    null,
    null,
    "right left",
    (0, c4.em)(c4.MATHSPACE.thickmathspace),
    ".5em",
    "D",
    null,
    "right"
  ],
  leqalignno: [
    "Matrix",
    null,
    null,
    "right left",
    (0, c4.em)(c4.MATHSPACE.thickmathspace),
    ".5em",
    "D",
    null,
    "left"
  ],
  hfill: "HFill",
  hfil: "HFill",
  hfilll: "HFill",
  bmod: ["Macro", '\\mmlToken{mo}[lspace="thickmathspace" rspace="thickmathspace"]{mod}'],
  pmod: ["Macro", "\\pod{\\mmlToken{mi}{mod}\\kern 6mu #1}", 1],
  mod: [
    "Macro",
    "\\mathchoice{\\kern18mu}{\\kern12mu}{\\kern12mu}{\\kern12mu}\\mmlToken{mi}{mod}\\,\\,#1",
    1
  ],
  pod: ["Macro", "\\mathchoice{\\kern18mu}{\\kern8mu}{\\kern8mu}{\\kern8mu}(#1)", 1],
  iff: ["Macro", "\\;\\Longleftrightarrow\\;"],
  skew: ["Macro", "{{#2{#3\\mkern#1mu}\\mkern-#1mu}{}}", 3],
  pmb: ["Macro", "\\rlap{#1}\\kern1px{#1}", 1],
  TeX: ["Macro", "T\\kern-.14em\\lower.5ex{E}\\kern-.115em X"],
  LaTeX: ["Macro", "L\\kern-.325em\\raise.21em{\\scriptstyle{A}}\\kern-.17em\\TeX"],
  " ": ["Macro", "\\text{ }"],
  not: "Not",
  dots: "Dots",
  space: "Tilde",
  " ": "Tilde",
  begin: "BeginEnd",
  end: "BeginEnd",
  label: "HandleLabel",
  ref: "HandleRef",
  nonumber: "HandleNoTag",
  mathchoice: "MathChoice",
  mmlToken: "MmlToken"
}, Es.default);
new o6.EnvironmentMap("environment", $5.default.environment, {
  array: ["AlignedArray"],
  equation: ["Equation", null, !0],
  eqnarray: [
    "EqnArray",
    null,
    !0,
    !0,
    "rcl",
    nL.default.cols(0, c4.MATHSPACE.thickmathspace),
    ".5em"
  ]
}, Es.default);
new o6.CharacterMap("not_remap", null, {
  "←": "↚",
  "→": "↛",
  "↔": "↮",
  "⇐": "⇍",
  "⇒": "⇏",
  "⇔": "⇎",
  "∈": "∉",
  "∋": "∌",
  "∣": "∤",
  "∥": "∦",
  "∼": "≁",
  "~": "≁",
  "≃": "≄",
  "≅": "≇",
  "≈": "≉",
  "≍": "≭",
  "=": "≠",
  "≡": "≢",
  "<": "≮",
  ">": "≯",
  "≤": "≰",
  "≥": "≱",
  "≲": "≴",
  "≳": "≵",
  "≶": "≸",
  "≷": "≹",
  "≺": "⊀",
  "≻": "⊁",
  "⊂": "⊄",
  "⊃": "⊅",
  "⊆": "⊈",
  "⊇": "⊉",
  "⊢": "⊬",
  "⊨": "⊭",
  "⊩": "⊮",
  "⊫": "⊯",
  "≼": "⋠",
  "≽": "⋡",
  "⊑": "⋢",
  "⊒": "⋣",
  "⊲": "⋪",
  "⊳": "⋫",
  "⊴": "⋬",
  "⊵": "⋭",
  "∃": "∄"
});
var iL = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), oL = b && b.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), aL = b && b.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), QL = b && b.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && oL(t, e, r);
  return aL(t, e), t;
}, TL = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, jd = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, o3;
Object.defineProperty(Fe, "__esModule", { value: !0 });
Fe.BaseConfiguration = Fe.BaseTags = Fe.Other = void 0;
var sL = fs, lL = Fr, $d = jd(i5), uL = jd(F4), cL = h3, l2 = QL(o2), fL = Br, dL = ss;
new cL.CharacterMap("remap", null, {
  "-": "−",
  "*": "∗",
  "`": "‘"
});
function Zd(e, t) {
  var r = e.stack.env.font, n = r ? { mathvariant: e.stack.env.font } : {}, i = lL.MapHandler.getMap("remap").lookup(t), o = (0, dL.getRange)(t), a = o ? o[3] : "mo", T = e.create("token", a, n, i ? i.char : t);
  o[4] && T.attributes.set("mathvariant", o[4]), a === "mo" && (uL.default.setProperty(T, "fixStretchy", !0), e.configuration.addNode("fixStretchy", T)), e.Push(T);
}
Fe.Other = Zd;
function hL(e, t) {
  throw new $d.default("UndefinedControlSequence", "Undefined control sequence %1", "\\" + t);
}
function pL(e, t) {
  throw new $d.default("UnknownEnv", "Unknown environment '%1'", t);
}
function mL(e) {
  var t, r, n = e.data;
  try {
    for (var i = TL(n.getList("nonscript")), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a.attributes.get("scriptlevel") > 0) {
        var T = a.parent;
        if (T.childNodes.splice(T.childIndex(a), 1), n.removeFromList(a.kind, [a]), a.isKind("mrow")) {
          var s = a.childNodes[0];
          n.removeFromList("mstyle", [s]), n.removeFromList("mspace", s.childNodes[0].childNodes);
        }
      } else
        a.isKind("mrow") && (a.parent.replaceChild(a.childNodes[0], a), n.removeFromList("mrow", [a]));
    }
  } catch (Q) {
    t = { error: Q };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
}
var Wd = function(e) {
  iL(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t;
}(fL.AbstractTags);
Fe.BaseTags = Wd;
Fe.BaseConfiguration = sL.Configuration.create("base", {
  handler: {
    character: ["command", "special", "letter", "digit"],
    delimiter: ["delimiter"],
    macro: ["delimiter", "macros", "mathchar0mi", "mathchar0mo", "mathchar7"],
    environment: ["environment"]
  },
  fallback: {
    character: Zd,
    macro: hL,
    environment: pL
  },
  items: (o3 = {}, o3[l2.StartItem.prototype.kind] = l2.StartItem, o3[l2.StopItem.prototype.kind] = l2.StopItem, o3[l2.OpenItem.prototype.kind] = l2.OpenItem, o3[l2.CloseItem.prototype.kind] = l2.CloseItem, o3[l2.PrimeItem.prototype.kind] = l2.PrimeItem, o3[l2.SubsupItem.prototype.kind] = l2.SubsupItem, o3[l2.OverItem.prototype.kind] = l2.OverItem, o3[l2.LeftItem.prototype.kind] = l2.LeftItem, o3[l2.Middle.prototype.kind] = l2.Middle, o3[l2.RightItem.prototype.kind] = l2.RightItem, o3[l2.BeginItem.prototype.kind] = l2.BeginItem, o3[l2.EndItem.prototype.kind] = l2.EndItem, o3[l2.StyleItem.prototype.kind] = l2.StyleItem, o3[l2.PositionItem.prototype.kind] = l2.PositionItem, o3[l2.CellItem.prototype.kind] = l2.CellItem, o3[l2.MmlItem.prototype.kind] = l2.MmlItem, o3[l2.FnItem.prototype.kind] = l2.FnItem, o3[l2.NotItem.prototype.kind] = l2.NotItem, o3[l2.NonscriptItem.prototype.kind] = l2.NonscriptItem, o3[l2.DotsItem.prototype.kind] = l2.DotsItem, o3[l2.ArrayItem.prototype.kind] = l2.ArrayItem, o3[l2.EqnArrayItem.prototype.kind] = l2.EqnArrayItem, o3[l2.EquationItem.prototype.kind] = l2.EquationItem, o3),
  options: {
    maxMacros: 1e3,
    baseURL: typeof document > "u" || document.getElementsByTagName("base").length === 0 ? "" : String(document.location).replace(/#.*$/, "")
  },
  tags: {
    base: Wd
  },
  postprocessors: [[mL, -4]]
});
var vL = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), o9 = b && b.__assign || function() {
  return o9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, o9.apply(this, arguments);
}, LL = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, $r = b && b.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qs, "__esModule", { value: !0 });
var Gd = Qs.TeX = void 0, Fl = D0, jl = r4, $l = G9, n0 = $r(Ts), Zl = $r(F4), yL = $r(U9()), gL = $r(i5), xL = $r(us), cn = Br, HL = fs, EL = function(e) {
  vL(t, e);
  function t(r) {
    r === void 0 && (r = {});
    var n = this, i = LL((0, jl.separateOptions)(r, t.OPTIONS, $l.FindTeX.OPTIONS), 3), o = i[0], a = i[1], T = i[2];
    n = e.call(this, a) || this, n.findTeX = n.options.FindTeX || new $l.FindTeX(T);
    var s = n.options.packages, Q = n.configuration = t.configure(s), u = n._parseOptions = new xL.default(Q, [n.options, cn.TagsFactory.OPTIONS]);
    return (0, jl.userOptions)(u.options, o), Q.config(n), t.tags(u, Q), n.postFilters.add(n0.default.cleanSubSup, -6), n.postFilters.add(n0.default.setInherited, -5), n.postFilters.add(n0.default.moveLimits, -4), n.postFilters.add(n0.default.cleanStretchy, -3), n.postFilters.add(n0.default.cleanAttributes, -2), n.postFilters.add(n0.default.combineRelations, -1), n;
  }
  return t.configure = function(r) {
    var n = new HL.ParserConfiguration(r, ["tex"]);
    return n.init(), n;
  }, t.tags = function(r, n) {
    cn.TagsFactory.addTags(n.tags), cn.TagsFactory.setDefault(r.options.tags), r.tags = cn.TagsFactory.getDefault(), r.tags.configuration = r;
  }, t.prototype.setMmlFactory = function(r) {
    e.prototype.setMmlFactory.call(this, r), this._parseOptions.nodeFactory.setMmlFactory(r);
  }, Object.defineProperty(t.prototype, "parseOptions", {
    get: function() {
      return this._parseOptions;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.reset = function(r) {
    r === void 0 && (r = 0), this.parseOptions.tags.reset(r);
  }, t.prototype.compile = function(r, n) {
    this.parseOptions.clear(), this.executeFilters(this.preFilters, r, n, this.parseOptions);
    var i = r.display;
    this.latex = r.math;
    var o;
    this.parseOptions.tags.startEquation(r);
    var a;
    try {
      var T = new yL.default(this.latex, { display: i, isInner: !1 }, this.parseOptions);
      o = T.mml(), a = T.stack.global;
    } catch (s) {
      if (!(s instanceof gL.default))
        throw s;
      this.parseOptions.error = !0, o = this.options.formatError(this, s);
    }
    return o = this.parseOptions.nodeFactory.create("node", "math", [o]), a != null && a.indentalign && Zl.default.setAttribute(o, "indentalign", a.indentalign), i && Zl.default.setAttribute(o, "display", "block"), this.parseOptions.tags.finishEquation(r), this.parseOptions.root = o, this.executeFilters(this.postFilters, r, n, this.parseOptions), this.mathNode = this.parseOptions.root, this.mathNode;
  }, t.prototype.findMath = function(r) {
    return this.findTeX.findMath(r);
  }, t.prototype.formatError = function(r) {
    var n = r.message.replace(/\n.*/, "");
    return this.parseOptions.nodeFactory.create("error", n, r.id, this.latex);
  }, t.NAME = "TeX", t.OPTIONS = o9(o9({}, Fl.AbstractInputJax.OPTIONS), { FindTeX: null, packages: ["base"], digits: /^(?:[0-9]+(?:\{,\}[0-9]{3})*(?:\.[0-9]*)?|\.[0-9]+)/, maxBuffer: 5 * 1024, formatError: function(r, n) {
    return r.formatError(n);
  } }), t;
}(Fl.AbstractInputJax);
Gd = Qs.TeX = EL;
var bs = {}, K9 = {}, bL = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), F7 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(K9, "__esModule", { value: !0 });
K9.FindMathML = void 0;
var ML = Rr, Wl = "http://www.w3.org/1998/Math/MathML", wL = function(e) {
  bL(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.findMath = function(r) {
    var n = /* @__PURE__ */ new Set();
    this.findMathNodes(r, n), this.findMathPrefixed(r, n);
    var i = this.adaptor.root(this.adaptor.document);
    return this.adaptor.kind(i) === "html" && n.size === 0 && this.findMathNS(r, n), this.processMath(n);
  }, t.prototype.findMathNodes = function(r, n) {
    var i, o;
    try {
      for (var a = F7(this.adaptor.tags(r, "math")), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        n.add(s);
      }
    } catch (Q) {
      i = { error: Q };
    } finally {
      try {
        T && !T.done && (o = a.return) && o.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, t.prototype.findMathPrefixed = function(r, n) {
    var i, o, a, T, s = this.adaptor.root(this.adaptor.document);
    try {
      for (var Q = F7(this.adaptor.allAttributes(s)), u = Q.next(); !u.done; u = Q.next()) {
        var l = u.value;
        if (l.name.substr(0, 6) === "xmlns:" && l.value === Wl) {
          var c = l.name.substr(6);
          try {
            for (var f = (a = void 0, F7(this.adaptor.tags(r, c + ":math"))), d = f.next(); !d.done; d = f.next()) {
              var m = d.value;
              n.add(m);
            }
          } catch (p) {
            a = { error: p };
          } finally {
            try {
              d && !d.done && (T = f.return) && T.call(f);
            } finally {
              if (a)
                throw a.error;
            }
          }
        }
      }
    } catch (p) {
      i = { error: p };
    } finally {
      try {
        u && !u.done && (o = Q.return) && o.call(Q);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, t.prototype.findMathNS = function(r, n) {
    var i, o;
    try {
      for (var a = F7(this.adaptor.tags(r, "math", Wl)), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        n.add(s);
      }
    } catch (Q) {
      i = { error: Q };
    } finally {
      try {
        T && !T.done && (o = a.return) && o.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, t.prototype.processMath = function(r) {
    var n, i, o = [];
    try {
      for (var a = F7(Array.from(r)), T = a.next(); !T.done; T = a.next()) {
        var s = T.value, Q = this.adaptor.getAttribute(s, "display") === "block" || this.adaptor.getAttribute(s, "mode") === "display", u = { node: s, n: 0, delim: "" }, l = { node: s, n: 0, delim: "" };
        o.push({ math: this.adaptor.outerHTML(s), start: u, end: l, display: Q });
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        T && !T.done && (i = a.return) && i.call(a);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return o;
  }, t.OPTIONS = {}, t;
}(ML.AbstractFindMath);
K9.FindMathML = wL;
var ei = {}, fT = b && b.__assign || function() {
  return fT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, fT.apply(this, arguments);
}, SL = b && b.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), CL = b && b.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), VL = b && b.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && SL(t, e, r);
  return CL(t, e), t;
}, fn = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(ei, "__esModule", { value: !0 });
ei.MathMLCompile = void 0;
var Gl = T2, zl = r4, _L = VL(Nr), OL = function() {
  function e(t) {
    t === void 0 && (t = {});
    var r = this.constructor;
    this.options = (0, zl.userOptions)((0, zl.defaultOptions)({}, r.OPTIONS), t);
  }
  return e.prototype.setMmlFactory = function(t) {
    this.factory = t;
  }, e.prototype.compile = function(t) {
    var r = this.makeNode(t);
    return r.verifyTree(this.options.verify), r.setInheritedAttributes({}, !1, 0, !1), r.walkTree(this.markMrows), r;
  }, e.prototype.makeNode = function(t) {
    var r, n, i = this.adaptor, o = !1, a = i.kind(t).replace(/^.*:/, ""), T = i.getAttribute(t, "data-mjx-texclass") || "";
    T && (T = this.filterAttribute("data-mjx-texclass", T) || "");
    var s = T && a === "mrow" ? "TeXAtom" : a;
    try {
      for (var Q = fn(this.filterClassList(i.allClasses(t))), u = Q.next(); !u.done; u = Q.next()) {
        var l = u.value;
        l.match(/^MJX-TeXAtom-/) && a === "mrow" ? (T = l.substr(12), s = "TeXAtom") : l === "MJX-fixedlimits" && (o = !0);
      }
    } catch (f) {
      r = { error: f };
    } finally {
      try {
        u && !u.done && (n = Q.return) && n.call(Q);
      } finally {
        if (r)
          throw r.error;
      }
    }
    this.factory.getNodeClass(s) || this.error('Unknown node type "' + s + '"');
    var c = this.factory.create(s);
    return s === "TeXAtom" && T === "OP" && !o && (c.setProperty("movesupsub", !0), c.attributes.setInherited("movablelimits", !0)), T && (c.texClass = Gl.TEXCLASS[T], c.setProperty("texClass", c.texClass)), this.addAttributes(c, t), this.checkClass(c, t), this.addChildren(c, t), c;
  }, e.prototype.addAttributes = function(t, r) {
    var n, i, o = !1;
    try {
      for (var a = fn(this.adaptor.allAttributes(r)), T = a.next(); !T.done; T = a.next()) {
        var s = T.value, Q = s.name, u = this.filterAttribute(Q, s.value);
        if (!(u === null || Q === "xmlns")) {
          if (Q.substr(0, 9) === "data-mjx-")
            switch (Q.substr(9)) {
              case "alternate":
                t.setProperty("variantForm", !0);
                break;
              case "variant":
                t.attributes.set("mathvariant", u), o = !0;
                break;
              case "smallmatrix":
                t.setProperty("scriptlevel", 1), t.setProperty("useHeight", !1);
                break;
              case "accent":
                t.setProperty("mathaccent", u === "true");
                break;
              case "auto-op":
                t.setProperty("autoOP", u === "true");
                break;
              case "script-align":
                t.setProperty("scriptalign", u);
                break;
            }
          else if (Q !== "class") {
            var l = u.toLowerCase();
            l === "true" || l === "false" ? t.attributes.set(Q, l === "true") : (!o || Q !== "mathvariant") && t.attributes.set(Q, u);
          }
        }
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        T && !T.done && (i = a.return) && i.call(a);
      } finally {
        if (n)
          throw n.error;
      }
    }
  }, e.prototype.filterAttribute = function(t, r) {
    return r;
  }, e.prototype.filterClassList = function(t) {
    return t;
  }, e.prototype.addChildren = function(t, r) {
    var n, i;
    if (t.arity !== 0) {
      var o = this.adaptor;
      try {
        for (var a = fn(o.childNodes(r)), T = a.next(); !T.done; T = a.next()) {
          var s = T.value, Q = o.kind(s);
          if (Q !== "#comment")
            if (Q === "#text")
              this.addText(t, s);
            else if (t.isKind("annotation-xml"))
              t.appendChild(this.factory.create("XML").setXML(s, o));
            else {
              var u = t.appendChild(this.makeNode(s));
              u.arity === 0 && o.childNodes(s).length && (this.options.fixMisplacedChildren ? this.addChildren(t, s) : u.mError("There should not be children for " + u.kind + " nodes", this.options.verify, !0));
            }
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          T && !T.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }
  }, e.prototype.addText = function(t, r) {
    var n = this.adaptor.value(r);
    (t.isToken || t.getProperty("isChars")) && t.arity ? (t.isToken && (n = _L.translate(n), n = this.trimSpace(n)), t.appendChild(this.factory.create("text").setText(n))) : n.match(/\S/) && this.error('Unexpected text node "' + n + '"');
  }, e.prototype.checkClass = function(t, r) {
    var n, i, o = [];
    try {
      for (var a = fn(this.filterClassList(this.adaptor.allClasses(r))), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        s.substr(0, 4) === "MJX-" ? s === "MJX-variant" ? t.setProperty("variantForm", !0) : s.substr(0, 11) !== "MJX-TeXAtom" && t.attributes.set("mathvariant", this.fixCalligraphic(s.substr(3))) : o.push(s);
      }
    } catch (Q) {
      n = { error: Q };
    } finally {
      try {
        T && !T.done && (i = a.return) && i.call(a);
      } finally {
        if (n)
          throw n.error;
      }
    }
    o.length && t.attributes.set("class", o.join(" "));
  }, e.prototype.fixCalligraphic = function(t) {
    return t.replace(/caligraphic/, "calligraphic");
  }, e.prototype.markMrows = function(t) {
    if (t.isKind("mrow") && !t.isInferred && t.childNodes.length >= 2) {
      var r = t.childNodes[0], n = t.childNodes[t.childNodes.length - 1];
      r.isKind("mo") && r.attributes.get("fence") && r.attributes.get("stretchy") && n.isKind("mo") && n.attributes.get("fence") && n.attributes.get("stretchy") && (r.childNodes.length && t.setProperty("open", r.getText()), n.childNodes.length && t.setProperty("close", n.getText()));
    }
  }, e.prototype.trimSpace = function(t) {
    return t.replace(/[\t\n\r]/g, " ").replace(/^ +/, "").replace(/ +$/, "").replace(/  +/g, " ");
  }, e.prototype.error = function(t) {
    throw new Error(t);
  }, e.OPTIONS = {
    MmlFactory: null,
    fixMisplacedChildren: !0,
    verify: fT({}, Gl.AbstractMmlNode.verifyDefaults),
    translateEntities: !0
  }, e;
}();
ei.MathMLCompile = OL;
var AL = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), DL = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
};
Object.defineProperty(bs, "__esModule", { value: !0 });
var zd = bs.MathML = void 0, Ul = D0, Xl = r4, kL = j5, ql = K9, Jl = ei, IL = function(e) {
  AL(t, e);
  function t(r) {
    r === void 0 && (r = {});
    var n = this, i = DL((0, Xl.separateOptions)(r, ql.FindMathML.OPTIONS, Jl.MathMLCompile.OPTIONS), 3), o = i[0], a = i[1], T = i[2];
    return n = e.call(this, o) || this, n.findMathML = n.options.FindMathML || new ql.FindMathML(a), n.mathml = n.options.MathMLCompile || new Jl.MathMLCompile(T), n.mmlFilters = new kL.FunctionList(), n;
  }
  return t.prototype.setAdaptor = function(r) {
    e.prototype.setAdaptor.call(this, r), this.findMathML.adaptor = r, this.mathml.adaptor = r;
  }, t.prototype.setMmlFactory = function(r) {
    e.prototype.setMmlFactory.call(this, r), this.mathml.setMmlFactory(r);
  }, Object.defineProperty(t.prototype, "processStrings", {
    get: function() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.compile = function(r, n) {
    var i = r.start.node;
    if (!i || !r.end.node || this.options.forceReparse || this.adaptor.kind(i) === "#text") {
      var o = this.executeFilters(this.preFilters, r, n, (r.math || "<math></math>").trim()), a = this.checkForErrors(this.adaptor.parse(o, "text/" + this.options.parseAs)), T = this.adaptor.body(a);
      this.adaptor.childNodes(T).length !== 1 && this.error("MathML must consist of a single element"), i = this.adaptor.remove(this.adaptor.firstChild(T)), this.adaptor.kind(i).replace(/^[a-z]+:/, "") !== "math" && this.error("MathML must be formed by a <math> element, not <" + this.adaptor.kind(i) + ">");
    }
    return i = this.executeFilters(this.mmlFilters, r, n, i), this.executeFilters(this.postFilters, r, n, this.mathml.compile(i));
  }, t.prototype.checkForErrors = function(r) {
    var n = this.adaptor.tags(this.adaptor.body(r), "parsererror")[0];
    return n && (this.adaptor.textContent(n) === "" && this.error("Error processing MathML"), this.options.parseError.call(this, n)), r;
  }, t.prototype.error = function(r) {
    throw new Error(r);
  }, t.prototype.findMath = function(r) {
    return this.findMathML.findMath(r);
  }, t.NAME = "MathML", t.OPTIONS = (0, Xl.defaultOptions)({
    parseAs: "html",
    forceReparse: !1,
    FindMathML: null,
    MathMLCompile: null,
    parseError: function(r) {
      this.error(this.adaptor.textContent(r).replace(/\n.*/g, ""));
    }
  }, Ul.AbstractInputJax.OPTIONS), t;
}(Ul.AbstractInputJax);
zd = bs.MathML = IL;
var lQ = {}, ti = {}, Zr = {};
Object.defineProperty(Zr, "__esModule", { value: !0 });
Zr.AbstractOutputJax = void 0;
var Yl = r4, RL = j5, NL = function() {
  function e(t) {
    t === void 0 && (t = {}), this.adaptor = null;
    var r = this.constructor;
    this.options = (0, Yl.userOptions)((0, Yl.defaultOptions)({}, r.OPTIONS), t), this.postFilters = new RL.FunctionList();
  }
  return Object.defineProperty(e.prototype, "name", {
    get: function() {
      return this.constructor.NAME;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.setAdaptor = function(t) {
    this.adaptor = t;
  }, e.prototype.initialize = function() {
  }, e.prototype.reset = function() {
  }, e.prototype.getMetrics = function(t) {
  }, e.prototype.styleSheet = function(t) {
    return null;
  }, e.prototype.pageElements = function(t) {
    return null;
  }, e.prototype.executeFilters = function(t, r, n, i) {
    var o = { math: r, document: n, data: i };
    return t.execute(o), o.data;
  }, e.NAME = "generic", e.OPTIONS = {}, e;
}();
Zr.AbstractOutputJax = NL;
var Wr = {}, B4 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ms = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, PL = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(Wr, "__esModule", { value: !0 });
Wr.Styles = void 0;
var j7 = ["top", "right", "bottom", "left"], dn = ["width", "style", "color"];
function ws(e) {
  for (var t = e.split(/((?:'[^']*'|"[^"]*"|,[\s\n]|[^\s\n])*)/g), r = []; t.length > 1; )
    t.shift(), r.push(t.shift());
  return r;
}
function hn(e) {
  var t, r, n = ws(this.styles[e]);
  n.length === 0 && n.push(""), n.length === 1 && n.push(n[0]), n.length === 2 && n.push(n[0]), n.length === 3 && n.push(n[1]);
  try {
    for (var i = B4(Z5.connect[e].children), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      this.setStyle(this.childName(e, a), n.shift());
    }
  } catch (T) {
    t = { error: T };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
}
function BL(e) {
  var t, r, n = Z5.connect[e].children, i = [];
  try {
    for (var o = B4(n), a = o.next(); !a.done; a = o.next()) {
      var T = a.value, s = this.styles[e + "-" + T];
      if (!s) {
        delete this.styles[e];
        return;
      }
      i.push(s);
    }
  } catch (Q) {
    t = { error: Q };
  } finally {
    try {
      a && !a.done && (r = o.return) && r.call(o);
    } finally {
      if (t)
        throw t.error;
    }
  }
  i[3] === i[1] && (i.pop(), i[2] === i[0] && (i.pop(), i[1] === i[0] && i.pop())), this.styles[e] = i.join(" ");
}
function FL(e) {
  var t, r;
  try {
    for (var n = B4(Z5.connect[e].children), i = n.next(); !i.done; i = n.next()) {
      var o = i.value;
      this.setStyle(this.childName(e, o), this.styles[e]);
    }
  } catch (a) {
    t = { error: a };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (t)
        throw t.error;
    }
  }
}
function jL(e) {
  var t, r, n = PL([], Ms(Z5.connect[e].children), !1), i = this.styles[this.childName(e, n.shift())];
  try {
    for (var o = B4(n), a = o.next(); !a.done; a = o.next()) {
      var T = a.value;
      if (this.styles[this.childName(e, T)] !== i) {
        delete this.styles[e];
        return;
      }
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      a && !a.done && (r = o.return) && r.call(o);
    } finally {
      if (t)
        throw t.error;
    }
  }
  this.styles[e] = i;
}
var Kl = {
  width: /^(?:[\d.]+(?:[a-z]+)|thin|medium|thick|inherit|initial|unset)$/,
  style: /^(?:none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset|inherit|initial|unset)$/
};
function pn(e) {
  var t, r, n, i, o = { width: "", style: "", color: "" };
  try {
    for (var a = B4(ws(this.styles[e])), T = a.next(); !T.done; T = a.next()) {
      var s = T.value;
      s.match(Kl.width) && o.width === "" ? o.width = s : s.match(Kl.style) && o.style === "" ? o.style = s : o.color = s;
    }
  } catch (c) {
    t = { error: c };
  } finally {
    try {
      T && !T.done && (r = a.return) && r.call(a);
    } finally {
      if (t)
        throw t.error;
    }
  }
  try {
    for (var Q = B4(Z5.connect[e].children), u = Q.next(); !u.done; u = Q.next()) {
      var l = u.value;
      this.setStyle(this.childName(e, l), o[l]);
    }
  } catch (c) {
    n = { error: c };
  } finally {
    try {
      u && !u.done && (i = Q.return) && i.call(Q);
    } finally {
      if (n)
        throw n.error;
    }
  }
}
function mn(e) {
  var t, r, n = [];
  try {
    for (var i = B4(Z5.connect[e].children), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, T = this.styles[this.childName(e, a)];
      T && n.push(T);
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  n.length ? this.styles[e] = n.join(" ") : delete this.styles[e];
}
var eu = {
  style: /^(?:normal|italic|oblique|inherit|initial|unset)$/,
  variant: new RegExp("^(?:" + [
    "normal|none",
    "inherit|initial|unset",
    "common-ligatures|no-common-ligatures",
    "discretionary-ligatures|no-discretionary-ligatures",
    "historical-ligatures|no-historical-ligatures",
    "contextual|no-contextual",
    "(?:stylistic|character-variant|swash|ornaments|annotation)\\([^)]*\\)",
    "small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
    "lining-nums|oldstyle-nums|proportional-nums|tabular-nums",
    "diagonal-fractions|stacked-fractions",
    "ordinal|slashed-zero",
    "jis78|jis83|jis90|jis04|simplified|traditional",
    "full-width|proportional-width",
    "ruby"
  ].join("|") + ")$"),
  weight: /^(?:normal|bold|bolder|lighter|[1-9]00|inherit|initial|unset)$/,
  stretch: new RegExp("^(?:" + [
    "normal",
    "(?:(?:ultra|extra|semi)-)?condensed",
    "(?:(?:semi|extra|ulta)-)?expanded",
    "inherit|initial|unset"
  ].join("|") + ")$"),
  size: new RegExp("^(?:" + [
    "xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller",
    "[d.]+%|[d.]+[a-z]+",
    "inherit|initial|unset"
  ].join("|") + ")(?:/(?:normal|[d.+](?:%|[a-z]+)?))?$")
};
function $L(e) {
  var t, r, n, i, o = ws(this.styles[e]), a = {
    style: "",
    variant: [],
    weight: "",
    stretch: "",
    size: "",
    family: "",
    "line-height": ""
  };
  try {
    for (var T = B4(o), s = T.next(); !s.done; s = T.next()) {
      var Q = s.value;
      a.family = Q;
      try {
        for (var u = (n = void 0, B4(Object.keys(eu))), l = u.next(); !l.done; l = u.next()) {
          var c = l.value;
          if ((Array.isArray(a[c]) || a[c] === "") && Q.match(eu[c]))
            if (c === "size") {
              var f = Ms(Q.split(/\//), 2), d = f[0], m = f[1];
              a[c] = d, m && (a["line-height"] = m);
            } else
              a.size === "" && (Array.isArray(a[c]) ? a[c].push(Q) : a[c] = Q);
        }
      } catch (p) {
        n = { error: p };
      } finally {
        try {
          l && !l.done && (i = u.return) && i.call(u);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }
  } catch (p) {
    t = { error: p };
  } finally {
    try {
      s && !s.done && (r = T.return) && r.call(T);
    } finally {
      if (t)
        throw t.error;
    }
  }
  ZL(e, a), delete this.styles[e];
}
function ZL(e, t) {
  var r, n;
  try {
    for (var i = B4(Z5.connect[e].children), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, T = this.childName(e, a);
      if (Array.isArray(t[a])) {
        var s = t[a];
        s.length && (this.styles[T] = s.join(" "));
      } else
        t[a] !== "" && (this.styles[T] = t[a]);
    }
  } catch (Q) {
    r = { error: Q };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r)
        throw r.error;
    }
  }
}
function WL(e) {
}
var Z5 = function() {
  function e(t) {
    t === void 0 && (t = ""), this.parse(t);
  }
  return Object.defineProperty(e.prototype, "cssText", {
    get: function() {
      var t, r, n = [];
      try {
        for (var i = B4(Object.keys(this.styles)), o = i.next(); !o.done; o = i.next()) {
          var a = o.value, T = this.parentName(a);
          this.styles[T] || n.push(a + ": " + this.styles[a] + ";");
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return n.join(" ");
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.set = function(t, r) {
    for (t = this.normalizeName(t), this.setStyle(t, r), e.connect[t] && !e.connect[t].combine && (this.combineChildren(t), delete this.styles[t]); t.match(/-/) && (t = this.parentName(t), !!e.connect[t]); )
      e.connect[t].combine.call(this, t);
  }, e.prototype.get = function(t) {
    return t = this.normalizeName(t), this.styles.hasOwnProperty(t) ? this.styles[t] : "";
  }, e.prototype.setStyle = function(t, r) {
    this.styles[t] = r, e.connect[t] && e.connect[t].children && e.connect[t].split.call(this, t), r === "" && delete this.styles[t];
  }, e.prototype.combineChildren = function(t) {
    var r, n, i = this.parentName(t);
    try {
      for (var o = B4(e.connect[t].children), a = o.next(); !a.done; a = o.next()) {
        var T = a.value, s = this.childName(i, T);
        e.connect[s].combine.call(this, s);
      }
    } catch (Q) {
      r = { error: Q };
    } finally {
      try {
        a && !a.done && (n = o.return) && n.call(o);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, e.prototype.parentName = function(t) {
    var r = t.replace(/-[^-]*$/, "");
    return t === r ? "" : r;
  }, e.prototype.childName = function(t, r) {
    return r.match(/-/) ? r : (e.connect[t] && !e.connect[t].combine && (r += t.replace(/.*-/, "-"), t = this.parentName(t)), t + "-" + r);
  }, e.prototype.normalizeName = function(t) {
    return t.replace(/[A-Z]/g, function(r) {
      return "-" + r.toLowerCase();
    });
  }, e.prototype.parse = function(t) {
    t === void 0 && (t = "");
    var r = this.constructor.pattern;
    this.styles = {};
    for (var n = t.replace(r.comment, "").split(r.style); n.length > 1; ) {
      var i = Ms(n.splice(0, 3), 3), o = i[0], a = i[1], T = i[2];
      if (o.match(/[^\s\n]/))
        return;
      this.set(a, T);
    }
  }, e.pattern = {
    style: /([-a-z]+)[\s\n]*:[\s\n]*((?:'[^']*'|"[^"]*"|\n|.)*?)[\s\n]*(?:;|$)/g,
    comment: /\/\*[^]*?\*\//g
  }, e.connect = {
    padding: {
      children: j7,
      split: hn,
      combine: BL
    },
    border: {
      children: j7,
      split: FL,
      combine: jL
    },
    "border-top": {
      children: dn,
      split: pn,
      combine: mn
    },
    "border-right": {
      children: dn,
      split: pn,
      combine: mn
    },
    "border-bottom": {
      children: dn,
      split: pn,
      combine: mn
    },
    "border-left": {
      children: dn,
      split: pn,
      combine: mn
    },
    "border-width": {
      children: j7,
      split: hn,
      combine: null
    },
    "border-style": {
      children: j7,
      split: hn,
      combine: null
    },
    "border-color": {
      children: j7,
      split: hn,
      combine: null
    },
    font: {
      children: ["style", "variant", "weight", "stretch", "line-height", "size", "family"],
      split: $L,
      combine: WL
    }
  }, e;
}();
Wr.Styles = Z5;
var ri = {}, vn = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(ri, "__esModule", { value: !0 });
ri.CssStyles = void 0;
var GL = function() {
  function e(t) {
    t === void 0 && (t = null), this.styles = {}, this.addStyles(t);
  }
  return Object.defineProperty(e.prototype, "cssText", {
    get: function() {
      return this.getStyleString();
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.addStyles = function(t) {
    var r, n;
    if (t)
      try {
        for (var i = vn(Object.keys(t)), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          this.styles[a] || (this.styles[a] = {}), Object.assign(this.styles[a], t[a]);
        }
      } catch (T) {
        r = { error: T };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r)
            throw r.error;
        }
      }
  }, e.prototype.removeStyles = function() {
    for (var t, r, n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    try {
      for (var o = vn(n), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        delete this.styles[T];
      }
    } catch (s) {
      t = { error: s };
    } finally {
      try {
        a && !a.done && (r = o.return) && r.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
  }, e.prototype.clear = function() {
    this.styles = {};
  }, e.prototype.getStyleString = function() {
    return this.getStyleRules().join(`

`);
  }, e.prototype.getStyleRules = function() {
    var t, r, n = Object.keys(this.styles), i = new Array(n.length), o = 0;
    try {
      for (var a = vn(n), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        i[o++] = s + ` {
` + this.getStyleDefString(this.styles[s]) + `
}`;
      }
    } catch (Q) {
      t = { error: Q };
    } finally {
      try {
        T && !T.done && (r = a.return) && r.call(a);
      } finally {
        if (t)
          throw t.error;
      }
    }
    return i;
  }, e.prototype.getStyleDefString = function(t) {
    var r, n, i = Object.keys(t), o = new Array(i.length), a = 0;
    try {
      for (var T = vn(i), s = T.next(); !s.done; s = T.next()) {
        var Q = s.value;
        o[a++] = "  " + Q + ": " + t[Q] + ";";
      }
    } catch (u) {
      r = { error: u };
    } finally {
      try {
        s && !s.done && (n = T.return) && n.call(T);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return o.join(`
`);
  }, e;
}();
ri.CssStyles = GL;
var zL = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), a9 = b && b.__assign || function() {
  return a9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, a9.apply(this, arguments);
}, uQ = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, b5 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(ti, "__esModule", { value: !0 });
ti.CommonOutputJax = void 0;
var tu = Zr, cQ = tt, UL = r4, XL = it, qL = Wr, JL = ri, YL = function(e) {
  zL(t, e);
  function t(r, n, i) {
    r === void 0 && (r = null), n === void 0 && (n = null), i === void 0 && (i = null);
    var o = this, a = uQ((0, UL.separateOptions)(r, i.OPTIONS), 2), T = a[0], s = a[1];
    return o = e.call(this, T) || this, o.factory = o.options.wrapperFactory || new n(), o.factory.jax = o, o.cssStyles = o.options.cssStyles || new JL.CssStyles(), o.font = o.options.font || new i(s), o.unknownCache = /* @__PURE__ */ new Map(), o;
  }
  return t.prototype.typeset = function(r, n) {
    this.setDocument(n);
    var i = this.createNode();
    return this.toDOM(r, i, n), i;
  }, t.prototype.createNode = function() {
    var r = this.constructor.NAME;
    return this.html("mjx-container", { class: "MathJax", jax: r });
  }, t.prototype.setScale = function(r) {
    var n = this.math.metrics.scale * this.options.scale;
    n !== 1 && this.adaptor.setStyle(r, "fontSize", (0, XL.percent)(n));
  }, t.prototype.toDOM = function(r, n, i) {
    i === void 0 && (i = null), this.setDocument(i), this.math = r, this.pxPerEm = r.metrics.ex / this.font.params.x_height, r.root.setTeXclass(null), this.setScale(n), this.nodeMap = /* @__PURE__ */ new Map(), this.container = n, this.processMath(r.root, n), this.nodeMap = null, this.executeFilters(this.postFilters, r, i, n);
  }, t.prototype.getBBox = function(r, n) {
    this.setDocument(n), this.math = r, r.root.setTeXclass(null), this.nodeMap = /* @__PURE__ */ new Map();
    var i = this.factory.wrap(r.root).getOuterBBox();
    return this.nodeMap = null, i;
  }, t.prototype.getMetrics = function(r) {
    var n, i;
    this.setDocument(r);
    var o = this.adaptor, a = this.getMetricMaps(r);
    try {
      for (var T = b5(r.math), s = T.next(); !s.done; s = T.next()) {
        var Q = s.value, u = o.parent(Q.start.node);
        if (Q.state() < cQ.STATE.METRICS && u) {
          var l = a[Q.display ? 1 : 0], c = l.get(u), f = c.em, d = c.ex, m = c.containerWidth, p = c.lineWidth, v = c.scale, H = c.family;
          Q.setMetrics(f, d, m, p, v), this.options.mtextInheritFont && (Q.outputData.mtextFamily = H), this.options.merrorInheritFont && (Q.outputData.merrorFamily = H), Q.state(cQ.STATE.METRICS);
        }
      }
    } catch (E) {
      n = { error: E };
    } finally {
      try {
        s && !s.done && (i = T.return) && i.call(T);
      } finally {
        if (n)
          throw n.error;
      }
    }
  }, t.prototype.getMetricsFor = function(r, n) {
    var i = this.options.mtextInheritFont || this.options.merrorInheritFont, o = this.getTestElement(r, n), a = this.measureMetrics(o, i);
    return this.adaptor.remove(o), a;
  }, t.prototype.getMetricMaps = function(r) {
    var n, i, o, a, T, s, Q, u, l, c, f = this.adaptor, d = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()];
    try {
      for (var m = b5(r.math), p = m.next(); !p.done; p = m.next()) {
        var v = p.value, H = f.parent(v.start.node);
        if (H && v.state() < cQ.STATE.METRICS) {
          var E = d[v.display ? 1 : 0];
          E.has(H) || E.set(H, this.getTestElement(H, v.display));
        }
      }
    } catch (t1) {
      n = { error: t1 };
    } finally {
      try {
        p && !p.done && (i = m.return) && i.call(m);
      } finally {
        if (n)
          throw n.error;
      }
    }
    var M = this.options.mtextInheritFont || this.options.merrorInheritFont, C = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()];
    try {
      for (var w = b5(C.keys()), S = w.next(); !S.done; S = w.next()) {
        var D = S.value;
        try {
          for (var k = (T = void 0, b5(d[D].keys())), $ = k.next(); !$.done; $ = k.next()) {
            var H = $.value;
            C[D].set(H, this.measureMetrics(d[D].get(H), M));
          }
        } catch (t1) {
          T = { error: t1 };
        } finally {
          try {
            $ && !$.done && (s = k.return) && s.call(k);
          } finally {
            if (T)
              throw T.error;
          }
        }
      }
    } catch (t1) {
      o = { error: t1 };
    } finally {
      try {
        S && !S.done && (a = w.return) && a.call(w);
      } finally {
        if (o)
          throw o.error;
      }
    }
    try {
      for (var z = b5(C.keys()), j = z.next(); !j.done; j = z.next()) {
        var D = j.value;
        try {
          for (var J = (l = void 0, b5(d[D].values())), i1 = J.next(); !i1.done; i1 = J.next()) {
            var H = i1.value;
            f.remove(H);
          }
        } catch (T1) {
          l = { error: T1 };
        } finally {
          try {
            i1 && !i1.done && (c = J.return) && c.call(J);
          } finally {
            if (l)
              throw l.error;
          }
        }
      }
    } catch (t1) {
      Q = { error: t1 };
    } finally {
      try {
        j && !j.done && (u = z.return) && u.call(z);
      } finally {
        if (Q)
          throw Q.error;
      }
    }
    return C;
  }, t.prototype.getTestElement = function(r, n) {
    var i = this.adaptor;
    if (!this.testInline) {
      this.testInline = this.html("mjx-test", { style: {
        display: "inline-block",
        width: "100%",
        "font-style": "normal",
        "font-weight": "normal",
        "font-size": "100%",
        "font-size-adjust": "none",
        "text-indent": 0,
        "text-transform": "none",
        "letter-spacing": "normal",
        "word-spacing": "normal",
        overflow: "hidden",
        height: "1px",
        "margin-right": "-1px"
      } }, [
        this.html("mjx-left-box", { style: {
          display: "inline-block",
          width: 0,
          float: "left"
        } }),
        this.html("mjx-ex-box", { style: {
          position: "absolute",
          overflow: "hidden",
          width: "1px",
          height: "60ex"
        } }),
        this.html("mjx-right-box", { style: {
          display: "inline-block",
          width: 0,
          float: "right"
        } })
      ]), this.testDisplay = i.clone(this.testInline), i.setStyle(this.testDisplay, "display", "table"), i.setStyle(this.testDisplay, "margin-right", ""), i.setStyle(i.firstChild(this.testDisplay), "display", "none");
      var o = i.lastChild(this.testDisplay);
      i.setStyle(o, "display", "table-cell"), i.setStyle(o, "width", "10000em"), i.setStyle(o, "float", "");
    }
    return i.append(r, i.clone(n ? this.testDisplay : this.testInline));
  }, t.prototype.measureMetrics = function(r, n) {
    var i = this.adaptor, o = n ? i.fontFamily(r) : "", a = i.fontSize(r), T = uQ(i.nodeSize(i.childNode(r, 1)), 2), s = T[0], Q = T[1], u = s ? Q / 60 : a * this.options.exFactor, l = s ? i.getStyle(r, "display") === "table" ? i.nodeSize(i.lastChild(r))[0] - 1 : i.nodeBBox(i.lastChild(r)).left - i.nodeBBox(i.firstChild(r)).left - 2 : 1e6, c = Math.max(this.options.minScale, this.options.matchFontHeight ? u / this.font.params.x_height / a : 1), f = 1e6;
    return { em: a, ex: u, containerWidth: l, lineWidth: f, scale: c, family: o };
  }, t.prototype.styleSheet = function(r) {
    var n, i;
    if (this.setDocument(r), this.cssStyles.clear(), this.cssStyles.addStyles(this.constructor.commonStyles), "getStyles" in r)
      try {
        for (var o = b5(r.getStyles()), a = o.next(); !a.done; a = o.next()) {
          var T = a.value;
          this.cssStyles.addStyles(T);
        }
      } catch (Q) {
        n = { error: Q };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n)
            throw n.error;
        }
      }
    this.addWrapperStyles(this.cssStyles), this.addFontStyles(this.cssStyles);
    var s = this.html("style", { id: "MJX-styles" }, [this.text(`
` + this.cssStyles.cssText + `
`)]);
    return s;
  }, t.prototype.addFontStyles = function(r) {
    r.addStyles(this.font.styles);
  }, t.prototype.addWrapperStyles = function(r) {
    var n, i;
    try {
      for (var o = b5(this.factory.getKinds()), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        this.addClassStyles(this.factory.getNodeClass(T), r);
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
  }, t.prototype.addClassStyles = function(r, n) {
    n.addStyles(r.styles);
  }, t.prototype.setDocument = function(r) {
    r && (this.document = r, this.adaptor.document = r.document);
  }, t.prototype.html = function(r, n, i, o) {
    return n === void 0 && (n = {}), i === void 0 && (i = []), this.adaptor.node(r, n, i, o);
  }, t.prototype.text = function(r) {
    return this.adaptor.text(r);
  }, t.prototype.fixed = function(r, n) {
    return n === void 0 && (n = 3), Math.abs(r) < 6e-4 ? "0" : r.toFixed(n).replace(/\.?0+$/, "");
  }, t.prototype.measureText = function(r, n, i) {
    i === void 0 && (i = ["", !1, !1]);
    var o = this.unknownText(r, n);
    if (n === "-explicitFont") {
      var a = this.cssFontStyles(i);
      this.adaptor.setAttributes(o, { style: a });
    }
    return this.measureTextNodeWithCache(o, r, n, i);
  }, t.prototype.measureTextNodeWithCache = function(r, n, i, o) {
    o === void 0 && (o = ["", !1, !1]), i === "-explicitFont" && (i = [o[0], o[1] ? "T" : "F", o[2] ? "T" : "F", ""].join("-")), this.unknownCache.has(i) || this.unknownCache.set(i, /* @__PURE__ */ new Map());
    var a = this.unknownCache.get(i), T = a.get(n);
    if (T)
      return T;
    var s = this.measureTextNode(r);
    return a.set(n, s), s;
  }, t.prototype.measureXMLnode = function(r) {
    var n = this.adaptor, i = this.html("mjx-xml-block", { style: { display: "inline-block" } }, [n.clone(r)]), o = this.html("mjx-baseline", { style: { display: "inline-block", width: 0, height: 0 } }), a = {
      position: "absolute",
      display: "inline-block",
      "font-family": "initial",
      "line-height": "normal"
    }, T = this.html("mjx-measure-xml", { style: a }, [o, i]);
    n.append(n.parent(this.math.start.node), this.container), n.append(this.container, T);
    var s = this.math.metrics.em * this.math.metrics.scale, Q = n.nodeBBox(i), u = Q.left, l = Q.right, c = Q.bottom, f = Q.top, d = (l - u) / s, m = (n.nodeBBox(o).top - f) / s, p = (c - f) / s - m;
    return n.remove(this.container), n.remove(T), { w: d, h: m, d: p };
  }, t.prototype.cssFontStyles = function(r, n) {
    n === void 0 && (n = {});
    var i = uQ(r, 3), o = i[0], a = i[1], T = i[2];
    return n["font-family"] = this.font.getFamily(o), a && (n["font-style"] = "italic"), T && (n["font-weight"] = "bold"), n;
  }, t.prototype.getFontData = function(r) {
    return r || (r = new qL.Styles()), [
      this.font.getFamily(r.get("font-family")),
      r.get("font-style") === "italic",
      r.get("font-weight") === "bold"
    ];
  }, t.NAME = "Common", t.OPTIONS = a9(a9({}, tu.AbstractOutputJax.OPTIONS), { scale: 1, minScale: 0.5, mtextInheritFont: !1, merrorInheritFont: !1, mtextFont: "", merrorFont: "serif", mathmlSpacing: !1, skipAttributes: {}, exFactor: 0.5, displayAlign: "center", displayIndent: "0", wrapperFactory: null, font: null, cssStyles: null }), t.commonStyles = {}, t;
}(tu.AbstractOutputJax);
ti.CommonOutputJax = YL;
var $7 = {}, ni = {}, ii = {}, KL = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ey = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, ty = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(ii, "__esModule", { value: !0 });
ii.AbstractWrapperFactory = void 0;
var ry = I0, ny = function(e) {
  KL(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.wrap = function(r) {
    for (var n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    return this.create.apply(this, ty([r.kind, r], ey(n), !1));
  }, t;
}(ry.AbstractFactory);
ii.AbstractWrapperFactory = ny;
var iy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(ni, "__esModule", { value: !0 });
ni.CommonWrapperFactory = void 0;
var oy = ii, ay = function(e) {
  iy(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.jax = null, r;
  }
  return Object.defineProperty(t.prototype, "Wrappers", {
    get: function() {
      return this.node;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaultNodes = {}, t;
}(oy.AbstractWrapperFactory);
ni.CommonWrapperFactory = ay;
var Z7 = {}, W7 = {}, a6 = {};
Object.defineProperty(a6, "__esModule", { value: !0 });
a6.BBox = void 0;
var M5 = it, Qy = function() {
  function e(t) {
    t === void 0 && (t = { w: 0, h: -M5.BIGDIMEN, d: -M5.BIGDIMEN }), this.w = t.w || 0, this.h = "h" in t ? t.h : -M5.BIGDIMEN, this.d = "d" in t ? t.d : -M5.BIGDIMEN, this.L = this.R = this.ic = this.sk = this.dx = 0, this.scale = this.rscale = 1, this.pwidth = "";
  }
  return e.zero = function() {
    return new e({ h: 0, d: 0, w: 0 });
  }, e.empty = function() {
    return new e();
  }, e.prototype.empty = function() {
    return this.w = 0, this.h = this.d = -M5.BIGDIMEN, this;
  }, e.prototype.clean = function() {
    this.w === -M5.BIGDIMEN && (this.w = 0), this.h === -M5.BIGDIMEN && (this.h = 0), this.d === -M5.BIGDIMEN && (this.d = 0);
  }, e.prototype.rescale = function(t) {
    this.w *= t, this.h *= t, this.d *= t;
  }, e.prototype.combine = function(t, r, n) {
    r === void 0 && (r = 0), n === void 0 && (n = 0);
    var i = t.rscale, o = r + i * (t.w + t.L + t.R), a = n + i * t.h, T = i * t.d - n;
    o > this.w && (this.w = o), a > this.h && (this.h = a), T > this.d && (this.d = T);
  }, e.prototype.append = function(t) {
    var r = t.rscale;
    this.w += r * (t.w + t.L + t.R), r * t.h > this.h && (this.h = r * t.h), r * t.d > this.d && (this.d = r * t.d);
  }, e.prototype.updateFrom = function(t) {
    this.h = t.h, this.d = t.d, this.w = t.w, t.pwidth && (this.pwidth = t.pwidth);
  }, e.fullWidth = "100%", e.StyleAdjust = [
    ["borderTopWidth", "h"],
    ["borderRightWidth", "w"],
    ["borderBottomWidth", "d"],
    ["borderLeftWidth", "w", 0],
    ["paddingTop", "h"],
    ["paddingRight", "w"],
    ["paddingBottom", "d"],
    ["paddingLeft", "w", 0]
  ], e;
}();
a6.BBox = Qy;
var oi = {}, ai = {};
Object.defineProperty(ai, "__esModule", { value: !0 });
ai.AbstractWrapper = void 0;
var Ty = function() {
  function e(t, r) {
    this.factory = t, this.node = r;
  }
  return Object.defineProperty(e.prototype, "kind", {
    get: function() {
      return this.node.kind;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.wrap = function(t) {
    return this.factory.wrap(t);
  }, e;
}();
ai.AbstractWrapper = Ty;
var p4 = {}, Q9 = b && b.__assign || function() {
  return Q9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Q9.apply(this, arguments);
}, fQ = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, ru = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, i0 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(p4, "__esModule", { value: !0 });
p4.FontData = p4.NOSTRETCH = p4.H = p4.V = void 0;
var nu = r4;
p4.V = 1;
p4.H = 2;
p4.NOSTRETCH = { dir: 0 };
var sy = function() {
  function e(t) {
    var r, n, i, o;
    t === void 0 && (t = null), this.variant = {}, this.delimiters = {}, this.cssFontMap = {}, this.remapChars = {}, this.skewIcFactor = 0.75;
    var a = this.constructor;
    this.options = (0, nu.userOptions)((0, nu.defaultOptions)({}, a.OPTIONS), t), this.params = Q9({}, a.defaultParams), this.sizeVariants = ru([], fQ(a.defaultSizeVariants), !1), this.stretchVariants = ru([], fQ(a.defaultStretchVariants), !1), this.cssFontMap = Q9({}, a.defaultCssFonts);
    try {
      for (var T = i0(Object.keys(this.cssFontMap)), s = T.next(); !s.done; s = T.next()) {
        var Q = s.value;
        this.cssFontMap[Q][0] === "unknown" && (this.cssFontMap[Q][0] = this.options.unknownFamily);
      }
    } catch (f) {
      r = { error: f };
    } finally {
      try {
        s && !s.done && (n = T.return) && n.call(T);
      } finally {
        if (r)
          throw r.error;
      }
    }
    this.cssFamilyPrefix = a.defaultCssFamilyPrefix, this.createVariants(a.defaultVariants), this.defineDelimiters(a.defaultDelimiters);
    try {
      for (var u = i0(Object.keys(a.defaultChars)), l = u.next(); !l.done; l = u.next()) {
        var c = l.value;
        this.defineChars(c, a.defaultChars[c]);
      }
    } catch (f) {
      i = { error: f };
    } finally {
      try {
        l && !l.done && (o = u.return) && o.call(u);
      } finally {
        if (i)
          throw i.error;
      }
    }
    this.defineRemap("accent", a.defaultAccentMap), this.defineRemap("mo", a.defaultMoMap), this.defineRemap("mn", a.defaultMnMap);
  }
  return e.charOptions = function(t, r) {
    var n = t[r];
    return n.length === 3 && (n[3] = {}), n[3];
  }, Object.defineProperty(e.prototype, "styles", {
    get: function() {
      return this._styles;
    },
    set: function(t) {
      this._styles = t;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.createVariant = function(t, r, n) {
    r === void 0 && (r = null), n === void 0 && (n = null);
    var i = {
      linked: [],
      chars: r ? Object.create(this.variant[r].chars) : {}
    };
    n && this.variant[n] && (Object.assign(i.chars, this.variant[n].chars), this.variant[n].linked.push(i.chars), i.chars = Object.create(i.chars)), this.remapSmpChars(i.chars, t), this.variant[t] = i;
  }, e.prototype.remapSmpChars = function(t, r) {
    var n, i, o, a, T = this.constructor;
    if (T.VariantSmp[r]) {
      var s = T.SmpRemap, Q = [null, null, T.SmpRemapGreekU, T.SmpRemapGreekL];
      try {
        for (var u = i0(T.SmpRanges), l = u.next(); !l.done; l = u.next()) {
          var c = fQ(l.value, 3), f = c[0], d = c[1], m = c[2], p = T.VariantSmp[r][f];
          if (p) {
            for (var v = d; v <= m; v++)
              if (v !== 930) {
                var H = p + v - d;
                t[v] = this.smpChar(s[H] || H);
              }
            if (Q[f])
              try {
                for (var E = (o = void 0, i0(Object.keys(Q[f]).map(function(C) {
                  return parseInt(C);
                }))), M = E.next(); !M.done; M = E.next()) {
                  var v = M.value;
                  t[v] = this.smpChar(p + Q[f][v]);
                }
              } catch (C) {
                o = { error: C };
              } finally {
                try {
                  M && !M.done && (a = E.return) && a.call(E);
                } finally {
                  if (o)
                    throw o.error;
                }
              }
          }
        }
      } catch (C) {
        n = { error: C };
      } finally {
        try {
          l && !l.done && (i = u.return) && i.call(u);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }
    r === "bold" && (t[988] = this.smpChar(120778), t[989] = this.smpChar(120779));
  }, e.prototype.smpChar = function(t) {
    return [, , , { smp: t }];
  }, e.prototype.createVariants = function(t) {
    var r, n;
    try {
      for (var i = i0(t), o = i.next(); !o.done; o = i.next()) {
        var a = o.value;
        this.createVariant(a[0], a[1], a[2]);
      }
    } catch (T) {
      r = { error: T };
    } finally {
      try {
        o && !o.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, e.prototype.defineChars = function(t, r) {
    var n, i, o = this.variant[t];
    Object.assign(o.chars, r);
    try {
      for (var a = i0(o.linked), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        Object.assign(s, r);
      }
    } catch (Q) {
      n = { error: Q };
    } finally {
      try {
        T && !T.done && (i = a.return) && i.call(a);
      } finally {
        if (n)
          throw n.error;
      }
    }
  }, e.prototype.defineDelimiters = function(t) {
    Object.assign(this.delimiters, t);
  }, e.prototype.defineRemap = function(t, r) {
    this.remapChars.hasOwnProperty(t) || (this.remapChars[t] = {}), Object.assign(this.remapChars[t], r);
  }, e.prototype.getDelimiter = function(t) {
    return this.delimiters[t];
  }, e.prototype.getSizeVariant = function(t, r) {
    return this.delimiters[t].variants && (r = this.delimiters[t].variants[r]), this.sizeVariants[r];
  }, e.prototype.getStretchVariant = function(t, r) {
    return this.stretchVariants[this.delimiters[t].stretchv ? this.delimiters[t].stretchv[r] : 0];
  }, e.prototype.getChar = function(t, r) {
    return this.variant[t].chars[r];
  }, e.prototype.getVariant = function(t) {
    return this.variant[t];
  }, e.prototype.getCssFont = function(t) {
    return this.cssFontMap[t] || ["serif", !1, !1];
  }, e.prototype.getFamily = function(t) {
    return this.cssFamilyPrefix ? this.cssFamilyPrefix + ", " + t : t;
  }, e.prototype.getRemappedChar = function(t, r) {
    var n = this.remapChars[t] || {};
    return n[r];
  }, e.OPTIONS = {
    unknownFamily: "serif"
  }, e.JAX = "common", e.NAME = "", e.defaultVariants = [
    ["normal"],
    ["bold", "normal"],
    ["italic", "normal"],
    ["bold-italic", "italic", "bold"],
    ["double-struck", "bold"],
    ["fraktur", "normal"],
    ["bold-fraktur", "bold", "fraktur"],
    ["script", "italic"],
    ["bold-script", "bold-italic", "script"],
    ["sans-serif", "normal"],
    ["bold-sans-serif", "bold", "sans-serif"],
    ["sans-serif-italic", "italic", "sans-serif"],
    ["sans-serif-bold-italic", "bold-italic", "bold-sans-serif"],
    ["monospace", "normal"]
  ], e.defaultCssFonts = {
    normal: ["unknown", !1, !1],
    bold: ["unknown", !1, !0],
    italic: ["unknown", !0, !1],
    "bold-italic": ["unknown", !0, !0],
    "double-struck": ["unknown", !1, !0],
    fraktur: ["unknown", !1, !1],
    "bold-fraktur": ["unknown", !1, !0],
    script: ["cursive", !1, !1],
    "bold-script": ["cursive", !1, !0],
    "sans-serif": ["sans-serif", !1, !1],
    "bold-sans-serif": ["sans-serif", !1, !0],
    "sans-serif-italic": ["sans-serif", !0, !1],
    "sans-serif-bold-italic": ["sans-serif", !0, !0],
    monospace: ["monospace", !1, !1]
  }, e.defaultCssFamilyPrefix = "", e.VariantSmp = {
    bold: [119808, 119834, 120488, 120514, 120782],
    italic: [119860, 119886, 120546, 120572],
    "bold-italic": [119912, 119938, 120604, 120630],
    script: [119964, 119990],
    "bold-script": [120016, 120042],
    fraktur: [120068, 120094],
    "double-struck": [120120, 120146, , , 120792],
    "bold-fraktur": [120172, 120198],
    "sans-serif": [120224, 120250, , , 120802],
    "bold-sans-serif": [120276, 120302, 120662, 120688, 120812],
    "sans-serif-italic": [120328, 120354],
    "sans-serif-bold-italic": [120380, 120406, 120720, 120746],
    monospace: [120432, 120458, , , 120822]
  }, e.SmpRanges = [
    [0, 65, 90],
    [1, 97, 122],
    [2, 913, 937],
    [3, 945, 969],
    [4, 48, 57]
  ], e.SmpRemap = {
    119893: 8462,
    119965: 8492,
    119968: 8496,
    119969: 8497,
    119971: 8459,
    119972: 8464,
    119975: 8466,
    119976: 8499,
    119981: 8475,
    119994: 8495,
    119996: 8458,
    120004: 8500,
    120070: 8493,
    120075: 8460,
    120076: 8465,
    120085: 8476,
    120093: 8488,
    120122: 8450,
    120127: 8461,
    120133: 8469,
    120135: 8473,
    120136: 8474,
    120137: 8477,
    120145: 8484
  }, e.SmpRemapGreekU = {
    8711: 25,
    1012: 17
  }, e.SmpRemapGreekL = {
    977: 27,
    981: 29,
    982: 31,
    1008: 28,
    1009: 30,
    1013: 26,
    8706: 25
  }, e.defaultAccentMap = {
    768: "ˋ",
    769: "ˊ",
    770: "ˆ",
    771: "˜",
    772: "ˉ",
    774: "˘",
    775: "˙",
    776: "¨",
    778: "˚",
    780: "ˇ",
    8594: "⃗",
    8242: "'",
    8243: "''",
    8244: "'''",
    8245: "`",
    8246: "``",
    8247: "```",
    8279: "''''",
    8400: "↼",
    8401: "⇀",
    8406: "←",
    8417: "↔",
    8432: "*",
    8411: "...",
    8412: "....",
    8428: "⇁",
    8429: "↽",
    8430: "←",
    8431: "→"
  }, e.defaultMoMap = {
    45: "−"
  }, e.defaultMnMap = {
    45: "−"
  }, e.defaultParams = {
    x_height: 0.442,
    quad: 1,
    num1: 0.676,
    num2: 0.394,
    num3: 0.444,
    denom1: 0.686,
    denom2: 0.345,
    sup1: 0.413,
    sup2: 0.363,
    sup3: 0.289,
    sub1: 0.15,
    sub2: 0.247,
    sup_drop: 0.386,
    sub_drop: 0.05,
    delim1: 2.39,
    delim2: 1,
    axis_height: 0.25,
    rule_thickness: 0.06,
    big_op_spacing1: 0.111,
    big_op_spacing2: 0.167,
    big_op_spacing3: 0.2,
    big_op_spacing4: 0.6,
    big_op_spacing5: 0.1,
    surd_height: 0.075,
    scriptspace: 0.05,
    nulldelimiterspace: 0.12,
    delimiterfactor: 901,
    delimitershortfall: 0.3,
    min_rule_thickness: 1.25,
    separation_factor: 1.75,
    extra_ic: 0.033
  }, e.defaultDelimiters = {}, e.defaultChars = {}, e.defaultSizeVariants = [], e.defaultStretchVariants = [], e;
}();
p4.FontData = sy;
var ly = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), uy = b && b.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), cy = b && b.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), fy = b && b.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && uy(t, e, r);
  return cy(t, e), t;
}, Ln = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, iu = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, dy = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(oi, "__esModule", { value: !0 });
oi.CommonWrapper = void 0;
var hy = ai, ou = T2, py = Q3, G7 = fy(it), au = Wr, z7 = a6, Qu = p4, Tu = 2 / 18;
function su(e, t) {
  return e ? t < Tu ? 0 : Tu : t;
}
var my = function(e) {
  ly(t, e);
  function t(r, n, i) {
    i === void 0 && (i = null);
    var o = e.call(this, r, n) || this;
    return o.parent = null, o.removedStyles = null, o.styles = null, o.variant = "", o.bboxComputed = !1, o.stretch = Qu.NOSTRETCH, o.font = null, o.parent = i, o.font = r.jax.font, o.bbox = z7.BBox.zero(), o.getStyles(), o.getVariant(), o.getScale(), o.getSpace(), o.childNodes = n.childNodes.map(function(a) {
      var T = o.wrap(a);
      return T.bbox.pwidth && (n.notParent || n.isKind("math")) && (o.bbox.pwidth = z7.BBox.fullWidth), T;
    }), o;
  }
  return Object.defineProperty(t.prototype, "jax", {
    get: function() {
      return this.factory.jax;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "adaptor", {
    get: function() {
      return this.factory.jax.adaptor;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "metrics", {
    get: function() {
      return this.factory.jax.math.metrics;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "fixesPWidth", {
    get: function() {
      return !this.node.notParent && !this.node.isToken;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.wrap = function(r, n) {
    n === void 0 && (n = null);
    var i = this.factory.wrap(r, n || this);
    return n && n.childNodes.push(i), this.jax.nodeMap.set(r, i), i;
  }, t.prototype.getBBox = function(r) {
    if (r === void 0 && (r = !0), this.bboxComputed)
      return this.bbox;
    var n = r ? this.bbox : z7.BBox.zero();
    return this.computeBBox(n), this.bboxComputed = r, n;
  }, t.prototype.getOuterBBox = function(r) {
    var n, i;
    r === void 0 && (r = !0);
    var o = this.getBBox(r);
    if (!this.styles)
      return o;
    var a = new z7.BBox();
    Object.assign(a, o);
    try {
      for (var T = Ln(z7.BBox.StyleAdjust), s = T.next(); !s.done; s = T.next()) {
        var Q = iu(s.value, 2), u = Q[0], l = Q[1], c = this.styles.get(u);
        c && (a[l] += this.length2em(c, 1, a.rscale));
      }
    } catch (f) {
      n = { error: f };
    } finally {
      try {
        s && !s.done && (i = T.return) && i.call(T);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return a;
  }, t.prototype.computeBBox = function(r, n) {
    var i, o;
    n === void 0 && (n = !1), r.empty();
    try {
      for (var a = Ln(this.childNodes), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        r.append(s.getOuterBBox());
      }
    } catch (Q) {
      i = { error: Q };
    } finally {
      try {
        T && !T.done && (o = a.return) && o.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
    r.clean(), this.fixesPWidth && this.setChildPWidths(n) && this.computeBBox(r, !0);
  }, t.prototype.setChildPWidths = function(r, n, i) {
    var o, a;
    if (n === void 0 && (n = null), i === void 0 && (i = !0), r)
      return !1;
    i && (this.bbox.pwidth = "");
    var T = !1;
    try {
      for (var s = Ln(this.childNodes), Q = s.next(); !Q.done; Q = s.next()) {
        var u = Q.value, l = u.getOuterBBox();
        l.pwidth && u.setChildPWidths(r, n === null ? l.w : n, i) && (T = !0);
      }
    } catch (c) {
      o = { error: c };
    } finally {
      try {
        Q && !Q.done && (a = s.return) && a.call(s);
      } finally {
        if (o)
          throw o.error;
      }
    }
    return T;
  }, t.prototype.invalidateBBox = function() {
    this.bboxComputed && (this.bboxComputed = !1, this.parent && this.parent.invalidateBBox());
  }, t.prototype.copySkewIC = function(r) {
    var n = this.childNodes[0];
    n != null && n.bbox.sk && (r.sk = n.bbox.sk), n != null && n.bbox.dx && (r.dx = n.bbox.dx);
    var i = this.childNodes[this.childNodes.length - 1];
    i != null && i.bbox.ic && (r.ic = i.bbox.ic, r.w += r.ic);
  }, t.prototype.getStyles = function() {
    var r = this.node.attributes.getExplicit("style");
    if (r)
      for (var n = this.styles = new au.Styles(r), i = 0, o = t.removeStyles.length; i < o; i++) {
        var a = t.removeStyles[i];
        n.get(a) && (this.removedStyles || (this.removedStyles = {}), this.removedStyles[a] = n.get(a), n.set(a, ""));
      }
  }, t.prototype.getVariant = function() {
    if (this.node.isToken) {
      var r = this.node.attributes, n = r.get("mathvariant");
      if (!r.getExplicit("mathvariant")) {
        var i = r.getList("fontfamily", "fontweight", "fontstyle");
        if (this.removedStyles) {
          var o = this.removedStyles;
          o.fontFamily && (i.family = o.fontFamily), o.fontWeight && (i.weight = o.fontWeight), o.fontStyle && (i.style = o.fontStyle);
        }
        i.fontfamily && (i.family = i.fontfamily), i.fontweight && (i.weight = i.fontweight), i.fontstyle && (i.style = i.fontstyle), i.weight && i.weight.match(/^\d+$/) && (i.weight = parseInt(i.weight) > 600 ? "bold" : "normal"), i.family ? n = this.explicitVariant(i.family, i.weight, i.style) : (this.node.getProperty("variantForm") && (n = "-tex-variant"), n = (t.BOLDVARIANTS[i.weight] || {})[n] || n, n = (t.ITALICVARIANTS[i.style] || {})[n] || n);
      }
      this.variant = n;
    }
  }, t.prototype.explicitVariant = function(r, n, i) {
    var o = this.styles;
    return o || (o = this.styles = new au.Styles()), o.set("fontFamily", r), n && o.set("fontWeight", n), i && o.set("fontStyle", i), "-explicitFont";
  }, t.prototype.getScale = function() {
    var r = 1, n = this.parent, i = n ? n.bbox.scale : 1, o = this.node.attributes, a = Math.min(o.get("scriptlevel"), 2), T = o.get("fontsize"), s = this.node.isToken || this.node.isKind("mstyle") ? o.get("mathsize") : o.getInherited("mathsize");
    if (a !== 0) {
      r = Math.pow(o.get("scriptsizemultiplier"), a);
      var Q = this.length2em(o.get("scriptminsize"), 0.8, 1);
      r < Q && (r = Q);
    }
    this.removedStyles && this.removedStyles.fontSize && !T && (T = this.removedStyles.fontSize), T && !o.getExplicit("mathsize") && (s = T), s !== "1" && (r *= this.length2em(s, 1, 1)), this.bbox.scale = r, this.bbox.rscale = r / i;
  }, t.prototype.getSpace = function() {
    var r = this.isTopEmbellished(), n = this.node.hasSpacingAttributes();
    this.jax.options.mathmlSpacing || n ? r && this.getMathMLSpacing() : this.getTeXSpacing(r, n);
  }, t.prototype.getMathMLSpacing = function() {
    var r = this.node.coreMO(), n = r.coreParent(), i = n.parent;
    if (!(!i || !i.isKind("mrow") || i.childNodes.length === 1)) {
      var o = r.attributes, a = o.get("scriptlevel") > 0;
      this.bbox.L = o.isSet("lspace") ? Math.max(0, this.length2em(o.get("lspace"))) : su(a, r.lspace), this.bbox.R = o.isSet("rspace") ? Math.max(0, this.length2em(o.get("rspace"))) : su(a, r.rspace);
      var T = i.childIndex(n);
      if (T !== 0) {
        var s = i.childNodes[T - 1];
        if (s.isEmbellished) {
          var Q = this.jax.nodeMap.get(s).getBBox();
          Q.R && (this.bbox.L = Math.max(0, this.bbox.L - Q.R));
        }
      }
    }
  }, t.prototype.getTeXSpacing = function(r, n) {
    if (!n) {
      var i = this.node.texSpacing();
      i && (this.bbox.L = this.length2em(i));
    }
    if (r || n) {
      var o = this.node.coreMO().attributes;
      o.isSet("lspace") && (this.bbox.L = Math.max(0, this.length2em(o.get("lspace")))), o.isSet("rspace") && (this.bbox.R = Math.max(0, this.length2em(o.get("rspace"))));
    }
  }, t.prototype.isTopEmbellished = function() {
    return this.node.isEmbellished && !(this.node.parent && this.node.parent.isEmbellished);
  }, t.prototype.core = function() {
    return this.jax.nodeMap.get(this.node.core());
  }, t.prototype.coreMO = function() {
    return this.jax.nodeMap.get(this.node.coreMO());
  }, t.prototype.getText = function() {
    var r, n, i = "";
    if (this.node.isToken)
      try {
        for (var o = Ln(this.node.childNodes), a = o.next(); !a.done; a = o.next()) {
          var T = a.value;
          T instanceof ou.TextNode && (i += T.getText());
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r)
            throw r.error;
        }
      }
    return i;
  }, t.prototype.canStretch = function(r) {
    if (this.stretch = Qu.NOSTRETCH, this.node.isEmbellished) {
      var n = this.core();
      n && n.node !== this.node && n.canStretch(r) && (this.stretch = n.stretch);
    }
    return this.stretch.dir !== 0;
  }, t.prototype.getAlignShift = function() {
    var r, n = (r = this.node.attributes).getList.apply(r, dy([], iu(ou.indentAttributes), !1)), i = n.indentalign, o = n.indentshift, a = n.indentalignfirst, T = n.indentshiftfirst;
    a !== "indentalign" && (i = a), i === "auto" && (i = this.jax.options.displayAlign), T !== "indentshift" && (o = T), o === "auto" && (o = this.jax.options.displayIndent, i === "right" && !o.match(/^\s*0[a-z]*\s*$/) && (o = ("-" + o.trim()).replace(/^--/, "")));
    var s = this.length2em(o, this.metrics.containerWidth);
    return [i, s];
  }, t.prototype.getAlignX = function(r, n, i) {
    return i === "right" ? r - (n.w + n.R) * n.rscale : i === "left" ? n.L * n.rscale : (r - n.w * n.rscale) / 2;
  }, t.prototype.getAlignY = function(r, n, i, o, a) {
    return a === "top" ? r - i : a === "bottom" ? o - n : a === "center" ? (r - i - (n - o)) / 2 : 0;
  }, t.prototype.getWrapWidth = function(r) {
    return this.childNodes[r].getBBox().w;
  }, t.prototype.getChildAlign = function(r) {
    return "left";
  }, t.prototype.percent = function(r) {
    return G7.percent(r);
  }, t.prototype.em = function(r) {
    return G7.em(r);
  }, t.prototype.px = function(r, n) {
    return n === void 0 && (n = -G7.BIGDIMEN), G7.px(r, n, this.metrics.em);
  }, t.prototype.length2em = function(r, n, i) {
    return n === void 0 && (n = 1), i === void 0 && (i = null), i === null && (i = this.bbox.scale), G7.length2em(r, n, i, this.jax.pxPerEm);
  }, t.prototype.unicodeChars = function(r, n) {
    n === void 0 && (n = this.variant);
    var i = (0, py.unicodeChars)(r), o = this.font.getVariant(n);
    if (o && o.chars) {
      var a = o.chars;
      i = i.map(function(T) {
        return ((a[T] || [])[3] || {}).smp || T;
      });
    }
    return i;
  }, t.prototype.remapChars = function(r) {
    return r;
  }, t.prototype.mmlText = function(r) {
    return this.node.factory.create("text").setText(r);
  }, t.prototype.mmlNode = function(r, n, i) {
    return n === void 0 && (n = {}), i === void 0 && (i = []), this.node.factory.create(r, n, i);
  }, t.prototype.createMo = function(r) {
    var n = this.node.factory, i = n.create("text").setText(r), o = n.create("mo", { stretchy: !0 }, [i]);
    o.inheritAttributesFrom(this.node);
    var a = this.wrap(o);
    return a.parent = this, a;
  }, t.prototype.getVariantChar = function(r, n) {
    var i = this.font.getChar(r, n) || [0, 0, 0, { unknown: !0 }];
    return i.length === 3 && (i[3] = {}), i;
  }, t.kind = "unknown", t.styles = {}, t.removeStyles = [
    "fontSize",
    "fontFamily",
    "fontWeight",
    "fontStyle",
    "fontVariant",
    "font"
  ], t.skipAttributes = {
    fontfamily: !0,
    fontsize: !0,
    fontweight: !0,
    fontstyle: !0,
    color: !0,
    background: !0,
    class: !0,
    href: !0,
    style: !0,
    xmlns: !0
  }, t.BOLDVARIANTS = {
    bold: {
      normal: "bold",
      italic: "bold-italic",
      fraktur: "bold-fraktur",
      script: "bold-script",
      "sans-serif": "bold-sans-serif",
      "sans-serif-italic": "sans-serif-bold-italic"
    },
    normal: {
      bold: "normal",
      "bold-italic": "italic",
      "bold-fraktur": "fraktur",
      "bold-script": "script",
      "bold-sans-serif": "sans-serif",
      "sans-serif-bold-italic": "sans-serif-italic"
    }
  }, t.ITALICVARIANTS = {
    italic: {
      normal: "italic",
      bold: "bold-italic",
      "sans-serif": "sans-serif-italic",
      "bold-sans-serif": "sans-serif-bold-italic"
    },
    normal: {
      italic: "normal",
      "bold-italic": "bold",
      "sans-serif-italic": "sans-serif",
      "sans-serif-bold-italic": "bold-sans-serif"
    }
  }, t;
}(hy.AbstractWrapper);
oi.CommonWrapper = my;
var lu;
function a3() {
  if (lu)
    return W7;
  lu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var T = function(s, Q) {
      return T = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, l) {
        u.__proto__ = l;
      } || function(u, l) {
        for (var c in l)
          Object.prototype.hasOwnProperty.call(l, c) && (u[c] = l[c]);
      }, T(s, Q);
    };
    return function(s, Q) {
      if (typeof Q != "function" && Q !== null)
        throw new TypeError("Class extends value " + String(Q) + " is not a constructor or null");
      T(s, Q);
      function u() {
        this.constructor = s;
      }
      s.prototype = Q === null ? Object.create(Q) : (u.prototype = Q.prototype, new u());
    };
  }(), t = b && b.__values || function(T) {
    var s = typeof Symbol == "function" && Symbol.iterator, Q = s && T[s], u = 0;
    if (Q)
      return Q.call(T);
    if (T && typeof T.length == "number")
      return {
        next: function() {
          return T && u >= T.length && (T = void 0), { value: T && T[u++], done: !T };
        }
      };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = b && b.__read || function(T, s) {
    var Q = typeof Symbol == "function" && T[Symbol.iterator];
    if (!Q)
      return T;
    var u = Q.call(T), l, c = [], f;
    try {
      for (; (s === void 0 || s-- > 0) && !(l = u.next()).done; )
        c.push(l.value);
    } catch (d) {
      f = { error: d };
    } finally {
      try {
        l && !l.done && (Q = u.return) && Q.call(u);
      } finally {
        if (f)
          throw f.error;
      }
    }
    return c;
  };
  Object.defineProperty(W7, "__esModule", { value: !0 }), W7.SVGWrapper = void 0;
  var n = a6, i = oi, o = Qh(), a = function(T) {
    e(s, T);
    function s() {
      var Q = T !== null && T.apply(this, arguments) || this;
      return Q.element = null, Q.dx = 0, Q;
    }
    return s.prototype.toSVG = function(Q) {
      this.addChildren(this.standardSVGnode(Q));
    }, s.prototype.addChildren = function(Q) {
      var u, l, c = 0;
      try {
        for (var f = t(this.childNodes), d = f.next(); !d.done; d = f.next()) {
          var m = d.value;
          m.toSVG(Q);
          var p = m.getOuterBBox();
          m.element && m.place(c + p.L * p.rscale, 0), c += (p.L + p.w + p.R) * p.rscale;
        }
      } catch (v) {
        u = { error: v };
      } finally {
        try {
          d && !d.done && (l = f.return) && l.call(f);
        } finally {
          if (u)
            throw u.error;
        }
      }
    }, s.prototype.standardSVGnode = function(Q) {
      var u = this.createSVGnode(Q);
      return this.handleStyles(), this.handleScale(), this.handleBorder(), this.handleColor(), this.handleAttributes(), u;
    }, s.prototype.createSVGnode = function(Q) {
      this.element = this.svg("g", { "data-mml-node": this.node.kind });
      var u = this.node.attributes.get("href");
      if (u) {
        Q = this.adaptor.append(Q, this.svg("a", { href: u }));
        var l = this.getOuterBBox(), c = l.h, f = l.d, d = l.w;
        this.adaptor.append(this.element, this.svg("rect", {
          "data-hitbox": !0,
          fill: "none",
          stroke: "none",
          "pointer-events": "all",
          width: this.fixed(d),
          height: this.fixed(c + f),
          y: this.fixed(-f)
        }));
      }
      return this.adaptor.append(Q, this.element), this.element;
    }, s.prototype.handleStyles = function() {
      var Q = this;
      if (this.styles) {
        var u = this.styles.cssText;
        u && this.adaptor.setAttribute(this.element, "style", u), n.BBox.StyleAdjust.forEach(function(l) {
          var c = r(l, 3), f = c[0], d = c[2];
          if (d === 0) {
            var m = Q.styles.get(f);
            m && (Q.dx += Q.length2em(m, 1, Q.bbox.rscale));
          }
        });
      }
    }, s.prototype.handleScale = function() {
      if (this.bbox.rscale !== 1) {
        var Q = "scale(" + this.fixed(this.bbox.rscale / 1e3, 3) + ")";
        this.adaptor.setAttribute(this.element, "transform", Q);
      }
    }, s.prototype.handleColor = function() {
      var Q, u = this.adaptor, l = this.node.attributes, c = l.getExplicit("mathcolor"), f = l.getExplicit("color"), d = l.getExplicit("mathbackground"), m = l.getExplicit("background"), p = ((Q = this.styles) === null || Q === void 0 ? void 0 : Q.get("background-color")) || "";
      if ((c || f) && (u.setAttribute(this.element, "fill", c || f), u.setAttribute(this.element, "stroke", c || f)), d || m || p) {
        var v = this.getOuterBBox(), H = v.h, E = v.d, M = v.w, C = this.svg("rect", {
          fill: d || m || p,
          x: this.fixed(-this.dx),
          y: this.fixed(-E),
          width: this.fixed(M),
          height: this.fixed(H + E),
          "data-bgcolor": !0
        }), w = u.firstChild(this.element);
        w ? u.insert(C, w) : u.append(this.element, C);
      }
    }, s.prototype.handleBorder = function() {
      var Q, u, l, c;
      if (this.styles) {
        var f = Array(4).fill(0), d = Array(4), m = Array(4);
        try {
          for (var p = t([["Top", 0], ["Right", 1], ["Bottom", 2], ["Left", 3]]), v = p.next(); !v.done; v = p.next()) {
            var H = r(v.value, 2), E = H[0], M = H[1], C = "border" + E, w = this.styles.get(C + "Width");
            w && (f[M] = Math.max(0, this.length2em(w, 1, this.bbox.rscale)), d[M] = this.styles.get(C + "Style") || "solid", m[M] = this.styles.get(C + "Color") || "currentColor");
          }
        } catch (l1) {
          Q = { error: l1 };
        } finally {
          try {
            v && !v.done && (u = p.return) && u.call(p);
          } finally {
            if (Q)
              throw Q.error;
          }
        }
        var S = s.borderFuzz, D = this.getOuterBBox(), k = r([D.h + S, D.d + S, D.w + S], 3), $ = k[0], z = k[1], j = k[2], J = [j, $], i1 = [-S, $], t1 = [j, -z], T1 = [-S, -z], X = [j - f[1], $ - f[0]], f1 = [-S + f[3], $ - f[0]], s1 = [j - f[1], -z + f[2]], Z = [-S + f[3], -z + f[2]], L1 = [
          [i1, J, X, f1],
          [t1, J, X, s1],
          [T1, t1, s1, Z],
          [T1, i1, f1, Z]
        ], C1 = this.adaptor, q = C1.firstChild(this.element);
        try {
          for (var N1 = t([0, 1, 2, 3]), O1 = N1.next(); !O1.done; O1 = N1.next()) {
            var M = O1.value;
            if (f[M]) {
              var x1 = L1[M];
              d[M] === "dashed" || d[M] === "dotted" ? this.addBorderBroken(x1, m[M], d[M], f[M], M) : this.addBorderSolid(x1, m[M], q);
            }
          }
        } catch (l1) {
          l = { error: l1 };
        } finally {
          try {
            O1 && !O1.done && (c = N1.return) && c.call(N1);
          } finally {
            if (l)
              throw l.error;
          }
        }
      }
    }, s.prototype.addBorderSolid = function(Q, u, l) {
      var c = this, f = this.svg("polygon", {
        points: Q.map(function(d) {
          var m = r(d, 2), p = m[0], v = m[1];
          return "".concat(c.fixed(p - c.dx), ",").concat(c.fixed(v));
        }).join(" "),
        stroke: "none",
        fill: u
      });
      l ? this.adaptor.insert(f, l) : this.adaptor.append(this.element, f);
    }, s.prototype.addBorderBroken = function(Q, u, l, c, f) {
      var d = l === "dotted", m = c / 2, p = r([[m, -m, -m, -m], [-m, m, -m, -m], [m, m, -m, m], [m, m, m, -m]][f], 4), v = p[0], H = p[1], E = p[2], M = p[3], C = r(Q, 2), w = C[0], S = C[1], D = w[0] + v - this.dx, k = w[1] + H, $ = S[0] + E - this.dx, z = S[1] + M, j = Math.abs(f % 2 ? z - k : $ - D), J = Math.ceil(d ? j / (2 * c) : (j - c) / (4 * c)), i1 = j / (4 * J + 1), t1 = this.svg("line", {
        x1: this.fixed(D),
        y1: this.fixed(k),
        x2: this.fixed($),
        y2: this.fixed(z),
        "stroke-width": this.fixed(c),
        stroke: u,
        "stroke-linecap": d ? "round" : "square",
        "stroke-dasharray": d ? [1, this.fixed(j / J - 2e-3)].join(" ") : [this.fixed(i1), this.fixed(3 * i1)].join(" ")
      }), T1 = this.adaptor, X = T1.firstChild(this.element);
      X ? T1.insert(t1, X) : T1.append(this.element, t1);
    }, s.prototype.handleAttributes = function() {
      var Q, u, l, c, f = this.node.attributes, d = f.getAllDefaults(), m = s.skipAttributes;
      try {
        for (var p = t(f.getExplicitNames()), v = p.next(); !v.done; v = p.next()) {
          var H = v.value;
          (m[H] === !1 || !(H in d) && !m[H] && !this.adaptor.hasAttribute(this.element, H)) && this.adaptor.setAttribute(this.element, H, f.getExplicit(H));
        }
      } catch (S) {
        Q = { error: S };
      } finally {
        try {
          v && !v.done && (u = p.return) && u.call(p);
        } finally {
          if (Q)
            throw Q.error;
        }
      }
      if (f.get("class")) {
        var E = f.get("class").trim().split(/ +/);
        try {
          for (var M = t(E), C = M.next(); !C.done; C = M.next()) {
            var w = C.value;
            this.adaptor.addClass(this.element, w);
          }
        } catch (S) {
          l = { error: S };
        } finally {
          try {
            C && !C.done && (c = M.return) && c.call(M);
          } finally {
            if (l)
              throw l.error;
          }
        }
      }
    }, s.prototype.place = function(Q, u, l) {
      if (l === void 0 && (l = null), Q += this.dx, !!(Q || u)) {
        l || (l = this.element, u = this.handleId(u));
        var c = "translate(".concat(this.fixed(Q), ",").concat(this.fixed(u), ")"), f = this.adaptor.getAttribute(l, "transform") || "";
        this.adaptor.setAttribute(l, "transform", c + (f ? " " + f : ""));
      }
    }, s.prototype.handleId = function(Q) {
      if (!this.node.attributes || !this.node.attributes.get("id"))
        return Q;
      var u = this.adaptor, l = this.getBBox().h, c = u.childNodes(this.element);
      c.forEach(function(d) {
        return u.remove(d);
      });
      var f = this.svg("g", { "data-idbox": !0, transform: "translate(0,".concat(this.fixed(-l), ")") }, c);
      return u.append(this.element, this.svg("text", { "data-id-align": !0 }, [this.text("")])), u.append(this.element, f), Q + l;
    }, s.prototype.firstChild = function() {
      var Q = this.adaptor, u = Q.firstChild(this.element);
      return u && Q.kind(u) === "text" && Q.getAttribute(u, "data-id-align") && (u = Q.firstChild(Q.next(u))), u && Q.kind(u) === "rect" && Q.getAttribute(u, "data-hitbox") && (u = Q.next(u)), u;
    }, s.prototype.placeChar = function(Q, u, l, c, f) {
      var d, m;
      f === void 0 && (f = null), f === null && (f = this.variant);
      var p = Q.toString(16).toUpperCase(), v = r(this.getVariantChar(f, Q), 4), H = v[2], E = v[3];
      if ("p" in E) {
        var M = E.p ? "M" + E.p + "Z" : "";
        this.place(u, l, this.adaptor.append(c, this.charNode(f, p, M)));
      } else if ("c" in E) {
        var C = this.adaptor.append(c, this.svg("g", { "data-c": p }));
        this.place(u, l, C), u = 0;
        try {
          for (var w = t(this.unicodeChars(E.c, f)), S = w.next(); !S.done; S = w.next()) {
            var D = S.value;
            u += this.placeChar(D, u, l, C, f);
          }
        } catch (z) {
          d = { error: z };
        } finally {
          try {
            S && !S.done && (m = w.return) && m.call(w);
          } finally {
            if (d)
              throw d.error;
          }
        }
      } else if (E.unknown) {
        var k = String.fromCodePoint(Q), $ = this.adaptor.append(c, this.jax.unknownText(k, f));
        return this.place(u, l, $), this.jax.measureTextNodeWithCache($, k, f).w;
      }
      return H;
    }, s.prototype.charNode = function(Q, u, l) {
      var c = this.jax.options.fontCache;
      return c !== "none" ? this.useNode(Q, u, l) : this.pathNode(u, l);
    }, s.prototype.pathNode = function(Q, u) {
      return this.svg("path", { "data-c": Q, d: u });
    }, s.prototype.useNode = function(Q, u, l) {
      var c = this.svg("use", { "data-c": u }), f = "#" + this.jax.fontCache.cachePath(Q, u, l);
      return this.adaptor.setAttribute(c, "href", f, o.XLINKNS), c;
    }, s.prototype.drawBBox = function() {
      var Q = this.getBBox(), u = Q.w, l = Q.h, c = Q.d, f = this.svg("g", { style: {
        opacity: 0.25
      } }, [
        this.svg("rect", {
          fill: "red",
          height: this.fixed(l),
          width: this.fixed(u)
        }),
        this.svg("rect", {
          fill: "green",
          height: this.fixed(c),
          width: this.fixed(u),
          y: this.fixed(-c)
        })
      ]), d = this.element || this.parent.element;
      this.adaptor.append(d, f);
    }, s.prototype.html = function(Q, u, l) {
      return u === void 0 && (u = {}), l === void 0 && (l = []), this.jax.html(Q, u, l);
    }, s.prototype.svg = function(Q, u, l) {
      return u === void 0 && (u = {}), l === void 0 && (l = []), this.jax.svg(Q, u, l);
    }, s.prototype.text = function(Q) {
      return this.jax.text(Q);
    }, s.prototype.fixed = function(Q, u) {
      return u === void 0 && (u = 1), this.jax.fixed(Q * 1e3, u);
    }, s.kind = "unknown", s.borderFuzz = 5e-3, s;
  }(i.CommonWrapper);
  return W7.SVGWrapper = a, W7;
}
var U7 = {}, Qi = {}, vy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Qi, "__esModule", { value: !0 });
Qi.CommonMathMixin = void 0;
function Ly(e) {
  return function(t) {
    vy(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.getWrapWidth = function(n) {
      return this.parent ? this.getBBox().w : this.metrics.containerWidth / this.jax.pxPerEm;
    }, r;
  }(e);
}
Qi.CommonMathMixin = Ly;
var Gr = {}, yy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), T9 = b && b.__assign || function() {
  return T9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, T9.apply(this, arguments);
};
Object.defineProperty(Gr, "__esModule", { value: !0 });
Gr.MmlMath = void 0;
var uu = T2, gy = function(e) {
  yy(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "math";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    this.attributes.get("mode") === "display" && this.attributes.setInherited("display", "block"), r = this.addInheritedAttributes(r, this.attributes.getAllAttributes()), n = !!this.attributes.get("displaystyle") || !this.attributes.get("displaystyle") && this.attributes.get("display") === "block", this.attributes.setInherited("displaystyle", n), i = this.attributes.get("scriptlevel") || this.constructor.defaults.scriptlevel, e.prototype.setChildInheritedAttributes.call(this, r, n, i, o);
  }, t.defaults = T9(T9({}, uu.AbstractMmlLayoutNode.defaults), { mathvariant: "normal", mathsize: "normal", mathcolor: "", mathbackground: "transparent", dir: "ltr", scriptlevel: 0, displaystyle: !1, display: "inline", maxwidth: "", overflow: "linebreak", altimg: "", "altimg-width": "", "altimg-height": "", "altimg-valign": "", alttext: "", cdgroup: "", scriptsizemultiplier: 1 / Math.sqrt(2), scriptminsize: "8px", infixlinebreakstyle: "before", lineleading: "1ex", linebreakmultchar: "⁢", indentshift: "auto", indentalign: "auto", indenttarget: "", indentalignfirst: "indentalign", indentshiftfirst: "indentshift", indentalignlast: "indentalign", indentshiftlast: "indentshift" }), t;
}(uu.AbstractMmlLayoutNode);
Gr.MmlMath = gy;
var cu;
function xy() {
  if (cu)
    return U7;
  cu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var s = function(Q, u) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var f in c)
          Object.prototype.hasOwnProperty.call(c, f) && (l[f] = c[f]);
      }, s(Q, u);
    };
    return function(Q, u) {
      if (typeof u != "function" && u !== null)
        throw new TypeError("Class extends value " + String(u) + " is not a constructor or null");
      s(Q, u);
      function l() {
        this.constructor = Q;
      }
      Q.prototype = u === null ? Object.create(u) : (l.prototype = u.prototype, new l());
    };
  }(), t = b && b.__read || function(s, Q) {
    var u = typeof Symbol == "function" && s[Symbol.iterator];
    if (!u)
      return s;
    var l = u.call(s), c, f = [], d;
    try {
      for (; (Q === void 0 || Q-- > 0) && !(c = l.next()).done; )
        f.push(c.value);
    } catch (m) {
      d = { error: m };
    } finally {
      try {
        c && !c.done && (u = l.return) && u.call(l);
      } finally {
        if (d)
          throw d.error;
      }
    }
    return f;
  }, r = b && b.__values || function(s) {
    var Q = typeof Symbol == "function" && Symbol.iterator, u = Q && s[Q], l = 0;
    if (u)
      return u.call(s);
    if (s && typeof s.length == "number")
      return {
        next: function() {
          return s && l >= s.length && (s = void 0), { value: s && s[l++], done: !s };
        }
      };
    throw new TypeError(Q ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(U7, "__esModule", { value: !0 }), U7.SVGmath = void 0;
  var n = a3(), i = Qi, o = Gr, a = a6, T = function(s) {
    e(Q, s);
    function Q() {
      return s !== null && s.apply(this, arguments) || this;
    }
    return Q.prototype.toSVG = function(u) {
      s.prototype.toSVG.call(this, u);
      var l = this.adaptor, c = this.node.attributes.get("display") === "block";
      c && (l.setAttribute(this.jax.container, "display", "true"), this.handleDisplay()), this.jax.document.options.internalSpeechTitles && this.handleSpeech();
    }, Q.prototype.handleDisplay = function() {
      var u = t(this.getAlignShift(), 2), l = u[0], c = u[1];
      if (l !== "center" && this.adaptor.setAttribute(this.jax.container, "justify", l), this.bbox.pwidth === a.BBox.fullWidth) {
        if (this.adaptor.setAttribute(this.jax.container, "width", "full"), this.jax.table) {
          var f = this.jax.table.getOuterBBox(), d = f.L, m = f.w, p = f.R;
          l === "right" ? p = Math.max(p || -c, -c) : l === "left" ? d = Math.max(d || c, c) : l === "center" && (m += 2 * Math.abs(c)), this.jax.minwidth = Math.max(0, d + m + p);
        }
      } else
        this.jax.shift = c;
    }, Q.prototype.handleSpeech = function() {
      var u, l, c = this.adaptor, f = this.node.attributes, d = f.get("aria-label") || f.get("data-semantic-speech");
      if (d) {
        var m = this.getTitleID(), p = this.svg("title", { id: m }, [this.text(d)]);
        c.insert(p, c.firstChild(this.element)), c.setAttribute(this.element, "aria-labeledby", m), c.removeAttribute(this.element, "aria-label");
        try {
          for (var v = r(this.childNodes[0].childNodes), H = v.next(); !H.done; H = v.next()) {
            var E = H.value;
            c.setAttribute(E.element, "aria-hidden", "true");
          }
        } catch (M) {
          u = { error: M };
        } finally {
          try {
            H && !H.done && (l = v.return) && l.call(v);
          } finally {
            if (u)
              throw u.error;
          }
        }
      }
    }, Q.prototype.getTitleID = function() {
      return "mjx-svg-title-" + String(this.jax.options.titleID++);
    }, Q.prototype.setChildPWidths = function(u, l, c) {
      return l === void 0 && (l = null), s.prototype.setChildPWidths.call(this, u, this.parent ? l : this.metrics.containerWidth / this.jax.pxPerEm, !1);
    }, Q.kind = o.MmlMath.prototype.kind, Q.styles = {
      'mjx-container[jax="SVG"][display="true"]': {
        display: "block",
        "text-align": "center",
        margin: "1em 0"
      },
      'mjx-container[jax="SVG"][display="true"][width="full"]': {
        display: "flex"
      },
      'mjx-container[jax="SVG"][justify="left"]': {
        "text-align": "left"
      },
      'mjx-container[jax="SVG"][justify="right"]': {
        "text-align": "right"
      }
    }, Q;
  }((0, i.CommonMathMixin)(n.SVGWrapper));
  return U7.SVGmath = T, U7;
}
var we = {}, ze = {}, Ud = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Hy = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Ey = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, yn = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(ze, "__esModule", { value: !0 });
ze.CommonInferredMrowMixin = ze.CommonMrowMixin = void 0;
var by = a6;
function My(e) {
  return function(t) {
    Ud(r, t);
    function r() {
      for (var n, i, o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      var T = t.apply(this, Ey([], Hy(o), !1)) || this;
      T.stretchChildren();
      try {
        for (var s = yn(T.childNodes), Q = s.next(); !Q.done; Q = s.next()) {
          var u = Q.value;
          if (u.bbox.pwidth) {
            T.bbox.pwidth = by.BBox.fullWidth;
            break;
          }
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          Q && !Q.done && (i = s.return) && i.call(s);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return T;
    }
    return Object.defineProperty(r.prototype, "fixesPWidth", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.stretchChildren = function() {
      var n, i, o, a, T, s, Q = [];
      try {
        for (var u = yn(this.childNodes), l = u.next(); !l.done; l = u.next()) {
          var c = l.value;
          c.canStretch(1) && Q.push(c);
        }
      } catch (z) {
        n = { error: z };
      } finally {
        try {
          l && !l.done && (i = u.return) && i.call(u);
        } finally {
          if (n)
            throw n.error;
        }
      }
      var f = Q.length, d = this.childNodes.length;
      if (f && d > 1) {
        var m = 0, p = 0, v = f > 1 && f === d;
        try {
          for (var H = yn(this.childNodes), E = H.next(); !E.done; E = H.next()) {
            var c = E.value, M = c.stretch.dir === 0;
            if (v || M) {
              var C = c.getOuterBBox(M), w = C.h, S = C.d, D = C.rscale;
              w *= D, S *= D, w > m && (m = w), S > p && (p = S);
            }
          }
        } catch (z) {
          o = { error: z };
        } finally {
          try {
            E && !E.done && (a = H.return) && a.call(H);
          } finally {
            if (o)
              throw o.error;
          }
        }
        try {
          for (var k = yn(Q), $ = k.next(); !$.done; $ = k.next()) {
            var c = $.value;
            c.coreMO().getStretchedVariant([m, p]);
          }
        } catch (z) {
          T = { error: z };
        } finally {
          try {
            $ && !$.done && (s = k.return) && s.call(k);
          } finally {
            if (T)
              throw T.error;
          }
        }
      }
    }, r;
  }(e);
}
ze.CommonMrowMixin = My;
function wy(e) {
  return function(t) {
    Ud(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.getScale = function() {
      this.bbox.scale = this.parent.bbox.scale, this.bbox.rscale = 1;
    }, r;
  }(e);
}
ze.CommonInferredMrowMixin = wy;
var Ue = {}, Xd = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), dT = b && b.__assign || function() {
  return dT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, dT.apply(this, arguments);
}, o0 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(Ue, "__esModule", { value: !0 });
Ue.MmlInferredMrow = Ue.MmlMrow = void 0;
var dQ = T2, hT = function(e) {
  Xd(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r._core = null, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mrow";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isSpacelike", {
    get: function() {
      var r, n;
      try {
        for (var i = o0(this.childNodes), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          if (!a.isSpacelike)
            return !1;
        }
      } catch (T) {
        r = { error: T };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isEmbellished", {
    get: function() {
      var r, n, i = !1, o = 0;
      try {
        for (var a = o0(this.childNodes), T = a.next(); !T.done; T = a.next()) {
          var s = T.value;
          if (s) {
            if (s.isEmbellished) {
              if (i)
                return !1;
              i = !0, this._core = o;
            } else if (!s.isSpacelike)
              return !1;
          }
          o++;
        }
      } catch (Q) {
        r = { error: Q };
      } finally {
        try {
          T && !T.done && (n = a.return) && n.call(a);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return i;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.core = function() {
    return !this.isEmbellished || this._core == null ? this : this.childNodes[this._core];
  }, t.prototype.coreMO = function() {
    return !this.isEmbellished || this._core == null ? this : this.childNodes[this._core].coreMO();
  }, t.prototype.nonSpaceLength = function() {
    var r, n, i = 0;
    try {
      for (var o = o0(this.childNodes), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        T && !T.isSpacelike && i++;
      }
    } catch (s) {
      r = { error: s };
    } finally {
      try {
        a && !a.done && (n = o.return) && n.call(o);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return i;
  }, t.prototype.firstNonSpace = function() {
    var r, n;
    try {
      for (var i = o0(this.childNodes), o = i.next(); !o.done; o = i.next()) {
        var a = o.value;
        if (a && !a.isSpacelike)
          return a;
      }
    } catch (T) {
      r = { error: T };
    } finally {
      try {
        o && !o.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return null;
  }, t.prototype.lastNonSpace = function() {
    for (var r = this.childNodes.length; --r >= 0; ) {
      var n = this.childNodes[r];
      if (n && !n.isSpacelike)
        return n;
    }
    return null;
  }, t.prototype.setTeXclass = function(r) {
    var n, i, o, a;
    if (this.getProperty("open") != null || this.getProperty("close") != null) {
      this.getPrevClass(r), r = null;
      try {
        for (var T = o0(this.childNodes), s = T.next(); !s.done; s = T.next()) {
          var Q = s.value;
          r = Q.setTeXclass(r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          s && !s.done && (i = T.return) && i.call(T);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this.texClass == null && (this.texClass = dQ.TEXCLASS.INNER);
    } else {
      try {
        for (var u = o0(this.childNodes), l = u.next(); !l.done; l = u.next()) {
          var Q = l.value;
          r = Q.setTeXclass(r);
        }
      } catch (c) {
        o = { error: c };
      } finally {
        try {
          l && !l.done && (a = u.return) && a.call(u);
        } finally {
          if (o)
            throw o.error;
        }
      }
      this.childNodes[0] && this.updateTeXclass(this.childNodes[0]);
    }
    return r;
  }, t.defaults = dT({}, dQ.AbstractMmlNode.defaults), t;
}(dQ.AbstractMmlNode);
Ue.MmlMrow = hT;
var Sy = function(e) {
  Xd(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "inferredMrow";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isInferred", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "notParent", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.toString = function() {
    return "[" + this.childNodes.join(",") + "]";
  }, t.defaults = hT.defaults, t;
}(hT);
Ue.MmlInferredMrow = Sy;
var fu;
function Cy() {
  if (fu)
    return we;
  fu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var T = function(s, Q) {
      return T = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, l) {
        u.__proto__ = l;
      } || function(u, l) {
        for (var c in l)
          Object.prototype.hasOwnProperty.call(l, c) && (u[c] = l[c]);
      }, T(s, Q);
    };
    return function(s, Q) {
      if (typeof Q != "function" && Q !== null)
        throw new TypeError("Class extends value " + String(Q) + " is not a constructor or null");
      T(s, Q);
      function u() {
        this.constructor = s;
      }
      s.prototype = Q === null ? Object.create(Q) : (u.prototype = Q.prototype, new u());
    };
  }();
  Object.defineProperty(we, "__esModule", { value: !0 }), we.SVGinferredMrow = we.SVGmrow = void 0;
  var t = a3(), r = ze, n = ze, i = Ue, o = function(T) {
    e(s, T);
    function s() {
      return T !== null && T.apply(this, arguments) || this;
    }
    return s.prototype.toSVG = function(Q) {
      var u = this.node.isInferred ? this.element = Q : this.standardSVGnode(Q);
      this.addChildren(u);
    }, s.kind = i.MmlMrow.prototype.kind, s;
  }((0, r.CommonMrowMixin)(t.SVGWrapper));
  we.SVGmrow = o;
  var a = function(T) {
    e(s, T);
    function s() {
      return T !== null && T.apply(this, arguments) || this;
    }
    return s.kind = i.MmlInferredMrow.prototype.kind, s;
  }((0, n.CommonInferredMrowMixin)(o));
  return we.SVGinferredMrow = a, we;
}
var X7 = {}, Ti = {}, Vy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Ti, "__esModule", { value: !0 });
Ti.CommonMiMixin = void 0;
function _y(e) {
  return function(t) {
    Vy(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.computeBBox = function(n, i) {
      t.prototype.computeBBox.call(this, n), this.copySkewIC(n);
    }, r;
  }(e);
}
Ti.CommonMiMixin = _y;
var zr = {}, Oy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), pT = b && b.__assign || function() {
  return pT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, pT.apply(this, arguments);
};
Object.defineProperty(zr, "__esModule", { value: !0 });
zr.MmlMi = void 0;
var gn = T2, Ay = function(e) {
  Oy(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = gn.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mi";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setInheritedAttributes = function(r, n, i, o) {
    r === void 0 && (r = {}), n === void 0 && (n = !1), i === void 0 && (i = 0), o === void 0 && (o = !1), e.prototype.setInheritedAttributes.call(this, r, n, i, o);
    var a = this.getText();
    a.match(t.singleCharacter) && !r.mathvariant && this.attributes.setInherited("mathvariant", "italic");
  }, t.prototype.setTeXclass = function(r) {
    this.getPrevClass(r);
    var n = this.getText();
    return n.length > 1 && n.match(t.operatorName) && this.attributes.get("mathvariant") === "normal" && this.getProperty("autoOP") === void 0 && this.getProperty("texClass") === void 0 && (this.texClass = gn.TEXCLASS.OP, this.setProperty("autoOP", !0)), this;
  }, t.defaults = pT({}, gn.AbstractMmlTokenNode.defaults), t.operatorName = /^[a-z][a-z0-9]*$/i, t.singleCharacter = /^[\uD800-\uDBFF]?.[\u0300-\u036F\u1AB0-\u1ABE\u1DC0-\u1DFF\u20D0-\u20EF]*$/, t;
}(gn.AbstractMmlTokenNode);
zr.MmlMi = Ay;
var du;
function Dy() {
  if (du)
    return X7;
  du = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(X7, "__esModule", { value: !0 }), X7.SVGmi = void 0;
  var t = a3(), r = Ti, n = zr, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.kind = n.MmlMi.prototype.kind, a;
  }((0, r.CommonMiMixin)(t.SVGWrapper));
  return X7.SVGmi = i, X7;
}
var q7 = {}, w0 = {}, ky = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), s9 = b && b.__assign || function() {
  return s9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, s9.apply(this, arguments);
}, w5 = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Iy = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ry = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xn;
Object.defineProperty(w0, "__esModule", { value: !0 });
w0.CommonMoMixin = w0.DirectionVH = void 0;
var hu = a6, Ny = Q3, Py = p4;
w0.DirectionVH = (xn = {}, xn[1] = "v", xn[2] = "h", xn);
function By(e) {
  return function(t) {
    ky(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Iy([], w5(n), !1)) || this;
      return o.size = null, o.isAccent = o.node.isAccent, o;
    }
    return r.prototype.computeBBox = function(n, i) {
      if (this.protoBBox(n), this.node.attributes.get("symmetric") && this.stretch.dir !== 2) {
        var o = this.getCenterOffset(n);
        n.h += o, n.d -= o;
      }
      this.node.getProperty("mathaccent") && (this.stretch.dir === 0 || this.size >= 0) && (n.w = 0);
    }, r.prototype.protoBBox = function(n) {
      var i = this.stretch.dir !== 0;
      i && this.size === null && this.getStretchedVariant([0]), !(i && this.size < 0) && (t.prototype.computeBBox.call(this, n), this.copySkewIC(n));
    }, r.prototype.getAccentOffset = function() {
      var n = hu.BBox.empty();
      return this.protoBBox(n), -n.w / 2;
    }, r.prototype.getCenterOffset = function(n) {
      return n === void 0 && (n = null), n || (n = hu.BBox.empty(), t.prototype.computeBBox.call(this, n)), (n.h + n.d) / 2 + this.font.params.axis_height - n.h;
    }, r.prototype.getVariant = function() {
      if (this.node.attributes.get("largeop")) {
        this.variant = this.node.attributes.get("displaystyle") ? "-largeop" : "-smallop";
        return;
      }
      if (!this.node.attributes.getExplicit("mathvariant") && this.node.getProperty("pseudoscript") === !1) {
        this.variant = "-tex-variant";
        return;
      }
      t.prototype.getVariant.call(this);
    }, r.prototype.canStretch = function(n) {
      if (this.stretch.dir !== 0)
        return this.stretch.dir === n;
      var i = this.node.attributes;
      if (!i.get("stretchy"))
        return !1;
      var o = this.getText();
      if (Array.from(o).length !== 1)
        return !1;
      var a = this.font.getDelimiter(o.codePointAt(0));
      return this.stretch = a && a.dir === n ? a : Py.NOSTRETCH, this.stretch.dir !== 0;
    }, r.prototype.getStretchedVariant = function(n, i) {
      var o, a;
      if (i === void 0 && (i = !1), this.stretch.dir !== 0) {
        var T = this.getWH(n), s = this.getSize("minsize", 0), Q = this.getSize("maxsize", 1 / 0), u = this.node.getProperty("mathaccent");
        T = Math.max(s, Math.min(Q, T));
        var l = this.font.params.delimiterfactor / 1e3, c = this.font.params.delimitershortfall, f = s || i ? T : u ? Math.min(T / l, T + c) : Math.max(T * l, T - c), d = this.stretch, m = d.c || this.getText().codePointAt(0), p = 0;
        if (d.sizes)
          try {
            for (var v = Ry(d.sizes), H = v.next(); !H.done; H = v.next()) {
              var E = H.value;
              if (E >= f) {
                u && p && p--, this.variant = this.font.getSizeVariant(m, p), this.size = p, d.schar && d.schar[p] && (this.stretch = s9(s9({}, this.stretch), { c: d.schar[p] }));
                return;
              }
              p++;
            }
          } catch (M) {
            o = { error: M };
          } finally {
            try {
              H && !H.done && (a = v.return) && a.call(v);
            } finally {
              if (o)
                throw o.error;
            }
          }
        d.stretch ? (this.size = -1, this.invalidateBBox(), this.getStretchBBox(n, this.checkExtendedHeight(T, d), d)) : (this.variant = this.font.getSizeVariant(m, p - 1), this.size = p - 1);
      }
    }, r.prototype.getSize = function(n, i) {
      var o = this.node.attributes;
      return o.isSet(n) && (i = this.length2em(o.get(n), 1, 1)), i;
    }, r.prototype.getWH = function(n) {
      if (n.length === 0)
        return 0;
      if (n.length === 1)
        return n[0];
      var i = w5(n, 2), o = i[0], a = i[1], T = this.font.params.axis_height;
      return this.node.attributes.get("symmetric") ? 2 * Math.max(o - T, a + T) : o + a;
    }, r.prototype.getStretchBBox = function(n, i, o) {
      var a;
      o.hasOwnProperty("min") && o.min > i && (i = o.min);
      var T = w5(o.HDW, 3), s = T[0], Q = T[1], u = T[2];
      this.stretch.dir === 1 ? (a = w5(this.getBaseline(n, i, o), 2), s = a[0], Q = a[1]) : u = i, this.bbox.h = s, this.bbox.d = Q, this.bbox.w = u;
    }, r.prototype.getBaseline = function(n, i, o) {
      var a = n.length === 2 && n[0] + n[1] === i, T = this.node.attributes.get("symmetric"), s = w5(a ? n : [i, 0], 2), Q = s[0], u = s[1], l = w5([Q + u, 0], 2), c = l[0], f = l[1];
      if (T) {
        var d = this.font.params.axis_height;
        a && (c = 2 * Math.max(Q - d, u + d)), f = c / 2 - d;
      } else if (a)
        f = u;
      else {
        var m = w5(o.HDW || [0.75, 0.25], 2), p = m[0], v = m[1];
        f = v * (c / (p + v));
      }
      return [c - f, f];
    }, r.prototype.checkExtendedHeight = function(n, i) {
      if (i.fullExt) {
        var o = w5(i.fullExt, 2), a = o[0], T = o[1], s = Math.ceil(Math.max(0, n - T) / a);
        n = T + s * a;
      }
      return n;
    }, r.prototype.remapChars = function(n) {
      var i = this.node.getProperty("primes");
      if (i)
        return (0, Ny.unicodeChars)(i);
      if (n.length === 1) {
        var o = this.node.coreParent().parent, a = this.isAccent && !o.isKind("mrow"), T = a ? "accent" : "mo", s = this.font.getRemappedChar(T, n[0]);
        s && (n = this.unicodeChars(s, this.variant));
      }
      return n;
    }, r;
  }(e);
}
w0.CommonMoMixin = By;
var pu;
function Fy() {
  if (pu)
    return q7;
  pu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var Q = function(u, l) {
      return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, f) {
        c.__proto__ = f;
      } || function(c, f) {
        for (var d in f)
          Object.prototype.hasOwnProperty.call(f, d) && (c[d] = f[d]);
      }, Q(u, l);
    };
    return function(u, l) {
      if (typeof l != "function" && l !== null)
        throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
      Q(u, l);
      function c() {
        this.constructor = u;
      }
      u.prototype = l === null ? Object.create(l) : (c.prototype = l.prototype, new c());
    };
  }(), t = b && b.__values || function(Q) {
    var u = typeof Symbol == "function" && Symbol.iterator, l = u && Q[u], c = 0;
    if (l)
      return l.call(Q);
    if (Q && typeof Q.length == "number")
      return {
        next: function() {
          return Q && c >= Q.length && (Q = void 0), { value: Q && Q[c++], done: !Q };
        }
      };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, r = b && b.__read || function(Q, u) {
    var l = typeof Symbol == "function" && Q[Symbol.iterator];
    if (!l)
      return Q;
    var c = l.call(Q), f, d = [], m;
    try {
      for (; (u === void 0 || u-- > 0) && !(f = c.next()).done; )
        d.push(f.value);
    } catch (p) {
      m = { error: p };
    } finally {
      try {
        f && !f.done && (l = c.return) && l.call(c);
      } finally {
        if (m)
          throw m.error;
      }
    }
    return d;
  };
  Object.defineProperty(q7, "__esModule", { value: !0 }), q7.SVGmo = void 0;
  var n = a3(), i = w0, o = rt, a = 0.1, T = 0.1, s = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.prototype.toSVG = function(l) {
      var c = this.node.attributes, f = c.get("symmetric") && this.stretch.dir !== 2, d = this.stretch.dir !== 0;
      d && this.size === null && this.getStretchedVariant([]);
      var m = this.standardSVGnode(l);
      if (d && this.size < 0)
        this.stretchSVG();
      else {
        var p = f || c.get("largeop") ? this.fixed(this.getCenterOffset()) : "0", v = this.node.getProperty("mathaccent") ? this.fixed(this.getAccentOffset()) : "0";
        (p !== "0" || v !== "0") && this.adaptor.setAttribute(m, "transform", "translate(".concat(v, " ").concat(p, ")")), this.addChildren(m);
      }
    }, u.prototype.stretchSVG = function() {
      var l = this.stretch.stretch, c = this.getStretchVariants(), f = this.getBBox();
      this.stretch.dir === 1 ? this.stretchVertical(l, c, f) : this.stretchHorizontal(l, c, f);
    }, u.prototype.getStretchVariants = function() {
      var l, c, f = this.stretch.c || this.getText().codePointAt(0), d = [];
      try {
        for (var m = t(this.stretch.stretch.keys()), p = m.next(); !p.done; p = m.next()) {
          var v = p.value;
          d[v] = this.font.getStretchVariant(f, v);
        }
      } catch (H) {
        l = { error: H };
      } finally {
        try {
          p && !p.done && (c = m.return) && c.call(m);
        } finally {
          if (l)
            throw l.error;
        }
      }
      return d;
    }, u.prototype.stretchVertical = function(l, c, f) {
      var d = f.h, m = f.d, p = f.w, v = this.addTop(l[0], c[0], d, p), H = this.addBot(l[2], c[2], m, p);
      if (l.length === 4) {
        var E = r(this.addMidV(l[3], c[3], p), 2), M = E[0], C = E[1];
        this.addExtV(l[1], c[1], d, 0, v, M, p), this.addExtV(l[1], c[1], 0, m, C, H, p);
      } else
        this.addExtV(l[1], c[1], d, m, v, H, p);
    }, u.prototype.stretchHorizontal = function(l, c, f) {
      var d = f.w, m = this.addLeft(l[0], c[0]), p = this.addRight(l[2], c[2], d);
      if (l.length === 4) {
        var v = r(this.addMidH(l[3], c[3], d), 2), H = v[0], E = v[1], M = d / 2;
        this.addExtH(l[1], c[1], M, m, M - H), this.addExtH(l[1], c[1], M, E - M, p, M);
      } else
        this.addExtH(l[1], c[1], d, m, p);
    }, u.prototype.getChar = function(l, c) {
      var f = this.font.getChar(c, l) || [0, 0, 0, null];
      return [f[0], f[1], f[2], f[3] || {}];
    }, u.prototype.addGlyph = function(l, c, f, d, m) {
      return m === void 0 && (m = null), this.placeChar(l, f, d, m || this.element, c);
    }, u.prototype.addTop = function(l, c, f, d) {
      if (!l)
        return 0;
      var m = r(this.getChar(l, c), 3), p = m[0], v = m[1], H = m[2];
      return this.addGlyph(l, c, (d - H) / 2, f - p), p + v;
    }, u.prototype.addExtV = function(l, c, f, d, m, p, v) {
      var H = this;
      if (l) {
        m = Math.max(0, m - a), p = Math.max(0, p - a);
        var E = this.adaptor, M = r(this.getChar(l, c), 3), C = M[0], w = M[1], S = M[2], D = f + d - m - p, k = 1.5 * D / (C + w), $ = (k * (C - w) - D) / 2;
        if (!(D <= 0)) {
          var z = this.svg("svg", {
            width: this.fixed(S),
            height: this.fixed(D),
            y: this.fixed(p - d),
            x: this.fixed((v - S) / 2),
            viewBox: [0, $, S, D].map(function(J) {
              return H.fixed(J);
            }).join(" ")
          });
          this.addGlyph(l, c, 0, 0, z);
          var j = E.lastChild(z);
          E.setAttribute(j, "transform", "scale(1,".concat(this.jax.fixed(k), ")")), E.append(this.element, z);
        }
      }
    }, u.prototype.addBot = function(l, c, f, d) {
      if (!l)
        return 0;
      var m = r(this.getChar(l, c), 3), p = m[0], v = m[1], H = m[2];
      return this.addGlyph(l, c, (d - H) / 2, v - f), p + v;
    }, u.prototype.addMidV = function(l, c, f) {
      if (!l)
        return [0, 0];
      var d = r(this.getChar(l, c), 3), m = d[0], p = d[1], v = d[2], H = (p - m) / 2 + this.font.params.axis_height;
      return this.addGlyph(l, c, (f - v) / 2, H), [m + H, p - H];
    }, u.prototype.addLeft = function(l, c) {
      return l ? this.addGlyph(l, c, 0, 0) : 0;
    }, u.prototype.addExtH = function(l, c, f, d, m, p) {
      var v = this;
      if (p === void 0 && (p = 0), !!l) {
        m = Math.max(0, m - T), d = Math.max(0, d - T);
        var H = this.adaptor, E = r(this.getChar(l, c), 3), M = E[0], C = E[1], w = E[2], S = f - d - m, D = M + C + 2 * a, k = 1.5 * (S / w), $ = -(C + a);
        if (!(S <= 0)) {
          var z = this.svg("svg", {
            width: this.fixed(S),
            height: this.fixed(D),
            x: this.fixed(p + d),
            y: this.fixed($),
            viewBox: [(k * w - S) / 2, $, S, D].map(function(J) {
              return v.fixed(J);
            }).join(" ")
          });
          this.addGlyph(l, c, 0, 0, z);
          var j = H.lastChild(z);
          H.setAttribute(j, "transform", "scale(" + this.jax.fixed(k) + ",1)"), H.append(this.element, z);
        }
      }
    }, u.prototype.addRight = function(l, c, f) {
      if (!l)
        return 0;
      var d = this.getChar(l, c)[2];
      return this.addGlyph(l, c, f - d, 0);
    }, u.prototype.addMidH = function(l, c, f) {
      if (!l)
        return [0, 0];
      var d = this.getChar(l, c)[2];
      return this.addGlyph(l, c, (f - d) / 2, 0), [(f - d) / 2, (f + d) / 2];
    }, u.kind = o.MmlMo.prototype.kind, u;
  }((0, i.CommonMoMixin)(n.SVGWrapper));
  return q7.SVGmo = s, q7;
}
var J7 = {}, si = {}, jy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(si, "__esModule", { value: !0 });
si.CommonMnMixin = void 0;
function $y(e) {
  return function(t) {
    jy(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.remapChars = function(n) {
      if (n.length) {
        var i = this.font.getRemappedChar("mn", n[0]);
        if (i) {
          var o = this.unicodeChars(i, this.variant);
          o.length === 1 ? n[0] = o[0] : n = o.concat(n.slice(1));
        }
      }
      return n;
    }, r;
  }(e);
}
si.CommonMnMixin = $y;
var Ur = {}, Zy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mT = b && b.__assign || function() {
  return mT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, mT.apply(this, arguments);
};
Object.defineProperty(Ur, "__esModule", { value: !0 });
Ur.MmlMn = void 0;
var hQ = T2, Wy = function(e) {
  Zy(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = hQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mn";
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = mT({}, hQ.AbstractMmlTokenNode.defaults), t;
}(hQ.AbstractMmlTokenNode);
Ur.MmlMn = Wy;
var mu;
function Gy() {
  if (mu)
    return J7;
  mu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(J7, "__esModule", { value: !0 }), J7.SVGmn = void 0;
  var t = a3(), r = si, n = Ur, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.kind = n.MmlMn.prototype.kind, a;
  }((0, r.CommonMnMixin)(t.SVGWrapper));
  return J7.SVGmn = i, J7;
}
var Y7 = {}, li = {}, zy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Uy = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Xy = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(li, "__esModule", { value: !0 });
li.CommonMsMixin = void 0;
function qy(e) {
  return function(t) {
    zy(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Xy([], Uy(n), !1)) || this, a = o.node.attributes, T = a.getList("lquote", "rquote");
      return o.variant !== "monospace" && (!a.isSet("lquote") && T.lquote === '"' && (T.lquote = "“"), !a.isSet("rquote") && T.rquote === '"' && (T.rquote = "”")), o.childNodes.unshift(o.createText(T.lquote)), o.childNodes.push(o.createText(T.rquote)), o;
    }
    return r.prototype.createText = function(n) {
      var i = this.wrap(this.mmlText(n));
      return i.parent = this, i;
    }, r;
  }(e);
}
li.CommonMsMixin = qy;
var Xr = {}, Jy = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), l9 = b && b.__assign || function() {
  return l9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, l9.apply(this, arguments);
};
Object.defineProperty(Xr, "__esModule", { value: !0 });
Xr.MmlMs = void 0;
var pQ = T2, Yy = function(e) {
  Jy(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = pQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "ms";
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = l9(l9({}, pQ.AbstractMmlTokenNode.defaults), { lquote: '"', rquote: '"' }), t;
}(pQ.AbstractMmlTokenNode);
Xr.MmlMs = Yy;
var vu;
function Ky() {
  if (vu)
    return Y7;
  vu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(Y7, "__esModule", { value: !0 }), Y7.SVGms = void 0;
  var t = a3(), r = li, n = Xr, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.kind = n.MmlMs.prototype.kind, a;
  }((0, r.CommonMsMixin)(t.SVGWrapper));
  return Y7.SVGms = i, Y7;
}
var K7 = {}, ui = {}, eg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(ui, "__esModule", { value: !0 });
ui.CommonMtextMixin = void 0;
function tg(e) {
  var t;
  return t = function(r) {
    eg(n, r);
    function n() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return n.prototype.getVariant = function() {
      var i = this.jax.options, o = this.jax.math.outputData, a = (!!o.merrorFamily || !!i.merrorFont) && this.node.Parent.isKind("merror");
      if (o.mtextFamily || i.mtextFont || a) {
        var T = this.node.attributes.get("mathvariant"), s = this.constructor.INHERITFONTS[T] || this.jax.font.getCssFont(T), Q = s[0] || (a ? o.merrorFamily || i.merrorFont : o.mtextFamily || i.mtextFont);
        this.variant = this.explicitVariant(Q, s[2] ? "bold" : "", s[1] ? "italic" : "");
        return;
      }
      r.prototype.getVariant.call(this);
    }, n;
  }(e), t.INHERITFONTS = {
    normal: ["", !1, !1],
    bold: ["", !1, !0],
    italic: ["", !0, !1],
    "bold-italic": ["", !0, !0]
  }, t;
}
ui.CommonMtextMixin = tg;
var qr = {}, rg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), vT = b && b.__assign || function() {
  return vT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vT.apply(this, arguments);
};
Object.defineProperty(qr, "__esModule", { value: !0 });
qr.MmlMtext = void 0;
var mQ = T2, ng = function(e) {
  rg(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = mQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mtext";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isSpacelike", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = vT({}, mQ.AbstractMmlTokenNode.defaults), t;
}(mQ.AbstractMmlTokenNode);
qr.MmlMtext = ng;
var Lu;
function ig() {
  if (Lu)
    return K7;
  Lu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(K7, "__esModule", { value: !0 }), K7.SVGmtext = void 0;
  var t = a3(), r = ui, n = qr, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.kind = n.MmlMtext.prototype.kind, a;
  }((0, r.CommonMtextMixin)(t.SVGWrapper));
  return K7.SVGmtext = i, K7;
}
var er = {}, Jr = {}, og = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), LT = b && b.__assign || function() {
  return LT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, LT.apply(this, arguments);
};
Object.defineProperty(Jr, "__esModule", { value: !0 });
Jr.MmlMerror = void 0;
var vQ = T2, ag = function(e) {
  og(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = vQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "merror";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return -1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = LT({}, vQ.AbstractMmlNode.defaults), t;
}(vQ.AbstractMmlNode);
Jr.MmlMerror = ag;
var yu;
function Qg() {
  if (yu)
    return er;
  yu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, s) {
        T.__proto__ = s;
      } || function(T, s) {
        for (var Q in s)
          Object.prototype.hasOwnProperty.call(s, Q) && (T[Q] = s[Q]);
      }, i(o, a);
    };
    return function(o, a) {
      if (typeof a != "function" && a !== null)
        throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
      i(o, a);
      function T() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (T.prototype = a.prototype, new T());
    };
  }();
  Object.defineProperty(er, "__esModule", { value: !0 }), er.SVGmerror = void 0;
  var t = a3(), r = Jr, n = function(i) {
    e(o, i);
    function o() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return o.prototype.toSVG = function(a) {
      var T = this.standardSVGnode(a), s = this.getBBox(), Q = s.h, u = s.d, l = s.w;
      this.adaptor.append(this.element, this.svg("rect", {
        "data-background": !0,
        width: this.fixed(l),
        height: this.fixed(Q + u),
        y: this.fixed(-u)
      }));
      var c = this.node.attributes.get("title");
      c && this.adaptor.append(this.element, this.svg("title", {}, [this.adaptor.text(c)])), this.addChildren(T);
    }, o.kind = r.MmlMerror.prototype.kind, o.styles = {
      'g[data-mml-node="merror"] > g': {
        fill: "red",
        stroke: "red"
      },
      'g[data-mml-node="merror"] > rect[data-background]': {
        fill: "yellow",
        stroke: "none"
      }
    }, o;
  }(t.SVGWrapper);
  return er.SVGmerror = n, er;
}
var tr = {}, ci = {}, Tg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(ci, "__esModule", { value: !0 });
ci.CommonMspaceMixin = void 0;
function sg(e) {
  return function(t) {
    Tg(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.computeBBox = function(n, i) {
      var o = this.node.attributes;
      n.w = this.length2em(o.get("width"), 0), n.h = this.length2em(o.get("height"), 0), n.d = this.length2em(o.get("depth"), 0);
    }, r.prototype.handleVariant = function() {
    }, r;
  }(e);
}
ci.CommonMspaceMixin = sg;
var Yr = {}, lg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), u9 = b && b.__assign || function() {
  return u9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, u9.apply(this, arguments);
};
Object.defineProperty(Yr, "__esModule", { value: !0 });
Yr.MmlMspace = void 0;
var LQ = T2, ug = function(e) {
  lg(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = LQ.TEXCLASS.NONE, r;
  }
  return t.prototype.setTeXclass = function(r) {
    return r;
  }, Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mspace";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isSpacelike", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "hasNewline", {
    get: function() {
      var r = this.attributes;
      return r.getExplicit("width") == null && r.getExplicit("height") == null && r.getExplicit("depth") == null && r.get("linebreak") === "newline";
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = u9(u9({}, LQ.AbstractMmlTokenNode.defaults), { width: "0em", height: "0ex", depth: "0ex", linebreak: "auto" }), t;
}(LQ.AbstractMmlTokenNode);
Yr.MmlMspace = ug;
var gu;
function cg() {
  if (gu)
    return tr;
  gu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(tr, "__esModule", { value: !0 }), tr.SVGmspace = void 0;
  var t = a3(), r = ci, n = Yr, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.kind = n.MmlMspace.prototype.kind, a;
  }((0, r.CommonMspaceMixin)(t.SVGWrapper));
  return tr.SVGmspace = i, tr;
}
var rr = {}, fi = {}, fg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), dg = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
};
Object.defineProperty(fi, "__esModule", { value: !0 });
fi.CommonMpaddedMixin = void 0;
function hg(e) {
  return function(t) {
    fg(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.getDimens = function() {
      var n = this.node.attributes.getList("width", "height", "depth", "lspace", "voffset"), i = this.childNodes[0].getBBox(), o = i.w, a = i.h, T = i.d, s = o, Q = a, u = T, l = 0, c = 0, f = 0;
      n.width !== "" && (o = this.dimen(n.width, i, "w", 0)), n.height !== "" && (a = this.dimen(n.height, i, "h", 0)), n.depth !== "" && (T = this.dimen(n.depth, i, "d", 0)), n.voffset !== "" && (c = this.dimen(n.voffset, i)), n.lspace !== "" && (l = this.dimen(n.lspace, i));
      var d = this.node.attributes.get("data-align");
      return d && (f = this.getAlignX(o, i, d)), [Q, u, s, a - Q, T - u, o - s, l, c, f];
    }, r.prototype.dimen = function(n, i, o, a) {
      o === void 0 && (o = ""), a === void 0 && (a = null), n = String(n);
      var T = n.match(/width|height|depth/), s = T ? i[T[0].charAt(0)] : o ? i[o] : 0, Q = this.length2em(n, s) || 0;
      return n.match(/^[-+]/) && o && (Q += s), a != null && (Q = Math.max(a, Q)), Q;
    }, r.prototype.computeBBox = function(n, i) {
      i === void 0 && (i = !1);
      var o = dg(this.getDimens(), 6), a = o[0], T = o[1], s = o[2], Q = o[3], u = o[4], l = o[5];
      n.w = s + l, n.h = a + Q, n.d = T + u, this.setChildPWidths(i, n.w);
    }, r.prototype.getWrapWidth = function(n) {
      return this.getBBox().w;
    }, r.prototype.getChildAlign = function(n) {
      return this.node.attributes.get("data-align") || "left";
    }, r;
  }(e);
}
fi.CommonMpaddedMixin = hg;
var Kr = {}, pg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), c9 = b && b.__assign || function() {
  return c9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, c9.apply(this, arguments);
};
Object.defineProperty(Kr, "__esModule", { value: !0 });
Kr.MmlMpadded = void 0;
var xu = T2, mg = function(e) {
  pg(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mpadded";
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = c9(c9({}, xu.AbstractMmlLayoutNode.defaults), { width: "", height: "", depth: "", lspace: 0, voffset: 0 }), t;
}(xu.AbstractMmlLayoutNode);
Kr.MmlMpadded = mg;
var Hu;
function vg() {
  if (Hu)
    return rr;
  Hu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }(), t = b && b.__read || function(a, T) {
    var s = typeof Symbol == "function" && a[Symbol.iterator];
    if (!s)
      return a;
    var Q = s.call(a), u, l = [], c;
    try {
      for (; (T === void 0 || T-- > 0) && !(u = Q.next()).done; )
        l.push(u.value);
    } catch (f) {
      c = { error: f };
    } finally {
      try {
        u && !u.done && (s = Q.return) && s.call(Q);
      } finally {
        if (c)
          throw c.error;
      }
    }
    return l;
  };
  Object.defineProperty(rr, "__esModule", { value: !0 }), rr.SVGmpadded = void 0;
  var r = a3(), n = fi, i = Kr, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.toSVG = function(s) {
      var Q = this.standardSVGnode(s), u = t(this.getDimens(), 9), l = u[5], c = u[6], f = u[7], d = u[8], m = this.node.attributes.get("data-align") || "left", p = c + d - (l < 0 && m !== "left" ? m === "center" ? l / 2 : l : 0);
      (p || f) && (Q = this.adaptor.append(Q, this.svg("g")), this.place(p, f, Q)), this.addChildren(Q);
    }, T.kind = i.MmlMpadded.prototype.kind, T;
  }((0, n.CommonMpaddedMixin)(r.SVGWrapper));
  return rr.SVGmpadded = o, rr;
}
var nr = {}, e8 = {}, Lg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), yT = b && b.__assign || function() {
  return yT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, yT.apply(this, arguments);
};
Object.defineProperty(e8, "__esModule", { value: !0 });
e8.MmlMphantom = void 0;
var yQ = T2, yg = function(e) {
  Lg(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = yQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mphantom";
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = yT({}, yQ.AbstractMmlLayoutNode.defaults), t;
}(yQ.AbstractMmlLayoutNode);
e8.MmlMphantom = yg;
var Eu;
function gg() {
  if (Eu)
    return nr;
  Eu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, s) {
        T.__proto__ = s;
      } || function(T, s) {
        for (var Q in s)
          Object.prototype.hasOwnProperty.call(s, Q) && (T[Q] = s[Q]);
      }, i(o, a);
    };
    return function(o, a) {
      if (typeof a != "function" && a !== null)
        throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
      i(o, a);
      function T() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (T.prototype = a.prototype, new T());
    };
  }();
  Object.defineProperty(nr, "__esModule", { value: !0 }), nr.SVGmphantom = void 0;
  var t = a3(), r = e8, n = function(i) {
    e(o, i);
    function o() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return o.prototype.toSVG = function(a) {
      this.standardSVGnode(a);
    }, o.kind = r.MmlMphantom.prototype.kind, o;
  }(t.SVGWrapper);
  return nr.SVGmphantom = n, nr;
}
var ir = {}, di = {}, xg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bu = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Hg = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(di, "__esModule", { value: !0 });
di.CommonMfracMixin = void 0;
function Eg(e) {
  return function(t) {
    xg(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Hg([], bu(n), !1)) || this;
      if (o.bevel = null, o.pad = o.node.getProperty("withDelims") ? 0 : o.font.params.nulldelimiterspace, o.node.attributes.get("bevelled")) {
        var a = o.getBevelData(o.isDisplay()).H, T = o.bevel = o.createMo("/");
        T.node.attributes.set("symmetric", !0), T.canStretch(1), T.getStretchedVariant([a], !0);
      }
      return o;
    }
    return r.prototype.computeBBox = function(n, i) {
      i === void 0 && (i = !1), n.empty();
      var o = this.node.attributes.getList("linethickness", "bevelled"), a = o.linethickness, T = o.bevelled, s = this.isDisplay(), Q = null;
      if (T)
        this.getBevelledBBox(n, s);
      else {
        var u = this.length2em(String(a), 0.06);
        Q = -2 * this.pad, u === 0 ? this.getAtopBBox(n, s) : (this.getFractionBBox(n, s, u), Q -= 0.2), Q += n.w;
      }
      n.clean(), this.setChildPWidths(i, Q);
    }, r.prototype.getFractionBBox = function(n, i, o) {
      var a = this.childNodes[0].getOuterBBox(), T = this.childNodes[1].getOuterBBox(), s = this.font.params, Q = s.axis_height, u = this.getTUV(i, o), l = u.T, c = u.u, f = u.v;
      n.combine(a, 0, Q + l + Math.max(a.d * a.rscale, c)), n.combine(T, 0, Q - l - Math.max(T.h * T.rscale, f)), n.w += 2 * this.pad + 0.2;
    }, r.prototype.getTUV = function(n, i) {
      var o = this.font.params, a = o.axis_height, T = (n ? 3.5 : 1.5) * i;
      return {
        T: (n ? 3.5 : 1.5) * i,
        u: (n ? o.num1 : o.num2) - a - T,
        v: (n ? o.denom1 : o.denom2) + a - T
      };
    }, r.prototype.getAtopBBox = function(n, i) {
      var o = this.getUVQ(i), a = o.u, T = o.v, s = o.nbox, Q = o.dbox;
      n.combine(s, 0, a), n.combine(Q, 0, -T), n.w += 2 * this.pad;
    }, r.prototype.getUVQ = function(n) {
      var i = this.childNodes[0].getOuterBBox(), o = this.childNodes[1].getOuterBBox(), a = this.font.params, T = bu(n ? [a.num1, a.denom1] : [a.num3, a.denom2], 2), s = T[0], Q = T[1], u = (n ? 7 : 3) * a.rule_thickness, l = s - i.d * i.scale - (o.h * o.scale - Q);
      return l < u && (s += (u - l) / 2, Q += (u - l) / 2, l = u), { u: s, v: Q, q: l, nbox: i, dbox: o };
    }, r.prototype.getBevelledBBox = function(n, i) {
      var o = this.getBevelData(i), a = o.u, T = o.v, s = o.delta, Q = o.nbox, u = o.dbox, l = this.bevel.getOuterBBox();
      n.combine(Q, 0, a), n.combine(l, n.w - s / 2, 0), n.combine(u, n.w - s / 2, T);
    }, r.prototype.getBevelData = function(n) {
      var i = this.childNodes[0].getOuterBBox(), o = this.childNodes[1].getOuterBBox(), a = n ? 0.4 : 0.15, T = Math.max(i.scale * (i.h + i.d), o.scale * (o.h + o.d)) + 2 * a, s = this.font.params.axis_height, Q = i.scale * (i.d - i.h) / 2 + s + a, u = o.scale * (o.d - o.h) / 2 + s - a;
      return { H: T, delta: a, u: Q, v: u, nbox: i, dbox: o };
    }, r.prototype.canStretch = function(n) {
      return !1;
    }, r.prototype.isDisplay = function() {
      var n = this.node.attributes.getList("displaystyle", "scriptlevel"), i = n.displaystyle, o = n.scriptlevel;
      return i && o === 0;
    }, r.prototype.getWrapWidth = function(n) {
      var i = this.node.attributes;
      if (i.get("bevelled"))
        return this.childNodes[n].getOuterBBox().w;
      var o = this.getBBox().w, a = this.length2em(i.get("linethickness"));
      return o - (a ? 0.2 : 0) - 2 * this.pad;
    }, r.prototype.getChildAlign = function(n) {
      var i = this.node.attributes;
      return i.get("bevelled") ? "left" : i.get(["numalign", "denomalign"][n]);
    }, r;
  }(e);
}
di.CommonMfracMixin = Eg;
var t8 = {}, bg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), f9 = b && b.__assign || function() {
  return f9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, f9.apply(this, arguments);
}, Mg = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(t8, "__esModule", { value: !0 });
t8.MmlMfrac = void 0;
var Mu = T2, wg = function(e) {
  bg(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mfrac";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    var n, i;
    this.getPrevClass(r);
    try {
      for (var o = Mg(this.childNodes), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        T.setTeXclass(null);
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return this;
  }, t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    (!n || i > 0) && i++, this.childNodes[0].setInheritedAttributes(r, !1, i, o), this.childNodes[1].setInheritedAttributes(r, !1, i, !0);
  }, t.defaults = f9(f9({}, Mu.AbstractMmlBaseNode.defaults), { linethickness: "medium", numalign: "center", denomalign: "center", bevelled: !1 }), t;
}(Mu.AbstractMmlBaseNode);
t8.MmlMfrac = wg;
var wu;
function Sg() {
  if (wu)
    return ir;
  wu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }(), t = b && b.__read || function(a, T) {
    var s = typeof Symbol == "function" && a[Symbol.iterator];
    if (!s)
      return a;
    var Q = s.call(a), u, l = [], c;
    try {
      for (; (T === void 0 || T-- > 0) && !(u = Q.next()).done; )
        l.push(u.value);
    } catch (f) {
      c = { error: f };
    } finally {
      try {
        u && !u.done && (s = Q.return) && s.call(Q);
      } finally {
        if (c)
          throw c.error;
      }
    }
    return l;
  };
  Object.defineProperty(ir, "__esModule", { value: !0 }), ir.SVGmfrac = void 0;
  var r = a3(), n = di, i = t8, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.toSVG = function(s) {
      this.standardSVGnode(s);
      var Q = this.node.attributes.getList("linethickness", "bevelled"), u = Q.linethickness, l = Q.bevelled, c = this.isDisplay();
      if (l)
        this.makeBevelled(c);
      else {
        var f = this.length2em(String(u), 0.06);
        f === 0 ? this.makeAtop(c) : this.makeFraction(c, f);
      }
    }, T.prototype.makeFraction = function(s, Q) {
      var u = this.element, l = this.node.attributes.getList("numalign", "denomalign"), c = l.numalign, f = l.denomalign, d = t(this.childNodes, 2), m = d[0], p = d[1], v = m.getOuterBBox(), H = p.getOuterBBox(), E = this.font.params, M = E.axis_height, C = 0.1, w = this.node.getProperty("withDelims") ? 0 : E.nulldelimiterspace, S = Math.max((v.L + v.w + v.R) * v.rscale, (H.L + H.w + H.R) * H.rscale), D = this.getAlignX(S, v, c) + C + w, k = this.getAlignX(S, H, f) + C + w, $ = this.getTUV(s, Q), z = $.T, j = $.u, J = $.v;
      m.toSVG(u), m.place(D, M + z + Math.max(v.d * v.rscale, j)), p.toSVG(u), p.place(k, M - z - Math.max(H.h * H.rscale, J)), this.adaptor.append(u, this.svg("rect", {
        width: this.fixed(S + 2 * C),
        height: this.fixed(Q),
        x: this.fixed(w),
        y: this.fixed(M - Q / 2)
      }));
    }, T.prototype.makeAtop = function(s) {
      var Q = this.element, u = this.node.attributes.getList("numalign", "denomalign"), l = u.numalign, c = u.denomalign, f = t(this.childNodes, 2), d = f[0], m = f[1], p = d.getOuterBBox(), v = m.getOuterBBox(), H = this.font.params, E = this.node.getProperty("withDelims") ? 0 : H.nulldelimiterspace, M = Math.max((p.L + p.w + p.R) * p.rscale, (v.L + v.w + v.R) * v.rscale), C = this.getAlignX(M, p, l) + E, w = this.getAlignX(M, v, c) + E, S = this.getUVQ(s), D = S.u, k = S.v;
      d.toSVG(Q), d.place(C, D), m.toSVG(Q), m.place(w, -k);
    }, T.prototype.makeBevelled = function(s) {
      var Q = this.element, u = t(this.childNodes, 2), l = u[0], c = u[1], f = this.getBevelData(s), d = f.u, m = f.v, p = f.delta, v = f.nbox, H = f.dbox, E = (v.L + v.w + v.R) * v.rscale;
      l.toSVG(Q), this.bevel.toSVG(Q), c.toSVG(Q), l.place(v.L * v.rscale, d), this.bevel.place(E - p / 2, 0), c.place(E + this.bevel.getOuterBBox().w + H.L * H.rscale - p, m);
    }, T.kind = i.MmlMfrac.prototype.kind, T;
  }((0, n.CommonMfracMixin)(r.SVGWrapper));
  return ir.SVGmfrac = o, ir;
}
var or = {}, hi = {}, Cg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Su = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Vg = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(hi, "__esModule", { value: !0 });
hi.CommonMsqrtMixin = void 0;
var _g = a6;
function Og(e) {
  return function(t) {
    Cg(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Vg([], Su(n), !1)) || this, a = o.createMo("√");
      a.canStretch(1);
      var T = o.childNodes[o.base].getOuterBBox(), s = T.h, Q = T.d, u = o.font.params.rule_thickness, l = o.node.attributes.get("displaystyle") ? o.font.params.x_height : u;
      return o.surdH = s + Q + 2 * u + l / 4, a.getStretchedVariant([o.surdH - Q, Q], !0), o;
    }
    return Object.defineProperty(r.prototype, "base", {
      get: function() {
        return 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "surd", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "root", {
      get: function() {
        return null;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.createMo = function(n) {
      var i = t.prototype.createMo.call(this, n);
      return this.childNodes.push(i), i;
    }, r.prototype.computeBBox = function(n, i) {
      i === void 0 && (i = !1);
      var o = this.childNodes[this.surd].getBBox(), a = new _g.BBox(this.childNodes[this.base].getOuterBBox()), T = this.getPQ(o)[1], s = this.font.params.rule_thickness, Q = a.h + T + s, u = Su(this.getRootDimens(o, Q), 1), l = u[0];
      n.h = Q + s, this.combineRootBBox(n, o, Q), n.combine(o, l, Q - o.h), n.combine(a, l + o.w, 0), n.clean(), this.setChildPWidths(i);
    }, r.prototype.combineRootBBox = function(n, i, o) {
    }, r.prototype.getPQ = function(n) {
      var i = this.font.params.rule_thickness, o = this.node.attributes.get("displaystyle") ? this.font.params.x_height : i, a = n.h + n.d > this.surdH ? (n.h + n.d - (this.surdH - 2 * i - o / 2)) / 2 : i + o / 4;
      return [o, a];
    }, r.prototype.getRootDimens = function(n, i) {
      return [0, 0, 0, 0];
    }, r;
  }(e);
}
hi.CommonMsqrtMixin = Og;
var r8 = {}, Ag = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), gT = b && b.__assign || function() {
  return gT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, gT.apply(this, arguments);
};
Object.defineProperty(r8, "__esModule", { value: !0 });
r8.MmlMsqrt = void 0;
var gQ = T2, Dg = function(e) {
  Ag(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = gQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "msqrt";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return -1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    return this.getPrevClass(r), this.childNodes[0].setTeXclass(null), this;
  }, t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    this.childNodes[0].setInheritedAttributes(r, n, i, !0);
  }, t.defaults = gT({}, gQ.AbstractMmlNode.defaults), t;
}(gQ.AbstractMmlNode);
r8.MmlMsqrt = Dg;
var Cu;
function qd() {
  if (Cu)
    return or;
  Cu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(or, "__esModule", { value: !0 }), or.SVGmsqrt = void 0;
  var t = a3(), r = hi, n = r8, i = function(o) {
    e(a, o);
    function a() {
      var T = o !== null && o.apply(this, arguments) || this;
      return T.dx = 0, T;
    }
    return a.prototype.toSVG = function(T) {
      var s = this.childNodes[this.surd], Q = this.childNodes[this.base], u = this.root ? this.childNodes[this.root] : null, l = s.getBBox(), c = Q.getOuterBBox(), f = this.getPQ(l)[1], d = this.font.params.rule_thickness * this.bbox.scale, m = c.h + f + d, p = this.standardSVGnode(T), v = this.adaptor.append(p, this.svg("g"));
      this.addRoot(p, u, l, m), s.toSVG(p), s.place(this.dx, m - l.h), Q.toSVG(v), Q.place(this.dx + l.w, 0), this.adaptor.append(p, this.svg("rect", {
        width: this.fixed(c.w),
        height: this.fixed(d),
        x: this.fixed(this.dx + l.w),
        y: this.fixed(m - d)
      }));
    }, a.prototype.addRoot = function(T, s, Q, u) {
    }, a.kind = n.MmlMsqrt.prototype.kind, a;
  }((0, r.CommonMsqrtMixin)(t.SVGWrapper));
  return or.SVGmsqrt = i, or;
}
var ar = {}, pi = {}, kg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(pi, "__esModule", { value: !0 });
pi.CommonMrootMixin = void 0;
function Ig(e) {
  return function(t) {
    kg(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(r.prototype, "surd", {
      get: function() {
        return 2;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "root", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.combineRootBBox = function(n, i, o) {
      var a = this.childNodes[this.root].getOuterBBox(), T = this.getRootDimens(i, o)[1];
      n.combine(a, 0, T);
    }, r.prototype.getRootDimens = function(n, i) {
      var o = this.childNodes[this.surd], a = this.childNodes[this.root].getOuterBBox(), T = (o.size < 0 ? 0.5 : 0.6) * n.w, s = a.w, Q = a.rscale, u = Math.max(s, T / Q), l = Math.max(0, u - s), c = this.rootHeight(a, n, o.size, i), f = u * Q - T;
      return [f, c, l];
    }, r.prototype.rootHeight = function(n, i, o, a) {
      var T = i.h + i.d, s = (o < 0 ? 1.9 : 0.55 * T) - (T - a);
      return s + Math.max(0, n.d * n.rscale);
    }, r;
  }(e);
}
pi.CommonMrootMixin = Ig;
var n8 = {}, Rg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), xT = b && b.__assign || function() {
  return xT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, xT.apply(this, arguments);
};
Object.defineProperty(n8, "__esModule", { value: !0 });
n8.MmlMroot = void 0;
var xQ = T2, Ng = function(e) {
  Rg(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = xQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mroot";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    return this.getPrevClass(r), this.childNodes[0].setTeXclass(null), this.childNodes[1].setTeXclass(null), this;
  }, t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    this.childNodes[0].setInheritedAttributes(r, n, i, !0), this.childNodes[1].setInheritedAttributes(r, !1, i + 2, o);
  }, t.defaults = xT({}, xQ.AbstractMmlNode.defaults), t;
}(xQ.AbstractMmlNode);
n8.MmlMroot = Ng;
var Vu;
function Pg() {
  if (Vu)
    return ar;
  Vu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }(), t = b && b.__read || function(a, T) {
    var s = typeof Symbol == "function" && a[Symbol.iterator];
    if (!s)
      return a;
    var Q = s.call(a), u, l = [], c;
    try {
      for (; (T === void 0 || T-- > 0) && !(u = Q.next()).done; )
        l.push(u.value);
    } catch (f) {
      c = { error: f };
    } finally {
      try {
        u && !u.done && (s = Q.return) && s.call(Q);
      } finally {
        if (c)
          throw c.error;
      }
    }
    return l;
  };
  Object.defineProperty(ar, "__esModule", { value: !0 }), ar.SVGmroot = void 0;
  var r = qd(), n = pi, i = n8, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.addRoot = function(s, Q, u, l) {
      Q.toSVG(s);
      var c = t(this.getRootDimens(u, l), 3), f = c[0], d = c[1], m = c[2], p = Q.getOuterBBox();
      Q.place(m * p.rscale, d), this.dx = f;
    }, T.kind = i.MmlMroot.prototype.kind, T;
  }((0, n.CommonMrootMixin)(r.SVGmsqrt));
  return ar.SVGmroot = o, ar;
}
var Qr = {}, mi = {}, Bg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Fg = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, jg = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, $g = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(mi, "__esModule", { value: !0 });
mi.CommonMfencedMixin = void 0;
function Zg(e) {
  return function(t) {
    Bg(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, jg([], Fg(n), !1)) || this;
      return o.mrow = null, o.createMrow(), o.addMrowChildren(), o;
    }
    return r.prototype.createMrow = function() {
      var n = this.node.factory, i = n.create("inferredMrow");
      i.inheritAttributesFrom(this.node), this.mrow = this.wrap(i), this.mrow.parent = this;
    }, r.prototype.addMrowChildren = function() {
      var n, i, o = this.node, a = this.mrow;
      this.addMo(o.open), this.childNodes.length && a.childNodes.push(this.childNodes[0]);
      var T = 0;
      try {
        for (var s = $g(this.childNodes.slice(1)), Q = s.next(); !Q.done; Q = s.next()) {
          var u = Q.value;
          this.addMo(o.separators[T++]), a.childNodes.push(u);
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          Q && !Q.done && (i = s.return) && i.call(s);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this.addMo(o.close), a.stretchChildren();
    }, r.prototype.addMo = function(n) {
      if (n) {
        var i = this.wrap(n);
        this.mrow.childNodes.push(i), i.parent = this.mrow;
      }
    }, r.prototype.computeBBox = function(n, i) {
      i === void 0 && (i = !1), n.updateFrom(this.mrow.getOuterBBox()), this.setChildPWidths(i);
    }, r;
  }(e);
}
mi.CommonMfencedMixin = Zg;
var i8 = {}, Wg = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), d9 = b && b.__assign || function() {
  return d9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, d9.apply(this, arguments);
}, _u = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(i8, "__esModule", { value: !0 });
i8.MmlMfenced = void 0;
var Tr = T2, Gg = function(e) {
  Wg(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = Tr.TEXCLASS.INNER, r.separators = [], r.open = null, r.close = null, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mfenced";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    this.getPrevClass(r), this.open && (r = this.open.setTeXclass(r)), this.childNodes[0] && (r = this.childNodes[0].setTeXclass(r));
    for (var n = 1, i = this.childNodes.length; n < i; n++)
      this.separators[n - 1] && (r = this.separators[n - 1].setTeXclass(r)), this.childNodes[n] && (r = this.childNodes[n].setTeXclass(r));
    return this.close && (r = this.close.setTeXclass(r)), this.updateTeXclass(this.open), r;
  }, t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    var a, T;
    this.addFakeNodes();
    try {
      for (var s = _u([this.open, this.close].concat(this.separators)), Q = s.next(); !Q.done; Q = s.next()) {
        var u = Q.value;
        u && u.setInheritedAttributes(r, n, i, o);
      }
    } catch (l) {
      a = { error: l };
    } finally {
      try {
        Q && !Q.done && (T = s.return) && T.call(s);
      } finally {
        if (a)
          throw a.error;
      }
    }
    e.prototype.setChildInheritedAttributes.call(this, r, n, i, o);
  }, t.prototype.addFakeNodes = function() {
    var r, n, i = this.attributes.getList("open", "close", "separators"), o = i.open, a = i.close, T = i.separators;
    if (o = o.replace(/[ \t\n\r]/g, ""), a = a.replace(/[ \t\n\r]/g, ""), T = T.replace(/[ \t\n\r]/g, ""), o && (this.open = this.fakeNode(o, { fence: !0, form: "prefix" }, Tr.TEXCLASS.OPEN)), T) {
      for (; T.length < this.childNodes.length - 1; )
        T += T.charAt(T.length - 1);
      var s = 0;
      try {
        for (var Q = _u(this.childNodes.slice(1)), u = Q.next(); !u.done; u = Q.next()) {
          var l = u.value;
          l && this.separators.push(this.fakeNode(T.charAt(s++)));
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          u && !u.done && (n = Q.return) && n.call(Q);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }
    a && (this.close = this.fakeNode(a, { fence: !0, form: "postfix" }, Tr.TEXCLASS.CLOSE));
  }, t.prototype.fakeNode = function(r, n, i) {
    n === void 0 && (n = {}), i === void 0 && (i = null);
    var o = this.factory.create("text").setText(r), a = this.factory.create("mo", n, [o]);
    return a.texClass = i, a.parent = this, a;
  }, t.defaults = d9(d9({}, Tr.AbstractMmlNode.defaults), { open: "(", close: ")", separators: "," }), t;
}(Tr.AbstractMmlNode);
i8.MmlMfenced = Gg;
var Ou;
function zg() {
  if (Ou)
    return Qr;
  Ou = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }(), t = b && b.__values || function(a) {
    var T = typeof Symbol == "function" && Symbol.iterator, s = T && a[T], Q = 0;
    if (s)
      return s.call(a);
    if (a && typeof a.length == "number")
      return {
        next: function() {
          return a && Q >= a.length && (a = void 0), { value: a && a[Q++], done: !a };
        }
      };
    throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(Qr, "__esModule", { value: !0 }), Qr.SVGmfenced = void 0;
  var r = a3(), n = mi, i = i8, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.toSVG = function(s) {
      var Q = this.standardSVGnode(s);
      this.setChildrenParent(this.mrow), this.mrow.toSVG(Q), this.setChildrenParent(this);
    }, T.prototype.setChildrenParent = function(s) {
      var Q, u;
      try {
        for (var l = t(this.childNodes), c = l.next(); !c.done; c = l.next()) {
          var f = c.value;
          f.parent = s;
        }
      } catch (d) {
        Q = { error: d };
      } finally {
        try {
          c && !c.done && (u = l.return) && u.call(l);
        } finally {
          if (Q)
            throw Q.error;
        }
      }
    }, T.kind = i.MmlMfenced.prototype.kind, T;
  }((0, n.CommonMfencedMixin)(r.SVGWrapper));
  return Qr.SVGmfenced = o, Qr;
}
var W6 = {}, sr = {}, vi = {}, Ug = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), HQ = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Au = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, a0 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(vi, "__esModule", { value: !0 });
vi.CommonScriptbaseMixin = void 0;
var Xg = T2;
function qg(e) {
  var t;
  return t = function(r) {
    Ug(n, r);
    function n() {
      for (var i = [], o = 0; o < arguments.length; o++)
        i[o] = arguments[o];
      var a = r.apply(this, Au([], HQ(i), !1)) || this;
      a.baseScale = 1, a.baseIc = 0, a.baseRemoveIc = !1, a.baseIsChar = !1, a.baseHasAccentOver = null, a.baseHasAccentUnder = null, a.isLineAbove = !1, a.isLineBelow = !1, a.isMathAccent = !1;
      var T = a.baseCore = a.getBaseCore();
      return T && (a.setBaseAccentsFor(T), a.baseScale = a.getBaseScale(), a.baseIc = a.getBaseIc(), a.baseIsChar = a.isCharBase(), a.isMathAccent = a.baseIsChar && a.scriptChild && !!a.scriptChild.coreMO().node.getProperty("mathaccent"), a.checkLineAccents(), a.baseRemoveIc = !a.isLineAbove && !a.isLineBelow && (!a.constructor.useIC || a.isMathAccent)), a;
    }
    return Object.defineProperty(n.prototype, "baseChild", {
      get: function() {
        return this.childNodes[this.node.base];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "scriptChild", {
      get: function() {
        return this.childNodes[1];
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.getBaseCore = function() {
      for (var i = this.getSemanticBase() || this.childNodes[0]; i && (i.childNodes.length === 1 && (i.node.isKind("mrow") || i.node.isKind("TeXAtom") && i.node.texClass !== Xg.TEXCLASS.VCENTER || i.node.isKind("mstyle") || i.node.isKind("mpadded") || i.node.isKind("mphantom") || i.node.isKind("semantics")) || i.node.isKind("munderover") && i.isMathAccent); )
        this.setBaseAccentsFor(i), i = i.childNodes[0];
      return i || (this.baseHasAccentOver = this.baseHasAccentUnder = !1), i || this.childNodes[0];
    }, n.prototype.setBaseAccentsFor = function(i) {
      i.node.isKind("munderover") && (this.baseHasAccentOver === null && (this.baseHasAccentOver = !!i.node.attributes.get("accent")), this.baseHasAccentUnder === null && (this.baseHasAccentUnder = !!i.node.attributes.get("accentunder")));
    }, n.prototype.getSemanticBase = function() {
      var i = this.node.attributes.getExplicit("data-semantic-fencepointer");
      return this.getBaseFence(this.baseChild, i);
    }, n.prototype.getBaseFence = function(i, o) {
      var a, T;
      if (!i || !i.node.attributes || !o)
        return null;
      if (i.node.attributes.getExplicit("data-semantic-id") === o)
        return i;
      try {
        for (var s = a0(i.childNodes), Q = s.next(); !Q.done; Q = s.next()) {
          var u = Q.value, l = this.getBaseFence(u, o);
          if (l)
            return l;
        }
      } catch (c) {
        a = { error: c };
      } finally {
        try {
          Q && !Q.done && (T = s.return) && T.call(s);
        } finally {
          if (a)
            throw a.error;
        }
      }
      return null;
    }, n.prototype.getBaseScale = function() {
      for (var i = this.baseCore, o = 1; i && i !== this; ) {
        var a = i.getOuterBBox();
        o *= a.rscale, i = i.parent;
      }
      return o;
    }, n.prototype.getBaseIc = function() {
      return this.baseCore.getOuterBBox().ic * this.baseScale;
    }, n.prototype.getAdjustedIc = function() {
      var i = this.baseCore.getOuterBBox();
      return (i.ic ? 1.05 * i.ic + 0.05 : 0) * this.baseScale;
    }, n.prototype.isCharBase = function() {
      var i = this.baseCore;
      return (i.node.isKind("mo") && i.size === null || i.node.isKind("mi") || i.node.isKind("mn")) && i.bbox.rscale === 1 && Array.from(i.getText()).length === 1;
    }, n.prototype.checkLineAccents = function() {
      if (this.node.isKind("munderover"))
        if (this.node.isKind("mover"))
          this.isLineAbove = this.isLineAccent(this.scriptChild);
        else if (this.node.isKind("munder"))
          this.isLineBelow = this.isLineAccent(this.scriptChild);
        else {
          var i = this;
          this.isLineAbove = this.isLineAccent(i.overChild), this.isLineBelow = this.isLineAccent(i.underChild);
        }
    }, n.prototype.isLineAccent = function(i) {
      var o = i.coreMO().node;
      return o.isToken && o.getText() === "―";
    }, n.prototype.getBaseWidth = function() {
      var i = this.baseChild.getOuterBBox();
      return i.w * i.rscale - (this.baseRemoveIc ? this.baseIc : 0) + this.font.params.extra_ic;
    }, n.prototype.computeBBox = function(i, o) {
      o === void 0 && (o = !1);
      var a = this.getBaseWidth(), T = HQ(this.getOffset(), 2), s = T[0], Q = T[1];
      i.append(this.baseChild.getOuterBBox()), i.combine(this.scriptChild.getOuterBBox(), a + s, Q), i.w += this.font.params.scriptspace, i.clean(), this.setChildPWidths(o);
    }, n.prototype.getOffset = function() {
      return [0, 0];
    }, n.prototype.baseCharZero = function(i) {
      var o = !!this.baseCore.node.attributes.get("largeop"), a = this.baseScale;
      return this.baseIsChar && !o && a === 1 ? 0 : i;
    }, n.prototype.getV = function() {
      var i = this.baseCore.getOuterBBox(), o = this.scriptChild.getOuterBBox(), a = this.font.params, T = this.length2em(this.node.attributes.get("subscriptshift"), a.sub1);
      return Math.max(this.baseCharZero(i.d * this.baseScale + a.sub_drop * o.rscale), T, o.h * o.rscale - 4 / 5 * a.x_height);
    }, n.prototype.getU = function() {
      var i = this.baseCore.getOuterBBox(), o = this.scriptChild.getOuterBBox(), a = this.font.params, T = this.node.attributes.getList("displaystyle", "superscriptshift"), s = this.node.getProperty("texprimestyle"), Q = s ? a.sup3 : T.displaystyle ? a.sup1 : a.sup2, u = this.length2em(T.superscriptshift, Q);
      return Math.max(this.baseCharZero(i.h * this.baseScale - a.sup_drop * o.rscale), u, o.d * o.rscale + 1 / 4 * a.x_height);
    }, n.prototype.hasMovableLimits = function() {
      var i = this.node.attributes.get("displaystyle"), o = this.baseChild.coreMO().node;
      return !i && !!o.attributes.get("movablelimits");
    }, n.prototype.getOverKU = function(i, o) {
      var a = this.node.attributes.get("accent"), T = this.font.params, s = o.d * o.rscale, Q = T.rule_thickness * T.separation_factor, u = this.baseHasAccentOver ? Q : 0, l = this.isLineAbove ? 3 * T.rule_thickness : Q, c = (a ? l : Math.max(T.big_op_spacing1, T.big_op_spacing3 - Math.max(0, s))) - u;
      return [c, i.h * i.rscale + c + s];
    }, n.prototype.getUnderKV = function(i, o) {
      var a = this.node.attributes.get("accentunder"), T = this.font.params, s = o.h * o.rscale, Q = T.rule_thickness * T.separation_factor, u = this.baseHasAccentUnder ? Q : 0, l = this.isLineBelow ? 3 * T.rule_thickness : Q, c = (a ? l : Math.max(T.big_op_spacing2, T.big_op_spacing4 - s)) - u;
      return [c, -(i.d * i.rscale + c + s)];
    }, n.prototype.getDeltaW = function(i, o) {
      var a, T, s, Q;
      o === void 0 && (o = [0, 0, 0]);
      var u = this.node.attributes.get("align"), l = i.map(function(M) {
        return M.w * M.rscale;
      });
      l[0] -= this.baseRemoveIc && !this.baseCore.node.attributes.get("largeop") ? this.baseIc : 0;
      var c = Math.max.apply(Math, Au([], HQ(l), !1)), f = [], d = 0;
      try {
        for (var m = a0(l.keys()), p = m.next(); !p.done; p = m.next()) {
          var v = p.value;
          f[v] = (u === "center" ? (c - l[v]) / 2 : u === "right" ? c - l[v] : 0) + o[v], f[v] < d && (d = -f[v]);
        }
      } catch (M) {
        a = { error: M };
      } finally {
        try {
          p && !p.done && (T = m.return) && T.call(m);
        } finally {
          if (a)
            throw a.error;
        }
      }
      if (d)
        try {
          for (var H = a0(f.keys()), E = H.next(); !E.done; E = H.next()) {
            var v = E.value;
            f[v] += d;
          }
        } catch (M) {
          s = { error: M };
        } finally {
          try {
            E && !E.done && (Q = H.return) && Q.call(H);
          } finally {
            if (s)
              throw s.error;
          }
        }
      return [1, 2].map(function(M) {
        return f[M] += i[M] ? i[M].dx * i[0].scale : 0;
      }), f;
    }, n.prototype.getDelta = function(i) {
      i === void 0 && (i = !1);
      var o = this.node.attributes.get("accent"), a = this.baseCore.getOuterBBox(), T = a.sk, s = a.ic;
      return ((o && !i ? T : 0) + this.font.skewIcFactor * s) * this.baseScale;
    }, n.prototype.stretchChildren = function() {
      var i, o, a, T, s, Q, u = [];
      try {
        for (var l = a0(this.childNodes), c = l.next(); !c.done; c = l.next()) {
          var f = c.value;
          f.canStretch(2) && u.push(f);
        }
      } catch ($) {
        i = { error: $ };
      } finally {
        try {
          c && !c.done && (o = l.return) && o.call(l);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var d = u.length, m = this.childNodes.length;
      if (d && m > 1) {
        var p = 0, v = d > 1 && d === m;
        try {
          for (var H = a0(this.childNodes), E = H.next(); !E.done; E = H.next()) {
            var f = E.value, M = f.stretch.dir === 0;
            if (v || M) {
              var C = f.getOuterBBox(M), w = C.w, S = C.rscale;
              w * S > p && (p = w * S);
            }
          }
        } catch ($) {
          a = { error: $ };
        } finally {
          try {
            E && !E.done && (T = H.return) && T.call(H);
          } finally {
            if (a)
              throw a.error;
          }
        }
        try {
          for (var D = a0(u), k = D.next(); !k.done; k = D.next()) {
            var f = k.value;
            f.coreMO().getStretchedVariant([p / f.bbox.rscale]);
          }
        } catch ($) {
          s = { error: $ };
        } finally {
          try {
            k && !k.done && (Q = D.return) && Q.call(D);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
    }, n;
  }(e), t.useIC = !0, t;
}
vi.CommonScriptbaseMixin = qg;
var Du;
function Jg() {
  if (Du)
    return sr;
  Du = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }(), t = b && b.__read || function(o, a) {
    var T = typeof Symbol == "function" && o[Symbol.iterator];
    if (!T)
      return o;
    var s = T.call(o), Q, u = [], l;
    try {
      for (; (a === void 0 || a-- > 0) && !(Q = s.next()).done; )
        u.push(Q.value);
    } catch (c) {
      l = { error: c };
    } finally {
      try {
        Q && !Q.done && (T = s.return) && T.call(s);
      } finally {
        if (l)
          throw l.error;
      }
    }
    return u;
  };
  Object.defineProperty(sr, "__esModule", { value: !0 }), sr.SVGscriptbase = void 0;
  var r = a3(), n = vi, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.prototype.toSVG = function(T) {
      var s = this.standardSVGnode(T), Q = this.getBaseWidth(), u = t(this.getOffset(), 2), l = u[0], c = u[1];
      this.baseChild.toSVG(s), this.scriptChild.toSVG(s), this.scriptChild.place(Q + l, c);
    }, a.kind = "scriptbase", a;
  }((0, n.CommonScriptbaseMixin)(r.SVGWrapper));
  return sr.SVGscriptbase = i, sr;
}
var H6 = {}, Ss = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), EQ = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
};
Object.defineProperty(H6, "__esModule", { value: !0 });
H6.CommonMsubsupMixin = H6.CommonMsupMixin = H6.CommonMsubMixin = void 0;
function Yg(e) {
  var t;
  return t = function(r) {
    Ss(n, r);
    function n() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return Object.defineProperty(n.prototype, "scriptChild", {
      get: function() {
        return this.childNodes[this.node.sub];
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.getOffset = function() {
      return [0, -this.getV()];
    }, n;
  }(e), t.useIC = !1, t;
}
H6.CommonMsubMixin = Yg;
function Kg(e) {
  return function(t) {
    Ss(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(r.prototype, "scriptChild", {
      get: function() {
        return this.childNodes[this.node.sup];
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.getOffset = function() {
      var n = this.getAdjustedIc() - (this.baseRemoveIc ? 0 : this.baseIc);
      return [n, this.getU()];
    }, r;
  }(e);
}
H6.CommonMsupMixin = Kg;
function ex(e) {
  var t;
  return t = function(r) {
    Ss(n, r);
    function n() {
      var i = r !== null && r.apply(this, arguments) || this;
      return i.UVQ = null, i;
    }
    return Object.defineProperty(n.prototype, "subChild", {
      get: function() {
        return this.childNodes[this.node.sub];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "supChild", {
      get: function() {
        return this.childNodes[this.node.sup];
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.computeBBox = function(i, o) {
      o === void 0 && (o = !1);
      var a = this.baseChild.getOuterBBox(), T = EQ([this.subChild.getOuterBBox(), this.supChild.getOuterBBox()], 2), s = T[0], Q = T[1];
      i.empty(), i.append(a);
      var u = this.getBaseWidth(), l = this.getAdjustedIc(), c = EQ(this.getUVQ(), 2), f = c[0], d = c[1];
      i.combine(s, u, d), i.combine(Q, u + l, f), i.w += this.font.params.scriptspace, i.clean(), this.setChildPWidths(o);
    }, n.prototype.getUVQ = function(i, o) {
      i === void 0 && (i = this.subChild.getOuterBBox()), o === void 0 && (o = this.supChild.getOuterBBox());
      var a = this.baseCore.getOuterBBox();
      if (this.UVQ)
        return this.UVQ;
      var T = this.font.params, s = 3 * T.rule_thickness, Q = this.length2em(this.node.attributes.get("subscriptshift"), T.sub2), u = this.baseCharZero(a.d * this.baseScale + T.sub_drop * i.rscale), l = EQ([this.getU(), Math.max(u, Q)], 2), c = l[0], f = l[1], d = c - o.d * o.rscale - (i.h * i.rscale - f);
      if (d < s) {
        f += s - d;
        var m = 4 / 5 * T.x_height - (c - o.d * o.rscale);
        m > 0 && (c += m, f -= m);
      }
      return c = Math.max(this.length2em(this.node.attributes.get("superscriptshift"), c), c), f = Math.max(this.length2em(this.node.attributes.get("subscriptshift"), f), f), d = c - o.d * o.rscale - (i.h * i.rscale - f), this.UVQ = [c, -f, d], this.UVQ;
    }, n;
  }(e), t.useIC = !1, t;
}
H6.CommonMsubsupMixin = ex;
var E6 = {}, Cs = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), S0 = b && b.__assign || function() {
  return S0 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, S0.apply(this, arguments);
};
Object.defineProperty(E6, "__esModule", { value: !0 });
E6.MmlMsup = E6.MmlMsub = E6.MmlMsubsup = void 0;
var ku = T2, Sr = function(e) {
  Cs(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "msubsup";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 3;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "base", {
    get: function() {
      return 0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "sub", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "sup", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    var a = this.childNodes;
    a[0].setInheritedAttributes(r, n, i, o), a[1].setInheritedAttributes(r, !1, i + 1, o || this.sub === 1), a[2] && a[2].setInheritedAttributes(r, !1, i + 1, o || this.sub === 2);
  }, t.defaults = S0(S0({}, ku.AbstractMmlBaseNode.defaults), { subscriptshift: "", superscriptshift: "" }), t;
}(ku.AbstractMmlBaseNode);
E6.MmlMsubsup = Sr;
var tx = function(e) {
  Cs(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "msub";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = S0({}, Sr.defaults), t;
}(Sr);
E6.MmlMsub = tx;
var rx = function(e) {
  Cs(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "msup";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "sup", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "sub", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = S0({}, Sr.defaults), t;
}(Sr);
E6.MmlMsup = rx;
var Iu;
function Vs() {
  if (Iu)
    return W6;
  Iu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var u = function(l, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var m in d)
          Object.prototype.hasOwnProperty.call(d, m) && (f[m] = d[m]);
      }, u(l, c);
    };
    return function(l, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
      u(l, c);
      function f() {
        this.constructor = l;
      }
      l.prototype = c === null ? Object.create(c) : (f.prototype = c.prototype, new f());
    };
  }(), t = b && b.__read || function(u, l) {
    var c = typeof Symbol == "function" && u[Symbol.iterator];
    if (!c)
      return u;
    var f = c.call(u), d, m = [], p;
    try {
      for (; (l === void 0 || l-- > 0) && !(d = f.next()).done; )
        m.push(d.value);
    } catch (v) {
      p = { error: v };
    } finally {
      try {
        d && !d.done && (c = f.return) && c.call(f);
      } finally {
        if (p)
          throw p.error;
      }
    }
    return m;
  };
  Object.defineProperty(W6, "__esModule", { value: !0 }), W6.SVGmsubsup = W6.SVGmsup = W6.SVGmsub = void 0;
  var r = Jg(), n = H6, i = H6, o = H6, a = E6, T = function(u) {
    e(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.kind = a.MmlMsub.prototype.kind, l;
  }((0, n.CommonMsubMixin)(r.SVGscriptbase));
  W6.SVGmsub = T;
  var s = function(u) {
    e(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.kind = a.MmlMsup.prototype.kind, l;
  }((0, i.CommonMsupMixin)(r.SVGscriptbase));
  W6.SVGmsup = s;
  var Q = function(u) {
    e(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.prototype.toSVG = function(c) {
      var f = this.standardSVGnode(c), d = t([this.baseChild, this.supChild, this.subChild], 3), m = d[0], p = d[1], v = d[2], H = this.getBaseWidth(), E = this.getAdjustedIc(), M = t(this.getUVQ(), 2), C = M[0], w = M[1];
      m.toSVG(f), p.toSVG(f), v.toSVG(f), v.place(H, w), p.place(H + E, C);
    }, l.kind = a.MmlMsubsup.prototype.kind, l;
  }((0, o.CommonMsubsupMixin)(r.SVGscriptbase));
  return W6.SVGmsubsup = Q, W6;
}
var G6 = {}, b6 = {}, _s = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), C0 = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Os = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(b6, "__esModule", { value: !0 });
b6.CommonMunderoverMixin = b6.CommonMoverMixin = b6.CommonMunderMixin = void 0;
function nx(e) {
  return function(t) {
    _s(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Os([], C0(n), !1)) || this;
      return o.stretchChildren(), o;
    }
    return Object.defineProperty(r.prototype, "scriptChild", {
      get: function() {
        return this.childNodes[this.node.under];
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.computeBBox = function(n, i) {
      if (i === void 0 && (i = !1), this.hasMovableLimits()) {
        t.prototype.computeBBox.call(this, n, i);
        return;
      }
      n.empty();
      var o = this.baseChild.getOuterBBox(), a = this.scriptChild.getOuterBBox(), T = this.getUnderKV(o, a)[1], s = this.isLineBelow ? 0 : this.getDelta(!0), Q = C0(this.getDeltaW([o, a], [0, -s]), 2), u = Q[0], l = Q[1];
      n.combine(o, u, 0), n.combine(a, l, T), n.d += this.font.params.big_op_spacing5, n.clean(), this.setChildPWidths(i);
    }, r;
  }(e);
}
b6.CommonMunderMixin = nx;
function ix(e) {
  return function(t) {
    _s(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Os([], C0(n), !1)) || this;
      return o.stretchChildren(), o;
    }
    return Object.defineProperty(r.prototype, "scriptChild", {
      get: function() {
        return this.childNodes[this.node.over];
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.computeBBox = function(n) {
      if (this.hasMovableLimits()) {
        t.prototype.computeBBox.call(this, n);
        return;
      }
      n.empty();
      var i = this.baseChild.getOuterBBox(), o = this.scriptChild.getOuterBBox();
      this.node.attributes.get("accent") && (i.h = Math.max(i.h, this.font.params.x_height * i.scale));
      var a = this.getOverKU(i, o)[1], T = this.isLineAbove ? 0 : this.getDelta(), s = C0(this.getDeltaW([i, o], [0, T]), 2), Q = s[0], u = s[1];
      n.combine(i, Q, 0), n.combine(o, u, a), n.h += this.font.params.big_op_spacing5, n.clean();
    }, r;
  }(e);
}
b6.CommonMoverMixin = ix;
function ox(e) {
  return function(t) {
    _s(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Os([], C0(n), !1)) || this;
      return o.stretchChildren(), o;
    }
    return Object.defineProperty(r.prototype, "underChild", {
      get: function() {
        return this.childNodes[this.node.under];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "overChild", {
      get: function() {
        return this.childNodes[this.node.over];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "subChild", {
      get: function() {
        return this.underChild;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "supChild", {
      get: function() {
        return this.overChild;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.computeBBox = function(n) {
      if (this.hasMovableLimits()) {
        t.prototype.computeBBox.call(this, n);
        return;
      }
      n.empty();
      var i = this.overChild.getOuterBBox(), o = this.baseChild.getOuterBBox(), a = this.underChild.getOuterBBox();
      this.node.attributes.get("accent") && (o.h = Math.max(o.h, this.font.params.x_height * o.scale));
      var T = this.getOverKU(o, i)[1], s = this.getUnderKV(o, a)[1], Q = this.getDelta(), u = C0(this.getDeltaW([o, a, i], [0, this.isLineBelow ? 0 : -Q, this.isLineAbove ? 0 : Q]), 3), l = u[0], c = u[1], f = u[2];
      n.combine(o, l, 0), n.combine(i, f, T), n.combine(a, c, s);
      var d = this.font.params.big_op_spacing5;
      n.h += d, n.d += d, n.clean();
    }, r;
  }(e);
}
b6.CommonMunderoverMixin = ox;
var e5 = {}, As = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), V0 = b && b.__assign || function() {
  return V0 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, V0.apply(this, arguments);
};
Object.defineProperty(e5, "__esModule", { value: !0 });
e5.MmlMover = e5.MmlMunder = e5.MmlMunderover = void 0;
var Ru = T2, Cr = function(e) {
  As(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "munderover";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 3;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "base", {
    get: function() {
      return 0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "under", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "over", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    var a = this.childNodes;
    a[0].setInheritedAttributes(r, n, i, o || !!a[this.over]);
    var T = !!(!n && a[0].coreMO().attributes.get("movablelimits")), s = this.constructor.ACCENTS;
    a[1].setInheritedAttributes(r, !1, this.getScriptlevel(s[1], T, i), o || this.under === 1), this.setInheritedAccent(1, s[1], n, i, o, T), a[2] && (a[2].setInheritedAttributes(r, !1, this.getScriptlevel(s[2], T, i), o || this.under === 2), this.setInheritedAccent(2, s[2], n, i, o, T));
  }, t.prototype.getScriptlevel = function(r, n, i) {
    return (n || !this.attributes.get(r)) && i++, i;
  }, t.prototype.setInheritedAccent = function(r, n, i, o, a, T) {
    var s = this.childNodes[r];
    if (this.attributes.getExplicit(n) == null && s.isEmbellished) {
      var Q = s.coreMO().attributes.get("accent");
      this.attributes.setInherited(n, Q), Q !== this.attributes.getDefault(n) && s.setInheritedAttributes({}, i, this.getScriptlevel(n, T, o), a);
    }
  }, t.defaults = V0(V0({}, Ru.AbstractMmlBaseNode.defaults), { accent: !1, accentunder: !1, align: "center" }), t.ACCENTS = ["", "accentunder", "accent"], t;
}(Ru.AbstractMmlBaseNode);
e5.MmlMunderover = Cr;
var ax = function(e) {
  As(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "munder";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = V0({}, Cr.defaults), t;
}(Cr);
e5.MmlMunder = ax;
var Qx = function(e) {
  As(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mover";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "over", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "under", {
    get: function() {
      return 2;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = V0({}, Cr.defaults), t.ACCENTS = ["", "accent", "accentunder"], t;
}(Cr);
e5.MmlMover = Qx;
var Nu;
function Tx() {
  if (Nu)
    return G6;
  Nu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var u = function(l, c) {
      return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, d) {
        f.__proto__ = d;
      } || function(f, d) {
        for (var m in d)
          Object.prototype.hasOwnProperty.call(d, m) && (f[m] = d[m]);
      }, u(l, c);
    };
    return function(l, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
      u(l, c);
      function f() {
        this.constructor = l;
      }
      l.prototype = c === null ? Object.create(c) : (f.prototype = c.prototype, new f());
    };
  }(), t = b && b.__read || function(u, l) {
    var c = typeof Symbol == "function" && u[Symbol.iterator];
    if (!c)
      return u;
    var f = c.call(u), d, m = [], p;
    try {
      for (; (l === void 0 || l-- > 0) && !(d = f.next()).done; )
        m.push(d.value);
    } catch (v) {
      p = { error: v };
    } finally {
      try {
        d && !d.done && (c = f.return) && c.call(f);
      } finally {
        if (p)
          throw p.error;
      }
    }
    return m;
  };
  Object.defineProperty(G6, "__esModule", { value: !0 }), G6.SVGmunderover = G6.SVGmover = G6.SVGmunder = void 0;
  var r = Vs(), n = b6, i = b6, o = b6, a = e5, T = function(u) {
    e(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.prototype.toSVG = function(c) {
      if (this.hasMovableLimits()) {
        u.prototype.toSVG.call(this, c);
        return;
      }
      var f = this.standardSVGnode(c), d = t([this.baseChild, this.scriptChild], 2), m = d[0], p = d[1], v = t([m.getOuterBBox(), p.getOuterBBox()], 2), H = v[0], E = v[1];
      m.toSVG(f), p.toSVG(f);
      var M = this.isLineBelow ? 0 : this.getDelta(!0), C = this.getUnderKV(H, E)[1], w = t(this.getDeltaW([H, E], [0, -M]), 2), S = w[0], D = w[1];
      m.place(S, 0), p.place(D, C);
    }, l.kind = a.MmlMunder.prototype.kind, l;
  }((0, n.CommonMunderMixin)(r.SVGmsub));
  G6.SVGmunder = T;
  var s = function(u) {
    e(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.prototype.toSVG = function(c) {
      if (this.hasMovableLimits()) {
        u.prototype.toSVG.call(this, c);
        return;
      }
      var f = this.standardSVGnode(c), d = t([this.baseChild, this.scriptChild], 2), m = d[0], p = d[1], v = t([m.getOuterBBox(), p.getOuterBBox()], 2), H = v[0], E = v[1];
      m.toSVG(f), p.toSVG(f);
      var M = this.isLineAbove ? 0 : this.getDelta(), C = this.getOverKU(H, E)[1], w = t(this.getDeltaW([H, E], [0, M]), 2), S = w[0], D = w[1];
      m.place(S, 0), p.place(D, C);
    }, l.kind = a.MmlMover.prototype.kind, l;
  }((0, i.CommonMoverMixin)(r.SVGmsup));
  G6.SVGmover = s;
  var Q = function(u) {
    e(l, u);
    function l() {
      return u !== null && u.apply(this, arguments) || this;
    }
    return l.prototype.toSVG = function(c) {
      if (this.hasMovableLimits()) {
        u.prototype.toSVG.call(this, c);
        return;
      }
      var f = this.standardSVGnode(c), d = t([this.baseChild, this.overChild, this.underChild], 3), m = d[0], p = d[1], v = d[2], H = t([m.getOuterBBox(), p.getOuterBBox(), v.getOuterBBox()], 3), E = H[0], M = H[1], C = H[2];
      m.toSVG(f), v.toSVG(f), p.toSVG(f);
      var w = this.getDelta(), S = this.getOverKU(E, M)[1], D = this.getUnderKV(E, C)[1], k = t(this.getDeltaW([E, C, M], [0, this.isLineBelow ? 0 : -w, this.isLineAbove ? 0 : w]), 3), $ = k[0], z = k[1], j = k[2];
      m.place($, 0), v.place(z, D), p.place(j, S);
    }, l.kind = a.MmlMunderover.prototype.kind, l;
  }((0, o.CommonMunderoverMixin)(r.SVGmsubsup));
  return G6.SVGmunderover = Q, G6;
}
var Se = {}, Jd = {};
(function(e) {
  var t = b && b.__extends || /* @__PURE__ */ function() {
    var T = function(s, Q) {
      return T = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, l) {
        u.__proto__ = l;
      } || function(u, l) {
        for (var c in l)
          Object.prototype.hasOwnProperty.call(l, c) && (u[c] = l[c]);
      }, T(s, Q);
    };
    return function(s, Q) {
      if (typeof Q != "function" && Q !== null)
        throw new TypeError("Class extends value " + String(Q) + " is not a constructor or null");
      T(s, Q);
      function u() {
        this.constructor = s;
      }
      s.prototype = Q === null ? Object.create(Q) : (u.prototype = Q.prototype, new u());
    };
  }(), r = b && b.__read || function(T, s) {
    var Q = typeof Symbol == "function" && T[Symbol.iterator];
    if (!Q)
      return T;
    var u = Q.call(T), l, c = [], f;
    try {
      for (; (s === void 0 || s-- > 0) && !(l = u.next()).done; )
        c.push(l.value);
    } catch (d) {
      f = { error: d };
    } finally {
      try {
        l && !l.done && (Q = u.return) && Q.call(u);
      } finally {
        if (f)
          throw f.error;
      }
    }
    return c;
  }, n = b && b.__spreadArray || function(T, s, Q) {
    if (Q || arguments.length === 2)
      for (var u = 0, l = s.length, c; u < l; u++)
        (c || !(u in s)) && (c || (c = Array.prototype.slice.call(s, 0, u)), c[u] = s[u]);
    return T.concat(c || Array.prototype.slice.call(s));
  }, i = b && b.__values || function(T) {
    var s = typeof Symbol == "function" && Symbol.iterator, Q = s && T[s], u = 0;
    if (Q)
      return Q.call(T);
    if (T && typeof T.length == "number")
      return {
        next: function() {
          return T && u >= T.length && (T = void 0), { value: T && T[u++], done: !T };
        }
      };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommonMmultiscriptsMixin = e.ScriptNames = e.NextScript = void 0;
  var o = a6;
  e.NextScript = {
    base: "subList",
    subList: "supList",
    supList: "subList",
    psubList: "psupList",
    psupList: "psubList"
  }, e.ScriptNames = ["sup", "sup", "psup", "psub"];
  function a(T) {
    return function(s) {
      t(Q, s);
      function Q() {
        for (var u = [], l = 0; l < arguments.length; l++)
          u[l] = arguments[l];
        var c = s.apply(this, n([], r(u), !1)) || this;
        return c.scriptData = null, c.firstPrescript = 0, c.getScriptData(), c;
      }
      return Q.prototype.combinePrePost = function(u, l) {
        var c = new o.BBox(u);
        return c.combine(l, 0, 0), c;
      }, Q.prototype.computeBBox = function(u, l) {
        l === void 0 && (l = !1);
        var c = this.font.params.scriptspace, f = this.scriptData, d = this.combinePrePost(f.sub, f.psub), m = this.combinePrePost(f.sup, f.psup), p = r(this.getUVQ(d, m), 2), v = p[0], H = p[1];
        if (u.empty(), f.numPrescripts && (u.combine(f.psup, c, v), u.combine(f.psub, c, H)), u.append(f.base), f.numScripts) {
          var E = u.w;
          u.combine(f.sup, E, v), u.combine(f.sub, E, H), u.w += c;
        }
        u.clean(), this.setChildPWidths(l);
      }, Q.prototype.getScriptData = function() {
        var u = this.scriptData = {
          base: null,
          sub: o.BBox.empty(),
          sup: o.BBox.empty(),
          psub: o.BBox.empty(),
          psup: o.BBox.empty(),
          numPrescripts: 0,
          numScripts: 0
        }, l = this.getScriptBBoxLists();
        this.combineBBoxLists(u.sub, u.sup, l.subList, l.supList), this.combineBBoxLists(u.psub, u.psup, l.psubList, l.psupList), u.base = l.base[0], u.numPrescripts = l.psubList.length, u.numScripts = l.subList.length;
      }, Q.prototype.getScriptBBoxLists = function() {
        var u, l, c = {
          base: [],
          subList: [],
          supList: [],
          psubList: [],
          psupList: []
        }, f = "base";
        try {
          for (var d = i(this.childNodes), m = d.next(); !m.done; m = d.next()) {
            var p = m.value;
            p.node.isKind("mprescripts") ? f = "psubList" : (c[f].push(p.getOuterBBox()), f = e.NextScript[f]);
          }
        } catch (v) {
          u = { error: v };
        } finally {
          try {
            m && !m.done && (l = d.return) && l.call(d);
          } finally {
            if (u)
              throw u.error;
          }
        }
        return this.firstPrescript = c.subList.length + c.supList.length + 2, this.padLists(c.subList, c.supList), this.padLists(c.psubList, c.psupList), c;
      }, Q.prototype.padLists = function(u, l) {
        u.length > l.length && l.push(o.BBox.empty());
      }, Q.prototype.combineBBoxLists = function(u, l, c, f) {
        for (var d = 0; d < c.length; d++) {
          var m = r(this.getScaledWHD(c[d]), 3), p = m[0], v = m[1], H = m[2], E = r(this.getScaledWHD(f[d]), 3), M = E[0], C = E[1], w = E[2], S = Math.max(p, M);
          u.w += S, l.w += S, v > u.h && (u.h = v), H > u.d && (u.d = H), C > l.h && (l.h = C), w > l.d && (l.d = w);
        }
      }, Q.prototype.getScaledWHD = function(u) {
        var l = u.w, c = u.h, f = u.d, d = u.rscale;
        return [l * d, c * d, f * d];
      }, Q.prototype.getUVQ = function(u, l) {
        var c;
        if (!this.UVQ) {
          var f = r([0, 0, 0], 3), d = f[0], m = f[1], p = f[2];
          u.h === 0 && u.d === 0 ? d = this.getU() : l.h === 0 && l.d === 0 ? d = -this.getV() : (c = r(s.prototype.getUVQ.call(this, u, l), 3), d = c[0], m = c[1], p = c[2]), this.UVQ = [d, m, p];
        }
        return this.UVQ;
      }, Q;
    }(T);
  }
  e.CommonMmultiscriptsMixin = a;
})(Jd);
var t5 = {}, Ds = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Vr = b && b.__assign || function() {
  return Vr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Vr.apply(this, arguments);
};
Object.defineProperty(t5, "__esModule", { value: !0 });
t5.MmlNone = t5.MmlMprescripts = t5.MmlMmultiscripts = void 0;
var h9 = T2, Pu = E6, sx = function(e) {
  Ds(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mmultiscripts";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    this.childNodes[0].setInheritedAttributes(r, n, i, o);
    for (var a = !1, T = 1, s = 0; T < this.childNodes.length; T++) {
      var Q = this.childNodes[T];
      if (Q.isKind("mprescripts")) {
        if (!a && (a = !0, T % 2 === 0)) {
          var u = this.factory.create("mrow");
          this.childNodes.splice(T, 0, u), u.parent = this, T++;
        }
      } else {
        var l = o || s % 2 === 0;
        Q.setInheritedAttributes(r, !1, i + 1, l), s++;
      }
    }
    this.childNodes.length % 2 === (a ? 1 : 0) && (this.appendChild(this.factory.create("mrow")), this.childNodes[this.childNodes.length - 1].setInheritedAttributes(r, !1, i + 1, o));
  }, t.prototype.verifyChildren = function(r) {
    for (var n = !1, i = r.fixMmultiscripts, o = 0; o < this.childNodes.length; o++) {
      var a = this.childNodes[o];
      a.isKind("mprescripts") && (n ? a.mError(a.kind + " can only appear once in " + this.kind, r, !0) : (n = !0, o % 2 === 0 && !i && this.mError("There must be an equal number of prescripts of each type", r)));
    }
    this.childNodes.length % 2 === (n ? 1 : 0) && !i && this.mError("There must be an equal number of scripts of each type", r), e.prototype.verifyChildren.call(this, r);
  }, t.defaults = Vr({}, Pu.MmlMsubsup.defaults), t;
}(Pu.MmlMsubsup);
t5.MmlMmultiscripts = sx;
var lx = function(e) {
  Ds(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mprescripts";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.verifyTree = function(r) {
    e.prototype.verifyTree.call(this, r), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", r, !0);
  }, t.defaults = Vr({}, h9.AbstractMmlNode.defaults), t;
}(h9.AbstractMmlNode);
t5.MmlMprescripts = lx;
var ux = function(e) {
  Ds(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "none";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.verifyTree = function(r) {
    e.prototype.verifyTree.call(this, r), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", r, !0);
  }, t.defaults = Vr({}, h9.AbstractMmlNode.defaults), t;
}(h9.AbstractMmlNode);
t5.MmlNone = ux;
var Bu;
function cx() {
  if (Bu)
    return Se;
  Bu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var s = function(Q, u) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var f in c)
          Object.prototype.hasOwnProperty.call(c, f) && (l[f] = c[f]);
      }, s(Q, u);
    };
    return function(Q, u) {
      if (typeof u != "function" && u !== null)
        throw new TypeError("Class extends value " + String(u) + " is not a constructor or null");
      s(Q, u);
      function l() {
        this.constructor = Q;
      }
      Q.prototype = u === null ? Object.create(u) : (l.prototype = u.prototype, new l());
    };
  }(), t = b && b.__read || function(s, Q) {
    var u = typeof Symbol == "function" && s[Symbol.iterator];
    if (!u)
      return s;
    var l = u.call(s), c, f = [], d;
    try {
      for (; (Q === void 0 || Q-- > 0) && !(c = l.next()).done; )
        f.push(c.value);
    } catch (m) {
      d = { error: m };
    } finally {
      try {
        c && !c.done && (u = l.return) && u.call(l);
      } finally {
        if (d)
          throw d.error;
      }
    }
    return f;
  };
  Object.defineProperty(Se, "__esModule", { value: !0 }), Se.SVGmmultiscripts = Se.AlignX = void 0;
  var r = Vs(), n = Jd, i = t5, o = Q3;
  function a(s) {
    return {
      left: function(Q, u) {
        return 0;
      },
      center: function(Q, u) {
        return (u - Q) / 2;
      },
      right: function(Q, u) {
        return u - Q;
      }
    }[s] || function(Q, u) {
      return 0;
    };
  }
  Se.AlignX = a;
  var T = function(s) {
    e(Q, s);
    function Q() {
      return s !== null && s.apply(this, arguments) || this;
    }
    return Q.prototype.toSVG = function(u) {
      var l = this.standardSVGnode(u), c = this.scriptData, f = this.node.getProperty("scriptalign") || "right left", d = t((0, o.split)(f + " " + f), 2), m = d[0], p = d[1], v = this.combinePrePost(c.sub, c.psub), H = this.combinePrePost(c.sup, c.psup), E = t(this.getUVQ(v, H), 2), M = E[0], C = E[1], w = 0;
      c.numPrescripts && (w = this.addScripts(0.05, M, C, this.firstPrescript, c.numPrescripts, m));
      var S = this.baseChild;
      S.toSVG(l), S.place(w, 0), w += S.getOuterBBox().w, c.numScripts && this.addScripts(w, M, C, 1, c.numScripts, p);
    }, Q.prototype.addScripts = function(u, l, c, f, d, m) {
      var p = this.adaptor, v = a(m), H = p.append(this.element, this.svg("g")), E = p.append(this.element, this.svg("g"));
      this.place(u, l, H), this.place(u, c, E);
      for (var M = f + 2 * d, C = 0; f < M; ) {
        var w = t([this.childNodes[f++], this.childNodes[f++]], 2), S = w[0], D = w[1], k = t([S.getOuterBBox(), D.getOuterBBox()], 2), $ = k[0], z = k[1], j = t([$.rscale, z.rscale], 2), J = j[0], i1 = j[1], t1 = Math.max($.w * J, z.w * i1);
        S.toSVG(E), D.toSVG(H), S.place(C + v($.w * J, t1), 0), D.place(C + v(z.w * i1, t1), 0), C += t1;
      }
      return u + C;
    }, Q.kind = i.MmlMmultiscripts.prototype.kind, Q;
  }((0, n.CommonMmultiscriptsMixin)(r.SVGmsubsup));
  return Se.SVGmmultiscripts = T, Se;
}
var lr = {}, Li = {}, _0 = {};
Object.defineProperty(_0, "__esModule", { value: !0 });
_0.max = _0.sum = void 0;
function fx(e) {
  return e.reduce(function(t, r) {
    return t + r;
  }, 0);
}
_0.sum = fx;
function dx(e) {
  return e.reduce(function(t, r) {
    return Math.max(t, r);
  }, 0);
}
_0.max = dx;
var hx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), y6 = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, px = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Hn = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(Li, "__esModule", { value: !0 });
Li.CommonMtableMixin = void 0;
var mx = a6, z6 = Q3, U6 = _0;
function vx(e) {
  return function(t) {
    hx(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, px([], y6(n), !1)) || this;
      o.numCols = 0, o.numRows = 0, o.data = null, o.pwidthCells = [], o.pWidth = 0, o.numCols = (0, U6.max)(o.tableRows.map(function(T) {
        return T.numCells;
      })), o.numRows = o.childNodes.length, o.hasLabels = o.childNodes.reduce(function(T, s) {
        return T || s.node.isKind("mlabeledtr");
      }, !1), o.findContainer(), o.isTop = !o.container || o.container.node.isKind("math") && !o.container.parent, o.isTop && (o.jax.table = o), o.getPercentageWidth();
      var a = o.node.attributes;
      return o.frame = a.get("frame") !== "none", o.fLine = o.frame && a.get("frame") ? 0.07 : 0, o.fSpace = o.frame ? o.convertLengths(o.getAttributeArray("framespacing")) : [0, 0], o.cSpace = o.convertLengths(o.getColumnAttributes("columnspacing")), o.rSpace = o.convertLengths(o.getRowAttributes("rowspacing")), o.cLines = o.getColumnAttributes("columnlines").map(function(T) {
        return T === "none" ? 0 : 0.07;
      }), o.rLines = o.getRowAttributes("rowlines").map(function(T) {
        return T === "none" ? 0 : 0.07;
      }), o.cWidths = o.getColumnWidths(), o.stretchRows(), o.stretchColumns(), o;
    }
    return Object.defineProperty(r.prototype, "tableRows", {
      get: function() {
        return this.childNodes;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.findContainer = function() {
      for (var n = this, i = n.parent; i && (i.node.notParent || i.node.isKind("mrow")); )
        n = i, i = i.parent;
      this.container = i, this.containerI = n.node.childPosition();
    }, r.prototype.getPercentageWidth = function() {
      if (this.hasLabels)
        this.bbox.pwidth = mx.BBox.fullWidth;
      else {
        var n = this.node.attributes.get("width");
        (0, z6.isPercent)(n) && (this.bbox.pwidth = n);
      }
    }, r.prototype.stretchRows = function() {
      for (var n = this.node.attributes.get("equalrows"), i = n ? this.getEqualRowHeight() : 0, o = n ? this.getTableData() : { H: [0], D: [0] }, a = o.H, T = o.D, s = this.tableRows, Q = 0; Q < this.numRows; Q++) {
        var u = n ? [(i + a[Q] - T[Q]) / 2, (i - a[Q] + T[Q]) / 2] : null;
        s[Q].stretchChildren(u);
      }
    }, r.prototype.stretchColumns = function() {
      for (var n = 0; n < this.numCols; n++) {
        var i = typeof this.cWidths[n] == "number" ? this.cWidths[n] : null;
        this.stretchColumn(n, i);
      }
    }, r.prototype.stretchColumn = function(n, i) {
      var o, a, T, s, Q, u, l = [];
      try {
        for (var c = Hn(this.tableRows), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, m = d.getChild(n);
          if (m) {
            var p = m.childNodes[0];
            p.stretch.dir === 0 && p.canStretch(2) && l.push(p);
          }
        }
      } catch ($) {
        o = { error: $ };
      } finally {
        try {
          f && !f.done && (a = c.return) && a.call(c);
        } finally {
          if (o)
            throw o.error;
        }
      }
      var v = l.length, H = this.childNodes.length;
      if (v && H > 1) {
        if (i === null) {
          i = 0;
          var E = v > 1 && v === H;
          try {
            for (var M = Hn(this.tableRows), C = M.next(); !C.done; C = M.next()) {
              var d = C.value, m = d.getChild(n);
              if (m) {
                var p = m.childNodes[0], w = p.stretch.dir === 0;
                if (E || w) {
                  var S = p.getBBox(w).w;
                  S > i && (i = S);
                }
              }
            }
          } catch ($) {
            T = { error: $ };
          } finally {
            try {
              C && !C.done && (s = M.return) && s.call(M);
            } finally {
              if (T)
                throw T.error;
            }
          }
        }
        try {
          for (var D = Hn(l), k = D.next(); !k.done; k = D.next()) {
            var p = k.value;
            p.coreMO().getStretchedVariant([i]);
          }
        } catch ($) {
          Q = { error: $ };
        } finally {
          try {
            k && !k.done && (u = D.return) && u.call(D);
          } finally {
            if (Q)
              throw Q.error;
          }
        }
      }
    }, r.prototype.getTableData = function() {
      if (this.data)
        return this.data;
      for (var n = new Array(this.numRows).fill(0), i = new Array(this.numRows).fill(0), o = new Array(this.numCols).fill(0), a = new Array(this.numRows), T = new Array(this.numRows), s = [0], Q = this.tableRows, u = 0; u < Q.length; u++) {
        for (var l = 0, c = Q[u], f = c.node.attributes.get("rowalign"), d = 0; d < c.numCells; d++) {
          var m = c.getChild(d);
          l = this.updateHDW(m, d, u, f, n, i, o, l), this.recordPWidthCell(m, d);
        }
        a[u] = n[u], T[u] = i[u], c.labeled && (l = this.updateHDW(c.childNodes[0], 0, u, f, n, i, s, l)), this.extendHD(u, n, i, l), this.extendHD(u, a, T, l);
      }
      var p = s[0];
      return this.data = { H: n, D: i, W: o, NH: a, ND: T, L: p }, this.data;
    }, r.prototype.updateHDW = function(n, i, o, a, T, s, Q, u) {
      var l = n.getBBox(), c = l.h, f = l.d, d = l.w, m = n.parent.bbox.rscale;
      n.parent.bbox.rscale !== 1 && (c *= m, f *= m, d *= m), this.node.getProperty("useHeight") && (c < 0.75 && (c = 0.75), f < 0.25 && (f = 0.25));
      var p = 0;
      return a = n.node.attributes.get("rowalign") || a, a !== "baseline" && a !== "axis" && (p = c + f, c = f = 0), c > T[o] && (T[o] = c), f > s[o] && (s[o] = f), p > u && (u = p), Q && d > Q[i] && (Q[i] = d), u;
    }, r.prototype.extendHD = function(n, i, o, a) {
      var T = (a - (i[n] + o[n])) / 2;
      T < 1e-5 || (i[n] += T, o[n] += T);
    }, r.prototype.recordPWidthCell = function(n, i) {
      n.childNodes[0] && n.childNodes[0].getBBox().pwidth && this.pwidthCells.push([n, i]);
    }, r.prototype.computeBBox = function(n, i) {
      var o = this.getTableData(), a = o.H, T = o.D, s, Q;
      if (this.node.attributes.get("equalrows")) {
        var u = this.getEqualRowHeight();
        s = (0, U6.sum)([].concat(this.rLines, this.rSpace)) + u * this.numRows;
      } else
        s = (0, U6.sum)(a.concat(T, this.rLines, this.rSpace));
      s += 2 * (this.fLine + this.fSpace[1]);
      var l = this.getComputedWidths();
      Q = (0, U6.sum)(l.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]);
      var c = this.node.attributes.get("width");
      c !== "auto" && (Q = Math.max(this.length2em(c, 0) + 2 * this.fLine, Q));
      var f = y6(this.getBBoxHD(s), 2), d = f[0], m = f[1];
      n.h = d, n.d = m, n.w = Q;
      var p = y6(this.getBBoxLR(), 2), v = p[0], H = p[1];
      n.L = v, n.R = H, (0, z6.isPercent)(c) || this.setColumnPWidths();
    }, r.prototype.setChildPWidths = function(n, i, o) {
      var a = this.node.attributes.get("width");
      if (!(0, z6.isPercent)(a))
        return !1;
      this.hasLabels || (this.bbox.pwidth = "", this.container.bbox.pwidth = "");
      var T = this.bbox, s = T.w, Q = T.L, u = T.R, l = this.node.attributes.get("data-width-includes-label"), c = Math.max(s, this.length2em(a, Math.max(i, Q + s + u))) - (l ? Q + u : 0), f = this.node.attributes.get("equalcolumns") ? Array(this.numCols).fill(this.percent(1 / Math.max(1, this.numCols))) : this.getColumnAttributes("columnwidth", 0);
      this.cWidths = this.getColumnWidthsFixed(f, c);
      var d = this.getComputedWidths();
      return this.pWidth = (0, U6.sum)(d.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]), this.isTop && (this.bbox.w = this.pWidth), this.setColumnPWidths(), this.pWidth !== s && this.parent.invalidateBBox(), this.pWidth !== s;
    }, r.prototype.setColumnPWidths = function() {
      var n, i, o = this.cWidths;
      try {
        for (var a = Hn(this.pwidthCells), T = a.next(); !T.done; T = a.next()) {
          var s = y6(T.value, 2), Q = s[0], u = s[1];
          Q.setChildPWidths(!1, o[u]) && (Q.invalidateBBox(), Q.getBBox());
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          T && !T.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, r.prototype.getBBoxHD = function(n) {
      var i = y6(this.getAlignmentRow(), 2), o = i[0], a = i[1];
      if (a === null) {
        var T = this.font.params.axis_height, s = n / 2, Q = {
          top: [0, n],
          center: [s, s],
          bottom: [n, 0],
          baseline: [s, s],
          axis: [s + T, s - T]
        };
        return Q[o] || [s, s];
      } else {
        var u = this.getVerticalPosition(a, o);
        return [u, n - u];
      }
    }, r.prototype.getBBoxLR = function() {
      if (this.hasLabels) {
        var n = this.node.attributes, i = n.get("side"), o = y6(this.getPadAlignShift(i), 2), a = o[0], T = o[1], s = this.hasLabels && !!n.get("data-width-includes-label");
        return s && this.frame && this.fSpace[0] && (a -= this.fSpace[0]), T === "center" && !s ? [a, a] : i === "left" ? [a, 0] : [0, a];
      }
      return [0, 0];
    }, r.prototype.getPadAlignShift = function(n) {
      var i = this.getTableData().L, o = this.length2em(this.node.attributes.get("minlabelspacing")), a = i + o, T = y6(this.styles == null ? ["", ""] : [this.styles.get("padding-left"), this.styles.get("padding-right")], 2), s = T[0], Q = T[1];
      (s || Q) && (a = Math.max(a, this.length2em(s || "0"), this.length2em(Q || "0")));
      var u = y6(this.getAlignShift(), 2), l = u[0], c = u[1];
      return l === n && (c = n === "left" ? Math.max(a, c) - a : Math.min(-a, c) + a), [a, l, c];
    }, r.prototype.getAlignShift = function() {
      return this.isTop ? t.prototype.getAlignShift.call(this) : [this.container.getChildAlign(this.containerI), 0];
    }, r.prototype.getWidth = function() {
      return this.pWidth || this.getBBox().w;
    }, r.prototype.getEqualRowHeight = function() {
      var n = this.getTableData(), i = n.H, o = n.D, a = Array.from(i.keys()).map(function(T) {
        return i[T] + o[T];
      });
      return Math.max.apply(Math, a);
    }, r.prototype.getComputedWidths = function() {
      var n = this, i = this.getTableData().W, o = Array.from(i.keys()).map(function(a) {
        return typeof n.cWidths[a] == "number" ? n.cWidths[a] : i[a];
      });
      return this.node.attributes.get("equalcolumns") && (o = Array(o.length).fill((0, U6.max)(o))), o;
    }, r.prototype.getColumnWidths = function() {
      var n = this.node.attributes.get("width");
      if (this.node.attributes.get("equalcolumns"))
        return this.getEqualColumns(n);
      var i = this.getColumnAttributes("columnwidth", 0);
      return n === "auto" ? this.getColumnWidthsAuto(i) : (0, z6.isPercent)(n) ? this.getColumnWidthsPercent(i) : this.getColumnWidthsFixed(i, this.length2em(n));
    }, r.prototype.getEqualColumns = function(n) {
      var i = Math.max(1, this.numCols), o;
      if (n === "auto") {
        var a = this.getTableData().W;
        o = (0, U6.max)(a);
      } else if ((0, z6.isPercent)(n))
        o = this.percent(1 / i);
      else {
        var T = (0, U6.sum)([].concat(this.cLines, this.cSpace)) + 2 * this.fSpace[0];
        o = Math.max(0, this.length2em(n) - T) / i;
      }
      return Array(this.numCols).fill(o);
    }, r.prototype.getColumnWidthsAuto = function(n) {
      var i = this;
      return n.map(function(o) {
        return o === "auto" || o === "fit" ? null : (0, z6.isPercent)(o) ? o : i.length2em(o);
      });
    }, r.prototype.getColumnWidthsPercent = function(n) {
      var i = this, o = n.indexOf("fit") >= 0, a = (o ? this.getTableData() : { W: null }).W;
      return Array.from(n.keys()).map(function(T) {
        var s = n[T];
        return s === "fit" ? null : s === "auto" ? o ? a[T] : null : (0, z6.isPercent)(s) ? s : i.length2em(s);
      });
    }, r.prototype.getColumnWidthsFixed = function(n, i) {
      var o = this, a = Array.from(n.keys()), T = a.filter(function(d) {
        return n[d] === "fit";
      }), s = a.filter(function(d) {
        return n[d] === "auto";
      }), Q = T.length || s.length, u = (Q ? this.getTableData() : { W: null }).W, l = i - (0, U6.sum)([].concat(this.cLines, this.cSpace)) - 2 * this.fSpace[0], c = l;
      a.forEach(function(d) {
        var m = n[d];
        c -= m === "fit" || m === "auto" ? u[d] : o.length2em(m, l);
      });
      var f = Q && c > 0 ? c / Q : 0;
      return a.map(function(d) {
        var m = n[d];
        return m === "fit" ? u[d] + f : m === "auto" ? u[d] + (T.length === 0 ? f : 0) : o.length2em(m, l);
      });
    }, r.prototype.getVerticalPosition = function(n, i) {
      for (var o = this.node.attributes.get("equalrows"), a = this.getTableData(), T = a.H, s = a.D, Q = o ? this.getEqualRowHeight() : 0, u = this.getRowHalfSpacing(), l = this.fLine, c = 0; c < n; c++)
        l += u[c] + (o ? Q : T[c] + s[c]) + u[c + 1] + this.rLines[c];
      var f = y6(o ? [(Q + T[n] - s[n]) / 2, (Q - T[n] + s[n]) / 2] : [T[n], s[n]], 2), d = f[0], m = f[1], p = {
        top: 0,
        center: u[n] + (d + m) / 2,
        bottom: u[n] + d + m + u[n + 1],
        baseline: u[n] + d,
        axis: u[n] + d - 0.25
      };
      return l += p[i] || 0, l;
    }, r.prototype.getEmHalfSpacing = function(n, i, o) {
      o === void 0 && (o = 1);
      var a = this.em(n * o), T = this.addEm(i, 2 / o);
      return T.unshift(a), T.push(a), T;
    }, r.prototype.getRowHalfSpacing = function() {
      var n = this.rSpace.map(function(i) {
        return i / 2;
      });
      return n.unshift(this.fSpace[1]), n.push(this.fSpace[1]), n;
    }, r.prototype.getColumnHalfSpacing = function() {
      var n = this.cSpace.map(function(i) {
        return i / 2;
      });
      return n.unshift(this.fSpace[0]), n.push(this.fSpace[0]), n;
    }, r.prototype.getAlignmentRow = function() {
      var n = y6((0, z6.split)(this.node.attributes.get("align")), 2), i = n[0], o = n[1];
      if (o == null)
        return [i, null];
      var a = parseInt(o);
      return a < 0 && (a += this.numRows + 1), [i, a < 1 || a > this.numRows ? null : a - 1];
    }, r.prototype.getColumnAttributes = function(n, i) {
      i === void 0 && (i = 1);
      var o = this.numCols - i, a = this.getAttributeArray(n);
      if (a.length === 0)
        return null;
      for (; a.length < o; )
        a.push(a[a.length - 1]);
      return a.length > o && a.splice(o), a;
    }, r.prototype.getRowAttributes = function(n, i) {
      i === void 0 && (i = 1);
      var o = this.numRows - i, a = this.getAttributeArray(n);
      if (a.length === 0)
        return null;
      for (; a.length < o; )
        a.push(a[a.length - 1]);
      return a.length > o && a.splice(o), a;
    }, r.prototype.getAttributeArray = function(n) {
      var i = this.node.attributes.get(n);
      return i ? (0, z6.split)(i) : [this.node.attributes.getDefault(n)];
    }, r.prototype.addEm = function(n, i) {
      var o = this;
      return i === void 0 && (i = 1), n ? n.map(function(a) {
        return o.em(a / i);
      }) : null;
    }, r.prototype.convertLengths = function(n) {
      var i = this;
      return n ? n.map(function(o) {
        return i.length2em(o);
      }) : null;
    }, r;
  }(e);
}
Li.CommonMtableMixin = vx;
var o8 = {}, Lx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), p9 = b && b.__assign || function() {
  return p9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, p9.apply(this, arguments);
}, En = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(o8, "__esModule", { value: !0 });
o8.MmlMtable = void 0;
var bn = T2, yx = Q3, gx = function(e) {
  Lx(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.properties = {
      useHeight: !0
    }, r.texclass = bn.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mtable";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setInheritedAttributes = function(r, n, i, o) {
    var a, T;
    try {
      for (var s = En(bn.indentAttributes), Q = s.next(); !Q.done; Q = s.next()) {
        var u = Q.value;
        r[u] && this.attributes.setInherited(u, r[u][1]), this.attributes.getExplicit(u) !== void 0 && delete this.attributes.getAllAttributes()[u];
      }
    } catch (l) {
      a = { error: l };
    } finally {
      try {
        Q && !Q.done && (T = s.return) && T.call(s);
      } finally {
        if (a)
          throw a.error;
      }
    }
    e.prototype.setInheritedAttributes.call(this, r, n, i, o);
  }, t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    var a, T, s, Q;
    try {
      for (var u = En(this.childNodes), l = u.next(); !l.done; l = u.next()) {
        var c = l.value;
        c.isKind("mtr") || this.replaceChild(this.factory.create("mtr"), c).appendChild(c);
      }
    } catch (v) {
      a = { error: v };
    } finally {
      try {
        l && !l.done && (T = u.return) && T.call(u);
      } finally {
        if (a)
          throw a.error;
      }
    }
    i = this.getProperty("scriptlevel") || i, n = !!(this.attributes.getExplicit("displaystyle") || this.attributes.getDefault("displaystyle")), r = this.addInheritedAttributes(r, {
      columnalign: this.attributes.get("columnalign"),
      rowalign: "center"
    });
    var f = this.attributes.getExplicit("data-cramped"), d = (0, yx.split)(this.attributes.get("rowalign"));
    try {
      for (var m = En(this.childNodes), p = m.next(); !p.done; p = m.next()) {
        var c = p.value;
        r.rowalign[1] = d.shift() || r.rowalign[1], c.setInheritedAttributes(r, n, i, !!f);
      }
    } catch (v) {
      s = { error: v };
    } finally {
      try {
        p && !p.done && (Q = m.return) && Q.call(m);
      } finally {
        if (s)
          throw s.error;
      }
    }
  }, t.prototype.verifyChildren = function(r) {
    for (var n = null, i = this.factory, o = 0; o < this.childNodes.length; o++) {
      var a = this.childNodes[o];
      if (a.isKind("mtr"))
        n = null;
      else {
        var T = a.isKind("mtd");
        if (n ? (this.removeChild(a), o--) : n = this.replaceChild(i.create("mtr"), a), n.appendChild(T ? a : i.create("mtd", {}, [a])), !r.fixMtables) {
          a.parent.removeChild(a), a.parent = this, T && n.appendChild(i.create("mtd"));
          var s = a.mError("Children of " + this.kind + " must be mtr or mlabeledtr", r, T);
          n.childNodes[n.childNodes.length - 1].appendChild(s);
        }
      }
    }
    e.prototype.verifyChildren.call(this, r);
  }, t.prototype.setTeXclass = function(r) {
    var n, i;
    this.getPrevClass(r);
    try {
      for (var o = En(this.childNodes), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        T.setTeXclass(null);
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return this;
  }, t.defaults = p9(p9({}, bn.AbstractMmlNode.defaults), { align: "axis", rowalign: "baseline", columnalign: "center", groupalign: "{left}", alignmentscope: !0, columnwidth: "auto", width: "auto", rowspacing: "1ex", columnspacing: ".8em", rowlines: "none", columnlines: "none", frame: "none", framespacing: "0.4em 0.5ex", equalrows: !1, equalcolumns: !1, displaystyle: !1, side: "right", minlabelspacing: "0.8em" }), t;
}(bn.AbstractMmlNode);
o8.MmlMtable = gx;
var Fu;
function xx() {
  if (Fu)
    return lr;
  Fu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var s = function(Q, u) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var f in c)
          Object.prototype.hasOwnProperty.call(c, f) && (l[f] = c[f]);
      }, s(Q, u);
    };
    return function(Q, u) {
      if (typeof u != "function" && u !== null)
        throw new TypeError("Class extends value " + String(u) + " is not a constructor or null");
      s(Q, u);
      function l() {
        this.constructor = Q;
      }
      Q.prototype = u === null ? Object.create(u) : (l.prototype = u.prototype, new l());
    };
  }(), t = b && b.__read || function(s, Q) {
    var u = typeof Symbol == "function" && s[Symbol.iterator];
    if (!u)
      return s;
    var l = u.call(s), c, f = [], d;
    try {
      for (; (Q === void 0 || Q-- > 0) && !(c = l.next()).done; )
        f.push(c.value);
    } catch (m) {
      d = { error: m };
    } finally {
      try {
        c && !c.done && (u = l.return) && u.call(l);
      } finally {
        if (d)
          throw d.error;
      }
    }
    return f;
  }, r = b && b.__spreadArray || function(s, Q, u) {
    if (u || arguments.length === 2)
      for (var l = 0, c = Q.length, f; l < c; l++)
        (f || !(l in Q)) && (f || (f = Array.prototype.slice.call(Q, 0, l)), f[l] = Q[l]);
    return s.concat(f || Array.prototype.slice.call(Q));
  };
  Object.defineProperty(lr, "__esModule", { value: !0 }), lr.SVGmtable = void 0;
  var n = a3(), i = Li, o = o8, a = "mjx-", T = function(s) {
    e(Q, s);
    function Q(u, l, c) {
      c === void 0 && (c = null);
      var f = s.call(this, u, l, c) || this, d = { "data-labels": !0 };
      return f.isTop && (d.transform = "matrix(1 0 0 -1 0 0)"), f.labels = f.svg("g", d), f;
    }
    return Q.prototype.toSVG = function(u) {
      var l = this.standardSVGnode(u);
      this.placeRows(l), this.handleColumnLines(l), this.handleRowLines(l), this.handleFrame(l);
      var c = this.handlePWidth(l);
      this.handleLabels(l, u, c);
    }, Q.prototype.placeRows = function(u) {
      for (var l, c, f, d = this.node.attributes.get("equalrows"), m = this.getTableData(), p = m.H, v = m.D, H = this.getEqualRowHeight(), E = this.getRowHalfSpacing(), M = r(r([this.fLine], t(this.rLines), !1), [this.fLine], !1), C = this.getBBox().h - M[0], w = 0; w < this.numRows; w++) {
        var S = this.childNodes[w];
        l = t(this.getRowHD(d, H, p[w], v[w]), 2), S.H = l[0], S.D = l[1], c = t([E[w], E[w + 1]], 2), S.tSpace = c[0], S.bSpace = c[1], f = t([M[w], M[w + 1]], 2), S.tLine = f[0], S.bLine = f[1], S.toSVG(u), S.place(0, C - E[w] - S.H), C -= E[w] + S.H + S.D + E[w + 1] + M[w + 1];
      }
    }, Q.prototype.getRowHD = function(u, l, c, f) {
      return u ? [(l + c - f) / 2, (l - c + f) / 2] : [c, f];
    }, Q.prototype.handleColor = function() {
      s.prototype.handleColor.call(this);
      var u = this.firstChild();
      u && this.adaptor.setAttribute(u, "width", this.fixed(this.getWidth()));
    }, Q.prototype.handleColumnLines = function(u) {
      if (this.node.attributes.get("columnlines") !== "none") {
        var l = this.getColumnAttributes("columnlines");
        if (l)
          for (var c = this.getColumnHalfSpacing(), f = this.cLines, d = this.getComputedWidths(), m = this.fLine, p = 0; p < l.length; p++)
            m += c[p] + d[p] + c[p + 1], l[p] !== "none" && this.adaptor.append(u, this.makeVLine(m, l[p], f[p])), m += f[p];
      }
    }, Q.prototype.handleRowLines = function(u) {
      if (this.node.attributes.get("rowlines") !== "none") {
        var l = this.getRowAttributes("rowlines");
        if (l)
          for (var c = this.node.attributes.get("equalrows"), f = this.getTableData(), d = f.H, m = f.D, p = this.getEqualRowHeight(), v = this.getRowHalfSpacing(), H = this.rLines, E = this.getBBox().h - this.fLine, M = 0; M < l.length; M++) {
            var C = t(this.getRowHD(c, p, d[M], m[M]), 2), w = C[0], S = C[1];
            E -= v[M] + w + S + v[M + 1], l[M] !== "none" && this.adaptor.append(u, this.makeHLine(E, l[M], H[M])), E -= H[M];
          }
      }
    }, Q.prototype.handleFrame = function(u) {
      if (this.frame && this.fLine) {
        var l = this.getBBox(), c = l.h, f = l.d, d = l.w, m = this.node.attributes.get("frame");
        this.adaptor.append(u, this.makeFrame(d, c, f, m));
      }
    }, Q.prototype.handlePWidth = function(u) {
      if (!this.pWidth)
        return 0;
      var l = this.getBBox(), c = l.w, f = l.L, d = l.R, m = f + this.pWidth + d, p = this.getAlignShift()[0], v = Math.max(this.isTop ? m : 0, this.container.getWrapWidth(this.containerI)) - f - d, H = c - (this.pWidth > v ? v : this.pWidth), E = p === "left" ? 0 : p === "right" ? H : H / 2;
      if (E) {
        var M = this.svg("g", {}, this.adaptor.childNodes(u));
        this.place(E, 0, M), this.adaptor.append(u, M);
      }
      return E;
    }, Q.prototype.lineClass = function(u) {
      return a + u;
    }, Q.prototype.makeFrame = function(u, l, c, f) {
      var d = this.fLine;
      return this.svg("rect", this.setLineThickness(d, f, {
        "data-frame": !0,
        class: this.lineClass(f),
        width: this.fixed(u - d),
        height: this.fixed(l + c - d),
        x: this.fixed(d / 2),
        y: this.fixed(d / 2 - c)
      }));
    }, Q.prototype.makeVLine = function(u, l, c) {
      var f = this.getBBox(), d = f.h, m = f.d, p = l === "dotted" ? c / 2 : 0, v = this.fixed(u + c / 2);
      return this.svg("line", this.setLineThickness(c, l, {
        "data-line": "v",
        class: this.lineClass(l),
        x1: v,
        y1: this.fixed(p - m),
        x2: v,
        y2: this.fixed(d - p)
      }));
    }, Q.prototype.makeHLine = function(u, l, c) {
      var f = this.getBBox().w, d = l === "dotted" ? c / 2 : 0, m = this.fixed(u - c / 2);
      return this.svg("line", this.setLineThickness(c, l, {
        "data-line": "h",
        class: this.lineClass(l),
        x1: this.fixed(d),
        y1: m,
        x2: this.fixed(f - d),
        y2: m
      }));
    }, Q.prototype.setLineThickness = function(u, l, c) {
      return u !== 0.07 && (c["stroke-thickness"] = this.fixed(u), l !== "solid" && (c["stroke-dasharray"] = (l === "dotted" ? "0," : "") + this.fixed(2 * u))), c;
    }, Q.prototype.handleLabels = function(u, l, c) {
      if (this.hasLabels) {
        var f = this.labels, d = this.node.attributes, m = d.get("side");
        this.spaceLabels(), this.isTop ? this.topTable(u, f, m) : this.subTable(u, f, m, c);
      }
    }, Q.prototype.spaceLabels = function() {
      for (var u = this.adaptor, l = this.getBBox().h, c = this.getTableData().L, f = this.getRowHalfSpacing(), d = l - this.fLine, m = u.firstChild(this.labels), p = 0; p < this.numRows; p++) {
        var v = this.childNodes[p];
        if (v.node.isKind("mlabeledtr")) {
          var H = v.childNodes[0];
          d -= f[p] + v.H, v.placeCell(H, { x: 0, y: d, w: c, lSpace: 0, rSpace: 0, lLine: 0, rLine: 0 }), d -= v.D + f[p + 1] + this.rLines[p], m = u.next(m);
        } else
          d -= f[p] + v.H + v.D + f[p + 1] + this.rLines[p];
      }
    }, Q.prototype.topTable = function(u, l, c) {
      var f = this.adaptor, d = this.getBBox(), m = d.h, p = d.d, v = d.w, H = d.L, E = d.R, M = H + (this.pWidth || v) + E, C = this.getTableData().L, w = t(this.getPadAlignShift(c), 3), S = w[1], D = w[2], k = D + (S === "right" ? -M : S === "center" ? -M / 2 : 0) + H, $ = "matrix(1 0 0 -1 0 0)", z = "scale(".concat(this.jax.fixed(this.font.params.x_height * 1e3 / this.metrics.ex, 2), ")"), j = "translate(0 ".concat(this.fixed(m), ") ").concat($, " ").concat(z), J = this.svg("svg", {
        "data-table": !0,
        preserveAspectRatio: S === "left" ? "xMinYMid" : S === "right" ? "xMaxYMid" : "xMidYMid",
        viewBox: [this.fixed(-k), this.fixed(-m), 1, this.fixed(m + p)].join(" ")
      }, [
        this.svg("g", { transform: $ }, f.childNodes(u))
      ]);
      l = this.svg("svg", {
        "data-labels": !0,
        preserveAspectRatio: c === "left" ? "xMinYMid" : "xMaxYMid",
        viewBox: [c === "left" ? 0 : this.fixed(C), this.fixed(-m), 1, this.fixed(m + p)].join(" ")
      }, [l]), f.append(u, this.svg("g", { transform: j }, [J, l])), this.place(-H, 0, u);
    }, Q.prototype.subTable = function(u, l, c, f) {
      var d = this.adaptor, m = this.getBBox(), p = m.w, v = m.L, H = m.R, E = v + (this.pWidth || p) + H, M = this.getTableData().L, C = this.getAlignShift()[0], w = Math.max(E, this.container.getWrapWidth(this.containerI));
      this.place(c === "left" ? (C === "left" ? 0 : C === "right" ? E - w + f : (E - w) / 2 + f) - v : (C === "left" ? w : C === "right" ? E + f : (w + E) / 2 + f) - v - M, 0, l), d.append(u, l);
    }, Q.kind = o.MmlMtable.prototype.kind, Q.styles = {
      'g[data-mml-node="mtable"] > line[data-line], svg[data-table] > g > line[data-line]': {
        "stroke-width": "70px",
        fill: "none"
      },
      'g[data-mml-node="mtable"] > rect[data-frame], svg[data-table] > g > rect[data-frame]': {
        "stroke-width": "70px",
        fill: "none"
      },
      'g[data-mml-node="mtable"] > .mjx-dashed, svg[data-table] > g > .mjx-dashed': {
        "stroke-dasharray": "140"
      },
      'g[data-mml-node="mtable"] > .mjx-dotted, svg[data-table] > g > .mjx-dotted': {
        "stroke-linecap": "round",
        "stroke-dasharray": "0,140"
      },
      'g[data-mml-node="mtable"] > g > svg': {
        overflow: "visible"
      }
    }, Q;
  }((0, i.CommonMtableMixin)(n.SVGWrapper));
  return lr.SVGmtable = T, lr;
}
var Ce = {}, Xe = {}, Yd = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bQ = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(Xe, "__esModule", { value: !0 });
Xe.CommonMlabeledtrMixin = Xe.CommonMtrMixin = void 0;
function Hx(e) {
  return function(t) {
    Yd(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(r.prototype, "fixesPWidth", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "numCells", {
      get: function() {
        return this.childNodes.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "labeled", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "tableCells", {
      get: function() {
        return this.childNodes;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.getChild = function(n) {
      return this.childNodes[n];
    }, r.prototype.getChildBBoxes = function() {
      return this.childNodes.map(function(n) {
        return n.getBBox();
      });
    }, r.prototype.stretchChildren = function(n) {
      var i, o, a, T, s, Q;
      n === void 0 && (n = null);
      var u = [], l = this.labeled ? this.childNodes.slice(1) : this.childNodes;
      try {
        for (var c = bQ(l), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, m = d.childNodes[0];
          m.canStretch(1) && u.push(m);
        }
      } catch (J) {
        i = { error: J };
      } finally {
        try {
          f && !f.done && (o = c.return) && o.call(c);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var p = u.length, v = this.childNodes.length;
      if (p && v > 1) {
        if (n === null) {
          var H = 0, E = 0, M = p > 1 && p === v;
          try {
            for (var C = bQ(l), w = C.next(); !w.done; w = C.next()) {
              var d = w.value, m = d.childNodes[0], S = m.stretch.dir === 0;
              if (M || S) {
                var D = m.getBBox(S), k = D.h, $ = D.d;
                k > H && (H = k), $ > E && (E = $);
              }
            }
          } catch (J) {
            a = { error: J };
          } finally {
            try {
              w && !w.done && (T = C.return) && T.call(C);
            } finally {
              if (a)
                throw a.error;
            }
          }
          n = [H, E];
        }
        try {
          for (var z = bQ(u), j = z.next(); !j.done; j = z.next()) {
            var m = j.value;
            m.coreMO().getStretchedVariant(n);
          }
        } catch (J) {
          s = { error: J };
        } finally {
          try {
            j && !j.done && (Q = z.return) && Q.call(z);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
    }, r;
  }(e);
}
Xe.CommonMtrMixin = Hx;
function Ex(e) {
  return function(t) {
    Yd(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(r.prototype, "numCells", {
      get: function() {
        return Math.max(0, this.childNodes.length - 1);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "labeled", {
      get: function() {
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "tableCells", {
      get: function() {
        return this.childNodes.slice(1);
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.getChild = function(n) {
      return this.childNodes[n + 1];
    }, r.prototype.getChildBBoxes = function() {
      return this.childNodes.slice(1).map(function(n) {
        return n.getBBox();
      });
    }, r;
  }(e);
}
Xe.CommonMlabeledtrMixin = Ex;
var qe = {}, Kd = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), m9 = b && b.__assign || function() {
  return m9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, m9.apply(this, arguments);
}, Mn = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(qe, "__esModule", { value: !0 });
qe.MmlMlabeledtr = qe.MmlMtr = void 0;
var ju = T2, MQ = k0, bx = Q3, eh = function(e) {
  Kd(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mtr";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    var a, T, s, Q;
    try {
      for (var u = Mn(this.childNodes), l = u.next(); !l.done; l = u.next()) {
        var c = l.value;
        c.isKind("mtd") || this.replaceChild(this.factory.create("mtd"), c).appendChild(c);
      }
    } catch (p) {
      a = { error: p };
    } finally {
      try {
        l && !l.done && (T = u.return) && T.call(u);
      } finally {
        if (a)
          throw a.error;
      }
    }
    var f = (0, bx.split)(this.attributes.get("columnalign"));
    this.arity === 1 && f.unshift(this.parent.attributes.get("side")), r = this.addInheritedAttributes(r, {
      rowalign: this.attributes.get("rowalign"),
      columnalign: "center"
    });
    try {
      for (var d = Mn(this.childNodes), m = d.next(); !m.done; m = d.next()) {
        var c = m.value;
        r.columnalign[1] = f.shift() || r.columnalign[1], c.setInheritedAttributes(r, n, i, o);
      }
    } catch (p) {
      s = { error: p };
    } finally {
      try {
        m && !m.done && (Q = d.return) && Q.call(d);
      } finally {
        if (s)
          throw s.error;
      }
    }
  }, t.prototype.verifyChildren = function(r) {
    var n, i;
    if (this.parent && !this.parent.isKind("mtable")) {
      this.mError(this.kind + " can only be a child of an mtable", r, !0);
      return;
    }
    try {
      for (var o = Mn(this.childNodes), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        if (!T.isKind("mtd")) {
          var s = this.replaceChild(this.factory.create("mtd"), T);
          s.appendChild(T), r.fixMtables || T.mError("Children of " + this.kind + " must be mtd", r);
        }
      }
    } catch (Q) {
      n = { error: Q };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    e.prototype.verifyChildren.call(this, r);
  }, t.prototype.setTeXclass = function(r) {
    var n, i;
    this.getPrevClass(r);
    try {
      for (var o = Mn(this.childNodes), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        T.setTeXclass(null);
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return this;
  }, t.defaults = m9(m9({}, ju.AbstractMmlNode.defaults), { rowalign: MQ.INHERIT, columnalign: MQ.INHERIT, groupalign: MQ.INHERIT }), t;
}(ju.AbstractMmlNode);
qe.MmlMtr = eh;
var Mx = function(e) {
  Kd(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mlabeledtr";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), t;
}(eh);
qe.MmlMlabeledtr = Mx;
var $u;
function wx() {
  if ($u)
    return Ce;
  $u = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var Q = function(u, l) {
      return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, f) {
        c.__proto__ = f;
      } || function(c, f) {
        for (var d in f)
          Object.prototype.hasOwnProperty.call(f, d) && (c[d] = f[d]);
      }, Q(u, l);
    };
    return function(u, l) {
      if (typeof l != "function" && l !== null)
        throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
      Q(u, l);
      function c() {
        this.constructor = u;
      }
      u.prototype = l === null ? Object.create(l) : (c.prototype = l.prototype, new c());
    };
  }(), t = b && b.__read || function(Q, u) {
    var l = typeof Symbol == "function" && Q[Symbol.iterator];
    if (!l)
      return Q;
    var c = l.call(Q), f, d = [], m;
    try {
      for (; (u === void 0 || u-- > 0) && !(f = c.next()).done; )
        d.push(f.value);
    } catch (p) {
      m = { error: p };
    } finally {
      try {
        f && !f.done && (l = c.return) && l.call(c);
      } finally {
        if (m)
          throw m.error;
      }
    }
    return d;
  }, r = b && b.__spreadArray || function(Q, u, l) {
    if (l || arguments.length === 2)
      for (var c = 0, f = u.length, d; c < f; c++)
        (d || !(c in u)) && (d || (d = Array.prototype.slice.call(u, 0, c)), d[c] = u[c]);
    return Q.concat(d || Array.prototype.slice.call(u));
  };
  Object.defineProperty(Ce, "__esModule", { value: !0 }), Ce.SVGmlabeledtr = Ce.SVGmtr = void 0;
  var n = a3(), i = Xe, o = Xe, a = qe, T = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.prototype.toSVG = function(l) {
      var c = this.standardSVGnode(l);
      this.placeCells(c), this.placeColor();
    }, u.prototype.placeCells = function(l) {
      for (var c = this.parent.getColumnHalfSpacing(), f = r(r([this.parent.fLine], t(this.parent.cLines), !1), [this.parent.fLine], !1), d = this.parent.getComputedWidths(), m = 1 / this.getBBox().rscale, p = f[0], v = 0; v < this.numCells; v++) {
        var H = this.getChild(v);
        H.toSVG(l), p += this.placeCell(H, {
          x: p,
          y: 0,
          lSpace: c[v] * m,
          rSpace: c[v + 1] * m,
          w: d[v] * m,
          lLine: f[v] * m,
          rLine: f[v + 1] * m
        });
      }
    }, u.prototype.placeCell = function(l, c) {
      var f = c.x, d = c.y, m = c.lSpace, p = c.w, v = c.rSpace, H = c.lLine, E = c.rLine, M = 1 / this.getBBox().rscale, C = t([this.H * M, this.D * M], 2), w = C[0], S = C[1], D = t([this.tSpace * M, this.bSpace * M], 2), k = D[0], $ = D[1], z = t(l.placeCell(f + m, d, p, w, S), 2), j = z[0], J = z[1], i1 = m + p + v;
      return l.placeColor(-(j + m + H / 2), -(S + $ + J), i1 + (H + E) / 2, w + S + k + $), i1 + E;
    }, u.prototype.placeColor = function() {
      var l = 1 / this.getBBox().rscale, c = this.adaptor, f = this.firstChild();
      if (f && c.kind(f) === "rect" && c.getAttribute(f, "data-bgcolor")) {
        var d = t([this.tLine / 2 * l, this.bLine / 2 * l], 2), m = d[0], p = d[1], v = t([this.tSpace * l, this.bSpace * l], 2), H = v[0], E = v[1], M = t([this.H * l, this.D * l], 2), C = M[0], w = M[1];
        c.setAttribute(f, "y", this.fixed(-(w + E + p))), c.setAttribute(f, "width", this.fixed(this.parent.getWidth() * l)), c.setAttribute(f, "height", this.fixed(m + H + C + w + E + p));
      }
    }, u.kind = a.MmlMtr.prototype.kind, u;
  }((0, i.CommonMtrMixin)(n.SVGWrapper));
  Ce.SVGmtr = T;
  var s = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.prototype.toSVG = function(l) {
      Q.prototype.toSVG.call(this, l);
      var c = this.childNodes[0];
      c && c.toSVG(this.parent.labels);
    }, u.kind = a.MmlMlabeledtr.prototype.kind, u;
  }((0, o.CommonMlabeledtrMixin)(T));
  return Ce.SVGmlabeledtr = s, Ce;
}
var ur = {}, yi = {}, Sx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(yi, "__esModule", { value: !0 });
yi.CommonMtdMixin = void 0;
function Cx(e) {
  return function(t) {
    Sx(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(r.prototype, "fixesPWidth", {
      get: function() {
        return !1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.invalidateBBox = function() {
      this.bboxComputed = !1;
    }, r.prototype.getWrapWidth = function(n) {
      var i = this.parent.parent, o = this.parent, a = this.node.childPosition() - (o.labeled ? 1 : 0);
      return typeof i.cWidths[a] == "number" ? i.cWidths[a] : i.getTableData().W[a];
    }, r.prototype.getChildAlign = function(n) {
      return this.node.attributes.get("columnalign");
    }, r;
  }(e);
}
yi.CommonMtdMixin = Cx;
var a8 = {}, Vx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), v9 = b && b.__assign || function() {
  return v9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, v9.apply(this, arguments);
};
Object.defineProperty(a8, "__esModule", { value: !0 });
a8.MmlMtd = void 0;
var Zu = T2, wQ = k0, _x = function(e) {
  Vx(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mtd";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return -1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContainer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.verifyChildren = function(r) {
    if (this.parent && !this.parent.isKind("mtr")) {
      this.mError(this.kind + " can only be a child of an mtr or mlabeledtr", r, !0);
      return;
    }
    e.prototype.verifyChildren.call(this, r);
  }, t.prototype.setTeXclass = function(r) {
    return this.getPrevClass(r), this.childNodes[0].setTeXclass(null), this;
  }, t.defaults = v9(v9({}, Zu.AbstractMmlBaseNode.defaults), { rowspan: 1, columnspan: 1, rowalign: wQ.INHERIT, columnalign: wQ.INHERIT, groupalign: wQ.INHERIT }), t;
}(Zu.AbstractMmlBaseNode);
a8.MmlMtd = _x;
var Wu;
function Ox() {
  if (Wu)
    return ur;
  Wu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(ur, "__esModule", { value: !0 }), ur.SVGmtd = void 0;
  var t = a3(), r = yi, n = a8, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.prototype.placeCell = function(T, s, Q, u, l) {
      var c = this.getBBox(), f = Math.max(c.h, 0.75), d = Math.max(c.d, 0.25), m = this.node.attributes.get("columnalign"), p = this.node.attributes.get("rowalign"), v = this.getAlignX(Q, c, m), H = this.getAlignY(u, l, f, d, p);
      return this.place(T + v, s + H), [v, H];
    }, a.prototype.placeColor = function(T, s, Q, u) {
      var l = this.adaptor, c = this.firstChild();
      c && l.kind(c) === "rect" && l.getAttribute(c, "data-bgcolor") && (l.setAttribute(c, "x", this.fixed(T)), l.setAttribute(c, "y", this.fixed(s)), l.setAttribute(c, "width", this.fixed(Q)), l.setAttribute(c, "height", this.fixed(u)));
    }, a.kind = n.MmlMtd.prototype.kind, a;
  }((0, r.CommonMtdMixin)(t.SVGWrapper));
  return ur.SVGmtd = i, ur;
}
var cr = {}, HT = {};
(function(e) {
  var t = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }(), r = b && b.__read || function(a, T) {
    var s = typeof Symbol == "function" && a[Symbol.iterator];
    if (!s)
      return a;
    var Q = s.call(a), u, l = [], c;
    try {
      for (; (T === void 0 || T-- > 0) && !(u = Q.next()).done; )
        l.push(u.value);
    } catch (f) {
      c = { error: f };
    } finally {
      try {
        u && !u.done && (s = Q.return) && s.call(Q);
      } finally {
        if (c)
          throw c.error;
      }
    }
    return l;
  }, n = b && b.__spreadArray || function(a, T, s) {
    if (s || arguments.length === 2)
      for (var Q = 0, u = T.length, l; Q < u; Q++)
        (l || !(Q in T)) && (l || (l = Array.prototype.slice.call(T, 0, Q)), l[Q] = T[Q]);
    return a.concat(l || Array.prototype.slice.call(T));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommonMactionMixin = e.TooltipData = void 0;
  var i = Q3;
  e.TooltipData = {
    dx: ".2em",
    dy: ".1em",
    postDelay: 600,
    clearDelay: 100,
    hoverTimer: /* @__PURE__ */ new Map(),
    clearTimer: /* @__PURE__ */ new Map(),
    stopTimers: function(a, T) {
      T.clearTimer.has(a) && (clearTimeout(T.clearTimer.get(a)), T.clearTimer.delete(a)), T.hoverTimer.has(a) && (clearTimeout(T.hoverTimer.get(a)), T.hoverTimer.delete(a));
    }
  };
  function o(a) {
    return function(T) {
      t(s, T);
      function s() {
        for (var Q = [], u = 0; u < arguments.length; u++)
          Q[u] = arguments[u];
        var l = T.apply(this, n([], r(Q), !1)) || this, c = l.constructor.actions, f = l.node.attributes.get("actiontype"), d = r(c.get(f) || [function(v, H) {
        }, {}], 2), m = d[0], p = d[1];
        return l.action = m, l.data = p, l.getParameters(), l;
      }
      return Object.defineProperty(s.prototype, "selected", {
        get: function() {
          var Q = this.node.attributes.get("selection"), u = Math.max(1, Math.min(this.childNodes.length, Q)) - 1;
          return this.childNodes[u] || this.wrap(this.node.selected);
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.getParameters = function() {
        var Q = this.node.attributes.get("data-offsets"), u = r((0, i.split)(Q || ""), 2), l = u[0], c = u[1];
        this.dx = this.length2em(l || e.TooltipData.dx), this.dy = this.length2em(c || e.TooltipData.dy);
      }, s.prototype.computeBBox = function(Q, u) {
        u === void 0 && (u = !1), Q.updateFrom(this.selected.getOuterBBox()), this.selected.setChildPWidths(u);
      }, s;
    }(a);
  }
  e.CommonMactionMixin = o;
})(HT);
var Q8 = {}, Ax = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), L9 = b && b.__assign || function() {
  return L9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, L9.apply(this, arguments);
};
Object.defineProperty(Q8, "__esModule", { value: !0 });
Q8.MmlMaction = void 0;
var Gu = T2, Dx = function(e) {
  Ax(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "maction";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "selected", {
    get: function() {
      var r = this.attributes.get("selection"), n = Math.max(1, Math.min(this.childNodes.length, r)) - 1;
      return this.childNodes[n] || this.factory.create("mrow");
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isEmbellished", {
    get: function() {
      return this.selected.isEmbellished;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isSpacelike", {
    get: function() {
      return this.selected.isSpacelike;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.core = function() {
    return this.selected.core();
  }, t.prototype.coreMO = function() {
    return this.selected.coreMO();
  }, t.prototype.verifyAttributes = function(r) {
    if (e.prototype.verifyAttributes.call(this, r), this.attributes.get("actiontype") !== "toggle" && this.attributes.getExplicit("selection") !== void 0) {
      var n = this.attributes.getAllAttributes();
      delete n.selection;
    }
  }, t.prototype.setTeXclass = function(r) {
    this.attributes.get("actiontype") === "tooltip" && this.childNodes[1] && this.childNodes[1].setTeXclass(null);
    var n = this.selected;
    return r = n.setTeXclass(r), this.updateTeXclass(n), r;
  }, t.prototype.nextToggleSelection = function() {
    var r = Math.max(1, this.attributes.get("selection") + 1);
    r > this.childNodes.length && (r = 1), this.attributes.set("selection", r);
  }, t.defaults = L9(L9({}, Gu.AbstractMmlNode.defaults), { actiontype: "toggle", selection: 1 }), t;
}(Gu.AbstractMmlNode);
Q8.MmlMaction = Dx;
var zu;
function kx() {
  if (zu)
    return cr;
  zu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }();
  Object.defineProperty(cr, "__esModule", { value: !0 }), cr.SVGmaction = void 0;
  var t = a3(), r = HT, n = HT, i = Q8, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.toSVG = function(s) {
      var Q = this.standardSVGnode(s), u = this.selected, l = u.getOuterBBox(), c = l.h, f = l.d, d = l.w;
      this.adaptor.append(this.element, this.svg("rect", {
        width: this.fixed(d),
        height: this.fixed(c + f),
        y: this.fixed(-f),
        fill: "none",
        "pointer-events": "all"
      })), u.toSVG(Q);
      var m = u.getOuterBBox();
      u.element && u.place(m.L * m.rscale, 0), this.action(this, this.data);
    }, T.prototype.setEventHandler = function(s, Q) {
      this.element.addEventListener(s, Q);
    }, T.kind = i.MmlMaction.prototype.kind, T.styles = {
      '[jax="SVG"] mjx-tool': {
        display: "inline-block",
        position: "relative",
        width: 0,
        height: 0
      },
      '[jax="SVG"] mjx-tool > mjx-tip': {
        position: "absolute",
        top: 0,
        left: 0
      },
      "mjx-tool > mjx-tip": {
        display: "inline-block",
        padding: ".2em",
        border: "1px solid #888",
        "font-size": "70%",
        "background-color": "#F8F8F8",
        color: "black",
        "box-shadow": "2px 2px 5px #AAAAAA"
      },
      'g[data-mml-node="maction"][data-toggle]': {
        cursor: "pointer"
      },
      "mjx-status": {
        display: "block",
        position: "fixed",
        left: "1em",
        bottom: "1em",
        "min-width": "25%",
        padding: ".2em .4em",
        border: "1px solid #888",
        "font-size": "90%",
        "background-color": "#F8F8F8",
        color: "black"
      }
    }, T.actions = /* @__PURE__ */ new Map([
      ["toggle", [function(s, Q) {
        s.adaptor.setAttribute(s.element, "data-toggle", s.node.attributes.get("selection"));
        var u = s.factory.jax.math, l = s.factory.jax.document, c = s.node;
        s.setEventHandler("click", function(f) {
          u.end.node || (u.start.node = u.end.node = u.typesetRoot, u.start.n = u.end.n = 0), c.nextToggleSelection(), u.rerender(l), f.stopPropagation();
        });
      }, {}]],
      ["tooltip", [function(s, Q) {
        var u = s.childNodes[1];
        if (u) {
          var l = s.firstChild();
          if (u.node.isKind("mtext")) {
            var c = u.node.getText();
            s.adaptor.insert(s.svg("title", {}, [s.text(c)]), l);
          } else {
            var f = s.adaptor, d = s.jax.container, m = s.node.factory.create("math", {}, [s.childNodes[1].node]), p = s.html("mjx-tool", {}, [s.html("mjx-tip")]), v = f.append(l, s.svg("foreignObject", { style: { display: "none" } }, [p]));
            s.jax.processMath(m, f.firstChild(p)), s.childNodes[1].node.parent = s.node, s.setEventHandler("mouseover", function(H) {
              Q.stopTimers(s, Q), Q.hoverTimer.set(s, setTimeout(function() {
                f.setStyle(p, "left", "0"), f.setStyle(p, "top", "0"), f.append(d, p);
                var E = f.nodeBBox(p), M = f.nodeBBox(s.element), C = (M.right - E.left) / s.metrics.em + s.dx, w = (M.bottom - E.bottom) / s.metrics.em + s.dy;
                f.setStyle(p, "left", s.px(C)), f.setStyle(p, "top", s.px(w));
              }, Q.postDelay)), H.stopPropagation();
            }), s.setEventHandler("mouseout", function(H) {
              Q.stopTimers(s, Q);
              var E = setTimeout(function() {
                return f.append(v, p);
              }, Q.clearDelay);
              Q.clearTimer.set(s, E), H.stopPropagation();
            });
          }
        }
      }, n.TooltipData]],
      ["statusline", [function(s, Q) {
        var u = s.childNodes[1];
        if (u && u.node.isKind("mtext")) {
          var l = s.adaptor, c = u.node.getText();
          l.setAttribute(s.element, "data-statusline", c), s.setEventHandler("mouseover", function(f) {
            if (Q.status === null) {
              var d = l.body(l.document);
              Q.status = l.append(d, s.html("mjx-status", {}, [s.text(c)]));
            }
            f.stopPropagation();
          }), s.setEventHandler("mouseout", function(f) {
            Q.status && (l.remove(Q.status), Q.status = null), f.stopPropagation();
          });
        }
      }, {
        status: null
      }]]
    ]), T;
  }((0, r.CommonMactionMixin)(t.SVGWrapper));
  return cr.SVGmaction = o, cr;
}
var fr = {}, gi = {}, y9 = {};
(function(e) {
  var t = b && b.__read || function(u, l) {
    var c = typeof Symbol == "function" && u[Symbol.iterator];
    if (!c)
      return u;
    var f = c.call(u), d, m = [], p;
    try {
      for (; (l === void 0 || l-- > 0) && !(d = f.next()).done; )
        m.push(d.value);
    } catch (v) {
      p = { error: v };
    } finally {
      try {
        d && !d.done && (c = f.return) && c.call(f);
      } finally {
        if (p)
          throw p.error;
      }
    }
    return m;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CommonArrow = e.CommonDiagonalArrow = e.CommonDiagonalStrike = e.CommonBorder2 = e.CommonBorder = e.arrowBBox = e.diagonalArrowDef = e.arrowDef = e.arrowBBoxW = e.arrowBBoxHD = e.arrowHead = e.fullBorder = e.fullPadding = e.fullBBox = e.sideNames = e.sideIndex = e.SOLID = e.PADDING = e.THICKNESS = e.ARROWY = e.ARROWDX = e.ARROWX = void 0, e.ARROWX = 4, e.ARROWDX = 1, e.ARROWY = 2, e.THICKNESS = 0.067, e.PADDING = 0.2, e.SOLID = e.THICKNESS + "em solid", e.sideIndex = { top: 0, right: 1, bottom: 2, left: 3 }, e.sideNames = Object.keys(e.sideIndex), e.fullBBox = function(u) {
    return new Array(4).fill(u.thickness + u.padding);
  }, e.fullPadding = function(u) {
    return new Array(4).fill(u.padding);
  }, e.fullBorder = function(u) {
    return new Array(4).fill(u.thickness);
  };
  var r = function(u) {
    return Math.max(u.padding, u.thickness * (u.arrowhead.x + u.arrowhead.dx + 1));
  };
  e.arrowHead = r;
  var n = function(u, l) {
    if (u.childNodes[0]) {
      var c = u.childNodes[0].getBBox(), f = c.h, d = c.d;
      l[0] = l[2] = Math.max(0, u.thickness * u.arrowhead.y - (f + d) / 2);
    }
    return l;
  };
  e.arrowBBoxHD = n;
  var i = function(u, l) {
    if (u.childNodes[0]) {
      var c = u.childNodes[0].getBBox().w;
      l[1] = l[3] = Math.max(0, u.thickness * u.arrowhead.y - c / 2);
    }
    return l;
  };
  e.arrowBBoxW = i, e.arrowDef = {
    up: [-Math.PI / 2, !1, !0, "verticalstrike"],
    down: [Math.PI / 2, !1, !0, "verticakstrike"],
    right: [0, !1, !1, "horizontalstrike"],
    left: [Math.PI, !1, !1, "horizontalstrike"],
    updown: [Math.PI / 2, !0, !0, "verticalstrike uparrow downarrow"],
    leftright: [0, !0, !1, "horizontalstrike leftarrow rightarrow"]
  }, e.diagonalArrowDef = {
    updiagonal: [-1, 0, !1, "updiagonalstrike northeastarrow"],
    northeast: [-1, 0, !1, "updiagonalstrike updiagonalarrow"],
    southeast: [1, 0, !1, "downdiagonalstrike"],
    northwest: [1, Math.PI, !1, "downdiagonalstrike"],
    southwest: [-1, Math.PI, !1, "updiagonalstrike"],
    northeastsouthwest: [-1, 0, !0, "updiagonalstrike northeastarrow updiagonalarrow southwestarrow"],
    northwestsoutheast: [1, 0, !0, "downdiagonalstrike northwestarrow southeastarrow"]
  }, e.arrowBBox = {
    up: function(u) {
      return (0, e.arrowBBoxW)(u, [(0, e.arrowHead)(u), 0, u.padding, 0]);
    },
    down: function(u) {
      return (0, e.arrowBBoxW)(u, [u.padding, 0, (0, e.arrowHead)(u), 0]);
    },
    right: function(u) {
      return (0, e.arrowBBoxHD)(u, [0, (0, e.arrowHead)(u), 0, u.padding]);
    },
    left: function(u) {
      return (0, e.arrowBBoxHD)(u, [0, u.padding, 0, (0, e.arrowHead)(u)]);
    },
    updown: function(u) {
      return (0, e.arrowBBoxW)(u, [(0, e.arrowHead)(u), 0, (0, e.arrowHead)(u), 0]);
    },
    leftright: function(u) {
      return (0, e.arrowBBoxHD)(u, [0, (0, e.arrowHead)(u), 0, (0, e.arrowHead)(u)]);
    }
  };
  var o = function(u) {
    return function(l) {
      var c = e.sideIndex[l];
      return [l, {
        renderer: u,
        bbox: function(f) {
          var d = [0, 0, 0, 0];
          return d[c] = f.thickness + f.padding, d;
        },
        border: function(f) {
          var d = [0, 0, 0, 0];
          return d[c] = f.thickness, d;
        }
      }];
    };
  };
  e.CommonBorder = o;
  var a = function(u) {
    return function(l, c, f) {
      var d = e.sideIndex[c], m = e.sideIndex[f];
      return [l, {
        renderer: u,
        bbox: function(p) {
          var v = p.thickness + p.padding, H = [0, 0, 0, 0];
          return H[d] = H[m] = v, H;
        },
        border: function(p) {
          var v = [0, 0, 0, 0];
          return v[d] = v[m] = p.thickness, v;
        },
        remove: c + " " + f
      }];
    };
  };
  e.CommonBorder2 = a;
  var T = function(u) {
    return function(l) {
      var c = "mjx-" + l.charAt(0) + "strike";
      return [l + "diagonalstrike", {
        renderer: u(c),
        bbox: e.fullBBox
      }];
    };
  };
  e.CommonDiagonalStrike = T;
  var s = function(u) {
    return function(l) {
      var c = t(e.diagonalArrowDef[l], 4), f = c[0], d = c[1], m = c[2], p = c[3];
      return [l + "arrow", {
        renderer: function(v, H) {
          var E = t(v.arrowAW(), 2), M = E[0], C = E[1], w = v.arrow(C, f * (M - d), m);
          u(v, w);
        },
        bbox: function(v) {
          var H = v.arrowData(), E = H.a, M = H.x, C = H.y, w = t([v.arrowhead.x, v.arrowhead.y, v.arrowhead.dx], 3), S = w[0], D = w[1], k = w[2], $ = t(v.getArgMod(S + k, D), 2), z = $[0], j = $[1], J = C + (z > E ? v.thickness * j * Math.sin(z - E) : 0), i1 = M + (z > Math.PI / 2 - E ? v.thickness * j * Math.sin(z + E - Math.PI / 2) : 0);
          return [J, i1, J, i1];
        },
        remove: p
      }];
    };
  };
  e.CommonDiagonalArrow = s;
  var Q = function(u) {
    return function(l) {
      var c = t(e.arrowDef[l], 4), f = c[0], d = c[1], m = c[2], p = c[3];
      return [l + "arrow", {
        renderer: function(v, H) {
          var E = v.getBBox(), M = E.w, C = E.h, w = E.d, S = t(m ? [C + w, "X"] : [M, "Y"], 2), D = S[0], k = S[1], $ = v.getOffset(k), z = v.arrow(D, f, d, k, $);
          u(v, z);
        },
        bbox: e.arrowBBox[l],
        remove: p
      }];
    };
  };
  e.CommonArrow = Q;
})(y9);
var Ix = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Rx = b && b.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), Nx = b && b.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Px = b && b.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && Rx(t, e, r);
  return Nx(t, e), t;
}, Ve = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Bx = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Q0 = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(gi, "__esModule", { value: !0 });
gi.CommonMencloseMixin = void 0;
var g6 = Px(y9), Uu = Q3;
function Fx(e) {
  return function(t) {
    Ix(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Bx([], Ve(n), !1)) || this;
      return o.notations = {}, o.renderChild = null, o.msqrt = null, o.padding = g6.PADDING, o.thickness = g6.THICKNESS, o.arrowhead = { x: g6.ARROWX, y: g6.ARROWY, dx: g6.ARROWDX }, o.TRBL = [0, 0, 0, 0], o.getParameters(), o.getNotations(), o.removeRedundantNotations(), o.initializeNotations(), o.TRBL = o.getBBoxExtenders(), o;
    }
    return r.prototype.getParameters = function() {
      var n = this.node.attributes, i = n.get("data-padding");
      i !== void 0 && (this.padding = this.length2em(i, g6.PADDING));
      var o = n.get("data-thickness");
      o !== void 0 && (this.thickness = this.length2em(o, g6.THICKNESS));
      var a = n.get("data-arrowhead");
      if (a !== void 0) {
        var T = Ve((0, Uu.split)(a), 3), s = T[0], Q = T[1], u = T[2];
        this.arrowhead = {
          x: s ? parseFloat(s) : g6.ARROWX,
          y: Q ? parseFloat(Q) : g6.ARROWY,
          dx: u ? parseFloat(u) : g6.ARROWDX
        };
      }
    }, r.prototype.getNotations = function() {
      var n, i, o = this.constructor.notations;
      try {
        for (var a = Q0((0, Uu.split)(this.node.attributes.get("notation"))), T = a.next(); !T.done; T = a.next()) {
          var s = T.value, Q = o.get(s);
          Q && (this.notations[s] = Q, Q.renderChild && (this.renderChild = Q.renderer));
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          T && !T.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, r.prototype.removeRedundantNotations = function() {
      var n, i, o, a;
      try {
        for (var T = Q0(Object.keys(this.notations)), s = T.next(); !s.done; s = T.next()) {
          var Q = s.value;
          if (this.notations[Q]) {
            var u = this.notations[Q].remove || "";
            try {
              for (var l = (o = void 0, Q0(u.split(/ /))), c = l.next(); !c.done; c = l.next()) {
                var f = c.value;
                delete this.notations[f];
              }
            } catch (d) {
              o = { error: d };
            } finally {
              try {
                c && !c.done && (a = l.return) && a.call(l);
              } finally {
                if (o)
                  throw o.error;
              }
            }
          }
        }
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          s && !s.done && (i = T.return) && i.call(T);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, r.prototype.initializeNotations = function() {
      var n, i;
      try {
        for (var o = Q0(Object.keys(this.notations)), a = o.next(); !a.done; a = o.next()) {
          var T = a.value, s = this.notations[T].init;
          s && s(this);
        }
      } catch (Q) {
        n = { error: Q };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, r.prototype.computeBBox = function(n, i) {
      i === void 0 && (i = !1);
      var o = Ve(this.TRBL, 4), a = o[0], T = o[1], s = o[2], Q = o[3], u = this.childNodes[0].getBBox();
      n.combine(u, Q, 0), n.h += a, n.d += s, n.w += T, this.setChildPWidths(i);
    }, r.prototype.getBBoxExtenders = function() {
      var n, i, o = [0, 0, 0, 0];
      try {
        for (var a = Q0(Object.keys(this.notations)), T = a.next(); !T.done; T = a.next()) {
          var s = T.value;
          this.maximizeEntries(o, this.notations[s].bbox(this));
        }
      } catch (Q) {
        n = { error: Q };
      } finally {
        try {
          T && !T.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return o;
    }, r.prototype.getPadding = function() {
      var n, i, o = this, a = [0, 0, 0, 0];
      try {
        for (var T = Q0(Object.keys(this.notations)), s = T.next(); !s.done; s = T.next()) {
          var Q = s.value, u = this.notations[Q].border;
          u && this.maximizeEntries(a, u(this));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          s && !s.done && (i = T.return) && i.call(T);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return [0, 1, 2, 3].map(function(l) {
        return o.TRBL[l] - a[l];
      });
    }, r.prototype.maximizeEntries = function(n, i) {
      for (var o = 0; o < n.length; o++)
        n[o] < i[o] && (n[o] = i[o]);
    }, r.prototype.getOffset = function(n) {
      var i = Ve(this.TRBL, 4), o = i[0], a = i[1], T = i[2], s = i[3], Q = (n === "X" ? a - s : T - o) / 2;
      return Math.abs(Q) > 1e-3 ? Q : 0;
    }, r.prototype.getArgMod = function(n, i) {
      return [Math.atan2(i, n), Math.sqrt(n * n + i * i)];
    }, r.prototype.arrow = function(n, i, o, a, T) {
      return null;
    }, r.prototype.arrowData = function() {
      var n = Ve([this.padding, this.thickness], 2), i = n[0], o = n[1], a = o * (this.arrowhead.x + Math.max(1, this.arrowhead.dx)), T = this.childNodes[0].getBBox(), s = T.h, Q = T.d, u = T.w, l = s + Q, c = Math.sqrt(l * l + u * u), f = Math.max(i, a * u / c), d = Math.max(i, a * l / c), m = Ve(this.getArgMod(u + 2 * f, l + 2 * d), 2), p = m[0], v = m[1];
      return { a: p, W: v, x: f, y: d };
    }, r.prototype.arrowAW = function() {
      var n = this.childNodes[0].getBBox(), i = n.h, o = n.d, a = n.w, T = Ve(this.TRBL, 4), s = T[0], Q = T[1], u = T[2], l = T[3];
      return this.getArgMod(l + a + Q, s + i + o + u);
    }, r.prototype.createMsqrt = function(n) {
      var i = this.node.factory, o = i.create("msqrt");
      o.inheritAttributesFrom(this.node), o.childNodes[0] = n.node;
      var a = this.wrap(o);
      return a.parent = this, a;
    }, r.prototype.sqrtTRBL = function() {
      var n = this.msqrt.getBBox(), i = this.msqrt.childNodes[0].getBBox();
      return [n.h - i.h, 0, n.d - i.d, n.w - i.w];
    }, r;
  }(e);
}
gi.CommonMencloseMixin = Fx;
var th = {};
(function(e) {
  var t = b && b.__createBinding || (Object.create ? function(d, m, p, v) {
    v === void 0 && (v = p);
    var H = Object.getOwnPropertyDescriptor(m, p);
    (!H || ("get" in H ? !m.__esModule : H.writable || H.configurable)) && (H = { enumerable: !0, get: function() {
      return m[p];
    } }), Object.defineProperty(d, v, H);
  } : function(d, m, p, v) {
    v === void 0 && (v = p), d[v] = m[p];
  }), r = b && b.__setModuleDefault || (Object.create ? function(d, m) {
    Object.defineProperty(d, "default", { enumerable: !0, value: m });
  } : function(d, m) {
    d.default = m;
  }), n = b && b.__importStar || function(d) {
    if (d && d.__esModule)
      return d;
    var m = {};
    if (d != null)
      for (var p in d)
        p !== "default" && Object.prototype.hasOwnProperty.call(d, p) && t(m, d, p);
    return r(m, d), m;
  }, i = b && b.__exportStar || function(d, m) {
    for (var p in d)
      p !== "default" && !Object.prototype.hasOwnProperty.call(m, p) && t(m, d, p);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Arrow = e.DiagonalArrow = e.DiagonalStrike = e.Border2 = e.Border = e.RenderLine = e.lineOffset = e.lineData = e.computeLineData = void 0;
  var o = n(y9);
  i(y9, e), e.computeLineData = {
    top: function(d, m, p, v) {
      return [0, d - v, p, d - v];
    },
    right: function(d, m, p, v) {
      return [p - v, -m, p - v, d];
    },
    bottom: function(d, m, p, v) {
      return [0, v - m, p, v - m];
    },
    left: function(d, m, p, v) {
      return [v, -m, v, d];
    },
    vertical: function(d, m, p, v) {
      return [p / 2, d, p / 2, -m];
    },
    horizontal: function(d, m, p, v) {
      return [0, (d - m) / 2, p, (d - m) / 2];
    },
    up: function(d, m, p, v) {
      return [v, v - m, p - v, d - v];
    },
    down: function(d, m, p, v) {
      return [v, d - v, p - v, v - m];
    }
  };
  var a = function(d, m, p) {
    p === void 0 && (p = "");
    var v = d.getBBox(), H = v.h, E = v.d, M = v.w, C = d.thickness / 2;
    return (0, e.lineOffset)(e.computeLineData[m](H, E, M, C), d, p);
  };
  e.lineData = a;
  var T = function(d, m, p) {
    if (p) {
      var v = m.getOffset(p);
      v && (p === "X" ? (d[0] -= v, d[2] -= v) : (d[1] -= v, d[3] -= v));
    }
    return d;
  };
  e.lineOffset = T;
  var s = function(d, m) {
    return m === void 0 && (m = ""), function(p, v) {
      var H = p.line((0, e.lineData)(p, d, m));
      p.adaptor.append(p.element, H);
    };
  };
  e.RenderLine = s;
  var Q = function(d) {
    return o.CommonBorder(function(m, p) {
      m.adaptor.append(m.element, m.line((0, e.lineData)(m, d)));
    })(d);
  };
  e.Border = Q;
  var u = function(d, m, p) {
    return o.CommonBorder2(function(v, H) {
      v.adaptor.append(v.element, v.line((0, e.lineData)(v, m))), v.adaptor.append(v.element, v.line((0, e.lineData)(v, p)));
    })(d, m, p);
  };
  e.Border2 = u;
  var l = function(d) {
    return o.CommonDiagonalStrike(function(m) {
      return function(p, v) {
        p.adaptor.append(p.element, p.line((0, e.lineData)(p, d)));
      };
    })(d);
  };
  e.DiagonalStrike = l;
  var c = function(d) {
    return o.CommonDiagonalArrow(function(m, p) {
      m.adaptor.append(m.element, p);
    })(d);
  };
  e.DiagonalArrow = c;
  var f = function(d) {
    return o.CommonArrow(function(m, p) {
      m.adaptor.append(m.element, p);
    })(d);
  };
  e.Arrow = f;
})(th);
var T8 = {}, jx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), g9 = b && b.__assign || function() {
  return g9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, g9.apply(this, arguments);
};
Object.defineProperty(T8, "__esModule", { value: !0 });
T8.MmlMenclose = void 0;
var SQ = T2, $x = function(e) {
  jx(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = SQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "menclose";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return -1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "linebreakContininer", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    return r = this.childNodes[0].setTeXclass(r), this.updateTeXclass(this.childNodes[0]), r;
  }, t.defaults = g9(g9({}, SQ.AbstractMmlNode.defaults), { notation: "longdiv" }), t;
}(SQ.AbstractMmlNode);
T8.MmlMenclose = $x;
var Xu;
function Zx() {
  if (Xu)
    return fr;
  Xu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var l = function(c, f) {
      return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
        d.__proto__ = m;
      } || function(d, m) {
        for (var p in m)
          Object.prototype.hasOwnProperty.call(m, p) && (d[p] = m[p]);
      }, l(c, f);
    };
    return function(c, f) {
      if (typeof f != "function" && f !== null)
        throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
      l(c, f);
      function d() {
        this.constructor = c;
      }
      c.prototype = f === null ? Object.create(f) : (d.prototype = f.prototype, new d());
    };
  }(), t = b && b.__createBinding || (Object.create ? function(l, c, f, d) {
    d === void 0 && (d = f);
    var m = Object.getOwnPropertyDescriptor(c, f);
    (!m || ("get" in m ? !c.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return c[f];
    } }), Object.defineProperty(l, d, m);
  } : function(l, c, f, d) {
    d === void 0 && (d = f), l[d] = c[f];
  }), r = b && b.__setModuleDefault || (Object.create ? function(l, c) {
    Object.defineProperty(l, "default", { enumerable: !0, value: c });
  } : function(l, c) {
    l.default = c;
  }), n = b && b.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var c = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(c, l, f);
    return r(c, l), c;
  }, i = b && b.__values || function(l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = c && l[c], d = 0;
    if (f)
      return f.call(l);
    if (l && typeof l.length == "number")
      return {
        next: function() {
          return l && d >= l.length && (l = void 0), { value: l && l[d++], done: !l };
        }
      };
    throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, o = b && b.__read || function(l, c) {
    var f = typeof Symbol == "function" && l[Symbol.iterator];
    if (!f)
      return l;
    var d = f.call(l), m, p = [], v;
    try {
      for (; (c === void 0 || c-- > 0) && !(m = d.next()).done; )
        p.push(m.value);
    } catch (H) {
      v = { error: H };
    } finally {
      try {
        m && !m.done && (f = d.return) && f.call(d);
      } finally {
        if (v)
          throw v.error;
      }
    }
    return p;
  };
  Object.defineProperty(fr, "__esModule", { value: !0 }), fr.SVGmenclose = void 0;
  var a = a3(), T = gi, s = n(th), Q = T8, u = function(l) {
    e(c, l);
    function c() {
      return l !== null && l.apply(this, arguments) || this;
    }
    return c.prototype.toSVG = function(f) {
      var d, m, p = this.standardSVGnode(f), v = this.getBBoxExtenders()[3], H = {};
      v > 0 && (H.transform = "translate(" + this.fixed(v) + ", 0)");
      var E = this.adaptor.append(p, this.svg("g", H));
      this.renderChild ? this.renderChild(this, E) : this.childNodes[0].toSVG(E);
      try {
        for (var M = i(Object.keys(this.notations)), C = M.next(); !C.done; C = M.next()) {
          var w = C.value, S = this.notations[w];
          !S.renderChild && S.renderer(this, p);
        }
      } catch (D) {
        d = { error: D };
      } finally {
        try {
          C && !C.done && (m = M.return) && m.call(M);
        } finally {
          if (d)
            throw d.error;
        }
      }
    }, c.prototype.arrow = function(f, d, m, p, v) {
      p === void 0 && (p = ""), v === void 0 && (v = 0);
      var H = this.getBBox(), E = H.w, M = H.h, C = H.d, w = (f - E) / 2, S = (M - C) / 2, D = this.thickness, k = D / 2, $ = o([D * this.arrowhead.x, D * this.arrowhead.y, D * this.arrowhead.dx], 3), z = $[0], j = $[1], J = $[2], i1 = m ? this.fill("M", E + w, S, "l", -(z + J), j, "l", J, k - j, "L", z - w, S + k, "l", J, j - k, "l", -(z + J), -j, "l", z + J, -j, "l", -J, j - k, "L", E + w - z, S - k, "l", -J, k - j, "Z") : this.fill("M", E + w, S, "l", -(z + J), j, "l", J, k - j, "L", -w, S + k, "l", 0, -D, "L", E + w - z, S - k, "l", -J, k - j, "Z"), t1 = [];
      if (v && t1.push(p === "X" ? "translate(".concat(this.fixed(-v), " 0)") : "translate(0 ".concat(this.fixed(v), ")")), d) {
        var T1 = this.jax.fixed(-d * 180 / Math.PI);
        t1.push("rotate(".concat(T1, " ").concat(this.fixed(E / 2), " ").concat(this.fixed(S), ")"));
      }
      return t1.length && this.adaptor.setAttribute(i1, "transform", t1.join(" ")), i1;
    }, c.prototype.line = function(f) {
      var d = o(f, 4), m = d[0], p = d[1], v = d[2], H = d[3];
      return this.svg("line", {
        x1: this.fixed(m),
        y1: this.fixed(p),
        x2: this.fixed(v),
        y2: this.fixed(H),
        "stroke-width": this.fixed(this.thickness)
      });
    }, c.prototype.box = function(f, d, m, p) {
      p === void 0 && (p = 0);
      var v = this.thickness, H = {
        x: this.fixed(v / 2),
        y: this.fixed(v / 2 - m),
        width: this.fixed(f - v),
        height: this.fixed(d + m - v),
        fill: "none",
        "stroke-width": this.fixed(v)
      };
      return p && (H.rx = this.fixed(p)), this.svg("rect", H);
    }, c.prototype.ellipse = function(f, d, m) {
      var p = this.thickness;
      return this.svg("ellipse", {
        rx: this.fixed((f - p) / 2),
        ry: this.fixed((d + m - p) / 2),
        cx: this.fixed(f / 2),
        cy: this.fixed((d - m) / 2),
        fill: "none",
        "stroke-width": this.fixed(p)
      });
    }, c.prototype.path = function(f) {
      for (var d = this, m = [], p = 1; p < arguments.length; p++)
        m[p - 1] = arguments[p];
      return this.svg("path", {
        d: m.map(function(v) {
          return typeof v == "string" ? v : d.fixed(v);
        }).join(" "),
        style: { "stroke-width": this.fixed(this.thickness) },
        "stroke-linecap": "round",
        "stroke-linejoin": f,
        fill: "none"
      });
    }, c.prototype.fill = function() {
      for (var f = this, d = [], m = 0; m < arguments.length; m++)
        d[m] = arguments[m];
      return this.svg("path", {
        d: d.map(function(p) {
          return typeof p == "string" ? p : f.fixed(p);
        }).join(" ")
      });
    }, c.kind = Q.MmlMenclose.prototype.kind, c.notations = new Map([
      s.Border("top"),
      s.Border("right"),
      s.Border("bottom"),
      s.Border("left"),
      s.Border2("actuarial", "top", "right"),
      s.Border2("madruwb", "bottom", "right"),
      s.DiagonalStrike("up"),
      s.DiagonalStrike("down"),
      ["horizontalstrike", {
        renderer: s.RenderLine("horizontal", "Y"),
        bbox: function(f) {
          return [0, f.padding, 0, f.padding];
        }
      }],
      ["verticalstrike", {
        renderer: s.RenderLine("vertical", "X"),
        bbox: function(f) {
          return [f.padding, 0, f.padding, 0];
        }
      }],
      ["box", {
        renderer: function(f, d) {
          var m = f.getBBox(), p = m.w, v = m.h, H = m.d;
          f.adaptor.append(f.element, f.box(p, v, H));
        },
        bbox: s.fullBBox,
        border: s.fullBorder,
        remove: "left right top bottom"
      }],
      ["roundedbox", {
        renderer: function(f, d) {
          var m = f.getBBox(), p = m.w, v = m.h, H = m.d, E = f.thickness + f.padding;
          f.adaptor.append(f.element, f.box(p, v, H, E));
        },
        bbox: s.fullBBox
      }],
      ["circle", {
        renderer: function(f, d) {
          var m = f.getBBox(), p = m.w, v = m.h, H = m.d;
          f.adaptor.append(f.element, f.ellipse(p, v, H));
        },
        bbox: s.fullBBox
      }],
      ["phasorangle", {
        renderer: function(f, d) {
          var m = f.getBBox(), p = m.w, v = m.h, H = m.d, E = f.getArgMod(1.75 * f.padding, v + H)[0], M = f.thickness / 2, C = v + H, w = Math.cos(E);
          f.adaptor.append(f.element, f.path("mitre", "M", p, M - H, "L", M + w * M, M - H, "L", w * C + M, C - H - M));
        },
        bbox: function(f) {
          var d = f.padding / 2, m = f.thickness;
          return [2 * d, d, d + m, 3 * d + m];
        },
        border: function(f) {
          return [0, 0, f.thickness, 0];
        },
        remove: "bottom"
      }],
      s.Arrow("up"),
      s.Arrow("down"),
      s.Arrow("left"),
      s.Arrow("right"),
      s.Arrow("updown"),
      s.Arrow("leftright"),
      s.DiagonalArrow("updiagonal"),
      s.DiagonalArrow("northeast"),
      s.DiagonalArrow("southeast"),
      s.DiagonalArrow("northwest"),
      s.DiagonalArrow("southwest"),
      s.DiagonalArrow("northeastsouthwest"),
      s.DiagonalArrow("northwestsoutheast"),
      ["longdiv", {
        renderer: function(f, d) {
          var m = f.getBBox(), p = m.w, v = m.h, H = m.d, E = f.thickness / 2, M = f.padding;
          f.adaptor.append(f.element, f.path("round", "M", E, E - H, "a", M - E / 2, (v + H) / 2 - 4 * E, 0, "0,1", 0, v + H - 2 * E, "L", p - E, v - E));
        },
        bbox: function(f) {
          var d = f.padding, m = f.thickness;
          return [d + m, d, d, 2 * d + m / 2];
        }
      }],
      ["radical", {
        renderer: function(f, d) {
          f.msqrt.toSVG(d);
          var m = f.sqrtTRBL()[3];
          f.place(-m, 0, d);
        },
        init: function(f) {
          f.msqrt = f.createMsqrt(f.childNodes[0]);
        },
        bbox: function(f) {
          return f.sqrtTRBL();
        },
        renderChild: !0
      }]
    ]), c;
  }((0, T.CommonMencloseMixin)(a.SVGWrapper));
  return fr.SVGmenclose = u, fr;
}
var K4 = {}, xi = {}, Wx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(xi, "__esModule", { value: !0 });
xi.CommonSemanticsMixin = void 0;
function Gx(e) {
  return function(t) {
    Wx(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.computeBBox = function(n, i) {
      if (this.childNodes.length) {
        var o = this.childNodes[0].getBBox(), a = o.w, T = o.h, s = o.d;
        n.w = a, n.h = T, n.d = s;
      }
    }, r;
  }(e);
}
xi.CommonSemanticsMixin = Gx;
var r5 = {}, ks = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Je = b && b.__assign || function() {
  return Je = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Je.apply(this, arguments);
};
Object.defineProperty(r5, "__esModule", { value: !0 });
r5.MmlAnnotation = r5.MmlAnnotationXML = r5.MmlSemantics = void 0;
var x9 = T2, zx = function(e) {
  ks(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "semantics";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "notParent", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = Je(Je({}, x9.AbstractMmlBaseNode.defaults), { definitionUrl: null, encoding: null }), t;
}(x9.AbstractMmlBaseNode);
r5.MmlSemantics = zx;
var ET = function(e) {
  ks(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "annotation-xml";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function() {
  }, t.defaults = Je(Je({}, x9.AbstractMmlNode.defaults), { definitionUrl: null, encoding: null, cd: "mathmlkeys", name: "", src: null }), t;
}(x9.AbstractMmlNode);
r5.MmlAnnotationXML = ET;
var Ux = function(e) {
  ks(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.properties = {
      isChars: !0
    }, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "annotation";
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = Je({}, ET.defaults), t;
}(ET);
r5.MmlAnnotation = Ux;
var qu;
function Xx() {
  if (qu)
    return K4;
  qu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var Q = function(u, l) {
      return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, f) {
        c.__proto__ = f;
      } || function(c, f) {
        for (var d in f)
          Object.prototype.hasOwnProperty.call(f, d) && (c[d] = f[d]);
      }, Q(u, l);
    };
    return function(u, l) {
      if (typeof l != "function" && l !== null)
        throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
      Q(u, l);
      function c() {
        this.constructor = u;
      }
      u.prototype = l === null ? Object.create(l) : (c.prototype = l.prototype, new c());
    };
  }();
  Object.defineProperty(K4, "__esModule", { value: !0 }), K4.SVGxml = K4.SVGannotationXML = K4.SVGannotation = K4.SVGsemantics = void 0;
  var t = a3(), r = xi, n = r5, i = T2, o = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.prototype.toSVG = function(l) {
      var c = this.standardSVGnode(l);
      this.childNodes.length && this.childNodes[0].toSVG(c);
    }, u.kind = n.MmlSemantics.prototype.kind, u;
  }((0, r.CommonSemanticsMixin)(t.SVGWrapper));
  K4.SVGsemantics = o;
  var a = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.prototype.toSVG = function(l) {
      Q.prototype.toSVG.call(this, l);
    }, u.prototype.computeBBox = function() {
      return this.bbox;
    }, u.kind = n.MmlAnnotation.prototype.kind, u;
  }(t.SVGWrapper);
  K4.SVGannotation = a;
  var T = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.kind = n.MmlAnnotationXML.prototype.kind, u.styles = {
      "foreignObject[data-mjx-xml]": {
        "font-family": "initial",
        "line-height": "normal",
        overflow: "visible"
      }
    }, u;
  }(t.SVGWrapper);
  K4.SVGannotationXML = T;
  var s = function(Q) {
    e(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.prototype.toSVG = function(l) {
      var c = this.adaptor.clone(this.node.getXML()), f = this.jax.math.metrics.em * this.jax.math.metrics.scale, d = this.fixed(1 / f), m = this.getBBox(), p = m.w, v = m.h, H = m.d;
      this.element = this.adaptor.append(l, this.svg("foreignObject", {
        "data-mjx-xml": !0,
        y: this.jax.fixed(-v * f) + "px",
        width: this.jax.fixed(p * f) + "px",
        height: this.jax.fixed((v + H) * f) + "px",
        transform: "scale(".concat(d, ") matrix(1 0 0 -1 0 0)")
      }, [c]));
    }, u.prototype.computeBBox = function(l, c) {
      var f = this.jax.measureXMLnode(this.node.getXML()), d = f.w, m = f.h, p = f.d;
      l.w = d, l.h = m, l.d = p;
    }, u.prototype.getStyles = function() {
    }, u.prototype.getScale = function() {
    }, u.prototype.getVariant = function() {
    }, u.kind = i.XMLNode.prototype.kind, u.autoStyle = !1, u;
  }(t.SVGWrapper);
  return K4.SVGxml = s, K4;
}
var dr = {}, Hi = {}, qx = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Jx = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Yx = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(Hi, "__esModule", { value: !0 });
Hi.CommonMglyphMixin = void 0;
function Kx(e) {
  return function(t) {
    qx(r, t);
    function r() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = t.apply(this, Yx([], Jx(n), !1)) || this;
      return o.getParameters(), o;
    }
    return r.prototype.getParameters = function() {
      var n = this.node.attributes.getList("width", "height", "valign", "src", "index"), i = n.width, o = n.height, a = n.valign, T = n.src, s = n.index;
      if (T)
        this.width = i === "auto" ? 1 : this.length2em(i), this.height = o === "auto" ? 1 : this.length2em(o), this.valign = this.length2em(a || "0");
      else {
        var Q = String.fromCodePoint(parseInt(s)), u = this.node.factory;
        this.charWrapper = this.wrap(u.create("text").setText(Q)), this.charWrapper.parent = this;
      }
    }, r.prototype.computeBBox = function(n, i) {
      this.charWrapper ? n.updateFrom(this.charWrapper.getBBox()) : (n.w = this.width, n.h = this.height + this.valign, n.d = -this.valign);
    }, r;
  }(e);
}
Hi.CommonMglyphMixin = Kx;
var s8 = {}, eH = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), H9 = b && b.__assign || function() {
  return H9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, H9.apply(this, arguments);
};
Object.defineProperty(s8, "__esModule", { value: !0 });
s8.MmlMglyph = void 0;
var CQ = T2, tH = function(e) {
  eH(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.texclass = CQ.TEXCLASS.ORD, r;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mglyph";
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.verifyAttributes = function(r) {
    var n = this.attributes.getList("src", "fontfamily", "index"), i = n.src, o = n.fontfamily, a = n.index;
    i === "" && (o === "" || a === "") ? this.mError("mglyph must have either src or fontfamily and index attributes", r, !0) : e.prototype.verifyAttributes.call(this, r);
  }, t.defaults = H9(H9({}, CQ.AbstractMmlTokenNode.defaults), { alt: "", src: "", index: "", width: "auto", height: "auto", valign: "0em" }), t;
}(CQ.AbstractMmlTokenNode);
s8.MmlMglyph = tH;
var Ju;
function rH() {
  if (Ju)
    return dr;
  Ju = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var o = function(a, T) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, Q) {
        s.__proto__ = Q;
      } || function(s, Q) {
        for (var u in Q)
          Object.prototype.hasOwnProperty.call(Q, u) && (s[u] = Q[u]);
      }, o(a, T);
    };
    return function(a, T) {
      if (typeof T != "function" && T !== null)
        throw new TypeError("Class extends value " + String(T) + " is not a constructor or null");
      o(a, T);
      function s() {
        this.constructor = a;
      }
      a.prototype = T === null ? Object.create(T) : (s.prototype = T.prototype, new s());
    };
  }();
  Object.defineProperty(dr, "__esModule", { value: !0 }), dr.SVGmglyph = void 0;
  var t = a3(), r = Hi, n = s8, i = function(o) {
    e(a, o);
    function a() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return a.prototype.toSVG = function(T) {
      var s = this.standardSVGnode(T);
      if (this.charWrapper) {
        this.charWrapper.toSVG(s);
        return;
      }
      var Q = this.node.attributes.getList("src", "alt"), u = Q.src, l = Q.alt, c = this.fixed(this.height), f = this.fixed(this.width), d = this.fixed(this.height + (this.valign || 0)), m = {
        width: f,
        height: c,
        transform: "translate(0 " + d + ") matrix(1 0 0 -1 0 0)",
        preserveAspectRatio: "none",
        "aria-label": l,
        href: u
      }, p = this.svg("image", m);
      this.adaptor.append(s, p);
    }, a.kind = n.MmlMglyph.prototype.kind, a;
  }((0, r.CommonMglyphMixin)(t.SVGWrapper));
  return dr.SVGmglyph = i, dr;
}
var hr = {}, Ei = {}, nH = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Ei, "__esModule", { value: !0 });
Ei.CommonTeXAtomMixin = void 0;
var iH = T2;
function oH(e) {
  return function(t) {
    nH(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.computeBBox = function(n, i) {
      if (i === void 0 && (i = !1), t.prototype.computeBBox.call(this, n, i), this.childNodes[0] && this.childNodes[0].bbox.ic && (n.ic = this.childNodes[0].bbox.ic), this.node.texClass === iH.TEXCLASS.VCENTER) {
        var o = n.h, a = n.d, T = this.font.params.axis_height, s = (o + a) / 2 + T - o;
        n.h += s, n.d -= s;
      }
    }, r;
  }(e);
}
Ei.CommonTeXAtomMixin = oH;
var l8 = {}, aH = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bT = b && b.__assign || function() {
  return bT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, bT.apply(this, arguments);
};
Object.defineProperty(l8, "__esModule", { value: !0 });
l8.TeXAtom = void 0;
var VQ = T2, QH = rt, rh = function(e) {
  aH(t, e);
  function t(r, n, i) {
    var o = e.call(this, r, n, i) || this;
    return o.texclass = VQ.TEXCLASS.ORD, o.setProperty("texClass", o.texClass), o;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "TeXAtom";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return -1;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "notParent", {
    get: function() {
      return this.childNodes[0] && this.childNodes[0].childNodes.length === 1;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setTeXclass = function(r) {
    return this.childNodes[0].setTeXclass(null), this.adjustTeXclass(r);
  }, t.prototype.adjustTeXclass = function(r) {
    return r;
  }, t.defaults = bT({}, VQ.AbstractMmlBaseNode.defaults), t;
}(VQ.AbstractMmlBaseNode);
l8.TeXAtom = rh;
rh.prototype.adjustTeXclass = QH.MmlMo.prototype.adjustTeXclass;
var Yu;
function TH() {
  if (Yu)
    return hr;
  Yu = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }();
  Object.defineProperty(hr, "__esModule", { value: !0 }), hr.SVGTeXAtom = void 0;
  var t = a3(), r = Ei, n = l8, i = T2, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.toSVG = function(s) {
      if (a.prototype.toSVG.call(this, s), this.adaptor.setAttribute(this.element, "data-mjx-texclass", i.TEXCLASSNAMES[this.node.texClass]), this.node.texClass === i.TEXCLASS.VCENTER) {
        var Q = this.childNodes[0].getBBox(), u = Q.h, l = Q.d, c = this.font.params.axis_height, f = (u + l) / 2 + c - u, d = "translate(0 " + this.fixed(f) + ")";
        this.adaptor.setAttribute(this.element, "transform", d);
      }
    }, T.kind = n.TeXAtom.prototype.kind, T;
  }((0, r.CommonTeXAtomMixin)(t.SVGWrapper));
  return hr.SVGTeXAtom = o, hr;
}
var pr = {}, bi = {}, sH = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), lH = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, uH = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
};
Object.defineProperty(bi, "__esModule", { value: !0 });
bi.CommonTextNodeMixin = void 0;
function cH(e) {
  return function(t) {
    sH(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.computeBBox = function(n, i) {
      var o, a, T = this.parent.variant, s = this.node.getText();
      if (T === "-explicitFont") {
        var Q = this.jax.getFontData(this.parent.styles), u = this.jax.measureText(s, T, Q), l = u.w, c = u.h, f = u.d;
        n.h = c, n.d = f, n.w = l;
      } else {
        var d = this.remappedText(s, T);
        n.empty();
        try {
          for (var m = lH(d), p = m.next(); !p.done; p = m.next()) {
            var v = p.value, H = uH(this.getVariantChar(T, v), 4), c = H[0], f = H[1], l = H[2], E = H[3];
            if (E.unknown) {
              var M = this.jax.measureText(String.fromCodePoint(v), T);
              l = M.w, c = M.h, f = M.d;
            }
            n.w += l, c > n.h && (n.h = c), f > n.d && (n.d = f), n.ic = E.ic || 0, n.sk = E.sk || 0, n.dx = E.dx || 0;
          }
        } catch (C) {
          o = { error: C };
        } finally {
          try {
            p && !p.done && (a = m.return) && a.call(m);
          } finally {
            if (o)
              throw o.error;
          }
        }
        d.length > 1 && (n.sk = 0), n.clean();
      }
    }, r.prototype.remappedText = function(n, i) {
      var o = this.parent.stretch.c;
      return o ? [o] : this.parent.remapChars(this.unicodeChars(n, i));
    }, r.prototype.getStyles = function() {
    }, r.prototype.getVariant = function() {
    }, r.prototype.getScale = function() {
    }, r.prototype.getSpace = function() {
    }, r;
  }(e);
}
bi.CommonTextNodeMixin = cH;
var Ku;
function fH() {
  if (Ku)
    return pr;
  Ku = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var a = function(T, s) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Q, u) {
        Q.__proto__ = u;
      } || function(Q, u) {
        for (var l in u)
          Object.prototype.hasOwnProperty.call(u, l) && (Q[l] = u[l]);
      }, a(T, s);
    };
    return function(T, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      a(T, s);
      function Q() {
        this.constructor = T;
      }
      T.prototype = s === null ? Object.create(s) : (Q.prototype = s.prototype, new Q());
    };
  }(), t = b && b.__values || function(a) {
    var T = typeof Symbol == "function" && Symbol.iterator, s = T && a[T], Q = 0;
    if (s)
      return s.call(a);
    if (a && typeof a.length == "number")
      return {
        next: function() {
          return a && Q >= a.length && (a = void 0), { value: a && a[Q++], done: !a };
        }
      };
    throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(pr, "__esModule", { value: !0 }), pr.SVGTextNode = void 0;
  var r = T2, n = a3(), i = bi, o = function(a) {
    e(T, a);
    function T() {
      return a !== null && a.apply(this, arguments) || this;
    }
    return T.prototype.toSVG = function(s) {
      var Q, u, l = this.node.getText(), c = this.parent.variant;
      if (l.length !== 0)
        if (c === "-explicitFont")
          this.element = this.adaptor.append(s, this.jax.unknownText(l, c));
        else {
          var f = this.remappedText(l, c);
          this.parent.childNodes.length > 1 && (s = this.element = this.adaptor.append(s, this.svg("g", { "data-mml-node": "text" })));
          var d = 0;
          try {
            for (var m = t(f), p = m.next(); !p.done; p = m.next()) {
              var v = p.value;
              d += this.placeChar(v, d, 0, s, c);
            }
          } catch (H) {
            Q = { error: H };
          } finally {
            try {
              p && !p.done && (u = m.return) && u.call(m);
            } finally {
              if (Q)
                throw Q.error;
            }
          }
        }
    }, T.kind = r.TextNode.prototype.kind, T.styles = {
      'mjx-container[jax="SVG"] path[data-c], mjx-container[jax="SVG"] use[data-c]': {
        "stroke-width": 3
      }
    }, T;
  }((0, i.CommonTextNodeMixin)(n.SVGWrapper));
  return pr.SVGTextNode = o, pr;
}
var ec;
function dH() {
  if (ec)
    return Z7;
  ec = 1;
  var e;
  Object.defineProperty(Z7, "__esModule", { value: !0 }), Z7.SVGWrappers = void 0;
  var t = a3(), r = xy(), n = Cy(), i = Dy(), o = Fy(), a = Gy(), T = Ky(), s = ig(), Q = Qg(), u = cg(), l = vg(), c = gg(), f = Sg(), d = qd(), m = Pg(), p = zg(), v = Vs(), H = Tx(), E = cx(), M = xx(), C = wx(), w = Ox(), S = kx(), D = Zx(), k = Xx(), $ = rH(), z = TH(), j = fH();
  return Z7.SVGWrappers = (e = {}, e[r.SVGmath.kind] = r.SVGmath, e[n.SVGmrow.kind] = n.SVGmrow, e[n.SVGinferredMrow.kind] = n.SVGinferredMrow, e[i.SVGmi.kind] = i.SVGmi, e[o.SVGmo.kind] = o.SVGmo, e[a.SVGmn.kind] = a.SVGmn, e[T.SVGms.kind] = T.SVGms, e[s.SVGmtext.kind] = s.SVGmtext, e[Q.SVGmerror.kind] = Q.SVGmerror, e[u.SVGmspace.kind] = u.SVGmspace, e[l.SVGmpadded.kind] = l.SVGmpadded, e[c.SVGmphantom.kind] = c.SVGmphantom, e[f.SVGmfrac.kind] = f.SVGmfrac, e[d.SVGmsqrt.kind] = d.SVGmsqrt, e[m.SVGmroot.kind] = m.SVGmroot, e[p.SVGmfenced.kind] = p.SVGmfenced, e[v.SVGmsub.kind] = v.SVGmsub, e[v.SVGmsup.kind] = v.SVGmsup, e[v.SVGmsubsup.kind] = v.SVGmsubsup, e[H.SVGmunder.kind] = H.SVGmunder, e[H.SVGmover.kind] = H.SVGmover, e[H.SVGmunderover.kind] = H.SVGmunderover, e[E.SVGmmultiscripts.kind] = E.SVGmmultiscripts, e[M.SVGmtable.kind] = M.SVGmtable, e[C.SVGmtr.kind] = C.SVGmtr, e[C.SVGmlabeledtr.kind] = C.SVGmlabeledtr, e[w.SVGmtd.kind] = w.SVGmtd, e[S.SVGmaction.kind] = S.SVGmaction, e[D.SVGmenclose.kind] = D.SVGmenclose, e[k.SVGsemantics.kind] = k.SVGsemantics, e[k.SVGannotation.kind] = k.SVGannotation, e[k.SVGannotationXML.kind] = k.SVGannotationXML, e[k.SVGxml.kind] = k.SVGxml, e[$.SVGmglyph.kind] = $.SVGmglyph, e[z.SVGTeXAtom.kind] = z.SVGTeXAtom, e[j.SVGTextNode.kind] = j.SVGTextNode, e[t.SVGWrapper.kind] = t.SVGWrapper, e), Z7;
}
var tc;
function hH() {
  if (tc)
    return $7;
  tc = 1;
  var e = b && b.__extends || /* @__PURE__ */ function() {
    var i = function(o, a) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, s) {
        T.__proto__ = s;
      } || function(T, s) {
        for (var Q in s)
          Object.prototype.hasOwnProperty.call(s, Q) && (T[Q] = s[Q]);
      }, i(o, a);
    };
    return function(o, a) {
      if (typeof a != "function" && a !== null)
        throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
      i(o, a);
      function T() {
        this.constructor = o;
      }
      o.prototype = a === null ? Object.create(a) : (T.prototype = a.prototype, new T());
    };
  }();
  Object.defineProperty($7, "__esModule", { value: !0 }), $7.SVGWrapperFactory = void 0;
  var t = ni, r = dH(), n = function(i) {
    e(o, i);
    function o() {
      var a = i !== null && i.apply(this, arguments) || this;
      return a.jax = null, a;
    }
    return o.defaultNodes = r.SVGWrappers, o;
  }(t.CommonWrapperFactory);
  return $7.SVGWrapperFactory = n, $7;
}
var Mi = {}, s3 = {};
(function(e) {
  var t = b && b.__extends || /* @__PURE__ */ function() {
    var Q = function(u, l) {
      return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, f) {
        c.__proto__ = f;
      } || function(c, f) {
        for (var d in f)
          Object.prototype.hasOwnProperty.call(f, d) && (c[d] = f[d]);
      }, Q(u, l);
    };
    return function(u, l) {
      if (typeof l != "function" && l !== null)
        throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
      Q(u, l);
      function c() {
        this.constructor = u;
      }
      u.prototype = l === null ? Object.create(l) : (c.prototype = l.prototype, new c());
    };
  }(), r = b && b.__assign || function() {
    return r = Object.assign || function(Q) {
      for (var u, l = 1, c = arguments.length; l < c; l++) {
        u = arguments[l];
        for (var f in u)
          Object.prototype.hasOwnProperty.call(u, f) && (Q[f] = u[f]);
      }
      return Q;
    }, r.apply(this, arguments);
  }, n = b && b.__createBinding || (Object.create ? function(Q, u, l, c) {
    c === void 0 && (c = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(Q, c, f);
  } : function(Q, u, l, c) {
    c === void 0 && (c = l), Q[c] = u[l];
  }), i = b && b.__exportStar || function(Q, u) {
    for (var l in Q)
      l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && n(u, Q, l);
  }, o = b && b.__values || function(Q) {
    var u = typeof Symbol == "function" && Symbol.iterator, l = u && Q[u], c = 0;
    if (l)
      return l.call(Q);
    if (Q && typeof Q.length == "number")
      return {
        next: function() {
          return Q && c >= Q.length && (Q = void 0), { value: Q && Q[c++], done: !Q };
        }
      };
    throw new TypeError(u ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AddPaths = e.SVGFontData = void 0;
  var a = p4;
  i(p4, e);
  var T = function(Q) {
    t(u, Q);
    function u() {
      return Q !== null && Q.apply(this, arguments) || this;
    }
    return u.charOptions = function(l, c) {
      return Q.charOptions.call(this, l, c);
    }, u.OPTIONS = r(r({}, a.FontData.OPTIONS), { dynamicPrefix: "./output/svg/fonts" }), u.JAX = "SVG", u;
  }(a.FontData);
  e.SVGFontData = T;
  function s(Q, u, l) {
    var c, f, d, m;
    try {
      for (var p = o(Object.keys(u)), v = p.next(); !v.done; v = p.next()) {
        var H = v.value, E = parseInt(H);
        T.charOptions(Q, E).p = u[E];
      }
    } catch (w) {
      c = { error: w };
    } finally {
      try {
        v && !v.done && (f = p.return) && f.call(p);
      } finally {
        if (c)
          throw c.error;
      }
    }
    try {
      for (var M = o(Object.keys(l)), C = M.next(); !C.done; C = M.next()) {
        var H = C.value, E = parseInt(H);
        T.charOptions(Q, E).c = l[E];
      }
    } catch (w) {
      d = { error: w };
    } finally {
      try {
        C && !C.done && (m = M.return) && m.call(M);
      } finally {
        if (d)
          throw d.error;
      }
    }
    return Q;
  }
  e.AddPaths = s;
})(s3);
var wi = {}, pH = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), E9 = b && b.__assign || function() {
  return E9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, E9.apply(this, arguments);
}, mH = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, rc = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(wi, "__esModule", { value: !0 });
wi.CommonTeXFontMixin = void 0;
function vH(e) {
  var t;
  return t = function(r) {
    pH(n, r);
    function n() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return n.prototype.getDelimiterData = function(i) {
      return this.getChar("-smallop", i) || this.getChar("-size4", i);
    }, n;
  }(e), t.NAME = "TeX", t.defaultVariants = rc(rc([], mH(e.defaultVariants), !1), [
    ["-smallop", "normal"],
    ["-largeop", "normal"],
    ["-size3", "normal"],
    ["-size4", "normal"],
    ["-tex-calligraphic", "italic"],
    ["-tex-bold-calligraphic", "bold-italic"],
    ["-tex-oldstyle", "normal"],
    ["-tex-bold-oldstyle", "bold"],
    ["-tex-mathit", "italic"],
    ["-tex-variant", "normal"]
  ], !1), t.defaultCssFonts = E9(E9({}, e.defaultCssFonts), { "-smallop": ["serif", !1, !1], "-largeop": ["serif", !1, !1], "-size3": ["serif", !1, !1], "-size4": ["serif", !1, !1], "-tex-calligraphic": ["cursive", !0, !1], "-tex-bold-calligraphic": ["cursive", !0, !0], "-tex-oldstyle": ["serif", !1, !1], "-tex-bold-oldstyle": ["serif", !1, !0], "-tex-mathit": ["serif", !0, !1] }), t.defaultSizeVariants = ["normal", "-smallop", "-largeop", "-size3", "-size4", "-tex-variant"], t.defaultStretchVariants = ["-size4"], t;
}
wi.CommonTeXFontMixin = vH;
var Si = {}, Ci = {};
Object.defineProperty(Ci, "__esModule", { value: !0 });
Ci.boldItalic = void 0;
Ci.boldItalic = {
  47: [0.711, 0.21, 0.894],
  305: [0.452, 8e-3, 0.394, { sk: 0.0319 }],
  567: [0.451, 0.201, 0.439, { sk: 0.0958 }],
  8260: [0.711, 0.21, 0.894],
  8710: [0.711, 0, 0.958, { sk: 0.192 }],
  10744: [0.711, 0.21, 0.894]
};
Object.defineProperty(Si, "__esModule", { value: !0 });
Si.boldItalic = void 0;
var LH = s3, yH = Ci;
Si.boldItalic = (0, LH.AddPaths)(yH.boldItalic, {
  47: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210",
  305: "24 296Q24 305 34 328T63 380T115 430T187 452Q205 452 223 448T262 435T295 406T308 360Q308 345 287 290T240 170T207 87Q202 67 202 57Q202 42 215 42Q235 42 257 64Q288 92 302 140Q307 156 310 159T330 162H336H347Q367 162 367 148Q367 140 357 117T329 65T276 14T201 -8Q158 -8 121 15T83 84Q83 104 133 229T184 358Q189 376 189 388Q189 402 177 402Q156 402 134 380Q103 352 89 304Q84 288 81 285T61 282H55H44Q24 282 24 296",
  567: "297 360T297 373T294 392T288 400T278 401H276Q237 398 200 363Q181 343 170 325T156 299T149 287T129 282H123H116Q102 282 97 284T92 298Q93 303 98 315T118 349T151 390T201 427T267 451H279Q357 451 388 422T420 354V339L370 138Q321 -60 317 -69Q287 -157 163 -194Q133 -201 99 -201Q39 -201 14 -178T-12 -125Q-12 -94 11 -69T68 -43Q93 -43 108 -57T123 -95Q123 -121 100 -151H104Q131 -151 155 -125T193 -60Q195 -54 244 141T294 345Q297 360 297 373",
  8260: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210",
  8710: "65 0Q59 6 59 9T61 16Q64 20 334 357T608 698Q616 706 629 710Q630 710 634 710T644 710T656 711Q686 711 694 703Q698 699 700 693Q706 674 805 345T904 14Q904 7 894 1L479 0H65ZM630 342L567 551L232 134L462 133H693Q693 137 630 342",
  10744: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210"
}, {});
var Vi = {}, _i = {};
Object.defineProperty(_i, "__esModule", { value: !0 });
_i.bold = void 0;
_i.bold = {
  33: [0.705, 0, 0.35],
  34: [0.694, -0.329, 0.603],
  35: [0.694, 0.193, 0.958],
  36: [0.75, 0.056, 0.575],
  37: [0.75, 0.056, 0.958],
  38: [0.705, 0.011, 0.894],
  39: [0.694, -0.329, 0.319],
  40: [0.75, 0.249, 0.447],
  41: [0.75, 0.249, 0.447],
  42: [0.75, -0.306, 0.575],
  43: [0.633, 0.131, 0.894],
  44: [0.171, 0.194, 0.319],
  45: [0.278, -0.166, 0.383],
  46: [0.171, 0, 0.319],
  47: [0.75, 0.25, 0.575],
  58: [0.444, 0, 0.319],
  59: [0.444, 0.194, 0.319],
  60: [0.587, 0.085, 0.894],
  61: [0.393, -0.109, 0.894],
  62: [0.587, 0.085, 0.894],
  63: [0.7, 0, 0.543],
  64: [0.699, 6e-3, 0.894],
  91: [0.75, 0.25, 0.319],
  92: [0.75, 0.25, 0.575],
  93: [0.75, 0.25, 0.319],
  94: [0.694, -0.52, 0.575],
  95: [-0.01, 0.061, 0.575],
  96: [0.706, -0.503, 0.575],
  123: [0.75, 0.25, 0.575],
  124: [0.75, 0.249, 0.319],
  125: [0.75, 0.25, 0.575],
  126: [0.344, -0.202, 0.575],
  168: [0.695, -0.535, 0.575],
  172: [0.371, -0.061, 0.767],
  175: [0.607, -0.54, 0.575],
  176: [0.702, -0.536, 0.575],
  177: [0.728, 0.035, 0.894],
  180: [0.706, -0.503, 0.575],
  183: [0.336, -0.166, 0.319],
  215: [0.53, 0.028, 0.894],
  247: [0.597, 0.096, 0.894],
  305: [0.442, 0, 0.278, { sk: 0.0278 }],
  567: [0.442, 0.205, 0.306, { sk: 0.0833 }],
  697: [0.563, -0.033, 0.344],
  710: [0.694, -0.52, 0.575],
  711: [0.66, -0.515, 0.575],
  713: [0.607, -0.54, 0.575],
  714: [0.706, -0.503, 0.575],
  715: [0.706, -0.503, 0.575],
  728: [0.694, -0.5, 0.575],
  729: [0.695, -0.525, 0.575],
  730: [0.702, -0.536, 0.575],
  732: [0.694, -0.552, 0.575],
  768: [0.706, -0.503, 0],
  769: [0.706, -0.503, 0],
  770: [0.694, -0.52, 0],
  771: [0.694, -0.552, 0],
  772: [0.607, -0.54, 0],
  774: [0.694, -0.5, 0],
  775: [0.695, -0.525, 0],
  776: [0.695, -0.535, 0],
  778: [0.702, -0.536, 0],
  779: [0.714, -0.511, 0],
  780: [0.66, -0.515, 0],
  824: [0.711, 0.21, 0],
  8194: [0, 0, 0.5],
  8195: [0, 0, 0.999],
  8196: [0, 0, 0.333],
  8197: [0, 0, 0.25],
  8198: [0, 0, 0.167],
  8201: [0, 0, 0.167],
  8202: [0, 0, 0.083],
  8211: [0.3, -0.249, 0.575],
  8212: [0.3, -0.249, 1.15],
  8213: [0.3, -0.249, 1.15],
  8214: [0.75, 0.248, 0.575],
  8215: [-0.01, 0.061, 0.575],
  8216: [0.694, -0.329, 0.319],
  8217: [0.694, -0.329, 0.319],
  8220: [0.694, -0.329, 0.603],
  8221: [0.694, -0.329, 0.603],
  8224: [0.702, 0.211, 0.511],
  8225: [0.702, 0.202, 0.511],
  8226: [0.474, -0.028, 0.575],
  8230: [0.171, 0, 1.295],
  8242: [0.563, -0.033, 0.344],
  8243: [0.563, 0, 0.688],
  8244: [0.563, 0, 1.032],
  8254: [0.607, -0.54, 0.575],
  8260: [0.75, 0.25, 0.575],
  8279: [0.563, 0, 1.376],
  8407: [0.723, -0.513, 0.575],
  8463: [0.694, 8e-3, 0.668, { sk: -0.0319 }],
  8467: [0.702, 0.019, 0.474, { sk: 0.128 }],
  8472: [0.461, 0.21, 0.74],
  8501: [0.694, 0, 0.703],
  8592: [0.518, 0.017, 1.15],
  8593: [0.694, 0.193, 0.575],
  8594: [0.518, 0.017, 1.15],
  8595: [0.694, 0.194, 0.575],
  8596: [0.518, 0.017, 1.15],
  8597: [0.767, 0.267, 0.575],
  8598: [0.724, 0.194, 1.15],
  8599: [0.724, 0.193, 1.15],
  8600: [0.694, 0.224, 1.15],
  8601: [0.694, 0.224, 1.15],
  8602: [0.711, 0.21, 1.15],
  8603: [0.711, 0.21, 1.15],
  8614: [0.518, 0.017, 1.15],
  8617: [0.518, 0.017, 1.282],
  8618: [0.518, 0.017, 1.282],
  8622: [0.711, 0.21, 1.15],
  8636: [0.518, -0.22, 1.15],
  8637: [0.281, 0.017, 1.15],
  8640: [0.518, -0.22, 1.15],
  8641: [0.281, 0.017, 1.15],
  8652: [0.718, 0.017, 1.15],
  8653: [0.711, 0.21, 1.15],
  8654: [0.711, 0.21, 1.15],
  8655: [0.711, 0.21, 1.15],
  8656: [0.547, 0.046, 1.15],
  8657: [0.694, 0.193, 0.703],
  8658: [0.547, 0.046, 1.15],
  8659: [0.694, 0.194, 0.703],
  8660: [0.547, 0.046, 1.15],
  8661: [0.767, 0.267, 0.703],
  8704: [0.694, 0.016, 0.639],
  8707: [0.694, 0, 0.639],
  8708: [0.711, 0.21, 0.639],
  8709: [0.767, 0.073, 0.575],
  8710: [0.698, 0, 0.958],
  8712: [0.587, 0.086, 0.767],
  8713: [0.711, 0.21, 0.767],
  8715: [0.587, 0.086, 0.767],
  8716: [0.711, 0.21, 0.767],
  8722: [0.281, -0.221, 0.894],
  8723: [0.537, 0.227, 0.894],
  8725: [0.75, 0.25, 0.575],
  8726: [0.75, 0.25, 0.575],
  8727: [0.472, -0.028, 0.575],
  8728: [0.474, -0.028, 0.575],
  8729: [0.474, -0.028, 0.575],
  8730: [0.82, 0.18, 0.958, { ic: 0.03 }],
  8733: [0.451, 8e-3, 0.894],
  8734: [0.452, 8e-3, 1.15],
  8736: [0.714, 0, 0.722],
  8739: [0.75, 0.249, 0.319],
  8740: [0.75, 0.249, 0.319],
  8741: [0.75, 0.248, 0.575],
  8742: [0.75, 0.248, 0.575],
  8743: [0.604, 0.017, 0.767],
  8744: [0.604, 0.016, 0.767],
  8745: [0.603, 0.016, 0.767],
  8746: [0.604, 0.016, 0.767],
  8747: [0.711, 0.211, 0.569, { ic: 0.063 }],
  8764: [0.391, -0.109, 0.894],
  8768: [0.583, 0.082, 0.319],
  8769: [0.711, 0.21, 0.894],
  8771: [0.502, 0, 0.894],
  8772: [0.711, 0.21, 0.894],
  8773: [0.638, 0.027, 0.894],
  8775: [0.711, 0.21, 0.894],
  8776: [0.524, -0.032, 0.894],
  8777: [0.711, 0.21, 0.894],
  8781: [0.533, 0.032, 0.894],
  8784: [0.721, -0.109, 0.894],
  8800: [0.711, 0.21, 0.894],
  8801: [0.505, 0, 0.894],
  8802: [0.711, 0.21, 0.894],
  8804: [0.697, 0.199, 0.894],
  8805: [0.697, 0.199, 0.894],
  8810: [0.617, 0.116, 1.15],
  8811: [0.618, 0.116, 1.15],
  8813: [0.711, 0.21, 0.894],
  8814: [0.711, 0.21, 0.894],
  8815: [0.711, 0.21, 0.894],
  8816: [0.711, 0.21, 0.894],
  8817: [0.711, 0.21, 0.894],
  8826: [0.585, 0.086, 0.894],
  8827: [0.586, 0.086, 0.894],
  8832: [0.711, 0.21, 0.894],
  8833: [0.711, 0.21, 0.894],
  8834: [0.587, 0.085, 0.894],
  8835: [0.587, 0.086, 0.894],
  8836: [0.711, 0.21, 0.894],
  8837: [0.711, 0.21, 0.894],
  8838: [0.697, 0.199, 0.894],
  8839: [0.697, 0.199, 0.894],
  8840: [0.711, 0.21, 0.894],
  8841: [0.711, 0.21, 0.894],
  8846: [0.604, 0.016, 0.767],
  8849: [0.697, 0.199, 0.894],
  8850: [0.697, 0.199, 0.894],
  8851: [0.604, 0, 0.767],
  8852: [0.604, 0, 0.767],
  8853: [0.632, 0.132, 0.894],
  8854: [0.632, 0.132, 0.894],
  8855: [0.632, 0.132, 0.894],
  8856: [0.632, 0.132, 0.894],
  8857: [0.632, 0.132, 0.894],
  8866: [0.693, 0, 0.703],
  8867: [0.693, 0, 0.703],
  8868: [0.694, 0, 0.894],
  8869: [0.693, 0, 0.894],
  8872: [0.75, 0.249, 0.974],
  8876: [0.711, 0.21, 0.703],
  8877: [0.75, 0.249, 0.974],
  8900: [0.523, 0.021, 0.575],
  8901: [0.336, -0.166, 0.319],
  8902: [0.502, 0, 0.575],
  8904: [0.54, 0.039, 1],
  8930: [0.711, 0.21, 0.894],
  8931: [0.711, 0.21, 0.894],
  8942: [0.951, 0.029, 0.319],
  8943: [0.336, -0.166, 1.295],
  8945: [0.871, -0.101, 1.323],
  8968: [0.75, 0.248, 0.511],
  8969: [0.75, 0.248, 0.511],
  8970: [0.749, 0.248, 0.511],
  8971: [0.749, 0.248, 0.511],
  8994: [0.405, -0.108, 1.15],
  8995: [0.392, -0.126, 1.15],
  9001: [0.75, 0.249, 0.447],
  9002: [0.75, 0.249, 0.447],
  9651: [0.711, 0, 1.022],
  9653: [0.711, 0, 1.022],
  9657: [0.54, 0.039, 0.575],
  9661: [0.5, 0.21, 1.022],
  9663: [0.5, 0.21, 1.022],
  9667: [0.539, 0.038, 0.575],
  9711: [0.711, 0.211, 1.15],
  9824: [0.719, 0.129, 0.894],
  9825: [0.711, 0.024, 0.894],
  9826: [0.719, 0.154, 0.894],
  9827: [0.719, 0.129, 0.894],
  9837: [0.75, 0.017, 0.447],
  9838: [0.741, 0.223, 0.447],
  9839: [0.724, 0.224, 0.447],
  10072: [0.75, 0.249, 0.319],
  10216: [0.75, 0.249, 0.447],
  10217: [0.75, 0.249, 0.447],
  10229: [0.518, 0.017, 1.805],
  10230: [0.518, 0.017, 1.833],
  10231: [0.518, 0.017, 2.126],
  10232: [0.547, 0.046, 1.868],
  10233: [0.547, 0.046, 1.87],
  10234: [0.547, 0.046, 2.126],
  10236: [0.518, 0.017, 1.833],
  10744: [0.711, 0.21, 0.894],
  10799: [0.53, 0.028, 0.894],
  10815: [0.686, 0, 0.9],
  10927: [0.696, 0.199, 0.894],
  10928: [0.697, 0.199, 0.894],
  12296: [0.75, 0.249, 0.447],
  12297: [0.75, 0.249, 0.447]
};
Object.defineProperty(Vi, "__esModule", { value: !0 });
Vi.bold = void 0;
var gH = s3, xH = _i;
Vi.bold = (0, gH.AddPaths)(xH.bold, {
  33: "89 629Q89 663 116 684T171 705Q215 705 237 681T260 634Q260 619 233 434T204 244Q201 237 175 237Q150 237 146 244Q144 248 117 433T89 629ZM90 86Q90 125 116 148T177 171Q211 169 235 146T259 86Q259 48 235 25T175 1Q138 1 114 24T90 86",
  34: "38 572T38 608T61 669T121 694Q167 694 196 657T225 559Q225 520 214 482T186 418T151 370T119 339T99 329T82 340T70 360Q70 365 74 369T92 385T122 414Q142 441 154 471T170 518L172 535L166 532Q160 530 148 527T122 523Q85 523 62 547ZM305 572T305 608T328 669T388 694Q434 694 463 657T492 559Q492 520 481 482T453 418T418 370T386 339T366 329T349 340T337 360Q337 365 341 369T359 385T389 414Q409 441 421 471T436 518L439 535L433 532Q427 530 415 527T389 523Q352 523 329 547",
  35: "64 362Q64 380 87 393H363L366 404Q379 443 390 480T409 542T424 590T435 628T443 655T451 674T458 686T467 692T478 694Q490 694 499 686T509 662Q505 643 427 395Q427 393 523 393H620L623 404Q630 426 652 498T691 624T711 681Q718 694 735 694Q748 694 757 685T766 662Q762 643 684 395Q684 393 777 393H871Q872 392 875 390T881 386T887 381T891 374T893 363Q893 345 871 333L767 332H664L660 319Q660 318 638 245T614 171Q614 169 742 169H871L877 165Q883 161 885 159T890 151T893 138Q893 120 871 109L732 108H594L590 95Q587 84 546 -46Q508 -175 505 -178Q498 -193 478 -193Q462 -193 455 -183T448 -164Q448 -156 530 106Q530 108 434 108H337L333 95Q330 84 289 -46Q251 -175 248 -178Q240 -193 222 -193Q206 -193 199 -183T191 -164Q191 -154 273 106Q273 108 180 108L87 109Q64 117 64 139Q64 156 87 169H293L321 262Q326 277 331 294T340 321L343 330Q343 332 215 332L87 333Q64 343 64 362ZM600 330Q600 332 504 332H407L403 319Q403 318 381 245T357 171Q357 169 453 169H550L578 262Q583 277 588 294T597 321L600 330",
  36: "64 494Q64 541 80 579T120 638T171 674T219 693T253 698H256V750H318V699H323Q355 694 380 686T433 663T480 620T506 556Q510 539 510 520Q510 480 488 463T440 445L422 447Q407 451 398 459Q370 478 370 515Q370 542 384 559T412 580L427 584Q424 589 418 596T386 617T324 636H318V434Q411 419 460 355T510 217Q510 196 507 175T492 122T461 67T404 23T318 -4V-56H256V-5H254Q252 -3 240 -3Q194 4 160 23T108 64T80 112T67 156T64 190Q64 218 81 240T134 262Q171 262 187 240T204 193T190 150T153 125Q146 125 144 123Q142 123 149 113T174 89T218 66Q247 58 255 58Q256 58 256 173V287L239 291Q160 308 112 365T64 494ZM255 636Q246 635 236 632T206 620T173 591T160 543Q160 472 256 448V542Q256 636 255 636ZM320 59Q324 59 333 61T356 70T384 89T406 120T415 167Q415 200 395 225T356 260T318 274V59H320",
  37: "65 549Q65 609 84 652T132 714T187 742T236 750Q265 750 296 734T355 697T431 661T541 644Q662 644 736 730Q751 749 767 749T790 739T797 719Q797 710 768 672T504 329Q212 -47 211 -48Q203 -55 191 -55Q161 -55 161 -25Q161 -17 163 -12L642 609Q608 595 542 595Q515 595 488 599T441 608T405 619T381 628L373 632Q373 630 375 619T380 589T383 548Q383 455 343 401T235 347Q217 347 198 351T154 368T110 403T78 462T65 549ZM320 549Q320 633 295 665T235 698H234Q214 698 196 674Q182 650 182 549Q182 509 183 486T190 441T207 409T238 399Q269 399 294 431T320 549ZM745 -56Q727 -56 708 -52T664 -35T620 0T588 59T575 146T588 232T620 291T663 325T708 343T747 347Q810 347 851 294T893 146Q893 89 879 48T841 -15T794 -46T745 -56ZM830 146Q830 230 805 262T745 295H744Q724 295 706 271Q692 247 692 146Q692 106 693 83T700 38T717 6T748 -4Q779 -4 804 28T830 146",
  38: "255 -11Q209 -11 164 4T84 56T48 146Q48 159 50 171Q57 197 72 218T99 249T152 292Q204 333 204 334L194 356Q185 379 176 421T166 511Q166 538 168 551Q182 613 226 654T332 704Q334 704 343 704T358 705Q412 702 444 661T476 565V559Q476 489 334 371L330 368L335 357Q382 272 485 165L496 154L506 163Q543 200 597 273L671 382H601V444H610L732 441Q821 441 830 444H836V382H741L709 335Q702 324 687 302T665 270T646 244T625 216T605 191T581 162T553 132L537 116Q544 109 557 98T605 69T673 51Q711 51 739 70T767 115V118H829V114Q829 70 786 30T668 -11Q570 -11 474 37L451 49L441 43Q352 -11 255 -11ZM415 564Q415 596 400 625T356 654Q329 654 310 634T285 588Q283 580 283 554Q283 475 309 417L325 431Q415 512 415 564ZM192 182Q192 126 213 89T279 51Q348 51 400 83L389 91Q362 112 338 137T295 186T264 229T240 265T227 286Q226 285 222 280T217 272T211 263T205 251T200 238T196 222T193 204T192 182",
  39: "74 572T74 608T97 669T157 694Q203 694 232 657T261 559Q261 520 250 482T222 418T187 370T155 339T135 329Q128 329 117 340T106 359Q106 365 117 375T144 399T176 440T203 505Q204 511 205 518T208 530V535L202 532Q196 530 184 527T158 523Q121 523 98 547",
  40: "103 166T103 251T121 412T165 541T225 639T287 708T341 750H356H361Q382 750 382 736Q382 732 365 714T323 661T274 576T232 439T214 250Q214 -62 381 -229Q382 -231 382 -234Q382 -249 360 -249H356H341Q314 -231 287 -207T226 -138T165 -41T121 89",
  41: "231 251Q231 354 214 439T173 575T123 661T81 714T64 735Q64 744 73 749H75Q77 749 79 749T84 750T90 750H105Q132 732 159 708T220 639T281 542T325 413T343 251T325 89T281 -40T221 -138T159 -207T105 -249H90Q80 -249 76 -249T68 -245T64 -234Q64 -230 81 -212T123 -160T172 -75T214 61T231 251",
  42: "235 706Q235 724 251 737T287 750Q306 750 322 738T339 706Q339 685 318 580V579Q429 663 436 666Q441 668 449 668Q471 668 486 650T501 612Q501 582 478 572Q476 570 414 549L354 528L414 507Q420 505 430 502T445 497T458 492T470 488T479 483T487 478T493 471T497 463T500 454T501 443Q501 423 486 406T449 388H446Q435 388 370 437Q339 461 318 477V476Q339 371 339 350Q339 332 323 319T287 306T251 319T235 350Q235 371 256 476V477Q145 393 138 390Q133 388 125 388Q103 388 88 406T73 444Q73 474 96 484Q98 486 160 507L220 528L160 549Q154 551 144 554T129 559T116 564T104 568T95 573T87 578T81 585T77 593T74 602T73 613Q73 633 88 650T125 668H128Q139 668 204 619Q235 595 256 579V580Q235 685 235 706",
  43: "64 232T64 250T87 281H416V444Q416 608 418 612Q426 633 446 633T475 613Q477 608 477 444V281H807Q808 280 811 278T817 274T823 269T827 262T829 251Q829 230 807 221L642 220H477V57Q477 -107 475 -112Q468 -131 446 -131Q425 -131 418 -112Q416 -107 416 57V220H251L87 221Q64 232 64 250",
  44: "74 85Q74 120 97 145T159 171Q200 171 226 138Q258 101 258 37Q258 -5 246 -44T218 -109T183 -155T152 -184T135 -194Q129 -194 118 -183T106 -164Q106 -157 115 -149Q121 -145 130 -137T161 -100T195 -35Q197 -28 200 -17T204 3T205 11T199 9T183 3T159 0Q120 0 97 26T74 85",
  45: "13 166V278H318V166H13",
  46: "74 85Q74 121 99 146T156 171Q200 171 222 143T245 85Q245 56 224 29T160 1Q118 1 96 27T74 85",
  47: "451 730Q460 750 479 750Q492 750 501 740T510 718Q508 708 318 244L122 -232Q112 -250 95 -250Q82 -250 73 -241T64 -218Q66 -205 258 261T451 730",
  58: "74 359Q74 394 98 419T158 444Q200 444 222 417T245 358Q245 329 224 302T160 274Q116 274 95 301T74 359ZM74 85Q74 121 99 146T156 171Q200 171 222 143T245 85Q245 56 224 29T160 1Q118 1 96 27T74 85",
  59: "74 359Q74 394 98 419T158 444Q200 444 222 417T245 358Q245 329 224 302T160 274Q116 274 95 301T74 359ZM74 50T74 86T97 146T158 171Q204 171 226 132T248 38Q248 -23 223 -80T171 -165T135 -194Q129 -194 118 -183T106 -164Q106 -163 106 -160L107 -158Q108 -155 121 -142T150 -107T177 -58Q189 -32 194 3Q195 6 193 6Q172 0 158 0Q121 0 98 25",
  60: "797 -56Q797 -68 790 -76T767 -85H759L434 70Q108 226 105 229Q96 238 96 250Q96 263 105 272Q109 276 271 354T595 508T757 585Q763 587 766 587Q780 587 788 578T797 556Q797 544 788 535Q784 531 490 391L197 251Q213 242 359 173T644 37T788 -34Q797 -43 797 -56",
  61: "87 333Q64 343 64 362Q64 383 84 391Q89 393 448 393H807Q808 392 811 390T817 386T823 381T827 374T829 363Q829 345 807 333H87ZM87 109Q64 118 64 139Q64 159 86 168Q89 169 448 169H807L812 166Q816 163 818 162T823 157T827 149T829 139Q829 118 807 109H87",
  62: "127 -85Q110 -85 103 -75T96 -55Q96 -41 106 -34Q119 -24 308 65Q361 90 411 114L696 250L427 379Q106 533 103 537Q96 545 96 557Q96 568 104 577T128 587Q137 586 460 431T788 272Q797 263 797 250Q797 238 788 229Q785 226 459 70L135 -85H127",
  63: "65 570Q65 628 119 664T259 700Q326 700 372 688T440 654T469 613T478 569Q478 505 412 465Q287 391 287 294V283Q287 250 284 244T263 237H256H249Q232 237 229 242T225 272V287Q227 364 253 418Q274 463 311 504Q335 530 335 575Q335 622 323 635T259 648Q231 648 209 644T179 636T170 630L172 628Q174 627 177 625T183 620T190 611T197 601T202 587T204 570Q204 539 185 519T134 499Q105 499 85 517T65 570ZM171 86Q171 125 197 148T258 171Q292 169 316 146T340 86Q340 48 316 25T256 1Q218 1 195 24T171 86",
  64: "64 347Q64 511 171 605T434 699Q487 699 500 698Q624 684 703 621T811 464Q828 414 828 344Q828 232 788 179T691 125Q673 125 657 127T628 132T606 140T588 148T576 156T568 162L566 164Q565 164 549 154T504 135T444 125Q349 125 284 183T218 347Q218 455 284 512T448 569Q554 569 610 479H638Q670 479 674 471Q676 468 676 340V258Q676 213 679 199T694 178Q701 174 713 177Q767 187 767 340Q767 489 678 569T446 649Q299 649 213 566T126 346Q126 307 134 269T166 189T225 116T320 65T455 45H463Q606 51 721 91L746 99H782H801Q829 99 829 85Q829 78 825 75T804 65Q800 63 797 62Q625 -6 451 -6Q271 -6 168 91T64 347ZM547 468Q526 493 504 505T444 517T377 476T346 347Q346 306 354 271T386 206T448 177Q505 177 547 226V468",
  91: "128 -250V750H293V689H189V-189H293V-250H128",
  92: "64 718Q63 731 72 740T94 750Q106 750 113 743Q118 741 122 732L318 256Q508 -208 510 -218Q511 -231 502 -240T480 -250Q460 -250 451 -230Q451 -229 259 238T64 718",
  93: "25 689V750H190V-250H25V-189H129V689H25",
  94: "207 632L287 694Q289 693 368 632T448 570T431 545T413 520Q410 520 350 559L287 597L224 559Q164 520 161 520Q160 520 143 544T126 570T207 632",
  95: "0 -61V-10H574V-61H0",
  96: "114 634Q114 663 136 684T183 706Q191 706 196 705T208 700T219 693T232 681T245 666T262 645T282 620Q332 558 337 553Q338 552 318 527L299 503L223 543Q215 547 202 553T183 563T167 571T153 580T141 587T131 595T124 603T118 612T115 622T114 634",
  123: "504 -207T504 -225T500 -246T476 -250H469Q257 -250 227 -145L225 -135L224 0Q224 15 224 30T224 59T224 84T224 106T223 122T223 133V137Q222 138 221 144T213 162T195 185Q171 206 141 215Q123 222 107 223T84 225T74 229T70 250T73 270T83 276T106 276T141 285Q171 294 195 315Q201 321 206 328T214 341T219 352T222 360L223 363V367Q223 371 223 378T223 394T224 415T224 441T224 470T224 501L225 636Q249 739 426 749Q428 749 443 749T466 750H473Q495 750 499 747T504 725T501 704T480 699Q381 693 357 645Q352 634 351 617T350 497V412Q350 350 338 329Q325 303 298 284T251 258T227 251Q226 251 226 250L227 249Q231 248 238 246T265 236T299 217T329 184T349 137Q350 131 350 3T352 -130Q358 -160 392 -178T480 -199Q497 -200 500 -203",
  124: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V-225Q181 -249 160 -249",
  125: "70 726Q71 744 74 747T99 750H106Q323 750 349 636L350 501Q350 486 350 470T350 441T350 416T350 394T351 378T351 367V363Q352 362 353 356T361 338T379 315Q403 294 433 285Q451 278 467 277T490 275T500 271T504 250T501 230T491 224T468 224T433 215Q403 206 379 185Q373 179 368 172T360 159T355 148T352 140L351 137V133Q351 129 351 122T351 106T350 85T350 59T350 31T350 0L349 -135L347 -145Q317 -250 106 -250H99Q79 -250 75 -247T70 -226Q70 -208 73 -204T95 -199Q193 -193 217 -145Q222 -134 223 -117T224 3Q224 20 224 48T223 86Q223 145 237 175T301 232Q335 249 347 249Q348 249 348 250L347 251Q343 252 336 254T309 264T275 284T245 316T225 363Q224 369 224 497T222 631Q216 660 182 678T95 699Q77 700 74 704T70 726",
  126: "343 202Q320 202 278 225T215 249Q181 249 146 214L134 202L115 219Q111 222 106 226T98 234L96 236Q158 306 165 313Q199 344 230 344Q239 344 244 343Q262 339 300 318T359 297Q393 297 428 332L440 344L459 327Q463 324 468 320T476 312L478 310Q416 240 409 233Q375 202 343 202",
  168: "96 615Q96 650 120 672T178 695Q214 693 234 669T255 615Q255 583 232 559T176 535Q147 535 122 556T96 615ZM319 615Q319 651 343 673T399 695Q426 695 452 675T478 615Q478 578 454 557T395 535Q364 537 342 559T319 615",
  172: "680 371Q683 369 688 366T695 361T698 356T701 346T701 332T702 308V216Q702 196 702 168T703 130Q703 90 697 76T671 61Q650 61 643 81Q641 86 641 198V310H364L87 311Q64 319 64 341Q64 362 84 369Q89 371 385 371H680",
  175: "80 540V607H494V540H80",
  176: "160 618Q160 653 193 677T279 702H284Q381 702 407 647Q414 634 414 618Q414 607 410 596T395 570T355 546T287 536T220 545T181 568T165 594T160 618ZM352 618Q352 645 341 652T301 659H292Q286 659 278 659T268 660Q247 660 236 653T224 638T222 619Q222 591 234 585T287 578Q315 578 326 580T345 590T352 618",
  177: "64 328T64 346T87 377H416V542L417 707Q431 728 443 728Q467 728 475 709Q477 704 477 540V377H807Q808 376 811 374T817 370T823 365T827 358T829 347Q829 326 807 317L642 316H477V25H807Q808 24 811 22T817 18T823 13T827 6T829 -5Q829 -26 807 -35H87Q64 -24 64 -6T87 25H416V316H251L87 317Q64 328 64 346",
  180: "391 706Q419 706 439 683T460 634Q460 608 441 593T366 550Q356 545 351 543L275 503L256 527Q236 552 237 553Q242 558 292 620Q299 629 309 641T324 659T336 673T346 685T354 693T363 699T371 703T380 705T391 706",
  183: "74 251Q74 286 99 311T156 336Q200 336 222 308T245 250Q245 221 224 194T160 166T96 193T74 251",
  215: "168 500Q168 515 178 522T195 530H198Q207 530 218 521T282 458Q312 428 331 409L447 294L563 409Q674 520 682 525Q687 529 695 529Q711 529 718 520T726 499V498Q726 489 720 481T666 427Q631 392 606 367L490 251L606 135Q717 23 721 17T726 2Q726 -9 719 -18T695 -28H692Q685 -28 674 -18T608 47Q581 74 563 92L447 207L331 91Q217 -22 208 -27Q206 -28 203 -28H197Q168 -28 168 2Q168 13 178 24T288 135L404 250L288 366Q177 479 173 485T168 500",
  247: "344 495Q344 535 372 566T447 597Q490 597 519 566T548 495Q548 452 518 423T446 393Q404 393 374 423T344 495ZM87 221Q64 230 64 251T84 279Q89 281 448 281H806Q807 280 810 278T816 274T822 269T826 262T828 251Q828 230 806 221H87ZM344 -36T344 6T373 78T446 108Q487 108 517 79T548 6Q548 -35 519 -65T446 -96Q406 -96 375 -66",
  305: "247 0Q232 3 143 3Q132 3 106 3T56 1L34 0H26V46H42Q70 46 91 49Q100 53 102 60T104 102V205V293Q104 345 102 359T88 378Q74 385 41 385H30V408Q30 431 32 431L42 432Q52 433 70 434T106 436Q123 437 142 438T171 441T182 442H185V62Q190 52 197 50T232 46H255V0H247",
  567: "28 -163Q58 -168 64 -168Q124 -168 135 -77Q137 -65 137 141T136 353Q132 371 120 377T72 385H52V408Q52 431 54 431L58 432Q62 432 70 432T87 433T108 434T133 436Q151 437 171 438T202 441T214 442H218V184Q217 -36 217 -59T211 -98Q195 -145 153 -175T58 -205Q9 -205 -23 -179T-55 -117Q-55 -94 -40 -79T-2 -64T36 -79T52 -118Q52 -143 28 -163",
  697: "240 563Q278 563 304 539T331 480V473Q331 462 316 431T217 236Q199 200 174 151T136 78T123 50Q113 33 105 33Q101 33 72 45T38 60Q35 63 35 65Q35 77 101 293T171 517Q182 542 202 552T240 563",
  710: "207 632L287 694Q289 693 368 632T448 570T431 545T413 520Q410 520 350 559L287 597L224 559Q164 520 161 520Q160 520 143 544T126 570T207 632",
  711: "131 603Q130 604 136 618T150 646T158 659L223 635L287 611L351 635L416 659Q417 660 424 647T437 619T443 603Q440 601 364 558T287 515T210 558T131 603",
  713: "80 540V607H494V540H80",
  714: "391 706Q419 706 439 683T460 634Q460 608 441 593T366 550Q356 545 351 543L275 503L256 527Q236 552 237 553Q242 558 292 620Q299 629 309 641T324 659T336 673T346 685T354 693T363 699T371 703T380 705T391 706",
  715: "114 634Q114 663 136 684T183 706Q191 706 196 705T208 700T219 693T232 681T245 666T262 645T282 620Q332 558 337 553Q338 552 318 527L299 503L223 543Q215 547 202 553T183 563T167 571T153 580T141 587T131 595T124 603T118 612T115 622T114 634",
  728: "287 500Q208 500 155 558T102 689V694H153V685Q153 681 154 674T164 648T186 615T226 590T287 578Q347 578 382 611T421 685V694H472V689Q472 623 422 562T287 500",
  729: "202 610Q202 647 227 671T283 695Q324 695 348 669T372 610T350 551T287 525Q248 525 225 551T202 610",
  730: "160 618Q160 653 193 677T279 702H284Q381 702 407 647Q414 634 414 618Q414 607 410 596T395 570T355 546T287 536T220 545T181 568T165 594T160 618ZM352 618Q352 645 341 652T301 659H292Q286 659 278 659T268 660Q247 660 236 653T224 638T222 619Q222 591 234 585T287 578Q315 578 326 580T345 590T352 618",
  732: "343 552Q320 552 278 575T215 599Q181 599 146 564L134 552L115 569Q111 572 106 576T98 584L96 586Q158 656 165 663Q199 694 230 694Q239 694 244 693Q262 689 300 668T359 647Q393 647 428 682L440 694L459 677Q463 674 468 670T476 662L478 660Q416 590 409 583Q375 552 343 552",
  768: "-461 634Q-461 663 -439 684T-392 706Q-384 706 -379 705T-367 700T-356 693T-343 681T-330 666T-313 645T-293 620Q-243 558 -238 553Q-237 552 -257 527L-276 503L-352 543Q-360 547 -373 553T-392 563T-408 571T-422 580T-434 587T-444 595T-451 603T-457 612T-460 622T-461 634",
  769: "-184 706Q-156 706 -136 683T-115 634Q-115 608 -134 593T-209 550Q-219 545 -224 543L-300 503L-319 527Q-339 552 -338 553Q-333 558 -283 620Q-276 629 -266 641T-251 659T-239 673T-229 685T-221 693T-212 699T-204 703T-195 705T-184 706",
  770: "-368 632L-288 694Q-286 693 -207 632T-127 570T-144 545T-162 520Q-165 520 -225 559L-288 597L-351 559Q-411 520 -414 520Q-415 520 -432 544T-449 570T-368 632",
  771: "-232 552Q-255 552 -297 575T-360 599Q-394 599 -429 564L-441 552L-460 569Q-464 572 -469 576T-476 584L-479 586Q-417 656 -410 663Q-376 694 -345 694Q-336 694 -331 693Q-313 689 -275 668T-216 647Q-182 647 -147 682L-135 694L-116 677Q-112 674 -107 670T-100 662L-97 660Q-159 590 -166 583Q-200 552 -232 552",
  772: "-495 540V607H-81V540H-495",
  774: "-288 500Q-367 500 -420 558T-473 689V694H-422V685Q-422 681 -421 674T-411 648T-389 615T-349 590T-288 578Q-228 578 -193 611T-154 685V694H-103V689Q-103 623 -153 562T-288 500",
  775: "-373 610Q-373 647 -348 671T-292 695Q-251 695 -227 669T-203 610T-225 551T-288 525Q-327 525 -350 551T-373 610",
  776: "-479 615Q-479 650 -456 672T-397 695Q-361 693 -341 669T-320 615Q-320 583 -343 559T-399 535Q-428 535 -453 556T-479 615ZM-256 615Q-256 651 -232 673T-176 695Q-149 695 -123 675T-97 615Q-97 578 -121 557T-180 535Q-211 537 -233 559T-256 615",
  778: "-415 618Q-415 653 -382 677T-296 702H-291Q-194 702 -168 647Q-161 634 -161 618Q-161 607 -165 596T-180 570T-220 546T-288 536T-355 545T-394 568T-410 594T-415 618ZM-223 618Q-223 645 -234 652T-274 659H-283Q-289 659 -297 659T-307 660Q-328 660 -339 653T-351 638T-353 619Q-353 591 -341 585T-288 578Q-260 578 -249 580T-230 590T-223 618",
  779: "-389 511L-442 543Q-442 544 -424 606T-404 674Q-390 705 -361 713Q-360 713 -356 713T-349 714Q-340 714 -330 712Q-273 690 -273 644Q-273 621 -290 604L-342 554L-389 511ZM-198 511L-251 543Q-251 544 -233 606T-213 674Q-199 705 -170 713Q-169 713 -165 713T-158 714Q-127 714 -105 693T-82 647Q-82 638 -84 631T-89 618T-99 604T-112 590T-130 574T-151 554L-198 511",
  780: "-444 603Q-445 604 -439 618T-425 646T-417 659L-352 635L-288 611L-224 635L-159 659Q-158 660 -151 647T-138 619T-132 603Q-135 601 -211 558T-288 515T-365 558T-444 603",
  824: "-705 -210Q-715 -210 -724 -203T-734 -179Q-734 -171 -732 -166Q-730 -163 -474 266T-215 698Q-208 711 -190 711Q-180 711 -171 704T-161 681Q-161 672 -164 667Q-171 654 -425 228T-683 -201Q-692 -210 -705 -210",
  8194: "",
  8195: "",
  8196: "",
  8197: "",
  8198: "",
  8201: "",
  8202: "",
  8211: "0 249V300H574V249H0",
  8212: "0 249V300H1149V249H0",
  8213: "0 249V300H1149V249H0",
  8214: "205 -225Q201 -234 199 -237T191 -244T175 -248T161 -246Q151 -240 146 -229Q145 -224 145 251Q145 725 146 730Q156 750 176 750Q193 748 205 727V-225ZM369 727L372 732Q375 737 377 740T385 747T398 750Q406 750 413 747Q423 740 428 730Q430 720 430 251Q430 -219 428 -229Q423 -240 413 -246Q408 -248 400 -248Q393 -248 388 -247T379 -242T375 -236T371 -230L369 -225V727",
  8215: "0 -61V-10H574V-61H0",
  8216: "58 461Q58 503 70 542T99 607T134 654T165 684T184 694T201 683T213 664Q213 658 202 648T175 624T143 583T116 518Q115 512 114 505T112 493L111 488Q132 500 161 500Q198 500 221 475T245 414T222 354T161 329Q112 329 85 369T58 461",
  8217: "74 572T74 608T97 669T157 694Q203 694 232 657T261 559Q261 520 250 482T222 418T187 370T155 339T135 329Q128 329 117 340T106 359Q106 365 117 375T144 399T176 440T203 505Q204 511 205 518T208 530V535L202 532Q196 530 184 527T158 523Q121 523 98 547",
  8220: "110 461Q110 502 121 541T150 606T185 653T217 684T235 694Q242 694 254 682T266 664Q266 659 254 648T226 623T193 578T167 511Q164 500 164 494T164 487Q188 500 212 500Q251 500 274 475T297 414Q297 378 274 354T212 329Q167 329 139 367T110 461ZM377 461Q377 502 388 541T417 606T452 653T484 684T502 694Q509 694 521 682T533 664Q533 659 521 648T493 623T460 578T434 511Q431 500 431 494T431 487Q455 500 479 500Q518 500 541 475T564 414Q564 378 541 354T479 329Q434 329 406 367T377 461",
  8221: "38 572T38 608T61 669T121 694Q167 694 196 657T225 559Q225 520 214 482T186 418T151 370T119 339T99 329T82 340T70 360Q70 365 74 369T92 385T122 414Q142 441 154 471T170 518L172 535L166 532Q160 530 148 527T122 523Q85 523 62 547ZM305 572T305 608T328 669T388 694Q434 694 463 657T492 559Q492 520 481 482T453 418T418 370T386 339T366 329T349 340T337 360Q337 365 341 369T359 385T389 414Q409 441 421 471T436 518L439 535L433 532Q427 530 415 527T389 523Q352 523 329 547",
  8224: "231 470Q232 471 232 473Q232 477 213 540T193 636Q192 642 192 651T204 677T239 700Q249 702 255 702Q300 702 315 660Q317 653 317 636Q317 603 298 539T279 472V470Q280 470 318 488T383 506Q408 506 423 493T442 467T446 444T443 421T424 396T383 382Q355 382 318 400T279 418Q278 416 285 392T303 334T316 284Q318 268 318 234Q318 149 311 45T296 -127T284 -203Q279 -211 255 -211Q237 -211 233 -210T226 -203Q222 -195 214 -129T199 41T192 234V245Q192 286 212 349Q233 413 231 418Q229 418 192 400T128 382Q102 382 86 396T67 421T64 444T67 466T86 492T128 506Q155 506 192 488T231 470",
  8225: "193 637Q193 663 206 679T231 698T255 702T279 699T304 679T317 637Q317 605 299 557T280 504Q280 503 281 503T320 521T382 539Q410 539 428 521T446 476Q446 454 432 434T383 414H377Q358 414 320 431T281 449L280 448Q280 444 298 396T317 316Q318 310 318 301T306 275T271 252Q261 250 255 250Q210 250 195 292Q193 299 193 316Q193 347 211 395T230 448Q230 449 229 449Q227 449 196 434Q151 414 133 414H127Q102 414 87 427T68 452T64 477Q64 503 81 521T127 539Q143 539 164 532T204 515T226 504Q230 502 230 504Q230 508 212 556T193 637ZM193 184Q193 210 206 226T231 245T255 249T279 246T304 226T317 184Q317 153 299 106T280 53Q280 51 282 51T322 68T383 86Q411 86 428 69T445 24T428 -21T382 -39Q358 -39 322 -22T282 -4Q280 -3 280 -3T280 -6Q281 -13 299 -59T317 -136Q318 -142 318 -151T306 -177T271 -200Q261 -202 255 -202Q210 -202 195 -160Q193 -153 193 -136Q193 -106 211 -60T230 -6Q230 -4 228 -4T188 -21T128 -39Q100 -39 83 -22T65 24Q65 53 82 69T127 86Q150 86 187 69T228 51Q230 50 230 50T230 53Q229 58 211 105T193 184",
  8226: "64 251Q64 303 80 344T121 409T175 448T230 469T275 474Q277 474 283 474T292 473Q385 473 447 415T510 251Q510 149 449 89T287 28T126 88T64 251",
  8230: "74 85Q74 121 99 146T156 171Q200 171 222 143T245 85Q245 56 224 29T160 1Q118 1 96 27T74 85ZM562 85Q562 121 587 146T644 171Q688 171 710 143T733 85Q733 56 712 29T648 1Q606 1 584 27T562 85ZM1050 85Q1050 121 1075 146T1132 171Q1176 171 1198 143T1221 85Q1221 56 1200 29T1136 1Q1094 1 1072 27T1050 85",
  8242: "240 563Q278 563 304 539T331 480V473Q331 462 316 431T217 236Q199 200 174 151T136 78T123 50Q113 33 105 33Q101 33 72 45T38 60Q35 63 35 65Q35 77 101 293T171 517Q182 542 202 552T240 563",
  8254: "80 540V607H494V540H80",
  8260: "451 730Q460 750 479 750Q492 750 501 740T510 718Q508 708 318 244L122 -232Q112 -250 95 -250Q82 -250 73 -241T64 -218Q66 -205 258 261T451 730",
  8407: "406 694Q406 704 413 713T433 723Q448 723 454 719T467 701Q483 665 522 648Q542 637 542 619Q542 605 536 599T514 586Q468 569 431 532Q411 513 399 513Q386 513 378 522T369 543Q369 557 381 568Q385 572 387 574L400 588H228L56 589Q33 598 33 618Q33 636 56 649H426Q406 676 406 694",
  8463: "477 56Q477 48 479 46T490 43Q522 45 544 75T577 140Q582 156 585 159T605 162H611H622Q642 162 642 148Q642 138 632 114T602 62T550 13T478 -8Q429 -8 394 17T358 83Q358 95 395 199T433 350Q433 400 394 400H388H383Q335 400 291 363Q256 332 236 298Q233 293 202 170T169 40Q160 18 141 5T99 -8Q70 -8 58 9T45 39Q45 51 116 336L167 540H80V607H184L188 622H184Q183 622 179 622T169 623T157 624T146 624T136 624T131 625Q119 628 119 642Q119 647 123 661T129 679Q133 684 142 685T220 690Q293 694 307 694Q324 694 328 679Q328 673 311 607H494V540H294Q286 507 278 473T264 420L260 403Q260 400 269 408Q327 451 393 451H401H410Q425 451 439 450T476 442T515 424T544 391T556 337Q556 286 517 179T477 56",
  8467: "245 -19Q228 -19 212 -16T184 -6T162 9T143 27T129 46T118 66T111 84T106 99T102 111L101 116L69 89L36 62Q31 60 24 62Q-1 88 -1 98Q-1 101 1 105Q1 106 73 170L95 189V197Q95 242 112 317T159 476T241 624T353 701Q357 702 367 702Q428 702 444 641Q446 630 446 606Q446 454 241 246L215 220L212 203Q203 150 203 114Q203 113 203 106T204 95T205 82T209 67T214 54T223 43T236 35T253 32Q277 32 305 44T352 70T389 98T407 112Q409 113 412 113Q420 113 432 95Q445 77 443 70Q440 64 416 44T342 3T245 -19ZM387 615Q387 651 366 651Q342 651 321 604T276 470L241 331Q246 331 280 373T350 486T387 615",
  8472: "399 159Q410 159 421 151T433 126Q433 104 410 85Q408 84 410 78Q411 72 414 66T428 51T455 43Q483 43 506 55T543 83T568 125T584 166T594 206Q595 211 596 214Q610 273 610 301Q610 365 542 365H538Q483 365 429 344T337 292T269 229T225 175T210 150L255 99Q261 92 274 78T292 58T305 41T316 22T321 3T324 -23Q324 -87 283 -148T174 -210H171Q161 -210 152 -209T128 -201T101 -180T81 -141T72 -78Q72 -72 72 -60T73 -45Q79 4 102 65L108 81Q84 117 84 167Q84 273 140 367T269 461Q285 461 285 447Q285 440 282 431Q278 418 276 415T264 410Q228 404 201 336T174 219Q174 218 176 202L184 214Q252 303 348 360T549 417Q614 417 658 391T719 317Q726 292 726 260Q726 148 646 70T451 -8Q407 -8 377 17T346 92Q346 159 396 159H399ZM178 -160Q200 -160 216 -132T232 -75Q232 -63 228 -56T203 -26Q196 -18 192 -14Q185 -5 176 5T161 20T156 27L153 28Q151 28 146 8T137 -42T132 -89Q132 -160 178 -160",
  8501: "590 427Q581 427 579 433T575 450T568 470V468L532 288L541 281Q620 220 634 165L637 154V124Q637 74 628 46Q623 32 612 16T592 0Q580 0 578 19T569 69T538 121Q532 126 385 240T236 355Q234 355 231 338T225 291T222 237Q222 222 223 213T225 201T228 195T231 190Q238 179 261 160T300 119T316 73Q316 41 291 23T231 1Q226 0 149 0H98Q73 0 69 3T64 24Q64 43 67 47T85 51H89Q119 51 134 55T152 64T154 76Q154 95 125 141T96 220Q96 243 104 270T123 319T145 360T164 391T172 404T150 421T102 468T68 529L65 541V570Q65 620 74 648Q79 664 91 679T111 694Q122 694 123 675T132 625T164 573Q168 569 319 452T471 335Q471 337 486 409T502 488Q502 489 491 493T467 511T448 546V573Q448 602 452 624T462 659T474 680T486 691T493 694Q499 694 502 691T507 682T513 673Q517 667 534 651T557 630Q558 629 590 616T631 587Q638 577 638 543Q637 489 622 458T590 427",
  8592: "1063 281Q1084 268 1084 251Q1084 231 1063 221L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1063",
  8593: "33 396Q14 396 14 423Q14 445 18 449T41 459Q72 466 99 478T147 505T185 537T215 571T238 604T254 635T264 661T270 678L272 685Q276 694 288 694Q298 692 300 689T307 672Q331 592 392 535T535 459Q553 454 557 450T561 423Q561 396 542 396Q531 396 501 405T418 443T329 517L319 529L318 179V-171Q307 -193 288 -193Q265 -193 258 -171L257 179V529L247 517Q209 473 158 444T76 405T33 396",
  8594: "65 251Q65 270 87 281H500L914 282Q881 304 842 357T785 482Q781 500 781 501Q781 512 792 517Q794 518 812 518H817Q832 518 835 515T844 495Q864 412 923 351T1065 270Q1085 263 1085 251Q1085 240 1077 236T1044 225T995 204Q937 173 898 122T844 6Q840 -10 836 -13T816 -17H811Q786 -16 782 -9Q781 -6 781 -2Q781 1 785 17Q813 138 914 220H500L87 221Q65 228 65 251",
  8595: "14 77Q14 104 33 104Q44 104 74 96T156 57T247 -17L257 -29V321Q257 669 259 675Q268 694 289 694Q295 693 300 691T307 686T313 679T318 672V321L319 -29L329 -17Q366 26 417 55T499 94T542 104Q561 104 561 77Q561 56 557 51T535 41Q481 28 438 0T370 -58T330 -119T308 -167T302 -187Q297 -194 288 -194Q278 -194 273 -186T265 -165T251 -127T220 -77Q151 15 41 41Q22 46 18 50T14 77",
  8596: "305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L404 281H744L914 282Q880 305 839 362T785 484Q781 500 781 503Q781 517 806 518Q809 518 811 518H817Q832 518 835 515T844 495Q864 412 923 351T1065 270Q1085 263 1085 251Q1085 240 1077 236T1044 225T995 204Q937 173 898 122T844 6Q840 -10 836 -13T816 -17H811Q786 -16 782 -9Q781 -6 781 -2Q781 1 785 17Q813 138 914 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495",
  8597: "33 469Q14 469 14 496Q14 518 18 522T41 532Q121 551 182 608T268 745Q275 767 288 767Q299 767 303 755T320 713T355 650Q424 558 535 532Q553 527 557 523T561 496Q561 469 542 469Q531 469 501 478T418 516T329 590L319 602L318 426V74L319 -102L329 -90Q366 -47 417 -18T499 21T542 31Q561 31 561 4Q561 -17 557 -22T535 -32Q454 -51 393 -108T307 -245Q300 -267 288 -267Q279 -267 274 -259T266 -238T250 -200T220 -150Q151 -58 41 -32Q22 -27 18 -23T14 4Q14 31 33 31Q44 31 74 23T156 -16T247 -90L257 -102V602L247 590Q209 546 158 517T76 478T33 469",
  8598: "429 724Q438 724 452 711T466 690Q466 681 452 671Q361 602 242 599H218L756 135Q832 69 913 -1T1036 -108L1077 -143Q1084 -151 1084 -163Q1084 -180 1074 -187T1054 -194H1052Q1043 -194 939 -105Q866 -42 812 5Q180 549 178 549V546Q179 542 179 539Q183 520 183 483Q183 435 172 390T149 323T130 296Q121 292 115 295Q85 312 85 328Q85 331 95 350T115 406T125 486Q125 540 110 583T79 648T64 675Q64 681 68 687T81 693Q87 693 94 690Q162 657 232 657Q296 657 349 681T420 722Q422 724 429 724",
  8599: "1069 693Q1076 693 1080 687T1085 675Q1085 671 1076 656T1055 621T1034 565T1024 486Q1024 442 1034 406T1054 351T1064 328Q1064 321 1057 313T1042 300L1034 295Q1030 293 1027 293Q1023 293 1020 295T1014 301T1009 308T1005 316T1001 324Q980 368 971 419Q966 442 966 484V492Q966 528 972 553Q971 553 757 368T328 -3T107 -191Q103 -193 94 -193Q78 -193 71 -184T64 -164Q64 -153 72 -143Q79 -136 382 124L934 599H909Q837 599 760 634T683 690Q683 697 696 710T722 724Q726 724 742 714T779 691T838 668T920 657Q959 657 991 666T1043 684T1069 693",
  8600: "65 663Q65 680 74 687T93 694H96Q104 694 118 683T204 610Q280 545 338 495Q969 -49 971 -49L970 -46Q970 -42 970 -39Q966 -20 966 18Q966 65 977 110T1001 177T1019 204Q1028 208 1034 205Q1064 188 1064 172Q1064 169 1054 150T1034 94T1024 14Q1024 -28 1033 -64T1054 -120T1075 -155T1085 -175Q1085 -181 1081 -187T1068 -193Q1062 -193 1055 -190Q987 -157 919 -157Q817 -157 739 -215Q727 -224 720 -224Q712 -224 697 -210Q683 -199 683 -190T697 -171Q788 -102 907 -99H931L393 365Q317 431 236 501T114 608L72 643Q65 651 65 663",
  8601: "80 -193Q73 -193 69 -187T64 -175Q64 -172 79 -150T109 -84T125 14Q125 58 115 94T95 149T85 172Q85 179 92 187T108 200L115 205Q119 207 122 207Q126 207 129 205T135 199T140 192T144 184T148 176Q169 132 178 81Q183 58 183 17Q183 -7 182 -24T178 -48L177 -53Q178 -53 389 129T816 498T1043 692Q1049 694 1054 694Q1070 694 1077 684T1085 664Q1085 653 1077 643Q1070 636 767 376L215 -98L240 -99Q312 -99 389 -134T466 -190Q466 -197 452 -210T429 -224Q422 -224 411 -215Q330 -157 229 -157Q190 -157 158 -166T106 -184T80 -193",
  8614: "65 426Q74 448 95 448Q112 448 125 426V281H500L914 282Q881 304 842 357T785 482Q781 500 781 501Q781 512 792 517Q794 518 812 518H817Q832 518 835 515T844 495Q864 412 923 351T1065 270Q1085 263 1085 251Q1085 240 1077 236T1044 225T995 204Q937 173 898 122T844 6Q840 -10 836 -13T816 -17H811Q786 -16 782 -9Q781 -6 781 -2Q781 1 785 17Q813 138 914 220H500L135 221Q134 221 133 221T130 220H125V76Q115 54 95 54Q73 54 65 76V426",
  8617: "1029 475Q1029 505 1068 505Q1129 501 1173 463T1218 363Q1218 296 1170 259T1066 221H1063L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1063Q1105 284 1131 305T1158 361Q1158 385 1146 401Q1122 441 1063 444Q1029 446 1029 475",
  8618: "225 221H218Q159 221 112 260T65 363Q65 431 116 468T221 505Q254 503 254 474Q254 456 245 450T216 443T188 438Q152 427 137 401Q125 385 125 362Q125 334 147 310Q171 288 221 281H632L1046 282Q1013 304 974 357T917 482Q913 500 913 501Q913 512 924 517Q926 518 944 518H949Q964 518 967 515T976 495Q996 412 1055 351T1197 270Q1217 263 1217 251Q1217 240 1209 236T1176 225T1127 204Q1069 173 1030 122T976 6Q972 -10 968 -13T948 -17H943Q918 -16 914 -9Q913 -6 913 -2Q913 1 917 17Q945 138 1046 220H632L225 221",
  8636: "1063 281Q1084 268 1084 251Q1084 231 1063 221L572 220Q79 220 77 221Q64 225 64 244Q64 250 64 254T67 261T71 265T78 268T85 272Q142 302 189 345T258 421T296 484T315 516Q319 518 337 518Q358 518 363 512Q370 504 367 496Q360 469 319 404T219 290L209 282L636 281H1063",
  8637: "1063 281Q1084 268 1084 251Q1084 231 1063 221L636 220H209L219 212Q278 162 319 97T367 5Q370 -3 363 -11Q358 -17 337 -17H332Q318 -17 314 -14T302 7Q278 55 246 95T185 160T130 202T88 228L70 237Q64 243 64 257Q64 274 75 279Q78 281 571 281H1063",
  8640: "65 251Q65 270 87 281H513L940 282L930 290Q871 338 830 403T782 496Q779 510 791 517Q794 518 812 518H817Q831 518 835 515T847 494Q871 445 903 404T966 338T1022 298T1064 272T1083 259Q1085 255 1085 245Q1085 225 1072 221Q1070 220 578 220L87 221Q65 228 65 251",
  8641: "84 279Q89 281 580 281Q1070 281 1074 279Q1085 275 1085 256Q1085 245 1083 241T1066 230Q919 153 847 7Q839 -11 835 -14T817 -17H812Q791 -17 786 -11Q779 -3 782 5Q789 31 830 96T930 212L940 220H513L87 221Q64 229 64 250Q64 272 84 279",
  8652: "65 451Q65 470 87 481H513L940 482L930 490Q871 538 830 603T782 696Q779 710 791 717Q794 718 812 718H817Q831 718 835 715T847 694Q871 645 903 604T966 538T1022 498T1064 472T1083 459Q1085 455 1085 445Q1085 425 1072 421Q1070 420 578 420L87 421Q65 428 65 451ZM1063 281Q1084 268 1084 251Q1084 231 1063 221L636 220H209L219 212Q278 162 319 97T367 5Q370 -3 363 -11Q358 -17 337 -17H332Q318 -17 314 -14T302 7Q278 55 246 95T185 160T130 202T88 228L70 237Q64 243 64 257Q64 274 75 279Q78 281 571 281H1063",
  8656: "1063 169L1068 166Q1072 163 1074 162T1079 157T1083 149T1085 139Q1085 118 1063 109L733 108H404L412 99Q455 50 488 -10Q498 -27 493 -37Q487 -46 465 -46H460Q446 -46 439 -39T426 -18T399 25T344 89Q239 194 99 229Q96 230 92 231T85 232T79 234T73 235T69 237T66 240T65 244T64 250Q64 267 90 271Q197 295 286 361T430 525Q439 542 442 544T460 547H465Q487 547 492 539Q496 531 496 530Q496 521 471 482T414 405L404 394L733 393H1063Q1064 392 1069 389T1076 384T1082 375T1085 362Q1085 344 1063 333L700 332H338L324 321Q283 290 230 264L205 250Q266 224 323 180L338 170L700 169H1063",
  8657: "672 343Q672 326 670 320T657 313Q644 313 602 335Q577 349 557 361T527 381T509 395T499 403T495 406T494 118Q494 -166 492 -174Q484 -193 465 -193H463Q456 -193 453 -192T444 -186T433 -170V465L423 477Q407 495 394 514T367 554T351 579Q349 576 339 560T313 520T279 477L269 465V-22V-102Q269 -132 269 -145T268 -169T266 -180T260 -185T253 -191Q248 -193 239 -193H237Q218 -193 210 -174Q208 -166 208 118Q208 406 207 406L199 399Q191 392 165 374T100 335Q58 313 45 313Q35 313 33 319T30 343V349Q30 359 30 362T35 369T45 374T66 383T100 401Q267 499 333 680Q339 694 351 694Q361 694 365 687T380 652T407 597Q442 536 489 489T573 420T638 383T670 365Q672 361 672 343",
  8658: "64 362Q64 380 87 393H416L745 394L735 405Q708 436 681 477T654 531Q654 547 679 547H684H689Q703 547 710 540T723 519T750 475T806 411Q914 303 1059 271Q1060 271 1063 270T1068 269T1072 268T1076 266T1079 264T1082 260T1083 256T1084 250Q1084 242 1080 238T1063 231T1035 225T992 211T934 185Q797 112 719 -24Q710 -40 706 -43T689 -46H684Q653 -46 653 -31Q653 -24 661 -10Q694 50 737 99L745 108H416L87 109Q64 117 64 139Q64 156 87 169H449L812 170L826 180Q842 193 860 204T892 223T918 237T937 246L944 250L919 264Q866 290 825 321L811 332H449L87 333Q64 343 64 362",
  8659: "30 157Q30 174 32 180T46 187Q59 187 104 163Q154 136 198 101L207 94Q208 94 208 382Q208 666 210 674Q219 694 241 694Q254 692 262 683Q266 679 267 674Q269 658 269 522V35L279 23Q295 5 308 -14T335 -54T351 -79Q353 -76 363 -60T389 -20T423 23L433 35V671Q439 682 444 686T452 692T463 693H465Q484 693 492 674Q494 666 494 382Q494 94 495 94L504 101Q547 135 593 160T652 187Q665 191 671 177Q672 175 672 157Q672 137 669 134T636 116Q606 101 578 83T528 47T486 9T452 -30T424 -68T403 -103T387 -134T377 -159T370 -176L367 -184Q360 -194 351 -194Q345 -194 342 -192T334 -182T327 -166T315 -137T295 -97Q260 -36 213 11T129 80T63 117T32 136Q30 139 30 157",
  8660: "336 497Q358 541 363 544Q367 547 379 547H384Q401 547 405 545Q418 538 414 525T389 474T346 408L335 393H814L803 408Q781 436 760 474T735 525T744 545Q748 547 765 547Q771 547 774 547T780 546T786 544T790 541T794 535T799 527T805 514T813 497Q841 446 877 406T950 340T1014 301T1068 276L1096 265Q1102 259 1102 251Q1102 240 1085 232Q981 195 902 121Q835 56 798 -25Q791 -40 787 -43T765 -46T744 -44Q735 -40 735 -30Q735 -15 760 28T806 98L814 108H335L343 98Q361 75 378 46T404 -1T414 -24Q418 -37 405 -44Q401 -46 384 -46T363 -43T351 -25Q314 56 247 121Q216 150 182 173T125 206T79 226T53 237Q47 243 47 251Q47 254 47 256T49 261T52 264T57 267T61 268T66 270T71 272Q246 335 336 497ZM985 251Q932 280 882 323L871 332H278Q264 321 253 311T237 297T214 282T164 251L176 244Q221 218 278 169H871Q928 218 973 244L985 251",
  8661: "49 441Q30 441 30 464V471V480Q30 498 44 502Q237 573 331 750Q337 767 351 767Q360 767 368 753T400 702T460 629Q504 584 552 554T632 511T666 497Q672 493 672 471Q672 454 670 449Q664 441 653 441Q639 443 591 465T508 513L495 522L494 386V114L495 -22L508 -13Q543 12 591 34T653 59Q672 59 672 36V29V20Q672 2 658 -2Q465 -71 367 -257Q360 -267 351 -267Q343 -267 336 -257T320 -231T292 -187T242 -129Q198 -84 150 -54T70 -11T36 3Q30 7 30 29Q30 46 32 51Q38 59 49 59Q63 57 111 35T194 -13L208 -22V522L194 513Q159 488 111 466T49 441ZM422 584Q411 594 400 606T383 626T366 648T351 667Q349 665 339 652T314 620T280 584L269 573V-73L280 -84Q305 -108 351 -166Q353 -164 363 -151T389 -119T422 -84L433 -73V573L422 584",
  8704: "1 664Q-2 685 23 693H27Q46 693 54 680T102 578L148 475H492L533 570Q541 586 548 603T560 630T569 650T576 667T582 678T588 686T594 691T600 693T609 694Q622 694 631 684T639 662Q637 653 492 325T341 -8Q333 -16 320 -16Q306 -16 298 -8Q294 -4 147 326L1 656V664ZM464 414H319Q175 414 175 413L319 88L464 414",
  8707: "81 347Q81 359 84 363T104 378H513V633H300L87 634Q64 642 64 664Q64 685 84 692Q89 694 321 694H552Q571 681 574 669V25Q567 7 552 1H87Q64 12 64 30T87 61H513V317H308Q103 317 99 319Q81 328 81 347",
  8709: "285 711Q307 711 326 708T357 701T370 698Q371 698 375 710T383 735T389 750Q395 767 415 767Q431 767 438 757T446 738T436 701T426 670Q426 668 433 664Q468 633 489 588Q511 542 519 488T528 344Q528 286 524 243T508 150T466 63T394 6Q345 -17 287 -17Q265 -17 246 -14T216 -7T203 -4Q191 -47 183 -60T159 -73Q146 -73 137 -63T128 -44Q128 -38 138 -7L148 24L141 30Q134 35 120 49Q94 77 78 113T56 194T48 268T46 344Q46 388 47 416T56 494T78 577T122 644T194 694Q239 711 285 711ZM351 639Q350 639 346 642T337 648T325 654T306 658T283 660Q254 660 221 638T181 567Q171 513 171 375Q171 164 182 129L351 639ZM402 356Q402 516 395 555Q395 557 395 559T394 563T394 566L393 568L223 57Q252 34 286 34H288Q318 34 346 53T387 109Q402 152 402 329V356",
  8710: "901 12Q901 7 892 0H479Q65 0 62 2Q56 6 56 11Q56 14 242 347T433 685Q438 694 450 696Q454 698 480 698H506L523 687Q526 683 711 354T899 17Q901 13 901 12ZM653 137L427 538L202 137L315 136H540L653 137",
  8712: "97 251Q97 393 194 484T417 586Q418 586 436 586T482 586T538 587H648Q649 586 652 584T658 580T664 575T668 568T670 557Q670 536 648 527L534 526Q515 526 491 526T457 526T435 526T417 525T404 523T390 521T374 517Q298 498 243 447T167 324Q159 295 159 283Q159 281 403 281H648Q649 280 652 278T658 274T664 269T668 262T670 251Q670 230 648 221L403 220Q159 220 159 218Q159 206 166 182T190 122T247 50T341 -6Q380 -20 405 -22T534 -25H648Q649 -26 654 -29T661 -34T667 -43T670 -56Q670 -74 648 -85L541 -86Q419 -86 396 -82Q276 -65 187 24T97 251",
  8713: "126 -210Q116 -210 107 -203T97 -179Q97 -171 99 -166Q99 -165 111 -145T150 -80T203 8Q97 104 97 251Q97 393 194 484T417 586Q418 586 436 586T482 586T538 587H549Q565 614 582 643T608 685L616 698Q623 711 641 711Q651 711 660 704T670 681Q670 672 667 667Q666 666 661 657T644 627T620 587H648Q649 586 652 584T658 580T664 575T668 568T670 557Q670 536 648 527L584 526L437 281H648Q649 280 652 278T658 274T664 269T668 262T670 251Q670 230 648 221L403 220H401L283 23Q311 5 341 -6Q380 -20 405 -22T534 -25H648Q649 -26 654 -29T661 -34T667 -43T670 -56Q670 -74 648 -85L541 -86Q419 -86 396 -82Q320 -71 252 -29Q152 -197 148 -201Q139 -210 126 -210ZM235 62L330 220Q159 219 159 218Q159 196 176 150T235 62ZM366 281L513 526Q503 526 487 526T465 526T448 525T433 525T422 525T412 524T403 523T394 521T385 519T374 517Q298 498 243 447T167 324Q159 295 159 283Q159 281 366 281",
  8715: "96 251Q96 268 119 281H363Q607 281 607 283Q607 295 600 319T576 379T519 451T425 507Q386 521 361 523T233 526L119 527Q96 535 96 557Q96 578 116 585Q121 587 229 587Q238 587 257 587T288 588Q366 588 435 568T568 488Q670 388 670 251Q670 155 621 78T499 -39T345 -85Q336 -86 225 -86L119 -85Q96 -77 96 -55Q96 -38 119 -25H233Q356 -24 371 -21Q373 -21 393 -16Q468 3 523 55T599 177Q607 206 607 218Q607 220 363 220L119 221Q96 229 96 251",
  8722: "119 221Q96 230 96 251T116 279Q121 281 448 281H775Q776 280 779 278T785 274T791 269T795 262T797 251Q797 230 775 221H119",
  8723: "64 155Q64 172 87 185H416V476H251L87 477Q64 485 64 507Q64 528 84 535Q89 537 448 537H807Q808 536 811 534T817 530T823 525T827 518T829 507Q829 486 807 477L642 476H477V185H807Q808 184 811 182T817 178T823 173T827 166T829 155Q829 134 807 125L642 124H477V-39Q477 -203 475 -208Q466 -227 446 -227Q427 -227 417 -205L416 -41V124H251L87 125Q64 133 64 155",
  8725: "451 730Q460 750 479 750Q492 750 501 740T510 718Q508 708 318 244L122 -232Q112 -250 95 -250Q82 -250 73 -241T64 -218Q66 -205 258 261T451 730",
  8726: "64 718Q63 731 72 740T94 750Q106 750 113 743Q118 741 122 732L318 256Q508 -208 510 -218Q511 -231 502 -240T480 -250Q460 -250 451 -230Q451 -229 259 238T64 718",
  8727: "236 431Q237 447 251 459T287 472T323 459T338 431Q338 423 328 363L317 300Q318 300 340 317T392 356T435 387Q442 390 450 390Q470 390 485 374T501 335Q501 326 500 320T494 309T486 300T473 293T458 287T438 280T414 272L353 250L414 228Q422 225 436 221T457 214T472 208T485 201T493 192T499 181T501 166Q501 141 484 126T450 111Q447 111 445 111T441 111T437 112T433 114T428 117T422 121T414 127T404 135T391 145T374 158L317 200L328 137Q338 77 338 69Q336 52 321 40T287 28T253 40T236 69Q236 77 246 137L257 200Q256 200 234 183T182 144T139 113Q132 110 124 110Q104 110 89 126T73 165Q73 174 74 180T80 191T88 200T101 207T116 213T136 220T160 228L221 250L160 272Q152 275 138 279T117 286T102 292T89 299T81 308T75 319T73 334Q73 359 90 374T124 389Q127 389 129 389T133 389T137 388T141 386T146 383T152 379T160 373T170 365T183 355T200 342L257 300L246 363Q236 423 236 431",
  8728: "64 251Q64 303 80 344T121 409T175 448T230 469T275 474Q277 474 283 474T292 473Q385 473 447 415T510 251Q510 149 449 89T287 28T126 88T64 251ZM448 251Q448 325 405 369T286 413Q215 413 171 371T126 251Q126 177 168 133T287 89Q361 89 404 132T448 251",
  8729: "64 251Q64 303 80 344T121 409T175 448T230 469T275 474Q277 474 283 474T292 473Q385 473 447 415T510 251Q510 149 449 89T287 28T126 88T64 251",
  8730: "107 178Q100 178 89 188T78 207Q78 216 84 220Q85 221 124 248T207 304T260 338Q269 340 275 335Q276 334 370 156L463 -20L698 393Q928 800 935 811Q944 820 954 820Q972 820 980 811T988 789Q988 781 858 553Q776 409 718 306Q452 -166 447 -171Q439 -179 422 -180Q405 -180 400 -175Q399 -174 346 -73T241 128T187 229L151 205Q111 178 107 178",
  8733: "65 222Q65 282 88 329T144 401T208 438T261 451H273Q312 451 320 450Q456 431 526 330L537 316Q638 451 778 451Q813 451 830 445V388Q821 391 799 391Q758 391 721 377T660 342T618 301T592 266L584 251Q648 152 697 114Q748 74 804 74H806Q823 74 829 77Q830 77 830 38V-1L820 -3Q801 -7 786 -7H771Q699 -7 632 25T527 114L516 128Q414 -8 276 -8Q192 -8 129 56T65 222ZM256 53Q296 53 332 67T392 102T434 143T461 178L469 193Q405 292 356 330Q308 369 251 369H243Q196 369 156 328T116 221Q116 191 124 161T158 99T225 55Q234 53 256 53",
  8734: "65 219Q65 318 132 385T302 452Q473 452 573 331L589 312L596 320Q710 452 857 452Q948 452 1016 386T1084 225Q1084 125 1017 59T848 -8Q679 -8 576 113L560 132L553 124Q439 -8 292 -8Q200 -8 133 58T65 219ZM1033 224Q1033 291 987 340T875 389Q748 389 648 261Q641 253 642 251Q717 163 748 137Q813 81 880 81Q941 81 987 120T1033 224ZM275 56Q315 56 353 70T418 104T466 144T497 178L507 192Q507 193 474 230T441 269Q355 362 267 362Q210 362 163 324T116 221Q116 150 162 103T275 56",
  8736: "71 0L68 2Q65 3 63 5T58 11T55 20Q55 21 56 23V25Q55 27 55 30Q55 31 56 33V35Q55 37 55 40Q55 42 57 48Q67 63 346 381Q421 467 518 578Q607 680 623 697T647 714Q656 714 661 708T666 694V692Q676 687 676 674Q676 668 673 663Q672 662 637 622T534 503T400 350L147 61L386 60H653Q666 50 666 40V38Q676 31 676 20Q676 8 661 0H71",
  8739: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V-225Q181 -249 160 -249",
  8741: "205 -225Q201 -234 199 -237T191 -244T175 -248T161 -246Q151 -240 146 -229Q145 -224 145 251Q145 725 146 730Q156 750 176 750Q193 748 205 727V-225ZM369 727L372 732Q375 737 377 740T385 747T398 750Q406 750 413 747Q423 740 428 730Q430 720 430 251Q430 -219 428 -229Q423 -240 413 -246Q408 -248 400 -248Q393 -248 388 -247T379 -242T375 -236T371 -230L369 -225V727",
  8743: "95 -16Q78 -16 71 -6T64 14Q64 20 65 22L212 308Q359 593 361 595Q370 604 385 604Q398 602 405 595Q407 593 554 308L701 22Q702 20 702 15Q702 1 693 -8T671 -17Q661 -17 651 -9Q647 -5 515 251L383 506L251 251Q119 -5 116 -8Q108 -16 95 -16",
  8744: "64 572Q64 585 72 594T94 604T116 595Q119 592 251 336L383 81L515 336Q647 592 651 596Q661 604 671 604Q684 604 693 595T702 572Q702 567 701 565L554 279Q407 -6 405 -8Q404 -9 401 -11T397 -14Q392 -16 383 -16H380Q369 -16 361 -8Q359 -6 212 279L65 565Q65 566 65 568T64 572",
  8745: "94 -16Q73 -16 64 8V209Q64 239 64 287Q65 418 69 432Q70 434 70 435Q84 487 125 523T216 575T299 597T354 603H372Q444 603 501 590T591 558T648 515T681 471T696 435Q696 434 697 432Q701 417 702 309Q702 303 702 287Q702 239 702 209V8Q693 -16 672 -16Q650 -16 643 3Q641 8 641 201Q641 397 640 403Q631 472 558 507T383 542Q339 542 298 535T219 511T156 468T126 403Q125 397 125 201Q125 8 123 3Q116 -16 94 -16",
  8746: "672 603Q693 603 702 579V378Q702 348 702 300Q701 169 697 155Q696 153 696 152Q676 78 593 31T383 -16Q265 -16 179 28T70 152Q70 153 69 155Q65 170 64 278Q64 285 64 300Q64 348 64 378Q64 579 65 583Q74 604 94 604T123 584Q125 579 125 386Q125 190 126 184Q135 115 210 80T383 44Q426 44 467 51T546 75T609 119T640 184Q641 190 641 386Q641 579 643 584Q650 603 672 603",
  8747: "204 -71Q204 -108 181 -124T137 -141Q132 -141 132 -142Q142 -161 154 -161Q164 -161 186 -152Q200 -145 210 -135T228 -107T241 -77T249 -38T254 -2T258 38T262 74Q282 265 334 489Q334 490 337 503T341 523T347 544T355 569T365 594T379 620T397 643T420 666T447 685T481 700Q511 711 539 711T587 696T616 656T628 612T632 573Q632 536 610 519T562 501Q534 501 513 519T492 571Q492 608 515 624T559 641Q564 641 564 642Q554 661 542 661Q532 661 510 652Q496 645 486 635T468 607T455 577T447 538T442 502T438 462T434 426Q414 235 362 11Q352 -35 347 -54T328 -101T291 -152Q235 -208 162 -211Q147 -211 136 -208T109 -196T83 -165T67 -108Q64 -94 64 -73Q64 -37 86 -19T134 -1Q162 -1 183 -19T204 -71",
  8764: "64 155Q64 210 84 262T150 353T257 391Q300 391 341 371T417 321T484 264T557 215T637 194Q702 194 745 244T788 367Q796 391 808 391Q815 391 821 381T828 353V342Q828 252 776 181T637 109Q594 109 552 129T476 179T409 236T336 285T256 306Q193 306 149 258T105 132Q98 109 86 109Q76 109 70 122T64 155",
  8768: "64 561Q64 570 76 576T108 583Q174 583 214 535T254 407Q254 368 238 324T202 248T166 173T149 92Q149 43 169 2T217 -39Q231 -40 242 -46T254 -60Q254 -69 241 -75T210 -82Q145 -82 105 -34T64 93Q64 133 80 177T116 253T152 328T169 408Q169 461 148 500T105 540Q92 540 78 545T64 561",
  8771: "64 295Q64 378 117 440T257 502Q298 502 339 485T416 443T486 394T560 352T637 335Q693 335 740 373T788 478Q796 502 808 502Q815 502 821 492T828 465V455Q828 365 771 308T640 250Q603 250 562 265T501 294T439 336L370 382Q308 417 256 417Q205 417 164 388T110 317Q110 316 109 304T107 286T103 270T97 255T86 250Q76 250 70 263T64 295ZM64 6T64 27T87 56H93Q99 56 110 56T137 56T173 56T217 56T267 57T323 57T383 57T448 57H807Q808 56 811 54T815 52T819 49T823 45T826 40T828 34T829 27Q829 7 807 -3H87Q64 6 64 27",
  8773: "64 402Q64 457 84 509T150 600T257 638Q300 638 341 618T417 569T484 511T557 462T637 441Q702 441 745 491T788 614Q796 638 808 638Q815 638 821 628T828 600V589Q828 499 776 428T637 356Q594 356 552 376T476 425T409 483T336 532T256 553Q193 553 149 505T105 379Q98 356 86 356Q76 356 70 369T64 402ZM87 197Q64 207 64 226Q64 247 84 255Q89 257 448 257H807Q808 256 811 254T817 250T823 245T827 238T829 227Q829 209 807 197H87ZM87 -27Q64 -18 64 3Q64 23 86 32Q89 33 448 33H807L812 30Q816 27 818 26T823 21T827 13T829 3Q829 -18 807 -27H87",
  8776: "64 345Q64 423 119 473T250 524Q301 524 356 503T451 455T542 407T636 385Q700 385 743 417T786 481Q786 493 791 508T807 524Q817 524 823 512T829 479Q829 404 776 352T638 300Q590 300 537 321T443 369T352 417T256 439Q207 439 166 417T110 359Q109 357 107 341T100 312T85 300Q77 300 71 313T64 345ZM64 77Q64 155 119 205T250 256Q302 256 357 235T451 187T541 139T636 117Q699 117 742 148T786 213Q786 231 792 243T808 256T823 242T829 208Q829 134 776 83T640 32Q591 32 537 53T443 101T352 149T256 171Q206 171 165 148T110 91Q109 89 107 73T100 44T85 32Q77 32 71 45T64 77",
  8781: "798 533Q812 533 820 524T829 502T819 480T769 440Q655 355 537 330Q492 322 447 322Q401 322 356 330Q289 344 219 381T118 443T73 481Q64 490 64 503Q64 517 72 525T94 533Q99 533 102 532Q107 531 138 507T209 456T314 405T446 382Q604 382 765 515Q788 533 798 533ZM95 -32Q81 -32 73 -23T64 -1Q64 10 74 21T124 61Q213 127 293 153T421 179L422 180Q424 180 426 180T432 180T441 180T452 179Q612 179 769 61Q811 29 820 19T829 -1Q829 -14 821 -23T798 -32Q788 -32 765 -14Q608 118 446 118Q287 118 128 -14Q105 -32 95 -32",
  8784: "87 333Q64 343 64 362Q64 383 84 391Q89 393 448 393H807Q808 392 811 390T817 386T823 381T827 374T829 363Q829 345 807 333H87ZM87 109Q64 118 64 139Q64 159 86 168Q89 169 448 169H807L812 166Q816 163 818 162T823 157T827 149T829 139Q829 118 807 109H87ZM362 635Q362 671 387 696T444 721Q488 721 510 693T533 635Q533 606 512 579T448 551Q406 551 384 577T362 635",
  8800: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q165 -163 327 109H87Q64 118 64 139Q64 159 86 168Q89 169 363 169L461 333H87Q64 343 64 362Q64 383 84 391Q89 393 448 393H496Q533 455 583 539T656 660T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q729 664 709 631T645 523T567 393H807Q808 392 811 390T817 386T823 381T827 374T829 363Q829 345 807 333H532L433 169H807L812 166Q816 163 818 162T823 157T827 149T829 139Q829 118 807 109H398Q217 -195 211 -201Q202 -210 189 -210",
  8801: "87 445Q64 454 64 475Q64 497 84 503Q89 505 448 505H807Q808 504 812 502T818 497T823 492T827 484T829 474Q829 456 807 445H87ZM87 221Q64 230 64 251T84 279Q89 281 448 281H807Q808 280 811 278T817 274T823 269T827 262T829 251Q829 230 807 221H87ZM64 6T64 27T87 56H93Q99 56 110 56T137 56T173 56T217 56T267 57T323 57T383 57T448 57H807Q808 56 811 54T815 52T819 49T823 45T826 40T828 34T829 27Q829 7 807 -3H87Q64 6 64 27",
  8804: "797 55Q797 45 790 35T767 25H759L434 180Q108 336 105 339Q96 348 96 360Q96 378 114 388Q126 394 439 544T757 695Q763 697 766 697Q780 697 788 688T797 666Q797 654 788 645Q784 641 507 509T197 361L466 232Q785 80 790 74Q797 66 797 55ZM119 -199Q96 -191 96 -169Q96 -160 102 -152T119 -140H124Q130 -140 140 -140T164 -140T197 -140T237 -140T283 -139T334 -139T389 -139T448 -139H775Q797 -153 797 -169Q797 -187 775 -199H119",
  8805: "127 25Q110 25 103 34T96 54Q96 66 105 75Q109 80 439 238L696 361Q113 637 105 645Q96 654 96 667Q96 679 104 688T128 697Q137 696 460 541T788 382Q797 373 797 360Q797 348 788 339Q785 336 459 180L135 25H127ZM119 -199Q96 -191 96 -169Q96 -160 102 -152T119 -140H124Q130 -140 140 -140T164 -140T197 -140T237 -140T283 -139T334 -139T389 -139T448 -139H775Q797 -153 797 -169Q797 -187 775 -199H119",
  8810: "734 -74T734 -86T727 -107T704 -116H702Q694 -116 584 -55Q473 7 380 58Q87 219 73 229Q64 238 64 250Q64 263 73 272Q87 282 380 443Q695 616 699 617H700Q718 617 726 607T734 588Q734 568 717 560Q705 554 435 404L157 250L439 94Q721 -61 726 -66Q734 -74 734 -86ZM1085 -74T1085 -86T1078 -107T1055 -116H1053Q1045 -116 935 -55Q824 7 731 58Q438 219 424 229Q415 238 415 250Q415 263 424 272Q438 282 731 443Q1046 616 1050 617H1051Q1069 617 1077 607T1085 588Q1085 568 1068 560Q1056 554 786 404L508 250L790 94Q1072 -61 1077 -66Q1085 -74 1085 -86",
  8811: "64 588Q64 600 72 609T94 618H95Q103 618 209 559Q322 496 419 443Q712 282 725 272Q734 263 734 250Q734 238 725 229Q714 220 415 55T110 -113Q103 -116 95 -116Q78 -116 71 -106T64 -86Q64 -74 72 -66Q77 -61 359 94L641 250L363 404Q277 452 173 509Q95 552 82 560T66 576V577Q64 585 64 588ZM415 588Q415 600 423 609T445 618H446Q454 618 560 559Q673 496 770 443Q1063 282 1076 272Q1085 263 1085 250Q1085 238 1076 229Q1065 220 766 55T461 -113Q454 -116 446 -116Q429 -116 422 -106T415 -86Q415 -74 423 -66Q428 -61 710 94L992 250L714 404Q628 452 524 509Q446 552 433 560T417 576V577Q415 585 415 588",
  8826: "797 -57Q797 -65 790 -75T766 -86Q748 -86 741 -74T733 -43T719 8T681 72Q647 112 588 141T475 185T343 207T230 216T136 219Q96 219 96 250Q96 280 132 280H136Q193 281 239 283T347 292T457 310T556 342T643 391T703 460T735 553Q741 585 763 585Q781 585 789 575T797 556Q797 540 792 513T758 434T682 345Q605 285 481 254L462 249Q483 246 526 233T633 185T733 104Q767 63 782 15T797 -57",
  8827: "96 556Q96 568 104 577T126 586Q152 586 158 553Q164 503 188 462T247 394T331 345T429 313T539 294T649 284T758 280H760Q797 280 797 250Q797 219 760 219H758Q627 217 529 204T347 160T216 77T158 -54Q152 -86 126 -86Q110 -86 103 -76T96 -57Q96 -41 101 -14T135 65T211 154Q288 214 412 245L431 250Q410 252 367 265T259 314T160 395Q127 435 112 483T96 556",
  8834: "96 251Q96 389 191 482T417 586Q418 586 428 586T456 586T496 586T546 587T601 587H775Q776 586 779 584T785 580T791 575T795 568T797 557Q797 536 775 527L597 526Q411 525 395 522Q390 521 370 516Q285 494 222 424T158 251Q158 131 246 53Q313 -9 408 -23Q417 -24 597 -25H775Q776 -26 781 -29T788 -34T794 -43T797 -56Q797 -74 775 -85H493Q407 -85 376 -79Q257 -55 177 35T96 251",
  8835: "96 -55Q96 -38 119 -25H296Q482 -24 498 -21Q503 -20 523 -15Q609 7 672 77T735 251T665 431T485 524Q476 525 296 526L119 527Q96 535 96 557Q96 578 116 585Q121 587 300 587Q451 586 476 585T522 579Q632 556 714 468T796 251Q796 112 695 13Q612 -65 497 -82Q473 -86 289 -86L119 -85Q96 -77 96 -55",
  8838: "96 361Q96 499 191 592T417 696Q418 696 428 696T456 696T496 696T546 697T601 697H775Q776 696 779 694T785 690T791 685T795 678T797 667Q797 646 775 637L597 636Q411 635 395 632Q390 631 370 626Q285 604 222 534T158 361Q158 241 246 163Q313 101 408 87Q417 86 597 85H775Q776 84 781 81T788 76T794 67T797 54Q797 36 775 25H493Q407 25 376 31Q257 55 177 145T96 361ZM149 -199Q127 -191 127 -169T149 -140H154Q160 -140 169 -140T192 -140T224 -140T262 -140T306 -139T354 -139T407 -139T463 -139H775Q776 -140 779 -142T785 -146T791 -151T795 -158T797 -169Q797 -190 775 -199H149",
  8839: "96 55Q96 72 119 85H296Q482 86 498 89Q503 90 523 95Q609 117 672 187T735 361T665 541T485 634Q476 635 296 636L119 637Q96 645 96 667Q96 688 116 695Q121 697 300 697Q451 696 476 695T522 689Q632 666 714 578T796 361Q796 222 695 123Q612 45 497 28Q473 24 289 24L119 25Q96 33 96 55ZM119 -199Q96 -190 96 -169T116 -141Q121 -139 433 -139H745Q766 -152 766 -170Q766 -190 745 -199H119",
  8846: "672 603Q693 603 702 579V378Q702 348 702 300Q701 169 697 155Q696 153 696 152Q676 78 593 31T383 -16Q265 -16 179 28T70 152Q70 153 69 155Q65 170 64 278Q64 285 64 300Q64 348 64 378Q64 579 65 583Q74 604 94 604T123 584Q125 579 125 386Q125 190 126 184Q135 115 210 80T383 44Q426 44 467 51T546 75T609 119T640 184Q641 190 641 386Q641 579 643 584Q650 603 672 603ZM353 412Q353 420 353 435T352 456Q352 483 358 495T385 507Q403 506 409 494T415 457Q415 451 415 436T414 411V341H558Q579 329 579 311Q579 289 558 281L486 280H414V136Q400 114 384 114Q363 114 354 136L353 208V280H281L209 281Q187 289 187 310Q187 328 209 341H353V412",
  8849: "127 25Q111 29 104 49V362L105 675Q114 693 127 696H132Q138 696 149 696T174 696T208 696T249 696T297 697T350 697T407 697T468 697H806Q828 683 828 666Q828 646 806 637L485 636H165V85H805Q806 84 809 82T813 80T817 77T821 73T824 68T826 62T827 55Q827 34 806 25H127ZM96 -190T96 -169T119 -140H125Q131 -140 141 -140T167 -140T201 -140T242 -140T290 -139T344 -139T402 -139T463 -139H805Q806 -140 809 -142T813 -144T817 -147T821 -151T824 -156T826 -162T827 -169Q827 -190 806 -199H119Q96 -190 96 -169",
  8850: "66 55Q66 74 89 85H728V636H408L88 637Q66 645 66 667T88 696H94Q99 696 110 696T135 696T169 696T210 696T258 697T311 697T368 697T429 697H767Q786 684 789 672V49Q782 31 767 25H88Q66 32 66 55ZM88 -199Q66 -191 66 -169Q66 -148 87 -140Q91 -139 433 -139H775Q776 -140 779 -142T783 -144T787 -147T791 -151T794 -156T796 -162T797 -169Q797 -189 775 -199H88",
  8851: "131 25Q121 1 100 1Q81 1 71 23L70 301Q70 579 72 583Q77 598 90 602Q95 604 385 604H674Q693 591 696 579V25Q686 1 665 1Q646 1 636 23L635 283V543H131V25",
  8852: "696 25Q689 7 674 1H93Q77 7 71 23L70 301Q70 579 72 583Q80 604 100 604T131 579V61H635V579Q644 603 666 603Q687 603 696 579V25",
  8853: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM416 282V570H414Q341 564 285 535T202 475T156 397T134 332T128 287Q127 283 127 282H416ZM765 288Q760 344 743 389T700 462T647 512T589 543T538 560T499 568L483 570H478V282H766L765 288ZM416 -69V220H127Q130 195 131 189T138 155T150 115T168 76T196 35T234 0T286 -35Q337 -61 410 -69H416ZM483 -69Q554 -60 607 -33T687 21T733 93T756 156T764 209Q766 217 766 220H478V-69H483",
  8854: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM765 288Q753 424 666 497T446 571T227 498T128 288L127 282H766L765 288ZM446 -70Q578 -70 666 4T765 213L766 220H127Q130 195 131 189T138 155T150 115T168 76T196 35T234 0T286 -35Q353 -70 446 -70",
  8855: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM647 512Q567 571 447 571Q340 571 262 523Q237 507 237 505L342 399L447 295L657 505L647 512ZM298 356L192 461Q180 445 161 411Q126 341 126 251Q126 128 192 40L403 250L298 356ZM701 41Q704 41 719 63T750 138T767 250Q767 310 750 362T719 437T701 460L491 250L701 41ZM238 -5Q238 -8 261 -22T336 -53T447 -70Q567 -70 647 -11L657 -4L447 206L342 101Q238 -1 238 -5",
  8856: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM657 505Q656 506 650 510T638 518T623 527T604 537T581 547T553 556T522 563T486 569T446 571Q305 571 216 487T126 251Q126 128 192 40L657 505ZM447 -70Q591 -70 679 16T767 250Q767 308 751 360T719 436T701 460L469 228Q238 -1 238 -5Q238 -8 261 -22T336 -53T447 -70",
  8857: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM767 252Q767 395 681 483T446 571Q303 571 215 486T126 249Q126 107 212 19T446 -70Q596 -70 681 18T767 252ZM335 251Q335 297 368 329T441 361Q498 361 527 327T557 250Q557 202 525 171T446 140Q397 140 366 173T335 251",
  8866: "65 672Q76 693 91 693Q115 693 123 674Q125 669 125 523V378H615Q618 376 622 373T628 369T632 366T635 362T636 356T637 347Q637 328 619 319Q615 317 370 317H125V171Q125 25 123 20Q114 1 94 1Q73 1 65 23V672",
  8867: "64 327T64 347T89 378H577V525L578 672Q592 693 604 693Q629 693 638 669V25Q628 1 607 1Q588 1 578 23L577 170V317H88Q64 327 64 347",
  8868: "64 664Q64 675 71 683T87 693H93Q99 693 110 693T137 693T173 693T217 694T267 694T323 694T383 694T448 694H807Q808 693 811 691T817 687T823 682T827 675T829 664Q829 643 807 634L642 633H477V25Q467 1 446 1Q427 1 417 23L416 328V633H251L87 634Q64 643 64 664",
  8869: "65 31Q65 38 66 41T71 50T87 61H416V366L417 672Q431 693 443 693Q468 693 477 669V61H807Q808 60 811 58T817 54T823 49T827 42T829 31Q829 10 807 1H87Q65 10 65 31",
  8872: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V392Q219 393 537 393H896Q897 392 900 390T906 386T912 381T916 374T918 363Q918 345 896 333H190V169H896L900 166Q905 163 907 162T912 157T916 149T918 139Q918 118 896 109H190V-225Q181 -249 160 -249",
  8900: "280 522Q281 523 285 523H289Q301 523 366 457Q404 420 431 393Q533 291 546 277T560 250Q560 239 548 226T431 108Q313 -10 304 -16Q297 -21 287 -21Q278 -21 275 -19Q270 -17 146 107T18 238Q15 242 15 251Q15 258 18 263Q20 268 145 392T274 519L280 522ZM388 350L288 449L188 350L89 250L288 52L487 250L388 350",
  8901: "74 251Q74 286 99 311T156 336Q200 336 222 308T245 250Q245 221 224 194T160 166T96 193T74 251",
  8902: "270 491Q274 502 287 502Q298 502 304 491Q304 486 323 396T342 303L438 314Q520 324 534 324Q540 324 545 320T550 307Q550 298 539 290T456 243Q377 198 377 197L416 111Q456 26 456 22Q457 21 457 18Q457 11 451 6T438 0H437Q432 0 415 16Q387 42 358 68L287 133L216 68Q193 47 167 23Q142 0 136 0Q129 0 123 5T117 18Q117 21 118 22Q118 26 158 111L197 197Q197 198 156 221T72 269T26 298Q24 304 24 307Q24 315 29 319T40 324Q53 324 136 314L232 303Q232 306 251 396T270 491",
  8904: "906 251Q906 456 905 456Q550 252 549 251Q549 250 726 148T905 45T906 251ZM967 -14Q958 -38 939 -38H937Q928 -38 923 -35Q919 -34 748 64T500 209L71 -38Q69 -39 63 -39Q42 -39 33 -16V518Q45 540 63 540H65Q72 540 174 481Q247 439 302 407L500 292Q578 339 750 438T929 539H933Q958 539 967 515V-14ZM449 251L94 456Q93 456 93 251Q93 45 94 45L106 52Q119 59 139 71T186 98T242 131T301 165T357 197T404 225T437 244L449 251",
  8942: "74 55Q74 91 99 116T156 141Q200 141 222 113T245 55Q245 26 224 -1T160 -29Q118 -29 96 -3T74 55ZM74 465Q74 501 99 526T156 551Q200 551 222 523T245 465Q245 436 224 409T160 381Q118 381 96 407T74 465ZM74 865Q74 901 99 926T156 951Q200 951 222 923T245 865Q245 836 224 809T160 781Q118 781 96 807T74 865",
  8943: "74 251Q74 286 99 311T156 336Q200 336 222 308T245 250Q245 221 224 194T160 166T96 193T74 251ZM562 251Q562 286 587 311T644 336Q688 336 710 308T733 250Q733 221 712 194T648 166T584 193T562 251ZM1050 251Q1050 286 1075 311T1132 336Q1176 336 1198 308T1221 250Q1221 221 1200 194T1136 166T1072 193T1050 251",
  8945: "129 785Q129 821 154 846T211 871Q255 871 277 843T300 785Q300 756 279 729T215 701Q173 701 151 727T129 785ZM576 485Q576 521 601 546T658 571Q702 571 724 543T747 485Q747 456 726 429T662 401Q620 401 598 427T576 485ZM1023 185Q1023 221 1048 246T1105 271Q1149 271 1171 243T1194 185Q1194 156 1173 129T1109 101Q1067 101 1045 127T1023 185",
  8968: "194 728Q199 743 216 749H220Q223 749 229 749T245 749T265 750T289 750T316 750T345 750H471Q472 749 477 746T484 741T490 732T493 719Q493 701 471 690L362 689H254V-224Q244 -248 223 -248T194 -226V728",
  8969: "317 -224Q307 -248 286 -248Q267 -248 257 -226L256 231V689H148L40 690Q17 698 17 720Q17 741 37 748Q42 750 169 750H295Q314 737 317 725V-224",
  8970: "194 728Q204 749 220 749Q245 749 254 725V-188H471Q472 -189 477 -192T484 -197T490 -206T493 -219Q493 -237 471 -248H216Q200 -242 194 -226V728",
  8971: "17 -219Q17 -201 40 -188H256V270L257 728Q271 749 283 749Q308 749 317 725V-224Q310 -242 295 -248H40L38 -247Q35 -246 34 -245T30 -243T25 -239T21 -234T18 -227T17 -219",
  8994: "95 108Q85 108 75 114T65 139Q65 159 129 227Q316 405 573 405Q654 405 729 387T854 344T950 286T1015 232T1053 191Q1078 160 1083 152Q1084 148 1084 139Q1084 121 1074 115T1054 108Q1040 108 1029 122T990 167T922 223Q819 291 680 309Q641 315 575 315Q508 315 469 309Q303 288 197 201Q168 179 148 155T118 119T95 108",
  8995: "1054 392Q1067 392 1076 384T1085 362Q1085 351 1079 342T1050 310Q983 243 901 200Q753 126 575 126Q494 126 420 141T298 176T205 225T140 272T100 310Q64 346 64 362Q64 370 67 374Q75 393 93 393Q107 393 124 375Q272 214 575 214Q877 214 1025 375Q1039 392 1054 392",
  9001: "127 243V259L223 491Q251 557 286 642Q318 719 324 732T340 748H341Q347 750 351 750Q365 750 373 740T382 723Q382 713 286 482L190 251Q190 249 286 20T382 -219Q382 -232 373 -240T352 -249Q332 -249 323 -229Q320 -220 223 10L127 243",
  9002: "64 720Q64 732 72 741T94 750Q106 750 113 743Q118 741 122 732L319 259V243L122 -231Q112 -249 95 -249Q83 -249 74 -240T64 -218Q64 -210 160 20L256 251L160 482Q64 715 64 720",
  9651: "91 1Q69 10 69 31Q69 39 81 59T168 197Q327 447 485 697Q493 711 510 711Q523 711 532 702Q536 697 743 371T951 41Q953 35 953 31Q953 12 931 1H91ZM690 340Q651 401 604 476T534 586L512 621Q511 622 507 616Q498 604 332 342L154 62L333 61H689L867 62L690 340",
  9653: "91 1Q69 10 69 31Q69 39 81 59T168 197Q327 447 485 697Q493 711 510 711Q523 711 532 702Q536 697 743 371T951 41Q953 35 953 31Q953 12 931 1H91ZM690 340Q651 401 604 476T534 586L512 621Q511 622 507 616Q498 604 332 342L154 62L333 61H689L867 62L690 340",
  9657: "33 518Q45 540 63 540H65Q72 540 174 481Q247 439 302 407Q529 276 533 272Q542 263 542 250Q542 238 533 229Q528 224 304 95T71 -38Q69 -39 63 -39Q42 -39 33 -16V518ZM449 251L94 456Q93 456 93 251Q93 45 94 45L106 52Q119 59 139 71T186 98T242 131T301 165T357 197T404 225T437 244L449 251",
  9661: "68 470Q68 481 75 489T91 499H93Q296 500 512 500H931Q932 499 937 496T945 490T950 482T953 469Q953 465 951 459Q950 455 743 129T532 -202Q524 -210 511 -210Q497 -210 489 -202Q486 -199 281 124T71 456Q68 462 68 470ZM154 439Q155 437 332 158T510 -122Q510 -123 533 -87T600 18T688 157Q866 437 866 438Q867 439 805 439T511 439H154",
  9663: "68 470Q68 481 75 489T91 499H93Q296 500 512 500H931Q932 499 937 496T945 490T950 482T953 469Q953 465 951 459Q950 455 743 129T532 -202Q524 -210 511 -210Q497 -210 489 -202Q486 -199 281 124T71 456Q68 462 68 470ZM154 439Q155 437 332 158T510 -122Q510 -123 533 -87T600 18T688 157Q866 437 866 438Q867 439 805 439T511 439H154",
  9667: "542 -14Q533 -38 514 -38H512Q503 -38 498 -35Q494 -34 270 95T42 229Q33 238 33 251Q33 259 35 264Q36 265 38 268T42 272Q48 278 271 407T504 539H508Q533 539 542 515V-14ZM481 251Q481 456 480 456Q125 252 124 251Q124 250 301 148T480 45T481 251",
  9711: "65 42T65 250T204 584T574 711Q795 711 935 594Q955 577 974 555T1022 490T1067 385T1084 250Q1084 42 945 -84T574 -211T204 -85ZM1024 250Q1024 431 903 540T578 650Q482 650 404 627T274 565T189 474T140 366T125 250Q125 123 186 31T347 -106T573 -150Q772 -150 898 -45T1024 250",
  9824: "675 -18Q536 -18 527 62V70H477V55Q479 14 487 -21T502 -75T509 -101Q509 -120 491 -127Q487 -129 447 -129Q446 -129 439 -129T427 -130Q384 -130 384 -101Q384 -95 391 -76T406 -21T416 55V70H366Q364 52 360 40T342 14T300 -8T230 -17H218Q110 -17 75 117Q64 163 64 209Q64 290 116 357T261 495Q363 574 414 690Q425 719 445 719Q467 719 478 693Q507 627 547 578T623 503T702 438T777 357Q829 285 829 202V197Q826 128 808 81T762 15T714 -11T675 -18",
  9825: "65 491Q65 602 121 656T246 710Q375 710 440 624L447 615Q519 711 638 711Q723 711 775 652T828 491Q828 390 770 313T581 129Q539 95 514 63T483 14T469 -13T446 -24Q434 -24 427 -17T416 0T400 32T371 74Q352 97 310 131T229 199T151 276T89 374T65 491ZM249 649Q188 649 157 603T125 489Q125 409 181 338T352 176Q408 131 437 87L446 73L456 87Q479 121 507 147T579 207T659 278Q768 387 768 489Q768 506 766 524T756 566T731 611T687 642Q668 649 638 649Q609 649 593 644Q547 633 516 604T478 534Q473 505 447 505H445Q420 505 416 534Q407 577 372 608T285 648Q277 649 249 649",
  9826: "409 686Q410 688 412 691T415 696T418 701T421 706T424 709T427 713T431 715T435 717T440 718T446 719Q455 719 460 717T472 704T488 679T516 633T563 567Q624 485 687 422T787 330T826 296T828 282Q828 270 825 265T801 245Q696 161 612 59T477 -133Q465 -154 447 -154Q439 -154 434 -152T425 -146T414 -130T399 -104T372 -62T330 -3Q270 78 207 142T107 234T70 265Q64 274 64 282Q64 296 90 317Q284 472 409 686ZM749 282Q745 286 721 307T681 343T635 388T581 446T525 516T465 601Q462 606 457 613T450 624L447 627V628Q446 628 436 611T402 561T348 489T266 396T155 292L145 282Q147 280 185 245T257 177T343 79T442 -57Q446 -64 447 -64V-63Q450 -59 475 -22T530 56T619 160T749 282",
  9827: "240 527Q240 611 301 665T446 719T590 665T652 527Q652 431 571 373Q578 363 584 352T593 335T597 329L604 335Q611 341 617 345T637 356T667 366Q672 366 680 367T694 368Q767 368 814 310T861 177Q861 109 819 57T713 -12Q690 -17 656 -17Q535 -13 527 62V70H477V55Q479 14 487 -21T502 -75T509 -101Q509 -120 491 -127Q487 -129 447 -129Q446 -129 439 -129T427 -130Q384 -130 384 -101Q384 -95 391 -76T406 -21T416 55V70H366V62Q356 -12 237 -17Q130 -17 71 60Q32 111 32 178Q32 251 78 309T198 368Q217 368 233 364T260 354T279 343T291 333T296 329L300 336Q304 343 310 354T322 373Q240 432 240 527",
  9837: "230 480Q293 480 337 440T381 330V322Q381 240 323 161Q258 71 123 -11L114 -16L97 -17Q70 -17 66 -7Q64 -3 64 366V641Q64 717 65 731T75 748Q78 750 95 750Q117 750 122 742T127 694Q127 685 127 653T126 595V454Q183 480 230 480ZM242 333Q242 405 212 405H207Q147 405 130 370L127 364L126 219Q126 77 128 77Q133 82 140 90T167 127T202 183T229 253T242 333",
  9838: "345 -223Q333 -223 330 -214T327 -178V-116Q327 -23 326 -23L203 -82Q90 -134 77 -140Q65 -142 59 -130Q57 -126 57 295V595Q57 643 57 667T58 704T60 719T63 724Q93 741 101 741Q113 741 116 732T119 680V597Q119 467 120 467Q121 468 180 495T301 552T369 584Q381 586 387 574Q389 570 389 187V-88Q389 -132 389 -154T388 -188T386 -202T383 -206Q353 -223 345 -223ZM327 271Q327 421 326 421L120 323L119 173V23Q120 23 223 72L327 121V271",
  9839: "140 628Q151 628 154 620T158 591V549V484L166 488Q175 492 192 500T223 516L288 548V622V674Q288 681 288 685T289 693T289 699T291 703T295 707T298 709T304 712T311 716Q326 724 332 724Q343 724 346 715T350 685V644V579Q358 583 364 583Q376 583 380 574Q382 570 382 514V481Q382 459 380 454T363 441L350 435V135Q358 139 364 139Q376 139 380 130Q382 126 382 70V37Q382 15 380 10T363 -3L350 -9V-76Q350 -102 348 -106T328 -119Q312 -128 306 -128Q288 -128 288 -99V-77V-40L280 -44Q271 -48 254 -56T223 -72L158 -104V-150V-180Q158 -198 155 -202T135 -216Q119 -224 114 -224Q96 -224 96 -192V-172V-135Q86 -140 81 -140Q70 -140 66 -129Q64 -126 64 -70V-54Q64 -18 66 -12T83 3L96 9V309Q86 304 81 304Q70 304 66 315Q64 318 64 374V407Q64 429 66 434T83 447L96 453V602Q99 609 100 610T118 619Q134 628 140 628ZM288 254Q288 404 287 404L158 340V40L166 44Q175 48 192 56T223 72L288 104V254",
  10072: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V-225Q181 -249 160 -249",
  10216: "127 243V259L223 491Q251 557 286 642Q318 719 324 732T340 748H341Q347 750 351 750Q365 750 373 740T382 723Q382 713 286 482L190 251Q190 249 286 20T382 -219Q382 -232 373 -240T352 -249Q332 -249 323 -229Q320 -220 223 10L127 243",
  10217: "64 720Q64 732 72 741T94 750Q106 750 113 743Q118 741 122 732L319 259V243L122 -231Q112 -249 95 -249Q83 -249 74 -240T64 -218Q64 -210 160 20L256 251L160 482Q64 715 64 720",
  10229: "1063 221L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1063L1065 280Q1079 281 1392 281H1719Q1720 280 1723 278T1729 274T1735 269T1739 262T1741 251Q1741 230 1719 221H1063",
  10230: "119 221Q96 230 96 251T116 279Q121 281 448 281H1188L1602 282Q1569 304 1530 357T1473 482Q1469 500 1469 501Q1469 512 1480 517Q1482 518 1500 518H1505Q1520 518 1523 515T1532 495Q1552 412 1611 351T1753 270Q1773 263 1773 251Q1773 240 1765 236T1732 225T1683 204Q1625 173 1586 122T1532 6Q1528 -10 1524 -13T1504 -17H1499Q1474 -16 1470 -9Q1469 -6 1469 -2Q1469 1 1473 17Q1501 138 1602 220H1188L775 221H119",
  10231: "1063 221L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1476L1890 282Q1857 304 1818 357T1761 482Q1757 500 1757 501Q1757 512 1768 517Q1770 518 1788 518H1793Q1808 518 1811 515T1820 495Q1840 412 1899 351T2041 270Q2061 263 2061 251Q2061 240 2053 236T2020 225T1971 204Q1913 173 1874 122T1820 6Q1816 -10 1812 -13T1792 -17H1787Q1762 -16 1758 -9Q1757 -6 1757 -2Q1757 1 1761 17Q1789 138 1890 220H1476L1063 221",
  10232: "1063 333L700 332H338L324 321Q283 290 230 264L205 250Q266 224 323 180L338 170L700 169H1063L1064 168Q1080 169 1423 169H1782L1786 166Q1791 163 1793 162T1798 157T1802 149T1804 139Q1804 118 1782 109H1063L733 108H404L412 99Q455 50 488 -10Q498 -27 493 -37Q487 -46 465 -46H460Q446 -46 439 -39T426 -18T399 25T344 89Q239 194 99 229Q96 230 92 231T85 232T79 234T73 235T69 237T66 240T65 244T64 250Q64 267 90 271Q197 295 286 361T430 525Q439 542 442 544T460 547H465Q487 547 492 539Q496 531 496 530Q496 521 471 482T414 405L404 394L733 393H1063Q1064 392 1065 392Q1081 393 1423 393H1782Q1783 392 1786 390T1792 386T1798 381T1802 374T1804 363Q1804 345 1782 333H1063",
  10233: "87 109Q64 118 64 139Q64 159 86 168Q89 169 448 169H1169L1532 170L1546 180Q1562 193 1580 204T1612 223T1638 237T1657 246L1664 250L1639 264Q1586 290 1545 321L1531 332H1169L807 333H87Q64 343 64 362Q64 383 84 391Q89 393 448 393H1136L1465 394L1455 405Q1428 436 1401 477T1374 531Q1374 547 1399 547H1404H1409Q1423 547 1430 540T1443 519T1470 475T1526 411Q1634 303 1779 271Q1780 271 1783 270T1788 269T1792 268T1796 266T1799 264T1802 260T1803 256T1804 250Q1804 242 1800 238T1783 231T1755 225T1712 211T1654 185Q1517 112 1439 -24Q1430 -40 1426 -43T1409 -46H1404Q1373 -46 1373 -31Q1373 -24 1381 -10Q1414 50 1457 99L1465 108H1136L807 109H87",
  10234: "1063 333L700 332H338L324 321Q283 290 230 264L205 250Q266 224 323 180L338 170L700 169H1425L1788 170L1802 180Q1818 193 1836 204T1868 223T1894 237T1913 246L1920 250L1895 264Q1842 290 1801 321L1787 332H1425L1063 333ZM733 393H1392L1721 394L1711 405Q1684 436 1657 477T1630 531Q1630 547 1655 547H1660H1665Q1679 547 1686 540T1699 519T1726 475T1782 411Q1890 303 2035 271Q2036 271 2039 270T2044 269T2048 268T2052 266T2055 264T2058 260T2059 256T2060 250Q2060 242 2056 238T2039 231T2011 225T1968 211T1910 185Q1773 112 1695 -24Q1686 -40 1682 -43T1665 -46H1660Q1629 -46 1629 -31Q1629 -24 1637 -10Q1670 50 1713 99L1721 108H1392L1063 109L733 108H404L412 99Q455 50 488 -10Q498 -27 493 -37Q487 -46 465 -46H460Q446 -46 439 -39T426 -18T399 25T344 89Q239 194 99 229Q96 230 92 231T85 232T79 234T73 235T69 237T66 240T65 244T64 250Q64 267 90 271Q197 295 286 361T430 525Q439 542 442 544T460 547H465Q487 547 492 539Q496 531 496 530Q496 521 471 482T414 405L404 394L733 393",
  10236: "65 426Q74 448 95 448Q112 448 125 426V281H130L132 280H134Q162 281 448 281H1188L1602 282Q1569 304 1530 357T1473 482Q1469 500 1469 501Q1469 512 1480 517Q1482 518 1500 518H1505Q1520 518 1523 515T1532 495Q1552 412 1611 351T1753 270Q1773 263 1773 251Q1773 240 1765 236T1732 225T1683 204Q1625 173 1586 122T1532 6Q1528 -10 1524 -13T1504 -17H1499Q1474 -16 1470 -9Q1469 -6 1469 -2Q1469 1 1473 17Q1501 138 1602 220H1188L775 221H135Q133 220 130 220H125V76Q115 54 95 54Q73 54 65 76V426",
  10744: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210",
  10799: "168 500Q168 515 178 522T195 530H198Q207 530 218 521T282 458Q312 428 331 409L447 294L563 409Q674 520 682 525Q687 529 695 529Q711 529 718 520T726 499V498Q726 489 720 481T666 427Q631 392 606 367L490 251L606 135Q717 23 721 17T726 2Q726 -9 719 -18T695 -28H692Q685 -28 674 -18T608 47Q581 74 563 92L447 207L331 91Q217 -22 208 -27Q206 -28 203 -28H197Q168 -28 168 2Q168 13 178 24T288 135L404 250L288 366Q177 479 173 485T168 500",
  10815: "39 655Q39 675 43 680T69 686Q110 684 225 684Q267 684 303 684T360 685T385 686Q401 686 405 680T409 651Q409 632 403 628T367 624H348H301V62H598V624H551H532Q502 624 496 628T490 651Q490 673 494 679T514 686Q518 686 558 685T675 684T792 685T836 686Q852 686 856 680T860 651Q860 632 854 628T818 624H799H752V62H799H809Q846 62 853 59T860 36V31V21Q860 6 850 2Q846 0 450 0H156Q75 0 60 1T40 11V18Q39 26 39 31Q39 54 44 58T82 63Q84 63 90 63T100 62H147V624H100H90Q53 624 46 627T39 650V655",
  10927: "796 54Q796 40 788 32T767 24Q741 24 735 57Q729 107 705 148T646 216T563 264T465 297T356 316T245 326T136 330H134Q96 330 96 360Q96 391 134 391H136Q193 392 239 394T347 403T457 421T556 453T643 502T703 571T735 664Q741 696 763 696Q781 696 789 686T797 667Q797 651 792 624T758 545T682 456Q605 396 481 365L462 360Q483 357 526 344T633 296T733 215Q767 173 781 128T796 54ZM119 -199Q96 -190 96 -169T116 -141Q121 -139 448 -139H775Q776 -140 779 -142T785 -146T791 -151T795 -158T797 -169Q797 -190 775 -199H119",
  10928: "127 24Q115 24 106 32T97 55Q97 95 124 156T211 265Q288 325 412 356L431 361Q410 363 367 376T259 425T160 506Q127 546 112 594T96 667Q96 679 104 688T126 697Q152 697 158 664Q164 614 188 573T247 505T331 456T429 424T539 405T649 395T758 391Q797 391 797 360Q797 330 761 330H758Q701 329 655 327T547 318T437 300T337 268T251 219T190 150T158 57Q151 24 127 24ZM119 -199Q96 -190 96 -169T116 -141Q121 -139 448 -139H775Q776 -140 779 -142T785 -146T791 -151T795 -158T797 -169Q797 -190 775 -199H119",
  12296: "127 243V259L223 491Q251 557 286 642Q318 719 324 732T340 748H341Q347 750 351 750Q365 750 373 740T382 723Q382 713 286 482L190 251Q190 249 286 20T382 -219Q382 -232 373 -240T352 -249Q332 -249 323 -229Q320 -220 223 10L127 243",
  12297: "64 720Q64 732 72 741T94 750Q106 750 113 743Q118 741 122 732L319 259V243L122 -231Q112 -249 95 -249Q83 -249 74 -240T64 -218Q64 -210 160 20L256 251L160 482Q64 715 64 720"
}, {
  8243: "′′",
  8244: "′′′",
  8279: "′′′′",
  8602: "↚",
  8603: "↛",
  8622: "↮",
  8653: "⇍",
  8654: "⇎",
  8655: "⇏",
  8708: "∄",
  8716: "∌",
  8740: "∤",
  8742: "∦",
  8769: "≁",
  8772: "≄",
  8775: "≇",
  8777: "≉",
  8802: "≢",
  8813: "≭",
  8814: "≮",
  8815: "≯",
  8816: "≰",
  8817: "≱",
  8832: "⊀",
  8833: "⊁",
  8836: "⊄",
  8837: "⊅",
  8840: "⊈",
  8841: "⊉",
  8876: "⊬",
  8877: "⊭",
  8930: "⋢",
  8931: "⋣"
});
var nh = {}, Oi = {};
Object.defineProperty(Oi, "__esModule", { value: !0 });
Oi.doubleStruck = void 0;
Oi.doubleStruck = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.doubleStruck = void 0;
  var t = Oi;
  Object.defineProperty(e, "doubleStruck", { enumerable: !0, get: function() {
    return t.doubleStruck;
  } });
})(nh);
var Ai = {}, Di = {};
Object.defineProperty(Di, "__esModule", { value: !0 });
Di.frakturBold = void 0;
Di.frakturBold = {
  33: [0.689, 0.012, 0.349],
  34: [0.695, -0.432, 0.254],
  38: [0.696, 0.016, 0.871],
  39: [0.695, -0.436, 0.25],
  40: [0.737, 0.186, 0.459],
  41: [0.735, 0.187, 0.459],
  42: [0.692, -0.449, 0.328],
  43: [0.598, 0.082, 0.893],
  44: [0.107, 0.191, 0.328],
  45: [0.275, -0.236, 0.893],
  46: [0.102, 0.015, 0.328],
  47: [0.721, 0.182, 0.593],
  48: [0.501, 0.012, 0.593],
  49: [0.489, 0, 0.593],
  50: [0.491, 0, 0.593],
  51: [0.487, 0.193, 0.593],
  52: [0.495, 0.196, 0.593],
  53: [0.481, 0.19, 0.593],
  54: [0.704, 0.012, 0.593],
  55: [0.479, 0.197, 0.593],
  56: [0.714, 5e-3, 0.593],
  57: [0.487, 0.195, 0.593],
  58: [0.457, 0.012, 0.255],
  59: [0.458, 0.19, 0.255],
  61: [0.343, -0.168, 0.582],
  63: [0.697, 0.014, 0.428],
  91: [0.74, 0.13, 0.257],
  93: [0.738, 0.132, 0.257],
  94: [0.734, -0.452, 0.59],
  8216: [0.708, -0.411, 0.254],
  8217: [0.692, -0.394, 0.254],
  8260: [0.721, 0.182, 0.593],
  58113: [0.63, 0.027, 0.587],
  58114: [0.693, 0.212, 0.394, { ic: 0.014 }],
  58115: [0.681, 0.219, 0.387],
  58116: [0.473, 0.212, 0.593],
  58117: [0.684, 0.027, 0.393],
  58120: [0.679, 0.22, 0.981],
  58121: [0.717, 0.137, 0.727]
};
Object.defineProperty(Ai, "__esModule", { value: !0 });
Ai.frakturBold = void 0;
var HH = s3, EH = Di;
Ai.frakturBold = (0, HH.AddPaths)(EH.frakturBold, {
  33: "121 621Q121 657 132 673T177 689Q223 689 223 644V635Q223 604 222 595Q221 590 210 490T187 292T175 190V186L166 185L156 184Q156 185 139 393T121 621ZM107 47Q107 70 127 87T174 104Q201 104 221 89T241 48Q241 24 222 6T174 -12Q147 -12 127 6T107 47",
  34: "53 695Q74 695 90 679V622L65 433L52 432H39L27 516Q10 626 10 655Q10 680 26 688Q33 693 39 693Q49 695 53 695ZM151 668Q151 691 191 691Q217 691 224 685T231 661V652Q230 634 219 531L207 433L195 432Q183 432 183 433L168 541Q151 664 151 668",
  38: "290 -14Q186 -14 115 41T44 185Q44 222 54 249T88 300T131 336T189 371Q216 387 216 388Q185 459 185 510Q185 563 206 601T263 659T334 687T405 696Q476 696 503 668T531 603Q531 565 513 536T450 476Q423 459 370 432L334 413L354 384Q474 212 560 139L563 137Q611 185 611 250Q611 295 577 329Q549 356 496 357Q439 357 433 354Q432 354 432 379V403L437 402Q443 402 479 401T557 400Q653 400 735 403T831 407H836Q833 352 833 351L821 352Q809 352 792 352T756 352T720 353T696 354Q680 354 680 353L681 346Q682 339 683 327T685 306Q685 283 681 260T669 218T653 182T635 152T619 129T606 114L602 109Q604 107 618 99T659 81T707 71Q742 71 767 99T804 155L815 183Q815 184 821 183T833 180T839 177Q837 169 834 156T816 110T782 52T727 5T648 -16Q569 -16 499 35H498Q496 35 466 23T387 -1T290 -14ZM418 592Q418 617 398 639T352 661T302 642T278 574Q278 545 288 514T306 465T319 444Q342 456 353 463T382 488T409 529T418 584V592ZM159 239Q159 158 222 98T364 38Q386 38 447 57L469 63L434 98Q349 185 286 275Q258 316 238 345Q233 353 232 353Q159 316 159 239",
  39: "80 645T80 662T93 687T123 695Q158 695 158 659Q158 649 157 643L123 437Q123 436 114 436H104Q104 442 92 538Q80 645 80 662",
  40: "347 719Q325 708 311 698T272 656T233 580T207 455T195 267Q195 30 247 -79Q261 -110 291 -136Q320 -163 347 -172V-179Q347 -186 344 -186Q338 -186 328 -184T287 -165T230 -123Q134 -25 134 271Q134 417 158 514T226 662T335 734L346 737Q347 737 347 728V719",
  41: "264 262Q264 366 253 446T226 572T186 649T145 692T105 714V725Q105 735 107 735Q108 734 121 731T154 719T196 692T242 641T284 560T314 437T326 268Q326 112 299 7Q279 -78 239 -124T116 -185L105 -187V-179L106 -171L109 -169Q130 -161 138 -158T165 -146T190 -127T210 -101T229 -64T243 -12T255 58T261 148T264 262",
  42: "40 516L62 529Q85 542 110 556T140 574L126 582Q112 591 104 595T80 607T40 629Q53 642 57 645L65 652L78 642Q106 620 132 603L152 589V595Q152 630 149 681V692H179V689Q178 681 174 638T171 593Q173 593 240 639L258 652Q260 652 267 643L276 633L260 625Q190 587 175 576Q173 575 180 570Q183 569 186 567Q213 549 256 527L277 515L256 495Q246 501 228 515T194 539T170 554V543Q170 486 178 449H148V456Q152 492 152 550L151 562Q150 562 102 528L53 495Q40 514 40 516",
  43: "422 584L471 598Q472 598 472 440V282H837Q833 273 829 263L821 244L647 243H472V-63L448 -73L423 -82Q422 -82 422 81V243H239Q56 243 56 244Q60 253 65 263L73 282H422V584",
  44: "118 61Q118 80 135 93T169 107Q190 107 221 65T253 -23Q253 -39 251 -49T237 -80T198 -133Q148 -191 144 -191Q142 -191 137 -182T132 -172Q143 -161 160 -131T183 -83Q185 -77 185 -62Q185 -54 184 -48T182 -38T177 -28T171 -19T162 -8T150 6Q130 28 124 38T118 61",
  45: "54 236L73 275H453Q833 275 833 274Q830 265 825 255L818 236H54",
  46: "103 23T103 44T120 83T170 102Q200 102 218 84T237 44Q237 20 216 3T168 -15Q138 -15 121 4",
  47: "272 270Q503 721 506 721L509 720Q512 720 518 719T529 717L550 713L91 -181L66 -182Q41 -182 41 -181L272 270",
  48: "238 -12Q162 -12 102 42T42 185Q42 303 130 393Q163 425 208 452T284 490L313 501Q323 499 339 495T395 472T464 426Q533 357 533 273Q533 201 483 133T364 27T238 -12ZM428 208Q428 255 402 297T342 365T280 404T241 419Q214 419 178 374T142 259Q142 206 168 164T225 99Q259 74 310 74Q326 74 337 75T366 82T396 103T417 141Q428 171 428 208",
  49: "95 481Q102 481 217 485T383 489Q384 489 384 485Q367 397 367 165Q367 58 369 54Q374 46 380 44T410 42H466H546V40Q547 38 547 19L548 0H54V23Q54 29 54 34T54 44L55 47Q79 47 134 46T202 45Q226 45 234 52Q240 57 241 64T245 105Q254 236 254 320V347Q254 369 252 382T240 409T211 431L97 450L96 465Q95 480 95 481",
  50: "307 335Q307 374 283 397T224 421Q187 421 112 387Q105 384 100 382T95 381Q90 387 86 394L77 407L86 413Q219 491 298 491Q370 491 399 460T428 388Q428 373 424 358T409 326T391 297T363 264T335 235T301 202T269 171L199 104Q194 99 205 97Q209 96 214 96Q527 105 544 105Q553 107 563 102Q563 100 557 79T545 34T537 2H377Q338 2 247 2T130 4H44V26L104 77Q185 145 212 172T267 235Q307 291 307 335",
  51: "102 402L108 408Q115 413 122 418T141 431T165 447T194 461T227 474T263 483T302 487H307Q413 487 452 420Q465 400 465 371Q465 334 445 303T396 253T347 225T317 213Q314 213 314 211Q316 209 316 205Q317 201 320 201Q337 201 359 198T411 184T465 156T506 109T523 39Q523 -62 436 -127T229 -193Q179 -193 130 -178T56 -150T31 -133Q31 -132 41 -122L52 -112L63 -117Q128 -148 201 -148Q282 -148 331 -104T381 20Q381 71 363 100T304 145Q243 166 149 166H137V204H146Q179 204 211 210T275 229T326 268T346 329Q346 372 314 401Q292 423 245 423Q188 423 125 383L102 402",
  52: "346 -196Q344 -196 335 -187L336 -148Q337 -127 337 -55V0H13V29L187 253Q362 477 362 479L368 480Q375 481 387 483T411 487T434 491T452 494L459 495Q460 495 470 482V453Q470 389 466 230T461 62Q461 61 513 61T565 60L555 29L546 -1H461V-15Q461 -48 463 -100T465 -154L457 -157Q449 -160 434 -165T405 -175Q347 -196 346 -196ZM339 265V341Q339 362 335 362Q327 362 219 217T110 65V61H337V117Q338 133 338 187T339 265",
  53: "232 192Q176 192 122 152L95 162V481H306Q516 481 516 479Q514 477 501 433L486 389L319 388H152V386V382Q152 379 152 374T151 365Q147 329 146 260V218H149Q211 242 284 242Q353 242 402 224T474 176T508 117T518 55Q518 -62 432 -126T220 -190Q184 -190 151 -185T96 -172T57 -157T31 -145T20 -139T19 -138Q19 -136 27 -125L35 -112L51 -120Q114 -152 174 -152Q257 -152 314 -100T371 46Q371 107 340 149T232 192",
  54: "48 251Q48 330 76 403T150 529T253 623T370 683T485 704Q494 704 520 701T547 695Q547 692 542 659T536 625Q531 624 524 624L512 623L502 628Q489 635 468 640Q452 645 423 645Q403 645 379 640T320 617T255 568T201 481T171 348Q170 341 170 330V325L183 333Q275 385 357 385H361Q464 385 514 312Q546 267 546 217Q546 127 457 58T262 -12Q225 -12 189 3T120 49T68 132T48 251ZM448 165Q448 228 406 274T289 320Q264 320 236 312T190 295T173 284Q173 266 176 241T189 178T214 112T259 61T326 39Q372 39 410 75T448 165",
  55: "57 376L87 479H591V455L584 446Q544 399 491 328T349 117T185 -169L171 -196H159Q152 -197 102 -197Q58 -197 58 -196T56 -185L54 -175L299 158L443 359Q446 367 444 370H254L71 365L57 376",
  56: "88 533Q88 573 120 610T194 668T268 701T307 714Q324 714 352 711T422 695T486 659Q518 625 518 585Q518 536 479 489T384 406L371 398L385 390Q387 389 400 382T420 370T442 356T466 339T489 319T510 295T526 269T538 238T542 204Q542 125 463 60T256 -5Q145 -5 92 52Q45 97 45 165Q45 204 64 237T109 290T163 324T209 345T228 353L214 364Q199 375 179 392T138 431T103 480T88 533ZM405 557Q405 568 402 581T387 612T350 644T286 663Q283 663 280 663T274 664H272Q256 664 228 636T199 572Q199 547 238 507Q268 475 320 437L334 427Q345 433 358 443T388 483T405 549V557ZM304 42Q366 42 398 76T431 155Q431 178 420 200T396 238T359 270T321 296T283 318L263 328Q262 328 230 312Q190 290 175 266T160 198Q160 132 202 87T304 42",
  57: "549 220Q549 23 429 -82T105 -195H84V-189Q84 -179 85 -174V-164H93Q184 -156 238 -132T334 -56Q361 -23 376 16T394 78L397 100L363 88Q329 75 291 61T244 45Q237 44 218 44Q154 44 94 97Q29 152 29 240Q29 350 108 404Q145 429 257 480Q270 487 279 487Q403 487 470 421Q549 347 549 220ZM408 217Q408 276 390 320T346 385T297 415T259 424Q218 424 185 393T151 286Q151 216 213 154Q252 115 321 115Q368 115 388 134T408 217",
  58: "57 398Q57 419 72 438T117 457Q154 457 174 439T194 398Q194 379 176 361T119 343Q85 343 71 362T57 398ZM62 19T62 43T77 85T115 104Q153 104 175 86T197 42Q197 14 171 1T119 -12Q96 -12 79 3",
  59: "56 399Q56 424 73 440T104 456Q114 458 120 458Q149 458 170 440T192 399Q192 380 174 362T120 344Q85 344 71 362T56 399ZM78 53Q78 67 84 76T90 86Q90 88 98 92T116 98Q117 98 121 98T128 99Q152 97 181 58T211 -24Q211 -77 128 -165Q124 -170 121 -173T116 -178T113 -181T110 -185T106 -190L97 -184L88 -177L95 -168Q143 -104 143 -65Q143 -51 137 -40T113 -7T81 35Q78 41 78 53",
  61: "559 342L549 304H22L27 319Q29 328 30 333T33 343H296Q559 343 559 342ZM559 206L549 168H22L27 183Q29 192 30 197T33 207H296Q559 207 559 206",
  63: "121 590Q121 575 128 562T144 542T152 533T115 512L78 491Q55 499 47 516Q40 530 40 553Q40 601 77 632Q155 697 257 697H268Q316 697 355 679Q422 646 422 576Q422 518 388 476Q383 468 376 461T358 444T340 428T316 410T290 390L230 344Q180 307 180 275Q180 261 187 248T202 227L209 219Q209 215 176 193L142 170Q114 177 100 194T84 226V239Q84 259 93 276T113 302T150 331T192 362Q203 370 219 382T247 403T267 422Q312 471 312 546Q312 593 282 623T207 653Q170 653 146 636T121 590ZM95 23T95 49T117 94T173 113Q204 113 223 96T242 54Q242 27 221 7T167 -14Q136 -14 116 4",
  91: "226 711T225 711T86 699V-93H89Q94 -93 157 -96T223 -100H226V-119H223Q134 -119 42 -130H36V740H42Q61 738 156 736H226V723Q226 711 225 711",
  93: "69 732Q116 733 146 734T184 736T197 737T206 738H208V-132Q190 -129 160 -127T99 -125T66 -124H14V-103H19Q20 -103 84 -98T152 -92H158V699H151Q148 700 85 703T18 708H14V732H69",
  94: "1 463T1 464T148 599T296 734Q584 486 584 485L561 472Q538 459 537 461Q296 672 293 672L161 563Q133 539 97 509T44 466L28 452Q27 452 14 457",
  8216: "187 456Q187 437 169 424T138 411Q114 411 84 454T53 538Q53 565 75 597Q109 648 155 697L166 708L181 694L173 681Q124 610 124 577Q124 549 155 511T187 456",
  8217: "125 524Q125 545 92 588T58 651Q58 661 61 667Q65 674 80 683T107 692Q131 692 162 645T193 564Q193 540 176 509T144 460T87 394L78 400L68 406L79 421Q125 489 125 524",
  8260: "272 270Q503 721 506 721L509 720Q512 720 518 719T529 717L550 713L91 -181L66 -182Q41 -182 41 -181L272 270",
  58113: "388 427Q320 485 242 524T128 563H116Q95 563 87 561L77 559Q72 563 69 566T65 570T65 572L75 576Q106 592 154 611T212 630Q230 630 262 622T358 581T492 498L508 486Q512 463 512 396Q512 246 469 112L465 102Q453 94 341 25Q252 -27 247 -27Q243 -27 174 24T97 84Q90 100 90 214Q90 285 98 345Q100 360 102 363T118 377Q175 422 262 465Q264 463 270 460L277 456Q277 455 267 447T244 428T228 414Q206 382 206 269Q206 187 214 164T259 110Q286 89 342 58Q391 131 391 313Q391 355 388 412V427",
  58114: "39 362L37 366L38 368L82 405H133V474Q135 563 143 589T198 658Q210 669 224 676T247 687L255 690H253Q241 690 253 692Q254 692 256 692T260 693Q263 693 262 691L261 690Q300 690 361 662L373 656L388 666Q404 675 405 675L406 674Q406 672 406 670T406 664L408 655L301 555Q300 555 287 564T254 584T221 597Q190 597 176 583T161 550Q161 525 184 495T232 440T261 405H387V399Q377 389 364 379L340 359H258V315Q258 52 228 -18L172 -120L121 -211H109Q102 -212 96 -212L109 -174Q131 -108 135 -80T139 53V76V157V362H39",
  58115: "41 352Q40 354 39 355T37 358L36 360H37Q48 370 61 380L84 400H108Q131 400 131 402Q121 424 104 501L100 519Q109 560 134 602T196 664Q230 681 271 681Q291 681 316 669T358 644L373 631Q373 630 304 553Q299 548 294 547Q292 547 290 546H287Q286 546 274 562T243 593T205 609Q180 609 165 596T150 562Q150 526 191 488L217 462Q248 431 253 405V400H381L384 394L349 352H251V332Q249 271 231 17L227 -37L120 -217L109 -218Q103 -219 97 -219Q97 -218 101 -206T110 -177T118 -151Q126 -129 128 -120T136 -46T141 127Q141 250 136 340V352H41",
  58116: "107 370Q127 384 172 409T255 454T294 473L306 468Q356 446 425 431L435 429L524 468Q528 465 531 461Q499 395 499 271V263Q499 146 509 71T519 -8Q519 -28 512 -45Q510 -50 435 -123T355 -197Q296 -212 257 -212Q209 -212 164 -196T98 -167T67 -143L133 -44H144Q167 -88 216 -111T320 -134Q371 -134 390 -118T410 -69Q410 -52 404 -12T392 60T385 92L193 -29L158 5Q124 39 110 51L96 63V71Q94 79 94 121Q94 130 94 148T93 174Q93 230 96 275T103 344T107 370ZM221 397Q200 334 200 254Q200 170 210 140Q216 126 234 109T268 81L283 71L383 119V127Q384 132 384 241L385 347L368 349Q325 357 290 369T240 389T221 397",
  58117: "103 453Q103 631 95 661Q95 663 102 667T110 672L114 664Q117 655 123 641T131 621L140 597L154 606Q208 641 275 673L297 684Q300 683 302 682T307 679T310 678L314 676Q283 658 256 625Q238 601 231 579T223 515L224 512L282 548Q339 583 341 583T365 548T386 509Q326 443 318 443L316 446Q314 448 311 452T304 460T294 470T283 480T272 488T260 494T248 497Q231 497 223 474Q220 468 218 440T215 407V401H345L309 360H218V314Q218 181 221 139V129L253 108Q306 73 310 73Q315 73 343 83L373 92L374 87Q375 82 375 79T375 74T360 65T308 36T229 -13L208 -27L192 -13Q149 24 90 61Q89 61 89 62L90 68Q91 73 93 87T97 125T100 191T103 291V360H33V366L34 371L85 405H94L103 404V453",
  58120: "602 575Q505 508 505 489Q505 488 505 482T506 463T507 432Q507 314 456 237L449 226L434 216Q420 208 325 143L316 137Q453 82 488 82Q527 82 585 127L596 136Q597 136 599 126L602 115Q578 85 511 27T428 -31Q400 -31 308 10T170 51Q143 51 123 43T92 24T54 -15L34 6L41 14Q65 41 170 129L188 144L204 145Q254 147 293 164T350 208Q378 249 378 344Q378 422 362 478T320 563T268 605T213 618Q177 618 156 600T134 561Q134 539 162 508T217 446T245 394Q245 368 213 337T85 250L62 262Q73 269 86 279T116 308T133 338T108 378T57 439T32 499Q32 556 117 617T291 679Q350 679 393 658Q415 647 433 631T462 600T480 572T490 550T494 541T499 544T516 556T547 578T603 613T689 662L720 679L730 670Q742 659 756 649T785 629T810 615T836 601T855 590Q855 587 860 536T870 419T875 312Q875 114 800 -25Q794 -35 781 -47Q584 -220 398 -220Q322 -220 278 -190Q253 -173 239 -155L244 -150Q248 -145 255 -138T271 -120T290 -100T310 -80T328 -63T341 -51T349 -46Q350 -46 351 -46T354 -47Q357 -47 357 -52Q359 -68 364 -83T383 -118T424 -151T491 -166Q559 -166 613 -129Q629 -118 641 -108T674 -68T710 1T735 107T746 260Q746 433 727 507Q727 512 685 535T615 570L602 575",
  58121: "351 571Q317 571 247 563T171 555Q153 555 133 563T107 584Q94 605 98 609Q101 615 138 658T190 717H207Q204 710 204 699Q204 673 231 666Q235 665 264 665Q296 665 345 667T426 669Q474 669 501 660T545 626Q553 612 553 594Q553 531 498 474T379 384Q371 379 371 378Q371 376 390 376H411H434Q520 376 602 318Q621 303 627 288T633 234Q633 59 540 -34Q465 -109 348 -130Q308 -137 235 -137Q159 -136 143 -129Q132 -125 132 -118V-53Q118 -24 90 -24Q69 -24 37 -39L27 -44L25 -42Q23 -39 21 -35T17 -30Q17 -28 40 -14T103 19T177 44Q183 45 205 45Q219 45 227 44T245 37T259 20T264 -12Q264 -33 262 -48T259 -80Q259 -93 260 -95Q271 -110 305 -110Q343 -110 383 -86T443 -33Q491 34 491 154Q491 223 467 249Q428 288 334 288H322Q288 288 237 276L222 273L206 286L262 367Q279 369 303 377T358 403T410 452T431 524Q431 531 431 533T427 545T416 558T392 566T351 571"
}, {});
var ki = {}, Ii = {};
Object.defineProperty(Ii, "__esModule", { value: !0 });
Ii.fraktur = void 0;
Ii.fraktur = {
  33: [0.689, 0.012, 0.296],
  34: [0.695, -0.432, 0.215],
  38: [0.698, 0.011, 0.738],
  39: [0.695, -0.436, 0.212],
  40: [0.737, 0.186, 0.389],
  41: [0.735, 0.187, 0.389],
  42: [0.692, -0.449, 0.278],
  43: [0.598, 0.082, 0.756],
  44: [0.107, 0.191, 0.278],
  45: [0.275, -0.236, 0.756],
  46: [0.102, 0.015, 0.278],
  47: [0.721, 0.182, 0.502],
  48: [0.492, 0.013, 0.502],
  49: [0.468, 0, 0.502],
  50: [0.474, 0, 0.502],
  51: [0.473, 0.182, 0.502],
  52: [0.476, 0.191, 0.502],
  53: [0.458, 0.184, 0.502],
  54: [0.7, 0.013, 0.502],
  55: [0.468, 0.181, 0.502],
  56: [0.705, 0.01, 0.502],
  57: [0.469, 0.182, 0.502],
  58: [0.457, 0.012, 0.216],
  59: [0.458, 0.189, 0.216],
  61: [0.368, -0.132, 0.756],
  63: [0.693, 0.011, 0.362],
  91: [0.74, 0.13, 0.278],
  93: [0.738, 0.131, 0.278],
  94: [0.734, -0.452, 0.5],
  8216: [0.708, -0.41, 0.215],
  8217: [0.692, -0.395, 0.215],
  8260: [0.721, 0.182, 0.502],
  58112: [0.683, 0.032, 0.497],
  58113: [0.616, 0.03, 0.498],
  58114: [0.68, 0.215, 0.333],
  58115: [0.679, 0.224, 0.329],
  58116: [0.471, 0.214, 0.503],
  58117: [0.686, 0.02, 0.333],
  58118: [0.577, 0.021, 0.334, { ic: 0.013 }],
  58119: [0.475, 0.022, 0.501, { ic: 0.013 }]
};
Object.defineProperty(ki, "__esModule", { value: !0 });
ki.fraktur = void 0;
var bH = s3, MH = Ii;
ki.fraktur = (0, bH.AddPaths)(MH.fraktur, {
  33: "102 582T102 620T112 673T152 689Q190 689 190 638Q190 605 167 373L148 187L133 184Q102 582 102 620ZM91 24T91 48T107 88T148 104Q171 104 187 87T204 48Q204 22 188 5T149 -12Q124 -12 108 6",
  34: "33 436Q8 603 8 648Q8 663 9 671T19 687T43 695Q63 695 74 681Q76 678 76 650V623L66 532Q57 443 55 436V432H33V436ZM128 666Q128 691 162 691T196 668Q196 634 186 531Q176 441 176 432H166Q155 432 155 434L142 545Q135 603 130 647Q128 664 128 666",
  38: "181 520Q181 604 231 650T328 697L330 698Q333 698 335 698Q336 698 340 698T346 697Q390 697 418 670T446 604Q446 554 414 511Q384 467 300 417L283 406Q281 405 296 374T347 286T425 182Q466 135 469 135Q470 135 473 140T480 152T486 165Q509 210 509 263Q509 282 507 292Q498 317 488 332T465 352T443 359T418 361Q388 361 357 358L346 356L347 374Q347 394 348 396V399H355Q366 396 535 396Q663 396 689 398L703 399Q703 398 702 375T700 351L688 353Q655 356 601 357Q553 357 553 355Q562 332 562 294Q562 280 561 267T555 241T548 218T539 195T529 175T518 156T508 141T497 126L489 115L496 107Q549 54 596 54Q623 54 644 67T677 101T697 140T708 174L710 187Q710 188 710 188L711 190Q714 190 723 187T733 183Q733 179 732 172T726 145T714 107T694 66T665 27T623 0T569 -11Q500 -11 443 41L434 49L425 42Q348 -9 275 -9Q251 -9 233 -6Q187 -1 152 18T98 60T67 111T52 159T49 195Q49 231 60 261T96 315T141 354T197 390L208 397Q181 459 181 520ZM374 577Q374 607 356 629T311 651Q289 651 271 636Q242 614 242 559Q242 533 249 502T262 453T270 435T279 440T298 453T314 464Q374 503 374 577ZM127 217Q127 145 173 89T291 32Q318 32 347 42T393 63T409 75Q384 100 325 184T227 351Q223 366 220 366Q215 366 178 338Q127 298 127 217",
  39: "69 666Q69 680 79 687T104 695Q112 695 117 694T128 684T134 659L104 438Q104 436 96 436T88 438Q88 447 79 540T69 655V666",
  40: "293 737V719Q291 718 285 714T276 708T268 702T258 695T250 686T241 674Q164 570 164 282Q164 -37 230 -119Q273 -171 292 -171Q293 -171 293 -179V-186H289Q270 -180 259 -175Q175 -132 145 -23T114 275Q114 491 157 598T293 737",
  41: "223 259Q223 386 212 474T178 609T136 677T89 714V735Q121 726 139 713Q276 622 276 273Q276 98 246 -23Q225 -106 189 -139T89 -187V-170L101 -165Q148 -146 172 -110T210 13T223 259",
  42: "118 573Q118 575 76 602L34 629L50 647L55 652L66 642Q76 633 91 620T117 598L128 590Q128 663 125 687V692H151V689V687Q151 685 151 683T150 678T150 672Q145 628 144 605V592L219 652L232 634Q232 632 220 624Q195 610 155 582L146 575L158 567Q178 552 197 540T225 523T233 516Q233 515 226 506T217 495L152 549L143 555V530Q144 509 145 492T148 466T149 454Q149 449 142 449H125V462Q128 522 128 549V562L115 552Q88 531 59 506L45 495Q44 495 39 505T34 516L118 573",
  43: "357 584L399 598V282H709L702 263L696 243H399V-64L379 -73L358 -82Q357 -82 357 81V243H47L51 253Q52 256 54 263T58 272L62 282H357V584",
  44: "99 62Q99 82 114 94T144 107Q159 107 178 77T205 26Q213 5 213 -23Q213 -49 207 -65T181 -113Q128 -189 122 -191Q121 -191 116 -184T111 -174Q111 -173 122 -155T145 -111T156 -62Q156 -44 152 -34T127 4L104 37Q99 49 99 62",
  45: "46 236L62 274Q62 275 384 275H706L699 255L693 236H46",
  46: "87 43Q87 69 104 85T142 102Q164 102 182 86T200 44Q200 20 183 3T141 -15Q118 -15 103 2T87 43",
  47: "230 270Q426 721 428 721Q437 719 447 717L466 713L448 672Q78 -180 77 -181Q77 -182 55 -182L34 -181L230 270",
  48: "212 -13Q184 -13 156 -2T101 32T59 97T42 195Q42 311 132 396Q170 433 211 462T262 492Q272 492 301 477T366 434T429 360T456 258Q456 161 378 74T212 -13ZM381 209Q381 257 365 295T328 355T282 390T243 408T223 413Q220 413 204 403T167 376T137 341Q119 305 119 250Q119 168 159 114T263 59Q308 59 344 93T381 209",
  49: "123 459Q145 459 170 460T217 462T256 464T284 466L295 467Q296 467 296 467T297 468Q299 468 302 466T307 462L309 459Q307 454 304 424T299 341T297 235Q297 139 298 101T302 55T313 44Q316 43 367 43L460 46Q460 35 459 22V-1H450Q402 2 281 6Q222 6 171 4T91 1T56 -1L47 -2V43H121H170Q195 43 201 45T209 56Q212 69 212 214Q212 333 209 365T194 409Q183 417 161 423T121 430L104 432Q103 432 103 446V459H123",
  50: "104 384Q115 394 133 409T199 449T281 474Q321 474 351 447T385 378Q385 328 333 255T228 127T176 72Q176 67 183 65Q184 65 203 65T260 67T331 69L475 73L484 67Q484 64 472 33L460 1H60V17L107 61Q210 159 249 208Q309 283 309 331Q309 363 285 389T228 415Q212 415 184 403T134 379L114 367L104 384",
  51: "305 328Q305 372 279 396T214 421H211Q172 421 128 384L107 398L116 405Q151 437 191 455T251 473H260Q314 473 341 455T382 394Q384 386 384 367T382 338Q362 263 271 217L256 210L257 206L259 202Q260 202 272 201T296 198T324 192T355 179T384 157T410 123T427 75Q429 64 429 41Q429 -59 353 -120T183 -182L88 -164Q81 -162 69 -157T48 -147T39 -141Q39 -139 46 -127L53 -114L69 -122Q129 -149 171 -149Q218 -149 253 -131T305 -83T330 -26T338 29Q338 41 336 55T328 89T308 127T273 153Q228 171 162 171Q158 171 152 171T142 170H127V204H134Q232 214 275 257Q305 292 305 328",
  52: "299 -179Q306 -156 306 -48V0H11V7Q10 10 10 18Q10 23 154 236L298 449Q298 450 339 463L379 476Q385 473 384 470V466Q384 463 384 457T384 444T383 427T383 408Q381 328 381 248Q381 46 384 40H387Q422 40 460 44Q465 44 470 44T478 44L481 45Q481 43 478 24T473 1Q473 -1 464 -1Q462 -1 451 -1T430 0H387V-76L389 -156V-161L311 -191Q299 -181 299 -179ZM299 364H287L277 352Q234 297 186 224T112 104T79 43Q79 42 192 42H306V115Q306 300 299 359V364",
  53: "334 25Q334 99 296 134T207 169Q154 169 107 123L98 114L89 120L80 125V458H420Q420 456 409 418L397 379Q397 378 264 378H131Q130 377 128 376T125 374T124 371T122 368T122 363T121 356T121 345V279V190L130 186L140 190Q196 214 260 214Q311 214 348 197T404 153T431 99T440 42T433 -16T406 -76T356 -130T276 -169T163 -184H156Q110 -184 57 -163L47 -159L53 -147L58 -134Q61 -134 74 -139T110 -148T156 -153Q206 -153 243 -135T299 -87T326 -30T334 25",
  54: "45 240Q45 328 73 406T143 536T235 626T327 681T399 699Q400 699 404 699T411 700Q424 700 441 696T459 689Q459 671 451 637Q451 633 447 632L444 629L434 633Q413 640 384 640H377Q299 640 222 565Q182 531 156 463T129 315V306H136L149 315Q229 376 316 376H318Q393 376 432 326T471 213Q471 129 402 58T237 -13T93 59T45 240ZM391 172Q391 231 354 272T258 314Q230 314 200 302T154 279T133 262L134 249Q154 32 266 32Q315 32 353 64T391 172",
  55: "395 377L391 382H225Q59 382 59 383L74 423Q89 464 89 465Q90 468 94 468Q146 460 350 458H498V442L473 406Q241 75 125 -156L113 -181H40L37 -168L57 -140Q115 -58 199 70T339 287T395 377",
  56: "220 -10Q168 -10 131 6T75 50T48 103T40 157Q40 223 77 266Q103 295 156 328T225 375Q247 393 247 394L206 361Q205 361 193 368T164 391T131 426T102 474T90 531Q90 580 114 615Q146 660 238 698L254 705L262 704Q288 704 332 693T402 656Q434 620 434 568Q434 518 401 475T321 402L305 391L336 368Q339 366 353 356T372 343T389 330T406 316T420 301T434 283T445 265T454 244T458 222T461 195Q461 106 389 48T220 -10ZM350 545Q350 578 337 601T304 634T266 649T234 653L224 654L204 639Q196 634 191 629T182 621T176 614T173 609T170 603T168 597Q165 585 165 567Q165 497 261 424L273 415Q350 467 350 545ZM261 405L263 407Q262 407 261 405ZM258 403Q257 403 255 401L254 399L256 400Q258 402 258 403ZM252 398Q251 398 249 396L248 394L250 395Q252 397 252 398ZM245 36Q276 36 300 45T338 69T360 102T371 136T374 168Q374 211 341 255Q324 275 305 289T235 332Q231 330 215 321T193 307T173 292T153 271T138 247T127 216T123 177Q123 146 132 117T170 62T245 36",
  57: "353 93T352 93T320 79T251 49T201 34Q127 37 87 79Q28 138 28 234Q28 273 37 304T60 355T101 396T152 429T218 462L234 469H243Q348 461 395 417Q466 348 466 201Q466 72 397 -29T211 -163Q155 -179 91 -182H72V-154H80Q144 -154 202 -131T297 -60Q318 -31 333 7T352 68L357 92Q353 93 352 93ZM369 208Q369 240 362 272T339 339T290 394T214 415Q171 415 144 372T116 266Q116 193 154 144T238 95H249Q369 95 369 208",
  58: "50 377T50 400T64 440T99 457Q128 457 146 440T165 399Q165 375 146 359T102 342T64 359ZM53 19T53 43T66 86T103 105Q129 105 148 87T168 41Q168 17 147 3T102 -12Q80 -12 67 3",
  59: "47 399Q47 424 62 441T101 458T143 442T162 400T144 359T101 343Q78 343 63 360T47 399ZM76 86Q76 88 80 91T91 96T106 99Q119 99 131 86Q179 35 179 -25Q179 -64 146 -115T89 -189Q86 -187 83 -185T79 -182T76 -180T75 -177T77 -173T80 -168Q121 -108 121 -64Q121 -44 94 -5T66 52Q66 66 71 75T76 86",
  61: "725 366Q724 365 721 349T716 331V329H385Q54 329 54 331Q55 332 59 349T63 368H394Q725 368 725 366ZM725 169Q724 168 721 152T716 134V132H385Q54 132 54 134Q55 135 59 152T63 171H394Q725 171 725 169",
  63: "46 557Q46 613 103 653T227 693Q287 693 322 659T357 564Q357 517 326 469T259 390T191 326T160 272Q160 240 187 221Q193 217 193 216Q182 209 170 200L147 184Q127 192 113 209T98 250Q98 290 193 376Q287 454 287 542Q287 581 262 616T188 652Q143 652 126 631T108 588Q108 559 140 527L79 490Q46 515 46 557ZM108 47Q108 68 123 85T160 103Q179 103 198 90T217 46Q215 24 201 7T164 -11Q142 -11 125 6T108 47",
  91: "262 -119Q224 -120 191 -123T141 -128T118 -130Q117 -130 117 305V740H122Q141 737 219 736H278V723Q278 711 277 711L159 699V-93H162Q167 -93 220 -96T276 -100Q278 -100 278 -109V-119H262",
  93: "64 733Q89 733 110 734T143 737T158 738H160V-131H154Q101 -125 40 -124H-4V-103H1Q3 -102 57 -98T113 -92H118V700L64 703Q7 707 3 708H-4V732H21Q34 733 64 733",
  94: "0 464L250 734L262 722Q274 712 384 598L495 486Q483 478 467 467L456 459L248 672L154 580L23 452Q17 454 10 458T0 464",
  8216: "117 410Q97 410 71 455T45 539Q45 588 129 694L140 708Q142 708 153 694L147 682Q106 609 106 582V577V571Q106 548 132 511T158 455Q158 434 143 422T117 410",
  8217: "105 529Q105 546 77 588T49 651Q49 658 51 666Q53 672 67 682T92 692Q111 692 137 644T163 563Q163 534 143 497T99 428T74 395Q72 395 65 400T58 407Q105 476 105 523V529",
  8260: "230 270Q426 721 428 721Q437 719 447 717L466 713L448 672Q78 -180 77 -181Q77 -182 55 -182L34 -181L230 270",
  58112: "427 436Q427 434 427 425T429 398T430 362Q430 222 396 109L393 99L305 33Q218 -32 216 -32Q208 -29 142 22L91 68L78 81L77 94Q75 130 75 173Q75 245 87 347L135 385Q178 418 184 424L177 428Q174 429 170 431Q116 454 96 473T75 534Q79 608 154 683Q164 677 164 673Q164 670 157 662T144 637T137 598Q137 552 182 518T280 470T380 447T427 436ZM342 371L275 394L208 417Q203 417 192 399T168 334T156 229Q153 187 153 157Q153 141 156 135Q158 125 208 88T280 51Q306 51 326 120T346 297Q346 339 344 354T342 371",
  58113: "39 551L35 569L52 577Q72 586 98 595T140 610T158 616Q174 612 200 604T293 560T412 477Q414 475 417 472Q428 462 430 450T432 376Q432 223 401 124Q395 106 393 103T382 92Q351 68 281 20T206 -29Q201 -31 137 26L100 60L78 83L77 112Q76 132 76 170Q76 259 86 342L88 360L101 371Q116 386 163 422T215 459Q216 459 224 455T233 450L229 446Q225 442 218 434T203 419Q179 394 175 389T168 372Q156 334 156 262Q156 167 164 137Q168 125 196 102T252 62L278 45Q279 45 285 52T302 78T322 126T339 205T346 316Q346 367 344 389L343 406L326 423Q228 520 113 559L100 564L70 557L39 551",
  58114: "123 386L120 431Q116 476 116 511V520Q116 593 174 649Q207 680 236 680Q258 680 284 664T312 648Q318 648 327 656Q328 657 330 659Q337 664 337 661Q337 660 338 657Q338 652 339 648L268 566L260 574Q234 600 206 600Q182 600 164 585T145 541Q145 492 211 386L267 385H324L299 354H214V312Q214 86 193 -58L192 -69L116 -215H108Q92 -215 92 -212Q93 -211 100 -189T116 -135T128 -80Q134 -41 134 22Q134 54 130 185T125 349V354H29L59 385H91Q123 385 123 386",
  58115: "91 530Q91 564 116 600T164 656T194 678Q195 678 200 678T209 679Q268 679 316 639L293 593Q267 547 263 546H262Q260 546 256 553Q222 613 180 613Q160 613 146 599T132 564T170 474T210 388H318L296 356H206V322Q204 284 204 255Q202 221 202 161V99Q202 28 194 -22T160 -124Q148 -146 116 -199L101 -224L91 -220Q85 -218 84 -217T83 -215L101 -161Q116 -114 119 -73T122 108Q119 334 117 352V356H72L28 357L66 388H92Q118 388 118 389L109 433Q91 514 91 530",
  58116: "254 -150Q293 -150 328 -126T363 -54Q363 -38 352 29T339 98L250 34Q160 -30 159 -30L77 64V71Q74 95 74 174Q74 212 75 243T79 294T83 328T87 352T90 366L117 384Q206 446 238 464L250 471Q277 455 306 443T350 427L365 423Q367 423 405 443T443 465L449 455Q431 414 426 362T418 201Q418 135 420 121Q438 -4 438 -19Q438 -26 438 -31T434 -42T429 -51T420 -63T408 -77T391 -95T370 -119T346 -147T325 -170T309 -187T291 -200T274 -207T252 -213T225 -214Q175 -214 132 -196T70 -160L52 -143Q52 -138 90 -48Q90 -47 95 -47H101Q108 -81 146 -115T254 -150ZM341 136Q341 157 344 242T347 348V355L334 356Q299 359 262 367T203 383T179 391Q177 391 173 377T163 323T158 227Q158 164 161 128V121L174 106Q203 75 223 59L341 127V136",
  58117: "92 446Q92 603 82 664Q94 670 95 670L96 666Q98 661 101 651T108 633Q121 598 121 597L141 612Q247 686 250 686Q251 686 266 679Q261 674 243 659T213 632T190 597T173 546Q172 541 171 530T170 511T170 502Q171 502 222 542L273 582Q308 522 315 504L279 449L269 462Q231 506 215 506Q202 506 190 490Q164 458 164 395V390H279L266 373L254 355H167V306Q169 252 169 217Q170 195 170 147V117L200 92Q234 64 237 64Q243 64 277 81L311 99V75Q310 75 242 27L174 -20L156 -3Q88 60 81 60L79 62Q80 60 82 62Q87 67 87 290V355H57L26 356L73 390H92V446",
  58118: "117 531Q117 533 137 544T178 566L198 577Q200 577 204 575T208 572V570Q208 568 208 566T207 560Q197 496 197 397V392H321L295 353H199V260Q199 157 200 145V122L269 68Q271 67 274 67Q282 67 310 83T342 100Q343 100 345 92T346 83L211 -21L172 12Q117 59 117 63Q117 65 117 87T119 150T120 238V353H75L29 354L65 391H118V460Q117 498 117 531",
  58119: "337 91V78L324 71Q288 53 256 29T206 -8T180 -22Q174 -22 158 -9Q82 46 60 46H59L63 51Q67 56 73 68T85 96Q101 158 101 254Q101 300 95 330T83 370T66 394L53 388Q48 385 41 382T24 374Q22 376 20 378T16 381T13 383T10 385V386L119 475Q150 439 160 430L171 422V409Q173 377 173 300Q173 228 166 183T152 122T145 102Q207 81 242 58L337 104V111Q340 146 340 227Q340 320 339 351T338 408V423L422 469Q425 465 429 462L426 438Q413 354 413 251Q413 152 423 119Q426 110 435 96T452 82Q454 82 509 103Q514 98 514 89Q514 87 507 81T472 51T409 -7L395 -20Q393 -18 390 -17Q386 -14 382 -6Q380 -2 379 1Q369 24 361 40T348 62T341 73T338 84L337 91"
}, {});
var Ri = {}, Ni = {};
Object.defineProperty(Ni, "__esModule", { value: !0 });
Ni.italic = void 0;
Ni.italic = {
  33: [0.716, 0, 0.307, { ic: 0.073 }],
  34: [0.694, -0.379, 0.514, { ic: 0.024 }],
  35: [0.694, 0.194, 0.818, { ic: 0.01 }],
  37: [0.75, 0.056, 0.818, { ic: 0.029 }],
  38: [0.716, 0.022, 0.767, { ic: 0.035 }],
  39: [0.694, -0.379, 0.307, { ic: 0.07 }],
  40: [0.75, 0.25, 0.409, { ic: 0.108 }],
  41: [0.75, 0.25, 0.409],
  42: [0.75, -0.32, 0.511, { ic: 0.073 }],
  43: [0.557, 0.057, 0.767],
  44: [0.121, 0.194, 0.307],
  45: [0.251, -0.18, 0.358],
  46: [0.121, 0, 0.307],
  47: [0.716, 0.215, 0.778],
  48: [0.665, 0.021, 0.511, { ic: 0.051 }],
  49: [0.666, 0, 0.511],
  50: [0.666, 0.022, 0.511, { ic: 0.04 }],
  51: [0.666, 0.022, 0.511, { ic: 0.051 }],
  52: [0.666, 0.194, 0.511],
  53: [0.666, 0.022, 0.511, { ic: 0.056 }],
  54: [0.665, 0.022, 0.511, { ic: 0.054 }],
  55: [0.666, 0.022, 0.511, { ic: 0.123 }],
  56: [0.666, 0.021, 0.511, { ic: 0.042 }],
  57: [0.666, 0.022, 0.511, { ic: 0.042 }],
  58: [0.431, 0, 0.307],
  59: [0.431, 0.194, 0.307],
  61: [0.367, -0.133, 0.767],
  63: [0.716, 0, 0.511, { ic: 0.04 }],
  64: [0.705, 0.011, 0.767, { ic: 0.022 }],
  91: [0.75, 0.25, 0.307, { ic: 0.139 }],
  93: [0.75, 0.25, 0.307, { ic: 0.052 }],
  94: [0.694, -0.527, 0.511, { ic: 0.017 }],
  95: [-0.025, 0.062, 0.511, { ic: 0.043 }],
  126: [0.318, -0.208, 0.511, { ic: 0.06 }],
  305: [0.441, 0.01, 0.307, { ic: 0.033 }],
  567: [0.442, 0.204, 0.332],
  768: [0.697, -0.5, 0],
  769: [0.697, -0.5, 0, { ic: 0.039 }],
  770: [0.694, -0.527, 0, { ic: 0.017 }],
  771: [0.668, -0.558, 0, { ic: 0.06 }],
  772: [0.589, -0.544, 0, { ic: 0.054 }],
  774: [0.694, -0.515, 0, { ic: 0.062 }],
  775: [0.669, -0.548, 0],
  776: [0.669, -0.554, 0, { ic: 0.045 }],
  778: [0.716, -0.542, 0],
  779: [0.697, -0.503, 0, { ic: 0.065 }],
  780: [0.638, -0.502, 0, { ic: 0.029 }],
  989: [0.605, 0.085, 0.778],
  8211: [0.285, -0.248, 0.511, { ic: 0.043 }],
  8212: [0.285, -0.248, 1.022, { ic: 0.016 }],
  8213: [0.285, -0.248, 1.022, { ic: 0.016 }],
  8215: [-0.025, 0.062, 0.511, { ic: 0.043 }],
  8216: [0.694, -0.379, 0.307, { ic: 0.055 }],
  8217: [0.694, -0.379, 0.307, { ic: 0.07 }],
  8220: [0.694, -0.379, 0.514, { ic: 0.092 }],
  8221: [0.694, -0.379, 0.514, { ic: 0.024 }],
  8260: [0.716, 0.215, 0.778],
  8463: [0.695, 0.013, 0.54, { ic: 0.022 }],
  8710: [0.716, 0, 0.833, { sk: 0.167 }],
  10744: [0.716, 0.215, 0.778]
};
Object.defineProperty(Ri, "__esModule", { value: !0 });
Ri.italic = void 0;
var wH = s3, SH = Ni;
Ri.italic = (0, wH.AddPaths)(SH.italic, {
  33: "330 716Q351 716 365 703T380 670V659L304 433Q230 207 227 204Q225 198 205 198Q184 198 184 207T220 439T260 669Q270 694 297 708Q300 709 304 710T311 713T316 714Q324 716 330 716ZM107 51Q110 83 133 102T179 121Q207 121 219 105T231 72Q231 45 209 23T156 0Q138 0 123 11T107 51",
  34: "214 620Q214 647 236 670T289 694Q312 694 326 677T341 633V624Q341 588 327 550T294 482T253 428T216 392T196 379Q191 379 184 388T176 401Q176 404 195 421T243 472T287 547Q299 576 299 582L295 580Q291 578 282 576T264 573Q241 573 228 585T214 620ZM411 620Q411 647 433 670T486 694Q509 694 523 677T538 633V624Q538 588 524 550T491 482T450 428T413 392T393 379Q388 379 381 388T373 401Q373 404 392 421T440 472T484 547Q496 576 496 582L492 580Q488 578 479 576T461 573Q438 573 425 585T411 620",
  35: "281 327H228Q186 327 175 330T164 347Q164 359 176 365Q179 367 292 367H404L563 688Q569 694 578 694T593 686T597 670Q597 667 531 535L448 367H614L773 688Q779 694 787 694Q796 694 802 688T808 674V672L807 670Q807 667 732 517L658 368L736 367H814Q828 357 828 347Q828 336 812 327H637L599 250Q561 174 561 173H662H724Q760 173 769 170T779 153T770 136T729 132Q721 132 696 132T651 133H540L380 -188Q374 -194 366 -194Q357 -194 351 -188T345 -174L346 -172V-170Q346 -167 412 -35L495 133H330L170 -188Q164 -194 156 -194Q147 -194 141 -188T135 -174L136 -172V-170Q136 -167 211 -17L285 133H207L130 134Q115 140 115 153Q115 164 131 173H306L344 250Q382 326 382 327H281ZM592 327H427L389 250Q351 174 351 173H516L554 250Q592 326 592 327",
  37: "301 348Q257 348 231 383T205 480Q205 553 244 629T346 736Q370 750 394 750Q416 750 429 742T458 714Q512 644 606 644Q722 644 802 732Q817 750 827 750Q835 750 841 744T847 730Q847 725 827 700T689 540Q586 421 512 335Q180 -50 176 -52Q172 -56 165 -56Q157 -56 151 -50T145 -35Q145 -29 162 -9T330 186Q392 258 430 302Q711 627 711 628L701 624Q652 607 604 607Q551 607 494 634L479 642V624Q479 544 439 467Q414 416 377 382T301 348ZM270 443Q270 385 303 385H306H308Q326 385 348 407Q384 441 409 504T434 627Q434 713 390 713Q358 713 328 663Q307 631 289 556T270 451V443ZM608 -56Q573 -56 543 -23T513 76Q513 129 536 190T604 296L627 318Q670 347 704 347Q747 347 767 310T788 222Q788 126 732 35T608 -56ZM742 222Q742 310 699 310Q677 310 655 285T620 227Q608 197 593 138T578 42V36Q578 -18 613 -18Q657 -18 699 64T742 222",
  38: "209 444Q209 546 278 631T424 716Q473 716 501 683T530 601Q530 554 511 535T467 515Q446 515 437 527T427 553Q427 578 446 594T481 610H483V617Q480 641 464 660T419 679Q367 679 328 603Q316 578 305 538T288 470L282 443L295 449Q308 455 330 462T371 469Q397 469 413 450T430 404Q430 363 400 329T331 295Q291 295 256 322Q255 322 246 293T227 223T217 158Q217 117 232 88T273 43T327 22T387 15Q457 15 512 37T599 93T652 169T680 248T688 317T678 380T659 423T647 437Q643 435 637 431T613 416T581 392T554 364T538 332Q540 310 541 310Q554 335 587 335Q601 335 613 327T626 300Q626 290 622 279T603 255T563 242Q532 245 512 263T491 320Q494 351 511 377T547 418T600 456T652 494Q676 512 697 539T728 582T738 601Q738 602 736 602Q732 602 726 604T714 616T707 638Q707 661 724 677T764 694Q799 694 802 660Q802 625 767 562T688 467L694 458Q700 449 702 444T711 428T720 408T727 385T733 358T735 327Q735 281 724 235T685 141T617 59T515 1T375 -22Q270 -22 199 34T127 181Q127 216 147 270T207 374L216 386Q209 421 209 444ZM386 412Q386 432 366 432Q345 432 325 418T294 390T284 375Q284 371 289 362T306 343T335 332Q355 332 367 350T383 384T386 412",
  39: "250 620Q250 647 272 670T325 694Q348 694 362 677T377 633V624Q377 566 343 506T275 412T231 379Q226 379 220 388T213 401T232 421T279 472T323 547Q335 573 335 582L331 580Q327 578 318 576T300 573Q277 573 264 585T250 620",
  40: "241 -250Q203 -212 174 -140T144 39Q144 158 180 288T296 544T481 746L487 750H499Q517 750 517 740Q517 736 495 716Q399 630 331 491T236 228T208 3Q208 -73 224 -130T255 -214T271 -244Q271 -250 252 -250H241",
  41: "326 497Q326 546 320 588T304 655T285 699T269 728T262 740Q262 746 267 749L272 750Q276 750 281 750H293Q331 712 360 640T390 461Q390 332 339 171T188 -116Q161 -150 121 -188T47 -250H35Q17 -250 17 -240Q17 -236 39 -216Q135 -130 203 9T298 272T326 497",
  42: "560 658Q569 658 576 649T584 631Q584 625 583 620T577 611T569 603T556 595T540 587T519 578T494 566L428 536Q427 535 433 531T479 502Q525 475 532 469T539 450Q538 435 525 424T497 412Q489 412 482 418T442 456Q400 497 400 494L387 420Q376 353 373 343T352 323Q345 320 336 320H331Q322 320 316 327T309 343Q309 347 334 420L359 496Q358 496 297 456T234 414Q228 411 221 411Q212 411 204 417T195 439Q198 458 209 465T283 502L353 534L300 566Q255 593 247 599T239 616Q239 631 252 644T282 658Q290 658 295 654T335 615L378 573L391 647Q393 657 395 671T398 691T400 706T404 720T408 730T414 739T423 744T434 749Q435 749 439 749T445 750Q467 748 469 728Q469 723 457 685T432 610L420 573L481 613Q548 658 560 658",
  43: "139 237T139 250T151 266T198 270H293H431L465 407Q469 424 476 452Q494 528 500 542T519 557Q526 557 532 552T538 538Q538 536 507 409T472 272Q472 270 604 270Q737 270 741 268Q753 261 753 250Q753 237 742 233T696 229Q687 229 655 229T599 230H462L461 226Q461 224 427 91T392 -47Q387 -57 374 -57Q367 -57 361 -51T355 -37Q355 -31 388 99L421 230H288Q267 230 238 230T199 229Q163 229 151 233",
  44: "106 46Q106 68 121 90T167 120Q168 120 173 120T180 121Q232 121 232 59V54Q232 18 219 -20T186 -88T145 -143T109 -181T88 -194Q84 -194 77 -185T69 -171Q69 -168 70 -166T76 -161T85 -154T101 -139T124 -114Q146 -88 162 -58T183 -12T188 7Q187 7 183 5T172 2T156 0Q129 0 118 14T106 46",
  45: "205 180H131Q102 180 93 181T84 190Q90 238 103 251H334Q341 244 341 241Q341 236 336 214T327 186Q325 181 312 181T205 180",
  46: "107 50Q107 76 129 98T181 121Q203 121 217 108T231 72Q231 47 210 24T156 0Q135 0 121 13T107 50",
  47: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215",
  48: "414 665Q562 665 562 490Q562 426 534 318Q451 -21 251 -21Q222 -21 202 -15Q155 2 134 40T110 144Q110 201 127 286T187 470T287 614Q348 665 414 665ZM187 98Q187 59 208 37T260 15Q320 15 365 83Q394 128 440 312T487 547Q487 580 471 600T433 627Q428 628 408 628Q381 628 353 609T311 569Q279 526 239 364T190 143Q187 120 187 98",
  49: "248 491Q228 491 228 502Q228 516 236 532Q237 536 246 537T275 541T314 552Q350 567 382 595T430 644L446 664Q450 666 454 666Q468 666 468 658Q468 647 395 359Q321 63 321 59Q321 52 334 50T388 46H422Q428 37 428 35Q428 19 421 5Q416 0 405 0Q400 0 361 1T263 2Q215 2 185 2T142 1T127 0Q110 0 110 11Q110 13 113 25T118 40Q120 46 146 46Q196 46 212 49T235 61Q238 66 295 295L353 526L340 519Q328 512 302 503T248 491",
  50: "159 404Q159 433 176 476T222 562T297 635T395 666Q466 666 508 617T551 497Q551 473 545 446Q534 388 482 333Q441 292 355 240T264 184Q216 151 179 101L171 91Q171 90 177 90Q206 90 269 77T366 64Q385 64 390 65Q418 73 441 98T475 156Q479 168 481 170T495 173H518Q524 167 524 166T521 152Q502 86 459 32T353 -22Q315 -22 259 15T172 53Q156 53 143 36T126 1L121 -16Q119 -22 98 -22H82Q76 -16 76 -13T80 5T98 50T132 111T189 178T274 242Q327 273 364 305T420 370T447 427T460 483Q466 514 466 538Q466 586 443 607T389 629Q338 629 293 584T226 487T204 399Q204 390 204 386T209 378T222 373Q258 376 282 422T307 493Q307 506 302 517T297 531Q297 537 308 546T327 551Q329 550 333 543T340 523T344 497Q344 450 306 393T216 336Q186 336 173 355T159 396V404",
  51: "296 531Q296 536 307 544T322 553Q330 553 338 534T346 501Q346 468 319 440T258 412Q232 412 216 430T200 478Q200 552 281 618Q345 666 416 666Q489 666 525 625T562 530Q562 473 525 419T430 335L416 329Q479 288 479 206Q479 142 440 89T344 7T229 -22Q173 -22 135 12T96 106Q96 192 157 192Q192 192 197 157Q197 134 184 117T142 96Q153 47 180 29Q201 15 232 15Q249 15 275 22Q307 34 331 57Q363 90 379 153T396 246Q396 261 393 272T384 290T371 301T355 308T341 311T326 312H316H307Q287 312 282 313T276 320Q276 323 279 337T283 352Q284 356 290 357T325 358Q364 359 368 360Q386 365 400 372T433 397T464 448T485 527Q487 535 487 556Q487 629 414 629Q350 629 298 580T245 476Q245 450 263 450H264Q280 450 294 463T308 496Q308 508 302 518T296 531",
  52: "448 34Q453 34 463 22T473 5Q473 -2 457 -7Q417 -22 383 -23H366L350 -91Q348 -98 345 -111T340 -130T335 -146T330 -161T325 -172T318 -182T310 -188T299 -193T286 -194Q256 -194 253 -165Q253 -159 271 -83T292 -5Q231 29 169 29Q114 29 91 14Q72 -2 65 1Q46 20 46 28Q46 35 55 43T77 60T96 74Q306 257 396 623Q410 666 444 666Q459 666 468 657T478 634Q478 627 470 595T440 504T387 381T303 239T187 99L164 75H178Q217 75 260 59L304 43Q304 48 325 127Q342 195 346 207T358 228Q372 242 391 242Q403 242 413 235T423 214Q423 205 402 116T378 25Q378 23 387 23Q405 23 418 25T439 31T448 34",
  53: "196 304Q189 309 189 314Q189 317 231 487T275 660Q278 666 283 666Q287 666 302 658T346 643T413 635Q447 635 481 642T537 658T559 666Q561 666 564 663T567 658Q565 637 557 629Q528 600 474 573T359 545Q342 545 327 546T304 550T294 552L291 540Q288 529 283 507T273 465L251 379Q307 420 364 420Q415 420 456 382T497 261Q497 165 429 82T262 -20Q256 -20 247 -21T233 -22Q176 -22 141 15T106 112Q106 208 173 208Q192 208 203 197T214 169Q214 143 195 125T156 107H153V100Q155 73 174 47T239 21Q245 21 259 23Q355 46 392 200Q393 205 394 207Q412 276 412 312Q412 352 396 367T358 383Q288 383 233 314Q226 306 224 305T209 304H196",
  54: "377 434Q425 434 457 404T499 341T509 278Q509 243 496 194T456 105T383 27Q322 -22 256 -22Q142 -22 122 114Q120 130 120 159Q120 221 135 292T195 452T310 599Q390 665 465 665Q565 665 565 583V574Q565 543 546 524Q528 506 504 506Q491 506 478 514T465 543Q465 585 515 602Q505 626 466 626Q419 626 372 587Q334 557 305 503T266 409L255 370Q287 410 339 429Q361 434 377 434ZM424 333Q424 359 411 378T365 397Q318 397 282 356T230 257T205 157T197 94Q197 67 211 45T260 22Q313 22 341 57T386 151Q424 283 424 333",
  55: "466 519Q448 519 435 528T416 550T400 571T376 581Q324 581 271 540T186 437Q185 435 183 432T181 428T179 426T177 424T174 423T171 422T165 422H159Q141 422 141 423Q136 423 136 431Q136 433 190 548T247 665Q249 666 266 666H282Q288 660 288 657Q288 655 284 646T276 628L273 620Q337 666 390 666Q413 666 425 652T438 620T444 584T457 559Q460 557 470 557Q497 557 524 582T571 635T594 665Q595 666 612 666H628Q634 660 634 657Q634 653 618 629T572 556T510 441T437 269T367 43Q356 -22 304 -22Q291 -22 278 -14T263 14Q263 36 281 95T354 269T486 507Q497 524 495 524Q482 519 466 519",
  56: "209 449Q209 545 278 605T416 666Q482 666 517 631T553 546Q553 513 539 482T504 430T463 394T426 370L410 360L430 343Q471 309 483 278T495 211Q495 141 441 75Q363 -21 253 -21Q182 -21 141 18T99 117Q99 161 119 201T170 268T222 308T259 331L272 338L259 349Q212 389 209 449ZM492 542Q492 586 469 605T415 625Q360 625 320 587T279 505Q279 495 281 487T286 474T295 460T306 449T321 436T337 422Q379 386 380 386Q389 386 420 412T472 471Q492 513 492 542ZM163 118Q163 76 189 49T258 21Q316 21 368 64T420 170Q420 193 412 208T395 233T350 271L302 312Q298 312 284 303T249 276T209 235T177 181T163 118",
  57: "297 211Q258 211 230 228T189 273T169 323T163 367Q163 411 183 472T254 585Q327 656 401 665Q403 665 412 665T427 666Q458 664 481 652T518 622T539 580T550 535T553 491Q553 448 544 395T515 277T454 148T358 37Q282 -22 213 -22Q166 -22 137 -1T107 55V64Q107 88 114 104T134 127T154 136T169 138Q185 138 196 128T207 101Q207 82 196 68T172 48L161 43Q161 40 167 36T187 26T219 21Q286 21 344 99Q364 126 382 169T408 241T417 275L412 269Q406 263 395 253T370 234T337 218T297 211ZM476 552Q476 626 417 626Q368 626 330 584Q312 563 300 533T270 433Q248 341 248 312Q248 286 262 267T310 248Q353 248 387 287T440 380T467 480T476 552",
  58: "184 358Q184 385 206 408T258 431Q279 431 293 418T308 383Q308 354 284 332T233 310Q212 310 198 324T184 358ZM107 50Q107 76 129 98T181 121Q203 121 217 108T231 72Q231 47 210 24T156 0Q135 0 121 13T107 50",
  59: "184 358Q184 385 206 408T258 431Q279 431 293 418T308 383Q308 354 284 332T233 310Q212 310 198 324T184 358ZM107 47Q107 77 130 99T180 121Q226 121 226 61Q226 25 214 -14T182 -84T144 -140T109 -180T88 -194T77 -185T70 -172Q70 -169 84 -155T121 -112T161 -48Q180 -10 180 3Q180 4 174 2Q172 2 166 1T156 0Q135 0 121 13T107 47",
  61: "776 357T776 347T761 327H470Q180 327 176 329Q164 334 164 347Q164 359 176 365Q179 367 470 367H761Q776 357 776 347ZM116 143T116 153T131 173H422Q713 173 717 171Q728 166 728 153T717 135Q713 133 422 133H131Q116 143 116 153",
  63: "235 431Q217 431 206 442T195 468Q195 490 215 537T280 638T380 707Q403 716 423 716Q425 716 429 716T436 715Q485 715 518 681T551 590Q551 543 530 503T482 439Q471 428 400 375T318 310Q300 287 300 259Q300 236 315 236Q333 236 352 251T384 300Q386 306 407 306H423Q429 300 429 297Q429 272 393 235T308 198Q287 198 269 215T251 270Q251 330 293 374L374 436Q377 438 401 456T432 480T457 503T481 531T494 561T501 598Q501 614 499 626Q482 678 430 678H426Q392 678 362 660T311 615T280 571T264 540L259 528Q259 527 266 526T283 516T294 492Q294 466 276 449T235 431ZM209 51Q212 83 235 102T281 121Q309 121 321 105T333 72Q333 45 311 23T258 0Q240 0 225 11T209 51",
  64: "198 250Q198 155 248 91T394 26Q514 26 640 80L650 84H675H683Q709 84 709 76Q709 73 708 71Q706 64 660 45T534 8T383 -11T260 24T181 115Q152 168 152 248Q152 410 268 552Q303 590 324 608Q439 705 551 705Q611 705 658 683T733 623T775 543T789 454Q789 380 766 304T720 192Q677 125 617 125Q591 125 573 137T548 160T541 176Q541 178 540 178L534 173Q527 168 515 160T488 144T454 131T417 125Q361 125 320 166T279 284Q279 393 356 481T523 569Q570 569 603 537Q623 515 632 490L637 480L657 479Q684 479 684 470Q684 465 650 333L617 199V185Q616 162 628 162Q677 162 712 278Q743 381 743 442Q743 555 687 611T553 668Q467 668 385 608T250 450T198 250ZM598 445Q598 453 594 470T569 510T518 532Q463 532 410 448T356 271Q356 220 374 191T423 162Q482 162 552 255L575 348Q598 440 598 445",
  91: "205 -221Q205 -239 194 -250H137H106Q73 -250 73 -242Q73 -232 194 255T321 747L324 750H381H417Q435 750 440 748T446 739Q446 730 443 723T437 712L434 710H350L349 706Q349 704 235 249T120 -208Q120 -210 159 -210Q166 -210 175 -210T187 -209Q205 -209 205 -221",
  93: "227 721Q227 739 238 750H295H326Q359 750 359 742Q359 732 238 245T111 -247L108 -250H51H15Q-3 -250 -8 -248T-14 -239Q-14 -230 -11 -223T-5 -212L-2 -210H82L83 -206Q83 -204 197 251T312 708Q312 710 273 710Q266 710 257 710T245 709Q227 709 227 721",
  94: "528 555Q528 549 514 538T496 527Q491 527 470 554Q458 569 449 580L414 625L353 578Q339 567 323 555T298 536L290 529Q286 527 285 527Q279 527 273 533T264 546L260 553Q260 559 263 562Q265 564 342 628T421 693T425 694Q430 694 433 691Q528 563 528 555",
  95: "98 -62Q91 -58 91 -51Q91 -31 100 -26Q102 -25 324 -25H442H500Q536 -25 545 -27T554 -36Q554 -50 548 -56Q546 -60 538 -61Q520 -62 319 -62H98",
  126: "266 208Q262 208 255 215T247 228Q247 233 250 236T274 259Q335 318 369 318Q394 318 420 292T464 265Q485 265 516 291T550 318Q554 318 562 311T571 297Q570 293 551 273T502 231T451 209H447Q421 209 396 235T355 261Q334 261 301 235T266 208",
  305: "75 287Q75 292 82 313T103 362T142 413T196 441H214Q248 441 270 419T293 357Q292 338 289 330T245 208Q193 72 193 46Q193 26 209 26Q228 26 247 43Q273 71 292 136Q295 148 297 150T311 153H317Q327 153 330 153T337 150T340 143Q340 133 330 105T292 41T228 -8Q220 -10 204 -10Q160 -10 141 15T122 71Q122 98 171 227T221 384Q221 396 218 400T203 405Q175 403 156 374T128 312T116 279Q115 278 97 278H81Q75 284 75 287",
  567: "75 284T75 287T81 305T101 343T133 389T180 426T240 442Q273 440 300 420T327 350V332L278 134Q267 92 253 37T233 -45T225 -73Q208 -123 162 -163T54 -204Q8 -204 -15 -181Q-32 -164 -32 -140Q-32 -112 -14 -96T27 -79Q48 -79 57 -91T67 -114Q67 -146 39 -166L44 -167H59H60Q112 -167 145 -74Q148 -65 198 134T251 347Q252 353 252 370Q252 382 251 388T245 399T230 405Q204 405 175 378Q157 360 145 337T126 298T117 280T98 278H81Q75 284 75 287",
  768: "-222 651Q-222 668 -206 682T-174 697Q-155 697 -145 680Q-140 671 -107 599T-74 526Q-74 522 -88 511T-107 500Q-109 500 -113 502T-167 568T-219 637Q-222 643 -222 651",
  769: "-148 500Q-154 500 -163 511T-173 528Q-173 529 -172 530V532Q-170 534 -97 610T-21 688Q-8 697 4 697Q19 697 29 688T39 663T30 638Q26 631 -50 573L-135 507Q-144 500 -148 500",
  770: "17 555Q17 549 3 538T-15 527Q-20 527 -41 554Q-53 569 -62 580L-97 625L-158 578Q-172 567 -188 555T-212 536L-221 529Q-225 527 -226 527Q-232 527 -238 533T-248 546L-251 553Q-251 559 -248 562Q-246 564 -169 628T-90 693T-86 694Q-81 694 -78 691Q17 563 17 555",
  771: "-245 558Q-249 558 -256 565T-264 578Q-264 583 -261 586T-237 609Q-176 668 -142 668Q-117 668 -91 642T-47 615Q-26 615 5 641T39 668Q43 668 51 661T60 647Q59 643 40 623T-9 581T-60 559H-64Q-90 559 -115 585T-156 611Q-177 611 -210 585T-245 558",
  772: "-275 544Q-282 548 -282 554Q-282 561 -279 573T-271 588Q-269 589 -111 589H-27H12Q38 589 46 587T54 578Q54 574 51 563T47 550Q45 546 32 545Q15 544 -118 544H-275",
  774: "-237 641Q-237 694 -218 694H-213Q-195 694 -195 684Q-195 683 -195 679T-197 667T-198 650Q-198 611 -176 589T-117 566Q-74 566 -34 597T23 678Q27 689 30 691T43 694Q62 694 62 684Q62 671 49 645T14 589T-46 537T-123 515Q-175 515 -206 550T-237 641",
  775: "-165 599Q-162 631 -139 650T-93 669Q-65 669 -53 653T-41 620Q-41 593 -63 571T-116 548Q-134 548 -149 559T-165 599",
  776: "-251 601Q-251 626 -230 647T-180 669Q-139 669 -133 625Q-133 595 -155 575T-203 554Q-223 554 -237 567T-251 601ZM-72 599Q-72 632 -48 650T-2 669Q18 669 31 657T45 623Q45 592 22 573T-25 554Q-68 554 -72 599",
  778: "-199 610Q-199 654 -161 685T-79 716Q-39 716 -16 693Q3 674 3 647Q3 607 -34 575T-118 542Q-199 542 -199 610ZM-41 631T-41 655T-83 679H-89Q-129 679 -142 656Q-146 650 -151 632T-156 604Q-156 578 -113 578H-108Q-94 578 -86 579T-69 586T-52 605Q-41 631 -41 655",
  779: "-217 503Q-221 503 -234 510T-248 523Q-248 528 -205 602Q-200 610 -192 623T-180 644T-170 661T-159 676T-151 686T-142 694T-134 696Q-132 697 -121 697Q-88 694 -88 664Q-88 652 -97 640T-152 574Q-214 504 -217 503ZM-64 503Q-68 503 -81 510T-95 523Q-95 528 -52 602Q-47 610 -39 623T-27 644T-17 661T-6 676T2 686T11 694T19 696Q21 697 32 697Q65 694 65 664Q65 652 56 640T1 574Q-61 504 -64 503",
  780: "11 637Q16 637 22 624T29 607Q29 606 27 602Q26 600 -47 552T-125 502H-127Q-133 502 -184 553Q-236 602 -236 608Q-236 612 -224 625T-206 638L-202 637L-196 632Q-190 628 -179 620T-158 603L-116 570Q-109 572 -52 604T11 637",
  989: "477 261Q477 257 473 256T455 253T417 251T348 250H235L155 -77L146 -82Q137 -85 109 -85Q55 -85 55 -77L139 261Q224 596 226 598Q229 603 239 603Q240 603 254 603T290 603T341 604T405 605T477 605Q656 603 687 602T719 596Q719 589 692 588T513 585H319L282 427L242 272Q242 270 351 270Q388 270 410 270T444 269T460 267T469 265T477 261",
  8211: "98 248Q91 252 91 259Q91 279 100 284Q102 285 324 285H442H500Q536 285 545 283T554 274Q554 260 548 254Q546 250 538 249Q520 248 319 248H98",
  8212: "124 248Q117 252 117 259Q117 279 126 284Q128 285 579 285T1033 284Q1037 280 1037 278Q1038 276 1038 274Q1038 253 1029 250Q1026 248 575 248H124",
  8213: "124 248Q117 252 117 259Q117 279 126 284Q128 285 579 285T1033 284Q1037 280 1037 278Q1038 276 1038 274Q1038 253 1029 250Q1026 248 575 248H124",
  8215: "98 -62Q91 -58 91 -51Q91 -31 100 -26Q102 -25 324 -25H442H500Q536 -25 545 -27T554 -36Q554 -50 548 -56Q546 -60 538 -61Q520 -62 319 -62H98",
  8216: "249 379Q228 379 213 396T197 448Q197 533 271 627L278 635Q286 643 295 652T314 671T332 687T344 694Q349 694 355 685T362 671Q362 668 345 654T301 608T256 537Q238 493 240 491Q241 491 245 493T258 498T275 500Q296 500 311 488T326 454Q326 426 304 403T249 379",
  8217: "250 620Q250 647 272 670T325 694Q348 694 362 677T377 633V624Q377 566 343 506T275 412T231 379Q226 379 220 388T213 401T232 421T279 472T323 547Q335 573 335 582L331 580Q327 578 318 576T300 573Q277 573 264 585T250 620",
  8220: "295 379Q274 379 259 396T243 448Q243 533 317 627Q326 638 354 666T391 694Q395 694 402 686T409 673Q409 668 392 654T348 608T302 537Q284 493 286 491Q287 491 291 493T304 498T321 500Q342 500 357 488T372 454Q372 426 350 403T295 379ZM492 379Q471 379 456 396T440 448Q440 533 514 627Q523 638 551 666T588 694Q592 694 599 685T606 672T589 654T544 608T499 537Q481 493 483 491Q484 491 488 493T501 498T518 500Q539 500 554 488T569 454Q569 426 547 403T492 379",
  8221: "214 620Q214 647 236 670T289 694Q312 694 326 677T341 633V624Q341 588 327 550T294 482T253 428T216 392T196 379Q191 379 184 388T176 401Q176 404 195 421T243 472T287 547Q299 576 299 582L295 580Q291 578 282 576T264 573Q241 573 228 585T214 620ZM411 620Q411 647 433 670T486 694Q509 694 523 677T538 633V624Q538 588 524 550T491 482T450 428T413 392T393 379Q388 379 381 388T373 401Q373 404 392 421T440 472T484 547Q496 576 496 582L492 580Q488 578 479 576T461 573Q438 573 425 585T411 620",
  8260: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215",
  8463: "150 475Q147 475 118 466T82 457Q73 457 64 467T54 487Q54 490 55 492Q63 506 64 506Q67 512 118 526Q162 541 169 546Q173 559 175 575Q181 596 181 604Q181 613 166 617Q164 617 153 618T135 619Q119 619 114 621T109 630Q109 636 114 656T122 681Q125 685 202 688Q272 695 286 695Q304 695 304 684Q304 682 291 628L278 577L386 612Q466 635 476 635T492 627T499 607Q499 593 489 586Q485 583 373 546L262 512Q262 511 248 455T233 397T236 397T244 404Q295 441 357 441Q405 441 445 417T485 333Q485 284 449 178T412 58T426 44Q447 44 466 68Q485 87 500 130L509 152H531H543Q562 152 562 144Q562 128 546 93T494 23T415 -13Q385 -13 359 3T322 44Q318 52 318 77Q318 99 352 196T386 337Q386 386 346 386Q318 386 286 370Q267 361 245 338T211 292Q207 287 193 235T162 113T138 21Q128 7 122 4Q105 -12 83 -12Q66 -12 54 -2T42 26Q42 45 98 257L151 475H150",
  8710: "574 715L582 716Q589 716 595 716Q612 716 616 714Q621 712 621 709Q622 707 705 359T788 8Q786 5 785 3L781 0H416Q52 0 50 2T48 6Q48 9 305 358T567 711Q572 712 574 715ZM599 346L538 602L442 474Q347 345 252 217T157 87T409 86T661 88L654 120Q646 151 629 220T599 346",
  10744: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215"
}, {});
var Pi = {}, Bi = {};
Object.defineProperty(Bi, "__esModule", { value: !0 });
Bi.largeop = void 0;
Bi.largeop = {
  40: [1.15, 0.649, 0.597],
  41: [1.15, 0.649, 0.597],
  47: [1.15, 0.649, 0.811],
  91: [1.15, 0.649, 0.472],
  92: [1.15, 0.649, 0.811],
  93: [1.15, 0.649, 0.472],
  123: [1.15, 0.649, 0.667],
  125: [1.15, 0.649, 0.667],
  710: [0.772, -0.565, 1],
  732: [0.75, -0.611, 1],
  770: [0.772, -0.565, 0],
  771: [0.75, -0.611, 0],
  8214: [0.602, 0, 0.778],
  8260: [1.15, 0.649, 0.811],
  8593: [0.6, 0, 0.667],
  8595: [0.6, 0, 0.667],
  8657: [0.599, 0, 0.778],
  8659: [0.6, 0, 0.778],
  8719: [0.95, 0.45, 1.278],
  8720: [0.95, 0.45, 1.278],
  8721: [0.95, 0.45, 1.444],
  8730: [1.15, 0.65, 1, { ic: 0.02 }],
  8739: [0.627, 0.015, 0.333],
  8741: [0.627, 0.015, 0.556],
  8747: [1.36, 0.862, 0.556, { ic: 0.388 }],
  8748: [1.36, 0.862, 1.084, { ic: 0.388 }],
  8749: [1.36, 0.862, 1.592, { ic: 0.388 }],
  8750: [1.36, 0.862, 0.556, { ic: 0.388 }],
  8896: [0.95, 0.45, 1.111],
  8897: [0.95, 0.45, 1.111],
  8898: [0.949, 0.45, 1.111],
  8899: [0.95, 0.449, 1.111],
  8968: [1.15, 0.649, 0.528],
  8969: [1.15, 0.649, 0.528],
  8970: [1.15, 0.649, 0.528],
  8971: [1.15, 0.649, 0.528],
  9001: [1.15, 0.649, 0.611],
  9002: [1.15, 0.649, 0.611],
  9168: [0.602, 0, 0.667],
  10072: [0.627, 0.015, 0.333],
  10216: [1.15, 0.649, 0.611],
  10217: [1.15, 0.649, 0.611],
  10752: [0.949, 0.449, 1.511],
  10753: [0.949, 0.449, 1.511],
  10754: [0.949, 0.449, 1.511],
  10756: [0.95, 0.449, 1.111],
  10758: [0.95, 0.45, 1.111],
  10764: [1.36, 0.862, 2.168, { ic: 0.388 }],
  12296: [1.15, 0.649, 0.611],
  12297: [1.15, 0.649, 0.611]
};
Object.defineProperty(Pi, "__esModule", { value: !0 });
Pi.largeop = void 0;
var CH = s3, VH = Bi;
Pi.largeop = (0, CH.AddPaths)(VH.largeop, {
  40: "180 96T180 250T205 541T266 770T353 944T444 1069T527 1150H555Q561 1144 561 1141Q561 1137 545 1120T504 1072T447 995T386 878T330 721T288 513T272 251Q272 133 280 56Q293 -87 326 -209T399 -405T475 -531T536 -609T561 -640Q561 -643 555 -649H527Q483 -612 443 -568T353 -443T266 -270T205 -41",
  41: "35 1138Q35 1150 51 1150H56H69Q113 1113 153 1069T243 944T330 771T391 541T416 250T391 -40T330 -270T243 -443T152 -568T69 -649H56Q43 -649 39 -647T35 -637Q65 -607 110 -548Q283 -316 316 56Q324 133 324 251Q324 368 316 445Q278 877 48 1123Q36 1137 35 1138",
  47: "78 -649Q56 -646 56 -625Q56 -614 382 261T712 1140Q716 1150 732 1150Q754 1147 754 1126Q754 1116 428 240T98 -639Q94 -649 78 -649",
  91: "224 -649V1150H455V1099H275V-598H455V-649H224",
  92: "754 -625Q754 -649 731 -649Q715 -649 712 -639Q709 -635 383 242T55 1124Q54 1135 61 1142T80 1150Q92 1150 98 1140Q101 1137 427 262T754 -625",
  93: "16 1099V1150H247V-649H16V-598H196V1099H16",
  123: "547 -643L541 -649H528Q515 -649 503 -645Q324 -582 293 -466Q289 -449 289 -428T287 -200L286 42L284 53Q274 98 248 135T196 190T146 222L121 235Q119 239 119 250Q119 262 121 266T133 273Q262 336 284 449L286 460L287 701Q287 737 287 794Q288 949 292 963Q293 966 293 967Q325 1080 508 1148Q516 1150 527 1150H541L547 1144V1130Q547 1117 546 1115T536 1109Q480 1086 437 1046T381 950L379 940L378 699Q378 657 378 594Q377 452 374 438Q373 437 373 436Q350 348 243 282Q192 257 186 254L176 251L188 245Q211 236 234 223T287 189T340 135T373 65Q373 64 374 63Q377 49 378 -93Q378 -156 378 -198L379 -438L381 -449Q393 -504 436 -544T536 -608Q544 -611 545 -613T547 -629V-643",
  125: "119 1130Q119 1144 121 1147T135 1150H139Q151 1150 182 1138T252 1105T326 1046T373 964Q378 942 378 702Q378 469 379 462Q386 394 439 339Q482 296 535 272Q544 268 545 266T547 251Q547 241 547 238T542 231T531 227T510 217T477 194Q390 129 379 39Q378 32 378 -201Q378 -441 373 -463Q342 -580 165 -644Q152 -649 139 -649Q125 -649 122 -646T119 -629Q119 -622 119 -619T121 -614T124 -610T132 -607T143 -602Q195 -579 235 -539T285 -447Q286 -435 287 -199T289 51Q294 74 300 91T329 138T390 197Q412 213 436 226T475 244L489 250L472 258Q455 265 430 279T377 313T327 366T293 434Q289 451 289 472T287 699Q286 941 285 948Q279 978 262 1005T227 1048T184 1080T151 1100T129 1109L127 1110Q119 1113 119 1130",
  710: "1004 603Q1004 600 999 583T991 565L960 574Q929 582 866 599T745 631L500 698Q497 698 254 631Q197 616 134 599T39 574L8 565Q5 565 0 582T-5 603L26 614Q58 624 124 646T248 687L499 772Q999 604 1004 603",
  732: "296 691Q258 691 216 683T140 663T79 639T34 619T16 611Q13 619 8 628L0 644L36 662Q206 749 321 749Q410 749 517 710T703 670Q741 670 783 678T859 698T920 722T965 742T983 750Q986 742 991 733L999 717L963 699Q787 611 664 611Q594 611 484 651T296 691",
  770: "4 603Q4 600 -1 583T-9 565L-40 574Q-71 582 -134 599T-255 631L-500 698Q-503 698 -746 631Q-803 616 -866 599T-961 574L-992 565Q-995 565 -1000 582T-1005 603L-974 614Q-942 624 -876 646T-752 687L-501 772Q-1 604 4 603",
  771: "-704 691Q-742 691 -784 683T-860 663T-921 639T-966 619T-984 611Q-987 619 -992 628L-1000 644L-964 662Q-794 749 -679 749Q-590 749 -483 710T-297 670Q-259 670 -217 678T-141 698T-80 722T-35 742T-17 750Q-14 742 -9 733L-1 717L-37 699Q-213 611 -336 611Q-405 611 -515 651T-704 691",
  8214: "257 0V602H300V0H257ZM478 0V602H521V0H478",
  8260: "78 -649Q56 -646 56 -625Q56 -614 382 261T712 1140Q716 1150 732 1150Q754 1147 754 1126Q754 1116 428 240T98 -639Q94 -649 78 -649",
  8593: "112 421L120 424Q127 427 136 430T161 441T191 458T224 481T260 510T295 546T328 591L333 600L340 589Q380 527 431 489T555 421V377L543 381Q445 418 368 492L355 504V0H312V504L299 492Q222 418 124 381L112 377V421",
  8595: "312 96V600H355V96L368 108Q445 182 543 219L555 223V179L546 176Q538 173 529 169T505 158T475 141T442 119T407 90T372 53T339 9L334 0L327 11Q287 73 236 111T112 179V223L124 219Q222 182 299 108L312 96",
  8657: "142 329Q300 419 389 599Q389 598 399 579T420 541T452 494T497 438T558 383T636 329T708 294L721 289V246Q718 246 694 256T623 293T532 356L522 364L521 182V0H478V405L466 417Q436 450 389 516Q388 515 378 500T352 463T312 417L300 405V0H257V364L247 356Q202 320 155 293T82 256L57 246V289L70 294Q101 305 142 329",
  8659: "257 236V600H300V195L312 183Q342 150 389 84Q390 85 400 100T426 137T466 183L478 195V600H521V418L522 236L532 244Q576 280 623 307T696 344L721 354V311L708 306Q677 295 636 271Q478 181 389 1Q389 2 379 21T358 59T326 106T281 162T220 217T142 271T70 306L57 311V354Q60 354 83 345T154 308T247 244L257 236",
  8719: "220 812Q220 813 218 819T214 829T208 840T199 853T185 866T166 878T140 887T107 893T66 896H56V950H1221V896H1211Q1080 896 1058 812V-311Q1076 -396 1211 -396H1221V-450H725V-396H735Q864 -396 888 -314Q889 -312 889 -311V896H388V292L389 -311Q405 -396 542 -396H552V-450H56V-396H66Q195 -396 219 -314Q220 -312 220 -311V812",
  8720: "220 812Q220 813 218 819T214 829T208 840T199 853T185 866T166 878T140 887T107 893T66 896H56V950H552V896H542Q411 896 389 812L388 208V-396H889V812Q889 813 887 819T883 829T877 840T868 853T854 866T835 878T809 887T776 893T735 896H725V950H1221V896H1211Q1080 896 1058 812V-311Q1076 -396 1211 -396H1221V-450H56V-396H66Q195 -396 219 -314Q220 -312 220 -311V812",
  8721: "60 948Q63 950 665 950H1267L1325 815Q1384 677 1388 669H1348L1341 683Q1320 724 1285 761Q1235 809 1174 838T1033 881T882 898T699 902H574H543H251L259 891Q722 258 724 252Q725 250 724 246Q721 243 460 -56L196 -356Q196 -357 407 -357Q459 -357 548 -357T676 -358Q812 -358 896 -353T1063 -332T1204 -283T1307 -196Q1328 -170 1348 -124H1388Q1388 -125 1381 -145T1356 -210T1325 -294L1267 -449L666 -450Q64 -450 61 -448Q55 -446 55 -439Q55 -437 57 -433L590 177Q590 178 557 222T452 366T322 544L56 909L55 924Q55 945 60 948",
  8730: "1001 1150Q1017 1150 1020 1132Q1020 1127 741 244L460 -643Q453 -650 436 -650H424Q423 -647 423 -645T421 -640T419 -631T415 -617T408 -594T399 -560T385 -512T367 -448T343 -364T312 -259L203 119L138 41L111 67L212 188L264 248L472 -474L983 1140Q988 1150 1001 1150",
  8739: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
  8741: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612ZM368 612Q373 627 388 627Q404 627 409 612Q410 610 410 306T409 0Q406 -15 389 -15Q371 -15 368 0V10Q368 19 368 35T368 73T368 122T367 179T367 241T367 306T367 370T367 433T367 489T368 538T368 576T368 602V612",
  8747: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798",
  8748: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798ZM642 -798Q660 -824 693 -824H695Q723 -824 751 -764T803 -600T848 -391T890 -164Q893 -143 895 -133Q967 292 1051 655T1173 1127Q1179 1145 1183 1157T1200 1201T1227 1257T1261 1306T1305 1346T1356 1360Q1412 1360 1440 1325T1472 1245Q1472 1220 1460 1205T1437 1186T1415 1183Q1394 1183 1377 1198T1360 1239Q1360 1287 1413 1296L1410 1300Q1407 1303 1402 1307T1394 1313Q1379 1323 1361 1323Q1347 1323 1335 1311T1303 1255T1264 1139T1217 936T1161 628Q1102 293 1038 -5T938 -437T883 -629Q806 -862 693 -862Q653 -862 620 -831T583 -746Q583 -711 602 -698T640 -685Q661 -685 678 -700T695 -741Q695 -789 642 -798",
  8749: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798ZM642 -798Q660 -824 693 -824H695Q723 -824 751 -764T803 -600T848 -391T890 -164Q893 -143 895 -133Q967 292 1051 655T1173 1127Q1179 1145 1183 1157T1200 1201T1227 1257T1261 1306T1305 1346T1356 1360Q1412 1360 1440 1325T1472 1245Q1472 1220 1460 1205T1437 1186T1415 1183Q1394 1183 1377 1198T1360 1239Q1360 1287 1413 1296L1410 1300Q1407 1303 1402 1307T1394 1313Q1379 1323 1361 1323Q1347 1323 1335 1311T1303 1255T1264 1139T1217 936T1161 628Q1102 293 1038 -5T938 -437T883 -629Q806 -862 693 -862Q653 -862 620 -831T583 -746Q583 -711 602 -698T640 -685Q661 -685 678 -700T695 -741Q695 -789 642 -798ZM1150 -798Q1168 -824 1201 -824H1203Q1231 -824 1259 -764T1311 -600T1356 -391T1398 -164Q1401 -143 1403 -133Q1475 292 1559 655T1681 1127Q1687 1145 1691 1157T1708 1201T1735 1257T1769 1306T1813 1346T1864 1360Q1920 1360 1948 1325T1980 1245Q1980 1220 1968 1205T1945 1186T1923 1183Q1902 1183 1885 1198T1868 1239Q1868 1287 1921 1296L1918 1300Q1915 1303 1910 1307T1902 1313Q1887 1323 1869 1323Q1855 1323 1843 1311T1811 1255T1772 1139T1725 936T1669 628Q1610 293 1546 -5T1446 -437T1391 -629Q1314 -862 1201 -862Q1161 -862 1128 -831T1091 -746Q1091 -711 1110 -698T1148 -685Q1169 -685 1186 -700T1203 -741Q1203 -789 1150 -798",
  8750: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q382 -52 390 2Q314 40 276 99Q230 167 230 249Q230 363 305 436T484 519H494L503 563Q587 939 632 1087T727 1298Q774 1360 828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q766 1323 688 929Q662 811 610 496Q770 416 770 249Q770 147 701 68T516 -21H506L497 -65Q407 -464 357 -623T237 -837Q203 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798ZM480 478Q460 478 435 470T380 444T327 401T287 335T271 249Q271 124 375 56L397 43L431 223L485 478H480ZM519 20Q545 20 578 33T647 72T706 144T730 249Q730 383 603 455Q603 454 597 421T582 343T569 276Q516 22 515 20H519",
  8896: "1055 -401Q1055 -419 1042 -434T1007 -450Q977 -450 963 -423Q959 -417 757 167L555 750L353 167Q151 -417 147 -423Q134 -450 104 -450Q84 -450 70 -436T55 -401Q55 -394 56 -390Q59 -381 284 270T512 925Q525 950 555 950Q583 950 597 926Q599 923 825 270T1054 -391Q1055 -394 1055 -401",
  8897: "55 900Q55 919 69 934T103 950Q134 950 147 924Q152 913 353 333L555 -250L757 333Q958 913 963 924Q978 950 1007 950Q1028 950 1041 935T1055 901Q1055 894 1054 891Q1052 884 826 231T597 -426Q583 -450 556 -450Q527 -450 512 -424Q510 -421 285 229T56 890Q55 893 55 900",
  8898: "57 516Q68 602 104 675T190 797T301 882T423 933T542 949Q594 949 606 948Q780 928 901 815T1048 545Q1053 516 1053 475T1055 49Q1055 -406 1054 -410Q1051 -427 1037 -438T1006 -450T976 -439T958 -411Q957 -407 957 37Q957 484 956 494Q945 643 831 747T554 852Q481 852 411 826Q301 786 232 696T154 494Q153 484 153 37Q153 -407 152 -411Q148 -428 135 -439T104 -450T73 -439T56 -410Q55 -406 55 49Q56 505 57 516",
  8899: "56 911Q58 926 71 938T103 950Q120 950 134 939T152 911Q153 907 153 463Q153 16 154 6Q165 -143 279 -247T556 -352Q716 -352 830 -248T956 6Q957 16 957 463Q957 907 958 911Q962 928 975 939T1006 950T1037 939T1054 911Q1055 906 1055 451Q1054 -5 1053 -16Q1029 -207 889 -328T555 -449Q363 -449 226 -331T62 -45Q57 -16 57 25T55 451Q55 906 56 911",
  8968: "224 -649V1150H511V1099H275V-649H224",
  8969: "16 1099V1150H303V-649H252V1099H16",
  8970: "224 -649V1150H275V-598H511V-649H224",
  8971: "252 -598V1150H303V-649H16V-598H252",
  9001: "112 244V258L473 1130Q482 1150 498 1150Q511 1150 517 1142T523 1125V1118L344 685Q304 587 257 473T187 305L165 251L344 -184L523 -616V-623Q524 -634 517 -641T499 -649Q484 -649 473 -629L112 244",
  9002: "112 -649Q103 -649 95 -642T87 -623V-616L266 -184L445 251Q445 252 356 466T178 898T86 1123Q85 1134 93 1142T110 1150Q126 1150 133 1137Q134 1136 317 695L498 258V244L317 -194Q134 -635 133 -636Q126 -649 112 -649",
  9168: "312 0V602H355V0H312",
  10072: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
  10216: "112 244V258L473 1130Q482 1150 498 1150Q511 1150 517 1142T523 1125V1118L344 685Q304 587 257 473T187 305L165 251L344 -184L523 -616V-623Q524 -634 517 -641T499 -649Q484 -649 473 -629L112 244",
  10217: "112 -649Q103 -649 95 -642T87 -623V-616L266 -184L445 251Q445 252 356 466T178 898T86 1123Q85 1134 93 1142T110 1150Q126 1150 133 1137Q134 1136 317 695L498 258V244L317 -194Q134 -635 133 -636Q126 -649 112 -649",
  10752: "668 944Q697 949 744 949Q803 949 814 948Q916 937 1006 902T1154 826T1262 730T1336 638T1380 563Q1454 415 1454 250Q1454 113 1402 -14T1258 -238T1036 -391T755 -449Q608 -449 477 -392T255 -240T110 -16T56 250Q56 387 105 510T239 723T434 871T668 944ZM755 -352Q922 -352 1061 -269T1278 -48T1356 250Q1356 479 1202 652T809 850Q798 851 747 851Q634 851 527 806T337 682T204 491T154 251Q154 128 201 17T329 -176T521 -304T755 -352ZM665 250Q665 290 692 315T758 341Q792 339 818 315T845 250Q845 211 819 186T755 160Q716 160 691 186T665 250",
  10753: "668 944Q697 949 744 949Q803 949 814 948Q916 937 1006 902T1154 826T1262 730T1336 638T1380 563Q1454 415 1454 250Q1454 113 1402 -14T1258 -238T1036 -391T755 -449Q608 -449 477 -392T255 -240T110 -16T56 250Q56 387 105 510T239 723T434 871T668 944ZM706 299V850H704Q519 832 386 725T198 476Q181 433 169 379T156 300Q156 299 431 299H706ZM1116 732Q1054 778 982 807T871 842T810 849L804 850V299H1079Q1354 299 1354 300Q1354 311 1352 329T1336 402T1299 506T1228 620T1116 732ZM706 -350V201H431Q156 201 156 200Q156 189 158 171T174 98T211 -6T282 -120T395 -232Q428 -257 464 -277T527 -308T587 -328T636 -339T678 -346T706 -350ZM1354 200Q1354 201 1079 201H804V-350Q808 -349 838 -345T887 -338T940 -323T1010 -295Q1038 -282 1067 -265T1144 -208T1229 -121T1301 0T1349 158Q1354 188 1354 200",
  10754: "668 944Q697 949 744 949Q803 949 814 948Q916 937 1006 902T1154 826T1262 730T1336 638T1380 563Q1454 415 1454 250Q1454 113 1402 -14T1258 -238T1036 -391T755 -449Q608 -449 477 -392T255 -240T110 -16T56 250Q56 387 105 510T239 723T434 871T668 944ZM1143 709Q1138 714 1129 722T1086 752T1017 791T925 826T809 850Q798 851 747 851H728Q659 851 571 823T408 741Q367 713 367 709L755 320L1143 709ZM297 639Q296 639 282 622T247 570T205 491T169 382T154 250T168 118T204 9T247 -70T282 -122L297 -139L685 250L297 639ZM1213 -139Q1214 -139 1228 -122T1263 -70T1305 9T1341 118T1356 250T1342 382T1306 491T1263 570T1228 622L1213 639L825 250L1213 -139ZM367 -209Q373 -215 384 -224T434 -258T514 -302T622 -336T755 -352T887 -338T996 -302T1075 -259T1126 -224L1143 -209L755 180Q754 180 561 -14T367 -209",
  10756: "56 911Q58 926 71 938T103 950Q120 950 134 939T152 911Q153 907 153 463Q153 16 154 6Q165 -143 279 -247T556 -352Q716 -352 830 -248T956 6Q957 16 957 463Q957 907 958 911Q962 928 975 939T1006 950T1037 939T1054 911Q1055 906 1055 451Q1054 -5 1053 -16Q1029 -207 889 -328T555 -449Q363 -449 226 -331T62 -45Q57 -16 57 25T55 451Q55 906 56 911ZM507 554Q511 570 523 581T554 593Q571 593 585 582T603 554Q604 551 604 443V338H709Q817 338 820 337Q835 334 847 321T859 290Q859 254 819 241Q816 240 709 240H604V134Q604 48 604 34T598 11Q583 -15 555 -15Q526 -15 512 11Q507 20 507 34T506 134V240H401H344Q292 240 278 246Q251 259 251 290Q251 309 264 321T290 337Q293 338 401 338H506V443Q506 551 507 554",
  10758: "56 911Q60 927 72 938T103 950Q120 950 134 939T152 911Q153 907 153 277V-352H957V277Q957 907 958 911Q962 928 975 939T1006 950T1036 939T1054 911V891Q1054 871 1054 836T1054 754T1054 647T1055 525T1055 390T1055 250T1055 111T1055 -24T1055 -147T1054 -253T1054 -335T1054 -391V-411Q1047 -442 1016 -449Q1011 -450 552 -450L94 -449Q63 -439 56 -411V-391Q56 -371 56 -336T56 -254T56 -147T55 -25T55 110T55 250T55 389T55 524T55 647T56 753T56 835T56 891V911",
  12296: "112 244V258L473 1130Q482 1150 498 1150Q511 1150 517 1142T523 1125V1118L344 685Q304 587 257 473T187 305L165 251L344 -184L523 -616V-623Q524 -634 517 -641T499 -649Q484 -649 473 -629L112 244",
  12297: "112 -649Q103 -649 95 -642T87 -623V-616L266 -184L445 251Q445 252 356 466T178 898T86 1123Q85 1134 93 1142T110 1150Q126 1150 133 1137Q134 1136 317 695L498 258V244L317 -194Q134 -635 133 -636Q126 -649 112 -649"
}, {
  10764: "∬∬"
});
var Fi = {}, ji = {};
Object.defineProperty(ji, "__esModule", { value: !0 });
ji.monospace = void 0;
ji.monospace = {
  32: [0, 0, 0.525],
  33: [0.622, 0, 0.525],
  34: [0.623, -0.333, 0.525],
  35: [0.611, 0, 0.525],
  36: [0.694, 0.082, 0.525],
  37: [0.694, 0.083, 0.525],
  38: [0.622, 0.011, 0.525],
  39: [0.611, -0.287, 0.525],
  40: [0.694, 0.082, 0.525],
  41: [0.694, 0.082, 0.525],
  42: [0.52, -0.09, 0.525],
  43: [0.531, -0.081, 0.525],
  44: [0.14, 0.139, 0.525],
  45: [0.341, -0.271, 0.525],
  46: [0.14, 0, 0.525],
  47: [0.694, 0.083, 0.525],
  58: [0.431, 0, 0.525],
  59: [0.431, 0.139, 0.525],
  60: [0.557, -0.055, 0.525],
  61: [0.417, -0.195, 0.525],
  62: [0.557, -0.055, 0.525],
  63: [0.617, 0, 0.525],
  64: [0.617, 6e-3, 0.525],
  91: [0.694, 0.082, 0.525],
  92: [0.694, 0.083, 0.525],
  93: [0.694, 0.082, 0.525],
  94: [0.611, -0.46, 0.525],
  95: [-0.025, 0.095, 0.525],
  96: [0.681, -0.357, 0.525],
  123: [0.694, 0.083, 0.525],
  124: [0.694, 0.082, 0.525],
  125: [0.694, 0.083, 0.525],
  126: [0.611, -0.466, 0.525],
  127: [0.612, -0.519, 0.525],
  160: [0, 0, 0.525],
  305: [0.431, 0, 0.525],
  567: [0.431, 0.228, 0.525],
  697: [0.623, -0.334, 0.525],
  768: [0.611, -0.485, 0],
  769: [0.611, -0.485, 0],
  770: [0.611, -0.46, 0],
  771: [0.611, -0.466, 0],
  772: [0.577, -0.5, 0],
  774: [0.611, -0.504, 0],
  776: [0.612, -0.519, 0],
  778: [0.619, -0.499, 0],
  780: [0.577, -0.449, 0],
  913: [0.623, 0, 0.525],
  914: [0.611, 0, 0.525],
  915: [0.611, 0, 0.525],
  916: [0.623, 0, 0.525],
  917: [0.611, 0, 0.525],
  918: [0.611, 0, 0.525],
  919: [0.611, 0, 0.525],
  920: [0.621, 0.01, 0.525],
  921: [0.611, 0, 0.525],
  922: [0.611, 0, 0.525],
  923: [0.623, 0, 0.525],
  924: [0.611, 0, 0.525],
  925: [0.611, 0, 0.525],
  926: [0.611, 0, 0.525],
  927: [0.621, 0.01, 0.525],
  928: [0.611, 0, 0.525],
  929: [0.611, 0, 0.525],
  931: [0.611, 0, 0.525],
  932: [0.611, 0, 0.525],
  933: [0.622, 0, 0.525],
  934: [0.611, 0, 0.525],
  935: [0.611, 0, 0.525],
  936: [0.611, 0, 0.525],
  937: [0.622, 0, 0.525],
  8215: [-0.025, 0.095, 0.525],
  8242: [0.623, -0.334, 0.525],
  8243: [0.623, 0, 1.05],
  8244: [0.623, 0, 1.575],
  8260: [0.694, 0.083, 0.525],
  8279: [0.623, 0, 2.1],
  8710: [0.623, 0, 0.525]
};
Object.defineProperty(Fi, "__esModule", { value: !0 });
Fi.monospace = void 0;
var _H = s3, OH = ji;
Fi.monospace = (0, _H.AddPaths)(OH.monospace, {
  32: "",
  33: "206 565Q206 590 222 606T265 622Q287 621 303 606T319 565T314 392L308 216Q299 194 273 194H262Q247 194 241 195T228 200T217 216L211 392Q206 539 206 565ZM206 56Q206 83 223 99T265 115Q288 113 304 99T320 58Q320 33 303 17T262 0Q237 0 222 17T206 56",
  34: "122 575Q122 593 137 608T173 623Q196 623 210 608T225 575Q225 562 218 464Q212 373 211 361T201 341Q193 333 173 333Q154 333 146 341Q138 348 137 360T129 464Q122 561 122 575ZM299 575Q299 593 314 608T350 623Q373 623 387 608T402 575Q402 562 395 464Q389 373 388 361T378 341Q370 333 350 333Q331 333 323 341Q315 348 314 360T306 464Q299 561 299 575",
  35: "93 163Q74 163 65 164T46 173T36 198Q36 210 40 215T61 233H131V236Q132 239 140 307T149 377Q149 379 105 379L61 380Q36 392 36 414Q36 450 86 450Q91 450 99 450T112 449H159Q163 480 167 517Q168 524 170 545T174 573T180 591T191 607T210 611Q223 611 232 604T243 588L245 580Q245 565 238 511T230 451Q230 449 282 449H333Q337 480 341 517Q342 524 343 537T345 556T348 573T352 589T359 600T370 608T384 611Q395 611 406 602T419 580Q419 565 412 511T404 451Q404 449 431 449H442Q477 449 485 429Q489 421 489 414Q489 392 463 380L428 379H394V376Q393 373 385 305T376 235Q376 233 419 233H463L468 230Q472 227 473 227T477 223T482 218T486 213T488 206T489 198Q489 162 436 162Q430 162 422 162T412 163H366V161Q364 159 357 92Q356 85 355 73T353 54T350 37T346 22T339 11T328 3T314 0Q303 0 292 9T279 31Q279 37 287 96T295 162Q295 163 244 163H192V161Q190 159 183 92Q182 85 181 73T179 54T176 37T172 22T165 11T154 3T140 0Q129 0 118 9T105 31Q105 37 113 96T121 162Q121 163 93 163ZM323 377Q323 379 272 379H220V376Q219 373 211 305T202 235Q202 233 253 233H305V236Q306 239 314 307T323 377",
  36: "415 397Q392 397 377 411T362 448Q362 464 376 485Q369 498 362 506T346 520T332 528T315 533T300 538V445L301 353L311 350Q382 334 424 284T466 174Q466 115 425 65T303 -2L300 -3V-30Q300 -64 291 -74Q283 -82 262 -82H255Q234 -82 225 -60L224 -32V-4L213 -2Q152 6 106 51T59 170V180Q59 197 74 213Q89 227 110 227T146 213T162 174Q162 156 147 137Q153 123 161 112T176 95T191 85T205 79T216 76T224 74V283L213 285Q147 298 103 343T58 449Q58 516 108 560T224 614V643V654Q224 666 226 673T237 687T264 694Q289 693 294 683T300 642V615H303Q355 607 390 587T440 540T460 493T466 453Q466 425 451 411T415 397ZM137 452Q137 425 158 404T198 376T223 369Q224 369 224 453T223 537Q198 532 168 509T137 452ZM301 75Q307 75 325 83T365 116T387 171Q387 238 300 267V171Q300 75 301 75",
  37: "35 560Q35 607 54 645T110 693Q111 693 116 693T125 694Q165 692 187 651T210 560Q210 506 186 467T123 428Q84 428 60 466T35 560ZM139 560Q139 574 136 587T130 608T124 615Q122 617 120 614Q106 595 106 561Q106 516 121 506Q123 504 125 507Q139 526 139 560ZM123 -83Q107 -83 98 -73T88 -48Q88 -43 89 -41Q90 -37 229 316T370 675Q381 694 400 694Q416 694 426 684T436 659Q436 654 435 652Q434 647 295 294T153 -65Q144 -83 123 -83ZM314 50Q314 104 338 143T400 183Q439 183 464 144T489 50T465 -43T402 -82Q358 -82 336 -41T314 50ZM417 50Q417 71 413 85T405 102L401 106Q386 95 386 50Q386 29 390 15T398 -2L402 -6Q417 5 417 50",
  38: "96 462Q96 546 132 584T211 622Q255 622 284 583T314 474Q314 395 224 305L208 288Q213 275 226 251L265 185L269 179Q273 184 299 246L332 333L342 363Q342 364 341 365Q334 365 334 393Q334 406 334 410T340 420T356 431H412H440Q467 431 478 424T490 393Q490 376 484 367T470 357T448 355H441H415L399 312Q349 176 322 127L315 115L323 106Q360 65 393 65Q405 65 410 80T416 109Q416 140 452 140Q487 140 487 105Q487 56 460 23T391 -11L286 41L273 53L262 42Q212 -11 151 -11Q97 -11 63 33T28 143Q28 161 30 176T38 205T47 227T60 247T72 261T84 274T94 283L122 311L119 323Q96 392 96 462ZM243 474Q243 533 218 545L215 546Q212 546 210 546Q182 546 169 501Q167 492 167 466Q167 419 179 368L188 377Q234 425 242 461Q243 465 243 474ZM217 129Q185 174 154 235Q121 214 115 176Q113 168 113 143Q113 83 139 67Q141 66 152 66Q191 66 228 112L217 129",
  39: "205 554Q205 577 221 594T263 611Q302 611 325 577T349 490Q349 409 298 347Q285 330 258 309T214 287Q203 289 189 302T175 327Q175 341 185 349T213 369T245 402Q269 437 273 483V497Q264 496 263 496Q240 496 223 513T205 554",
  40: "437 -53Q437 -82 399 -82H394Q377 -82 342 -55Q259 7 213 102T166 306Q166 412 211 507T342 667Q377 694 393 694H399Q437 694 437 665Q437 654 426 643T397 620T356 584T311 525Q301 511 290 488T264 412T250 306Q250 191 300 105T422 -27Q437 -37 437 -53",
  41: "87 664Q87 694 126 694Q138 694 147 690T183 667Q266 605 312 510T358 306Q358 193 307 93T161 -70Q142 -82 126 -82Q105 -82 96 -73T87 -53Q87 -47 88 -44Q92 -36 116 -19T173 34T230 119Q273 206 273 306Q273 408 231 494T109 635Q87 649 87 664",
  42: "222 487Q224 501 235 510T262 520Q279 520 289 510T302 487Q302 458 301 429Q301 421 301 413T301 398T300 386T300 377V374Q300 373 301 373Q304 373 353 403T416 434Q432 434 444 423T456 393Q456 389 456 386T454 379T451 373T448 368T442 363T436 358T427 353T417 348T405 342T391 334Q345 309 339 305L388 279Q400 273 412 266T432 255T441 250Q456 238 456 218Q456 200 445 189T417 177Q403 177 354 207T301 238Q300 238 300 237V234Q300 231 300 226T300 214T301 199T301 182Q302 153 302 124Q300 109 289 100T262 90T235 100T222 124Q222 153 223 182Q223 190 223 198T223 213T224 225T224 234V237Q224 238 223 238Q220 238 171 208T108 177Q92 177 80 188T68 218Q68 237 79 246T134 277Q180 303 185 306L136 332Q124 338 112 345T92 356T83 361Q68 373 68 393Q68 411 79 422T107 434Q121 434 170 404T223 373Q224 373 224 374V377Q224 380 224 385T224 397T223 412T223 429Q222 458 222 487",
  43: "147 271Q138 271 122 271T98 270Q68 270 53 277T38 306T53 335T98 342Q105 342 121 342T147 341H227V423L228 505Q241 531 262 531Q268 531 273 530T282 525T287 519T293 511L297 505V341H377H430Q457 341 467 338T483 321Q487 313 487 306Q487 295 480 286T463 273Q457 271 377 271H297V107Q281 81 262 81Q250 81 242 87T230 100L228 107L227 189V271H147",
  44: "193 37T193 70T213 121T260 140Q302 140 327 108T353 36Q353 -7 336 -43T294 -98T249 -128T215 -139Q204 -139 189 -125Q177 -111 174 -101Q172 -84 183 -77T217 -61T253 -33Q261 -24 272 1L265 0Q234 0 214 18",
  45: "57 306Q57 333 86 341H438Q468 332 468 306T438 271H86Q57 280 57 306",
  46: "193 70Q193 105 214 122T258 140Q291 140 311 120T332 70Q332 44 314 23T262 1Q234 1 214 18T193 70",
  47: "94 -83Q78 -83 68 -73T58 -48Q58 -44 60 -36Q62 -31 227 314T399 673Q410 694 431 694Q445 694 455 684T466 659Q466 656 464 648Q463 643 298 298T125 -62Q114 -83 94 -83",
  58: "193 361Q193 396 214 413T258 431Q291 431 311 411T332 361Q332 335 314 314T262 292Q234 292 214 309T193 361ZM193 70Q193 105 214 122T258 140Q291 140 311 120T332 70Q332 44 314 23T262 1Q234 1 214 18T193 70",
  59: "193 361Q193 396 214 413T258 431Q291 431 311 411T332 361Q332 335 314 314T262 292Q234 292 214 309T193 361ZM193 70Q193 105 214 122T259 140Q301 140 319 108T337 33Q337 -38 291 -88T214 -139Q203 -139 189 -126T175 -97Q175 -85 182 -78T200 -66T225 -50T249 -17Q256 -3 256 0Q252 1 248 1Q242 2 235 5T218 15T200 36T193 70",
  60: "468 90Q468 76 458 66T433 55Q426 55 419 58Q413 61 243 168T68 280Q57 291 57 306T68 332Q72 335 241 442T416 553Q424 557 432 557Q447 557 457 547T468 522T456 496Q454 494 305 399L158 306L305 213Q341 190 390 159Q443 125 452 119T464 106V105Q468 97 468 90",
  61: "38 382Q38 409 67 417H457Q487 408 487 382Q487 358 461 348H64Q51 352 45 360T38 376V382ZM67 195Q38 204 38 230Q38 255 62 264Q66 265 264 265H461L464 264Q467 262 469 261T475 256T481 249T485 240T487 230Q487 204 457 195H67",
  62: "57 522Q57 539 67 548T90 557Q98 557 105 554Q111 551 281 444T456 332Q468 320 468 306T456 280Q452 276 282 169T105 58Q98 55 91 55Q79 55 68 63T57 90Q57 105 68 116Q70 118 219 213L366 306L219 399Q75 491 71 494Q57 507 57 522",
  63: "62 493Q62 540 107 578T253 617Q366 617 414 578T462 490Q462 459 445 434T411 400L394 390Q315 347 296 287Q294 278 293 247V217Q285 201 278 198T246 194T216 197T201 215V245V253Q201 379 351 456Q366 464 375 477Q377 482 377 490Q377 517 339 528T251 540Q182 540 159 517Q166 503 166 490Q166 468 151 453T114 438Q96 438 79 451T62 493ZM190 58Q190 85 208 100T249 115Q272 113 288 99T304 58Q304 33 287 17T246 0T206 16T190 58",
  64: "44 306Q44 445 125 531T302 617Q332 617 358 607T411 574T456 502T479 387Q481 361 481 321Q481 203 421 143Q381 103 332 103Q266 103 225 165T183 307Q183 390 227 449T332 508Q358 508 378 498Q350 541 304 541Q229 541 172 473T115 305Q115 208 171 140T306 71H310Q358 71 397 105Q409 115 436 115Q458 115 462 113Q481 106 481 86Q481 73 468 61Q401 -6 305 -6Q262 -6 217 14T133 71T69 170T44 306ZM410 306Q410 361 386 396T333 431Q300 431 277 394T254 305Q254 256 276 218T332 180Q364 180 387 217T410 306",
  91: "237 -82Q221 -78 214 -58V305Q214 669 216 673Q220 687 231 690T278 694H350H461Q462 693 467 690T474 685T478 679T482 670T483 656Q483 632 471 625T428 617Q422 617 406 617T379 618H298V-7H379H420Q459 -7 471 -13T483 -45Q483 -55 483 -59T477 -70T461 -82H237",
  92: "58 659Q58 673 68 683T93 694Q114 694 125 673Q132 659 297 314T464 -36Q466 -44 466 -48Q466 -66 454 -74T431 -83Q410 -83 399 -62Q391 -47 226 298T60 648Q58 656 58 659",
  93: "41 656Q41 681 53 688T99 695Q107 695 133 695T177 694H288Q307 681 310 669V-58Q303 -76 288 -82H64Q41 -73 41 -45Q41 -21 53 -14T96 -6Q102 -6 118 -6T145 -7H226V618H145H100Q67 618 54 625T41 656",
  94: "138 460Q121 460 109 479T96 512Q96 527 106 534Q109 536 178 571T253 609Q256 611 264 611Q272 610 343 574Q357 567 369 561T389 550T402 543T411 538T416 535T420 532T422 529T425 525Q428 518 428 512Q428 498 416 479T386 460H384Q377 460 316 496L262 526L208 496Q147 460 138 460",
  95: "57 -60Q57 -33 86 -25H438Q468 -34 468 -60T438 -95H86Q57 -86 57 -60",
  96: "176 479Q176 563 227 622T310 681Q324 680 337 667T350 641Q350 627 340 619T312 599T280 566Q256 531 252 485V471Q261 472 262 472Q285 472 302 455T320 414Q320 389 303 373T261 357Q223 357 200 391T176 479",
  123: "430 -7H436Q449 -7 456 -8T469 -19T475 -45Q475 -69 466 -76T434 -83H419Q386 -82 363 -80T308 -69T253 -41T223 7L221 17L220 118V220L218 224Q215 229 214 230T210 235T204 241T195 246T184 252T170 257T151 262T127 265Q118 267 100 267T69 270T52 283Q50 288 50 306V314Q50 335 67 341Q68 342 102 343T172 355T217 386L220 392V493L221 595Q225 611 230 621T251 650T304 679T395 693L406 694Q418 694 426 694Q458 694 466 685Q475 676 475 656T466 627Q458 618 430 618Q319 618 305 587L304 486Q304 476 304 458T305 431Q305 385 295 358T251 311L243 306Q243 305 254 298T281 274T302 231Q304 223 304 125L305 25Q309 16 316 10T352 -1T430 -7",
  124: "228 668Q241 694 262 694Q268 694 273 693T282 688T287 682T293 674L297 668V-57Q282 -82 262 -82Q239 -82 228 -57V668",
  125: "49 655Q49 674 56 682T73 692T106 694Q141 693 167 690T224 677T275 647T303 595L305 392Q313 367 347 356T417 344T457 341Q475 335 475 306Q475 292 473 285T464 273T451 269T430 267Q352 262 327 246Q311 236 305 220L303 17L301 7Q294 -16 277 -33T242 -60T196 -74T150 -80T106 -83Q78 -83 72 -82T58 -74Q49 -65 49 -44Q49 -24 58 -16Q66 -7 94 -7Q143 -7 171 -1T207 10T220 25V125Q220 223 222 231Q228 257 243 274T270 299L281 306Q234 329 222 381Q220 387 220 486V587Q212 597 207 601T173 612T94 618Q66 618 58 627Q49 635 49 655",
  126: "125 467Q113 467 100 480T87 509Q88 520 111 543Q172 602 209 609Q219 611 224 611Q246 611 263 596T290 566T304 551Q319 551 367 594Q383 610 396 610H400Q411 610 424 597T437 568Q436 557 413 534Q348 469 305 466Q278 466 260 481T234 511T220 526Q205 526 157 483Q141 467 129 467H125",
  127: "104 565Q104 590 120 600T155 611Q175 611 180 610Q217 599 217 565Q217 545 202 532T166 519H159H155Q120 519 107 547Q104 553 104 565ZM307 565Q307 580 317 593T346 610Q348 610 350 610T354 611Q355 612 367 612Q395 611 408 597T421 565T409 534T365 519H358Q336 519 322 532T307 565",
  160: "",
  305: "411 76Q441 76 451 69T462 38Q462 29 462 26T460 18T453 9T440 1H94Q72 8 72 33V38Q72 46 72 49T74 58T81 68T94 76H233V355H167L102 356Q80 363 80 393Q80 418 91 425T138 432Q145 432 165 432T200 431H295Q297 429 303 425T310 420T314 415T317 404T317 389T318 363Q318 354 318 314T317 241V76H378H411",
  567: "75 -91T100 -91T138 -107T152 -144V-150L160 -151H193H203Q241 -151 267 -121Q284 -97 288 -73T292 23V151V355H218L145 356Q123 365 123 387V393Q123 422 145 430H148Q151 430 156 430T169 430T185 430T205 431T227 431T251 431H354Q356 430 360 427T365 424T369 420T372 416T373 410T375 402T376 391T377 376T377 356Q377 345 377 286T376 176Q376 -67 371 -88Q362 -123 342 -151T299 -194Q254 -228 180 -228Q84 -226 56 -177Q49 -162 48 -148Q48 -122 61 -107",
  697: "211 572Q211 593 226 608T262 623Q281 623 297 610T313 573Q313 561 307 465Q301 370 299 357T284 336Q279 334 262 334Q240 334 231 343Q226 350 225 362T217 465Q211 549 211 572",
  768: "-409 569Q-409 586 -399 596T-377 610Q-376 610 -372 610T-365 611Q-355 610 -284 588T-210 563Q-195 556 -195 537Q-195 533 -197 522T-208 498T-229 485Q-238 485 -312 508T-388 533Q-400 538 -405 552Q-409 559 -409 569",
  769: "-297 485Q-315 485 -323 505T-331 537Q-331 556 -316 563Q-307 569 -170 610Q-169 610 -165 610T-157 611Q-141 609 -131 600T-119 584T-117 569Q-117 555 -124 545T-138 533Q-140 531 -214 508T-297 485",
  770: "-387 460Q-404 460 -416 479T-429 512Q-429 527 -419 534Q-416 536 -347 571T-272 609Q-269 611 -261 611Q-254 610 -182 574Q-168 567 -156 561T-136 550T-123 543T-114 538T-109 535T-105 532T-103 529T-100 525Q-97 518 -97 512Q-97 498 -109 479T-139 460H-141Q-148 460 -209 496L-263 526L-317 496Q-378 460 -387 460",
  771: "-400 467Q-412 467 -425 480T-438 509Q-437 520 -414 543Q-353 602 -316 609Q-306 611 -301 611Q-279 611 -262 596T-235 566T-221 551Q-206 551 -158 594Q-142 610 -129 610H-125Q-114 610 -101 597T-88 568Q-89 557 -112 534Q-177 469 -220 466Q-247 466 -265 481T-291 511T-305 526Q-320 526 -368 483Q-384 467 -396 467H-400",
  772: "-429 500Q-440 504 -445 511T-450 522T-452 536Q-452 552 -451 556Q-445 571 -434 574T-379 578Q-369 578 -330 578T-261 577H-96Q-94 575 -90 573T-85 569T-81 564T-77 558T-75 550T-74 538Q-74 522 -78 515T-96 500H-429",
  774: "-446 579Q-446 611 -412 611H-407Q-383 609 -378 599T-358 587Q-340 583 -263 583H-235Q-159 583 -152 593Q-145 611 -120 611H-117H-115Q-79 611 -79 577Q-80 552 -95 536T-140 514T-191 506T-251 504H-263H-274Q-311 504 -334 505T-386 513T-431 536T-446 579",
  776: "-421 565Q-421 590 -405 600T-370 611Q-350 611 -345 610Q-308 599 -308 565Q-308 545 -323 532T-359 519H-366H-370Q-405 519 -418 547Q-421 553 -421 565ZM-218 565Q-218 580 -208 593T-179 610Q-177 610 -175 610T-171 611Q-170 612 -158 612Q-130 611 -117 597T-104 565T-116 534T-160 519H-167Q-189 519 -203 532T-218 565",
  778: "-344 558Q-344 583 -321 601T-262 619Q-225 619 -204 600T-182 560Q-182 536 -205 518T-264 499Q-301 499 -322 519T-344 558ZM-223 559Q-223 570 -234 579T-261 588T-289 580T-303 559Q-303 549 -293 540T-263 530T-234 539T-223 559",
  780: "-427 525Q-427 542 -417 559T-392 577Q-385 577 -323 553L-263 530L-203 553Q-143 576 -136 576Q-118 576 -109 559T-99 525Q-99 508 -107 502T-161 481Q-177 475 -186 472Q-256 449 -263 449Q-272 449 -339 472T-412 498Q-420 501 -423 508T-427 520V525",
  913: "191 76Q212 75 220 68T229 38Q229 10 208 1H129H80Q48 1 38 7T28 38Q28 51 29 57T40 69T70 76Q89 76 89 78Q90 79 117 205T173 461T205 599Q212 623 250 623H262H273Q312 623 319 599Q322 591 350 461T406 205T435 78Q435 76 454 76H458Q484 76 493 59Q496 53 496 38Q496 11 478 3Q474 1 395 1H317Q295 8 295 38Q295 65 311 73Q316 75 333 76L348 77V78Q348 80 341 112L334 143H190L183 112Q176 80 176 78Q175 76 178 76Q180 76 191 76ZM318 221Q313 238 288 366T263 519Q263 526 262 527Q261 527 261 520Q261 493 236 365T206 221Q206 219 262 219T318 221",
  914: "39 1Q17 10 17 32V38V46Q17 65 34 73Q40 76 61 76H84V535H61H54Q27 535 19 553Q17 557 17 573Q17 583 17 587T23 599T39 610Q40 611 179 611Q320 610 332 607Q332 607 339 605Q394 591 427 547T461 454Q461 413 436 378T369 325L358 320Q405 311 443 270T482 169Q482 112 445 64T345 3L334 1H39ZM309 533Q302 535 234 535H168V356H230Q284 357 296 358T323 368Q346 380 361 402T377 452Q377 482 358 505T309 533ZM398 176Q396 218 371 246T315 279Q310 280 237 280H168V76H239Q316 77 327 81Q329 82 334 84Q398 107 398 176",
  915: "466 611Q468 609 473 606T479 602T483 598T486 593T487 586T488 576T488 562V526V488Q488 452 470 444Q466 442 446 442Q421 442 413 450Q406 457 405 463T404 501V535H185V76H222H239Q260 76 270 69T281 38Q281 12 270 6T209 0H155H104Q48 0 37 5T25 38Q25 59 35 69Q44 76 76 76H101V535H76H64Q36 535 27 552Q25 557 25 573T27 594Q33 606 43 608T106 611H258H466",
  916: "232 622H237Q242 622 249 622T264 623H293Q295 622 300 619T308 613T314 608T319 601Q322 597 405 316T489 19Q489 9 473 1Q471 0 262 0T51 1Q35 9 35 19Q35 34 118 315T205 601Q214 616 232 622ZM267 501Q266 504 265 510T263 521T261 526V523Q261 508 211 332Q142 91 138 82H386Q385 84 345 224Q281 439 267 501",
  917: "374 271Q374 241 367 232T332 223Q307 223 299 231Q290 240 290 263V279H173V76H418V118V144Q418 167 426 176T460 186Q491 186 500 166Q502 161 502 93V52Q502 25 499 17T480 1H41Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q44 535 38 537T25 548T19 573Q19 602 41 610H47Q53 610 63 610T88 610T121 610T160 611T204 611T251 611H458Q460 609 465 606T471 602T475 598T478 593T479 586T480 576T480 562V526V488Q480 452 462 444Q458 442 438 442Q413 442 405 450Q398 457 397 463T396 501V535H173V355H290V371Q290 394 299 403T332 412Q363 412 372 392Q374 387 374 317V271",
  918: "71 1Q60 5 55 11T49 23T48 39V46Q48 56 58 73T131 183Q171 242 197 282L366 535H144V501Q144 470 143 464T135 450Q127 442 102 442H94Q71 442 62 461Q60 466 60 527L61 589Q70 607 83 610H88Q93 610 102 610T124 610T154 610T188 611T227 611T270 611H454Q456 609 461 606T467 601T471 597T474 591T475 584T476 572V565Q476 555 466 538T393 428Q353 369 327 329L158 76H397V120V146Q397 169 405 179T439 189Q470 189 479 169Q481 164 481 95V48Q481 24 478 16T459 1H71",
  919: "16 571Q16 597 27 604T74 611H125H208Q223 602 226 596T230 573Q230 559 227 551T217 540T204 536T186 535H165V356H359V535H338H333Q306 535 297 552Q295 556 295 573Q295 586 295 590T301 600T317 611H486Q501 602 504 596T508 573Q508 559 505 551T495 540T482 536T464 535H443V76H464H470Q482 76 489 75T502 64T508 38Q508 10 486 1H317Q306 5 301 11T296 21T295 38V44Q295 66 311 73Q318 76 338 76H359V280H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60Q45 535 38 536T24 545T16 571",
  920: "102 588Q140 621 240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 185 460 118T422 23Q382 -10 289 -10H262H235Q142 -10 102 23Q74 50 65 118T56 306Q56 427 64 494T102 588ZM262 66Q285 66 300 67T329 74T351 86T366 108T376 138T381 181T383 235T384 306Q384 452 371 492T304 544Q296 545 251 545Q230 545 215 543T188 534T169 520T155 497T147 466T143 423T141 371T140 306Q140 247 141 215T146 151T158 107T179 82T212 69T262 66ZM179 356Q187 378 219 378H223Q240 377 249 372T260 360L261 355Q261 353 262 353T263 355Q263 362 272 369Q280 377 304 377H310Q325 377 331 374T346 356V256Q338 241 331 238T309 234H304Q280 234 272 242Q263 249 263 256Q263 258 262 258T261 256Q261 249 252 242Q244 234 220 234H216Q186 234 179 256V356",
  921: "400 76Q431 76 441 69T452 38Q452 29 452 26T450 18T443 9T430 1H95Q84 6 79 12T73 23T72 38Q72 65 90 73Q96 76 157 76H220V535H157H124Q93 535 83 542T72 573Q72 603 93 610Q97 611 264 611H430Q432 609 436 607T444 602T449 594Q452 588 452 573Q452 546 434 538Q428 535 367 535H304V76H367H400",
  922: "18 549T18 573T29 604T70 611H118H193Q207 603 210 596T214 573Q214 549 198 538Q191 535 172 535H152V421Q152 344 152 326T153 309L242 422L329 534Q327 535 322 536T314 538T308 542T303 548T300 558T298 573Q298 600 316 608Q322 611 392 611H463Q477 602 481 595T485 573Q485 535 446 535H441H420L281 357L436 77L454 76Q473 75 478 73Q495 62 495 38Q495 10 473 1H345Q334 5 329 11T324 21T323 38Q323 51 324 56T332 68T355 77L233 296L152 192V76H172Q191 76 198 73Q214 63 214 38Q214 9 193 1H41Q18 8 18 38Q18 61 35 73Q42 76 61 76H81V535H61Q42 535 35 538Q18 549 18 573",
  923: "30 38Q30 57 38 66T70 76Q88 76 88 78Q89 79 117 207T173 466T205 602Q213 617 231 622H236Q241 622 249 622T264 623H294Q315 609 319 602Q321 598 350 468T407 208T435 78Q436 76 454 76Q470 76 478 73Q495 62 495 38Q495 10 473 1H313Q290 10 290 38Q290 56 297 65T310 74T331 76Q350 76 350 78Q349 80 328 176T285 383T263 520Q263 526 262 527Q261 527 261 521Q261 497 240 388T198 181T174 78Q174 76 193 76Q220 75 227 65Q234 56 234 38Q234 28 234 24T228 13T212 1H52Q30 9 30 32V38",
  924: "50 535Q37 536 31 537T18 547T12 573Q12 598 22 604T62 611H91H121Q147 611 158 607T178 587Q183 579 222 446T261 293Q261 289 262 288Q263 288 263 292Q263 311 298 434T346 588Q353 603 365 607T402 611H435H450Q488 611 500 605T512 573Q512 556 506 547T493 537T474 535H459V76H474Q487 75 493 74T505 64T512 38Q512 11 494 3Q490 1 424 1H386Q355 1 345 7T335 38Q335 55 341 64T354 74T373 76H388V302Q388 512 387 519Q382 482 346 359T304 228Q292 204 262 204T220 228Q215 237 179 359T137 519Q136 512 136 302V76H151Q164 75 170 74T182 64T189 38Q189 11 171 3Q167 1 101 1H63Q32 1 22 7T12 38Q12 55 18 64T31 74T50 76H65V535H50",
  925: "20 571Q20 598 30 604T73 611H105H136Q152 611 160 611T177 607T189 601T198 587T206 568T217 537T231 497Q354 142 365 95L368 84V535H347H342Q314 535 306 552Q304 556 304 573Q304 586 304 590T310 600T326 611H482Q497 602 500 596T504 573Q504 559 501 551T491 540T478 536T460 535H439V25Q432 7 424 4T389 0H374Q334 0 322 31L293 115Q171 468 159 517L156 528V76H177H183Q195 76 202 75T215 64T221 38Q221 10 199 1H43Q32 5 27 11T22 21T21 38V44Q21 66 37 73Q44 76 64 76H85V535H64Q49 535 42 536T28 545T20 571",
  926: "37 555V569Q37 605 60 610H66Q71 610 81 610T105 610T137 610T175 611T217 611T264 611H465Q467 609 471 606T477 602T481 599T484 594T485 588T487 580T487 570T487 554Q487 526 486 520T478 506Q470 498 445 498T412 506Q403 515 403 531V539H121V531Q121 498 86 498H79H71Q48 498 39 517Q37 522 37 555ZM109 318V346Q109 366 113 374T132 389H170Q193 379 193 359V354H331V359Q331 379 354 389H392Q407 381 411 373T415 342V318V290Q415 270 411 262T392 247H354Q331 257 331 277V282H193V277Q193 257 170 247H132Q117 255 113 263T109 294V318ZM56 1Q41 7 37 15T33 42V58V80Q33 101 41 110T77 119Q87 118 91 118T103 114T114 103T117 83V72H407V83Q407 101 416 110T449 119T482 110Q489 103 490 97T491 59V41Q491 24 487 16T469 1H56",
  927: "102 588Q140 621 240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 185 460 118T422 23Q382 -10 289 -10H262H235Q142 -10 102 23Q74 50 65 118T56 306Q56 427 64 494T102 588ZM363 513Q357 523 347 530T324 540T302 544T280 546H268Q192 546 167 521Q150 501 145 452T140 300Q140 235 142 197T151 130T172 89T207 71T262 65Q317 65 341 81T374 144T384 300Q384 474 363 513",
  928: "60 535Q45 535 38 536T24 545T16 571Q16 603 36 609Q41 611 264 611H486Q501 602 504 596T508 573Q508 559 505 551T495 540T482 536T464 535H443V76H464H470Q482 76 489 75T502 64T508 38Q508 10 486 1H317Q306 5 301 11T296 21T295 38V44Q295 66 311 73Q318 76 338 76H359V535H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60",
  929: "41 1Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q38 535 29 543T19 576Q19 603 41 610H49Q57 610 70 610T100 610T136 611T175 611Q190 611 216 611T255 612Q321 612 363 598T441 537Q480 486 480 427V421Q480 354 447 311T378 251Q339 230 275 230H239H173V76H197Q220 76 227 73Q244 62 244 38Q244 10 222 1H41ZM396 421Q396 461 369 491T300 533Q294 534 233 535H173V306H233Q294 307 300 308Q345 319 370 352T396 421",
  931: "40 575Q40 576 40 579T41 583T41 588T43 593T46 597T50 602T55 606T63 610H68Q74 610 84 610T108 610T139 610T176 611T219 611T264 611H462Q464 609 469 606T475 602T479 598T482 593T483 586T484 576T484 562V526V488Q484 452 466 444Q462 442 442 442Q417 442 409 450Q402 457 401 463T400 501V535H153Q153 533 218 430Q233 405 250 378T276 336T286 319Q290 311 290 307Q290 296 239 211Q229 194 223 184L161 78H400V112Q400 142 401 149T409 163Q418 172 442 172Q473 172 482 152Q484 147 484 86V49Q484 25 481 17T462 1H63Q41 10 41 31Q41 39 43 44Q43 45 81 109T157 238L195 303Q195 307 119 430T41 557T40 575",
  932: "129 38Q129 51 129 55T135 65T151 76H220V535H110V501Q110 470 109 464T101 450Q93 442 68 442H60Q37 442 28 461Q26 466 26 527L27 589Q36 607 49 610H55Q61 610 72 610T97 610T131 610T170 611T215 611T264 611H476Q478 609 483 606T489 602T493 598T496 593T497 586T498 576T498 562V526V488Q498 452 480 444Q476 442 456 442Q431 442 423 450Q416 457 415 463T414 501V535H304V76H374Q389 67 392 61T396 38Q396 10 374 1H151Q140 5 135 11T130 21T129 38",
  933: "38 494Q38 549 74 585T152 621Q168 621 179 619T209 606T241 566T262 492Q262 494 265 507T270 526T276 547T285 569T298 589T315 606T337 617T365 622Q416 622 451 584T486 494Q486 470 469 461Q464 459 445 459H437Q416 459 406 476Q404 479 403 502T393 541T365 558Q350 558 340 548T323 519T312 475T307 419T305 354T304 282Q304 254 304 239V76H358Q372 67 376 60T380 38Q380 10 358 1H167Q145 9 145 32V38Q145 54 148 60T167 76H220V239Q220 256 220 289T220 338T219 383T217 426T214 463T209 497T201 522T189 543T174 555Q168 558 159 558Q139 558 131 541T121 502T118 476Q108 459 84 459H79H71Q38 459 38 494",
  934: "139 573V578Q139 603 161 610H166Q172 610 182 610T204 610T232 611T264 611H364Q379 602 382 595T385 573Q385 544 364 536L334 535H304V441H306Q313 440 325 438T367 426T421 403T464 364T483 306Q483 251 430 216T317 172Q315 172 313 172T308 170H306H304V76H364Q379 67 382 60T385 38Q385 28 385 24T379 12T364 1H161Q139 8 139 33V38Q139 46 139 49T141 58T148 68T161 76H220V170H218Q211 171 199 173T157 185T103 208T60 248T41 306Q41 361 94 396T208 439Q210 439 212 439T216 440L218 441H220V535H190L161 536Q139 543 139 573ZM124 306Q124 286 147 271T194 252L218 247Q220 247 220 306V364H218Q212 364 192 359T148 340T124 306ZM400 305Q400 325 377 340T330 360L306 364Q304 364 304 306Q304 247 306 247Q312 247 332 252T376 271T400 305",
  935: "39 571Q39 597 49 604T93 611H141H218Q233 602 236 595T239 573Q239 538 210 535Q202 535 202 534T215 507T243 454L257 428L307 535H298Q266 538 266 573Q266 584 267 588T273 598T289 611H366H401Q442 611 454 605T466 573Q466 546 448 538Q442 535 421 535H398L299 327Q299 323 362 201L426 77L449 76Q467 76 475 75T489 65T495 38Q495 11 477 3Q473 1 395 1H317Q295 8 295 38Q295 73 325 76L334 77Q333 78 314 117T276 196L257 235L239 196Q221 157 204 118T186 77Q190 76 196 76Q211 74 218 67T227 55T228 38Q228 28 227 24T221 13T206 1H50Q28 9 28 32V38Q28 63 45 73Q51 76 73 76H96L214 324Q215 327 162 431L108 535H85H79Q67 535 60 536T46 546T39 571",
  936: "37 439Q38 451 40 457T52 469T77 475H79Q96 475 107 473T132 456T152 411Q152 409 153 396T154 372V365Q154 291 198 261Q215 251 219 251Q220 251 220 393V535H193L167 536Q145 545 145 567V573Q145 602 167 610Q168 611 264 611H358Q372 602 376 595T380 573Q380 545 358 536L331 535H304V393Q304 251 305 251Q307 251 310 252T323 259T339 272T355 295T367 331Q368 337 370 372Q370 382 371 395T372 411Q376 434 384 448T404 467T425 474T447 475Q461 474 467 473T480 463T487 437Q487 419 481 412Q476 403 459 398Q457 390 453 344T431 263Q415 228 383 205T332 177T306 172H304V76H358Q372 67 376 60T380 38Q380 10 358 1H167Q145 9 145 32V38Q145 54 148 60T167 76H220V172H218Q211 172 192 177T141 205T93 263Q74 298 71 343T67 391L66 398Q47 403 42 411T37 433V439",
  937: "40 404Q40 498 106 560T258 622Q357 622 420 558T484 406Q484 359 469 311T428 205T392 117Q382 84 382 78Q382 76 402 76H421V87Q421 110 431 116T457 123Q474 123 483 114Q490 107 491 100T492 61V42Q492 11 474 3Q470 1 397 1H324Q302 9 302 32V39Q302 104 351 225T400 405Q400 462 361 504T262 546Q200 546 162 504T124 405Q124 346 171 230T223 42V36Q223 11 205 3Q201 1 128 1H55Q39 7 33 23L32 60V80Q32 94 34 102T44 116T68 123Q103 123 103 87V76H123Q142 76 142 78Q142 100 117 156T66 282T40 404",
  8215: "57 -60Q57 -33 86 -25H438Q468 -34 468 -60T438 -95H86Q57 -86 57 -60",
  8242: "211 572Q211 593 226 608T262 623Q281 623 297 610T313 573Q313 561 307 465Q301 370 299 357T284 336Q279 334 262 334Q240 334 231 343Q226 350 225 362T217 465Q211 549 211 572",
  8260: "94 -83Q78 -83 68 -73T58 -48Q58 -44 60 -36Q62 -31 227 314T399 673Q410 694 431 694Q445 694 455 684T466 659Q466 656 464 648Q463 643 298 298T125 -62Q114 -83 94 -83",
  8710: "232 622H237Q242 622 249 622T264 623H293Q295 622 300 619T308 613T314 608T319 601Q322 597 405 316T489 19Q489 9 473 1Q471 0 262 0T51 1Q35 9 35 19Q35 34 118 315T205 601Q214 616 232 622ZM267 501Q266 504 265 510T263 521T261 526V523Q261 508 211 332Q142 91 138 82H386Q385 84 345 224Q281 439 267 501"
}, {
  8243: "′′",
  8244: "′′′",
  8279: "′′′′"
});
var $i = {}, Zi = {};
Object.defineProperty(Zi, "__esModule", { value: !0 });
Zi.normal = void 0;
Zi.normal = {
  32: [0, 0, 0.25],
  33: [0.716, 0, 0.278],
  34: [0.694, -0.379, 0.5],
  35: [0.694, 0.194, 0.833],
  36: [0.75, 0.056, 0.5],
  37: [0.75, 0.056, 0.833],
  38: [0.716, 0.022, 0.778],
  39: [0.694, -0.379, 0.278],
  40: [0.75, 0.25, 0.389],
  41: [0.75, 0.25, 0.389],
  42: [0.75, -0.32, 0.5],
  43: [0.583, 0.082, 0.778],
  44: [0.121, 0.194, 0.278],
  45: [0.252, -0.179, 0.333],
  46: [0.12, 0, 0.278],
  47: [0.75, 0.25, 0.5],
  48: [0.666, 0.022, 0.5],
  49: [0.666, 0, 0.5],
  50: [0.666, 0, 0.5],
  51: [0.665, 0.022, 0.5],
  52: [0.677, 0, 0.5],
  53: [0.666, 0.022, 0.5],
  54: [0.666, 0.022, 0.5],
  55: [0.676, 0.022, 0.5],
  56: [0.666, 0.022, 0.5],
  57: [0.666, 0.022, 0.5],
  58: [0.43, 0, 0.278],
  59: [0.43, 0.194, 0.278],
  60: [0.54, 0.04, 0.778],
  61: [0.583, 0.082, 0.778],
  62: [0.54, 0.04, 0.778],
  63: [0.705, 0, 0.472],
  64: [0.705, 0.011, 0.778],
  65: [0.716, 0, 0.75],
  66: [0.683, 0, 0.708],
  67: [0.705, 0.021, 0.722],
  68: [0.683, 0, 0.764],
  69: [0.68, 0, 0.681],
  70: [0.68, 0, 0.653],
  71: [0.705, 0.022, 0.785],
  72: [0.683, 0, 0.75],
  73: [0.683, 0, 0.361],
  74: [0.683, 0.022, 0.514],
  75: [0.683, 0, 0.778],
  76: [0.683, 0, 0.625],
  77: [0.683, 0, 0.917],
  78: [0.683, 0, 0.75],
  79: [0.705, 0.022, 0.778],
  80: [0.683, 0, 0.681],
  81: [0.705, 0.193, 0.778],
  82: [0.683, 0.022, 0.736],
  83: [0.705, 0.022, 0.556],
  84: [0.677, 0, 0.722],
  85: [0.683, 0.022, 0.75],
  86: [0.683, 0.022, 0.75],
  87: [0.683, 0.022, 1.028],
  88: [0.683, 0, 0.75],
  89: [0.683, 0, 0.75],
  90: [0.683, 0, 0.611],
  91: [0.75, 0.25, 0.278],
  92: [0.75, 0.25, 0.5],
  93: [0.75, 0.25, 0.278],
  94: [0.694, -0.531, 0.5],
  95: [-0.025, 0.062, 0.5],
  96: [0.699, -0.505, 0.5],
  97: [0.448, 0.011, 0.5],
  98: [0.694, 0.011, 0.556],
  99: [0.448, 0.011, 0.444],
  100: [0.694, 0.011, 0.556],
  101: [0.448, 0.011, 0.444],
  102: [0.705, 0, 0.306, { ic: 0.066 }],
  103: [0.453, 0.206, 0.5],
  104: [0.694, 0, 0.556],
  105: [0.669, 0, 0.278],
  106: [0.669, 0.205, 0.306],
  107: [0.694, 0, 0.528],
  108: [0.694, 0, 0.278],
  109: [0.442, 0, 0.833],
  110: [0.442, 0, 0.556],
  111: [0.448, 0.01, 0.5],
  112: [0.442, 0.194, 0.556],
  113: [0.442, 0.194, 0.528],
  114: [0.442, 0, 0.392],
  115: [0.448, 0.011, 0.394],
  116: [0.615, 0.01, 0.389],
  117: [0.442, 0.011, 0.556],
  118: [0.431, 0.011, 0.528],
  119: [0.431, 0.011, 0.722],
  120: [0.431, 0, 0.528],
  121: [0.431, 0.204, 0.528],
  122: [0.431, 0, 0.444],
  123: [0.75, 0.25, 0.5],
  124: [0.75, 0.249, 0.278],
  125: [0.75, 0.25, 0.5],
  126: [0.318, -0.215, 0.5],
  160: [0, 0, 0.25],
  163: [0.714, 0.011, 0.769],
  165: [0.683, 0, 0.75],
  168: [0.669, -0.554, 0.5],
  172: [0.356, -0.089, 0.667],
  174: [0.709, 0.175, 0.947],
  175: [0.59, -0.544, 0.5],
  176: [0.715, -0.542, 0.5],
  177: [0.666, 0, 0.778],
  180: [0.699, -0.505, 0.5],
  183: [0.31, -0.19, 0.278],
  215: [0.491, -9e-3, 0.778],
  240: [0.749, 0.021, 0.556],
  247: [0.537, 0.036, 0.778],
  305: [0.442, 0, 0.278, { sk: 0.0278 }],
  567: [0.442, 0.205, 0.306, { sk: 0.0833 }],
  697: [0.56, -0.043, 0.275],
  710: [0.694, -0.531, 0.5],
  711: [0.644, -0.513, 0.5],
  713: [0.59, -0.544, 0.5],
  714: [0.699, -0.505, 0.5],
  715: [0.699, -0.505, 0.5],
  728: [0.694, -0.515, 0.5],
  729: [0.669, -0.549, 0.5],
  730: [0.715, -0.542, 0.5],
  732: [0.668, -0.565, 0.5],
  768: [0.699, -0.505, 0],
  769: [0.699, -0.505, 0],
  770: [0.694, -0.531, 0],
  771: [0.668, -0.565, 0],
  772: [0.59, -0.544, 0],
  774: [0.694, -0.515, 0],
  775: [0.669, -0.549, 0],
  776: [0.669, -0.554, 0],
  778: [0.715, -0.542, 0],
  779: [0.701, -0.51, 0],
  780: [0.644, -0.513, 0],
  824: [0.716, 0.215, 0],
  913: [0.716, 0, 0.75],
  914: [0.683, 0, 0.708],
  915: [0.68, 0, 0.625],
  916: [0.716, 0, 0.833],
  917: [0.68, 0, 0.681],
  918: [0.683, 0, 0.611],
  919: [0.683, 0, 0.75],
  920: [0.705, 0.022, 0.778],
  921: [0.683, 0, 0.361],
  922: [0.683, 0, 0.778],
  923: [0.716, 0, 0.694],
  924: [0.683, 0, 0.917],
  925: [0.683, 0, 0.75],
  926: [0.677, 0, 0.667],
  927: [0.705, 0.022, 0.778],
  928: [0.68, 0, 0.75],
  929: [0.683, 0, 0.681],
  931: [0.683, 0, 0.722],
  932: [0.677, 0, 0.722],
  933: [0.705, 0, 0.778],
  934: [0.683, 0, 0.722],
  935: [0.683, 0, 0.75],
  936: [0.683, 0, 0.778],
  937: [0.704, 0, 0.722],
  8192: [0, 0, 0.5],
  8193: [0, 0, 1],
  8194: [0, 0, 0.5],
  8195: [0, 0, 1],
  8196: [0, 0, 0.333],
  8197: [0, 0, 0.25],
  8198: [0, 0, 0.167],
  8201: [0, 0, 0.167],
  8202: [0, 0, 0.1],
  8203: [0, 0, 0],
  8204: [0, 0, 0],
  8211: [0.285, -0.248, 0.5],
  8212: [0.285, -0.248, 1],
  8213: [0.285, -0.248, 1],
  8214: [0.75, 0.25, 0.5],
  8215: [-0.025, 0.062, 0.5],
  8216: [0.694, -0.379, 0.278],
  8217: [0.694, -0.379, 0.278],
  8220: [0.694, -0.379, 0.5],
  8221: [0.694, -0.379, 0.5],
  8224: [0.705, 0.216, 0.444],
  8225: [0.705, 0.205, 0.444],
  8226: [0.444, -0.055, 0.5],
  8230: [0.12, 0, 1.172],
  8242: [0.56, -0.043, 0.275],
  8243: [0.56, 0, 0.55],
  8244: [0.56, 0, 0.825],
  8245: [0.56, -0.043, 0.275],
  8246: [0.56, 0, 0.55],
  8247: [0.56, 0, 0.825],
  8254: [0.59, -0.544, 0.5],
  8260: [0.75, 0.25, 0.5],
  8279: [0.56, 0, 1.1],
  8288: [0, 0, 0],
  8289: [0, 0, 0],
  8290: [0, 0, 0],
  8291: [0, 0, 0],
  8292: [0, 0, 0],
  8407: [0.714, -0.516, 0.5],
  8450: [0.702, 0.019, 0.722],
  8459: [0.717, 0.036, 0.969, { ic: 0.272, sk: 0.333 }],
  8460: [0.666, 0.133, 0.72],
  8461: [0.683, 0, 0.778],
  8462: [0.694, 0.011, 0.576, { sk: -0.0278 }],
  8463: [0.695, 0.013, 0.54, { ic: 0.022 }],
  8464: [0.717, 0.017, 0.809, { ic: 0.137, sk: 0.333 }],
  8465: [0.686, 0.026, 0.554],
  8466: [0.717, 0.017, 0.874, { ic: 0.161, sk: 0.306 }],
  8467: [0.705, 0.02, 0.417, { sk: 0.111 }],
  8469: [0.683, 0.02, 0.722],
  8472: [0.453, 0.216, 0.636, { sk: 0.111 }],
  8473: [0.683, 0, 0.611],
  8474: [0.701, 0.181, 0.778],
  8475: [0.717, 0.017, 0.85, { ic: 0.037, sk: 0.194 }],
  8476: [0.686, 0.026, 0.828],
  8477: [0.683, 0, 0.722],
  8484: [0.683, 0, 0.667],
  8486: [0.704, 0, 0.722],
  8487: [0.684, 0.022, 0.722],
  8488: [0.729, 0.139, 0.602],
  8492: [0.708, 0.028, 0.908, { ic: 0.02, sk: 0.194 }],
  8493: [0.685, 0.024, 0.613],
  8496: [0.707, 8e-3, 0.562, { ic: 0.156, sk: 0.139 }],
  8497: [0.735, 0.036, 0.895, { ic: 0.095, sk: 0.222 }],
  8498: [0.695, 0, 0.556],
  8499: [0.721, 0.05, 1.08, { ic: 0.136, sk: 0.444 }],
  8501: [0.694, 0, 0.611],
  8502: [0.763, 0.021, 0.667, { ic: 0.02 }],
  8503: [0.764, 0.043, 0.444],
  8504: [0.764, 0.043, 0.667],
  8513: [0.705, 0.023, 0.639],
  8592: [0.511, 0.011, 1],
  8593: [0.694, 0.193, 0.5],
  8594: [0.511, 0.011, 1],
  8595: [0.694, 0.194, 0.5],
  8596: [0.511, 0.011, 1],
  8597: [0.772, 0.272, 0.5],
  8598: [0.72, 0.195, 1],
  8599: [0.72, 0.195, 1],
  8600: [0.695, 0.22, 1],
  8601: [0.695, 0.22, 1],
  8602: [0.437, -0.06, 1],
  8603: [0.437, -0.06, 1],
  8606: [0.417, -0.083, 1],
  8608: [0.417, -0.083, 1],
  8610: [0.417, -0.083, 1.111],
  8611: [0.417, -0.083, 1.111],
  8614: [0.511, 0.011, 1],
  8617: [0.511, 0.011, 1.126],
  8618: [0.511, 0.011, 1.126],
  8619: [0.575, 0.041, 1],
  8620: [0.575, 0.041, 1],
  8621: [0.417, -0.083, 1.389],
  8622: [0.437, -0.06, 1],
  8624: [0.722, 0, 0.5],
  8625: [0.722, 0, 0.5],
  8630: [0.461, 0, 1],
  8631: [0.46, 0, 1],
  8634: [0.65, 0.083, 0.778],
  8635: [0.65, 0.083, 0.778],
  8636: [0.511, -0.23, 1],
  8637: [0.27, 0.011, 1],
  8638: [0.694, 0.194, 0.417],
  8639: [0.694, 0.194, 0.417],
  8640: [0.511, -0.23, 1],
  8641: [0.27, 0.011, 1],
  8642: [0.694, 0.194, 0.417],
  8643: [0.694, 0.194, 0.417],
  8644: [0.667, 0, 1],
  8646: [0.667, 0, 1],
  8647: [0.583, 0.083, 1],
  8648: [0.694, 0.193, 0.833],
  8649: [0.583, 0.083, 1],
  8650: [0.694, 0.194, 0.833],
  8651: [0.514, 0.014, 1],
  8652: [0.671, 0.011, 1],
  8653: [0.534, 0.035, 1],
  8654: [0.534, 0.037, 1],
  8655: [0.534, 0.035, 1],
  8656: [0.525, 0.024, 1],
  8657: [0.694, 0.194, 0.611],
  8658: [0.525, 0.024, 1],
  8659: [0.694, 0.194, 0.611],
  8660: [0.526, 0.025, 1],
  8661: [0.772, 0.272, 0.611],
  8666: [0.611, 0.111, 1],
  8667: [0.611, 0.111, 1],
  8669: [0.417, -0.083, 1],
  8672: [0.437, -0.064, 1.334],
  8674: [0.437, -0.064, 1.334],
  8704: [0.694, 0.022, 0.556],
  8705: [0.846, 0.021, 0.5],
  8706: [0.715, 0.022, 0.531, { ic: 0.035, sk: 0.0833 }],
  8707: [0.694, 0, 0.556],
  8708: [0.716, 0.215, 0.556],
  8709: [0.772, 0.078, 0.5],
  8710: [0.716, 0, 0.833],
  8711: [0.683, 0.033, 0.833],
  8712: [0.54, 0.04, 0.667],
  8713: [0.716, 0.215, 0.667],
  8715: [0.54, 0.04, 0.667],
  8716: [0.716, 0.215, 0.667],
  8717: [0.44, 0, 0.429, { ic: 0.027 }],
  8719: [0.75, 0.25, 0.944],
  8720: [0.75, 0.25, 0.944],
  8721: [0.75, 0.25, 1.056],
  8722: [0.583, 0.082, 0.778],
  8723: [0.5, 0.166, 0.778],
  8724: [0.766, 0.093, 0.778],
  8725: [0.75, 0.25, 0.5],
  8726: [0.75, 0.25, 0.5],
  8727: [0.465, -0.035, 0.5],
  8728: [0.444, -0.055, 0.5],
  8729: [0.444, -0.055, 0.5],
  8730: [0.8, 0.2, 0.833, { ic: 0.02 }],
  8733: [0.442, 0.011, 0.778],
  8734: [0.442, 0.011, 1],
  8736: [0.694, 0, 0.722],
  8737: [0.714, 0.02, 0.722],
  8738: [0.551, 0.051, 0.722],
  8739: [0.75, 0.249, 0.278],
  8740: [0.75, 0.252, 0.278, { ic: 0.019 }],
  8741: [0.75, 0.25, 0.5],
  8742: [0.75, 0.25, 0.5, { ic: 0.018 }],
  8743: [0.598, 0.022, 0.667],
  8744: [0.598, 0.022, 0.667],
  8745: [0.598, 0.022, 0.667],
  8746: [0.598, 0.022, 0.667],
  8747: [0.716, 0.216, 0.417, { ic: 0.055 }],
  8748: [0.805, 0.306, 0.819, { ic: 0.138 }],
  8749: [0.805, 0.306, 1.166, { ic: 0.138 }],
  8750: [0.805, 0.306, 0.472, { ic: 0.138 }],
  8756: [0.471, 0.082, 0.667],
  8757: [0.471, 0.082, 0.667],
  8764: [0.367, -0.133, 0.778],
  8765: [0.367, -0.133, 0.778],
  8768: [0.583, 0.083, 0.278],
  8769: [0.467, -0.032, 0.778],
  8770: [0.463, -0.034, 0.778],
  8771: [0.464, -0.036, 0.778],
  8772: [0.716, 0.215, 0.778],
  8773: [0.589, -0.022, 0.778],
  8775: [0.652, 0.155, 0.778],
  8776: [0.483, -0.055, 0.778],
  8777: [0.716, 0.215, 0.778],
  8778: [0.579, 0.039, 0.778],
  8781: [0.484, -0.016, 0.778],
  8782: [0.492, -8e-3, 0.778],
  8783: [0.492, -0.133, 0.778],
  8784: [0.67, -0.133, 0.778],
  8785: [0.609, 0.108, 0.778],
  8786: [0.601, 0.101, 0.778],
  8787: [0.601, 0.102, 0.778],
  8790: [0.367, -0.133, 0.778],
  8791: [0.721, -0.133, 0.778],
  8796: [0.859, -0.133, 0.778],
  8800: [0.716, 0.215, 0.778],
  8801: [0.464, -0.036, 0.778],
  8802: [0.716, 0.215, 0.778],
  8804: [0.636, 0.138, 0.778],
  8805: [0.636, 0.138, 0.778],
  8806: [0.753, 0.175, 0.778],
  8807: [0.753, 0.175, 0.778],
  8808: [0.752, 0.286, 0.778],
  8809: [0.752, 0.286, 0.778],
  8810: [0.568, 0.067, 1],
  8811: [0.567, 0.067, 1],
  8812: [0.75, 0.25, 0.5],
  8813: [0.716, 0.215, 0.778],
  8814: [0.708, 0.209, 0.778],
  8815: [0.708, 0.209, 0.778],
  8816: [0.801, 0.303, 0.778],
  8817: [0.801, 0.303, 0.778],
  8818: [0.732, 0.228, 0.778],
  8819: [0.732, 0.228, 0.778],
  8820: [0.732, 0.228, 0.778],
  8821: [0.732, 0.228, 0.778],
  8822: [0.681, 0.253, 0.778],
  8823: [0.681, 0.253, 0.778],
  8824: [0.716, 0.253, 0.778],
  8825: [0.716, 0.253, 0.778],
  8826: [0.539, 0.041, 0.778],
  8827: [0.539, 0.041, 0.778],
  8828: [0.58, 0.153, 0.778],
  8829: [0.58, 0.154, 0.778],
  8830: [0.732, 0.228, 0.778],
  8831: [0.732, 0.228, 0.778],
  8832: [0.705, 0.208, 0.778],
  8833: [0.705, 0.208, 0.778],
  8834: [0.54, 0.04, 0.778],
  8835: [0.54, 0.04, 0.778],
  8836: [0.716, 0.215, 0.778],
  8837: [0.716, 0.215, 0.778],
  8838: [0.636, 0.138, 0.778],
  8839: [0.636, 0.138, 0.778],
  8840: [0.801, 0.303, 0.778],
  8841: [0.801, 0.303, 0.778],
  8842: [0.635, 0.241, 0.778],
  8843: [0.635, 0.241, 0.778],
  8846: [0.598, 0.022, 0.667],
  8847: [0.539, 0.041, 0.778],
  8848: [0.539, 0.041, 0.778],
  8849: [0.636, 0.138, 0.778],
  8850: [0.636, 0.138, 0.778],
  8851: [0.598, 0, 0.667],
  8852: [0.598, 0, 0.667],
  8853: [0.583, 0.083, 0.778],
  8854: [0.583, 0.083, 0.778],
  8855: [0.583, 0.083, 0.778],
  8856: [0.583, 0.083, 0.778],
  8857: [0.583, 0.083, 0.778],
  8858: [0.582, 0.082, 0.778],
  8859: [0.582, 0.082, 0.778],
  8861: [0.582, 0.082, 0.778],
  8862: [0.689, 0, 0.778],
  8863: [0.689, 0, 0.778],
  8864: [0.689, 0, 0.778],
  8865: [0.689, 0, 0.778],
  8866: [0.694, 0, 0.611],
  8867: [0.694, 0, 0.611],
  8868: [0.668, 0, 0.778],
  8869: [0.668, 0, 0.778],
  8872: [0.75, 0.249, 0.867],
  8873: [0.694, 0, 0.722],
  8874: [0.694, 0, 0.889],
  8876: [0.695, 0, 0.611],
  8877: [0.695, 0, 0.611],
  8878: [0.695, 0, 0.722],
  8879: [0.695, 0, 0.722],
  8882: [0.539, 0.041, 0.778],
  8883: [0.539, 0.041, 0.778],
  8884: [0.636, 0.138, 0.778],
  8885: [0.636, 0.138, 0.778],
  8888: [0.408, -0.092, 1.111],
  8890: [0.431, 0.212, 0.556],
  8891: [0.716, 0, 0.611],
  8892: [0.716, 0, 0.611],
  8896: [0.75, 0.249, 0.833],
  8897: [0.75, 0.249, 0.833],
  8898: [0.75, 0.249, 0.833],
  8899: [0.75, 0.249, 0.833],
  8900: [0.488, -0.012, 0.5],
  8901: [0.31, -0.19, 0.278],
  8902: [0.486, -0.016, 0.5],
  8903: [0.545, 0.044, 0.778],
  8904: [0.505, 5e-3, 0.9],
  8905: [0.492, -8e-3, 0.778],
  8906: [0.492, -8e-3, 0.778],
  8907: [0.694, 0.022, 0.778],
  8908: [0.694, 0.022, 0.778],
  8909: [0.464, -0.036, 0.778],
  8910: [0.578, 0.021, 0.76],
  8911: [0.578, 0.022, 0.76],
  8912: [0.54, 0.04, 0.778],
  8913: [0.54, 0.04, 0.778],
  8914: [0.598, 0.022, 0.667],
  8915: [0.598, 0.022, 0.667],
  8916: [0.736, 0.022, 0.667],
  8918: [0.541, 0.041, 0.778],
  8919: [0.541, 0.041, 0.778],
  8920: [0.568, 0.067, 1.333],
  8921: [0.568, 0.067, 1.333],
  8922: [0.886, 0.386, 0.778],
  8923: [0.886, 0.386, 0.778],
  8926: [0.734, 0, 0.778],
  8927: [0.734, 0, 0.778],
  8928: [0.801, 0.303, 0.778],
  8929: [0.801, 0.303, 0.778],
  8930: [0.716, 0.215, 0.778],
  8931: [0.716, 0.215, 0.778],
  8934: [0.73, 0.359, 0.778],
  8935: [0.73, 0.359, 0.778],
  8936: [0.73, 0.359, 0.778],
  8937: [0.73, 0.359, 0.778],
  8938: [0.706, 0.208, 0.778],
  8939: [0.706, 0.208, 0.778],
  8940: [0.802, 0.303, 0.778],
  8941: [0.801, 0.303, 0.778],
  8942: [1.3, 0.03, 0.278],
  8943: [0.31, -0.19, 1.172],
  8945: [1.52, -0.1, 1.282],
  8965: [0.716, 0, 0.611],
  8966: [0.813, 0.097, 0.611],
  8968: [0.75, 0.25, 0.444],
  8969: [0.75, 0.25, 0.444],
  8970: [0.75, 0.25, 0.444],
  8971: [0.75, 0.25, 0.444],
  8988: [0.694, -0.306, 0.5],
  8989: [0.694, -0.306, 0.5],
  8990: [0.366, 0.022, 0.5],
  8991: [0.366, 0.022, 0.5],
  8994: [0.388, -0.122, 1],
  8995: [0.378, -0.134, 1],
  9001: [0.75, 0.25, 0.389],
  9002: [0.75, 0.25, 0.389],
  9136: [0.744, 0.244, 0.412],
  9137: [0.744, 0.244, 0.412],
  9168: [0.602, 0, 0.667],
  9416: [0.709, 0.175, 0.902],
  9484: [0.694, -0.306, 0.5],
  9488: [0.694, -0.306, 0.5],
  9492: [0.366, 0.022, 0.5],
  9496: [0.366, 0.022, 0.5],
  9585: [0.694, 0.195, 0.889],
  9586: [0.694, 0.195, 0.889],
  9632: [0.689, 0, 0.778],
  9633: [0.689, 0, 0.778],
  9642: [0.689, 0, 0.778],
  9650: [0.575, 0.02, 0.722],
  9651: [0.716, 0, 0.889],
  9652: [0.575, 0.02, 0.722],
  9653: [0.716, 0, 0.889],
  9654: [0.539, 0.041, 0.778],
  9656: [0.539, 0.041, 0.778],
  9657: [0.505, 5e-3, 0.5],
  9660: [0.576, 0.019, 0.722],
  9661: [0.5, 0.215, 0.889],
  9662: [0.576, 0.019, 0.722],
  9663: [0.5, 0.215, 0.889],
  9664: [0.539, 0.041, 0.778],
  9666: [0.539, 0.041, 0.778],
  9667: [0.505, 5e-3, 0.5],
  9674: [0.716, 0.132, 0.667],
  9711: [0.715, 0.215, 1],
  9723: [0.689, 0, 0.778],
  9724: [0.689, 0, 0.778],
  9733: [0.694, 0.111, 0.944],
  9824: [0.727, 0.13, 0.778],
  9825: [0.716, 0.033, 0.778],
  9826: [0.727, 0.162, 0.778],
  9827: [0.726, 0.13, 0.778],
  9837: [0.75, 0.022, 0.389],
  9838: [0.734, 0.223, 0.389],
  9839: [0.723, 0.223, 0.389],
  10003: [0.706, 0.034, 0.833],
  10016: [0.716, 0.022, 0.833],
  10072: [0.75, 0.249, 0.278],
  10216: [0.75, 0.25, 0.389],
  10217: [0.75, 0.25, 0.389],
  10222: [0.744, 0.244, 0.412],
  10223: [0.744, 0.244, 0.412],
  10229: [0.511, 0.011, 1.609],
  10230: [0.511, 0.011, 1.638],
  10231: [0.511, 0.011, 1.859],
  10232: [0.525, 0.024, 1.609],
  10233: [0.525, 0.024, 1.638],
  10234: [0.525, 0.024, 1.858],
  10236: [0.511, 0.011, 1.638],
  10731: [0.716, 0.132, 0.667],
  10744: [0.716, 0.215, 0.778],
  10752: [0.75, 0.25, 1.111],
  10753: [0.75, 0.25, 1.111],
  10754: [0.75, 0.25, 1.111],
  10756: [0.75, 0.249, 0.833],
  10758: [0.75, 0.249, 0.833],
  10764: [0.805, 0.306, 1.638, { ic: 0.138 }],
  10799: [0.491, -9e-3, 0.778],
  10815: [0.683, 0, 0.75],
  10846: [0.813, 0.097, 0.611],
  10877: [0.636, 0.138, 0.778],
  10878: [0.636, 0.138, 0.778],
  10885: [0.762, 0.29, 0.778],
  10886: [0.762, 0.29, 0.778],
  10887: [0.635, 0.241, 0.778],
  10888: [0.635, 0.241, 0.778],
  10889: [0.761, 0.387, 0.778],
  10890: [0.761, 0.387, 0.778],
  10891: [1.003, 0.463, 0.778],
  10892: [1.003, 0.463, 0.778],
  10901: [0.636, 0.138, 0.778],
  10902: [0.636, 0.138, 0.778],
  10927: [0.636, 0.138, 0.778],
  10928: [0.636, 0.138, 0.778],
  10933: [0.752, 0.286, 0.778],
  10934: [0.752, 0.286, 0.778],
  10935: [0.761, 0.294, 0.778],
  10936: [0.761, 0.294, 0.778],
  10937: [0.761, 0.337, 0.778],
  10938: [0.761, 0.337, 0.778],
  10949: [0.753, 0.215, 0.778],
  10950: [0.753, 0.215, 0.778],
  10955: [0.783, 0.385, 0.778],
  10956: [0.783, 0.385, 0.778],
  12296: [0.75, 0.25, 0.389],
  12297: [0.75, 0.25, 0.389],
  57350: [0.43, 0.023, 0.222, { ic: 0.018 }],
  57351: [0.431, 0.024, 0.389, { ic: 0.018 }],
  57352: [0.605, 0.085, 0.778],
  57353: [0.434, 6e-3, 0.667, { ic: 0.067 }],
  57356: [0.752, 0.284, 0.778],
  57357: [0.752, 0.284, 0.778],
  57358: [0.919, 0.421, 0.778],
  57359: [0.801, 0.303, 0.778],
  57360: [0.801, 0.303, 0.778],
  57361: [0.919, 0.421, 0.778],
  57366: [0.828, 0.33, 0.778],
  57367: [0.752, 0.332, 0.778],
  57368: [0.828, 0.33, 0.778],
  57369: [0.752, 0.333, 0.778],
  57370: [0.634, 0.255, 0.778],
  57371: [0.634, 0.254, 0.778],
  119808: [0.698, 0, 0.869],
  119809: [0.686, 0, 0.818],
  119810: [0.697, 0.011, 0.831],
  119811: [0.686, 0, 0.882],
  119812: [0.68, 0, 0.756],
  119813: [0.68, 0, 0.724],
  119814: [0.697, 0.01, 0.904],
  119815: [0.686, 0, 0.9],
  119816: [0.686, 0, 0.436],
  119817: [0.686, 0.011, 0.594],
  119818: [0.686, 0, 0.901],
  119819: [0.686, 0, 0.692],
  119820: [0.686, 0, 1.092],
  119821: [0.686, 0, 0.9],
  119822: [0.696, 0.01, 0.864],
  119823: [0.686, 0, 0.786],
  119824: [0.696, 0.193, 0.864],
  119825: [0.686, 0.011, 0.862],
  119826: [0.697, 0.011, 0.639],
  119827: [0.675, 0, 0.8],
  119828: [0.686, 0.011, 0.885],
  119829: [0.686, 7e-3, 0.869],
  119830: [0.686, 7e-3, 1.189],
  119831: [0.686, 0, 0.869],
  119832: [0.686, 0, 0.869],
  119833: [0.686, 0, 0.703],
  119834: [0.453, 6e-3, 0.559],
  119835: [0.694, 6e-3, 0.639],
  119836: [0.453, 6e-3, 0.511],
  119837: [0.694, 6e-3, 0.639],
  119838: [0.452, 6e-3, 0.527],
  119839: [0.7, 0, 0.351, { ic: 0.101 }],
  119840: [0.455, 0.201, 0.575],
  119841: [0.694, 0, 0.639],
  119842: [0.695, 0, 0.319],
  119843: [0.695, 0.2, 0.351],
  119844: [0.694, 0, 0.607],
  119845: [0.694, 0, 0.319],
  119846: [0.45, 0, 0.958],
  119847: [0.45, 0, 0.639],
  119848: [0.452, 5e-3, 0.575],
  119849: [0.45, 0.194, 0.639],
  119850: [0.45, 0.194, 0.607],
  119851: [0.45, 0, 0.474],
  119852: [0.453, 6e-3, 0.454],
  119853: [0.635, 5e-3, 0.447],
  119854: [0.45, 6e-3, 0.639],
  119855: [0.444, 0, 0.607],
  119856: [0.444, 0, 0.831],
  119857: [0.444, 0, 0.607],
  119858: [0.444, 0.2, 0.607],
  119859: [0.444, 0, 0.511],
  119860: [0.716, 0, 0.75, { sk: 0.139 }],
  119861: [0.683, 0, 0.759, { sk: 0.0833 }],
  119862: [0.705, 0.022, 0.715, { ic: 0.045, sk: 0.0833 }],
  119863: [0.683, 0, 0.828, { sk: 0.0556 }],
  119864: [0.68, 0, 0.738, { ic: 0.026, sk: 0.0833 }],
  119865: [0.68, 0, 0.643, { ic: 0.106, sk: 0.0833 }],
  119866: [0.705, 0.022, 0.786, { sk: 0.0833 }],
  119867: [0.683, 0, 0.831, { ic: 0.057, sk: 0.0556 }],
  119868: [0.683, 0, 0.44, { ic: 0.064, sk: 0.111 }],
  119869: [0.683, 0.022, 0.555, { ic: 0.078, sk: 0.167 }],
  119870: [0.683, 0, 0.849, { ic: 0.04, sk: 0.0556 }],
  119871: [0.683, 0, 0.681, { sk: 0.0278 }],
  119872: [0.683, 0, 0.97, { ic: 0.081, sk: 0.0833 }],
  119873: [0.683, 0, 0.803, { ic: 0.085, sk: 0.0833 }],
  119874: [0.704, 0.022, 0.763, { sk: 0.0833 }],
  119875: [0.683, 0, 0.642, { ic: 0.109, sk: 0.0833 }],
  119876: [0.704, 0.194, 0.791, { sk: 0.0833 }],
  119877: [0.683, 0.021, 0.759, { sk: 0.0833 }],
  119878: [0.705, 0.022, 0.613, { ic: 0.032, sk: 0.0833 }],
  119879: [0.677, 0, 0.584, { ic: 0.12, sk: 0.0833 }],
  119880: [0.683, 0.022, 0.683, { ic: 0.084, sk: 0.0278 }],
  119881: [0.683, 0.022, 0.583, { ic: 0.186 }],
  119882: [0.683, 0.022, 0.944, { ic: 0.104 }],
  119883: [0.683, 0, 0.828, { ic: 0.024, sk: 0.0833 }],
  119884: [0.683, 0, 0.581, { ic: 0.182 }],
  119885: [0.683, 0, 0.683, { ic: 0.04, sk: 0.0833 }],
  119886: [0.441, 0.01, 0.529],
  119887: [0.694, 0.011, 0.429],
  119888: [0.442, 0.011, 0.433, { sk: 0.0556 }],
  119889: [0.694, 0.01, 0.52, { sk: 0.167 }],
  119890: [0.442, 0.011, 0.466, { sk: 0.0556 }],
  119891: [0.705, 0.205, 0.49, { ic: 0.06, sk: 0.167 }],
  119892: [0.442, 0.205, 0.477, { sk: 0.0278 }],
  119894: [0.661, 0.011, 0.345],
  119895: [0.661, 0.204, 0.412],
  119896: [0.694, 0.011, 0.521],
  119897: [0.694, 0.011, 0.298, { sk: 0.0833 }],
  119898: [0.442, 0.011, 0.878],
  119899: [0.442, 0.011, 0.6],
  119900: [0.441, 0.011, 0.485, { sk: 0.0556 }],
  119901: [0.442, 0.194, 0.503, { sk: 0.0833 }],
  119902: [0.442, 0.194, 0.446, { ic: 0.014, sk: 0.0833 }],
  119903: [0.442, 0.011, 0.451, { sk: 0.0556 }],
  119904: [0.442, 0.01, 0.469, { sk: 0.0556 }],
  119905: [0.626, 0.011, 0.361, { sk: 0.0833 }],
  119906: [0.442, 0.011, 0.572, { sk: 0.0278 }],
  119907: [0.443, 0.011, 0.485, { sk: 0.0278 }],
  119908: [0.443, 0.011, 0.716, { sk: 0.0833 }],
  119909: [0.442, 0.011, 0.572, { sk: 0.0278 }],
  119910: [0.442, 0.205, 0.49, { sk: 0.0556 }],
  119911: [0.442, 0.011, 0.465, { sk: 0.0556 }],
  119912: [0.711, 0, 0.869, { sk: 0.16 }],
  119913: [0.686, 0, 0.866, { sk: 0.0958 }],
  119914: [0.703, 0.017, 0.817, { ic: 0.038, sk: 0.0958 }],
  119915: [0.686, 0, 0.938, { sk: 0.0639 }],
  119916: [0.68, 0, 0.81, { ic: 0.015, sk: 0.0958 }],
  119917: [0.68, 0, 0.689, { ic: 0.12, sk: 0.0958 }],
  119918: [0.703, 0.016, 0.887, { sk: 0.0958 }],
  119919: [0.686, 0, 0.982, { ic: 0.045, sk: 0.0639 }],
  119920: [0.686, 0, 0.511, { ic: 0.062, sk: 0.128 }],
  119921: [0.686, 0.017, 0.631, { ic: 0.063, sk: 0.192 }],
  119922: [0.686, 0, 0.971, { ic: 0.032, sk: 0.0639 }],
  119923: [0.686, 0, 0.756, { sk: 0.0319 }],
  119924: [0.686, 0, 1.142, { ic: 0.077, sk: 0.0958 }],
  119925: [0.686, 0, 0.95, { ic: 0.077, sk: 0.0958 }],
  119926: [0.703, 0.017, 0.837, { sk: 0.0958 }],
  119927: [0.686, 0, 0.723, { ic: 0.124, sk: 0.0958 }],
  119928: [0.703, 0.194, 0.869, { sk: 0.0958 }],
  119929: [0.686, 0.017, 0.872, { sk: 0.0958 }],
  119930: [0.703, 0.017, 0.693, { ic: 0.021, sk: 0.0958 }],
  119931: [0.675, 0, 0.637, { ic: 0.135, sk: 0.0958 }],
  119932: [0.686, 0.016, 0.8, { ic: 0.077, sk: 0.0319 }],
  119933: [0.686, 0.016, 0.678, { ic: 0.208 }],
  119934: [0.686, 0.017, 1.093, { ic: 0.114 }],
  119935: [0.686, 0, 0.947, { sk: 0.0958 }],
  119936: [0.686, 0, 0.675, { ic: 0.201 }],
  119937: [0.686, 0, 0.773, { ic: 0.032, sk: 0.0958 }],
  119938: [0.452, 8e-3, 0.633],
  119939: [0.694, 8e-3, 0.521],
  119940: [0.451, 8e-3, 0.513, { sk: 0.0639 }],
  119941: [0.694, 8e-3, 0.61, { sk: 0.192 }],
  119942: [0.452, 8e-3, 0.554, { sk: 0.0639 }],
  119943: [0.701, 0.201, 0.568, { ic: 0.056, sk: 0.192 }],
  119944: [0.452, 0.202, 0.545, { sk: 0.0319 }],
  119945: [0.694, 8e-3, 0.668, { sk: -0.0319 }],
  119946: [0.694, 8e-3, 0.405],
  119947: [0.694, 0.202, 0.471],
  119948: [0.694, 8e-3, 0.604],
  119949: [0.694, 8e-3, 0.348, { sk: 0.0958 }],
  119950: [0.452, 8e-3, 1.032],
  119951: [0.452, 8e-3, 0.713],
  119952: [0.452, 8e-3, 0.585, { sk: 0.0639 }],
  119953: [0.452, 0.194, 0.601, { sk: 0.0958 }],
  119954: [0.452, 0.194, 0.542, { sk: 0.0958 }],
  119955: [0.452, 8e-3, 0.529, { sk: 0.0639 }],
  119956: [0.451, 8e-3, 0.531, { sk: 0.0639 }],
  119957: [0.643, 7e-3, 0.415, { sk: 0.0958 }],
  119958: [0.452, 8e-3, 0.681, { sk: 0.0319 }],
  119959: [0.453, 8e-3, 0.567, { sk: 0.0319 }],
  119960: [0.453, 8e-3, 0.831, { sk: 0.0958 }],
  119961: [0.452, 8e-3, 0.659, { sk: 0.0319 }],
  119962: [0.452, 0.202, 0.59, { sk: 0.0639 }],
  119963: [0.452, 8e-3, 0.555, { sk: 0.0639 }],
  119964: [0.717, 8e-3, 0.803, { ic: 0.213, sk: 0.389 }],
  119966: [0.728, 0.026, 0.666, { ic: 0.153, sk: 0.278 }],
  119967: [0.708, 0.031, 0.774, { ic: 0.081, sk: 0.111 }],
  119970: [0.717, 0.037, 0.61, { ic: 0.128, sk: 0.25 }],
  119973: [0.717, 0.314, 1.052, { ic: 0.081, sk: 0.417 }],
  119974: [0.717, 0.037, 0.914, { ic: 0.29, sk: 0.361 }],
  119977: [0.726, 0.036, 0.902, { ic: 0.306, sk: 0.389 }],
  119978: [0.707, 8e-3, 0.738, { ic: 0.067, sk: 0.167 }],
  119979: [0.716, 0.037, 1.013, { ic: 0.018, sk: 0.222 }],
  119980: [0.717, 0.017, 0.883, { sk: 0.278 }],
  119982: [0.708, 0.036, 0.868, { ic: 0.148, sk: 0.333 }],
  119983: [0.735, 0.037, 0.747, { ic: 0.249, sk: 0.222 }],
  119984: [0.717, 0.017, 0.8, { ic: 0.16, sk: 0.25 }],
  119985: [0.717, 0.017, 0.622, { ic: 0.228, sk: 0.222 }],
  119986: [0.717, 0.017, 0.805, { ic: 0.221, sk: 0.25 }],
  119987: [0.717, 0.017, 0.944, { ic: 0.187, sk: 0.278 }],
  119988: [0.716, 0.017, 0.71, { ic: 0.249, sk: 0.194 }],
  119989: [0.717, 0.016, 0.821, { ic: 0.211, sk: 0.306 }],
  120068: [0.696, 0.026, 0.718],
  120069: [0.691, 0.027, 0.884],
  120071: [0.685, 0.027, 0.832],
  120072: [0.685, 0.024, 0.663],
  120073: [0.686, 0.153, 0.611],
  120074: [0.69, 0.026, 0.785],
  120077: [0.686, 0.139, 0.552],
  120078: [0.68, 0.027, 0.668, { ic: 0.014 }],
  120079: [0.686, 0.026, 0.666],
  120080: [0.692, 0.027, 1.05],
  120081: [0.686, 0.025, 0.832],
  120082: [0.729, 0.027, 0.827],
  120083: [0.692, 0.218, 0.828],
  120084: [0.729, 0.069, 0.827],
  120086: [0.692, 0.027, 0.829],
  120087: [0.701, 0.027, 0.669],
  120088: [0.697, 0.027, 0.646, { ic: 0.019 }],
  120089: [0.686, 0.026, 0.831],
  120090: [0.686, 0.027, 1.046],
  120091: [0.688, 0.027, 0.719],
  120092: [0.686, 0.218, 0.833],
  120094: [0.47, 0.035, 0.5],
  120095: [0.685, 0.031, 0.513],
  120096: [0.466, 0.029, 0.389],
  120097: [0.609, 0.033, 0.499],
  120098: [0.467, 0.03, 0.401],
  120099: [0.681, 0.221, 0.326],
  120100: [0.47, 0.209, 0.504],
  120101: [0.688, 0.205, 0.521],
  120102: [0.673, 0.02, 0.279],
  120103: [0.672, 0.208, 0.281],
  120104: [0.689, 0.025, 0.389],
  120105: [0.685, 0.02, 0.28],
  120106: [0.475, 0.026, 0.767],
  120107: [0.475, 0.022, 0.527],
  120108: [0.48, 0.028, 0.489],
  120109: [0.541, 0.212, 0.5],
  120110: [0.479, 0.219, 0.489],
  120111: [0.474, 0.021, 0.389],
  120112: [0.478, 0.029, 0.443],
  120113: [0.64, 0.02, 0.333, { ic: 0.015 }],
  120114: [0.474, 0.023, 0.517],
  120115: [0.53, 0.028, 0.512],
  120116: [0.532, 0.028, 0.774],
  120117: [0.472, 0.188, 0.389],
  120118: [0.528, 0.218, 0.499],
  120119: [0.471, 0.214, 0.391],
  120120: [0.701, 0, 0.722],
  120121: [0.683, 0, 0.667],
  120123: [0.683, 0, 0.722],
  120124: [0.683, 0, 0.667],
  120125: [0.683, 0, 0.611],
  120126: [0.702, 0.019, 0.778],
  120128: [0.683, 0, 0.389],
  120129: [0.683, 0.077, 0.5],
  120130: [0.683, 0, 0.778],
  120131: [0.683, 0, 0.667],
  120132: [0.683, 0, 0.944],
  120134: [0.701, 0.019, 0.778],
  120138: [0.702, 0.012, 0.556],
  120139: [0.683, 0, 0.667],
  120140: [0.683, 0.019, 0.722],
  120141: [0.683, 0.02, 0.722],
  120142: [0.683, 0.019, 1],
  120143: [0.683, 0, 0.722],
  120144: [0.683, 0, 0.722],
  120172: [0.686, 0.031, 0.847],
  120173: [0.684, 0.031, 1.044],
  120174: [0.676, 0.032, 0.723],
  120175: [0.683, 0.029, 0.982],
  120176: [0.686, 0.029, 0.783],
  120177: [0.684, 0.146, 0.722],
  120178: [0.687, 0.029, 0.927],
  120179: [0.683, 0.126, 0.851],
  120180: [0.681, 0.025, 0.655],
  120181: [0.68, 0.141, 0.652],
  120182: [0.681, 0.026, 0.789, { ic: 0.017 }],
  120183: [0.683, 0.028, 0.786],
  120184: [0.683, 0.032, 1.239],
  120185: [0.679, 0.03, 0.983],
  120186: [0.726, 0.03, 0.976],
  120187: [0.688, 0.223, 0.977],
  120188: [0.726, 0.083, 0.976],
  120189: [0.688, 0.028, 0.978],
  120190: [0.685, 0.031, 0.978],
  120191: [0.686, 0.03, 0.79, { ic: 0.012 }],
  120192: [0.688, 0.039, 0.851, { ic: 0.02 }],
  120193: [0.685, 0.029, 0.982],
  120194: [0.683, 0.03, 1.235],
  120195: [0.681, 0.035, 0.849],
  120196: [0.688, 0.214, 0.984],
  120197: [0.677, 0.148, 0.711],
  120198: [0.472, 0.032, 0.603],
  120199: [0.69, 0.032, 0.59],
  120200: [0.473, 0.026, 0.464],
  120201: [0.632, 0.028, 0.589],
  120202: [0.471, 0.027, 0.472],
  120203: [0.687, 0.222, 0.388],
  120204: [0.472, 0.208, 0.595],
  120205: [0.687, 0.207, 0.615],
  120206: [0.686, 0.025, 0.331],
  120207: [0.682, 0.203, 0.332],
  120208: [0.682, 0.025, 0.464],
  120209: [0.681, 0.024, 0.337],
  120210: [0.476, 0.031, 0.921],
  120211: [0.473, 0.028, 0.654],
  120212: [0.482, 0.034, 0.609],
  120213: [0.557, 0.207, 0.604],
  120214: [0.485, 0.211, 0.596],
  120215: [0.472, 0.026, 0.46],
  120216: [0.479, 0.034, 0.523],
  120217: [0.648, 0.027, 0.393, { ic: 0.014 }],
  120218: [0.472, 0.032, 0.589, { ic: 0.014 }],
  120219: [0.546, 0.027, 0.604],
  120220: [0.549, 0.032, 0.918],
  120221: [0.471, 0.188, 0.459],
  120222: [0.557, 0.221, 0.589],
  120223: [0.471, 0.214, 0.461],
  120224: [0.694, 0, 0.667],
  120225: [0.694, 0, 0.667],
  120226: [0.705, 0.011, 0.639],
  120227: [0.694, 0, 0.722],
  120228: [0.691, 0, 0.597],
  120229: [0.691, 0, 0.569],
  120230: [0.704, 0.011, 0.667],
  120231: [0.694, 0, 0.708],
  120232: [0.694, 0, 0.278],
  120233: [0.694, 0.022, 0.472],
  120234: [0.694, 0, 0.694],
  120235: [0.694, 0, 0.542],
  120236: [0.694, 0, 0.875],
  120237: [0.694, 0, 0.708],
  120238: [0.715, 0.022, 0.736],
  120239: [0.694, 0, 0.639],
  120240: [0.715, 0.125, 0.736],
  120241: [0.694, 0, 0.646],
  120242: [0.716, 0.022, 0.556],
  120243: [0.688, 0, 0.681],
  120244: [0.694, 0.022, 0.688],
  120245: [0.694, 0, 0.667],
  120246: [0.694, 0, 0.944],
  120247: [0.694, 0, 0.667],
  120248: [0.694, 0, 0.667],
  120249: [0.694, 0, 0.611],
  120250: [0.46, 0.01, 0.481],
  120251: [0.694, 0.011, 0.517],
  120252: [0.46, 0.01, 0.444],
  120253: [0.694, 0.01, 0.517],
  120254: [0.461, 0.01, 0.444],
  120255: [0.705, 0, 0.306, { ic: 0.041 }],
  120256: [0.455, 0.206, 0.5],
  120257: [0.694, 0, 0.517],
  120258: [0.68, 0, 0.239],
  120259: [0.68, 0.205, 0.267],
  120260: [0.694, 0, 0.489],
  120261: [0.694, 0, 0.239],
  120262: [0.455, 0, 0.794],
  120263: [0.455, 0, 0.517],
  120264: [0.46, 0.01, 0.5],
  120265: [0.455, 0.194, 0.517],
  120266: [0.455, 0.194, 0.517],
  120267: [0.455, 0, 0.342],
  120268: [0.46, 0.01, 0.383],
  120269: [0.571, 0.01, 0.361],
  120270: [0.444, 0.01, 0.517],
  120271: [0.444, 0, 0.461],
  120272: [0.444, 0, 0.683],
  120273: [0.444, 0, 0.461],
  120274: [0.444, 0.204, 0.461],
  120275: [0.444, 0, 0.435],
  120276: [0.694, 0, 0.733],
  120277: [0.694, 0, 0.733],
  120278: [0.704, 0.011, 0.703],
  120279: [0.694, 0, 0.794],
  120280: [0.691, 0, 0.642],
  120281: [0.691, 0, 0.611],
  120282: [0.705, 0.011, 0.733],
  120283: [0.694, 0, 0.794],
  120284: [0.694, 0, 0.331],
  120285: [0.694, 0.022, 0.519],
  120286: [0.694, 0, 0.764],
  120287: [0.694, 0, 0.581],
  120288: [0.694, 0, 0.978],
  120289: [0.694, 0, 0.794],
  120290: [0.716, 0.022, 0.794],
  120291: [0.694, 0, 0.703],
  120292: [0.716, 0.106, 0.794],
  120293: [0.694, 0, 0.703],
  120294: [0.716, 0.022, 0.611],
  120295: [0.688, 0, 0.733],
  120296: [0.694, 0.022, 0.764],
  120297: [0.694, 0, 0.733],
  120298: [0.694, 0, 1.039],
  120299: [0.694, 0, 0.733],
  120300: [0.694, 0, 0.733],
  120301: [0.694, 0, 0.672],
  120302: [0.475, 0.011, 0.525],
  120303: [0.694, 0.01, 0.561],
  120304: [0.475, 0.011, 0.489],
  120305: [0.694, 0.011, 0.561],
  120306: [0.474, 0.01, 0.511],
  120307: [0.705, 0, 0.336, { ic: 0.045 }],
  120308: [0.469, 0.206, 0.55],
  120309: [0.694, 0, 0.561],
  120310: [0.695, 0, 0.256],
  120311: [0.695, 0.205, 0.286],
  120312: [0.694, 0, 0.531],
  120313: [0.694, 0, 0.256],
  120314: [0.469, 0, 0.867],
  120315: [0.468, 0, 0.561],
  120316: [0.474, 0.011, 0.55],
  120317: [0.469, 0.194, 0.561],
  120318: [0.469, 0.194, 0.561],
  120319: [0.469, 0, 0.372],
  120320: [0.474, 0.01, 0.422],
  120321: [0.589, 0.01, 0.404],
  120322: [0.458, 0.011, 0.561],
  120323: [0.458, 0, 0.5],
  120324: [0.458, 0, 0.744],
  120325: [0.458, 0, 0.5],
  120326: [0.458, 0.205, 0.5],
  120327: [0.458, 0, 0.476],
  120328: [0.694, 0, 0.667],
  120329: [0.694, 0, 0.667, { ic: 0.029 }],
  120330: [0.705, 0.01, 0.639, { ic: 0.08 }],
  120331: [0.694, 0, 0.722, { ic: 0.025 }],
  120332: [0.691, 0, 0.597, { ic: 0.091 }],
  120333: [0.691, 0, 0.569, { ic: 0.104 }],
  120334: [0.705, 0.011, 0.667, { ic: 0.063 }],
  120335: [0.694, 0, 0.708, { ic: 0.06 }],
  120336: [0.694, 0, 0.278, { ic: 0.06 }],
  120337: [0.694, 0.022, 0.472, { ic: 0.063 }],
  120338: [0.694, 0, 0.694, { ic: 0.091 }],
  120339: [0.694, 0, 0.542],
  120340: [0.694, 0, 0.875, { ic: 0.054 }],
  120341: [0.694, 0, 0.708, { ic: 0.058 }],
  120342: [0.716, 0.022, 0.736, { ic: 0.027 }],
  120343: [0.694, 0, 0.639, { ic: 0.051 }],
  120344: [0.716, 0.125, 0.736, { ic: 0.027 }],
  120345: [0.694, 0, 0.646, { ic: 0.052 }],
  120346: [0.716, 0.022, 0.556, { ic: 0.053 }],
  120347: [0.688, 0, 0.681, { ic: 0.109 }],
  120348: [0.694, 0.022, 0.688, { ic: 0.059 }],
  120349: [0.694, 0, 0.667, { ic: 0.132 }],
  120350: [0.694, 0, 0.944, { ic: 0.132 }],
  120351: [0.694, 0, 0.667, { ic: 0.091 }],
  120352: [0.694, 0, 0.667, { ic: 0.143 }],
  120353: [0.694, 0, 0.611, { ic: 0.091 }],
  120354: [0.461, 0.01, 0.481],
  120355: [0.694, 0.011, 0.517, { ic: 0.022 }],
  120356: [0.46, 0.011, 0.444, { ic: 0.055 }],
  120357: [0.694, 0.01, 0.517, { ic: 0.071 }],
  120358: [0.46, 0.011, 0.444, { ic: 0.028 }],
  120359: [0.705, 0, 0.306, { ic: 0.188 }],
  120360: [0.455, 0.206, 0.5, { ic: 0.068 }],
  120361: [0.694, 0, 0.517],
  120362: [0.68, 0, 0.239, { ic: 0.076 }],
  120363: [0.68, 0.204, 0.267, { ic: 0.069 }],
  120364: [0.694, 0, 0.489, { ic: 0.054 }],
  120365: [0.694, 0, 0.239, { ic: 0.072 }],
  120366: [0.455, 0, 0.794],
  120367: [0.454, 0, 0.517],
  120368: [0.461, 0.011, 0.5, { ic: 0.023 }],
  120369: [0.455, 0.194, 0.517, { ic: 0.021 }],
  120370: [0.455, 0.194, 0.517, { ic: 0.021 }],
  120371: [0.455, 0, 0.342, { ic: 0.082 }],
  120372: [0.461, 0.011, 0.383, { ic: 0.053 }],
  120373: [0.571, 0.011, 0.361, { ic: 0.049 }],
  120374: [0.444, 0.01, 0.517, { ic: 0.02 }],
  120375: [0.444, 0, 0.461, { ic: 0.079 }],
  120376: [0.444, 0, 0.683, { ic: 0.079 }],
  120377: [0.444, 0, 0.461, { ic: 0.076 }],
  120378: [0.444, 0.205, 0.461, { ic: 0.079 }],
  120379: [0.444, 0, 0.435, { ic: 0.059 }],
  120432: [0.623, 0, 0.525],
  120433: [0.611, 0, 0.525],
  120434: [0.622, 0.011, 0.525],
  120435: [0.611, 0, 0.525],
  120436: [0.611, 0, 0.525],
  120437: [0.611, 0, 0.525],
  120438: [0.622, 0.011, 0.525],
  120439: [0.611, 0, 0.525],
  120440: [0.611, 0, 0.525],
  120441: [0.611, 0.011, 0.525],
  120442: [0.611, 0, 0.525],
  120443: [0.611, 0, 0.525],
  120444: [0.611, 0, 0.525],
  120445: [0.611, 0, 0.525],
  120446: [0.621, 0.01, 0.525],
  120447: [0.611, 0, 0.525],
  120448: [0.621, 0.138, 0.525],
  120449: [0.611, 0.011, 0.525],
  120450: [0.622, 0.011, 0.525],
  120451: [0.611, 0, 0.525],
  120452: [0.611, 0.011, 0.525],
  120453: [0.611, 7e-3, 0.525],
  120454: [0.611, 7e-3, 0.525],
  120455: [0.611, 0, 0.525],
  120456: [0.611, 0, 0.525],
  120457: [0.611, 0, 0.525],
  120458: [0.439, 6e-3, 0.525],
  120459: [0.611, 6e-3, 0.525],
  120460: [0.44, 6e-3, 0.525],
  120461: [0.611, 6e-3, 0.525],
  120462: [0.44, 6e-3, 0.525],
  120463: [0.617, 0, 0.525],
  120464: [0.442, 0.229, 0.525],
  120465: [0.611, 0, 0.525],
  120466: [0.612, 0, 0.525],
  120467: [0.612, 0.228, 0.525],
  120468: [0.611, 0, 0.525],
  120469: [0.611, 0, 0.525],
  120470: [0.436, 0, 0.525, { ic: 0.011 }],
  120471: [0.436, 0, 0.525],
  120472: [0.44, 6e-3, 0.525],
  120473: [0.437, 0.221, 0.525],
  120474: [0.437, 0.221, 0.525, { ic: 0.02 }],
  120475: [0.437, 0, 0.525],
  120476: [0.44, 6e-3, 0.525],
  120477: [0.554, 6e-3, 0.525],
  120478: [0.431, 5e-3, 0.525],
  120479: [0.431, 0, 0.525],
  120480: [0.431, 0, 0.525],
  120481: [0.431, 0, 0.525],
  120482: [0.431, 0.228, 0.525],
  120483: [0.431, 0, 0.525],
  120488: [0.698, 0, 0.869],
  120489: [0.686, 0, 0.818],
  120490: [0.68, 0, 0.692],
  120491: [0.698, 0, 0.958],
  120492: [0.68, 0, 0.756],
  120493: [0.686, 0, 0.703],
  120494: [0.686, 0, 0.9],
  120495: [0.696, 0.01, 0.894],
  120496: [0.686, 0, 0.436],
  120497: [0.686, 0, 0.901],
  120498: [0.698, 0, 0.806],
  120499: [0.686, 0, 1.092],
  120500: [0.686, 0, 0.9],
  120501: [0.675, 0, 0.767],
  120502: [0.696, 0.01, 0.864],
  120503: [0.68, 0, 0.9],
  120504: [0.686, 0, 0.786],
  120506: [0.686, 0, 0.831],
  120507: [0.675, 0, 0.8],
  120508: [0.697, 0, 0.894],
  120509: [0.686, 0, 0.831],
  120510: [0.686, 0, 0.869],
  120511: [0.686, 0, 0.894],
  120512: [0.696, 0, 0.831],
  120513: [0.686, 0.024, 0.958],
  120546: [0.716, 0, 0.75, { sk: 0.139 }],
  120547: [0.683, 0, 0.759, { sk: 0.0833 }],
  120548: [0.68, 0, 0.615, { ic: 0.106, sk: 0.0833 }],
  120549: [0.716, 0, 0.833, { sk: 0.167 }],
  120550: [0.68, 0, 0.738, { ic: 0.026, sk: 0.0833 }],
  120551: [0.683, 0, 0.683, { ic: 0.04, sk: 0.0833 }],
  120552: [0.683, 0, 0.831, { ic: 0.057, sk: 0.0556 }],
  120553: [0.704, 0.022, 0.763, { sk: 0.0833 }],
  120554: [0.683, 0, 0.44, { ic: 0.064, sk: 0.111 }],
  120555: [0.683, 0, 0.849, { ic: 0.04, sk: 0.0556 }],
  120556: [0.716, 0, 0.694, { sk: 0.167 }],
  120557: [0.683, 0, 0.97, { ic: 0.081, sk: 0.0833 }],
  120558: [0.683, 0, 0.803, { ic: 0.085, sk: 0.0833 }],
  120559: [0.677, 0, 0.742, { ic: 0.035, sk: 0.0833 }],
  120560: [0.704, 0.022, 0.763, { sk: 0.0833 }],
  120561: [0.68, 0, 0.831, { ic: 0.056, sk: 0.0556 }],
  120562: [0.683, 0, 0.642, { ic: 0.109, sk: 0.0833 }],
  120564: [0.683, 0, 0.78, { ic: 0.026, sk: 0.0833 }],
  120565: [0.677, 0, 0.584, { ic: 0.12, sk: 0.0833 }],
  120566: [0.705, 0, 0.583, { ic: 0.117, sk: 0.0556 }],
  120567: [0.683, 0, 0.667, { sk: 0.0833 }],
  120568: [0.683, 0, 0.828, { ic: 0.024, sk: 0.0833 }],
  120569: [0.683, 0, 0.612, { ic: 0.08, sk: 0.0556 }],
  120570: [0.704, 0, 0.772, { ic: 0.014, sk: 0.0833 }],
  120572: [0.442, 0.011, 0.64, { sk: 0.0278 }],
  120573: [0.705, 0.194, 0.566, { sk: 0.0833 }],
  120574: [0.441, 0.216, 0.518, { ic: 0.025 }],
  120575: [0.717, 0.01, 0.444, { sk: 0.0556 }],
  120576: [0.452, 0.022, 0.466, { sk: 0.0833 }],
  120577: [0.704, 0.204, 0.438, { ic: 0.033, sk: 0.0833 }],
  120578: [0.442, 0.216, 0.497, { sk: 0.0556 }],
  120579: [0.705, 0.01, 0.469, { sk: 0.0833 }],
  120580: [0.442, 0.01, 0.354, { sk: 0.0556 }],
  120581: [0.442, 0.011, 0.576],
  120582: [0.694, 0.012, 0.583],
  120583: [0.442, 0.216, 0.603, { sk: 0.0278 }],
  120584: [0.442, 0, 0.494, { ic: 0.036, sk: 0.0278 }],
  120585: [0.704, 0.205, 0.438, { sk: 0.111 }],
  120586: [0.441, 0.011, 0.485, { sk: 0.0556 }],
  120587: [0.431, 0.011, 0.57],
  120588: [0.442, 0.216, 0.517, { sk: 0.0833 }],
  120589: [0.442, 0.107, 0.363, { ic: 0.042, sk: 0.0833 }],
  120590: [0.431, 0.011, 0.571],
  120591: [0.431, 0.013, 0.437, { ic: 0.08, sk: 0.0278 }],
  120592: [0.443, 0.01, 0.54, { sk: 0.0278 }],
  120593: [0.442, 0.218, 0.654, { sk: 0.0833 }],
  120594: [0.442, 0.204, 0.626, { sk: 0.0556 }],
  120595: [0.694, 0.205, 0.651, { sk: 0.111 }],
  120596: [0.443, 0.011, 0.622],
  120597: [0.715, 0.022, 0.531, { ic: 0.035, sk: 0.0833 }],
  120598: [0.431, 0.011, 0.406, { sk: 0.0556 }],
  120599: [0.705, 0.011, 0.591, { sk: 0.0833 }],
  120600: [0.434, 6e-3, 0.667, { ic: 0.067 }],
  120601: [0.694, 0.205, 0.596, { sk: 0.0833 }],
  120602: [0.442, 0.194, 0.517, { sk: 0.0833 }],
  120603: [0.431, 0.01, 0.828],
  120604: [0.711, 0, 0.869, { sk: 0.16 }],
  120605: [0.686, 0, 0.866, { sk: 0.0958 }],
  120606: [0.68, 0, 0.657, { ic: 0.12, sk: 0.0958 }],
  120607: [0.711, 0, 0.958, { sk: 0.192 }],
  120608: [0.68, 0, 0.81, { ic: 0.015, sk: 0.0958 }],
  120609: [0.686, 0, 0.773, { ic: 0.032, sk: 0.0958 }],
  120610: [0.686, 0, 0.982, { ic: 0.045, sk: 0.0639 }],
  120611: [0.702, 0.017, 0.867, { sk: 0.0958 }],
  120612: [0.686, 0, 0.511, { ic: 0.062, sk: 0.128 }],
  120613: [0.686, 0, 0.971, { ic: 0.032, sk: 0.0639 }],
  120614: [0.711, 0, 0.806, { sk: 0.192 }],
  120615: [0.686, 0, 1.142, { ic: 0.077, sk: 0.0958 }],
  120616: [0.686, 0, 0.95, { ic: 0.077, sk: 0.0958 }],
  120617: [0.675, 0, 0.841, { ic: 0.026, sk: 0.0958 }],
  120618: [0.703, 0.017, 0.837, { sk: 0.0958 }],
  120619: [0.68, 0, 0.982, { ic: 0.044, sk: 0.0639 }],
  120620: [0.686, 0, 0.723, { ic: 0.124, sk: 0.0958 }],
  120622: [0.686, 0, 0.885, { ic: 0.017, sk: 0.0958 }],
  120623: [0.675, 0, 0.637, { ic: 0.135, sk: 0.0958 }],
  120624: [0.703, 0, 0.671, { ic: 0.131, sk: 0.0639 }],
  120625: [0.686, 0, 0.767, { sk: 0.0958 }],
  120626: [0.686, 0, 0.947, { sk: 0.0958 }],
  120627: [0.686, 0, 0.714, { ic: 0.076, sk: 0.0639 }],
  120628: [0.703, 0, 0.879, { sk: 0.0958 }],
  120630: [0.452, 8e-3, 0.761, { sk: 0.0319 }],
  120631: [0.701, 0.194, 0.66, { sk: 0.0958 }],
  120632: [0.451, 0.211, 0.59, { ic: 0.027 }],
  120633: [0.725, 8e-3, 0.522, { sk: 0.0639 }],
  120634: [0.461, 0.017, 0.529, { sk: 0.0958 }],
  120635: [0.711, 0.202, 0.508, { ic: 0.013, sk: 0.0958 }],
  120636: [0.452, 0.211, 0.6, { sk: 0.0639 }],
  120637: [0.702, 8e-3, 0.562, { sk: 0.0958 }],
  120638: [0.452, 8e-3, 0.412, { sk: 0.0639 }],
  120639: [0.452, 8e-3, 0.668],
  120640: [0.694, 0.013, 0.671],
  120641: [0.452, 0.211, 0.708, { sk: 0.0319 }],
  120642: [0.452, 0, 0.577, { ic: 0.031, sk: 0.0319 }],
  120643: [0.711, 0.201, 0.508, { sk: 0.128 }],
  120644: [0.452, 8e-3, 0.585, { sk: 0.0639 }],
  120645: [0.444, 8e-3, 0.682],
  120646: [0.451, 0.211, 0.612, { sk: 0.0958 }],
  120647: [0.451, 0.105, 0.424, { ic: 0.033, sk: 0.0958 }],
  120648: [0.444, 8e-3, 0.686],
  120649: [0.444, 0.013, 0.521, { ic: 0.089, sk: 0.0319 }],
  120650: [0.453, 8e-3, 0.631, { sk: 0.0319 }],
  120651: [0.452, 0.216, 0.747, { sk: 0.0958 }],
  120652: [0.452, 0.201, 0.718, { sk: 0.0639 }],
  120653: [0.694, 0.202, 0.758, { sk: 0.128 }],
  120654: [0.453, 8e-3, 0.718],
  120655: [0.71, 0.017, 0.628, { ic: 0.029, sk: 0.0958 }],
  120656: [0.444, 7e-3, 0.483, { sk: 0.0639 }],
  120657: [0.701, 8e-3, 0.692, { sk: 0.0958 }],
  120658: [0.434, 6e-3, 0.667, { ic: 0.067 }],
  120659: [0.694, 0.202, 0.712, { sk: 0.0958 }],
  120660: [0.451, 0.194, 0.612, { sk: 0.0958 }],
  120661: [0.444, 8e-3, 0.975],
  120662: [0.694, 0, 0.733],
  120663: [0.694, 0, 0.733],
  120664: [0.691, 0, 0.581],
  120665: [0.694, 0, 0.917],
  120666: [0.691, 0, 0.642],
  120667: [0.694, 0, 0.672],
  120668: [0.694, 0, 0.794],
  120669: [0.716, 0.022, 0.856],
  120670: [0.694, 0, 0.331],
  120671: [0.694, 0, 0.764],
  120672: [0.694, 0, 0.672],
  120673: [0.694, 0, 0.978],
  120674: [0.694, 0, 0.794],
  120675: [0.688, 0, 0.733],
  120676: [0.716, 0.022, 0.794],
  120677: [0.691, 0, 0.794],
  120678: [0.694, 0, 0.703],
  120680: [0.694, 0, 0.794],
  120681: [0.688, 0, 0.733],
  120682: [0.715, 0, 0.856],
  120683: [0.694, 0, 0.794],
  120684: [0.694, 0, 0.733],
  120685: [0.694, 0, 0.856],
  120686: [0.716, 0, 0.794],
  120782: [0.654, 0.01, 0.575],
  120783: [0.655, 0, 0.575],
  120784: [0.654, 0, 0.575],
  120785: [0.655, 0.011, 0.575],
  120786: [0.656, 0, 0.575],
  120787: [0.655, 0.011, 0.575],
  120788: [0.655, 0.011, 0.575],
  120789: [0.676, 0.011, 0.575],
  120790: [0.654, 0.011, 0.575],
  120791: [0.654, 0.011, 0.575],
  120802: [0.678, 0.022, 0.5],
  120803: [0.678, 0, 0.5],
  120804: [0.677, 0, 0.5],
  120805: [0.678, 0.022, 0.5],
  120806: [0.656, 0, 0.5],
  120807: [0.656, 0.021, 0.5],
  120808: [0.677, 0.022, 0.5],
  120809: [0.656, 0.011, 0.5],
  120810: [0.678, 0.022, 0.5],
  120811: [0.677, 0.022, 0.5],
  120812: [0.715, 0.022, 0.55],
  120813: [0.716, 0, 0.55],
  120814: [0.716, 0, 0.55],
  120815: [0.716, 0.022, 0.55],
  120816: [0.694, 0, 0.55],
  120817: [0.694, 0.022, 0.55],
  120818: [0.716, 0.022, 0.55],
  120819: [0.695, 0.011, 0.55],
  120820: [0.715, 0.022, 0.55],
  120821: [0.716, 0.022, 0.55],
  120822: [0.621, 0.01, 0.525],
  120823: [0.622, 0, 0.525],
  120824: [0.622, 0, 0.525],
  120825: [0.622, 0.011, 0.525],
  120826: [0.624, 0, 0.525],
  120827: [0.611, 0.01, 0.525],
  120828: [0.622, 0.011, 0.525],
  120829: [0.627, 0.01, 0.525],
  120830: [0.621, 0.01, 0.525],
  120831: [0.622, 0.011, 0.525]
};
Object.defineProperty($i, "__esModule", { value: !0 });
$i.normal = void 0;
var AH = s3, DH = Zi;
$i.normal = (0, AH.AddPaths)(DH.normal, {
  32: "",
  33: "78 661Q78 682 96 699T138 716T180 700T199 661Q199 654 179 432T158 206Q156 198 139 198Q121 198 119 206Q118 209 98 431T78 661ZM79 61Q79 89 97 105T141 121Q164 119 181 104T198 61Q198 31 181 16T139 1Q114 1 97 16T79 61",
  34: "34 634Q34 659 50 676T93 694Q121 694 144 668T168 579Q168 525 146 476T101 403T73 379Q69 379 60 388T50 401Q50 404 62 417T88 448T116 500T131 572Q131 584 130 584T125 581T112 576T94 573Q69 573 52 590T34 634ZM238 634Q238 659 254 676T297 694Q325 694 348 668T372 579Q372 525 350 476T305 403T277 379Q273 379 264 388T254 401Q254 404 266 417T292 448T320 500T335 572Q335 584 334 584T329 581T316 576T298 573Q273 573 256 590T238 634",
  35: "56 347Q56 360 70 367H313L355 524Q394 676 401 686Q406 694 416 694Q434 694 436 676Q436 672 396 522Q355 374 355 369L354 367H543L585 524Q626 679 630 685Q636 694 646 694Q653 694 659 689T665 678Q665 668 626 522Q585 374 585 369L584 367H762Q777 359 777 347Q777 334 767 331T722 327H667H572L552 251L531 174Q531 173 647 173H720Q756 173 766 170T777 153T762 133H519L477 -24Q436 -179 432 -185Q426 -194 416 -194Q409 -194 403 -189T397 -177Q397 -167 436 -21Q477 125 477 131L478 133H289L247 -24Q206 -179 202 -185Q196 -194 186 -194Q179 -194 173 -189T167 -177Q167 -167 206 -21Q247 125 247 131L248 133H70Q56 140 56 153Q56 168 72 173H260L280 249L301 326Q301 327 186 327H72Q56 332 56 347ZM531 326Q531 327 437 327H342L322 251L301 174Q301 173 395 173H490L510 249L531 326",
  36: "162 187Q162 164 146 149T109 133H103V130Q108 115 115 105Q122 92 131 82T150 64T170 52T190 44T206 40T220 37L227 36V313Q190 320 162 335Q116 358 86 404T55 508Q55 567 85 614T165 685Q186 696 225 704H227V750H273V704L286 703Q369 690 413 631Q441 588 444 531Q444 514 443 509Q439 490 425 479T391 468Q368 468 353 483T337 522Q337 546 353 560T390 575L394 576V578Q386 599 372 614T342 637T314 649T288 656L273 658V408L288 405Q329 394 355 376Q396 348 420 300T444 199Q444 130 408 76T313 1Q286 -9 276 -9H273V-56H227V-10H221Q202 -6 193 -4T155 11T108 41T74 94T55 176V182Q55 227 95 238Q103 240 108 240Q129 240 145 226T162 187ZM225 657Q219 657 204 651T169 632T135 594T121 538Q121 512 131 491T156 457T187 435T213 423T227 420V539Q227 657 225 657ZM378 169Q378 230 339 265T274 301Q273 301 273 169V37Q324 50 351 87T378 169",
  37: "465 605Q428 605 394 614T340 632T319 641Q332 608 332 548Q332 458 293 403T202 347Q145 347 101 402T56 548Q56 637 101 693T202 750Q241 750 272 719Q359 642 464 642Q580 642 650 732Q662 748 668 749Q670 750 673 750Q682 750 688 743T693 726Q178 -47 170 -52Q166 -56 160 -56Q147 -56 142 -45Q137 -36 142 -27Q143 -24 363 304Q469 462 525 546T581 630Q528 605 465 605ZM207 385Q235 385 263 427T292 548Q292 617 267 664T200 712Q193 712 186 709T167 698T147 668T134 615Q132 595 132 548V527Q132 436 165 403Q183 385 203 385H207ZM500 146Q500 234 544 290T647 347Q699 347 737 292T776 146T737 0T646 -56Q590 -56 545 0T500 146ZM651 -18Q679 -18 707 24T736 146Q736 215 711 262T644 309Q637 309 630 306T611 295T591 265T578 212Q577 200 577 146V124Q577 -18 647 -18H651",
  38: "156 540Q156 620 201 668T302 716Q354 716 377 671T401 578Q401 505 287 386L274 373Q309 285 416 148L429 132L437 142Q474 191 543 309L562 341V349Q562 368 541 376T498 385H493V431H502L626 428Q709 428 721 431H727V385H712Q688 384 669 379T639 369T618 354T603 337T591 316T578 295Q537 223 506 176T464 117T454 104Q454 102 471 85T497 62Q543 24 585 24Q618 24 648 48T682 113V121H722V112Q721 94 714 75T692 32T646 -7T574 -22Q491 -19 414 42L402 51L391 42Q312 -22 224 -22Q144 -22 93 25T42 135Q42 153 46 169T55 197T74 225T96 249T125 278T156 308L195 347L190 360Q185 372 182 382T174 411T165 448T159 491T156 540ZM361 576Q361 613 348 646T305 679Q272 679 252 649T232 572Q232 497 255 426L259 411L267 420Q361 519 361 576ZM140 164Q140 103 167 64T240 24Q271 24 304 36T356 61T374 77Q295 156 235 262L220 292L210 310L193 293Q177 277 169 268T151 229T140 164",
  39: "78 634Q78 659 95 676T138 694Q166 694 189 668T212 579Q212 525 190 476T146 403T118 379Q114 379 105 388T95 401Q95 404 107 417T133 448T161 500T176 572Q176 584 175 584T170 581T157 576T139 573Q114 573 96 590T78 634",
  40: "94 250Q94 319 104 381T127 488T164 576T202 643T244 695T277 729T302 750H315H319Q333 750 333 741Q333 738 316 720T275 667T226 581T184 443T167 250T184 58T225 -81T274 -167T316 -220T333 -241Q333 -250 318 -250H315H302L274 -226Q180 -141 137 -14T94 250",
  41: "60 749L64 750Q69 750 74 750H86L114 726Q208 641 251 514T294 250Q294 182 284 119T261 12T224 -76T186 -143T145 -194T113 -227T90 -246Q87 -249 86 -250H74Q66 -250 63 -250T58 -247T55 -238Q56 -237 66 -225Q221 -64 221 250T66 725Q56 737 55 738Q55 746 60 749",
  42: "215 721Q216 732 225 741T248 750Q263 750 273 742T284 721L270 571L327 613Q383 654 388 657T399 660Q412 660 423 650T435 624T424 600T376 575Q363 569 355 566L289 534L355 504L424 470Q435 462 435 447Q435 431 424 420T399 409Q393 409 388 412T327 456L270 498L277 423L284 348Q280 320 250 320T215 348L229 498L172 456Q116 415 111 412T100 409Q87 409 76 420T64 447Q64 461 75 470L144 504L210 534L144 566Q136 570 122 576Q83 593 74 600T64 624Q64 639 75 649T100 660Q106 660 111 657T172 613L229 571Q229 578 222 643T215 721",
  43: "56 237T56 250T70 270H369V420L370 570Q380 583 389 583Q402 583 409 568V270H707Q722 262 722 250T707 230H409V-68Q401 -82 391 -82H389H387Q375 -82 369 -68V230H70Q56 237 56 250",
  44: "78 35T78 60T94 103T137 121Q165 121 187 96T210 8Q210 -27 201 -60T180 -117T154 -158T130 -185T117 -194Q113 -194 104 -185T95 -172Q95 -168 106 -156T131 -126T157 -76T173 -3V9L172 8Q170 7 167 6T161 3T152 1T140 0Q113 0 96 17",
  45: "11 179V252H277V179H11",
  46: "78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60",
  47: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
  48: "96 585Q152 666 249 666Q297 666 345 640T423 548Q460 465 460 320Q460 165 417 83Q397 41 362 16T301 -15T250 -22Q224 -22 198 -16T137 16T82 83Q39 165 39 320Q39 494 96 585ZM321 597Q291 629 250 629Q208 629 178 597Q153 571 145 525T137 333Q137 175 145 125T181 46Q209 16 250 16Q290 16 318 46Q347 76 354 130T362 333Q362 478 354 524T321 597",
  49: "213 578L200 573Q186 568 160 563T102 556H83V602H102Q149 604 189 617T245 641T273 663Q275 666 285 666Q294 666 302 660V361L303 61Q310 54 315 52T339 48T401 46H427V0H416Q395 3 257 3Q121 3 100 0H88V46H114Q136 46 152 46T177 47T193 50T201 52T207 57T213 61V578",
  50: "109 429Q82 429 66 447T50 491Q50 562 103 614T235 666Q326 666 387 610T449 465Q449 422 429 383T381 315T301 241Q265 210 201 149L142 93L218 92Q375 92 385 97Q392 99 409 186V189H449V186Q448 183 436 95T421 3V0H50V19V31Q50 38 56 46T86 81Q115 113 136 137Q145 147 170 174T204 211T233 244T261 278T284 308T305 340T320 369T333 401T340 431T343 464Q343 527 309 573T212 619Q179 619 154 602T119 569T109 550Q109 549 114 549Q132 549 151 535T170 489Q170 464 154 447T109 429",
  51: "127 463Q100 463 85 480T69 524Q69 579 117 622T233 665Q268 665 277 664Q351 652 390 611T430 522Q430 470 396 421T302 350L299 348Q299 347 308 345T337 336T375 315Q457 262 457 175Q457 96 395 37T238 -22Q158 -22 100 21T42 130Q42 158 60 175T105 193Q133 193 151 175T169 130Q169 119 166 110T159 94T148 82T136 74T126 70T118 67L114 66Q165 21 238 21Q293 21 321 74Q338 107 338 175V195Q338 290 274 322Q259 328 213 329L171 330L168 332Q166 335 166 348Q166 366 174 366Q202 366 232 371Q266 376 294 413T322 525V533Q322 590 287 612Q265 626 240 626Q208 626 181 615T143 592T132 580H135Q138 579 143 578T153 573T165 566T175 555T183 540T186 520Q186 498 172 481T127 463",
  52: "462 0Q444 3 333 3Q217 3 199 0H190V46H221Q241 46 248 46T265 48T279 53T286 61Q287 63 287 115V165H28V211L179 442Q332 674 334 675Q336 677 355 677H373L379 671V211H471V165H379V114Q379 73 379 66T385 54Q393 47 442 46H471V0H462ZM293 211V545L74 212L183 211H293",
  53: "164 157Q164 133 148 117T109 101H102Q148 22 224 22Q294 22 326 82Q345 115 345 210Q345 313 318 349Q292 382 260 382H254Q176 382 136 314Q132 307 129 306T114 304Q97 304 95 310Q93 314 93 485V614Q93 664 98 664Q100 666 102 666Q103 666 123 658T178 642T253 634Q324 634 389 662Q397 666 402 666Q410 666 410 648V635Q328 538 205 538Q174 538 149 544L139 546V374Q158 388 169 396T205 412T256 420Q337 420 393 355T449 201Q449 109 385 44T229 -22Q148 -22 99 32T50 154Q50 178 61 192T84 210T107 214Q132 214 148 197T164 157",
  54: "42 313Q42 476 123 571T303 666Q372 666 402 630T432 550Q432 525 418 510T379 495Q356 495 341 509T326 548Q326 592 373 601Q351 623 311 626Q240 626 194 566Q147 500 147 364L148 360Q153 366 156 373Q197 433 263 433H267Q313 433 348 414Q372 400 396 374T435 317Q456 268 456 210V192Q456 169 451 149Q440 90 387 34T253 -22Q225 -22 199 -14T143 16T92 75T56 172T42 313ZM257 397Q227 397 205 380T171 335T154 278T148 216Q148 133 160 97T198 39Q222 21 251 21Q302 21 329 59Q342 77 347 104T352 209Q352 289 347 316T329 361Q302 397 257 397",
  55: "55 458Q56 460 72 567L88 674Q88 676 108 676H128V672Q128 662 143 655T195 646T364 644H485V605L417 512Q408 500 387 472T360 435T339 403T319 367T305 330T292 284T284 230T278 162T275 80Q275 66 275 52T274 28V19Q270 2 255 -10T221 -22Q210 -22 200 -19T179 0T168 40Q168 198 265 368Q285 400 349 489L395 552H302Q128 552 119 546Q113 543 108 522T98 479L95 458V455H55V458",
  56: "70 417T70 494T124 618T248 666Q319 666 374 624T429 515Q429 485 418 459T392 417T361 389T335 371T324 363L338 354Q352 344 366 334T382 323Q457 264 457 174Q457 95 399 37T249 -22Q159 -22 101 29T43 155Q43 263 172 335L154 348Q133 361 127 368Q70 417 70 494ZM286 386L292 390Q298 394 301 396T311 403T323 413T334 425T345 438T355 454T364 471T369 491T371 513Q371 556 342 586T275 624Q268 625 242 625Q201 625 165 599T128 534Q128 511 141 492T167 463T217 431Q224 426 228 424L286 386ZM250 21Q308 21 350 55T392 137Q392 154 387 169T375 194T353 216T330 234T301 253T274 270Q260 279 244 289T218 306L210 311Q204 311 181 294T133 239T107 157Q107 98 150 60T250 21",
  57: "352 287Q304 211 232 211Q154 211 104 270T44 396Q42 412 42 436V444Q42 537 111 606Q171 666 243 666Q245 666 249 666T257 665H261Q273 665 286 663T323 651T370 619T413 560Q456 472 456 334Q456 194 396 97Q361 41 312 10T208 -22Q147 -22 108 7T68 93T121 149Q143 149 158 135T173 96Q173 78 164 65T148 49T135 44L131 43Q131 41 138 37T164 27T206 22H212Q272 22 313 86Q352 142 352 280V287ZM244 248Q292 248 321 297T351 430Q351 508 343 542Q341 552 337 562T323 588T293 615T246 625Q208 625 181 598Q160 576 154 546T147 441Q147 358 152 329T172 282Q197 248 244 248",
  58: "78 370Q78 394 95 412T138 430Q162 430 180 414T199 371Q199 346 182 328T139 310T96 327T78 370ZM78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60",
  59: "78 370Q78 394 95 412T138 430Q162 430 180 414T199 371Q199 346 182 328T139 310T96 327T78 370ZM78 60Q78 85 94 103T137 121Q202 121 202 8Q202 -44 183 -94T144 -169T118 -194Q115 -194 106 -186T95 -174Q94 -171 107 -155T137 -107T160 -38Q161 -32 162 -22T165 -4T165 4Q165 5 161 4T142 0Q110 0 94 18T78 60",
  60: "694 -11T694 -19T688 -33T678 -40Q671 -40 524 29T234 166L90 235Q83 240 83 250Q83 261 91 266Q664 540 678 540Q681 540 687 534T694 519T687 505Q686 504 417 376L151 250L417 124Q686 -4 687 -5Q694 -11 694 -19",
  61: "56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153",
  62: "84 520Q84 528 88 533T96 539L99 540Q106 540 253 471T544 334L687 265Q694 260 694 250T687 235Q685 233 395 96L107 -40H101Q83 -38 83 -20Q83 -19 83 -17Q82 -10 98 -1Q117 9 248 71Q326 108 378 132L626 250L378 368Q90 504 86 509Q84 513 84 520",
  63: "226 668Q190 668 162 656T124 632L114 621Q116 621 119 620T130 616T145 607T157 591T162 567Q162 544 147 529T109 514T71 528T55 566Q55 625 100 661T199 704Q201 704 210 704T224 705H228Q281 705 320 692T378 656T407 612T416 567Q416 503 361 462Q267 395 247 303Q242 279 242 241V224Q242 205 239 202T222 198T205 201T202 218V249Q204 320 220 371T255 445T292 491T315 537Q317 546 317 574V587Q317 604 315 615T304 640T277 661T226 668ZM162 61Q162 89 180 105T224 121Q247 119 264 104T281 61Q281 31 264 16T222 1Q197 1 180 16T162 61",
  64: "56 347Q56 429 86 498T164 612T270 680T386 705Q522 705 622 603T722 349Q722 126 608 126Q541 126 513 176Q512 177 512 179T510 182L509 183Q508 183 503 177T487 163T464 146T429 132T385 126Q311 126 251 186T190 347Q190 448 251 508T385 568Q426 568 460 548T509 511T531 479H555Q580 479 582 478Q586 477 587 468Q588 454 588 338V260Q588 200 593 182T619 163Q641 163 655 178T674 223T680 273T682 325V330Q682 426 647 500Q611 569 544 618T388 668Q271 668 184 577T96 347Q96 216 180 121T396 26Q421 26 446 28T493 34T535 43T573 52T605 63T629 72T647 80T657 84H716Q722 78 722 74Q722 65 675 45T547 7T392 -11Q255 -11 156 90T56 347ZM274 347Q274 266 308 214T390 162Q420 162 449 182T498 235L504 245V449L498 459Q453 532 387 532Q347 532 311 483T274 347",
  65: "255 0Q240 3 140 3Q48 3 39 0H32V46H47Q119 49 139 88Q140 91 192 245T295 553T348 708Q351 716 366 716H376Q396 715 400 709Q402 707 508 390L617 67Q624 54 636 51T687 46H717V0H708Q699 3 581 3Q458 3 437 0H427V46H440Q510 46 510 64Q510 66 486 138L462 209H229L209 150Q189 91 189 85Q189 72 209 59T259 46H264V0H255ZM447 255L345 557L244 256Q244 255 345 255H447",
  66: "131 622Q124 629 120 631T104 634T61 637H28V683H229H267H346Q423 683 459 678T531 651Q574 627 599 590T624 512Q624 461 583 419T476 360L466 357Q539 348 595 302T651 187Q651 119 600 67T469 3Q456 1 242 0H28V46H61Q103 47 112 49T131 61V622ZM511 513Q511 560 485 594T416 636Q415 636 403 636T371 636T333 637Q266 637 251 636T232 628Q229 624 229 499V374H312L396 375L406 377Q410 378 417 380T442 393T474 417T499 456T511 513ZM537 188Q537 239 509 282T430 336L329 337H229V200V116Q229 57 234 52Q240 47 334 47H383Q425 47 443 53Q486 67 511 104T537 188",
  67: "56 342Q56 428 89 500T174 615T283 681T391 705Q394 705 400 705T408 704Q499 704 569 636L582 624L612 663Q639 700 643 704Q644 704 647 704T653 705H657Q660 705 666 699V419L660 413H626Q620 419 619 430Q610 512 571 572T476 651Q457 658 426 658Q322 658 252 588Q173 509 173 342Q173 221 211 151Q232 111 263 84T328 45T384 29T428 24Q517 24 571 93T626 244Q626 251 632 257H660L666 251V236Q661 133 590 56T403 -21Q262 -21 159 83T56 342",
  68: "130 622Q123 629 119 631T103 634T60 637H27V683H228Q399 682 419 682T461 676Q504 667 546 641T626 573T685 470T708 336Q708 210 634 116T442 3Q429 1 228 0H27V46H60Q102 47 111 49T130 61V622ZM593 338Q593 439 571 501T493 602Q439 637 355 637H322H294Q238 637 234 628Q231 624 231 344Q231 62 232 59Q233 49 248 48T339 46H350Q456 46 515 95Q561 133 577 191T593 338",
  69: "128 619Q121 626 117 628T101 631T58 634H25V680H597V676Q599 670 611 560T625 444V440H585V444Q584 447 582 465Q578 500 570 526T553 571T528 601T498 619T457 629T411 633T353 634Q266 634 251 633T233 622Q233 622 233 621Q232 619 232 497V376H286Q359 378 377 385Q413 401 416 469Q416 471 416 473V493H456V213H416V233Q415 268 408 288T383 317T349 328T297 330Q290 330 286 330H232V196V114Q232 57 237 52Q243 47 289 47H340H391Q428 47 452 50T505 62T552 92T584 146Q594 172 599 200T607 247T612 270V273H652V270Q651 267 632 137T610 3V0H25V46H58Q100 47 109 49T128 61V619",
  70: "128 619Q121 626 117 628T101 631T58 634H25V680H582V676Q584 670 596 560T610 444V440H570V444Q563 493 561 501Q555 538 543 563T516 601T477 622T431 631T374 633H334H286Q252 633 244 631T233 621Q232 619 232 490V363H284Q287 363 303 363T327 364T349 367T372 373T389 385Q407 403 410 459V480H450V200H410V221Q407 276 389 296Q381 303 371 307T348 313T327 316T303 317T284 317H232V189L233 61Q240 54 245 52T270 48T333 46H360V0H348Q324 3 182 3Q51 3 36 0H25V46H58Q100 47 109 49T128 61V619",
  71: "56 342Q56 428 89 500T174 615T283 681T391 705Q394 705 400 705T408 704Q499 704 569 636L582 624L612 663Q639 700 643 704Q644 704 647 704T653 705H657Q660 705 666 699V419L660 413H626Q620 419 619 430Q610 512 571 572T476 651Q457 658 426 658Q401 658 376 654T316 633T254 592T205 519T177 411Q173 369 173 335Q173 259 192 201T238 111T302 58T370 31T431 24Q478 24 513 45T559 100Q562 110 562 160V212Q561 213 557 216T551 220T542 223T526 225T502 226T463 227H437V273H449L609 270Q715 270 727 273H735V227H721Q674 227 668 215Q666 211 666 108V6Q660 0 657 0Q653 0 639 10Q617 25 600 42L587 54Q571 27 524 3T406 -22Q317 -22 238 22T108 151T56 342",
  72: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H302Q262 636 251 634T233 622L232 500V378H517V622Q510 629 506 631T490 634T447 637H414V683H425Q446 680 569 680Q704 680 713 683H724V637H691Q651 636 640 634T622 622V61Q628 51 639 49T691 46H724V0H713Q692 3 569 3Q434 3 425 0H414V46H447Q489 47 498 49T517 61V332H232V197L233 61Q239 51 250 49T302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
  73: "328 0Q307 3 180 3T32 0H21V46H43Q92 46 106 49T126 60Q128 63 128 342Q128 620 126 623Q122 628 118 630T96 635T43 637H21V683H32Q53 680 180 680T328 683H339V637H317Q268 637 254 634T234 623Q232 620 232 342Q232 63 234 60Q238 55 242 53T264 48T317 46H339V0H328",
  74: "89 177Q115 177 133 160T152 112Q152 88 137 72T102 52Q99 51 101 49Q106 43 129 29Q159 15 190 15Q232 15 256 48T286 126Q286 127 286 142T286 183T286 238T287 306T287 378Q287 403 287 429T287 479T287 524T286 563T286 593T286 614V621Q281 630 263 633T182 637H154V683H166Q187 680 332 680Q439 680 457 683H465V637H449Q422 637 401 634Q393 631 389 623Q388 621 388 376T387 123Q377 61 322 20T194 -22Q188 -22 177 -21T160 -20Q96 -9 61 29T25 110Q25 144 44 160T89 177",
  75: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H313Q235 637 233 620Q232 618 232 462L233 307L379 449Q425 494 479 546Q518 584 524 591T531 607V608Q531 630 503 636Q501 636 498 636T493 637H489V683H499Q517 680 630 680Q704 680 716 683H722V637H708Q633 633 589 597Q584 592 495 506T406 419T515 254T631 80Q644 60 662 54T715 46H736V0H728Q719 3 615 3Q493 3 472 0H461V46H469Q515 46 515 72Q515 78 512 84L336 351Q332 348 278 296L232 251V156Q232 62 235 58Q243 47 302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
  76: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q48 680 182 680Q324 680 348 683H360V637H333Q273 637 258 635T233 622L232 342V129Q232 57 237 52Q243 47 313 47Q384 47 410 53Q470 70 498 110T536 221Q536 226 537 238T540 261T542 272T562 273H582V268Q580 265 568 137T554 5V0H25V46H58Q100 47 109 49T128 61V622",
  77: "132 622Q125 629 121 631T105 634T62 637H29V683H135Q221 683 232 682T249 675Q250 674 354 398L458 124L562 398Q666 674 668 675Q671 681 683 682T781 683H887V637H854Q814 636 803 634T785 622V61Q791 51 802 49T854 46H887V0H876Q855 3 736 3Q605 3 596 0H585V46H618Q660 47 669 49T688 61V347Q688 424 688 461T688 546T688 613L687 632Q454 14 450 7Q446 1 430 1T410 7Q409 9 292 316L176 624V606Q175 588 175 543T175 463T175 356L176 86Q187 50 261 46H278V0H269Q254 3 154 3Q52 3 37 0H29V46H46Q78 48 98 56T122 69T132 86V622",
  78: "42 46Q74 48 94 56T118 69T128 86V634H124Q114 637 52 637H25V683H232L235 680Q237 679 322 554T493 303L578 178V598Q572 608 568 613T544 627T492 637H475V683H483Q498 680 600 680Q706 680 715 683H724V637H707Q634 633 622 598L621 302V6L614 0H600Q585 0 582 3T481 150T282 443T171 605V345L172 86Q183 50 257 46H274V0H265Q250 3 150 3Q48 3 33 0H25V46H42",
  79: "56 340Q56 423 86 494T164 610T270 680T388 705Q521 705 621 601T722 341Q722 260 693 191T617 75T510 4T388 -22T267 3T160 74T85 189T56 340ZM467 647Q426 665 388 665Q360 665 331 654T269 620T213 549T179 439Q174 411 174 354Q174 144 277 61Q327 20 385 20H389H391Q474 20 537 99Q603 188 603 354Q603 411 598 439Q577 592 467 647",
  80: "130 622Q123 629 119 631T103 634T60 637H27V683H214Q237 683 276 683T331 684Q419 684 471 671T567 616Q624 563 624 489Q624 421 573 372T451 307Q429 302 328 301H234V181Q234 62 237 58Q245 47 304 46H337V0H326Q305 3 182 3Q47 3 38 0H27V46H60Q102 47 111 49T130 61V622ZM507 488Q507 514 506 528T500 564T483 597T450 620T397 635Q385 637 307 637H286Q237 637 234 628Q231 624 231 483V342H302H339Q390 342 423 349T481 382Q507 411 507 488",
  81: "56 341Q56 499 157 602T388 705Q521 705 621 601T722 341Q722 275 703 218T660 127T603 63T555 25T525 9Q524 8 524 8H523Q524 5 526 -1T537 -21T555 -47T581 -67T615 -76Q653 -76 678 -56T706 -3Q707 10 716 10Q721 10 728 5L727 -13Q727 -88 697 -140T606 -193Q563 -193 538 -166T498 -83Q483 -23 483 -8L471 -11Q459 -14 435 -18T388 -22Q254 -22 155 81T56 341ZM607 339Q607 429 586 496T531 598T461 649T390 665T318 649T248 598T192 496T170 339Q170 143 277 57Q301 39 305 39L304 42Q304 44 304 46Q301 53 301 68Q301 101 325 128T391 155Q454 155 495 70L501 58Q549 91 578 164Q607 234 607 339ZM385 18Q404 18 425 23T459 33T472 40Q471 47 468 57T449 88T412 115Q398 117 386 117Q367 117 353 102T338 67Q338 48 351 33T385 18",
  82: "130 622Q123 629 119 631T103 634T60 637H27V683H202H236H300Q376 683 417 677T500 648Q595 600 609 517Q610 512 610 501Q610 468 594 439T556 392T511 361T472 343L456 338Q459 335 467 332Q497 316 516 298T545 254T559 211T568 155T578 94Q588 46 602 31T640 16H645Q660 16 674 32T692 87Q692 98 696 101T712 105T728 103T732 90Q732 59 716 27T672 -16Q656 -22 630 -22Q481 -16 458 90Q456 101 456 163T449 246Q430 304 373 320L363 322L297 323H231V192L232 61Q238 51 249 49T301 46H334V0H323Q302 3 181 3Q59 3 38 0H27V46H60Q102 47 111 49T130 61V622ZM491 499V509Q491 527 490 539T481 570T462 601T424 623T362 636Q360 636 340 636T304 637H283Q238 637 234 628Q231 624 231 492V360H289Q390 360 434 378T489 456Q491 467 491 499",
  83: "55 507Q55 590 112 647T243 704H257Q342 704 405 641L426 672Q431 679 436 687T446 700L449 704Q450 704 453 704T459 705H463Q466 705 472 699V462L466 456H448Q437 456 435 459T430 479Q413 605 329 646Q292 662 254 662Q201 662 168 626T135 542Q135 508 152 480T200 435Q210 431 286 412T370 389Q427 367 463 314T500 191Q500 110 448 45T301 -21Q245 -21 201 -4T140 27L122 41Q118 36 107 21T87 -7T78 -21Q76 -22 68 -22H64Q61 -22 55 -16V101Q55 220 56 222Q58 227 76 227H89Q95 221 95 214Q95 182 105 151T139 90T205 42T305 24Q352 24 386 62T420 155Q420 198 398 233T340 281Q284 295 266 300Q261 301 239 306T206 314T174 325T141 343T112 367T85 402Q55 451 55 507",
  84: "36 443Q37 448 46 558T55 671V677H666V671Q667 666 676 556T685 443V437H645V443Q645 445 642 478T631 544T610 593Q593 614 555 625Q534 630 478 630H451H443Q417 630 414 618Q413 616 413 339V63Q420 53 439 50T528 46H558V0H545L361 3Q186 1 177 0H164V46H194Q264 46 283 49T309 63V339V550Q309 620 304 625T271 630H244H224Q154 630 119 601Q101 585 93 554T81 486T76 443V437H36V443",
  85: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H302Q262 636 251 634T233 622L232 418V291Q232 189 240 145T280 67Q325 24 389 24Q454 24 506 64T571 183Q575 206 575 410V598Q569 608 565 613T541 627T489 637H472V683H481Q496 680 598 680T715 683H724V637H707Q634 633 622 598L621 399Q620 194 617 180Q617 179 615 171Q595 83 531 31T389 -22Q304 -22 226 33T130 192Q129 201 128 412V622",
  86: "114 620Q113 621 110 624T107 627T103 630T98 632T91 634T80 635T67 636T48 637H19V683H28Q46 680 152 680Q273 680 294 683H305V637H284Q223 634 223 620Q223 618 313 372T404 126L490 358Q575 588 575 597Q575 616 554 626T508 637H503V683H512Q527 680 627 680Q718 680 724 683H730V637H723Q648 637 627 596Q627 595 515 291T401 -14Q396 -22 382 -22H374H367Q353 -22 348 -14Q346 -12 231 303Q114 617 114 620",
  87: "792 683Q810 680 914 680Q991 680 1003 683H1009V637H996Q931 633 915 598Q912 591 863 438T766 135T716 -17Q711 -22 694 -22Q676 -22 673 -15Q671 -13 593 231L514 477L435 234Q416 174 391 92T358 -6T341 -22H331Q314 -21 310 -15Q309 -14 208 302T104 622Q98 632 87 633Q73 637 35 637H18V683H27Q69 681 154 681Q164 681 181 681T216 681T249 682T276 683H287H298V637H285Q213 637 213 620Q213 616 289 381L364 144L427 339Q490 535 492 546Q487 560 482 578T475 602T468 618T461 628T449 633T433 636T408 637H380V683H388Q397 680 508 680Q629 680 650 683H660V637H647Q576 637 576 619L727 146Q869 580 869 600Q869 605 863 612T839 627T794 637H783V683H792",
  88: "270 0Q252 3 141 3Q46 3 31 0H23V46H40Q129 50 161 88Q165 94 244 216T324 339Q324 341 235 480T143 622Q133 631 119 634T57 637H37V683H46Q64 680 172 680Q297 680 318 683H329V637H324Q307 637 286 632T263 621Q263 618 322 525T384 431Q385 431 437 511T489 593Q490 595 490 599Q490 611 477 622T436 637H428V683H437Q455 680 566 680Q661 680 676 683H684V637H667Q585 634 551 599Q548 596 478 491Q412 388 412 387Q412 385 514 225T620 62Q628 53 642 50T695 46H726V0H717Q699 3 591 3Q466 3 445 0H434V46H440Q454 46 476 51T499 64Q499 67 463 124T390 238L353 295L350 292Q348 290 343 283T331 265T312 236T286 195Q219 88 218 84Q218 70 234 59T272 46H280V0H270",
  89: "518 0Q497 3 374 3Q253 3 232 0H221V46H254Q313 47 321 58Q324 62 324 167V273L221 446Q117 620 114 623Q106 631 91 634T31 637H11V683H20Q29 680 148 680Q273 680 294 683H305V637H287Q239 636 236 621Q236 619 321 475L407 332L483 460Q502 492 527 534Q563 594 563 604Q563 632 517 637H508V683H517H525Q533 683 545 683T571 682T600 681T626 681Q695 681 731 683H738V637H723Q640 633 613 588Q612 587 517 427L425 273V169V95Q425 66 428 59T444 49Q459 46 506 46H528V0H518",
  90: "69 443Q69 452 74 554T80 683H549Q555 677 555 664Q555 649 554 648Q552 645 366 348T179 50T192 49T263 49H275H302Q333 49 353 50T401 59T447 78T482 115T507 173Q513 200 520 273V282H560V274Q560 272 552 143T543 8V0H302L61 1L58 3Q55 8 55 21V35Q59 43 153 193T340 489T432 637H343Q259 637 214 625T141 573Q109 523 109 445Q109 443 89 443H69",
  91: "118 -250V750H255V710H158V-210H255V-250H118",
  92: "56 731Q56 740 62 745T75 750Q85 750 92 740Q96 733 270 255T444 -231Q444 -239 438 -244T424 -250Q414 -250 407 -240Q404 -236 230 242T56 731",
  93: "22 710V750H159V-250H22V-210H119V710H22",
  94: "112 560L249 694L257 686Q387 562 387 560L361 531Q359 532 303 581L250 627L195 580Q182 569 169 557T148 538L140 532Q138 530 125 546L112 560",
  95: "0 -62V-25H499V-62H0",
  96: "106 655Q106 671 119 685T150 699Q166 699 177 688Q190 671 222 629T275 561T295 533T282 519L267 505L196 563Q119 626 113 634Q106 643 106 655",
  97: "137 305T115 305T78 320T63 359Q63 394 97 421T218 448Q291 448 336 416T396 340Q401 326 401 309T402 194V124Q402 76 407 58T428 40Q443 40 448 56T453 109V145H493V106Q492 66 490 59Q481 29 455 12T400 -6T353 12T329 54V58L327 55Q325 52 322 49T314 40T302 29T287 17T269 6T247 -2T221 -8T190 -11Q130 -11 82 20T34 107Q34 128 41 147T68 188T116 225T194 253T304 268H318V290Q318 324 312 340Q290 411 215 411Q197 411 181 410T156 406T148 403Q170 388 170 359Q170 334 154 320ZM126 106Q126 75 150 51T209 26Q247 26 276 49T315 109Q317 116 318 175Q318 233 317 233Q309 233 296 232T251 223T193 203T147 166T126 106",
  98: "307 -11Q234 -11 168 55L158 37Q156 34 153 28T147 17T143 10L138 1L118 0H98V298Q98 599 97 603Q94 622 83 628T38 637H20V660Q20 683 22 683L32 684Q42 685 61 686T98 688Q115 689 135 690T165 693T176 694H179V543Q179 391 180 391L183 394Q186 397 192 401T207 411T228 421T254 431T286 439T323 442Q401 442 461 379T522 216Q522 115 458 52T307 -11ZM182 98Q182 97 187 90T196 79T206 67T218 55T233 44T250 35T271 29T295 26Q330 26 363 46T412 113Q424 148 424 212Q424 287 412 323Q385 405 300 405Q270 405 239 390T188 347L182 339V98",
  99: "370 305T349 305T313 320T297 358Q297 381 312 396Q317 401 317 402T307 404Q281 408 258 408Q209 408 178 376Q131 329 131 219Q131 137 162 90Q203 29 272 29Q313 29 338 55T374 117Q376 125 379 127T395 129H409Q415 123 415 120Q415 116 411 104T395 71T366 33T318 2T249 -11Q163 -11 99 53T34 214Q34 318 99 383T250 448T370 421T404 357Q404 334 387 320",
  100: "376 495Q376 511 376 535T377 568Q377 613 367 624T316 637H298V660Q298 683 300 683L310 684Q320 685 339 686T376 688Q393 689 413 690T443 693T454 694H457V390Q457 84 458 81Q461 61 472 55T517 46H535V0Q533 0 459 -5T380 -11H373V44L365 37Q307 -11 235 -11Q158 -11 96 50T34 215Q34 315 97 378T244 442Q319 442 376 393V495ZM373 342Q328 405 260 405Q211 405 173 369Q146 341 139 305T131 211Q131 155 138 120T173 59Q203 26 251 26Q322 26 373 103V342",
  101: "28 218Q28 273 48 318T98 391T163 433T229 448Q282 448 320 430T378 380T406 316T415 245Q415 238 408 231H126V216Q126 68 226 36Q246 30 270 30Q312 30 342 62Q359 79 369 104L379 128Q382 131 395 131H398Q415 131 415 121Q415 117 412 108Q393 53 349 21T250 -11Q155 -11 92 58T28 218ZM333 275Q322 403 238 411H236Q228 411 220 410T195 402T166 381T143 340T127 274V267H333V275",
  102: "273 0Q255 3 146 3Q43 3 34 0H26V46H42Q70 46 91 49Q99 52 103 60Q104 62 104 224V385H33V431H104V497L105 564L107 574Q126 639 171 668T266 704Q267 704 275 704T289 705Q330 702 351 679T372 627Q372 604 358 590T321 576T284 590T270 627Q270 647 288 667H284Q280 668 273 668Q245 668 223 647T189 592Q183 572 182 497V431H293V385H185V225Q185 63 186 61T189 57T194 54T199 51T206 49T213 48T222 47T231 47T241 46T251 46H282V0H273",
  103: "329 409Q373 453 429 453Q459 453 472 434T485 396Q485 382 476 371T449 360Q416 360 412 390Q410 404 415 411Q415 412 416 414V415Q388 412 363 393Q355 388 355 386Q355 385 359 381T368 369T379 351T388 325T392 292Q392 230 343 187T222 143Q172 143 123 171Q112 153 112 133Q112 98 138 81Q147 75 155 75T227 73Q311 72 335 67Q396 58 431 26Q470 -13 470 -72Q470 -139 392 -175Q332 -206 250 -206Q167 -206 107 -175Q29 -140 29 -75Q29 -39 50 -15T92 18L103 24Q67 55 67 108Q67 155 96 193Q52 237 52 292Q52 355 102 398T223 442Q274 442 318 416L329 409ZM299 343Q294 371 273 387T221 404Q192 404 171 388T145 343Q142 326 142 292Q142 248 149 227T179 192Q196 182 222 182Q244 182 260 189T283 207T294 227T299 242Q302 258 302 292T299 343ZM403 -75Q403 -50 389 -34T348 -11T299 -2T245 0H218Q151 0 138 -6Q118 -15 107 -34T95 -74Q95 -84 101 -97T122 -127T170 -155T250 -167Q319 -167 361 -139T403 -75",
  104: "41 46H55Q94 46 102 60V68Q102 77 102 91T102 124T102 167T103 217T103 272T103 329Q103 366 103 407T103 482T102 542T102 586T102 603Q99 622 88 628T43 637H25V660Q25 683 27 683L37 684Q47 685 66 686T103 688Q120 689 140 690T170 693T181 694H184V367Q244 442 328 442Q451 442 463 329Q464 322 464 190V104Q464 66 466 59T477 49Q498 46 526 46H542V0H534L510 1Q487 2 460 2T422 3Q319 3 310 0H302V46H318Q379 46 379 62Q380 64 380 200Q379 335 378 343Q372 371 358 385T334 402T308 404Q263 404 229 370Q202 343 195 315T187 232V168V108Q187 78 188 68T191 55T200 49Q221 46 249 46H265V0H257L234 1Q210 2 183 2T145 3Q42 3 33 0H25V46H41",
  105: "69 609Q69 637 87 653T131 669Q154 667 171 652T188 609Q188 579 171 564T129 549Q104 549 87 564T69 609ZM247 0Q232 3 143 3Q132 3 106 3T56 1L34 0H26V46H42Q70 46 91 49Q100 53 102 60T104 102V205V293Q104 345 102 359T88 378Q74 385 41 385H30V408Q30 431 32 431L42 432Q52 433 70 434T106 436Q123 437 142 438T171 441T182 442H185V62Q190 52 197 50T232 46H255V0H247",
  106: "98 609Q98 637 116 653T160 669Q183 667 200 652T217 609Q217 579 200 564T158 549Q133 549 116 564T98 609ZM28 -163Q58 -168 64 -168Q124 -168 135 -77Q137 -65 137 141T136 353Q132 371 120 377T72 385H52V408Q52 431 54 431L58 432Q62 432 70 432T87 433T108 434T133 436Q151 437 171 438T202 441T214 442H218V184Q217 -36 217 -59T211 -98Q195 -145 153 -175T58 -205Q9 -205 -23 -179T-55 -117Q-55 -94 -40 -79T-2 -64T36 -79T52 -118Q52 -143 28 -163",
  107: "36 46H50Q89 46 97 60V68Q97 77 97 91T97 124T98 167T98 217T98 272T98 329Q98 366 98 407T98 482T98 542T97 586T97 603Q94 622 83 628T38 637H20V660Q20 683 22 683L32 684Q42 685 61 686T98 688Q115 689 135 690T165 693T176 694H179V463L180 233L240 287Q300 341 304 347Q310 356 310 364Q310 383 289 385H284V431H293Q308 428 412 428Q475 428 484 431H489V385H476Q407 380 360 341Q286 278 286 274Q286 273 349 181T420 79Q434 60 451 53T500 46H511V0H505Q496 3 418 3Q322 3 307 0H299V46H306Q330 48 330 65Q330 72 326 79Q323 84 276 153T228 222L176 176V120V84Q176 65 178 59T189 49Q210 46 238 46H254V0H246Q231 3 137 3T28 0H20V46H36",
  108: "42 46H56Q95 46 103 60V68Q103 77 103 91T103 124T104 167T104 217T104 272T104 329Q104 366 104 407T104 482T104 542T103 586T103 603Q100 622 89 628T44 637H26V660Q26 683 28 683L38 684Q48 685 67 686T104 688Q121 689 141 690T171 693T182 694H185V379Q185 62 186 60Q190 52 198 49Q219 46 247 46H263V0H255L232 1Q209 2 183 2T145 3T107 3T57 1L34 0H26V46H42",
  109: "41 46H55Q94 46 102 60V68Q102 77 102 91T102 122T103 161T103 203Q103 234 103 269T102 328V351Q99 370 88 376T43 385H25V408Q25 431 27 431L37 432Q47 433 65 434T102 436Q119 437 138 438T167 441T178 442H181V402Q181 364 182 364T187 369T199 384T218 402T247 421T285 437Q305 442 336 442Q351 442 364 440T387 434T406 426T421 417T432 406T441 395T448 384T452 374T455 366L457 361L460 365Q463 369 466 373T475 384T488 397T503 410T523 422T546 432T572 439T603 442Q729 442 740 329Q741 322 741 190V104Q741 66 743 59T754 49Q775 46 803 46H819V0H811L788 1Q764 2 737 2T699 3Q596 3 587 0H579V46H595Q656 46 656 62Q657 64 657 200Q656 335 655 343Q649 371 635 385T611 402T585 404Q540 404 506 370Q479 343 472 315T464 232V168V108Q464 78 465 68T468 55T477 49Q498 46 526 46H542V0H534L510 1Q487 2 460 2T422 3Q319 3 310 0H302V46H318Q379 46 379 62Q380 64 380 200Q379 335 378 343Q372 371 358 385T334 402T308 404Q263 404 229 370Q202 343 195 315T187 232V168V108Q187 78 188 68T191 55T200 49Q221 46 249 46H265V0H257L234 1Q210 2 183 2T145 3Q42 3 33 0H25V46H41",
  110: "41 46H55Q94 46 102 60V68Q102 77 102 91T102 122T103 161T103 203Q103 234 103 269T102 328V351Q99 370 88 376T43 385H25V408Q25 431 27 431L37 432Q47 433 65 434T102 436Q119 437 138 438T167 441T178 442H181V402Q181 364 182 364T187 369T199 384T218 402T247 421T285 437Q305 442 336 442Q450 438 463 329Q464 322 464 190V104Q464 66 466 59T477 49Q498 46 526 46H542V0H534L510 1Q487 2 460 2T422 3Q319 3 310 0H302V46H318Q379 46 379 62Q380 64 380 200Q379 335 378 343Q372 371 358 385T334 402T308 404Q263 404 229 370Q202 343 195 315T187 232V168V108Q187 78 188 68T191 55T200 49Q221 46 249 46H265V0H257L234 1Q210 2 183 2T145 3Q42 3 33 0H25V46H41",
  111: "28 214Q28 309 93 378T250 448Q340 448 405 380T471 215Q471 120 407 55T250 -10Q153 -10 91 57T28 214ZM250 30Q372 30 372 193V225V250Q372 272 371 288T364 326T348 362T317 390T268 410Q263 411 252 411Q222 411 195 399Q152 377 139 338T126 246V226Q126 130 145 91Q177 30 250 30",
  112: "36 -148H50Q89 -148 97 -134V-126Q97 -119 97 -107T97 -77T98 -38T98 6T98 55T98 106Q98 140 98 177T98 243T98 296T97 335T97 351Q94 370 83 376T38 385H20V408Q20 431 22 431L32 432Q42 433 61 434T98 436Q115 437 135 438T165 441T176 442H179V416L180 390L188 397Q247 441 326 441Q407 441 464 377T522 216Q522 115 457 52T310 -11Q242 -11 190 33L182 40V-45V-101Q182 -128 184 -134T195 -145Q216 -148 244 -148H260V-194H252L228 -193Q205 -192 178 -192T140 -191Q37 -191 28 -194H20V-148H36ZM424 218Q424 292 390 347T305 402Q234 402 182 337V98Q222 26 294 26Q345 26 384 80T424 218",
  113: "33 218Q33 308 95 374T236 441H246Q330 441 381 372L387 364Q388 364 404 403L420 442H457V156Q457 -132 458 -134Q462 -142 470 -145Q491 -148 519 -148H535V-194H527L504 -193Q480 -192 453 -192T415 -191Q312 -191 303 -194H295V-148H311Q339 -148 360 -145Q369 -141 371 -135T373 -106V-41V49Q313 -11 236 -11Q154 -11 94 53T33 218ZM376 300Q346 389 278 401Q275 401 269 401T261 402Q211 400 171 350T131 214Q131 137 165 82T253 27Q296 27 328 54T376 118V300",
  114: "36 46H50Q89 46 97 60V68Q97 77 97 91T98 122T98 161T98 203Q98 234 98 269T98 328L97 351Q94 370 83 376T38 385H20V408Q20 431 22 431L32 432Q42 433 60 434T96 436Q112 437 131 438T160 441T171 442H174V373Q213 441 271 441H277Q322 441 343 419T364 373Q364 352 351 337T313 322Q288 322 276 338T263 372Q263 381 265 388T270 400T273 405Q271 407 250 401Q234 393 226 386Q179 341 179 207V154Q179 141 179 127T179 101T180 81T180 66V61Q181 59 183 57T188 54T193 51T200 49T207 48T216 47T225 47T235 46T245 46H276V0H267Q249 3 140 3Q37 3 28 0H20V46H36",
  115: "295 316Q295 356 268 385T190 414Q154 414 128 401Q98 382 98 349Q97 344 98 336T114 312T157 287Q175 282 201 278T245 269T277 256Q294 248 310 236T342 195T359 133Q359 71 321 31T198 -10H190Q138 -10 94 26L86 19L77 10Q71 4 65 -1L54 -11H46H42Q39 -11 33 -5V74V132Q33 153 35 157T45 162H54Q66 162 70 158T75 146T82 119T101 77Q136 26 198 26Q295 26 295 104Q295 133 277 151Q257 175 194 187T111 210Q75 227 54 256T33 318Q33 357 50 384T93 424T143 442T187 447H198Q238 447 268 432L283 424L292 431Q302 440 314 448H322H326Q329 448 335 442V310L329 304H301Q295 310 295 316",
  116: "27 422Q80 426 109 478T141 600V615H181V431H316V385H181V241Q182 116 182 100T189 68Q203 29 238 29Q282 29 292 100Q293 108 293 146V181H333V146V134Q333 57 291 17Q264 -10 221 -10Q187 -10 162 2T124 33T105 68T98 100Q97 107 97 248V385H18V422H27",
  117: "383 58Q327 -10 256 -10H249Q124 -10 105 89Q104 96 103 226Q102 335 102 348T96 369Q86 385 36 385H25V408Q25 431 27 431L38 432Q48 433 67 434T105 436Q122 437 142 438T172 441T184 442H187V261Q188 77 190 64Q193 49 204 40Q224 26 264 26Q290 26 311 35T343 58T363 90T375 120T379 144Q379 145 379 161T380 201T380 248V315Q380 361 370 372T320 385H302V431Q304 431 378 436T457 442H464V264Q464 84 465 81Q468 61 479 55T524 46H542V0Q540 0 467 -5T390 -11H383V58",
  118: "338 431Q344 429 422 429Q479 429 503 431H508V385H497Q439 381 423 345Q421 341 356 172T288 -2Q283 -11 263 -11Q244 -11 239 -2Q99 359 98 364Q93 378 82 381T43 385H19V431H25L33 430Q41 430 53 430T79 430T104 429T122 428Q217 428 232 431H240V385H226Q187 384 184 370Q184 366 235 234L286 102L377 341V349Q377 363 367 372T349 383T335 385H331V431H338",
  119: "90 368Q84 378 76 380T40 385H18V431H24L43 430Q62 430 84 429T116 428Q206 428 221 431H229V385H215Q177 383 177 368Q177 367 221 239L265 113L339 328L333 345Q323 374 316 379Q308 384 278 385H258V431H264Q270 428 348 428Q439 428 454 431H461V385H452Q404 385 404 369Q404 366 418 324T449 234T481 143L496 100L537 219Q579 341 579 347Q579 363 564 373T530 385H522V431H529Q541 428 624 428Q692 428 698 431H703V385H697Q696 385 691 385T682 384Q635 377 619 334L559 161Q546 124 528 71Q508 12 503 1T487 -11H479Q460 -11 456 -4Q455 -3 407 133L361 267Q359 263 266 -4Q261 -11 243 -11H238Q225 -11 220 -3L90 368",
  120: "201 0Q189 3 102 3Q26 3 17 0H11V46H25Q48 47 67 52T96 61T121 78T139 96T160 122T180 150L226 210L168 288Q159 301 149 315T133 336T122 351T113 363T107 370T100 376T94 379T88 381T80 383Q74 383 44 385H16V431H23Q59 429 126 429Q219 429 229 431H237V385Q201 381 201 369Q201 367 211 353T239 315T268 274L272 270L297 304Q329 345 329 358Q329 364 327 369T322 376T317 380T310 384L307 385H302V431H309Q324 428 408 428Q487 428 493 431H499V385H492Q443 385 411 368Q394 360 377 341T312 257L296 236L358 151Q424 61 429 57T446 50Q464 46 499 46H516V0H510H502Q494 1 482 1T457 2T432 2T414 3Q403 3 377 3T327 1L304 0H295V46H298Q309 46 320 51T331 63Q331 65 291 120L250 175Q249 174 219 133T185 88Q181 83 181 74Q181 63 188 55T206 46Q208 46 208 23V0H201",
  121: "69 -66Q91 -66 104 -80T118 -116Q118 -134 109 -145T91 -160Q84 -163 97 -166Q104 -168 111 -168Q131 -168 148 -159T175 -138T197 -106T213 -75T225 -43L242 0L170 183Q150 233 125 297Q101 358 96 368T80 381Q79 382 78 382Q66 385 34 385H19V431H26L46 430Q65 430 88 429T122 428Q129 428 142 428T171 429T200 430T224 430L233 431H241V385H232Q183 385 185 366L286 112Q286 113 332 227L376 341V350Q376 365 366 373T348 383T334 385H331V431H337H344Q351 431 361 431T382 430T405 429T422 429Q477 429 503 431H508V385H497Q441 380 422 345Q420 343 378 235T289 9T227 -131Q180 -204 113 -204Q69 -204 44 -177T19 -116Q19 -89 35 -78T69 -66",
  122: "42 263Q44 270 48 345T53 423V431H393Q399 425 399 415Q399 403 398 402L381 378Q364 355 331 309T265 220L134 41L182 40H206Q254 40 283 46T331 77Q352 105 359 185L361 201Q361 202 381 202H401V196Q401 195 393 103T384 6V0H209L34 1L31 3Q28 8 28 17Q28 30 29 31T160 210T294 394H236Q169 393 152 388Q127 382 113 367Q89 344 82 264V255H42V263",
  123: "434 -231Q434 -244 428 -250H410Q281 -250 230 -184Q225 -177 222 -172T217 -161T213 -148T211 -133T210 -111T209 -84T209 -47T209 0Q209 21 209 53Q208 142 204 153Q203 154 203 155Q189 191 153 211T82 231Q71 231 68 234T65 250T68 266T82 269Q116 269 152 289T203 345Q208 356 208 377T209 529V579Q209 634 215 656T244 698Q270 724 324 740Q361 748 377 749Q379 749 390 749T408 750H428Q434 744 434 732Q434 719 431 716Q429 713 415 713Q362 710 332 689T296 647Q291 634 291 499V417Q291 370 288 353T271 314Q240 271 184 255L170 250L184 245Q202 239 220 230T262 196T290 137Q291 131 291 1Q291 -134 296 -147Q306 -174 339 -192T415 -213Q429 -213 431 -216Q434 -219 434 -231",
  124: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V-235Q151 -249 141 -249H139",
  125: "65 731Q65 745 68 747T88 750Q171 750 216 725T279 670Q288 649 289 635T291 501Q292 362 293 357Q306 312 345 291T417 269Q428 269 431 266T434 250T431 234T417 231Q380 231 345 210T298 157Q293 143 292 121T291 -28V-79Q291 -134 285 -156T256 -198Q202 -250 89 -250Q71 -250 68 -247T65 -230Q65 -224 65 -223T66 -218T69 -214T77 -213Q91 -213 108 -210T146 -200T183 -177T207 -139Q208 -134 209 3L210 139Q223 196 280 230Q315 247 330 250Q305 257 280 270Q225 304 212 352L210 362L209 498Q208 635 207 640Q195 680 154 696T77 713Q68 713 67 716T65 731",
  126: "179 251Q164 251 151 245T131 234T111 215L97 227L83 238Q83 239 95 253T121 283T142 304Q165 318 187 318T253 300T320 282Q335 282 348 288T368 299T388 318L402 306L416 295Q375 236 344 222Q330 215 313 215Q292 215 248 233T179 251",
  160: "",
  163: "699 578Q699 473 635 473Q597 473 595 508Q595 559 654 569V576Q654 619 637 648T581 677Q545 677 513 647T463 561Q460 554 437 464T414 371Q414 370 458 370H502Q508 364 508 362Q505 334 495 324H402L382 241Q377 224 373 206T366 180T361 163T358 151T354 142T350 133T344 120Q340 112 338 107T336 101L354 90Q398 63 422 54T476 44Q515 44 539 73T574 133Q578 144 580 146T598 148Q622 148 622 139Q622 138 620 130Q602 74 555 32T447 -11Q395 -11 317 38L294 51Q271 28 233 9T155 -10Q117 -10 103 5T88 39Q88 73 126 106T224 139Q236 139 247 138T266 134L273 132Q275 132 302 239L323 324H259Q253 330 253 332Q253 350 265 370H300L334 371L355 453Q356 457 360 477T366 501T372 522T379 545T387 565T397 587T409 606T425 627Q453 664 497 689T583 714Q640 714 669 676T699 578ZM245 76Q211 85 195 85Q173 85 158 71T142 42Q142 26 160 26H163Q211 30 245 76",
  165: "515 0Q494 3 374 3Q256 3 235 0H224V46H257Q316 47 324 58Q327 62 327 137V213H133Q121 213 113 213T97 213T86 213T78 213T73 214T70 215T69 216T68 218T67 220Q64 225 66 231T73 240Q76 242 202 242H327V273L247 407H115Q81 407 75 408T67 414Q64 419 66 425T73 434Q76 436 153 436Q228 436 228 437Q227 440 173 530T115 623Q101 637 31 637H11V683H20Q66 681 153 681Q169 681 202 681T262 682L288 683H298V637H280Q230 636 230 621Q230 619 250 584Q255 576 264 561T286 526T305 494L340 437L403 436H467L513 514Q564 596 564 605Q564 608 560 616Q550 634 517 637H508V683H516Q531 680 633 680Q722 680 731 683H738V637H723Q644 632 617 595Q614 591 568 515T521 437T597 436T676 434Q681 432 683 426T682 414T671 409T589 407H503L422 273V242H547Q673 242 676 240Q681 238 683 232T682 220Q682 219 682 218T681 217T679 216T677 215T672 214T664 213T652 213T637 213T616 213H422V139V87Q422 64 425 58T441 49Q456 46 503 46H525V0H515ZM449 406Q449 407 403 407Q358 407 358 406L370 387Q381 368 392 350L404 331Q447 404 449 406",
  168: "95 612Q95 633 112 651T153 669T193 652T210 612Q210 588 194 571T152 554L127 560Q95 577 95 612ZM289 611Q289 634 304 649T335 668Q336 668 340 668T346 669Q369 669 386 652T404 612T387 572T346 554Q323 554 306 570T289 611",
  172: "56 323T56 336T70 356H596Q603 353 611 343V102Q598 89 591 89Q587 89 584 90T579 94T575 98T572 102L571 209V316H70Q56 323 56 336",
  174: "915 266Q915 140 852 38T689 -120T474 -175Q312 -175 188 -71T38 190Q32 220 32 266V287Q32 345 57 416T129 545Q192 624 282 666T464 709Q513 709 522 708Q599 698 665 666T776 590T853 493T900 387T915 287V266ZM875 285Q875 339 853 399T789 517T676 616T519 668Q510 669 465 669Q380 669 299 630T155 514T77 336Q72 312 72 285V266V256Q72 123 163 11Q290 -135 474 -135Q614 -135 727 -46Q875 81 875 266V285ZM276 457Q275 458 274 460T272 463T270 465T267 467T264 469T258 471T252 472T243 473T232 474T218 474H204V514H335Q477 514 499 510Q560 502 610 467T661 375Q661 362 658 350T648 327T635 308T618 292T601 280T583 269T568 262T554 256L547 253Q548 252 556 247T570 237T586 223T602 202T614 174Q616 169 626 123T638 72Q652 23 683 23Q715 23 720 68Q721 78 724 81T740 84T756 82T760 70Q760 47 747 25T715 -7Q700 -14 673 -14Q672 -14 662 -14T643 -12T619 -7T593 2T568 16T547 37T534 67Q531 80 531 97Q531 103 531 116T532 136Q532 218 472 236Q466 238 413 239H360V148L361 58Q366 47 375 44T418 40H432V0H424Q409 3 318 3T212 0H204V40H218Q242 40 253 42T268 47T276 58V457ZM376 473Q365 471 363 464T360 430V366V276H416Q421 276 434 276T453 276T469 277T486 279T501 282T517 287T529 294T542 305Q561 324 561 375Q561 424 545 444T482 472Q478 473 427 474Q415 474 403 474T384 474L376 473",
  175: "69 544V590H430V544H69",
  176: "147 628Q147 669 179 692T244 715Q298 715 325 689T352 629Q352 592 323 567T249 542Q202 542 175 567T147 628ZM313 628Q313 660 300 669T259 678H253Q248 678 242 678T234 679Q217 679 207 674T192 659T188 644T187 629Q187 600 198 590Q210 579 250 579H265Q279 579 288 581T305 595T313 628",
  177: "56 320T56 333T70 353H369V502Q369 651 371 655Q376 666 388 666Q402 666 405 654T409 596V500V353H707Q722 345 722 333Q722 320 707 313H409V40H707Q722 32 722 20T707 0H70Q56 7 56 20T70 40H369V313H70Q56 320 56 333",
  180: "349 699Q367 699 380 686T393 656Q393 651 392 647T387 637T380 627T367 616T351 602T330 585T303 563L232 505L217 519Q203 533 204 533Q204 534 229 567T282 636T313 678L316 681Q318 684 321 686T328 692T337 697T349 699",
  183: "78 250Q78 274 95 292T138 310Q162 310 180 294T199 251Q199 226 182 208T139 190T96 207T78 250",
  215: "630 29Q630 9 609 9Q604 9 587 25T493 118L389 222L284 117Q178 13 175 11Q171 9 168 9Q160 9 154 15T147 29Q147 36 161 51T255 146L359 250L255 354Q174 435 161 449T147 471Q147 480 153 485T168 490Q173 490 175 489Q178 487 284 383L389 278L493 382Q570 459 587 475T609 491Q630 491 630 471Q630 464 620 453T522 355L418 250L522 145Q606 61 618 48T630 29",
  240: "75 566V604Q75 624 79 629T102 635Q124 635 127 629T131 588L133 550L191 588L249 628L231 635Q176 654 124 657Q116 657 106 658L95 659Q94 661 94 687T95 715Q99 717 113 717Q195 717 282 679L309 668L331 681Q351 697 391 721Q428 748 435 748Q437 749 446 749Q470 749 473 746Q478 744 478 681V621Q466 615 456 615Q435 615 424 624L422 661V699L382 675L344 648Q353 639 366 630Q480 538 504 413Q509 393 509 333V313Q509 284 507 257T495 184T466 102T413 33T329 -16Q311 -21 275 -21Q226 -21 195 -10Q150 7 110 50T53 141Q42 179 42 227Q42 332 101 403T245 474Q282 474 314 461T359 436T380 415Q386 405 389 408Q389 426 378 475Q368 505 355 529T329 567T306 590T288 603L282 606L120 501Q116 500 102 500Q84 500 75 506V566ZM388 225Q388 376 309 410Q299 416 273 419Q216 419 191 390Q174 371 168 342T162 218Q162 112 184 79Q212 39 273 39Q312 39 342 62T380 121Q388 159 388 225",
  247: "318 466Q318 500 339 518T386 537Q418 537 438 517T458 466Q458 438 440 417T388 396Q355 396 337 417T318 466ZM56 237T56 250T70 270H706Q721 262 721 250T706 230H70Q56 237 56 250ZM318 34Q318 68 339 86T386 105Q418 105 438 85T458 34Q458 6 440 -15T388 -36Q355 -36 337 -15T318 34",
  305: "247 0Q232 3 143 3Q132 3 106 3T56 1L34 0H26V46H42Q70 46 91 49Q100 53 102 60T104 102V205V293Q104 345 102 359T88 378Q74 385 41 385H30V408Q30 431 32 431L42 432Q52 433 70 434T106 436Q123 437 142 438T171 441T182 442H185V62Q190 52 197 50T232 46H255V0H247",
  567: "28 -163Q58 -168 64 -168Q124 -168 135 -77Q137 -65 137 141T136 353Q132 371 120 377T72 385H52V408Q52 431 54 431L58 432Q62 432 70 432T87 433T108 434T133 436Q151 437 171 438T202 441T214 442H218V184Q217 -36 217 -59T211 -98Q195 -145 153 -175T58 -205Q9 -205 -23 -179T-55 -117Q-55 -94 -40 -79T-2 -64T36 -79T52 -118Q52 -143 28 -163",
  697: "79 43Q73 43 52 49T30 61Q30 68 85 293T146 528Q161 560 198 560Q218 560 240 545T262 501Q262 496 260 486Q259 479 173 263T84 45T79 43",
  710: "112 560L249 694L257 686Q387 562 387 560L361 531Q359 532 303 581L250 627L195 580Q182 569 169 557T148 538L140 532Q138 530 125 546L112 560",
  711: "114 611L127 630L136 644Q138 644 193 612Q248 581 250 581L306 612Q361 644 363 644L385 611L318 562L249 513L114 611",
  713: "69 544V590H430V544H69",
  714: "349 699Q367 699 380 686T393 656Q393 651 392 647T387 637T380 627T367 616T351 602T330 585T303 563L232 505L217 519Q203 533 204 533Q204 534 229 567T282 636T313 678L316 681Q318 684 321 686T328 692T337 697T349 699",
  715: "106 655Q106 671 119 685T150 699Q166 699 177 688Q190 671 222 629T275 561T295 533T282 519L267 505L196 563Q119 626 113 634Q106 643 106 655",
  728: "250 515Q179 515 138 565T92 683V694H129V689Q129 688 129 683T130 675Q137 631 169 599T248 567Q304 567 337 608T370 689V694H407V683Q403 617 361 566T250 515",
  729: "190 609Q190 637 208 653T252 669Q275 667 292 652T309 609Q309 579 292 564T250 549Q225 549 208 564T190 609",
  730: "147 628Q147 669 179 692T244 715Q298 715 325 689T352 629Q352 592 323 567T249 542Q202 542 175 567T147 628ZM313 628Q313 660 300 669T259 678H253Q248 678 242 678T234 679Q217 679 207 674T192 659T188 644T187 629Q187 600 198 590Q210 579 250 579H265Q279 579 288 581T305 595T313 628",
  732: "179 601Q164 601 151 595T131 584T111 565L97 577L83 588Q83 589 95 603T121 633T142 654Q165 668 187 668T253 650T320 632Q335 632 348 638T368 649T388 668L402 656L416 645Q375 586 344 572Q330 565 313 565Q292 565 248 583T179 601",
  768: "-394 655Q-394 671 -381 685T-350 699Q-334 699 -323 688Q-310 671 -278 629T-225 561T-205 533T-218 519L-233 505L-304 563Q-381 626 -387 634Q-394 643 -394 655",
  769: "-151 699Q-133 699 -120 686T-107 656Q-107 651 -108 647T-113 637T-120 627T-133 616T-149 602T-170 585T-197 563L-268 505L-283 519Q-297 533 -296 533Q-296 534 -271 567T-218 636T-187 678L-184 681Q-182 684 -179 686T-172 692T-163 697T-151 699",
  770: "-388 560L-251 694L-243 686Q-113 562 -113 560L-139 531Q-141 532 -197 581L-250 627L-305 580Q-318 569 -331 557T-352 538L-360 532Q-362 530 -375 546L-388 560",
  771: "-321 601Q-336 601 -349 595T-369 584T-389 565L-403 577L-417 588Q-417 589 -405 603T-379 633T-358 654Q-335 668 -313 668T-247 650T-180 632Q-165 632 -152 638T-132 649T-112 668L-98 656L-84 645Q-125 586 -156 572Q-170 565 -187 565Q-208 565 -252 583T-321 601",
  772: "-431 544V590H-70V544H-431",
  774: "-250 515Q-321 515 -362 565T-408 683V694H-371V689Q-371 688 -371 683T-370 675Q-363 631 -331 599T-252 567Q-196 567 -163 608T-130 689V694H-93V683Q-97 617 -139 566T-250 515",
  775: "-310 609Q-310 637 -292 653T-248 669Q-225 667 -208 652T-191 609Q-191 579 -208 564T-250 549Q-275 549 -292 564T-310 609",
  776: "-405 612Q-405 633 -388 651T-347 669T-307 652T-290 612Q-290 588 -306 571T-348 554L-373 560Q-405 577 -405 612ZM-211 611Q-211 634 -196 649T-165 668Q-164 668 -160 668T-154 669Q-131 669 -114 652T-96 612T-113 572T-154 554Q-177 554 -194 570T-211 611",
  778: "-353 628Q-353 669 -321 692T-256 715Q-202 715 -175 689T-148 629Q-148 592 -177 567T-251 542Q-298 542 -325 567T-353 628ZM-187 628Q-187 660 -200 669T-241 678H-247Q-252 678 -258 678T-266 679Q-283 679 -293 674T-308 659T-312 644T-313 629Q-313 600 -302 590Q-290 579 -250 579H-235Q-221 579 -212 581T-195 595T-187 628",
  779: "-292 701Q-278 701 -262 690T-246 658Q-246 649 -250 641Q-252 637 -297 574T-344 510L-378 528Q-378 530 -355 598T-327 676Q-316 701 -292 701ZM-126 701Q-112 701 -96 690T-80 658Q-80 649 -84 641Q-86 637 -131 574T-178 510L-212 528Q-212 530 -189 598T-161 676Q-150 701 -126 701",
  780: "-386 611L-373 630L-364 644Q-362 644 -307 612Q-252 581 -250 581L-194 612Q-139 644 -137 644L-115 611L-182 562L-251 513L-386 611",
  824: "-612 -215T-619 -215T-631 -212T-637 -204T-639 -197Q-639 -190 -634 -183Q-621 -157 -400 274T-176 707Q-173 716 -160 716Q-153 716 -148 712T-142 703T-140 696Q-140 691 -372 241T-608 -212Q-612 -215 -619 -215",
  913: "255 0Q240 3 140 3Q48 3 39 0H32V46H47Q119 49 139 88Q140 91 192 245T295 553T348 708Q351 716 366 716H376Q396 715 400 709Q402 707 508 390L617 67Q624 54 636 51T687 46H717V0H708Q699 3 581 3Q458 3 437 0H427V46H440Q510 46 510 64Q510 66 486 138L462 209H229L209 150Q189 91 189 85Q189 72 209 59T259 46H264V0H255ZM447 255L345 557L244 256Q244 255 345 255H447",
  914: "131 622Q124 629 120 631T104 634T61 637H28V683H229H267H346Q423 683 459 678T531 651Q574 627 599 590T624 512Q624 461 583 419T476 360L466 357Q539 348 595 302T651 187Q651 119 600 67T469 3Q456 1 242 0H28V46H61Q103 47 112 49T131 61V622ZM511 513Q511 560 485 594T416 636Q415 636 403 636T371 636T333 637Q266 637 251 636T232 628Q229 624 229 499V374H312L396 375L406 377Q410 378 417 380T442 393T474 417T499 456T511 513ZM537 188Q537 239 509 282T430 336L329 337H229V200V116Q229 57 234 52Q240 47 334 47H383Q425 47 443 53Q486 67 511 104T537 188",
  915: "128 619Q121 626 117 628T101 631T58 634H25V680H554V676Q556 670 568 560T582 444V440H542V444Q542 445 538 478T523 545T492 598Q454 634 349 634H334Q264 634 249 633T233 621Q232 618 232 339L233 61Q240 54 245 52T270 48T333 46H360V0H348Q324 3 182 3Q51 3 36 0H25V46H58Q100 47 109 49T128 61V619",
  916: "51 0Q46 4 46 7Q46 9 215 357T388 709Q391 716 416 716Q439 716 444 709Q447 705 616 357T786 7Q786 4 781 0H51ZM507 344L384 596L137 92L383 91H630Q630 93 507 344",
  917: "128 619Q121 626 117 628T101 631T58 634H25V680H597V676Q599 670 611 560T625 444V440H585V444Q584 447 582 465Q578 500 570 526T553 571T528 601T498 619T457 629T411 633T353 634Q266 634 251 633T233 622Q233 622 233 621Q232 619 232 497V376H286Q359 378 377 385Q413 401 416 469Q416 471 416 473V493H456V213H416V233Q415 268 408 288T383 317T349 328T297 330Q290 330 286 330H232V196V114Q232 57 237 52Q243 47 289 47H340H391Q428 47 452 50T505 62T552 92T584 146Q594 172 599 200T607 247T612 270V273H652V270Q651 267 632 137T610 3V0H25V46H58Q100 47 109 49T128 61V619",
  918: "69 443Q69 452 74 554T80 683H549Q555 677 555 664Q555 649 554 648Q552 645 366 348T179 50T192 49T263 49H275H302Q333 49 353 50T401 59T447 78T482 115T507 173Q513 200 520 273V282H560V274Q560 272 552 143T543 8V0H302L61 1L58 3Q55 8 55 21V35Q59 43 153 193T340 489T432 637H343Q259 637 214 625T141 573Q109 523 109 445Q109 443 89 443H69",
  919: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H302Q262 636 251 634T233 622L232 500V378H517V622Q510 629 506 631T490 634T447 637H414V683H425Q446 680 569 680Q704 680 713 683H724V637H691Q651 636 640 634T622 622V61Q628 51 639 49T691 46H724V0H713Q692 3 569 3Q434 3 425 0H414V46H447Q489 47 498 49T517 61V332H232V197L233 61Q239 51 250 49T302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
  920: "56 340Q56 423 86 494T164 610T270 680T388 705Q521 705 621 601T722 341Q722 260 693 191T617 75T510 4T388 -22T267 3T160 74T85 189T56 340ZM610 339Q610 428 590 495T535 598T463 651T384 668Q332 668 289 638T221 566Q168 485 168 339Q168 274 176 235Q189 158 228 105T324 28Q356 16 388 16Q415 16 442 24T501 54T555 111T594 205T610 339ZM223 263V422H263V388H514V422H554V263H514V297H263V263H223",
  921: "328 0Q307 3 180 3T32 0H21V46H43Q92 46 106 49T126 60Q128 63 128 342Q128 620 126 623Q122 628 118 630T96 635T43 637H21V683H32Q53 680 180 680T328 683H339V637H317Q268 637 254 634T234 623Q232 620 232 342Q232 63 234 60Q238 55 242 53T264 48T317 46H339V0H328",
  922: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H313Q235 637 233 620Q232 618 232 462L233 307L379 449Q425 494 479 546Q518 584 524 591T531 607V608Q531 630 503 636Q501 636 498 636T493 637H489V683H499Q517 680 630 680Q704 680 716 683H722V637H708Q633 633 589 597Q584 592 495 506T406 419T515 254T631 80Q644 60 662 54T715 46H736V0H728Q719 3 615 3Q493 3 472 0H461V46H469Q515 46 515 72Q515 78 512 84L336 351Q332 348 278 296L232 251V156Q232 62 235 58Q243 47 302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
  923: "320 708Q326 716 340 716H348H355Q367 716 372 708Q374 706 423 547T523 226T575 62Q581 52 591 50T634 46H661V0H653Q644 3 532 3Q411 3 390 0H379V46H392Q464 46 464 65Q463 70 390 305T316 539L246 316Q177 95 177 84Q177 72 198 59T248 46H253V0H245Q230 3 130 3Q47 3 38 0H32V46H45Q112 51 127 91Q128 92 224 399T320 708",
  924: "132 622Q125 629 121 631T105 634T62 637H29V683H135Q221 683 232 682T249 675Q250 674 354 398L458 124L562 398Q666 674 668 675Q671 681 683 682T781 683H887V637H854Q814 636 803 634T785 622V61Q791 51 802 49T854 46H887V0H876Q855 3 736 3Q605 3 596 0H585V46H618Q660 47 669 49T688 61V347Q688 424 688 461T688 546T688 613L687 632Q454 14 450 7Q446 1 430 1T410 7Q409 9 292 316L176 624V606Q175 588 175 543T175 463T175 356L176 86Q187 50 261 46H278V0H269Q254 3 154 3Q52 3 37 0H29V46H46Q78 48 98 56T122 69T132 86V622",
  925: "42 46Q74 48 94 56T118 69T128 86V634H124Q114 637 52 637H25V683H232L235 680Q237 679 322 554T493 303L578 178V598Q572 608 568 613T544 627T492 637H475V683H483Q498 680 600 680Q706 680 715 683H724V637H707Q634 633 622 598L621 302V6L614 0H600Q585 0 582 3T481 150T282 443T171 605V345L172 86Q183 50 257 46H274V0H265Q250 3 150 3Q48 3 33 0H25V46H42",
  926: "47 509L55 676Q55 677 333 677T611 676L619 509Q619 508 599 508T579 510Q579 529 575 557T564 589Q550 594 333 594T102 589Q95 586 91 558T87 510Q87 508 67 508T47 509ZM139 260V445H179V394H487V445H527V260H487V311H179V260H139ZM50 0L42 180H62Q82 180 82 178Q82 133 89 105Q92 93 95 90T108 86Q137 83 333 83Q530 83 558 86Q568 87 571 90T577 105Q584 133 584 178Q584 180 604 180H624L616 0H50",
  927: "56 340Q56 423 86 494T164 610T270 680T388 705Q521 705 621 601T722 341Q722 260 693 191T617 75T510 4T388 -22T267 3T160 74T85 189T56 340ZM467 647Q426 665 388 665Q360 665 331 654T269 620T213 549T179 439Q174 411 174 354Q174 144 277 61Q327 20 385 20H389H391Q474 20 537 99Q603 188 603 354Q603 411 598 439Q577 592 467 647",
  928: "128 619Q121 626 117 628T101 631T58 634H25V680H724V634H691Q651 633 640 631T622 619V61Q628 51 639 49T691 46H724V0H713Q692 3 569 3Q434 3 425 0H414V46H447Q489 47 498 49T517 61V634H232V348L233 61Q239 51 250 49T302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V619",
  929: "130 622Q123 629 119 631T103 634T60 637H27V683H214Q237 683 276 683T331 684Q419 684 471 671T567 616Q624 563 624 489Q624 421 573 372T451 307Q429 302 328 301H234V181Q234 62 237 58Q245 47 304 46H337V0H326Q305 3 182 3Q47 3 38 0H27V46H60Q102 47 111 49T130 61V622ZM507 488Q507 514 506 528T500 564T483 597T450 620T397 635Q385 637 307 637H286Q237 637 234 628Q231 624 231 483V342H302H339Q390 342 423 349T481 382Q507 411 507 488",
  931: "666 247Q664 244 652 126T638 4V0H351Q131 0 95 0T57 5V6Q54 12 57 17L73 36Q89 54 121 90T182 159L305 299L56 644L55 658Q55 677 60 681Q63 683 351 683H638V679Q640 674 652 564T666 447V443H626V447Q618 505 604 543T559 605Q529 626 478 631T333 637H294H189L293 494Q314 465 345 422Q400 346 400 340Q400 338 399 337L154 57Q407 57 428 58Q476 60 508 68T551 83T575 103Q595 125 608 162T624 225L626 251H666V247",
  932: "36 443Q37 448 46 558T55 671V677H666V671Q667 666 676 556T685 443V437H645V443Q645 445 642 478T631 544T610 593Q593 614 555 625Q534 630 478 630H451H443Q417 630 414 618Q413 616 413 339V63Q420 53 439 50T528 46H558V0H545L361 3Q186 1 177 0H164V46H194Q264 46 283 49T309 63V339V550Q309 620 304 625T271 630H244H224Q154 630 119 601Q101 585 93 554T81 486T76 443V437H36V443",
  933: "55 551Q55 604 91 654T194 705Q240 705 277 681T334 624T367 556T385 498L389 474L392 488Q394 501 400 521T414 566T438 615T473 659T521 692T584 705Q620 705 648 689T691 647T714 597T722 551Q722 540 719 538T699 536Q680 536 677 541Q677 542 677 544T676 548Q676 576 650 596T588 616H582Q538 616 505 582Q466 543 454 477T441 318Q441 301 441 269T442 222V61Q448 55 452 53T478 48T542 46H569V0H557Q533 3 389 3T221 0H209V46H236Q256 46 270 46T295 47T311 48T322 51T328 54T332 57T337 61V209Q337 383 333 415Q313 616 189 616Q154 616 128 597T101 548Q101 540 97 538T78 536Q63 536 59 538T55 551",
  934: "312 622Q310 623 307 625T303 629T297 631T286 634T270 635T246 636T211 637H184V683H196Q220 680 361 680T526 683H538V637H511Q468 637 447 635T422 631T411 622V533L425 531Q525 519 595 466T665 342Q665 301 642 267T583 209T506 172T425 152L411 150V61Q417 55 421 53T447 48T511 46H538V0H526Q502 3 361 3T196 0H184V46H211Q231 46 245 46T270 47T286 48T297 51T303 54T307 57T312 61V150H310Q309 151 289 153T232 166T160 195Q149 201 136 210T103 238T69 284T56 342Q56 414 128 467T294 530Q309 532 310 533H312V622ZM170 342Q170 207 307 188H312V495H309Q301 495 282 491T231 469T186 423Q170 389 170 342ZM415 188Q487 199 519 236T551 342Q551 384 539 414T507 459T470 481T434 491T415 495H410V188H415",
  935: "270 0Q252 3 141 3Q46 3 31 0H23V46H40Q129 50 161 88Q165 94 244 216T324 339Q324 341 235 480T143 622Q133 631 119 634T57 637H37V683H46Q64 680 172 680Q297 680 318 683H329V637H324Q307 637 286 632T263 621Q263 618 322 525T384 431Q385 431 437 511T489 593Q490 595 490 599Q490 611 477 622T436 637H428V683H437Q455 680 566 680Q661 680 676 683H684V637H667Q585 634 551 599Q548 596 478 491Q412 388 412 387Q412 385 514 225T620 62Q628 53 642 50T695 46H726V0H717Q699 3 591 3Q466 3 445 0H434V46H440Q454 46 476 51T499 64Q499 67 463 124T390 238L353 295L350 292Q348 290 343 283T331 265T312 236T286 195Q219 88 218 84Q218 70 234 59T272 46H280V0H270",
  936: "340 622Q338 623 335 625T331 629T325 631T314 634T298 635T274 636T239 637H212V683H224Q248 680 389 680T554 683H566V637H539Q479 637 464 635T439 622L438 407Q438 192 439 192Q443 193 449 195T474 207T507 232T536 276T557 344Q560 365 562 417T573 493Q587 536 620 544Q627 546 671 546H715L722 540V515Q714 509 708 509Q680 505 671 476T658 392T644 307Q599 177 451 153L438 151V106L439 61Q446 54 451 52T476 48T539 46H566V0H554Q530 3 389 3T224 0H212V46H239Q259 46 273 46T298 47T314 48T325 51T331 54T335 57T340 61V151Q126 178 117 406Q115 503 69 509Q55 509 55 526Q55 541 59 543T86 546H107H120Q150 546 161 543T184 528Q198 514 204 493Q212 472 213 420T226 316T272 230Q287 216 303 207T330 194L339 192Q340 192 340 407V622",
  937: "55 454Q55 503 75 546T127 617T197 665T272 695T337 704H352Q396 704 404 703Q527 687 596 615T666 454Q666 392 635 330T559 200T499 83V80H543Q589 81 600 83T617 93Q622 102 629 135T636 172L637 177H677V175L660 89Q645 3 644 2V0H552H488Q461 0 456 3T451 20Q451 89 499 235T548 455Q548 512 530 555T483 622T424 656T361 668Q332 668 303 658T243 626T193 560T174 456Q174 380 222 233T270 20Q270 7 263 0H77V2Q76 3 61 89L44 175V177H84L85 172Q85 171 88 155T96 119T104 93Q109 86 120 84T178 80H222V83Q206 132 162 199T87 329T55 454",
  8192: "",
  8193: "",
  8194: "",
  8195: "",
  8196: "",
  8197: "",
  8198: "",
  8201: "",
  8202: "",
  8203: "",
  8204: "",
  8211: "0 248V285H499V248H0",
  8212: "0 248V285H999V248H0",
  8213: "0 248V285H999V248H0",
  8214: "133 736Q138 750 153 750Q164 750 170 739Q172 735 172 250T170 -239Q164 -250 152 -250Q144 -250 138 -244L137 -243Q133 -241 133 -179T132 250Q132 731 133 736ZM329 739Q334 750 346 750Q353 750 361 744L362 743Q366 741 366 679T367 250T367 -178T362 -243L361 -244Q355 -250 347 -250Q335 -250 329 -239Q327 -235 327 250T329 739",
  8215: "0 -62V-25H499V-62H0",
  8216: "64 494Q64 548 86 597T131 670T160 694Q163 694 172 685T182 672Q182 669 170 656T144 625T116 573T101 501Q101 489 102 489T107 491T120 497T138 500Q163 500 180 483T198 440T181 397T139 379Q110 379 87 405T64 494",
  8217: "78 634Q78 659 95 676T138 694Q166 694 189 668T212 579Q212 525 190 476T146 403T118 379Q114 379 105 388T95 401Q95 404 107 417T133 448T161 500T176 572Q176 584 175 584T170 581T157 576T139 573Q114 573 96 590T78 634",
  8220: "128 494Q128 528 137 560T158 616T185 658T209 685T223 694T236 685T245 670Q244 668 231 654T204 622T178 571T164 501Q164 489 165 489T170 491T183 497T201 500Q226 500 244 483T262 440T245 397T202 379Q173 379 151 405T128 494ZM332 494Q332 528 341 560T362 616T389 658T413 685T427 694T439 685T449 672Q449 669 437 656T411 625T383 573T368 501Q368 489 369 489T374 491T387 497T405 500Q430 500 448 483T466 440T449 397T406 379Q377 379 355 405T332 494",
  8221: "34 634Q34 659 50 676T93 694Q121 694 144 668T168 579Q168 525 146 476T101 403T73 379Q69 379 60 388T50 401Q50 404 62 417T88 448T116 500T131 572Q131 584 130 584T125 581T112 576T94 573Q69 573 52 590T34 634ZM238 634Q238 659 254 676T297 694Q325 694 348 668T372 579Q372 525 350 476T305 403T277 379Q273 379 264 388T254 401Q254 404 266 417T292 448T320 500T335 572Q335 584 334 584T329 581T316 576T298 573Q273 573 256 590T238 634",
  8224: "182 675Q195 705 222 705Q234 705 243 700T253 691T263 675L262 655Q262 620 252 549T240 454V449Q250 451 288 461T346 472T377 461T389 431Q389 417 379 404T346 390Q327 390 288 401T243 412H240V405Q245 367 250 339T258 301T261 274T263 225Q263 124 255 -41T239 -213Q236 -216 222 -216H217Q206 -216 204 -212T200 -186Q199 -175 199 -168Q181 38 181 225Q181 265 182 280T191 327T204 405V412H201Q196 412 157 401T98 390Q76 390 66 403T55 431T65 458T98 472Q116 472 155 462T205 449Q204 452 204 460T201 490T193 547Q182 619 182 655V675",
  8225: "181 658Q181 705 222 705T263 658Q263 633 252 572T240 497Q240 496 241 496Q243 496 285 507T345 519Q365 519 376 508T388 478Q388 466 384 458T375 447T361 438H344Q318 438 282 448T241 459Q240 458 240 456Q240 449 251 384T263 297Q263 278 255 267T238 253T222 250T206 252T190 266T181 297Q181 323 192 383T204 458Q204 459 203 459Q198 459 162 449T101 438H84Q74 443 70 446T61 457T56 478Q56 497 67 508T99 519Q117 519 159 508T203 496Q204 496 204 499Q204 507 193 572T181 658ZM181 202Q181 249 222 249T263 202Q263 185 259 161T249 103T240 48V41H243Q248 41 287 52T346 63T377 52T389 22Q389 8 379 -5T346 -19Q327 -19 288 -8T243 3H240V-4Q243 -24 249 -58T259 -117T263 -158Q263 -177 255 -188T238 -202T222 -205T206 -203T190 -189T181 -158Q181 -141 185 -117T195 -59T204 -4V3H201Q196 3 157 -8T98 -19Q76 -19 66 -6T55 22T65 49T98 63Q117 63 156 52T201 41H204V48Q201 68 195 102T185 161T181 202",
  8226: "55 251Q55 328 112 386T249 444T386 388T444 249Q444 171 388 113T250 55Q170 55 113 112T55 251",
  8230: "78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60ZM525 60Q525 84 542 102T585 120Q609 120 627 104T646 61Q646 36 629 18T586 0T543 17T525 60ZM972 60Q972 84 989 102T1032 120Q1056 120 1074 104T1093 61Q1093 36 1076 18T1033 0T990 17T972 60",
  8242: "79 43Q73 43 52 49T30 61Q30 68 85 293T146 528Q161 560 198 560Q218 560 240 545T262 501Q262 496 260 486Q259 479 173 263T84 45T79 43",
  8245: "12 501Q12 527 31 542T63 558Q73 560 77 560Q114 560 128 528Q133 518 188 293T244 61Q244 56 223 50T195 43Q192 43 190 45T102 263T14 486Q12 496 12 501",
  8254: "69 544V590H430V544H69",
  8260: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
  8288: "",
  8289: "",
  8290: "",
  8291: "",
  8292: "",
  8407: "377 694Q377 702 382 708T397 714Q404 714 409 709Q414 705 419 690Q429 653 460 633Q471 626 471 615Q471 606 468 603T454 594Q411 572 379 531Q377 529 374 525T369 519T364 517T357 516Q350 516 344 521T337 536Q337 555 384 595H213L42 596Q29 605 29 615Q29 622 42 635H401Q377 673 377 694",
  8450: "684 131Q684 125 672 109T633 71T573 29T489 -5T386 -19Q330 -19 276 -3T174 46T91 134T44 261Q39 283 39 341T44 421Q66 538 143 611T341 699Q344 699 364 700T395 701Q449 698 503 677T585 655Q603 655 611 662T620 678T625 694T639 702Q650 702 657 690V481L653 474Q640 467 628 472Q624 476 618 496T595 541Q562 587 507 625T390 663H381Q337 663 299 625Q212 547 212 336Q212 249 233 179Q274 30 405 30Q533 30 641 130Q658 147 666 147Q671 147 677 143T684 131ZM250 625Q264 643 261 643Q238 635 214 620T161 579T110 510T79 414Q74 384 74 341T79 268Q89 213 113 169T164 101T217 61T260 39L277 34Q270 41 264 48Q199 111 181 254Q178 281 178 344T181 434Q200 559 250 625ZM621 565V625Q617 623 613 623Q603 619 590 619H575L588 605Q608 583 610 579L621 565",
  8459: "331 505Q331 519 382 574T472 629H480Q512 629 529 614T547 576Q547 555 534 532T520 504Q520 493 549 493Q590 493 623 506T668 533L681 546Q731 600 772 641T832 700T852 717Q857 717 860 711T865 697L866 690Q866 688 813 617T708 475T656 403Q682 403 714 404H771L780 416Q1004 707 1167 707Q1209 707 1225 689T1241 646Q1241 604 1209 547T1118 447Q1081 422 1034 405T952 382T888 374T857 370H852L826 334Q733 204 708 144Q691 104 691 76Q691 29 748 29Q768 31 791 48T831 83T862 122T881 146Q883 148 900 148H917Q921 143 921 140T914 127Q810 -8 723 -8Q611 -4 611 100Q611 142 631 191T676 275T721 337T742 367Q716 367 685 366H628L620 355Q618 352 558 268Q486 168 461 141Q405 79 339 34T215 -28Q188 -36 153 -36Q86 -36 58 -11T29 46Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q67 82 67 60Q67 28 99 14T170 0Q214 0 272 47T419 224L505 340L518 357Q513 357 504 356T467 347T415 330T360 300T308 253Q296 238 295 237H278H274Q256 237 256 243Q256 248 263 256Q291 294 330 321T407 362T476 382T530 393T552 398Q556 402 573 423T600 454Q602 457 604 460T608 465L610 467Q565 455 532 455Q465 455 449 483Q447 487 447 498Q447 513 463 538T479 579Q479 593 463 593Q436 593 385 519Q374 504 371 502T360 499H353H349Q331 499 331 505ZM1195 634Q1195 643 1195 648T1185 662T1157 671Q1130 671 1092 644T1019 579T952 502T901 436L882 409L891 410Q900 411 913 412T934 415Q1081 439 1144 520Q1195 590 1195 634",
  8460: "11 -16L1 0Q7 6 25 27T57 62T91 88T128 101Q159 99 195 66L203 59L211 67Q239 95 239 133Q239 158 210 213T152 330T123 430Q123 477 173 536T269 630T320 666Q376 610 440 606H443Q457 606 466 611T519 647L542 664Q543 664 543 654V643L522 622Q434 537 403 537Q388 537 366 543T329 555T293 570T270 580L261 585L253 574Q206 517 206 475Q206 452 218 416T242 356L255 331Q256 331 270 345T324 391T421 459L437 468H453Q545 463 608 421L618 415L623 392Q644 307 644 233Q644 97 612 9Q604 -10 601 -15T581 -35Q505 -104 467 -124Q446 -133 431 -133Q414 -132 399 -126T376 -115T368 -107Q368 -106 392 -75L415 -43Q432 -67 444 -73T472 -79H474Q479 -79 484 -78T501 -69T521 -50T538 -13T551 46Q558 97 558 180Q558 232 557 245Q553 277 547 300T528 349T488 389T424 404Q344 404 276 295Q272 288 273 285Q300 216 300 168Q300 161 300 156T298 145T297 137T293 129T289 123T283 116T277 107Q212 23 178 -13L166 -26L149 -9Q108 32 81 32Q63 32 21 -7L11 -16",
  8461: "14 666Q14 675 26 683H344L351 679Q361 665 351 655Q344 648 317 648Q287 645 282 641Q270 637 269 623T266 497V370H511V497Q511 519 510 553Q509 615 507 626T496 641H495Q489 645 459 648Q420 648 420 665Q420 672 426 679L433 683H751Q762 676 762 666Q762 648 724 648Q684 645 677 632Q675 626 675 341Q675 57 677 52Q684 38 724 35Q762 35 762 16Q762 6 751 -1H433L426 3Q420 10 420 17Q420 35 459 35Q501 38 506 52Q511 64 511 190V323H266V190Q266 60 271 52Q276 38 317 35Q342 35 351 28Q360 17 351 3L344 -1H26Q14 5 14 16Q14 35 53 35Q94 38 99 52Q104 60 104 341T99 632Q93 645 53 648Q14 648 14 666ZM233 341V553Q233 635 239 648H131Q134 641 135 638T137 603T139 517T139 341Q139 131 138 89T132 37Q131 36 131 35H239Q233 47 233 129V341ZM639 341V489Q639 548 639 576T640 620T642 639T646 648H537L542 639Q546 625 546 341Q546 130 545 88T538 37Q537 36 537 35H646Q643 41 643 42T641 55T639 84T639 140V341",
  8462: "137 683Q138 683 209 688T282 694Q294 694 294 685Q294 674 258 534Q220 386 220 383Q220 381 227 388Q288 442 357 442Q411 442 444 415T478 336Q478 285 440 178T402 50Q403 36 407 31T422 26Q450 26 474 56T513 138Q516 149 519 151T535 153Q555 153 555 145Q555 144 551 130Q535 71 500 33Q466 -10 419 -10H414Q367 -10 346 17T325 74Q325 90 361 192T398 345Q398 404 354 404H349Q266 404 205 306L198 293L164 158Q132 28 127 16Q114 -11 83 -11Q69 -11 59 -2T48 16Q48 30 121 320L195 616Q195 629 188 632T149 637H128Q122 643 122 645T124 664Q129 683 137 683",
  8463: "150 475Q147 475 118 466T82 457Q73 457 64 467T54 487Q54 490 55 492Q63 506 64 506Q67 512 118 526Q162 541 169 546Q173 559 175 575Q181 596 181 604Q181 613 166 617Q164 617 153 618T135 619Q119 619 114 621T109 630Q109 636 114 656T122 681Q125 685 202 688Q272 695 286 695Q304 695 304 684Q304 682 291 628L278 577L386 612Q466 635 476 635T492 627T499 607Q499 593 489 586Q485 583 373 546L262 512Q262 511 248 455T233 397T236 397T244 404Q295 441 357 441Q405 441 445 417T485 333Q485 284 449 178T412 58T426 44Q447 44 466 68Q485 87 500 130L509 152H531H543Q562 152 562 144Q562 128 546 93T494 23T415 -13Q385 -13 359 3T322 44Q318 52 318 77Q318 99 352 196T386 337Q386 386 346 386Q318 386 286 370Q267 361 245 338T211 292Q207 287 193 235T162 113T138 21Q128 7 122 4Q105 -12 83 -12Q66 -12 54 -2T42 26Q42 45 98 257L151 475H150",
  8464: "487 225Q398 255 398 342Q398 410 455 492Q491 545 552 582T669 636T800 673T918 712Q930 717 933 717Q939 717 942 706T946 689Q946 686 915 664T830 591T729 480Q691 429 657 351T615 260Q628 260 663 279T733 339T769 426Q769 442 767 459T764 479Q764 484 766 486Q769 488 781 493T797 498Q802 498 803 494T808 472Q813 442 813 425Q813 369 761 315Q692 246 605 224L592 220L584 209Q547 155 487 106T358 25Q270 -17 191 -17Q143 -17 101 1T59 59Q59 96 85 127T148 158Q169 158 179 146T189 119Q189 102 167 89T125 75Q116 75 109 77T101 81T97 80Q96 77 96 72Q96 50 123 36T204 21H216Q249 21 302 49T411 134Q439 161 459 187Q487 220 487 225ZM460 334Q460 308 472 290T498 268L510 263Q515 263 545 313T626 438T723 561Q751 589 775 609T808 636T817 644H816Q813 644 732 618Q681 601 645 584T585 548T549 514T518 476Q460 390 460 334",
  8465: "190 601Q161 601 137 587T97 553T71 512T55 477T48 463Q44 465 39 468L30 473L35 488Q73 594 106 636T199 685Q200 686 211 686Q250 686 326 652T417 617Q435 617 455 626T497 652T522 670Q532 660 532 654Q469 591 390 550L378 543L343 556Q223 601 190 601ZM378 208Q378 249 369 318T360 424Q360 430 360 439T361 451L362 462Q416 526 482 571L495 580L503 577L511 575L499 562Q442 502 442 465Q442 436 452 368T462 246Q462 169 442 128T385 56Q292 -26 195 -26Q150 -26 104 14L96 21L43 -16Q43 -15 43 -14T41 -10T38 0L48 13Q76 50 123 97L150 125Q154 131 159 131Q166 131 171 116T182 81T193 53Q199 43 216 33T261 22Q307 22 344 68Q378 113 378 208",
  8466: "572 704Q607 704 607 693Q607 681 590 664H588Q586 664 584 664T578 663Q504 658 434 592T363 457Q363 426 386 401Q417 371 481 361Q490 360 527 360H562Q565 363 595 404T666 494T755 596T854 682T945 717Q986 717 1010 696T1035 637Q1035 593 996 531T873 414Q809 378 753 360T674 338T651 333Q650 333 633 308T588 245T544 185Q498 126 426 78L413 68H414Q498 47 575 47Q626 47 676 74T755 139L762 148H779H783Q802 148 802 142Q802 137 795 129Q760 81 691 33T544 -16Q470 -16 366 20L341 29L331 24Q239 -17 155 -17H141Q90 -17 61 -12T23 1T14 22Q14 44 39 65T103 95Q126 101 180 101Q224 101 258 98T309 90T330 86Q332 86 353 103T389 135Q401 146 412 158T431 179T450 203T466 225T485 252T505 280L535 322H509Q391 322 340 362T289 452Q289 495 321 547T396 630Q438 665 486 684T572 704ZM978 635Q978 644 977 650T973 661T968 668T961 673T954 676T946 678T938 680Q929 680 925 677Q893 659 795 531T682 377Q683 377 711 385T755 401T801 421T856 453T906 495Q927 516 952 557T978 635ZM274 50Q274 51 258 54T216 61T166 65Q160 65 151 65T140 64Q115 58 102 48T88 31Q88 20 159 20Q191 20 219 27T261 42L274 50",
  8467: "345 104T349 104T361 95T369 80T352 59Q268 -20 206 -20Q170 -20 146 3T113 53T99 104L94 129Q94 130 79 116T48 86T28 70Q22 70 15 79T7 94Q7 98 12 103T58 147L91 179V185Q91 186 91 191T92 200Q92 282 128 400T223 612T336 705Q397 705 397 636V627Q397 453 194 233Q185 223 180 218T174 211T171 208T165 201L163 186Q159 142 159 123Q159 17 208 17Q228 17 253 30T293 56T335 94Q345 104 349 104ZM360 634Q360 655 354 661T336 668Q328 668 322 666T302 645T272 592Q252 547 229 467T192 330L179 273Q179 272 186 280T204 300T221 322Q327 453 355 590Q360 612 360 634",
  8469: "20 664Q20 666 31 683H142Q256 683 258 681Q259 680 279 653T342 572T422 468L582 259V425Q582 451 582 490T583 541Q583 611 573 628T522 648Q500 648 493 654Q484 665 493 679L500 683H691Q702 676 702 666Q702 657 698 652Q688 648 680 648Q633 648 627 612Q624 601 624 294V-8Q616 -20 607 -20Q601 -20 596 -15Q593 -13 371 270L156 548L153 319Q153 284 153 234T152 167Q152 103 156 78T172 44T213 34Q236 34 242 28Q253 17 242 3L236 -1H36Q24 6 24 16Q24 34 56 34Q58 35 69 36T86 40T100 50T109 72Q111 83 111 345V603L96 619Q72 643 44 648Q20 648 20 664ZM413 419L240 648H120L136 628Q137 626 361 341T587 54L589 68Q589 78 589 121V192L413 419",
  8472: "300 74Q300 133 338 133Q350 133 356 126T363 109Q363 88 340 76Q340 71 342 62T358 39T393 26Q435 26 474 67T532 182T551 290Q551 325 535 349T484 373Q430 373 378 348T291 289T228 218T187 157T174 130Q254 30 265 10Q276 -15 276 -41Q276 -101 235 -158T142 -216Q112 -216 90 -195T67 -118Q67 -40 104 64L110 81Q81 118 81 174Q81 268 134 360T247 453Q252 453 255 451T258 447L259 445Q259 432 253 420Q251 416 242 416Q209 411 176 341T142 203Q142 193 143 184T146 170T149 165L158 180Q215 280 303 345T485 410Q548 410 586 368T625 255Q625 157 553 74T389 -10H383Q349 -10 325 14Q302 37 300 74ZM105 -123Q105 -134 106 -141T110 -158T122 -173T145 -178Q155 -178 160 -176Q184 -163 199 -132T214 -73Q214 -69 214 -66T213 -59T212 -53T209 -47T205 -41T199 -33T193 -25T184 -14T174 -1L165 10Q156 22 148 32L139 43Q138 43 130 15T113 -54T105 -123",
  8473: "16 666Q16 675 28 683H195Q334 683 370 682T437 672Q511 657 554 611T597 495Q597 343 404 309Q402 308 401 308Q381 303 319 303H261V181Q261 157 262 120Q262 60 267 50T304 36Q310 35 313 35Q352 35 352 17Q352 10 346 3L339 -1H28Q16 5 16 16Q16 35 53 35Q68 36 75 37T87 42T95 52Q98 61 98 341T95 630Q91 640 83 643T53 648Q16 648 16 666ZM235 35Q228 46 227 84Q226 129 226 337V621L230 635L237 648H128Q128 647 133 632Q136 620 136 341Q136 64 133 50L128 35H235ZM301 341H313Q339 341 354 344T389 362T417 410T426 498Q426 586 401 616T322 647Q301 647 293 643Q271 637 264 621Q261 617 261 479V341H301ZM429 350Q431 350 443 353T476 367T515 391T548 432T562 490Q562 550 524 592Q507 607 484 619Q481 621 448 635L433 639L439 621Q462 578 462 506Q462 448 454 413T437 366T428 350H429",
  8474: "480 -10Q480 -13 486 -24T507 -50T541 -80T588 -104T648 -114Q666 -114 688 -110T714 -106Q724 -106 728 -114T729 -130Q723 -145 663 -163T548 -181Q503 -181 463 -169T395 -139T343 -97T307 -56T284 -19L280 -3L262 1Q188 24 131 81Q57 155 37 275Q34 292 34 342T37 410Q58 528 131 601Q179 652 248 676T388 701Q485 701 562 661Q698 595 731 448Q742 410 742 341T731 235Q707 141 646 81Q616 50 575 27T493 -5L480 -10ZM568 342Q568 613 437 659L395 666Q329 666 286 626Q232 570 213 439Q210 408 210 342T213 246Q231 113 286 57Q309 37 342 23Q357 19 389 19Q420 19 437 23Q469 38 491 57Q568 134 568 342ZM174 341V354Q174 393 175 419T183 484T205 561T246 635L249 639Q246 639 224 627T193 608Q189 606 183 601T169 589T155 577Q69 491 69 344Q69 133 231 52Q247 42 247 46Q247 46 246 48Q231 69 222 85T200 141T177 239Q174 269 174 341ZM708 341Q708 410 689 467T640 556T588 606T546 630Q532 638 531 638Q530 638 531 635Q563 590 577 543Q602 472 602 341V316Q602 264 599 230T580 144T531 48Q529 44 532 45T546 52Q575 68 596 84T642 128T683 200T706 299Q708 327 708 341ZM391 -17H333Q329 -15 326 -15Q324 -15 324 -17Q324 -21 362 -68Q424 -130 506 -143Q518 -144 544 -144Q569 -144 577 -143L589 -141L575 -139Q544 -127 509 -101T453 -37L442 -19L391 -17",
  8475: "224 266Q185 266 156 286T127 354Q127 419 176 487T282 594Q346 642 433 679T615 717Q732 717 802 680L815 673Q824 680 840 690T860 700Q864 700 867 693T872 680L873 673Q873 668 858 659L845 651L853 642Q887 605 887 561Q887 500 840 439Q790 379 681 336Q693 312 693 292Q692 276 689 263T672 229T653 198T620 152L575 87Q557 57 557 33Q557 24 560 17T566 8L569 5Q546 5 508 25T470 76Q470 83 473 92T545 198T616 310Q616 317 615 318T612 319Q603 319 575 315H560L545 291Q492 201 429 135T277 23Q202 -17 142 -17H130Q50 -17 16 17Q-2 35 -2 57Q-2 95 24 126T88 158Q106 158 116 147T127 121Q127 110 122 102Q116 93 99 84T63 75Q58 75 53 76T47 77T45 75T44 67Q45 52 57 42T88 27T120 21T144 19Q174 19 208 36T267 76T324 134T369 189T406 239Q462 319 504 374T616 503T755 631L770 644Q767 647 753 654T697 670T602 680Q493 680 399 631T247 516Q218 485 193 440T168 359Q168 328 188 316T234 303Q255 303 273 315T304 340T343 389T390 448Q428 490 441 510T456 548Q456 557 458 559Q459 560 476 567T496 575Q505 575 505 558Q505 511 434 412Q429 406 427 403Q397 360 378 343Q342 308 300 287T224 266ZM819 564Q819 595 800 619L784 606Q729 557 692 512T605 387L591 365L610 364Q622 364 631 363T641 361Q643 361 651 363Q725 388 772 449T819 564ZM794 141Q794 123 725 63T612 3Q609 3 612 5Q612 5 615 7Q639 19 678 57T742 131L755 148H772H780Q794 148 794 141ZM588 -3Q590 0 593 0H594L593 -1Q592 -1 590 -2L588 -3",
  8476: "27 496Q31 569 102 627T234 685Q236 685 241 685T251 686Q287 686 318 672T367 638T399 598T418 564L423 550Q424 554 434 567T463 601T505 639T561 671T626 685Q672 685 688 659T710 572Q713 533 721 523T766 513Q781 513 787 514T794 516Q796 512 798 509T801 504T802 501T787 493Q702 461 624 401L607 389Q655 383 688 358L697 352V342Q699 330 699 297Q704 209 710 173T734 103Q751 69 765 69Q769 69 806 83L824 90V74Q823 73 759 24T693 -26Q692 -26 660 32L628 90L629 111Q631 159 631 177Q631 278 614 300Q584 340 523 340Q500 340 467 333T431 325Q429 325 429 322Q428 321 426 308T420 275T410 230T392 178T366 125L358 112L342 99Q306 70 269 38T213 -10T193 -26Q192 -26 163 0T116 26Q82 26 50 -8L42 -16L35 -8L27 0L35 10Q43 21 58 38T104 80T158 106Q179 106 218 65L235 48Q238 48 255 60T295 99T329 158Q352 231 352 359Q352 555 242 614Q210 628 187 628Q140 628 116 600T91 548Q91 522 138 464T185 382V376Q185 345 158 313T103 263L76 246Q74 244 64 253L54 260L65 267Q91 285 100 302Q111 318 111 337Q111 355 69 410T27 496ZM562 628Q504 628 443 507L435 491L436 479Q437 471 437 446Q437 396 432 351L529 389L602 426Q673 462 673 463H672Q644 470 637 483T622 553Q608 628 562 628",
  8477: "17 665Q17 672 28 683H221Q415 681 439 677Q461 673 481 667T516 654T544 639T566 623T584 607T597 592T607 578T614 565T618 554L621 548Q626 530 626 497Q626 447 613 419Q578 348 473 326L455 321Q462 310 473 292T517 226T578 141T637 72T686 35Q705 30 705 16Q705 7 693 -1H510Q503 6 404 159L306 310H268V183Q270 67 271 59Q274 42 291 38Q295 37 319 35Q344 35 353 28Q362 17 353 3L346 -1H28Q16 5 16 16Q16 35 55 35Q96 38 101 52Q106 60 106 341T101 632Q95 645 55 648Q17 648 17 665ZM241 35Q238 42 237 45T235 78T233 163T233 337V621L237 635L244 648H133Q136 641 137 638T139 603T141 517T141 341Q141 131 140 89T134 37Q133 36 133 35H241ZM457 496Q457 540 449 570T425 615T400 634T377 643Q374 643 339 648Q300 648 281 635Q271 628 270 610T268 481V346H284Q327 346 375 352Q421 364 439 392T457 496ZM492 537T492 496T488 427T478 389T469 371T464 361Q464 360 465 360Q469 360 497 370Q593 400 593 495Q593 592 477 630L457 637L461 626Q474 611 488 561Q492 537 492 496ZM464 243Q411 317 410 317Q404 317 401 315Q384 315 370 312H346L526 35H619L606 50Q553 109 464 243",
  8484: "39 -1Q29 9 29 12Q29 23 60 77T219 337L410 648H364Q261 648 210 628Q168 612 142 588T109 545T97 509T88 490Q85 489 80 489Q72 489 61 503L70 588Q72 607 75 628T79 662T81 675Q84 677 88 681Q90 683 341 683H592Q604 673 604 666Q604 662 412 348L221 37Q221 35 301 35Q406 35 446 48Q504 68 543 111T597 212Q602 239 617 239Q624 239 629 234T635 223Q635 215 621 113T604 8L597 1Q595 -1 317 -1H39ZM148 637L166 648H112V632Q111 629 110 622T108 612Q108 608 110 608T116 612T129 623T148 637ZM552 646Q552 648 504 648Q452 648 450 643Q448 639 266 343T77 37Q77 35 128 35H179L366 339L552 646ZM572 35Q581 89 581 97L561 77Q542 59 526 48L508 37L539 35H572",
  8486: "55 454Q55 503 75 546T127 617T197 665T272 695T337 704H352Q396 704 404 703Q527 687 596 615T666 454Q666 392 635 330T559 200T499 83V80H543Q589 81 600 83T617 93Q622 102 629 135T636 172L637 177H677V175L660 89Q645 3 644 2V0H552H488Q461 0 456 3T451 20Q451 89 499 235T548 455Q548 512 530 555T483 622T424 656T361 668Q332 668 303 658T243 626T193 560T174 456Q174 380 222 233T270 20Q270 7 263 0H77V2Q76 3 61 89L44 175V177H84L85 172Q85 171 88 155T96 119T104 93Q109 86 120 84T178 80H222V83Q206 132 162 199T87 329T55 454",
  8487: "126 584Q119 584 110 539T97 493Q95 490 73 490Q44 490 44 501Q44 515 62 590Q75 672 82 679Q84 684 177 684Q193 684 214 684T241 685Q265 685 271 682T277 664V648Q271 572 229 434T186 231Q186 173 203 132T247 70T302 42T360 33Q391 33 419 42T474 72T517 133T533 231Q533 297 491 437T442 648Q442 675 446 679Q448 684 542 684Q635 684 637 681Q640 678 657 594T675 501Q675 490 646 490Q624 490 622 493Q620 493 609 538T593 584Q591 585 585 585T569 586T551 588H513Q514 586 518 573T538 531T582 453Q647 340 660 277Q663 259 663 232Q663 194 657 177Q652 151 629 112T560 39Q495 -5 424 -19Q403 -22 360 -22Q318 -22 297 -19Q239 -8 193 18T120 74T80 131T62 177Q56 194 56 229Q56 281 74 328T137 453Q160 491 174 518T193 555T201 575T206 588H168Q160 587 150 587T134 586T126 584",
  8488: "148 590Q95 592 91 627V633L160 729H176Q169 713 169 705Q169 670 244 670Q269 670 305 672T357 675Q405 675 432 661T468 609Q469 605 469 596Q469 572 460 540Q433 463 301 372Q325 378 359 378Q431 378 472 350T519 297Q532 249 532 198Q532 115 500 40T442 -57Q335 -139 202 -139Q165 -139 125 -131L112 -129V-100Q112 -49 106 -33T75 -17Q55 -17 31 -35L22 -42L11 -26L22 -18Q94 36 151 36H160Q171 36 178 33T188 27T194 13T196 -5T197 -32Q198 -79 206 -90Q217 -107 251 -107Q336 -107 389 -33T442 155Q442 240 407 274Q362 319 285 319Q236 319 192 298Q188 298 181 309L224 372Q227 373 234 374T246 376T257 379T271 384T285 391T302 402T321 417Q384 471 384 540Q384 562 366 581T306 600Q292 600 233 595T148 590",
  8492: "256 262Q161 262 161 351Q161 408 203 471T289 570Q380 645 475 676T617 707L627 708Q637 708 644 708Q759 708 831 675L844 669L857 677Q892 700 896 700Q902 700 907 685Q907 683 907 681T908 678T909 676T909 673Q909 671 909 670T906 667T903 664T897 660T889 655L878 647L889 636Q928 598 928 548Q928 529 923 510T907 474T886 442T861 412T837 388T815 368T800 355Q847 323 847 270V263Q847 205 806 145Q766 82 695 37T564 -8Q527 -8 506 10T484 58Q484 85 501 117T543 172Q607 226 685 228Q695 228 698 226Q703 220 692 206Q684 194 682 193T665 191Q625 189 595 172T550 133T529 93T522 66Q522 29 576 29Q642 29 705 109Q785 211 785 270Q785 287 779 300T769 316T755 327L740 319Q682 290 634 290Q611 290 592 294H588L565 261Q559 252 544 231T522 201T504 178T481 151T455 123Q394 63 314 18T159 -28Q103 -28 67 -6T31 54Q31 88 57 123T123 158Q144 158 154 146T164 119Q164 102 142 89T100 75Q94 75 87 77T76 80L72 81Q69 78 69 65Q69 35 102 22T175 9Q184 9 198 11Q248 23 300 70T403 187T508 331T636 489T789 629L801 639Q796 642 786 647T732 661T633 670Q592 670 558 665Q481 651 409 613T286 520Q274 507 258 485T222 424T202 354Q202 299 269 299Q282 299 295 301T318 307T339 317T358 329T376 345T391 362T406 380T420 398T433 417T445 435Q496 512 496 547Q496 559 497 560T516 569Q526 574 530 574Q538 574 538 540Q538 414 427 325Q342 262 256 262ZM689 382Q708 382 753 375L765 387Q860 482 860 555Q860 594 839 610L822 592Q794 563 752 511T680 420T651 380Q655 381 660 381Q664 382 689 382ZM697 344Q692 345 681 345H675Q671 345 665 345T655 344T650 344L648 342Q646 339 645 338Q643 333 639 327H653Q670 329 676 330Q706 342 706 343Q702 344 697 344",
  8493: "299 585Q333 609 384 634T470 672L505 685Q506 685 513 662T531 613T548 580Q553 576 563 576Q575 576 605 585Q607 585 607 575V564Q537 532 496 527Q475 542 456 567T427 610T415 627Q410 627 398 618T382 603Q373 588 373 558T386 475T400 399Q400 337 366 303Q343 281 309 266T254 247T226 242L214 257Q214 258 223 260T251 272T287 299Q304 316 304 360Q304 396 289 451T274 532Q274 553 277 561V564H269Q205 558 172 501T139 358Q139 207 226 127T443 46Q448 46 457 46T470 47L485 48L601 106Q602 106 602 93V80Q551 48 517 25T474 -4T460 -13T443 -19Q409 -24 367 -24Q360 -24 351 -24T335 -23T326 -22Q190 -2 125 87T59 319V328Q62 412 96 487L101 500L118 512Q189 563 245 591L266 601L299 585",
  8496: "280 398L279 400Q278 402 277 405T275 413T272 426T271 443Q271 494 302 544T379 629T472 685T553 707H565H573Q630 707 664 689Q718 661 718 604Q718 548 662 492T553 436Q525 436 508 451T490 492Q490 534 531 579T619 630Q632 630 632 623Q632 619 624 606Q614 593 602 592T578 580Q566 568 549 541T532 497Q532 474 565 474Q577 474 587 476Q600 481 611 489Q630 503 651 535T672 596Q672 660 553 660H548Q494 660 450 616Q421 587 384 531T343 439Q341 420 344 415H345Q346 415 352 415T369 417T391 418Q421 418 440 412T466 398T473 382Q473 367 452 353T398 339Q370 339 348 345T315 359L304 366Q297 365 284 360T234 321T163 234Q120 160 120 117Q120 83 149 57T252 30Q311 30 357 60Q386 79 414 114T452 179Q454 186 454 200Q454 230 415 242Q401 246 373 246Q353 246 347 244Q328 236 313 219T288 184T274 149T265 121T261 109Q260 107 247 102T230 97Q223 97 223 105Q223 148 271 216T386 284Q446 284 483 260T520 195Q520 121 427 57T239 -8Q192 -8 152 2T79 46T46 133Q46 212 107 285T269 394L280 398ZM427 376Q427 377 402 380Q386 380 386 379L425 375L427 376",
  8497: "258 428Q258 489 322 562T482 685T661 735Q726 735 824 693T977 651Q990 651 990 644Q990 639 971 612T948 581Q947 580 938 580Q878 580 784 621T617 663Q544 663 480 635T379 568T320 492T299 431Q299 387 362 387Q404 387 438 402T493 438T527 486T546 531T551 563Q551 569 550 575T549 584T549 590Q551 593 563 602T579 611Q584 611 592 605T608 584T616 548Q616 513 595 477T554 423Q518 392 464 372T349 351Q258 351 258 428ZM324 187T305 187T286 196Q286 202 301 217Q327 242 383 262T484 290L527 297L567 356Q624 441 643 467T688 521Q715 550 752 581T795 613T804 603T808 587T778 547T702 444T626 300H637Q663 302 685 306L697 308L703 317Q745 376 792 400Q806 406 818 406Q849 406 849 375Q847 355 831 338T797 312T763 296L747 290Q744 289 735 266T724 241Q722 240 702 232T664 217T645 210Q638 210 638 218Q638 224 653 246T669 270Q669 271 668 271Q663 270 624 264L607 263Q570 199 529 152Q513 133 484 106T409 45T305 -13T193 -36Q109 -36 74 -10T39 50Q39 86 64 121T128 158Q171 158 171 121Q171 97 141 83Q125 75 107 75Q93 75 80 83Q76 71 76 62Q76 29 117 15T207 0Q324 0 494 248L501 258H495Q368 239 330 195Q324 187 305 187ZM775 335Q806 358 806 368Q805 369 804 369Q800 369 791 360Q774 336 775 335",
  8498: "457 681Q471 695 477 695Q485 695 497 681V12L484 -1H68Q55 14 55 19T68 39H457V328H215L211 335Q198 346 211 359L217 368H457V681",
  8499: "112 -7Q86 -7 58 6T30 48T54 103T113 130Q129 130 141 121T153 94Q153 71 132 59T90 47H80Q95 30 133 30Q180 30 228 63T311 137T402 249T500 361Q566 425 703 529T910 693Q942 721 945 721T958 716T970 709Q974 704 964 691Q961 688 905 622T847 554L595 181Q553 121 527 77T496 19L492 5Q497 5 531 46Q579 98 685 224T850 409L972 524Q994 543 1004 556Q1012 567 1097 643T1186 720Q1194 720 1206 715T1215 703Q1215 701 1191 671T1133 599T1080 530Q1036 461 983 357T862 152Q802 64 799 17Q799 7 800 5T811 2Q836 2 882 37T969 126Q972 130 974 134T978 138T983 139T996 140H1012Q1018 134 1018 132Q1018 122 981 83T889 4T795 -35Q761 -35 745 -12T728 48Q728 122 781 190Q833 269 890 370L927 434L914 422Q848 360 752 245Q643 117 582 51T498 -33T461 -50Q424 -48 424 -4Q424 84 481 172L714 495Q591 406 523 333Q507 316 430 226T313 95Q263 48 221 24T162 -4T120 -7H112",
  8501: "55 613Q55 643 61 663T74 688T85 694Q94 694 94 681Q98 632 134 588L412 285Q416 311 430 397T447 509V519L438 526Q407 554 398 571T388 617T394 664T407 688T418 694Q425 694 427 684Q429 675 454 635T488 586Q490 584 496 579T513 563T537 540Q555 516 555 487Q555 460 549 441T537 416T528 409Q519 409 517 415T513 435T503 463Q492 481 490 481Q454 264 454 246Q454 237 479 212T529 152T555 79Q555 32 538 9Q531 1 524 1Q516 1 516 13Q512 62 476 106Q468 115 337 258T195 412L193 406Q191 401 189 394T183 377T176 352T171 322T167 284T165 240Q165 224 166 220Q171 199 211 152T252 70Q252 45 235 29T203 8T175 1Q170 0 115 0H79Q60 0 58 3T55 20Q55 31 58 34Q60 37 76 37Q112 39 126 46T140 70Q140 96 112 148T83 236Q83 281 102 334T140 419T159 452Q55 556 55 613",
  8502: "56 706V726Q56 763 76 763Q83 763 87 759T98 741Q108 726 116 721L127 717L340 715Q547 712 564 709Q575 705 587 692Q599 680 605 663L609 650V137H676Q687 124 687 115Q687 110 678 100T622 43L558 -21H-9Q-22 -6 -22 -1T-13 14T42 72L107 137H569V339Q569 541 567 546Q558 555 554 557L545 563H329Q118 566 101 569Q90 573 78 586Q54 610 54 661Q54 670 56 706",
  8503: "56 750Q68 764 76 764Q88 764 97 743T125 717Q131 715 240 715T358 713Q421 691 421 640Q421 608 399 588T358 566Q353 566 352 565T351 557L356 526Q356 488 379 346T402 97Q400 21 385 -12Q366 -43 351 -43Q335 -43 329 -10Q316 40 316 64Q316 67 315 67Q313 67 269 26L222 -21H-9Q-22 -7 -22 -1Q-22 4 -14 14T42 73L107 137H311V564H211H164Q115 564 93 573T60 615Q56 630 56 690V750",
  8504: "62 757Q69 764 75 764Q87 764 97 741Q102 731 105 728T117 721L129 715H349Q569 715 580 710Q618 701 635 670Q640 661 640 639Q640 609 622 590Q617 583 604 575T580 566H573V553Q575 547 576 531T582 469T600 353Q624 205 624 104Q624 46 617 17T591 -32Q581 -43 573 -43Q550 -43 540 44Q535 73 533 319V564H322Q117 566 100 570Q90 573 77 586Q54 609 54 663Q54 689 55 706Q55 738 56 745T62 757",
  8513: "239 665Q194 665 154 653T90 629T66 617Q59 617 53 623T46 637Q46 652 66 659Q129 695 197 701Q218 705 248 705Q293 705 335 693Q371 684 435 644Q543 562 573 417Q577 393 577 341Q577 290 573 266Q531 83 384 10Q346 -9 315 -16T234 -23H206Q202 -23 183 -23T152 -21T120 -18T88 -10T63 3T44 24L37 35V297L50 310H235Q248 297 248 290Q248 285 235 270H77V103Q77 88 77 80T77 63T78 50T80 43T82 38T85 35T89 32T95 30Q126 20 206 17Q289 17 330 30Q407 55 460 120T533 275Q538 305 538 342Q538 486 452 575T239 665",
  8592: "944 261T944 250T929 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270H929Q944 261 944 250",
  8593: "27 414Q17 414 17 433Q17 437 17 439T17 444T19 447T20 450T22 452T26 453T30 454T36 456Q80 467 120 494T180 549Q227 607 238 678Q240 694 251 694Q259 694 261 684Q261 677 265 659T284 608T320 549Q340 525 363 507T405 479T440 463T467 455T479 451Q483 447 483 433Q483 413 472 413Q467 413 458 416Q342 448 277 545L270 555V-179Q262 -193 252 -193H250H248Q236 -193 230 -179V555L223 545Q192 499 146 467T70 424T27 414",
  8594: "56 237T56 250T70 270H835Q719 357 692 493Q692 494 692 496T691 499Q691 511 708 511H711Q720 511 723 510T729 506T732 497T735 481T743 456Q765 389 816 336T935 261Q944 258 944 250Q944 244 939 241T915 231T877 212Q836 186 806 152T761 85T740 35T732 4Q730 -6 727 -8T711 -11Q691 -11 691 0Q691 7 696 25Q728 151 835 230H70Q56 237 56 250",
  8595: "473 86Q483 86 483 67Q483 63 483 61T483 56T481 53T480 50T478 48T474 47T470 46T464 44Q428 35 391 14T316 -55T264 -168Q264 -170 263 -173T262 -180T261 -184Q259 -194 251 -194Q242 -194 238 -176T221 -121T180 -49Q169 -34 155 -21T125 2T95 20T67 33T44 42T27 47L21 49Q17 53 17 67Q17 87 28 87Q33 87 42 84Q158 52 223 -45L230 -55V312Q230 391 230 482T229 591Q229 662 231 676T243 693Q244 694 251 694Q264 692 270 679V-55L277 -45Q307 1 353 33T430 76T473 86",
  8596: "263 479Q267 501 271 506T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270H835Q729 349 696 475Q691 493 691 500Q691 511 711 511Q720 511 723 510T729 506T732 497T735 481T743 456Q765 389 816 336T935 261Q944 258 944 250Q944 244 939 241T915 231T877 212Q836 186 806 152T761 85T740 35T732 4Q730 -6 727 -8T711 -11Q691 -11 691 0Q691 7 696 25Q728 151 835 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q144 292 194 349T263 479",
  8597: "27 492Q17 492 17 511Q17 515 17 517T17 522T19 525T20 528T22 530T26 531T30 532T36 534Q80 545 120 572T180 627Q210 664 223 701T238 755T250 772T261 762Q261 757 264 741T282 691T319 628Q352 589 390 566T454 536L479 529Q483 525 483 511Q483 491 472 491Q467 491 458 494Q342 526 277 623L270 633V-133L277 -123Q307 -77 353 -45T430 -2T473 8Q483 8 483 -11Q483 -15 483 -17T483 -22T481 -25T480 -28T478 -30T474 -31T470 -32T464 -34Q407 -49 364 -84T300 -157T270 -223T261 -262Q259 -272 250 -272Q242 -272 239 -255T223 -201T180 -127Q169 -112 155 -99T125 -76T95 -58T67 -45T44 -36T27 -31L21 -29Q17 -25 17 -11Q17 9 28 9Q33 9 42 6Q158 -26 223 -123L230 -133V633L223 623Q192 577 146 545T70 502T27 492",
  8598: "204 662Q257 662 301 676T369 705T394 720Q398 720 407 711T417 697Q417 688 389 671T310 639T212 623Q176 623 153 628Q151 628 221 557T546 232Q942 -164 943 -168Q944 -170 944 -174Q944 -182 938 -188T924 -195Q922 -195 916 -193Q912 -191 517 204Q440 281 326 394T166 553L121 598Q126 589 126 541Q126 438 70 349Q59 332 52 332Q48 332 39 341T29 355Q29 358 38 372T57 407T77 464T86 545Q86 583 78 614T63 663T55 683Q55 693 65 693Q73 693 82 688Q136 662 204 662",
  8599: "582 697Q582 701 591 710T605 720Q607 720 630 706T697 677T795 662Q830 662 863 670T914 686T934 694Q942 694 944 685Q944 680 936 663T921 615T913 545Q913 490 927 446T956 379T970 355Q970 351 961 342T947 332Q940 332 929 349Q874 436 874 541Q874 590 878 598L832 553Q787 508 673 395T482 204Q87 -191 83 -193Q77 -195 75 -195Q67 -195 61 -189T55 -174Q55 -170 56 -168Q58 -164 453 232Q707 487 777 557T847 628Q824 623 787 623Q689 623 599 679Q582 690 582 697",
  8600: "55 675Q55 683 60 689T75 695Q77 695 83 693Q87 691 482 296Q532 246 605 174T717 62T799 -20T859 -80T878 -97Q874 -93 874 -41Q874 64 929 151Q940 168 947 168Q951 168 960 159T970 145Q970 143 956 121T928 54T913 -45Q913 -83 920 -114T936 -163T944 -185Q942 -194 934 -194Q932 -194 914 -186T864 -170T795 -162Q743 -162 698 -176T630 -205T605 -220Q601 -220 592 -211T582 -197Q582 -187 611 -170T691 -138T787 -123Q824 -123 847 -128Q848 -128 778 -57T453 268Q58 664 56 668Q55 670 55 675",
  8601: "126 -41Q126 -92 121 -97Q121 -98 139 -80T200 -20T281 61T394 173T517 296Q909 690 916 693Q922 695 924 695Q932 695 938 689T944 674Q944 670 943 668Q942 664 546 268Q292 13 222 -57T153 -128Q176 -123 212 -123Q310 -123 400 -179Q417 -190 417 -197Q417 -201 408 -210T394 -220Q392 -220 369 -206T302 -177T204 -162Q131 -162 67 -194Q63 -195 59 -192T55 -183Q55 -180 62 -163T78 -115T86 -45Q86 10 72 54T44 120T29 145Q29 149 38 158T52 168Q59 168 70 151Q126 62 126 -41",
  8602: "942 250Q942 244 928 230H511L457 148Q440 124 420 93Q404 68 400 64T389 60Q381 60 375 66T368 81Q368 88 415 159L462 230H175L188 214Q210 188 235 145T264 85Q264 75 260 74T231 72L206 74L191 103Q169 142 164 150Q130 195 64 239Q56 244 56 250T64 261Q115 294 142 323T191 397L206 428H231Q255 428 259 426T264 414Q260 397 235 355T188 288L175 272L331 270Q488 270 491 272Q491 275 542 352T597 432Q602 437 609 437Q617 437 622 432T628 417T582 341L537 272L735 270H931Q942 257 942 250",
  8603: "54 250Q54 258 66 270H277L488 272L542 350Q596 431 602 435Q604 437 609 437Q617 437 622 432T628 417T582 341L537 272L608 270H751L822 272L808 288Q786 313 761 355T733 414Q733 424 737 426T766 428H793L806 397Q829 354 864 314Q896 284 928 263Q942 257 942 250T928 237Q887 208 864 185Q829 147 806 103L793 74L766 72Q742 72 738 73T733 85Q735 102 756 137T797 198L817 225L822 230H511L457 148Q440 124 420 93Q404 68 400 64T389 60Q381 60 375 66T368 81Q368 88 415 159L462 230H264L66 232Q54 239 54 250",
  8606: "56 250Q103 277 142 322T199 417H221Q244 417 244 416Q244 414 237 397T208 344T158 278L151 270H276L285 277Q322 306 349 345T388 417H434Q434 413 424 392T393 338T349 279L340 270H634Q933 270 937 266L938 265Q944 259 944 250T938 235L937 234Q933 230 634 230H340L349 221Q372 196 393 163T424 108T434 83H388Q377 116 350 155T285 223L276 230H151L158 222Q186 191 207 156T236 104T244 84Q244 83 221 83H199Q181 133 142 178T56 250",
  8608: "943 250Q895 221 856 177T801 83H778Q755 83 755 84Q755 86 762 103T791 156T841 222L848 230H723L714 223Q677 194 650 155T611 83H565Q565 87 575 108T606 162T650 221L659 230H365Q66 230 62 234L61 235Q55 241 55 250T61 265L62 266Q66 270 365 270H659L650 279Q627 304 606 337T575 392T565 417H611Q622 384 649 345T714 277L723 270H848L841 278Q813 309 792 344T763 396T755 416Q755 417 778 417H801Q817 367 856 323T943 250",
  8610: "56 250Q103 277 142 322T199 417H221Q244 417 244 416Q244 414 237 397T208 344T158 278L151 270H873L882 277Q919 306 946 345T985 417H1031Q1031 413 1021 392T990 338T946 279L937 270V230L946 221Q969 196 990 163T1021 108T1031 83H985Q974 116 947 155T882 223L873 230H151L158 222Q186 191 207 156T236 104T244 84Q244 83 221 83H199Q181 133 142 178T56 250",
  8611: "1054 250Q1006 221 967 177T912 83H889Q866 83 866 84Q866 86 873 103T902 156T952 222L959 230H237L228 223Q191 194 164 155T125 83H79Q79 87 89 108T120 162T164 221L173 230V270L164 279Q141 304 120 337T89 392T79 417H125Q136 384 163 345T228 277L237 270H959L952 278Q924 309 903 344T874 396T866 416Q866 417 889 417H912Q928 367 967 323T1054 250",
  8614: "95 155V109Q95 83 92 73T75 63Q61 63 58 74T54 130Q54 140 54 180T55 250Q55 421 57 425Q61 437 75 437Q88 437 91 428T95 393V345V270H835Q719 357 692 493Q692 494 692 496T691 499Q691 511 708 511H711Q720 511 723 510T729 506T732 497T735 481T743 456Q765 389 816 336T935 261Q944 258 944 250Q944 244 939 241T915 231T877 212Q836 186 806 152T761 85T740 35T732 4Q730 -6 727 -8T711 -11Q691 -11 691 0Q691 7 696 25Q728 151 835 230H95V155",
  8617: "903 424T903 444T929 464Q976 464 1023 434T1070 347Q1070 316 1055 292T1016 256T971 237T929 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270H926Q929 270 941 271T960 275T978 280T998 290T1015 307Q1030 325 1030 347Q1030 355 1027 364T1014 387T983 411T929 424H928Q903 424 903 444",
  8618: "55 347Q55 380 72 404T113 441T159 458T197 464Q222 464 222 444Q222 429 204 426T157 417T110 387Q95 369 95 347Q95 339 98 330T111 307T142 283T196 270H961Q845 357 818 493Q818 494 818 496T817 499Q817 511 834 511H837Q846 511 849 510T855 506T858 497T861 481T869 456Q891 389 942 336T1061 261Q1070 258 1070 250Q1070 244 1065 241T1041 231T1003 212Q962 186 932 152T887 85T866 35T858 4Q856 -6 853 -8T837 -11Q817 -11 817 0Q817 7 822 25Q854 151 961 230H196Q149 230 102 260T55 347",
  8619: "56 250Q103 277 142 322T199 417H221Q244 417 244 416Q244 414 237 397T208 344T158 278L151 270H622V305Q622 356 624 388T635 460T661 521T709 559T785 575Q813 575 833 573T880 561T923 534T952 483T964 405Q964 374 959 350T942 307T918 276T884 255T847 242T804 235T760 231T713 230H662V-27Q654 -41 644 -41H642H640Q628 -41 622 -27V230H151L158 222Q186 191 207 156T236 104T244 84Q244 83 221 83H199Q181 133 142 178T56 250ZM924 403Q924 474 894 505T794 536Q758 536 734 526T696 500T675 453T665 395T662 319V270H699Q826 270 875 295T924 403",
  8620: "35 405Q35 454 48 489T86 542T137 567T195 575Q229 575 251 571T301 554T345 510T370 429Q377 384 377 305V270H848L841 278Q813 309 792 344T763 396T755 416Q755 417 778 417H801Q817 367 856 323T943 250Q896 221 857 177T801 83H778Q755 83 755 84Q755 86 762 103T791 156T841 222L848 230H377V-27Q369 -41 359 -41H357Q342 -41 337 -25V230H286Q247 231 225 232T169 238T115 255T75 284T45 333T35 405ZM75 406Q75 322 123 296T300 270H337V319Q335 432 317 477T240 534Q232 535 197 535Q140 535 108 507T75 406",
  8621: "57 250Q159 311 200 417H246L242 407Q215 340 159 278L152 270H276L315 310Q354 349 358 351Q366 356 376 351Q378 350 455 273L530 196L606 273Q683 350 686 351Q694 354 703 351Q705 350 782 273L858 196L933 273Q1010 350 1012 351Q1022 356 1030 351Q1034 349 1073 310L1112 270H1236L1229 278Q1173 340 1146 407L1142 417H1188Q1233 306 1331 250Q1231 192 1188 83H1142L1146 93Q1173 160 1229 222L1236 230H1168Q1155 230 1139 230T1119 229Q1112 229 1108 229T1099 231T1092 233T1085 238T1078 245T1068 256T1056 269L1021 304L984 267Q948 230 910 191T867 149Q857 144 848 150Q844 151 770 227T694 304T618 228T540 150Q531 144 521 149Q517 152 479 191T404 267L367 304L332 269Q328 264 320 256T310 246T303 239T296 234T289 231T280 229T269 229Q265 229 249 229T220 230H152L159 222Q215 160 242 93L246 83H223L200 84L195 96Q152 190 57 250",
  8622: "491 272Q491 275 542 352T597 432Q602 437 609 437Q617 437 622 432T628 417T582 341L537 272L608 270H751L822 272L808 288Q786 313 761 355T733 414Q733 424 737 426T766 428H793L806 397Q829 354 864 314Q896 284 928 263Q942 257 942 250T928 237Q887 208 864 185Q829 147 806 103L793 74L766 72Q742 72 738 73T733 85Q735 102 756 137T797 198L817 225L822 230H511L457 148Q440 124 420 93Q404 68 400 64T389 60Q381 60 375 66T368 81Q368 88 415 159L462 230H175L188 214Q210 188 235 145T264 85Q264 75 260 74T231 72L206 74L191 103Q169 142 164 150Q130 195 64 239Q56 244 56 250T64 261Q115 294 142 323T191 397L206 428H231Q255 428 259 426T264 414Q260 397 235 355T188 288L175 272L331 270Q488 270 491 272",
  8624: "56 555Q74 567 79 570T107 592T141 625T170 667T198 722H221Q244 722 244 721Q244 718 236 699T207 647T161 587L151 576L291 575H292H293H294H296H297H298H299H300H301H302H304H305H306H307H308H309H310H311H312H314H315H316H317H318H319H320H321H322H323H324H325H327H328H329H330H331H332H333H334H335H336H337H338H339H340H341H342H343H345Q435 574 438 570L439 569L440 568Q444 564 444 287Q444 15 442 12Q436 0 424 0T406 12Q404 15 404 275V535H151L162 523Q187 495 207 462T236 410T244 389H198L193 402Q171 457 131 497T56 555",
  8625: "301 722Q339 618 443 555L437 551Q431 547 422 541T401 526T377 504T352 477T327 443T306 402L301 389H255Q255 392 263 410T291 461T337 523L348 535H95V275Q95 15 93 12Q87 0 75 0T57 12Q55 15 55 287Q55 564 59 568L60 569Q64 573 76 573T208 575L348 576L338 587Q314 613 294 646T264 698T255 721Q255 722 278 722H301",
  8630: "361 210Q373 210 373 182V177Q373 155 370 151T348 139Q303 118 267 84T216 28T201 1Q197 -1 196 -1Q189 -1 184 8Q166 39 143 64T99 104T61 129T32 144T19 150Q17 152 17 179Q17 203 21 208Q28 210 39 206Q106 178 157 135L175 119V126Q179 130 179 155Q182 173 193 201Q228 305 312 374T510 459Q532 461 551 461H567Q678 461 784 386Q835 344 861 301Q902 245 926 173T950 32Q950 15 944 8Q930 -6 917 8Q910 12 910 43Q901 208 801 314T561 421Q453 421 359 359Q300 319 263 258T217 126L216 125Q216 124 216 123T217 122Q219 122 229 131T260 156T301 181Q314 189 336 199T361 210",
  8631: "972 209Q980 209 981 204T982 179Q982 155 979 151T957 139Q915 121 878 86T815 8Q808 -1 803 -1Q801 -1 797 1Q797 6 783 28T732 84T650 139L628 150Q626 152 626 177Q626 201 630 206Q636 210 637 210Q650 210 697 181Q727 166 764 137L784 119L782 132Q767 239 689 318T499 417Q474 421 442 421Q343 421 261 369T130 219Q86 121 86 28Q86 15 79 8Q73 1 66 1T53 8Q46 15 46 30Q46 102 77 192T186 361Q274 443 386 459Q396 460 426 460Q515 460 588 431T703 361T773 271T812 187T822 132Q822 123 825 123Q936 209 972 209",
  8634: "369 543T369 563T397 583Q408 583 440 579L454 577L464 581Q492 592 516 609T552 638T565 650Q604 638 607 637Q606 636 598 628T585 614T570 601T548 584T523 568L510 560L516 558Q522 555 527 553T541 546T559 536T580 523T603 506T626 485Q722 384 722 250Q722 106 622 12T387 -83Q253 -83 155 12T56 250Q56 357 110 433T235 545Q244 550 252 550Q270 550 270 531Q270 522 261 515T238 501T202 477T159 433Q95 352 95 250Q95 131 178 45T388 -42Q511 -42 596 43T682 250Q682 340 636 408T522 511Q495 526 488 526Q488 525 488 525T487 522T485 515L490 506Q505 481 516 451T531 404T535 384L532 385Q529 386 524 387T513 390L491 397L488 408Q472 483 413 542L399 543Q369 543 369 563",
  8635: "170 637L213 650Q270 597 313 581L323 577L337 579Q369 583 380 583Q408 583 408 563T380 543H378L364 542Q305 483 289 408L286 397L264 390Q259 389 254 388T245 385L242 384Q242 387 246 403T261 450T287 506L292 515Q291 519 291 521T290 524T289 526Q284 526 265 517T216 486T160 434T114 354T95 249Q95 132 178 45T388 -42Q513 -42 597 44T682 250Q682 337 638 404T532 506Q529 508 525 510T519 514T515 516T511 519T509 522T508 526T507 531Q507 550 525 550Q533 550 542 545Q569 532 596 511T653 454T702 366T721 250Q721 151 672 74T547 -43T388 -83Q254 -83 155 12T56 250Q56 385 151 485Q164 498 179 509T205 528T228 542T247 551T260 558L267 560L254 568Q215 590 170 637",
  8636: "62 230Q56 236 55 244Q55 252 57 255T69 265Q114 292 151 326T208 391T243 448T265 491T273 509Q276 511 288 511Q304 511 306 505Q309 501 303 484Q293 456 279 430T251 383T223 344T196 313T173 291T156 276L148 270H929Q944 261 944 250T929 230H62",
  8637: "55 256Q56 264 62 270H929Q944 261 944 250T929 230H148Q149 229 165 215T196 185T231 145T270 87T303 16Q309 -1 306 -5Q304 -11 288 -11Q279 -11 276 -10T269 -4T264 10T253 36T231 75Q172 173 69 235Q59 242 57 245T55 256",
  8638: "188 258V694H208L215 682Q246 628 293 594T375 551V528Q375 505 374 505Q369 505 351 510T299 534T237 578L228 587V205Q228 -178 226 -182Q221 -194 208 -194T190 -182Q188 -178 188 258",
  8639: "41 551Q76 559 123 592T201 682L208 694H228V258Q228 -178 226 -182Q221 -194 208 -194T190 -182Q188 -178 188 205V587L179 578Q151 552 117 534T65 511T42 505Q41 505 41 528V551",
  8640: "691 500Q691 511 711 511Q720 511 723 510T730 504T735 490T746 464T768 425Q796 378 835 339T897 285T933 263Q941 258 942 256T944 245T937 230H70Q56 237 56 250T70 270H852Q802 308 762 364T707 455T691 500",
  8641: "56 237T56 250T70 270H937Q944 263 944 256Q944 251 944 250T943 246T940 242T933 238Q794 153 734 7Q729 -7 726 -9T711 -11Q695 -11 693 -5Q690 -1 696 16Q721 84 763 139T852 230H70Q56 237 56 250",
  8642: "190 682Q195 694 208 694T226 683Q228 679 228 296V-87L237 -78Q265 -52 299 -34T351 -11T374 -5Q375 -5 375 -28V-51Q340 -60 293 -92T215 -182L208 -194H188V242Q188 678 190 682",
  8643: "188 295V573Q188 657 189 672T200 692Q206 694 208 694Q221 694 226 683Q228 679 228 242V-194H208L201 -182Q170 -128 123 -94T41 -51V-28Q41 -5 42 -5Q47 -5 65 -10T117 -34T179 -78L188 -87V295",
  8644: "943 500Q895 471 856 427T801 333H778Q755 333 755 334Q755 336 762 353T791 406T841 472L848 480H459Q70 480 67 482Q55 488 55 500T67 518Q70 520 459 520H848L841 528Q813 559 792 594T763 646T755 666Q755 667 778 667H801Q817 617 856 573T943 500ZM56 167Q102 194 141 238T198 333H221Q244 333 244 332Q221 265 161 198L151 187H539Q928 187 930 186Q944 182 944 167Q944 155 934 149Q930 147 541 147H151L160 137Q185 110 205 77T235 24T244 1Q244 0 221 0H199Q158 106 56 167",
  8646: "56 500Q103 527 142 572T199 667H221Q244 667 244 666Q244 664 237 647T208 594T158 528L151 520H539Q928 520 932 518Q944 513 944 500T932 482Q928 480 539 480H151L158 472Q186 441 207 406T236 354T244 334Q244 333 221 333H199Q181 383 142 428T56 500ZM943 167Q835 101 801 0H778Q755 0 755 1T758 9T765 25T771 39Q800 94 839 137L848 147H458Q68 147 66 149Q55 154 55 167Q55 182 69 186Q71 187 460 187H848L838 198Q811 228 791 261T762 314L755 332Q755 333 778 333H801Q841 227 943 167",
  8647: "930 437Q944 426 944 416T934 399Q930 397 540 397H150L159 387Q185 360 205 328T234 277T243 252Q243 237 217 191T159 113L150 103H540Q930 103 934 101Q944 94 944 84Q944 71 930 64L540 63H151Q180 34 203 -2T236 -61L244 -83H198Q178 -31 142 11T66 77L55 83L65 89Q157 145 197 246Q199 250 190 269Q150 359 65 411L55 417L66 423Q106 447 142 489T198 583H244Q202 488 151 437H930",
  8648: "83 551Q190 590 250 694Q251 689 263 671T307 621T380 567Q409 551 416 551Q422 551 447 563T511 608T577 684L582 694Q642 591 749 551V528Q749 505 748 505Q745 505 724 515T669 546T612 590L602 599V-181Q595 -193 585 -193H582H581Q568 -193 565 -183L563 -179L562 209V598L552 589Q517 556 473 531T414 506H412Q411 506 393 514T361 530T324 553T280 589L270 598V-179Q255 -192 250 -193H247Q237 -193 230 -181V599L220 590Q197 567 164 546T110 515T84 505Q83 505 83 528V551",
  8649: "55 416Q55 427 70 437H848Q819 466 796 502T764 561L755 583H801Q821 531 857 489T933 423L944 417L934 411Q843 355 802 254Q800 250 809 231Q849 141 934 89L944 83L933 77Q893 53 857 11T801 -83H755Q797 12 848 63H459L70 64Q55 70 55 84Q55 94 65 101Q69 103 459 103H849L840 113Q806 148 779 196T756 254Q756 255 760 264T770 286T786 315T809 351T840 387L849 397H459Q69 397 65 399Q55 406 55 416",
  8650: "230 681Q240 694 251 694Q260 693 270 680V-98L280 -89Q297 -73 314 -60T348 -38T374 -24T397 -13T412 -6H414Q428 -6 473 -32T552 -89L562 -98V291L563 680Q570 693 582 693Q593 694 602 681V-99L612 -90Q635 -68 668 -47T723 -15T748 -5Q749 -5 749 -28V-51Q642 -91 582 -194L577 -184Q551 -141 512 -108T447 -63T416 -51T385 -63T321 -108T255 -184L250 -194Q189 -89 83 -51V-28Q83 -5 84 -5Q88 -5 109 -15T164 -46T220 -90L230 -99V681",
  8651: "195 504L198 514H221Q244 514 244 512Q244 508 239 490T215 437T171 376L162 367H545Q928 367 932 365Q944 360 944 347T932 329Q928 327 492 327H55V347L67 354Q113 379 146 420T195 504ZM67 171Q70 173 507 173H944V153L932 146Q839 95 804 -4L801 -14H778Q755 -14 755 -12Q768 59 828 124L837 133H454Q71 133 67 135Q55 140 55 153Q55 165 67 171",
  8652: "691 660Q691 671 711 671Q720 671 723 670T730 664T735 650T746 624T768 585Q797 538 836 499T897 445T933 423Q941 418 942 416T944 405T937 390H70Q56 397 56 410T70 430H852Q802 468 762 524T707 615T691 660ZM55 256Q56 264 62 270H929Q944 261 944 250T929 230H148Q149 229 165 215T196 185T231 145T270 87T303 16Q309 -1 306 -5Q304 -11 288 -11Q279 -11 276 -10T269 -4T264 10T253 36T231 75Q172 173 69 235Q59 242 57 245T55 256",
  8653: "397 525Q410 525 414 524T418 516Q418 506 394 467T331 381L319 367H473L624 369L657 445Q674 487 684 507T699 531T709 534Q717 534 722 528T728 516Q728 510 695 434Q689 418 683 402T672 377T668 367H928Q942 355 942 347Q942 341 928 327H791Q651 327 651 325Q649 324 620 251T586 174Q586 172 757 172H928Q942 158 942 152Q942 143 928 132H568L537 54Q510 -9 503 -22T486 -35Q479 -35 473 -29T466 -17T495 61L526 132H319L331 118Q364 81 391 37T418 -17Q418 -23 415 -24T401 -26Q398 -26 397 -26L384 -24L377 -13Q344 49 301 97T218 170T143 210T84 233T55 245Q54 253 59 256T86 267Q281 327 377 512L384 525H397ZM606 325Q606 327 439 327H275Q258 312 179 265L148 249Q228 206 262 181L275 172H544L575 247L606 325",
  8654: "395 -24T395 -19T417 57T440 132H255L266 116Q308 64 340 -6Q342 -17 337 -21Q335 -26 320 -26T302 -19Q302 -15 294 4T265 54T217 117T145 182T49 236Q30 243 33 254Q40 261 49 263Q98 283 142 315T214 379T263 442T293 493T302 519Q305 525 320 525T337 521Q342 516 340 505Q308 435 266 383L255 370L384 367H515Q561 522 569 530Q574 534 580 534Q587 534 594 528T602 516Q602 512 580 441T557 367H651L742 370L731 383Q689 435 657 505Q655 516 660 521Q662 525 677 525T695 519Q695 515 703 496T732 446T780 383T853 317T949 263Q967 258 964 245Q959 240 949 236Q897 215 852 182T779 116T731 52T703 3T695 -19Q692 -26 677 -26T660 -21Q655 -17 657 -6Q670 21 682 42T702 77T717 99T728 114T735 122T739 126T740 130T613 132H482L460 54Q440 -9 433 -23T415 -37Q408 -37 402 -31ZM502 325Q502 327 360 327H217L195 310Q173 291 120 256L111 250Q114 248 143 229T195 190L217 172H335L453 174L502 325ZM886 250Q885 251 865 263T831 286T802 310L780 327H544L535 299Q531 283 511 223L495 174L637 172H780L802 190Q843 225 877 243L886 250",
  8655: "346 174Q348 176 378 249T411 325Q411 327 239 327H68Q55 342 55 347Q55 354 68 367H428L459 445Q487 509 494 521T510 534Q517 534 524 527T531 516Q531 515 502 438L471 367H677L666 381Q631 421 605 463T578 516Q578 522 582 523T599 525H615L619 512Q659 437 714 383T812 309T896 272T942 254Q943 246 938 243T911 232Q718 172 619 -13L615 -24L599 -26Q578 -26 578 -17Q578 -11 587 6T617 53T666 118L677 132H373L339 54Q323 12 313 -8T298 -32T288 -35Q280 -35 275 -29T269 -17Q269 -14 298 57T328 132H68Q55 145 55 152Q55 156 56 158T62 165T68 172H206Q346 172 346 174ZM848 249Q763 297 735 318L722 327H455L422 252L391 174Q391 172 557 172H722L735 181Q773 210 819 234L848 249",
  8656: "944 153Q944 140 929 133H318L328 123Q379 69 414 0Q419 -13 419 -17Q419 -24 399 -24Q388 -24 385 -23T377 -12Q332 77 253 144T72 237Q62 240 59 242T56 250T59 257T70 262T89 268T119 278T160 296Q303 366 377 512Q382 522 385 523T401 525Q419 524 419 515Q419 510 414 500Q379 431 328 377L318 367H929Q944 359 944 347Q944 336 930 328L602 327H274L264 319Q225 289 147 250Q148 249 165 241T210 217T264 181L274 173H930Q931 172 933 171T936 169T938 167T941 164T942 162T943 158T944 153",
  8657: "228 -179Q227 -180 226 -182T223 -186T221 -189T218 -192T214 -193T208 -194Q196 -194 189 -181L188 125V430L176 419Q122 369 59 338Q46 330 40 330Q38 330 31 337V350Q31 362 33 365T46 374Q60 381 77 390T128 426T190 484T247 567T292 677Q295 688 298 692Q302 694 305 694Q313 694 318 677Q334 619 363 568T420 485T481 427T532 391T564 374Q575 368 577 365T579 350V337Q572 330 570 330Q564 330 551 338Q487 370 435 419L423 430L422 125V-181Q409 -194 401 -194Q397 -194 394 -193T388 -189T385 -184T382 -180V-177V475L373 487Q331 541 305 602Q304 601 300 591T290 571T278 548T260 519T238 488L229 476L228 148V-179",
  8658: "580 514Q580 525 596 525Q601 525 604 525T609 525T613 524T615 523T617 520T619 517T622 512Q659 438 720 381T831 300T927 263Q944 258 944 250T935 239T898 228T840 204Q696 134 622 -12Q618 -21 615 -22T600 -24Q580 -24 580 -17Q580 -13 585 0Q620 69 671 123L681 133H70Q56 140 56 153Q56 168 72 173H725L735 181Q774 211 852 250Q851 251 834 259T789 283T735 319L725 327H72Q56 332 56 347Q56 360 70 367H681L671 377Q638 412 609 458T580 514",
  8659: "401 694Q412 694 422 681V375L423 70L435 81Q487 130 551 162Q564 170 570 170Q572 170 579 163V150Q579 138 577 135T564 126Q541 114 518 99T453 48T374 -46T318 -177Q313 -194 305 -194T293 -178T272 -119T225 -31Q158 70 46 126Q35 132 33 135T31 150V163Q38 170 40 170Q46 170 59 162Q122 131 176 81L188 70V375L189 681Q199 694 208 694Q219 694 228 680V352L229 25L238 12Q279 -42 305 -102Q344 -23 373 13L382 25V678Q387 692 401 694",
  8660: "308 524Q318 526 323 526Q340 526 340 514Q340 507 336 499Q326 476 314 454T292 417T274 391T260 374L255 368Q255 367 500 367Q744 367 744 368L739 374Q734 379 726 390T707 416T685 453T663 499Q658 511 658 515Q658 525 680 525Q687 524 690 523T695 519T701 507Q766 359 902 287Q921 276 939 269T961 259T966 250Q966 246 965 244T960 240T949 236T930 228T902 213Q763 137 701 -7Q697 -16 695 -19T690 -23T680 -25Q658 -25 658 -15Q658 -11 663 1Q673 24 685 46T707 83T725 109T739 126L744 132Q744 133 500 133Q255 133 255 132L260 126Q265 121 273 110T292 84T314 47T336 1Q341 -11 341 -15Q341 -25 319 -25Q312 -24 309 -23T304 -19T298 -7Q233 141 97 213Q83 221 70 227T51 235T41 239T35 243T34 250T35 256T40 261T51 265T70 273T97 287Q235 363 299 509Q305 522 308 524ZM792 319L783 327H216Q183 294 120 256L110 250L120 244Q173 212 207 181L216 173H783L792 181Q826 212 879 244L889 250L879 256Q826 288 792 319",
  8661: "290 755Q298 772 305 772T318 757T343 706T393 633Q431 588 473 558T545 515T579 497V484Q579 464 570 464Q564 464 550 470Q485 497 423 550L422 400V100L423 -50Q485 3 550 30Q565 36 570 36Q579 36 579 16V3Q575 -1 549 -12T480 -53T393 -132Q361 -172 342 -208T318 -258T305 -272T293 -258T268 -208T217 -132Q170 -80 128 -51T61 -12T31 3V16Q31 36 40 36Q46 36 61 30Q86 19 109 6T146 -18T173 -38T188 -50V550Q186 549 173 539T147 519T110 495T61 470Q46 464 40 464Q31 464 31 484V497Q34 500 63 513T135 557T217 633Q267 692 290 755ZM374 598Q363 610 351 625T332 651T316 676T305 695L294 676Q282 657 267 636T236 598L228 589V-89L236 -98Q247 -110 259 -125T278 -151T294 -176T305 -195L316 -176Q328 -157 343 -136T374 -98L382 -89V589L374 598",
  8666: "944 54Q942 44 929 36H372Q372 34 377 26T395 -4T422 -58Q442 -109 442 -110T408 -111H374L370 -100Q282 124 87 243L76 250L87 257Q284 377 370 600L374 611H408Q442 611 442 610Q423 550 381 480Q380 478 379 475T376 471T374 468T372 465V464H929Q942 456 944 446Q944 442 943 439T941 434T938 430T935 428T931 426T928 424H344L336 414Q277 336 200 277L191 270H560Q929 270 933 268Q944 262 944 250Q944 237 933 232Q929 230 560 230H191L200 223Q279 162 336 86L344 76H928Q929 76 931 75T934 73T938 70T941 66T943 61T944 54",
  8667: "56 250Q56 260 68 270H808L799 277Q720 338 663 414L655 424H363Q71 424 68 426Q55 432 55 444T68 462Q71 464 349 464H627Q627 466 622 474T604 504T577 558Q557 609 557 610T591 611H626L629 600Q717 376 912 257L923 250L912 243Q715 123 629 -100L626 -111H591Q557 -111 557 -110Q576 -50 618 20Q619 22 620 25T623 29T625 32T626 35L627 36H349Q71 36 68 38Q55 44 55 56T68 74Q71 76 363 76H655L663 86Q722 164 799 223L808 230H438L68 231Q56 236 56 250",
  8669: "76 230Q68 230 62 237T56 250Q56 257 63 264T91 291Q102 300 108 306L159 351Q168 356 177 351L218 316L303 239L353 195Q376 214 403 239L488 316L529 351Q538 356 546 351Q548 350 594 310L638 270H848L841 278Q813 309 792 344T763 396T755 416Q755 417 778 417H801Q817 367 856 323T943 250Q895 221 856 177T801 83H778Q755 83 755 84Q755 86 762 103T791 156T841 222L848 230H737Q625 230 622 232Q620 233 599 251T558 288L537 306Q537 305 451 228T362 149Q353 146 345 149Q341 150 255 227T169 306Q167 306 129 270Q123 265 115 257T102 245T93 237T84 232T76 230",
  8672: "292 419Q292 400 261 347T211 275H306H364Q400 275 411 271T422 250T411 230T366 225H306H211Q214 222 232 197T271 136T292 82Q292 71 285 68T262 64H250H241Q221 64 216 67T205 83Q186 127 153 167T78 230Q64 238 64 250Q64 258 69 263T82 272T106 288T139 318Q162 342 177 365T198 402T209 425T223 436Q224 437 252 437H258Q292 437 292 419ZM501 237T501 250T515 270H819Q834 262 834 250T819 230H515Q501 237 501 250ZM918 237T918 250T932 270H1236Q1251 262 1251 250T1236 230H932Q918 237 918 250",
  8674: "84 237T84 250T98 270H402Q417 262 417 250T402 230H98Q84 237 84 250ZM501 237T501 250T515 270H819Q834 262 834 250T819 230H515Q501 237 501 250ZM1022 417Q1022 437 1055 437H1067Q1090 437 1097 434T1109 417Q1128 373 1161 333T1236 270Q1251 261 1251 250Q1251 241 1244 236T1216 217T1175 182Q1149 155 1133 128T1109 85T1097 66Q1093 64 1065 64H1053Q1031 64 1025 72T1027 100Q1036 124 1049 147T1073 185T1091 210T1101 223L1103 225H1008H950Q914 225 903 229T892 250T903 270T948 275H1008H1103L1101 277Q1100 280 1091 291T1067 325T1039 374Q1022 408 1022 417",
  8704: "0 673Q0 684 7 689T20 694Q32 694 38 680T82 567L126 451H430L473 566Q483 593 494 622T512 668T519 685Q524 694 538 694Q556 692 556 674Q556 670 426 329T293 -15Q288 -22 278 -22T263 -15Q260 -11 131 328T0 673ZM414 410Q414 411 278 411T142 410L278 55L414 410",
  8705: "404 269Q412 269 418 267T428 261T435 253T441 245L444 240V172Q444 103 443 96Q440 81 431 65T403 27T344 -7T250 -21T156 -8T97 27T69 65T58 96Q56 103 56 413Q56 722 58 729Q74 822 215 845Q221 846 229 846H243Q282 846 290 845Q422 826 443 729Q444 722 444 653V586L442 583Q441 580 440 578T436 573T430 567T423 562T415 558T404 556Q377 556 367 583Q364 590 364 654V719Q363 721 360 726T355 733Q326 766 250 766H249Q235 766 219 765T174 752T137 719V107Q145 83 178 71T251 58H254Q340 58 364 107V172Q364 176 364 187T363 204Q363 269 404 269",
  8706: "202 508Q179 508 169 520T158 547Q158 557 164 577T185 624T230 675T301 710L333 715H345Q378 715 384 714Q447 703 489 661T549 568T566 457Q566 362 519 240T402 53Q321 -22 223 -22Q123 -22 73 56Q42 102 42 148V159Q42 276 129 370T322 465Q383 465 414 434T455 367L458 378Q478 461 478 515Q478 603 437 639T344 676Q266 676 223 612Q264 606 264 572Q264 547 246 528T202 508ZM430 306Q430 372 401 400T333 428Q270 428 222 382Q197 354 183 323T150 221Q132 149 132 116Q132 21 232 21Q244 21 250 22Q327 35 374 112Q389 137 409 196T430 306",
  8707: "56 661T56 674T70 694H487Q497 686 500 679V15Q497 10 487 1L279 0H70Q56 7 56 20T70 40H460V327H84Q70 334 70 347T84 367H460V654H70Q56 661 56 674",
  8709: "331 696Q335 708 339 722T345 744T350 759T357 769T367 772Q374 772 381 767T388 754Q388 746 377 712L366 673L378 661Q460 575 460 344Q460 281 456 234T432 126T373 27Q319 -22 250 -22Q214 -22 180 -7Q168 -3 168 -4L159 -33Q148 -71 142 -75Q138 -78 132 -78Q124 -78 118 -72T111 -60Q111 -52 122 -18L133 21L125 29Q39 111 39 344Q39 596 137 675Q187 716 251 716Q265 716 278 714T296 710T315 703T331 696ZM276 676Q264 679 246 679Q196 679 159 631Q134 597 128 536T121 356Q121 234 127 174T151 80L234 366Q253 430 275 506T308 618L318 654Q318 656 294 669L276 676ZM181 42Q207 16 250 16Q291 16 324 47Q354 78 366 136T378 356Q378 470 372 528T349 616L348 613Q348 611 264 326L181 42",
  8710: "51 0Q46 4 46 7Q46 9 215 357T388 709Q391 716 416 716Q439 716 444 709Q447 705 616 357T786 7Q786 4 781 0H51ZM507 344L384 596L137 92L383 91H630Q630 93 507 344",
  8711: "46 676Q46 679 51 683H781Q786 679 786 676Q786 674 617 326T444 -26Q439 -33 416 -33T388 -26Q385 -22 216 326T46 676ZM697 596Q697 597 445 597T193 596Q195 591 319 336T445 80L697 596",
  8712: "84 250Q84 372 166 450T360 539Q361 539 377 539T419 540T469 540H568Q583 532 583 520Q583 511 570 501L466 500Q355 499 329 494Q280 482 242 458T183 409T147 354T129 306T124 272V270H568Q583 262 583 250T568 230H124V228Q124 207 134 177T167 112T231 48T328 7Q355 1 466 0H570Q583 -10 583 -20Q583 -32 568 -40H471Q464 -40 446 -40T417 -41Q262 -41 172 45Q84 127 84 250",
  8713: "196 25Q84 109 84 250Q84 372 166 450T360 539Q361 539 375 539T413 540T460 540L547 707Q550 716 563 716Q570 716 575 712T581 703T583 696T505 540H568Q583 532 583 520Q583 511 570 501L484 500L366 270H568Q583 262 583 250T568 230H346L247 38Q284 16 328 7Q355 1 466 0H570Q583 -10 583 -20Q583 -32 568 -40H471Q464 -40 447 -40T419 -41Q304 -41 228 3Q117 -211 115 -212Q111 -215 104 -215T92 -212T86 -204T84 -197Q84 -190 89 -183L196 25ZM214 61L301 230H124V228Q124 196 147 147T214 61ZM321 270L440 500Q353 499 329 494Q280 482 242 458T183 409T147 354T129 306T124 272V270H321",
  8715: "83 520Q83 532 98 540H195Q202 540 220 540T249 541Q404 541 494 455Q582 374 582 250Q582 165 539 99T434 0T304 -39Q297 -40 195 -40H98Q83 -32 83 -20Q83 -10 96 0H200Q311 1 337 6Q369 14 401 28Q422 39 445 55Q484 85 508 127T537 191T542 228V230H98Q84 237 84 250T98 270H542V272Q542 280 539 295T527 336T497 391T445 445Q422 461 401 472Q386 479 374 483T347 491T325 495T298 498T273 499T239 500T200 500L96 501Q83 511 83 520",
  8717: "154 -1Q122 -1 112 3T102 26Q102 63 158 63H178Q192 64 206 65T228 66T240 68Q301 85 324 146L329 157H244Q158 157 153 161Q149 162 145 169T140 183Q140 201 158 215L167 221H256L344 223L349 237Q352 262 352 287Q352 308 351 315Q341 352 315 368T256 385Q231 385 206 376T166 356T149 346Q143 346 138 364T132 388Q132 396 147 406Q198 440 252 440Q291 440 318 435Q421 404 451 301Q456 288 456 248V234Q456 151 391 86Q330 25 240 3Q212 -1 154 -1",
  8719: "158 656Q147 684 131 694Q110 707 69 710H55V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H570V-210H584Q618 -208 638 -197T663 -178T673 -155V710H270V277L271 -155Q283 -206 359 -210H373V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
  8720: "158 656Q147 684 131 694Q110 707 69 710H55V750H373V710H359Q325 708 305 698T280 678T271 656L270 223V-210H673V656Q666 672 663 679T639 697T584 710H570V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
  8721: "61 748Q64 750 489 750H913L954 640Q965 609 976 579T993 533T999 516H979L959 517Q936 579 886 621T777 682Q724 700 655 705T436 710H319Q183 710 183 709Q186 706 348 484T511 259Q517 250 513 244L490 216Q466 188 420 134T330 27L149 -187Q149 -188 362 -188Q388 -188 436 -188T506 -189Q679 -189 778 -162T936 -43Q946 -27 959 6H999L913 -249L489 -250Q65 -250 62 -248Q56 -246 56 -239Q56 -234 118 -161Q186 -81 245 -11L428 206Q428 207 242 462L57 717L56 728Q56 744 61 748",
  8722: "84 237T84 250T98 270H679Q694 262 694 250T679 230H98Q84 237 84 250",
  8723: "56 467T56 480T70 500H707Q722 492 722 480T707 460H409V187H707Q722 179 722 167Q722 154 707 147H409V0V-93Q409 -144 406 -155T389 -166Q376 -166 372 -155T368 -105Q368 -96 368 -62T369 -2V147H70Q56 154 56 167T70 187H369V460H70Q56 467 56 480",
  8724: "339 717Q339 739 354 752T388 766Q410 766 424 751T439 716T424 681T390 666Q369 666 354 681T339 717ZM57 237T57 250T71 270H369V425L370 581Q380 594 389 594Q402 594 409 579V270H707Q722 262 722 250T707 230H409V-79Q401 -93 391 -93H389H387Q375 -93 369 -79V230H71Q57 237 57 250",
  8725: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
  8726: "56 731Q56 740 62 745T75 750Q85 750 92 740Q96 733 270 255T444 -231Q444 -239 438 -244T424 -250Q414 -250 407 -240Q404 -236 230 242T56 731",
  8727: "229 286Q216 420 216 436Q216 454 240 464Q241 464 245 464T251 465Q263 464 273 456T283 436Q283 419 277 356T270 286L328 328Q384 369 389 372T399 375Q412 375 423 365T435 338Q435 325 425 315Q420 312 357 282T289 250L355 219L425 184Q434 175 434 161Q434 146 425 136T401 125Q393 125 383 131T328 171L270 213Q283 79 283 63Q283 53 276 44T250 35Q231 35 224 44T216 63Q216 80 222 143T229 213L171 171Q115 130 110 127Q106 124 100 124Q87 124 76 134T64 161Q64 166 64 169T67 175T72 181T81 188T94 195T113 204T138 215T170 230T210 250L74 315Q65 324 65 338Q65 353 74 363T98 374Q106 374 116 368T171 328L229 286",
  8728: "55 251Q55 328 112 386T249 444T386 388T444 249Q444 171 388 113T250 55Q170 55 113 112T55 251ZM245 403Q188 403 142 361T96 250Q96 183 141 140T250 96Q284 96 313 109T354 135T375 160Q403 197 403 250Q403 313 360 358T245 403",
  8729: "55 251Q55 328 112 386T249 444T386 388T444 249Q444 171 388 113T250 55Q170 55 113 112T55 251",
  8730: "95 178Q89 178 81 186T72 200T103 230T169 280T207 309Q209 311 212 311H213Q219 311 227 294T281 177Q300 134 312 108L397 -77Q398 -77 501 136T707 565T814 786Q820 800 834 800Q841 800 846 794T853 782V776L620 293L385 -193Q381 -200 366 -200Q357 -200 354 -197Q352 -195 256 15L160 225L144 214Q129 202 113 190T95 178",
  8733: "56 124T56 216T107 375T238 442Q260 442 280 438T319 425T352 407T382 385T406 361T427 336T442 315T455 297T462 285L469 297Q555 442 679 442Q687 442 722 437V398H718Q710 400 694 400Q657 400 623 383T567 343T527 294T503 253T495 235Q495 231 520 192T554 143Q625 44 696 44Q717 44 719 46H722V-5Q695 -11 678 -11Q552 -11 457 141Q455 145 454 146L447 134Q362 -11 235 -11Q157 -11 107 56ZM93 213Q93 143 126 87T220 31Q258 31 292 48T349 88T389 137T413 178T421 196Q421 200 396 239T362 288Q322 345 288 366T213 387Q163 387 128 337T93 213",
  8734: "55 217Q55 305 111 373T254 442Q342 442 419 381Q457 350 493 303L507 284L514 294Q618 442 747 442Q833 442 888 374T944 214Q944 128 889 59T743 -11Q657 -11 580 50Q542 81 506 128L492 147L485 137Q381 -11 252 -11Q166 -11 111 57T55 217ZM907 217Q907 285 869 341T761 397Q740 397 720 392T682 378T648 359T619 335T594 310T574 285T559 263T548 246L543 238L574 198Q605 158 622 138T664 94T714 61T765 51Q827 51 867 100T907 217ZM92 214Q92 145 131 89T239 33Q357 33 456 193L425 233Q364 312 334 337Q285 380 233 380Q171 380 132 331T92 214",
  8736: "71 0L68 2Q65 3 63 5T58 11T55 20Q55 22 57 28Q67 43 346 361Q397 420 474 508Q595 648 616 671T647 694T661 688T666 674Q666 668 663 663Q662 662 627 622T524 503T390 350L120 41L386 40H653Q666 30 666 20Q666 8 651 0H71",
  8737: "71 0L68 2Q65 3 63 5T58 11T55 20Q55 22 57 28Q64 38 348 373T638 712Q644 714 646 714Q653 714 659 709T666 694V693Q666 687 633 647Q619 631 576 580Q528 524 495 485Q336 296 329 289Q328 288 348 264T395 182T433 54L434 40H651Q666 32 666 20T651 0H436Q431 -20 416 -20Q400 -20 396 -4V0H71ZM394 40Q394 51 389 76T366 149T319 234L302 256L119 41L256 40H394",
  8738: "666 -32Q666 -51 646 -51Q639 -51 365 85L75 228Q55 238 55 250Q55 257 59 262T68 268L72 270L611 536Q642 551 647 551T659 547T666 532Q666 521 657 515L525 449Q525 448 535 424T556 352T566 250T556 148T536 77T525 51L657 -15Q666 -21 666 -32ZM526 250Q526 297 517 342T499 409T488 431Q487 431 304 341T121 250T304 159T488 69Q526 143 526 250",
  8739: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V-235Q151 -249 141 -249H139",
  8740: "118 737Q131 750 138 750L151 746L158 739V579L160 421L213 470Q269 519 276 519Q284 519 290 513T296 499V498Q296 493 291 488T244 445Q225 428 213 417L158 368V-239Q143 -252 136 -252L124 -248L120 -241L118 44V328L62 279Q4 231 0 230Q-8 230 -14 236T-20 250Q-20 257 -11 265T62 332L118 384V737",
  8741: "133 736Q138 750 153 750Q164 750 170 739Q172 735 172 250T170 -239Q164 -250 152 -250Q144 -250 138 -244L137 -243Q133 -241 133 -179T132 250Q132 731 133 736ZM329 739Q334 750 346 750Q353 750 361 744L362 743Q366 741 366 679T367 250T367 -178T362 -243L361 -244Q355 -250 347 -250Q335 -250 329 -239Q327 -235 327 250T329 739",
  8742: "131 737Q134 739 138 743T144 748T151 750T171 737V199L327 357V737Q340 750 347 750Q351 750 353 749T360 743T367 737V397L429 457Q493 518 498 519Q506 519 512 512T518 500Q518 489 442 417L367 339V-237Q352 -250 346 -250L333 -243L327 -237V301L171 143V-237Q156 -250 151 -250T131 -237V101L69 41Q24 -3 15 -12T0 -21Q-8 -21 -14 -14T-20 -2Q-20 5 -7 19T56 81L131 159V737",
  8743: "318 591Q325 598 333 598Q344 598 348 591Q349 590 414 445T545 151T611 -4Q609 -22 591 -22Q588 -22 586 -21T581 -20T577 -17T575 -13T572 -9T570 -4L333 528L96 -4Q87 -20 80 -21Q78 -22 75 -22Q57 -22 55 -4Q55 2 120 150T251 444T318 591",
  8744: "55 580Q56 587 61 592T75 598Q86 598 96 580L333 48L570 580Q579 596 586 597Q588 598 591 598Q609 598 611 580Q611 574 546 426T415 132T348 -15Q343 -22 333 -22T318 -15Q317 -14 252 131T121 425T55 580",
  8745: "88 -21T75 -21T55 -7V200Q55 231 55 280Q56 414 60 428Q61 430 61 431Q77 500 152 549T332 598Q443 598 522 544T610 405Q611 399 611 194V-7Q604 -22 591 -22Q582 -22 572 -9L570 405Q563 433 556 449T529 485Q498 519 445 538T334 558Q251 558 179 518T96 401Q95 396 95 193V-7Q88 -21 75 -21",
  8746: "591 598H592Q604 598 611 583V376Q611 345 611 296Q610 162 606 148Q605 146 605 145Q586 68 507 23T333 -22Q268 -22 209 -1T106 66T56 173Q55 180 55 384L56 585Q66 598 75 598Q85 598 95 585V378L96 172L98 162Q112 95 181 57T332 18Q415 18 487 58T570 175Q571 180 571 383V583Q579 598 591 598",
  8747: "151 -112Q151 -150 106 -161Q106 -165 114 -172T134 -179Q155 -179 170 -146Q181 -120 188 -64T206 101T232 310Q256 472 277 567Q308 716 392 716Q434 716 453 681T472 613Q472 590 458 577T424 564Q404 564 390 578T376 612Q376 650 421 661Q421 663 418 667T407 675T393 679Q387 679 380 675Q360 665 350 619T326 438Q302 190 253 -57Q235 -147 201 -186Q174 -213 138 -216Q93 -216 74 -181T55 -113Q55 -91 69 -78T103 -64Q123 -64 137 -78T151 -112",
  8748: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244",
  8749: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244ZM807 -244Q807 -246 813 -251T833 -263T861 -269Q880 -269 893 -260Q914 -247 926 -218T945 -133T956 -15T970 155T991 367Q994 390 999 438T1008 512T1019 580T1034 647T1055 703T1084 751T1122 784T1173 804Q1175 804 1182 804T1195 805Q1246 802 1275 769T1304 695Q1304 669 1288 657T1255 645Q1236 645 1221 658T1206 694Q1206 705 1210 714T1220 729T1232 737T1242 742L1246 743Q1246 745 1239 751T1219 762T1192 768Q1169 768 1154 756T1128 716T1112 652T1101 559T1092 444T1081 300T1063 133Q1043 -38 1031 -102T997 -207Q950 -306 863 -306Q813 -306 781 -272T749 -196Q749 -170 765 -158T798 -146Q817 -146 832 -159T847 -195Q847 -206 843 -215T833 -230T821 -238T811 -242L807 -244",
  8750: "269 74L256 80Q244 85 227 97T191 128T161 179T148 250Q148 332 199 379T302 433L306 434L307 444Q309 456 313 495T321 553T331 607T345 664T365 712T393 756T431 785T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q471 768 454 752T427 693T414 626T406 536Q405 530 405 527L397 425L404 422Q410 419 421 413T445 399T470 376T494 345T511 303T518 250Q518 205 502 169T460 112T410 80T364 66L360 65L359 55Q357 38 353 4T346 -43T340 -81T333 -118T326 -148T316 -179T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q231 -241 242 -183T266 33L269 74ZM272 122Q272 156 300 391Q300 392 299 392Q287 392 263 379T213 331T187 249Q187 211 205 180T239 137T272 116V122ZM366 107Q378 107 402 119T453 167T479 249Q479 340 394 383V377Q394 375 394 374T393 371T393 366T392 357T391 342T389 321T386 291T382 251T377 199T369 133Q366 112 366 107",
  8756: "273 411Q273 437 291 454T334 471Q358 471 375 454T393 411T376 368T333 351Q307 351 290 368T273 411ZM84 38Q110 38 126 21T143 -22Q143 -46 127 -64T83 -82Q57 -82 41 -65T24 -22Q24 4 41 21T84 38ZM524 -22Q524 4 541 21T584 38Q608 38 625 21T643 -22Q643 -45 627 -63T583 -82Q557 -82 541 -65T524 -22",
  8757: "23 411Q23 437 41 454T84 471Q108 471 125 454T143 411T126 368T83 351Q57 351 40 368T23 411ZM523 411Q523 437 541 454T584 471Q608 471 625 454T643 411T626 368T583 351Q557 351 540 368T523 411ZM274 -22Q274 4 291 21T334 38Q356 38 374 22T392 -22T375 -65T333 -82Q307 -82 291 -65T274 -22",
  8764: "55 166Q55 241 101 304T222 367Q260 367 296 349T362 304T421 252T484 208T554 189Q616 189 655 236T694 338Q694 350 698 358T708 367Q722 367 722 334Q722 260 677 197T562 134H554Q517 134 481 152T414 196T355 248T292 293T223 311Q179 311 145 286Q109 257 96 218T80 156T69 133Q55 133 55 166",
  8765: "222 133Q147 133 102 197T56 335Q56 362 66 365Q71 369 77 364Q83 356 84 335T90 298Q102 254 137 222T223 189Q258 189 292 206T355 250T413 301T477 346T550 367Q628 367 673 309T722 171Q722 133 708 133Q703 133 699 141T694 162Q694 220 655 265T555 311Q519 311 485 293T421 248T363 196T298 152T222 133",
  8768: "55 569Q55 583 83 583Q122 583 151 565T194 519T215 464T222 411Q222 360 194 304T139 193T111 89Q111 38 134 -7T195 -55Q222 -57 222 -69Q222 -83 189 -83Q130 -83 93 -33T55 90Q55 130 72 174T110 252T148 328T166 411Q166 462 144 507T83 555Q55 556 55 569",
  8769: "220 366Q258 366 297 347T361 308T391 288Q394 288 464 370Q494 407 510 425T535 454T546 465T552 467H553Q560 467 566 461T573 448Q573 439 499 350Q424 266 424 261Q424 259 442 247T492 222T554 209Q607 209 646 243Q671 268 680 295T690 341T702 366Q719 366 719 314Q716 265 695 226Q682 199 664 179Q614 132 555 132Q517 132 477 151T412 190T383 210T347 172T278 89T233 37Q228 32 220 32Q210 32 206 38T201 48Q201 57 266 137Q272 144 275 148Q351 231 351 237Q351 239 333 251T283 276T221 289Q159 289 123 248T86 166Q86 156 82 145T73 132Q55 132 55 172Q55 220 79 272Q95 301 111 319Q161 366 220 366",
  8770: "55 439T55 443T56 449T62 456T68 463H706Q720 449 720 443T706 423H68Q55 439 55 443ZM56 72Q56 112 73 152T130 225T224 257Q259 257 294 240T360 199T419 149T484 107T553 90Q603 90 643 125T691 223Q693 257 704 257Q717 257 717 221Q717 147 671 91T554 34Q517 34 481 51T414 93T355 142T291 184T222 201Q172 201 131 167T84 67Q81 34 71 34Q56 37 56 72",
  8771: "55 283Q55 356 103 409T217 463Q262 463 297 447T395 382Q431 355 446 344T493 320T554 307H558Q613 307 652 344T694 433Q694 464 708 464T722 432Q722 356 673 304T564 251H554Q510 251 465 275T387 329T310 382T223 407H219Q164 407 122 367Q91 333 85 295T76 253T69 250Q55 250 55 283ZM56 56Q56 71 72 76H706Q722 70 722 56Q722 44 707 36H70Q56 43 56 56",
  8773: "55 388Q55 463 101 526T222 589Q260 589 296 571T362 526T421 474T484 430T554 411Q616 411 655 458T694 560Q694 572 698 580T708 589Q722 589 722 556Q722 482 677 419T562 356H554Q517 356 481 374T414 418T355 471T292 515T223 533Q179 533 145 508Q109 479 96 440T80 378T69 355Q55 355 55 388ZM56 236Q56 249 70 256H707Q722 248 722 236Q722 225 708 217L390 216H72Q56 221 56 236ZM56 42Q56 57 72 62H708Q722 52 722 42Q722 30 707 22H70Q56 29 56 42",
  8775: "55 417Q55 479 101 528T222 578Q259 578 294 564T393 507Q413 493 434 480T469 460T484 454L537 549Q587 639 595 647Q600 652 607 652Q615 652 621 647T628 634Q628 625 575 536Q524 446 524 443Q527 440 555 440Q603 440 644 469T691 547Q694 578 706 578T718 556Q718 555 718 551T717 545Q717 488 684 445T595 387Q582 384 558 384Q530 384 508 389L493 394L404 238L557 236H708Q720 224 720 217T706 196H379L291 43L499 41H708Q720 29 720 21T706 1H268L226 -71Q186 -143 179 -148Q173 -155 165 -155T152 -150T146 -137Q146 -133 184 -64L222 1H144L66 3L59 7Q54 14 54 20Q54 29 66 41H246L333 194Q333 196 202 196H68Q55 211 55 218T66 236H213L357 238L457 409L437 421Q432 423 393 450T307 500T222 523Q171 523 129 491T84 414Q82 383 70 383Q55 383 55 417",
  8776: "55 319Q55 360 72 393T114 444T163 472T205 482Q207 482 213 482T223 483Q262 483 296 468T393 413L443 381Q502 346 553 346Q609 346 649 375T694 454Q694 465 698 474T708 483Q722 483 722 452Q722 386 675 338T555 289Q514 289 468 310T388 357T308 404T224 426Q164 426 125 393T83 318Q81 289 69 289Q55 289 55 319ZM55 85Q55 126 72 159T114 210T163 238T205 248Q207 248 213 248T223 249Q262 249 296 234T393 179L443 147Q502 112 553 112Q609 112 649 141T694 220Q694 249 708 249T722 217Q722 153 675 104T555 55Q514 55 468 76T388 123T308 170T224 192Q164 192 125 159T83 84Q80 55 69 55Q55 55 55 85",
  8778: "220 523Q163 523 124 486T84 412Q81 383 69 383Q56 383 56 413Q56 441 67 470Q78 508 111 537T187 575Q203 579 219 579Q248 579 271 572Q304 565 393 508Q498 439 551 439Q620 439 662 486Q688 512 693 557Q693 565 697 572T707 579Q719 579 719 548Q719 483 673 434T550 384Q512 384 467 405T386 453T305 501T220 523ZM222 288Q164 288 124 251T84 177Q81 148 69 148Q56 148 56 178Q56 206 67 235Q78 274 111 302T187 339Q198 343 220 343Q244 343 259 341T308 322T393 272Q496 203 553 203Q612 203 651 241T691 312Q693 343 705 343Q719 343 719 313Q719 245 673 199Q626 148 552 148Q513 148 467 170T385 218T304 266T222 288ZM51 -19Q51 -6 62 -1H387Q713 -1 715 -3Q725 -10 725 -20Q725 -27 718 -34Q714 -38 672 -38T387 -39H62Q51 -25 51 -19",
  8781: "55 464Q55 471 60 477T74 484Q80 484 108 464T172 420T268 376T389 356Q436 356 483 368T566 399T630 436T675 467T695 482Q701 484 703 484Q711 484 716 478T722 464Q722 454 707 442Q550 316 389 316Q338 316 286 329T195 362T124 402T76 437T57 456Q55 462 55 464ZM57 45Q66 58 109 88T230 151T381 183Q438 183 494 168T587 135T658 94T703 61T720 45Q722 39 722 36Q722 28 717 22T703 16Q697 16 669 36T606 80T510 124T389 144Q341 144 294 132T211 101T147 64T102 33T82 18Q76 16 74 16Q66 16 61 22T55 36Q55 39 57 45",
  8782: "245 367Q251 415 288 453T392 492Q445 492 485 456T532 367H707Q722 359 722 347Q722 334 711 331T665 327H608H509Q500 332 498 336Q496 338 493 363T472 411Q443 451 389 451H387Q335 451 305 411Q290 392 287 374T282 344T268 327H72Q56 332 56 347Q56 360 70 367H245ZM56 153Q56 168 72 173H268Q277 168 279 164Q281 162 284 137T305 89Q334 49 389 49H391Q442 49 472 89Q487 108 490 126T495 156T509 173H608H666Q701 173 711 170T722 153T707 133H532Q526 81 486 45T389 8Q331 8 291 45T245 133H70Q56 140 56 153",
  8783: "245 367Q251 415 288 453T392 492Q445 492 485 456T532 367H707Q722 359 722 347Q722 334 711 331T665 327H608H509Q500 332 498 336Q496 338 493 363T472 411Q443 451 389 451H387Q335 451 305 411Q290 392 287 374T282 344T268 327H72Q56 332 56 347Q56 360 70 367H245ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153",
  8784: "56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM329 610Q329 634 346 652T389 670Q413 670 431 654T450 611Q450 586 433 568T390 550T347 567T329 610",
  8785: "421 474T389 474T339 493T321 541Q321 566 337 587T391 609Q456 602 456 541Q456 512 439 493ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM421 -108T389 -108T339 -89T321 -41Q321 -16 337 5T391 27Q456 20 456 -41Q456 -70 439 -89",
  8786: "15 541Q15 569 33 585T75 601T117 585T135 541Q135 514 118 498T75 481T32 498T15 541ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM642 -41Q642 -17 658 0T702 18Q726 18 744 3T762 -41Q762 -67 745 -84T702 -101Q676 -101 659 -85T642 -41",
  8787: "642 541Q642 569 660 585T702 601T744 585T762 541Q762 515 745 498T702 481Q676 481 659 497T642 541ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM14 -41Q14 -15 31 1T74 18Q101 18 118 0T135 -41Q135 -64 118 -83T75 -102Q51 -102 33 -85T14 -41",
  8790: "56 347Q56 360 70 367H707Q722 359 722 347Q722 334 711 331T658 327H586H465L472 318Q496 288 496 250T472 182L465 173H586H663Q700 173 711 170T722 153T707 133H70Q56 140 56 153Q56 168 72 173H312L305 182Q281 212 281 250T305 318L312 327H72Q56 332 56 347ZM473 250Q473 265 472 273T460 297T428 327H349Q328 313 318 298T306 273T304 250Q304 235 305 227T317 203T349 173H428Q449 187 459 202T471 227T473 250",
  8791: "279 612Q279 656 310 688T388 721Q433 721 465 689T498 612Q498 573 470 538T389 503Q336 503 308 538T279 612ZM458 614Q458 637 452 651T433 672T411 679T383 680T352 675T333 664T324 647T321 629T320 611Q320 593 321 584T332 562T359 545Q366 543 389 543H391Q406 543 414 544T435 552T452 573T458 614ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153",
  8796: "192 482H190Q187 483 185 484T181 488T177 493T175 501Q175 506 178 512Q184 523 278 687T375 853Q379 857 383 857Q385 857 387 858T390 859Q397 859 403 853Q405 851 499 687T600 512Q603 506 603 501Q603 488 587 482H192ZM548 523L389 798Q388 798 309 661T230 523T389 522T548 523ZM56 347Q56 360 70 367H708Q723 359 723 347Q723 336 709 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H709Q723 163 723 153Q723 140 708 133H70Q56 140 56 153",
  8800: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183L306 133H70Q56 140 56 153Q56 168 72 173H327L406 327H72Q56 332 56 347Q56 360 70 367H426Q597 702 602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 692 471 367H707Q722 359 722 347Q722 336 708 328L451 327L371 173H708Q722 163 722 153Q722 140 707 133H351Q175 -210 170 -212Q166 -215 159 -215",
  8801: "56 444Q56 457 70 464H707Q722 456 722 444Q722 430 706 424H72Q56 429 56 444ZM56 237T56 250T70 270H707Q722 262 722 250T707 230H70Q56 237 56 250ZM56 56Q56 71 72 76H706Q722 70 722 56Q722 44 707 36H70Q56 43 56 56",
  8804: "674 636Q682 636 688 630T694 615T687 601Q686 600 417 472L151 346L399 228Q687 92 691 87Q694 81 694 76Q694 58 676 56H670L382 192Q92 329 90 331Q83 336 83 348Q84 359 96 365Q104 369 382 500T665 634Q669 636 674 636ZM84 -118Q84 -108 99 -98H678Q694 -104 694 -118Q694 -130 679 -138H98Q84 -131 84 -118",
  8805: "83 616Q83 624 89 630T99 636Q107 636 253 568T543 431T687 361Q694 356 694 346T687 331Q685 329 395 192L107 56H101Q83 58 83 76Q83 77 83 79Q82 86 98 95Q117 105 248 167Q326 204 378 228L626 346L360 472Q291 505 200 548Q112 589 98 597T83 616ZM84 -118Q84 -108 99 -98H678Q694 -104 694 -118Q694 -130 679 -138H98Q84 -131 84 -118",
  8806: "674 753Q682 753 688 747T694 732T687 718Q686 717 417 589L151 463L399 345Q687 209 691 204Q694 198 694 193Q694 175 676 173H670L382 309Q92 446 90 448Q83 453 83 465Q84 476 96 482Q104 486 382 617T665 751Q669 753 674 753ZM84 39Q84 49 99 59H678Q694 53 694 39Q694 26 679 19H98Q84 26 84 39ZM83 -157Q83 -153 84 -150T86 -145T89 -141T92 -139T96 -137T99 -135H678Q694 -146 694 -155Q694 -168 679 -175H98Q84 -168 83 -157",
  8807: "83 733Q83 741 89 747T99 753Q107 753 253 685T543 548T687 478Q694 473 694 463T687 448Q685 446 395 309L107 173H101Q83 175 83 193Q83 194 83 196Q82 203 98 212Q117 222 248 284Q326 321 378 345L626 463L360 589Q291 622 200 665Q112 706 98 714T83 733ZM84 39Q84 49 99 59H678Q694 53 694 39Q694 26 679 19H98Q84 26 84 39ZM83 -157Q83 -153 84 -150T86 -145T89 -141T92 -139T96 -137T99 -135H678Q694 -146 694 -155Q694 -168 679 -175H98Q84 -168 83 -157",
  8808: "86 472Q93 477 381 614T673 752Q680 752 686 746T693 732T689 721Q686 715 418 590L151 461L418 332Q684 207 689 201Q693 195 693 190Q693 183 687 177T675 170Q668 170 380 307T86 450Q82 454 82 461Q82 467 86 472ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
  8809: "89 745Q95 752 100 752Q106 752 394 615T689 472Q693 468 693 461T689 450Q684 445 396 308T100 170Q95 170 89 176T82 190Q82 195 86 201Q91 208 358 332L624 461L358 590Q90 715 86 721Q82 725 82 731Q82 739 89 745ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
  8810: "639 -48Q639 -54 634 -60T619 -67H618Q612 -67 536 -26Q430 33 329 88Q61 235 59 239Q56 243 56 250T59 261Q62 266 336 415T615 567L619 568Q622 567 625 567Q639 562 639 548Q639 540 633 534Q632 532 374 391L117 250L374 109Q632 -32 633 -34Q639 -40 639 -48ZM944 -48Q944 -54 939 -60T924 -67H923Q917 -67 841 -26Q735 33 634 88Q366 235 364 239Q361 243 361 250T364 261Q367 266 641 415T920 567L924 568Q927 567 930 567Q944 562 944 548Q944 540 938 534Q937 532 679 391L422 250L679 109Q937 -32 938 -34Q944 -40 944 -48",
  8811: "55 539T55 547T60 561T74 567Q81 567 207 498Q297 449 365 412Q633 265 636 261Q639 255 639 250Q639 241 626 232Q614 224 365 88Q83 -65 79 -66Q76 -67 73 -67Q65 -67 60 -61T55 -47Q55 -39 61 -33Q62 -33 95 -15T193 39T320 109L321 110H322L323 111H324L325 112L326 113H327L329 114H330L331 115H332L333 116L334 117H335L336 118H337L338 119H339L340 120L341 121H342L343 122H344L345 123H346L347 124L348 125H349L351 126H352L353 127H354L355 128L356 129H357L358 130H359L360 131H361L362 132L363 133H364L365 134H366L367 135H368L369 136H370L371 137L372 138H373L374 139H375L376 140L378 141L576 251Q63 530 62 533Q55 539 55 547ZM360 539T360 547T365 561T379 567Q386 567 512 498Q602 449 670 412Q938 265 941 261Q944 255 944 250Q944 241 931 232Q919 224 670 88Q388 -65 384 -66Q381 -67 378 -67Q370 -67 365 -61T360 -47Q360 -39 366 -33Q367 -33 400 -15T498 39T625 109L626 110H627L628 111H629L630 112L631 113H632L634 114H635L636 115H637L638 116L639 117H640L641 118H642L643 119H644L645 120L646 121H647L648 122H649L650 123H651L652 124L653 125H654L656 126H657L658 127H659L660 128L661 129H662L663 130H664L665 131H666L667 132L668 133H669L670 134H671L672 135H673L674 136H675L676 137L677 138H678L679 139H680L681 140L683 141L881 251Q368 530 367 533Q360 539 360 547",
  8812: "104 730Q104 749 123 749Q130 749 138 745Q186 717 237 671L250 659L261 670Q297 703 332 726T375 750T389 744T395 730Q395 721 390 717T364 699T322 668Q290 641 283 632Q280 628 281 627T293 612Q425 454 425 250Q425 144 388 51T293 -112Q282 -125 281 -126T283 -132Q306 -162 379 -209Q395 -219 395 -230Q395 -238 389 -244T375 -250T335 -228T262 -171L250 -159L238 -170Q202 -203 167 -226T124 -250T110 -244T104 -230Q104 -219 121 -209Q199 -156 216 -132Q219 -128 218 -127T206 -112Q74 46 74 250T206 612Q217 625 218 626T216 632Q199 656 121 709Q104 719 104 730ZM249 -94Q364 61 364 250Q364 430 265 574Q253 590 249 594L242 583Q134 439 134 250Q134 114 192 -1Q212 -44 242 -83L249 -94",
  8814: "693 -14T693 -20T687 -33T675 -41Q667 -41 506 37L344 112Q342 112 262 -46Q184 -196 176 -205Q172 -209 168 -209T162 -208Q155 -208 151 -203T146 -190Q146 -178 171 -137Q193 -91 251 21L306 132L198 183Q142 208 118 220T88 238T82 249Q82 253 86 261Q92 267 278 357L464 443L529 572Q561 637 577 667T597 703T607 708Q615 708 622 702T629 688Q629 680 575 579L524 474Q524 473 545 482T598 508Q666 541 673 541T686 535T693 521Q693 512 679 504T589 459L493 414L360 150Q366 148 378 142T431 116T529 70Q686 -8 689 -10Q693 -14 693 -20ZM380 277L433 383Q432 385 292 319T151 250T237 209T324 170L380 277",
  8815: "82 514T82 520T89 533T100 541Q106 541 271 463Q434 386 435 386L515 543Q593 699 600 706Q604 708 607 708Q615 708 622 702T629 688T549 526Q509 445 491 407T473 368Q522 343 580 317Q636 291 660 278T688 261T693 250V249Q693 241 681 234T580 184Q533 161 502 146Q317 59 315 59Q312 56 246 -74Q197 -170 186 -189T168 -209Q164 -209 162 -208Q155 -208 151 -203T146 -190Q146 -187 200 -79L253 28L218 11Q182 -6 144 -23T100 -41Q95 -41 89 -35T82 -21Q82 -12 96 -4T186 41L284 88L349 217Q377 273 395 311T413 350Q413 351 253 428Q101 498 86 510Q82 514 82 520ZM624 250Q461 330 455 330Q454 331 453 329T448 321T441 308T430 287T416 259T398 223L342 114L624 250",
  8816: "82 -124Q82 -120 83 -117T89 -110T95 -103H220L284 50Q346 204 344 206L218 268Q153 297 123 313T87 333T82 344T86 355Q104 369 291 455Q491 552 491 553L542 673Q581 767 590 784T609 801Q616 801 622 795T629 781Q629 773 586 677Q546 581 546 577L609 606Q669 635 673 635Q680 635 686 629T693 615Q693 610 692 608T670 593T604 561L524 521L400 226L542 157Q617 123 649 107T687 85T694 72Q694 66 690 60T679 54Q664 54 526 121Q513 127 495 136T464 150T438 162T416 173T399 180T388 185L384 186Q383 186 322 41L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H146L93 -141Q82 -134 82 -124ZM418 370L466 495Q464 495 308 420T151 344T204 317T311 267T364 244Q364 247 418 370",
  8817: "97 54Q82 54 82 72Q82 79 86 84Q95 91 222 153L351 215L398 324L442 433L258 519Q95 597 87 604Q82 608 82 615T88 628T102 635Q107 635 424 484L458 468L524 630Q593 789 597 795Q601 801 609 801Q616 801 622 795T629 781L562 615L493 450L589 406Q665 371 679 362T694 344Q694 339 693 337T677 326T631 302T538 257Q504 241 465 223T406 195T386 186Q384 185 322 39L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H146L93 -141Q82 -134 82 -124Q82 -120 83 -117T89 -110T95 -103H220L273 26Q326 156 326 157L218 106Q109 54 97 54ZM553 379Q480 412 480 415Q479 415 460 372T423 285T406 241Q408 240 516 291T624 344L553 379",
  8818: "674 732Q682 732 688 726T694 711T687 697Q686 696 417 568L151 442L399 324Q687 188 691 183Q694 177 694 172Q694 154 676 152H670L382 288Q92 425 90 427Q83 432 83 444Q84 455 96 461Q104 465 382 596T665 730Q669 732 674 732ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
  8819: "90 697Q83 704 83 712T88 726T99 732Q107 732 253 664T543 527T687 457Q694 452 694 442T687 427Q685 425 395 288L107 152H101Q83 154 83 172Q83 173 83 175Q82 182 98 191Q117 201 248 263Q326 300 378 324L626 442L360 568Q91 696 90 697ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
  8822: "734 181Q734 173 728 167T714 161Q711 161 386 280T54 404Q44 408 44 421Q44 432 52 437Q66 443 388 562T714 681Q721 681 727 675T734 661Q734 651 722 645Q711 639 462 546Q441 539 420 531L122 421L420 311L723 198Q734 192 734 181ZM44 247Q44 255 50 261T63 267Q66 267 391 148T723 24Q734 18 734 7T723 -10Q716 -14 391 -133T63 -253Q56 -253 50 -247T44 -233Q44 -223 55 -217Q67 -210 317 -118Q337 -110 357 -103L655 7L357 117L54 230Q44 236 44 247",
  8823: "83 661Q83 668 88 674T104 681Q111 679 396 560Q686 437 687 436Q694 431 694 421T687 406Q686 405 543 344T253 222T101 161Q83 163 83 180Q83 194 95 199Q96 199 130 213T232 257T361 311L621 421L357 532Q307 553 233 584Q121 631 102 640T83 661ZM673 267Q694 267 694 248Q694 237 687 232Q684 229 420 118L156 7L416 -103L683 -215Q694 -222 694 -233Q694 -251 676 -253Q670 -253 524 -192T235 -70T90 -8Q83 -1 83 7Q83 19 94 24Q97 25 378 144T667 266Q669 267 673 267",
  8826: "84 249Q84 262 91 266T117 270Q120 270 126 270T137 269Q388 273 512 333T653 512Q657 539 676 539Q685 538 689 532T694 520V515Q689 469 672 431T626 366T569 320T500 286T435 265T373 249Q379 248 404 242T440 233T477 221T533 199Q681 124 694 -17Q694 -41 674 -41Q658 -41 653 -17Q646 41 613 84T533 154T418 197T284 220T137 229H114Q104 229 98 230T88 235T84 249",
  8827: "84 517Q84 539 102 539Q115 539 119 529T125 503T137 459T171 404Q277 275 640 269H661Q694 269 694 249T661 229H640Q526 227 439 214T283 173T173 98T124 -17Q118 -41 103 -41Q83 -41 83 -17Q88 29 105 67T151 132T208 178T277 212T342 233T404 249Q401 250 380 254T345 263T302 276T245 299Q125 358 92 468Q84 502 84 517",
  8828: "112 270Q83 270 83 290Q83 301 94 307Q98 310 118 310Q516 310 620 464Q635 486 642 510T651 548T657 571T675 580Q693 577 693 559V552Q684 472 628 410T465 314Q436 303 372 290Q373 290 388 287T425 278T465 266Q674 199 693 28L694 17Q688 5 683 3Q677 0 673 0Q656 0 653 24Q623 270 118 270H112ZM110 116Q83 116 83 136T110 156H113Q134 156 160 155T231 146T318 128T407 95T489 44T550 -30T583 -131Q583 -153 563 -153Q556 -153 553 -152T547 -145T542 -127Q531 -54 478 0Q425 53 333 83T123 116H110",
  8829: "668 310Q694 310 694 290Q694 285 691 279Q684 271 664 270Q550 268 464 257T301 220T179 146T124 27Q119 0 103 0T83 16Q83 21 83 31T92 68T113 121T157 177T229 231Q295 268 405 290Q404 290 389 293T352 302T312 314Q138 371 96 500Q83 541 83 562Q83 568 89 574T103 580Q115 580 120 570T126 542T138 497T173 442Q289 310 659 310H668ZM194 -131Q201 -60 241 -6T343 82T477 133T628 155Q632 155 644 155T661 156Q685 155 690 147Q694 143 694 136Q694 132 693 129T689 124T685 120T681 117L656 116Q596 114 543 106T436 79T342 35T272 -33T235 -127Q231 -154 212 -154Q203 -153 199 -147T194 -136V-131",
  8830: "84 442Q84 455 91 459T117 463Q120 463 126 463T137 462Q388 466 512 526T653 705Q657 732 676 732Q685 731 689 725T694 714V708Q689 662 672 624T626 559T569 513T500 479T435 458T373 442Q379 441 404 435T440 426T477 414T533 392Q592 362 630 319T681 241T694 174Q694 153 674 153Q662 153 657 163T652 188T640 231T606 287Q500 416 137 422H114Q104 422 98 423T88 428T84 442ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
  8831: "84 710Q84 732 102 732Q115 732 119 722T125 696T137 652T171 597Q277 468 640 462H661Q694 462 694 442T661 422H640Q578 421 526 417T415 403T309 376T222 333T156 268T124 179Q122 162 118 158T103 153Q100 153 98 153T95 154T93 155T90 158T85 163Q83 167 83 176Q88 222 105 260T151 325T208 371T277 405T342 426T404 442Q401 443 380 447T345 456T302 469T245 492Q125 551 92 661Q84 695 84 710ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
  8832: "386 292Q388 292 439 393T543 598T598 703Q599 703 603 704T609 705Q616 705 622 699T629 685T533 494Q440 308 440 305Q451 310 462 312Q547 342 592 388T651 505Q654 525 658 532T673 539Q680 539 686 533T693 519Q693 495 678 450Q638 341 500 283Q433 259 418 259Q416 259 411 251T406 241T415 239Q482 224 544 190Q674 121 691 -10Q693 -28 691 -32Q684 -43 672 -43Q664 -43 658 -37Q656 -33 650 -6T634 47T589 109T500 168Q473 179 436 190T388 201H386L284 -1Q261 -45 232 -101T191 -181T178 -206Q176 -206 172 -207T166 -208Q160 -208 153 -202T146 -188Q146 -185 246 12Q344 206 344 210Q344 213 305 217T213 225T124 228H95Q82 241 82 248Q82 253 95 268H124Q172 268 236 273T343 283T386 292",
  8833: "103 -43Q96 -43 89 -39T82 -26L84 -10Q105 141 275 212Q342 236 355 236Q360 236 364 245L369 256H360Q284 280 275 283Q115 351 86 490Q82 507 82 517Q82 526 88 532T103 538Q110 538 115 534Q119 531 122 517T128 486T143 444T174 397T231 351T320 310Q371 292 389 292L491 496Q595 701 598 703Q599 703 603 704T609 705Q616 705 622 699T629 685Q629 684 531 485Q431 296 431 288Q431 278 520 273T651 268H680Q693 253 693 248Q693 241 680 228H651Q591 228 491 218T386 201L284 -1Q261 -45 232 -101T191 -181T178 -206Q176 -206 172 -207T166 -208Q160 -208 153 -202T146 -188Q146 -182 302 125L335 190L324 185Q313 185 289 172Q241 153 208 128T159 78T135 31T124 -11T118 -37Q112 -43 103 -43",
  8834: "84 250Q84 372 166 450T360 539Q361 539 370 539T395 539T430 540T475 540T524 540H679Q694 532 694 520Q694 511 681 501L522 500H470H441Q366 500 338 496T266 472Q244 461 224 446T179 404T139 337T124 250V245Q124 157 185 89Q244 25 328 7Q348 2 366 2T522 0H681Q694 -10 694 -20Q694 -32 679 -40H526Q510 -40 480 -40T434 -41Q350 -41 289 -25T172 45Q84 127 84 250",
  8835: "83 520Q83 532 98 540H251Q267 540 297 540T343 541Q427 541 488 525T605 455Q693 374 693 250Q693 165 650 99T545 0T415 -39Q407 -40 251 -40H98Q83 -32 83 -20Q83 -10 96 0H255H308H337Q412 0 439 4T512 28Q533 39 553 54T599 96T639 163T654 250Q654 341 592 411Q557 449 512 472Q468 491 439 495T335 500H306H255L96 501Q83 511 83 520",
  8838: "84 346Q84 468 166 546T360 635Q361 635 370 635T395 635T430 636T475 636T524 636H679Q694 628 694 616Q694 607 681 597L522 596H470H441Q366 596 338 592T266 568Q244 557 224 542T179 500T139 433T124 346V341Q124 253 185 185Q244 121 328 103Q348 98 366 98T522 96H681Q694 86 694 76Q694 64 679 56H526Q510 56 480 56T434 55Q350 55 289 71T172 141Q84 223 84 346ZM104 -131T104 -118T118 -98H679Q694 -106 694 -118T679 -138H118Q104 -131 104 -118",
  8839: "83 616Q83 628 98 636H251Q267 636 297 636T343 637Q427 637 488 621T605 551Q693 470 693 346Q693 261 650 195T545 96T415 57Q407 56 251 56H98Q83 64 83 76Q83 86 96 96H255H308H337Q412 96 439 100T512 124Q533 135 553 150T599 192T639 259T654 346Q654 437 592 507Q557 545 512 568Q468 587 439 591T335 596H306H255L96 597Q83 607 83 616ZM84 -131T84 -118T98 -98H659Q674 -106 674 -118T659 -138H98Q84 -131 84 -118",
  8840: "146 -283Q146 -282 174 -213T202 -143H115Q102 -127 102 -123T115 -103H220L291 68L278 73Q203 101 153 157T86 288Q83 309 83 344Q83 380 86 399Q107 480 160 539Q222 601 298 621Q328 630 345 631T435 635L526 637L560 715Q587 778 593 789T609 801Q616 801 622 795T629 781Q629 780 625 771T614 742T600 706L571 637Q571 635 626 635H680Q693 620 693 613T689 601L682 597L618 595H553L449 346Q425 288 399 223T359 127T346 95H356Q365 95 381 95T417 94T463 93T515 93H682Q693 82 693 74T680 53H511Q420 55 335 55L329 57L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283ZM509 590Q509 595 438 595Q354 595 318 586Q246 567 195 516T126 395Q123 378 123 344T126 293Q141 229 184 181T291 110L306 104L406 346L509 590",
  8841: "82 606T82 613T95 635H251H348Q408 635 435 632T502 615L515 608L520 617Q520 619 558 708Q584 774 591 787T609 801Q616 801 622 795T629 781Q629 775 562 615L551 590L569 577Q646 527 678 437Q691 398 691 344T678 250Q653 182 597 132T469 64Q427 53 366 53H326L295 -25L262 -103H660Q673 -118 673 -124Q673 -129 669 -136L662 -141L453 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H95Q82 -128 82 -123T95 -103H220L251 -25L284 53H189L93 55L86 59Q82 64 82 71T95 93H302L400 333Q498 569 498 573L444 590Q431 593 260 595L93 597L86 601Q82 606 82 613ZM652 344V354Q652 451 575 521Q571 526 557 538T537 551Q534 551 533 548Q533 543 438 319L344 95L371 93H386Q487 93 557 150T649 293Q652 309 652 344",
  8842: "693 72Q693 68 692 66T686 59T680 52H524Q398 52 367 53T309 63Q236 82 180 132T98 250Q84 288 84 343Q84 397 98 437Q126 515 193 568T346 632Q347 632 373 633T440 634T520 635H680Q693 620 693 615Q693 608 680 595H526Q364 595 353 592Q279 582 221 539T138 430Q124 392 124 343Q124 296 138 257Q163 192 221 149T353 95Q364 92 526 92H680Q693 79 693 72ZM102 -132T102 -125T115 -103H382L420 -68Q429 -60 438 -52T452 -39T463 -28T472 -20T478 -14T483 -10T487 -7T490 -6T493 -5T496 -5Q502 -5 508 -12T515 -28Q515 -34 513 -37Q512 -38 507 -42T492 -55T475 -70L440 -101L562 -103H682Q693 -114 693 -122T680 -143H395L355 -179Q289 -241 280 -241Q273 -241 267 -235T260 -221T265 -208T300 -174L335 -143H224L113 -141L106 -137Q102 -132 102 -125",
  8843: "82 615Q82 620 95 635H251Q378 635 409 634T469 623Q540 605 596 555T678 437Q691 397 691 343T678 250Q649 172 581 119T426 55Q415 52 251 52H95Q93 55 89 59T84 65T82 72Q82 79 95 92H249Q411 92 422 95Q496 105 554 148T638 257Q651 296 651 343Q651 391 638 430Q613 495 555 538T422 592Q411 595 249 595H95Q82 608 82 615ZM82 -132T82 -125T95 -103H380L420 -57Q452 -21 460 -14T474 -6Q482 -6 488 -12T495 -25T451 -81L433 -101L549 -103H662Q673 -114 673 -122T660 -143H395L355 -190Q311 -239 309 -239Q305 -241 302 -241Q294 -241 287 -235T280 -221T324 -163L342 -143H218L93 -141L86 -137Q82 -132 82 -125",
  8846: "591 598H592Q604 598 611 583V376Q611 345 611 296Q610 162 606 148Q605 146 605 145Q586 68 507 23T333 -22Q268 -22 209 -1T106 66T56 173Q55 180 55 384L56 585Q66 598 75 598Q85 598 95 585V378L96 172L98 162Q112 95 181 57T332 18Q415 18 487 58T570 175Q571 180 571 383V583Q579 598 591 598ZM313 406Q313 417 313 435T312 459Q312 483 316 493T333 503T349 494T353 461V406V325H515Q516 325 519 323T527 316T531 305T527 294T520 287T515 285H353V204V152Q353 127 350 117T333 107T316 117T312 152Q312 158 312 175T313 204V285H151Q150 285 147 287T139 294T135 305T139 316T146 323T151 325H313V406",
  8847: "83 523Q87 535 99 539H679Q694 531 694 519Q694 506 679 499H123V-1H678Q694 -7 694 -21Q694 -34 679 -41H98Q93 -38 84 -28L83 247V523",
  8848: "64 506T64 519T78 539H699Q706 536 714 526V-28Q706 -38 699 -41H78Q64 -34 64 -21Q64 -6 80 -1H674V499H78Q64 506 64 519",
  8849: "94 620Q98 632 110 636H699Q714 628 714 616T699 596H134V96H698Q714 90 714 76Q714 64 699 56H109Q104 59 95 69L94 344V620ZM84 -118Q84 -103 100 -98H698Q714 -104 714 -118Q714 -130 699 -138H98Q84 -131 84 -118",
  8850: "64 603T64 616T78 636H668Q675 633 683 623V69Q675 59 668 56H78Q64 63 64 76Q64 91 80 96H643V596H78Q64 603 64 616ZM64 -118Q64 -108 79 -98H678Q694 -104 694 -118Q694 -130 679 -138H78Q64 -131 64 -118",
  8851: "83 0Q79 0 76 1T71 3T67 6T65 9T63 13T61 16V301L62 585Q70 595 76 598H592Q602 590 605 583V15Q598 2 587 0Q583 0 580 1T575 3T571 6T569 9T567 13T565 16V558H101V15Q94 2 83 0",
  8852: "77 0Q65 4 61 16V301L62 585Q72 598 81 598Q94 598 101 583V40H565V583Q573 598 585 598Q598 598 605 583V15Q602 10 592 1L335 0H77",
  8853: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM364 542Q308 539 251 509T148 418T96 278V270H369V542H364ZM681 278Q675 338 650 386T592 462T522 509T458 535T412 542H409V270H681V278ZM96 222Q104 150 139 95T219 12T302 -29T366 -42H369V230H96V222ZM681 222V230H409V-42H412Q429 -42 456 -36T521 -10T590 37T649 113T681 222",
  8854: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM681 278Q669 385 591 463T381 542Q283 542 196 471T96 278V270H681V278ZM275 -42T388 -42T585 32T681 222V230H96V222Q108 107 191 33",
  8855: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM582 471Q531 510 496 523Q446 542 381 542Q324 542 272 519T196 471L389 278L485 375L582 471ZM167 442Q95 362 95 250Q95 137 167 58L359 250L167 442ZM610 58Q682 138 682 250Q682 363 610 442L418 250L610 58ZM196 29Q209 16 230 2T295 -27T388 -42Q409 -42 429 -40T465 -33T496 -23T522 -11T544 1T561 13T574 22T582 29L388 222L196 29",
  8856: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM582 471Q581 472 571 480T556 491T539 502T517 514T491 525T460 534T424 539T381 542Q272 542 184 460T95 251Q95 198 113 150T149 80L167 58L582 471ZM388 -42Q513 -42 597 44T682 250Q682 363 610 442L196 29Q209 16 229 2T295 -27T388 -42",
  8857: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM682 250Q682 322 649 387T546 497T381 542Q272 542 184 459T95 250Q95 132 178 45T389 -42Q515 -42 598 45T682 250ZM311 250Q311 285 332 304T375 328Q376 328 382 328T392 329Q424 326 445 305T466 250Q466 217 445 195T389 172Q354 172 333 195T311 250",
  8858: "57 250Q57 327 87 392T166 497T270 560T382 582H394Q512 582 610 500Q721 401 721 250Q721 112 626 15T389 -82Q251 -82 154 13T57 250ZM682 129T682 250T596 457T390 543Q269 543 183 457T96 250Q96 132 180 45T389 -43Q511 -43 596 43ZM250 250Q250 316 295 352T384 388Q451 388 489 347T528 250Q528 192 487 152T389 112Q331 112 291 152T250 250ZM488 250Q488 290 460 319T389 349Q348 349 319 320T290 250Q290 208 320 180T389 151Q431 151 459 181T488 250",
  8859: "57 250Q57 327 87 392T166 497T270 560T382 582H394Q512 582 610 500Q721 401 721 250Q721 112 626 15T389 -82Q251 -82 154 13T57 250ZM682 129T682 250T596 457T390 543Q269 543 183 457T96 250Q96 132 180 45T389 -43Q511 -43 596 43ZM204 339Q204 357 215 366T238 375Q247 375 283 348Q300 336 311 328L368 286Q369 286 366 323T359 398T355 437Q357 456 379 465Q380 465 384 465T391 466Q403 465 412 457T423 437Q423 436 420 398T413 323T410 286L467 328Q476 334 486 341T501 353T513 361T523 368T529 372T535 374T541 375Q554 375 564 365T575 339Q575 325 566 318T519 292Q504 285 496 281L430 250L496 219Q552 192 559 188T572 175Q575 168 575 161Q575 148 566 137T541 126H538Q530 126 499 149Q480 163 467 172L410 214Q409 214 412 177T419 102T423 63Q423 59 421 54T411 43T389 36T368 42T357 54T355 63Q355 64 358 102T365 177T368 214L311 172Q302 165 293 159T279 148T268 140T260 134T254 131T250 128T246 127T242 126T238 126Q223 126 214 135T204 161T213 183T282 219L348 250L282 281Q226 308 219 312T206 325Q204 330 204 339",
  8861: "57 250Q57 327 87 392T166 497T270 560T382 582H394Q512 582 610 500Q721 401 721 250Q721 112 626 15T389 -82Q251 -82 154 13T57 250ZM682 129T682 250T596 457T390 543Q269 543 183 457T96 250Q96 132 180 45T389 -43Q511 -43 596 43ZM223 250Q223 263 233 267T280 271Q289 271 325 271T389 270H490Q535 270 545 267T555 250Q555 241 549 235Q544 231 527 231T389 230Q239 230 235 232Q223 236 223 250",
  8862: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM369 365V649H95V365H369ZM682 365V649H409V365H682ZM369 40V325H95V40H369ZM682 40V325H409V40H682",
  8863: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 365V649H95V365H682ZM682 40V325H95V40H682",
  8864: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H707Q714 686 722 676V13Q714 3 707 0H71ZM123 649Q147 625 214 555T335 430T389 374L654 649H123ZM95 70Q99 74 229 209T360 345L95 619V70ZM682 70V619L418 346Q417 344 549 207L682 70ZM654 41L400 304L388 315L123 41L256 40H522L654 41",
  8865: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 40V649H95V40H682ZM330 345Q330 371 347 388T390 405Q412 405 430 389T448 345Q448 317 430 301T389 285T348 301T330 345",
  8866: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V367H540Q555 359 555 347Q555 334 540 327H95V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678",
  8867: "515 678Q515 679 516 681T518 684T521 688T525 691T530 693T537 694Q548 692 555 679V15Q548 2 537 0Q533 0 530 1T525 3T521 6T519 9T517 13T515 16V327H71Q70 327 67 329T59 336T55 347T59 358T66 365T71 367H515V678",
  8868: "55 642T55 648T59 659T66 666T71 668H708Q723 660 723 648T708 628H409V15Q402 2 391 0Q387 0 384 1T379 3T375 6T373 9T371 13T369 16V628H71Q70 628 67 630T59 637",
  8869: "369 652Q369 653 370 655T372 658T375 662T379 665T384 667T391 668Q402 666 409 653V40H708Q723 32 723 20T708 0H71Q70 0 67 2T59 9T55 20T59 31T66 38T71 40H369V652",
  8872: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V367H796Q811 359 811 347Q811 336 797 328L479 327H161L159 328V172L161 173H797Q798 172 800 171T803 169T805 167T808 164T809 162T810 158T811 153Q811 140 796 133H159V-235Q151 -249 141 -249H139",
  8873: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678ZM249 678Q249 679 250 681T252 684T255 688T259 691T264 693T271 694Q282 692 289 679V367H651Q666 359 666 347Q666 334 651 327H289V15Q282 2 271 0Q267 0 264 1T259 3T255 6T253 9T251 13T249 16V678",
  8874: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678ZM237 678Q237 679 238 681T240 684T243 688T247 691T252 693T259 694Q270 692 277 679V15Q270 2 259 0Q255 0 252 1T247 3T243 6T241 9T239 13T237 16V678ZM419 678Q419 679 420 681T422 684T425 688T429 691T434 693T441 694Q452 692 459 679V367H818Q833 359 833 347Q833 334 818 327H459V15Q452 2 441 0Q437 0 434 1T429 3T425 6T423 9T421 13T419 16V678",
  8876: "56 681Q70 695 76 695T96 681V368H243L381 530Q521 692 525 692Q537 700 547 688Q554 682 554 674Q554 671 553 669T548 661T539 649T522 631T499 604T465 565T421 512Q296 373 296 368H416H476Q525 368 539 365T554 348Q554 334 543 328H261L96 141V12Q81 -1 75 -1Q65 -1 58 10L56 50V92L18 48Q7 37 -1 28T-13 14T-19 6T-23 1T-27 0T-33 -1Q-42 -1 -48 4T-55 19Q-55 24 -47 34T12 103L56 155V681ZM205 326Q205 328 152 328H96V263Q96 203 98 203Q99 203 123 231T174 290T205 326",
  8877: "56 681Q70 695 76 695T96 681V466H327L425 579Q522 692 527 692Q529 693 534 693Q542 693 547 688T553 674Q553 668 549 663Q549 662 538 650T504 611T463 563L381 468L461 466H543Q554 453 554 446T541 426H345L209 272L376 270H543Q554 257 554 251T541 230H174L96 141V12Q81 -1 75 -1Q65 -1 58 10L56 50V92L18 48Q7 37 -1 28T-13 14T-19 6T-23 1T-27 0T-33 -1Q-42 -1 -48 4T-55 19Q-55 24 -47 34T12 103L56 155V681ZM267 399L292 426H96V270H158L201 321Q256 382 267 399ZM118 228L119 229Q119 230 109 230H96V201L107 212Q118 227 118 228",
  8878: "56 681Q70 695 77 695T96 683V428L98 175L252 323V681Q264 695 272 695Q278 695 292 681V526Q292 368 296 368Q298 368 447 510Q638 695 642 695H645Q651 695 658 688T665 673Q665 666 661 661Q659 660 639 641T578 582T505 512L356 370L505 368H654Q665 357 665 349Q665 343 652 328H314L303 317L292 308V12Q289 10 285 6T279 1T272 -1Q265 -1 252 12V139Q252 266 249 266L96 119V12Q80 -1 76 -1T70 0T63 6T56 12V79L29 55Q-26 -1 -35 -1Q-42 -1 -48 5T-55 19Q-55 25 -51 30T-15 66Q5 86 18 99L56 135V681",
  8879: "56 681Q70 695 77 695T96 683V428L98 175L252 323V681Q264 695 272 695Q278 695 292 681V466H401L503 563L621 679Q637 695 645 695Q652 695 658 688T665 673Q665 670 663 666Q663 665 651 652T611 612T561 563L458 468L556 466H654Q665 455 665 447T652 426H416L294 308L292 288V270H652Q665 255 665 250T652 230H292V12Q289 10 285 6T279 1T272 -1Q265 -1 252 12V139Q252 266 249 266L96 119V12Q80 -1 76 -1T70 0T63 6T56 12V79L29 55Q-26 -1 -35 -1Q-42 -1 -48 5T-55 19Q-55 25 -51 30T-15 66Q5 86 18 99L56 135V681ZM358 426H292V361L325 392L358 426",
  8882: "694 -26Q686 -40 676 -41H670L382 95Q92 232 90 234Q83 239 83 249Q83 262 96 267Q101 270 379 401T665 537Q671 539 674 539Q686 539 694 524V-26ZM654 11T654 249T653 487T402 369T151 249L275 190Q399 131 524 72T652 11Q654 11 654 249",
  8883: "83 523Q83 524 85 527T92 535T103 539Q107 539 389 406T680 268Q694 260 694 249Q694 239 687 234Q685 232 395 95L107 -41H101Q90 -40 83 -26V523ZM376 368Q323 393 254 425T155 472L125 487Q123 487 123 249T125 11Q127 12 252 71T502 190L626 249L376 368",
  8884: "694 71Q686 58 676 56H670L382 192Q92 329 90 331Q83 336 83 346Q83 359 96 364Q101 367 379 498T665 634Q671 636 674 636Q686 636 694 621V71ZM654 108T654 346T653 584T402 466T151 346L275 287Q399 228 524 169T652 108Q654 108 654 346ZM83 -120Q83 -116 84 -113T86 -108T89 -104T92 -102T96 -100T99 -98H678Q679 -98 681 -99T684 -101T688 -104T691 -108T693 -113T694 -120Q692 -130 679 -138H98Q84 -130 83 -120",
  8885: "83 620Q83 621 85 624T92 632T103 636Q107 636 389 503T680 365Q694 357 694 346Q694 336 687 331Q685 329 395 192L107 56H101Q90 58 83 71V620ZM376 465Q323 490 254 522T155 570L125 584Q123 584 123 346T125 108Q127 109 252 168T502 287L626 346L376 465ZM83 -120Q83 -116 84 -113T86 -108T89 -104T92 -102T96 -100T99 -98H678Q679 -98 681 -99T684 -101T688 -104T691 -108T693 -113T694 -120Q692 -130 679 -138H98Q84 -130 83 -120",
  8888: "1055 250Q1055 190 1012 141T896 92Q858 92 828 106T781 140T755 180T741 214L738 228V230H405Q71 230 68 232Q55 238 55 250T68 268Q71 270 405 270H738V272L740 280Q742 287 745 297T754 321T771 348T796 374T832 396T881 408H891Q969 408 1012 360T1055 250ZM896 132Q948 132 981 166T1014 250Q1014 301 985 330T920 367Q914 368 891 368Q853 368 816 338T778 250Q778 198 812 165T896 132",
  8890: "318 -182Q302 -212 280 -212H278H275Q249 -212 239 -182L238 84V351H162L87 352Q57 362 57 391T84 429Q89 431 280 431H470L474 429Q477 427 479 426T484 423T490 417T495 410T499 402T500 391Q500 365 470 352L394 351H318V-182",
  8891: "56 697Q56 706 62 711T75 716Q86 716 90 709Q91 708 104 680T147 592T199 483L305 261L411 483Q443 548 481 629Q512 694 518 705T535 716Q543 716 549 710T555 700Q555 693 501 577T388 340T325 210Q316 194 305 194Q292 194 285 210Q282 219 224 339T111 574T56 697ZM55 14T55 20T59 31T66 38T71 40H540Q555 32 555 20T540 0H71Q70 0 67 2T59 9",
  8892: "55 698Q56 708 70 716H540Q554 708 555 698Q555 694 554 691T552 686T549 682T546 680T542 678T539 676H71Q70 676 68 677T65 679T61 682T58 686T56 691T55 698ZM555 18Q554 12 549 6T536 0H535Q525 0 515 17T459 132Q430 194 410 235L305 455L199 233Q176 185 147 125T105 36T90 7Q85 0 75 0Q63 0 58 11Q55 15 55 21Q58 31 170 266T285 507Q295 522 305 522T320 515Q322 513 439 268L555 24V18",
  8896: "119 -249T97 -249T65 -235T55 -207Q55 -201 56 -198Q58 -190 218 268T380 729Q392 750 416 750Q438 750 451 732Q453 728 534 498T695 36L775 -194Q777 -204 777 -208Q777 -222 767 -235T735 -249Q713 -249 700 -231Q696 -225 557 177L416 579L276 177Q136 -226 132 -231Q119 -249 97 -249",
  8897: "55 708Q55 729 68 739T96 750Q119 750 132 731Q136 726 276 323L416 -79L557 323Q696 725 700 731Q713 749 735 749Q756 749 766 736T777 708Q777 700 696 466T533 1T451 -232Q436 -249 416 -249Q402 -249 391 -241Q384 -236 380 -226Q368 -198 219 230Q55 697 55 708",
  8898: "139 -217Q127 -241 114 -246Q106 -249 97 -249Q67 -249 57 -220Q55 -214 55 102Q55 152 55 221T54 312Q54 422 60 464T91 554Q120 612 165 654T257 714T337 741T392 749Q393 750 402 750Q414 750 422 749Q557 749 660 659T776 430Q777 422 777 102Q777 -214 775 -220Q765 -249 735 -249Q716 -249 708 -241T694 -217L692 428L690 441Q674 540 597 603T416 666H409Q388 666 364 662T294 638T212 581Q156 523 142 441L140 428L139 105V-217",
  8899: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750",
  8900: "242 486Q245 488 250 488Q256 488 258 486Q262 484 373 373T486 258T488 250T486 242T373 127T258 14Q256 12 250 12Q245 12 242 14Q237 16 127 126T14 242Q12 245 12 250T14 258Q16 263 126 373T242 486ZM439 250L250 439L61 250L250 61L439 250",
  8901: "78 250Q78 274 95 292T138 310Q162 310 180 294T199 251Q199 226 182 208T139 190T96 207T78 250",
  8902: "210 282Q210 284 225 381T241 480Q241 484 245 484Q249 486 251 486Q258 486 260 477T272 406Q275 390 276 380Q290 286 290 282L388 299Q484 314 487 314H488Q497 314 497 302Q497 297 434 266Q416 257 404 251L315 206L361 118Q372 98 383 75T401 40L407 28Q407 16 395 16Q394 16 392 16L390 17L250 159L110 17L108 16Q106 16 105 16Q93 16 93 28L99 40Q105 52 116 75T139 118L185 206L96 251Q6 296 4 300Q3 301 3 302Q3 314 12 314H13Q16 314 112 299L210 282",
  8903: "366 543Q374 545 382 545Q405 545 419 538Q429 534 443 521T462 496Q466 478 466 467Q466 438 444 412Q422 390 388 390Q352 390 331 412Q311 434 311 467Q311 499 331 518Q345 533 366 543ZM146 472Q146 479 153 485T166 492Q171 492 187 476T279 385L386 278L495 385Q600 492 608 492Q615 492 621 486T628 472Q628 467 614 452T531 367L435 270H706Q720 256 720 250Q720 241 706 230H435L531 132Q600 63 614 48T628 27Q628 20 622 14T608 7Q600 7 495 114L386 221L279 114Q204 39 188 23T166 7Q159 7 153 13T146 27Q146 32 160 47T244 132L339 230H68Q55 243 55 250Q55 255 68 270H339L244 367Q175 436 161 451T146 472ZM466 34Q466 4 447 -20T388 -44Q353 -44 331 -22Q311 1 311 34Q311 66 331 85Q347 101 366 110Q374 112 382 112Q405 112 419 105Q429 100 443 87T462 63Q466 45 466 34",
  8904: "833 50T833 250T832 450T659 351T487 250T658 150T832 50Q833 50 833 250ZM873 10Q866 -5 854 -5Q851 -5 845 -3L449 226L260 115Q51 -5 43 -5Q39 -5 35 -1T28 7L26 11V489Q33 505 43 505Q51 505 260 385L449 274L845 503Q851 505 853 505Q866 505 873 490V10ZM412 250L67 450Q66 450 66 250T67 50Q69 51 240 150T412 250",
  8905: "146 479Q159 492 166 492Q171 492 189 475T279 386L386 279L495 386Q598 492 608 492Q615 492 621 486T628 472Q628 464 522 357L415 250L522 144Q628 37 628 28Q628 21 622 15T608 8Q599 8 495 115L386 221L279 115Q204 40 188 24T166 8Q162 8 160 9T153 15T146 21V479ZM186 77L359 250L186 424V77",
  8906: "146 472Q146 479 152 485T166 492Q171 492 189 475T279 386L386 279L495 386Q598 492 608 492Q615 492 628 479V21Q615 8 608 8Q599 8 495 115L386 221L279 115Q204 40 188 24T166 8Q159 8 153 14T146 28Q146 37 253 144L359 250L253 357Q146 464 146 472ZM588 77V424L499 337L415 250L588 77",
  8907: "55 674Q55 682 62 688T76 694H77Q83 694 100 677T208 561Q320 440 410 342Q462 286 541 201Q677 55 699 30T722 -2Q722 -9 716 -15T701 -22T688 -17Q687 -15 542 141T394 301L388 306L240 146Q119 15 101 -3T75 -22T61 -16T55 -2Q55 4 67 19T158 117Q190 151 209 172L361 336L209 500Q62 657 57 667Q55 671 55 674",
  8908: "84 -22T76 -22T62 -16T55 -2Q55 4 78 30T249 215Q321 293 367 342Q672 672 683 682Q695 694 702 694Q710 694 716 688T722 674Q722 668 710 653T619 555Q587 521 568 500L416 336L568 172Q715 15 720 5Q722 1 722 -2Q722 -9 716 -15T702 -22H700Q693 -22 671 1T537 146L389 306Q387 304 340 253T237 143T135 33L89 -17Q84 -22 76 -22",
  8909: "56 433Q56 464 71 464Q74 464 77 461Q82 454 82 438T91 397T123 347Q166 307 222 307Q264 307 308 331T386 385T465 438T556 463Q631 463 676 408T722 283Q722 250 708 250Q704 250 699 257Q695 265 693 286T682 330Q670 350 655 367Q612 407 556 407Q514 407 470 383T393 329T314 276T222 251Q148 251 102 306T56 433ZM57 56Q57 71 73 76H706Q722 70 722 56Q722 44 707 36H71Q57 43 57 56",
  8910: "83 558Q83 566 89 572T104 578Q108 578 116 577T146 570T190 555T239 526T286 480Q308 453 325 420T351 358T367 304T376 265T380 251T381 253Q381 262 395 312Q428 434 492 499T642 576Q654 578 655 578Q664 578 670 572T676 558Q676 543 657 540T599 524T525 476Q406 362 400 29V8Q400 -21 380 -21Q369 -21 362 -11Q360 -7 360 12Q360 115 348 200T308 360T231 480T111 537Q83 540 83 558",
  8911: "104 -22Q95 -22 89 -16T83 -2Q83 11 98 16T135 23T192 46T256 103Q360 233 360 549Q360 554 360 557T361 563T362 567T364 569T367 572T371 576Q377 578 380 578Q401 578 401 547Q401 543 401 537T400 527Q409 53 648 19Q676 16 676 -2Q676 -10 670 -16T655 -22Q654 -22 642 -20Q556 -9 492 56T395 244Q381 294 381 303Q381 305 380 305T374 275T352 201T310 110T234 27T117 -20Q105 -22 104 -22",
  8912: "84 250Q84 372 166 450T360 539Q361 539 370 539T395 539T430 540T475 540T524 540H679Q694 532 694 520Q694 511 681 501L522 500H470H441Q366 500 338 496T266 472Q244 461 224 446T179 404T139 337T124 250V245Q124 157 185 89Q244 25 328 7Q348 2 366 2T522 0H681Q694 -10 694 -20Q694 -32 679 -40H526Q510 -40 480 -40T434 -41Q350 -41 289 -25T172 45Q84 127 84 250ZM694 134Q694 123 679 114H425H384Q350 114 326 121T277 154Q238 193 238 251Q238 322 295 361Q318 378 339 382T412 387Q423 387 459 387T520 386H679Q694 377 694 366Q694 354 679 346H519Q493 346 458 346T411 347Q360 347 341 342T303 315Q278 287 278 250Q278 210 301 187T351 156Q358 154 519 154H679Q694 146 694 134",
  8913: "83 520Q83 532 98 540H251Q267 540 297 540T343 541Q427 541 488 525T605 455Q693 374 693 250Q693 165 650 99T545 0T415 -39Q407 -40 251 -40H98Q83 -32 83 -20Q83 -10 96 0H255H308H337Q412 0 439 4T512 28Q533 39 553 54T599 96T639 163T654 250Q654 341 592 411Q557 449 512 472Q468 491 439 495T335 500H306H255L96 501Q83 511 83 520ZM83 366Q83 376 96 386H244Q280 386 317 386T378 386L402 387Q456 387 498 348T540 250Q540 203 512 168T446 120Q427 114 353 114H99Q84 120 84 134Q84 147 98 154H258Q284 154 319 154T366 153Q416 153 436 158T474 185Q500 214 500 250Q500 290 477 313T426 344Q419 346 258 346H98Q83 354 83 366",
  8914: "88 -21T75 -21T55 -7V200Q55 231 55 280Q56 414 60 428Q61 430 61 431Q77 500 152 549T332 598Q443 598 522 544T610 405Q611 399 611 194V-7Q604 -22 591 -22Q582 -22 572 -9L570 405Q563 433 556 449T529 485Q498 519 445 538T334 558Q251 558 179 518T96 401Q95 396 95 193V-7Q88 -21 75 -21ZM229 -21H227Q215 -21 209 -7V166Q209 304 209 327T215 363Q226 398 259 421T333 444Q380 444 414 416T455 347Q457 339 457 166V-7Q449 -21 439 -21H437H435Q423 -21 417 -7V164Q417 303 417 325T411 358Q387 403 333 403T255 358Q250 347 250 325T249 164V-7Q241 -21 231 -21H229",
  8915: "591 598H592Q604 598 611 583V376Q611 345 611 296Q610 162 606 148Q605 146 605 145Q586 68 507 23T333 -22Q268 -22 209 -1T106 66T56 173Q55 180 55 384L56 585Q66 598 75 598Q85 598 95 585V378L96 172L98 162Q112 95 181 57T332 18Q415 18 487 58T570 175Q571 180 571 383V583Q579 598 591 598ZM437 598Q450 598 457 583V410Q457 237 455 229Q448 189 414 161T333 132Q291 132 255 157T211 230Q209 237 209 412L210 585Q220 598 229 598Q242 598 249 583V412Q249 273 249 251T255 218Q279 173 333 173T411 218Q416 229 416 251T417 412V583Q425 598 437 598",
  8916: "76 -22Q64 -22 56 -7V176L57 360L59 370Q66 401 83 426T123 468T171 495T221 513T265 522T298 527L311 528H314V625L315 723Q325 736 334 736Q346 736 354 721V528H356L368 527Q380 526 399 523T441 515T490 498T537 472T578 433T606 379Q611 359 611 171V-7Q604 -21 591 -21T571 -7V170Q571 313 571 337T565 375Q555 408 526 432T461 467T402 482T365 487H354V-7Q347 -21 334 -21T314 -7V487H303Q251 484 207 467Q121 438 99 367L97 357L96 174V-9Q86 -22 76 -22",
  8918: "86 261Q92 267 381 404T673 541Q680 541 686 535T693 521T689 510Q684 504 418 379L151 250L418 121Q686 -4 689 -10Q693 -14 693 -21T687 -34T675 -41Q668 -41 380 96T86 239Q82 244 82 250Q82 257 86 261ZM610 250Q610 224 592 198T531 172Q498 172 475 195Q453 214 453 250Q453 308 513 328Q515 330 535 330Q569 328 589 304T610 250",
  8919: "82 521Q82 529 89 535T100 541Q107 541 395 404T689 261Q693 257 693 250T689 239Q684 234 396 97T100 -41Q95 -41 89 -35T82 -21Q82 -12 96 -4Q118 9 358 121L624 250L358 379Q91 503 86 510Q82 514 82 521ZM165 250Q165 282 188 306T239 330Q262 330 275 323Q303 312 318 283Q322 272 322 250Q322 213 300 195Q277 172 246 172Q224 172 213 177Q165 200 165 250",
  8920: "639 -48Q639 -54 634 -60T619 -67H618Q612 -67 536 -26Q430 33 329 88Q61 235 59 239Q56 243 56 250T59 261Q62 266 336 415T615 567L619 568Q622 567 625 567Q639 562 639 548Q639 540 633 534Q632 532 374 391L117 250L374 109Q632 -32 633 -34Q639 -40 639 -48ZM958 -48Q958 -54 953 -60T938 -67H937Q931 -67 855 -26Q749 33 648 88Q380 235 378 239Q375 243 375 250T378 261Q381 266 655 415T934 567L938 568Q941 567 944 567Q958 562 958 548Q958 540 952 534Q951 532 693 391L436 250L693 109Q951 -32 952 -34Q958 -40 958 -48ZM1277 -48Q1277 -54 1272 -60T1257 -67H1256Q1250 -67 1174 -26Q1068 33 967 88Q699 235 697 239Q694 243 694 250T697 261Q700 266 974 415T1253 567L1257 568Q1260 567 1263 567Q1277 562 1277 548Q1277 540 1271 534Q1270 532 1012 391L755 250L1012 109Q1270 -32 1271 -34Q1277 -40 1277 -48",
  8921: "75 -67Q65 -67 60 -61T55 -48Q55 -40 61 -34Q62 -32 329 109L595 250L329 391Q62 532 61 534Q55 540 55 548Q55 562 69 567H77Q81 567 222 493T506 342T653 264Q667 250 653 236Q649 234 504 157T220 7T77 -67H75ZM364 547Q364 563 381 567L384 568Q387 568 518 499T795 353T955 269Q967 261 967 250T955 231Q925 216 780 139T513 -3T383 -67Q373 -67 369 -60T364 -47Q364 -40 370 -34Q373 -31 639 109L904 250L639 391Q373 531 370 534Q364 540 364 547ZM674 538T674 548T681 562T693 567Q699 567 816 505Q915 453 993 412Q1050 382 1132 339Q1241 282 1259 271T1277 250Q1277 241 1263 232Q1246 221 985 84Q698 -67 692 -67Q674 -67 674 -47Q674 -38 680 -33Q683 -30 947 109L1213 250L947 391Q683 530 680 533Q674 538 674 548",
  8922: "674 445Q674 438 669 432T655 425T369 531T90 640Q83 645 83 655Q83 668 95 673Q644 886 654 886Q662 886 668 880T674 866Q674 856 663 850Q649 843 411 751L160 655L407 560Q474 534 561 501Q646 469 660 462T674 445ZM84 250Q84 260 99 270H658Q674 264 674 250Q674 238 659 230H98Q84 237 84 250ZM83 55Q83 68 94 73Q98 76 104 76Q108 75 383 -30T664 -138Q674 -144 674 -155Q674 -165 667 -170Q664 -173 385 -279T104 -386Q85 -386 83 -368Q83 -354 92 -349Q93 -349 347 -251L597 -155L346 -59Q296 -40 223 -12Q118 28 101 36T83 55",
  8923: "111 425T102 425T88 431T83 445V446Q83 455 96 461Q111 469 203 504Q287 536 350 560L597 655L346 751Q94 848 92 850Q83 856 83 866Q83 873 88 879T104 886Q109 885 386 779T667 670Q674 665 674 655T667 640Q665 638 388 532ZM84 250Q84 260 99 270H658Q674 264 674 250Q674 238 659 230H98Q84 237 84 250ZM653 76Q656 76 660 75T669 68T674 56Q674 46 665 40Q663 38 411 -59L160 -155L410 -251Q664 -349 665 -349Q674 -354 674 -368Q672 -386 654 -386Q650 -386 371 -279T90 -170Q83 -165 83 -155Q83 -144 93 -138Q645 76 653 76",
  8926: "113 424Q83 424 83 444Q83 453 96 464H121Q181 466 234 474T341 501T435 545T505 613T542 707Q545 734 564 734Q583 731 583 714Q583 658 560 613T500 538T414 486T321 453T229 434T156 426T113 424ZM112 270Q83 270 83 290Q83 301 94 307Q98 310 118 310Q624 310 653 556Q657 580 675 580Q693 577 693 559V552Q684 472 628 410T465 314Q436 303 372 290Q373 290 388 287T425 278T465 266Q674 199 693 28L694 17L692 14Q691 11 689 8T683 3T673 0Q657 0 653 24Q623 270 118 270H112",
  8927: "195 713Q195 725 201 729T214 734Q227 734 231 722T238 691T255 641T299 580Q405 474 656 464H681Q694 451 694 443Q694 424 670 424H664Q535 424 415 465T235 595Q195 657 195 713ZM668 310Q694 310 694 290Q694 285 691 279Q684 271 664 270Q550 268 464 257T301 220T179 146T124 27Q119 0 103 0T83 16Q83 21 83 31T92 68T113 121T157 177T229 231Q295 268 405 290Q404 290 389 293T352 302T312 314Q138 371 96 500Q83 541 83 562Q83 568 89 574T103 580Q115 580 120 570T126 542T138 497T173 442Q289 310 659 310H668",
  8928: "82 344Q82 349 95 364H124Q266 364 398 390L429 397L509 595Q519 619 536 659Q581 766 590 783T609 801Q616 801 622 795T629 781Q629 776 553 595Q533 548 516 506T489 439T480 415Q482 415 505 426T538 444Q632 498 651 601Q654 621 658 628T673 635Q680 635 686 629T693 615Q693 591 678 546Q636 433 484 375L458 364L451 348Q443 332 443 329T455 324Q480 316 503 307T560 277T619 233T664 170T691 86Q693 68 691 64Q684 53 672 53Q664 53 658 59Q657 60 650 97T617 174T538 244Q515 257 476 273T428 289Q425 289 412 256Q381 179 344 90L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H95Q82 -128 82 -123T95 -103H220L302 97Q384 288 384 299Q384 302 341 308T235 319T124 324H95Q82 337 82 344ZM399 338Q403 338 406 346L409 353L375 344Q375 343 384 341T399 338",
  8929: "146 -283Q146 -282 174 -213T202 -143H95Q82 -127 82 -123T95 -103H220L300 93Q343 196 374 270Q385 294 386 299L373 295Q331 287 289 268Q241 249 208 224T159 174T135 127T124 85T118 59Q112 53 103 53Q91 53 84 64Q82 68 84 86Q96 185 174 248T375 337L400 344Q399 344 381 348T351 355T316 364T276 379T235 398T193 424T155 456T122 497T98 546Q82 587 82 615Q82 622 88 628T102 635Q112 635 116 628T124 601Q128 579 134 562T159 515T207 463T290 418T415 384L422 381L506 586Q571 744 584 772T609 801Q616 801 622 795T629 781T544 577Q525 529 504 478T473 402T462 375Q480 373 500 373Q579 364 651 364H680Q682 361 686 357T691 351T693 344Q693 337 680 324H651Q553 324 451 310L433 308L349 104L262 -101L473 -103H682Q694 -115 694 -123Q694 -133 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283",
  8934: "86 450Q93 455 380 592T673 730Q680 730 686 724T693 710Q693 702 688 699Q686 693 417 568L151 439L417 310Q685 185 688 179Q693 176 693 168Q693 161 687 155T675 148Q668 148 380 285T86 428Q74 438 86 450ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
  8935: "88 723Q95 730 99 730Q106 730 394 593T688 450Q693 447 693 439T688 428Q683 423 395 286T99 148Q94 148 88 155T82 168Q82 175 86 179Q89 184 357 310L624 439L357 568Q88 694 86 699Q81 703 81 711T88 723ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
  8936: "95 419Q81 433 81 439T95 459H124Q318 459 455 501Q515 521 556 550T615 607T641 659T652 702T659 725Q667 730 673 730Q680 730 686 724T693 710Q693 682 677 641Q668 616 654 594T622 554T586 522T545 497T504 477T464 462T428 452T397 444T375 439Q379 437 410 430T476 411T551 379T625 321T677 237Q693 196 693 168Q693 161 687 155T673 148Q662 148 658 154T651 181Q638 253 591 300T455 377Q318 419 124 419H95ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
  8937: "679 459Q693 445 693 439Q693 430 679 419H651Q455 419 319 377Q231 347 184 300T124 181Q120 161 116 155T102 148Q95 148 89 154T82 168Q82 192 97 237Q111 275 137 306T188 355T249 391T307 414T361 429T399 439Q397 440 364 447T298 467T224 499T149 557T97 641Q82 686 82 710Q82 717 88 723T102 730L115 725Q118 722 124 697Q137 625 184 578T319 501Q456 459 651 459H679ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
  8938: "693 -30Q686 -41 673 -41Q661 -41 506 34L346 110L280 -44Q228 -162 216 -185T193 -208Q177 -208 173 -192Q173 -186 242 -30T311 128Q271 145 184 186T86 236Q82 240 82 246Q82 251 86 259Q96 267 271 350L449 434L506 565Q537 635 551 664T571 700T582 706Q587 706 593 701T600 690Q600 679 553 572Q504 463 504 461L586 501Q672 539 673 539Q679 539 693 525V-30ZM653 10V488L566 445L480 405L422 276Q415 260 405 236T388 199T376 171T368 151T366 145Q368 143 510 77T653 10ZM422 374Q422 376 420 376T285 313T151 248Q315 168 326 163Q415 356 422 374",
  8939: "82 525Q96 539 102 539Q103 539 122 530T186 501T266 463L426 388Q428 388 495 541Q564 694 569 699Q573 706 581 706Q587 706 593 702T600 691Q600 676 533 528Q515 486 506 465T485 418T470 381T466 370Q466 369 575 316Q676 269 689 259Q693 253 693 248Q693 242 689 236Q688 235 506 145Q328 63 324 59Q324 50 266 -70Q224 -169 214 -188T193 -208Q177 -208 173 -192Q173 -183 222 -77Q244 -29 257 2T269 34L186 -6Q108 -43 99 -43Q93 -43 82 -30V525ZM271 416Q129 485 126 485H125Q122 485 122 250Q122 10 124 10L211 50L295 92L411 350Q411 351 271 416ZM624 248L449 332L440 319Q434 297 393 214Q353 121 353 119Q355 119 489 182T624 248",
  8940: "82 -123Q82 -114 93 -103H166L238 -101L293 50Q349 200 349 204L220 266Q166 291 140 304T100 325T84 336T82 344Q82 353 94 360Q112 372 282 453L473 541L482 568Q487 578 529 693Q559 785 569 795Q573 802 581 802Q587 802 593 797T599 786Q599 775 564 675L526 570Q526 568 561 584T633 617T673 635Q679 635 693 621V66Q686 54 679 54Q665 54 526 119Q491 137 458 153T405 177T386 184Q385 182 334 42T282 -101T482 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L473 -143H266L238 -219Q217 -278 210 -290T193 -303Q178 -303 173 -287Q173 -279 198 -214L222 -145Q222 -143 158 -143L93 -141L86 -136Q82 -131 82 -123ZM653 106V584L506 513L453 370Q442 339 428 300T407 243T400 224Q403 222 527 164T653 106ZM453 486Q453 488 451 488T300 417T151 344L224 308Q247 298 285 279T331 257L364 241L453 486",
  8941: "82 621Q96 635 102 635T249 568L420 486L449 473L469 533Q563 789 569 797Q573 801 581 801Q598 801 600 786Q602 781 544 617L484 455Q531 435 584 408Q677 364 689 355Q693 351 693 344Q693 339 692 337T676 325T631 302T538 257Q504 241 465 223T406 195T386 186Q384 184 333 44T282 -101Q282 -103 482 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L473 -143H266L238 -219Q217 -278 210 -290T193 -303Q178 -303 173 -287Q173 -279 198 -214L222 -145Q222 -143 158 -143L93 -141L86 -136Q82 -131 82 -123Q82 -114 93 -103H166L238 -101L333 159Q326 159 220 106Q110 54 97 54Q89 54 82 66V621ZM298 501Q155 567 142 575L122 584V344Q122 106 124 106Q125 106 180 132T291 185T351 213Q355 217 393 326L433 435Q433 436 298 501ZM549 381Q472 417 471 417L406 241Q408 240 516 291T624 344L549 381",
  8942: "78 30Q78 54 95 72T138 90Q162 90 180 74T199 31Q199 6 182 -12T139 -30T96 -13T78 30ZM78 440Q78 464 95 482T138 500Q162 500 180 484T199 441Q199 416 182 398T139 380T96 397T78 440ZM78 840Q78 864 95 882T138 900Q162 900 180 884T199 841Q199 816 182 798T139 780T96 797T78 840",
  8943: "78 250Q78 274 95 292T138 310Q162 310 180 294T199 251Q199 226 182 208T139 190T96 207T78 250ZM525 250Q525 274 542 292T585 310Q609 310 627 294T646 251Q646 226 629 208T586 190T543 207T525 250ZM972 250Q972 274 989 292T1032 310Q1056 310 1074 294T1093 251Q1093 226 1076 208T1033 190T990 207T972 250",
  8945: "133 760Q133 784 150 802T193 820Q217 820 235 804T254 761Q254 736 237 718T194 700T151 717T133 760ZM580 460Q580 484 597 502T640 520Q664 520 682 504T701 461Q701 436 684 418T641 400T598 417T580 460ZM1027 160Q1027 184 1044 202T1087 220Q1111 220 1129 204T1148 161Q1148 136 1131 118T1088 100T1045 117T1027 160",
  8965: "55 698Q56 708 70 716H540Q554 708 555 698Q555 694 554 691T552 686T549 682T546 680T542 678T539 676H71Q70 676 68 677T65 679T61 682T58 686T56 691T55 698ZM555 18Q554 12 549 6T536 0H535Q525 0 515 17T459 132Q430 194 410 235L305 455L199 233Q176 185 147 125T105 36T90 7Q85 0 75 0Q63 0 58 11Q55 15 55 21Q58 31 170 266T285 507Q295 522 305 522T320 515Q322 513 439 268L555 24V18",
  8966: "55 795Q56 806 70 813H540Q554 806 555 795Q555 791 554 788T552 783T549 779T546 777T542 775T539 773H71Q70 773 68 774T65 776T61 779T58 783T56 788T55 795ZM55 601Q56 612 70 619H540Q554 612 555 601Q555 597 554 594T552 589T549 585T546 583T542 581T539 579H71Q70 579 68 580T65 582T61 585T58 589T56 594T55 601ZM75 -97Q67 -97 61 -91T55 -81Q55 -71 169 166T285 410Q295 425 305 425Q311 425 316 422T323 414L325 410Q327 404 441 167T555 -81Q555 -85 549 -91T535 -97T520 -90Q519 -89 506 -61T463 27T411 136L305 358L199 136Q167 71 129 -10Q98 -75 92 -86T75 -97",
  8968: "174 734Q178 746 190 750H298H369Q400 750 411 747T422 730T411 713T372 709Q365 709 345 709T310 710H214V-235Q206 -248 196 -250Q192 -250 189 -249T184 -247T180 -244T178 -241T176 -237T174 -234V734",
  8969: "21 717T21 730T32 746T75 750H147H256Q266 742 269 735V-235Q262 -248 251 -250Q247 -250 244 -249T239 -247T235 -244T233 -241T231 -237T229 -234V710H133Q119 710 99 710T71 709Q43 709 32 713",
  8970: "174 734Q174 735 175 737T177 740T180 744T184 747T189 749T196 750Q206 748 214 735V-210H310H373Q401 -210 411 -213T422 -230T411 -247T369 -251Q362 -251 338 -251T298 -250H190Q178 -246 174 -234V734",
  8971: "229 734Q229 735 230 737T232 740T235 744T239 747T244 749T251 750Q262 748 269 735V-235Q266 -240 256 -249L147 -250H77Q43 -250 32 -247T21 -230T32 -213T72 -209Q79 -209 99 -209T133 -210H229V734",
  8988: "76 306Q62 306 59 319T55 386V500V596Q55 664 57 676T68 692Q71 694 250 694Q428 694 432 692Q444 685 444 674Q444 665 432 656Q428 654 261 654H95V487Q95 355 95 336T90 312Q84 306 76 306",
  8989: "424 306Q418 306 413 310T406 318L404 321V654H238Q71 654 68 656Q55 662 55 674T68 692Q71 694 250 694H379Q432 694 438 688Q443 683 443 662T444 500T444 338T438 312Q432 306 424 306",
  8990: "55 172V287Q55 341 58 353T76 366Q88 366 95 351V18H261Q428 18 432 16Q444 9 444 -2Q444 -11 432 -20Q428 -22 250 -22H120Q67 -22 61 -16Q56 -11 56 10T55 172",
  8991: "404 351Q410 366 424 366Q437 366 440 353T444 288V172V72Q444 8 443 -4T432 -20Q428 -22 250 -22Q71 -22 68 -20Q55 -14 55 -2T68 16Q71 18 238 18H404V351",
  8994: "55 141Q55 149 72 174T125 234T209 303T329 360T478 388H526Q649 383 765 319Q814 291 858 250T923 179T944 141Q944 133 938 128T924 122Q914 124 912 125T902 139Q766 328 500 328Q415 328 342 308T225 258T150 199T102 148T84 124Q81 122 75 122Q55 127 55 141",
  8995: "923 378Q944 378 944 358Q944 345 912 311T859 259Q710 134 500 134Q288 134 140 259Q55 336 55 358Q55 366 61 372T75 378Q78 378 84 376Q86 376 101 356T147 310T221 257T339 212T500 193Q628 193 734 236Q841 282 903 363Q914 378 923 378",
  9001: "333 -232Q332 -239 327 -244T313 -250Q303 -250 296 -240Q293 -233 202 6T110 250T201 494T296 740Q299 745 306 749L309 750Q312 750 313 750Q331 750 333 732Q333 727 243 489Q152 252 152 250T243 11Q333 -227 333 -232",
  9002: "55 732Q56 739 61 744T75 750Q85 750 92 740Q95 733 186 494T278 250T187 6T92 -240Q85 -250 75 -250Q67 -250 62 -245T55 -232Q55 -227 145 11Q236 248 236 250T145 489Q55 727 55 732",
  9136: "357 741V726Q357 720 349 715Q261 655 242 539Q240 526 240 454T239 315T239 247Q240 235 240 124V40Q240 -17 233 -53T201 -130Q155 -206 78 -244H69H64Q58 -244 57 -243T56 -234Q56 -232 56 -231V-225Q56 -218 63 -215Q153 -153 170 -39Q172 -25 173 119V219Q173 245 174 249Q173 258 173 376V460Q173 515 178 545T201 611Q244 695 327 741L334 744H354L357 741",
  9137: "78 744Q153 706 196 640T239 492V376Q239 341 239 314T238 271T238 253Q239 251 239 223V119V49Q239 -39 254 -85Q263 -111 275 -134T301 -172T326 -197T346 -213T356 -221T357 -232V-241L354 -244H334Q264 -209 222 -146T174 -12Q173 -6 173 95Q173 134 173 191T174 250Q173 258 173 382V451Q173 542 159 585Q145 626 120 658T75 706T56 723V731Q56 741 57 742T66 744H78",
  9168: "312 0V602H355V0H312",
  9416: "451 -175Q328 -175 226 -115T66 47T8 267Q8 303 15 342T39 431T94 531T186 622Q239 663 307 686T424 709H440Q604 709 716 622Q757 592 788 555T838 482T869 414T886 350T892 301T894 267Q894 147 835 45T674 -116T451 -175ZM854 268Q854 375 802 467T657 614T450 670Q283 670 166 552T49 267Q49 99 167 -18T453 -136Q617 -136 735 -18T854 268ZM273 378Q273 430 309 474T409 527Q411 527 417 527T428 528Q498 528 549 484L567 505Q583 528 590 528H594Q600 528 606 522V350L600 344H586Q577 344 574 344T569 347T566 357Q542 491 432 491Q389 491 365 465T340 407Q340 391 344 378T358 356T377 340T400 328T421 321T443 316T459 313Q499 305 517 300T559 279T601 238Q629 195 629 148Q629 80 583 33T471 -14Q392 -14 330 30Q312 6 293 -13Q292 -14 285 -14Q279 -14 273 -8V77V138Q273 160 275 165T286 170H294H307Q313 164 313 158Q313 108 350 67T471 26Q512 26 537 54T562 119Q562 137 558 151T544 176T527 193T504 205T483 212T459 218T441 222Q391 232 368 241T318 273Q273 316 273 378",
  9484: "76 306Q62 306 59 319T55 386V500V596Q55 664 57 676T68 692Q71 694 250 694Q428 694 432 692Q444 685 444 674Q444 665 432 656Q428 654 261 654H95V487Q95 355 95 336T90 312Q84 306 76 306",
  9488: "424 306Q418 306 413 310T406 318L404 321V654H238Q71 654 68 656Q55 662 55 674T68 692Q71 694 250 694H379Q432 694 438 688Q443 683 443 662T444 500T444 338T438 312Q432 306 424 306",
  9492: "55 172V287Q55 341 58 353T76 366Q88 366 95 351V18H261Q428 18 432 16Q444 9 444 -2Q444 -11 432 -20Q428 -22 250 -22H120Q67 -22 61 -16Q56 -11 56 10T55 172",
  9496: "404 351Q410 366 424 366Q437 366 440 353T444 288V172V72Q444 8 443 -4T432 -20Q428 -22 250 -22Q71 -22 68 -20Q55 -14 55 -2T68 16Q71 18 238 18H404V351",
  9585: "19 -195Q13 -195 7 -188T0 -176Q0 -169 18 -151L822 683Q835 694 840 694T852 688T860 674Q860 667 810 614T460 252Q57 -167 44 -179Q27 -195 19 -195",
  9586: "0 675Q0 681 6 687T19 694Q27 694 44 678L460 247Q759 -62 809 -115T860 -175Q860 -183 852 -189T840 -195Q835 -195 822 -184L18 649Q0 667 0 675",
  9632: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71",
  9633: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 40V649H95V40H682",
  9642: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71",
  9650: "99 -20Q84 -11 84 0Q84 5 148 145T278 424L342 563Q347 575 360 575Q368 575 375 570Q376 569 441 430T571 148T637 0Q637 -11 622 -20H99",
  9651: "75 0L72 2Q69 3 67 5T62 11T59 20Q59 24 62 30Q65 37 245 370T428 707Q428 708 430 710T436 714T444 716Q451 716 455 712Q459 710 644 368L828 27V20Q828 7 814 0H75ZM610 347L444 653Q443 653 278 347T113 40H775Q775 42 610 347",
  9652: "99 -20Q84 -11 84 0Q84 5 148 145T278 424L342 563Q347 575 360 575Q368 575 375 570Q376 569 441 430T571 148T637 0Q637 -11 622 -20H99",
  9653: "75 0L72 2Q69 3 67 5T62 11T59 20Q59 24 62 30Q65 37 245 370T428 707Q428 708 430 710T436 714T444 716Q451 716 455 712Q459 710 644 368L828 27V20Q828 7 814 0H75ZM610 347L444 653Q443 653 278 347T113 40H775Q775 42 610 347",
  9654: "83 523Q83 524 85 527T92 535T103 539Q107 539 389 406T680 268Q694 260 694 249Q694 239 687 234Q685 232 395 95L107 -41H101Q90 -40 83 -26V523",
  9656: "83 523Q83 524 85 527T92 535T103 539Q107 539 389 406T680 268Q694 260 694 249Q694 239 687 234Q685 232 395 95L107 -41H101Q90 -40 83 -26V523",
  9657: "26 489Q33 505 43 505Q51 505 260 385Q464 266 471 259Q473 257 473 250Q473 242 469 239Q459 231 260 115Q51 -5 43 -5Q39 -5 35 -1T28 7L26 11V489ZM412 250L67 450Q66 450 66 250T67 50Q69 51 240 150T412 250",
  9660: "84 556Q84 567 99 576H622Q637 567 637 556Q637 551 572 409T441 127T375 -14Q368 -19 360 -19H358Q349 -19 342 -7T296 92Q249 193 211 275Q84 550 84 556",
  9661: "59 480Q59 485 61 489T66 495T72 498L75 500H814Q828 493 828 480V474L644 132Q458 -210 455 -212Q451 -215 444 -215T433 -212Q429 -210 342 -49T164 282T64 466Q59 478 59 480ZM775 460H113Q113 459 278 153T444 -153T610 153T775 460",
  9662: "84 556Q84 567 99 576H622Q637 567 637 556Q637 551 572 409T441 127T375 -14Q368 -19 360 -19H358Q349 -19 342 -7T296 92Q249 193 211 275Q84 550 84 556",
  9663: "59 480Q59 485 61 489T66 495T72 498L75 500H814Q828 493 828 480V474L644 132Q458 -210 455 -212Q451 -215 444 -215T433 -212Q429 -210 342 -49T164 282T64 466Q59 478 59 480ZM775 460H113Q113 459 278 153T444 -153T610 153T775 460",
  9664: "694 -26Q686 -40 676 -41H670L382 95Q92 232 90 234Q83 239 83 249Q83 262 96 267Q101 270 379 401T665 537Q671 539 674 539Q686 539 694 524V-26",
  9666: "694 -26Q686 -40 676 -41H670L382 95Q92 232 90 234Q83 239 83 249Q83 262 96 267Q101 270 379 401T665 537Q671 539 674 539Q686 539 694 524V-26",
  9667: "473 10Q466 -5 454 -5Q451 -5 445 -3Q444 -3 343 56T140 173T35 234Q26 239 26 250T35 266Q40 269 240 384T445 503Q451 505 453 505Q466 505 473 490V10ZM433 50T433 250T432 450T259 351T87 250T258 150T432 50Q433 50 433 250",
  9674: "318 709Q325 716 332 716Q340 716 344 713T474 511Q611 298 611 292Q611 285 526 152Q494 103 474 72Q347 -128 344 -130Q340 -132 333 -132T322 -130Q319 -128 257 -31T131 169T60 278Q56 285 56 292Q56 298 60 305Q73 326 194 516T318 709ZM567 290T567 291T451 475T333 658L100 293Q100 288 215 108L333 -74Q334 -74 450 108",
  9711: "56 250Q56 353 95 442T196 589T335 681T491 715Q573 715 635 693Q694 673 747 635T846 543T917 412T944 250Q944 58 815 -78T500 -215Q457 -215 429 -210Q274 -183 165 -56T56 250ZM500 -176Q664 -176 784 -54T904 250Q904 418 799 536T543 674Q534 675 493 675Q425 675 357 647T229 567T133 432T96 250Q96 160 129 80T217 -56T346 -144T500 -176",
  9723: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 40V649H95V40H682",
  9724: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71",
  9733: "367 395Q374 416 398 492T442 627T463 688Q463 692 467 692Q471 694 472 694Q478 694 484 680T523 562Q553 469 576 400L577 395H731H819Q872 395 883 394T895 384Q895 380 891 376T832 333Q794 305 767 285Q643 195 643 194L690 47Q737 -96 737 -103Q737 -111 727 -111Q721 -111 594 -18L472 71L350 -18Q223 -111 217 -111Q207 -111 207 -103Q207 -96 254 47L301 194Q301 195 241 239T118 328T51 378Q49 382 49 384Q49 392 58 393T110 395H213H367",
  9824: "181 -21Q134 -21 96 27T55 193Q55 224 58 247T82 317T143 410Q172 443 234 498Q282 543 314 598T360 687T380 725Q386 727 389 727Q395 727 398 725T406 716T413 702T423 677T439 641Q481 556 544 498Q633 420 678 353T723 204Q723 142 711 94T669 12T590 -21Q520 -21 490 8T459 66V70H409V62Q409 22 416 -17T430 -82T437 -112Q437 -131 407 -131Q403 -131 397 -131T389 -130T382 -130T372 -131Q341 -131 341 -111Q341 -107 348 -82T362 -18T369 62V70H319V66Q319 57 314 44T297 16T257 -10T191 -21H181",
  9825: "55 490Q55 557 71 604T114 674T167 706T222 716Q279 716 322 684T389 605Q391 610 395 617T414 643T447 677T494 704T555 716Q642 716 682 652T723 490Q723 455 718 426T684 342T602 227Q573 196 537 161T485 110T449 63T412 -8Q408 -22 404 -27T389 -33Q382 -33 379 -31T372 -23T366 -8T355 18T335 54Q319 81 298 104T239 163T176 227Q102 310 79 371T55 490ZM198 674Q143 664 119 613T95 491Q95 415 137 346Q174 282 265 194T384 48L389 39Q391 42 397 54T406 71T415 86T427 104T442 122T464 146T491 172Q571 249 613 303Q683 396 683 487Q683 581 649 631Q613 676 556 676Q495 676 457 634T410 538Q407 514 390 514Q386 514 380 517Q372 520 369 536T355 581T319 635Q277 675 223 675H217H208L204 674Q200 674 198 674",
  9826: "370 714Q370 717 375 722T388 727Q398 727 403 721T417 697Q420 692 421 689Q536 465 709 304Q723 291 723 282T709 260Q529 93 406 -153Q402 -162 390 -162H389Q379 -162 376 -158T357 -125Q247 89 89 241L64 265Q55 272 55 282Q55 287 57 290T64 300T77 312T98 331T127 361Q197 435 258 523T344 663L370 714ZM655 299Q568 384 508 470T389 662L376 638Q362 613 341 577T289 497T215 399T123 299L105 282L123 265Q210 180 270 94T389 -98L402 -74Q416 -49 437 -13T489 67T563 165T655 265L673 282L655 299",
  9827: "213 532Q213 615 265 670T389 726Q461 726 513 671T565 532Q565 511 562 492T553 458T541 432T526 409T512 393T498 379L490 371L511 326Q512 326 516 330T528 341T546 353T572 363T606 368Q664 368 707 315T750 174Q750 87 699 33T579 -22Q567 -22 553 -20T517 -10T479 16T459 63V70H409V62Q409 22 416 -17T430 -82T437 -112Q437 -131 407 -131Q403 -131 397 -131T389 -130T382 -130T372 -131Q341 -131 341 -111Q341 -107 348 -82T362 -18T369 62V70H319V63Q315 25 281 2T197 -22Q132 -22 80 32T28 174Q28 255 69 311T175 368Q192 368 207 364T232 353T250 341T262 331T267 326L288 371L280 378Q272 385 267 391T253 407T238 430T226 457T217 492T213 532",
  9837: "200 467Q254 467 293 428T332 321Q332 147 104 -11L88 -22H75Q62 -22 56 -16L55 362V647Q55 743 60 748Q63 750 76 750H83Q87 750 95 744V434L104 440Q144 467 200 467ZM237 322Q237 360 225 388T183 417Q158 417 134 407T101 378Q96 370 96 349T95 197V34Q152 91 194 167T237 322",
  9838: "65 721Q78 734 94 734Q100 734 104 727V444L116 449Q129 454 157 465T208 486Q313 527 314 527Q318 527 324 521V-210Q306 -223 294 -223Q289 -223 284 -216V-13L270 -18Q257 -24 231 -34T180 -54Q77 -96 74 -96T65 -90V721ZM104 13Q282 84 283 85Q284 85 284 252Q284 418 283 418L230 396L140 360L104 346V13",
  9839: "101 -223Q94 -223 93 -217T91 -188V-151Q91 -88 90 -88Q87 -88 80 -92T68 -96Q62 -96 56 -90L55 -50V-22Q55 -8 58 -4T78 5L91 10V177Q91 343 90 343Q87 343 80 339T68 335Q62 335 56 341L55 381V409Q55 423 58 427T78 436L91 441V543V616Q91 643 93 648T106 656Q119 662 126 659Q130 657 130 645T131 554V456L257 503V607L258 710L260 712Q261 715 272 719T286 723Q293 723 295 715T297 671V617Q297 519 298 519Q301 519 307 522T319 526Q327 526 333 521V437L330 435Q328 432 312 427L297 421V254Q297 88 298 88Q301 88 307 91T319 95Q327 95 333 90V6L330 4Q328 1 312 -4L297 -10V-78V-122Q297 -145 295 -149T282 -156Q274 -160 268 -160Q257 -160 257 -130V-89V-25L131 -72V-210Q123 -215 116 -218T104 -222L101 -223ZM257 72V406L131 359V25L257 72",
  10003: "84 231Q84 244 114 264T170 285Q176 285 183 274T224 205Q267 129 268 129Q271 141 279 163T318 250T389 378T502 523T662 673Q702 706 732 706H734Q749 706 749 695Q749 682 730 666T660 607T559 505Q387 299 328 29Q324 0 295 -17T245 -34H241Q234 -34 225 -21T185 46Q166 79 154 101Q84 223 84 231",
  10016: "195 702T195 706T201 716H632Q638 710 638 706T636 700T621 690Q436 581 427 374V357H430Q554 357 645 421Q682 447 711 483T755 542T770 567Q775 572 786 563V131Q777 125 774 125T762 139Q709 228 642 274T482 333Q452 337 430 337H427V320Q430 279 437 247T462 170T521 82T621 4Q630 -2 633 -4T637 -7T638 -12Q638 -16 632 -22H201Q195 -16 195 -12T197 -6T212 4Q397 113 406 320V337H403Q279 337 188 273Q151 247 122 211T78 152T63 127Q58 122 48 131V563Q54 569 59 569Q62 569 71 555Q124 466 191 420T351 361Q381 357 403 357H406V374Q403 415 396 447T371 525T312 613T212 690Q199 697 197 699",
  10072: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V-235Q151 -249 141 -249H139",
  10216: "333 -232Q332 -239 327 -244T313 -250Q303 -250 296 -240Q293 -233 202 6T110 250T201 494T296 740Q299 745 306 749L309 750Q312 750 313 750Q331 750 333 732Q333 727 243 489Q152 252 152 250T243 11Q333 -227 333 -232",
  10217: "55 732Q56 739 61 744T75 750Q85 750 92 740Q95 733 186 494T278 250T187 6T92 -240Q85 -250 75 -250Q67 -250 62 -245T55 -232Q55 -227 145 11Q236 248 236 250T145 489Q55 727 55 732",
  10222: "357 741V726Q357 720 349 715Q261 655 242 539Q240 526 240 394V331Q240 259 239 250Q240 242 240 119V49Q240 -42 254 -85Q263 -111 275 -134T301 -172T326 -197T346 -213T356 -221T357 -232V-241L354 -244H334Q264 -209 222 -146T174 -12Q173 -6 173 95Q173 134 173 191T174 250Q173 260 173 376V460Q173 515 178 545T201 611Q244 695 327 741L334 744H354L357 741",
  10223: "78 744Q153 706 196 640T239 492V376Q239 339 239 311T238 269T238 252Q240 236 240 124V40Q240 -18 233 -53T202 -130Q156 -206 79 -244H70H65Q58 -244 57 -242T56 -231T57 -220T64 -215Q153 -154 170 -39Q173 -18 174 119V247Q173 249 173 382V451Q173 542 159 585Q145 626 120 658T75 706T56 723V731Q56 741 57 742T66 744H78",
  10229: "165 270H1510Q1525 262 1525 250T1510 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270",
  10230: "84 237T84 250T98 270H1444Q1328 357 1301 493Q1301 494 1301 496T1300 499Q1300 511 1317 511H1320Q1329 511 1332 510T1338 506T1341 497T1344 481T1352 456Q1374 389 1425 336T1544 261Q1553 258 1553 250Q1553 244 1548 241T1524 231T1486 212Q1445 186 1415 152T1370 85T1349 35T1341 4Q1339 -6 1336 -8T1320 -11Q1300 -11 1300 0Q1300 7 1305 25Q1337 151 1444 230H98Q84 237 84 250",
  10231: "165 270H1694Q1578 357 1551 493Q1551 494 1551 496T1550 499Q1550 511 1567 511H1570Q1579 511 1582 510T1588 506T1591 497T1594 481T1602 456Q1624 389 1675 336T1794 261Q1803 258 1803 250Q1803 244 1798 241T1774 231T1736 212Q1695 186 1665 152T1620 85T1599 35T1591 4Q1589 -6 1586 -8T1570 -11Q1550 -11 1550 0Q1550 7 1555 25Q1587 151 1694 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270",
  10232: "274 173H1539Q1540 172 1542 171T1545 169T1547 167T1550 164T1551 162T1552 158T1553 153Q1553 140 1538 133H318L328 123Q379 69 414 0Q419 -13 419 -17Q419 -24 399 -24Q388 -24 385 -23T377 -12Q332 77 253 144T72 237Q62 240 59 242T56 250T59 257T70 262T89 268T119 278T160 296Q303 366 377 512Q382 522 385 523T401 525Q419 524 419 515Q419 510 414 500Q379 431 328 377L318 367H1538Q1553 359 1553 347Q1553 336 1539 328L1221 327H903L900 328L602 327H274L264 319Q225 289 147 250Q148 249 165 241T210 217T264 181L274 173",
  10233: "1218 514Q1218 525 1234 525Q1239 525 1242 525T1247 525T1251 524T1253 523T1255 520T1257 517T1260 512Q1297 438 1358 381T1469 300T1565 263Q1582 258 1582 250T1573 239T1536 228T1478 204Q1334 134 1260 -12Q1256 -21 1253 -22T1238 -24Q1218 -24 1218 -17Q1218 -13 1223 0Q1258 69 1309 123L1319 133H70Q56 140 56 153Q56 168 72 173H1363L1373 181Q1412 211 1490 250Q1489 251 1472 259T1427 283T1373 319L1363 327H710L707 328L390 327H72Q56 332 56 347Q56 360 70 367H1319L1309 377Q1276 412 1247 458T1218 514",
  10234: "1438 514Q1438 525 1454 525Q1459 525 1462 525T1467 525T1471 524T1473 523T1475 520T1477 517T1480 512Q1517 438 1578 381T1689 300T1785 263Q1802 258 1802 250T1793 239T1756 228T1698 204Q1554 134 1480 -12Q1476 -21 1473 -22T1458 -24Q1438 -24 1438 -17Q1438 -13 1443 0Q1478 69 1529 123L1539 133H318L328 123Q379 69 414 0Q419 -13 419 -17Q419 -24 399 -24Q388 -24 385 -23T377 -12Q332 77 253 144T72 237Q62 240 59 242T56 250T59 257T70 262T89 268T119 278T160 296Q303 366 377 512Q382 522 385 523T401 525Q419 524 419 515Q419 510 414 500Q379 431 328 377L318 367H1539L1529 377Q1496 412 1467 458T1438 514ZM274 173H1583L1593 181Q1632 211 1710 250Q1709 251 1692 259T1647 283T1593 319L1583 327H930L927 328L602 327H274L264 319Q225 289 147 250Q148 249 165 241T210 217T264 181L274 173",
  10236: "95 155V109Q95 83 92 73T75 63Q61 63 58 74T54 130Q54 140 54 180T55 250Q55 421 57 425Q61 437 75 437Q88 437 91 428T95 393V345V270H1444Q1328 357 1301 493Q1301 494 1301 496T1300 499Q1300 511 1317 511H1320Q1329 511 1332 510T1338 506T1341 497T1344 481T1352 456Q1374 389 1425 336T1544 261Q1553 258 1553 250Q1553 244 1548 241T1524 231T1486 212Q1445 186 1415 152T1370 85T1349 35T1341 4Q1339 -6 1336 -8T1320 -11Q1300 -11 1300 0Q1300 7 1305 25Q1337 151 1444 230H95V155",
  10731: "318 709Q325 716 332 716Q340 716 344 713T474 511Q611 298 611 292Q611 285 526 152Q494 103 474 72Q347 -128 344 -130Q340 -132 333 -132T322 -130Q319 -128 257 -31T131 169T60 278Q56 285 56 292Q56 298 60 305Q73 326 194 516T318 709",
  10744: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215",
  10752: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM555 -165Q672 -165 767 -108T916 44T970 250Q970 418 861 532T600 664Q591 665 548 665Q446 665 353 614T200 466T140 250V243Q140 88 248 -30Q262 -46 280 -62T338 -105T434 -148T555 -165ZM478 250Q478 288 503 307T551 326Q586 326 609 305T632 250Q632 217 610 196T555 174T500 196T478 250",
  10753: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM513 478Q513 664 512 664Q504 664 481 660T406 637T313 588Q281 564 255 537T211 483T181 431T161 382T150 342T144 310T141 292H513V478ZM798 588Q758 616 711 634T639 658T602 663L597 664V292H969Q969 293 967 309T960 341T949 381T930 430T900 482T856 537T798 588ZM513 -164V208H141Q142 205 144 189T149 160T158 125T173 83T196 39T229 -9Q249 -34 273 -55T318 -92T363 -119T405 -138T444 -150T475 -158T499 -162T513 -164ZM775 -103Q801 -87 823 -68T863 -30T894 10T919 49T937 88T950 123T959 154T964 180T968 198L969 208H597V-164Q599 -163 616 -161T647 -155T683 -145T728 -128T775 -103",
  10754: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM600 664Q591 665 548 665Q414 665 306 583L292 573L423 441L555 310L687 441L818 573L804 583Q714 650 600 664ZM364 118L495 250L364 382L232 513L223 500Q140 391 140 250Q140 107 223 0L232 -13L364 118ZM970 250Q970 389 887 501L878 512Q878 513 861 496T812 447T746 381L615 250L746 118L878 -13L887 0Q970 109 970 250ZM687 59L555 190L423 59L292 -73L306 -83Q416 -166 555 -166T804 -83L818 -73L687 59",
  10756: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750ZM223 276Q223 282 224 287T227 296T232 302T238 308T243 313T250 316L254 319H374V376V406Q374 438 382 454T418 470Q443 467 450 453T458 410V376V319H579Q580 319 583 317T589 313T594 308T600 302T604 295T608 287T609 276Q609 253 587 241Q577 235 513 235H458V178Q458 176 458 166T459 148Q459 84 415 84Q401 84 390 93T375 117Q374 120 374 178V235H319Q317 235 307 235T290 234Q223 234 223 276",
  10758: "777 -217Q766 -244 745 -249H88Q64 -242 57 -220Q55 -214 55 250T57 720Q60 734 70 740Q80 750 96 750Q127 750 137 720Q139 714 139 274V-166H693V274Q693 714 695 720Q705 749 735 749Q766 749 775 719Q777 713 777 248V-217",
  10799: "630 29Q630 9 609 9Q604 9 587 25T493 118L389 222L284 117Q178 13 175 11Q171 9 168 9Q160 9 154 15T147 29Q147 36 161 51T255 146L359 250L255 354Q174 435 161 449T147 471Q147 480 153 485T168 490Q173 490 175 489Q178 487 284 383L389 278L493 382Q570 459 587 475T609 491Q630 491 630 471Q630 464 620 453T522 355L418 250L522 145Q606 61 618 48T630 29",
  10815: "28 660Q28 676 31 679T46 683H50Q87 681 182 681Q217 681 247 681T294 682T315 682Q321 682 323 682T328 679T331 673T332 660Q332 643 328 640T304 637Q239 637 231 626Q229 620 229 334V46H520V334Q520 620 518 626Q510 637 445 637Q426 637 422 640T417 660Q417 675 420 678T432 682H435Q437 682 467 682T569 681T671 681T703 682Q714 682 717 679T721 660Q721 643 717 640T693 637Q628 637 620 626Q619 623 619 342Q619 60 620 57Q628 46 693 46Q714 46 717 43T721 23Q721 5 715 1Q713 0 374 0Q36 0 34 1Q28 5 28 23Q28 40 31 43T56 46Q121 46 129 57Q131 63 131 342Q131 620 129 626Q121 637 56 637Q35 637 32 640T28 660",
  10846: "55 795Q56 806 70 813H540Q554 806 555 795Q555 791 554 788T552 783T549 779T546 777T542 775T539 773H71Q70 773 68 774T65 776T61 779T58 783T56 788T55 795ZM55 601Q56 612 70 619H540Q554 612 555 601Q555 597 554 594T552 589T549 585T546 583T542 581T539 579H71Q70 579 68 580T65 582T61 585T58 589T56 594T55 601ZM75 -97Q67 -97 61 -91T55 -81Q55 -71 169 166T285 410Q295 425 305 425Q311 425 316 422T323 414L325 410Q327 404 441 167T555 -81Q555 -85 549 -91T535 -97T520 -90Q519 -89 506 -61T463 27T411 136L305 358L199 136Q167 71 129 -10Q98 -75 92 -86T75 -97",
  10877: "674 636Q682 636 688 630T694 615T687 601Q686 600 417 472L151 346L399 228Q687 92 691 87Q694 81 694 76Q694 58 676 56H670L382 192Q92 329 90 331Q83 336 83 348Q84 359 96 365Q104 369 382 500T665 634Q669 636 674 636ZM94 170Q102 172 104 172Q110 171 254 103T535 -30T678 -98Q694 -106 694 -118Q694 -136 676 -138H670L382 -2Q92 135 90 137Q83 142 83 154Q84 164 94 170",
  10878: "83 616Q83 624 89 630T99 636Q107 636 253 568T543 431T687 361Q694 356 694 346T687 331Q685 329 395 192L107 56H101Q83 58 83 76Q83 77 83 79Q82 86 98 95Q117 105 248 167Q326 204 378 228L626 346L360 472Q291 505 200 548Q112 589 98 597T83 616ZM674 172Q692 172 694 154Q694 142 687 137Q685 135 395 -2L107 -138H101Q83 -136 83 -118Q83 -106 96 -100Q100 -98 380 35T665 170T674 172",
  10885: "667 761Q669 762 673 762Q682 762 688 756T694 741Q694 731 687 727Q684 724 420 613L156 502L416 392Q476 367 544 338T647 295T682 280Q694 274 694 262Q694 244 676 242Q670 242 524 303T235 425T90 487Q83 493 83 501Q83 514 94 519Q97 520 378 639T667 761ZM55 -23Q55 43 103 90T223 138Q265 138 316 114Q342 100 393 68L443 36Q502 0 554 0Q609 0 650 32T694 109Q694 138 708 138Q710 138 713 136T719 127T722 108Q722 37 673 -9T557 -56Q514 -56 468 -35T387 13T308 60T223 82Q167 82 127 50T83 -27Q81 -56 69 -56Q55 -56 55 -23ZM55 -257Q55 -191 103 -144T223 -96Q265 -96 316 -120Q342 -134 393 -166L443 -198Q502 -234 554 -234Q609 -234 650 -202T694 -125Q694 -96 708 -96Q710 -96 713 -98T719 -107T722 -126Q722 -197 673 -243T557 -290Q514 -290 468 -269T387 -221T308 -174T223 -152Q167 -152 127 -184T83 -261Q80 -290 69 -290Q55 -290 55 -257",
  10886: "90 727Q83 734 83 743Q83 751 89 756T104 762Q111 760 396 641Q686 518 687 517Q694 512 694 502T687 487Q686 486 543 425T253 303T101 242Q83 244 83 262Q83 274 95 280Q96 280 130 294T232 338T361 392L621 502L357 613Q93 724 90 727ZM55 -23Q55 43 103 90T223 138Q265 138 316 114Q342 100 393 68L443 36Q502 0 554 0Q609 0 650 32T694 109Q694 138 708 138Q710 138 713 136T719 127T722 108Q722 37 673 -9T557 -56Q514 -56 468 -35T387 13T308 60T223 82Q167 82 127 50T83 -27Q81 -56 69 -56Q55 -56 55 -23ZM55 -257Q55 -191 103 -144T223 -96Q265 -96 316 -120Q342 -134 393 -166L443 -198Q502 -234 554 -234Q609 -234 650 -202T694 -125Q694 -96 708 -96Q710 -96 713 -98T719 -107T722 -126Q722 -197 673 -243T557 -290Q514 -290 468 -269T387 -221T308 -174T223 -152Q167 -152 127 -184T83 -261Q80 -290 69 -290Q55 -290 55 -257",
  10887: "380 497Q445 528 522 564T636 618T673 635Q680 635 686 628T693 615T689 603Q686 599 418 472L151 343L418 215Q686 88 689 83Q693 79 693 72T687 59T675 52Q669 52 381 189T86 332Q82 337 82 344Q82 350 86 355Q91 359 380 497ZM82 -130T82 -124T95 -103H380L431 -54Q476 -6 486 -6Q491 -6 498 -12T505 -27Q505 -28 505 -29T504 -32Q503 -33 498 -38T485 -53T469 -70L438 -103H680Q682 -106 686 -110T691 -116T693 -123Q693 -130 680 -143H398L346 -192Q300 -241 291 -241Q271 -241 271 -221Q271 -209 306 -179L340 -143H95Q82 -130 82 -124",
  10888: "82 614Q82 620 86 625T94 632T100 635Q106 635 394 498T689 355Q693 349 693 343Q693 338 689 332Q683 327 395 190T100 52Q95 52 89 58T82 72Q82 80 95 88Q114 99 358 215L624 343L358 472Q89 599 86 603Q82 607 82 614ZM82 -130T82 -124T95 -103H380L431 -54Q476 -6 486 -6Q491 -6 498 -12T505 -27Q505 -28 505 -29T504 -32Q503 -33 498 -38T485 -53T469 -70L438 -103H680Q682 -106 686 -110T691 -116T693 -123Q693 -130 680 -143H398L346 -192Q300 -241 291 -241Q271 -241 271 -221Q271 -209 306 -179L340 -143H95Q82 -130 82 -124",
  10889: "86 512Q93 518 381 639T673 761Q680 761 686 755T693 741Q693 733 688 730Q685 723 419 612L155 501L419 390Q685 277 688 272Q693 269 693 261Q693 254 687 248T675 241Q669 241 381 362T86 490Q74 500 86 512ZM70 -59Q57 -59 57 -24Q57 40 104 87Q116 102 146 118Q186 136 231 136Q232 136 242 135T258 133T276 128T302 118T334 101T377 74Q386 69 396 63T411 53T417 50Q435 87 453 134Q491 223 495 227Q498 230 505 230Q513 230 519 225T526 212Q526 203 491 118T453 30Q453 22 489 10T553 -3Q589 -3 622 14Q653 28 669 50T688 90T694 122T706 136Q718 136 718 114Q718 113 718 109T717 103Q717 31 668 -14T554 -60Q529 -60 499 -50T451 -32T433 -24Q431 -24 404 -90T375 -157Q375 -159 402 -178T473 -218T553 -239Q599 -239 641 -211T691 -130Q694 -99 706 -99T718 -122Q718 -123 718 -127T717 -133Q717 -204 668 -249T559 -295Q512 -295 470 -275T355 -206L322 -290Q313 -310 304 -332T289 -367T282 -382Q277 -387 270 -387Q262 -387 255 -382T248 -368Q248 -361 322 -186Q311 -177 280 -166T222 -155Q189 -155 153 -173Q122 -186 106 -208T87 -248T82 -280T71 -294Q57 -294 57 -259Q57 -195 104 -148Q122 -126 155 -113T220 -99Q245 -99 276 -109T324 -127T342 -135Q397 -2 397 1Q386 10 367 23T302 58T222 80Q175 80 132 52T84 -28Q82 -59 70 -59",
  10890: "86 730Q81 734 81 740Q81 747 88 754T99 761Q103 761 392 640T688 512Q693 509 693 501T688 490Q682 484 394 363T99 241Q94 241 88 248T82 261Q82 268 86 272Q89 277 355 390L619 501L355 612Q89 723 86 730ZM70 -59Q57 -59 57 -24Q57 40 104 87Q116 102 146 118Q186 136 231 136Q232 136 242 135T258 133T276 128T302 118T334 101T377 74Q386 69 396 63T411 53T417 50Q435 87 453 134Q491 223 495 227Q498 230 505 230Q513 230 519 225T526 212Q526 203 491 118T453 30Q453 22 489 10T553 -3Q589 -3 622 14Q653 28 669 50T688 90T694 122T706 136Q718 136 718 114Q718 113 718 109T717 103Q717 31 668 -14T554 -60Q529 -60 499 -50T451 -32T433 -24Q431 -24 404 -90T375 -157Q375 -159 402 -178T473 -218T553 -239Q599 -239 641 -211T691 -130Q694 -99 706 -99T718 -122Q718 -123 718 -127T717 -133Q717 -204 668 -249T559 -295Q512 -295 470 -275T355 -206L322 -290Q313 -310 304 -332T289 -367T282 -382Q277 -387 270 -387Q262 -387 255 -382T248 -368Q248 -361 322 -186Q311 -177 280 -166T222 -155Q189 -155 153 -173Q122 -186 106 -208T87 -248T82 -280T71 -294Q57 -294 57 -259Q57 -195 104 -148Q122 -126 155 -113T220 -99Q245 -99 276 -109T324 -127T342 -135Q397 -2 397 1Q386 10 367 23T302 58T222 80Q175 80 132 52T84 -28Q82 -59 70 -59",
  10891: "674 1003Q681 1003 687 999T694 983Q694 973 683 967Q669 959 420 868L162 772L422 676Q683 579 685 577Q694 571 694 560Q694 550 687 546T673 541Q669 542 384 647T93 755Q83 760 83 772Q83 783 91 788Q98 791 383 897T674 1003ZM84 354T84 367T98 387H679Q694 379 694 367Q694 354 679 347H98Q84 354 84 367ZM84 160T84 173T98 193H679Q694 185 694 173Q694 160 679 153H98Q84 160 84 173ZM94 -3Q102 -1 104 -1Q107 -2 392 -107T684 -215Q694 -219 694 -232Q694 -241 687 -247Q686 -248 395 -357Q106 -463 101 -463Q83 -461 83 -443Q83 -431 94 -426Q97 -423 357 -328L615 -232L355 -136Q94 -39 92 -37Q83 -31 83 -21Q83 -9 94 -3",
  10892: "104 541Q98 541 91 545T83 560Q83 571 92 577Q94 579 355 676L615 772L357 868Q108 959 94 967Q83 973 83 983Q83 989 87 996T104 1003Q109 1002 396 896T687 787Q694 781 694 772Q694 759 684 755Q678 752 393 647T104 541ZM84 367Q84 380 98 387H679Q694 379 694 367Q694 356 680 348L390 347H100Q84 352 84 367ZM84 173Q84 188 100 193H680Q694 183 694 173Q694 160 679 153H98Q84 160 84 173ZM674 -1Q682 -1 688 -6T694 -20Q694 -31 685 -37Q683 -39 422 -136L162 -232L420 -328Q680 -423 683 -426Q694 -431 694 -443Q694 -461 676 -463Q671 -463 382 -357Q91 -248 90 -247Q83 -242 83 -232Q83 -220 93 -215Q667 -1 674 -1",
  10901: "674 636Q682 636 688 631T694 616Q694 605 687 601Q685 599 395 462L107 326H101Q83 328 83 345Q83 358 96 365Q102 367 382 500T665 634Q671 636 674 636ZM674 442Q692 442 694 424Q694 412 687 407Q686 406 417 278L151 152L399 34Q687 -102 691 -107Q694 -113 694 -118Q694 -136 676 -138H670L382 -2Q92 135 90 137Q83 142 83 154Q84 165 96 171Q104 175 382 306T665 440Q669 442 674 442",
  10902: "83 616Q83 624 89 630T99 636Q107 636 253 568T543 431T687 361Q694 354 694 346Q694 328 676 326H670L382 462Q317 493 226 535Q119 585 101 595T83 616ZM94 440Q102 442 104 442Q110 441 254 373T535 240T678 172Q679 172 680 171Q694 164 694 153T687 137Q685 135 395 -2L107 -138H101Q83 -136 83 -118Q83 -106 93 -101L128 -84Q163 -68 230 -36T361 26L626 152L360 278Q91 406 90 407Q83 412 83 424Q84 434 94 440",
  10927: "84 346Q84 359 91 363T117 367Q120 367 126 367T137 366Q388 370 512 430T653 609Q657 636 676 636Q685 635 689 629T694 618V612Q689 566 672 528T626 463T569 417T500 383T435 362T373 346Q379 345 404 339T440 330T477 318T533 296Q592 266 630 223T681 145T694 78Q694 57 674 57Q662 57 657 67T652 92T640 135T606 191Q500 320 137 326H114Q104 326 98 327T88 332T84 346ZM84 -131T84 -118T98 -98H679Q694 -106 694 -118T679 -138H98Q84 -131 84 -118",
  10928: "84 614Q84 636 102 636Q115 636 119 626T125 600T137 556T171 501Q277 372 640 366H661Q694 366 694 346T661 326H640Q578 325 526 321T415 307T309 280T222 237T156 172T124 83Q122 66 118 62T103 57Q100 57 98 57T95 58T93 59T90 62T85 67Q83 71 83 80Q88 126 105 164T151 229T208 275T277 309T342 330T404 346Q401 347 380 351T345 360T302 373T245 396Q125 455 92 565Q84 599 84 614ZM84 -131T84 -118T98 -98H679Q694 -106 694 -118T679 -138H98Q84 -131 84 -118",
  10933: "653 734Q653 738 660 745T673 752T686 745T693 723Q672 555 466 485Q390 463 378 463Q373 463 373 461Q373 458 378 458Q390 458 466 436Q562 404 620 350Q682 283 693 198Q693 183 686 176Q681 170 674 170T660 176T653 187Q653 192 652 200T646 228T631 265T602 307T555 350Q435 431 151 441H95Q82 454 82 460T95 481H151Q165 482 197 483T238 485Q427 500 528 554T649 707Q653 729 653 734ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
  10934: "693 466T693 460T680 441H624Q608 439 577 438T538 436Q349 421 248 367T126 214Q122 192 122 187Q122 183 116 177T102 170Q95 170 89 176Q82 183 82 198Q93 283 155 350Q213 404 309 436Q385 458 398 458Q402 458 402 461Q402 463 398 463Q385 463 309 485Q103 555 82 723Q82 738 89 745T102 752T115 745T122 734Q122 721 126 701T155 640T220 572Q340 490 624 481H680Q693 466 693 460ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
  10935: "82 494T82 501T95 521H171Q405 527 511 569Q630 618 651 732Q652 734 653 740T655 748T658 754T663 759T672 761L686 754Q693 747 693 734Q684 668 648 623Q627 591 573 557T442 507L417 501Q428 496 442 494Q520 478 573 444T648 378Q684 333 693 267Q693 254 686 247Q673 234 659 245Q657 247 651 269Q630 383 511 432Q406 474 171 481H95Q82 494 82 501ZM70 -59Q57 -59 57 -26Q57 30 90 73T177 132Q191 136 226 136Q228 136 239 136T253 135T267 132T287 125T311 113T346 95T391 67Q462 20 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 704 136Q717 136 717 115V105Q717 39 671 -9T554 -58Q518 -58 481 -43T382 14Q302 63 273 74Q255 78 222 78Q188 78 173 74Q90 46 84 -28Q82 -59 70 -59ZM71 -294Q57 -294 57 -262Q57 -205 90 -162T177 -104Q191 -99 226 -99Q266 -103 277 -106Q310 -119 391 -168Q455 -212 502 -231Q519 -235 553 -235Q586 -235 602 -231Q640 -218 661 -195T686 -151T693 -115T704 -99Q717 -99 717 -121V-131Q717 -198 671 -246T556 -294Q519 -294 482 -279T382 -222Q307 -175 273 -162Q255 -157 222 -157Q188 -157 173 -162Q133 -175 110 -201T84 -264Q82 -294 71 -294",
  10936: "693 501Q693 493 679 481H604Q369 474 264 432Q143 382 124 269Q116 246 115 245Q101 234 88 247Q82 254 82 267Q89 329 126 378Q147 410 201 444T333 494L357 501Q354 502 340 505T318 510T295 516T269 525T243 535T215 548T188 565Q142 599 126 623Q89 672 82 734Q82 761 102 761L115 756Q116 755 124 732Q143 619 264 569Q371 527 604 521H679Q693 507 693 501ZM70 -59Q57 -59 57 -26Q57 30 90 73T177 132Q191 136 226 136Q228 136 239 136T253 135T267 132T287 125T311 113T346 95T391 67Q462 20 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 704 136Q717 136 717 115V105Q717 39 671 -9T554 -58Q518 -58 481 -43T382 14Q302 63 273 74Q255 78 222 78Q188 78 173 74Q90 46 84 -28Q82 -59 70 -59ZM71 -294Q57 -294 57 -262Q57 -205 90 -162T177 -104Q191 -99 226 -99Q266 -103 277 -106Q310 -119 391 -168Q455 -212 502 -231Q519 -235 553 -235Q586 -235 602 -231Q640 -218 661 -195T686 -151T693 -115T704 -99Q717 -99 717 -121V-131Q717 -198 671 -246T556 -294Q519 -294 482 -279T382 -222Q307 -175 273 -162Q255 -157 222 -157Q188 -157 173 -162Q133 -175 110 -201T84 -264Q82 -294 71 -294",
  10937: "82 494T82 501T95 521H171Q256 523 317 528T441 548T543 584T613 644T651 732Q652 734 653 740T655 748T658 754T663 759T672 761L686 754Q693 747 693 734Q686 686 664 647T615 586T548 545T482 518T417 501Q419 500 451 493T517 471T590 434T657 367T693 267Q693 241 673 241Q664 241 659 245Q656 249 650 273T635 323T593 380T511 432Q406 474 171 481H95Q82 494 82 501ZM57 -26Q57 39 101 87T219 136Q254 136 277 130Q320 114 382 72Q419 50 424 45Q426 45 459 110Q496 178 497 179Q500 180 504 180Q509 180 517 175T526 161Q526 158 495 90L462 25Q462 21 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 706 136T718 115Q718 114 718 111T717 105Q717 39 671 -9T554 -58L459 -33Q450 -29 444 -27T437 -26L371 -155L391 -168Q485 -235 538 -235H553Q586 -235 602 -230Q683 -204 691 -128Q694 -99 706 -99T718 -120Q718 -121 718 -124T717 -130Q717 -199 670 -246T557 -294T393 -228Q353 -205 351 -201Q348 -201 315 -266Q294 -310 285 -323T268 -337Q259 -337 254 -331T248 -317Q248 -305 282 -246L313 -181Q313 -177 273 -161Q255 -157 222 -157Q188 -157 173 -161Q134 -174 113 -198T88 -242T82 -278T71 -294Q57 -294 57 -261Q57 -204 91 -161T179 -104Q195 -99 228 -99Q274 -102 315 -124Q337 -132 337 -130L404 -1L384 12Q319 58 273 74Q255 79 222 79Q188 79 173 74Q133 61 112 37T88 -7T82 -43T70 -59Q57 -59 57 -26",
  10938: "693 501Q693 493 679 481H604Q548 479 509 477T418 469T331 454T257 429T194 392T150 340T124 270Q117 247 115 245Q101 236 88 247Q82 254 82 267Q89 330 126 379Q147 411 202 444T333 494L357 501Q239 531 188 565Q142 599 126 623Q89 672 82 734Q82 761 102 761L115 756Q116 755 124 732Q133 678 166 640T241 579T349 544T470 527T604 521H679Q693 507 693 501ZM57 -26Q57 39 101 87T219 136Q254 136 277 130Q320 114 382 72Q419 50 424 45Q426 45 459 110Q496 178 497 179Q500 180 504 180Q509 180 517 175T526 161Q526 158 495 90L462 25Q462 21 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 706 136T718 115Q718 114 718 111T717 105Q717 39 671 -9T554 -58L459 -33Q450 -29 444 -27T437 -26L371 -155L391 -168Q485 -235 538 -235H553Q586 -235 602 -230Q683 -204 691 -128Q694 -99 706 -99T718 -120Q718 -121 718 -124T717 -130Q717 -199 670 -246T557 -294T393 -228Q353 -205 351 -201Q348 -201 315 -266Q294 -310 285 -323T268 -337Q259 -337 254 -331T248 -317Q248 -305 282 -246L313 -181Q313 -177 273 -161Q255 -157 222 -157Q188 -157 173 -161Q134 -174 113 -198T88 -242T82 -278T71 -294Q57 -294 57 -261Q57 -204 91 -161T179 -104Q195 -99 228 -99Q274 -102 315 -124Q337 -132 337 -130L404 -1L384 12Q319 58 273 74Q255 79 222 79Q188 79 173 74Q133 61 112 37T88 -7T82 -43T70 -59Q57 -59 57 -26",
  10949: "84 463Q84 585 166 663T360 752Q361 752 370 752T395 752T430 752T475 753T524 753H679Q694 746 694 733Q694 724 681 714L522 713H470H441Q366 713 338 709T266 685Q244 674 224 659T179 617T139 550T124 463V458Q124 370 185 302Q244 238 328 220Q348 215 366 215T522 213H681Q694 203 694 193Q694 180 679 173H526Q510 173 480 173T434 172Q350 172 289 188T172 258Q84 340 84 463ZM84 -14T84 -1T98 19H679Q694 11 694 -1Q694 -14 679 -21H98Q84 -14 84 -1ZM84 -208T84 -195T98 -175H679Q694 -183 694 -195Q694 -208 679 -215H98Q84 -208 84 -195",
  10950: "83 733Q83 746 98 753H251Q267 753 297 753T343 754Q427 754 488 738T605 668Q693 587 693 463Q693 378 650 312T545 213T415 174Q407 173 251 173H98Q83 180 83 193Q83 203 96 213H255H308H337Q412 213 439 217T512 241Q533 252 553 267T599 309T639 376T654 463Q654 554 592 624Q557 662 512 685Q468 704 439 708T335 713H306H255L96 714Q83 724 83 733ZM84 -14T84 -1T98 19H679Q694 11 694 -1Q694 -14 679 -21H98Q84 -14 84 -1ZM84 -208T84 -195T98 -175H679Q694 -183 694 -195Q694 -208 679 -215H98Q84 -208 84 -195",
  10955: "693 221Q693 214 680 201H524Q398 201 367 202T309 212Q236 230 180 280T98 398Q84 438 84 492T98 585Q126 663 193 716T346 781Q347 781 373 781T440 782T520 783H680Q682 780 686 776T691 770T693 763T680 743H526Q364 743 353 741Q279 730 221 687T138 578Q124 540 124 492T138 405Q163 340 221 297T353 243Q364 241 526 241H680Q682 238 686 234T691 228T693 221ZM82 -48T82 -41T95 -19H462L513 41L569 105Q574 110 582 110T596 104T602 90Q602 87 600 83Q600 77 555 30L515 -17L600 -19H682Q693 -30 693 -38T680 -59H480L415 -137L349 -213L515 -215H682Q693 -226 693 -233T680 -255H313L260 -317Q224 -360 212 -372T192 -385Q184 -385 179 -377T173 -362Q174 -361 218 -306L260 -255H178L93 -253L86 -248Q82 -243 82 -235Q82 -226 93 -215H195L295 -213L362 -137L426 -59H260L93 -57L86 -53Q82 -48 82 -41",
  10956: "82 759T82 763T83 769T89 776T95 783H251Q378 783 409 782T469 772Q540 753 596 703T678 585Q691 546 691 492T678 398Q649 320 581 267T426 203Q415 201 251 201H95Q82 214 82 221Q82 225 83 227T89 234T95 241H249Q411 241 422 243Q496 253 554 296T638 405Q651 444 651 492Q651 539 638 578Q613 643 555 686T422 741Q411 743 249 743H95Q82 759 82 763ZM82 -48T82 -41T95 -19H462L513 41L569 105Q574 110 582 110T596 104T602 90Q602 87 600 83Q600 77 555 30L515 -17L600 -19H682Q693 -30 693 -38T680 -59H480L415 -137L349 -213L515 -215H682Q693 -226 693 -233T680 -255H313L260 -317Q224 -360 212 -372T192 -385Q184 -385 179 -377T173 -362Q174 -361 218 -306L260 -255H178L93 -253L86 -248Q82 -243 82 -235Q82 -226 93 -215H195L295 -213L362 -137L426 -59H260L93 -57L86 -53Q82 -48 82 -41",
  12296: "333 -232Q332 -239 327 -244T313 -250Q303 -250 296 -240Q293 -233 202 6T110 250T201 494T296 740Q299 745 306 749L309 750Q312 750 313 750Q331 750 333 732Q333 727 243 489Q152 252 152 250T243 11Q333 -227 333 -232",
  12297: "55 732Q56 739 61 744T75 750Q85 750 92 740Q95 733 186 494T278 250T187 6T92 -240Q85 -250 75 -250Q67 -250 62 -245T55 -232Q55 -227 145 11Q236 248 236 250T145 489Q55 727 55 732",
  57350: "91 417Q104 430 111 430T131 417V301L171 341Q201 373 207 378T220 384Q227 384 233 377T240 366Q240 357 187 299L131 244V-10Q116 -23 111 -23T91 -10V201L49 157Q20 127 14 121T0 115Q-8 115 -14 121T-20 132Q-20 139 17 178Q29 191 36 199L91 257V417",
  57351: "56 417Q68 431 76 431L89 426L96 419V317L98 215L193 273L291 330V375L293 419Q301 431 311 431Q331 431 331 388L333 355L356 370Q381 384 388 384Q394 384 400 377T407 363Q407 354 367 328L331 308V-10Q316 -23 310 -23Q300 -23 293 -12L291 135V284L98 168L96 77V-12Q84 -24 76 -24L62 -19L58 -12L56 66V144L31 128Q5 114 -2 114Q-8 114 -14 121T-20 136Q-20 142 -14 147T20 170L56 190V417",
  57352: "477 261Q477 257 473 256T455 253T417 251T348 250H235L155 -77L146 -82Q137 -85 109 -85Q55 -85 55 -77L139 261Q224 596 226 598Q229 603 239 603Q240 603 254 603T290 603T341 604T405 605T477 605Q656 603 687 602T719 596Q719 589 692 588T513 585H319L282 427L242 272Q242 270 351 270Q388 270 410 270T444 269T460 267T469 265T477 261",
  57353: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
  57356: "86 472Q93 477 381 614T673 752Q680 752 686 746T693 732T689 721Q686 715 418 590L151 461L418 332Q684 207 689 201Q693 195 693 190Q693 183 687 177T675 170Q668 170 380 307T86 450Q82 454 82 461Q82 467 86 472ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
  57357: "89 745Q95 752 100 752Q106 752 394 615T689 472Q693 468 693 461T689 450Q684 445 396 308T100 170Q95 170 89 176T82 190Q82 195 86 201Q91 208 358 332L624 461L358 590Q90 715 86 721Q82 725 82 731Q82 739 89 745ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
  57358: "97 172Q82 172 82 190Q82 197 86 201Q94 209 173 246T327 319T402 357Q405 360 434 448T462 539L278 628Q96 713 86 721Q82 725 82 732T88 745T102 752Q103 752 125 742T198 709T293 666Q342 642 385 622T453 590T478 579Q479 579 506 659T562 824T598 915Q602 919 609 919T622 913T629 901Q629 898 571 728Q546 656 531 608T518 559Q555 539 602 519Q664 488 679 479T694 461Q694 457 689 450Q680 443 616 413T494 356T435 326L389 190L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34Q82 44 93 55H198L300 57L342 179Q350 204 361 238T378 286T382 301L246 237Q111 172 97 172ZM624 461Q621 464 560 492Q512 518 503 518Q500 518 500 517Q499 513 488 479T465 413T453 379L624 461",
  57359: "97 54Q82 54 82 72Q82 79 86 84Q95 91 222 153L351 215L398 324L442 433L258 519Q95 597 87 604Q82 608 82 615T88 628T102 635Q107 635 424 484L458 468L524 630Q593 789 597 795Q601 801 609 801Q616 801 622 795T629 781L562 615L493 450L589 406Q665 371 679 362T694 344Q694 339 693 337T677 326T631 302T538 257Q504 241 465 223T406 195T386 186Q383 185 344 92T306 -3L486 81Q662 168 673 168Q680 168 686 162T693 148T689 137Q688 136 482 35L280 -59L233 -176Q184 -291 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -279 185 -186T224 -90Q225 -88 223 -88Q219 -88 193 -101Q109 -143 98 -143Q82 -138 82 -122Q82 -116 85 -113T108 -98T171 -67L249 -30L289 61Q297 81 307 107T321 144T326 157L218 106Q109 54 97 54ZM553 379Q480 412 480 415Q479 415 460 372T423 285T406 241Q408 240 516 291T624 344L553 379",
  57360: "102 168Q103 168 151 146T247 102T295 81Q299 85 322 144T344 206L218 268Q153 297 123 313T87 333T82 344T86 355Q104 369 291 455Q491 552 491 553L542 673Q581 767 590 784T609 801Q616 801 622 795T629 781Q629 773 586 677Q546 581 546 577L609 606Q669 635 673 635Q680 635 686 629T693 615Q693 610 692 608T670 593T604 561L524 521L400 226L542 157Q617 123 649 107T687 85T694 72Q694 66 690 60T679 54Q665 54 526 119Q394 186 386 186Q385 186 342 88L331 61L509 -23Q680 -105 688 -111Q693 -115 693 -122T688 -135T675 -141H673Q664 -141 491 -59Q320 21 316 21H315L249 -136Q183 -293 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 154 -261T181 -197T213 -119L280 41Q280 46 186 86Q157 101 121 119Q92 133 87 136T82 148Q82 155 88 161T102 168ZM418 370L466 495Q464 495 308 420T151 344T204 317T311 267T364 244Q364 247 418 370",
  57361: "82 34Q82 44 93 55H198L300 57L342 179Q351 207 362 238T378 286T384 303T238 377Q109 435 86 450Q82 454 82 460T86 472Q90 476 302 579L511 679Q512 679 553 795Q569 842 577 866T592 903T600 917T608 919Q615 919 622 912T629 901Q629 899 595 799Q589 777 581 753T569 717T564 703L618 728Q666 752 673 752T686 746T693 732Q693 723 683 717T615 683L546 650L491 488Q464 410 450 368T438 326Q493 297 562 266Q660 219 677 209T694 190Q694 183 690 177T678 171Q664 171 546 228L424 286Q422 286 382 172L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34ZM495 623Q495 626 493 626T321 544T151 461L398 343Q399 343 405 360T423 415T446 483Q457 513 469 551T488 606T495 623",
  57366: "82 -6Q82 1 95 14H262L295 94Q331 171 331 174Q324 175 312 178T267 194T206 227T146 283T98 368Q84 406 84 461T98 554Q126 632 194 685T349 750Q360 752 480 752H591L604 783Q620 819 624 821Q631 828 640 828Q653 825 658 810Q658 808 646 781L635 754Q635 752 658 752Q680 752 686 746Q693 739 693 732Q693 728 692 726T686 719T680 712H615L506 466Q479 407 451 344T408 248T393 214Q393 210 535 210H680Q693 194 693 190T680 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6ZM571 710Q571 712 469 712Q443 712 416 712T371 711T351 710Q279 700 221 656T138 548Q124 508 124 461T138 374Q186 245 351 212L460 459Q571 709 571 710",
  57367: "82 -14T82 -7T95 15H431L529 170H435Q341 170 333 175Q149 218 98 368Q84 406 84 461Q84 515 98 555Q126 633 193 686T346 750Q347 750 373 750T440 751T520 752H680Q693 739 693 732Q693 727 680 712H526Q364 712 353 710Q268 700 207 646T126 512Q123 496 123 461T126 410Q141 350 180 304T280 232Q312 217 344 214T464 210H555L589 261Q613 301 620 311T635 321Q644 321 650 315T657 301Q657 296 651 286T630 252T604 212Q604 210 642 210H680Q693 197 693 190Q693 186 692 184T686 177T680 170H578L526 92L478 17L580 15H682Q693 4 693 -4T680 -25H451L353 -179L518 -181H682Q694 -193 694 -201Q694 -211 682 -219L504 -221H326L293 -272Q257 -332 246 -332Q238 -332 232 -326T225 -313Q225 -310 226 -308Q226 -305 251 -265T278 -223Q278 -221 186 -221H95Q93 -218 89 -214T84 -208T82 -201T95 -181H306L404 -25H249L93 -23L86 -19Q82 -14 82 -7",
  57368: "82 732Q82 739 95 752H251H348Q420 752 460 744T551 708Q566 697 566 701Q618 815 624 821Q631 828 640 828Q653 825 658 810L600 677Q600 671 615 656T653 605T689 517Q692 496 692 461T689 406Q668 325 615 266Q572 221 513 196T391 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6Q82 1 95 14H262L295 92L331 170H95Q93 172 91 175T87 180T84 185T82 191Q82 199 93 210H220L349 212L549 659Q507 692 462 702T338 712H249H95Q82 727 82 732ZM652 473Q652 513 636 552T603 611T582 632Q581 632 487 422T393 210Q424 210 460 220T535 253T605 316T649 410Q652 427 652 461V473",
  57369: "82 732Q82 739 95 752H251Q415 752 426 750Q539 736 615 657Q667 599 689 517Q692 496 692 461T689 406Q668 325 615 266Q522 170 382 170H355L326 95Q319 80 311 59T298 28T293 17Q293 15 486 15H680Q693 0 693 -6T680 -25H275L213 -179L449 -181H682Q693 -192 693 -199T680 -221H198L178 -270Q153 -333 139 -333Q132 -333 126 -327T119 -314T135 -266T153 -223Q153 -221 124 -221H95Q82 -207 82 -201T95 -181H171L233 -25H162L93 -23L86 -19Q82 -14 82 -7T95 15H251L313 170H202L93 172L86 177Q82 182 82 190Q82 199 93 210H211L329 212L349 261Q366 301 372 311T386 321Q392 321 399 315T407 302Q407 295 390 254T373 210Q374 209 377 209Q412 209 444 217Q512 231 564 273T638 377Q651 414 651 461Q651 509 638 548Q613 613 555 656T422 710Q411 712 249 712H95Q82 727 82 732",
  57370: "693 -115T693 -122T680 -144H315L269 -199Q221 -255 213 -255H212Q203 -255 197 -248T193 -231Q195 -225 229 -184L262 -144H186L113 -142L106 -137Q102 -130 102 -125Q102 -119 115 -104H298L426 52H386Q342 54 309 63Q236 79 180 129T98 249Q84 289 84 343Q84 398 98 436Q126 514 193 567T346 632Q347 632 373 632T440 633T520 634H680Q682 631 686 627T691 621T693 614T680 594H526Q364 594 353 592Q268 581 207 528T126 394Q123 378 123 343T126 292Q141 231 181 185T280 114Q329 92 415 92H462L506 147Q554 203 562 203H563Q572 203 578 196T582 178Q579 173 546 132L513 94L598 92H682Q693 81 693 73T680 52H480L349 -102L515 -104H682Q693 -115 693 -122",
  57371: "82 610T82 614T83 620T89 627T95 634H251Q378 634 409 633T469 623Q540 604 596 554T678 436Q691 397 691 343T678 249Q653 181 597 131T469 63Q427 52 362 52H315L213 -102L438 -104H662Q673 -115 673 -123Q673 -129 660 -144H186L151 -197Q114 -250 109 -253Q106 -254 104 -254Q100 -254 98 -253Q91 -253 87 -248T82 -235Q82 -230 109 -186L138 -144H115Q82 -144 82 -125Q82 -119 95 -104H166L266 49Q266 52 182 52H95Q82 65 82 72Q82 76 83 78T89 85T95 92H295L329 143Q365 195 369 198Q372 203 380 203Q385 203 391 197T398 185Q398 184 398 184L399 182Q399 175 369 129L344 94Q344 92 376 92Q402 92 422 94Q496 104 554 147T638 256Q651 295 651 343Q651 390 638 429Q613 494 555 537T422 592Q411 594 249 594H95Q82 610 82 614",
  119808: "296 0Q278 3 164 3Q58 3 49 0H40V62H92Q144 62 144 64Q388 682 397 689Q403 698 434 698Q463 698 471 689Q475 686 538 530T663 218L724 64Q724 62 776 62H828V0H817Q796 3 658 3Q509 3 485 0H472V62H517Q561 62 561 63L517 175H262L240 120Q218 65 217 64Q217 62 261 62H306V0H296ZM390 237L492 238L440 365Q390 491 388 491Q287 239 287 237H390",
  119809: "720 510Q720 476 704 448T665 404T619 377T580 362L564 359L583 356Q602 353 632 342T690 312Q712 292 725 276Q752 235 752 189V183Q752 160 741 125Q698 18 547 2Q543 1 288 0H39V62H147V624H39V686H264H409Q502 686 542 681T624 655Q720 607 720 510ZM563 513Q563 553 548 578T518 611T486 622Q479 624 385 624H293V382H375Q458 383 467 385Q563 405 563 513ZM590 192Q590 307 505 329Q504 330 503 330L398 331H293V62H391H400H444Q496 62 528 75T580 131Q590 155 590 192",
  119810: "64 343Q64 502 174 599T468 697Q502 697 533 691T586 674T623 655T647 639T657 632L694 663Q703 670 711 677T723 687T730 692T735 695T740 696T746 697Q759 697 762 692T766 668V627V489V449Q766 428 762 424T742 419H732H720Q699 419 697 436Q690 498 657 545Q611 618 532 632Q522 634 496 634Q356 634 286 553Q232 488 232 343T286 133Q355 52 497 52Q597 52 650 112T704 237Q704 248 709 251T729 254H735Q750 254 755 253T763 248T766 234Q766 136 680 63T469 -11Q285 -11 175 86T64 343",
  119811: "39 624V686H270H310H408Q500 686 545 680T638 649Q768 584 805 438Q817 388 817 338Q817 171 702 75Q628 17 515 2Q504 1 270 0H39V62H147V624H39ZM655 337Q655 370 655 390T650 442T639 494T616 540T580 580T526 607T451 623Q443 624 368 624H298V62H377H387H407Q445 62 472 65T540 83T606 129Q629 156 640 195T653 262T655 337",
  119812: "723 286Q721 284 700 145T677 3V0H39V62H147V618H39V680H660V676Q662 670 675 552T691 428V424H629V428Q629 429 627 448T618 494T601 541Q574 593 527 605T382 618H374H304V384H336Q338 384 347 384T361 384T376 386T392 390T407 397T421 407T432 423Q442 444 443 482V501H505V205H443V224Q442 258 435 278T411 307T380 318T336 322H304V62H375H394Q429 62 449 62T497 66T541 76T577 95T609 126T632 170T651 232Q661 287 661 289H723V286",
  119813: "425 0L228 3Q63 3 51 0H39V62H147V618H39V680H644V676Q647 670 659 552T675 428V424H613Q613 433 605 477Q599 511 589 535T562 574T530 599T488 612T441 617T387 618H368H304V371H333Q389 373 411 390T437 468V488H499V192H437V212Q436 244 430 263T408 292T378 305T333 309H304V62H439V0H425",
  119814: "465 -10Q281 -10 173 88T64 343Q64 413 85 471T143 568T217 631T298 670Q371 697 449 697Q452 697 459 697T470 696Q502 696 531 690T582 675T618 658T644 641T656 632L732 695Q734 697 745 697Q758 697 761 692T765 668V627V489V449Q765 428 761 424T741 419H731H724Q705 419 702 422T695 444Q683 520 631 577T495 635Q364 635 295 563Q261 528 247 477T232 343Q232 296 236 260T256 185T296 120T366 76T472 52Q481 51 498 51Q544 51 573 67T607 108Q608 111 608 164V214H464V276H479Q506 273 680 273Q816 273 834 276H845V214H765V113V51Q765 16 763 8T750 0Q742 2 709 16T658 40L648 46Q592 -10 465 -10",
  119815: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V388H595V624H487V686H499Q523 683 673 683Q824 683 848 686H860V624H752V62H860V0H848Q824 3 674 3Q523 3 499 0H487V62H595V326H304V62H412V0H400",
  119816: "397 0Q370 3 218 3Q65 3 38 0H25V62H139V624H25V686H38Q65 683 218 683Q370 683 397 686H410V624H296V62H410V0H397",
  119817: "174 114Q174 96 169 82T159 63T144 47L155 45Q183 40 203 40Q271 40 290 104Q294 118 294 150T295 380V624H154V686H169Q196 683 365 683Q499 683 517 686H527V624H446V379Q446 183 446 153T441 108Q413 32 315 2Q266 -11 208 -11Q160 -11 118 -2T42 37T8 114V122Q8 150 30 174T91 198T152 174T174 122V114",
  119818: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V338L472 483L634 624H565V686H576Q597 683 728 683Q814 683 829 686H836V624H730L614 524Q507 432 497 422Q496 422 498 418T514 395T553 342T627 241L759 63L805 62H852V0H842Q830 3 701 3Q550 3 526 0H513V62H549Q584 62 584 63Q583 65 486 196T388 328L304 256V62H412V0H400",
  119819: "643 285Q641 280 629 148T612 4V0H39V62H147V624H39V686H51Q75 683 228 683Q415 685 425 686H439V624H304V62H352H378Q492 62 539 138Q551 156 558 178T569 214T576 255T581 289H643V285",
  119820: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H305Q316 679 323 667Q330 653 434 414L546 157L658 414Q766 662 773 674Q778 681 788 686H1052V624H944V62H1052V0H1040Q1016 3 874 3T708 0H696V62H804V341L803 618L786 580Q770 543 735 462T671 315Q540 13 536 9Q528 1 507 1Q485 1 477 9Q472 14 408 162T281 457T217 603Q215 603 215 334V62H323V0H314",
  119821: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H171H265Q288 686 297 686T309 684T315 679Q317 676 500 455T684 233V624H576V686H585Q603 683 718 683T851 686H860V624H752V319Q752 15 750 11Q747 4 742 2T718 0H712Q708 0 706 0T700 0T696 1T693 2T690 4T687 7T684 11T679 16T674 23Q671 27 437 311L215 579V62H323V0H314",
  119822: "64 339Q64 431 96 502T182 614T295 675T420 696Q469 696 481 695Q620 680 709 589T798 339Q798 173 697 82T432 -10Q262 -10 163 85T64 339ZM625 454Q618 502 600 538T562 593T515 624T469 639T431 642Q331 642 276 563Q232 493 232 353Q232 315 234 285T244 216T267 148T308 94T372 56Q405 46 432 46Q517 46 567 106T627 267Q631 299 631 353Q631 418 625 454",
  119823: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H253Q435 686 470 685T536 678Q585 668 621 648T675 605T705 557T718 514T721 483T718 451T704 409T673 362T616 322T530 293Q500 288 399 287H304V62H412V0H400ZM553 475Q553 554 537 582T459 622Q451 623 373 624H298V343H372Q457 344 480 350Q527 362 540 390T553 475",
  119824: "64 339Q64 431 96 502T182 614T295 675T420 696Q469 696 481 695Q620 680 709 589T798 339Q798 255 768 184Q720 77 611 26L600 21Q635 -26 682 -26H696Q769 -26 769 0Q769 7 774 12T787 18Q805 18 805 -7V-13Q803 -64 785 -106T737 -171Q720 -183 697 -191Q687 -193 668 -193Q636 -193 613 -182T575 -144T552 -94T532 -27Q531 -23 530 -16T528 -6T526 -3L512 -5Q499 -7 477 -8T431 -10Q393 -10 382 -9Q238 8 151 97T64 339ZM326 80Q326 113 356 138T430 163Q492 163 542 100L553 86Q554 85 561 91T578 108Q637 179 637 330Q637 430 619 498T548 604Q500 641 425 641Q408 641 390 637T347 623T299 590T259 535Q226 469 226 338Q226 244 246 180T318 79L325 74Q326 74 326 80ZM506 58Q480 112 433 112Q412 112 395 104T378 77Q378 44 431 44Q480 44 506 58",
  119825: "394 0Q370 3 222 3Q75 3 51 0H39V62H147V624H39V686H234Q256 686 299 686T362 687Q479 687 554 669T681 593Q716 550 716 497Q716 390 568 338Q569 337 572 336T577 332Q605 317 623 300T650 258T662 218T668 172Q678 98 689 76Q707 40 748 40Q770 40 780 54T795 88T801 111Q805 117 827 117H831Q846 117 852 113T858 92Q857 78 852 63T834 30T797 1T739 -11Q630 -11 580 12T511 87Q506 104 506 168Q506 170 506 178T507 194Q507 289 438 313Q424 318 356 318H298V62H406V0H394ZM366 369Q459 370 490 381Q548 402 548 476V498V517Q548 578 513 600Q479 624 392 624H358H298V369H366",
  119826: "64 493Q64 582 120 636T264 696H272Q280 697 285 697Q380 697 454 645L480 669Q484 672 488 676T495 683T500 688T504 691T508 693T511 695T514 696T517 697T522 697Q536 697 539 691T542 652V577Q542 557 542 532T543 500Q543 472 540 465T524 458H511H505Q489 458 485 461T479 478Q472 529 449 564T393 614T336 634T287 639Q228 639 203 610T177 544Q177 517 195 493T247 457Q253 454 343 436T475 391Q574 326 574 207V200Q574 163 559 120Q517 12 389 -9Q380 -10 346 -10Q308 -10 275 -5T221 7T184 22T160 35T151 40L126 17Q122 14 118 10T111 3T106 -2T102 -5T98 -7T95 -9T92 -10T89 -11T84 -11Q70 -11 67 -4T64 35V108Q64 128 64 153T63 185Q63 203 63 211T69 223T77 227T94 228H100Q118 228 122 225T126 205Q130 125 193 88T345 51Q408 51 434 82T460 157Q460 196 439 221T388 257Q384 259 305 276T221 295Q155 313 110 366T64 493",
  119827: "41 425Q41 426 51 545T62 669V675H737V669Q738 665 748 546T758 425V419H696V425Q687 517 669 555T595 607Q578 612 522 613H478V62H631V0H615Q585 3 399 3Q214 3 184 0H168V62H321V613H277H263Q164 613 134 561Q113 527 103 425V419H41V425",
  119828: "570 686Q588 683 703 683T836 686H845V624H737V420Q737 390 737 345T738 284Q738 205 729 164T689 83Q614 -11 465 -11Q321 -11 240 51T148 207Q147 214 147 421V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V405V370V268Q304 181 311 146T346 87Q387 52 466 52Q642 52 667 195Q668 204 669 415V624H561V686H570",
  119829: "592 686H604Q615 685 631 685T666 684T700 684T724 683Q829 683 835 686H843V624H744L611 315Q584 254 546 165Q492 40 482 19T461 -6L460 -7H409Q398 -4 391 9Q385 20 257 315L124 624H25V686H36Q57 683 190 683Q340 683 364 686H377V624H289L384 403L480 185L492 212Q504 240 529 298T575 405L670 624H582V686H592",
  119830: "915 686L1052 683Q1142 683 1157 686H1164V624H1073L957 320Q930 249 900 170T855 52T839 10Q834 0 826 -5Q821 -7 799 -7H792Q777 -7 772 -5T759 10Q759 11 748 39T716 122T676 228L594 442L512 228Q486 159 455 78Q433 19 428 9T416 -5Q411 -7 389 -7H379Q356 -7 349 10Q349 12 334 51T288 170T231 320L116 624H24V686H35Q44 683 183 683Q331 683 355 686H368V624H323Q278 624 278 623L437 207L499 369L561 531L526 624H434V686H445Q454 683 593 683Q741 683 765 686H778V624H733Q688 624 688 623L847 207Q848 207 927 415T1006 624H905V686H915",
  119831: "327 0Q306 3 174 3Q52 3 43 0H33V62H98L162 63L360 333L157 624H48V686H59Q80 683 217 683Q368 683 395 686H408V624H335L393 540L452 458L573 623Q573 624 528 624H483V686H494Q515 683 646 683Q769 683 778 686H787V624H658L575 511Q493 398 493 397L508 376Q522 356 553 312T611 229L727 62H835V0H824Q803 3 667 3Q516 3 489 0H476V62H513L549 63L401 274L247 63Q247 62 292 62H338V0H327",
  119832: "605 0Q581 3 434 3Q286 3 262 0H250V62H358V275L126 624H19V686H30Q54 683 189 683Q361 685 370 686H383V624H308L319 608Q330 591 353 556T396 491L484 359L660 623Q660 624 623 624H585V686H595Q613 683 728 683Q832 683 841 686H849V624H742L509 274V62H618V0H605",
  119833: "80 430L92 686H358Q624 686 628 684Q638 679 638 656Q638 640 637 639Q637 638 445 353Q401 288 351 214T277 103L253 67L256 66Q258 66 265 66T279 66T298 66H343Q380 66 406 68T464 81T518 110T557 164T579 250Q583 278 583 298Q583 299 614 299H645V291Q643 281 636 150T627 8V0H353Q79 0 75 2Q64 7 64 31Q64 48 66 52L259 340L451 623Q451 624 384 624Q294 623 259 612Q155 581 143 446Q142 440 142 432V430H80",
  119834: "64 349Q64 399 107 426T255 453Q346 453 402 423T473 341Q478 327 478 310T479 196V77Q493 63 529 62Q549 62 553 57T558 31Q558 9 552 5T514 0H497H481Q375 0 367 56L356 46Q300 -6 210 -6Q130 -6 81 30T32 121Q32 188 111 226T332 272H350V292Q350 313 348 327T337 361T306 391T248 402T194 399H189Q204 376 204 354Q204 327 187 306T134 284Q97 284 81 305T64 349ZM164 121Q164 89 186 67T238 45Q274 45 307 63T346 108L350 117V226H347Q248 218 206 189T164 121",
  119835: "32 686L123 690Q214 694 215 694H221V409Q289 450 378 450Q479 450 539 387T600 221Q600 122 535 58T358 -6H355Q272 -6 203 53L160 1L129 0H98V301Q98 362 98 435T99 525Q99 591 97 604T83 620Q69 624 42 624H29V686H32ZM227 105L232 99Q237 93 242 87T258 73T280 59T306 49T339 45Q380 45 411 66T451 131Q457 160 457 230Q457 264 456 284T448 329T430 367T396 389T343 398Q282 398 235 355L227 348V105",
  119836: "447 131H458Q478 131 478 117Q478 112 471 95T439 51T377 9Q330 -6 286 -6Q196 -6 135 35Q39 96 39 222Q39 324 101 384Q169 453 286 453Q359 453 411 431T464 353Q464 319 445 302T395 284Q360 284 343 305T325 353Q325 380 338 396H333Q317 398 295 398H292Q280 398 271 397T245 390T218 373T197 338T183 283Q182 275 182 231Q182 199 184 180T193 132T220 85T270 57Q289 50 317 50H326Q385 50 414 115Q419 127 423 129T447 131",
  119837: "351 686L442 690Q533 694 534 694H540V389Q540 327 540 253T539 163Q539 97 541 83T555 66Q569 62 596 62H609V31Q609 0 608 0Q588 0 510 -3T412 -6Q411 -6 411 16V38L401 31Q337 -6 265 -6Q159 -6 99 58T38 224Q38 265 51 303T92 375T165 429T272 449Q359 449 417 412V507V555Q417 597 415 607T402 620Q388 624 361 624H348V686H351ZM411 350Q362 399 291 399Q278 399 256 392T218 371Q195 351 189 320T182 238V221Q182 179 183 159T191 115T212 74Q241 46 288 46Q358 46 404 100L411 109V350",
  119838: "32 225Q32 332 102 392T272 452H283Q382 452 436 401Q494 343 494 243Q494 226 486 222T440 217Q431 217 394 217T327 218H175V209Q175 177 179 154T196 107T236 69T306 50Q312 49 323 49Q376 49 410 85Q421 99 427 111T434 127T442 133T463 135H468Q494 135 494 117Q494 110 489 97T468 66T431 32T373 5T292 -6Q181 -6 107 55T32 225ZM383 276Q377 346 348 374T280 402Q253 402 230 390T195 357Q179 331 176 279V266H383V276",
  119839: "308 0Q290 3 172 3Q58 3 49 0H40V62H109V382H42V444H109V503L110 562L112 572Q127 625 178 658T316 699Q318 699 330 699T348 700Q381 698 404 687T436 658T449 629T452 606Q452 576 432 557T383 537Q355 537 335 555T314 605Q314 635 328 649H325Q311 649 293 644T253 618T227 560Q226 555 226 498V444H340V382H232V62H318V0H308",
  119840: "50 300Q50 368 105 409T255 450Q328 450 376 426L388 420Q435 455 489 455Q517 455 533 441T554 414T558 389Q558 367 544 353T508 339Q484 339 471 354T458 387Q458 397 462 400Q464 401 461 400Q459 400 454 399Q429 392 427 390Q454 353 459 328Q461 315 461 300Q461 240 419 202Q364 149 248 149Q185 149 136 172Q129 158 129 148Q129 105 170 93Q176 91 263 91Q273 91 298 91T334 91T366 89T400 85T432 77T466 64Q544 22 544 -69Q544 -114 506 -145Q438 -201 287 -201Q149 -201 90 -161T30 -70Q30 -58 33 -47T42 -27T54 -13T69 -1T82 6T94 12T101 15Q66 57 66 106Q66 151 90 187L97 197L89 204Q50 243 50 300ZM485 403H492Q491 404 488 404L485 403V403ZM255 200Q279 200 295 206T319 219T331 242T335 268T336 300Q336 337 333 352T317 380Q298 399 255 399Q228 399 211 392T187 371T178 345T176 312V300V289Q176 235 194 219Q215 200 255 200ZM287 -150Q357 -150 400 -128T443 -71Q443 -65 442 -61T436 -50T420 -37T389 -27T339 -21L308 -20Q276 -20 253 -20Q190 -20 180 -20T156 -26Q130 -38 130 -69Q130 -105 173 -127T287 -150",
  119841: "40 686L131 690Q222 694 223 694H229V533L230 372L238 381Q248 394 264 407T317 435T398 450Q428 450 448 447T491 434T529 402T551 346Q553 335 554 198V62H623V0H614Q596 3 489 3Q374 3 365 0H356V62H425V194V275Q425 348 416 373T371 399Q326 399 288 370T238 290Q236 281 235 171V62H304V0H295Q277 3 171 3Q64 3 46 0H37V62H106V332Q106 387 106 453T107 534Q107 593 105 605T91 620Q77 624 50 624H37V686H40",
  119842: "72 610Q72 649 98 672T159 695Q193 693 217 670T241 610Q241 572 217 549T157 525Q120 525 96 548T72 610ZM46 442L136 446L226 450H232V62H294V0H286Q271 3 171 3Q67 3 49 0H40V62H109V209Q109 358 108 362Q103 380 55 380H43V442H46",
  119843: "104 610Q104 649 130 672T191 695Q225 693 249 670T273 610Q273 572 249 549T189 525Q152 525 128 548T104 610ZM78 442L173 446L268 450H274V196Q274 -5 274 -37T269 -83Q256 -132 201 -166T71 -200Q10 -200 -30 -173T-71 -102Q-71 -70 -51 -51T-1 -31Q27 -31 48 -49T69 -100Q69 -121 53 -147H56Q66 -149 77 -149H80Q90 -149 100 -146T127 -125T149 -73Q151 -55 151 149V362Q150 364 148 366T145 370T142 373T138 375T133 377T124 378T113 379T97 380H75V442H78",
  119844: "32 686L123 690Q214 694 215 694H221V255L377 382H346V444H355Q370 441 476 441Q544 441 556 444H562V382H476L347 277L515 62H587V0H579Q564 3 476 3Q370 3 352 0H343V62H358L373 63L260 206L237 189L216 172V62H285V0H277Q259 3 157 3Q46 3 37 0H29V62H98V332Q98 387 98 453T99 534Q99 593 97 605T83 620Q69 624 42 624H29V686H32",
  119845: "43 686L134 690Q225 694 226 694H232V62H301V0H292Q274 3 170 3Q67 3 49 0H40V62H109V332Q109 387 109 453T110 534Q110 593 108 605T94 620Q80 624 53 624H40V686H43",
  119846: "40 442Q217 450 218 450H224V365Q226 367 235 378T254 397T278 416T314 435T362 448Q376 450 400 450H406Q503 450 534 393Q545 376 545 370Q545 368 555 379Q611 450 716 450Q774 450 809 434Q850 414 861 379T873 276V213V198V62H942V0H933Q915 3 809 3Q702 3 684 0H675V62H744V194V275Q744 348 735 373T690 399Q645 399 607 370T557 290Q555 281 554 171V62H623V0H614Q596 3 489 3Q374 3 365 0H356V62H425V194V275Q425 348 416 373T371 399Q326 399 288 370T238 290Q236 281 235 171V62H304V0H295Q277 3 171 3Q64 3 46 0H37V62H106V210V303Q106 353 104 363T91 376Q77 380 50 380H37V442H40",
  119847: "40 442Q217 450 218 450H224V407L225 365Q233 378 245 391T289 422T362 448Q374 450 398 450Q428 450 448 447T491 434T529 402T551 346Q553 335 554 198V62H623V0H614Q596 3 489 3Q374 3 365 0H356V62H425V194V275Q425 348 416 373T371 399Q326 399 288 370T238 290Q236 281 235 171V62H304V0H295Q277 3 171 3Q64 3 46 0H37V62H106V210V303Q106 353 104 363T91 376Q77 380 50 380H37V442H40",
  119848: "287 -5Q228 -5 182 10T109 48T63 102T39 161T32 219Q32 272 50 314T94 382T154 423T214 446T265 452H279Q319 452 326 451Q428 439 485 376T542 221Q542 156 514 108T442 33Q384 -5 287 -5ZM399 230V250Q399 280 398 298T391 338T372 372T338 392T282 401Q241 401 212 380Q190 363 183 334T175 230Q175 202 175 189T177 153T183 118T195 91T215 68T245 56T287 50Q348 50 374 84Q388 101 393 132T399 230",
  119849: "32 442L123 446Q214 450 215 450H221V409Q222 409 229 413T251 423T284 436T328 446T382 450Q480 450 540 388T600 223Q600 128 539 61T361 -6H354Q292 -6 236 28L227 34V-132H296V-194H287Q269 -191 163 -191Q56 -191 38 -194H29V-132H98V113V284Q98 330 97 348T93 370T83 376Q69 380 42 380H29V442H32ZM457 224Q457 303 427 349T350 395Q282 395 235 352L227 345V104L233 97Q274 45 337 45Q383 45 420 86T457 224",
  119850: "38 220Q38 273 54 314T95 380T152 421T211 443T264 449Q368 449 429 386L438 377L484 450H540V-132H609V-194H600Q582 -191 475 -191Q360 -191 351 -194H342V-132H411V42Q409 41 399 34T383 25T367 16T347 7T324 1T296 -4T264 -6Q162 -6 100 56T38 220ZM287 46Q368 46 417 127V301L412 312Q398 347 369 371T302 395Q282 395 263 388T225 362T194 308T182 221Q182 126 214 86T287 46",
  119851: "405 293T374 293T324 312T305 361Q305 378 312 394Q315 397 315 399Q305 399 294 394T266 375T238 329T222 249Q221 241 221 149V62H308V0H298Q280 3 161 3Q47 3 38 0H29V62H98V210V303Q98 353 96 363T83 376Q69 380 42 380H29V442H32L118 446Q204 450 205 450H210V414L211 378Q247 449 315 449H321Q384 449 413 422T442 360Q442 332 424 313",
  119852: "38 315Q38 339 45 360T70 404T127 440T223 453Q273 453 320 436L338 445L357 453H366Q380 453 383 447T386 403V387V355Q386 331 383 326T365 321H355H349Q333 321 329 324T324 341Q317 406 224 406H216Q123 406 123 353Q123 334 143 321T188 304T244 294T285 286Q305 281 325 273T373 237T412 172Q414 162 414 142Q414 -6 230 -6Q154 -6 117 22L68 -6H58Q44 -6 41 0T38 42V73Q38 85 38 101T37 122Q37 144 42 148T68 153H75Q87 153 91 151T97 147T103 132Q131 46 220 46H230Q257 46 265 47Q330 58 330 108Q330 127 316 142Q300 156 284 162Q271 168 212 178T122 202Q38 243 38 315",
  119853: "272 49Q320 49 320 136V145V177H382V143Q382 106 380 99Q374 62 349 36T285 -2L272 -5H247Q173 -5 134 27Q109 46 102 74T94 160Q94 171 94 199T95 245V382H21V433H25Q58 433 90 456Q121 479 140 523T162 621V635H224V444H363V382H224V239V207V149Q224 98 228 81T249 55Q261 49 272 49",
  119854: "40 442L134 446Q228 450 229 450H235V273V165Q235 90 238 74T254 52Q268 46 304 46H319Q352 46 380 67T419 121L420 123Q424 135 425 199Q425 201 425 207Q425 233 425 249V316Q425 354 423 363T410 376Q396 380 369 380H356V442L554 450V267Q554 84 556 79Q561 62 610 62H623V31Q623 0 622 0Q603 0 527 -3T432 -6Q431 -6 431 25V56L420 45Q373 6 332 -1Q313 -6 281 -6Q208 -6 165 14T109 87L107 98L106 230Q106 358 104 366Q96 380 50 380H37V442H40",
  119855: "401 444Q413 441 495 441Q568 441 574 444H580V382H510L409 156Q348 18 339 6Q331 -4 320 -4Q318 -4 313 -4T303 -3H288Q273 -3 264 12T221 102Q206 135 197 156L96 382H26V444H34Q49 441 145 441Q252 441 270 444H279V382H231L284 264Q335 149 338 149Q338 150 389 264T442 381Q442 382 418 382H394V444H401",
  119856: "624 444Q636 441 722 441Q797 441 800 444H805V382H741L593 11Q592 10 590 8T586 4T584 2T581 0T579 -2T575 -3T571 -3T567 -4T561 -4T553 -4H542Q525 -4 518 6T490 70Q474 110 463 137L415 257L367 137Q357 111 341 72Q320 17 313 7T289 -4H277Q259 -4 253 -2T238 11L90 382H25V444H32Q47 441 140 441Q243 441 261 444H270V382H222L310 164L382 342L366 382H303V444H310Q322 441 407 441Q508 441 523 444H531V382H506Q481 382 481 380Q482 376 529 259T577 142L674 382H617V444H624",
  119857: "227 0Q212 3 121 3Q40 3 28 0H21V62H117L245 213L109 382H26V444H34Q49 441 143 441Q247 441 265 444H274V382H246L281 339Q315 297 316 297Q320 297 354 341L389 382H352V444H360Q375 441 466 441Q547 441 559 444H566V382H471L355 246L504 63L545 62H586V0H578Q563 3 469 3Q365 3 347 0H338V62H366Q366 63 326 112T285 163L198 63L217 62H235V0H227",
  119858: "84 -102Q84 -110 87 -119T102 -138T133 -149Q148 -148 162 -143T186 -131T206 -114T222 -95T234 -76T243 -59T249 -45T252 -37L269 0L96 382H26V444H34Q49 441 146 441Q252 441 270 444H279V382H255Q232 382 232 380L337 151L442 382H394V444H401Q413 441 495 441Q568 441 574 444H580V382H510L406 152Q298 -84 297 -87Q269 -139 225 -169T131 -200Q85 -200 54 -172T23 -100Q23 -64 44 -50T87 -35Q111 -35 130 -50T152 -92V-100H84V-102",
  119859: "48 262Q48 264 54 349T60 436V444H252Q289 444 336 444T394 445Q441 445 450 441T459 418Q459 406 458 404Q456 399 327 229T194 55H237Q260 56 268 56T297 58T325 65T348 77T370 98T384 128T395 170Q400 197 400 216Q400 217 431 217H462V211Q461 208 453 108T444 6V0H245Q46 0 43 2Q32 7 32 28V33Q32 41 40 52T84 112Q129 170 164 217L298 393H256Q189 392 165 380Q124 360 115 303Q110 280 110 256Q110 254 79 254H48V262",
  119860: "208 74Q208 50 254 46Q272 46 272 35Q272 34 270 22Q267 8 264 4T251 0Q249 0 239 0T205 1T141 2Q70 2 50 0H42Q35 7 35 11Q37 38 48 46H62Q132 49 164 96Q170 102 345 401T523 704Q530 716 547 716H555H572Q578 707 578 706L606 383Q634 60 636 57Q641 46 701 46Q726 46 726 36Q726 34 723 22Q720 7 718 4T704 0Q701 0 690 0T651 1T578 2Q484 2 455 0H443Q437 6 437 9T439 27Q443 40 445 43L449 46H469Q523 49 533 63L521 213H283L249 155Q208 86 208 74ZM516 260Q516 271 504 416T490 562L463 519Q447 492 400 412L310 260L413 259Q516 259 516 260",
  119861: "231 637Q204 637 199 638T194 649Q194 676 205 682Q206 683 335 683Q594 683 608 681Q671 671 713 636T756 544Q756 480 698 429T565 360L555 357Q619 348 660 311T702 219Q702 146 630 78T453 1Q446 0 242 0Q42 0 39 2Q35 5 35 10Q35 17 37 24Q42 43 47 45Q51 46 62 46H68Q95 46 128 49Q142 52 147 61Q150 65 219 339T288 628Q288 635 231 637ZM649 544Q649 574 634 600T585 634Q578 636 493 637Q473 637 451 637T416 636H403Q388 635 384 626Q382 622 352 506Q352 503 351 500L320 374H401Q482 374 494 376Q554 386 601 434T649 544ZM595 229Q595 273 572 302T512 336Q506 337 429 337Q311 337 310 336Q310 334 293 263T258 122L240 52Q240 48 252 48T333 46Q422 46 429 47Q491 54 543 105T595 229",
  119862: "50 252Q50 367 117 473T286 641T490 704Q580 704 633 653Q642 643 648 636T656 626L657 623Q660 623 684 649Q691 655 699 663T715 679T725 690L740 705H746Q760 705 760 698Q760 694 728 561Q692 422 692 421Q690 416 687 415T669 413H653Q647 419 647 422Q647 423 648 429T650 449T651 481Q651 552 619 605T510 659Q484 659 454 652T382 628T299 572T226 479Q194 422 175 346T156 222Q156 108 232 58Q280 24 350 24Q441 24 512 92T606 240Q610 253 612 255T628 257Q648 257 648 248Q648 243 647 239Q618 132 523 55T319 -22Q206 -22 128 53T50 252",
  119863: "287 628Q287 635 230 637Q207 637 200 638T193 647Q193 655 197 667T204 682Q206 683 403 683Q570 682 590 682T630 676Q702 659 752 597T803 431Q803 275 696 151T444 3L430 1L236 0H125H72Q48 0 41 2T33 11Q33 13 36 25Q40 41 44 43T67 46Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628ZM703 469Q703 507 692 537T666 584T629 613T590 629T555 636Q553 636 541 636T512 636T479 637H436Q392 637 386 627Q384 623 313 339T242 52Q242 48 253 48T330 47Q335 47 349 47T373 46Q499 46 581 128Q617 164 640 212T683 339T703 469",
  119864: "492 213Q472 213 472 226Q472 230 477 250T482 285Q482 316 461 323T364 330H312Q311 328 277 192T243 52Q243 48 254 48T334 46Q428 46 458 48T518 61Q567 77 599 117T670 248Q680 270 683 272Q690 274 698 274Q718 274 718 261Q613 7 608 2Q605 0 322 0H133Q31 0 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 659Q197 676 203 680H757Q764 676 764 669Q764 664 751 557T737 447Q735 440 717 440H705Q698 445 698 453L701 476Q704 500 704 528Q704 558 697 578T678 609T643 625T596 632T532 634H485Q397 633 392 631Q388 629 386 622Q385 619 355 499T324 377Q347 376 372 376H398Q464 376 489 391T534 472Q538 488 540 490T557 493Q562 493 565 493T570 492T572 491T574 487T577 483L544 351Q511 218 508 216Q505 213 492 213",
  119865: "48 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 659Q197 676 203 680H742Q749 676 749 669Q749 664 736 557T722 447Q720 440 702 440H690Q683 445 683 453Q683 454 686 477T689 530Q689 560 682 579T663 610T626 626T575 633T503 634H480Q398 633 393 631Q388 629 386 623Q385 622 352 492L320 363H375Q378 363 398 363T426 364T448 367T472 374T489 386Q502 398 511 419T524 457T529 475Q532 480 548 480H560Q567 475 567 470Q567 467 536 339T502 207Q500 200 482 200H470Q463 206 463 212Q463 215 468 234T473 274Q473 303 453 310T364 317H309L277 190Q245 66 245 60Q245 46 334 46H359Q365 40 365 39T363 19Q359 6 353 0H336Q295 2 185 2Q120 2 86 2T48 1",
  119866: "50 252Q50 367 117 473T286 641T490 704Q580 704 633 653Q642 643 648 636T656 626L657 623Q660 623 684 649Q691 655 699 663T715 679T725 690L740 705H746Q760 705 760 698Q760 694 728 561Q692 422 692 421Q690 416 687 415T669 413H653Q647 419 647 422Q647 423 648 429T650 449T651 481Q651 552 619 605T510 659Q492 659 471 656T418 643T357 615T294 567T236 496T189 394T158 260Q156 242 156 221Q156 173 170 136T206 79T256 45T308 28T353 24Q407 24 452 47T514 106Q517 114 529 161T541 214Q541 222 528 224T468 227H431Q425 233 425 235T427 254Q431 267 437 273H454Q494 271 594 271Q634 271 659 271T695 272T707 272Q721 272 721 263Q721 261 719 249Q714 230 709 228Q706 227 694 227Q674 227 653 224Q646 221 643 215T629 164Q620 131 614 108Q589 6 586 3Q584 1 581 1Q571 1 553 21T530 52Q530 53 528 52T522 47Q448 -22 322 -22Q201 -22 126 55T50 252",
  119867: "228 637Q194 637 192 641Q191 643 191 649Q191 673 202 682Q204 683 219 683Q260 681 355 681Q389 681 418 681T463 682T483 682Q499 682 499 672Q499 670 497 658Q492 641 487 638H485Q483 638 480 638T473 638T464 637T455 637Q416 636 405 634T387 623Q384 619 355 500Q348 474 340 442T328 395L324 380Q324 378 469 378H614L615 381Q615 384 646 504Q674 619 674 627T617 637Q594 637 587 639T580 648Q580 650 582 660Q586 677 588 679T604 682Q609 682 646 681T740 680Q802 680 835 681T871 682Q888 682 888 672Q888 645 876 638H874Q872 638 869 638T862 638T853 637T844 637Q805 636 794 634T776 623Q773 618 704 340T634 58Q634 51 638 51Q646 48 692 46H723Q729 38 729 37T726 19Q722 6 716 0H701Q664 2 567 2Q533 2 504 2T458 2T437 1Q420 1 420 10Q420 15 423 24Q428 43 433 45Q437 46 448 46H454Q481 46 514 49Q520 50 522 50T528 55T534 64T540 82T547 110T558 153Q565 181 569 198Q602 330 602 331T457 332H312L279 197Q245 63 245 58Q245 51 253 49T303 46H334Q340 38 340 37T337 19Q333 6 327 0H312Q275 2 178 2Q144 2 115 2T69 2T48 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Q285 635 228 637",
  119868: "43 1Q26 1 26 10Q26 12 29 24Q34 43 39 45Q42 46 54 46H60Q120 46 136 53Q137 53 138 54Q143 56 149 77T198 273Q210 318 216 344Q286 624 286 626Q284 630 284 631Q274 637 213 637H193Q184 643 189 662Q193 677 195 680T209 683H213Q285 681 359 681Q481 681 487 683H497Q504 676 504 672T501 655T494 639Q491 637 471 637Q440 637 407 634Q393 631 388 623Q381 609 337 432Q326 385 315 341Q245 65 245 59Q245 52 255 50T307 46H339Q345 38 345 37T342 19Q338 6 332 0H316Q279 2 179 2Q143 2 113 2T65 2T43 1",
  119869: "447 625Q447 637 354 637H329Q323 642 323 645T325 664Q329 677 335 683H352Q393 681 498 681Q541 681 568 681T605 682T619 682Q633 682 633 672Q633 670 630 658Q626 642 623 640T604 637Q552 637 545 623Q541 610 483 376Q420 128 419 127Q397 64 333 21T195 -22Q137 -22 97 8T57 88Q57 130 80 152T132 174Q177 174 182 130Q182 98 164 80T123 56Q115 54 115 53T122 44Q148 15 197 15Q235 15 271 47T324 130Q328 142 387 380T447 625",
  119870: "285 628Q285 635 228 637Q205 637 198 638T191 647Q191 649 193 661Q199 681 203 682Q205 683 214 683H219Q260 681 355 681Q389 681 418 681T463 682T483 682Q500 682 500 674Q500 669 497 660Q496 658 496 654T495 648T493 644T490 641T486 639T479 638T470 637T456 637Q416 636 405 634T387 623L306 305Q307 305 490 449T678 597Q692 611 692 620Q692 635 667 637Q651 637 651 648Q651 650 654 662T659 677Q662 682 676 682Q680 682 711 681T791 680Q814 680 839 681T869 682Q889 682 889 672Q889 650 881 642Q878 637 862 637Q787 632 726 586Q710 576 656 534T556 455L509 418L518 396Q527 374 546 329T581 244Q656 67 661 61Q663 59 666 57Q680 47 717 46H738Q744 38 744 37T741 19Q737 6 731 0H720Q680 3 625 3Q503 3 488 0H478Q472 6 472 9T474 27Q478 40 480 43T491 46H494Q544 46 544 71Q544 75 517 141T485 216L427 354L359 301L291 248L268 155Q245 63 245 58Q245 51 253 49T303 46H334Q340 37 340 35Q340 19 333 5Q328 0 317 0Q314 0 280 1T180 2Q118 2 85 2T49 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628",
  119871: "228 637Q194 637 192 641Q191 643 191 649Q191 673 202 682Q204 683 217 683Q271 680 344 680Q485 680 506 683H518Q524 677 524 674T522 656Q517 641 513 637H475Q406 636 394 628Q387 624 380 600T313 336Q297 271 279 198T252 88L243 52Q243 48 252 48T311 46H328Q360 46 379 47T428 54T478 72T522 106T564 161Q580 191 594 228T611 270Q616 273 628 273H641Q647 264 647 262T627 203T583 83T557 9Q555 4 553 3T537 0T494 -1Q483 -1 418 -1T294 0H116Q32 0 32 10Q32 17 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Q285 635 228 637",
  119872: "289 629Q289 635 232 637Q208 637 201 638T194 648Q194 649 196 659Q197 662 198 666T199 671T201 676T203 679T207 681T212 683T220 683T232 684Q238 684 262 684T307 683Q386 683 398 683T414 678Q415 674 451 396L487 117L510 154Q534 190 574 254T662 394Q837 673 839 675Q840 676 842 678T846 681L852 683H948Q965 683 988 683T1017 684Q1051 684 1051 673Q1051 668 1048 656T1045 643Q1041 637 1008 637Q968 636 957 634T939 623Q936 618 867 340T797 59Q797 55 798 54T805 50T822 48T855 46H886Q892 37 892 35Q892 19 885 5Q880 0 869 0Q864 0 828 1T736 2Q675 2 644 2T609 1Q592 1 592 11Q592 13 594 25Q598 41 602 43T625 46Q652 46 685 49Q699 52 704 61Q706 65 742 207T813 490T848 631L654 322Q458 10 453 5Q451 4 449 3Q444 0 433 0Q418 0 415 7Q413 11 374 317L335 624L267 354Q200 88 200 79Q206 46 272 46H282Q288 41 289 37T286 19Q282 3 278 1Q274 0 267 0Q265 0 255 0T221 1T157 2Q127 2 95 1T58 0Q43 0 39 2T35 11Q35 13 38 25T43 40Q45 46 65 46Q135 46 154 86Q158 92 223 354T289 629",
  119873: "234 637Q231 637 226 637Q201 637 196 638T191 649Q191 676 202 682Q204 683 299 683Q376 683 387 683T401 677Q612 181 616 168L670 381Q723 592 723 606Q723 633 659 637Q635 637 635 648Q635 650 637 660Q641 676 643 679T653 683Q656 683 684 682T767 680Q817 680 843 681T873 682Q888 682 888 672Q888 650 880 642Q878 637 858 637Q787 633 769 597L620 7Q618 0 599 0Q585 0 582 2Q579 5 453 305L326 604L261 344Q196 88 196 79Q201 46 268 46H278Q284 41 284 38T282 19Q278 6 272 0H259Q228 2 151 2Q123 2 100 2T63 2T46 1Q31 1 31 10Q31 14 34 26T39 40Q41 46 62 46Q130 49 150 85Q154 91 221 362L289 634Q287 635 234 637",
  119874: "740 435Q740 320 676 213T511 42T304 -22Q207 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435ZM637 476Q637 565 591 615T476 665Q396 665 322 605Q242 542 200 428T157 216Q157 126 200 73T314 19Q404 19 485 98T608 313Q637 408 637 476",
  119875: "287 628Q287 635 230 637Q206 637 199 638T192 648Q192 649 194 659Q200 679 203 681T397 683Q587 682 600 680Q664 669 707 631T751 530Q751 453 685 389Q616 321 507 303Q500 302 402 301H307L277 182Q247 66 247 59Q247 55 248 54T255 50T272 48T305 46H336Q342 37 342 35Q342 19 335 5Q330 0 319 0Q316 0 282 1T182 2Q120 2 87 2T51 1Q33 1 33 11Q33 13 36 25Q40 41 44 43T67 46Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628ZM645 554Q645 567 643 575T634 597T609 619T560 635Q553 636 480 637Q463 637 445 637T416 636T404 636Q391 635 386 627Q384 621 367 550T332 412T314 344Q314 342 395 342H407H430Q542 342 590 392Q617 419 631 471T645 554",
  119876: "399 -80Q399 -47 400 -30T402 -11V-7L387 -11Q341 -22 303 -22Q208 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435Q740 255 592 107Q529 47 461 16L444 8V3Q444 2 449 -24T470 -66T516 -82Q551 -82 583 -60T625 -3Q631 11 638 11Q647 11 649 2Q649 -6 639 -34T611 -100T557 -165T481 -194Q399 -194 399 -87V-80ZM636 468Q636 523 621 564T580 625T530 655T477 665Q429 665 379 640Q277 591 215 464T153 216Q153 110 207 59Q231 38 236 38V46Q236 86 269 120T347 155Q372 155 390 144T417 114T429 82T435 55L448 64Q512 108 557 185T619 334T636 468ZM314 18Q362 18 404 39L403 49Q399 104 366 115Q354 117 347 117Q344 117 341 117T337 118Q317 118 296 98T274 52Q274 18 314 18",
  119877: "230 637Q203 637 198 638T193 649Q193 676 204 682Q206 683 378 683Q550 682 564 680Q620 672 658 652T712 606T733 563T739 529Q739 484 710 445T643 385T576 351T538 338L545 333Q612 295 612 223Q612 212 607 162T602 80V71Q602 53 603 43T614 25T640 16Q668 16 686 38T712 85Q717 99 720 102T735 105Q755 105 755 93Q755 75 731 36Q693 -21 641 -21H632Q571 -21 531 4T487 82Q487 109 502 166T517 239Q517 290 474 313Q459 320 449 321T378 323H309L277 193Q244 61 244 59Q244 55 245 54T252 50T269 48T302 46H333Q339 38 339 37T336 19Q332 6 326 0H311Q275 2 180 2Q146 2 117 2T71 2T50 1Q33 1 33 10Q33 12 36 24Q41 43 46 45Q50 46 61 46H67Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628Q287 635 230 637ZM630 554Q630 586 609 608T523 636Q521 636 500 636T462 637H440Q393 637 386 627Q385 624 352 494T319 361Q319 360 388 360Q466 361 492 367Q556 377 592 426Q608 449 619 486T630 554",
  119878: "308 24Q367 24 416 76T466 197Q466 260 414 284Q308 311 278 321T236 341Q176 383 176 462Q176 523 208 573T273 648Q302 673 343 688T407 704H418H425Q521 704 564 640Q565 640 577 653T603 682T623 704Q624 704 627 704T632 705Q645 705 645 698T617 577T585 459T569 456Q549 456 549 465Q549 471 550 475Q550 478 551 494T553 520Q553 554 544 579T526 616T501 641Q465 662 419 662Q362 662 313 616T263 510Q263 480 278 458T319 427Q323 425 389 408T456 390Q490 379 522 342T554 242Q554 216 546 186Q541 164 528 137T492 78T426 18T332 -20Q320 -22 298 -22Q199 -22 144 33L134 44L106 13Q83 -14 78 -18T65 -22Q52 -22 52 -14Q52 -11 110 221Q112 227 130 227H143Q149 221 149 216Q149 214 148 207T144 186T142 153Q144 114 160 87T203 47T255 29T308 24",
  119879: "40 437Q21 437 21 445Q21 450 37 501T71 602L88 651Q93 669 101 677H569H659Q691 677 697 676T704 667Q704 661 687 553T668 444Q668 437 649 437Q640 437 637 437T631 442L629 445Q629 451 635 490T641 551Q641 586 628 604T573 629Q568 630 515 631Q469 631 457 630T439 622Q438 621 368 343T298 60Q298 48 386 46Q418 46 427 45T436 36Q436 31 433 22Q429 4 424 1L422 0Q419 0 415 0Q410 0 363 1T228 2Q99 2 64 0H49Q43 6 43 9T45 27Q49 40 55 46H83H94Q174 46 189 55Q190 56 191 56Q196 59 201 76T241 233Q258 301 269 344Q339 619 339 625Q339 630 310 630H279Q212 630 191 624Q146 614 121 583T67 467Q60 445 57 441T43 437H40",
  119880: "107 637Q73 637 71 641Q70 643 70 649Q70 673 81 682Q83 683 98 683Q139 681 234 681Q268 681 297 681T342 682T362 682Q378 682 378 672Q378 670 376 658Q371 641 366 638H364Q362 638 359 638T352 638T343 637T334 637Q295 636 284 634T266 623Q265 621 238 518T184 302T154 169Q152 155 152 140Q152 86 183 55T269 24Q336 24 403 69T501 205L552 406Q599 598 599 606Q599 633 535 637Q511 637 511 648Q511 650 513 660Q517 676 519 679T529 683Q532 683 561 682T645 680Q696 680 723 681T752 682Q767 682 767 672Q767 650 759 642Q756 637 737 637Q666 633 648 597Q646 592 598 404Q557 235 548 205Q515 105 433 42T263 -22Q171 -22 116 34T60 167V183Q60 201 115 421Q164 622 164 628Q164 635 107 637",
  119881: "52 648Q52 670 65 683H76Q118 680 181 680Q299 680 320 683H330Q336 677 336 674T334 656Q329 641 325 637H304Q282 635 274 635Q245 630 242 620Q242 618 271 369T301 118L374 235Q447 352 520 471T595 594Q599 601 599 609Q599 633 555 637Q537 637 537 648Q537 649 539 661Q542 675 545 679T558 683Q560 683 570 683T604 682T668 681Q737 681 755 683H762Q769 676 769 672Q769 655 760 640Q757 637 743 637Q730 636 719 635T698 630T682 623T670 615T660 608T652 599T645 592L452 282Q272 -9 266 -16Q263 -18 259 -21L241 -22H234Q216 -22 216 -15Q213 -9 177 305Q139 623 138 626Q133 637 76 637H59Q52 642 52 648",
  119882: "436 683Q450 683 486 682T553 680Q604 680 638 681T677 682Q695 682 695 674Q695 670 692 659Q687 641 683 639T661 637Q636 636 621 632T600 624T597 615Q597 603 613 377T629 138L631 141Q633 144 637 151T649 170T666 200T690 241T720 295T759 362Q863 546 877 572T892 604Q892 619 873 628T831 637Q817 637 817 647Q817 650 819 660Q823 676 825 679T839 682Q842 682 856 682T895 682T949 681Q1015 681 1034 683Q1048 683 1048 672Q1048 666 1045 655T1038 640T1028 637Q1006 637 988 631T958 617T939 600T927 584L923 578L754 282Q586 -14 585 -15Q579 -22 561 -22Q546 -22 542 -17Q539 -14 523 229T506 480L494 462Q472 425 366 239Q222 -13 220 -15T215 -19Q210 -22 197 -22Q178 -22 176 -15Q176 -12 154 304T131 622Q129 631 121 633T82 637H58Q51 644 51 648Q52 671 64 683H76Q118 680 176 680Q301 680 313 683H323Q329 677 329 674T327 656Q322 641 318 637H297Q236 634 232 620Q262 160 266 136L501 550L499 587Q496 629 489 632Q483 636 447 637Q428 637 422 639T416 648Q416 650 418 660Q419 664 420 669T421 676T424 680T428 682T436 683",
  119883: "42 0H40Q26 0 26 11Q26 15 29 27Q33 41 36 43T55 46Q141 49 190 98Q200 108 306 224T411 342Q302 620 297 625Q288 636 234 637H206Q200 643 200 645T202 664Q206 677 212 683H226Q260 681 347 681Q380 681 408 681T453 682T473 682Q490 682 490 671Q490 670 488 658Q484 643 481 640T465 637Q434 634 411 620L488 426L541 485Q646 598 646 610Q646 628 622 635Q617 635 609 637Q594 637 594 648Q594 650 596 664Q600 677 606 683H618Q619 683 643 683T697 681T738 680Q828 680 837 683H845Q852 676 852 672Q850 647 840 637H824Q790 636 763 628T722 611T698 593L687 584Q687 585 592 480L505 384Q505 383 536 304T601 142T638 56Q648 47 699 46Q734 46 734 37Q734 35 732 23Q728 7 725 4T711 1Q708 1 678 1T589 2Q528 2 496 2T461 1Q444 1 444 10Q444 11 446 25Q448 35 450 39T455 44T464 46T480 47T506 54Q523 62 523 64Q522 64 476 181L429 299Q241 95 236 84Q232 76 232 72Q232 53 261 47Q262 47 267 47T273 46Q276 46 277 46T280 45T283 42T284 35Q284 26 282 19Q279 6 276 4T261 1Q258 1 243 1T201 2T142 2Q64 2 42 0",
  119884: "66 637Q54 637 49 637T39 638T32 641T30 647T33 664T42 682Q44 683 56 683Q104 680 165 680Q288 680 306 683H316Q322 677 322 674T320 656Q316 643 310 637H298Q242 637 242 624Q242 619 292 477T343 333L346 336Q350 340 358 349T379 373T411 410T454 461Q546 568 561 587T577 618Q577 634 545 637Q528 637 528 647Q528 649 530 661Q533 676 535 679T549 683Q551 683 578 682T657 680Q684 680 713 681T746 682Q763 682 763 673Q763 669 760 657T755 643Q753 637 734 637Q662 632 617 587Q608 578 477 424L348 273L322 169Q295 62 295 57Q295 46 363 46Q379 46 384 45T390 35Q390 33 388 23Q384 6 382 4T366 1Q361 1 324 1T232 2Q170 2 138 2T102 1Q84 1 84 9Q84 14 87 24Q88 27 89 30T90 35T91 39T93 42T96 44T101 45T107 45T116 46T129 46Q168 47 180 50T198 63Q201 68 227 171L252 274L129 623Q128 624 127 625T125 627T122 629T118 631T113 633T105 634T96 635T83 636T66 637",
  119885: "58 8Q58 23 64 35Q64 36 329 334T596 635L586 637Q575 637 512 637H500H476Q442 637 420 635T365 624T311 598T266 548T228 469Q227 466 226 463T224 458T223 453T222 450L221 448Q218 443 202 443Q185 443 182 453L214 561Q228 606 241 651Q249 679 253 681Q256 683 487 683H718Q723 678 723 675Q723 673 717 649Q189 54 188 52L185 49H274Q369 50 377 51Q452 60 500 100T579 247Q587 272 590 277T603 282H607Q628 282 628 271Q547 5 541 2Q538 0 300 0H124Q58 0 58 8",
  119886: "33 157Q33 258 109 349T280 441Q331 441 370 392Q386 422 416 422Q429 422 439 414T449 394Q449 381 412 234T374 68Q374 43 381 35T402 26Q411 27 422 35Q443 55 463 131Q469 151 473 152Q475 153 483 153H487Q506 153 506 144Q506 138 501 117T481 63T449 13Q436 0 417 -8Q409 -10 393 -10Q359 -10 336 5T306 36L300 51Q299 52 296 50Q294 48 292 46Q233 -10 172 -10Q117 -10 75 30T33 157ZM351 328Q351 334 346 350T323 385T277 405Q242 405 210 374T160 293Q131 214 119 129Q119 126 119 118T118 106Q118 61 136 44T179 26Q217 26 254 59T298 110Q300 114 325 217T351 328",
  119887: "73 647Q73 657 77 670T89 683Q90 683 161 688T234 694Q246 694 246 685T212 542Q204 508 195 472T180 418L176 399Q176 396 182 402Q231 442 283 442Q345 442 383 396T422 280Q422 169 343 79T173 -11Q123 -11 82 27T40 150V159Q40 180 48 217T97 414Q147 611 147 623T109 637Q104 637 101 637H96Q86 637 83 637T76 640T73 647ZM336 325V331Q336 405 275 405Q258 405 240 397T207 376T181 352T163 330L157 322L136 236Q114 150 114 114Q114 66 138 42Q154 26 178 26Q211 26 245 58Q270 81 285 114T318 219Q336 291 336 325",
  119888: "34 159Q34 268 120 355T306 442Q362 442 394 418T427 355Q427 326 408 306T360 285Q341 285 330 295T319 325T330 359T352 380T366 386H367Q367 388 361 392T340 400T306 404Q276 404 249 390Q228 381 206 359Q162 315 142 235T121 119Q121 73 147 50Q169 26 205 26H209Q321 26 394 111Q403 121 406 121Q410 121 419 112T429 98T420 83T391 55T346 25T282 0T202 -11Q127 -11 81 37T34 159",
  119889: "366 683Q367 683 438 688T511 694Q523 694 523 686Q523 679 450 384T375 83T374 68Q374 26 402 26Q411 27 422 35Q443 55 463 131Q469 151 473 152Q475 153 483 153H487H491Q506 153 506 145Q506 140 503 129Q490 79 473 48T445 8T417 -8Q409 -10 393 -10Q359 -10 336 5T306 36L300 51Q299 52 296 50Q294 48 292 46Q233 -10 172 -10Q117 -10 75 30T33 157Q33 205 53 255T101 341Q148 398 195 420T280 442Q336 442 364 400Q369 394 369 396Q370 400 396 505T424 616Q424 629 417 632T378 637H357Q351 643 351 645T353 664Q358 683 366 683ZM352 326Q329 405 277 405Q242 405 210 374T160 293Q131 214 119 129Q119 126 119 118T118 106Q118 61 136 44T179 26Q233 26 290 98L298 109L352 326",
  119890: "39 168Q39 225 58 272T107 350T174 402T244 433T307 442H310Q355 442 388 420T421 355Q421 265 310 237Q261 224 176 223Q139 223 138 221Q138 219 132 186T125 128Q125 81 146 54T209 26T302 45T394 111Q403 121 406 121Q410 121 419 112T429 98T420 82T390 55T344 24T281 -1T205 -11Q126 -11 83 42T39 168ZM373 353Q367 405 305 405Q272 405 244 391T199 357T170 316T154 280T149 261Q149 260 169 260Q282 260 327 284T373 353",
  119891: "118 -162Q120 -162 124 -164T135 -167T147 -168Q160 -168 171 -155T187 -126Q197 -99 221 27T267 267T289 382V385H242Q195 385 192 387Q188 390 188 397L195 425Q197 430 203 430T250 431Q298 431 298 432Q298 434 307 482T319 540Q356 705 465 705Q502 703 526 683T550 630Q550 594 529 578T487 561Q443 561 443 603Q443 622 454 636T478 657L487 662Q471 668 457 668Q445 668 434 658T419 630Q412 601 403 552T387 469T380 433Q380 431 435 431Q480 431 487 430T498 424Q499 420 496 407T491 391Q489 386 482 386T428 385H372L349 263Q301 15 282 -47Q255 -132 212 -173Q175 -205 139 -205Q107 -205 81 -186T55 -132Q55 -95 76 -78T118 -61Q162 -61 162 -103Q162 -122 151 -136T127 -157L118 -162",
  119892: "311 43Q296 30 267 15T206 0Q143 0 105 45T66 160Q66 265 143 353T314 442Q361 442 401 394L404 398Q406 401 409 404T418 412T431 419T447 422Q461 422 470 413T480 394Q480 379 423 152T363 -80Q345 -134 286 -169T151 -205Q10 -205 10 -137Q10 -111 28 -91T74 -71Q89 -71 102 -80T116 -111Q116 -121 114 -130T107 -144T99 -154T92 -162L90 -164H91Q101 -167 151 -167Q189 -167 211 -155Q234 -144 254 -122T282 -75Q288 -56 298 -13Q311 35 311 43ZM384 328L380 339Q377 350 375 354T369 368T359 382T346 393T328 402T306 405Q262 405 221 352Q191 313 171 233T151 117Q151 38 213 38Q269 38 323 108L331 118L384 328",
  119894: "184 600Q184 624 203 642T247 661Q265 661 277 649T290 619Q290 596 270 577T226 557Q211 557 198 567T184 600ZM21 287Q21 295 30 318T54 369T98 420T158 442Q197 442 223 419T250 357Q250 340 236 301T196 196T154 83Q149 61 149 51Q149 26 166 26Q175 26 185 29T208 43T235 78T260 137Q263 149 265 151T282 153Q302 153 302 143Q302 135 293 112T268 61T223 11T161 -11Q129 -11 102 10T74 74Q74 91 79 106T122 220Q160 321 166 341T173 380Q173 404 156 404H154Q124 404 99 371T61 287Q60 286 59 284T58 281T56 279T53 278T49 278T41 278H27Q21 284 21 287",
  119895: "297 596Q297 627 318 644T361 661Q378 661 389 651T403 623Q403 595 384 576T340 557Q322 557 310 567T297 596ZM288 376Q288 405 262 405Q240 405 220 393T185 362T161 325T144 293L137 279Q135 278 121 278H107Q101 284 101 286T105 299Q126 348 164 391T252 441Q253 441 260 441T272 442Q296 441 316 432Q341 418 354 401T367 348V332L318 133Q267 -67 264 -75Q246 -125 194 -164T75 -204Q25 -204 7 -183T-12 -137Q-12 -110 7 -91T53 -71Q70 -71 82 -81T95 -112Q95 -148 63 -167Q69 -168 77 -168Q111 -168 139 -140T182 -74L193 -32Q204 11 219 72T251 197T278 308T289 365Q289 372 288 376",
  119896: "121 647Q121 657 125 670T137 683Q138 683 209 688T282 694Q294 694 294 686Q294 679 244 477Q194 279 194 272Q213 282 223 291Q247 309 292 354T362 415Q402 442 438 442Q468 442 485 423T503 369Q503 344 496 327T477 302T456 291T438 288Q418 288 406 299T394 328Q394 353 410 369T442 390L458 393Q446 405 434 405H430Q398 402 367 380T294 316T228 255Q230 254 243 252T267 246T293 238T320 224T342 206T359 180T365 147Q365 130 360 106T354 66Q354 26 381 26Q429 26 459 145Q461 153 479 153H483Q499 153 499 144Q499 139 496 130Q455 -11 378 -11Q333 -11 305 15T277 90Q277 108 280 121T283 145Q283 167 269 183T234 206T200 217T182 220H180Q168 178 159 139T145 81T136 44T129 20T122 7T111 -2Q98 -11 83 -11Q66 -11 57 -1T48 16Q48 26 85 176T158 471L195 616Q196 629 188 632T149 637H144Q134 637 131 637T124 640T121 647",
  119897: "117 59Q117 26 142 26Q179 26 205 131Q211 151 215 152Q217 153 225 153H229Q238 153 241 153T246 151T248 144Q247 138 245 128T234 90T214 43T183 6T137 -11Q101 -11 70 11T38 85Q38 97 39 102L104 360Q167 615 167 623Q167 626 166 628T162 632T157 634T149 635T141 636T132 637T122 637Q112 637 109 637T101 638T95 641T94 647Q94 649 96 661Q101 680 107 682T179 688Q194 689 213 690T243 693T254 694Q266 694 266 686Q266 675 193 386T118 83Q118 81 118 75T117 65V59",
  119898: "21 287Q22 293 24 303T36 341T56 388T88 425T132 442T175 435T205 417T221 395T229 376L231 369Q231 367 232 367L243 378Q303 442 384 442Q401 442 415 440T441 433T460 423T475 411T485 398T493 385T497 373T500 364T502 357L510 367Q573 442 659 442Q713 442 746 415T780 336Q780 285 742 178T704 50Q705 36 709 31T724 26Q752 26 776 56T815 138Q818 149 821 151T837 153Q857 153 857 145Q857 144 853 130Q845 101 831 73T785 17T716 -10Q669 -10 648 17T627 73Q627 92 663 193T700 345Q700 404 656 404H651Q565 404 506 303L499 291L466 157Q433 26 428 16Q415 -11 385 -11Q372 -11 364 -4T353 8T350 18Q350 29 384 161L420 307Q423 322 423 345Q423 404 379 404H374Q288 404 229 303L222 291L189 157Q156 26 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 112 181Q151 335 151 342Q154 357 154 369Q154 405 129 405Q107 405 92 377T69 316T57 280Q55 278 41 278H27Q21 284 21 287",
  119899: "21 287Q22 293 24 303T36 341T56 388T89 425T135 442Q171 442 195 424T225 390T231 369Q231 367 232 367L243 378Q304 442 382 442Q436 442 469 415T503 336T465 179T427 52Q427 26 444 26Q450 26 453 27Q482 32 505 65T540 145Q542 153 560 153Q580 153 580 145Q580 144 576 130Q568 101 554 73T508 17T439 -10Q392 -10 371 17T350 73Q350 92 386 193T423 345Q423 404 379 404H374Q288 404 229 303L222 291L189 157Q156 26 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 112 180T152 343Q153 348 153 366Q153 405 129 405Q91 405 66 305Q60 285 60 284Q58 278 41 278H27Q21 284 21 287",
  119900: "201 -11Q126 -11 80 38T34 156Q34 221 64 279T146 380Q222 441 301 441Q333 441 341 440Q354 437 367 433T402 417T438 387T464 338T476 268Q476 161 390 75T201 -11ZM121 120Q121 70 147 48T206 26Q250 26 289 58T351 142Q360 163 374 216T388 308Q388 352 370 375Q346 405 306 405Q243 405 195 347Q158 303 140 230T121 120",
  119901: "23 287Q24 290 25 295T30 317T40 348T55 381T75 411T101 433T134 442Q209 442 230 378L240 387Q302 442 358 442Q423 442 460 395T497 281Q497 173 421 82T249 -10Q227 -10 210 -4Q199 1 187 11T168 28L161 36Q160 35 139 -51T118 -138Q118 -144 126 -145T163 -148H188Q194 -155 194 -157T191 -175Q188 -187 185 -190T172 -194Q170 -194 161 -194T127 -193T65 -192Q-5 -192 -24 -194H-32Q-39 -187 -39 -183Q-37 -156 -26 -148H-6Q28 -147 33 -136Q36 -130 94 103T155 350Q156 355 156 364Q156 405 131 405Q109 405 94 377T71 316T59 280Q57 278 43 278H29Q23 284 23 287ZM178 102Q200 26 252 26Q282 26 310 49T356 107Q374 141 392 215T411 325V331Q411 405 350 405Q339 405 328 402T306 393T286 380T269 365T254 350T243 336T235 326L232 322Q232 321 229 308T218 264T204 212Q178 106 178 102",
  119902: "33 157Q33 258 109 349T280 441Q340 441 372 389Q373 390 377 395T388 406T404 418Q438 442 450 442Q454 442 457 439T460 434Q460 425 391 149Q320 -135 320 -139Q320 -147 365 -148H390Q396 -156 396 -157T393 -175Q389 -188 383 -194H370Q339 -192 262 -192Q234 -192 211 -192T174 -192T157 -193Q143 -193 143 -185Q143 -182 145 -170Q149 -154 152 -151T172 -148Q220 -148 230 -141Q238 -136 258 -53T279 32Q279 33 272 29Q224 -10 172 -10Q117 -10 75 30T33 157ZM352 326Q329 405 277 405Q242 405 210 374T160 293Q131 214 119 129Q119 126 119 118T118 106Q118 61 136 44T179 26Q233 26 290 98L298 109L352 326",
  119903: "21 287Q22 290 23 295T28 317T38 348T53 381T73 411T99 433T132 442Q161 442 183 430T214 408T225 388Q227 382 228 382T236 389Q284 441 347 441H350Q398 441 422 400Q430 381 430 363Q430 333 417 315T391 292T366 288Q346 288 334 299T322 328Q322 376 378 392Q356 405 342 405Q286 405 239 331Q229 315 224 298T190 165Q156 25 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 114 189T154 366Q154 405 128 405Q107 405 92 377T68 316T57 280Q55 278 41 278H27Q21 284 21 287",
  119904: "131 289Q131 321 147 354T203 415T300 442Q362 442 390 415T419 355Q419 323 402 308T364 292Q351 292 340 300T328 326Q328 342 337 354T354 372T367 378Q368 378 368 379Q368 382 361 388T336 399T297 405Q249 405 227 379T204 326Q204 301 223 291T278 274T330 259Q396 230 396 163Q396 135 385 107T352 51T289 7T195 -10Q118 -10 86 19T53 87Q53 126 74 143T118 160Q133 160 146 151T160 120Q160 94 142 76T111 58Q109 57 108 57T107 55Q108 52 115 47T146 34T201 27Q237 27 263 38T301 66T318 97T323 122Q323 150 302 164T254 181T195 196T148 231Q131 256 131 289",
  119905: "26 385Q19 392 19 395Q19 399 22 411T27 425Q29 430 36 430T87 431H140L159 511Q162 522 166 540T173 566T179 586T187 603T197 615T211 624T229 626Q247 625 254 615T261 596Q261 589 252 549T232 470L222 433Q222 431 272 431H323Q330 424 330 420Q330 398 317 385H210L174 240Q135 80 135 68Q135 26 162 26Q197 26 230 60T283 144Q285 150 288 151T303 153H307Q322 153 322 145Q322 142 319 133Q314 117 301 95T267 48T216 6T155 -11Q125 -11 98 4T59 56Q57 64 57 83V101L92 241Q127 382 128 383Q128 385 77 385H26",
  119906: "21 287Q21 295 30 318T55 370T99 420T158 442Q204 442 227 417T250 358Q250 340 216 246T182 105Q182 62 196 45T238 27T291 44T328 78L339 95Q341 99 377 247Q407 367 413 387T427 416Q444 431 463 431Q480 431 488 421T496 402L420 84Q419 79 419 68Q419 43 426 35T447 26Q469 29 482 57T512 145Q514 153 532 153Q551 153 551 144Q550 139 549 130T540 98T523 55T498 17T462 -8Q454 -10 438 -10Q372 -10 347 46Q345 45 336 36T318 21T296 6T267 -6T233 -11Q189 -11 155 7Q103 38 103 113Q103 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287",
  119907: "173 380Q173 405 154 405Q130 405 104 376T61 287Q60 286 59 284T58 281T56 279T53 278T49 278T41 278H27Q21 284 21 287Q21 294 29 316T53 368T97 419T160 441Q202 441 225 417T249 361Q249 344 246 335Q246 329 231 291T200 202T182 113Q182 86 187 69Q200 26 250 26Q287 26 319 60T369 139T398 222T409 277Q409 300 401 317T383 343T365 361T357 383Q357 405 376 424T417 443Q436 443 451 425T467 367Q467 340 455 284T418 159T347 40T241 -11Q177 -11 139 22Q102 54 102 117Q102 148 110 181T151 298Q173 362 173 380",
  119908: "580 385Q580 406 599 424T641 443Q659 443 674 425T690 368Q690 339 671 253Q656 197 644 161T609 80T554 12T482 -11Q438 -11 404 5T355 48Q354 47 352 44Q311 -11 252 -11Q226 -11 202 -5T155 14T118 53T104 116Q104 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287Q21 293 29 315T52 366T96 418T161 441Q204 441 227 416T250 358Q250 340 217 250T184 111Q184 65 205 46T258 26Q301 26 334 87L339 96V119Q339 122 339 128T340 136T341 143T342 152T345 165T348 182T354 206T362 238T373 281Q402 395 406 404Q419 431 449 431Q468 431 475 421T483 402Q483 389 454 274T422 142Q420 131 420 107V100Q420 85 423 71T442 42T487 26Q558 26 600 148Q609 171 620 213T632 273Q632 306 619 325T593 357T580 385",
  119909: "52 289Q59 331 106 386T222 442Q257 442 286 424T329 379Q371 442 430 442Q467 442 494 420T522 361Q522 332 508 314T481 292T458 288Q439 288 427 299T415 328Q415 374 465 391Q454 404 425 404Q412 404 406 402Q368 386 350 336Q290 115 290 78Q290 50 306 38T341 26Q378 26 414 59T463 140Q466 150 469 151T485 153H489Q504 153 504 145Q504 144 502 134Q486 77 440 33T333 -11Q263 -11 227 52Q186 -10 133 -10H127Q78 -10 57 16T35 71Q35 103 54 123T99 143Q142 143 142 101Q142 81 130 66T107 46T94 41L91 40Q91 39 97 36T113 29T132 26Q168 26 194 71Q203 87 217 139T245 247T261 313Q266 340 266 352Q266 380 251 392T217 404Q177 404 142 372T93 290Q91 281 88 280T72 278H58Q52 284 52 289",
  119910: "21 287Q21 301 36 335T84 406T158 442Q199 442 224 419T250 355Q248 336 247 334Q247 331 231 288T198 191T182 105Q182 62 196 45T238 27Q261 27 281 38T312 61T339 94Q339 95 344 114T358 173T377 247Q415 397 419 404Q432 431 462 431Q475 431 483 424T494 412T496 403Q496 390 447 193T391 -23Q363 -106 294 -155T156 -205Q111 -205 77 -183T43 -117Q43 -95 50 -80T69 -58T89 -48T106 -45Q150 -45 150 -87Q150 -107 138 -122T115 -142T102 -147L99 -148Q101 -153 118 -160T152 -167H160Q177 -167 186 -165Q219 -156 247 -127T290 -65T313 -9T321 21L315 17Q309 13 296 6T270 -6Q250 -11 231 -11Q185 -11 150 11T104 82Q103 89 103 113Q103 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287",
  119911: "347 338Q337 338 294 349T231 360Q211 360 197 356T174 346T162 335T155 324L153 320Q150 317 138 317Q117 317 117 325Q117 330 120 339Q133 378 163 406T229 440Q241 442 246 442Q271 442 291 425T329 392T367 375Q389 375 411 408T434 441Q435 442 449 442H462Q468 436 468 434Q468 430 463 420T449 399T432 377T418 358L411 349Q368 298 275 214T160 106L148 94L163 93Q185 93 227 82T290 71Q328 71 360 90T402 140Q406 149 409 151T424 153Q443 153 443 143Q443 138 442 134Q425 72 376 31T278 -11Q252 -11 232 6T193 40T155 57Q111 57 76 -3Q70 -11 59 -11H54H41Q35 -5 35 -2Q35 13 93 84Q132 129 225 214T340 322Q352 338 347 338",
  119912: "65 0Q45 0 45 18Q48 52 61 60Q65 62 81 62Q155 62 165 74Q166 74 265 228T465 539T569 699Q576 707 583 709T611 711T637 710T649 700Q650 697 695 380L741 63L784 62H827Q839 50 839 45L835 29Q831 9 827 5T806 0Q803 0 790 0T743 1T657 2Q585 2 547 1T504 0Q481 0 481 17Q484 54 497 60Q501 62 541 62Q580 62 580 63Q580 68 573 121T564 179V181H308L271 124Q236 69 236 67T283 62H287Q316 62 316 46Q316 26 307 8Q302 3 295 0L262 1Q242 2 168 2Q119 2 93 1T65 0ZM537 372Q533 402 528 435T521 486T518 504V505Q517 505 433 375L348 244L451 243Q555 243 555 244L537 372",
  119913: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 449 686H477H586Q684 686 733 677T817 634Q853 598 853 547Q853 499 826 460T761 401T695 371T654 360H653L662 358Q670 357 683 354T712 344T744 327T774 303T795 269T804 224Q804 148 732 79T533 1Q524 0 288 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM703 550Q703 571 695 586T675 609T656 619T643 623L545 624H447L417 504Q386 384 386 383T470 382Q554 383 565 385Q632 397 667 447T703 550ZM651 240Q651 265 645 282T626 309T608 322T592 329Q587 330 479 331H373L340 198Q307 65 306 64Q306 62 406 62L507 63L519 65Q565 76 596 107T639 171T651 240",
  119914: "380 -17Q335 -17 293 -10T207 16T130 65T76 144T55 256Q55 306 70 361T122 476T211 582T345 663T525 702H545Q673 702 731 634L777 668Q783 672 789 677T800 685T808 691T814 695T818 698T822 700T825 702T828 703T830 703T833 703Q855 703 855 690Q855 686 823 558T789 426Q786 421 782 420T756 419Q734 420 729 421T724 432Q724 434 725 447T726 472Q726 552 678 604Q640 640 586 640H574Q533 640 494 632T409 604T324 541T260 437Q243 397 227 333T210 219Q210 152 237 117Q255 90 299 68T420 46H429Q506 46 580 100T678 234Q683 249 687 251T712 254H723Q743 254 743 240Q743 232 736 213T710 162T663 100T586 40T477 -5Q433 -17 380 -17",
  119915: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 437 686Q659 686 668 685Q727 680 772 662T842 621T883 568T905 517T913 475Q914 466 914 434Q914 373 892 307T828 179T712 69T548 7Q517 2 494 2T279 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM768 475Q768 515 753 544T718 588T666 611T613 622T563 624H538H532H452L382 344Q311 64 311 63T363 62H405Q490 62 545 76T656 142Q696 185 724 265T760 399T768 475",
  119916: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H811Q817 677 820 673T824 666L825 664Q825 659 814 549T799 433Q793 424 771 424Q752 424 746 427T740 441Q740 445 742 466T744 505Q744 561 722 585T646 616Q639 617 545 618H456Q456 617 427 502T398 385Q398 384 435 384Q461 385 471 385T499 391T526 405T545 433T562 478Q566 494 571 497T595 501H604Q622 501 626 486Q626 482 593 349T557 213Q552 205 530 205Q499 205 499 219Q499 222 503 242T508 281Q508 308 491 314T429 322Q425 322 423 322H382L317 64Q317 62 390 62Q460 62 493 64T569 80T640 124Q665 149 686 187T719 253T733 283Q739 289 760 289Q791 289 791 274Q791 267 763 201T706 71L678 8Q676 4 667 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
  119917: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H795Q801 677 804 673T808 666L809 664Q809 659 798 549T783 433Q777 424 755 424Q736 424 730 427T724 444Q724 448 725 468T727 507V524Q727 541 724 554T713 577T698 594T676 605T653 612T625 616T597 617T566 618T538 618H456L455 614Q455 611 424 491L394 371H429Q454 372 463 372T491 378T517 392T536 419T552 464Q556 481 561 484T586 488Q603 488 607 486Q616 482 616 473Q616 467 584 337T549 201Q542 192 521 192Q503 192 497 195T490 209Q490 212 492 224Q499 251 499 269Q499 288 489 296T465 306T417 308L379 309L348 188Q341 161 334 129T322 80L318 65L317 62H375H409Q430 62 438 59T447 45Q444 8 431 2L426 0L377 1Q347 2 231 2Q152 2 111 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
  119918: "379 -16Q233 -16 145 52T56 255Q56 310 73 368T127 483T216 586T347 663T518 702H540Q562 702 582 700T616 696T644 689T667 681T686 670T702 659T717 647T731 635L776 668Q782 672 788 677T799 685T807 691T813 695T817 698T821 700T824 702T827 703T829 703T832 703Q854 703 854 690Q854 686 822 558T788 426Q785 421 781 420T755 419Q734 420 729 422T723 432Q723 434 724 446T725 469Q725 531 702 571T642 628Q616 640 575 640Q468 640 390 593T272 464Q247 415 229 340T210 214Q210 166 228 132T277 79T343 54T419 46Q445 46 465 50T500 59T526 76T544 96T557 123T566 150T574 182T581 214H519Q511 214 498 214T479 213Q443 213 443 230Q443 250 452 268Q457 273 464 276L514 275Q546 274 657 274Q735 274 768 275T803 276Q826 276 826 258Q823 224 810 216Q806 214 771 214H736Q736 211 710 109T683 5Q678 0 671 0Q666 0 637 14T597 36Q593 38 590 40T585 44T582 44T576 40Q511 -16 379 -16",
  119919: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L399 389Q399 388 547 388H695L753 623Q753 624 709 624H686Q665 624 660 626T650 639Q653 678 668 684Q672 686 681 686Q685 686 726 685T847 684Q902 684 937 684T986 685T1004 686Q1027 686 1027 668Q1023 632 1011 626Q1006 624 957 624H908L839 344Q768 64 768 63T812 62H839Q871 62 871 44Q867 6 854 2L850 0L808 1Q782 2 675 2Q600 2 560 1T516 0Q499 0 494 15Q498 54 511 60Q515 62 564 62H613L614 66L679 324Q679 326 531 326H383L382 322L317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624",
  119920: "247 624Q242 624 233 624T220 623Q186 623 186 640Q186 647 190 664T202 684Q206 686 226 686Q277 684 393 684Q435 684 471 684T528 685T553 686Q573 686 573 670Q573 650 564 632Q556 624 537 624H501H449L380 344Q309 64 309 63T356 62Q361 62 370 62T384 63Q417 63 417 46Q417 26 408 8Q403 3 396 0L352 1Q325 2 216 2T82 1L45 0Q30 7 30 16Q33 51 46 60Q51 62 102 62H154L294 623Q294 624 247 624",
  119921: "205 131Q205 105 192 84T165 54L152 45Q152 44 160 42T182 37T213 35H216Q255 35 289 65Q314 90 329 129Q331 136 392 378T453 623Q453 624 393 624H332Q318 631 318 640Q318 647 322 664T334 684Q338 686 359 686Q413 684 533 684Q566 684 605 685T652 686Q677 686 685 683T694 669Q694 664 691 652Q686 631 681 628T647 624H602L542 380Q531 336 518 285T500 212T487 161T475 122T463 97T448 74T429 55Q351 -17 213 -17Q142 -17 99 7T43 70Q42 75 42 93Q42 143 73 168T139 194Q168 194 186 177T205 131",
  119922: "536 0Q522 6 522 18Q522 35 533 57Q539 62 557 62Q595 62 601 65L472 330L365 255L342 160Q318 65 317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L422 481Q386 339 386 337L785 621Q779 624 749 624Q726 624 726 641Q726 645 730 659Q734 675 736 679T747 686L786 685Q812 684 888 684Q908 684 934 685T968 686Q1003 686 1003 669Q1003 646 991 629Q985 624 967 624Q918 624 888 617Q884 617 874 613L865 609Q864 608 732 515T599 420Q599 418 686 242T775 65Q784 62 829 62Q847 62 850 61T860 54Q862 52 862 43Q862 10 845 1Q844 1 842 1T836 0T797 1T694 2Q599 2 573 1L536 0",
  119923: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 409 684Q454 684 492 684T552 685T579 686Q603 686 603 668Q599 632 587 626Q583 624 520 624H457L388 344Q317 64 317 63T353 62H390Q418 62 440 64T493 78T548 110T598 169T643 261Q651 282 655 285T680 289Q696 289 700 288T709 279Q711 274 711 269Q710 265 663 138T613 8Q611 4 602 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624",
  119924: "258 624H231Q214 624 208 626T199 639Q203 678 216 684Q220 686 347 686H473Q474 685 478 682T484 677Q487 673 535 413L584 153L608 187Q631 221 672 281T761 410Q935 663 943 671Q949 678 962 686H1082H1166Q1201 686 1210 683T1219 668Q1215 632 1203 626Q1199 624 1149 624H1100L1031 344Q960 64 960 63T1004 62H1031Q1063 62 1063 44Q1060 7 1046 2Q1042 0 1034 0Q1030 0 990 1T875 2Q804 2 767 1T725 0H723Q707 0 703 15Q707 54 720 60Q724 62 773 62H822Q961 618 961 619L754 318Q546 15 543 12Q531 0 510 0Q500 0 495 0T484 5T477 19Q477 20 421 315L367 604L299 335Q234 72 234 68Q234 62 302 62Q334 62 334 46Q332 8 317 2Q313 0 306 0Q301 0 267 1T181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
  119925: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 344 686H434Q464 686 477 680Q480 677 607 454Q738 227 739 227Q742 227 789 418T836 618Q836 620 835 620L821 622Q811 622 779 624Q755 624 749 625T740 632Q737 635 737 644Q737 656 742 669T754 685Q755 685 757 685T763 686Q768 686 803 685T890 684Q925 684 951 684T990 685T1006 686Q1014 686 1016 684Q1027 679 1027 668Q1023 632 1011 626Q1007 624 978 624Q912 622 907 617Q907 616 831 314T753 8Q749 0 723 0H712Q699 0 692 7Q692 8 671 44T607 155T526 296L361 580L296 323Q234 74 234 68T302 62H307Q334 62 334 44Q330 6 317 2L313 0L280 1Q260 2 181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
  119926: "53 245Q53 297 70 356T125 478T216 590T349 671T523 703Q656 703 735 637T815 445Q815 378 791 307Q727 104 527 17Q437 -17 344 -17Q289 -17 242 -5T150 35T79 116T53 245ZM664 489Q664 575 618 611T511 648Q463 648 416 627T334 570Q297 531 270 472T230 355T213 261T208 206Q208 177 215 151T237 98T284 56T358 40Q440 40 510 98T618 270Q664 400 664 489",
  119927: "162 62L302 623Q302 624 258 624H234Q214 624 209 626T200 638Q200 677 217 684Q220 686 439 686Q667 685 684 682Q686 681 693 680Q713 677 733 671T782 649T829 602T847 528Q847 450 784 382T604 293Q571 288 469 287H373L346 176Q340 151 333 122T321 78L317 64Q317 62 361 62H387Q420 62 420 44Q417 10 404 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q43 0 43 17Q43 21 47 33Q52 54 57 58T89 62H113H162ZM692 558Q692 611 617 622Q610 623 529 624H452L381 343H458H492Q604 343 641 389Q662 414 677 471T692 558",
  119928: "53 245Q53 297 70 356T125 478T216 590T349 671T523 703Q656 703 735 637T815 445Q815 410 808 370T781 277T729 178T643 87T519 14L525 4Q540 -19 553 -25T592 -32Q632 -32 654 -24T680 -7T689 10T704 18Q713 18 717 12T722 0Q722 -8 711 -36T681 -101T624 -166T541 -194Q513 -194 494 -183T465 -157T450 -118T444 -79T443 -41V-7L433 -9Q391 -17 344 -17Q301 -17 263 -10T185 15T118 62T71 138T53 245ZM666 482Q666 529 652 563T614 615T565 640T512 648Q412 648 335 573Q268 506 235 389T201 202Q201 164 210 136T230 95T259 66L262 76Q269 109 302 135T382 162Q401 162 415 159T449 140T484 92L491 78L496 82Q502 86 505 88T515 97T528 107T541 120T555 137T570 156T585 179T599 205T612 235Q629 278 647 351T666 482ZM439 56Q439 58 439 62T435 75T426 92T410 106T383 112Q353 112 332 96T311 63Q311 38 355 38H366Q391 39 415 45T439 56",
  119929: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 422 686H446H525Q634 686 698 674T806 620Q843 583 843 535Q843 505 833 478T805 432T768 396T728 370T690 352T662 342L651 338L654 336Q658 334 667 327T688 310Q719 278 719 237Q719 222 710 165T701 94Q701 35 748 35Q775 35 793 57T819 101Q822 112 826 114T843 117H849Q881 117 881 99Q881 78 852 39T781 -11Q765 -17 728 -17Q537 -13 537 94Q537 110 552 169T567 243Q567 292 529 309Q517 316 508 316T441 318H375L374 314Q374 312 343 189T311 64Q311 62 355 62H382Q414 62 414 44Q410 6 397 2L393 0L351 1Q325 2 221 2Q147 2 108 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM687 555Q687 617 589 623Q581 624 513 624H451L420 498Q413 468 405 436T392 388L388 371Q388 369 458 369Q464 369 485 369T515 369T541 372T570 377T596 386T624 400Q649 417 664 457T683 522T687 555",
  119930: "354 45Q429 45 467 91T506 184Q506 225 477 250Q461 262 384 279T294 300Q238 318 210 362T182 452Q182 493 202 540T257 623Q338 702 449 702Q491 702 501 701Q571 690 610 654Q614 649 617 650Q618 650 650 675T683 702Q685 703 692 703Q714 703 714 690Q714 686 687 578T658 466Q653 458 629 458Q606 458 602 463Q600 465 599 466Q599 467 599 469T598 473Q598 475 599 487T600 511Q600 584 557 614T454 645Q386 645 347 606T308 520Q308 506 311 496T323 477T338 464T360 454T384 446T413 439T441 433Q523 416 549 401Q581 384 602 352Q631 309 631 254Q631 214 615 170T567 83T478 12T347 -16Q322 -16 300 -14T261 -8T230 0T205 10T187 20T172 30L162 37L130 11Q124 7 119 3T110 -4T104 -9T100 -13T96 -15T93 -16T91 -17T88 -17H82Q76 -17 73 -16T69 -14T66 -10T63 -5L90 107Q97 133 106 170Q116 211 120 219T136 228H148Q167 228 173 227T179 218Q179 216 176 200T173 168Q173 102 227 74T354 45",
  119931: "498 62Q511 58 511 43Q511 10 494 1L490 0Q487 0 482 0T424 1T271 2Q201 2 157 2T94 1T72 0H70Q46 0 46 17Q49 54 62 60L66 62H137Q208 62 209 63L218 98Q227 134 244 203T278 339L347 613H300Q262 612 246 611T198 599T146 564Q128 545 114 512T91 454T79 425Q73 419 52 419Q22 419 22 434Q22 440 41 498T80 611L100 666Q105 673 111 675H434Q758 675 762 673Q772 668 772 657Q772 655 756 549T738 434Q735 419 711 419H707Q690 419 686 421Q677 425 677 434Q676 436 678 449T683 485T686 529Q686 553 679 569T662 594T631 607T593 612T544 613H502L433 340Q418 279 400 207T374 100L365 65L364 62H498",
  119932: "856 686Q877 686 877 668Q877 663 873 649T867 631Q861 624 828 624Q762 622 757 617Q757 613 705 409T651 200Q620 112 540 48T328 -16Q251 -16 196 2T113 51T75 112T63 176Q63 202 70 232T117 422Q129 469 141 520T160 598L167 623Q167 624 123 624H96Q79 624 73 626T64 639Q68 678 81 684Q85 686 104 686Q155 684 268 684Q340 684 377 685T418 686Q441 686 441 668Q437 632 425 626Q421 624 371 624H322L270 415Q224 232 217 198T209 141Q209 45 336 45Q372 45 406 52T475 77T540 128T585 211L590 229Q594 247 601 274T617 336T636 409T654 482T670 547T681 595T686 618Q686 620 685 620H683Q681 621 678 621T671 622Q660 622 630 624Q616 624 610 624T598 626T589 630T587 640Q587 647 590 659Q594 677 598 681T613 686Q618 686 653 685T740 684Q775 684 801 684T840 685T856 686",
  119933: "401 686Q415 680 415 668Q415 651 404 629Q398 624 356 624Q318 624 318 623Q318 620 337 508T377 284L397 174L472 285Q548 396 623 507T699 620Q698 621 652 624Q634 624 627 627T619 641Q619 648 622 658Q627 677 631 681T650 686Q654 686 686 685T766 684Q794 684 823 684T858 685Q874 685 878 683T886 671Q886 667 882 651Q877 632 873 628T850 624Q800 624 779 617Q774 617 770 613Q767 610 560 304T350 -5Q346 -9 332 -16H306H291Q270 -16 267 -2Q267 -1 260 37T238 161T210 313L156 624H116H94Q62 624 62 642Q66 678 78 684Q82 686 99 686Q144 684 246 684Q330 684 368 685L401 686",
  119934: "111 624Q109 624 102 624T91 623Q61 623 61 640Q61 660 70 678Q78 686 98 686Q140 684 239 684Q277 684 309 684T360 685T383 686H385Q407 686 407 668Q404 634 391 626Q387 624 348 624Q307 624 307 622Q307 618 332 409Q359 198 359 195L570 532L564 576L558 622V624H522H504Q472 624 472 641Q475 678 488 684L493 686L529 685Q551 684 645 684Q716 684 753 685T795 686Q818 686 818 669Q815 632 802 626Q798 624 759 624Q718 624 718 622Q718 615 743 410Q770 199 770 196Q770 195 806 253T903 406Q1035 618 1035 619Q1025 624 968 624Q943 624 943 641Q943 648 946 659Q950 675 952 679T963 686L998 685Q1020 684 1093 684Q1113 684 1139 685T1173 686Q1207 686 1207 669Q1207 664 1204 652Q1199 631 1194 628T1164 624Q1113 622 1101 615Q1098 612 905 305Q715 -1 709 -7Q699 -17 673 -17Q645 -17 639 -8L581 441Q581 444 442 221Q331 44 314 18T288 -14Q279 -17 263 -17H254Q229 -17 227 -5Q225 2 186 311L147 620V624H111",
  119935: "931 686Q953 686 953 670Q953 650 944 632Q936 624 924 624H914Q823 624 803 611Q800 609 696 503T591 396Q591 394 667 229L743 62H787H814Q846 62 846 44Q843 7 829 2Q825 0 817 0Q813 0 775 1T664 2Q590 2 551 1T508 0H507Q484 0 484 18Q484 19 488 37Q492 56 497 58T534 62L566 63Q567 64 520 169T471 274Q469 274 369 172T268 67L315 62Q320 62 328 62L335 61Q347 58 347 44Q344 10 331 2L326 0L287 1Q263 2 177 2Q95 2 78 1L53 0Q38 6 38 17Q38 40 50 57Q56 62 78 62Q169 62 188 75Q194 77 435 324L444 334L439 347Q437 351 373 492L313 624H268H246Q220 624 212 632Q210 636 210 642Q210 655 215 669T227 684Q230 686 247 686Q295 684 398 684Q438 684 472 684T527 685T551 686Q567 686 572 671Q572 667 568 651Q563 631 558 628T523 624T492 623H488L526 540Q563 457 564 457Q564 456 574 466T604 496T645 537L724 619Q716 622 677 624H673Q645 624 645 640Q645 660 654 678Q659 683 666 686L704 685Q728 684 813 684Q847 684 873 684T913 685T931 686",
  119936: "97 624H73Q40 624 40 640Q40 660 49 678Q57 686 77 686Q122 684 228 684Q269 684 304 684T360 685T385 686Q406 686 406 668Q406 662 403 653Q398 631 393 628T361 624H353Q321 624 321 623T376 491T432 360L448 377Q465 394 493 424T553 490L673 620Q662 624 630 624Q606 624 606 640Q608 678 623 684Q627 686 634 686Q638 686 671 685T755 684Q777 684 805 685T841 686Q861 686 868 683T876 669Q876 664 873 652Q868 631 863 628T829 624Q764 622 747 611Q727 590 590 441L437 275L411 170Q385 65 384 64Q384 62 429 62H453Q473 62 478 60T487 48Q488 44 484 29Q479 6 473 3Q468 0 454 0Q450 0 436 0T386 1T294 2Q220 2 181 1T138 0Q121 0 116 15Q120 54 133 60Q137 62 187 62H236L289 275L142 624H97",
  119937: "223 430Q192 430 192 448Q192 450 225 561T261 677Q265 683 270 684Q273 686 534 686Q796 686 797 685Q805 682 805 673Q805 668 804 661T800 648T798 641Q796 637 531 352L266 67L329 66H364Q412 66 446 70T523 96T596 157Q617 186 630 220T649 273T663 297Q667 299 684 299H688Q715 299 715 281Q715 278 673 145T628 8Q626 4 617 0H348Q289 0 221 0T139 -1Q112 -1 99 -1T78 1T69 5T68 12Q68 16 71 31T77 49L84 57Q91 65 104 79T133 110T170 151T213 196L610 624H540Q533 624 514 624T488 624T467 623T443 620T422 616T398 609T373 600Q292 560 255 449Q251 436 246 433T223 430",
  119938: "222 -8Q140 -8 89 34T38 158Q38 191 48 227Q72 329 151 390T327 452Q361 452 385 443T421 425T433 416H434L441 421Q448 426 460 430T486 435Q509 435 523 422T538 386Q538 380 522 315T488 179T467 93Q466 87 466 72Q466 42 483 42Q505 42 521 75Q531 94 541 134Q546 155 550 158T571 162H576H587Q607 162 607 148Q606 142 604 132T590 94T566 47T528 9T474 -8Q396 -8 358 40Q295 -8 222 -8ZM404 351Q383 401 324 401Q300 401 270 385T221 330Q206 296 186 220Q166 136 166 106Q166 72 184 58T228 43Q256 43 284 57T328 84T343 103Q343 106 374 228L404 351",
  119939: "220 -8Q142 -8 94 35T45 155V167Q45 187 52 218T104 426L153 622H149Q148 622 144 622T134 623T122 624T111 624T101 624T96 625Q84 628 84 642Q84 647 88 661T94 679Q98 684 109 685T185 690Q258 694 272 694Q289 694 293 679Q293 676 263 553L232 429L244 434Q256 440 281 446T331 452Q417 452 465 407T513 285Q513 235 494 184T439 90T346 20T220 -8ZM385 337Q385 400 318 400Q269 400 226 360Q214 349 211 341T191 268Q162 149 162 113Q162 44 226 44Q269 44 299 76T339 135T362 215Q364 222 365 226Q385 303 385 337",
  119940: "362 325Q362 344 371 361T390 386L399 394Q390 401 355 401Q276 401 231 338Q207 301 189 230T170 122Q170 43 264 43Q392 43 457 105Q472 120 480 117Q486 114 497 102T509 83Q509 79 502 70T477 47T432 21T360 1T259 -8Q194 -8 148 9T80 54T49 109T40 167Q40 280 129 365T352 451Q390 451 396 450Q448 442 473 416T499 358T477 302T421 274H417Q393 274 378 288T362 325",
  119941: "222 -8Q140 -8 89 34T38 158Q38 220 68 285T151 391Q230 452 329 452Q382 452 416 428L422 424Q423 424 447 523L472 622H468Q467 622 463 622T453 623T441 624T430 624T420 624T415 625Q403 628 403 642Q403 647 407 661T413 679Q417 684 428 685T504 690Q577 694 591 694Q608 694 612 679L467 91Q466 87 466 72Q466 43 483 43Q518 43 541 134Q546 155 550 158T571 162H576H587Q607 162 607 148Q606 142 604 132T590 94T566 47T528 9T474 -8Q396 -8 358 40Q295 -8 222 -8ZM404 351Q383 401 324 401Q300 401 270 385T221 330Q206 296 186 220Q166 136 166 106Q166 72 184 58T228 43Q256 43 284 57T328 84T343 103Q343 106 374 228L404 351",
  119942: "260 -8Q196 -8 151 9T83 54T52 111T42 169Q42 188 44 210Q50 240 58 266Q127 434 335 451L338 452Q342 452 345 452Q347 452 353 452T363 451Q426 451 464 424T502 352Q502 289 442 250Q381 211 222 211H184Q184 210 181 196T175 162T171 126Q171 43 264 43Q391 43 457 105Q472 120 480 117Q486 114 497 102T509 83Q509 79 502 70T477 47T432 21T360 1T260 -8ZM237 262Q427 266 427 349Q427 368 409 384T354 401Q316 401 287 388T242 354T216 314T202 278L197 263Q197 262 237 262",
  119943: "584 444Q597 439 597 426Q597 409 586 387Q580 382 505 382H434V380Q432 378 421 314T395 162T368 30Q324 -164 203 -199Q194 -201 175 -201Q123 -201 94 -177T64 -117T88 -58T145 -33Q169 -33 184 -47T200 -84Q200 -122 166 -150L174 -151H185Q202 -148 217 -112Q222 -94 240 9Q246 40 262 132T293 303T307 382H247H210Q190 382 182 385T173 400Q177 436 189 442Q193 444 256 444H318L319 446Q337 565 355 602Q373 640 404 664T458 694T503 701Q569 701 596 676T624 617Q624 581 599 557T544 533Q520 533 504 547T488 585Q488 596 491 606T499 624T508 637T516 646L520 650Q515 650 509 651Q459 651 459 561V554L458 518L452 484Q446 448 445 447V444H584",
  119944: "227 0Q142 0 93 43T43 166Q43 207 58 252T104 341T188 414T310 451L313 452Q316 452 319 452Q321 452 326 452T335 451Q367 451 390 443T425 425L436 416L443 421Q450 426 462 430T488 435Q511 435 525 422T540 386Q540 378 483 151T424 -82Q401 -139 335 -170T167 -202Q72 -202 36 -183T0 -125Q0 -90 24 -67T81 -43Q103 -43 119 -56T136 -99Q133 -124 114 -149L123 -150H183Q222 -150 254 -127T299 -74Q300 -71 306 -47T318 -1T324 23Q323 23 310 18T274 6T227 0ZM407 353Q406 354 404 358T400 365T395 371T388 379T381 385T371 391T360 396T346 400T329 401Q300 401 277 389T240 355T219 317T205 280Q171 148 171 109Q171 77 190 64T235 51T296 67Q322 82 337 98L345 106L407 353",
  119945: "477 56Q477 48 479 46T490 43Q522 45 544 75T577 140Q582 156 585 159T605 162H611H622Q642 162 642 148Q642 138 632 114T602 62T550 13T478 -8Q429 -8 394 17T358 83Q358 95 395 199T433 350Q433 400 394 400H388H383Q335 400 291 363Q256 332 236 298Q233 293 202 170T169 40Q160 18 141 5T99 -8Q70 -8 58 9T45 39Q45 51 116 336L188 622H184Q183 622 179 622T169 623T157 624T146 624T136 624T131 625Q119 628 119 642Q119 647 123 661T129 679Q133 684 144 685T220 690Q293 694 307 694Q324 694 328 679Q328 672 294 540Q286 507 278 473T264 420L260 403Q260 400 269 408Q327 451 393 451H401H410Q425 451 439 450T476 442T515 424T544 391T556 337Q556 286 517 179T477 56",
  119946: "205 615Q205 646 229 670T283 694Q310 694 324 679T339 641Q339 610 315 586T258 562Q235 562 220 577T205 615ZM24 296Q24 305 34 328T63 380T115 430T187 452Q205 452 223 448T262 435T295 406T308 360Q308 345 287 290T240 170T207 87Q202 67 202 57Q202 42 215 42Q235 42 257 64Q288 92 302 140Q307 156 310 159T330 162H336H347Q367 162 367 148Q367 140 357 117T329 65T276 14T201 -8Q158 -8 121 15T83 84Q83 104 133 229T184 358Q189 376 189 388Q189 402 177 402Q156 402 134 380Q103 352 89 304Q84 288 81 285T61 282H55H44Q24 282 24 296",
  119947: "321 616Q321 648 346 671T400 694Q425 694 440 680T456 640Q456 609 431 586T376 562Q353 562 337 577T321 616ZM297 360T297 373T294 392T288 400T278 401H276Q241 399 210 372T158 303Q151 287 148 285T129 282H123H116Q102 282 97 284T92 298Q96 331 153 391T279 451Q357 451 388 422T420 354V339L371 142Q363 111 353 71T339 13T329 -30T318 -64T308 -88T296 -109T283 -125T264 -142Q190 -202 88 -202Q44 -202 16 -181T-12 -125Q-12 -93 11 -68T68 -43Q92 -43 108 -58T124 -93Q124 -121 106 -144Q101 -150 103 -150Q120 -150 147 -128T191 -64Q194 -57 242 136T294 345Q297 360 297 373",
  119948: "99 -8Q71 -8 58 9T45 39Q45 51 116 336L188 622H184Q183 622 179 622T169 623T157 624T146 624T136 624T131 625Q119 628 119 642Q119 647 123 661T129 679Q133 684 144 685T220 690Q293 694 307 694Q324 694 328 679Q328 674 280 482Q231 290 231 287Q231 285 234 286Q259 302 294 334T356 390T420 433T493 452Q528 452 546 427T564 364Q564 308 538 282T480 256Q456 256 441 269T425 308Q425 339 444 359T483 384L502 389Q502 395 496 398Q493 400 483 400Q465 400 449 395T409 374T373 347T323 305T268 257Q274 256 282 256Q312 251 329 247T371 232T411 202Q431 181 431 146Q431 132 427 110T422 73Q422 44 440 44H442Q462 44 478 64T502 102T514 141Q518 157 522 159T547 162H558Q578 162 578 148Q578 118 537 56T440 -7H432Q374 -7 337 21T299 94Q299 103 301 116T304 139Q304 164 281 181T235 202L212 206H211Q176 47 160 24Q137 -8 99 -8",
  119949: "157 -8Q138 -8 118 -4T77 11T41 42T27 91V106L156 622H152Q151 622 147 622T137 623T125 624T114 624T104 624T99 625Q87 628 87 642Q87 647 91 661T97 679Q101 684 112 685T188 690Q261 694 275 694Q292 694 296 679L151 91Q150 85 150 71Q150 42 167 42Q186 42 205 75Q216 96 225 134Q230 155 234 158T255 162H260H271Q291 162 291 148Q290 145 289 140T283 118T271 87T254 54T229 23T197 1T157 -8",
  119950: "24 296Q25 302 27 312T41 350T65 397T104 435T159 452Q203 452 234 435Q268 419 285 384L295 392Q305 401 317 410T349 429T389 445Q411 451 446 451Q560 451 592 383Q593 380 594 379L595 375L604 384Q675 452 762 452Q893 452 916 367Q918 356 918 334Q918 285 881 183T841 66Q838 43 849 43Q876 43 901 69T940 138Q945 156 949 159T969 162H975H986Q1006 162 1006 148Q1006 138 996 115T966 63T914 13T841 -8Q794 -8 758 16T721 82Q721 96 758 199T796 351Q796 401 753 401Q702 401 662 369T599 298Q597 294 567 172T533 40Q525 22 506 7T462 -8Q435 -8 422 8T409 39Q409 48 425 114T458 248T476 320Q478 330 478 348T474 377T462 393T449 399T433 400H428Q380 400 336 363Q301 332 281 298Q278 293 247 170T214 40Q206 22 187 7T143 -8T104 7T90 39Q90 47 108 124T146 274L164 347Q166 355 166 372Q166 401 149 401Q129 401 115 379T89 306Q84 288 80 285T55 282H44Q24 282 24 296",
  119951: "24 296Q25 302 27 312T41 350T65 397T104 435T159 452Q203 452 234 435Q268 419 285 384L293 391Q363 452 454 452Q575 446 597 367Q599 356 599 334Q599 285 562 183T522 66Q519 43 530 43Q557 43 582 69T621 138Q626 156 630 159T650 162H656H667Q687 162 687 148Q687 138 677 115T647 63T595 13T522 -8Q475 -8 439 16T402 82Q402 96 439 199T477 351Q477 401 434 401Q421 401 409 398Q341 388 285 305L278 295L247 170Q216 46 214 40Q206 22 187 7T143 -8T104 7T90 39Q90 47 108 124T146 274L164 347Q166 355 166 372Q166 401 149 401Q129 401 115 379T89 306Q84 288 80 285T55 282H44Q24 282 24 296",
  119952: "254 -8Q191 -8 146 9T80 54T49 111T39 169Q39 206 53 247T96 329T176 402T292 446Q317 451 336 451L344 452Q353 452 359 452Q457 452 516 408T576 279Q576 169 488 81T254 -8ZM349 400Q321 400 287 385T231 338Q206 301 188 228T170 126Q170 99 178 83Q198 44 260 44Q367 44 409 157Q419 185 432 238T445 317Q445 336 443 348Q435 372 416 384T384 398T349 400",
  119953: "24 296Q25 302 27 312T41 350T65 397T103 435T157 452Q235 452 273 404Q336 452 409 452Q434 452 458 448T507 432T550 402T581 354T593 285Q593 221 564 159T480 53Q401 -8 302 -8Q290 -8 279 -7T259 -3T242 3T228 9T218 14T212 18L209 20Q208 19 190 -55T171 -131T198 -132H213Q240 -132 240 -150Q237 -187 223 -192Q219 -194 212 -194Q208 -194 176 -193T95 -192Q48 -192 24 -193T-3 -194Q-11 -194 -16 -190T-22 -182T-23 -176Q-20 -142 -7 -134Q-3 -132 20 -132H44L164 354Q165 357 165 372Q165 401 148 401Q113 401 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296ZM465 339Q465 373 447 387T403 401Q375 401 347 387T303 360T288 341Q288 338 257 216L227 93Q248 43 306 43Q332 43 361 59T410 115Q425 147 445 224Q465 309 465 339",
  119954: "38 159Q38 209 58 260T113 355T205 425T327 452Q338 452 348 451T366 449T382 444T394 440T405 434T414 429T422 423T429 418Q440 429 481 440T533 452Q540 452 545 447T550 437Q550 432 481 152Q410 -130 410 -131T437 -132H452Q479 -132 479 -150Q476 -187 462 -192Q458 -194 451 -194Q447 -194 414 -193T330 -192Q277 -192 249 -193T217 -194Q202 -194 197 -179Q197 -175 201 -159Q206 -139 211 -136T243 -132H283L319 15L307 10Q295 4 270 -2T220 -8Q134 -8 86 37T38 159ZM402 353Q402 358 395 368T369 390T324 401Q301 401 282 394T249 369T226 338T208 297T196 258T186 218Q166 141 166 107Q166 44 229 44Q265 44 294 61T337 95Q341 100 371 222T402 353",
  119955: "24 296Q24 298 28 313T42 352T67 398T104 436T154 452Q198 452 230 437T273 404L282 411Q334 452 393 452Q441 452 470 423T500 350Q500 301 473 279T418 256Q395 256 379 270T363 308Q363 366 424 386Q424 388 420 391T405 398T385 401Q363 401 343 390Q321 380 289 341L252 192Q214 42 212 39Q190 -8 142 -8Q117 -8 103 7T89 39Q89 52 127 202T165 369Q165 402 148 402Q139 402 128 393T110 369Q100 348 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296",
  119956: "140 290Q140 311 148 336T176 388T235 433T326 451H336Q355 451 373 449T418 439T460 412T476 363Q476 333 456 311T406 289Q384 289 371 302T357 335Q357 351 364 364T379 384L386 391Q386 392 381 394T362 398T330 400Q299 400 278 393T247 373T235 352T232 335Q232 322 242 312Q258 299 315 290T403 260Q457 224 457 167Q457 152 453 134T435 90T397 43T330 7T229 -8Q133 -8 95 22T57 91Q57 127 81 152T139 177Q161 177 177 164T194 121Q189 80 153 56Q179 43 236 43Q275 43 303 52T343 75T361 101T366 124Q366 148 338 161T272 180T232 186Q187 198 164 227T140 290",
  119957: "82 382H55Q21 382 21 399Q21 422 33 439Q39 444 93 444H144L162 517Q163 522 167 541T174 567T181 589T192 611T206 627T226 639T253 643Q276 643 291 630T306 594Q306 586 288 514Q284 499 280 481T273 454L271 445Q271 444 317 444Q322 444 331 444T345 445Q377 445 377 428Q377 408 368 390Q360 382 341 382H306H255Q182 86 182 75Q182 43 201 43H204Q242 46 279 81Q298 101 309 119T323 145T330 157T350 162H356H363Q377 162 382 160T387 146Q385 136 372 114T337 64T275 14T192 -7Q131 -7 95 19T59 90V105L128 381Q128 382 82 382",
  119958: "189 389Q189 397 187 399T176 401Q150 399 126 372T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 307 35 331T65 383T117 431T187 452Q237 452 272 427T308 362Q308 347 273 254T238 111Q238 43 291 43Q319 43 344 58T380 86T391 103T426 247T464 396Q472 414 491 429T535 444T574 429T588 397Q588 390 570 315T534 168L516 97Q514 89 514 72Q514 42 531 42Q544 42 556 56Q574 76 589 134Q594 155 598 158T619 162H624H635Q655 162 655 148Q654 142 652 132T638 94T614 47T575 9T520 -8Q509 -8 498 -7T478 -3T461 2T446 8T434 16T424 23T416 29T410 35T406 39L405 41L397 34Q347 -7 288 -7H281Q148 -7 122 78Q116 95 116 125V136Q116 174 152 273T189 389",
  119959: "380 367Q380 397 406 425T465 453Q493 453 516 430T540 357Q540 314 524 250T467 115T373 13Q338 -8 292 -8Q218 -8 167 23T116 129Q116 178 152 275T189 388Q189 396 187 398T176 401Q148 398 125 372T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 330T64 382T116 431T189 452Q231 452 269 429T308 362Q308 346 273 255T238 114Q238 43 306 43Q336 43 363 65T407 118T437 182T456 239T462 268Q462 290 417 315Q380 335 380 367",
  119960: "636 367Q636 400 664 426T719 453Q748 453 772 431T796 357Q796 321 782 256T727 112T633 6Q604 -8 567 -8Q466 -8 415 43Q414 42 410 38T403 31T396 25T388 18T378 11T367 5T355 0T340 -4T324 -7T306 -8Q249 -8 209 5T151 40T125 84T117 129Q117 176 153 274T190 388Q190 408 158 396Q112 376 90 306Q85 288 81 285T61 282H55H44Q24 282 24 296Q24 305 34 328T63 380T114 430T187 452Q240 452 274 427T309 362Q309 346 275 255T240 117Q240 43 317 43Q325 43 333 45T347 50T359 57T369 66T377 75T383 83T388 90L390 95Q390 99 389 110T387 129Q387 139 391 167Q393 177 419 282T448 396Q456 414 475 429T519 444Q546 444 559 428T572 397Q572 384 542 265T511 114Q511 43 579 43Q608 43 633 66T673 122T699 188T714 244L718 267Q718 291 673 315Q636 335 636 367",
  119961: "74 282H63Q43 282 43 296Q43 298 45 307T56 332T76 365T110 401T159 433Q200 451 233 451H236Q273 451 282 450Q358 437 382 400L392 410Q434 452 483 452Q538 452 568 421T599 346Q599 303 573 280T517 256Q494 256 478 270T462 308Q462 343 488 367Q501 377 520 385Q520 386 516 389T502 396T480 400T462 398Q429 383 415 341Q354 116 354 80T405 44Q449 44 485 74T535 142Q539 156 542 159T562 162H568H579Q599 162 599 148Q599 135 586 111T550 60T485 12T397 -8Q313 -8 266 35L258 44Q215 -7 161 -7H156Q99 -7 71 25T43 95Q43 143 70 165T125 188Q148 188 164 174T180 136Q180 101 154 77Q141 67 122 59Q124 54 136 49T161 43Q183 43 200 61T226 103Q287 328 287 364T236 400Q200 400 164 377T107 302Q103 288 100 285T80 282H74",
  119962: "206 -150Q240 -150 268 -134T314 -95T344 -48T362 -7T367 14Q339 -7 280 -7Q230 -7 195 5T144 39T122 79T115 122Q115 175 152 274T189 388Q189 396 187 398T176 401Q148 398 125 372T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 329T64 381T116 431T188 452Q239 452 273 427T308 361Q308 347 273 253T237 109Q237 43 291 43T388 98Q388 99 425 246T463 396Q471 414 490 429T534 444T573 430T587 399Q587 386 537 186T483 -25Q461 -84 410 -126T296 -188Q248 -202 204 -202Q127 -202 96 -175T64 -114Q64 -82 86 -57T144 -31Q169 -31 184 -45T199 -83Q199 -89 198 -94T196 -104T193 -113T189 -120T184 -128T179 -134T173 -141T168 -147Q189 -150 206 -150",
  119963: "66 -8H60Q34 -8 34 5Q34 9 42 22T70 59T115 110Q162 156 255 229T381 332L389 339H381Q348 332 298 329T212 325T172 321Q168 318 151 318H146Q116 318 116 332Q116 334 118 342Q128 374 154 402Q205 452 265 452Q304 452 352 422T426 392Q441 392 462 421T485 451T508 452H518Q539 452 539 438Q539 431 516 401T458 334Q412 289 312 210Q229 146 191 111L183 103H195Q203 103 213 104T240 107T268 110Q301 114 337 116T391 119T428 123T455 134T469 157Q473 166 495 166Q521 166 525 161Q532 156 528 141Q510 81 456 37T337 -7Q297 -7 251 22T177 52Q154 52 134 38T100 8L88 -7Q86 -8 66 -8",
  119964: "76 60Q83 29 135 29Q190 29 264 81Q280 93 280 95T277 99T265 106T248 118Q189 166 189 237Q189 307 245 388Q267 421 299 436Q336 455 386 455Q488 455 550 403L559 395L571 405Q727 544 944 679L957 687L966 701Q968 704 970 707T973 712T975 714T978 716T982 717T989 717H995Q1004 717 1007 717T1013 714T1016 708Q1016 705 829 403L636 92L630 83Q659 93 685 110T728 143L745 158Q758 158 752 138L748 127L740 119Q676 58 605 42L593 22Q590 17 587 12T583 6T579 2T573 0T564 0H530H484Q480 3 480 8Q480 15 489 26T498 39T497 40Q477 40 423 49T327 74L316 78L302 68Q200 -8 121 -8Q85 -8 60 7T35 53T60 113T123 144Q144 144 153 132T162 106Q162 89 143 75T99 61Q90 61 76 65V60ZM904 614L905 615Q901 615 840 573T700 469T581 369L587 359Q600 340 608 315T618 273T622 238T624 216L764 414Q904 612 904 614ZM525 363Q493 405 379 418H375Q342 418 309 378Q251 300 251 234Q251 174 306 137Q318 128 322 131Q323 132 329 139Q351 161 362 180Q430 273 509 348L525 363ZM579 205Q579 245 571 278T556 323T546 337L521 311Q461 248 422 196T362 121L353 111Q427 85 499 79Q517 77 520 77L525 76L549 111Q551 114 556 121T563 131T568 138T573 147T575 157T577 169T578 185T579 205",
  119966: "367 89Q367 84 353 77T334 70Q325 70 312 83T298 120Q298 169 364 233T496 298Q538 298 563 275T588 220V213Q588 132 501 53T306 -26Q251 -26 211 6T170 114Q171 148 181 184T205 248T232 298T255 334T265 349T246 350Q127 350 77 390T26 480Q26 533 71 581T178 656T295 683Q312 683 312 676Q312 674 311 672L302 660Q294 648 292 647L286 646Q280 646 276 646Q197 641 145 583T93 476Q93 387 265 387Q271 387 277 387T287 388T292 388T313 414T373 483T451 562Q618 712 732 727Q733 727 740 727T753 728Q790 727 804 708T819 665Q819 643 810 617T773 553T699 481T572 414T385 361Q381 361 367 341Q247 172 247 86Q247 11 325 11Q404 11 465 95Q518 165 528 208Q529 212 529 220Q529 237 518 249T480 261Q431 261 387 209T343 126Q343 111 355 101T367 89ZM777 658Q777 691 738 691Q704 691 658 662T570 590T491 504T432 432T410 400H411Q416 400 440 405T505 423T589 455T675 506T743 576Q777 627 777 658",
  119967: "251 272Q199 272 168 298T136 374Q136 432 175 496T267 603Q321 645 395 676T552 708Q610 708 655 694T724 659T763 618T784 584L790 569Q792 569 800 572T819 576T840 578Q855 578 855 571Q855 566 846 554T829 541Q824 541 817 539T804 533T799 529Q802 517 802 483Q802 376 742 256T585 53T392 -31Q353 -31 300 -7L289 -2L277 -6Q242 -17 192 -17Q141 -17 113 -13T77 -3T68 14Q68 20 73 28T93 45T131 58Q152 62 197 62Q241 62 272 48L282 44Q308 65 334 93Q380 145 467 266T622 454Q644 476 664 493T694 517T720 534T740 547Q699 671 540 671Q461 671 385 625T276 534Q265 520 251 499T219 438T202 368Q202 309 267 309Q325 309 396 383T491 545Q492 548 493 552Q494 558 496 559T511 564Q513 565 514 565Q523 568 527 568Q534 568 534 560Q534 554 529 537Q507 442 420 357T251 272ZM332 20Q332 19 341 15T368 6T400 2Q425 2 457 13T531 49T614 125T690 248Q750 376 750 476V490L738 479Q698 436 646 366T554 239T455 121T332 20ZM226 20Q226 25 186 25Q181 25 174 24H166Q161 24 158 23H152Q170 21 197 21Q205 21 213 21T223 20H226",
  119970: "206 318L249 320Q249 327 259 352T282 399Q312 447 366 510T465 610Q588 717 661 717Q695 717 716 701T738 653T704 577Q663 522 610 474T512 397T424 346T359 315T333 306Q331 304 327 290T323 267Q323 229 368 229Q402 229 439 254T505 312T571 382T638 435Q642 437 644 437Q658 437 658 409Q655 403 647 399T624 379T595 326Q583 296 564 267T523 179Q504 126 483 91T423 27Q335 -37 231 -37Q191 -37 157 -30T95 -2T67 53Q67 89 94 123T159 158Q180 158 190 146T200 119Q200 102 178 89T136 75Q128 75 120 78T110 81Q105 81 105 62Q105 38 129 24T180 5T238 1H244Q282 1 319 32Q349 55 371 85T436 190L465 239Q413 192 354 192Q300 192 274 217T245 276Q245 284 242 284Q220 280 187 280Q106 280 59 315T12 409Q12 457 43 508T118 597T210 659T295 683Q308 683 308 675Q308 670 299 658T282 646Q266 646 240 633Q182 606 118 511Q76 448 76 400Q76 368 105 343T206 318ZM677 660Q677 680 646 680Q616 680 565 629Q537 601 514 571Q493 544 455 492T389 398T360 355Q366 357 386 367Q463 406 534 473T641 591T677 660",
  119973: "829 148Q845 148 845 143T841 130T823 109T788 83T730 54T644 22Q637 20 634 19T627 16T622 13T618 10T612 3T604 -6Q510 -112 396 -203T201 -312Q190 -314 171 -314H166Q156 -314 147 -312T123 -304T101 -283T92 -245Q92 -203 117 -160T175 -93Q214 -65 280 -41T390 -6T509 22L532 27L547 47Q673 219 673 225L665 228Q657 231 648 235T627 249T606 270T591 300T584 341Q584 389 614 447T686 544Q735 588 799 615T959 667T1108 713Q1118 717 1119 717Q1125 717 1129 705T1133 689Q1133 686 1115 673Q1051 627 1001 579T918 481T867 403T828 328T805 277Q802 271 801 267T798 261T798 259Q849 270 900 317Q956 371 956 421Q956 438 953 457T950 480Q950 481 950 482L951 484Q953 487 966 492T985 498Q989 498 994 473Q1000 441 1000 423Q1000 362 934 302T790 223L775 220L767 207Q757 191 731 158T685 98T662 63Q662 61 690 70T755 99T811 142L816 148H829ZM646 332Q646 308 659 291T685 268L698 263L735 320Q828 465 865 511Q923 582 1003 643L1005 645Q1004 645 924 620Q775 572 716 492Q646 401 646 332ZM184 -278Q233 -278 311 -212T444 -80L498 -15H496Q468 -20 424 -30T293 -70T174 -133Q167 -140 158 -153T138 -190T127 -232Q127 -278 184 -278",
  119974: "521 506Q521 493 549 493Q608 493 660 527Q667 531 690 555L736 604Q750 619 777 646T825 694T848 716T852 717Q857 717 860 711T865 697L866 690Q866 687 812 615Q654 404 654 401Q655 401 656 401T659 402T665 403T680 404Q718 404 734 374Q735 370 743 376Q745 377 752 382Q806 416 852 466T933 563T982 623Q1028 666 1075 686T1155 706Q1165 706 1173 705T1186 703T1194 699T1199 695T1201 692T1202 688V687L1204 677Q1204 667 1191 670Q1189 670 1183 670T1174 671Q1137 671 1086 643T1001 564Q970 517 899 449T749 339L739 333L736 322Q730 295 703 253T652 165T628 77Q628 21 681 21Q692 21 698 23Q751 46 817 134L827 148H844Q861 148 864 146Q869 140 859 127Q818 75 761 29T665 -17Q649 -17 633 -12T598 4T569 40T558 100Q558 128 563 152T585 205T609 245T643 294Q647 300 645 300Q633 297 615 297Q607 297 600 298T589 300T584 301Q581 301 569 284T536 236T488 171T418 97T331 28Q233 -37 155 -37Q104 -37 68 -17T29 44Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q68 82 68 59Q68 37 85 23T123 5T167 0Q203 0 238 21T311 85T382 174T468 288T563 410Q576 426 588 440T607 462T615 472L605 468Q568 456 533 456H527Q490 456 463 483Q451 496 451 508T468 545T486 581Q486 593 465 593Q448 593 425 568T384 518T364 493Q364 492 347 492Q326 492 326 499T351 537T414 599T477 630Q509 630 528 615T547 576Q547 556 534 533T521 506ZM675 357Q675 368 665 368Q656 368 644 363Q631 355 616 333H628Q640 334 672 341Q675 354 675 357",
  119977: "764 513Q764 482 772 423T780 330Q780 304 778 285T775 256T773 245Q778 252 826 328T932 484T1042 617Q1077 652 1114 678T1173 715T1200 726Q1208 726 1208 717Q1208 711 1206 695L1203 679L1199 675Q1197 675 1187 670T1161 657T1133 639Q1050 583 959 456Q906 381 858 307T779 179T725 83T691 18T679 -6Q677 -8 660 -8H656Q639 -8 639 -1Q639 4 646 17Q685 93 685 173V196Q685 233 681 288T676 380Q676 438 687 487L664 454Q505 230 454 170Q366 64 290 14T163 -36H152Q87 -36 58 -11T29 46Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q67 82 67 59Q67 37 89 19T167 1Q187 1 197 3Q221 9 246 22T292 52T336 91T375 132T411 174T440 212T463 245T478 266Q779 695 784 698Q786 700 802 700H818Q824 694 824 692T809 668T779 604T764 513",
  119978: "259 -8Q230 -7 205 0T153 24T112 74T96 153Q96 254 174 379T374 599T607 707H621Q732 707 778 661Q805 634 805 598Q805 558 775 517T696 452L684 447V441Q684 378 626 273T484 97Q379 7 288 -7Q279 -8 259 -8ZM760 594Q760 670 608 670Q562 670 493 622T347 472Q174 240 174 131Q174 76 205 53T279 29Q294 29 306 32Q405 60 507 205Q592 325 616 401Q625 426 625 435Q625 436 621 436T603 440T569 449Q524 466 515 475Q513 477 513 481T525 496T541 508L548 504Q555 501 565 497T587 488T609 480T625 476Q627 476 626 481Q626 486 623 494T613 513T589 533T548 541Q495 541 413 454T286 281Q265 241 254 201T240 141T235 120Q234 118 217 111T197 104Q195 104 192 107T189 112Q190 125 193 147T220 231T280 348Q335 428 407 493T539 576Q548 578 563 578Q594 578 617 568T653 546T672 518T681 494T683 482Q683 481 684 481Q690 481 707 495T742 538T760 594",
  119979: "571 345Q571 384 612 418T687 452Q698 452 698 445Q698 436 679 417Q677 415 670 415Q650 412 633 389T615 350Q615 340 621 331T634 319T643 315L663 342Q751 462 817 536Q873 595 896 614L907 625Q843 680 701 680Q594 680 499 632T344 516Q317 486 296 449T267 384Q262 366 262 354Q262 332 276 316T326 299H327Q374 299 426 338Q481 376 537 456T597 598Q597 616 599 617Q601 619 614 624T630 630Q639 630 639 604V587V581Q639 519 597 456Q544 377 462 320T318 262Q278 262 250 282T222 350Q222 418 285 504Q360 597 480 656T702 716Q773 716 825 707T898 688T951 660Q962 670 985 685T1012 700Q1018 700 1022 690T1026 673Q1026 670 1019 664Q988 633 988 631Q988 630 999 618T1020 580T1031 522Q1031 471 1003 419T928 330Q854 275 765 264Q757 262 733 262H714L701 245Q615 121 473 42T218 -37Q159 -37 125 -15T90 46Q90 82 116 120T185 158Q203 158 213 147T224 121Q224 110 219 102Q198 75 159 75Q154 75 149 76T143 77T140 77Q137 72 137 53Q138 37 149 26T177 9T205 2T228 0Q313 0 419 74T602 257L620 281L614 285Q607 289 601 294T587 306T576 323T571 345ZM950 529Q950 576 943 576Q940 576 840 439T741 299H751Q804 300 845 334T924 438Q949 490 950 529",
  119980: "330 387Q330 331 402 331Q463 331 514 371T589 459T613 542Q613 559 608 570T598 588T593 596Q593 601 617 610Q632 617 636 616Q675 585 675 527Q675 464 629 409T516 324T387 294Q271 294 271 394V402Q271 438 292 478Q344 582 457 649T672 717Q765 717 825 675T885 548Q885 433 771 298T498 76Q493 73 491 72T486 69T484 67T485 66Q539 41 607 41Q655 41 703 71T780 139L787 148H804Q806 148 809 148Q826 149 826 140Q826 128 786 91T687 19T589 -16H576Q503 -16 414 20L396 27Q279 -17 192 -17Q130 -17 92 2T54 53Q54 92 107 123T222 155Q303 155 401 106L431 91L441 97Q476 118 527 157Q622 236 711 361T801 573Q801 591 795 607T775 641T732 668T660 679Q592 679 528 644T422 560T355 464T330 387ZM201 20Q232 20 267 27T322 40T342 49Q342 52 315 60T243 77T160 86Q150 88 144 88Q130 88 122 79T112 62L111 53Q111 20 201 20",
  119982: "346 463Q346 419 406 386T576 352H588L613 384L681 476Q767 594 842 651T973 708Q1016 708 1016 661Q1016 621 987 562T894 449Q802 375 696 338L682 334L665 312Q638 279 605 233T547 158T482 97Q418 46 332 5T158 -36Q87 -36 58 -11T29 48Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q67 82 67 59Q67 28 98 14T166 0Q232 0 320 55T491 226Q530 279 551 305L558 314Q558 315 543 315Q417 321 353 365T289 460Q289 566 488 632Q578 662 660 665H679Q685 660 685 657T676 642Q670 633 666 629L664 628Q663 628 661 628T655 628Q606 628 546 615T426 568T350 486Q346 475 346 463ZM976 653Q976 671 959 671Q938 671 919 661T883 629T858 593T835 554Q832 548 830 545Q802 495 775 455T734 400T721 382L736 388Q876 449 946 568Q948 572 949 573Q976 622 976 653",
  119983: "354 350Q264 350 264 426Q264 442 265 448Q279 514 347 582T503 692T662 735Q719 735 774 714T882 672T983 651Q996 651 996 644Q996 639 977 612T954 581Q953 580 938 580Q909 582 884 587L869 591L870 587Q870 583 849 557T796 491T748 422Q729 391 692 313T620 188Q555 105 454 34T253 -37Q214 -37 181 -30T120 -2T92 53Q92 89 119 123T184 158Q205 158 215 146T225 119Q225 102 203 89T161 75Q153 75 145 78T135 81Q130 81 130 62Q130 39 153 24T204 5T267 0Q311 0 358 29T454 117T539 226T629 358T710 476Q726 496 744 516T778 551T807 577T828 595L836 601L785 623Q743 642 713 651T668 661T626 663Q564 663 509 644T418 596T356 535T317 475T305 431Q305 416 312 408Q323 388 369 388Q429 388 465 411T530 480Q557 526 557 565Q557 573 556 579T555 587T555 590Q555 591 568 600T584 611Q588 612 600 603Q622 581 622 549Q622 516 600 475T536 405Q454 350 354 350",
  119984: "55 377Q55 443 122 523T290 660T478 717Q533 717 575 689T618 594Q618 565 611 538T585 477T552 422T506 355T458 288L357 146Q307 68 307 31Q307 20 318 20Q326 20 331 21Q367 27 411 57T490 128L767 500L861 617H908H939Q953 617 956 616T960 609Q960 605 928 566T816 423T648 198Q587 113 571 86Q540 34 540 21Q540 20 545 20Q580 25 623 55T696 124Q702 132 704 133T722 134H739Q744 130 744 127T735 113Q713 80 655 38T548 -14Q527 -17 524 -17Q475 -17 473 47V63L462 55Q364 -17 302 -17Q235 -17 235 69Q235 88 239 105T248 135T268 171T292 205T328 251T369 304Q376 313 395 338T423 374T450 408T476 445T499 479T519 514T534 546T545 579T548 608Q548 647 522 663T460 680Q355 680 243 591T99 406Q97 399 97 383V377Q97 339 153 339Q169 339 175 340Q215 350 241 373T298 444Q333 496 349 535T367 588T374 603Q402 616 408 616Q416 616 416 608Q416 563 393 492T320 378Q233 302 140 302H132Q75 302 57 353Q55 361 55 377",
  119985: "540 717Q542 717 545 717Q562 717 562 710Q562 708 557 702T541 678T517 632T485 544T448 407Q447 405 443 388T438 366T433 345T427 321T420 299T411 274T400 250T387 223T372 197Q363 181 364 181L388 203Q476 284 527 354T620 490T718 612Q754 647 790 673T835 700Q839 700 842 691T848 672L850 662Q850 657 842 653Q803 630 768 600T699 527T653 467T610 405Q554 322 518 282T368 138Q307 84 273 51T231 9T218 -5L207 -17H175Q169 -11 169 -9Q169 -4 183 10Q227 56 258 120T302 234T330 350T356 445Q357 450 360 458L362 464Q317 434 276 434Q221 437 221 479Q221 498 240 521T259 552Q259 565 235 565Q209 565 174 546T105 482Q103 480 102 478T99 474T97 472T95 470T93 468T90 467T86 467T81 467H75Q56 467 56 475Q56 482 82 511T156 570T253 601Q289 601 311 590T334 557Q334 543 312 517T289 478Q289 471 297 471Q327 471 378 514Q384 519 390 531T412 571T451 632Q482 675 524 717H540",
  119986: "232 504Q232 492 263 492Q304 492 356 515L367 520L379 537Q443 632 515 705L527 717H543H552Q564 717 564 709Q564 705 562 703T554 694T540 677T518 643T488 589T448 504T398 385Q368 309 353 281L349 270L523 472L669 634Q726 695 737 706T757 717H765Q786 717 786 710Q786 704 776 691T738 627T675 497Q630 394 609 354T541 244Q456 120 449 111L447 107L448 108Q630 240 700 327Q734 368 788 463Q821 520 841 550T898 619T980 683Q1010 700 1018 700Q1020 700 1023 697T1026 692Q1026 688 1024 671T1020 652Q1018 650 1007 645T988 635Q940 609 902 565T842 477T781 374T699 272Q653 226 535 133Q423 47 373 -2L358 -17H342Q320 -17 320 -11Q320 -7 328 5T354 46T390 112Q416 161 439 217T488 326T564 453L589 490Q587 490 523 414T352 217T166 14Q138 -16 137 -16Q136 -17 120 -17Q106 -17 103 -16T99 -9Q99 -5 100 -3T106 3T116 14T132 35T154 72T184 129T222 212T270 327Q310 426 337 471L326 467Q278 455 243 455Q209 455 188 462T161 478T155 496Q155 508 176 533T198 576Q198 579 198 581T192 588T178 593Q151 593 100 519Q89 504 86 502T75 499H68Q46 499 46 506Q46 510 63 534T112 587T170 627Q178 629 195 629Q235 629 252 613T270 577Q270 556 251 532T232 504",
  119987: "351 351Q308 351 290 373T272 426Q272 487 329 566T478 688Q538 717 584 717Q635 717 681 696T745 620Q752 598 752 564T745 498L741 485Q742 486 769 516T825 573T889 634T962 689T1027 716Q1035 717 1060 717Q1083 716 1096 714T1120 705T1131 686Q1131 668 1109 647T1055 626Q1035 626 1026 638T1016 663Q1016 667 1020 679H1015Q971 671 886 589T728 413L688 360Q688 359 725 359H750Q762 359 766 357T770 348Q769 345 761 335T750 322Q748 321 704 321H660Q651 311 632 282T589 199T565 107Q565 25 653 20Q684 20 720 44T779 95T826 152T850 183L856 184Q861 184 865 184Q888 184 888 173Q883 163 845 117Q770 37 723 10T638 -17Q584 -14 554 17T523 101Q523 147 534 167L532 166Q530 164 526 160T518 153Q378 15 256 -15Q250 -16 226 -16Q161 -16 132 7T103 59Q103 93 129 125T194 158Q232 158 232 121Q233 118 233 113T221 96T188 77Q182 75 168 75T150 78V70Q150 43 178 32T241 20Q340 20 527 286L552 321H524Q489 321 489 330Q489 333 497 344T509 358Q511 359 545 359H579Q580 362 597 389T631 445T661 514T675 586Q675 637 645 658T572 680Q506 680 444 632T348 527T314 434Q314 388 361 388H364H366Q380 388 389 390T416 408T457 454Q487 497 505 536T526 594L529 613Q531 615 545 622T560 630Q568 630 573 613T578 577Q578 518 532 455Q504 413 453 382T351 351",
  119988: "155 280Q116 280 87 300T57 368Q57 409 87 466T192 589Q269 653 345 684T472 716Q572 716 613 675Q644 644 644 599Q644 585 643 574T637 550T629 529T616 505T600 481T578 450T554 416Q494 330 493 328L480 306Q466 278 466 256Q466 227 492 227H496Q514 227 534 234Q541 237 544 241T571 279L762 559Q777 579 792 595Q818 620 856 646T919 686T946 700Q951 700 955 692T959 677Q959 673 947 665T911 639T866 595Q816 538 749 408T640 225Q574 138 464 61T248 -17Q190 -17 144 1T98 62Q98 81 109 102T131 135Q156 156 183 158Q226 158 226 121Q226 111 224 107Q215 93 196 84T162 74Q154 74 147 77H144V70Q146 41 185 31T263 20Q363 20 493 175L507 192H504Q500 191 498 191Q484 189 476 189Q430 189 405 219T379 287Q379 294 379 299T382 311T385 322T391 335T398 347T408 363T420 379T434 399T450 422Q455 429 469 449T488 475T504 499T520 523T533 543T544 565T552 583T557 603T559 620Q559 680 467 680Q402 680 333 646T213 563T131 462T98 373Q98 343 119 330T169 317Q187 317 212 333Q242 354 291 423T352 555Q354 562 355 588Q355 612 356 612Q357 614 371 622T387 630Q391 630 397 623T409 597T415 556Q415 507 380 448T294 344Q216 280 155 280",
  119989: "221 428Q221 487 280 555T425 670T583 717H587Q641 717 665 695T689 646Q689 625 674 600T658 564Q658 550 671 541T695 530T710 528L718 539Q779 613 821 646Q894 707 964 707H970Q1010 707 1025 675Q1032 661 1032 645Q1032 626 1022 607Q1008 579 980 560T897 522Q867 512 836 505T788 496L771 493Q768 493 760 477T736 429T702 370Q700 367 698 363Q696 360 696 359H805Q809 355 809 350Q809 340 791 322Q789 321 728 321H668Q562 179 433 88L419 78L434 73Q505 54 554 54Q609 54 654 82T720 140H752Q758 134 758 132Q758 128 747 113Q711 67 657 32T552 -14Q540 -16 517 -16T480 -15T439 -3T375 27L354 38L338 30Q257 -8 191 -8H184Q154 -8 133 -5T103 1T88 10T83 19T83 29Q83 35 86 44T100 65T127 88T173 105T241 112Q286 112 342 99L360 95L372 105Q434 157 523 270L560 320Q560 321 533 321L507 322Q502 325 502 330Q502 339 521 358Q523 359 556 359H588L669 474L682 491Q676 492 665 494T647 498T632 503T614 510T596 521Q556 547 556 570Q556 585 579 618T603 663Q603 679 568 679Q510 679 452 650T354 581T288 500T262 431Q262 407 280 397T321 387Q331 387 341 390T360 398T376 409T390 423T400 435T409 447L414 454Q457 514 460 562Q460 575 461 576Q461 577 475 586T492 595Q496 595 503 588T514 572Q520 559 520 539Q520 473 452 412T308 351Q269 351 245 370T221 428ZM989 642Q989 667 953 671Q905 671 871 644Q853 632 832 604T799 554T787 531H788Q801 531 842 539T916 561Q989 592 989 642ZM198 29Q230 29 257 36T295 52L306 59Q306 63 259 73Q251 74 209 74Q177 74 158 66T134 48L130 40Q130 29 198 29",
  120068: "22 505Q22 563 94 624T271 685H280Q416 685 443 560Q447 535 447 504Q444 414 405 330L399 319L229 155Q233 154 241 153T253 150T265 145T281 135T301 119T328 93L357 64L402 92Q438 116 473 137L500 154V339Q500 528 495 593V601L559 649Q621 696 624 696L638 686L629 677Q599 650 593 638Q582 614 581 504Q580 490 580 443Q580 314 584 238Q584 235 584 224T584 210T585 199T586 187T588 176T591 164T595 152T601 137T609 121Q630 77 640 77Q661 77 703 101Q704 95 706 90L707 86V84L636 29Q618 15 601 2T574 -19T564 -25L500 121Q499 121 399 48L299 -26Q298 -26 291 -15T272 11T245 42T209 69T165 80Q120 80 58 43L48 37L40 42L32 48L122 117Q196 173 241 211Q319 280 343 327T368 447Q368 535 317 582Q264 633 199 633Q155 633 122 605T86 542Q86 518 133 467T181 387Q181 348 140 309Q113 281 73 260L64 255L50 265L59 273Q112 307 112 345Q112 363 90 387T45 441T22 505",
  120069: "48 506Q48 568 120 629T268 691Q362 691 425 594L431 585L441 594Q478 628 528 657T629 686Q665 686 687 670Q703 658 718 584T753 506Q756 505 763 505Q778 505 804 512L815 516L820 496Q820 494 808 490T774 476T732 454Q720 445 708 437L675 415L640 394L625 383Q626 382 635 382Q652 382 670 379T712 364T754 336T784 289T797 220Q797 172 776 122Q769 106 766 102T745 84Q654 11 619 -8T538 -27Q483 -27 387 10T249 47Q218 47 186 34T133 8T112 -5T104 7T97 21L196 82Q259 120 284 140Q333 181 351 214Q368 251 368 353Q368 588 228 620Q222 621 205 621Q160 621 139 596Q117 569 117 548Q117 526 162 470T208 387Q208 352 179 320T104 264Q88 256 86 256Q83 256 70 266L82 274Q134 309 134 343Q134 352 130 359Q118 377 100 401T72 439T56 470T48 506ZM453 528Q457 496 457 419L458 357L488 367Q554 390 622 425Q673 449 673 453L671 454Q669 456 665 460T657 473T648 498T639 541Q629 597 616 613Q599 633 567 633Q534 633 493 599Q471 577 457 540L453 528ZM713 176Q713 252 661 295T528 339Q512 339 494 336T466 330T455 325Q454 325 452 311T444 270T425 217L420 207L304 118L319 116Q381 111 475 74T602 37Q655 37 684 79T713 176",
  120071: "346 611Q300 611 261 604T194 584T144 555T107 519T82 481T65 443T55 410T50 383T48 367L37 372L27 378V393Q33 524 115 603Q160 648 230 666T365 685Q423 685 434 684Q745 653 745 405Q745 281 694 151L687 133L657 103Q524 -27 470 -27Q456 -27 331 18T157 64Q122 64 84 28Q67 9 57 -6L50 -16L43 -8L35 0Q35 3 46 22T83 74T141 133H154Q208 136 253 161T299 230Q299 259 277 290T232 348T209 392Q209 434 254 479T358 556L368 561L382 550Q382 549 381 548T377 545T371 541Q353 527 326 496T298 444Q298 430 343 365T389 277Q389 240 353 202T267 136L252 127Q304 118 400 83T513 47Q548 47 582 79T635 145Q671 208 671 323Q671 390 651 441T599 524T523 576T436 603T346 611",
  120072: "301 564Q240 564 203 507T165 361Q165 280 190 218T260 119T358 64T474 46Q491 46 499 47L511 48L628 106V80L499 -5Q498 -6 497 -7T494 -10T490 -12T485 -15T478 -17T468 -19T456 -21T439 -22T418 -23T392 -24Q252 -20 169 67T86 315Q86 409 124 491Q128 500 139 508Q211 560 272 591L293 601L325 585L338 594Q374 617 422 639T502 674L532 685Q533 685 540 663T557 614T574 581Q580 575 591 575Q600 575 616 580T634 585V564L623 559Q572 535 532 529L522 527Q491 547 442 627Q442 628 440 627T435 624T428 620Q410 610 405 597T399 559V553Q399 534 409 487Q419 431 427 369L476 400Q526 431 526 432Q531 426 537 420Q565 382 602 359Q611 353 610 352Q609 351 575 332T537 312Q536 312 505 335T463 358Q451 358 439 352T425 337Q394 243 263 223L251 221L243 229L235 236L245 239Q274 247 303 266Q320 277 325 290T330 336Q330 394 315 451T300 531Q300 549 303 561Q303 564 301 564",
  120073: "198 617Q177 617 159 609T128 587T106 557T91 524T82 494T76 472L75 463Q74 463 67 468T59 474Q59 488 63 510T80 564T114 622T170 667T253 686Q272 686 295 680Q330 672 384 645T468 598Q498 580 524 580Q549 580 595 626L612 643V616L599 599Q522 500 482 500Q466 500 435 514L420 521Q388 516 349 486T309 415Q309 396 323 366T352 315T367 294Q367 293 375 301T398 322T429 352L490 410Q537 355 542 332Q542 330 531 315T510 286L499 273Q479 313 449 313Q437 313 419 303T390 282L378 271L394 250Q444 183 470 129Q484 96 484 71Q484 -19 402 -86T223 -153H220Q175 -153 137 -120Q103 -89 103 -8Q103 12 106 40T109 96Q109 132 103 146T72 161Q46 161 16 143L14 154L11 165Q88 219 143 219Q163 219 177 197T192 127Q192 102 186 65T179 4Q179 -60 210 -88T272 -117Q319 -117 362 -75T405 33Q405 72 363 139T278 271T235 368Q235 385 243 404T264 439T292 472T324 500T353 522T374 538L382 543Q382 544 351 562T274 598T198 617",
  120074: "373 560Q373 543 378 509T388 448T394 421Q396 421 416 433T474 474T548 537L538 543Q481 570 452 628L487 659Q521 690 522 690L526 684Q529 677 535 667T551 646T575 625T607 608Q617 606 621 606Q644 606 660 622L664 600L497 455Q495 453 527 453H546Q628 453 665 407L666 406Q710 357 710 297Q710 196 631 109L621 98L577 69Q471 -7 452 -15Q413 -26 370 -26Q239 -26 155 59Q66 148 66 319Q66 442 113 505L191 552Q269 600 270 600H271Q273 600 280 596T293 589T299 586Q300 586 357 623Q413 659 415 659L426 649Q373 604 373 560ZM219 228Q305 262 305 329V343Q305 384 294 434T282 519Q282 562 287 567Q287 569 286 569Q222 556 191 520Q144 464 144 362Q144 213 228 128T420 42Q514 42 568 103T622 255V260Q622 320 578 357Q526 400 453 400Q434 400 410 396L399 394L400 378V372Q400 330 388 301T348 254T305 232T252 217Q245 215 242 214L234 213L226 220L219 228",
  120077: "194 601Q175 601 155 590T121 564T95 533T76 506L69 495Q55 503 55 507Q55 509 60 521Q87 586 132 636T222 686Q251 686 289 660T363 607T422 580Q442 580 466 588T506 604L522 612V591L487 574Q371 517 359 517H357Q332 522 280 561T194 601ZM383 39Q383 96 356 203T329 361Q329 364 329 370T330 378L331 388L339 399Q362 429 394 462T446 513T469 531Q470 531 477 527T484 521L474 509Q411 434 411 379Q411 341 434 223T458 82Q458 1 390 -69T239 -139Q191 -139 162 -123T123 -83T108 -30T101 23T88 64T52 80Q27 80 -4 64L-10 80Q-5 85 13 98T63 128T118 144Q149 144 163 129T179 93T182 38T187 -19Q199 -96 278 -96Q294 -96 309 -91T343 -73T372 -31T383 39",
  120078: "154 37Q219 41 219 142Q219 203 190 302T160 434Q160 445 172 472T209 534T269 602T354 657T460 680H472Q576 680 618 617V599Q618 578 615 555T608 517T602 501Q596 495 587 495Q586 495 586 499Q586 500 586 505T585 513Q567 628 415 628Q384 628 356 621T302 596T260 546T244 466Q244 416 258 377L261 367L276 382Q294 401 317 422T386 471T468 500Q500 500 518 477T544 422T554 386Q555 382 560 376T576 364T601 357Q612 357 623 361Q623 360 621 351T617 340L541 305L465 272Q469 271 476 270T488 266T502 260L512 255L519 242Q533 211 546 157T564 93Q584 53 617 53Q649 53 682 74V54L675 46Q646 17 612 -5T554 -27Q546 -27 538 -23T517 -9T494 28T478 91Q465 172 448 200T378 228Q337 228 289 207L288 196Q288 160 284 138Q283 125 262 98Q185 1 112 -24L102 -27L91 -25Q47 -13 17 31Q17 33 49 69L80 106Q111 37 154 37ZM421 434Q411 436 405 436Q370 436 336 407T275 337L267 325L271 313Q288 257 288 234Q289 234 395 276T502 319Q501 320 499 323T493 330T485 345T475 371Q473 378 468 388T449 416T421 434",
  120079: "251 231Q251 254 206 341T160 468Q160 529 238 605Q313 677 425 685L432 686Q440 686 445 686Q520 686 545 657T571 576Q571 548 568 517T564 480Q564 466 572 460T608 452H623V431L619 430Q618 430 611 428T591 423T566 417L516 404Q497 415 491 419T480 433T475 461Q475 470 477 498T480 546Q480 561 480 569T474 592T459 615T429 631T379 638Q322 638 283 606T239 526Q237 480 280 394Q319 310 320 268V250Q308 235 244 169L203 128H210Q215 128 256 112T357 80T466 64Q526 64 564 88T625 186L629 196Q643 187 644 186Q618 70 604 41Q577 -15 513 -24Q496 -26 476 -26Q418 -26 344 -3T211 45T133 69Q115 69 97 50T65 7T49 -20L45 -16Q41 -11 37 -6T33 0Q33 8 66 69T111 134Q251 156 251 231",
  120080: "687 578Q690 586 719 612T794 665T877 692Q909 692 926 670T953 614T973 570Q983 561 1000 560Q1023 560 1048 569V553L1034 546Q1003 528 972 504T933 466Q905 403 905 264Q905 205 909 172T920 126T940 91Q951 74 959 74T997 87L1027 100V79L956 27Q940 15 922 2T894 -19L885 -26Q883 -26 854 27L825 80V192Q826 314 830 341Q831 345 833 356Q840 398 844 404Q871 444 920 489L917 491Q914 493 911 495T903 501T898 508Q893 516 877 562T852 616Q840 628 818 628Q751 628 702 541L697 532L700 515Q708 467 708 419Q706 348 690 276T662 169T643 126L634 116Q626 105 611 87T581 51L522 -22L514 -15Q470 21 452 21Q431 21 394 -16L384 5L386 9L426 60Q449 87 460 95T486 104Q487 104 491 104T497 103Q514 99 541 81L559 69Q595 96 606 169T618 350Q618 486 598 543T517 601Q484 601 458 570T432 523Q432 516 434 492T436 443Q436 250 369 133L363 122L280 50Q207 -16 192 -27L182 -18Q136 26 106 26Q83 26 62 9T37 -16L27 0L33 10Q41 22 54 39T94 81T143 106Q178 106 225 62L235 53Q283 82 307 117Q352 190 352 359Q352 408 345 451T320 534T267 597T183 621Q159 621 147 617T120 598Q97 574 96 556Q96 528 143 469T191 377T161 311T102 262T70 245Q69 245 59 252T49 260L56 264Q63 268 73 275T94 291T111 312T118 338Q118 355 95 384T50 446T27 506Q31 567 101 626T255 686Q297 686 330 671T382 632T409 595T421 572V571L430 580Q454 610 496 634T588 659H590Q655 659 683 585L687 578",
  120081: "112 334Q112 356 70 410T27 497Q27 553 94 619T229 685Q230 685 236 685T246 686Q303 686 349 654Q373 636 392 607T419 558L426 538L454 576Q474 604 486 618T520 651T569 678T633 686Q668 684 687 673T713 651T730 609Q730 608 732 600T736 588T741 578T747 568T754 561T765 555T779 553Q789 553 817 562Q819 557 819 555V547L790 526Q743 492 730 479T712 447Q697 369 697 281Q697 166 726 108Q741 76 755 68Q759 66 767 66Q789 66 825 93V82Q825 71 822 70Q821 69 763 27T701 -18L692 -25L668 15Q662 25 650 45T635 70L627 85V107Q627 122 626 162T624 285Q624 381 632 398Q638 409 651 425T675 454T696 477T707 489H696Q683 490 679 492T669 507T653 551Q642 588 627 608T584 628Q572 628 560 625T538 616T519 602T502 586T486 568T473 549T463 532T454 517T448 504L445 497Q437 480 437 474Q437 472 439 461T444 421T446 348Q446 205 405 124Q396 105 392 100T368 78Q312 32 278 9T235 -18T214 -22Q191 -22 170 -10T139 12T129 25T160 66T192 105Q193 102 194 98T200 83T213 64T233 49T261 42Q303 42 339 90Q373 134 373 268Q373 397 339 493T235 618Q215 628 191 628Q155 628 126 604T97 548Q97 524 120 493T168 431T192 381Q192 346 164 318T86 260L70 250L54 266L63 272Q112 300 112 334",
  120082: "428 596Q412 596 386 595T350 593Q289 593 270 625Q267 632 267 640Q267 656 280 672T312 705T336 729H343Q351 729 351 728Q342 710 342 703Q342 683 382 676T493 662T604 643Q648 627 677 599T720 535T739 466T744 392Q744 317 732 260T696 166T659 116T621 83Q617 80 615 78Q485 -27 377 -27Q320 -25 272 -9T187 21T122 36H116Q65 36 29 -13L27 -15L12 0Q12 1 32 26T76 78T109 109Q145 123 166 150T187 207Q187 244 134 318T80 412Q80 454 112 498T176 566T213 590Q216 590 224 585L234 580L225 573Q216 566 207 557T188 536T172 511T165 484Q165 448 213 368T261 259Q261 241 252 219T228 179T200 146T176 122L167 112Q170 111 174 111Q188 110 233 91T339 55T453 37Q508 37 556 68T626 152Q655 219 655 328Q655 543 532 582Q484 596 428 596",
  120083: "112 339Q112 354 91 380T49 438T28 497Q28 565 95 628T242 692Q261 692 277 689T307 682T331 670T351 655T367 637T379 619T388 600T395 582T401 565T405 550Q409 554 422 570T453 603T500 641Q573 692 637 692Q656 692 670 686T692 672T705 647T713 618T718 584Q720 568 721 562T728 546T742 534T768 530Q776 531 782 532T791 535T796 536Q799 536 804 521Q801 519 789 513T764 499T738 480Q697 447 680 414Q677 407 677 396Q677 370 713 312T750 210Q750 125 686 57T560 -11Q540 -11 475 13L410 37V31Q410 -9 412 -50T417 -118T420 -150Q419 -150 373 -184T326 -218L305 -208Q305 -207 307 -196T314 -165T322 -116T328 -46T331 43V63L318 66Q270 80 250 80Q233 80 213 70Q183 57 138 -3L128 -16L118 5L125 20Q193 154 282 154Q309 154 331 146V287Q331 444 327 469Q321 522 301 560Q284 590 251 611T184 633Q146 633 119 607T92 550Q92 539 94 534Q100 516 143 460T186 386Q186 366 170 336T119 281Q102 264 70 250L49 260L56 266Q64 271 72 278T90 296T106 317T112 339ZM602 345Q602 357 608 371T622 397T642 421T661 441T678 456L686 462Q663 473 652 486T639 512T634 553Q631 594 624 608T593 631Q587 632 567 632Q539 632 497 600T416 497L410 484V122L467 103Q481 99 502 92T533 82T557 75T578 69T594 66T610 64Q647 64 672 87T697 144Q697 180 650 250T602 345",
  120084: "428 596Q412 596 386 595T350 593Q313 593 291 605T268 638Q268 644 269 648T274 658T284 669T301 689T326 718L336 729H343Q351 729 351 728Q342 710 342 703Q342 683 382 676T493 662T604 643Q744 592 744 398Q744 299 708 213T646 104L603 68L614 55Q670 -5 710 -5Q726 -5 744 1T772 14L781 20Q782 20 782 7V-6L771 -13Q673 -69 665 -69L647 -63Q552 -30 514 8H512Q509 8 500 3T471 -9T428 -23Q405 -27 377 -27Q305 -24 228 6T124 36Q69 36 27 -16Q23 -13 19 -8L11 0L27 20Q93 102 109 109Q145 123 166 150T187 207Q187 244 134 318T80 412Q80 454 112 498T176 566T213 590Q216 590 224 585L234 580L225 573Q216 566 207 557T188 536T172 511T165 484Q165 448 213 368T261 259Q261 241 252 219T228 179T200 146T176 122L167 112Q170 111 174 111Q188 110 233 91T339 55T453 37Q508 37 556 68T626 152Q655 219 655 328Q655 543 532 582Q484 596 428 596",
  120086: "750 276Q750 141 645 57T378 -27Q224 -27 146 67Q66 163 66 307Q66 361 80 412T127 515T217 609T356 676L388 684L420 692L442 681Q545 625 586 608T654 591Q688 591 710 609T737 646L742 665Q742 665 756 654L752 642Q736 594 706 566T621 515L607 510Q580 513 528 542T421 599T335 627Q272 627 214 569Q139 500 139 373Q139 308 159 247T217 136T316 56T455 26Q520 26 566 43T634 90T666 148T676 207Q676 264 649 297T580 338Q574 339 552 339Q516 339 442 325T327 310H324Q303 310 290 312T259 328T232 369Q230 375 230 390Q230 426 259 461Q286 488 338 507Q351 498 351 495L346 492Q342 490 339 488T330 482T320 473T312 462T305 447T303 428Q303 368 366 368Q393 368 487 388T613 409Q656 409 696 385T748 306Q750 294 750 276",
  120087: "289 686Q338 686 439 668T565 649Q606 649 641 672Q656 683 664 690T674 700L675 701Q676 698 676 692V681L641 636Q608 591 602 588Q577 575 528 575Q490 575 438 583L426 585L416 578Q335 520 335 465Q335 437 393 366T452 259Q452 226 406 171Q387 146 351 115L341 106L358 97Q438 58 475 58Q525 58 598 124L608 133Q617 119 617 118Q617 114 606 103Q513 0 448 -27L438 -25Q401 -19 337 14T234 48Q186 48 122 -3L112 -11L106 -3L101 5L110 15Q160 63 209 105L224 117H310Q384 163 384 210Q384 238 329 303T263 398Q262 400 262 404Q262 427 290 476T368 580Q383 596 381 596Q315 622 228 622Q159 622 118 593T76 516Q76 482 96 461T139 431L107 399L75 367Q34 403 34 472Q34 525 64 572T148 652Q207 686 289 686",
  120088: "160 247Q160 291 110 382T59 505Q59 542 106 597T207 690L218 697L229 682Q229 680 216 669T187 644T158 604T144 552Q144 526 165 482T207 387T228 291Q228 277 228 267T224 247T219 232T210 217T199 202T184 184T166 163L118 107Q124 105 132 105T160 98T220 77Q298 47 317 47Q354 47 409 105Q444 142 451 161T458 244V277Q458 339 455 457T447 596L575 686L591 676L583 668Q550 632 541 587T532 449V372V298Q532 198 550 147Q572 79 605 79Q617 79 631 84T656 95L665 100V79L595 27Q578 15 560 2T532 -19L523 -26Q522 -26 490 42L458 111L397 50Q389 42 374 27T355 8T340 -5T325 -16T311 -22T294 -26T274 -27Q232 -25 152 6T35 37Q28 36 19 30T4 18T-8 4T-16 -5Q-25 10 -25 11T-20 18Q-5 34 15 57L54 101Q70 103 86 116Q94 121 113 140T137 166Q160 201 160 247",
  120089: "54 266Q118 307 118 339Q118 360 74 413T27 493Q26 530 59 578T133 651Q187 686 256 686Q299 686 332 673T382 640T409 600T424 567T429 553Q431 553 463 586T542 653T624 686Q663 686 715 652T798 617Q812 617 825 622V606L815 599Q785 576 762 546Q724 495 724 432Q724 397 737 317T750 217Q750 148 711 96Q697 75 639 34T578 -10Q563 -21 555 -23T522 -26Q458 -26 363 29Q253 89 211 89Q192 89 173 83T139 67T114 49T96 34L90 27L80 43L95 59Q121 87 148 110T191 143T213 154Q261 154 300 195Q328 222 340 267T352 406Q352 562 255 611Q222 627 187 627H182Q143 627 115 598Q96 579 96 559Q96 528 144 470T192 381Q192 348 156 314T80 256L70 250L54 266ZM727 548Q701 550 650 583T567 617Q560 617 554 615Q532 610 501 580T445 501L437 485V465Q432 326 378 223L294 150Q321 143 421 87T560 31Q608 31 634 64Q660 102 660 198Q660 226 655 292T650 387Q650 418 658 452L660 462L735 548H727ZM264 150Q265 151 263 151H261Q261 150 264 150ZM280 150H276V149Q280 149 280 150",
  120090: "32 501Q35 564 103 625T264 686Q326 686 365 652Q402 618 420 564L441 585Q486 630 539 670L559 686L572 672Q637 606 665 559L682 576Q787 686 845 686Q877 686 929 656T992 623Q999 621 1016 621Q1041 621 1054 628L1051 617L1047 606Q1042 602 1037 597Q983 557 969 522T954 434Q954 394 961 336T968 221Q968 201 966 184T963 155T956 131T948 113T936 96T923 82T906 66T887 50L816 -2Q815 -3 810 -6T801 -11T791 -16T777 -20T759 -23T735 -25Q691 -25 619 4T505 37H496L463 21Q420 0 389 -20L378 -27H362Q316 -27 275 -9T202 28T150 46H146Q114 46 59 -5L48 -16L41 -6Q40 -4 38 -2T34 2L33 4Q33 8 77 54Q111 87 142 112L154 122H166Q239 127 288 182Q346 244 346 406Q346 489 326 537T259 610Q227 628 195 628Q155 628 128 606T101 549Q101 517 146 465T192 382Q192 348 156 310T85 254L75 250L64 258L55 266Q56 267 74 276T105 301T118 339Q118 362 75 413T32 501ZM952 547Q927 555 877 586T796 617Q744 617 682 525L676 516L677 498Q678 486 678 425Q678 301 652 206Q649 195 613 151T577 102Q577 100 582 100Q618 100 720 51Q761 32 790 32H794Q843 32 869 83Q884 110 884 189Q884 233 879 294T873 400Q874 433 879 451T889 478T915 507T952 547ZM241 105Q249 98 263 88T317 60T393 42Q478 42 547 109Q607 171 607 358Q607 371 607 380T604 417T595 467T577 517T546 566T500 601L479 580Q449 550 433 526L426 516V503Q426 311 357 200L352 191L296 149Q241 107 241 105",
  120091: "96 511L78 527L149 603Q207 666 227 686L237 685Q278 680 306 667T351 631T376 588T395 533L400 516L406 527Q439 600 523 653Q538 664 587 688Q589 688 596 672T613 635T629 606Q643 588 665 588Q677 588 693 596L709 603V585L607 526Q583 536 554 564T512 614Q461 571 435 507T405 381V367H581L563 347Q561 344 558 341T553 335T549 330T546 326L545 325H541Q537 325 488 329T411 334H405V325Q405 198 454 123Q497 54 568 54Q594 54 619 64T660 84L676 95V74L565 -16L553 -20Q528 -27 512 -27Q492 -27 475 -21T444 -5T418 19T398 47T382 77T371 105T363 128T358 145L357 151Q354 151 339 136T294 91T232 37Q152 -22 113 -22Q90 -22 69 -9T38 17T28 32Q28 33 58 68L86 101Q94 81 115 64T165 47Q206 47 249 84Q302 128 325 222Q334 263 336 312V334H312Q198 334 163 324H161Q162 326 182 348L198 367H336V398Q333 508 308 550Q295 570 274 585T227 601Q204 601 181 589T145 565T115 533T96 511",
  120092: "123 345Q123 358 75 415T27 496Q27 533 63 578T121 639Q181 685 256 685Q305 685 332 676T384 635Q419 588 425 542Q468 585 526 628T618 686Q632 667 658 645T704 609T724 594Q740 512 740 385V375V361Q740 128 682 -3Q656 -64 554 -141T361 -218Q319 -218 287 -203T243 -173T230 -150Q230 -148 267 -109L304 -69Q311 -115 341 -142T411 -170Q474 -170 534 -119T624 11Q660 111 660 312Q660 447 633 528L612 549Q578 583 552 596L543 601L528 592Q501 574 483 558Q454 528 436 494L431 484V473Q431 330 376 230Q366 213 359 206T306 159L250 112Q278 105 327 82T399 58Q421 58 440 69T471 92T484 104H485L493 90L480 73Q453 39 429 13Q393 -22 372 -22Q342 -22 260 15T153 53Q97 53 48 -16L38 5Q46 22 74 54T128 108L143 122H155Q226 127 275 168Q352 236 352 399Q352 501 309 564T197 628Q156 628 129 607T102 553Q102 517 147 463T192 383Q192 323 75 250L59 266Q123 314 123 345",
  120094: "86 363Q86 365 128 391T212 444L255 470Q256 470 263 465T283 453T308 442Q338 431 346 431Q350 431 358 436L414 465L421 459L418 434Q404 339 404 262Q404 147 408 119L425 97Q443 74 444 74L467 86L491 97Q492 97 497 83L436 28Q377 -26 374 -26L331 46L329 91L155 -35Q152 -35 114 10T68 65L67 86Q66 100 66 156Q66 177 66 198T68 236T71 268T74 296T77 320T80 338T83 351T86 360V363ZM314 365Q285 367 255 374T206 386L187 392Q181 392 172 376T154 311T145 197Q145 124 151 118Q156 110 187 78L208 56H214Q221 57 253 76L308 109L329 123V136Q328 143 328 257V365H314",
  120095: "177 427Q177 364 181 364Q184 364 192 370T223 395T271 433Q317 469 323 469Q325 469 338 462T377 440T432 413L440 409L441 396Q441 394 441 372T442 334Q442 203 425 108L423 97L400 83Q347 49 296 21T222 -19T196 -31Q192 -29 149 12T87 71L89 89Q100 155 100 319Q100 500 94 627Q94 632 94 638T94 648T94 656T93 662V664Q93 668 97 669T106 670H110Q114 653 118 633L127 596Q127 595 132 597Q136 599 195 642L255 685L272 673Q269 670 256 659T233 637T211 609T190 565T179 508Q177 494 177 427ZM295 377L274 385Q273 385 264 381T242 370T223 361Q213 355 188 340L178 333V123L198 103Q259 42 285 42Q299 42 314 55T339 85Q363 132 363 232Q363 310 358 343V349L345 355Q330 363 295 377",
  120096: "72 208Q72 323 84 361Q84 363 167 414Q248 466 250 466Q255 465 260 465Q283 460 307 450T344 430L357 422L306 343L301 342L296 340Q267 362 247 372T216 384T177 390Q154 349 154 238Q154 220 156 158V145L168 132Q179 121 208 93T244 59Q245 58 246 58Q255 58 302 83T350 108L352 104Q355 100 356 96L358 92Q358 91 274 32T187 -29L177 -20Q160 -6 120 36T77 84Q77 87 75 118T72 208",
  120097: "13 542Q13 544 77 576T147 609Q154 609 185 598T283 551T414 464L427 454V440Q427 436 427 412T428 372Q428 315 426 270T418 197T409 152T400 121T394 103L304 35Q285 21 261 2T225 -25L214 -33Q149 7 97 59L76 80L75 91V171Q75 221 76 254T79 299T80 313Q80 315 78 321Q78 323 78 326L77 330Q79 336 132 384T211 447L219 445Q221 445 224 444L228 443Q229 443 228 441T221 432T206 415L191 395Q175 378 162 339Q152 306 152 250Q152 217 159 140V134L171 121Q194 99 235 74T284 48Q296 48 310 75T337 156T349 267Q349 346 336 400L315 420Q246 489 176 525Q127 545 94 545H73L27 527L13 542",
  120098: "353 103Q353 97 358 87L337 71Q293 38 247 6Q191 -30 189 -30Q188 -30 173 -16T130 26T76 85L74 99Q70 139 70 190Q70 228 73 271T79 338T84 365L94 372Q105 378 126 392T166 417L246 467Q283 417 349 369L364 358L355 349Q249 249 169 180L151 166L152 152V139L165 126Q186 105 215 84T260 62Q267 62 309 82L353 103ZM267 323Q246 337 230 350T204 371T189 385T179 394T174 397Q149 381 149 219V211Q151 211 171 223T220 258T268 299L282 313L267 323",
  120099: "128 387Q128 391 112 456T92 546V555L101 568Q133 617 183 670L193 681L204 673Q238 648 262 648Q276 648 292 656L302 661L308 653Q308 652 278 618L249 585H234Q194 587 159 595Q158 595 156 596H153L150 597Q151 593 152 581T154 564T157 547T164 524T176 494Q199 436 203 400V392H207L323 386Q323 384 309 368L296 351H203V176Q201 -9 198 -32Q194 -61 166 -114Q158 -129 153 -138Q114 -214 110 -221Q105 -221 98 -220L87 -219V-216Q88 -215 106 -150T124 -82Q128 -73 129 155V351H30L64 386H96Q128 386 128 387",
  120100: "27 -144L17 -131L82 -75L146 -20L126 6Q99 37 92 48L78 65L77 79Q75 103 75 158Q75 217 78 268T86 343T91 368Q92 370 109 382T157 413T222 452Q240 465 249 469L251 470Q296 443 350 428L365 424L437 465L442 459Q442 456 441 453T437 444T432 424T427 385T423 317T421 215V133L423 119Q423 111 455 -17Q455 -21 380 -108T290 -201Q290 -202 284 -204T269 -207T252 -209Q172 -209 75 -135L62 -126Q60 -126 44 -135L27 -144ZM349 351Q267 359 178 389Q177 387 173 376T166 358T161 337T157 303T155 259Q155 195 159 135L160 124L170 112Q180 101 204 77T230 53Q231 53 286 88L340 123V141Q340 235 348 329Q348 334 348 339T348 348L349 351ZM364 -59Q364 -37 358 -1T347 64T341 93Q336 93 252 28T149 -57Q226 -134 293 -134Q325 -134 344 -118T364 -69V-59",
  120101: "88 427Q88 486 87 545T84 634T81 667Q81 673 82 673T89 676H94L117 600L200 661Q208 667 218 674T233 684L238 688L254 678Q222 646 216 637Q164 572 164 483V442V371Q187 390 244 431T312 478Q344 446 411 423L428 417L429 396Q434 297 434 218Q430 8 406 -34Q346 -111 262 -195L251 -205L249 -203Q248 -203 244 -199T236 -193Q226 -183 227 -182Q228 -182 244 -169T278 -140T301 -121Q330 -89 340 -22Q355 60 355 171Q355 200 353 244T348 321T344 354Q333 363 307 376T260 390Q241 390 179 350L164 341V121Q180 96 201 66L213 50Q210 46 172 11T131 -24Q130 -24 123 -11T102 25T77 65V78Q80 104 84 227T88 427",
  120102: "72 617Q72 618 102 645T133 673H134Q134 668 175 627L187 615L130 555L116 568Q72 615 72 617ZM27 369Q21 376 14 382L26 392Q83 440 119 474Q158 435 169 427L179 420L176 395Q166 302 166 227Q166 171 174 139Q178 119 186 103T202 81L208 75Q255 100 261 100Q262 100 264 92T267 83Q267 80 208 30T145 -20Q143 -20 118 17L91 55Q98 117 98 193Q98 339 88 369Q71 390 68 390Q63 390 39 376L27 369",
  120103: "101 644L132 672L145 657Q155 642 169 628L182 614L169 600Q148 579 140 570L125 555L112 568Q109 570 91 592T72 615Q72 617 101 644ZM19 -208Q-9 -185 -9 -183Q57 -134 80 -106Q103 -81 110 -19T118 179Q118 294 113 329T86 383Q78 389 76 389Q73 389 57 379L39 367Q26 380 26 381L33 387Q40 393 53 405T79 428L130 474Q147 457 186 428L195 422L196 376Q196 130 192 58T174 -35Q172 -39 104 -114T19 -208",
  120104: "93 348Q93 379 90 503T87 658V670Q87 671 94 671L100 672L112 636Q124 603 124 600L144 616Q196 659 234 682L246 689Q252 686 256 685T268 680L254 667Q225 641 211 626T184 579T168 505V497L178 504Q203 523 237 544L300 584L310 573Q359 522 359 481Q359 476 359 472T358 464T355 456T351 448T346 440T340 433T332 424T323 414T312 402T299 389L255 343L300 342H346L320 309H177V128L193 113Q214 92 244 68L254 60L303 84Q351 108 352 108L362 96Q355 85 277 30T194 -25L170 -4Q146 18 120 41T89 68Q94 85 94 168Q94 184 94 218T93 268V309H58L24 310L51 342H93V348ZM172 342Q217 342 252 374T287 445Q287 472 255 504Q242 517 241 517Q202 498 187 468T168 365V342H172",
  120105: "221 76L267 99Q268 98 269 96T271 88T270 82L262 76Q255 69 241 57T214 34L148 -20L98 56L99 89Q107 247 107 373Q107 494 101 621Q101 653 99 659V665L106 668L113 672L118 655Q122 642 131 617L138 597Q140 597 157 611L240 670L264 685Q265 685 270 680T276 674T269 667T247 647T219 617Q197 587 186 551T173 493T171 438Q171 376 175 282T179 147V117Q184 109 201 93T221 76",
  120106: "20 367L8 379Q9 380 63 425T118 471Q130 460 143 446L168 421V398L169 376L295 475Q362 433 415 418V399Q415 380 416 380T437 394T484 428T529 462L544 474L556 467Q590 449 614 438T646 424L653 421L665 417L664 412Q664 411 664 407T664 397T663 384Q660 342 660 335Q658 303 658 245Q658 186 660 152L661 126L669 115Q680 96 697 79L707 83Q716 87 723 90T735 96T741 100T746 102L747 103V102L750 95Q753 88 753 87L631 -18Q630 -17 622 -3T589 43L576 60L579 72Q592 146 592 218Q592 265 584 321Q581 345 578 350T560 363Q535 376 496 386L481 390Q475 387 425 358L415 351V238V157Q415 142 415 135T417 120T421 110T430 98T441 81L465 47Q462 44 458 41T443 28T420 8L380 -26L333 47L336 62Q339 77 342 109T345 184Q345 223 341 285T333 348Q322 364 258 382L240 388L169 347L168 240Q168 118 171 110L174 106Q178 101 183 93T195 78L217 48Q217 47 196 30T154 -5T133 -21L130 -16Q127 -10 122 0T111 19Q89 56 89 60Q95 76 95 153Q95 239 88 337V365L62 391L20 367",
  120107: "31 368Q20 379 20 380T72 427L121 470L129 463Q137 455 155 441T176 425V367L320 475L329 469Q351 454 385 437T434 417L432 402Q429 362 429 231V128L439 111Q442 107 445 102T449 95T453 90T456 86T459 84T463 82T467 82Q468 82 489 93T511 105T514 95V88L395 -18L340 65L341 77Q347 111 348 178Q348 343 343 353V358L332 363Q298 377 264 382Q260 382 254 382L249 383Q247 383 211 362L176 341V229V147Q176 134 176 127T177 115T179 106T183 99T189 91T197 81Q201 76 206 69T214 57L217 53Q217 52 175 15T132 -22Q132 -20 114 5T88 41Q84 45 84 50Q94 116 94 203Q94 227 93 263T92 324L90 364L67 388L50 378Q32 368 31 368",
  120108: "67 121Q70 265 84 359V364L97 371Q137 394 177 421T238 464T260 480L278 468Q295 457 327 442T394 418L406 414Q412 388 412 300Q412 263 410 228T405 170T399 130T393 103T391 92L381 86Q274 19 165 -28L161 -24Q157 -21 151 -15T136 -2T118 14T101 30T86 46T74 60L67 68V121ZM335 278Q335 286 335 303T334 335L333 349V356H326Q288 360 208 388L183 397Q178 393 172 383T154 333T142 239Q142 192 151 134Q152 124 155 120T175 99Q197 77 219 64T251 47T267 44T281 52T302 80T320 124Q335 182 335 278",
  120109: "23 25Q15 33 12 38L35 59Q82 102 87 105V351L68 378Q42 414 42 422Q42 437 67 472T114 530L125 541Q126 541 132 537T138 532Q121 507 121 488Q121 453 160 413L167 405L166 390L165 372Q169 372 233 421T305 478Q307 479 315 472Q395 421 423 415Q424 415 424 415T425 414L426 410Q426 407 426 401T426 388Q430 335 430 272Q430 139 408 80Q407 78 340 22L273 -33Q200 23 165 23Q164 23 164 -32Q165 -89 168 -155V-170L93 -212L78 -203Q85 -48 87 16V47H79Q53 44 23 25ZM319 41Q346 94 349 212Q349 278 343 343V351L330 357Q318 363 270 381L255 387L245 383Q212 370 178 345L166 336V287Q165 260 165 166V94H175Q219 90 299 51L319 41ZM132 57L129 60Q130 58 132 57ZM158 29Q159 29 155 34T145 45T138 50Q155 29 158 29",
  120110: "399 19Q399 -123 407 -174V-179L332 -219L322 -210L312 -202L314 -185Q320 -83 323 54V95L311 85Q255 40 162 -19Q146 -29 145 -27Q140 -22 103 20L63 65V73Q61 83 61 115Q61 122 61 135T60 154Q60 263 79 353L83 368L94 375Q123 391 147 405T186 429T212 446T229 458T238 466T243 470T247 471L260 464Q274 457 295 448T330 434L341 432L410 479L412 478Q414 476 416 475T419 473L417 461Q399 358 399 19ZM316 367Q287 370 252 377T196 391L176 397H175Q173 397 166 382T149 314T139 187V158Q139 138 141 132T155 114Q158 111 160 109Q210 58 211 58L218 62Q226 67 240 75T266 91L319 124V196Q319 334 325 361V367H316",
  120111: "357 398Q364 398 375 403L386 408Q386 404 387 400V393L369 377Q361 370 350 360T336 347T327 340T316 336T303 335Q270 335 234 371L224 379Q220 375 214 370T198 355L182 340V243Q182 164 183 152T189 129Q195 117 211 100T239 72T254 60T298 81Q342 101 343 101Q344 100 345 92T346 82L200 -21Q174 -5 117 55L97 75L99 92Q106 147 106 196Q106 216 104 282T97 355Q95 359 95 361Q95 364 77 378L65 387L48 380Q30 372 29 372Q28 371 23 375T17 380Q17 384 50 415T107 467L115 474L128 461Q171 421 182 414V382L235 425Q247 435 261 446T283 462L290 468L295 460Q335 398 357 398",
  120112: "272 33Q284 33 290 70T296 138Q296 181 290 198T262 230Q257 232 246 232Q231 232 218 227T156 194L108 167L101 176Q90 192 75 219L69 230V284Q69 346 70 357V377L146 427Q181 450 202 464T223 477L225 476Q227 475 229 474Q231 472 242 466T270 450T296 431Q309 418 326 418Q342 418 361 429T392 450T403 459Q406 445 406 442Q406 440 384 421T338 382L316 363Q315 362 310 362Q292 362 251 371T173 396Q156 403 155 403Q143 386 143 342Q143 305 150 278T168 244Q171 242 181 242L190 243L315 300Q330 295 357 274Q358 273 362 270T366 266T369 261T372 253T373 239T374 217T374 185Q374 157 372 133T368 98T363 71T358 50L336 40Q288 20 255 2T211 -22T198 -29L190 -22Q181 -14 168 -3T138 19T104 38T70 46Q50 46 32 37T3 20T-9 11L-18 23L-1 41Q46 89 62 99T112 110Q141 110 157 103T225 62Q268 33 272 33",
  120113: "228 640L242 627L227 613Q213 599 211 593T203 553Q197 500 196 435V389H301L272 353H195V274Q195 178 196 159L197 123Q249 71 273 68H280L312 83Q344 99 345 99Q348 99 348 78Q348 76 314 52T246 4L212 -20Q211 -20 164 19T112 62Q112 122 113 196Q113 228 113 262T114 318T114 341V353H27L62 389H116L117 431V558L228 640",
  120114: "171 315Q171 252 165 199T153 124L147 103Q147 102 196 80L244 57L335 107V116Q339 161 339 268Q339 315 338 351T337 412V424L420 468Q424 465 427 461L424 435Q412 331 412 226Q412 170 415 145T434 96Q442 84 452 83Q461 83 492 96L506 102Q507 102 510 96T513 88L493 71Q445 32 401 -9Q392 -18 388 -17L384 -16Q358 39 355 44Q336 77 333 77Q261 45 203 -9Q186 -23 181 -23Q177 -23 162 -11T121 18T69 44L57 48L61 54Q65 60 71 73T82 102Q100 156 100 262Q100 305 93 335T80 373T62 396L23 376Q18 377 9 386L119 474Q149 437 171 421V339V315",
  120115: "55 418Q55 443 100 503Q121 530 123 530Q125 528 127 528T131 528T134 528T135 524T131 516Q123 499 123 486Q123 457 159 416L169 405L170 388L171 372Q171 371 244 424L317 477L334 466Q394 428 432 416L433 402Q433 400 433 377T434 336V305Q434 195 420 131Q413 94 406 87Q403 84 298 29L192 -28L172 -8Q139 25 106 52L92 64V70Q95 97 95 198Q95 293 94 318L92 355L84 367Q55 406 55 418ZM174 306Q174 297 173 255T171 184Q171 153 175 136T198 100Q207 94 224 80T255 57T282 49Q304 49 328 80Q359 129 359 243Q359 284 352 345Q351 358 348 360Q333 373 304 384T265 396L251 390Q215 372 186 351L175 344V337Q175 319 174 306",
  120116: "45 425Q45 439 82 485T126 532Q127 532 128 532T131 531T137 529L132 519Q121 499 121 483Q121 473 131 454T156 419L167 408L169 376L185 388Q237 425 291 473L301 466Q337 443 394 416L419 405L418 387V369Q419 369 487 418T560 471L581 459Q597 450 621 437T664 415T684 406Q688 406 688 323Q688 254 679 193T662 103T648 71Q647 70 554 20L464 -28L443 -15Q416 1 386 17T343 40T331 49Q331 52 333 73T337 133T339 216Q339 309 334 339Q333 341 316 353T277 377T246 389Q235 389 201 369T166 346Q166 345 164 247Q164 232 164 210T163 179Q163 139 170 116T205 57L212 48L136 -27Q115 16 87 44L78 53L80 67Q88 124 88 211Q88 282 87 315T83 356T74 371Q45 410 45 425ZM591 352Q580 359 565 365T540 374T517 381T504 385L418 342L417 318V220Q417 212 417 194T417 170T418 152T420 134T424 120T431 106T440 95T454 83Q508 44 544 44Q566 44 583 77Q603 120 605 235Q605 289 600 322Q598 343 597 345T591 352",
  120117: "14 377Q63 428 117 472Q130 462 144 449L193 408V392V376L247 420Q300 464 301 464L310 451Q331 417 363 390L333 365Q303 340 301 340Q293 343 277 364T250 386Q241 386 215 361L195 341Q194 333 193 327T191 318T190 304T188 269Q188 220 192 148Q193 122 195 118T210 101Q255 60 271 60Q276 60 278 61L318 82Q327 86 336 91T351 98L356 101Q359 82 356 79Q354 77 283 27T210 -24L192 -7Q160 23 137 40L126 49L116 40Q66 -13 66 -54Q66 -117 167 -140L179 -142V-147L180 -152L123 -188L112 -185Q58 -170 31 -145Q10 -122 10 -96Q10 -80 22 -53Q44 -10 95 49Q97 51 100 54T104 59T107 64T109 71T111 81T112 97T113 119T114 149T114 188Q114 284 108 347V354L96 365Q76 385 67 385Q62 385 45 377L27 368L14 377",
  120118: "74 58Q89 124 89 241Q89 265 89 278T89 305T88 324T87 336T84 346T81 352T77 359T71 368Q57 388 52 398L45 409Q62 454 98 507L113 528Q128 528 128 524Q128 523 125 518T120 503T117 483V471Q123 456 130 445Q135 438 140 432T148 422T153 415T157 409T160 405T162 402T163 399T163 395V384V365Q165 365 237 419L311 473Q383 430 420 416Q426 414 426 411V404Q426 398 426 388T427 367Q431 233 431 201Q431 -3 391 -52Q387 -58 305 -138T221 -218L218 -217Q216 -216 211 -214T202 -210L184 -202L199 -194Q259 -162 288 -127T334 -19T350 184Q350 257 342 328L340 356Q282 390 262 390Q248 390 178 346L163 336V111L216 45L131 -26L124 -15Q114 3 85 44L74 58",
  120119: "47 335L36 347L52 362Q112 421 167 461L181 471L192 465Q236 444 260 417T284 369Q284 355 276 343T233 291Q195 246 195 245T205 242T241 228T300 198L302 187Q314 138 314 74Q314 -24 291 -95Q290 -100 222 -157L154 -214H145Q102 -214 53 -189T-7 -117Q41 -21 183 122L207 147Q205 149 186 157T140 172T100 180H97V192L140 231Q192 280 199 293Q205 303 205 315Q205 339 185 363T137 388Q119 388 63 347L47 335ZM179 -153Q212 -153 226 -113T240 14Q240 67 233 98T223 132T211 143L222 130Q216 125 206 116T170 82T124 33T88 -20T72 -70Q72 -99 105 -126T179 -153",
  120120: "130 -1H63Q34 -1 26 2T17 17Q17 24 22 29T35 35Q49 35 64 44T88 66Q101 93 210 383Q331 693 335 697T346 701T357 697Q358 696 493 399Q621 104 633 83Q656 35 686 35Q693 35 698 30T703 17Q703 5 693 2T643 -1H541Q388 -1 386 1Q378 6 378 16Q378 24 383 29T397 35Q412 35 434 45T456 65Q456 93 428 170L419 197H197L195 179Q184 134 184 97Q184 82 186 71T190 55T198 45T205 39T214 36L219 35Q241 31 241 17Q241 5 233 2T196 -1H130ZM493 68Q493 51 481 35H619Q604 56 515 256Q486 321 468 361L348 637Q347 637 330 592T313 543Q313 538 358 436T448 219T493 68ZM404 235Q404 239 355 355T295 488L275 430Q241 348 208 232H306Q404 232 404 235ZM155 48Q151 55 148 88V117L135 86Q118 47 117 46L110 37L135 35H159Q157 41 155 48",
  120121: "11 665Q11 672 22 683H213Q407 681 431 677Q582 649 582 515Q582 488 573 468Q554 413 484 372L474 366H475Q620 317 620 178Q620 115 568 69T420 6Q393 1 207 -1H22Q11 10 11 18Q11 35 51 35Q79 37 88 39T102 52Q107 70 107 341T102 630Q97 640 88 643T51 648H46Q11 648 11 665ZM142 341Q142 129 141 88T134 37Q133 36 133 35H240L233 48L229 61V623L233 635L240 648H133L138 639Q142 621 142 341ZM284 370Q365 378 391 411T417 508Q417 551 406 581T378 624T347 643T320 648Q298 648 278 635Q267 628 266 611T264 492V370H284ZM546 515Q546 551 531 577T494 617T454 635T422 641L411 643L420 630Q439 604 445 579T452 510V504Q452 481 451 467T441 430T415 383Q420 383 439 391T483 413T527 455T546 515ZM585 185Q585 221 570 249T534 294T490 320T453 334T436 337L435 336L440 330Q445 325 452 315T467 288T479 246T484 188Q484 145 474 110T454 62T442 48Q442 47 444 47Q450 47 470 54T517 75T564 119T585 185ZM449 184Q449 316 358 332Q355 332 335 333T302 335H264V199Q266 68 270 57Q275 50 289 43Q300 37 324 37Q449 37 449 184",
  120123: "16 666Q16 675 28 683H193Q329 683 364 682T430 672Q534 650 600 585T686 423Q688 406 688 352Q688 274 673 226Q641 130 565 72T381 1Q368 -1 195 -1H28Q16 5 16 16Q16 35 53 35Q68 36 75 37T87 42T95 52Q98 61 98 341T95 630Q91 640 83 643T53 648Q16 648 16 666ZM237 646Q237 648 184 648H128Q128 647 133 632Q136 620 136 341Q136 64 133 50L128 35H237L230 48L226 61V343Q228 620 231 633Q232 636 237 646ZM264 61Q278 40 310 35Q363 35 401 55T461 112T496 193T513 295Q515 333 515 349Q515 411 504 459Q481 598 373 641Q351 648 321 648Q304 648 292 643T277 635T264 621V61ZM461 628Q462 627 471 616T489 594T509 559T529 509T544 441T550 352Q550 165 479 75L468 59Q474 61 484 65T522 87T573 128T618 195T650 290Q654 322 654 354Q654 418 638 464T581 552Q559 576 529 595T480 621L461 628",
  120124: "12 666Q12 675 24 683H582Q590 680 593 672V588Q593 514 591 502T575 490Q567 490 563 495T555 517Q552 556 517 590Q486 623 445 634T340 648H282Q266 636 264 620T260 492V370H277Q329 375 358 391T404 439Q420 480 420 506Q420 529 436 529Q445 529 451 521Q455 517 455 361Q455 333 455 298T456 253Q456 217 453 207T437 197Q420 196 420 217Q420 240 406 270Q377 328 284 335H260V201Q261 174 261 134Q262 73 264 61T278 38Q281 36 282 35H331Q400 35 449 50Q571 93 602 179Q605 203 622 203Q629 203 634 197T640 183Q638 181 624 95T604 3L600 -1H24Q12 5 12 16Q12 35 51 35Q92 38 97 52Q102 60 102 341T97 632Q91 645 51 648Q12 648 12 666ZM137 341Q137 131 136 89T130 37Q129 36 129 35H235Q233 41 231 48L226 61V623L231 635L235 648H129Q132 641 133 638T135 603T137 517T137 341ZM557 603V648H504Q504 646 515 639Q527 634 542 619L557 603ZM420 317V397L406 383Q394 370 380 363L366 355Q373 350 382 346Q400 333 409 328L420 317ZM582 61L586 88Q585 88 582 83Q557 61 526 46L511 37L542 35H577Q577 36 578 39T580 49T582 61",
  120125: "584 499Q569 490 566 490Q558 490 552 497T546 515Q546 535 533 559Q526 574 506 593T469 621Q415 648 326 648Q293 648 287 647T275 641Q264 630 263 617Q262 609 260 492V370L275 372Q323 376 350 392T393 441Q409 473 409 506Q409 529 427 529Q437 529 442 519Q444 511 444 362Q444 212 442 206Q436 197 426 197Q409 197 409 217Q409 265 375 299Q346 328 280 335H260V206Q260 70 262 63Q265 46 276 41T326 35Q362 35 366 28Q377 17 366 3L360 -1H24Q12 5 12 16Q12 35 51 35Q92 38 97 52Q102 60 102 341T97 632Q91 645 51 648Q12 648 12 666Q12 675 24 683H573Q576 678 584 670V499ZM137 341Q137 131 136 89T130 37Q129 36 129 35H182Q233 35 233 39Q226 54 225 92T224 346L226 623L231 635L235 648H129Q132 641 133 638T135 603T137 517T137 341ZM549 603V648H495L506 641Q531 621 533 619L549 603ZM409 317V395L400 386Q390 376 375 366L357 355L373 346Q394 331 397 328L409 317",
  120126: "737 285Q749 277 749 268Q749 260 744 255T730 250Q695 250 677 217Q666 195 666 119Q666 52 664 50Q656 36 555 3Q483 -16 415 -19Q364 -19 348 -17Q226 -3 146 70T44 261Q39 283 39 341T44 421Q66 538 143 611T341 699Q344 699 364 700T395 701Q449 698 503 677T585 655Q603 655 611 662T620 678T625 694T639 702Q650 702 657 690V481L653 474Q640 467 628 472Q624 476 618 496T595 541Q562 587 507 625T390 663H381Q337 663 299 625Q213 547 213 337Q213 75 341 23Q357 19 397 19Q440 19 462 22T492 30T513 45V119Q513 184 506 203Q491 237 435 250Q421 250 415 257Q404 267 415 281L421 285H737ZM250 43Q250 45 243 55T225 87T203 139T185 224T177 343V361Q184 533 250 625Q264 643 261 643Q238 635 214 620T161 579T110 510T79 414Q74 384 74 341T79 268Q106 117 230 52L250 43ZM621 565V625Q617 623 613 623Q603 619 590 619H575L588 605Q608 583 610 579L621 565ZM655 250H517L524 241Q548 213 548 149V114V39Q549 39 562 44T592 55T615 63L630 70V134Q632 190 634 204T648 237Q655 245 655 250",
  120128: "20 666Q20 676 31 683H358Q369 676 369 666Q369 648 331 648Q288 645 282 632Q278 626 278 341Q278 57 282 50Q286 42 295 40T331 35Q369 35 369 16Q369 6 358 -1H31Q20 4 20 16Q20 35 58 35Q84 37 93 39T107 50Q113 60 113 341Q113 623 107 632Q101 645 58 648Q20 648 20 666ZM249 35Q246 40 246 41T244 54T242 83T242 139V341Q242 632 244 639L249 648H140Q146 634 147 596T149 341Q149 124 148 86T140 35H249",
  120129: "79 103Q108 103 129 83T151 38Q151 9 130 -15Q116 -34 130 -37Q133 -39 157 -39Q208 -39 219 -8L226 3V305Q226 612 224 621Q220 636 211 641T166 647Q137 647 128 654Q119 665 128 679L135 683H466Q478 677 478 666Q478 647 439 647Q399 644 393 632Q388 620 388 347Q386 69 384 59Q364 -6 316 -39T184 -77H172Q102 -77 56 -48T6 30Q6 62 26 82T79 103ZM353 354Q353 556 354 596T361 645Q362 646 362 647H253Q257 639 258 628T261 547T262 312V-4L255 -17Q248 -29 250 -29Q253 -29 258 -28T277 -20T302 -5T327 22T348 65Q350 74 353 354ZM115 36Q115 47 105 57T79 67Q73 67 67 66T52 56T44 34Q44 9 62 -8Q66 -11 71 -15T81 -22T86 -24L90 -13Q100 3 102 5Q115 22 115 36",
  120130: "22 666Q22 676 33 683H351L358 679Q368 665 358 655Q351 648 324 648Q288 645 280 637Q275 631 274 605T273 477L275 343L382 446Q473 530 492 553T512 599Q512 617 502 631T475 648Q455 651 455 666Q455 677 465 680T510 683H593H720Q732 676 732 666Q732 659 727 654T713 648Q670 648 589 581Q567 562 490 489T413 415Q413 413 554 245T711 61Q737 35 751 35Q758 35 763 29T768 15Q768 6 758 -1H624Q491 -1 486 3Q480 10 480 17Q480 25 487 30T506 35Q518 36 520 38T520 48L400 195L302 310L286 297L273 283V170Q275 65 277 57Q280 41 300 38Q302 37 324 35Q349 35 358 28Q367 17 358 3L351 -1H33Q22 4 22 16Q22 35 60 35Q101 38 106 52Q111 60 111 341T106 632Q100 645 60 648Q22 648 22 666ZM240 341V553Q240 635 246 648H138Q141 641 142 638T144 603T146 517T146 341Q146 131 145 89T139 37Q138 36 138 35H246Q240 47 240 129V341ZM595 632L615 648H535L542 637Q542 636 544 625T549 610V595L562 606Q565 608 577 618T595 632ZM524 226L386 388Q386 389 378 382T358 361Q330 338 330 333Q330 332 330 332L331 330L533 90Q558 55 558 41V35H684L671 50Q667 54 524 226",
  120131: "12 666Q12 675 24 683H333L340 679Q350 665 340 655Q333 648 309 648Q287 646 279 643T266 630Q264 623 264 346Q264 68 266 57Q274 40 284 35H340Q413 37 460 55Q514 78 553 117T602 197Q605 221 622 221Q629 221 634 215T640 201Q638 194 625 105T611 12Q611 6 600 -1H24Q12 5 12 16Q12 35 51 35Q92 38 97 52Q102 60 102 341T97 632Q91 645 51 648Q12 648 12 666ZM137 341Q137 131 136 89T130 37Q129 36 129 35H237Q235 41 233 48L229 61L226 339Q226 621 229 628Q230 630 231 636T233 643V648H129Q132 641 133 638T135 603T137 517T137 341ZM580 48Q580 59 583 74T586 97Q586 98 585 97T579 92T571 86Q549 64 513 43L500 35H577L580 48",
  120132: "18 666Q18 677 27 680T73 683H146Q261 683 266 679L465 215Q469 215 566 443Q663 676 668 681Q673 683 790 683H908L915 679Q924 664 915 655Q912 648 897 648Q851 639 835 606L833 346Q833 86 835 79Q838 69 849 58T873 41Q877 40 887 38T901 35Q926 35 926 16Q926 6 915 -1H604L597 3Q588 19 597 28Q600 35 615 35Q660 42 673 68L679 79V339Q679 409 679 443T679 520T679 580T677 597Q646 521 584 375T473 117T424 3Q416 -1 410 -1T401 1Q399 3 273 301L148 599L146 343Q146 86 148 79Q152 69 163 58T186 41Q190 40 200 38T215 35Q226 35 235 28Q244 17 235 3L228 -1H28Q17 4 17 17Q17 35 39 35Q84 42 97 68L104 79V639L88 641Q72 644 53 648Q34 648 26 651T18 666ZM457 166Q451 169 449 171T435 198T404 268T344 412L244 648H157L166 637Q169 633 293 346L413 66Q424 88 435 117L457 166ZM817 646Q817 648 766 648H715V72L708 57Q701 45 697 41L695 37Q695 35 757 35H819L813 46Q802 61 800 76Q797 105 797 346L799 612L804 626Q812 638 815 641L817 646ZM124 42Q119 42 119 38Q119 35 128 35Q132 35 132 36Q125 42 124 42",
  120134: "131 601Q180 652 249 676T387 701Q485 701 562 661Q628 629 671 575T731 448Q742 410 742 341T731 234Q707 140 646 81Q549 -19 389 -19Q228 -19 131 81Q57 155 37 274Q34 292 34 341Q34 392 37 410Q58 528 131 601ZM568 341Q568 613 437 659Q406 664 395 665Q329 665 286 625Q232 571 213 439Q210 408 210 341Q210 275 213 245Q232 111 286 57Q309 37 342 23Q357 19 389 19Q420 19 437 23Q469 38 491 57Q568 132 568 341ZM174 341Q174 403 177 441T197 535T249 639Q246 639 224 627T193 608Q189 606 183 601T169 589T155 577Q69 488 69 344Q69 133 231 52Q244 45 246 45Q248 45 246 48Q231 69 222 85T200 141T177 239Q174 269 174 341ZM708 341Q708 415 684 475T635 563T582 610Q578 612 565 619T546 630Q533 637 531 637Q530 637 530 636V635L531 634Q562 591 577 543Q602 471 602 341V316Q602 264 599 230T580 144T531 48L530 47V46Q530 45 531 45Q533 45 547 52T583 75T622 105Q708 195 708 341",
  120138: "54 238Q72 238 72 212Q72 174 106 121Q113 110 132 90T166 59Q221 23 264 23Q315 23 348 41Q368 50 384 79Q393 102 393 129Q393 181 356 219T221 299Q120 343 74 390T28 501Q28 561 55 610Q98 682 212 699Q214 699 231 700T261 701Q309 698 340 687T408 675Q431 678 445 690T465 702Q474 702 481 690V497L477 490Q464 481 450 490Q446 500 446 501Q446 546 386 606T260 666Q215 666 182 639T148 565Q148 528 186 496T319 428Q352 414 370 405T418 379T468 338T506 284Q528 239 528 191Q528 102 456 46T266 -10Q211 -10 176 2T110 15Q86 9 73 -1T53 -12Q44 -12 37 -1V112V182Q37 214 40 226T54 238ZM446 619Q446 648 444 648Q439 646 435 644Q425 644 415 639H404L417 624Q435 606 439 601L446 592V619ZM124 619L128 635Q126 635 108 617Q64 576 64 502Q64 489 65 479T76 449T102 414T150 376T228 335Q335 291 381 245T427 128Q427 94 419 75L415 61Q421 61 448 88Q490 127 490 190Q490 233 475 264Q456 299 430 321Q402 349 369 367T287 404T204 441Q138 481 119 526Q113 544 113 565Q113 596 124 619ZM75 43Q76 43 90 46T110 50H119L106 64L74 101Q72 101 72 72T75 43",
  120139: "33 672Q36 680 44 683H624Q632 680 635 672V490L631 483Q621 479 617 479Q611 479 606 485T600 499Q600 525 584 552Q577 567 558 588T524 617Q479 642 426 646L415 648V355Q415 62 422 52Q425 42 434 40T473 35Q500 35 509 28Q518 17 509 3L502 -1H166L160 3Q149 17 160 28Q167 35 195 35Q224 37 234 39T249 52Q253 66 253 355V648L242 646Q192 642 144 617Q129 609 110 588T84 552Q69 527 69 499Q69 490 64 484T50 478Q39 478 33 490V672ZM113 639L126 648H69V597L84 612Q93 623 113 639ZM389 35Q382 46 381 86Q380 134 380 350V648H289V350Q289 199 288 131T286 53T280 35H389ZM600 597V648H542L555 639Q575 623 584 612L600 597",
  120140: "16 666Q16 677 28 683H341L348 679Q359 665 348 654Q342 648 315 648Q270 644 266 632Q262 627 262 598T261 399Q261 372 261 325T260 260Q260 149 274 99T339 30Q355 25 393 25Q430 25 457 33T494 49T519 72Q562 115 575 205Q576 219 576 379Q576 538 575 550Q568 597 550 622T506 648Q498 648 493 654T487 667T499 683H697Q709 675 709 667T704 654T690 648Q653 648 633 597Q624 573 622 546T619 377Q617 193 613 174Q596 95 544 41Q477 -19 355 -19H344Q275 -16 226 5T153 57T120 110T106 154Q101 172 99 399Q99 618 95 632Q88 644 53 648Q16 648 16 666ZM228 639L233 648H128Q128 647 133 632Q135 621 135 412Q135 197 137 185Q148 115 181 79Q209 51 235 41Q242 36 258 31T277 25Q276 27 268 38T254 59T241 92T228 145Q226 161 226 399Q226 632 228 639ZM604 621Q606 626 619 648H577L586 634Q587 632 591 625T595 614L597 608L604 621",
  120141: "316 683Q327 676 327 666Q327 648 302 648Q272 642 258 628Q249 621 249 608Q252 589 263 556T289 485T322 406T357 325T388 256T411 205L420 185Q423 185 473 317Q547 497 547 590Q547 621 541 632T516 648Q501 648 498 654Q488 664 498 679L504 683H607H660Q695 683 707 680T719 667Q719 660 714 654T700 648Q678 648 658 628L642 614L513 301Q484 231 449 148T397 25T380 -15Q373 -20 368 -20Q361 -20 358 -15Q354 -13 287 135T149 438T67 610Q45 648 18 648Q11 648 6 653T0 666Q0 677 9 680T59 683H164H316ZM216 614Q216 620 216 622T216 628T216 633T217 635T218 638T219 640T221 644T224 648H84L96 632Q118 592 236 330L367 43L387 88L404 132L380 185Q250 468 222 568Q216 590 216 614ZM576 645Q584 628 584 597L587 568L598 597Q609 624 618 637L624 648H600Q576 648 576 645",
  120142: "785 664Q785 670 795 683H982Q994 675 994 665Q994 650 975 648Q953 643 939 619Q931 593 823 292T710 -15Q706 -19 699 -19T688 -15Q682 -6 639 107T555 328T513 437Q513 438 500 409T462 325T413 212Q315 -14 310 -17Q308 -19 302 -19T288 -15L57 619Q45 643 24 648Q5 650 5 665Q5 677 17 683H146H200Q256 683 270 681T285 666Q285 659 280 654T268 648Q253 648 239 634Q230 630 230 619Q230 598 264 481L362 192Q363 193 428 341T493 492Q493 496 473 546T446 608Q426 648 399 648Q392 648 387 653T382 667Q382 678 393 683H679Q690 670 690 665Q690 662 685 655T673 648Q653 648 633 632L622 625V610Q626 576 657 479T719 300T751 218Q754 218 779 294Q847 492 847 581Q847 648 802 648Q796 648 791 652T785 664ZM194 623Q194 630 199 648H82L90 632Q99 616 199 332L302 50Q303 50 322 94T342 141Q342 142 305 245T231 467T194 623ZM585 620Q585 634 593 648H530Q466 648 466 645Q479 632 595 323L699 54Q701 56 718 103T735 154L702 245Q585 562 585 620ZM884 572L890 587Q896 602 903 620T915 645Q915 648 893 648H868L875 634Q883 598 883 576Q883 572 884 572",
  120143: "22 666Q22 677 31 680T80 683H184H335Q346 675 346 667Q346 660 341 655Q335 648 315 648Q280 644 273 637Q273 630 300 583T356 492T386 448Q430 504 450 535T474 577T478 601Q478 620 469 634T444 648Q428 648 428 666Q428 678 436 680T488 683H559H630Q673 683 681 681T690 666Q690 648 673 648Q652 648 619 637Q571 615 517 550Q490 517 450 464T410 408Q415 399 501 273T617 106Q648 61 661 48T688 35Q705 35 705 16Q705 5 695 -1H539Q384 -1 379 3Q373 10 373 17Q373 27 380 31T408 35Q459 40 459 49Q459 59 418 129T335 259Q334 260 332 260Q328 260 273 197Q210 127 208 117Q199 104 199 82Q199 57 213 46T239 35Q247 35 252 29T257 15Q257 10 256 7T253 3T248 0L246 -1H28Q16 7 16 15T21 29T35 35Q61 35 117 88Q289 279 304 297Q307 303 255 377Q117 586 79 626Q60 648 39 648Q32 648 27 653T22 666ZM237 639V648H173Q113 647 113 646Q113 642 137 612Q186 546 302 373T453 139Q497 63 497 43Q497 39 495 35H559Q622 35 622 37Q622 38 583 94T486 233T373 399T277 552T237 639ZM553 637L566 648H504L508 637Q510 630 515 615V603L528 615Q529 616 539 625T553 637ZM170 46Q169 49 167 58T164 70V83L137 59L113 35H175Q175 38 170 46",
  120144: "16 659T16 667T28 683H295Q306 676 306 666Q306 648 284 648Q258 648 255 641Q255 634 265 615T339 479Q418 339 421 339L455 394Q489 448 523 502L557 557Q560 566 560 582Q560 637 504 648Q489 648 486 655Q475 664 486 679L493 683H693Q704 675 704 667Q704 650 684 648Q672 645 653 623Q633 604 614 576T517 426L439 301V183Q442 62 444 59Q449 35 504 35Q521 35 528 30Q538 16 528 3L521 -1H195L188 3Q178 16 188 30Q195 35 213 35Q266 35 273 59Q274 61 277 163V261L75 621Q64 638 58 643T37 648Q28 648 22 653ZM219 637V648H101Q110 634 215 446L313 270V166Q310 59 306 48L301 35H415L410 48Q404 65 404 175V290L317 443Q230 601 226 612Q219 625 219 637ZM608 630L624 648H575Q584 632 588 623L595 610L608 630",
  120172: "821 97Q822 97 824 88T827 77L793 53Q676 -25 670 -28Q669 -29 656 -27L583 123Q583 124 467 46L352 -31L341 -20Q305 18 264 47T192 77Q161 77 60 32L49 40Q37 47 38 49Q39 49 93 83T212 160T297 219Q411 312 411 452Q411 519 360 571T233 624Q180 624 157 601T133 548Q133 524 160 496T214 441T241 393Q241 356 199 321T100 256L86 249L77 256Q68 263 67 263L84 274Q101 286 118 304T135 339T109 384T56 446T29 504Q29 566 118 624Q207 686 309 686Q349 686 360 685Q405 678 439 661T491 625T520 583T534 543T537 511Q537 436 491 344L478 318L455 299Q420 272 308 179L284 160L294 158Q348 154 426 89L437 79Q513 110 579 153V175Q579 183 579 227T580 330T581 446T582 542L583 582L664 630Q681 640 703 653T734 673L744 679Q750 678 756 676L767 674L716 623V585Q716 568 712 463T708 289V250Q708 237 709 218T710 195L711 180L739 130Q768 79 771 79Q775 79 796 88T821 97",
  120173: "160 345Q160 357 144 376T109 413T73 458T57 509Q57 544 95 584Q142 631 205 657T331 684Q382 684 427 658T500 585L505 577L521 588Q537 599 562 614T616 646T679 673T738 684Q790 684 807 666T840 587Q850 552 863 532T888 508Q894 505 906 505Q917 505 930 507T953 512T963 514L964 504Q965 495 965 494T914 467T808 413T745 384H751Q782 380 802 377T854 362T904 334T937 287T951 217Q951 178 937 143T908 91Q903 86 820 34L734 -21L718 -24Q679 -31 639 -31Q561 -31 451 4T271 40Q190 40 119 -2L99 -13L91 1L84 15L86 16Q88 18 132 42T233 100T315 152Q377 199 386 233Q388 240 393 297T399 363Q399 487 353 551Q337 573 306 597T238 622Q201 622 179 602T157 557T214 476T272 396Q272 371 229 334T143 272T96 246Q95 246 85 252T74 259T95 273T138 306T160 345ZM529 443Q529 409 528 385T526 353L525 346Q526 346 649 390T773 435Q749 451 742 464T727 518Q727 519 725 532T721 548T717 562T712 577T706 589T698 601T688 608T675 614T658 616Q626 616 576 582T525 528Q525 527 526 518T528 489T529 443ZM772 57Q774 57 778 58T792 64T808 77T821 103T827 144Q827 222 784 266T660 322Q652 323 611 323H596Q577 323 535 316L523 314Q520 291 505 255L500 241L356 138L366 137Q443 131 518 110T650 72T748 54Q763 54 772 57",
  120174: "460 -32Q373 -32 305 -11T193 45T122 124T83 214T72 303Q72 395 114 476L119 486L313 592L338 568L359 580Q418 615 479 638T568 668T606 675Q607 675 608 676H610Q612 676 615 661T630 621T660 578Q673 568 694 568Q717 568 721 570H726Q724 565 722 559L717 549L706 545Q608 513 583 513Q568 517 559 522T533 546T493 603L490 609Q452 599 452 558Q452 537 469 481T486 393Q486 353 474 331T422 285T296 231L272 223L262 230L253 237Q279 246 314 274T351 338Q351 376 334 442T316 532Q316 546 319 552Q319 554 316 554Q304 554 288 547T250 523T214 466T199 371Q199 218 299 133T541 47Q571 47 585 51T652 81L712 108Q716 104 716 81L706 74Q695 68 673 54T633 29L550 -22L540 -24Q492 -32 460 -32",
  120175: "380 596Q307 596 250 582T158 546T100 493T67 433T56 373V361Q55 361 43 366L31 372V384Q31 455 69 523T173 627Q213 650 284 666T444 683H452Q629 683 735 629Q896 548 896 369Q896 263 839 163Q835 155 818 140Q746 82 662 27T563 -29Q525 -29 386 16T183 62Q147 62 127 52T63 1L48 -14L40 -4L31 5Q83 73 172 149L186 161H199Q291 161 329 181Q357 199 357 231Q357 258 301 316T245 396Q245 423 282 458T349 512T403 543L413 548L425 545L438 541Q373 491 373 462Q373 446 399 415T453 349T480 288Q480 251 433 212Q394 180 348 156L334 148L353 145Q408 134 513 105T654 76Q711 76 745 132T780 277Q780 434 676 517Q637 549 562 572T380 596",
  120176: "527 55Q574 55 619 69T691 97L717 111V85L562 -18Q520 -29 443 -29Q379 -29 325 -15T235 21T180 61T146 98Q74 186 74 307Q74 395 109 472Q113 482 123 489T190 533Q251 568 295 591L308 598L350 580L361 586Q403 612 464 636T564 673T609 686Q610 686 610 685Q612 683 616 670T627 636T646 601Q666 572 686 572H692Q713 572 726 576H728L725 565L723 554L692 544Q660 535 629 526T595 516Q585 514 574 519Q563 527 543 552T507 597T490 617Q467 604 456 579V564Q456 535 473 471T492 393L494 381L613 460L622 446Q630 433 650 411T696 371L703 365L614 312H596L580 322Q568 329 553 340T528 355T510 360Q496 358 491 354T484 345T471 326T435 297Q408 278 370 261T307 235T277 227Q273 227 266 234L256 240L267 245Q280 251 294 258T330 288T353 336Q353 373 335 444T316 530V537Q316 549 322 567Q270 554 233 499T196 370Q196 253 287 157Q392 55 527 55",
  120177: "424 522Q265 596 208 596Q193 596 180 593T150 579T116 542T89 474Q86 465 86 463L59 481L63 494Q87 578 137 627Q191 684 285 684Q334 684 406 658T538 607T621 581Q644 581 706 629L721 640Q722 640 725 630L727 620Q701 592 654 548T582 486L569 487Q533 490 485 504L468 508Q449 503 429 495T387 466T365 422Q365 373 439 299L453 310Q473 325 528 370L588 418Q614 398 642 368T668 331Q667 331 628 296L590 262L582 274Q557 311 526 311Q511 311 487 297T462 278Q462 277 492 244T551 166T581 88Q581 54 570 25T536 -27T505 -56T478 -76Q376 -146 274 -146H270Q199 -146 162 -118T124 -15Q124 12 128 30T132 96V107Q132 144 117 157Q102 169 85 169Q74 169 59 165T32 156T20 151Q20 152 19 158T17 167Q17 168 17 168T17 169T19 170T22 172T27 175T35 179Q131 230 195 230Q231 230 259 202Q270 190 270 171Q269 150 253 87T236 -16Q236 -67 261 -87T322 -107Q380 -107 428 -68Q467 -35 467 30Q467 60 447 91T383 171T316 251Q290 286 278 308T263 339T261 359Q261 384 284 418Q322 469 424 522",
  120178: "742 611Q784 611 812 631V611Q807 607 783 591T718 544T629 476L606 458Q608 458 628 457T667 453T713 443T762 423T804 388T836 335Q844 313 844 289Q844 231 814 182T746 103Q720 82 655 48T546 -18L520 -21Q456 -29 432 -29Q313 -29 223 33Q204 45 183 65T135 119T91 207T74 320Q74 428 109 480Q116 491 127 497T215 546L308 595L343 583L355 591Q387 613 433 636T488 660H489L491 659Q493 658 495 657T500 655L509 650L500 645Q479 635 460 612T441 552Q441 535 447 498T459 433T466 405L625 513L643 526Q620 530 585 546T535 586Q535 587 532 592T527 602T525 610Q525 613 577 649L630 687Q632 687 638 675T653 649T686 623T742 611ZM349 313Q349 328 327 413T305 510V516Q305 531 308 542T314 559T317 566T315 567Q297 567 270 548Q233 524 212 490T191 392Q191 337 206 288T244 207T284 156T316 128Q410 51 535 51Q632 51 675 102T718 217Q718 269 690 314T599 375Q574 381 535 381Q501 381 477 377L466 376Q469 364 469 349Q469 314 457 295T408 258Q366 236 308 219L288 213L279 220L270 227Q284 232 294 236T309 243T320 252T326 260T331 270T336 281Q349 310 349 313",
  120179: "288 139Q288 172 255 224T189 335T156 442Q156 495 242 579Q289 625 361 668Q364 671 368 673T376 678T380 681L384 683L392 676Q401 670 414 661T443 642T477 626T509 619Q543 619 618 668Q625 672 628 674T631 675Q632 673 633 663T633 651L564 595Q556 589 545 580T528 566T516 556T505 548T497 543T488 539T481 537T472 535T463 534T451 534H442Q385 534 304 581L291 589Q290 588 285 583T277 575T269 566T262 555T257 543T255 529V522Q255 507 260 487T276 446T293 409T311 376L321 359Q321 358 322 358T324 359T327 361T333 366Q386 409 481 460L503 472L543 471Q586 471 599 470Q692 459 714 430Q725 416 738 360T752 245Q752 184 742 127T725 51T703 -8Q700 -13 619 -64T518 -123Q508 -126 493 -126Q438 -126 398 -86L427 -52Q456 -17 457 -17Q460 -17 465 -16H473Q474 -21 481 -32T504 -56T539 -69Q572 -69 599 -34Q625 4 625 158Q625 264 609 311T532 378Q508 386 484 386Q455 386 419 372T360 345T337 330L346 313Q375 263 386 227Q389 215 389 202Q389 192 388 184T384 168T376 152T365 138T350 121T331 103T307 81T278 54L194 -24Q130 30 99 30Q85 30 64 20T31 1T16 -10Q15 -11 13 -7Q12 -6 11 -3Q8 4 6 8L32 35Q88 88 117 107T169 126Q177 126 182 125Q218 118 252 84L263 73Q288 113 288 139",
  120180: "500 615Q523 615 550 628T595 655T614 668L623 654L607 642Q512 569 440 534L427 527L413 529Q384 535 340 547T265 565T209 572Q173 572 145 556T101 522T60 465Q58 460 54 460T41 468L32 477L37 487Q96 599 139 640Q187 681 247 681Q275 681 283 680Q313 674 398 645T500 615ZM418 170Q418 186 410 260T401 382Q403 418 403 424L405 433L415 444Q482 515 571 571L582 578Q591 573 607 568L597 560Q522 504 522 450Q522 427 533 357T545 241V228Q545 190 536 159T508 106T478 73T446 48Q343 -25 238 -25Q179 -25 118 15L107 22L79 5Q51 -12 51 -12L38 2L55 18Q106 67 175 122L192 136Q202 130 206 123Q223 91 252 61Q263 50 266 48T278 39T297 32T320 30Q357 30 389 68Q415 102 418 170",
  120181: "65 510Q68 517 74 528T101 569T144 620T202 661T274 680Q308 680 389 628T503 576Q530 576 596 600Q615 607 616 607Q616 602 615 596V585Q605 581 576 568T531 548T485 531T418 509L400 503L358 522Q347 527 327 537T299 550T277 560T257 568T239 573T220 577T201 578H196Q181 578 169 575T135 554T88 502L83 496Q82 496 74 502T65 510ZM424 4Q424 50 395 151T365 313V320Q365 352 369 361T405 403Q431 432 465 462T521 508T547 525L549 524Q551 524 554 523T560 521L571 517L552 498Q515 461 499 430Q485 399 485 366Q485 326 512 231T539 84Q539 -14 460 -77T273 -141Q248 -141 234 -140T198 -131T160 -106T134 -59Q128 -40 124 -16T117 22T108 49T91 69T59 75T15 65L1 59Q-8 76 -7 77Q4 85 22 97T88 129T170 149Q218 149 234 125Q242 112 242 43V21Q242 -17 248 -41T274 -85T322 -105H325H330Q363 -105 396 -75Q424 -47 424 4",
  120182: "234 109Q234 144 194 245T153 404Q153 445 180 490Q232 572 325 626T517 681H524Q612 681 661 658Q683 647 699 632T717 604Q717 600 708 545L699 490L690 489Q681 488 679 488Q675 488 669 504T640 546T577 592Q520 620 446 620Q415 620 386 614T327 594T280 553T262 487Q262 468 265 447T271 413T279 384T285 362L295 371Q320 396 352 421T439 474T538 502Q577 502 596 484T627 428Q642 386 651 373T677 360H682Q698 360 727 369L724 357Q724 354 724 351T722 346V344Q559 289 539 283Q582 272 589 271L615 265L637 189Q662 109 663 108Q668 97 682 84Q698 68 722 68H730H738Q762 68 799 91L803 80L806 70Q795 59 770 40T703 -3T631 -26Q598 -26 578 -8Q548 24 536 92Q524 154 509 183T477 218T428 224Q409 224 385 220T346 212L331 207Q330 205 330 201T331 189T332 178Q332 158 325 116L305 96Q269 60 240 38Q171 -21 123 -21Q72 -21 33 18L20 32L62 74Q96 107 102 112T116 118Q120 118 122 113T131 95T150 69Q171 48 190 48Q198 48 206 51T224 69T234 109ZM519 367Q497 432 450 432Q379 432 313 333L300 314L304 299Q306 294 309 280T315 260L321 235L542 313Q530 325 519 367",
  120183: "277 226Q277 248 253 286T203 369T178 449Q178 490 212 533T284 607Q380 683 532 683Q610 683 639 660T668 583Q668 568 666 546T663 509Q663 478 683 460Q691 452 719 452L738 450Q732 437 729 437Q728 437 652 416T573 394Q554 394 541 409T527 444Q527 449 532 487T538 542Q536 584 501 606T418 628Q389 628 364 620T317 587T295 523Q295 478 333 401T372 276Q372 269 371 267Q371 264 318 206L264 149Q284 141 317 130T433 101T577 82Q619 82 652 95T701 127T728 164T742 196L744 209Q744 210 749 208T759 203T764 199T760 185T751 154T744 129Q714 42 680 13Q628 -28 566 -28Q490 -28 403 -5T249 42T153 66T106 53T70 15T47 -16Q46 -17 30 -5L39 13Q85 100 138 148L147 156L161 157Q218 165 246 179T277 226",
  120184: "134 338Q134 357 81 417T27 504Q27 516 34 530Q55 568 110 615Q190 683 305 683H314Q445 683 495 580L501 569L512 577Q608 646 681 646Q759 646 801 585L808 576L816 583Q860 619 921 650T1041 682Q1063 682 1077 675T1096 660T1112 631T1132 596Q1160 555 1188 555Q1204 555 1228 564Q1230 565 1231 562Q1231 560 1232 554V547L1215 538Q1179 521 1114 475Q1112 474 1106 470T1099 464T1093 459T1088 452T1085 441T1082 425T1081 404T1079 376T1079 339Q1079 282 1084 236T1098 160T1117 112T1138 85T1159 77Q1166 77 1180 81T1207 90L1219 94Q1220 94 1221 86T1222 76L1045 -32Q1044 -32 1004 15L964 64V167Q965 334 970 372V378L994 402Q1032 440 1057 460Q1061 463 1066 467Q1070 469 1070 470T1068 471T1060 474T1050 481Q1040 488 1021 531T996 583Q979 609 947 609Q922 609 887 592T820 537L821 524Q825 484 825 448Q825 268 768 155L759 137L589 -28L579 -20Q533 17 507 17Q475 17 449 -7L436 -18L424 2L441 20Q446 25 456 36T471 52T484 65T497 79T509 90T522 99T534 106T548 112T561 115T576 117Q602 117 639 86Q648 81 648 81Q650 82 657 94T668 112Q711 202 711 373Q711 484 677 533T600 583Q592 583 583 581T569 577T554 568T542 560T528 549T516 539L519 523Q527 485 527 461Q527 444 522 407Q506 266 447 150L437 130L217 -25L208 -15Q165 28 126 28Q89 28 62 1Q47 -14 43 -14Q42 -14 36 -8L28 0L44 17Q96 73 120 92T166 117Q182 123 204 123Q239 123 284 78L295 67Q307 72 337 102Q400 178 400 346Q400 508 325 571Q270 618 208 618Q180 618 168 614T140 594Q124 578 124 564Q124 540 182 480T240 396Q240 359 197 321Q154 285 94 252L80 245L76 248L67 257L61 262L71 268Q82 275 94 284T120 309T134 338",
  120185: "522 492Q521 492 517 502T512 513Q542 444 542 333Q542 226 503 137L498 125L396 53Q308 -8 292 -17T260 -27Q226 -27 191 -9T136 29L145 39Q162 56 192 89L230 129L235 128H241Q276 57 332 57Q358 57 391 80Q403 89 409 100T422 143T428 227Q428 329 406 408T347 530T272 594T196 615Q152 615 135 596T118 558Q118 535 146 502T203 438T232 385Q232 357 195 322T122 265T83 243Q82 242 72 249T61 258L66 262Q72 265 82 273T103 292Q125 314 125 333Q125 351 101 376T51 432T26 492Q26 549 108 614T290 679Q326 679 335 678Q353 675 370 670T400 658T425 642T445 625T463 606T477 588T487 571T495 556T500 543L504 535L523 553Q553 581 569 595T619 632T686 667T757 678Q778 678 793 675T819 664T833 651T844 633T852 617Q884 548 910 548H916Q938 548 962 556L967 542Q967 540 947 531Q909 509 883 492T847 467T838 458Q825 419 825 328Q825 234 833 191T858 121Q875 94 892 77Q898 71 907 71Q912 71 928 76T957 87T971 91L972 88Q972 84 972 81L973 73L957 63Q891 21 806 -23L794 -30L783 -14Q766 13 728 60L713 79V372L724 384Q743 406 765 427T800 460L813 471Q809 472 806 472Q783 479 766 503T741 551T715 594T672 614Q644 614 622 595Q597 576 572 550T534 508L522 492",
  120186: "254 595Q269 583 269 581L262 577Q256 573 247 566T228 549T212 527T205 502Q205 480 266 386T328 277Q328 234 239 150L221 134L231 133Q264 131 376 99T516 62Q567 50 604 50Q614 50 626 52Q643 57 662 71T703 115T739 198T753 323Q753 454 692 517Q652 555 584 565T382 577Q365 577 357 577H308L300 591L292 606Q292 608 342 665L392 724L403 725Q406 725 411 726H416L417 725L412 715Q408 705 408 698Q408 684 423 679Q431 677 516 672T663 655Q757 634 806 593T873 463Q881 421 881 380Q881 340 874 306Q859 223 809 147Q801 134 789 124Q595 -30 456 -30Q395 -30 289 3T147 36Q134 36 121 33T98 26T76 15T59 4T44 -8T32 -17L22 -7L12 4L56 59L100 114L116 118Q217 142 217 199Q217 230 185 276T120 365T87 430Q87 435 109 464T172 534T254 595",
  120187: "247 398Q247 372 206 334T126 272T83 247Q82 247 72 253T61 261Q60 261 61 262T66 265Q127 306 127 343Q127 364 63 430Q42 451 38 458T33 480V490V497Q33 526 63 567Q112 632 170 660T282 688Q341 688 384 667Q454 633 482 566Q483 565 484 566T496 574Q562 623 630 653Q699 681 751 681Q778 681 797 673Q818 662 830 609Q835 580 843 564Q863 524 895 524H901Q917 524 932 528Q936 522 938 518T942 513T942 511Q873 480 836 454Q789 423 789 395Q789 362 834 298T880 200Q880 170 867 145T820 81Q733 -20 647 -20Q581 -20 499 21V9Q499 -16 502 -53T509 -116L512 -141L370 -223L357 -216Q344 -209 344 -208L348 -196Q370 -113 370 33V52L355 58Q307 76 284 76Q258 76 228 60T183 29T141 -11Q137 -7 133 -2L126 7L134 18Q181 89 210 121T278 170Q304 179 328 179Q336 179 358 177L370 175Q368 268 367 359Q367 416 363 434Q362 438 362 441Q348 527 302 574T203 621Q169 621 148 599T127 557Q127 535 187 476T247 398ZM673 315Q673 357 786 442Q786 443 776 444T750 449T727 462Q719 471 716 484V496Q715 507 715 515Q715 571 698 588Q680 611 643 611Q592 611 547 571Q534 558 511 522L499 505V139L543 123Q702 64 744 64Q770 64 781 79T793 112Q793 143 733 217T673 315",
  120188: "254 595Q269 583 269 581L262 577Q256 573 247 566T228 549T212 527T205 502Q205 480 266 386T328 277Q328 234 239 150L221 134L231 133Q264 131 376 99T516 62Q567 50 604 50Q614 50 626 52Q643 57 662 71T703 115T739 198T753 323Q753 454 692 517Q652 555 584 565T382 577Q365 577 357 577H308L300 591L292 606Q292 608 342 665L392 724L403 725Q406 725 411 726H416L417 725L412 715Q408 705 408 698Q408 684 423 679Q431 677 516 672T663 655Q757 634 806 593T873 463Q881 421 881 380Q881 340 874 306Q864 250 838 196T791 126Q748 93 733 82L715 69Q714 68 723 60T748 40T774 23Q806 2 832 2Q849 2 870 6T904 14L917 17Q917 12 918 6V-3L882 -22Q806 -60 778 -73L755 -83Q640 -36 596 -7L586 0L576 -4Q513 -30 457 -30Q394 -30 289 2T149 35Q119 35 93 22T52 -4T36 -17T24 -7T12 4L56 59L100 114L116 118Q217 142 217 199Q217 230 185 276T120 365T87 430Q87 435 109 464T172 534T254 595",
  120189: "31 498Q34 541 76 586T176 659T279 688H290Q377 688 429 653T506 569L511 558L526 572Q620 663 707 682Q722 685 737 685Q781 685 804 665T830 619T838 565T854 525Q866 511 897 511Q917 511 925 513L937 515Q938 515 941 509T944 501T925 493T870 470T803 438Q735 406 735 401Q735 400 741 399T767 390T814 374L828 367L829 307Q829 233 833 202T852 144Q873 109 896 90Q906 82 928 82T976 95V92Q976 88 978 72L807 -28Q768 39 733 87L718 108V149Q718 230 714 257T693 298Q654 333 580 333Q524 333 520 329Q520 300 489 224T443 133Q441 131 333 53T223 -27Q221 -26 204 -11T169 16T136 28Q110 28 66 -8L56 -16Q52 -13 40 -1L48 7Q165 124 211 124Q232 124 287 77L298 67Q309 73 337 97Q397 150 397 347Q397 419 379 474T330 560T269 604T207 619Q177 619 152 601T126 563Q126 540 185 479T244 387Q240 336 160 289Q144 278 98 255L80 246L62 261L79 272Q96 283 113 301T130 337Q130 353 115 373T81 410T47 451T31 498ZM524 358Q537 358 657 405T777 457Q777 459 768 459Q749 462 738 474T723 499T714 539Q706 585 697 599Q681 618 657 618Q632 618 597 595T532 515L525 502L524 441Q524 375 523 369Q523 358 524 358",
  120190: "457 -31Q356 -31 272 6T135 120T82 304Q82 372 106 430T170 527T241 588T305 626Q341 643 386 657T460 678T495 685T554 660T674 609T778 584Q800 584 818 591T848 610T866 633T878 651T883 659L893 649L901 639Q879 574 803 532T666 490Q661 490 657 490T650 491T641 492T633 495T622 500T610 505T595 513T577 522T554 533T527 547Q436 594 415 602Q393 608 374 608Q303 608 253 545T202 386Q202 229 307 135T568 41Q674 41 748 85T822 198Q822 244 779 283T639 322Q595 322 499 303T383 283Q358 283 335 290T291 318T270 374Q270 418 313 460T424 510H431L435 505L440 500Q425 496 403 475T380 427Q380 382 431 373Q437 372 475 372Q543 372 626 388T742 404Q831 404 868 362T905 260Q905 182 831 108Q692 -31 457 -31",
  120191: "666 641Q737 641 794 686L802 662Q790 648 734 596L677 541L664 538Q630 528 583 528Q540 528 482 537L461 541Q402 512 402 456Q402 427 439 387T512 311T549 253Q549 220 455 139L440 126Q541 75 586 75Q600 75 619 80T654 94T685 110T709 124T719 130Q722 125 725 119L730 108Q700 72 568 -18Q551 -30 542 -30Q495 -30 404 6T270 42H263Q213 42 142 -11L131 -19L129 -8Q126 1 126 4Q218 84 301 126L316 134H406L413 142Q436 165 436 189Q436 202 421 221T364 281Q336 307 318 328T296 356T283 381L290 394Q338 478 410 540Q419 549 417 549Q415 550 369 558T268 575T195 584Q153 584 127 567T100 523Q100 499 116 479T151 447T170 433Q170 429 171 428Q171 427 131 394T88 359Q82 363 73 370T47 403T31 457Q31 513 79 565T197 648T332 679Q369 679 490 660T666 641",
  120192: "273 244Q273 281 244 331T186 428T155 502Q155 524 165 536Q239 634 333 688Q338 684 345 680L356 672L344 664Q310 642 295 624T280 582Q280 550 303 505T348 407T371 300Q371 270 362 248L247 123L358 92Q452 64 484 64Q507 64 523 72Q553 87 573 109Q583 121 586 146T593 283Q594 303 594 344Q594 401 591 461T584 558L581 595Q598 600 623 611T672 634T719 659T754 678L768 686Q770 686 784 673L782 670Q781 668 777 664T768 655Q747 635 738 616T721 535T714 359Q714 205 723 176Q727 164 744 133T771 89Q780 75 804 75Q814 75 853 87L867 92L871 73L671 -39L654 -10Q636 20 619 50T600 83Q600 84 589 75T539 34Q478 -16 475 -19Q469 -22 449 -28T414 -34Q410 -34 394 -32Q356 -28 282 -2L237 15Q169 38 126 38Q106 38 85 27T51 4T37 -8T27 -1T18 8Q18 10 70 63T124 116Q154 123 176 131T223 154T260 191T273 244",
  120193: "133 343Q133 360 79 416T25 496Q25 523 58 563T118 624Q197 685 293 685Q331 685 339 684Q453 665 489 558L493 546Q521 570 553 596T640 653T725 684Q753 684 783 672T844 641T889 618Q895 616 912 616Q924 616 936 617T956 620T965 622T966 612V604L952 595Q924 576 895 549Q864 517 856 496T847 448V434Q847 395 848 388L859 323Q874 241 874 212Q874 142 830 96Q796 62 724 14Q661 -29 603 -29Q555 -29 421 28T242 86Q182 86 110 31Q105 28 102 26T99 25Q88 36 88 42Q95 54 222 142Q252 163 262 165Q319 183 344 218Q378 266 378 377Q378 444 362 494T319 571T266 610T212 623Q181 623 156 603T131 562Q131 539 154 512T206 458T243 416Q246 409 246 399Q246 387 242 377T225 351T178 311T94 259L79 251Q72 256 68 261T62 268L61 270L70 277Q131 318 133 343ZM822 526Q778 531 719 564T628 597Q611 597 579 574Q543 543 513 506L505 495L506 473Q506 469 506 461T507 449Q507 348 467 271L462 261L404 218L348 174Q349 173 356 173Q384 169 450 144L546 105Q665 56 708 56Q737 56 746 72T756 118Q756 129 755 135L741 219Q725 314 725 334V344Q725 416 736 431Q748 450 815 510L832 526H822",
  120194: "133 317T133 338T80 413T26 496Q26 532 83 591Q100 608 111 616T151 644T219 672T304 682Q381 682 434 646T506 564L510 557Q513 557 534 573L677 665L707 683L790 561L803 572Q933 682 1001 682Q1037 682 1098 650T1193 616Q1208 616 1222 619L1235 622Q1239 622 1239 616Q1239 611 1240 609Q1240 608 1206 577T1138 503T1104 430Q1104 409 1123 330T1142 208Q1142 183 1136 147Q1127 118 1117 106Q1114 103 1031 48T935 -14Q930 -18 908 -22T862 -27Q826 -27 759 -6T647 26Q597 38 578 38Q573 38 561 33T533 20T505 4T480 -10L469 -16L452 -26L439 -28Q423 -30 411 -30Q358 -30 279 7T169 45Q125 45 58 -5L47 -14L41 -4L35 8Q35 11 56 29T113 75T181 125L200 139H217Q279 143 320 180T377 270T394 393Q394 453 378 498T334 568T277 605T213 617Q177 617 155 607Q140 600 130 587T119 560Q119 545 137 522T177 479T217 434T236 393Q236 324 98 251L89 246L76 253L63 261Q91 275 112 296ZM1088 526Q1066 526 1004 556T909 586Q863 586 816 539L802 526L804 514Q814 461 814 411Q814 319 781 238Q772 214 760 198T730 165T702 136L715 133Q759 122 848 90T973 57Q1003 57 1017 80Q1022 93 1022 116Q1022 152 1003 241T983 377V391Q983 405 985 409T1002 429Q1019 450 1045 475T1090 514L1107 528Q1104 527 1102 527T1096 527T1088 526ZM699 358Q699 391 696 419T688 467T675 503T660 530T642 550T626 563T608 574T593 582Q581 575 559 554T524 512Q523 510 523 477Q523 315 444 218L435 207L368 169Q301 132 301 131Q307 128 315 125L377 99Q476 57 515 57Q534 57 608 94L627 102L636 111Q699 187 699 358",
  120195: "273 679Q354 674 408 633T477 525L484 533Q496 548 524 574T571 615Q594 633 625 649T675 673T699 681Q724 632 747 607Q754 601 756 599T765 594T777 591T794 590Q818 590 834 594V585L835 577L704 513L693 518Q657 534 631 560T597 599Q596 601 581 584Q495 490 489 379V366H562L681 369Q682 369 679 366T668 355T651 341L620 314H485V295Q490 190 543 125T686 60Q720 60 789 88L801 93V89Q798 83 798 66Q781 59 685 -10L665 -25L634 -30Q596 -35 594 -35Q570 -35 536 -23T477 19Q461 37 445 67T418 118L409 138Q401 131 388 120T340 79T273 28T206 -12T151 -31Q129 -31 90 -12T32 22L113 101Q114 101 120 96T136 84T160 69T189 56T221 51Q256 51 305 90Q376 149 376 301V315H293Q276 315 251 315T210 314T190 313L168 312Q168 313 200 340L231 368L238 367Q275 367 311 366H378V387Q376 470 355 512T291 572Q274 579 252 579Q223 579 197 568T156 544T131 519T117 508Q112 512 108 518L99 527L117 545Q177 604 255 665L273 679",
  120196: "34 496Q34 518 53 549T107 610T195 661T310 682Q357 682 398 663T460 611Q467 600 475 583T489 554T495 542Q495 544 531 570T617 629T700 676L724 688Q742 670 756 657T784 635T806 621T830 606T856 592Q878 416 878 340Q878 154 805 -3L798 -20L779 -40Q706 -113 613 -163T421 -214Q359 -214 317 -196T256 -160L306 -63L313 -64L320 -66L326 -79Q337 -104 349 -120T392 -151T470 -166Q576 -166 644 -101Q750 7 750 292Q750 426 721 495T617 565H611Q563 565 513 509L506 501L508 493Q508 490 509 475T510 445Q510 319 458 236L451 225L436 216Q406 198 365 169T318 134L332 127Q336 126 397 103T489 80H493Q527 80 593 129L604 137L607 127Q610 119 610 116Q610 114 592 95T543 46T484 -4Q450 -27 446 -27Q441 -27 402 -18Q365 -9 290 20T188 50Q135 50 64 -7L52 -17L43 -7L34 2L51 19Q118 87 177 132L192 143H215Q259 145 289 155T335 184T355 214T366 245Q382 306 382 388Q382 426 381 436Q368 520 318 570T214 621Q184 621 165 608T142 583T137 562Q137 541 163 508L201 469Q245 425 251 408Q253 403 253 398Q253 383 240 366T212 335T161 295Q128 271 99 253L89 247L77 256L65 266L76 273Q125 301 134 329Q136 334 136 342Q136 357 124 372T88 410T49 455Q34 479 34 496",
  120197: "278 601Q242 601 212 591T167 570T121 533Q114 528 111 525L93 550Q223 661 244 667Q299 677 356 677Q415 677 456 666T515 634T541 596T549 555Q549 513 529 478T480 421T424 388T377 372Q365 370 365 367Q365 365 389 365T450 358T523 337T588 282T623 183Q624 177 624 161Q624 20 524 -60Q415 -148 285 -148Q242 -148 213 -139Q181 -131 159 -109Q136 -87 127 -56T114 6T104 49Q94 69 57 69Q38 69 13 58L1 53Q1 55 0 59T-3 68T-4 76Q78 130 138 142Q150 144 162 144Q213 144 227 120T242 31Q242 -30 263 -66T345 -102Q397 -102 444 -52T491 107Q491 172 471 211T428 265Q392 288 306 288Q269 288 233 284L218 282Q208 289 208 291L229 324L251 359Q250 360 248 360Q239 360 248 371L256 381H273Q344 385 378 409T413 495Q413 537 384 569T278 601",
  120198: "80 129V151Q80 241 99 363Q99 367 111 372T172 401T285 465L297 472Q340 455 405 443L423 440L455 453Q486 467 489 467L497 461L494 451Q480 390 480 292V283Q480 207 483 155L484 143L535 80L558 90L582 99Q586 95 586 83Q586 81 513 25L443 -29Q410 16 386 40L371 55V61Q371 63 371 67T370 74V80L278 25Q186 -29 184 -31Q182 -32 160 -12T112 35T80 75V129ZM359 366Q334 366 300 371T243 382L221 388Q218 388 212 375T200 323T194 228Q194 191 197 152L198 139L217 120Q245 92 269 74L279 66L304 78Q338 95 349 100L369 110V152Q368 164 368 210T367 275Q367 358 366 361V366H359",
  120199: "99 398Q99 610 86 662Q86 665 95 669T106 674L108 669Q109 664 112 654T119 635Q122 626 125 616T130 601L131 596Q214 649 273 678Q295 690 298 690Q299 690 304 688T313 682L317 679Q275 653 240 612Q210 569 210 469V459Q210 450 210 432T211 406L212 378L285 425Q301 435 321 447T350 466L360 472Q360 473 361 473T368 471T401 456T465 429L501 414V408Q504 386 504 309Q504 255 500 203T491 125T485 97Q485 95 445 74T343 23T237 -24L214 -32Q197 -22 165 3T109 49T87 73Q99 169 99 398ZM386 251Q386 320 380 347V350L305 374L282 382L214 348L213 274Q213 184 214 165V131L230 119Q288 76 349 54Q386 137 386 251",
  120200: "227 393Q215 393 210 351T205 269Q205 161 213 153Q220 145 244 125T290 88L312 72L365 92Q414 113 418 113V93L365 60Q255 -9 221 -26L211 -18Q158 21 91 88L90 107Q87 167 87 225Q87 267 90 302T96 351T100 366L295 473L311 470Q340 464 368 454T410 437T424 429L347 334L342 333H337L325 342Q299 363 271 378T228 393H227",
  120201: "88 117Q88 177 91 231T97 310T102 341Q102 343 118 357T168 397T239 447L257 459L268 454L278 449Q242 416 238 412L219 394Q219 391 216 378T211 349T206 307T203 249Q203 211 206 166L208 148Q224 132 261 108T333 70Q341 66 342 67T350 79Q393 157 393 302Q393 368 388 406V411L371 424Q199 558 101 558Q69 558 28 545L18 542L8 549L-1 557L24 569Q61 587 147 621L177 632Q179 631 194 627T216 621T240 613T269 602T302 589T340 571T382 549T431 522T484 488Q504 475 504 472Q511 449 511 365Q511 248 474 129L468 108L451 96Q427 77 347 28T254 -28Q235 -20 174 21T89 86L88 117",
  120202: "309 69Q391 98 416 108Q418 106 422 100T425 92Q419 86 326 30T229 -27Q228 -27 207 -13T154 27T97 76L85 87L84 106Q81 152 81 194Q81 295 93 359L95 369L286 471L313 449Q376 397 414 372L428 362Q428 360 375 318L188 181V170Q188 156 189 153V148L203 138Q228 119 266 94T309 69ZM209 389Q208 388 204 366T194 307T187 244Q187 225 188 225T201 233L245 261Q283 284 291 291Q324 313 324 316L296 334Q280 343 259 357T224 380L210 390Q209 390 209 389",
  120203: "128 400Q127 401 121 422T108 478T99 540V555L111 569Q135 597 165 626T214 671T235 687L249 678Q263 668 282 659T315 650Q335 650 362 666L372 654L286 569H271Q205 576 173 586V583Q173 558 208 492T252 401Q253 399 310 399T367 398L332 355H254V311Q251 160 235 16Q230 -28 226 -36Q225 -38 221 -45Q171 -140 121 -211L113 -222H104Q94 -222 94 -220Q94 -215 105 -187L121 -145Q139 -80 139 35V93Q139 222 135 314L134 354Q134 355 84 355H35L84 399H106Q128 399 128 400",
  120204: "92 71Q92 74 91 88T88 128T86 183Q86 230 91 275T102 342T109 366Q115 372 207 422T305 472Q407 426 431 426Q435 426 476 445L519 465L525 463L532 461Q497 392 497 268Q496 255 496 233Q496 179 516 92T539 -10L541 -22L526 -38Q441 -126 355 -194L339 -206L327 -207Q324 -207 319 -207T310 -208Q242 -208 171 -179T73 -131L56 -141Q40 -150 38 -150Q17 -140 17 -137Q17 -136 18 -136T98 -79L176 -23Q174 -21 134 24T92 71ZM226 393Q224 393 221 372T214 312T210 235Q210 182 214 144L215 132L230 118Q281 70 301 66Q304 66 331 80T373 105L384 112L383 165Q383 224 387 309Q387 314 387 319T387 329T388 336T388 341V343Q388 344 381 344T339 354T249 384Q246 385 243 386T236 389T231 391T228 392L226 393ZM414 -80Q414 -64 411 -43T403 -1T394 37T386 66T382 79Q381 79 286 15T189 -52Q312 -125 365 -125Q397 -125 405 -115T414 -80",
  120205: "95 661Q95 662 103 667T113 672L126 634L137 596L147 602Q235 656 275 677L292 687L303 680Q305 679 307 677T312 674L313 672L310 670Q307 669 301 667T289 660T274 649T259 634Q250 622 244 611T233 585T226 560T222 528T221 497T220 456T219 413V377L232 384Q244 391 271 409T339 455L362 471L383 461Q425 440 491 415L504 410V406Q507 399 507 269Q507 76 486 -21Q485 -30 483 -33T461 -57Q382 -139 299 -207L281 -197L263 -186L266 -185Q268 -184 280 -177T312 -155Q344 -130 353 -116Q394 -59 394 117Q394 162 391 216T386 301T382 335Q382 338 365 346T323 364T281 376L250 362Q220 347 219 347Q213 336 213 232Q213 177 217 144L218 128L224 119Q244 92 263 71L272 60Q206 21 157 -24Q156 -24 151 -16T132 11T98 52L89 62L91 103Q104 289 104 436Q104 471 103 506T101 568T99 616T96 649L95 661",
  120206: "73 613L164 686L184 666Q200 650 214 637T235 620T242 614T203 577T162 540Q158 540 122 570T73 613ZM92 58Q92 63 94 83T98 142T101 234Q101 318 97 358V366L59 387L40 379L21 371Q20 371 12 376T3 382L38 406Q78 431 125 466L138 477Q149 468 186 444L219 422V389Q215 324 215 247Q215 136 222 123Q226 113 238 98T258 83Q263 83 292 94L322 104Q322 103 324 97T327 89Q327 88 317 82T272 52T190 -7Q166 -25 164 -25L112 35Q92 55 92 58",
  120207: "74 611L155 682Q172 666 186 655T208 636L235 614Q227 606 191 574L154 540L135 556Q101 582 84 601L74 611ZM10 377L144 477Q145 476 184 453T229 428L233 425V416Q238 346 238 252Q238 93 215 -16L213 -30L185 -57Q29 -203 19 -203Q17 -203 -19 -189L-9 -183Q52 -146 78 -116T114 -37Q120 31 120 192V237Q120 327 113 351T72 380L53 372Q34 362 32 364L10 377",
  120208: "106 72Q110 105 111 193T114 294V308H74L34 309L83 346H115V430Q114 591 106 652Q105 662 107 665T114 668T123 672Q125 672 139 635L152 597L154 598Q156 600 160 602T167 607Q193 625 226 644T279 672T302 682L312 676L321 670L312 665Q281 649 263 626T241 587T233 547Q232 541 231 530T230 510T230 501Q231 501 265 522T334 564T369 583L380 570Q428 509 428 481Q428 475 427 470T423 459T416 448T404 434T389 418T369 397T344 371L321 347L365 346H409L372 308H227V294Q227 272 230 208T234 138Q234 136 256 119T302 84L324 68L372 88Q421 108 422 108T432 90L421 83Q373 53 270 -5L234 -25L204 -1Q172 25 124 60L106 72ZM336 434Q336 452 327 472T308 503T297 514Q296 514 290 510T275 499T264 490Q230 458 230 358V346H247Q268 346 276 350T302 372Q328 398 335 423Q335 424 335 428T336 434",
  120209: "111 275Q111 406 108 518T104 650V657Q105 657 109 660T117 665T122 666L133 629L144 594L161 606Q218 642 272 670L294 681Q295 681 300 677T306 672L302 669Q298 666 292 662T278 651T263 637T251 621Q232 587 227 530T222 343Q222 226 230 125L231 112L244 98L258 83Q271 87 285 92L312 102V84Q297 72 231 24T163 -23L100 55Q110 141 111 275",
  120210: "115 203Q115 257 114 291T112 338T111 355Q111 357 93 370L75 384L54 375Q32 366 31 365Q27 365 16 378Q25 383 89 430L152 476Q175 453 228 420Q229 420 229 418T229 410T227 394L225 369Q279 400 315 425T363 461T376 471Q480 424 514 416V412Q514 411 514 404T513 392L511 376L520 382Q529 387 548 399T584 422Q599 432 618 444T648 463L657 469H658Q661 469 681 461T735 440T796 420Q803 418 803 416Q801 414 798 390T791 325T788 247Q788 220 790 172T794 123Q799 115 814 97T835 78H838Q841 78 867 89L895 101Q896 101 896 100T897 92T900 78L873 62Q810 23 761 -12L736 -30Q735 -30 729 -22T707 7T671 48L661 59Q674 93 674 207V219Q674 341 670 344Q655 353 591 372L576 376L544 364Q511 351 510 351Q507 349 507 224V132L535 95Q541 87 548 78T560 63L563 58Q563 57 504 15T444 -28L385 53L387 67Q396 114 396 206Q396 289 393 334Q393 346 390 348Q369 358 306 373Q301 373 265 361L228 349V335Q227 322 227 284Q227 206 231 157Q231 151 231 144T232 133V129Q232 125 259 90Q286 56 286 53Q287 53 284 51T273 43T258 31L173 -31L166 -20Q160 -11 145 7T119 38T108 59Q108 62 110 81T113 133T115 203",
  120211: "608 88Q572 65 535 37T477 -8T455 -25Q432 7 389 53L375 68L378 82Q386 160 386 195V221Q386 284 385 307L384 344Q352 359 306 373L286 379L213 353V273Q214 229 214 161V129L275 62L163 -28L150 -14Q136 0 121 16T91 44Q86 48 86 50Q95 83 96 148Q96 224 89 340L88 366L79 374Q69 384 67 385L64 388L55 383Q52 382 44 378T33 373L21 367L13 374Q5 379 5 381Q5 384 69 428L133 473Q135 473 147 464T179 443T215 424L214 400V376Q271 404 342 457L363 472Q363 473 364 473Q366 473 375 469T418 449T502 414L512 411V407Q502 330 502 217V197V132L523 109Q527 104 533 97T543 87T547 83L550 80L578 92Q603 103 604 103Q606 103 608 88",
  120212: "107 102Q107 178 112 242T123 334T129 362Q129 363 140 368T199 400T315 469L336 482L346 476Q409 439 498 414L514 410L515 389Q515 208 502 141Q494 101 491 94Q490 89 478 81Q430 51 375 23T288 -20T254 -34Q250 -34 200 -1T119 56L108 65L107 76V102ZM389 355Q367 358 346 363T309 372T282 381T264 388L257 390H256Q254 390 249 381T238 348T227 293Q226 280 226 237Q226 183 231 146L232 131L244 122Q285 91 323 74T374 57H377L380 68Q405 154 405 267Q405 315 401 349V354L389 355",
  120213: "66 435Q66 445 117 501T173 557Q174 557 183 555T193 551Q174 526 174 509Q174 496 190 472T233 428V386L377 482L399 471Q450 445 509 425Q519 421 519 420L518 419Q518 418 518 416T517 410Q517 405 518 381T519 335Q519 222 501 137Q492 84 489 84L473 75Q457 66 423 44T354 -6L338 -19L329 -13Q320 -8 313 -4T297 4T284 10T270 14T258 17T245 20T233 22V12L241 -161L214 -172Q187 -184 160 -195T131 -207Q127 -207 112 -202L113 -188Q113 -182 115 -77T118 31Q118 32 109 32Q63 27 23 0L10 -9Q5 -4 -1 8Q1 13 52 57T114 101H115L117 123Q117 141 117 230V359L110 367Q85 394 71 421Q66 433 66 435ZM384 83Q386 83 389 110T396 180T400 254Q400 294 395 339L394 349L379 355Q308 383 294 383Q290 383 263 372L234 360L233 245V130Q270 125 305 113T361 92T384 83",
  120214: "362 -196Q375 -92 375 47V78L282 24Q189 -29 188 -30Q187 -30 139 21T90 75Q87 84 87 158Q88 206 94 259T107 342L113 372L308 478L322 473Q374 452 421 444L433 442L503 485Q515 479 515 477Q485 378 485 56Q485 -100 494 -164V-171L381 -211L371 -207L362 -202V-196ZM280 72Q301 77 323 86T358 101T372 110Q372 268 377 346L378 358H374Q368 360 358 360T323 365T257 380L234 386Q231 386 229 379Q215 353 211 310T207 180Q207 152 208 150Q210 142 235 114T280 72",
  120215: "23 367Q21 370 18 374T14 380L13 382L151 472L236 411L238 381L290 426Q298 432 307 439T322 452T333 461T342 467L344 469Q382 410 404 399Q410 397 416 397Q423 397 432 399T446 403L451 405Q453 405 453 399V393Q430 374 404 356T364 328T350 318L349 317Q321 320 276 356Q257 371 256 371Q253 374 249 366T242 351Q232 321 232 236Q232 214 232 205T232 182T233 162T235 148T238 137T242 129T249 120T257 114T268 105T281 95Q313 70 314 70L358 85Q377 92 389 96T402 100V90L403 80L229 -26L221 -18Q195 6 166 29T121 63T105 76T106 82T110 97T114 121T117 158T119 208Q119 269 114 329L113 341L103 350Q90 362 67 380L45 374L23 367",
  120216: "189 331Q190 304 196 282T207 252T214 244Q239 244 348 292L371 302L382 297Q398 290 415 279T433 265Q442 238 442 166Q442 103 423 45Q416 42 380 29T310 3T244 -26L227 -34Q139 40 73 40Q61 40 48 37T24 30T6 22T-8 14L-13 11Q-14 11 -18 18T-23 26T38 75T102 125Q107 128 146 131H153Q192 131 296 56Q318 40 318 43Q323 48 323 114Q323 157 321 177L319 194Q308 208 291 216T261 225Q239 225 160 185L123 167Q85 205 79 227Q78 230 78 304V377L171 428Q264 479 265 478Q268 478 287 465T334 440T384 427Q423 427 475 463L478 453Q481 446 481 442Q481 439 410 391L339 342H331Q309 345 277 361T222 391T198 406T195 399T191 372T189 331",
  120217: "328 69Q401 102 403 102Q404 102 405 94T406 84Q406 83 318 28L230 -27Q223 -21 206 -5T171 25T132 54L124 60V71Q129 154 129 297V359H43L44 363Q44 365 44 367L45 369L48 372Q51 374 57 378T68 387L90 405H129V553L285 648Q304 641 306 640L260 598V592Q259 589 255 505T249 413V405H353V402Q353 399 328 379L303 360H245V319Q245 150 253 125Q257 115 276 101T311 78T328 69",
  120218: "444 -31Q444 -29 384 66Q382 66 364 58T309 30T231 -17Q214 -29 212 -29L197 -20Q172 -4 140 11T88 34L68 42Q68 43 73 49T85 67T100 98T113 149T118 221Q118 272 105 332L100 356L58 383L23 365L9 379L76 425Q141 472 144 472Q144 471 183 443L221 414V404Q224 365 224 275V253Q224 159 196 113Q191 104 193 104Q203 104 285 72L308 62L374 89L375 106Q375 266 373 340Q373 364 371 396V424L430 445L491 467Q493 467 499 463T505 457Q505 456 503 442Q488 335 488 187V158L529 81L534 80Q541 80 568 90L598 101Q605 94 602 87L524 27Q445 -32 444 -31",
  120219: "95 67Q104 80 104 193Q104 261 100 321L98 355L91 363Q56 402 56 421Q56 441 82 472T132 524T159 546Q174 542 175 542Q159 520 159 501Q159 481 205 432L221 415L220 401Q219 394 219 387L288 429Q309 441 325 451T347 465T358 472T365 476L504 415V409Q504 408 505 374T507 318Q507 155 474 91L469 80L343 26Q314 14 281 0T232 -20L216 -27L202 -15Q192 -5 152 28Q141 35 126 45T103 60T95 67ZM386 349Q302 389 287 389Q271 383 253 375L220 361V136Q226 120 256 100T312 68T342 56Q355 56 360 68Q389 134 389 258Q389 310 386 341V349",
  120220: "90 58T90 59T92 64T97 78T102 105T107 150T109 218Q109 290 103 350V356L83 377Q55 407 55 425Q55 445 138 528Q158 549 162 549L164 548Q165 548 167 548T170 547L175 546L172 540Q168 533 165 523T161 502Q161 479 216 430L229 419V382Q232 382 366 471Q407 445 500 408L511 404V387L512 370L595 420Q678 469 679 469L693 462Q756 431 795 417L815 409L814 380Q812 187 782 96Q774 71 766 62T744 48T684 25T577 -23L557 -32L546 -26Q536 -19 519 -10T481 10T436 31T393 47Q384 50 380 50Q380 52 381 58T384 77T387 104Q391 174 391 256V292L390 333L377 340Q350 357 304 373L294 376L227 355V348Q224 322 224 243Q228 117 232 112L235 108Q238 103 245 95T257 80L281 50Q281 49 227 10T172 -29L159 -13Q133 19 116 36T94 56ZM652 64Q658 64 667 84T685 162T697 303V336L686 341Q653 356 619 367L591 376Q590 376 553 361T514 344T512 324T510 275T508 221Q508 167 510 152T521 126Q537 112 590 88T652 64",
  120221: "8 -90Q8 -68 13 -63Q13 -56 53 -8T120 63L128 71L129 85Q133 120 134 182Q134 308 131 331T106 365Q100 367 97 369L75 381L35 365L20 377Q20 378 47 397T110 440T161 471L253 413V396Q253 378 254 378L309 422Q364 466 365 466Q365 467 366 466T370 461T376 454Q403 419 426 396L441 380L438 377Q438 376 433 372T420 359T404 344L372 314Q351 320 338 327T310 344T277 364Q261 364 252 316Q251 306 251 235Q251 136 255 129Q257 127 258 124T268 113T298 92Q334 68 335 68Q340 70 349 73T377 84T408 95T421 99Q422 99 422 90L423 82L334 26Q246 -28 243 -28L200 8Q156 43 148 43Q144 43 130 36T99 9T83 -36Q83 -67 121 -89T198 -118L237 -124V-129L238 -133L193 -160Q183 -166 171 -173T152 -184L146 -188Q140 -187 131 -185T98 -173T56 -154T23 -127T8 -90",
  120222: "280 53Q272 47 246 27T199 -10T176 -27L167 -18Q137 17 107 44L90 60L93 71Q108 130 109 290V331Q109 339 109 344T108 353T107 359T105 364T102 369T97 374T91 381Q60 412 60 432Q60 448 86 479T138 534L164 557Q168 553 180 553Q163 532 163 511Q165 491 186 468Q206 443 231 423V404L232 385L371 477L389 468Q439 441 498 418L512 412V386Q512 360 507 190T500 14Q488 -26 445 -67Q401 -111 355 -148T282 -203T249 -221Q247 -220 230 -210T213 -199T229 -191T269 -172T306 -151Q361 -120 379 14Q391 92 391 182Q391 218 386 305Q384 339 380 341Q363 353 330 366T288 379Q282 379 258 368L230 356V181V141Q230 127 232 120T236 108T251 89T275 59L280 53",
  120223: "153 371Q141 371 126 365T100 354T78 340L65 331L57 338L50 346L62 356Q133 419 222 471Q274 453 306 422T338 366Q338 356 329 346T283 301L243 264L262 257Q298 246 361 214Q378 154 378 73Q378 33 371 -9T356 -74T345 -104Q340 -106 267 -160L191 -214H177Q60 -214 13 -150Q-7 -122 -7 -115Q-7 -112 19 -77T106 25T241 149Q241 152 227 158T181 173T109 185V190L108 194L158 229Q212 267 223 278T234 306Q234 329 208 350T153 371ZM258 1Q258 42 257 68T254 105T252 118Q235 105 210 85T144 22T102 -45Q102 -79 146 -106T234 -133H238Q248 -128 254 -80Q258 -58 258 1",
  120224: "183 181Q183 179 152 91T118 0H28L154 346L280 693Q281 694 333 694H385L511 349Q636 4 638 2Q638 0 584 0H530L464 183H184L183 181ZM324 606Q319 578 292 492T238 332T210 256Q210 254 324 254T438 255L429 281L419 308Q409 336 395 378T365 465T339 551T324 611V606",
  120225: "425 363Q438 363 465 353T526 324T585 270T610 192Q610 132 561 78T426 7Q404 2 387 2T240 0H90V694H227Q373 693 396 689Q484 673 533 623T583 517Q583 494 574 473T551 437T520 409T487 388T456 374T433 366L425 363ZM490 516Q490 527 485 539T467 568T423 599T347 621Q340 622 262 623H188V399H261H286Q432 399 478 475Q490 496 490 516ZM514 190Q514 245 462 280T343 322Q336 323 259 323H188V71H274Q365 72 388 77Q445 88 479 121T514 190",
  120226: "59 347Q59 440 100 521T218 654T392 705Q473 705 550 680Q577 670 577 667Q576 666 572 642T564 595T559 571Q515 601 479 613T392 626Q300 626 232 549T164 347Q164 231 229 150T397 68Q453 68 489 80T568 120L581 129L582 110Q584 91 585 71T587 46Q580 40 566 31T502 5T396 -11Q296 -11 218 41T99 174T59 347",
  120227: "88 0V694H237H258H316Q383 694 425 686T511 648Q578 604 622 525T666 343Q666 190 564 86Q494 18 400 3Q387 1 237 0H88ZM565 341Q565 409 546 463T495 550T429 600T359 621Q348 623 267 623H189V71H267Q272 71 286 71T310 70Q461 70 527 184Q565 251 565 341",
  120228: "86 0V691H541V611H366L190 612V397H513V321H190V85H372L554 86V0H86",
  120229: "86 0V691H526V611H358L190 612V384H485V308H190V0H86",
  120230: "59 346Q59 499 157 601T384 704Q436 704 466 700T541 679Q551 674 560 670T575 664T583 660T588 658T590 656Q590 652 582 605T573 557L564 564Q489 626 392 626Q301 626 233 549T164 347T233 145T392 68Q441 68 506 84V223H388V299H599V38L588 33Q494 -11 393 -11Q296 -11 219 40T100 172T59 346",
  120231: "86 0V694H190V399H517V694H621V0H517V323H190V0H86",
  120232: "87 0V694H191V0H87",
  120233: "181 53Q200 53 215 56T241 66T259 79T272 95T280 109T285 122L287 129V694H388V415V229Q388 135 385 112T369 63Q364 51 355 39T328 12T280 -12T212 -22Q172 -22 130 -12T66 8T43 20L46 42Q50 65 54 88L58 110Q58 111 65 104Q107 53 181 53",
  120234: "88 0V694H188V519L189 343L525 694H638L375 419L651 0H541L309 351L188 225V0H88",
  120235: "87 0V694H191V79L297 80H451L499 81V0H87",
  120236: "92 0V694H228L233 680Q236 675 284 547T382 275T436 106Q446 149 497 292T594 558L640 680L645 694H782V0H689V305L688 606Q688 577 500 78L479 23H392L364 96Q364 97 342 156T296 280T246 418T203 544T186 609V588Q185 568 185 517T185 427T185 305V0H92",
  120237: "88 0V694H235L252 659Q261 639 364 428T526 84V694H619V0H472L455 35Q453 39 330 294T185 601L181 611V0H88",
  120238: "55 345Q55 504 149 609T361 715Q386 715 406 713Q521 696 600 592T680 344Q680 193 590 86T368 -22Q239 -22 147 84T55 345ZM276 59T368 59T518 146T576 360Q576 473 525 545T401 634Q371 637 362 637Q284 637 222 562T159 360T217 147",
  120239: "88 0V694H230Q347 693 370 692T410 686Q487 667 535 611T583 485Q583 409 527 348T379 276Q369 274 279 274H192V0H88ZM486 485Q486 523 471 551T432 593T391 612T357 621Q350 622 268 623H189V347H268Q350 348 357 349Q370 351 383 354T416 368T450 391T475 429T486 485",
  120240: "55 345Q55 504 149 609T361 715Q386 715 406 713Q521 696 600 592T680 344Q680 284 665 231T629 143T587 85T551 48L536 35L648 -120L652 -125H531L452 -8L440 -12Q407 -22 369 -22Q239 -22 147 85T55 345ZM579 345Q579 473 517 555T369 637Q279 637 218 554T156 345Q156 223 215 141T368 58Q376 58 382 58T392 58T397 59T401 60T403 61H404Q404 63 360 128T315 194H421L453 150Q485 105 486 105Q490 108 496 113T517 138T545 182T567 247T579 334V345",
  120241: "88 0V694H227H259H302Q365 694 399 689T474 663Q528 637 558 595T589 504Q589 482 584 462T569 426T547 396T522 372T495 353T470 338T449 328T434 322L429 320L440 300Q452 280 477 238T523 160L617 1L565 0Q513 0 512 1Q512 2 424 156L337 309H189V0H88ZM492 504Q492 600 367 620Q354 622 271 623H189V385H271Q363 386 388 392Q432 402 462 430T492 504",
  120242: "55 514Q55 589 115 652T283 716Q315 716 345 711T396 699T432 685T457 672T467 667Q467 666 459 618T449 568Q383 634 282 634Q214 634 182 600T150 525Q150 507 155 492T172 465T194 446T222 432T247 423T272 416T289 412Q353 396 378 384Q432 358 466 307T500 194Q500 110 438 44T272 -22Q215 -22 159 -5T73 28T44 50Q45 51 49 75T57 122T62 146L65 143Q68 140 74 136T88 125T107 111T131 98T160 85T194 74T232 66T274 63H286Q327 63 366 96T406 182Q406 245 352 280Q329 296 265 310T173 339Q124 363 90 409T55 514",
  120243: "36 608V688H644V608H518L392 609V0H288V609L162 608H36",
  120244: "87 450V694H191V449Q192 203 193 194Q200 148 220 117T266 72T311 54T347 49Q404 49 446 84T501 178Q505 195 505 218T507 449V694H600V450Q600 414 600 356Q599 198 595 181Q594 178 594 177Q575 89 505 34T345 -22Q258 -22 184 34T89 196Q88 205 87 450",
  120245: "14 692Q14 694 68 694H122L146 633Q325 165 339 90Q340 87 341 87Q341 124 530 619L558 694H605Q652 694 652 692Q650 690 523 354T390 10L387 0H279L276 10Q271 18 144 354T14 692",
  120246: "115 694Q115 693 156 550T233 266T270 90L271 85Q272 86 272 92Q272 153 405 616L427 694H524L553 590Q672 174 681 95L682 84L684 95Q689 138 728 287T803 563T841 692Q841 694 885 694T929 693Q929 691 829 346L730 0H679L628 1L606 75Q478 524 470 600L469 611L467 600Q458 518 338 101L310 0H213L114 346Q14 691 14 693Q14 694 64 694H115",
  120247: "14 0Q16 5 144 184T275 367L153 528Q121 571 88 615T42 674T28 694H150L228 584Q315 463 316 461L326 448L497 694H610L609 692Q606 689 492 528Q440 454 409 410T378 366Q378 365 515 182L652 0H531L326 292Q326 293 299 254T226 146L128 0H14",
  120248: "4 693L64 694H125L174 621Q335 378 340 364L341 362Q361 398 395 450L558 694H663L383 277V0H282V278L143 485Q112 531 75 586T21 668L4 693",
  120249: "69 617V694H555V643L373 362Q190 81 190 79H234Q244 79 272 79T344 80T419 81H560V0H55V53L237 334Q420 615 420 617Q413 618 387 618Q380 618 334 618T245 617H69",
  120250: "236 387Q209 387 184 382T141 370T111 355T91 342T83 337L82 355Q80 373 79 393T77 417Q77 419 81 421Q86 423 91 426Q155 460 227 460H238Q319 460 368 400Q393 371 400 341T408 252Q408 240 408 207T407 152V0H317V39L306 32Q244 -10 159 -10H152Q109 -10 77 22Q38 61 38 126Q38 142 39 146Q55 199 130 223T295 252H314V277Q314 305 313 310Q308 342 287 364T236 387ZM303 186Q124 180 124 126Q124 105 144 86T208 66Q284 66 309 124Q314 137 314 166V186H303",
  120251: "303 -11Q280 -11 259 -6T222 6T194 21T176 33T168 38V0H75V694H165V550L166 405Q247 455 336 455Q397 455 439 389T482 226Q482 115 428 52T303 -11ZM390 221Q390 283 361 331T265 379Q214 379 177 342L168 334V118Q203 66 258 66Q316 66 353 106T390 221",
  120252: "34 223Q34 327 99 393T245 460Q290 460 301 459Q328 455 354 445T395 427T410 415L396 338L386 344Q377 349 362 357T335 370Q305 381 258 381H252Q182 381 146 315Q126 275 126 224Q126 158 159 113T255 68Q329 68 394 106L408 114L410 93Q411 72 412 52L414 32Q407 27 394 20T338 2T252 -10Q156 -10 95 58T34 223",
  120253: "33 224Q33 321 81 388T197 455Q277 455 342 414L351 408V694H441V0H348V44L338 37Q278 -10 198 -10Q177 -10 168 -8Q99 11 62 90Q33 148 33 224ZM348 337Q307 378 263 378Q260 378 256 378T251 379Q239 379 223 374T182 355T142 305T126 220Q126 90 225 67Q231 66 250 66H255Q306 66 342 115L348 124V337",
  120254: "28 226Q28 329 91 395T235 461Q258 461 279 456T325 436T368 397T399 332T415 238V219H113V215Q113 163 151 114T248 65Q273 65 298 70T341 82T373 96T396 108L403 113Q403 106 406 76T409 38Q409 34 408 33T393 24Q325 -10 252 -10Q155 -10 92 59T28 226ZM340 289L338 297Q335 305 333 310T327 326T317 343T304 358T286 372T263 381T233 385Q212 385 193 376T162 353T140 325T127 301T123 289H340",
  120255: "262 705H267Q300 705 347 694V612L336 616Q303 628 274 628H266Q224 628 199 605Q187 590 184 579T181 541V507V444H287V371H184V0H94V371H27V444H94V492Q94 544 95 550Q102 617 151 661T262 705",
  120256: "55 286Q55 357 105 406T224 455Q280 455 323 421L322 423L318 427Q318 428 339 434T396 448T465 455H471L478 416L485 377Q484 377 474 379T445 383T401 385Q397 385 391 385T381 384L362 383L357 387Q358 386 364 375T375 354T384 325T389 287Q389 217 340 168T221 119Q178 119 138 142Q133 145 131 143Q125 131 125 117Q125 82 155 72L227 71Q230 71 251 71T280 71T310 69T343 65T373 57T403 46T428 30T449 7Q471 -26 471 -62V-71Q471 -136 384 -178Q326 -206 250 -206Q159 -206 102 -172T30 -92Q28 -84 28 -68T31 -37T40 -12T52 7T64 21T75 31T82 38Q60 68 60 106Q60 145 80 180L86 189L80 199Q55 240 55 286ZM304 233T304 287T279 362T220 383Q189 383 165 361T140 287Q140 243 161 217T220 191Q253 191 278 212ZM250 -134Q298 -134 331 -122T375 -96T387 -69Q387 -21 306 -7Q288 -5 216 -5Q161 -5 153 -7Q146 -9 139 -13T122 -31T113 -66Q113 -75 113 -80T127 -97T166 -121Q203 -134 250 -134",
  120257: "163 395Q223 455 307 455Q417 455 438 354Q442 331 443 164V0H350V157Q349 315 348 320Q334 378 259 378H253Q224 378 204 358Q180 334 173 301T165 209Q165 198 165 172T166 129V0H73V694H163V395",
  120258: "67 576V680H171V576H67ZM74 0V444H164V0H74",
  120259: "88 576V680H192V576H88ZM31 -126Q40 -126 48 -125T62 -122T73 -117T82 -111T89 -105T94 -99T98 -92L102 -86V444H192V180Q191 -45 191 -70T184 -113Q171 -152 140 -178T63 -205Q34 -205 4 -197T-43 -181T-59 -171T-51 -133T-41 -96L-38 -99Q-34 -102 -28 -106T-13 -115T7 -123T31 -126",
  120260: "76 0V694H163V257L340 444H449L286 272L292 263Q296 259 378 138T463 12L471 0H372L309 92Q294 114 277 139T250 179T237 198L228 211L160 139V0H76",
  120261: "74 0V694H164V0H74",
  120262: "160 392Q223 455 304 455Q359 455 386 436T430 383L437 391Q495 455 584 455Q694 455 715 354Q719 331 720 164V0H627V157Q626 315 625 320Q611 378 536 378H530Q501 378 481 358Q457 334 450 301T442 209Q442 198 442 172T443 129V0H350V157Q349 315 348 320Q334 378 259 378H253Q224 378 204 358Q180 334 173 301T165 209Q165 198 165 172T166 129V0H73V450H160V392",
  120263: "160 392Q214 446 283 454Q285 454 292 454T303 455H306Q417 455 438 354Q442 331 443 164V0H350V157Q349 315 348 320Q334 378 259 378H253Q224 378 204 358Q180 334 173 301T165 209Q165 198 165 172T166 129V0H73V450H160V392",
  120264: "28 222Q28 323 95 391T244 460Q275 460 281 459Q364 445 417 377T471 219Q471 124 408 57T250 -10Q158 -10 93 57T28 222ZM377 230Q377 277 364 310T328 358T287 379T248 385Q233 385 219 382T186 369T155 342T132 297T122 230Q122 146 159 108T250 69H253Q263 69 274 70T305 81T339 106T365 154T377 230",
  120265: "166 404Q194 424 241 439T337 455H341Q410 455 451 370Q483 307 483 222Q483 128 433 59T306 -10Q282 -10 260 -5T222 7T194 21T176 33T168 38V-194H75V444H165V424L166 404ZM390 222Q390 287 354 331T266 376T177 340L168 332V118Q200 66 257 66Q313 66 351 112T390 222",
  120266: "33 220Q33 325 87 389T206 454Q286 454 341 406L351 398V455H441V-194H348V41L338 35Q276 -8 198 -11Q171 -11 154 -5Q102 12 68 74T33 220ZM126 220Q126 160 161 113T251 65Q305 65 351 123V298L350 301Q349 304 347 308T342 319T336 331T327 343T315 355T300 365T283 373Q273 375 256 375Q208 375 167 332T126 220",
  120267: "171 389Q237 455 320 455H327V373H317Q262 369 220 336T167 248Q165 239 164 119V0H74V450H159V377L171 389",
  120268: "33 326Q33 376 60 408T117 450T175 460H190Q245 460 272 454T345 429Q345 428 338 388L331 349Q278 386 188 386H183Q119 386 119 336Q119 307 142 295T210 276T278 256Q360 213 360 130Q360 108 354 88T332 43T281 5T195 -10Q152 -10 111 1T49 22T28 35Q29 36 32 56T39 95T43 115T51 110T72 99T102 85T143 73T193 68Q274 68 274 123Q274 152 248 167Q234 178 187 186T115 207Q66 229 46 273Q33 298 33 326",
  120269: "333 27Q333 24 314 16T257 -1T184 -10H172Q146 -10 128 14T105 58T99 91Q95 113 95 251V371H18V444H98V571H182V444H316V371H182V253Q183 128 189 104Q199 68 234 68Q277 72 314 98Q315 93 323 61T333 27",
  120270: "353 39Q352 38 344 34T331 27T315 19T295 11T270 3T241 -3T207 -8T168 -10H162Q148 -10 137 -8T111 2T87 30T74 81Q73 89 73 268V444H166V268L167 92Q171 79 174 74T192 64T238 59Q317 59 344 116Q349 128 349 148T350 291V444H443V0H353V39",
  120271: "178 0Q15 441 14 442Q14 444 60 444Q107 444 107 442Q108 441 136 364T196 194T232 67Q233 98 280 234T356 442Q356 444 401 444T446 442L282 0H178",
  120272: "14 444H105L108 434Q192 160 200 74V65L201 75Q206 144 282 399L296 444H381L399 381Q480 112 480 69L481 70Q481 113 562 386L580 444H668L534 1L483 0H432L429 10Q343 294 338 367L337 377Q336 375 336 370Q336 340 313 250T269 88T245 11L242 0H195L148 1L14 444",
  120273: "187 229L6 444H107L227 294L344 444H393L442 443Q439 437 299 268L267 229L460 0H359L294 88Q280 107 262 131T236 166L227 177L100 0H0Q1 1 47 58T140 171T187 229",
  120274: "113 -204Q83 -204 63 -200L43 -197Q43 -196 40 -157T36 -117L48 -121Q79 -133 114 -133Q124 -133 130 -132T145 -121T163 -94Q169 -82 184 -42T200 1L188 29Q176 57 152 115T107 223T62 330T26 416L14 443Q14 444 61 444H109L122 411Q230 155 236 75L237 65V74Q245 161 348 424L356 444H401Q446 444 446 443L396 313Q345 183 293 49T236 -93Q191 -204 123 -204H113",
  120275: "42 370V444H400V395L156 76L279 77H402V0H28V51L273 371L157 370H42",
  120276: "110 0H86Q42 0 42 27Q42 37 148 350T258 667Q269 687 291 692Q295 694 366 694H399Q432 694 448 689T474 667Q477 663 583 350T690 27Q690 0 642 0H617H592Q582 0 575 1T561 2T549 6T541 11T533 18T527 26T522 37T517 49T512 64T506 81L490 130H225Q225 128 208 79T189 27Q185 19 180 14T170 7T156 3T143 1T127 0T110 0ZM439 279Q359 524 359 547L357 555L355 543Q347 503 270 263L259 231H357Q455 231 455 232L439 279",
  120277: "119 1Q98 5 92 28V667Q98 686 118 693Q121 694 272 694H289H346Q439 694 500 681T600 625Q640 580 640 513Q640 451 601 414T504 364L518 361Q568 351 602 329T649 280T666 235T671 197Q671 172 665 147T642 91T586 37T488 5Q456 1 282 1H119ZM489 509Q489 532 479 548T450 573T421 585T394 591Q387 592 315 593H247V404H298H325Q432 404 466 444Q489 470 489 509ZM517 194Q517 235 502 261T458 299T407 313T353 317H329H322H247V101H319H357Q387 101 407 103T452 111T492 133T514 171Q516 176 517 194",
  120278: "423 -11Q339 -11 275 9T171 62T106 143T71 240T61 347Q61 450 93 527Q157 664 313 694Q357 704 416 704Q479 704 517 699T608 676Q634 667 635 660Q635 653 624 592L612 528L609 524Q604 521 601 521Q595 521 583 531T555 555T505 578T428 589H424Q298 589 250 494Q224 438 224 347Q224 292 233 251T265 175T329 122T432 104Q488 104 524 115T604 158Q607 160 610 162T615 165T619 168L621 170Q625 172 630 170T637 163Q638 160 642 109T647 54Q646 49 625 37T568 11T499 -7Q463 -11 423 -11",
  120279: "119 1Q98 5 92 28V667Q98 686 118 693H124Q131 693 142 693T168 694T200 694T237 694H296Q416 694 450 692T525 677Q732 617 732 342Q732 169 644 81Q593 32 528 16T372 0Q356 0 324 0T276 1H119ZM573 349Q573 387 571 413T559 473T532 527T482 567T403 591Q395 592 320 593H250V101H321Q418 102 456 114Q553 144 569 263Q573 303 573 349",
  120280: "277 122Q280 122 380 123T544 125Q552 125 557 125T565 124T569 124Q595 115 595 75V62V47Q595 9 569 2Q564 0 341 0L119 1Q99 7 92 28V664Q98 683 118 690Q121 691 335 691T554 689Q580 682 580 644V632V618Q580 582 554 573Q553 573 551 573T542 572T527 572Q464 572 364 573T260 575H253V412H385H459Q524 412 536 404T549 357Q549 341 549 334T542 318T523 305Q518 303 385 303H253V122H277",
  120281: "512 572Q451 572 356 573T258 575H253V400H370H431Q494 400 506 392T518 345Q518 307 507 299T437 291H370H253V161Q253 141 253 113T254 75Q254 23 245 12T195 0H170L119 1Q99 7 92 28V664Q98 683 118 690Q121 691 327 691T538 689Q564 682 564 644V632V618Q564 582 538 573Q537 573 535 573T526 572T512 572",
  120282: "61 347Q61 405 70 454T105 550T171 631T276 685T426 705Q483 705 537 693T620 668T650 646Q650 645 649 637T645 612T639 578L627 514L624 510Q620 507 615 507T597 520T566 548T512 577T430 590Q223 590 223 347T431 104Q478 104 506 112Q508 112 508 164V215H471L434 216L428 222L427 268Q427 315 429 318Q432 323 444 323T544 324H652Q655 320 659 317V45L656 43Q654 39 624 27T536 2T424 -11Q366 -11 317 -2T219 33T137 97T82 200T61 347",
  120283: "92 667Q101 694 143 694H172H198Q244 694 251 669Q253 663 253 539V415H540V539Q540 558 540 585T539 621Q539 673 550 683T611 694H621H646Q671 694 683 690T700 669Q702 663 702 347T700 25Q696 9 684 5T646 0H621H606Q560 0 550 11T539 76Q539 85 539 116T540 169V306H253V169Q253 147 253 116T254 75Q254 23 245 12T194 0H170L119 1Q99 7 92 28V667",
  120284: "85 667Q94 694 136 694H165H191Q237 694 244 669Q246 663 246 347T244 25Q235 0 192 0H163L112 1Q92 7 85 28V667",
  120285: "236 -22Q190 -22 144 -11T72 12T46 29Q63 147 69 153Q80 164 92 146Q124 91 191 91Q222 91 242 102T267 134Q268 139 268 402Q268 663 270 669Q275 687 294 692Q298 694 347 694H367Q393 694 406 690T425 669Q427 663 427 399Q427 132 426 125Q421 87 404 58T366 15T318 -9T273 -20T236 -22",
  120286: "92 667Q101 694 139 694H163H186Q225 694 234 671Q236 663 236 529L237 392L533 682Q550 694 590 694H623H681Q695 680 695 672Q695 670 693 664Q688 657 561 533L431 405L698 33Q701 28 701 23Q701 7 683 0H626H604Q571 0 564 2T545 13Q544 14 530 33T489 90T437 162L332 307Q331 307 284 260L236 214V122V65Q236 32 231 19T210 2Q205 0 161 0L119 1Q99 7 92 28V667",
  120287: "92 667Q98 684 109 689T142 694H172H198Q244 694 251 669Q253 663 253 389V116L278 117Q410 119 490 119H495Q511 119 517 115T534 93V63V48Q534 9 508 2Q503 0 310 0L119 1Q99 7 92 28V667",
  120288: "92 667Q98 684 109 689T146 695Q152 695 167 695T192 694Q200 694 214 694T234 695Q291 695 305 664Q313 651 400 419T487 165Q487 162 488 162T489 165Q489 187 574 413T671 664Q679 680 695 688Q708 694 785 694H828Q855 694 867 689T884 669Q886 663 886 347T884 25Q876 0 832 0H817H802Q758 0 750 25Q748 31 748 293V555L746 544Q737 509 692 386T606 160T564 52Q548 22 502 22H487H472Q423 22 410 52Q407 59 367 160T283 385T231 546L230 548Q229 548 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
  120289: "92 667Q98 684 109 689T146 694H185Q273 694 279 692Q301 689 315 669Q322 660 419 453L554 163L562 143Q564 143 564 401Q564 663 566 669Q574 694 618 694H633H648Q692 694 700 669Q702 663 702 347T700 25Q696 10 683 5T642 0H596H551Q520 0 505 4T478 25Q471 34 374 241L239 532Q231 550 231 552L229 479Q229 440 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
  120290: "362 715Q364 715 376 715T394 716H400Q542 716 626 643T727 426Q731 395 731 342Q731 271 722 225Q674 -22 396 -22Q320 -22 259 -3T148 68T77 201Q62 257 62 342Q62 447 86 522T173 649Q245 707 362 715ZM568 433Q551 623 396 623Q383 623 370 622T333 612T292 591T257 550T233 485Q223 442 223 350Q223 276 232 227T267 137Q309 74 397 74Q433 74 461 85T507 113T537 156T556 205T566 260T569 310T570 357Q570 409 568 433",
  120291: "641 470Q641 426 630 391T603 334T561 295T513 271T459 259T408 254T361 253H350H337H253V142Q253 125 253 100T254 67Q254 32 249 19T227 2Q222 0 170 0L119 1Q99 7 92 28V667Q98 686 118 693Q121 694 271 694Q428 693 462 688Q641 656 641 470ZM487 467Q487 495 485 510T474 546T442 578T382 592Q375 593 310 593H250V347H309H339Q364 347 380 348T418 354T451 368T474 395T486 438Q487 444 487 467",
  120292: "450 -20Q444 -20 429 -21T396 -22Q320 -22 259 -3T148 68T77 201Q62 257 62 342Q62 447 86 522T173 649Q245 707 362 715Q364 715 376 715T394 716Q732 716 732 340Q732 268 719 210T686 120T647 68T615 39T601 29T638 -22T676 -73Q679 -78 679 -83Q679 -98 661 -106H593Q526 -106 521 -104Q514 -103 507 -97T496 -84T477 -55L454 -19L450 -20ZM554 509Q516 622 391 622Q294 622 250 535Q220 475 220 345Q220 299 222 266T234 198T258 140T299 99T363 74Q378 71 393 71H395L381 92Q367 114 353 136T338 161Q336 165 336 170Q336 186 352 193L361 194Q370 194 384 194T412 194H452Q457 194 460 194T466 194T471 192T476 191T480 188T483 185T487 180T492 174T497 167T504 158L526 129Q532 127 552 175Q573 231 573 348Q573 455 554 509",
  120293: "654 24Q654 9 644 5T612 0H577L521 1Q509 5 503 13Q498 20 421 160L343 304H250V168Q250 147 250 118T251 78Q251 24 242 12T192 0H168L119 1Q99 7 92 28V667Q98 686 118 693H124Q131 693 141 693T165 694T195 694T229 694T280 694T332 695Q389 695 428 691T510 675T582 637T627 569Q641 532 641 493Q641 377 537 331L497 317L493 316L571 177Q653 28 654 24ZM487 472T487 492T485 525T476 553T450 577T404 591Q398 592 322 593H250V391H321Q327 391 353 391T385 392T412 395T438 401T457 412T474 430T483 456",
  120294: "61 503Q61 547 72 583T110 650T186 698T305 716Q405 716 496 671Q513 664 514 657Q514 656 513 648T509 623T503 589L491 525L488 521Q484 518 479 518H475L461 532Q430 565 395 581T305 598Q201 598 201 523Q201 480 240 462T345 431T443 394Q549 324 549 204Q549 160 538 123T502 51T427 -2T308 -22Q180 -22 69 41Q50 52 49 57Q49 58 50 66T54 91T60 125L72 189L75 193Q80 196 84 196Q87 196 104 182T145 149T212 117T304 102Q408 102 408 188Q408 215 396 234T362 263T319 278T267 290T219 302Q149 324 105 380T61 503",
  120295: "67 687Q70 688 366 688Q661 688 666 686Q692 680 692 641V629V615Q692 579 666 570H660Q655 569 648 569Q645 569 624 569T581 570Q505 570 475 572H447V302Q447 31 445 25Q436 0 393 0H364L313 1Q293 7 286 28L285 300V572H257Q227 570 151 570Q130 570 109 570T84 569Q77 569 72 570H66Q48 577 44 588T40 631L41 661Q47 680 67 687",
  120296: "92 667Q101 694 143 694H172H200Q242 694 251 671Q253 663 253 430Q254 189 255 185Q262 134 288 107T384 79Q498 79 516 168Q520 191 521 431Q521 663 523 671Q532 694 572 694H596H618Q639 694 648 692T665 679Q671 672 671 653Q672 632 672 555V432Q671 200 670 190Q652 79 581 29T383 -22Q137 -22 98 166Q92 195 92 303V667",
  120297: "27 667Q27 683 39 688T75 694H101Q155 694 159 692Q182 687 194 665Q202 652 283 419T374 142Q376 165 473 445Q552 664 553 666Q568 694 618 694H639H658Q681 694 693 689T705 667Q705 660 592 347Q481 32 477 28Q466 7 441 1H292Q266 7 255 28Q251 32 140 347Q27 660 27 667",
  120298: "994 694Q1012 683 1014 668Q1014 661 977 519T896 217T845 26Q831 0 783 0H747H711Q685 0 672 5T649 26Q644 36 583 272T517 548Q516 552 516 551Q503 479 437 227Q389 37 383 26Q367 0 323 0H288H254Q207 0 193 26Q191 32 108 346T24 665Q24 685 44 693Q47 694 98 694H115Q152 694 168 668Q174 657 235 417T297 144Q297 134 300 153Q307 204 362 421T427 668Q441 694 488 694H523Q586 694 597 688Q612 683 620 661T651 549Q664 496 673 462Q744 194 750 146V140Q767 223 800 354T857 576T883 668Q897 694 938 694H958H994",
  120299: "52 1Q37 11 37 23Q37 26 39 32Q39 34 158 202L275 369Q275 370 221 441T112 586T55 663Q53 669 53 672Q53 687 68 693H72Q77 693 84 693T99 694T118 694T139 694H176Q203 694 212 692T230 682Q231 681 239 669T265 634T296 591L358 504L418 591Q481 682 486 686Q491 691 499 692Q505 694 569 694H632Q650 685 650 672Q650 667 646 660Q643 654 592 582T491 440T441 369T566 201T693 29Q694 27 694 23Q694 11 677 0H607L537 1Q523 6 519 10T437 131Q422 153 411 170T390 200T375 222T365 237T359 245L357 247L348 232Q339 218 319 188T283 131Q222 37 211 22T186 1H52",
  120300: "635 694H668Q688 694 698 690T708 670Q708 664 704 658L446 278L445 152V27Q442 20 440 17T433 9T419 1L368 0H339Q316 0 305 5T288 26Q286 31 286 154V278L157 468Q135 500 101 550Q43 635 34 650T24 671Q24 686 39 693Q42 694 105 694H122H132Q163 694 180 689T214 666Q225 654 336 485Q373 425 373 420L374 418Q375 419 375 421Q378 432 418 493T496 609T536 667Q543 676 551 681T572 689T591 693T615 694T635 694",
  120301: "411 584Q243 581 131 581Q122 581 116 581T106 582T102 582Q84 589 80 600T76 640L77 667Q83 686 103 693Q106 694 343 694Q579 694 584 692Q592 691 599 684T609 668Q610 665 610 646Q610 614 608 608Q605 603 434 361L261 116Q340 117 402 118T490 119T533 120T560 120H572Q605 120 614 95Q616 89 616 60V46Q616 9 590 2Q585 0 339 0Q92 0 87 2Q79 3 72 10T62 26Q61 29 61 49Q61 84 63 90Q65 94 152 217T325 461T411 584",
  120302: "255 394Q218 394 186 383T138 358T109 333T94 321H91Q88 321 86 322T83 325T80 331T79 339T78 349T77 362T75 377Q72 410 72 420Q72 423 72 425T73 429T74 431T77 433T80 435T85 437Q166 475 262 475Q360 475 413 440Q462 406 471 341Q472 332 472 181Q472 155 472 119T473 73Q473 20 462 10T398 0H380Q349 0 337 8T324 48V65Q298 30 257 10T172 -11Q109 -11 70 37T31 145Q31 276 307 289H321V309Q321 337 318 352T300 381T255 394ZM176 146Q176 116 190 97T231 77Q251 77 266 85Q322 110 322 185Q322 189 322 192T322 198L321 201V234L308 232Q176 220 176 146",
  120303: "54 667Q63 694 102 694H127H151Q190 694 199 671Q201 663 201 544L202 422L211 428Q270 468 355 468Q523 468 523 231Q523 -10 321 -10Q286 -10 261 -2T204 33Q197 11 187 6T142 0H126L81 1Q61 7 54 28V667ZM372 230Q372 317 355 349T280 382Q251 382 204 356V107Q235 76 274 76Q301 76 320 84T349 105T364 139T371 180T372 230",
  120304: "188 233Q188 199 190 177T200 131T225 95T271 83H281Q356 83 421 130Q433 138 434 139Q446 141 448 131Q449 128 453 84T457 36Q455 30 432 20T364 -1T273 -11Q37 -11 37 232Q37 456 244 474Q246 474 257 474T276 475Q349 475 400 455Q443 436 448 431L451 425Q451 419 443 377Q442 372 441 366T439 356T438 348T436 340T435 334T433 330T431 327T429 325T426 324Q420 324 406 336Q376 362 350 372T281 382Q254 382 236 373T208 352T194 317T189 278T188 233",
  120305: "225 -11Q192 -11 164 -3T104 29T55 102T37 227Q37 321 63 376Q111 469 223 469Q292 469 349 433L359 426V546Q359 564 359 589T358 623Q358 675 369 684T433 694H451Q497 694 505 669Q507 663 507 347T505 25Q500 9 487 5T450 0H432H413Q356 0 356 36V40Q298 -11 225 -11ZM356 359Q326 382 286 382Q239 382 215 358Q189 330 189 256V229V203V195Q189 102 231 86Q251 76 274 76Q318 76 356 114V359",
  120306: "30 231Q30 301 51 351T107 426T181 463T262 474H268Q293 474 312 472T366 459T422 427T462 363T480 260Q480 230 466 222T405 213Q395 213 364 213T311 214H173V211Q173 183 183 148T216 96Q244 76 287 76Q319 76 350 85T399 104T433 125T451 136Q463 138 465 128Q466 125 469 84T473 39Q471 29 423 13T330 -9Q321 -10 286 -10Q213 -10 161 11T81 68T42 144T30 231ZM353 292Q350 324 342 344T320 373T294 384T264 387Q191 387 175 286V282H353V292",
  120307: "67 458H78V502V509Q78 538 79 556T90 604T117 651T169 685T253 704Q254 704 258 704T265 705T275 705T287 704Q364 704 381 687V638V607Q381 591 378 585T366 579Q362 581 351 591T323 610T282 618Q238 618 226 587Q224 581 223 519V458H253Q288 458 298 453Q315 441 315 415Q315 399 312 390T299 377T282 372T259 371H255H226V201Q226 31 224 25Q215 0 174 0H150L106 1Q86 7 79 28L78 199V371H69Q29 371 29 412Q29 425 30 431T40 447T67 458",
  120308: "63 108Q63 142 83 176L76 184Q35 227 35 300Q35 469 243 469Q330 469 385 437L397 443Q451 469 508 469Q515 468 517 466T522 456T528 425Q534 392 534 386Q532 379 523 377Q520 377 509 381T477 390T431 398L425 399Q453 362 453 297Q453 268 445 242T417 189T351 146T242 130Q169 130 119 153Q117 141 117 136Q117 95 155 83Q161 81 252 81Q354 80 362 79Q437 71 475 48T526 -24Q532 -42 532 -65Q532 -116 489 -156T341 -204Q323 -206 274 -206H256Q39 -206 18 -84Q17 -79 17 -68Q17 15 82 42L76 53Q63 79 63 108ZM310 300Q310 359 298 377T238 396Q217 396 204 390T186 368T179 339T178 300Q178 245 189 224T244 203T299 224T310 300ZM414 -66Q414 -55 411 -47T401 -32T387 -21T368 -14T346 -10T322 -7T297 -6T271 -6T246 -6H193Q163 -6 154 -10T140 -30Q135 -45 135 -62Q135 -134 274 -134Q414 -134 414 -66",
  120309: "53 667Q62 694 101 694H126H148Q191 694 198 669Q200 663 200 526V390Q263 469 361 469Q390 469 412 465T456 449T491 413T507 351Q508 342 508 185Q508 31 506 25Q498 0 450 0H432H413Q368 0 359 23Q357 31 357 186Q356 345 355 350Q349 369 336 376Q324 381 301 381H298Q269 381 242 362Q217 342 210 316T202 239Q202 229 202 202T203 157V82Q203 24 195 12T146 0H125L80 1Q60 7 53 28V667",
  120310: "72 574Q55 583 51 591T46 619V636L47 670L48 673Q50 676 52 678T56 684T63 690T73 694H81Q89 694 102 694T129 695H181Q193 687 196 685T203 676T207 661T208 634Q208 603 204 593T181 574H72ZM54 431Q63 458 102 458H127H149Q192 458 199 433Q201 427 201 229T199 25Q190 0 149 0H125L81 1Q61 7 54 28V431",
  120311: "70 634V648Q70 686 96 693Q100 695 151 695H176Q201 695 213 691T230 670Q232 665 232 634V620Q232 582 206 575Q202 573 151 573H126Q101 573 89 577T72 598Q70 603 70 634ZM-41 -84Q-1 -105 28 -105Q67 -105 78 -85Q83 -77 83 -48T84 180Q84 427 86 433Q93 458 136 458H158H180Q201 458 209 456T225 443Q230 436 231 418Q232 397 232 313V183V124V40Q232 -55 228 -87T203 -147Q166 -205 78 -205Q31 -205 -20 -189T-71 -159Q-71 -156 -62 -124T-52 -89Q-49 -84 -41 -84",
  120312: "496 23Q496 9 487 5T457 0H427H398Q367 0 354 11Q352 12 288 99L226 183L191 150V90V54Q191 30 186 18T165 2Q160 0 124 0L90 1Q70 7 63 28V667Q72 694 108 694H128H146Q183 694 192 671Q194 663 194 496L195 325L254 383Q266 394 281 409T301 429T316 441T329 450T341 455T357 458T376 458H409H436Q461 458 470 454T480 437Q480 430 477 427T445 395Q417 368 396 347L319 271Q319 270 358 217T442 103T494 32Q496 30 496 23",
  120313: "54 667Q63 694 102 694H127H149Q192 694 199 669Q201 663 201 347T199 25Q190 0 149 0H125L81 1Q61 7 54 28V667",
  120314: "197 386Q256 468 366 468Q404 468 430 461T471 438T491 413T503 385Q563 469 666 469Q731 469 769 446T814 350Q815 343 815 185Q815 31 813 25Q808 9 796 5T758 0H737L692 1Q672 7 665 28L664 186V206V290Q664 349 655 365T610 381Q581 381 560 370T529 341T515 311T510 291Q509 286 509 157V82Q509 24 501 12T452 0H431L386 1Q366 7 359 28L358 186V206V290Q358 349 349 365T304 381Q275 381 254 370T223 341T209 311T204 291Q203 286 203 157V82Q203 24 195 12T146 0H125L80 1Q60 7 53 28V437Q58 453 80 464H122H142Q167 464 178 460T195 439Q197 434 197 409V386",
  120315: "197 386Q264 468 350 468Q375 468 390 467T429 460T466 443T492 408T507 351Q508 342 508 185Q508 31 506 25Q498 0 450 0H432H413Q368 0 359 23Q357 31 357 186Q356 345 355 350Q349 369 336 376Q324 381 301 381H298Q269 381 242 362Q217 342 210 316T202 239Q202 229 202 202T203 157V82Q203 24 195 12T146 0H125L80 1Q60 7 53 28V437Q58 453 80 464H122H142Q167 464 178 460T195 439Q197 434 197 409V386",
  120316: "274 -11Q32 -11 32 225Q32 346 85 406T249 474H266H271Q302 474 325 471T385 458T451 419T498 346Q518 300 518 225Q518 -11 274 -11ZM367 233Q367 322 350 354T270 387Q240 387 222 377T195 344T184 298T182 233Q182 151 198 117T275 83H282Q318 83 339 104Q355 119 361 146T367 233",
  120317: "125 458H139Q174 458 185 452T202 420L211 426Q245 448 288 458T354 469Q356 469 361 469T369 468Q443 468 481 412Q523 355 523 223Q523 164 509 120T473 51T423 12T371 -7T323 -11Q260 -11 204 33V-65Q204 -80 204 -102T205 -131Q205 -162 200 -175T178 -192Q173 -194 126 -194L81 -193Q61 -187 54 -166V431Q58 447 81 458H125ZM372 230Q372 376 282 376Q247 376 204 352V107L208 103Q213 99 218 95T232 87T251 79T274 76Q323 76 349 116Q372 153 372 230",
  120318: "226 -11Q37 -11 37 236Q37 294 51 338T86 407T135 445T186 464T233 469H235Q300 469 349 422L359 413V425Q359 452 376 464Q384 469 433 469H455Q498 469 505 444Q507 438 507 137Q507 -163 505 -169Q500 -185 487 -189T450 -194H432H413Q367 -194 358 -171Q356 -163 356 -63V40L348 33Q296 -11 231 -11H226ZM281 375Q188 375 188 228Q188 77 275 77Q322 77 359 120V328Q338 357 324 366T281 375",
  120319: "54 437Q58 453 81 464H122H147Q186 464 194 439Q196 434 196 405V377L203 387Q245 456 324 468Q325 468 331 468T340 469Q347 469 356 462V360Q350 355 346 354T339 353T326 353T300 347Q260 337 234 311T202 252Q201 247 201 138Q201 122 201 98T202 66Q202 33 197 20T175 2Q170 0 125 0L81 1Q61 7 54 28V437",
  120320: "37 328Q37 392 75 433T203 474Q254 474 265 473Q319 465 370 442Q378 439 380 432Q380 426 372 384Q364 336 359 333Q358 331 355 331Q348 331 337 341Q282 388 216 388H208Q190 388 180 387T161 377T151 351Q151 333 164 323T224 306L267 297Q314 285 355 246T396 144Q396 17 282 -5Q260 -10 218 -10Q170 -10 124 2T55 26T30 44Q30 48 39 99T49 153Q52 159 60 159Q66 159 70 153Q100 120 133 101T218 82Q231 82 238 83T258 87T277 101T283 126Q283 149 260 160T200 176T153 186Q109 201 73 236T37 328",
  120321: "225 267Q225 202 226 169T232 115T244 88T265 82Q295 84 318 100T345 116Q352 116 354 110T364 77Q373 46 373 43Q373 28 312 9T190 -10Q160 -10 139 1T107 29T89 77T82 136T80 210V258V371H66H59Q39 371 27 386Q20 394 20 417Q21 432 23 437Q35 458 60 458H65H83V510L84 562Q93 589 131 589H154H174Q216 589 223 564Q225 558 225 508V458H274Q330 458 338 453Q355 441 355 415Q355 388 338 376Q330 371 274 371H225V267",
  120322: "53 431Q62 459 100 459Q105 459 114 459T127 458H152Q192 458 201 435Q203 427 203 262Q204 86 208 77Q209 74 216 71Q227 66 258 66H264Q334 66 354 140L356 150L357 290Q357 427 359 435Q365 449 377 453T412 458H432H450Q498 458 506 433Q508 427 508 229T506 25Q498 0 451 0H434H418Q386 0 374 7T360 43V58L352 49Q298 -11 199 -11Q135 -9 101 11T56 80Q52 100 52 273L53 431",
  120323: "26 429T26 435T32 448T44 456Q48 458 85 458H99Q145 458 161 431Q162 429 207 285L251 145L294 284Q333 410 341 430Q351 451 374 456Q379 458 420 458H430Q450 458 457 456T471 443Q473 437 473 435Q473 426 443 325T381 126L350 28Q339 7 316 2Q312 0 250 0Q187 0 183 2Q160 7 149 28L136 68Q124 109 106 166T70 283T39 385",
  120324: "699 458Q717 447 719 432Q719 426 666 230T610 27Q602 10 588 5T548 0H512H482Q431 0 420 17T384 135Q356 241 352 298V308L351 295Q348 251 322 145T290 28Q279 0 233 0H212H191Q146 0 133 27Q130 33 77 229T24 430Q24 449 44 457Q47 458 79 458Q122 458 126 456Q154 450 163 419L233 153Q241 187 272 304T307 431Q318 458 368 458Q394 458 398 456Q421 451 430 431Q434 423 509 147L547 286Q582 416 588 429Q600 454 624 457Q632 458 647 458H663H699",
  120325: "92 0Q87 0 77 0T62 -1Q24 -1 24 22Q24 29 33 41T106 136Q185 237 184 238Q184 239 147 284T73 376T33 427Q31 430 31 436Q31 451 45 457Q48 458 96 458H122Q152 458 163 450T208 394L247 345L282 394Q288 403 297 416T309 434T319 444T328 452T338 455T352 458T372 458H393H440Q457 449 457 435Q457 428 450 419T379 328Q308 239 308 237L389 137Q409 112 436 79Q475 31 475 23Q475 -1 436 -1Q432 -1 422 -1T407 0Q360 0 352 3Q343 6 336 16T291 83L247 151L245 148Q243 145 239 139T229 124T218 106T204 84Q167 24 160 15T141 1L92 0",
  120326: "454 458Q473 446 473 430Q473 426 394 184L311 -68Q291 -119 245 -162T123 -205Q51 -205 46 -190Q44 -187 40 -142T36 -92Q36 -90 36 -88L37 -87Q41 -80 46 -80Q48 -80 73 -92T126 -105Q146 -105 161 -98T185 -76T197 -53T206 -28L215 0L122 212Q29 427 29 435Q29 448 46 457Q49 458 91 458Q93 458 106 458T125 457T140 454T157 446T170 431Q183 410 224 305T266 158Q266 152 266 151Q267 151 268 163Q271 206 302 310T342 432Q354 458 398 458H418H454",
  120327: "268 376Q250 376 180 375T92 374Q69 374 63 380Q46 390 46 419Q46 428 49 437Q57 451 73 457Q76 458 242 458T413 456Q420 455 427 448Q439 438 439 413Q439 392 433 385Q432 383 318 236T204 88Q235 88 306 89T395 90H399Q408 90 414 89T427 84T438 70T442 45Q442 9 416 2Q411 0 236 0H136Q73 0 62 1T41 12Q31 23 31 47Q31 68 36 77Q37 78 51 97T96 155T153 228L268 376",
  120328: "28 0L429 694H533L585 350Q596 275 610 182T632 46L638 3V0H530L528 18Q527 25 515 103T503 183H223L135 29L118 1L73 0H28ZM492 254Q492 256 473 398T454 589V610Q433 552 290 301L264 255L378 254H492",
  120329: "501 363Q557 355 605 316T653 222Q653 148 586 85T403 2Q394 1 240 0Q90 0 90 1L100 46Q109 90 128 177T164 348L238 694H375Q518 693 546 688Q614 674 655 635T696 544Q696 490 648 441T516 368L501 363ZM601 530Q601 568 566 590T479 621Q472 622 394 623H320L297 513Q292 489 286 459T276 415L273 401V399H339H372Q504 399 571 466Q601 498 601 530ZM257 322Q256 320 230 197T203 73Q203 71 289 71Q379 72 387 73Q459 84 507 122T556 210Q556 255 519 283T428 320Q415 322 336 323Q257 323 257 322",
  120330: "124 266Q124 372 179 473T333 639T544 705Q592 705 635 697T698 679L718 670Q719 669 701 621T681 572L676 576Q670 580 661 586T641 598T614 611T583 620Q558 625 526 625Q406 625 318 516T230 276Q230 238 236 212Q251 148 294 108T412 68Q469 68 508 80T598 123Q608 129 608 128Q606 109 603 87L598 45L573 33Q521 7 486 -1T394 -10Q358 -10 346 -8Q260 5 202 62Q124 145 124 266",
  120331: "162 348L236 694H385Q535 693 543 692Q600 682 641 654T705 586T737 506T747 425Q747 296 672 187Q625 114 548 62T384 1Q376 0 262 0Q88 0 88 1L98 46Q107 90 126 177T162 348ZM622 533Q575 624 443 624Q434 624 419 624T399 623H321L263 348Q249 283 234 213T212 107L204 72Q204 71 289 71Q374 72 386 74Q501 94 573 193T646 422Q646 487 622 533",
  120332: "86 2Q88 4 160 346T233 689Q233 691 461 691Q688 691 688 689Q685 686 671 611H495L320 612L319 609Q319 607 297 501L274 397H436Q597 397 597 396L596 391Q595 386 593 376T589 358L581 322L420 321Q258 321 258 320Q209 89 208 87Q208 85 390 85Q417 85 460 85T518 86L572 85Q556 8 554 2V0H86V2",
  120333: "86 2Q88 4 160 346T233 689Q233 691 453 691T673 689Q670 686 656 611H488L320 612Q314 579 302 523T281 427T272 385Q272 384 419 384H567L551 308H255L223 156Q216 124 207 82T194 20L190 2Q190 0 138 0H86V2",
  120334: "125 267Q125 375 182 476T337 641T544 705Q598 705 644 693T710 669T730 655L712 609L693 560L692 557L681 567Q618 626 526 626Q447 626 378 573T269 440T229 277Q229 185 276 127T406 68Q422 68 451 71T502 78T524 84L526 93Q528 102 532 119T539 153L553 222Q553 223 495 223Q436 223 436 224Q436 230 444 262L452 299H662V296Q661 290 635 166T607 40Q606 37 576 25T492 1T391 -11Q272 -11 199 66T125 267",
  120335: "517 2Q518 3 551 161T585 322Q586 323 557 323T422 323H259L190 0H138Q86 0 86 1L96 46Q105 90 124 177T160 348L234 694H337V691Q336 690 306 545T275 399H602L603 403Q603 407 634 551L665 694H768V691Q768 690 695 348T621 2V0H517V2",
  120336: "161 348L235 694H338V691Q338 690 265 348T191 2V0H139Q87 0 87 1L96 46Q106 90 125 177T161 348",
  120337: "377 424L435 694H535V691Q534 685 476 412T416 135Q401 74 350 26T210 -22Q165 -22 124 -11T65 9T46 21L54 41Q62 61 70 83T81 109Q82 111 85 106Q86 105 87 103Q93 94 103 84T135 64T185 53Q238 53 272 76T317 142Q317 145 325 182T348 289T377 424",
  120338: "236 223Q235 222 213 113T188 2V0H138Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H285Q335 694 335 693L330 671Q326 649 316 603T298 518Q289 477 280 433T266 366L261 343L672 694H729L784 693L465 420L651 0H596L541 1L384 350Q383 351 310 288T236 223",
  120339: "161 348L235 694H338V691Q338 690 273 385T208 79Q278 80 362 80H516Q502 11 499 2V0H293Q87 0 87 1L96 46Q106 90 125 177T161 348",
  120340: "375 691Q456 215 459 124V106Q488 177 762 641L793 694H929V691Q929 690 856 348T782 2V0H689V2Q691 4 753 304Q817 604 818 606Q819 611 817 608Q817 607 815 603Q798 559 540 117L484 22H440L397 23L393 42Q393 47 373 169T334 422T315 594V609L250 306Q186 3 185 2Q185 0 138 0Q92 0 92 1L102 46Q111 90 130 177T166 348L240 694H375V691",
  120341: "311 609Q310 608 246 306T181 2V0H134Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H382L383 691Q383 688 418 561T493 286T541 97L544 84L545 89Q545 90 553 128T578 246T610 394L674 694H766V691Q766 690 693 348T619 2V0H472L469 13Q468 17 393 293T312 605L311 609",
  120342: "118 254Q118 366 174 473T324 648T517 716Q627 716 695 638T763 435Q763 321 706 215T555 43T362 -22Q256 -22 187 56T118 254ZM380 58Q452 58 518 116T622 263T661 442Q661 496 646 535T608 594T567 622T534 634Q516 636 496 636Q400 636 313 528T225 264Q225 172 267 115T380 58",
  120343: "162 348L236 694H378Q522 693 530 692Q604 680 647 635T690 524Q690 474 665 430T612 359Q550 299 465 280Q443 275 343 274H250V271Q250 269 235 201T206 68T192 2V0H140Q88 0 88 1L98 46Q107 90 126 177T162 348ZM594 513Q594 560 562 588T477 622Q470 623 394 623H321L293 487L263 349V347H342H347H375Q530 347 578 449Q594 483 594 513",
  120344: "118 254Q118 366 174 473T324 648T517 716Q627 716 695 638T763 435Q763 305 693 194T543 36Q547 29 586 -47T625 -125H504L450 -8Q406 -22 363 -22Q256 -22 187 56T118 254ZM661 437Q661 532 616 584T506 636Q428 636 361 578T257 433T220 258Q220 167 264 113T380 58Q390 58 397 58T408 59T413 60T417 61Q417 63 387 127T356 193Q356 194 409 194H462L485 150L508 105Q509 103 532 125T567 161Q661 278 661 437",
  120345: "162 348L236 694H375H414H445Q507 694 538 690T606 668Q698 623 698 534V528Q698 447 608 377Q582 358 555 345T512 326L497 321L617 0H565L513 1L402 309H255L189 0H138Q88 0 88 1L98 46Q107 90 126 177T162 348ZM603 525Q603 603 499 620Q486 622 403 623H321L297 506Q292 482 285 449T274 402L271 387V385H346Q350 385 363 385T386 384Q548 384 592 479Q603 503 603 525",
  120346: "161 478Q161 568 242 642T435 716Q527 716 599 673L609 667Q595 633 589 615L571 568Q570 568 564 575T546 592T518 611T475 628T417 635Q351 635 305 596T259 507Q259 465 290 444T372 411T432 396Q473 385 509 343T545 236Q545 140 464 59T270 -22Q155 -22 54 48L92 146Q93 146 101 138T124 117T161 92T216 72T288 63Q360 63 403 109T447 204Q447 220 444 233T435 256T421 273T404 285T385 295T366 301T347 306T331 310T315 314T292 321T265 331T235 346T207 367T183 395T168 431T161 478",
  120347: "165 608L182 687Q182 688 486 688H790L789 685L781 645L773 609H521L457 306Q393 3 392 2Q392 0 340 0H288V2Q289 5 353 304T417 605V609L291 608H165",
  120348: "340 -22Q251 -22 191 33T131 177V187Q131 192 131 195T132 205T133 215T136 231T141 253T147 285T156 328T168 384T184 457L235 694H338V691Q338 690 288 451T236 210Q234 194 234 177Q234 138 247 111T280 72T319 54T357 49Q408 49 449 74T510 128Q516 136 521 143T530 158T538 175T545 194T553 220T560 250T569 289T579 336T591 395T606 464L655 694H747V691Q651 243 645 213Q623 149 587 102Q482 -22 340 -22",
  120349: "220 348L161 694H216Q270 694 270 693L283 613Q334 313 346 215Q359 102 359 96Q359 87 358 84Q388 162 684 657L706 694H753Q799 694 799 693L387 0H333Q279 0 279 1L272 45Q264 89 249 177T220 348",
  120350: "596 540Q596 562 597 585T599 609Q599 588 436 255Q402 185 362 104L310 0H213V3Q213 6 188 347T161 694H263L265 664Q290 327 293 184Q293 112 289 85Q290 85 290 87Q290 95 301 123T332 194T373 282T419 380T463 469T498 541T517 579L574 694H671V689L674 646Q678 603 682 538T691 401T699 263T703 160Q703 102 700 87Q719 154 930 576L989 694H1076Q1076 693 903 347L730 0H628V4L626 26Q624 48 622 85T616 168T609 267T603 369T598 464T596 540",
  120351: "14 0Q17 3 184 184T352 367L265 529Q244 567 222 609T188 672L176 692Q176 694 236 694H297L338 612Q387 515 400 489L421 448L645 694H758L708 640Q481 393 456 368Q455 366 500 281T596 104T652 0H531L388 293L128 0H14",
  120352: "151 692Q151 694 212 694H272L418 362L696 683L705 694H758L809 693Q809 692 630 490T444 280Q442 275 413 139L383 1L333 0Q282 0 282 2Q283 3 312 141L341 278L246 484L151 692",
  120353: "67 54Q551 615 551 617Q543 618 517 618Q510 618 463 618T376 617Q200 617 200 618T209 657L216 694H459Q702 694 702 692Q702 689 697 667L692 643L207 80H392Q493 81 577 81Q577 70 560 2V0H55V2L67 54",
  120354: "313 386Q286 386 260 381T217 369T186 355T164 342T155 337Q154 338 159 377T165 418Q251 461 320 461Q322 461 328 461T337 460Q397 460 435 424T473 329Q473 325 473 318T472 308Q432 110 407 2V0H317V2L325 38Q295 21 269 10Q215 -10 156 -10H149Q76 -10 62 69Q61 75 61 90Q61 127 73 150T116 194Q146 215 207 231T348 252H368L373 277Q378 302 378 318Q378 367 339 384Q332 386 313 386ZM150 116Q150 93 171 79T223 65Q259 65 293 85T341 135Q343 140 348 160T353 184Q353 186 342 186Q298 186 231 174T153 134Q150 127 150 116",
  120355: "302 -11Q266 -11 235 1T190 26L176 38Q170 8 168 2V0H121Q75 0 75 1L84 46Q94 90 113 177T149 348L223 694H267Q312 694 312 693T282 551T251 407Q251 406 256 408T271 415Q347 454 430 454H438Q501 454 528 374Q539 339 539 299Q539 179 466 84T302 -11ZM443 275Q443 317 421 348T346 379Q318 379 296 369Q269 359 238 332L193 118L198 109Q220 65 269 65Q350 65 396 130T443 275",
  120356: "75 164Q75 226 100 282T165 377T252 437T342 460H347Q447 460 499 417L483 378Q468 339 468 338Q466 338 455 347T424 366T385 378Q355 382 334 382Q262 382 215 318T168 177Q168 120 196 95T259 69H269Q345 69 420 108Q432 114 432 113T427 72L422 32L402 22Q382 12 344 2T259 -11Q214 -11 180 2T126 36T95 81T79 126T75 164",
  120357: "73 156Q73 224 102 293T184 408T294 455Q375 455 432 413Q438 407 438 410T469 553L499 694H588V691Q588 690 515 348T441 2V0H348V2Q357 29 357 43L352 41Q332 24 288 7T196 -10H190Q178 -10 166 -7T134 8T98 46T75 113Q73 129 73 156ZM419 335Q419 339 412 348T386 368T342 379Q284 379 243 343T184 261T167 168Q167 122 191 94T263 66Q321 66 367 116L374 124L397 229Q419 333 419 335",
  120358: "248 -11Q170 -11 121 41T71 173Q71 265 133 349T285 454Q305 460 318 460H328Q368 460 399 448Q472 414 472 309Q472 274 464 234L462 219H159Q156 198 156 185Q156 137 179 107T237 68Q246 66 268 66Q345 66 427 113V109Q426 108 422 73T417 37Q417 34 409 29Q329 -11 248 -11ZM401 299Q399 337 376 361T316 385Q291 385 266 371Q220 350 184 289H401V299",
  120359: "381 443Q381 440 374 407T366 371H315Q263 371 263 369Q262 368 224 186Q215 145 205 97T189 25L184 2V0H94V2L99 25Q104 48 114 96T134 186Q172 368 173 369Q173 371 139 371H106V373L114 410L121 444H155L188 445L191 455L212 551Q232 612 288 658T415 705Q438 705 464 701T494 694Q478 614 477 614L467 618Q457 621 440 624T406 629H400Q333 629 306 579Q301 568 289 507L275 444H328Q381 444 381 443",
  120360: "113 252Q113 334 177 394T311 454Q332 454 350 451T379 442T398 432T410 424L413 421Q412 423 411 424L409 426Q409 429 434 436T496 449T560 455H568V451Q568 447 567 429T566 394L565 377L553 379Q522 385 479 385Q463 385 456 384L443 383L436 392Q454 357 454 324Q454 243 390 182T249 120Q233 120 219 122T195 128T178 136T167 142L163 145Q149 131 149 105Q149 78 171 72L242 71Q246 71 269 71T303 71T336 68T372 62T403 51T432 32Q461 8 461 -40Q461 -112 383 -159T211 -206Q123 -206 68 -172T12 -86Q12 -55 31 -23T82 32Q90 38 89 39Q89 40 87 44T82 59T80 82Q80 134 126 189Q113 228 113 252ZM369 319Q369 354 350 368T304 383Q274 383 252 369T218 333T202 291T197 255Q197 221 217 206T263 191Q317 191 343 233T369 319ZM373 -59Q373 -41 362 -30T330 -13T291 -7T247 -5H216Q167 -5 158 -6T139 -12Q123 -20 110 -38T97 -76Q97 -102 133 -118T221 -134Q242 -134 267 -130T316 -118T357 -94T373 -59",
  120361: "416 321Q416 379 336 379Q276 379 237 302Q226 276 209 202T180 66T166 2V0H119Q73 0 73 1L82 46Q92 90 111 177T147 348L221 694H265Q310 694 310 693T279 544L247 395Q325 455 403 455Q513 455 513 358Q513 334 508 309Q507 304 476 156T443 2V0H350V2L357 34Q364 65 373 110T392 200T409 281T416 321",
  120362: "189 578Q190 579 199 627T211 678V680H315V678Q313 675 304 627T293 578V576H189V578ZM168 442T168 443T213 444T258 443T212 225T164 2V0H74V2Q75 7 121 224",
  120363: "211 577L233 680H284Q336 680 336 679L315 576H263Q211 576 211 577ZM19 -204Q-12 -204 -40 -196T-82 -179T-96 -170Q-96 -168 -78 -132L-61 -95L-54 -103Q-32 -126 3 -126Q26 -126 50 -116Q76 -101 83 -85Q84 -79 140 180T196 443Q196 444 241 444T286 443Q286 441 232 186T175 -75Q163 -120 122 -162T19 -204",
  120364: "150 348L224 694H310V691Q218 259 218 258L232 270Q245 281 274 306T327 351L435 444H489L542 443Q542 442 443 357L344 272L471 1L422 0H372L366 14Q359 27 347 54T323 105L273 210Q271 210 231 174L190 139L160 0H118Q76 0 76 1L86 46Q95 90 114 177T150 348",
  120365: "148 348L222 694H311V691Q311 690 238 348T164 2V0H119Q74 0 74 1L84 46Q93 90 112 177T148 348",
  120366: "416 321Q416 379 336 379Q276 379 237 302Q226 276 209 202T180 66T166 2V0H119Q73 0 73 2L121 226L169 449Q169 450 213 450H256L249 421Q248 417 247 412T246 404T245 398T244 394T244 392Q250 398 261 407T307 433T379 454H392H400Q451 454 472 439Q482 434 489 427T500 412T506 399T510 388L511 384Q511 384 517 388Q563 431 620 446Q648 455 680 455Q790 455 790 358Q790 334 785 309Q784 304 753 156T720 2V0H627V2L634 34Q641 65 650 110T669 200T686 281T693 321Q693 379 613 379Q553 379 514 302Q503 276 486 202T457 66T443 2V0H350V2L357 34Q364 65 373 110T392 200T409 281T416 321",
  120367: "416 321Q416 379 336 379Q276 379 237 302Q226 276 209 202T180 66T166 2V0H119Q73 0 73 2L121 226L169 449Q169 450 213 450H256L249 421Q248 417 247 412T246 404T245 398T244 394T244 392Q250 398 261 407T307 433T379 454H392Q416 454 433 452T470 440T502 411T513 358Q513 334 508 309Q507 304 476 156T443 2V0H350V2L357 34Q364 65 373 110T392 200T409 281T416 321",
  120368: "69 169Q69 238 107 306T211 417T348 461Q419 461 471 412T523 271Q523 161 438 75T247 -11Q170 -11 120 39T69 169ZM432 279Q432 338 401 361T333 385Q280 385 240 352T182 273T164 178Q164 119 195 94T265 68Q306 68 344 94Q380 115 406 169T432 279",
  120369: "259 443Q251 405 251 404L260 409Q269 414 286 421T324 436T375 449T434 455Q482 455 510 417T538 303Q538 169 463 79T302 -11Q226 -11 176 39V36Q175 35 151 -80L127 -193Q127 -194 80 -194H34V-191L102 127L169 443Q169 444 214 444T259 443ZM269 65Q332 65 386 124T441 262Q441 304 422 334T370 373Q356 375 339 375Q293 375 238 331L193 118Q200 103 206 94T229 75T269 65",
  120370: "72 149Q72 272 146 363T304 455Q340 455 371 442T409 423T436 398Q438 411 442 427L448 455H538L400 -193Q400 -194 354 -194Q307 -194 307 -193L356 37V41Q355 41 350 38T332 27T302 13Q247 -10 191 -10H179Q138 -10 105 32T72 149ZM414 298Q402 376 341 376Q277 376 223 317T169 182Q169 121 198 93T265 65Q319 65 365 111L377 123L414 298",
  120371: "240 377L244 380Q248 384 255 390T272 404T296 419T325 434T361 446T401 454Q403 454 408 454T416 455H424L421 442Q419 435 413 405T406 373Q351 373 294 336T216 237Q213 231 201 173T178 60T164 2V0H119Q74 0 74 2L122 226L170 449Q170 450 213 450H255L247 414Q246 409 245 403T243 393T241 385T240 379T240 377",
  120372: "99 299Q99 318 106 341T133 393T195 441T298 461Q336 461 370 453T420 437L436 429Q436 428 421 389T405 350Q356 386 273 386H265Q248 386 237 384T211 371T191 337Q189 329 189 326Q189 320 190 315T194 306T200 299T209 293T218 289T228 285T239 283T251 281T263 278L270 276Q278 275 283 274T298 270T316 264T333 255T351 243T367 228T380 209T388 186T391 157Q391 96 341 43T193 -11Q171 -11 150 -8T114 -1T84 9T61 19T45 28T35 33Q35 36 67 116L76 109Q132 67 211 67Q258 67 279 88T301 135Q301 159 280 170T224 187T180 197Q141 212 120 239T99 299",
  120373: "245 68Q267 68 289 75T322 90L334 98Q338 94 338 28V24L324 19Q268 -4 218 -8Q198 -11 177 -11Q118 -11 118 75Q118 98 123 127Q125 137 149 251T174 369Q174 371 135 371H97V373L105 410L112 444H152L192 445L200 478Q208 512 213 541L219 571H261Q303 571 303 570T290 506L276 444H343Q410 444 410 443Q410 440 403 407T395 371H328Q261 371 261 369Q211 152 211 118Q211 68 245 68",
  120374: "166 -10H160Q146 -10 137 -8T115 0T97 22T90 63Q90 79 130 268L167 443Q167 444 214 444Q260 444 260 443L224 273Q187 97 187 86Q187 70 202 65T250 59Q303 59 336 83T379 139Q380 143 412 292T444 443Q444 444 491 444Q537 444 537 443T491 225T443 2V0H353V2L361 38L352 34Q344 29 326 22T286 7T232 -5T166 -10",
  120375: "177 6L108 442V444H201V442Q202 441 213 371T235 213T246 90V65Q259 117 429 406L450 444H495Q540 444 540 443Q539 442 411 221L282 1L230 0H178L177 6",
  120376: "148 5Q147 8 128 222T109 440L108 444H199V442Q200 441 204 385T214 253T219 140Q219 108 215 76Q215 72 214 67V65L215 66Q219 95 278 221L390 444H475V437Q497 203 497 121Q497 90 494 70Q494 67 494 67L496 73Q520 143 654 405L674 444H718Q762 444 762 443L534 1L483 0H432V5Q429 28 422 126T413 283Q413 343 416 370L417 378Q416 377 416 376Q401 303 248 12L242 0H148V5",
  120377: "317 229Q453 9 460 0H409L359 1L312 88Q266 176 265 176Q265 177 254 165T223 132T182 88L100 0H1L15 14Q29 28 61 59T118 115L236 229L226 244Q108 433 100 444H201L290 294L438 444H537L528 435Q526 432 512 418T468 376T418 327L317 229",
  120378: "11 -117L20 -120Q28 -124 46 -128T84 -132H100Q124 -122 149 -85Q200 -6 200 1Q200 17 155 204T109 442Q109 444 156 444H203Q203 443 208 419T221 357T235 277T248 190T254 114Q254 81 250 67V65Q251 65 251 67Q256 94 297 177Q339 259 422 397L450 444H540Q540 443 386 186T219 -90Q179 -153 145 -179T73 -205Q52 -205 34 -202Q29 -202 21 -201T7 -198L1 -197Q1 -196 6 -157T11 -117",
  120379: "129 408L136 444H315Q494 444 494 443Q494 441 489 419L484 396L164 76L291 77Q418 77 418 76T411 41T402 2V0H215Q28 0 28 2L34 27L38 50L360 371L240 370Q121 370 121 371Q124 388 129 408",
  120432: "191 76Q212 75 220 68T229 38Q229 10 208 1H129H80Q48 1 38 7T28 38Q28 51 29 57T40 69T70 76Q89 76 89 78Q90 79 117 205T173 461T205 599Q212 623 250 623H262H273Q312 623 319 599Q322 591 350 461T406 205T435 78Q435 76 454 76H458Q484 76 493 59Q496 53 496 38Q496 11 478 3Q474 1 395 1H317Q295 8 295 38Q295 65 311 73Q316 75 333 76L348 77V78Q348 80 341 112L334 143H190L183 112Q176 80 176 78Q175 76 178 76Q180 76 191 76ZM318 221Q313 238 288 366T263 519Q263 526 262 527Q261 527 261 520Q261 493 236 365T206 221Q206 219 262 219T318 221",
  120433: "39 1Q17 10 17 32V38V46Q17 65 34 73Q40 76 61 76H84V535H61H54Q27 535 19 553Q17 557 17 573Q17 583 17 587T23 599T39 610Q40 611 179 611Q320 610 332 607Q332 607 339 605Q394 591 427 547T461 454Q461 413 436 378T369 325L358 320Q405 311 443 270T482 169Q482 112 445 64T345 3L334 1H39ZM309 533Q302 535 234 535H168V356H230Q284 357 296 358T323 368Q346 380 361 402T377 452Q377 482 358 505T309 533ZM398 176Q396 218 371 246T315 279Q310 280 237 280H168V76H239Q316 77 327 81Q329 82 334 84Q398 107 398 176",
  120434: "40 305Q40 437 110 529T281 622Q315 622 343 611T387 589T404 578Q409 585 415 596T425 611T435 618T452 622Q472 622 478 609T485 566Q485 559 485 540T484 508V460Q484 413 478 403T442 393Q417 393 409 402Q400 409 400 420Q400 428 395 445T380 487T347 528T295 546Q235 546 180 483T124 306Q124 245 141 197T186 121T241 80T296 66Q346 66 373 103T400 178Q400 209 435 209H442H450Q484 209 484 172Q480 96 421 43T281 -11Q177 -11 109 84T40 305",
  120435: "38 1Q16 8 16 38Q16 62 32 73Q39 76 58 76H78V535H58Q40 535 32 538Q16 548 16 573Q16 587 17 591Q23 604 34 607T83 611H166H176Q188 611 209 611T239 612Q299 612 337 597T415 530Q485 438 485 300Q485 180 431 100T301 3L291 1H38ZM400 301Q400 363 385 410T346 482T303 519T267 534Q261 535 210 535H162V76H214L267 77Q323 89 361 148T400 301",
  120436: "374 271Q374 241 367 232T332 223Q307 223 299 231Q290 240 290 263V279H173V76H418V118V144Q418 167 426 176T460 186Q491 186 500 166Q502 161 502 93V52Q502 25 499 17T480 1H41Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q44 535 38 537T25 548T19 573Q19 602 41 610H47Q53 610 63 610T88 610T121 610T160 611T204 611T251 611H458Q460 609 465 606T471 602T475 598T478 593T479 586T480 576T480 562V526V488Q480 452 462 444Q458 442 438 442Q413 442 405 450Q398 457 397 463T396 501V535H173V355H290V371Q290 394 299 403T332 412Q363 412 372 392Q374 387 374 317V271",
  120437: "384 260Q384 230 377 221T342 212Q317 212 309 220Q300 229 300 252V268H179V76H249Q264 67 267 61T271 38Q271 10 249 1H44Q22 9 22 32V38Q22 63 39 73Q45 76 69 76H95V535H69H59Q42 535 32 542T22 573Q22 602 44 610H50Q56 610 66 610T91 610T125 610T164 611T208 611T257 611H468Q470 609 475 606T481 602T485 598T488 593T489 586T490 576T490 562V526V488Q490 452 472 444Q468 442 448 442Q423 442 415 450Q408 457 407 463T406 501V535H179V344H300V360Q300 383 309 392T342 401Q373 401 382 381Q384 376 384 306V260",
  120438: "38 306Q38 447 105 534T261 622Q280 622 298 618T329 608T350 596T366 585L371 581Q373 581 377 591T390 612T417 622Q437 622 443 609T450 566Q450 559 450 540T449 508V460Q449 413 443 403T407 393Q392 393 386 394T373 402T364 426Q360 472 335 509T271 546Q214 546 168 477T121 308Q121 210 164 138T271 65Q293 65 310 78T337 109T352 147T360 180T362 195Q362 196 333 196L304 197Q282 204 282 227V234Q282 247 282 251T288 261T304 272H474Q488 263 492 256T496 234Q496 211 479 199Q475 197 461 196H449V21Q441 6 434 3T412 -1H407H402Q385 -1 379 3T364 28Q350 14 322 2T260 -11Q173 -11 106 76T38 306",
  120439: "16 571Q16 597 27 604T74 611H125H208Q223 602 226 596T230 573Q230 559 227 551T217 540T204 536T186 535H165V356H359V535H338H333Q306 535 297 552Q295 556 295 573Q295 586 295 590T301 600T317 611H486Q501 602 504 596T508 573Q508 559 505 551T495 540T482 536T464 535H443V76H464H470Q482 76 489 75T502 64T508 38Q508 10 486 1H317Q306 5 301 11T296 21T295 38V44Q295 66 311 73Q318 76 338 76H359V280H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60Q45 535 38 536T24 545T16 571",
  120440: "400 76Q431 76 441 69T452 38Q452 29 452 26T450 18T443 9T430 1H95Q84 6 79 12T73 23T72 38Q72 65 90 73Q96 76 157 76H220V535H157H124Q93 535 83 542T72 573Q72 603 93 610Q97 611 264 611H430Q432 609 436 607T444 602T449 594Q452 588 452 573Q452 546 434 538Q428 535 367 535H304V76H367H400",
  120441: "202 543T202 573T224 610H228Q231 610 237 610T251 610T269 610T291 611T315 611T342 611H457Q471 602 475 595T479 573Q479 549 462 538Q454 535 432 535H408V328Q408 159 408 133T402 93Q386 48 340 19T229 -11Q158 -11 108 16T57 100Q57 129 73 141T108 154Q128 154 143 140T159 102Q159 93 155 79Q188 65 228 65H230Q290 65 318 106Q323 115 323 139T324 329V535H274L224 536Q202 543 202 573",
  120442: "18 549T18 573T29 604T70 611H118H193Q207 603 210 596T214 573Q214 549 198 538Q191 535 172 535H152V421Q152 344 152 326T153 309L242 422L329 534Q327 535 322 536T314 538T308 542T303 548T300 558T298 573Q298 600 316 608Q322 611 392 611H463Q477 602 481 595T485 573Q485 535 446 535H441H420L281 357L436 77L454 76Q473 75 478 73Q495 62 495 38Q495 10 473 1H345Q334 5 329 11T324 21T323 38Q323 51 324 56T332 68T355 77L233 296L152 192V76H172Q191 76 198 73Q214 63 214 38Q214 9 193 1H41Q18 8 18 38Q18 61 35 73Q42 76 61 76H81V535H61Q42 535 35 538Q18 549 18 573",
  120443: "27 594Q34 605 43 608T84 611H154H213Q258 611 269 605T281 573Q281 546 263 538Q257 535 222 535H185V76H404V118V145Q404 168 411 177T446 186H453Q478 186 486 167Q488 161 488 93V50Q488 24 485 17T466 1L258 0H147H99Q47 0 36 6T25 38Q25 59 35 69Q44 76 76 76H101V535H76H64Q36 535 27 552Q25 557 25 573T27 594",
  120444: "50 535Q37 536 31 537T18 547T12 573Q12 598 22 604T62 611H91H121Q147 611 158 607T178 587Q183 579 222 446T261 293Q261 289 262 288Q263 288 263 292Q263 311 298 434T346 588Q353 603 365 607T402 611H435H450Q488 611 500 605T512 573Q512 556 506 547T493 537T474 535H459V76H474Q487 75 493 74T505 64T512 38Q512 11 494 3Q490 1 424 1H386Q355 1 345 7T335 38Q335 55 341 64T354 74T373 76H388V302Q388 512 387 519Q382 482 346 359T304 228Q292 204 262 204T220 228Q215 237 179 359T137 519Q136 512 136 302V76H151Q164 75 170 74T182 64T189 38Q189 11 171 3Q167 1 101 1H63Q32 1 22 7T12 38Q12 55 18 64T31 74T50 76H65V535H50",
  120445: "20 571Q20 598 30 604T73 611H105H136Q152 611 160 611T177 607T189 601T198 587T206 568T217 537T231 497Q354 142 365 95L368 84V535H347H342Q314 535 306 552Q304 556 304 573Q304 586 304 590T310 600T326 611H482Q497 602 500 596T504 573Q504 559 501 551T491 540T478 536T460 535H439V25Q432 7 424 4T389 0H374Q334 0 322 31L293 115Q171 468 159 517L156 528V76H177H183Q195 76 202 75T215 64T221 38Q221 10 199 1H43Q32 5 27 11T22 21T21 38V44Q21 66 37 73Q44 76 64 76H85V535H64Q49 535 42 536T28 545T20 571",
  120446: "102 588Q140 621 240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 185 460 118T422 23Q382 -10 289 -10H262H235Q142 -10 102 23Q74 50 65 118T56 306Q56 427 64 494T102 588ZM363 513Q357 523 347 530T324 540T302 544T280 546H268Q192 546 167 521Q150 501 145 452T140 300Q140 235 142 197T151 130T172 89T207 71T262 65Q317 65 341 81T374 144T384 300Q384 474 363 513",
  120447: "41 1Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q38 535 29 543T19 576Q19 603 41 610H49Q57 610 70 610T100 610T136 611T175 611Q190 611 216 611T255 612Q321 612 363 598T441 537Q480 486 480 427V421Q480 354 447 311T378 251Q339 230 275 230H239H173V76H197Q220 76 227 73Q244 62 244 38Q244 10 222 1H41ZM396 421Q396 461 369 491T300 533Q294 534 233 535H173V306H233Q294 307 300 308Q345 319 370 352T396 421",
  120448: "56 306Q56 380 58 426T68 510T87 568T120 600T170 617T240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 124 447 66Q433 23 394 6L424 -53Q454 -112 454 -118Q454 -128 441 -138H377Q367 -135 363 -129T333 -69L304 -11H254Q205 -10 180 -8T128 6T91 36T70 92T58 178T56 306ZM227 151Q227 171 262 171H276H281Q292 171 296 171T305 170T313 165T317 158T323 145T332 127L353 88Q356 88 361 95T372 131T382 202Q384 228 384 306Q384 452 371 492T304 544Q296 545 251 545Q230 545 215 543T188 534T169 520T155 497T147 466T143 423T141 371T140 306Q140 248 141 217T146 154T157 109T178 83T212 68T262 65H266L264 70Q261 75 256 85T247 105Q227 145 227 151",
  120449: "16 571Q16 598 27 605T76 612Q84 612 108 612T148 611Q268 611 294 605Q346 592 389 550T432 440Q432 394 410 359Q393 329 366 310L358 303Q387 273 399 239Q405 219 405 178T408 106T421 68Q426 65 428 65Q433 65 435 74T438 96T441 112Q450 130 480 130H485Q519 130 522 100Q522 79 516 56T488 11T434 -11Q421 -11 408 -8T377 5T344 37T324 93Q322 101 322 154L321 209Q304 257 257 267Q252 268 207 268H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60Q45 535 38 536T24 545T16 571ZM348 440Q348 478 321 502T260 532Q252 534 208 535H165V344H208Q212 344 223 344T239 345T252 346T266 348T278 351T293 358Q348 387 348 440",
  120450: "52 454Q52 524 107 572T229 621Q266 621 274 620Q326 610 360 588L371 581Q377 594 379 598T386 610T397 619T412 622Q433 622 439 610T446 570Q446 563 446 545T445 515V479Q445 441 444 432T436 417Q428 408 403 408T370 417Q361 424 361 434Q361 439 360 448T351 476T331 509T295 535T238 546Q194 546 163 522T132 458Q132 435 148 412Q155 401 166 393T192 380T218 371T247 364T270 359Q341 342 349 339Q389 325 418 296T461 229Q472 201 472 164Q469 92 417 41T287 -11Q240 -11 200 -1T143 19L126 29Q117 6 109 -2Q100 -11 84 -11Q64 -11 58 1T51 42Q51 49 51 66T52 95V135Q52 173 53 180T61 194Q70 203 95 203Q119 203 127 194Q136 186 136 168Q143 66 284 66H290Q325 66 350 85Q391 115 391 165Q391 204 369 228T322 260Q320 260 255 275T185 293Q123 309 88 355T52 454",
  120451: "129 38Q129 51 129 55T135 65T151 76H220V535H110V501Q110 470 109 464T101 450Q93 442 68 442H60Q37 442 28 461Q26 466 26 527L27 589Q36 607 49 610H55Q61 610 72 610T97 610T131 610T170 611T215 611T264 611H476Q478 609 483 606T489 602T493 598T496 593T497 586T498 576T498 562V526V488Q498 452 480 444Q476 442 456 442Q431 442 423 450Q416 457 415 463T414 501V535H304V76H374Q389 67 392 61T396 38Q396 10 374 1H151Q140 5 135 11T130 21T129 38",
  120452: "-3 573Q-3 597 8 604T50 612Q57 612 77 612T111 611H200Q214 602 218 595T222 573Q222 549 205 538Q198 535 175 535H151V359Q151 333 151 291Q152 177 156 162Q157 160 157 159Q165 123 193 95T262 66Q303 66 330 94T367 159Q371 175 371 191T373 359V535H349H339Q328 535 322 537T309 548T303 573T306 595T325 611H506Q520 602 524 595T528 573Q528 549 511 538Q504 535 481 535H457V364Q457 189 456 182Q448 101 394 45T262 -11Q189 -11 132 43T68 182Q67 189 67 364V535H43H33Q22 535 16 537T3 548T-3 573",
  120453: "19 578Q19 585 20 590T23 598T29 604T38 608T48 610T62 611T78 612T97 611T119 611H195Q210 602 213 596T217 573Q217 561 216 555T206 542T179 535H164Q166 529 188 435T235 231T261 94L262 84V88Q263 91 263 94Q265 121 289 231T336 438L360 535H345Q308 535 308 566V573Q308 586 308 590T314 600T330 611H484Q499 602 502 595T505 573Q505 560 504 554T493 541T465 535H447L384 278Q321 19 319 14Q309 -7 278 -7H262H246Q215 -7 205 14Q203 19 140 278L78 535H59Q45 535 38 536T25 547T19 573V578",
  120454: "459 611Q491 611 501 605T512 573Q512 538 482 535H474L439 276Q406 26 402 11Q398 2 389 -3Q387 -3 386 -4L380 -7H359H349Q324 -7 313 13Q307 29 285 139T263 275Q263 283 262 283Q261 282 261 274Q261 248 239 137T211 13Q200 -7 175 -7H165H144Q136 -3 127 3Q121 10 117 36T85 276L50 535H42Q26 536 19 545T12 564V573Q12 603 33 610Q37 611 101 611H134Q165 611 175 604T186 573Q186 563 186 559T182 547T169 538T143 535H122V531Q124 517 133 446T155 266T172 96V84L173 102Q176 157 192 243T215 346Q227 367 259 367H262H265Q297 367 309 346Q316 329 332 243T351 102L352 84V96Q356 161 368 266T390 444T402 531V535H381Q366 535 359 536T345 547T338 573Q338 600 356 608Q362 611 425 611H459",
  120455: "39 571Q39 597 49 604T93 611H141H218Q233 602 236 595T239 573Q239 538 210 535Q202 535 202 534T215 507T243 454L257 428L307 535H298Q266 538 266 573Q266 584 267 588T273 598T289 611H366H401Q442 611 454 605T466 573Q466 546 448 538Q442 535 421 535H398L299 327Q299 323 362 201L426 77L449 76Q467 76 475 75T489 65T495 38Q495 11 477 3Q473 1 395 1H317Q295 8 295 38Q295 73 325 76L334 77Q333 78 314 117T276 196L257 235L239 196Q221 157 204 118T186 77Q190 76 196 76Q211 74 218 67T227 55T228 38Q228 28 227 24T221 13T206 1H50Q28 9 28 32V38Q28 63 45 73Q51 76 73 76H96L214 324Q215 327 162 431L108 535H85H79Q67 535 60 536T46 546T39 571",
  120456: "20 573Q20 597 30 604T72 611H121H198Q212 602 216 595T220 573Q220 568 219 563T217 555T214 549T211 544T207 541T203 538T198 537T194 536T190 536L188 535Q179 535 179 534L188 516Q196 497 208 470T232 415T252 363T261 332Q261 329 262 329T263 332Q263 354 333 508L345 534Q345 535 336 535Q305 538 305 567V573Q305 589 308 595T327 611H483Q505 598 505 573Q505 549 488 538Q481 535 460 535H438L304 245V76H325H331Q343 76 350 75T363 64T369 38Q369 10 347 1H178Q167 5 162 11T157 21T156 38V44Q156 66 172 73Q180 76 199 76H220V245L86 535H64Q44 535 36 538Q20 548 20 573",
  120457: "71 1Q60 5 55 11T49 23T48 39V46Q48 56 58 73T131 183Q171 242 197 282L366 535H144V501Q144 470 143 464T135 450Q127 442 102 442H94Q71 442 62 461Q60 466 60 527L61 589Q70 607 83 610H88Q93 610 102 610T124 610T154 610T188 611T227 611T270 611H454Q456 609 461 606T467 601T471 597T474 591T475 584T476 572V565Q476 555 466 538T393 428Q353 369 327 329L158 76H397V120V146Q397 169 405 179T439 189Q470 189 479 169Q481 164 481 95V48Q481 24 478 16T459 1H71",
  120458: "126 306Q105 306 90 321T74 359Q74 439 211 439Q268 439 276 438Q343 426 383 390T430 306Q431 301 431 190V81Q446 79 465 78T492 76T509 72T521 60T524 38Q524 11 506 3Q502 1 466 1Q426 1 406 5T379 14T355 36L345 30Q284 -6 205 -6Q135 -6 92 39T48 141Q48 182 79 212T158 256T252 278T342 285H347V290Q347 315 325 335T267 362Q258 363 224 363Q189 363 185 362H179L178 358Q178 353 178 352T176 345T174 337T170 330T165 322T158 316T150 311T139 308T126 306ZM132 140Q132 115 157 93T224 70Q269 70 302 87T344 133Q346 139 347 175V211H339Q256 209 194 190T132 140",
  120459: "4 573Q4 596 15 603T52 611H90H124Q146 611 155 608T171 591Q173 586 173 491V396L182 402Q217 424 256 431Q280 437 309 437Q376 437 434 379T492 217Q492 162 473 118T422 47T358 8T293 -6Q229 -6 174 38Q171 13 163 7T135 1H131H122Q99 1 90 23L89 279V535H58L27 536Q4 543 4 573ZM409 215Q409 269 377 315T283 361Q255 361 224 344T177 297L173 290V167Q189 124 213 97T278 70Q330 70 369 111T409 215",
  120460: "291 -6Q196 -6 131 60T66 216Q66 296 119 361Q154 403 200 421T273 439Q275 440 293 440H313Q400 440 433 409Q454 388 454 359Q454 335 439 321T402 306Q380 306 365 321T350 357V362L340 363Q339 363 326 363T303 364Q280 364 266 362Q217 352 184 313T151 215Q151 153 199 112T313 70Q341 70 357 85T381 118T394 140Q402 146 424 146Q443 146 447 144Q466 137 466 117Q466 106 457 88T429 47T374 10T291 -6",
  120461: "266 573Q266 596 277 603T314 611H352H385Q411 611 419 607T435 586V76H498Q512 67 516 60T520 38Q520 9 498 1H436Q429 1 417 1T398 0Q375 0 363 7T351 34V43L342 36Q288 -6 223 -6Q143 -6 87 58T31 216Q31 307 88 372T230 437Q292 437 342 405L351 399V535H320L289 536Q266 543 266 573ZM351 290Q347 302 337 316T302 346T244 361Q193 361 154 319T115 215Q115 152 152 111T235 70Q314 70 351 170V290",
  120462: "48 217Q48 295 100 361T248 439L258 440Q268 440 274 440Q329 438 369 416T428 359T456 292T464 228Q464 215 461 208T454 198T442 190L288 189H135L138 179Q153 132 199 102T303 71Q336 71 353 86T380 120T398 143Q404 146 422 146Q453 146 462 126Q464 120 464 116Q464 84 416 39T285 -6Q187 -6 118 59T48 217ZM377 264Q371 291 365 306T341 338T294 362Q288 363 264 363Q225 363 190 336T139 264H377",
  120463: "43 395Q44 405 44 408T47 416T53 423T66 431H176V461Q176 500 182 518Q201 570 252 593T353 617Q399 614 418 593T437 548Q437 528 424 514T387 499Q365 499 353 511T338 537V541H328Q275 536 261 494Q260 490 260 460V431H327Q334 431 346 431T364 432Q392 432 404 425T416 393T405 362T365 355H327H260V76H319Q375 76 388 71T401 38Q401 27 400 23T395 12T379 1H58Q47 6 42 12T36 23T35 38Q35 65 53 73Q59 76 117 76H176V355H121H93Q64 355 54 362T43 395",
  120464: "60 274Q60 337 107 386T233 436Q278 436 316 417L329 410L338 416Q384 442 427 442T489 423T509 381T494 345T460 332Q449 332 440 338Q432 341 427 348T419 360T415 365Q414 364 410 364L383 355Q406 320 406 274Q406 211 358 162T233 112Q189 112 155 128L146 133Q142 125 142 115Q142 99 150 85T175 71Q182 72 187 70Q188 70 195 70T218 70T254 69Q259 69 275 69T297 69T318 68T340 66T361 62T384 57T405 49T428 38Q495 -1 495 -76Q495 -143 427 -186T262 -229Q161 -229 94 -185T29 -73Q30 -60 33 -48T39 -26T47 -8T57 8T67 20T77 30T86 38L91 43Q91 44 86 53T75 80T70 117Q70 142 89 183L83 194Q60 232 60 274ZM321 274Q321 312 296 337T230 362Q197 362 171 338T145 274Q145 235 170 211T233 187Q273 187 297 212T321 274ZM422 -78Q422 -54 408 -38T366 -15T315 -6T255 -4H200Q198 -4 193 -4T183 -3Q148 -3 125 -26T102 -78Q102 -110 151 -132T261 -154Q321 -154 371 -132T422 -78",
  120465: "4 573Q4 596 15 603T52 611H90H124Q146 611 155 608T171 591Q173 586 173 489Q173 394 175 394L186 402Q197 410 219 420T269 434Q278 436 306 436Q343 436 371 423Q411 402 423 365T436 265Q436 257 436 239T435 211V198V76H498Q512 67 516 60T520 38Q520 9 498 1H308Q286 10 286 32V38V46Q286 65 303 73Q309 76 329 76H351V188Q351 204 351 230T352 266Q352 321 341 341T288 361Q253 361 222 341T176 274L174 264L173 170V76H236Q250 67 254 60T258 38Q258 9 236 1H27Q4 8 4 38Q4 53 8 60T27 76H89V535H58L27 536Q4 543 4 573",
  120466: "202 538T202 559T218 596T260 612Q283 612 300 597T317 560Q317 538 300 523T260 507Q235 507 219 522ZM411 76Q441 76 451 69T462 38Q462 29 462 26T460 18T453 9T440 1H94Q72 8 72 33V38Q72 46 72 49T74 58T81 68T94 76H233V355H167L102 356Q80 363 80 393Q80 418 91 425T138 432Q145 432 165 432T200 431H295Q297 429 303 425T310 420T314 415T317 404T317 389T318 363Q318 354 318 314T317 241V76H378H411",
  120467: "261 559Q261 580 277 596T319 612Q342 612 359 597T376 560T360 523T320 507Q296 507 279 523T261 559ZM75 -91T100 -91T138 -107T152 -144V-150L160 -151H193H203Q241 -151 267 -121Q284 -97 288 -73T292 23V151V355H218L145 356Q123 365 123 387V393Q123 422 145 430H148Q151 430 156 430T169 430T185 430T205 431T227 431T251 431H354Q356 430 360 427T365 424T369 420T372 416T373 410T375 402T376 391T377 376T377 356Q377 345 377 286T376 176Q376 -67 371 -88Q362 -123 342 -151T299 -194Q254 -228 180 -228Q84 -226 56 -177Q49 -162 48 -148Q48 -122 61 -107",
  120468: "13 42Q13 63 23 69T69 76H102V535H69H54Q34 535 24 542T13 573Q13 588 15 593Q22 605 29 608T56 611H95Q113 611 122 611T140 610T152 609T159 607T163 603T167 597T173 589V413L174 237L295 355H275Q260 355 253 356T239 367T232 393Q232 419 243 425T304 431H359H464Q479 422 482 415T485 393Q485 364 464 356L431 355H398L293 254L427 76H486Q501 67 504 60T507 38Q507 28 507 24T501 12T486 1H314Q292 8 292 38Q292 62 308 73Q312 75 326 76L338 77L290 140Q279 154 267 171T248 196L242 204L207 171L173 139V76H206H221Q241 76 251 69T262 38Q262 11 244 3Q240 1 138 1Q123 1 100 1T70 0Q32 0 23 7T13 42",
  120469: "51 573Q51 602 73 610H76Q79 610 84 610T97 610T113 610T133 611T155 611T179 611H282Q301 598 304 586V76H452Q466 67 470 60T474 38Q474 10 452 1H73Q51 9 51 32V38Q51 54 54 60T73 76H220V535H146L73 536Q51 545 51 567V573",
  120470: "133 76Q156 74 164 67T172 38Q172 9 151 1H11Q-12 8 -12 38Q-12 61 5 73Q10 75 28 76H45V355H28Q10 356 5 358Q-12 370 -12 393Q-12 419 11 431H52H70Q91 431 100 427T116 405Q163 436 200 436Q255 436 281 390L285 394Q289 398 292 400T301 407T314 415T329 423T346 429T366 434T389 436H392Q425 436 448 411Q469 390 474 360T480 268V232V203V76H497Q520 74 528 67T536 38Q536 9 515 1H396Q374 9 374 32V38Q374 73 402 76H409V191V242Q409 317 404 339T375 361Q343 361 323 332T299 264Q298 258 298 165V76H315Q338 74 346 67T354 38Q354 9 333 1H214Q192 9 192 32V38Q192 73 220 76H227V191V242Q227 317 222 339T193 361Q161 361 141 332T117 264Q116 258 116 165V76H133",
  120471: "89 431Q94 431 105 431T122 432Q173 432 173 399Q173 394 175 394Q176 394 190 404T233 425T298 436Q343 436 371 423Q411 402 423 365T436 265Q436 257 436 239T435 211V198V76H498Q512 67 516 60T520 38Q520 9 498 1H308Q286 9 286 32V38V45Q286 65 303 73Q309 76 329 76H351V188Q351 204 351 230T352 266Q352 321 341 341T288 361Q253 361 222 341T176 274L174 264L173 170V76H236Q250 67 254 60T258 38Q258 9 236 1H27Q4 8 4 38Q4 53 8 60T27 76H89V355H58L27 356Q4 363 4 393Q4 408 8 415T27 431H89",
  120472: "52 216Q52 318 118 379T261 440Q343 440 407 378T472 216Q472 121 410 58T262 -6Q176 -6 114 58T52 216ZM388 225Q388 281 351 322T261 364Q213 364 175 325T136 225Q136 158 174 114T262 70T350 114T388 225",
  120473: "89 431Q93 431 104 431T121 432Q173 432 173 401V396L182 402Q237 437 305 437Q376 437 434 378T492 217Q492 146 459 93T382 17T291 -6Q261 -6 232 5T188 26L174 37Q173 37 173 -54V-146H236Q250 -155 254 -162T258 -184Q258 -213 236 -221H27Q4 -214 4 -184Q4 -169 8 -162T27 -146H89V355H58L27 356Q4 363 4 393Q4 408 8 415T27 431H89ZM409 215Q409 269 377 315T283 361Q255 361 224 344T177 297L173 290V167Q189 124 213 97T278 70Q330 70 369 111T409 215",
  120474: "34 215Q34 309 91 368T222 436Q224 436 231 436T242 437Q309 437 372 390V401Q372 419 381 428T414 437Q426 437 432 436T444 430T456 412V-146H489H504Q524 -146 534 -153T545 -184Q545 -211 527 -219Q523 -221 414 -221Q398 -221 374 -221T342 -222Q304 -222 294 -216T283 -184Q283 -157 301 -149Q307 -146 339 -146H372V-51Q372 43 371 43L364 38Q357 33 345 26T318 12T280 -1T236 -6Q155 -6 95 55T34 215ZM117 215Q117 152 157 111T250 70Q289 70 318 92T363 146Q372 163 372 192V215L371 263Q339 360 254 360Q206 360 162 321T117 215",
  120475: "327 76Q359 76 369 70T380 38Q380 10 359 1H47Q24 8 24 38Q24 54 28 61T47 76H145V355H96L47 356Q24 363 24 393Q24 409 28 416T47 431H207Q223 419 226 414T229 393V387V369Q297 437 394 437Q436 437 461 417T487 368Q487 347 473 332T438 317Q428 317 420 320T407 327T398 337T393 347T390 356L388 361Q348 356 324 345Q228 299 228 170Q228 161 228 151T229 138V76H293H327",
  120476: "72 317Q72 361 108 396T229 439Q231 439 245 439T268 440Q303 439 324 435T353 427T363 423L372 432Q380 440 397 440Q430 440 430 395Q430 390 430 380T429 366V335Q429 311 422 302T387 293Q364 293 355 300T346 316T343 336T325 353Q306 364 257 364Q209 364 178 351T147 317Q147 284 231 272Q327 256 357 247Q458 210 458 129V121Q458 74 413 34T271 -6Q246 -6 224 -3T189 5T165 14T150 22T144 26Q142 23 139 18T135 11T132 6T128 1T124 -2T119 -4T113 -5T104 -6Q84 -6 78 6T71 43Q71 48 71 60T72 79Q72 132 73 141T81 157Q90 166 115 166Q135 166 142 162T157 140Q168 108 191 90T260 70Q297 70 323 76T361 91T379 110T384 129Q384 157 346 171T247 195T165 212Q119 228 96 256T72 317",
  120477: "25 395Q26 405 26 408T29 416T35 423T48 431H145V481L146 532Q154 547 161 550T184 554H189Q218 554 227 534Q229 529 229 480V431H405Q406 430 411 427T418 422T422 416T426 407T427 393Q427 387 427 382T424 374T421 368T417 363T413 360T408 358L405 356L317 355H229V249Q229 237 229 214T228 179Q228 126 241 98T295 70Q354 70 365 149Q366 167 375 174Q383 182 407 182H415Q438 182 446 166Q448 161 448 148Q448 84 398 39T282 -6Q226 -6 189 29T146 128Q145 134 145 247V355H96H72Q45 355 35 362T25 395",
  120478: "4 393Q4 416 15 423T52 431H90Q141 431 151 429T168 417Q171 412 173 409V254L174 100Q182 70 244 70Q320 70 344 119Q349 130 350 144T351 248V355H320L289 356Q266 363 266 393Q266 408 270 415T289 431H351H386Q409 431 418 428T433 411Q435 406 435 241V76H498Q512 67 516 60T520 38Q520 9 498 1H436H394Q372 1 364 5T351 26L342 21Q293 -5 227 -5Q118 -5 96 67Q91 82 90 101T89 227V355H58L27 356Q4 363 4 393",
  120479: "24 392Q24 417 36 424T79 432Q85 432 103 432T132 431H215Q229 422 233 415T237 393Q237 355 198 355H193H172L262 77L352 355H331H323Q288 355 288 393Q288 409 291 415T310 431H478Q491 423 495 416T500 393Q500 364 478 356L452 355H426L374 190Q320 24 318 20Q307 -4 273 -4H262H251Q217 -4 206 20Q204 24 150 190L98 355H72L47 356Q24 363 24 392",
  120480: "54 355Q16 355 16 388V393Q16 423 37 430Q41 431 125 431H162Q206 431 218 425T230 393Q230 366 212 358Q206 355 174 355Q141 355 141 354L150 296Q181 110 181 89V84Q182 85 183 96Q185 118 199 173T218 237Q223 247 245 259H264H268Q294 259 309 240Q315 229 329 174T343 92Q343 84 344 84V86Q344 88 344 91T345 97Q347 125 356 187T374 301T383 354Q383 355 350 355H333Q314 355 304 362T294 393Q294 420 312 428Q318 431 401 431H440Q485 431 496 425T508 393Q508 382 508 377T498 363T470 355L455 354Q455 353 441 271T413 104T396 16Q384 -4 355 -4H351Q315 -4 305 9T280 79Q278 90 276 96Q265 149 265 169Q265 176 264 169Q263 166 263 162Q261 130 248 79T230 18Q220 -4 183 -4H175L151 -3Q134 5 127 17L112 102Q97 188 83 270T69 354Q62 355 54 355",
  120481: "35 393Q35 417 46 424T89 432Q95 432 112 432T141 431H223Q238 422 241 415T244 393Q244 389 244 383T237 367T216 355Q209 355 209 354L234 319Q259 286 260 286L308 354Q308 355 301 355Q285 356 278 365T270 384L271 393Q271 420 289 428Q295 431 376 431H459Q460 430 465 427T472 422T476 416T480 407T481 393Q481 368 470 362T434 355H425H392L344 290Q295 225 295 223Q294 223 309 203T350 149L405 77L439 76H453Q474 76 484 69T495 38Q495 10 473 1H303Q281 9 281 32V38Q281 49 282 54T290 67T313 76Q324 76 324 77L259 173L197 77Q202 76 209 76Q225 75 233 68T241 55T242 38Q242 28 242 24T236 12T221 1H51Q29 9 29 32V38Q29 48 29 51T31 59T38 67T51 76H117L171 149Q224 222 224 223L124 355H90H78Q54 355 45 361T35 393",
  120482: "26 393Q26 417 37 424T80 431H134H217Q232 422 235 416T239 393Q239 379 236 371T226 360T214 356T197 355L179 354V353L188 330Q197 306 209 272T235 201T259 133T271 89V84L274 95Q279 122 298 185T335 300T352 354Q352 355 331 355Q312 355 304 358Q288 368 288 393Q288 408 291 415T310 431H478Q479 430 484 427T491 422T495 416T499 407T500 393Q500 376 493 367T479 357T458 355H452Q426 355 425 353Q420 337 351 124T280 -94Q240 -195 168 -220Q147 -228 125 -228Q89 -228 66 -201T42 -139Q42 -116 56 -102T93 -87Q117 -87 130 -102T144 -135V-138H126Q121 -148 121 -150T130 -152Q182 -147 207 -87Q211 -78 223 -40T236 1Q230 10 102 355H75L49 356Q26 363 26 393",
  120483: "56 1Q40 7 37 14T34 41Q34 59 36 64Q39 67 43 73Q65 95 191 213T341 355H133V334Q133 306 124 297Q116 289 91 289H83Q60 289 51 308Q49 313 49 361L50 409Q59 427 72 430H78Q83 430 92 430T115 430T144 430T179 431T219 431T262 431H450Q452 430 455 428T459 424T463 422T466 419T468 416T469 413T470 409T471 404T472 398T472 391Q472 374 469 368L462 358Q453 349 315 218Q210 122 164 76H391V103Q391 136 400 146Q409 155 433 155Q464 155 473 135Q475 130 475 78V46Q475 24 472 16T453 1H56",
  120488: "296 0Q278 3 164 3Q58 3 49 0H40V62H92Q144 62 144 64Q388 682 397 689Q403 698 434 698Q463 698 471 689Q475 686 538 530T663 218L724 64Q724 62 776 62H828V0H817Q796 3 658 3Q509 3 485 0H472V62H517Q561 62 561 63L517 175H262L240 120Q218 65 217 64Q217 62 261 62H306V0H296ZM390 237L492 238L440 365Q390 491 388 491Q287 239 287 237H390",
  120489: "720 510Q720 476 704 448T665 404T619 377T580 362L564 359L583 356Q602 353 632 342T690 312Q712 292 725 276Q752 235 752 189V183Q752 160 741 125Q698 18 547 2Q543 1 288 0H39V62H147V624H39V686H264H409Q502 686 542 681T624 655Q720 607 720 510ZM563 513Q563 553 548 578T518 611T486 622Q479 624 385 624H293V382H375Q458 383 467 385Q563 405 563 513ZM590 192Q590 307 505 329Q504 330 503 330L398 331H293V62H391H400H444Q496 62 528 75T580 131Q590 155 590 192",
  120490: "425 0L228 3Q63 3 51 0H39V62H147V618H39V680H612V676Q614 670 627 552T643 428V424H581V428Q580 430 576 461T562 524T532 576Q512 596 481 605T426 616T357 618H304V62H439V0H425",
  120491: "901 12Q901 7 892 0H479Q65 0 62 2Q56 6 56 11Q56 14 242 347T433 685Q438 694 450 696Q454 698 480 698H506L523 687Q526 683 711 354T899 17Q901 13 901 12ZM653 137L427 538L202 137L315 136H540L653 137",
  120492: "723 286Q721 284 700 145T677 3V0H39V62H147V618H39V680H660V676Q662 670 675 552T691 428V424H629V428Q629 429 627 448T618 494T601 541Q574 593 527 605T382 618H374H304V384H336Q338 384 347 384T361 384T376 386T392 390T407 397T421 407T432 423Q442 444 443 482V501H505V205H443V224Q442 258 435 278T411 307T380 318T336 322H304V62H375H394Q429 62 449 62T497 66T541 76T577 95T609 126T632 170T651 232Q661 287 661 289H723V286",
  120493: "80 430L92 686H358Q624 686 628 684Q638 679 638 656Q638 640 637 639Q637 638 445 353Q401 288 351 214T277 103L253 67L256 66Q258 66 265 66T279 66T298 66H343Q380 66 406 68T464 81T518 110T557 164T579 250Q583 278 583 298Q583 299 614 299H645V291Q643 281 636 150T627 8V0H353Q79 0 75 2Q64 7 64 31Q64 48 66 52L259 340L451 623Q451 624 384 624Q294 623 259 612Q155 581 143 446Q142 440 142 432V430H80",
  120494: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V388H595V624H487V686H499Q523 683 673 683Q824 683 848 686H860V624H752V62H860V0H848Q824 3 674 3Q523 3 499 0H487V62H595V326H304V62H412V0H400",
  120495: "629 -10T446 -10T164 89T64 340Q64 380 71 420T102 510T163 596T266 662T418 696H438Q488 696 499 695Q582 686 644 655T741 584T796 495T823 409T829 338Q829 188 729 89ZM439 645Q416 645 390 638T333 615T275 564T236 480Q221 423 221 341Q221 272 230 228Q247 144 301 94T447 43T592 93T663 228Q672 272 672 341Q672 645 439 645ZM286 242V446H348V412H545V446H607V242H545V276H348V242H286",
  120496: "397 0Q370 3 218 3Q65 3 38 0H25V62H139V624H25V686H38Q65 683 218 683Q370 683 397 686H410V624H296V62H410V0H397",
  120497: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V338L472 483L634 624H565V686H576Q597 683 728 683Q814 683 829 686H836V624H730L614 524Q507 432 497 422Q496 422 498 418T514 395T553 342T627 241L759 63L805 62H852V0H842Q830 3 701 3Q550 3 526 0H513V62H549Q584 62 584 63Q583 65 486 196T388 328L304 256V62H412V0H400",
  120498: "285 0Q267 3 154 3Q56 3 47 0H40V62H131Q131 63 167 160T244 369T321 578T359 678Q366 698 393 698H404H413Q437 698 446 678Q448 672 560 369T674 62H765V0H754Q733 3 604 3Q453 3 429 0H416V62H461L507 63L355 470Q353 468 279 265L203 63L249 62H294V0H285",
  120499: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H305Q316 679 323 667Q330 653 434 414L546 157L658 414Q766 662 773 674Q778 681 788 686H1052V624H944V62H1052V0H1040Q1016 3 874 3T708 0H696V62H804V341L803 618L786 580Q770 543 735 462T671 315Q540 13 536 9Q528 1 507 1Q485 1 477 9Q472 14 408 162T281 457T217 603Q215 603 215 334V62H323V0H314",
  120500: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H171H265Q288 686 297 686T309 684T315 679Q317 676 500 455T684 233V624H576V686H585Q603 683 718 683T851 686H860V624H752V319Q752 15 750 11Q747 4 742 2T718 0H712Q708 0 706 0T700 0T696 1T693 2T690 4T687 7T684 11T679 16T674 23Q671 27 437 311L215 579V62H323V0H314",
  120501: "54 465L63 674Q63 675 383 675T703 674L712 465Q712 464 681 464H650V467Q650 490 646 516T632 545Q612 550 383 550H283Q169 550 149 548T124 531Q123 530 123 529Q116 506 116 467V464H85Q54 464 54 465ZM160 256V447H222V414H544V447H606V256H544V289H222V256H160ZM57 0L48 222H110V219Q110 147 125 133Q127 130 130 129T160 127T235 126T383 126Q482 126 530 126T604 127T635 129T641 133Q656 146 656 219V222H718L709 0H57",
  120502: "64 339Q64 431 96 502T182 614T295 675T420 696Q469 696 481 695Q620 680 709 589T798 339Q798 173 697 82T432 -10Q262 -10 163 85T64 339ZM625 454Q618 502 600 538T562 593T515 624T469 639T431 642Q331 642 276 563Q232 493 232 353Q232 315 234 285T244 216T267 148T308 94T372 56Q405 46 432 46Q517 46 567 106T627 267Q631 299 631 353Q631 418 625 454",
  120503: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V618H39V680H860V618H752V62H860V0H848Q824 3 674 3Q523 3 499 0H487V62H595V618H304V62H412V0H400",
  120504: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H253Q435 686 470 685T536 678Q585 668 621 648T675 605T705 557T718 514T721 483T718 451T704 409T673 362T616 322T530 293Q500 288 399 287H304V62H412V0H400ZM553 475Q553 554 537 582T459 622Q451 623 373 624H298V343H372Q457 344 480 350Q527 362 540 390T553 475",
  120506: "766 271Q764 266 750 137T735 4V0H407Q74 0 71 4L70 5Q64 9 64 18Q64 24 82 41T213 158L359 288Q360 288 320 336T214 460Q67 633 66 635Q64 638 64 655Q64 679 75 684Q78 686 407 686H735V682Q738 676 751 558T766 434V430H735Q704 430 704 431Q704 434 703 444T696 477T681 520T654 563T613 598Q578 615 527 619T371 624H281L396 489Q506 358 513 351Q517 342 512 334Q503 325 371 208Q338 179 303 147T249 99L231 83L243 81Q258 81 364 81Q382 81 418 81T470 82T513 83T554 88T587 96T619 109T645 129Q689 173 702 260L704 274Q704 275 735 275H766V271",
  120507: "41 425Q41 426 51 545T62 669V675H737V669Q738 665 748 546T758 425V419H696V425Q687 517 669 555T595 607Q578 612 522 613H478V62H631V0H615Q585 3 399 3Q214 3 184 0H168V62H321V613H277H263Q164 613 134 561Q113 527 103 425V419H41V425",
  120508: "64 556Q69 619 114 658T224 697Q271 697 310 677T375 622T417 554T444 484L447 477V479Q456 516 473 551T516 620T582 676T670 697Q735 697 780 656T829 556Q829 539 818 532H772Q761 539 761 548Q761 571 681 571Q664 571 653 570T623 562T587 537T555 490Q536 448 531 410T525 300V210V62H660V0H646L447 3Q257 1 247 0H233V62H368V210V301Q368 373 363 410T338 490Q324 518 307 536T270 561T240 569T212 571Q132 571 132 548Q132 539 121 532H75Q64 538 64 556",
  120509: "609 0Q582 3 415 3T221 0H207V62H342V168L328 169Q193 180 117 241Q64 286 64 343T117 445Q193 506 328 517L342 518V624H207V686H221Q248 683 415 683T609 686H623V624H488V518L502 517Q637 506 713 445Q766 400 766 343T713 241Q637 180 502 169L488 168V62H623V0H609ZM342 219T342 343T340 467Q328 467 304 459Q277 451 261 439T237 409T228 378T226 343Q226 314 229 296T250 259T301 228Q331 219 341 219Q342 219 342 343ZM604 343Q604 365 602 379T591 413T560 446T503 464L489 467Q488 467 488 343T489 219Q499 219 529 228Q554 236 570 248T593 277T602 308T604 343",
  120510: "327 0Q306 3 174 3Q52 3 43 0H33V62H98L162 63L360 333L157 624H48V686H59Q80 683 217 683Q368 683 395 686H408V624H335L393 540L452 458L573 623Q573 624 528 624H483V686H494Q515 683 646 683Q769 683 778 686H787V624H658L575 511Q493 398 493 397L508 376Q522 356 553 312T611 229L727 62H835V0H824Q803 3 667 3Q516 3 489 0H476V62H513L549 63L401 274L247 63Q247 62 292 62H338V0H327",
  120511: "64 515Q64 532 71 536T104 540H139Q200 540 207 538Q225 533 236 521T253 489T260 454T264 414Q264 340 287 296T347 237Q369 226 373 226Q374 226 374 425V624H239V686H253Q280 683 447 683T641 686H655V624H520V226L522 227Q525 228 531 229T552 240T580 261T606 298T624 354Q627 368 628 394T631 440T637 482T654 518T686 538Q693 540 754 540H794Q817 540 823 536T829 515Q829 500 824 495T811 489T796 483T782 461T775 408Q767 212 568 175Q526 168 521 168Q520 168 520 115V62H655V0H641Q614 3 447 3T253 0H239V62H374V168L364 169Q290 178 243 203Q126 261 118 409Q117 443 111 461T98 484T83 489T70 495T64 515",
  120512: "598 645T415 645T232 458Q232 385 275 239T318 26Q318 8 311 4T272 -1Q265 -1 240 -1T196 0H88V3Q86 5 70 108Q52 211 51 212V215H113V212Q123 149 132 133Q136 124 149 122T202 118Q241 118 241 119Q241 132 132 277Q64 378 64 457Q64 564 158 630T403 696Q487 696 543 685T661 638Q722 599 744 549T766 458Q766 434 761 410T749 368T729 327T709 293T684 258T663 229Q632 187 614 160T592 126L589 119Q589 118 628 118Q667 119 680 121T698 133Q702 140 706 160T714 196L717 212V215H779V212Q778 211 760 108Q744 5 742 3V0H634H562Q528 0 520 4T512 26Q512 92 555 238T598 458Q598 645 415 645",
  120513: "56 673Q56 679 65 686H892Q901 679 901 673Q901 668 714 331T521 -15Q518 -18 506 -24H452Q440 -19 436 -15Q431 -8 337 162T150 501L57 669Q57 670 56 672V673ZM528 136L758 553H297Q298 551 414 341L528 136",
  120546: "208 74Q208 50 254 46Q272 46 272 35Q272 34 270 22Q267 8 264 4T251 0Q249 0 239 0T205 1T141 2Q70 2 50 0H42Q35 7 35 11Q37 38 48 46H62Q132 49 164 96Q170 102 345 401T523 704Q530 716 547 716H555H572Q578 707 578 706L606 383Q634 60 636 57Q641 46 701 46Q726 46 726 36Q726 34 723 22Q720 7 718 4T704 0Q701 0 690 0T651 1T578 2Q484 2 455 0H443Q437 6 437 9T439 27Q443 40 445 43L449 46H469Q523 49 533 63L521 213H283L249 155Q208 86 208 74ZM516 260Q516 271 504 416T490 562L463 519Q447 492 400 412L310 260L413 259Q516 259 516 260",
  120547: "231 637Q204 637 199 638T194 649Q194 676 205 682Q206 683 335 683Q594 683 608 681Q671 671 713 636T756 544Q756 480 698 429T565 360L555 357Q619 348 660 311T702 219Q702 146 630 78T453 1Q446 0 242 0Q42 0 39 2Q35 5 35 10Q35 17 37 24Q42 43 47 45Q51 46 62 46H68Q95 46 128 49Q142 52 147 61Q150 65 219 339T288 628Q288 635 231 637ZM649 544Q649 574 634 600T585 634Q578 636 493 637Q473 637 451 637T416 636H403Q388 635 384 626Q382 622 352 506Q352 503 351 500L320 374H401Q482 374 494 376Q554 386 601 434T649 544ZM595 229Q595 273 572 302T512 336Q506 337 429 337Q311 337 310 336Q310 334 293 263T258 122L240 52Q240 48 252 48T333 46Q422 46 429 47Q491 54 543 105T595 229",
  120548: "49 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 661Q197 674 203 680H714Q721 676 721 669Q721 664 708 557T694 447Q692 440 674 440H662Q655 445 655 454Q655 455 658 480T661 534Q661 572 652 592Q638 619 603 626T501 634H471Q398 633 393 630Q389 628 386 622Q385 619 315 341T245 60Q245 46 333 46H345Q366 46 366 35Q366 33 363 21T358 6Q356 1 339 1Q334 1 292 1T187 2Q122 2 88 2T49 1",
  120549: "574 715L582 716Q589 716 595 716Q612 716 616 714Q621 712 621 709Q622 707 705 359T788 8Q786 5 785 3L781 0H416Q52 0 50 2T48 6Q48 9 305 358T567 711Q572 712 574 715ZM599 346L538 602L442 474Q347 345 252 217T157 87T409 86T661 88L654 120Q646 151 629 220T599 346",
  120550: "492 213Q472 213 472 226Q472 230 477 250T482 285Q482 316 461 323T364 330H312Q311 328 277 192T243 52Q243 48 254 48T334 46Q428 46 458 48T518 61Q567 77 599 117T670 248Q680 270 683 272Q690 274 698 274Q718 274 718 261Q613 7 608 2Q605 0 322 0H133Q31 0 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 659Q197 676 203 680H757Q764 676 764 669Q764 664 751 557T737 447Q735 440 717 440H705Q698 445 698 453L701 476Q704 500 704 528Q704 558 697 578T678 609T643 625T596 632T532 634H485Q397 633 392 631Q388 629 386 622Q385 619 355 499T324 377Q347 376 372 376H398Q464 376 489 391T534 472Q538 488 540 490T557 493Q562 493 565 493T570 492T572 491T574 487T577 483L544 351Q511 218 508 216Q505 213 492 213",
  120551: "58 8Q58 23 64 35Q64 36 329 334T596 635L586 637Q575 637 512 637H500H476Q442 637 420 635T365 624T311 598T266 548T228 469Q227 466 226 463T224 458T223 453T222 450L221 448Q218 443 202 443Q185 443 182 453L214 561Q228 606 241 651Q249 679 253 681Q256 683 487 683H718Q723 678 723 675Q723 673 717 649Q189 54 188 52L185 49H274Q369 50 377 51Q452 60 500 100T579 247Q587 272 590 277T603 282H607Q628 282 628 271Q547 5 541 2Q538 0 300 0H124Q58 0 58 8",
  120552: "228 637Q194 637 192 641Q191 643 191 649Q191 673 202 682Q204 683 219 683Q260 681 355 681Q389 681 418 681T463 682T483 682Q499 682 499 672Q499 670 497 658Q492 641 487 638H485Q483 638 480 638T473 638T464 637T455 637Q416 636 405 634T387 623Q384 619 355 500Q348 474 340 442T328 395L324 380Q324 378 469 378H614L615 381Q615 384 646 504Q674 619 674 627T617 637Q594 637 587 639T580 648Q580 650 582 660Q586 677 588 679T604 682Q609 682 646 681T740 680Q802 680 835 681T871 682Q888 682 888 672Q888 645 876 638H874Q872 638 869 638T862 638T853 637T844 637Q805 636 794 634T776 623Q773 618 704 340T634 58Q634 51 638 51Q646 48 692 46H723Q729 38 729 37T726 19Q722 6 716 0H701Q664 2 567 2Q533 2 504 2T458 2T437 1Q420 1 420 10Q420 15 423 24Q428 43 433 45Q437 46 448 46H454Q481 46 514 49Q520 50 522 50T528 55T534 64T540 82T547 110T558 153Q565 181 569 198Q602 330 602 331T457 332H312L279 197Q245 63 245 58Q245 51 253 49T303 46H334Q340 38 340 37T337 19Q333 6 327 0H312Q275 2 178 2Q144 2 115 2T69 2T48 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Q285 635 228 637",
  120553: "740 435Q740 320 676 213T511 42T304 -22Q207 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435ZM640 466Q640 523 625 565T583 628T532 658T479 668Q370 668 273 559T151 255Q150 245 150 213Q150 156 165 116T207 55T259 26T313 17Q385 17 451 63T561 184Q590 234 615 312T640 466ZM510 276Q510 278 512 288L515 298Q515 299 384 299H253L250 285Q246 271 244 268T231 265H227Q216 265 214 266T207 274Q207 278 223 345T244 416Q247 419 260 419H263Q280 419 280 408Q280 406 278 396L275 386Q275 385 406 385H537L540 399Q544 413 546 416T559 419H563Q574 419 576 418T583 410Q583 403 566 339Q549 271 544 267Q542 265 538 265H530H527Q510 265 510 276",
  120554: "43 1Q26 1 26 10Q26 12 29 24Q34 43 39 45Q42 46 54 46H60Q120 46 136 53Q137 53 138 54Q143 56 149 77T198 273Q210 318 216 344Q286 624 286 626Q284 630 284 631Q274 637 213 637H193Q184 643 189 662Q193 677 195 680T209 683H213Q285 681 359 681Q481 681 487 683H497Q504 676 504 672T501 655T494 639Q491 637 471 637Q440 637 407 634Q393 631 388 623Q381 609 337 432Q326 385 315 341Q245 65 245 59Q245 52 255 50T307 46H339Q345 38 345 37T342 19Q338 6 332 0H316Q279 2 179 2Q143 2 113 2T65 2T43 1",
  120555: "285 628Q285 635 228 637Q205 637 198 638T191 647Q191 649 193 661Q199 681 203 682Q205 683 214 683H219Q260 681 355 681Q389 681 418 681T463 682T483 682Q500 682 500 674Q500 669 497 660Q496 658 496 654T495 648T493 644T490 641T486 639T479 638T470 637T456 637Q416 636 405 634T387 623L306 305Q307 305 490 449T678 597Q692 611 692 620Q692 635 667 637Q651 637 651 648Q651 650 654 662T659 677Q662 682 676 682Q680 682 711 681T791 680Q814 680 839 681T869 682Q889 682 889 672Q889 650 881 642Q878 637 862 637Q787 632 726 586Q710 576 656 534T556 455L509 418L518 396Q527 374 546 329T581 244Q656 67 661 61Q663 59 666 57Q680 47 717 46H738Q744 38 744 37T741 19Q737 6 731 0H720Q680 3 625 3Q503 3 488 0H478Q472 6 472 9T474 27Q478 40 480 43T491 46H494Q544 46 544 71Q544 75 517 141T485 216L427 354L359 301L291 248L268 155Q245 63 245 58Q245 51 253 49T303 46H334Q340 37 340 35Q340 19 333 5Q328 0 317 0Q314 0 280 1T180 2Q118 2 85 2T49 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628",
  120556: "135 2Q114 2 90 2T60 1Q35 1 35 11Q35 28 42 40Q45 46 55 46Q119 46 151 94Q153 97 325 402T498 709Q505 716 526 716Q543 716 549 710Q550 709 560 548T580 224T591 57Q594 52 595 52Q603 47 638 46H663Q670 39 670 35Q669 12 657 0H644Q613 2 530 2Q497 2 469 2T424 2T405 1Q388 1 388 10Q388 15 391 24Q392 27 393 32T395 38T397 41T401 44T406 45T415 46Q473 46 487 64L472 306Q468 365 465 426T459 518L457 550Q456 550 328 322T198 88Q196 80 196 77Q196 49 243 46Q261 46 261 35Q261 34 259 22Q256 7 254 4T240 0Q237 0 211 1T135 2",
  120557: "289 629Q289 635 232 637Q208 637 201 638T194 648Q194 649 196 659Q197 662 198 666T199 671T201 676T203 679T207 681T212 683T220 683T232 684Q238 684 262 684T307 683Q386 683 398 683T414 678Q415 674 451 396L487 117L510 154Q534 190 574 254T662 394Q837 673 839 675Q840 676 842 678T846 681L852 683H948Q965 683 988 683T1017 684Q1051 684 1051 673Q1051 668 1048 656T1045 643Q1041 637 1008 637Q968 636 957 634T939 623Q936 618 867 340T797 59Q797 55 798 54T805 50T822 48T855 46H886Q892 37 892 35Q892 19 885 5Q880 0 869 0Q864 0 828 1T736 2Q675 2 644 2T609 1Q592 1 592 11Q592 13 594 25Q598 41 602 43T625 46Q652 46 685 49Q699 52 704 61Q706 65 742 207T813 490T848 631L654 322Q458 10 453 5Q451 4 449 3Q444 0 433 0Q418 0 415 7Q413 11 374 317L335 624L267 354Q200 88 200 79Q206 46 272 46H282Q288 41 289 37T286 19Q282 3 278 1Q274 0 267 0Q265 0 255 0T221 1T157 2Q127 2 95 1T58 0Q43 0 39 2T35 11Q35 13 38 25T43 40Q45 46 65 46Q135 46 154 86Q158 92 223 354T289 629",
  120558: "234 637Q231 637 226 637Q201 637 196 638T191 649Q191 676 202 682Q204 683 299 683Q376 683 387 683T401 677Q612 181 616 168L670 381Q723 592 723 606Q723 633 659 637Q635 637 635 648Q635 650 637 660Q641 676 643 679T653 683Q656 683 684 682T767 680Q817 680 843 681T873 682Q888 682 888 672Q888 650 880 642Q878 637 858 637Q787 633 769 597L620 7Q618 0 599 0Q585 0 582 2Q579 5 453 305L326 604L261 344Q196 88 196 79Q201 46 268 46H278Q284 41 284 38T282 19Q278 6 272 0H259Q228 2 151 2Q123 2 100 2T63 2T46 1Q31 1 31 10Q31 14 34 26T39 40Q41 46 62 46Q130 49 150 85Q154 91 221 362L289 634Q287 635 234 637",
  120559: "222 668Q222 670 229 677H654Q677 677 705 677T740 678Q764 678 770 676T777 667Q777 662 764 594Q761 579 757 559T751 528L749 519Q747 512 729 512H717Q710 519 710 525Q712 532 715 559T719 591Q718 595 711 595Q682 598 486 598Q252 598 246 592Q239 587 228 552L216 517Q214 512 197 512H185Q178 517 178 522Q178 524 198 591T222 668ZM227 262Q218 262 215 262T209 266L207 270L227 356Q247 435 250 439Q253 443 260 443H267H280Q287 438 287 433Q287 430 285 420T280 402L278 393Q278 392 431 392H585L590 415Q595 436 598 439T612 443H628Q635 438 635 433Q635 431 615 351T594 268Q592 262 575 262H572Q556 262 556 272Q556 280 560 293L565 313H258L252 292Q248 271 245 267T230 262H227ZM60 0Q53 4 53 11Q53 14 68 89T84 169Q88 176 98 176H104H116Q123 169 123 163Q122 160 117 127T112 88Q112 80 243 80H351H454Q554 80 574 81T597 88V89Q603 100 610 121T622 157T630 174Q633 176 646 176H658Q665 171 665 166Q665 164 643 89T618 7Q616 2 607 1T548 0H335H60",
  120560: "740 435Q740 320 676 213T511 42T304 -22Q207 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435ZM637 476Q637 565 591 615T476 665Q396 665 322 605Q242 542 200 428T157 216Q157 126 200 73T314 19Q404 19 485 98T608 313Q637 408 637 476",
  120561: "48 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 661Q197 674 203 680H541Q621 680 709 680T812 681Q841 681 855 681T877 679T886 676T887 670Q887 663 885 656Q880 637 875 635Q871 634 860 634H854Q827 634 794 631Q780 628 775 619Q773 614 704 338T634 58Q634 51 638 51Q646 48 692 46H723Q729 38 729 37T726 19Q722 6 716 0H701Q664 2 567 2Q533 2 504 2T458 2T437 1Q420 1 420 10Q420 15 423 24Q428 43 433 45Q437 46 448 46H454Q481 46 514 49Q528 52 533 61Q536 67 572 209T642 491T678 632Q678 634 533 634H388Q387 631 316 347T245 59Q245 55 246 54T253 50T270 48T303 46H334Q340 38 340 37T337 19Q333 6 327 0H312Q275 2 178 2Q144 2 115 2T69 2T48 1",
  120562: "287 628Q287 635 230 637Q206 637 199 638T192 648Q192 649 194 659Q200 679 203 681T397 683Q587 682 600 680Q664 669 707 631T751 530Q751 453 685 389Q616 321 507 303Q500 302 402 301H307L277 182Q247 66 247 59Q247 55 248 54T255 50T272 48T305 46H336Q342 37 342 35Q342 19 335 5Q330 0 319 0Q316 0 282 1T182 2Q120 2 87 2T51 1Q33 1 33 11Q33 13 36 25Q40 41 44 43T67 46Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628ZM645 554Q645 567 643 575T634 597T609 619T560 635Q553 636 480 637Q463 637 445 637T416 636T404 636Q391 635 386 627Q384 621 367 550T332 412T314 344Q314 342 395 342H407H430Q542 342 590 392Q617 419 631 471T645 554",
  120564: "65 0Q58 4 58 11Q58 16 114 67Q173 119 222 164L377 304Q378 305 340 386T261 552T218 644Q217 648 219 660Q224 678 228 681Q231 683 515 683H799Q804 678 806 674Q806 667 793 559T778 448Q774 443 759 443Q747 443 743 445T739 456Q739 458 741 477T743 516Q743 552 734 574T710 609T663 627T596 635T502 637Q480 637 469 637H339Q344 627 411 486T478 341V339Q477 337 477 336L457 318Q437 300 398 265T322 196L168 57Q167 56 188 56T258 56H359Q426 56 463 58T537 69T596 97T639 146T680 225Q686 243 689 246T702 250H705Q726 250 726 239Q726 238 683 123T639 5Q637 1 610 1Q577 0 348 0H65",
  120565: "40 437Q21 437 21 445Q21 450 37 501T71 602L88 651Q93 669 101 677H569H659Q691 677 697 676T704 667Q704 661 687 553T668 444Q668 437 649 437Q640 437 637 437T631 442L629 445Q629 451 635 490T641 551Q641 586 628 604T573 629Q568 630 515 631Q469 631 457 630T439 622Q438 621 368 343T298 60Q298 48 386 46Q418 46 427 45T436 36Q436 31 433 22Q429 4 424 1L422 0Q419 0 415 0Q410 0 363 1T228 2Q99 2 64 0H49Q43 6 43 9T45 27Q49 40 55 46H83H94Q174 46 189 55Q190 56 191 56Q196 59 201 76T241 233Q258 301 269 344Q339 619 339 625Q339 630 310 630H279Q212 630 191 624Q146 614 121 583T67 467Q60 445 57 441T43 437H40",
  120566: "45 535Q34 535 31 536T28 544Q28 554 39 578T70 631T126 683T206 705Q230 705 251 698T295 671T330 612T344 514Q344 477 342 473V472Q343 472 347 480T361 509T380 547Q471 704 596 704Q615 704 625 702Q659 692 679 663T700 595Q700 565 696 552T687 537T670 535Q656 535 653 536T649 543Q649 544 649 550T650 562Q650 589 629 605T575 621Q502 621 448 547T365 361Q290 70 290 60Q290 46 379 46H404Q410 40 410 39T408 19Q404 6 398 0H381Q340 2 225 2Q184 2 149 2T94 2T69 1Q61 1 58 1T53 4T51 10Q51 11 53 23Q54 25 55 30T56 36T58 40T60 43T62 44T67 46T73 46T82 46H89Q144 46 163 49T190 62L198 93Q206 124 217 169T241 262T262 350T274 404Q281 445 281 486V494Q281 621 185 621Q147 621 116 601T74 550Q71 539 66 537T45 535",
  120567: "356 624Q356 637 267 637H243Q237 642 237 645T239 664Q243 677 249 683H264Q342 681 429 681Q565 681 571 683H583Q589 677 589 674T587 656Q582 641 578 637H540Q516 637 504 637T479 633T463 630T454 623T448 613T443 597T438 576Q436 566 434 556T430 539L428 533Q442 533 472 526T543 502T613 451T642 373Q642 301 567 241T386 158L336 150Q332 150 331 146Q310 66 310 60Q310 46 399 46H424Q430 40 430 39T428 19Q424 6 418 0H401Q360 2 247 2Q207 2 173 2T119 2T95 1Q87 1 84 1T79 4T77 10Q77 11 79 23Q80 25 81 30T82 36T84 40T86 43T88 44T93 46T99 46T108 46H115Q170 46 189 49T216 62Q220 74 228 107L239 150L223 152Q139 164 82 205T24 311Q24 396 125 462Q207 517 335 533L346 578Q356 619 356 624ZM130 291Q130 203 241 188H249Q249 190 287 342L325 495H324Q313 495 291 491T229 466T168 414Q130 357 130 291ZM536 393Q536 440 507 463T418 496L341 187L351 189Q443 201 487 255Q536 314 536 393",
  120568: "42 0H40Q26 0 26 11Q26 15 29 27Q33 41 36 43T55 46Q141 49 190 98Q200 108 306 224T411 342Q302 620 297 625Q288 636 234 637H206Q200 643 200 645T202 664Q206 677 212 683H226Q260 681 347 681Q380 681 408 681T453 682T473 682Q490 682 490 671Q490 670 488 658Q484 643 481 640T465 637Q434 634 411 620L488 426L541 485Q646 598 646 610Q646 628 622 635Q617 635 609 637Q594 637 594 648Q594 650 596 664Q600 677 606 683H618Q619 683 643 683T697 681T738 680Q828 680 837 683H845Q852 676 852 672Q850 647 840 637H824Q790 636 763 628T722 611T698 593L687 584Q687 585 592 480L505 384Q505 383 536 304T601 142T638 56Q648 47 699 46Q734 46 734 37Q734 35 732 23Q728 7 725 4T711 1Q708 1 678 1T589 2Q528 2 496 2T461 1Q444 1 444 10Q444 11 446 25Q448 35 450 39T455 44T464 46T480 47T506 54Q523 62 523 64Q522 64 476 181L429 299Q241 95 236 84Q232 76 232 72Q232 53 261 47Q262 47 267 47T273 46Q276 46 277 46T280 45T283 42T284 35Q284 26 282 19Q279 6 276 4T261 1Q258 1 243 1T201 2T142 2Q64 2 42 0",
  120569: "216 151Q48 174 48 329Q48 361 56 403T65 458Q65 482 58 494T43 507T28 510T21 520Q21 528 23 534T29 544L32 546H72H94Q110 546 119 544T139 536T154 514T159 476V465Q159 445 149 399T138 314Q142 229 197 201Q223 187 226 190L233 218Q240 246 253 300T280 407Q333 619 333 625Q333 637 244 637H220Q214 642 214 645T216 664Q220 677 226 683H241Q321 681 405 681Q543 681 549 683H560Q566 677 566 674T564 656Q559 641 555 637H517Q448 636 436 628Q429 623 423 600T373 404L320 192Q370 201 419 248Q451 281 469 317T500 400T518 457Q529 486 542 505T569 532T594 543T621 546H644H669Q692 546 692 536Q691 509 676 509Q623 509 593 399Q587 377 579 355T552 301T509 244T446 195T359 159Q324 151 314 151Q311 151 310 150T298 106T287 60Q287 46 376 46H401Q407 40 407 39T405 19Q401 6 395 0H378Q337 2 224 2Q184 2 150 2T96 2T72 1Q64 1 61 1T56 4T54 10Q54 11 56 23Q57 25 58 30T59 36T61 40T63 43T65 44T70 46T76 46T85 46H92Q147 46 166 49T193 62L204 106Q216 149 216 151",
  120570: "125 84Q127 78 194 76H243V78Q243 122 208 215T165 350Q164 359 162 389Q162 522 272 610Q328 656 396 680T525 704Q628 704 698 661Q734 637 755 601T781 544T786 504Q786 439 747 374T635 226T537 109Q518 81 518 77Q537 76 557 76Q608 76 620 78T640 92Q646 100 656 119T673 155T683 172Q690 173 698 173Q718 173 718 162Q718 161 681 82T642 2Q639 0 550 0H461Q455 5 455 9T458 28Q472 78 510 149T584 276T648 402T677 525Q677 594 636 631T530 668Q476 668 423 641T335 568Q284 499 271 400Q270 388 270 348Q270 298 277 228T285 115Q285 82 280 49T271 6Q269 1 258 1T175 0H87Q83 3 80 7V18Q80 22 82 98Q84 156 85 163T91 172Q94 173 104 173T119 172Q124 169 124 126Q125 104 125 84",
  120572: "34 156Q34 270 120 356T309 442Q379 442 421 402T478 304Q484 275 485 237V208Q534 282 560 374Q564 388 566 390T582 393Q603 393 603 385Q603 376 594 346T558 261T497 161L486 147L487 123Q489 67 495 47T514 26Q528 28 540 37T557 60Q559 67 562 68T577 70Q597 70 597 62Q597 56 591 43Q579 19 556 5T512 -10H505Q438 -10 414 62L411 69L400 61Q390 53 370 41T325 18T267 -2T203 -11Q124 -11 79 39T34 156ZM208 26Q257 26 306 47T379 90L403 112Q401 255 396 290Q382 405 304 405Q235 405 183 332Q156 292 139 224T121 120Q121 71 146 49T208 26",
  120573: "29 -194Q23 -188 23 -186Q23 -183 102 134T186 465Q208 533 243 584T309 658Q365 705 429 705H431Q493 705 533 667T573 570Q573 465 469 396L482 383Q533 332 533 252Q533 139 448 65T257 -10Q227 -10 203 -2T165 17T143 40T131 59T126 65L62 -188Q60 -194 42 -194H29ZM353 431Q392 431 427 419L432 422Q436 426 439 429T449 439T461 453T472 471T484 495T493 524T501 560Q503 569 503 593Q503 611 502 616Q487 667 426 667Q384 667 347 643T286 582T247 514T224 455Q219 439 186 308T152 168Q151 163 151 147Q151 99 173 68Q204 26 260 26Q302 26 349 51T425 137Q441 171 449 214T457 279Q457 337 422 372Q380 358 347 358H337Q258 358 258 389Q258 396 261 403Q275 431 353 431",
  120574: "31 249Q11 249 11 258Q11 275 26 304T66 365T129 418T206 441Q233 441 239 440Q287 429 318 386T371 255Q385 195 385 170Q385 166 386 166L398 193Q418 244 443 300T486 391T508 430Q510 431 524 431H537Q543 425 543 422Q543 418 522 378T463 251T391 71Q385 55 378 6T357 -100Q341 -165 330 -190T303 -216Q286 -216 286 -188Q286 -138 340 32L346 51L347 69Q348 79 348 100Q348 257 291 317Q251 355 196 355Q148 355 108 329T51 260Q49 251 47 251Q45 249 31 249",
  120575: "195 609Q195 656 227 686T302 717Q319 716 351 709T407 697T433 690Q451 682 451 662Q451 644 438 628T403 612Q382 612 348 641T288 671T249 657T235 628Q235 584 334 463Q401 379 401 292Q401 169 340 80T205 -10H198Q127 -10 83 36T36 153Q36 286 151 382Q191 413 252 434Q252 435 245 449T230 481T214 521T201 566T195 609ZM112 130Q112 83 136 55T204 27Q233 27 256 51T291 111T309 178T316 232Q316 267 309 298T295 344T269 400L259 396Q215 381 183 342T137 256T118 179T112 130",
  120576: "190 -22Q124 -22 76 11T27 107Q27 174 97 232L107 239L99 248Q76 273 76 304Q76 364 144 408T290 452H302Q360 452 405 421Q428 405 428 392Q428 381 417 369T391 356Q382 356 371 365T338 383T283 392Q217 392 167 368T116 308Q116 289 133 272Q142 263 145 262T157 264Q188 278 238 278H243Q308 278 308 247Q308 206 223 206Q177 206 142 219L132 212Q68 169 68 112Q68 39 201 39Q253 39 286 49T328 72T345 94T362 105Q376 103 376 88Q376 79 365 62T334 26T275 -8T190 -22",
  120577: "296 643Q298 704 324 704Q342 704 342 687Q342 682 339 664T336 633Q336 623 337 618T338 611Q339 612 341 612Q343 614 354 616T374 618L384 619H394Q471 619 471 586Q467 548 386 546H372Q338 546 320 564L311 558Q235 506 175 398T114 190Q114 171 116 155T125 127T137 104T153 86T171 72T192 61T213 53T235 46T256 39L322 16Q389 -10 389 -80Q389 -119 364 -154T300 -202Q292 -204 274 -204Q247 -204 225 -196Q210 -192 193 -182T172 -167Q167 -159 173 -148Q180 -139 191 -139Q195 -139 221 -153T283 -168Q298 -166 310 -152T322 -117Q322 -91 302 -75T250 -51T183 -29T116 4T65 62T44 160Q44 287 121 410T293 590L302 595Q296 613 296 643",
  120578: "21 287Q22 290 23 295T28 317T38 348T53 381T73 411T99 433T132 442Q156 442 175 435T205 417T221 395T229 376L231 369Q231 367 232 367L243 378Q304 442 382 442Q436 442 469 415T503 336V326Q503 302 439 53Q381 -182 377 -189Q364 -216 332 -216Q319 -216 310 -208T299 -186Q299 -177 358 57L420 307Q423 322 423 345Q423 404 379 404H374Q288 404 229 303L222 291L189 157Q156 26 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 114 189T154 366Q154 405 128 405Q107 405 92 377T68 316T57 280Q55 278 41 278H27Q21 284 21 287",
  120579: "35 200Q35 302 74 415T180 610T319 704Q320 704 327 704T339 705Q393 701 423 656Q462 596 462 495Q462 380 417 261T302 66T168 -10H161Q125 -10 99 10T60 63T41 130T35 200ZM383 566Q383 668 330 668Q294 668 260 623T204 521T170 421T157 371Q206 370 254 370L351 371Q352 372 359 404T375 484T383 566ZM113 132Q113 26 166 26Q181 26 198 36T239 74T287 161T335 307L340 324H145Q145 321 136 286T120 208T113 132",
  120580: "139 -10Q111 -10 92 0T64 25T52 52T48 74Q48 89 55 109T85 199T135 375L137 384Q139 394 140 397T145 409T151 422T160 431T173 439T190 442Q202 442 213 435T225 410Q225 404 214 358T181 238T137 107Q126 74 126 54Q126 43 126 39T130 31T142 27H147Q206 27 255 78Q272 98 281 114T290 138T295 149T313 153Q321 153 324 153T329 152T332 149T332 143Q332 106 276 48T145 -10H139",
  120581: "83 -11Q70 -11 62 -4T51 8T49 17Q49 30 96 217T147 414Q160 442 193 442Q205 441 213 435T223 422T225 412Q225 401 208 337L192 270Q193 269 208 277T235 292Q252 304 306 349T396 412T467 431Q489 431 500 420T512 391Q512 366 494 347T449 327Q430 327 418 338T405 368Q405 370 407 380L397 375Q368 360 315 315L253 266L240 257H245Q262 257 300 251T366 230Q422 203 422 150Q422 140 417 114T411 67Q411 26 437 26Q484 26 513 137Q516 149 519 151T535 153Q554 153 554 144Q554 121 527 64T457 -7Q447 -10 431 -10Q386 -10 360 17T333 90Q333 108 336 122T339 146Q339 170 320 186T271 209T222 218T185 221H180L155 122Q129 22 126 16Q113 -11 83 -11",
  120582: "166 673Q166 685 183 694H202Q292 691 316 644Q322 629 373 486T474 207T524 67Q531 47 537 34T546 15T551 6T555 2T556 -2T550 -11H482Q457 3 450 18T399 152L354 277L340 262Q327 246 293 207T236 141Q211 112 174 69Q123 9 111 -1T83 -12Q47 -12 47 20Q47 37 61 52T199 187Q229 216 266 252T321 306L338 322Q338 323 288 462T234 612Q214 657 183 657Q166 657 166 673",
  120583: "58 -216Q44 -216 34 -208T23 -186Q23 -176 96 116T173 414Q186 442 219 442Q231 441 239 435T249 423T251 413Q251 401 220 279T187 142Q185 131 185 107V99Q185 26 252 26Q261 26 270 27T287 31T302 38T315 45T327 55T338 65T348 77T356 88T365 100L372 110L408 253Q444 395 448 404Q461 431 491 431Q504 431 512 424T523 412T525 402L449 84Q448 79 448 68Q448 43 455 35T476 26Q485 27 496 35Q517 55 537 131Q543 151 547 152Q549 153 557 153H561Q580 153 580 144Q580 138 575 117T555 63T523 13Q510 0 491 -8Q483 -10 467 -10Q446 -10 429 -4T402 11T385 29T376 44T374 51L368 45Q362 39 350 30T324 12T288 -4T246 -11Q199 -11 153 12L129 -85Q108 -167 104 -180T92 -202Q76 -216 58 -216",
  120584: "74 431Q75 431 146 436T219 442Q231 442 231 434Q231 428 185 241L137 51H140L150 55Q161 59 177 67T214 86T261 119T312 165Q410 264 445 394Q458 442 496 442Q509 442 519 434T530 411Q530 390 516 352T469 262T388 162T267 70T106 5Q81 -2 71 -2Q66 -2 59 -1T51 1Q45 5 45 11Q45 13 88 188L132 364Q133 377 125 380T86 385H65Q59 391 59 393T61 412Q65 431 74 431",
  120585: "268 632Q268 704 296 704Q314 704 314 687Q314 682 311 664T308 635T309 620V616H315Q342 619 360 619Q443 619 443 586Q439 548 358 546H344Q326 546 317 549T290 566Q257 550 226 505T195 405Q195 381 201 364T211 342T218 337Q266 347 298 347Q375 347 375 314Q374 297 359 288T327 277T280 275Q234 275 208 283L195 286Q149 260 119 214T88 130Q88 116 90 108Q101 79 129 63T229 20Q238 17 243 15Q337 -21 354 -33Q383 -53 383 -94Q383 -137 351 -171T273 -205Q240 -205 202 -190T158 -167Q156 -163 156 -159Q156 -151 161 -146T176 -140Q182 -140 189 -143Q232 -168 274 -168Q286 -168 292 -165Q313 -151 313 -129Q313 -112 301 -104T232 -75Q214 -68 204 -64Q198 -62 171 -52T136 -38T107 -24T78 -8T56 12T36 37T26 66T21 103Q21 149 55 206T145 301L154 307L148 313Q141 319 136 323T124 338T111 358T103 382T99 413Q99 471 143 524T259 602L271 607Q268 618 268 632",
  120586: "201 -11Q126 -11 80 38T34 156Q34 221 64 279T146 380Q222 441 301 441Q333 441 341 440Q354 437 367 433T402 417T438 387T464 338T476 268Q476 161 390 75T201 -11ZM121 120Q121 70 147 48T206 26Q250 26 289 58T351 142Q360 163 374 216T388 308Q388 352 370 375Q346 405 306 405Q243 405 195 347Q158 303 140 230T121 120",
  120587: "132 -11Q98 -11 98 22V33L111 61Q186 219 220 334L228 358H196Q158 358 142 355T103 336Q92 329 81 318T62 297T53 285Q51 284 38 284Q19 284 19 294Q19 300 38 329T93 391T164 429Q171 431 389 431Q549 431 553 430Q573 423 573 402Q573 371 541 360Q535 358 472 358H408L405 341Q393 269 393 222Q393 170 402 129T421 65T431 37Q431 20 417 5T381 -10Q370 -10 363 -7T347 17T331 77Q330 86 330 121Q330 170 339 226T357 318T367 358H269L268 354Q268 351 249 275T206 114T175 17Q164 -11 132 -11",
  120588: "58 -216Q25 -216 23 -186Q23 -176 73 26T127 234Q143 289 182 341Q252 427 341 441Q343 441 349 441T359 442Q432 442 471 394T510 276Q510 219 486 165T425 74T345 13T266 -10H255H248Q197 -10 165 35L160 41L133 -71Q108 -168 104 -181T92 -202Q76 -216 58 -216ZM424 322Q424 359 407 382T357 405Q322 405 287 376T231 300Q217 269 193 170L176 102Q193 26 260 26Q298 26 334 62Q367 92 389 158T418 266T424 322",
  120589: "31 207Q31 306 115 374T302 442Q341 442 373 430T405 400Q405 392 399 383T379 374Q373 375 348 390T296 405Q222 405 160 357T98 249Q98 232 103 218T112 195T132 175T154 159T186 141T219 122Q234 114 255 102T286 85T299 78L302 74Q306 71 308 69T315 61T322 51T328 40T332 25T334 8Q334 -31 305 -69T224 -107Q194 -107 163 -92Q156 -88 156 -80Q156 -73 162 -67T178 -61Q186 -61 190 -63Q209 -71 224 -71Q244 -71 253 -59T263 -30Q263 -25 263 -21T260 -12T255 -4T248 3T239 9T227 17T213 25T195 34T174 46Q170 48 150 58T122 74T97 90T70 112T51 137T36 169T31 207",
  120590: "184 -11Q116 -11 74 34T31 147Q31 247 104 333T274 430Q275 431 414 431H552Q553 430 555 429T559 427T562 425T565 422T567 420T569 416T570 412T571 407T572 401Q572 357 507 357Q500 357 490 357T476 358H416L421 348Q439 310 439 263Q439 153 359 71T184 -11ZM361 278Q361 358 276 358Q152 358 115 184Q114 180 114 178Q106 141 106 117Q106 67 131 47T188 26Q242 26 287 73Q316 103 334 153T356 233T361 278",
  120591: "39 284Q18 284 18 294Q18 301 45 338T99 398Q134 425 164 429Q170 431 332 431Q492 431 497 429Q517 424 517 402Q517 388 508 376T485 360Q479 358 389 358T299 356Q298 355 283 274T251 109T233 20Q228 5 215 -4T186 -13Q153 -13 153 20V30L203 192Q214 228 227 272T248 336L254 357Q254 358 208 358Q206 358 197 358T183 359Q105 359 61 295Q56 287 53 286T39 284",
  120592: "413 384Q413 406 432 424T473 443Q492 443 507 425T523 367Q523 334 508 270T468 153Q424 63 373 27T282 -10H268Q220 -10 186 2T135 36T111 78T104 121Q104 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287Q21 299 34 333T82 404T161 441Q200 441 225 419T250 355Q248 336 247 334Q247 331 232 291T201 199T185 118Q185 68 211 47T275 26Q317 26 355 57T416 132T452 216T465 277Q465 301 457 318T439 343T421 361T413 384",
  120593: "92 210Q92 176 106 149T142 108T185 85T220 72L235 70L237 71L250 112Q268 170 283 211T322 299T370 375T429 423T502 442Q547 442 582 410T618 302Q618 224 575 152T457 35T299 -10Q273 -10 273 -12L266 -48Q260 -83 252 -125T241 -179Q236 -203 215 -212Q204 -218 190 -218Q159 -215 159 -185Q159 -175 214 -2L209 0Q204 2 195 5T173 14T147 28T120 46T94 71T71 103T56 142T50 190Q50 238 76 311T149 431H162Q183 431 183 423Q183 417 175 409Q134 361 114 300T92 210ZM574 278Q574 320 550 344T486 369Q437 369 394 329T323 218Q309 184 295 109L286 64Q304 62 306 62Q423 62 498 131T574 278",
  120594: "576 -125Q576 -147 547 -175T487 -204H476Q394 -204 363 -157Q334 -114 293 26L284 59Q283 58 248 19T170 -66T92 -151T53 -191Q49 -194 43 -194Q36 -194 31 -189T25 -177T38 -154T151 -30L272 102L265 131Q189 405 135 405Q104 405 87 358Q86 351 68 351Q48 351 48 361Q48 369 56 386T89 423T148 442Q224 442 258 400Q276 375 297 320T330 222L341 180Q344 180 455 303T573 429Q579 431 582 431Q600 431 600 414Q600 407 587 392T477 270Q356 138 353 134L362 102Q392 -10 428 -89T490 -168Q504 -168 517 -156T536 -126Q539 -116 543 -115T557 -114T571 -115Q576 -118 576 -125",
  120595: "161 441Q202 441 226 417T250 358Q250 338 218 252T187 127Q190 85 214 61Q235 43 257 37Q275 29 288 29H289L371 360Q455 691 456 692Q459 694 472 694Q492 694 492 687Q492 678 411 356Q329 28 329 27T335 26Q421 26 498 114T576 278Q576 302 568 319T550 343T532 361T524 384Q524 405 541 424T583 443Q602 443 618 425T634 366Q634 337 623 288T605 220Q573 125 492 57T329 -11H319L296 -104Q272 -198 272 -199Q270 -205 252 -205H239Q233 -199 233 -197Q233 -192 256 -102T279 -9Q272 -8 265 -8Q106 14 106 139Q106 174 139 264T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287Q21 299 34 333T82 404T161 441",
  120596: "495 384Q495 406 514 424T555 443Q574 443 589 425T604 364Q604 334 592 278T555 155T483 38T377 -11Q297 -11 267 66Q266 68 260 61Q201 -11 125 -11Q15 -11 15 139Q15 230 56 325T123 434Q135 441 147 436Q160 429 160 418Q160 406 140 379T94 306T62 208Q61 202 61 187Q61 124 85 100T143 76Q201 76 245 129L253 137V156Q258 297 317 297Q348 297 348 261Q348 243 338 213T318 158L308 135Q309 133 310 129T318 115T334 97T358 83T393 76Q456 76 501 148T546 274Q546 305 533 325T508 357T495 384",
  120597: "202 508Q179 508 169 520T158 547Q158 557 164 577T185 624T230 675T301 710L333 715H345Q378 715 384 714Q447 703 489 661T549 568T566 457Q566 362 519 240T402 53Q321 -22 223 -22Q123 -22 73 56Q42 102 42 148V159Q42 276 129 370T322 465Q383 465 414 434T455 367L458 378Q478 461 478 515Q478 603 437 639T344 676Q266 676 223 612Q264 606 264 572Q264 547 246 528T202 508ZM430 306Q430 372 401 400T333 428Q270 428 222 382Q197 354 183 323T150 221Q132 149 132 116Q132 21 232 21Q244 21 250 22Q327 35 374 112Q389 137 409 196T430 306",
  120598: "227 -11Q149 -11 95 41T40 174Q40 262 87 322Q121 367 173 396T287 430Q289 431 329 431H367Q382 426 382 411Q382 385 341 385H325H312Q191 385 154 277L150 265H327Q340 256 340 246Q340 228 320 219H138V217Q128 187 128 143Q128 77 160 52T231 26Q258 26 284 36T326 57T343 68Q350 68 354 58T358 39Q358 36 357 35Q354 31 337 21T289 0T227 -11",
  120599: "537 500Q537 474 533 439T524 383L521 362Q558 355 561 351Q563 349 563 345Q563 321 552 318Q542 318 521 323L510 326Q496 261 459 187T362 51T241 -11Q100 -11 100 105Q100 139 127 242T154 366Q154 405 128 405Q107 405 92 377T68 316T57 280Q55 278 41 278H27Q21 284 21 287Q21 291 27 313T47 368T79 418Q103 442 134 442Q169 442 201 419T233 344Q232 330 206 228T180 98Q180 26 247 26Q292 26 332 90T404 260L427 349Q422 349 398 359T339 392T289 440Q265 476 265 520Q265 590 312 647T417 705Q463 705 491 670T528 592T537 500ZM464 564Q464 668 413 668Q373 668 339 622T304 522Q304 494 317 470T349 431T388 406T421 391T435 387H436L443 415Q450 443 457 485T464 564",
  120600: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
  120601: "409 688Q413 694 421 694H429H442Q448 688 448 686Q448 679 418 563Q411 535 404 504T392 458L388 442Q388 441 397 441T429 435T477 418Q521 397 550 357T579 260T548 151T471 65T374 11T279 -10H275L251 -105Q245 -128 238 -160Q230 -192 227 -198T215 -205H209Q189 -205 189 -198Q189 -193 211 -103L234 -11Q234 -10 226 -10Q221 -10 206 -8T161 6T107 36T62 89T43 171Q43 231 76 284T157 370T254 422T342 441Q347 441 348 445L378 567Q409 686 409 688ZM122 150Q122 116 134 91T167 53T203 35T237 27H244L337 404Q333 404 326 403T297 395T255 379T211 350T170 304Q152 276 137 237Q122 191 122 150ZM500 282Q500 320 484 347T444 385T405 400T381 404H378L332 217L284 29Q284 27 285 27Q293 27 317 33T357 47Q400 66 431 100T475 170T494 234T500 282",
  120602: "205 -174Q136 -174 102 -153T67 -76Q67 -25 91 85T127 234Q143 289 182 341Q252 427 341 441Q343 441 349 441T359 442Q432 442 471 394T510 276Q510 169 431 80T253 -10Q226 -10 204 -2T169 19T146 44T132 64L128 73Q128 72 124 53T116 5T112 -44Q112 -68 117 -78T150 -95T236 -102Q327 -102 356 -111T386 -154Q386 -166 384 -178Q381 -190 378 -192T361 -194H348Q342 -188 342 -179Q342 -169 315 -169Q294 -169 264 -171T205 -174ZM424 322Q424 359 407 382T357 405Q322 405 287 376T231 300Q221 276 204 217Q188 152 188 116Q188 68 210 47T259 26Q297 26 334 62Q367 92 389 158T418 266T424 322",
  120603: "206 -10Q158 -10 136 24T114 110Q114 233 199 349L205 358H184Q144 358 121 347Q108 340 95 330T75 312T61 295T53 285Q51 284 38 284Q19 284 19 294Q19 300 38 329T93 391T164 429Q171 431 532 431Q799 431 803 430Q823 423 823 402Q823 377 801 364Q790 358 766 358Q748 358 748 357Q748 355 749 348T752 327T754 297Q754 258 738 207T693 107T618 24T520 -10Q488 -10 466 2T432 36T416 77T411 120Q411 128 410 128T404 122Q373 71 323 31T206 -10ZM714 296Q714 316 707 358H251Q250 357 244 348T230 328T212 301T193 267T176 229T164 187T159 144Q159 62 222 62Q290 62 349 127T432 285Q433 286 434 288T435 291T437 293T440 294T444 294T452 294H466Q472 288 472 286Q472 285 464 244T456 170Q456 62 534 62Q604 62 659 139T714 296",
  120604: "65 0Q45 0 45 18Q48 52 61 60Q65 62 81 62Q155 62 165 74Q166 74 265 228T465 539T569 699Q576 707 583 709T611 711T637 710T649 700Q650 697 695 380L741 63L784 62H827Q839 50 839 45L835 29Q831 9 827 5T806 0Q803 0 790 0T743 1T657 2Q585 2 547 1T504 0Q481 0 481 17Q484 54 497 60Q501 62 541 62Q580 62 580 63Q580 68 573 121T564 179V181H308L271 124Q236 69 236 67T283 62H287Q316 62 316 46Q316 26 307 8Q302 3 295 0L262 1Q242 2 168 2Q119 2 93 1T65 0ZM537 372Q533 402 528 435T521 486T518 504V505Q517 505 433 375L348 244L451 243Q555 243 555 244L537 372",
  120605: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 449 686H477H586Q684 686 733 677T817 634Q853 598 853 547Q853 499 826 460T761 401T695 371T654 360H653L662 358Q670 357 683 354T712 344T744 327T774 303T795 269T804 224Q804 148 732 79T533 1Q524 0 288 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM703 550Q703 571 695 586T675 609T656 619T643 623L545 624H447L417 504Q386 384 386 383T470 382Q554 383 565 385Q632 397 667 447T703 550ZM651 240Q651 265 645 282T626 309T608 322T592 329Q587 330 479 331H373L340 198Q307 65 306 64Q306 62 406 62L507 63L519 65Q565 76 596 107T639 171T651 240",
  120606: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H763Q769 677 772 673T776 666L777 664Q777 659 766 549T751 433Q745 424 723 424Q704 424 699 427T693 441Q693 444 695 467T697 513Q697 543 689 563T670 594T636 610T592 617T534 618H516H456L455 614Q455 613 387 339T317 64Q317 62 375 62H411Q430 62 438 59T447 44Q444 7 430 2Q426 0 416 0Q409 0 359 1T231 2Q152 2 111 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
  120607: "65 0Q59 6 59 9T61 16Q64 20 334 357T608 698Q616 706 629 710Q630 710 634 710T644 710T656 711Q686 711 694 703Q698 699 700 693Q706 674 805 345T904 14Q904 7 894 1L479 0H65ZM630 342L567 551L232 134L462 133H693Q693 137 630 342",
  120608: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H811Q817 677 820 673T824 666L825 664Q825 659 814 549T799 433Q793 424 771 424Q752 424 746 427T740 441Q740 445 742 466T744 505Q744 561 722 585T646 616Q639 617 545 618H456Q456 617 427 502T398 385Q398 384 435 384Q461 385 471 385T499 391T526 405T545 433T562 478Q566 494 571 497T595 501H604Q622 501 626 486Q626 482 593 349T557 213Q552 205 530 205Q499 205 499 219Q499 222 503 242T508 281Q508 308 491 314T429 322Q425 322 423 322H382L317 64Q317 62 390 62Q460 62 493 64T569 80T640 124Q665 149 686 187T719 253T733 283Q739 289 760 289Q791 289 791 274Q791 267 763 201T706 71L678 8Q676 4 667 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
  120609: "223 430Q192 430 192 448Q192 450 225 561T261 677Q265 683 270 684Q273 686 534 686Q796 686 797 685Q805 682 805 673Q805 668 804 661T800 648T798 641Q796 637 531 352L266 67L329 66H364Q412 66 446 70T523 96T596 157Q617 186 630 220T649 273T663 297Q667 299 684 299H688Q715 299 715 281Q715 278 673 145T628 8Q626 4 617 0H348Q289 0 221 0T139 -1Q112 -1 99 -1T78 1T69 5T68 12Q68 16 71 31T77 49L84 57Q91 65 104 79T133 110T170 151T213 196L610 624H540Q533 624 514 624T488 624T467 623T443 620T422 616T398 609T373 600Q292 560 255 449Q251 436 246 433T223 430",
  120610: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L399 389Q399 388 547 388H695L753 623Q753 624 709 624H686Q665 624 660 626T650 639Q653 678 668 684Q672 686 681 686Q685 686 726 685T847 684Q902 684 937 684T986 685T1004 686Q1027 686 1027 668Q1023 632 1011 626Q1006 624 957 624H908L839 344Q768 64 768 63T812 62H839Q871 62 871 44Q867 6 854 2L850 0L808 1Q782 2 675 2Q600 2 560 1T516 0Q499 0 494 15Q498 54 511 60Q515 62 564 62H613L614 66L679 324Q679 326 531 326H383L382 322L317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624",
  120611: "358 -17Q218 -17 136 49T54 243Q54 298 70 356T123 474T211 582T338 663T504 702H527Q578 702 590 701Q709 688 776 622T844 441Q844 379 825 315T765 192T668 86T532 11T358 -17ZM700 474Q700 525 685 561T642 616T587 643T528 652Q390 652 301 534Q252 472 225 373T198 210Q198 160 214 125T256 71T311 44T372 36Q484 36 571 119Q639 189 669 299T700 474ZM366 428Q366 425 364 419T362 411H466L570 412L573 422Q576 437 581 441T604 445Q620 445 623 444Q636 440 636 429Q636 423 616 340T593 253Q586 243 572 243H566Q545 243 539 249Q536 251 535 253T534 258T534 263T535 270T537 277H329L326 266Q323 251 318 247T295 243Q279 243 276 244Q263 248 263 259Q263 265 283 346Q288 366 295 394Q304 431 308 438T326 445H334H338Q366 445 366 428",
  120612: "247 624Q242 624 233 624T220 623Q186 623 186 640Q186 647 190 664T202 684Q206 686 226 686Q277 684 393 684Q435 684 471 684T528 685T553 686Q573 686 573 670Q573 650 564 632Q556 624 537 624H501H449L380 344Q309 64 309 63T356 62Q361 62 370 62T384 63Q417 63 417 46Q417 26 408 8Q403 3 396 0L352 1Q325 2 216 2T82 1L45 0Q30 7 30 16Q33 51 46 60Q51 62 102 62H154L294 623Q294 624 247 624",
  120613: "536 0Q522 6 522 18Q522 35 533 57Q539 62 557 62Q595 62 601 65L472 330L365 255L342 160Q318 65 317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L422 481Q386 339 386 337L785 621Q779 624 749 624Q726 624 726 641Q726 645 730 659Q734 675 736 679T747 686L786 685Q812 684 888 684Q908 684 934 685T968 686Q1003 686 1003 669Q1003 646 991 629Q985 624 967 624Q918 624 888 617Q884 617 874 613L865 609Q864 608 732 515T599 420Q599 418 686 242T775 65Q784 62 829 62Q847 62 850 61T860 54Q862 52 862 43Q862 10 845 1Q844 1 842 1T836 0T797 1T694 2Q599 2 573 1L536 0",
  120614: "439 0Q425 6 425 18Q425 35 436 57Q442 62 485 62Q525 62 525 64L478 483Q478 484 465 463T422 394T350 277Q222 69 222 68Q223 67 224 67Q229 64 271 62Q290 62 297 59T305 45Q305 38 302 28Q297 9 293 5T274 0Q270 0 238 1T159 2Q133 2 105 2T72 1Q56 1 52 3T44 15Q44 19 48 35Q53 55 58 58T89 62Q142 64 151 73Q154 76 345 387T538 699Q550 711 570 711H580H592Q613 711 618 695Q619 692 654 379T690 63Q690 62 726 62H746Q776 62 776 44Q773 7 759 2Q755 0 747 0Q743 0 707 1T600 2Q502 2 476 1L439 0",
  120615: "258 624H231Q214 624 208 626T199 639Q203 678 216 684Q220 686 347 686H473Q474 685 478 682T484 677Q487 673 535 413L584 153L608 187Q631 221 672 281T761 410Q935 663 943 671Q949 678 962 686H1082H1166Q1201 686 1210 683T1219 668Q1215 632 1203 626Q1199 624 1149 624H1100L1031 344Q960 64 960 63T1004 62H1031Q1063 62 1063 44Q1060 7 1046 2Q1042 0 1034 0Q1030 0 990 1T875 2Q804 2 767 1T725 0H723Q707 0 703 15Q707 54 720 60Q724 62 773 62H822Q961 618 961 619L754 318Q546 15 543 12Q531 0 510 0Q500 0 495 0T484 5T477 19Q477 20 421 315L367 604L299 335Q234 72 234 68Q234 62 302 62Q334 62 334 46Q332 8 317 2Q313 0 306 0Q301 0 267 1T181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
  120616: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 344 686H434Q464 686 477 680Q480 677 607 454Q738 227 739 227Q742 227 789 418T836 618Q836 620 835 620L821 622Q811 622 779 624Q755 624 749 625T740 632Q737 635 737 644Q737 656 742 669T754 685Q755 685 757 685T763 686Q768 686 803 685T890 684Q925 684 951 684T990 685T1006 686Q1014 686 1016 684Q1027 679 1027 668Q1023 632 1011 626Q1007 624 978 624Q912 622 907 617Q907 616 831 314T753 8Q749 0 723 0H712Q699 0 692 7Q692 8 671 44T607 155T526 296L361 580L296 323Q234 74 234 68T302 62H307Q334 62 334 44Q330 6 317 2L313 0L280 1Q260 2 181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
  120617: "206 466Q175 466 175 484Q175 487 201 574T230 666Q235 673 241 675H547Q853 675 857 673Q867 668 867 657Q867 655 850 569T832 478Q827 466 808 466H802H795Q773 466 771 481Q771 486 775 508T779 541V549H774Q755 552 505 552Q281 551 267 548Q262 548 255 533T242 496T233 472Q228 466 206 466ZM259 255H252Q231 255 228 270Q228 275 248 355T270 439Q277 448 288 448H298Q321 448 326 440Q331 434 326 414Q326 413 486 413H647L650 424Q654 441 658 444T678 448H683H693Q702 448 705 446T714 432L694 348Q674 267 669 261Q664 255 652 255H643Q622 255 617 261Q613 265 613 272T613 283T616 289Q616 290 456 290H295L294 285Q293 280 292 275T288 265T281 257Q278 255 259 255ZM150 131Q150 124 281 123Q346 123 390 123Q640 123 664 126Q668 127 675 127Q686 131 704 198Q708 213 713 216T733 220H738Q755 220 759 218Q768 213 768 203Q768 198 741 105T710 8Q708 4 699 0H388Q77 0 73 2Q62 7 62 18Q62 27 81 115Q99 206 102 212Q106 220 120 220H129Q140 220 145 220T155 215T160 202Q160 196 159 192Q150 145 150 131",
  120618: "53 245Q53 297 70 356T125 478T216 590T349 671T523 703Q656 703 735 637T815 445Q815 378 791 307Q727 104 527 17Q437 -17 344 -17Q289 -17 242 -5T150 35T79 116T53 245ZM664 489Q664 575 618 611T511 648Q463 648 416 627T334 570Q297 531 270 472T230 355T213 261T208 206Q208 177 215 151T237 98T284 56T358 40Q440 40 510 98T618 270Q664 400 664 489",
  120619: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H1011Q1022 675 1026 665Q1022 626 1009 620Q1005 618 956 618H907L906 614Q906 613 838 339T768 64Q768 62 812 62H839Q871 62 871 44Q867 6 854 2L850 0L808 1Q782 2 675 2Q600 2 560 1T516 0Q499 0 494 15Q498 54 511 60Q515 62 564 62H613L614 66Q614 67 682 341T752 616Q752 618 604 618H456L455 614Q455 613 387 339T317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
  120620: "162 62L302 623Q302 624 258 624H234Q214 624 209 626T200 638Q200 677 217 684Q220 686 439 686Q667 685 684 682Q686 681 693 680Q713 677 733 671T782 649T829 602T847 528Q847 450 784 382T604 293Q571 288 469 287H373L346 176Q340 151 333 122T321 78L317 64Q317 62 361 62H387Q420 62 420 44Q417 10 404 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q43 0 43 17Q43 21 47 33Q52 54 57 58T89 62H113H162ZM692 558Q692 611 617 622Q610 623 529 624H452L381 343H458H492Q604 343 641 389Q662 414 677 471T692 558",
  120622: "847 430Q828 430 823 434T817 450Q817 454 817 466T818 487Q818 526 809 551T784 591T737 613T675 622T590 624H528H430L513 487Q594 351 596 345Q596 335 590 330Q583 323 418 204L250 81L363 80Q533 80 591 89T694 142Q739 185 765 252Q772 268 776 271T799 274Q816 274 820 272Q832 266 830 254Q829 250 784 130T736 7Q732 3 725 0H405Q84 0 80 2Q69 7 69 18Q69 26 75 32Q76 32 98 48T168 100T255 164L432 293Q429 300 329 465T225 637Q223 675 245 686H888Q900 680 902 671Q902 667 890 556T876 441Q871 430 847 430",
  120623: "498 62Q511 58 511 43Q511 10 494 1L490 0Q487 0 482 0T424 1T271 2Q201 2 157 2T94 1T72 0H70Q46 0 46 17Q49 54 62 60L66 62H137Q208 62 209 63L218 98Q227 134 244 203T278 339L347 613H300Q262 612 246 611T198 599T146 564Q128 545 114 512T91 454T79 425Q73 419 52 419Q22 419 22 434Q22 440 41 498T80 611L100 666Q105 673 111 675H434Q758 675 762 673Q772 668 772 657Q772 655 756 549T738 434Q735 419 711 419H707Q690 419 686 421Q677 425 677 434Q676 436 678 449T683 485T686 529Q686 553 679 569T662 594T631 607T593 612T544 613H502L433 340Q418 279 400 207T374 100L365 65L364 62H498",
  120624: "32 544Q32 586 91 644T229 703Q277 703 311 683T363 628T389 560T397 491V478L404 491Q455 589 526 646T677 703Q730 703 766 671T802 584Q802 551 793 541T766 531H757L736 532L732 535L729 539V549Q731 569 715 575T658 581H650Q545 581 477 443Q453 392 443 351Q441 345 424 273T389 133T371 64Q371 62 428 62H461Q483 62 492 59T501 44Q498 10 485 2L480 0L431 1Q401 2 278 2T127 1L85 0Q71 5 71 17Q71 24 74 33Q77 46 78 49T84 57T95 61T118 62H154H216Q232 126 249 193T273 287T287 345T296 388T299 416T300 452Q294 581 198 581Q154 581 132 575T106 562T99 546T86 533Q82 531 60 531L39 532Q32 537 32 544",
  120625: "323 624H293Q267 624 261 626T251 639Q255 678 268 684Q272 686 293 686Q348 684 475 684Q557 684 600 685T647 686H648Q671 686 671 668Q667 632 655 626Q650 624 588 624H525L500 520Q500 519 520 518T579 507T656 480Q737 440 737 372Q737 294 648 237Q562 180 426 169L412 168L399 118Q386 66 386 65L385 62H443H479Q498 62 506 59T515 44Q511 8 499 2L494 0L447 1Q417 2 298 2Q212 2 167 1T118 0Q100 0 95 15Q99 54 112 60Q116 62 179 62H241Q242 64 254 114T266 167Q266 168 262 168Q256 168 237 170T180 181T110 205T54 249T29 316Q29 391 112 446T327 516Q345 518 349 518Q351 518 353 518L355 519Q356 520 368 570T381 623Q381 624 323 624ZM342 466Q341 467 339 467Q320 467 283 455T225 420Q181 361 181 296Q181 273 193 257T222 233T254 222T277 219L280 220Q281 220 311 342T342 466ZM583 389Q583 409 576 423T557 444T533 456T509 463T492 467H486L455 343Q444 300 437 271T428 231T426 219Q430 219 445 222T483 232T521 250Q551 269 567 310T583 389",
  120626: "931 686Q953 686 953 670Q953 650 944 632Q936 624 924 624H914Q823 624 803 611Q800 609 696 503T591 396Q591 394 667 229L743 62H787H814Q846 62 846 44Q843 7 829 2Q825 0 817 0Q813 0 775 1T664 2Q590 2 551 1T508 0H507Q484 0 484 18Q484 19 488 37Q492 56 497 58T534 62L566 63Q567 64 520 169T471 274Q469 274 369 172T268 67L315 62Q320 62 328 62L335 61Q347 58 347 44Q344 10 331 2L326 0L287 1Q263 2 177 2Q95 2 78 1L53 0Q38 6 38 17Q38 40 50 57Q56 62 78 62Q169 62 188 75Q194 77 435 324L444 334L439 347Q437 351 373 492L313 624H268H246Q220 624 212 632Q210 636 210 642Q210 655 215 669T227 684Q230 686 247 686Q295 684 398 684Q438 684 472 684T527 685T551 686Q567 686 572 671Q572 667 568 651Q563 631 558 628T523 624T492 623H488L526 540Q563 457 564 457Q564 456 574 466T604 496T645 537L724 619Q716 622 677 624H673Q645 624 645 640Q645 660 654 678Q659 683 666 686L704 685Q728 684 813 684Q847 684 873 684T913 685T931 686",
  120627: "205 471Q205 445 196 403T186 333Q186 303 194 281T218 248T240 233T262 224L361 623Q361 624 303 624Q296 624 284 624T266 623Q232 623 232 641Q232 648 235 657Q240 678 244 682T268 686H273Q329 684 457 684Q502 684 540 684T599 685T626 686H628Q651 686 651 668Q649 633 631 624H505L407 227Q410 228 416 229T439 239T472 259T507 294T539 345Q549 365 563 416T597 498T649 538Q657 540 717 540Q725 540 737 540T755 541Q790 541 790 524Q790 512 784 497Q780 491 767 490T742 477Q736 471 731 463T722 449T715 433T710 419T705 403T701 389Q686 340 658 302T599 240T530 201T463 179T404 169L391 168L379 116Q365 67 365 63Q365 62 422 62H455Q477 62 486 59T495 44Q492 10 479 2L474 0L427 1Q397 2 278 2T131 1L90 0Q76 5 76 17Q76 24 79 33Q82 46 83 49T89 57T100 61T123 62H159H221Q247 162 247 168H244Q241 169 239 169Q202 176 178 182T123 207T74 252Q46 291 46 351Q46 375 52 404T59 454Q59 489 40 489Q32 489 27 494T22 507Q22 535 37 538Q40 540 99 540H128Q168 540 186 528T205 471",
  120628: "162 119Q181 115 235 115L273 116Q273 133 231 222T180 345Q173 368 173 391V406V414Q173 477 214 540Q255 600 315 635Q353 661 423 682T585 703Q656 703 711 690T799 656T851 608T879 555T886 503Q886 449 860 401Q840 359 810 322T725 230T643 146Q619 117 619 116T650 115Q707 115 722 120Q730 123 750 165T775 210Q779 212 796 212Q828 212 828 196Q828 191 807 144T764 52L743 7Q740 4 740 4T733 2T717 0T686 0H632H573Q535 0 526 3T517 17Q517 44 544 103T617 243T671 341Q729 454 729 535Q729 599 686 625T583 652Q549 652 517 645T450 616T388 561T344 470T327 340Q327 304 331 237T336 135Q336 93 330 50T313 2Q308 0 208 0H142Q107 0 100 4T93 25Q93 28 93 41T95 77T96 118L100 199Q105 208 109 210T131 212Q147 212 151 210T161 199V160Q161 131 162 125V119",
  120630: "39 166Q39 213 59 261T117 353T219 424T362 452Q420 452 466 433T536 384T573 325T586 269V265Q593 272 609 308T636 381Q640 397 644 399T669 402H680Q700 402 700 388Q700 379 691 351T659 276T604 188L593 173L595 153Q600 79 612 43H618Q634 45 642 51T653 64T658 71Q661 73 684 73Q712 73 712 59Q712 39 685 16T603 -7Q588 -7 575 -5T551 2T532 12T516 24T503 37T494 49T487 60T481 69L469 61Q362 -8 251 -8Q159 -8 99 36T39 166ZM260 43Q310 43 361 63T438 101T465 124Q458 240 453 277Q435 401 354 401Q291 401 245 355Q230 337 217 313Q201 279 186 216T170 126Q170 72 208 54Q230 43 260 43",
  120631: "59 -194H49Q31 -194 28 -182Q28 -178 107 139T192 473Q212 533 248 580T324 652T395 689T450 701H461Q514 701 551 688T605 652T630 607T637 561Q637 546 634 526T611 465T556 393Q572 382 590 347T608 262Q608 146 522 69T299 -8Q279 -8 261 -6T228 2T204 13T183 26T169 37T157 48L150 56L120 -64Q113 -90 104 -128Q93 -175 89 -184T73 -194H59ZM531 592Q531 651 463 651Q399 651 341 600T253 466Q250 458 217 327T182 185Q180 176 180 159Q180 108 212 76T301 44Q330 44 354 51T393 65T423 91T444 118T459 151T468 179T475 206Q490 264 491 296Q491 313 489 326T484 345L482 350Q481 350 477 348T464 344T444 340T413 335T372 333T334 334T301 340T274 355T265 380Q265 444 397 444Q425 444 445 441T476 436L485 433Q489 433 499 458Q509 482 520 527T531 592ZM424 390Q424 393 389 393Q383 393 374 393T362 392Q348 392 333 388Q345 384 379 384Q424 384 424 390",
  120632: "5 269Q5 285 19 312T57 368T124 421T215 451H241Q274 451 303 439T353 406T389 361T416 311T432 266T442 232L444 220L446 216L450 226Q473 278 513 357T561 441Q566 444 584 444H594Q617 444 617 430Q617 426 596 389T536 273T462 110L452 84L451 70Q447 12 427 -76T388 -192Q375 -211 355 -211Q339 -211 332 -198T325 -171Q325 -114 386 64L393 84V98Q393 181 371 241Q360 280 319 303T210 327Q158 327 126 317T84 296T68 272T59 258Q55 256 36 256Q23 256 18 256T9 260T5 269",
  120633: "216 610Q216 640 229 664T262 700T299 719T327 725Q330 725 406 709T487 690Q513 681 513 651Q513 627 494 607T450 587Q417 587 378 631Q346 663 314 663Q286 663 272 639Q271 637 271 634Q271 609 344 536L397 484Q438 448 458 410T478 313Q478 234 443 147T338 18Q298 -8 249 -8Q214 -8 180 0T113 26T60 81T39 168Q39 200 50 237T87 316T160 391T272 442L260 465Q216 553 216 610ZM348 235Q348 274 336 313T310 372L298 392Q295 391 290 390T269 380T241 359T212 323T185 267Q157 168 157 130Q157 83 186 63T255 43Q280 43 300 67Q317 89 332 138T348 235",
  120634: "224 -17Q126 -17 81 22T36 112Q36 178 84 226L93 236L88 246Q79 264 79 289Q79 341 124 388Q201 461 333 461Q402 461 455 425Q480 409 481 390Q481 365 464 350T428 334Q415 334 387 352T313 370Q141 370 141 293Q141 275 146 270Q147 270 148 270T155 272Q202 291 263 291H270Q349 291 349 244Q349 195 281 183Q274 182 239 182Q201 182 184 185T137 200Q123 188 112 168T100 129T112 98T148 81T189 75T237 74H243H251Q288 74 310 75T359 86T398 112Q405 124 417 124Q426 124 432 117T439 100Q439 88 427 70T390 32T322 -3T224 -17ZM286 238Q286 240 253 240Q245 240 234 239T216 237T209 235Q209 232 250 232Q286 232 286 238",
  120635: "361 711Q373 711 381 703T389 683Q389 681 388 676T383 656T376 618V612H379Q385 618 429 618Q521 618 521 572Q521 551 506 534Q483 510 415 507Q385 507 371 511T336 536L326 528Q254 472 204 381T154 209Q154 190 157 177Q159 165 162 154T170 135T182 119T195 106T212 95T229 86T249 78T269 72T290 66T311 60Q385 37 388 36Q437 14 454 -36Q456 -46 456 -64Q456 -83 455 -90Q445 -132 413 -167T333 -202Q300 -202 257 -191T206 -169Q203 -164 203 -158Q203 -148 210 -140T231 -130Q239 -130 263 -139T326 -151H329Q337 -151 342 -150T352 -143T357 -123Q356 -117 355 -113T350 -104T344 -96T335 -90T324 -85T310 -80T294 -74T275 -68T254 -62Q253 -62 231 -56T205 -48T179 -39T150 -26T125 -10T100 11T80 37T62 70T53 109T48 157Q48 281 123 396T317 586V612Q319 638 320 649T325 678T338 703T361 711ZM454 564Q445 567 424 567Q407 567 398 565T387 563Q387 558 411 558Q434 558 450 562L454 564",
  120636: "24 296Q25 302 27 312T41 350T65 397T103 435T157 452Q202 452 233 435Q267 419 284 384L294 392Q304 401 316 410T348 429T388 445Q410 451 445 451H453Q468 451 482 450T519 443T558 425T587 391T600 337V327Q600 311 538 64Q484 -158 478 -168Q457 -211 409 -211Q386 -211 372 -197T357 -161Q357 -158 415 80Q476 330 477 348Q477 366 473 377T461 393T448 399T432 400H427Q379 400 335 363Q300 332 280 298Q277 293 246 170T213 40Q205 22 186 7T142 -8T103 7T89 39Q89 49 106 117T142 260T164 351Q166 363 166 372Q166 402 148 402Q126 402 110 369Q100 350 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296",
  120637: "213 -8Q130 -8 85 50T40 200V207Q40 303 83 428Q122 535 189 608Q279 702 381 702Q410 702 437 693T492 661T537 593T554 486Q554 428 539 362T495 230T425 111T330 25T213 -8ZM433 562Q433 600 419 625T377 651Q363 651 348 644T311 619T268 557T229 453Q225 441 217 411T208 378H401Q433 500 433 562ZM161 140Q161 43 217 43Q249 43 280 74Q310 103 332 150T378 287Q385 313 385 315Q385 316 289 316H192Q191 308 183 275T169 205T161 140",
  120638: "161 -8Q111 -8 75 16T38 85Q38 95 48 121T80 214T123 368L124 374Q126 381 127 386T132 399T139 414T149 428T162 440T180 448T203 452Q226 452 241 439T257 404Q257 386 230 290T171 111Q157 73 157 57Q157 43 166 43Q209 43 258 69T322 144Q326 157 330 159T348 162H355H366Q386 162 386 148Q386 143 383 132T367 100T335 61Q301 27 253 10T161 -8",
  120639: "258 405Q258 394 251 364T237 308T230 281T238 284T270 306T330 349Q365 377 389 394T450 427T519 444Q545 444 559 430T574 391Q574 360 551 336T491 312Q469 312 454 326T439 364Q439 372 438 372Q433 372 395 344T320 289T283 260H285Q287 260 290 260T297 259Q495 248 495 146Q495 132 491 110T486 74Q486 43 505 43Q520 43 531 53Q559 72 578 141Q582 157 586 159T611 162H622Q642 162 642 148T627 100T578 29T504 -7H495Q435 -7 399 22T363 96Q363 111 366 122T369 142Q369 155 364 165T347 182T326 193T298 200T269 204T238 207T212 210L211 206L190 123L169 40Q161 22 142 7T98 -8T59 7T45 39Q45 48 67 139T112 317L134 404Q142 424 161 438T204 452Q226 452 242 440T258 405",
  120640: "95 -13Q70 -13 55 4T40 41Q40 65 61 88Q65 92 210 207T357 322L235 602Q217 640 185 643Q182 643 178 644T173 645Q161 651 161 666Q161 677 167 684T181 692Q189 694 212 694Q335 694 358 660Q362 653 500 340T647 18Q652 10 652 6Q652 -8 622 -8H589H538L526 -5Q506 1 500 8Q494 16 444 128Q442 133 440 138L387 259L265 134Q156 20 137 4T95 -13",
  120641: "294 -8Q265 -8 244 -5T213 1T201 4Q200 4 192 -32T172 -111T155 -168Q134 -211 86 -211Q62 -211 48 -196T34 -158Q37 -144 103 123T174 404Q182 424 201 438T244 452Q271 452 284 436T298 404Q298 392 267 269T235 114Q235 43 305 43Q342 43 375 68T418 110Q420 112 455 253T492 397Q514 444 562 444Q587 444 601 429T615 397Q615 387 599 320T563 178T542 93Q540 81 540 72Q540 42 558 42Q580 42 596 75Q606 94 616 134Q621 155 624 158T646 162H651H662Q682 162 682 148Q681 142 679 132T665 94T641 47T602 9T548 -8Q523 -8 502 -3T468 11T446 27T432 40L429 46Q367 -8 294 -8",
  120642: "88 382Q70 382 65 385T59 402T64 427T78 443Q79 444 157 448T247 452Q256 452 261 448T266 440L267 437Q267 432 223 252L177 71L192 77Q293 117 371 199T480 388Q489 424 511 438T556 452Q579 452 593 438T608 402Q608 378 593 340T540 251T446 152T299 62T96 -1Q91 -2 78 -2Q38 -2 38 15Q38 22 82 198L127 379Q124 382 88 382",
  120643: "287 648Q291 671 293 680T305 700T329 711Q339 711 347 705T356 687Q356 680 351 653T345 619Q345 615 346 615Q358 618 398 618Q490 618 490 572Q490 553 476 536T434 512Q411 508 378 508H366Q332 508 306 534L298 525Q271 496 254 456T237 375Q237 336 244 336Q272 346 319 346H325Q354 346 372 344T406 331T422 300Q422 252 350 238Q332 236 303 236Q286 236 269 238T240 242T218 247T202 252L196 254Q191 254 174 237T141 191T124 139Q124 108 151 92T267 46Q285 40 295 37Q308 33 332 25T366 13T392 3T415 -8T432 -20T445 -36T451 -55T454 -80Q454 -118 427 -153T358 -199Q349 -201 327 -201Q313 -201 298 -200T271 -196T246 -191T226 -185T210 -180T200 -176L196 -174Q187 -170 187 -158T196 -138T216 -130Q217 -130 254 -140T329 -151Q349 -151 349 -135Q349 -127 340 -122T293 -104Q260 -93 238 -85Q130 -48 115 -41Q71 -19 47 15T23 88Q23 126 48 179T130 277L144 288L136 297Q99 336 99 390Q99 456 148 514T285 602V619Q285 624 286 635T287 648ZM355 563Q362 560 376 558Q424 558 423 564Q405 567 390 567Q369 567 355 563ZM279 292Q297 287 315 287Q355 287 355 293Q355 296 321 296Q316 296 308 296L301 295Q295 295 289 294L279 292",
  120644: "254 -8Q191 -8 146 9T80 54T49 111T39 169Q39 206 53 247T96 329T176 402T292 446Q317 451 336 451L344 452Q353 452 359 452Q457 452 516 408T576 279Q576 169 488 81T254 -8ZM349 400Q321 400 287 385T231 338Q206 301 188 228T170 126Q170 99 178 83Q198 44 260 44Q367 44 409 157Q419 185 432 238T445 317Q445 336 443 348Q435 372 416 384T384 398T349 400",
  120645: "55 289H43Q23 289 23 303Q23 308 33 322Q116 434 199 443Q200 444 418 444Q591 444 617 444T652 439Q674 426 674 400Q674 378 661 360T625 335Q621 334 549 333H479L477 321Q476 312 476 279Q476 219 491 174T521 104T536 65Q536 38 511 15T457 -8Q403 -8 386 94Q384 110 384 139Q384 181 391 229T406 304L413 331Q413 333 365 333H316L315 329Q315 328 312 314T301 272T288 220Q274 167 258 103Q244 49 240 38T228 18Q225 16 224 14Q200 -8 172 -8Q146 -8 132 7T118 44Q118 54 121 61Q122 65 142 102T190 195T235 293Q250 329 250 333Q177 333 166 332Q115 328 88 301L77 290L55 289",
  120646: "307 -8Q277 -8 251 0T215 14L205 20Q203 18 193 -25T171 -114T155 -168Q134 -211 87 -211Q64 -211 49 -198T34 -162Q34 -158 137 254Q153 299 179 334T232 390T277 419T311 434Q357 451 403 451Q435 451 455 449T506 435T560 400Q603 357 603 285Q603 172 520 82T307 -8ZM474 343Q474 364 458 382T409 400H406Q339 400 299 341Q281 313 264 257Q261 248 242 170T222 89Q222 84 230 74T260 54T308 43Q334 43 365 57T417 110Q437 145 456 228Q474 298 474 332V343",
  120647: "33 209Q33 277 80 334T195 421T330 451H344Q410 451 439 429Q457 417 457 402Q457 386 445 375T420 363Q415 363 406 368T383 383T354 398Q347 400 330 400Q256 400 196 361T135 265V257Q135 242 147 225T174 199L358 107Q400 77 400 28T362 -63T271 -105Q254 -105 229 -99T195 -86Q188 -82 188 -71Q188 -56 197 -50T216 -44Q225 -44 237 -48T270 -53H282Q293 -44 293 -31Q293 -19 283 -10Q278 -4 200 33T115 76Q77 98 55 133T33 209",
  120648: "35 151Q35 190 51 236T99 327T184 404T306 443Q307 443 316 443T342 443T378 444T425 444T476 444Q606 444 626 444T655 439Q677 426 677 400Q677 358 639 340Q625 333 563 333Q510 333 510 331Q518 319 518 272Q518 155 437 74T226 -8Q123 -8 79 41T35 151ZM396 278Q396 314 375 323T305 332Q249 332 222 310T180 243Q171 219 162 178T153 116V110Q153 43 234 43Q347 43 382 199Q383 203 383 204Q396 255 396 278",
  120649: "55 289H43Q23 289 23 303Q23 308 33 322Q116 434 199 443Q200 444 386 444Q571 444 577 442Q588 441 599 432T610 402Q610 359 572 340Q561 335 547 334T452 333H353V331Q352 330 342 261T320 119T306 40Q300 18 281 3Q257 -13 233 -13Q210 -13 196 0T181 35Q181 44 182 48Q183 53 229 187T279 331Q279 333 228 333H209Q163 333 136 328T88 301L77 290L55 289",
  120650: "189 388Q189 396 187 398T176 401Q144 399 122 369T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 330T64 382T116 431T188 452Q232 452 270 430T308 361Q308 345 275 258T241 123Q241 44 336 44H344Q380 44 415 73T474 140T511 214T526 267Q526 280 513 292Q505 301 486 311T456 333T444 367Q444 400 471 426T529 453Q555 453 579 431T604 358Q604 327 592 271T557 172Q550 157 541 142T510 97T464 47T404 9T328 -8Q264 -8 219 5T154 41T125 85T117 131Q117 182 153 277T189 388",
  120651: "238 4Q230 5 218 8T174 26T118 58T73 112T53 190Q53 219 60 246Q77 313 103 362T143 426T163 443Q165 444 186 444Q217 444 217 432Q217 425 188 392Q157 351 137 291T116 206Q116 127 263 109L276 107L288 139Q347 304 414 378T566 452Q621 449 662 412T703 286Q698 167 598 82T357 -8H332V-11Q332 -12 327 -46T317 -116T310 -157Q306 -180 286 -198T234 -216Q211 -216 197 -203T183 -168Q183 -160 184 -155Q184 -152 198 -112T225 -34T238 4ZM637 260Q637 303 607 322T541 341Q502 341 466 319T405 264Q368 218 356 159Q348 111 348 104Q348 103 361 103Q502 103 569 152T637 260",
  120652: "58 -194Q32 -194 32 -164Q32 -153 46 -139L175 -13Q296 104 296 106Q271 232 226 308Q165 401 141 401Q128 401 117 390T100 365Q94 350 91 349T69 346H45Q35 348 35 359Q35 380 62 411T133 450Q143 452 165 452Q286 452 329 402Q347 379 366 333T394 254T404 215Q404 213 405 213Q405 212 420 227T463 268T520 324Q637 437 640 438Q647 444 661 444Q667 444 676 438T685 419Q685 405 670 389T549 271L420 145Q433 85 444 53Q466 -25 509 -88T575 -151Q590 -151 600 -140T617 -114T626 -98Q629 -96 650 -96H655Q681 -96 681 -108Q681 -114 679 -119Q670 -148 646 -169T591 -199Q581 -201 550 -201Q422 -201 381 -143Q345 -88 316 20L311 39L230 -40Q144 -126 114 -153Q85 -182 77 -188T58 -194",
  120653: "244 141Q244 117 254 98T277 70T305 55T329 48T342 47L344 48L424 366Q501 678 505 686Q508 691 512 692T533 694T555 693T562 688T565 683Q565 678 486 362T406 45Q406 43 415 43Q467 49 514 78T590 143T636 213T653 266Q653 282 641 293T613 311T585 332T572 367Q572 397 598 425T657 453Q684 453 708 430T732 358Q732 330 723 287T706 225Q671 124 578 58T401 -8H393L370 -101Q346 -196 345 -197Q340 -202 316 -202H306Q286 -202 286 -188Q286 -187 296 -144T318 -57T331 -8Q331 -6 328 -6Q290 -6 233 11T148 62Q119 97 119 146Q119 181 154 275T190 388Q190 401 181 401Q154 401 129 375T90 306Q85 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 329T64 381T116 431T189 452Q237 452 273 428T309 362Q309 343 277 260T244 141",
  120654: "532 367Q532 399 559 426T618 453Q645 453 668 430T691 357Q691 319 677 261T649 171Q640 149 626 125T586 68T521 14T438 -7Q401 -7 372 7T333 30T311 57Q246 -8 165 -8Q119 -8 82 19T30 102Q24 126 24 163V178Q24 210 37 255Q61 346 118 424Q141 451 161 451Q174 451 184 443T194 419Q194 402 179 387Q91 273 91 206Q91 159 122 138T189 117T281 145V173Q283 223 294 253Q304 276 323 289T364 303Q386 303 400 287T415 250Q415 219 385 157L378 144Q378 142 388 136T419 124T462 117Q522 117 566 165T610 255Q610 288 561 320Q532 337 532 367",
  120655: "230 475Q202 475 189 492T175 526T186 570T221 631T288 687T389 710Q430 710 438 709Q495 701 537 679T601 629T637 568T653 509T657 459Q657 409 640 341Q617 248 581 180T507 75T424 16T348 -11T282 -17Q171 -17 113 37Q60 88 60 159Q60 192 71 231Q96 336 184 402Q264 462 366 462Q407 462 439 448T497 389L502 380Q503 381 508 403T519 463T525 531Q523 580 499 610T447 648T387 657Q324 657 283 616Q271 604 276 604Q279 604 286 600T302 583T311 555Q311 523 287 499T230 475ZM196 110Q196 41 287 41Q351 41 398 88Q422 111 437 151Q473 243 473 298Q473 386 409 409Q408 409 383 411Q316 411 278 373Q265 360 259 351T241 311T217 226Q196 143 196 110",
  120656: "415 89Q423 89 429 74T436 46Q436 43 434 39Q432 36 420 29T380 11T322 -5Q311 -7 281 -7Q216 -7 168 10T94 54T56 110T44 167V181Q44 262 94 329Q104 343 119 357T162 391T234 425T327 443Q328 443 348 443T383 444Q434 444 442 438Q450 430 450 416Q446 392 424 383L376 382Q306 381 278 369Q230 349 208 294Q199 274 199 268Q199 267 291 267Q305 267 325 267T353 268Q383 268 394 263T406 241Q406 214 380 206Q375 205 279 205T183 203Q174 176 174 140Q174 87 208 65T292 43Q295 43 300 43T307 44Q337 49 372 69T415 89",
  120657: "114 132Q114 153 140 253T166 372Q166 402 148 402Q126 402 110 369Q100 350 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296Q25 302 27 312T41 350T65 397T104 435T158 452Q184 452 211 445T263 414T288 354V339L265 245Q237 134 237 118V107V102Q237 87 239 77T257 56T300 43Q395 43 455 254Q479 346 479 347L460 354Q294 408 294 528Q294 606 350 653T464 701Q536 701 579 659Q634 601 634 491Q634 468 630 438T623 388L620 370Q624 370 631 369T647 364T656 352Q656 347 653 335Q647 317 642 316Q640 315 637 315Q635 315 619 317Q606 319 605 316Q605 315 603 308Q587 248 550 177T457 57Q379 -8 293 -8Q192 -8 153 23T114 116V132ZM519 566Q519 600 507 625T464 651Q425 651 391 617T356 529Q356 501 370 478T404 441T443 417T477 404L491 400Q493 400 499 428T512 497T519 566",
  120658: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
  120659: "274 -7Q232 -4 195 7T125 38T71 94T51 176V190Q51 213 60 242T95 307T156 373T255 425T393 451L397 452L427 568Q434 597 443 636Q452 677 456 685T472 694H486H495Q517 694 517 680L514 665Q510 650 503 621T489 564L460 451H469Q527 447 574 430T657 370T693 266Q693 163 599 82T350 -7H346L322 -100Q301 -190 295 -197Q291 -202 283 -202H269H258Q238 -202 238 -188Q238 -186 260 -96L283 -7H274ZM449 400Q448 400 404 225T359 47T366 45Q464 55 516 119Q542 149 558 199T575 295Q575 387 462 398L449 400ZM384 398Q384 399 381 399Q350 399 298 378T214 308Q168 236 168 149Q168 68 259 49Q282 44 294 44H295L384 398",
  120660: "371 -168Q357 -168 323 -171T245 -175Q143 -175 109 -150T75 -66Q75 -5 100 108T137 254Q153 299 179 334T232 390T277 419T311 434Q357 451 403 451Q435 451 455 449T506 435T560 400Q603 357 603 282Q603 213 569 148T465 38T304 -8Q273 -8 247 -2T204 14T176 31T159 46T152 53Q152 52 148 27T144 -16Q144 -36 150 -44T189 -58T293 -64Q405 -65 432 -75Q466 -88 466 -127Q466 -140 459 -172Q455 -188 451 -191T426 -194H420Q405 -194 400 -191T395 -176Q396 -170 394 -169T378 -168Q373 -168 371 -168ZM236 116Q236 77 258 60T311 43Q369 43 407 94Q429 123 451 206T474 331Q474 400 409 400H406Q339 400 299 341Q276 305 256 227T236 116",
  120661: "55 289H43Q23 289 23 303Q23 308 33 322Q116 434 199 443Q200 444 562 444Q922 444 928 442Q961 434 961 400Q961 376 944 355T886 333H870Q872 322 872 295V279Q872 230 842 165T751 46T618 -8Q581 -8 554 6T513 45T494 84T484 119Q484 121 478 114Q477 113 476 111Q384 -7 268 -7H265Q251 -7 237 -4T199 11T162 54T147 132Q147 149 149 166T155 198T165 229T176 256T189 281T200 301T211 319T220 333H199Q120 333 88 301L77 290L55 289ZM639 103Q674 103 712 122T780 188T811 295Q811 318 808 330V333H289Q274 318 244 263T214 169Q214 133 236 118T288 103Q351 103 412 153T494 278Q497 290 502 292T529 295Q546 295 551 293T556 283Q556 281 553 260T550 218Q550 153 576 128T639 103",
  120662: "110 0H86Q42 0 42 27Q42 37 148 350T258 667Q269 687 291 692Q295 694 366 694H399Q432 694 448 689T474 667Q477 663 583 350T690 27Q690 0 642 0H617H592Q582 0 575 1T561 2T549 6T541 11T533 18T527 26T522 37T517 49T512 64T506 81L490 130H225Q225 128 208 79T189 27Q185 19 180 14T170 7T156 3T143 1T127 0T110 0ZM439 279Q359 524 359 547L357 555L355 543Q347 503 270 263L259 231H357Q455 231 455 232L439 279",
  120663: "119 1Q98 5 92 28V667Q98 686 118 693Q121 694 272 694H289H346Q439 694 500 681T600 625Q640 580 640 513Q640 451 601 414T504 364L518 361Q568 351 602 329T649 280T666 235T671 197Q671 172 665 147T642 91T586 37T488 5Q456 1 282 1H119ZM489 509Q489 532 479 548T450 573T421 585T394 591Q387 592 315 593H247V404H298H325Q432 404 466 444Q489 470 489 509ZM517 194Q517 235 502 261T458 299T407 313T353 317H329H322H247V101H319H357Q387 101 407 103T452 111T492 133T514 171Q516 176 517 194",
  120664: "92 664Q98 683 118 690Q121 691 312 691T508 689Q534 682 534 644V632V618Q534 582 508 573L502 572Q496 572 489 572Q486 572 463 572T416 573Q333 573 291 575H253V303Q253 31 251 25Q242 0 199 0H170L119 1Q99 7 92 28V664",
  120665: "381 692Q386 694 458 694Q516 694 527 693T549 687Q564 680 575 663Q576 658 715 349T856 27Q856 6 838 1H826Q815 1 795 1T747 1T686 1T616 0T539 0T458 0T378 0T300 0T230 0T169 1T122 1T90 1H78Q60 6 60 27Q62 38 201 349T341 663Q356 687 381 692ZM627 148Q626 149 581 250T492 453L447 554Q447 553 446 552Q444 546 326 278L268 148Q268 147 448 147Q627 147 627 148",
  120666: "277 122Q280 122 380 123T544 125Q552 125 557 125T565 124T569 124Q595 115 595 75V62V47Q595 9 569 2Q564 0 341 0L119 1Q99 7 92 28V664Q98 683 118 690Q121 691 335 691T554 689Q580 682 580 644V632V618Q580 582 554 573Q553 573 551 573T542 572T527 572Q464 572 364 573T260 575H253V412H385H459Q524 412 536 404T549 357Q549 341 549 334T542 318T523 305Q518 303 385 303H253V122H277",
  120667: "411 584Q243 581 131 581Q122 581 116 581T106 582T102 582Q84 589 80 600T76 640L77 667Q83 686 103 693Q106 694 343 694Q579 694 584 692Q592 691 599 684T609 668Q610 665 610 646Q610 614 608 608Q605 603 434 361L261 116Q340 117 402 118T490 119T533 120T560 120H572Q605 120 614 95Q616 89 616 60V46Q616 9 590 2Q585 0 339 0Q92 0 87 2Q79 3 72 10T62 26Q61 29 61 49Q61 84 63 90Q65 94 152 217T325 461T411 584",
  120668: "92 667Q101 694 143 694H172H198Q244 694 251 669Q253 663 253 539V415H540V539Q540 558 540 585T539 621Q539 673 550 683T611 694H621H646Q671 694 683 690T700 669Q702 663 702 347T700 25Q696 9 684 5T646 0H621H606Q560 0 550 11T539 76Q539 85 539 116T540 169V306H253V169Q253 147 253 116T254 75Q254 23 245 12T194 0H170L119 1Q99 7 92 28V667",
  120669: "62 340Q62 716 425 716Q511 716 576 696T681 642T747 559T783 458T793 341Q793 264 777 203T721 89T608 7T428 -22Q62 -22 62 340ZM638 333Q638 365 637 387T632 441T621 495T600 542T567 583T518 611T451 628Q443 629 427 629Q402 629 378 624T327 608T276 571T240 511Q217 453 217 345Q217 254 231 204T279 120Q333 69 428 69Q522 69 576 120Q638 183 638 333ZM279 349V373Q279 413 305 420Q309 422 427 422H487Q550 422 563 414T576 369V349Q576 345 576 337T577 324Q577 284 550 277Q545 275 428 275H369Q306 275 293 283T279 329V349",
  120670: "85 667Q94 694 136 694H165H191Q237 694 244 669Q246 663 246 347T244 25Q235 0 192 0H163L112 1Q92 7 85 28V667",
  120671: "92 667Q101 694 139 694H163H186Q225 694 234 671Q236 663 236 529L237 392L533 682Q550 694 590 694H623H681Q695 680 695 672Q695 670 693 664Q688 657 561 533L431 405L698 33Q701 28 701 23Q701 7 683 0H626H604Q571 0 564 2T545 13Q544 14 530 33T489 90T437 162L332 307Q331 307 284 260L236 214V122V65Q236 32 231 19T210 2Q205 0 161 0L119 1Q99 7 92 28V667",
  120672: "106 0H83Q41 0 41 28Q41 39 133 349T229 667Q242 694 296 694H335H375Q403 694 418 689T442 667Q445 660 537 350T630 28Q630 11 619 6T584 0H555H526Q478 0 465 27Q462 32 431 136T366 372T325 555V546Q320 503 287 376T222 141T186 27Q184 22 177 15T165 6Q154 0 106 0",
  120673: "92 667Q98 684 109 689T146 695Q152 695 167 695T192 694Q200 694 214 694T234 695Q291 695 305 664Q313 651 400 419T487 165Q487 162 488 162T489 165Q489 187 574 413T671 664Q679 680 695 688Q708 694 785 694H828Q855 694 867 689T884 669Q886 663 886 347T884 25Q876 0 832 0H817H802Q758 0 750 25Q748 31 748 293V555L746 544Q737 509 692 386T606 160T564 52Q548 22 502 22H487H472Q423 22 410 52Q407 59 367 160T283 385T231 546L230 548Q229 548 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
  120674: "92 667Q98 684 109 689T146 694H185Q273 694 279 692Q301 689 315 669Q322 660 419 453L554 163L562 143Q564 143 564 401Q564 663 566 669Q574 694 618 694H633H648Q692 694 700 669Q702 663 702 347T700 25Q696 10 683 5T642 0H596H551Q520 0 505 4T478 25Q471 34 374 241L239 532Q231 550 231 552L229 479Q229 440 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
  120675: "627 553Q609 553 512 554T366 555Q316 555 220 554T105 553Q96 553 90 553T82 554T78 554Q61 560 57 571T52 605V623L53 661Q59 680 79 687Q82 688 366 688Q649 688 654 686Q680 679 680 639V621V603Q680 563 654 554Q653 554 651 554T642 554T627 553ZM149 423Q152 424 366 424Q579 424 584 422Q610 415 610 376V358V340Q610 300 584 293Q579 291 366 291H232Q162 291 150 293T129 306Q122 315 122 360L123 397Q129 416 149 423ZM108 135Q143 135 226 134T363 133Q407 133 507 134T632 135H645Q675 135 684 110Q686 104 686 68V49Q686 9 660 2Q655 0 364 0L74 1Q57 7 49 21L47 28L46 65V83Q46 126 72 133Q80 135 108 135",
  120676: "362 715Q364 715 376 715T394 716H400Q542 716 626 643T727 426Q731 395 731 342Q731 271 722 225Q674 -22 396 -22Q320 -22 259 -3T148 68T77 201Q62 257 62 342Q62 447 86 522T173 649Q245 707 362 715ZM568 433Q551 623 396 623Q383 623 370 622T333 612T292 591T257 550T233 485Q223 442 223 350Q223 276 232 227T267 137Q309 74 397 74Q433 74 461 85T507 113T537 156T556 205T566 260T569 310T570 357Q570 409 568 433",
  120677: "92 664Q98 683 118 690Q121 691 396 691T676 689Q695 684 700 666Q702 660 702 345Q702 31 700 25Q696 9 684 5T646 0H621H596Q571 0 559 4T542 25Q540 31 540 307V582H253V307Q253 31 251 25Q242 0 199 0H170L119 1Q99 7 92 28V664",
  120678: "641 470Q641 426 630 391T603 334T561 295T513 271T459 259T408 254T361 253H350H337H253V142Q253 125 253 100T254 67Q254 32 249 19T227 2Q222 0 170 0L119 1Q99 7 92 28V667Q98 686 118 693Q121 694 271 694Q428 693 462 688Q641 656 641 470ZM487 467Q487 495 485 510T474 546T442 578T382 592Q375 593 310 593H250V347H309H339Q364 347 380 348T418 354T451 368T474 395T486 438Q487 444 487 467",
  120680: "322 124Q326 124 457 125T672 127H689Q721 127 730 102Q732 96 732 64V48Q732 9 706 2Q701 0 394 0L89 1Q76 5 69 13T62 29V36Q62 37 62 38Q62 47 70 58T126 126Q161 167 185 196Q302 335 302 336L187 463Q74 584 68 594Q61 603 61 639L62 667Q68 686 88 693Q91 694 396 694T706 692Q732 686 732 647V635V621Q732 585 706 576Q705 576 702 576T691 576T670 575L302 578Q302 577 394 475T490 371Q498 362 498 347Q498 336 488 323T408 226L322 124",
  120681: "67 687Q70 688 366 688Q661 688 666 686Q692 680 692 641V629V615Q692 579 666 570H660Q655 569 648 569Q645 569 624 569T581 570Q505 570 475 572H447V302Q447 31 445 25Q436 0 393 0H364L313 1Q293 7 286 28L285 300V572H257Q227 570 151 570Q130 570 109 570T84 569Q77 569 72 570H66Q48 577 44 588T40 631L41 661Q47 680 67 687",
  120682: "62 560Q62 607 94 644T169 698T253 715Q273 715 286 713T322 704T363 677T398 625Q413 597 423 556L428 540Q429 541 436 566T454 620T494 677T561 713Q570 715 593 715Q682 715 737 668T793 560Q793 549 793 545T786 533T767 520H670Q646 532 644 551T632 579Q618 594 591 594Q539 594 524 530T509 321V216Q509 31 507 25Q498 0 455 0H426L375 1Q355 7 348 28L347 232Q346 344 346 441Q346 442 343 468T335 521T312 571T266 594Q252 594 247 593Q228 586 220 576T212 557T209 539T191 523L185 520H88Q75 527 69 534T63 545T62 560",
  120683: "62 292T62 347T80 445T124 511T183 552T243 574T292 584L315 587H319V627L320 667Q329 694 370 694H397H422Q466 694 473 669Q475 663 475 625V587H478Q479 587 500 584T548 575T608 553T668 513T713 446T732 347Q732 253 674 187Q655 167 628 152T576 128T530 116T493 109L478 107H475V69V50Q475 9 449 2Q444 0 395 0L347 1Q327 7 320 28L319 67V107H315L292 110Q269 114 243 119T184 142T124 182T80 249ZM319 197T319 347T318 497Q316 497 307 494T284 485T262 471Q220 438 220 347Q220 285 239 249Q248 234 261 223T286 208T308 200L317 197Q319 197 319 347ZM572 347V357Q572 387 569 407T548 452T496 491Q495 491 494 491T487 493T475 497V197Q518 210 541 232T571 303Q572 312 572 347",
  120684: "52 1Q37 11 37 23Q37 26 39 32Q39 34 158 202L275 369Q275 370 221 441T112 586T55 663Q53 669 53 672Q53 687 68 693H72Q77 693 84 693T99 694T118 694T139 694H176Q203 694 212 692T230 682Q231 681 239 669T265 634T296 591L358 504L418 591Q481 682 486 686Q491 691 499 692Q505 694 569 694H632Q650 685 650 672Q650 667 646 660Q643 654 592 582T491 440T441 369T566 201T693 29Q694 27 694 23Q694 11 677 0H607L537 1Q523 6 519 10T437 131Q422 153 411 170T390 200T375 222T365 237T359 245L357 247L348 232Q339 218 319 188T283 131Q222 37 211 22T186 1H52",
  120685: "61 585Q62 594 62 597T64 606T73 616T89 626H138Q196 626 208 620Q243 602 253 546T261 431T271 309T325 219Q342 205 349 205Q350 205 350 436L351 667Q360 694 401 694H428H454Q495 694 504 671Q506 663 506 436L507 205Q542 222 561 251T586 318T593 392T595 472T602 546Q614 614 661 625Q665 626 708 626H730Q766 626 780 618T794 582Q794 548 768 540Q755 538 754 501T750 410T736 298T680 191T560 120Q550 116 512 109H506V70V50Q506 9 480 2Q475 0 426 0L378 1Q358 7 351 28L350 68V109L335 111Q298 117 267 129T214 156T175 191T146 229T127 272T115 314T109 357T106 395T105 429Q104 537 87 540Q66 548 63 565Q61 570 61 585",
  120686: "241 122Q225 154 191 199T131 278T83 363T61 464Q61 497 68 527T94 591T145 650T228 693T349 715Q354 715 370 715T396 716Q539 716 622 668Q658 647 682 617T715 556T728 505T732 465Q732 415 711 365T663 280T602 200T552 122H632Q649 122 669 122T693 123H697Q736 123 742 98Q744 92 744 62V47Q744 9 718 2Q713 0 591 0L471 1Q454 7 446 21Q444 27 444 45Q444 96 463 154T506 257T549 360T569 469Q569 504 563 530T538 580T485 616T396 629Q313 629 268 594T223 468Q223 419 243 361T286 258T330 152T350 41Q350 14 335 7T276 -1Q267 -1 241 -1T197 0L77 1Q57 7 50 28L49 59V74Q49 114 75 121Q81 123 100 123Q104 123 124 123T161 122H241",
  120782: "266 654H280H282Q500 654 524 418Q529 370 529 320Q529 125 456 52Q397 -10 287 -10Q110 -10 63 154Q45 212 45 316Q45 504 113 585Q140 618 185 636T266 654ZM374 548Q347 604 286 604Q247 604 218 575Q197 552 193 511T188 311Q188 159 196 116Q202 87 225 64T287 41Q339 41 367 87Q379 107 382 152T386 329Q386 518 374 548",
  120783: "481 0L294 3Q136 3 109 0H96V62H227V304Q227 546 225 546Q169 529 97 529H80V591H97Q231 591 308 647L319 655H333Q355 655 359 644Q361 640 361 351V62H494V0H481",
  120784: "175 580Q175 578 185 572T205 551T215 510Q215 467 191 449T137 430Q107 430 83 448T58 511Q58 558 91 592T168 640T259 654Q328 654 383 637Q451 610 484 563T517 459Q517 401 482 360T368 262Q340 243 265 184L210 140H274Q416 140 429 145Q439 148 447 186T455 237H517V233Q516 230 501 119Q489 9 486 4V0H57V25Q57 51 58 54Q60 57 109 106T215 214T288 291Q364 377 364 458Q364 515 328 553T231 592Q214 592 201 589T181 584T175 580",
  120785: "80 503Q80 565 133 610T274 655Q366 655 421 623T491 538Q493 528 493 510Q493 446 453 407T361 348L376 344Q452 324 489 281T526 184Q526 152 514 121T474 58T392 8T265 -11Q175 -11 111 34T48 152Q50 187 72 209T132 232Q171 232 193 208T216 147Q216 136 214 126T207 108T197 94T187 84T178 77T170 72L168 71Q168 70 179 65T215 54T266 48H270Q331 48 350 105Q358 128 358 185Q358 239 348 268T309 313Q292 321 242 322Q205 322 198 324T191 341V348Q191 366 196 369T232 375Q239 375 247 376T260 377T268 378Q284 383 297 393T326 436T341 517Q341 536 339 547T331 573T308 593T266 600Q248 600 241 599Q214 593 183 576Q234 556 234 503Q234 462 210 444T157 426Q126 426 103 446T80 503",
  120786: "531 0Q510 3 381 3Q238 3 214 0H201V62H313V155H32V217L205 434Q342 606 362 630T387 655L391 656Q395 656 401 656T414 656H427Q447 656 451 645Q453 641 453 429V217H542V155H453V62H542V0H531ZM324 217V494L103 218L213 217H324",
  120787: "100 565V605Q100 637 102 646T113 655Q116 655 139 647T202 631T286 623Q332 623 372 631T434 647T459 655Q466 655 469 651T472 643T472 629Q472 613 463 601Q370 487 219 487Q195 487 183 488T169 490T168 433V376Q169 376 174 379T188 387T211 397T244 405T288 409Q390 409 453 352T517 201Q517 106 445 48T253 -11Q169 -11 113 37T57 154Q57 187 79 208T131 229T183 209T206 154Q206 99 155 83Q152 82 157 78Q196 47 253 47Q347 47 358 135Q358 137 358 138Q360 158 360 209Q360 277 355 301T337 338Q315 358 282 358Q202 358 160 303Q153 294 149 292T130 290Q107 290 102 301Q100 304 100 474V565",
  120788: "48 318Q48 395 68 456T120 553T193 613T273 646T350 655Q425 655 461 616T497 524Q497 485 475 468T428 451Q399 451 378 470T357 521Q357 565 403 588Q375 601 351 601Q313 601 282 584Q242 565 222 526Q199 473 199 367Q201 369 210 380T227 396T246 410T275 422T312 426Q438 426 494 332Q526 285 526 208V199Q526 112 465 53Q428 17 388 3T285 -11Q236 -11 195 7T135 43T104 80Q48 165 48 318ZM375 231V244V268Q375 295 373 310T364 342T341 366T299 374H297Q231 374 208 287Q200 257 200 196Q201 120 209 100Q231 47 288 47Q351 47 368 90Q375 112 375 231",
  120789: "256 -11Q231 -11 208 5T185 65Q185 105 193 146T212 220T241 289T275 349T312 402T346 445T377 479T397 502L400 504H301Q156 503 150 497Q142 491 134 456T126 407H64V411Q65 414 82 544T99 675T130 676H161V673Q161 669 162 666T167 661T173 657T181 654T190 652T200 651T210 650T220 649T229 648Q237 648 254 647T276 646Q277 646 426 644H558V620V607Q558 596 551 586T509 537Q489 515 476 500Q390 401 384 393Q349 339 337 259T324 113T322 38Q307 -11 256 -11",
  120790: "80 474Q80 561 139 607T278 654Q357 654 411 632Q490 593 494 509Q494 424 416 376L407 371L418 364Q432 356 447 345T481 312T513 260T526 192Q526 100 461 45T285 -11Q184 -11 116 32T48 164Q48 181 50 196T58 225T69 249T84 270T100 286T117 300T134 311T149 321T162 329L152 336Q120 360 100 397T80 474ZM347 404Q404 446 404 503Q404 579 317 599Q309 600 276 600Q178 600 170 538Q170 532 171 527T173 518T178 509T184 501T194 492T205 484T219 476T235 467T254 456T275 445L347 404ZM289 47Q323 47 351 54T402 82T425 137Q425 147 421 161Q411 183 391 197T303 249Q224 293 223 293Q220 291 215 288T197 273T175 248T157 213T149 167Q149 109 188 78T289 47",
  120791: "178 59Q206 48 238 48Q311 48 345 102Q370 138 375 259V278Q374 278 369 271T350 252T322 232Q297 220 258 220Q172 220 110 275T48 438V446Q54 561 146 618Q199 654 278 654Q321 654 329 653Q526 621 526 330Q526 252 507 190T457 92T388 31T312 -2T240 -11Q165 -11 121 25T77 120Q77 159 99 176T147 193T194 177T217 122Q217 113 216 106T211 92T205 82T198 73T191 67T184 62T178 59ZM374 446V465Q374 523 364 552T315 598Q309 600 293 601Q227 601 210 562Q199 539 199 433Q199 343 204 319T235 279Q250 272 274 271H282Q293 271 303 274T327 288T353 323T371 385Q374 403 374 446",
  120802: "117 621Q174 678 247 678Q305 678 351 647Q396 617 424 557Q460 472 460 328Q460 271 455 224Q448 154 427 104T376 27T314 -10T249 -22Q201 -22 160 1T91 67Q39 154 39 316Q39 541 117 621ZM250 55Q274 55 293 66T324 93T344 136T357 185T364 240T366 291T367 340Q367 373 367 393T363 449T352 507T332 553T299 589T250 601Q217 601 194 584T159 542T141 479T133 411T132 340V331Q132 299 133 277T137 219T147 157T167 107T201 68T250 55",
  120803: "94 612Q172 616 211 632T284 678H307V73H430V0H88V73H213V317Q213 560 212 560Q210 558 197 554T155 546T96 540L83 539V612H94",
  120804: "222 599Q190 599 166 585T128 550T108 509T97 474T93 459L67 492L42 526L47 539Q72 608 120 642T225 677Q304 677 355 644Q449 579 449 454Q449 373 361 290Q351 280 315 250T199 144Q156 103 137 85L293 86H449V0H50V79L216 242Q284 302 317 349T351 456Q351 517 315 558T222 599",
  120805: "333 521Q333 554 313 579T243 604Q154 604 99 514L78 546Q56 577 56 579Q56 580 62 589T82 611T114 637T162 662T222 677Q224 677 231 677T242 678H245Q318 678 374 634T430 520Q430 483 417 452T382 398T351 369T329 354L328 353Q369 333 373 330Q408 306 432 268T457 184Q457 103 397 41T242 -22Q131 -22 51 58L42 68L49 105L55 142L58 138Q62 134 66 130T77 120T91 108T108 96T129 83T152 72T179 63T209 57T242 54Q285 54 319 86T353 184Q353 231 331 267T260 315L213 316H166V354Q166 392 167 392Q233 395 257 405Q290 418 311 450T333 521",
  120806: "271 654L272 656H380V235H471V159H380V0H286V159H28V235L149 443Q269 652 271 654ZM292 235V607Q292 604 290 591T286 571T280 548T269 517T252 476T226 422T189 354T140 267Q136 260 132 253T126 240L123 236Q123 235 207 235H292",
  120807: "257 350Q236 350 218 342T189 323T171 301T160 281L157 273Q157 272 116 272H75V656H416V577H162V486Q162 396 163 396T174 403T207 418T258 426Q339 426 394 360T449 203Q449 113 386 46T226 -21H223Q188 -21 156 -11T102 13T64 42T41 66T33 77Q34 78 44 95T64 128L73 144Q93 112 117 93Q165 54 223 54Q270 54 306 86T345 197Q345 350 257 350",
  120808: "42 318Q42 396 61 460T109 564T173 629T237 666T289 677H301H317Q359 677 408 658V621Q408 585 407 585H406Q359 605 308 605Q246 605 203 556T146 421Q143 403 144 403Q145 402 152 409Q216 469 299 469Q333 469 357 457T407 405Q457 330 457 226Q457 126 402 57Q340 -22 251 -22Q216 -22 183 -7T116 43T63 149T42 318ZM260 393Q216 393 188 365T150 306T141 243Q141 153 172 104Q192 68 230 56Q238 54 251 54Q311 54 342 116Q360 152 360 226Q360 297 344 332Q320 382 277 392Q275 392 270 392T260 393",
  120809: "42 570V656H457V577L447 564Q345 439 295 289T244 0V-11H145V12Q160 330 356 550Q360 556 365 561T374 571L208 570H42",
  120810: "55 500Q55 568 109 623T250 678Q327 678 385 627T444 501Q444 445 410 410T336 357L329 353H330Q378 335 417 293T456 184Q456 93 393 36T249 -22T106 35T43 184Q43 251 82 293T169 353Q171 354 166 356Q165 356 163 357Q113 378 84 416T55 500ZM358 496Q358 557 325 581T250 605Q206 605 174 580T141 496Q141 446 171 420T250 393Q298 393 328 419T358 496ZM245 316Q205 316 172 285T139 185V179Q139 79 222 57Q231 55 250 55H254Q295 55 327 84Q360 120 360 188Q360 254 326 285Q295 316 245 316",
  120811: "44 476Q57 561 116 619T245 677H255Q308 677 349 647Q392 619 424 545T457 334Q457 178 382 78T205 -22Q168 -22 135 -10T86 14L72 25Q73 25 91 58L110 91Q127 78 136 72T163 60T203 54Q238 54 265 71T308 110T335 164T350 214T357 253V257L347 248Q284 187 200 187Q165 187 140 201T87 258Q42 332 42 430Q42 458 44 476ZM269 604Q265 605 254 605Q222 605 199 591T164 554T148 517T141 487Q140 478 140 430T141 373Q146 335 164 307T207 269Q223 263 247 263Q299 266 328 308T358 417Q358 435 356 456T346 511T318 570T269 604",
  120812: "274 -22Q227 -22 190 -9T128 24T87 76T62 135T49 204T44 271T43 336V343V362Q43 407 45 440T56 524T86 613T141 677Q197 715 264 715Q314 715 353 702T418 669T460 616T487 555T500 483T505 413T506 343Q506 310 506 293T503 241T498 185T486 133T467 83T437 42T397 8T343 -13T274 -22ZM355 355V401Q355 448 354 476T349 537T336 587T311 617T272 629Q270 629 266 629T261 628Q219 618 207 568T194 419V355Q194 203 200 156T231 85Q250 66 275 66Q299 66 318 85Q342 109 348 156T355 355",
  120813: "118 560H116Q107 560 100 561T85 572T76 600Q76 612 77 618T83 632T99 644Q102 645 135 646T207 660T275 700Q292 716 310 716Q353 716 360 691Q362 685 362 386V87H446Q464 76 468 69T473 44Q473 12 446 1H118Q105 7 100 13T94 25T93 44V62Q100 79 119 87H210V329Q210 571 208 571Q182 560 118 560",
  120814: "339 477Q339 505 332 531T301 579T242 601Q165 601 136 503Q133 493 130 490T121 486Q116 486 94 514Q86 523 82 528Q46 572 46 577Q46 591 77 632T147 691Q192 716 257 716Q305 716 351 700Q416 674 455 615T494 481Q494 421 463 376T356 266Q326 240 287 205T224 146T199 122H331Q359 122 392 122T431 123H445Q485 123 492 98Q494 92 494 62V47Q494 9 468 2Q463 0 272 0L83 1Q63 7 56 28L55 57V89Q59 97 215 261Q255 303 275 327T317 394T339 477",
  120815: "61 624Q62 630 83 650T153 693T262 716Q328 716 373 698T438 650T465 593T473 536Q473 438 375 376L387 371Q450 350 476 305T503 208Q503 164 492 126T456 53T380 -2T261 -22Q224 -22 189 -15T130 2T86 24T57 43T46 53Q46 56 53 99T62 145Q65 152 71 152Q76 152 90 143T123 121T175 99T248 87Q302 87 321 113T341 202Q341 264 329 292T279 329L232 331L190 332L184 338V411Q190 417 192 417Q193 418 205 419T232 421T252 424Q280 430 299 461T318 539V551Q318 599 283 609Q276 611 257 611Q225 611 199 601T159 577T136 554T120 543T102 560T76 597T62 618T61 624",
  120816: "278 693H282Q285 693 291 693T305 694T322 694T342 694H377Q402 694 411 691T430 677Q434 670 434 646T435 456V249H461H472Q509 249 516 224Q518 219 518 194Q518 178 518 171T511 155T492 142Q488 140 461 140H435V86V53Q435 9 409 2Q405 0 366 0H351Q306 0 298 25Q296 31 296 86V140H179H123Q99 140 80 129T50 106T37 95Q31 95 31 163V208Q31 246 33 251Q251 673 262 684Q268 691 278 693ZM302 249V416L301 576Q301 536 165 276L151 250L226 249H302",
  120817: "109 282Q87 290 83 310V666Q83 667 84 670T87 676T91 682T98 688T108 693Q112 694 269 694T431 692Q457 686 457 648V637V624Q457 588 431 581Q426 579 326 579H227V510Q227 442 229 442Q243 450 288 450Q377 450 435 399T494 222Q494 -22 241 -22Q202 -22 167 -11T109 16T69 49T45 79T37 94T69 151Q91 185 97 185Q105 185 112 170Q127 135 160 111T240 87Q266 87 284 94T311 111T325 142T331 179T332 226Q332 307 324 335T281 363Q228 363 197 306Q189 289 172 282H109",
  120818: "414 589Q410 589 389 600T334 612Q275 612 243 575Q209 538 202 433V422L209 431Q243 487 317 487Q392 487 440 442Q478 402 490 357T503 236Q503 113 454 54Q421 13 381 -4T279 -22Q263 -22 250 -21T214 -15T173 1T133 30T96 77T68 146T50 242Q46 278 46 336Q46 406 52 447Q84 698 312 715L315 716Q318 716 321 716Q323 716 328 716T337 715Q398 715 425 688V596Q419 591 414 589ZM282 87Q324 89 336 117T348 231Q348 310 343 343T324 388T277 399Q249 399 231 373T208 317T202 253Q202 201 207 168T224 117T249 93T282 87",
  120819: "135 38Q135 190 198 335T353 572H215Q185 572 151 572T110 571H96Q55 571 48 596Q46 602 46 633V648Q46 686 72 693Q76 695 124 695Q134 695 183 695T274 694Q472 694 477 692Q503 686 503 648V637Q503 612 502 605T491 588Q300 349 292 46V36Q292 -4 266 -9Q262 -11 214 -11H192Q160 -11 148 -3T135 38",
  120820: "61 518Q61 574 79 614T128 676T192 706T263 715H270Q298 715 318 714T373 701T430 671T470 612T488 517Q488 459 458 423T390 376Q388 375 393 373Q395 372 398 371Q503 330 503 204Q503 -22 275 -22Q209 -22 163 -3T92 49T57 120T46 204Q46 230 50 252T61 289T77 318T96 339T116 353T134 363T148 369T158 373T160 376Q118 389 90 424T61 518ZM344 538Q344 563 340 578T326 600T307 609T279 612Q232 612 218 594T204 518Q204 459 216 439T275 418Q328 418 338 450Q344 464 344 515V538ZM248 88T274 88T315 94T338 117T346 149T349 197Q349 269 342 290Q338 309 320 320T274 331Q246 331 229 320T207 290Q200 269 200 197Q201 163 202 149T210 118T232 94",
  120821: "347 272Q346 272 342 266T330 250T309 230T276 214T230 207Q185 207 150 223Q116 240 90 276T54 357Q46 393 46 468Q46 469 46 484T47 502T48 520T51 540T55 559T61 579T69 599T81 620T96 640T115 661Q174 716 276 716Q299 716 317 714T369 698T426 658T471 580T499 456Q503 402 503 342Q503 115 392 29Q322 -22 231 -22Q163 -22 115 7L82 31Q76 38 81 46Q116 112 127 123Q130 126 134 126T148 116T179 97T226 87Q287 87 318 132Q323 139 326 146T332 165T337 182T340 204T342 225T345 249T347 272ZM201 547T201 454T211 329T262 294Q276 294 285 296T310 312T335 355Q347 391 347 447Q347 520 340 550T317 595Q300 612 277 612Q226 612 214 580",
  120822: "42 305Q42 450 111 535T257 621Q335 621 390 562Q482 468 482 306Q482 174 418 82T262 -10T106 82T42 305ZM257 545Q209 545 168 481T126 320Q126 220 162 147Q204 65 262 65Q318 65 358 139T398 320V328Q395 411 364 470T284 543Q270 545 257 545",
  120823: "99 461Q99 470 99 474T104 487T120 498T151 502Q213 517 251 596Q264 622 283 622Q308 622 319 597V76H373H401Q428 76 439 69T450 38Q450 11 428 1H127Q104 10 104 38Q104 62 115 69T153 76H181H235V269Q235 461 234 461Q184 426 137 424H133Q124 424 119 425T109 431T99 447V461",
  120824: "52 462Q52 528 110 575T247 622H250Q343 622 407 565T472 421Q472 371 446 324T390 248T308 178Q307 177 275 151T214 101L185 77Q185 76 286 76H388V87Q388 105 397 114T430 123T463 114Q470 107 471 100T472 61V42Q472 24 468 16T450 1H75Q53 10 53 32V38V48Q53 57 63 67T127 122Q153 144 169 157L289 256Q388 345 388 419Q388 473 346 509T231 545H224Q176 545 146 499L144 494Q155 476 155 459Q154 459 155 455T154 444T148 430T136 417T114 408Q113 408 110 408T104 407Q80 407 66 422T52 462",
  120825: "260 546Q233 546 211 541T180 531T171 524L174 514Q177 505 177 497Q177 476 162 461T125 446Q106 446 90 459T73 504Q76 540 98 565T150 601T203 616T239 621Q241 622 265 622Q322 620 362 602T420 558T444 513T451 478Q451 386 369 329L375 326Q381 323 386 320T401 311T419 298T436 283T452 263T466 240T475 212T479 180Q479 99 416 44T259 -11T105 28T44 130Q44 154 59 168T95 183Q117 183 132 169T148 131Q148 119 139 101Q175 65 260 65Q316 65 355 97T395 179Q395 211 375 240Q336 292 253 292H234H215Q194 292 185 299T175 330Q175 350 184 359Q192 368 238 370T309 384Q336 398 351 423T367 474Q367 496 350 513Q321 546 260 546",
  120826: "235 1Q213 10 213 32V38V46Q213 65 230 73Q236 76 274 76H314V168H183L52 169Q37 175 33 182T29 205V218L30 244Q53 283 155 443T264 613Q276 623 298 623H323H363Q378 616 385 601V244H429H450Q474 244 484 237T495 206Q495 179 477 171Q471 168 429 168H385V76H425H442Q466 76 476 69T487 38Q487 10 465 1H235ZM314 244V554L117 245L215 244H314",
  120827: "387 189Q387 244 354 278T273 313Q230 313 205 301T163 271T138 249H120Q102 249 97 251Q85 258 83 266T80 311Q80 320 80 359T81 430Q81 587 82 591Q88 605 103 610H108Q112 610 120 610T138 610T163 610T192 611T225 611T260 611H415Q416 610 421 607T428 602T432 596T436 587T437 573Q437 567 437 562T434 554T431 548T427 543T423 540T418 538L415 536L289 535H164V363L170 366Q175 368 184 372T207 380T238 386T276 389Q357 389 414 331T472 187Q472 116 412 53T245 -10Q218 -10 209 -9Q126 5 89 48T52 137Q52 164 68 177T104 191Q130 191 143 175T156 141Q156 132 154 125T149 113T146 107Q146 104 155 95T188 76T245 65Q298 65 342 98T387 189",
  120828: "357 536Q357 546 318 546Q258 546 205 497T133 357V353L144 361Q210 402 285 402Q362 402 414 350Q479 285 479 193Q479 111 418 50T263 -11Q234 -11 207 -3T149 26T97 81T60 171T45 301Q45 444 129 533T319 622Q388 622 421 589T454 510Q454 491 442 475T402 458Q373 458 362 475T350 510Q350 520 354 528L357 536ZM319 326T269 326T179 298T136 223Q136 202 143 174T176 112T237 68Q246 66 265 66Q319 66 360 107Q395 146 395 197Q395 250 356 289Q319 326 269 326",
  120829: "204 -10Q162 -10 162 40Q162 146 198 261T310 477Q311 478 321 491T342 517T358 535H128V524Q128 506 119 497Q111 489 86 489H78Q55 489 46 508Q44 513 44 557V580Q44 605 52 616T88 627H93Q114 627 125 611H458Q474 598 477 593T480 573Q480 559 478 553T469 543T446 521T408 477Q252 290 246 49Q246 43 246 37T246 27T245 22Q243 11 233 1T204 -10",
  120830: "58 460Q58 523 117 572T254 621Q290 621 298 620Q376 607 421 560T466 460Q466 441 460 424T443 393T421 370T397 352T374 340T357 332L350 330L356 328Q363 325 371 321T392 310T415 295T439 274T459 249T473 217T479 179Q479 102 418 46T262 -10T106 46T45 179Q45 202 52 222T70 257T96 284T123 305T148 319T167 328L174 330L170 332Q166 333 159 336T145 343Q104 362 81 393T58 460ZM382 458Q382 491 349 518T263 546Q215 546 179 521T142 458Q142 421 178 395T262 368Q315 368 348 396T382 458ZM396 178Q396 223 358 257T263 292Q206 292 167 258T128 178Q128 137 163 102T262 66Q324 66 360 101T396 178",
  120831: "392 259Q333 210 236 210H233Q163 210 109 262Q46 325 46 411T99 550Q164 622 264 622Q293 622 319 615T376 587T428 532T464 440T479 304Q479 167 400 78T217 -11Q140 -11 105 22T70 101Q70 124 84 138T122 153Q150 153 162 137T174 101Q174 91 168 76Q179 65 216 65Q267 65 300 93Q322 109 339 130T366 173T380 210T388 242T392 259ZM388 389Q388 438 357 492T268 546T185 520Q129 479 129 415Q129 384 138 363Q145 349 156 334T195 302T255 285Q305 285 345 313T388 389"
}, {
  8243: "′′",
  8244: "′′′",
  8246: "‵‵",
  8247: "‵‵‵",
  8279: "′′′′",
  8708: "∄",
  8716: "∌",
  8772: "≄",
  8777: "≉",
  8802: "≢",
  8813: "≭",
  8820: "≴",
  8821: "≵",
  8824: "≸",
  8825: "≹",
  8836: "⊄",
  8837: "⊅",
  8930: "⋢",
  8931: "⋣",
  10764: "∬∬"
});
var Wi = {}, Gi = {};
Object.defineProperty(Gi, "__esModule", { value: !0 });
Gi.sansSerifBoldItalic = void 0;
Gi.sansSerifBoldItalic = {
  305: [0.458, 0, 0.256],
  567: [0.458, 0.205, 0.286]
};
Object.defineProperty(Wi, "__esModule", { value: !0 });
Wi.sansSerifBoldItalic = void 0;
var kH = s3, IH = Gi;
Wi.sansSerifBoldItalic = (0, kH.AddPaths)(IH.sansSerifBoldItalic, {
  305: "54 431Q63 458 102 458H127H149Q192 458 199 433Q201 427 201 229T199 25Q190 0 149 0H125L81 1Q61 7 54 28V431",
  567: "-38 -84Q-36 -84 -14 -95T33 -106H38Q70 -103 78 -86Q83 -78 83 -49T84 180Q84 427 86 433Q93 458 136 458H158H180Q201 458 209 456T225 443Q230 436 231 418Q232 397 232 313V183V124V40Q232 -55 228 -87T203 -147Q166 -205 78 -205Q31 -205 -20 -189T-71 -159Q-71 -156 -59 -123Q-50 -96 -47 -91T-38 -84"
}, {});
var zi = {}, Ui = {};
Object.defineProperty(Ui, "__esModule", { value: !0 });
Ui.sansSerifBold = void 0;
Ui.sansSerifBold = {
  33: [0.694, 0, 0.367],
  34: [0.694, -0.442, 0.558],
  35: [0.694, 0.193, 0.917],
  36: [0.75, 0.056, 0.55],
  37: [0.75, 0.056, 1.029],
  38: [0.716, 0.022, 0.831],
  39: [0.694, -0.442, 0.306],
  40: [0.75, 0.249, 0.428],
  41: [0.75, 0.25, 0.428],
  42: [0.75, -0.293, 0.55],
  43: [0.617, 0.116, 0.856],
  44: [0.146, 0.106, 0.306],
  45: [0.273, -0.186, 0.367],
  46: [0.146, 0, 0.306],
  47: [0.75, 0.249, 0.55],
  58: [0.458, 0, 0.306],
  59: [0.458, 0.106, 0.306],
  61: [0.407, -0.094, 0.856],
  63: [0.705, 0, 0.519],
  64: [0.704, 0.011, 0.733],
  91: [0.75, 0.25, 0.343],
  93: [0.75, 0.25, 0.343],
  94: [0.694, -0.537, 0.55],
  95: [-0.023, 0.11, 0.55],
  126: [0.344, -0.198, 0.55],
  305: [0.458, 0, 0.256],
  567: [0.458, 0.205, 0.286],
  768: [0.694, -0.537, 0],
  769: [0.694, -0.537, 0],
  770: [0.694, -0.537, 0],
  771: [0.694, -0.548, 0],
  772: [0.66, -0.56, 0],
  774: [0.694, -0.552, 0],
  775: [0.695, -0.596, 0],
  776: [0.695, -0.595, 0],
  778: [0.694, -0.538, 0],
  779: [0.694, -0.537, 0],
  780: [0.657, -0.5, 0],
  8211: [0.327, -0.24, 0.55],
  8212: [0.327, -0.24, 1.1],
  8213: [0.327, -0.24, 1.1],
  8215: [-0.023, 0.11, 0.55],
  8216: [0.694, -0.443, 0.306],
  8217: [0.694, -0.442, 0.306],
  8220: [0.694, -0.443, 0.558],
  8221: [0.694, -0.442, 0.558],
  8260: [0.75, 0.249, 0.55],
  8710: [0.694, 0, 0.917]
};
Object.defineProperty(zi, "__esModule", { value: !0 });
zi.sansSerifBold = void 0;
var RH = s3, NH = Ui;
zi.sansSerifBold = (0, RH.AddPaths)(NH.sansSerifBold, {
  33: "111 669Q111 680 111 682T113 689T121 693T137 694H184H249Q255 686 256 681Q244 220 239 213Q236 208 229 208T183 207T137 207T127 213T118 431T111 669ZM110 71V95Q110 137 136 144Q140 146 183 146H200Q246 146 254 121Q256 115 256 73V51Q256 9 230 2Q225 0 181 0L138 1Q121 7 113 21L111 28L110 71",
  34: "38 687Q42 693 45 693Q46 694 111 694H176Q179 690 183 687V556L144 501Q139 494 134 486T126 474T120 465T114 457T110 451T106 447T102 445T98 443T94 443T89 442H73H62Q37 442 37 453Q37 458 55 501T74 546Q74 548 59 548L44 549L38 555V687ZM275 687Q279 693 282 693Q283 694 348 694H413Q416 690 420 687V556L381 501Q376 494 371 486T363 474T357 465T351 457T347 451T343 447T339 445T335 443T331 443T326 442H310H299Q274 442 274 453Q274 458 292 501T311 546Q311 548 296 548L281 549L275 555V687",
  35: "61 365Q61 370 62 375T65 383T69 390T74 395T80 399T85 403T90 406L94 407H344L381 536Q418 668 426 680Q431 687 445 692Q451 694 457 694Q477 694 488 682T500 651Q500 645 466 528T431 409Q431 407 504 407H577L609 521Q651 668 656 675Q669 693 691 693Q710 693 721 680T733 651Q733 645 699 528T664 409Q664 407 743 407H823L827 405Q831 403 834 402T841 397T848 389T853 379T855 365Q855 337 823 324L731 323H639L619 253Q599 181 598 180V177H823L827 175Q831 173 834 172T841 167T848 159T853 149T855 135Q855 107 823 94L698 93H573L540 -21Q498 -168 493 -175Q480 -193 458 -193Q439 -193 428 -180T416 -151Q416 -144 450 -27T485 91Q485 93 412 93H340L307 -21Q265 -168 260 -175Q247 -193 225 -193Q206 -193 195 -180T183 -151Q183 -144 217 -27T252 91Q252 93 173 93L94 94Q61 105 61 135Q61 140 62 145T65 153T69 160T74 165T80 169T85 173T90 176L94 177H185L277 178L297 248L318 320V323H206L94 324Q61 335 61 365ZM551 320V323H479Q406 323 405 322Q404 319 385 249T365 178T438 177L510 178L530 248L551 320",
  36: "231 712L232 716Q232 719 232 722T234 729T239 736T246 743T256 748T271 750Q318 750 318 711V703Q393 692 451 656Q469 645 470 640Q470 635 461 587L453 537Q445 529 442 529Q438 529 424 540T384 565T330 585Q328 585 325 585T320 586L318 587V434Q322 433 333 429T350 424T365 418T382 409T399 397T419 380Q488 313 488 213Q488 24 334 -5L318 -8V-17Q318 -56 279 -56H272Q253 -56 243 -46T232 -30T231 -18V-8H224Q170 2 127 20T68 50T49 67Q49 71 58 122T68 176Q71 182 79 182Q83 182 98 169T145 138T216 110Q228 108 229 108H231V288Q167 299 114 356T61 496Q61 537 70 570T94 624T126 661T162 684T195 696T219 701L228 702H231V712ZM231 521Q231 583 230 583Q226 582 220 579T204 561T193 521Q193 491 212 472Q226 458 230 458Q231 458 231 521ZM318 112Q356 131 356 187Q356 237 318 263V112",
  37: "61 549Q61 733 218 749Q220 749 228 749T241 750Q286 750 321 735T369 708T389 683Q422 634 422 548V538Q422 519 420 501T408 453T381 401T328 364T243 347Q61 347 61 549ZM292 549Q292 663 242 663Q221 663 211 648T198 615T196 566V548Q196 471 206 454Q218 434 242 434Q292 434 292 549ZM243 -55Q223 -55 212 -42T201 -13Q201 -2 207 7Q209 11 480 371T758 738Q770 750 788 750Q805 750 817 738T830 709Q830 694 820 681L544 315Q273 -43 269 -47Q258 -55 243 -55ZM606 146Q606 330 763 346Q764 346 773 346T786 347Q831 347 866 332T914 305T934 280Q966 233 966 146V135Q966 115 964 97T952 49T925 -2T872 -40T788 -56Q606 -56 606 146ZM742 146V132Q742 107 743 93T748 62T762 39T787 31Q819 31 832 79Q837 97 837 146Q837 260 787 260Q767 260 757 246T744 214T742 169V146",
  38: "757 117Q762 117 769 110V3Q759 -7 718 -14T641 -22T571 -15T518 1T477 19T453 31L437 23Q350 -19 257 -22Q158 -22 103 30T47 155Q47 188 57 216T87 263T119 292T151 313L182 333L187 336L181 349Q150 431 150 506Q150 605 211 660T347 716Q417 716 471 668T526 543Q526 517 518 495T471 432T360 343L342 330Q342 327 358 306T402 250T458 189L467 181Q518 225 556 289T607 395L620 437Q622 443 630 443Q631 443 679 430Q718 420 725 418T733 409Q733 402 722 365T670 255T573 123Q562 111 563 111Q589 94 644 94Q678 94 703 100T740 111T757 117ZM397 544Q397 573 384 601T346 629Q320 629 299 607T277 538Q277 484 295 429Q301 413 301 412Q302 409 309 415Q397 476 397 544ZM227 258Q197 228 197 177Q197 150 207 126T234 95Q242 93 251 93Q288 93 337 107L349 110L328 131Q266 196 234 248L227 258",
  39: "81 687Q85 693 88 693Q89 694 154 694H219Q222 690 226 687V556L187 501Q182 494 177 486T169 474T163 465T157 457T153 451T149 447T145 445T141 443T137 443T132 442H116H105Q80 442 80 453Q80 458 98 501T117 546Q117 548 102 548L87 549L81 555V687",
  40: "79 250Q79 352 100 441T152 585T213 678T266 733L287 749Q288 750 324 750H359Q366 741 366 738Q366 734 356 721T329 682T296 623T262 531T238 407Q230 346 230 250Q230 142 244 55T278 -82T318 -165T352 -215T366 -238Q366 -242 359 -249H286L277 -242Q79 -74 79 250",
  41: "61 737Q61 750 85 750H106H141L150 742Q348 574 348 250T150 -242L141 -249L106 -250H87Q61 -250 61 -238Q61 -233 74 -216Q157 -113 183 51Q197 130 197 250T183 449Q174 505 158 554T126 634T95 687T71 722T61 737",
  42: "241 579Q241 582 228 639T215 702Q215 722 233 736T271 750Q296 750 315 736T334 702V697Q334 693 328 664T314 607L308 579L352 620Q389 654 397 660T417 668Q447 668 464 647T482 602Q482 591 479 583T472 569T459 559T443 552T421 546T397 538L342 521L397 504Q405 501 420 497T442 490T458 483T472 473T479 460T482 440Q482 416 465 395T417 374Q406 375 398 381T352 422L308 463L314 435Q321 407 327 378T334 345Q336 333 327 319T296 295Q288 293 275 293Q241 293 227 311T215 345Q215 349 221 378T234 435L241 463L197 422Q160 388 152 382T132 374Q102 374 85 395T67 440Q67 451 70 459T77 473T90 483T106 490T128 496T152 504L207 521L152 538Q144 541 129 545T107 552T91 559T77 569T70 582T67 602Q67 626 84 647T132 668Q143 667 151 661T197 620L241 579",
  43: "61 250Q61 276 94 292H386V436V535Q386 577 388 589T401 607Q411 617 427 617Q458 617 468 587Q470 581 470 436V292H762L766 290Q770 288 773 287T780 282T787 274T792 264T794 250Q794 222 762 209L616 208H470V64Q470 -81 468 -87Q458 -116 428 -116T388 -87Q386 -81 386 64V208H240L94 209Q61 220 61 250",
  44: "81 139Q85 145 88 145Q89 146 154 146H219Q222 142 226 139V8L187 -47Q182 -54 177 -62T169 -74T163 -83T157 -91T153 -97T149 -101T145 -103T141 -105T137 -105T132 -106H116H105Q80 -106 80 -95Q80 -90 98 -47T117 -2Q117 0 102 0L87 1L81 7V139",
  45: "12 230Q12 257 26 265T80 274Q88 274 114 274T158 273T201 273T235 274Q276 274 290 266T305 230T291 194T235 185Q226 185 201 185T159 186Q143 186 119 186T85 185Q43 185 28 193T12 230",
  46: "219 146Q222 142 226 139V7L222 4L219 1L154 0Q102 0 94 0T82 6Q80 9 80 74L81 139Q85 145 88 145Q89 146 154 146H219",
  47: "103 -249Q81 -249 71 -235T61 -207Q61 -201 62 -198Q64 -192 235 265T409 727Q418 750 445 750Q464 750 476 737T488 707Q488 701 313 234Q143 -225 137 -232Q126 -249 103 -249",
  58: "226 319L219 313H87L81 319L80 384Q80 437 80 445T86 456Q89 458 154 458H219Q222 454 226 451V319ZM219 146Q222 142 226 139V7L222 4L219 1L154 0Q102 0 94 0T82 6Q80 9 80 74L81 139Q85 145 88 145Q89 146 154 146H219",
  59: "226 319L219 313H87L81 319L80 384Q80 437 80 445T86 456Q89 458 154 458H219Q222 454 226 451V319ZM81 139Q85 145 88 145Q89 146 154 146H219Q222 142 226 139V8L187 -47Q182 -54 177 -62T169 -74T163 -83T157 -91T153 -97T149 -101T145 -103T141 -105T137 -105T132 -106H116H105Q80 -106 80 -95Q80 -90 98 -47T117 -2Q117 0 102 0L87 1L81 7V139",
  61: "94 324Q61 335 61 366Q61 396 91 405Q96 407 429 407H762Q763 406 767 404T774 400T781 395T787 387T792 378T794 365Q794 338 762 324H94ZM94 94Q61 105 61 135Q61 149 69 160T92 175Q97 177 430 177H762L766 175Q770 173 773 172T780 167T787 159T792 149T794 135Q794 107 762 94H94",
  63: "61 644Q61 652 87 666T157 693T244 705Q344 705 400 671T457 551Q457 516 446 490T422 451T387 421T356 391Q330 361 318 332T305 292T303 252Q303 218 300 213T290 208T244 207H220Q194 207 188 213Q187 214 186 215V255Q187 282 188 296T198 345T229 417T288 496Q306 515 306 559Q306 596 296 607T253 618Q214 618 185 607T143 583T120 558T103 547Q99 547 95 551Q93 553 77 597T61 644ZM171 71V95Q171 137 197 144Q201 146 244 146H261Q307 146 315 121Q317 115 317 73V51Q317 9 291 2Q286 0 242 0L199 1Q182 7 174 21L172 28L171 71",
  64: "61 264T61 347T82 494T136 596T217 660T311 694T410 704Q460 704 471 703Q534 694 577 666Q633 623 651 552T670 370V342Q670 249 633 195Q583 116 454 116Q238 116 238 347Q238 443 276 499Q328 578 456 578Q488 578 494 577L504 575Q475 617 430 617H421Q196 617 196 347Q196 215 253 143Q310 76 427 76Q499 76 561 102L575 107H664Q671 97 671 94V89L663 81Q566 -11 422 -11Q365 -11 316 -2T219 33T137 97T82 200ZM469 490Q459 492 453 492Q429 492 405 472Q374 439 374 347Q374 233 423 210Q436 202 454 202L486 210Q536 228 536 347Q536 461 486 484Q476 490 469 490",
  91: "318 -206Q318 -235 305 -243T255 -251Q248 -251 229 -251T198 -250H143Q112 -250 99 -246T81 -225Q79 -219 79 250T81 725Q85 741 98 745T143 750H198Q210 750 229 750T255 751Q291 751 304 743T318 707Q318 680 301 668Q293 663 255 663H224V-163H255Q293 -163 301 -168Q318 -180 318 -206",
  93: "24 706Q24 734 39 742T90 751Q97 751 114 751T143 750H198Q230 750 243 746T261 725Q263 719 263 250T261 -225Q257 -241 244 -245T198 -250H143Q131 -250 112 -250T86 -251Q50 -251 37 -243T24 -207Q24 -180 41 -168Q49 -163 87 -163H118V663H87H71Q24 663 24 706",
  94: "108 550Q108 554 135 589T190 658T219 692Q221 694 275 694Q328 694 330 693Q331 692 381 629T438 557Q441 553 441 549T434 538L399 537Q363 537 362 538Q361 538 318 575L275 611Q274 611 231 575Q188 538 187 538Q186 537 150 537L115 538Q108 545 108 550",
  95: "0 -66Q0 -32 26 -25Q30 -23 274 -23Q469 -23 497 -23T532 -28Q549 -40 549 -67Q549 -93 532 -105Q525 -109 498 -109T275 -110Q31 -110 26 -108Q0 -101 0 -66",
  126: "92 215Q92 259 122 301T204 344Q238 344 264 329T310 300T343 285Q356 285 361 295T369 322T377 344H450Q457 334 457 330Q457 281 427 240T344 198Q312 198 285 213T239 242T206 257Q188 257 182 230T172 199L137 198H120Q102 198 97 200T92 215",
  305: "54 431Q63 458 102 458H127H149Q192 458 199 433Q201 427 201 229T199 25Q190 0 149 0H125L81 1Q61 7 54 28V431",
  567: "-38 -84Q-36 -84 -14 -95T33 -106H38Q70 -103 78 -86Q83 -78 83 -49T84 180Q84 427 86 433Q93 458 136 458H158H180Q201 458 209 456T225 443Q230 436 231 418Q232 397 232 313V183V124V40Q232 -55 228 -87T203 -147Q166 -205 78 -205Q31 -205 -20 -189T-71 -159Q-71 -156 -59 -123Q-50 -96 -47 -91T-38 -84",
  768: "-458 682Q-458 690 -452 692T-426 694H-381H-314L-312 691Q-311 691 -305 682T-287 655T-263 622L-218 555V549Q-218 544 -224 538L-259 537Q-295 537 -296 538Q-298 539 -376 606T-456 676Q-458 680 -458 682",
  769: "-290 537H-310Q-334 537 -334 549Q-334 553 -311 588T-264 656L-241 690Q-240 690 -239 691T-236 693Q-235 694 -167 694H-100Q-93 684 -93 681T-94 677Q-95 675 -173 607T-255 538Q-256 537 -290 537",
  770: "-442 550Q-442 554 -415 589T-360 658T-331 692Q-329 694 -275 694Q-222 694 -220 693Q-219 692 -169 629T-112 557Q-109 552 -109 549Q-109 545 -116 538L-151 537Q-187 537 -188 538Q-189 538 -232 575L-275 611Q-276 611 -319 575Q-362 538 -363 538Q-364 537 -400 537L-435 538Q-442 545 -442 550",
  771: "-458 565Q-458 609 -428 651T-346 694Q-312 694 -286 679T-240 650T-207 635Q-194 635 -189 645T-181 672T-173 694H-100Q-93 684 -93 680Q-93 631 -123 590T-206 548Q-238 548 -265 563T-311 592T-344 607Q-362 607 -368 580T-378 549L-413 548H-430Q-448 548 -453 550T-458 565",
  772: "-84 660Q-81 656 -77 653V567L-81 564L-84 561L-274 560H-383Q-469 560 -471 565L-472 566Q-474 569 -474 611L-473 653Q-469 659 -466 659Q-465 660 -274 660H-84",
  774: "-123 694Q-80 694 -80 657Q-80 626 -99 601T-161 563Q-199 552 -275 552Q-352 552 -389 563Q-470 586 -470 655Q-470 667 -468 673Q-457 694 -435 694H-431Q-408 694 -396 685Q-387 676 -387 671Q-384 661 -275 661Q-167 661 -164 671Q-164 674 -163 677T-151 687T-123 694",
  775: "-329 596Q-346 602 -351 611T-356 638V646Q-356 653 -356 654T-356 661T-355 668T-353 673T-351 679T-347 684T-341 689T-332 693T-274 695H-221Q-202 683 -198 676T-194 645Q-194 632 -195 625T-202 610T-221 596H-329",
  776: "-331 695Q-312 683 -308 676T-304 645Q-304 632 -304 626T-311 610T-331 596L-380 595H-408Q-448 595 -457 617Q-459 621 -459 645T-457 673Q-448 696 -409 696Q-405 696 -396 696T-380 695H-331ZM-247 644Q-247 658 -246 665T-239 680T-221 694Q-217 695 -169 695H-143Q-102 695 -93 672Q-91 664 -91 645V635Q-91 613 -106 602Q-113 597 -121 596T-171 595L-219 596Q-232 600 -238 608T-246 622T-247 644",
  778: "-365 616Q-365 658 -331 676T-256 694Q-253 694 -247 694T-236 693Q-166 693 -139 666Q-119 644 -119 616T-139 565Q-166 538 -237 538H-242Q-365 538 -365 616ZM-181 616Q-181 641 -195 647T-242 654Q-258 654 -266 654T-284 650T-298 638T-303 616Q-303 592 -289 585T-242 577Q-209 577 -195 584T-181 616",
  779: "-426 686Q-424 694 -394 694H-350H-283Q-277 686 -277 682Q-277 673 -317 608T-361 538L-396 537H-420Q-432 537 -436 539T-440 548Q-440 560 -434 616Q-432 633 -430 650T-427 677L-426 686ZM-243 686Q-241 694 -211 694H-167H-100Q-94 686 -94 682Q-94 673 -134 608T-178 538L-213 537H-237Q-249 537 -253 539T-257 548Q-257 560 -251 616Q-249 633 -247 650T-244 677L-243 686",
  780: "-442 645Q-442 657 -418 657H-398Q-393 657 -388 657T-379 657T-371 656T-365 656H-363L-319 620L-276 583Q-275 583 -232 619Q-189 656 -188 656Q-187 657 -151 657H-116Q-109 649 -109 645Q-109 642 -112 637Q-118 629 -168 566T-220 501Q-222 500 -275 500Q-329 500 -331 501Q-442 634 -442 645",
  8211: "0 284Q0 318 26 325Q30 327 274 327Q469 327 497 327T532 322Q549 310 549 283Q549 257 532 245Q525 241 498 241T275 240Q31 240 26 242Q0 249 0 284",
  8212: "0 284Q0 318 26 325Q30 327 549 327T1073 325Q1099 318 1099 284Q1099 249 1073 242Q1068 240 549 240Q31 240 26 242Q0 249 0 284",
  8213: "0 284Q0 318 26 325Q30 327 549 327T1073 325Q1099 318 1099 284Q1099 249 1073 242Q1068 240 549 240Q31 240 26 242Q0 249 0 284",
  8215: "0 -66Q0 -32 26 -25Q30 -23 274 -23Q469 -23 497 -23T532 -28Q549 -40 549 -67Q549 -93 532 -105Q525 -109 498 -109T275 -110Q31 -110 26 -108Q0 -101 0 -66",
  8216: "87 443L81 449V581L119 636Q125 644 131 653T141 667T148 677T154 685T158 689T163 692T167 693T173 694H190H201Q226 694 226 683Q226 678 208 635T189 590Q189 588 204 588H219Q222 584 226 581V449L219 443H87",
  8217: "81 687Q85 693 88 693Q89 694 154 694H219Q222 690 226 687V556L187 501Q182 494 177 486T169 474T163 465T157 457T153 451T149 447T145 445T141 443T137 443T132 442H116H105Q80 442 80 453Q80 458 98 501T117 546Q117 548 102 548L87 549L81 555V687",
  8220: "144 443L138 449V581L176 636Q182 644 188 653T198 667T205 677T211 685T215 689T220 692T224 693T230 694H247H258Q283 694 283 683Q283 678 265 635T246 590Q246 588 261 588H276Q279 584 283 581V449L276 443H144ZM381 443L375 449V581L413 636Q419 644 425 653T435 667T442 677T448 685T452 689T457 692T461 693T467 694H484H495Q520 694 520 683Q520 678 502 635T483 590Q483 588 498 588H513Q516 584 520 581V449L513 443H381",
  8221: "38 687Q42 693 45 693Q46 694 111 694H176Q179 690 183 687V556L144 501Q139 494 134 486T126 474T120 465T114 457T110 451T106 447T102 445T98 443T94 443T89 442H73H62Q37 442 37 453Q37 458 55 501T74 546Q74 548 59 548L44 549L38 555V687ZM275 687Q279 693 282 693Q283 694 348 694H413Q416 690 420 687V556L381 501Q376 494 371 486T363 474T357 465T351 457T347 451T343 447T339 445T335 443T331 443T326 442H310H299Q274 442 274 453Q274 458 292 501T311 546Q311 548 296 548L281 549L275 555V687",
  8260: "103 -249Q81 -249 71 -235T61 -207Q61 -201 62 -198Q64 -192 235 265T409 727Q418 750 445 750Q464 750 476 737T488 707Q488 701 313 234Q143 -225 137 -232Q126 -249 103 -249",
  8710: "381 692Q386 694 458 694Q516 694 527 693T549 687Q564 680 575 663Q576 658 715 349T856 27Q856 6 838 1H826Q815 1 795 1T747 1T686 1T616 0T539 0T458 0T378 0T300 0T230 0T169 1T122 1T90 1H78Q60 6 60 27Q62 38 201 349T341 663Q356 687 381 692ZM627 148Q626 149 581 250T492 453L447 554Q447 553 446 552Q444 546 326 278L268 148Q268 147 448 147Q627 147 627 148"
}, {});
var Xi = {}, qi = {};
Object.defineProperty(qi, "__esModule", { value: !0 });
qi.sansSerifItalic = void 0;
qi.sansSerifItalic = {
  33: [0.694, 0, 0.319, { ic: 0.036 }],
  34: [0.694, -0.471, 0.5],
  35: [0.694, 0.194, 0.833, { ic: 0.018 }],
  36: [0.75, 0.056, 0.5, { ic: 0.065 }],
  37: [0.75, 0.056, 0.833],
  38: [0.716, 0.022, 0.758],
  39: [0.694, -0.471, 0.278, { ic: 0.057 }],
  40: [0.75, 0.25, 0.389, { ic: 0.102 }],
  41: [0.75, 0.25, 0.389],
  42: [0.75, -0.306, 0.5, { ic: 0.068 }],
  43: [0.583, 0.083, 0.778],
  44: [0.098, 0.125, 0.278],
  45: [0.259, -0.186, 0.333],
  46: [0.098, 0, 0.278],
  47: [0.75, 0.25, 0.5, { ic: 0.1 }],
  48: [0.678, 0.022, 0.5, { ic: 0.049 }],
  49: [0.678, 0, 0.5],
  50: [0.678, 0, 0.5, { ic: 0.051 }],
  51: [0.678, 0.022, 0.5, { ic: 0.044 }],
  52: [0.656, 0, 0.5, { ic: 0.021 }],
  53: [0.656, 0.022, 0.5, { ic: 0.055 }],
  54: [0.678, 0.022, 0.5, { ic: 0.048 }],
  55: [0.656, 0.011, 0.5, { ic: 0.096 }],
  56: [0.678, 0.022, 0.5, { ic: 0.054 }],
  57: [0.677, 0.022, 0.5, { ic: 0.045 }],
  58: [0.444, 0, 0.278],
  59: [0.444, 0.125, 0.278],
  61: [0.37, -0.13, 0.778, { ic: 0.018 }],
  63: [0.704, 0, 0.472, { ic: 0.064 }],
  64: [0.705, 0.01, 0.667, { ic: 0.04 }],
  91: [0.75, 0.25, 0.289, { ic: 0.136 }],
  93: [0.75, 0.25, 0.289, { ic: 0.064 }],
  94: [0.694, -0.527, 0.5, { ic: 0.033 }],
  95: [-0.038, 0.114, 0.5, { ic: 0.065 }],
  126: [0.327, -0.193, 0.5, { ic: 0.06 }],
  305: [0.444, 0, 0.239, { ic: 0.019 }],
  567: [0.444, 0.204, 0.267, { ic: 0.019 }],
  768: [0.694, -0.527, 0],
  769: [0.694, -0.527, 0, { ic: 0.063 }],
  770: [0.694, -0.527, 0, { ic: 0.033 }],
  771: [0.677, -0.543, 0, { ic: 0.06 }],
  772: [0.631, -0.552, 0, { ic: 0.064 }],
  774: [0.694, -0.508, 0, { ic: 0.073 }],
  775: [0.68, -0.576, 0],
  776: [0.68, -0.582, 0, { ic: 0.04 }],
  778: [0.693, -0.527, 0],
  779: [0.694, -0.527, 0, { ic: 0.063 }],
  780: [0.654, -0.487, 0, { ic: 0.06 }],
  913: [0.694, 0, 0.667],
  914: [0.694, 0, 0.667, { ic: 0.029 }],
  915: [0.691, 0, 0.542, { ic: 0.104 }],
  916: [0.694, 0, 0.833],
  917: [0.691, 0, 0.597, { ic: 0.091 }],
  918: [0.694, 0, 0.611, { ic: 0.091 }],
  919: [0.694, 0, 0.708, { ic: 0.06 }],
  920: [0.715, 0.022, 0.778, { ic: 0.026 }],
  921: [0.694, 0, 0.278, { ic: 0.06 }],
  922: [0.694, 0, 0.694, { ic: 0.091 }],
  923: [0.694, 0, 0.611],
  924: [0.694, 0, 0.875, { ic: 0.054 }],
  925: [0.694, 0, 0.708, { ic: 0.058 }],
  926: [0.688, 0, 0.667, { ic: 0.098 }],
  927: [0.716, 0.022, 0.736, { ic: 0.027 }],
  928: [0.691, 0, 0.708, { ic: 0.06 }],
  929: [0.694, 0, 0.639, { ic: 0.051 }],
  931: [0.694, 0, 0.722, { ic: 0.091 }],
  932: [0.688, 0, 0.681, { ic: 0.109 }],
  933: [0.716, 0, 0.778, { ic: 0.065 }],
  934: [0.694, 0, 0.722, { ic: 0.021 }],
  935: [0.694, 0, 0.667, { ic: 0.091 }],
  936: [0.694, 0, 0.778, { ic: 0.076 }],
  937: [0.716, 0, 0.722, { ic: 0.047 }],
  8211: [0.312, -0.236, 0.5, { ic: 0.065 }],
  8212: [0.312, -0.236, 1, { ic: 0.065 }],
  8213: [0.312, -0.236, 1, { ic: 0.065 }],
  8215: [-0.038, 0.114, 0.5, { ic: 0.065 }],
  8216: [0.694, -0.471, 0.278, { ic: 0.058 }],
  8217: [0.694, -0.471, 0.278, { ic: 0.057 }],
  8220: [0.694, -0.471, 0.5, { ic: 0.114 }],
  8221: [0.694, -0.471, 0.5],
  8260: [0.75, 0.25, 0.5, { ic: 0.1 }],
  8710: [0.694, 0, 0.833]
};
Object.defineProperty(Xi, "__esModule", { value: !0 });
Xi.sansSerifItalic = void 0;
var PH = s3, BH = qi;
Xi.sansSerifItalic = (0, PH.AddPaths)(BH.sansSerifItalic, {
  33: "160 187L257 694H306Q355 694 355 693L238 186H199Q160 186 160 187ZM110 2Q111 3 120 49T131 96Q131 98 180 98T229 96L219 50Q209 3 208 2V0H110V2",
  34: "171 647L180 694H229Q278 694 278 693L276 686Q275 680 273 668T268 644L258 597L182 471H157Q133 471 133 472L189 595Q189 596 174 596H160V598Q160 601 171 647ZM365 647L374 694H423Q472 694 472 693L470 686Q469 680 467 668T462 644L452 597L376 471H351Q327 471 327 472L383 595Q383 596 368 596H354V598Q354 601 365 647",
  35: "793 170Q809 162 809 149Q809 145 807 141T802 135T796 132L793 130H547L472 -27Q397 -184 394 -187Q389 -194 379 -194Q367 -194 362 -183Q359 -179 359 -173Q360 -168 431 -20L503 129Q503 130 410 130H317L242 -27Q167 -184 164 -187Q159 -194 149 -194Q137 -194 132 -183Q129 -179 129 -173Q130 -168 201 -19L273 130H187L100 131Q87 141 87 150Q87 162 102 170H294L331 248Q339 265 349 286T365 318L370 328Q370 330 258 330Q145 330 142 332Q129 338 129 351Q129 362 140 368Q146 370 267 370L391 371L467 527Q542 684 544 686Q544 688 549 691T560 694H562Q565 693 567 692T571 690T575 686T578 681T579 672Q577 665 507 520T436 373L435 370H528L621 371L692 518Q767 675 769 677Q775 694 789 694Q798 694 804 688T809 672Q806 664 737 519L665 371L751 370Q835 370 841 368Q851 362 851 350Q851 337 841 334T799 330H765H741H645L606 250L568 170H793ZM600 328Q600 330 508 330H415Q412 326 338 171Q338 170 431 170H524L561 248Q569 265 579 286T595 318L600 328",
  36: "228 70Q233 92 246 155T270 266T280 316Q271 318 265 320T237 333T200 360T172 403T159 468Q159 537 205 600T325 691Q352 701 360 701Q361 701 361 701T362 703T364 711T368 727L372 750H409Q445 750 445 749L436 705Q436 703 450 702T494 691T554 657L565 649Q562 642 548 604L534 568Q511 591 484 605T440 621L424 623L419 624L372 405Q399 400 424 384Q490 338 490 247V240Q490 156 430 85Q374 13 294 -5L284 -7L280 -30Q279 -35 278 -41T275 -52L274 -55Q274 -56 237 -56Q201 -56 201 -54Q202 -53 205 -34T211 -11Q211 -9 206 -9Q154 -2 115 19Q80 35 56 59L88 141L99 131Q109 121 119 113T141 99T160 89T180 82T197 77T214 73T228 70ZM303 426Q304 427 313 471T332 564T345 620L335 616Q287 596 263 549Q252 525 252 499Q252 470 267 451T298 426Q303 424 303 426ZM302 75Q305 75 315 80T340 98T367 125T390 164T399 214Q399 247 384 268T349 297Q338 247 326 186L302 75",
  37: "268 347Q224 347 195 386T165 488Q165 517 173 552Q191 637 246 693T349 749Q389 749 414 725T448 673T456 614Q456 506 396 427T268 347ZM372 604Q372 674 339 674Q311 674 290 633T261 549T253 482V474Q253 438 272 426Q277 424 286 424Q319 424 345 485T372 604ZM189 -56Q179 -56 173 -49T167 -37Q167 -30 347 198Q425 296 475 360Q780 745 785 747Q790 750 796 750Q814 748 814 730Q814 725 811 719L204 -49Q198 -56 189 -56ZM523 87Q523 184 583 265T713 347Q758 347 786 308T815 207Q815 110 757 28T629 -55Q576 -55 550 -12T523 87ZM729 200Q729 271 696 271Q675 271 658 247T631 189T616 125T611 76Q611 21 644 21H647Q672 21 700 77T729 200",
  38: "219 -22Q158 -22 117 13T71 111Q71 131 74 150T84 185T98 215T118 241T137 262T159 281T179 295T199 308L214 318L258 348L256 362Q254 373 254 413V435Q254 483 271 537T325 641T411 708Q427 715 441 715Q446 716 455 716Q504 716 534 681T565 590Q565 522 519 468T377 347L358 334Q359 333 363 320T374 290T387 262Q404 227 428 187T460 139Q521 183 574 251T651 362T674 409L710 398Q746 388 747 388Q747 381 720 333T635 213T517 94L510 87Q542 57 598 57Q649 57 708 72Q716 75 718 75L709 34L701 -7Q636 -22 578 -22Q531 -22 498 -8T428 34L408 25Q314 -22 219 -22ZM480 579Q480 640 436 640Q410 640 385 615T351 554Q340 513 340 457Q340 413 343 410Q343 406 360 419Q431 471 455 505T480 579ZM245 57Q279 59 311 67T359 81T375 89T358 113T318 178T281 260L274 277L245 257Q167 205 167 135Q167 110 174 93T194 69T217 60T237 57H245",
  39: "228 647L237 694H286Q335 694 335 693L334 686Q332 680 330 668T325 644L315 597L239 471H214Q190 471 190 472L246 595Q246 596 231 596H217V598Q217 601 228 647",
  40: "195 37Q195 -7 200 -47T213 -113T231 -166T250 -204T268 -232T280 -250H204L194 -238Q104 -124 104 55Q104 238 181 432T405 740L417 750H454Q491 750 491 749L468 729Q446 709 411 667T337 565T262 405T208 188Q195 110 195 37",
  41: "300 463Q300 634 222 740L214 750H290L299 740Q300 738 309 726T323 707T337 682T353 651T367 613T379 566T387 510T390 444Q390 314 344 156T203 -125Q179 -155 145 -191Q111 -224 89 -241L78 -250H2Q4 -248 27 -227T65 -189T107 -140T155 -71T200 16T244 129T278 266Q300 372 300 463",
  42: "193 608Q193 628 210 644T246 660Q250 660 252 660T257 658T264 654T272 648T284 638T302 623Q340 590 340 593Q341 594 345 623T354 682T360 715Q365 729 378 739T407 750Q424 750 433 740T443 720Q443 712 427 652L410 591L462 623Q505 650 514 655T534 660Q549 660 558 650T568 625Q568 617 567 611T560 599T551 590T536 580T519 571T496 561T470 548L429 528L474 500Q482 495 492 489T506 481T516 475T523 469T527 464T529 458T530 450Q530 430 514 414T479 397H475Q468 397 460 402T423 433Q414 440 404 448T388 461L383 465L365 344Q348 306 314 306Q302 306 292 313T281 338Q281 347 297 404L313 464L260 433Q201 397 195 397H189Q173 397 165 407T156 432Q156 438 157 443T161 452T166 460T175 468T185 475T198 482T212 489T230 497T250 506L295 528L250 556Q203 582 202 585Q193 591 193 608",
  43: "108 244T108 250T112 261T119 268T124 270H426V272Q428 274 457 419Q489 565 492 573Q497 583 508 583Q516 583 522 577T528 565Q528 553 498 417Q491 384 483 346T471 288L467 270H760Q775 262 775 250T760 230H458Q456 221 426 77T394 -71Q389 -83 375 -83Q367 -83 362 -78T356 -64Q356 -58 387 84Q394 118 401 155T413 210L417 229Q417 230 271 230H124Q123 230 120 232T112 239",
  44: "90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2Q188 0 149 -63L112 -125H63L120 0H105Q90 0 90 2",
  45: "66 257V259H332V257L324 220L317 186H184Q51 186 51 187T58 220T66 257",
  46: "90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2V0H90V2",
  47: "564 744L568 747Q573 750 579 750Q588 750 594 744T599 729Q597 721 321 241T41 -243Q37 -250 27 -250Q6 -250 6 -230Q6 -228 8 -222Q9 -219 285 261T564 744",
  48: "245 -22Q209 -22 181 -11T135 20T107 65T92 116T88 171Q88 235 114 354T194 557Q226 606 269 635T340 671T392 678H395Q422 678 446 670T495 643T534 582T549 481Q549 430 534 350T499 213Q459 89 379 25Q315 -22 247 -22H245ZM430 582Q408 601 378 601Q313 601 269 534Q234 475 205 341Q181 232 181 174Q181 104 209 76Q231 54 260 54T318 73T368 125Q410 194 447 375Q460 445 460 487Q460 555 430 582",
  49: "234 613Q277 613 331 628T428 678H439Q451 678 451 676Q450 671 387 373T323 74T384 73H445L430 0H259L88 1L104 73H229L332 560Q278 541 198 539Q198 540 198 541T199 546T200 554T202 564T205 576L213 612H219Q221 612 226 612T234 613",
  50: "190 460Q189 460 181 475T164 507T155 527Q155 535 182 571Q259 678 380 678Q462 678 506 630T551 513V507Q551 418 487 349Q469 329 441 305T391 265T344 232T316 212Q158 87 158 86T188 85Q194 85 234 85T311 86Q467 86 467 85Q451 9 449 2V0H50Q54 18 58 40L67 79L133 133Q246 226 269 243Q369 318 410 373T452 492Q452 535 433 560T393 592T350 599Q311 599 279 578T231 532T203 484T190 460",
  51: "446 542Q446 576 424 590T372 605Q330 605 288 583T216 524Q209 515 208 516Q207 517 192 549L178 580L187 589Q224 627 276 652T386 678Q456 678 500 642T544 550Q544 515 530 482T495 427T453 387T418 362L403 353L413 348Q440 335 462 313Q500 271 500 217Q500 135 423 57T236 -22T63 59L56 68L85 141Q106 112 125 98Q177 54 254 54Q315 54 355 105T396 218Q396 242 393 254Q380 301 335 313Q327 315 280 316Q233 316 233 318L249 392Q298 392 322 399Q373 408 409 453T446 542",
  52: "78 235L411 656H465Q519 656 519 655T475 447T430 237V235H521V233L505 160Q505 159 459 159H414L380 0H286L320 159H62L63 164Q64 169 66 179T70 198L78 235ZM342 235L421 607Q420 607 419 604Q409 535 197 267Q173 236 173 235H342",
  53: "330 350Q263 350 214 272H133V275Q134 276 174 467L214 655Q214 656 385 656H555V653Q555 652 554 647T550 631T546 613L539 577H284L265 486Q261 464 256 441T248 406L246 395L250 398Q255 401 264 406T286 415T315 423T350 427Q412 427 455 381T498 256Q498 150 415 64T222 -22Q186 -22 155 -12T105 12T74 41T55 65T50 77L51 79Q61 89 78 112L104 145L107 138Q110 130 114 123T125 106T142 88T165 72T196 60T236 55Q282 55 316 79T366 140T389 208T396 267Q396 310 378 330T337 350H330",
  54: "437 605Q397 605 361 585T301 536T261 477T236 426T228 401L236 408Q244 414 260 424T296 445T345 462T402 469H404Q422 469 434 467T465 446T498 394Q515 351 515 307Q515 254 497 193T439 85Q352 -22 246 -22Q220 -22 196 -14T148 15T109 78T94 179Q94 272 123 373Q163 505 257 591T450 678Q474 678 498 674T535 664T548 656L540 621L532 586L520 590Q509 594 485 599T437 605ZM339 392Q281 392 233 334T185 163V158Q185 87 230 61Q244 54 262 54Q325 54 371 122Q395 158 407 217T419 298Q419 337 401 364T339 392",
  55: "173 614L181 656H389Q596 656 596 655L595 650Q594 645 592 635T588 616L580 578L554 551Q313 307 245 4L242 -11H192Q143 -11 143 -10Q144 0 148 17T169 89T212 198T285 327T393 470Q423 504 472 550Q479 555 485 561T496 571L329 570Q163 570 163 571L164 577Q166 583 168 593T173 614",
  56: "159 470Q159 547 229 612T394 678Q467 678 510 636T554 533Q554 512 549 493T535 458T515 429T492 405T467 386T443 372T423 362T409 356L404 354Q404 353 405 353Q411 353 432 341T476 295T500 218Q500 134 424 56T246 -22Q175 -22 126 22T77 143Q77 204 110 251T188 327L202 334Q216 340 229 346T243 353T235 358T214 372T189 393T168 426T159 470ZM467 527Q467 605 375 605Q317 605 281 566T244 472Q244 429 271 411T334 392Q392 392 429 430T467 527ZM405 228Q405 262 384 289T315 316Q257 316 216 266T174 144Q174 95 199 75T262 54Q329 54 367 109T405 228",
  57: "220 594Q303 677 389 677Q545 677 545 479Q545 413 526 327Q493 175 398 77T202 -22Q124 -22 77 25L130 91L137 83Q169 54 218 54Q255 54 290 76T347 129Q364 151 380 182T403 232T411 256Q410 255 390 241T353 217T303 197T236 187Q195 187 173 209Q155 226 140 263T124 352Q124 392 135 435Q154 527 220 594ZM455 497Q455 605 383 605Q340 605 305 577T246 492Q220 411 220 360Q220 278 279 264Q280 264 287 264T299 263Q347 263 387 302Q455 375 455 497",
  58: "174 396L184 444H233Q282 444 282 443Q277 421 272 394L262 346H213Q164 346 164 347Q169 369 174 396ZM90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2V0H90V2",
  59: "174 396L184 444H233Q282 444 282 443Q277 421 272 394L262 346H213Q164 346 164 347Q169 369 174 396ZM90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2Q188 0 149 -63L112 -125H63L120 0H105Q90 0 90 2",
  61: "142 368Q145 370 463 370Q780 370 784 368Q796 364 796 350T784 332Q780 330 463 330Q145 330 142 332Q129 338 129 351Q129 362 142 368ZM88 137T88 150T102 170H738Q739 170 742 168T750 161T754 150T750 139T743 132T738 130H102Q88 137 88 150",
  63: "194 652Q194 654 218 666T284 691T362 704Q444 704 490 678T536 583Q536 541 516 500T459 433Q415 400 387 371T343 313T321 266T307 216L301 186H262Q223 186 223 187Q224 199 228 218T250 288T294 377Q317 413 344 440T391 481T414 499Q442 527 442 574Q442 584 441 590T433 607T409 623T362 629Q335 629 310 624T267 610T235 595T214 582T205 576L200 614Q194 651 194 652ZM173 2Q174 3 183 49T194 96Q194 98 243 98T292 96L282 50Q272 3 271 2V0H173V2",
  64: "120 267Q120 377 179 478T336 642T538 705Q610 705 658 662T707 513Q707 425 681 331Q658 241 590 179T447 117Q386 117 343 163T300 288Q300 397 374 486T544 576Q575 576 608 562Q590 628 517 628Q406 628 309 522T212 278Q212 179 267 122T404 65T550 91H631Q513 -10 390 -10Q265 -10 193 70T120 267ZM600 397Q600 441 581 471T530 501Q476 501 433 436T390 298Q390 254 409 224T462 193Q512 193 556 257T600 397",
  91: "148 252L253 750H339Q425 750 425 749L424 744Q423 739 421 729T417 711L409 675L367 674H325L235 252Q145 -167 145 -172Q145 -174 187 -174H229V-176Q213 -240 213 -250H127Q41 -250 41 -248Q41 -245 148 252",
  93: "353 749Q353 746 303 512T200 27T141 -250H-31Q-31 -240 -15 -176V-174H70L250 674H208L165 675L181 750H267Q353 750 353 749",
  94: "190 527L360 694H434L484 611Q533 528 533 527H457L390 632L385 639L266 527H190",
  95: "59 -75L66 -38H316Q565 -38 565 -39T558 -75T549 -112Q549 -114 299 -114Q50 -114 50 -113L52 -108Q53 -103 55 -93T59 -75",
  126: "330 327Q356 326 388 298T446 269Q470 269 484 327H522Q560 327 560 325L557 316Q554 306 549 292T535 263T512 232T480 208Q453 193 429 193T370 222T315 251Q285 251 275 193H199V197Q214 257 251 292T330 327",
  305: "168 442T168 443T213 444T258 443T212 225T164 2V0H74V2Q75 7 121 224",
  567: "-54 -96L-48 -104Q-41 -111 -27 -118T7 -126Q60 -126 82 -87Q85 -81 140 181L196 443Q196 444 241 444T286 443Q286 441 232 186T175 -75Q163 -120 122 -162T19 -204Q-13 -204 -41 -196T-83 -180T-96 -170Q-55 -96 -54 -96",
  768: "-262 681L-270 694H-177L-132 612Q-89 530 -87 528Q-87 527 -125 527H-163L-208 598Q-254 670 -262 681",
  769: "-96 625L-29 694H63Q42 673 -31 605L-114 527H-190L-176 541Q-160 559 -96 625",
  770: "-310 527L-140 694H-66L-16 611Q33 528 33 527H-43L-110 632L-115 639L-234 527H-310",
  771: "-170 677Q-144 676 -112 648T-54 619Q-30 619 -16 677H22Q60 677 60 675L57 666Q54 656 49 642T35 613T12 582T-20 558Q-47 543 -71 543T-130 572T-185 601Q-215 601 -225 543H-301V547Q-286 607 -249 642T-170 677",
  772: "-314 553L-297 631H-116Q64 631 64 630Q60 612 56 591L47 553L-133 552Q-314 552 -314 553",
  774: "-142 508Q-205 508 -244 548T-284 652Q-284 666 -281 683L-280 694H-204Q-205 689 -205 677Q-205 650 -196 631T-173 604T-147 593T-125 590Q-85 590 -50 618T-5 686L-2 694H73V690Q53 610 -10 559T-142 508",
  775: "-180 578Q-179 579 -170 627T-158 678V680H-54V678Q-56 675 -65 627T-76 578V576H-180V578",
  776: "-273 584Q-272 585 -262 632L-252 678V680H-154V678L-164 632Q-174 585 -175 584Q-175 582 -224 582T-273 584ZM-78 586Q-78 587 -69 632T-58 678V680H40L39 677Q39 676 38 670T34 651T29 628L19 583L-30 582H-79L-78 586",
  778: "-227 597Q-227 639 -186 666T-102 693H-97Q-29 693 -8 649Q-2 637 -2 623Q-2 582 -43 555T-132 527Q-171 527 -199 546T-227 597ZM-59 619Q-59 635 -68 643T-104 652Q-142 652 -156 636T-171 602Q-171 569 -123 569Q-119 569 -111 570T-99 571Q-59 582 -59 619",
  779: "-236 619L-195 694H-149Q-103 694 -103 693L-211 527H-287L-282 536Q-281 539 -236 619ZM-70 619L-29 694H17Q63 694 63 693L-45 527H-121L-116 536Q-115 539 -70 619",
  780: "-283 654H-207L-140 549L-135 542L-16 654H60L-109 487H-147L-184 488L-234 570Q-283 653 -283 654",
  913: "28 0L429 694H533L585 350Q596 275 610 182T632 46L638 3V0H530L528 18Q527 25 515 103T503 183H223L135 29L118 1L73 0H28ZM492 254Q492 256 473 398T454 589V610Q433 552 290 301L264 255L378 254H492",
  914: "501 363Q557 355 605 316T653 222Q653 148 586 85T403 2Q394 1 240 0Q90 0 90 1L100 46Q109 90 128 177T164 348L238 694H375Q518 693 546 688Q614 674 655 635T696 544Q696 490 648 441T516 368L501 363ZM601 530Q601 568 566 590T479 621Q472 622 394 623H320L297 513Q292 489 286 459T276 415L273 401V399H339H372Q504 399 571 466Q601 498 601 530ZM257 322Q256 320 230 197T203 73Q203 71 289 71Q379 72 387 73Q459 84 507 122T556 210Q556 255 519 283T428 320Q415 322 336 323Q257 323 257 322",
  915: "87 2Q88 4 160 346T234 689Q234 691 440 691T646 689Q643 686 629 611H475L321 612Q193 4 191 2V0H87V2",
  916: "273 343L510 694H617Q790 2 790 0H416L42 1L273 343ZM539 576Q536 597 536 600Q536 602 535 605Q534 607 534 607Q527 580 222 130L201 98H651L648 110Q645 123 639 149T627 198Q554 489 539 576",
  917: "86 2Q88 4 160 346T233 689Q233 691 461 691Q688 691 688 689Q685 686 671 611H495L320 612L319 609Q319 607 297 501L274 397H436Q597 397 597 396L596 391Q595 386 593 376T589 358L581 322L420 321Q258 321 258 320Q209 89 208 87Q208 85 390 85Q417 85 460 85T518 86L572 85Q556 8 554 2V0H86V2",
  918: "67 54Q551 615 551 617Q543 618 517 618Q510 618 463 618T376 617Q200 617 200 618T209 657L216 694H459Q702 694 702 692Q702 689 697 667L692 643L207 80H392Q493 81 577 81Q577 70 560 2V0H55V2L67 54",
  919: "517 2Q518 3 551 161T585 322Q586 323 557 323T422 323H259L190 0H138Q86 0 86 1L96 46Q105 90 124 177T160 348L234 694H337V691Q336 690 306 545T275 399H602L603 403Q603 407 634 551L665 694H768V691Q768 690 695 348T621 2V0H517V2",
  920: "119 260Q119 348 157 433T254 579T387 677T533 715Q701 715 772 574Q804 511 804 431Q804 315 744 209T586 41T384 -22Q262 -22 191 59T119 260ZM706 426Q706 524 655 582T525 640Q454 640 395 600T293 502Q256 447 237 383T218 266Q218 168 269 112T401 55Q518 55 612 166T706 426ZM283 349L293 397H473Q652 397 652 396Q647 374 642 347L632 299H452Q273 299 273 300Q278 322 283 349",
  921: "161 348L235 694H338V691Q338 690 265 348T191 2V0H139Q87 0 87 1L96 46Q106 90 125 177T161 348",
  922: "236 223Q235 222 213 113T188 2V0H138Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H285Q335 694 335 693L330 671Q326 649 316 603T298 518Q289 477 280 433T266 366L261 343L672 694H729L784 693L465 420L651 0H596L541 1L384 350Q383 351 310 288T236 223",
  923: "28 0L401 694H504V690Q505 686 543 345T582 1Q582 0 528 0H473V3Q472 6 460 113T435 359T422 558Q422 593 424 603L425 610L424 608Q414 572 343 431Q287 316 143 49L117 1L73 0H28",
  924: "375 691Q456 215 459 124V106Q488 177 762 641L793 694H929V691Q929 690 856 348T782 2V0H689V2Q691 4 753 304Q817 604 818 606Q819 611 817 608Q817 607 815 603Q798 559 540 117L484 22H440L397 23L393 42Q393 47 373 169T334 422T315 594V609L250 306Q186 3 185 2Q185 0 138 0Q92 0 92 1L102 46Q111 90 130 177T166 348L240 694H375V691",
  925: "311 609Q310 608 246 306T181 2V0H134Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H382L383 691Q383 688 418 561T493 286T541 97L544 84L545 89Q545 90 553 128T578 246T610 394L674 694H766V691Q766 690 693 348T619 2V0H472L469 13Q468 17 393 293T312 605L311 609",
  926: "193 687Q193 688 479 688H765V686Q764 685 755 642L747 600H461L175 601Q175 602 184 645L193 687ZM196 400Q196 401 418 401T640 400L622 315Q622 314 400 314T178 315L196 400ZM42 2Q43 3 51 44T60 87H64Q68 87 75 87T93 87T119 87T151 88T190 88T237 88T291 88T352 88H643Q638 66 634 44T627 13T624 2V0H42V2",
  927: "118 254Q118 366 174 473T324 648T517 716Q627 716 695 638T763 435Q763 321 706 215T555 43T362 -22Q256 -22 187 56T118 254ZM380 58Q452 58 518 116T622 263T661 442Q661 496 646 535T608 594T567 622T534 634Q516 636 496 636Q400 636 313 528T225 264Q225 172 267 115T380 58",
  928: "86 2Q88 4 160 346T233 689Q233 691 501 691Q768 691 768 689Q766 688 694 346T621 2V0H517V2Q518 3 582 304T646 609L648 615H321L190 0H86V2",
  929: "162 348L236 694H378Q522 693 530 692Q604 680 647 635T690 524Q690 474 665 430T612 359Q550 299 465 280Q443 275 343 274H250V271Q250 269 235 201T206 68T192 2V0H140Q88 0 88 1L98 46Q107 90 126 177T162 348ZM594 513Q594 560 562 588T477 622Q470 623 394 623H321L293 487L263 349V347H342H347H375Q530 347 578 449Q594 483 594 513",
  931: "194 655L202 694H508Q813 694 813 693Q809 675 805 653L797 614H559L321 615Q327 606 405 478L485 347Q449 311 348 203T247 86Q247 84 294 84Q303 84 359 84T465 85H684Q684 84 675 42L666 0H360L55 1L195 154Q346 319 347 320L359 333L273 473Q187 614 186 614L187 620Q188 625 190 635T194 655",
  932: "165 608L182 687Q182 688 486 688H790L789 685L781 645L773 609H521L457 306Q393 3 392 2Q392 0 340 0H288V2Q289 5 353 304T417 605V609L291 608H165",
  933: "357 637Q320 637 297 612T266 555H173Q178 576 188 598Q214 651 265 683T373 716Q497 716 497 542V509L504 526Q579 715 711 715Q773 715 808 677T843 589Q843 576 840 555H747L748 557Q748 559 748 563T749 574V580Q749 604 731 622Q715 638 693 638Q591 638 543 465Q531 425 506 309T462 98T441 2V0H337V2Q425 401 436 486Q438 504 438 526Q438 637 364 637H357",
  934: "124 308Q124 399 208 481T433 587Q437 587 437 589Q438 590 449 643L459 694H508Q557 694 557 693Q557 691 546 641T535 587Q543 587 562 583T614 565T674 531T722 472T743 387Q743 288 656 209T449 110L433 106Q411 3 410 2Q410 0 361 0H312L313 3Q313 5 324 56L335 107H331L321 108Q311 110 297 114T266 124T228 141T190 168Q124 225 124 308ZM227 315Q227 282 239 257T270 218T306 197T338 186L350 184H351L386 346Q420 507 420 509H419Q411 509 393 505T342 485T284 444Q227 387 227 315ZM642 381Q642 413 629 437T599 475T563 496T533 507T519 510Q518 510 484 348T450 184Q544 201 593 258T642 381",
  935: "14 0Q17 3 184 184T352 367L265 529Q244 567 222 609T188 672L176 692Q176 694 236 694H297L338 612Q387 515 400 489L421 448L645 694H758L708 640Q481 393 456 368Q455 366 500 281T596 104T652 0H531L388 293L128 0H14",
  936: "325 556Q325 524 310 447T294 330Q294 289 304 260Q314 234 333 216T364 192T380 187L488 694H585V691Q584 689 531 438L478 188H479Q485 188 503 195T555 231T613 305Q637 352 654 435Q662 470 669 496T681 538T690 562T698 578T704 587Q719 609 733 615T772 621H802H854V619L838 546Q838 545 832 545Q775 539 749 418Q716 274 638 196Q616 173 590 156T543 131T503 117T473 110T460 106Q460 105 450 54T438 2V0H340V2Q341 3 351 54T362 106Q363 107 358 108T344 111T322 117T295 128T267 145T239 171T216 207T200 256T194 319Q194 356 203 408T213 483Q213 517 203 530T182 544T171 546Q184 609 187 619V621H239Q286 621 294 620T309 612Q325 596 325 556",
  937: "148 407Q148 475 182 534T269 633T386 694T511 716Q622 716 695 658T769 507Q769 461 747 409T699 321T628 225T562 136Q533 90 533 86Q542 85 557 85Q564 85 583 85T614 86Q695 86 695 85Q679 9 677 2V0H425Q426 3 433 30T447 72T480 131T549 241L554 248Q558 254 563 261T576 281T592 306T609 335T625 366T640 400T653 434T661 466T664 498Q664 562 618 601T497 640Q416 640 351 596T262 482Q250 441 250 392T276 237T302 70V56Q302 28 296 2V0H44V2L62 85Q62 86 143 86L225 85V88Q224 89 224 89T224 91T224 95T223 101T222 110T220 123T216 140T209 163T200 191T188 227Q148 344 148 407",
  8211: "59 275L66 312H316Q565 312 565 311T558 275T549 238Q549 236 299 236Q50 236 50 237L52 242Q53 247 55 257T59 275",
  8212: "59 275L66 312H566Q1065 312 1065 311T1058 275T1049 238Q1049 236 549 236Q50 236 50 237L52 242Q53 247 55 257T59 275",
  8213: "59 275L66 312H566Q1065 312 1065 311T1058 275T1049 238Q1049 236 549 236Q50 236 50 237L52 242Q53 247 55 257T59 275",
  8215: "59 -75L66 -38H316Q565 -38 565 -39T558 -75T549 -112Q549 -114 299 -114Q50 -114 50 -113L52 -108Q53 -103 55 -93T59 -75",
  8216: "309 567L299 520Q289 474 288 473Q288 471 239 471T190 473L192 480Q193 486 196 499T201 522L211 569L287 694H312L335 693L332 685Q328 677 321 661T307 630L279 570L294 569Q309 569 309 567",
  8217: "228 647L237 694H286Q335 694 335 693L334 686Q332 680 330 668T325 644L315 597L239 471H214Q190 471 190 472L246 595Q246 596 231 596H217V598Q217 601 228 647",
  8220: "393 567L383 520Q373 474 372 473Q372 471 323 471T274 473L276 480Q277 486 280 499T285 522L295 569L371 694H396L419 693L416 685Q412 677 405 661T391 630L363 570L378 569Q393 569 393 567ZM587 567L577 520Q567 474 566 473Q566 471 517 471T468 473L470 480Q471 486 474 499T479 522L489 569L565 694H590L613 693L610 685Q606 677 599 661T585 630L557 570L572 569Q587 569 587 567",
  8221: "171 647L180 694H229Q278 694 278 693L276 686Q275 680 273 668T268 644L258 597L182 471H157Q133 471 133 472L189 595Q189 596 174 596H160V598Q160 601 171 647ZM365 647L374 694H423Q472 694 472 693L470 686Q469 680 467 668T462 644L452 597L376 471H351Q327 471 327 472L383 595Q383 596 368 596H354V598Q354 601 365 647",
  8260: "564 744L568 747Q573 750 579 750Q588 750 594 744T599 729Q597 721 321 241T41 -243Q37 -250 27 -250Q6 -250 6 -230Q6 -228 8 -222Q9 -219 285 261T564 744",
  8710: "273 343L510 694H617Q790 2 790 0H416L42 1L273 343ZM539 576Q536 597 536 600Q536 602 535 605Q534 607 534 607Q527 580 222 130L201 98H651L648 110Q645 123 639 149T627 198Q554 489 539 576"
}, {});
var Ji = {}, Yi = {};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.sansSerif = void 0;
Yi.sansSerif = {
  33: [0.694, 0, 0.319],
  34: [0.694, -0.471, 0.5],
  35: [0.694, 0.194, 0.833],
  36: [0.75, 0.056, 0.5],
  37: [0.75, 0.056, 0.833],
  38: [0.716, 0.022, 0.758],
  39: [0.694, -0.471, 0.278],
  40: [0.75, 0.25, 0.389],
  41: [0.75, 0.25, 0.389],
  42: [0.75, -0.306, 0.5],
  43: [0.583, 0.082, 0.778],
  44: [0.098, 0.125, 0.278],
  45: [0.259, -0.186, 0.333],
  46: [0.098, 0, 0.278],
  47: [0.75, 0.25, 0.5],
  58: [0.444, 0, 0.278],
  59: [0.444, 0.125, 0.278],
  61: [0.37, -0.13, 0.778],
  63: [0.704, 0, 0.472],
  64: [0.704, 0.011, 0.667],
  91: [0.75, 0.25, 0.289],
  93: [0.75, 0.25, 0.289],
  94: [0.694, -0.527, 0.5],
  95: [-0.038, 0.114, 0.5],
  126: [0.327, -0.193, 0.5],
  305: [0.444, 0, 0.239],
  567: [0.444, 0.205, 0.267],
  768: [0.694, -0.527, 0],
  769: [0.694, -0.527, 0],
  770: [0.694, -0.527, 0],
  771: [0.677, -0.543, 0],
  772: [0.631, -0.552, 0],
  774: [0.694, -0.508, 0],
  775: [0.68, -0.576, 0],
  776: [0.68, -0.582, 0],
  778: [0.694, -0.527, 0],
  779: [0.694, -0.527, 0],
  780: [0.654, -0.487, 0],
  913: [0.694, 0, 0.667],
  914: [0.694, 0, 0.667],
  915: [0.691, 0, 0.542],
  916: [0.694, 0, 0.833],
  917: [0.691, 0, 0.597],
  918: [0.694, 0, 0.611],
  919: [0.694, 0, 0.708],
  920: [0.716, 0.021, 0.778],
  921: [0.694, 0, 0.278],
  922: [0.694, 0, 0.694],
  923: [0.694, 0, 0.611],
  924: [0.694, 0, 0.875],
  925: [0.694, 0, 0.708],
  926: [0.688, 0, 0.667],
  927: [0.715, 0.022, 0.736],
  928: [0.691, 0, 0.708],
  929: [0.694, 0, 0.639],
  931: [0.694, 0, 0.722],
  932: [0.688, 0, 0.681],
  933: [0.716, 0, 0.778],
  934: [0.694, 0, 0.722],
  935: [0.694, 0, 0.667],
  936: [0.694, 0, 0.778],
  937: [0.716, 0, 0.722],
  8211: [0.312, -0.236, 0.5],
  8212: [0.312, -0.236, 1],
  8213: [0.312, -0.236, 1],
  8215: [-0.038, 0.114, 0.5],
  8216: [0.694, -0.471, 0.278],
  8217: [0.694, -0.471, 0.278],
  8220: [0.694, -0.471, 0.5],
  8221: [0.694, -0.471, 0.5],
  8260: [0.75, 0.25, 0.5],
  8710: [0.694, 0, 0.833]
};
Object.defineProperty(Ji, "__esModule", { value: !0 });
Ji.sansSerif = void 0;
var FH = s3, jH = Yi;
Ji.sansSerif = (0, FH.AddPaths)(jH.sansSerif, {
  33: "120 187Q120 225 115 440T110 693Q110 694 159 694T208 693Q208 655 203 440T198 187Q198 186 159 186T120 187ZM110 0V98H208V0H110",
  34: "33 596V694H131V597L82 471H32L47 532Q62 593 63 594Q63 596 48 596H33ZM227 596V694H325V597L276 471H226L241 532Q256 593 257 594Q257 596 242 596H227",
  35: "56 350Q56 363 70 370H192Q314 370 314 371L356 526Q396 676 401 685Q406 694 416 694Q423 694 429 689T436 677Q436 673 396 523T355 371Q355 370 449 370Q544 370 544 371L586 526Q628 682 630 685Q636 694 646 694Q653 694 659 689T665 678Q665 670 645 593T605 444L585 371Q585 370 673 370H762Q777 362 777 350Q777 337 767 334T723 330H668H573L567 305Q560 282 545 226L530 171L646 170H721Q756 170 766 167T777 150Q777 138 762 130H640Q518 130 518 129L476 -26Q434 -182 432 -185Q426 -194 416 -194Q409 -194 403 -189T397 -178Q397 -170 417 -93T457 56L477 129Q477 130 383 130Q288 130 288 129L246 -26Q204 -182 202 -185Q196 -194 186 -194Q179 -194 173 -189T167 -178Q167 -170 187 -94T227 56L247 129Q247 130 159 130H70Q56 137 56 150Q56 165 72 170H259L265 195Q273 222 287 275L302 330H186L70 331Q63 334 58 339Q56 343 56 350ZM489 170L532 330H343L337 305Q330 282 315 226L300 171L394 170H489",
  36: "55 509Q55 585 103 638T213 701V750H286V703H289Q312 703 354 689Q372 682 399 666T427 646L413 569Q413 568 403 575Q352 615 291 624H286V405Q357 389 400 331T444 199Q444 128 402 69T286 -7V-56H213V-9Q167 -3 125 14T63 44T44 60Q44 61 52 101L59 140L69 132Q78 125 87 119T107 107T124 97T141 90T157 84T173 80T187 76T201 73T213 70V317L202 319Q141 335 98 386T55 509ZM213 424V620L203 615Q143 587 143 522Q143 455 213 424ZM356 187Q356 208 350 227T334 258T315 280T298 293T287 297Q286 297 286 186V75Q356 110 356 187",
  37: "56 549Q56 639 98 694T195 750Q248 750 290 694T332 548Q332 455 290 401T195 347Q141 347 99 403T56 549ZM248 549Q248 602 234 638T195 674Q145 674 145 549Q145 423 195 423Q219 423 233 459T248 549ZM197 -56Q187 -56 182 -49T176 -35Q176 -33 178 -27Q179 -25 399 356T623 741Q626 750 639 750Q648 750 654 744T659 729Q657 721 435 336T207 -52Q203 -56 197 -56ZM500 146Q500 235 542 291T639 347Q692 347 734 293T776 146Q776 53 733 -1T639 -56Q587 -56 544 -2T500 146ZM692 146Q692 199 678 235T639 271Q589 271 589 146Q589 20 639 20Q663 20 677 56T692 146",
  38: "156 502Q156 600 198 658T302 716Q367 716 405 665T444 549Q444 531 442 523Q426 446 304 348L287 334Q305 297 340 249T402 170T430 139T443 149T472 181T509 231T549 303T583 394Q584 398 586 404Q587 408 587 409Q588 409 626 399T665 388Q663 381 660 369T644 322T614 253T567 176T502 98L491 87Q534 57 584 57Q653 57 700 75Q702 75 702 34T700 -7Q652 -22 586 -22H580Q505 -22 434 26L421 34Q419 33 405 25T374 11T336 -4T285 -17T226 -22Q143 -22 93 31T42 152Q42 184 51 211T81 260T111 291T144 317L184 348L178 365Q156 430 156 502ZM359 552Q359 588 345 614T302 640Q292 640 282 636T260 622T241 590T233 535Q236 474 253 417L257 407L271 419Q312 454 330 479Q359 514 359 552ZM345 102Q262 190 216 277Q215 277 204 267T180 247T165 236Q135 208 135 159Q135 123 152 97T198 61Q207 58 227 58Q286 58 357 89L345 102",
  39: "90 596V694H188V597L139 471H89L104 532Q119 593 120 594Q120 596 105 596H90",
  40: "74 250Q74 564 240 733L257 750H333L323 739Q167 573 167 250T323 -239L333 -250H257L240 -233Q74 -63 74 250",
  41: "221 -73T221 250T65 739L55 750H131L148 733Q314 567 314 250T148 -233L131 -250H55L65 -239Q221 -73 221 250",
  42: "208 717Q211 731 222 740T250 750Q265 750 277 741T291 717Q291 706 290 675T286 617L285 591L329 622Q369 651 376 655T393 659Q411 659 423 647T436 616Q436 609 434 603T429 594T419 585T407 577T389 567T368 556L316 528L368 500Q421 472 429 464Q436 455 436 440Q436 422 423 409T393 396Q390 396 388 396T384 397T380 398T375 401T367 406T358 413T346 422T329 434L285 465Q284 465 285 438T289 381T291 347Q291 327 278 317T250 306Q234 306 222 315T208 339Q208 350 209 381T212 439L214 465L170 434Q130 405 123 401T106 397Q88 397 76 409T63 440Q63 447 65 453T70 462T80 471T92 479T110 489T131 500L183 528L131 556Q78 584 70 592Q63 601 63 616Q63 634 76 647T106 660Q109 660 111 660T115 659T119 658T124 655T132 650T141 643T153 634T170 622L214 591L212 617Q211 643 210 674T208 717",
  43: "56 237T56 250T70 270H369V420L370 570Q380 583 389 583Q402 583 409 568V270H707Q722 262 722 250T707 230H409V-68Q401 -82 391 -82H389H387Q375 -82 369 -68V230H70Q56 237 56 250",
  44: "90 0V98H188V1L139 -125H89L104 -64Q119 -3 120 -2Q120 0 105 0H90",
  45: "11 186V259H277V186H11",
  46: "90 0V98H188V0H90",
  47: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
  58: "90 346V444H188V346H90ZM90 0V98H188V0H90",
  59: "90 346V444H188V346H90ZM90 0V98H188V1L139 -125H89L104 -64Q119 -3 120 -2Q120 0 105 0H90",
  61: "56 350Q56 363 70 370H707Q722 362 722 350Q722 339 708 331L390 330H72Q56 335 56 350ZM56 150Q56 165 72 170H708Q722 160 722 150Q722 138 707 130H70Q56 137 56 150",
  63: "55 652Q63 658 77 666T132 689T214 704T265 703Q303 698 332 684T376 653T401 615T413 578T416 546Q416 475 360 426Q325 396 303 365T273 303T263 256T261 216V186H183V225Q184 281 194 322Q206 368 232 409T276 469T306 495Q323 517 323 550Q323 596 297 612T223 629Q187 629 157 618Q122 607 91 583L83 576L55 652ZM173 0V98H271V0H173",
  64: "422 576Q440 576 456 573T480 566L488 563Q488 565 484 571T472 588T452 607T424 622T387 629Q294 629 220 550T146 347Q146 233 210 155T365 66Q376 65 400 65Q465 68 517 86L532 91H612L598 76Q511 -11 388 -11Q250 -11 153 93T56 347Q56 454 107 538T231 663T378 704Q446 704 492 680T564 608T599 506T611 376Q611 320 607 299Q595 227 546 173T422 118Q343 118 288 185T232 347Q232 444 287 510T422 576ZM520 347Q520 429 487 465T421 501Q385 501 354 461T323 347Q323 270 355 232T422 193Q454 193 487 229T520 347",
  91: "94 -250V750H266V674H181V-174H266V-250H94",
  93: "22 674V750H194V-250H22V-174H107V674H22",
  94: "146 612L212 694H287L353 612Q417 532 420 529Q421 528 418 527Q414 527 383 527H345L250 639Q244 633 199 580L154 527H116Q79 528 79 529Q82 532 146 612",
  95: "0 -114V-38H499V-114H0",
  126: "83 204Q86 254 113 290T186 327Q211 327 251 299T312 270Q337 270 340 315V327H416V316Q413 258 382 226T315 193Q289 193 249 221T187 250Q162 250 159 205V193H83V204",
  305: "74 0V444H164V0H74",
  567: "-35 -95Q-4 -126 34 -126Q58 -126 76 -116T100 -88Q102 -82 102 181V444H192V180Q191 -45 191 -70T184 -113Q171 -152 140 -178T63 -205Q34 -205 4 -197T-43 -181T-59 -171L-47 -133L-35 -95",
  768: "-415 692L-417 694H-324L-262 612Q-249 594 -233 572T-208 539L-200 528L-237 527H-275L-344 608Q-359 625 -378 647T-406 680T-415 692",
  769: "-239 612L-177 694H-84L-86 692Q-86 691 -95 681T-123 648T-157 608L-226 527H-264L-301 528L-293 539Q-285 550 -269 572T-239 612",
  770: "-354 612L-288 694H-213L-147 612Q-83 532 -80 529Q-79 528 -82 527Q-86 527 -117 527H-155L-250 639Q-256 633 -301 580L-346 527H-384Q-421 528 -421 529Q-418 532 -354 612",
  771: "-417 554Q-414 604 -387 640T-314 677Q-289 677 -249 649T-188 620Q-163 620 -160 665V677H-84V666Q-87 608 -118 576T-185 543Q-211 543 -251 571T-313 600Q-338 600 -341 555V543H-417V554",
  772: "-431 552V631H-70V552H-431",
  774: "-250 508Q-331 508 -379 567T-427 689V694H-351V685Q-348 649 -321 620T-250 591Q-206 591 -180 619T-150 685V694H-74V689Q-74 624 -122 566T-250 508",
  775: "-302 576V680H-198V576H-302",
  776: "-397 582V680H-299V582H-397ZM-202 582V680H-104V582H-202",
  778: "-319 611Q-319 649 -285 671T-211 694Q-164 694 -132 671T-99 611Q-99 572 -133 550T-209 527T-285 549T-319 611ZM-155 610Q-155 635 -171 643T-215 651Q-263 651 -263 610Q-263 570 -211 570H-209H-207Q-155 570 -155 610",
  779: "-250 693Q-317 544 -323 527H-399L-343 694H-296Q-250 694 -250 693ZM-84 693Q-151 544 -157 527H-233L-177 694H-130Q-84 694 -84 693",
  780: "-421 652Q-422 653 -419 654Q-415 654 -384 654H-346L-301 601Q-287 585 -275 571T-258 551T-250 542L-155 654H-117Q-80 653 -80 652Q-83 649 -147 569L-213 487H-288L-354 569Q-418 649 -421 652",
  913: "183 181Q183 179 152 91T118 0H28L154 346L280 693Q281 694 333 694H385L511 349Q636 4 638 2Q638 0 584 0H530L464 183H184L183 181ZM324 606Q319 578 292 492T238 332T210 256Q210 254 324 254T438 255L429 281L419 308Q409 336 395 378T365 465T339 551T324 611V606",
  914: "425 363Q438 363 465 353T526 324T585 270T610 192Q610 132 561 78T426 7Q404 2 387 2T240 0H90V694H227Q373 693 396 689Q484 673 533 623T583 517Q583 494 574 473T551 437T520 409T487 388T456 374T433 366L425 363ZM490 516Q490 527 485 539T467 568T423 599T347 621Q340 622 262 623H188V399H261H286Q432 399 478 475Q490 496 490 516ZM514 190Q514 245 462 280T343 322Q336 323 259 323H188V71H274Q365 72 388 77Q445 88 479 121T514 190",
  915: "87 0V691H499V611H345L191 612V0H87",
  916: "203 348L362 694H470L629 348Q789 2 790 1Q790 0 416 0T42 1Q43 2 203 348ZM630 98Q630 100 584 198T481 422T407 603L405 610L403 600Q388 544 191 122L180 99L405 98H630",
  917: "86 0V691H541V611H366L190 612V397H513V321H190V85H372L554 86V0H86",
  918: "69 617V694H555V643L373 362Q190 81 190 79H234Q244 79 272 79T344 80T419 81H560V0H55V53L237 334Q420 615 420 617Q413 618 387 618Q380 618 334 618T245 617H69",
  919: "86 0V694H190V399H517V694H621V0H517V323H190V0H86",
  920: "56 344Q56 430 86 502T164 619T271 690T388 716Q448 716 506 691T613 619T692 501T722 344Q722 188 624 84T389 -21Q252 -21 154 83T56 344ZM624 345Q624 423 597 488T513 596T380 639Q343 639 305 621T232 568T175 475T153 344Q153 216 222 136T388 56Q487 56 555 138T624 345ZM209 299V397H568V299H209",
  921: "87 0V694H191V0H87",
  922: "88 0V694H188V519L189 343L525 694H638L375 419L651 0H541L309 351L188 225V0H88",
  923: "294 606Q294 574 252 430T163 144T117 0H72Q28 0 28 1T141 348L254 694H357L469 348Q582 2 582 1T527 0L473 1L469 11Q469 13 427 141T343 411T296 599L294 610V606",
  924: "92 0V694H228L233 680Q236 675 284 547T382 275T436 106Q446 149 497 292T594 558L640 680L645 694H782V0H689V305L688 606Q688 577 500 78L479 23H392L364 96Q364 97 342 156T296 280T246 418T203 544T186 609V588Q185 568 185 517T185 427T185 305V0H92",
  925: "88 0V694H235L252 659Q261 639 364 428T526 84V694H619V0H472L455 35Q453 39 330 294T185 601L181 611V0H88",
  926: "47 600V688H619V600H47ZM111 314V401H555V314H111ZM42 0V88H624V0H42",
  927: "55 345Q55 504 149 609T361 715Q386 715 406 713Q521 696 600 592T680 344Q680 193 590 86T368 -22Q239 -22 147 84T55 345ZM276 59T368 59T518 146T576 360Q576 473 525 545T401 634Q371 637 362 637Q284 637 222 562T159 360T217 147",
  928: "86 0V691H621V0H517V615H190V0H86",
  929: "88 0V694H230Q347 693 370 692T410 686Q487 667 535 611T583 485Q583 409 527 348T379 276Q369 274 279 274H192V0H88ZM486 485Q486 523 471 551T432 593T391 612T357 621Q350 622 268 623H189V347H268Q350 348 357 349Q370 351 383 354T416 368T450 391T475 429T486 485",
  931: "55 0Q56 3 171 167T288 332Q288 334 172 474L55 615V694H666V614H428L190 615L412 347L322 218Q236 97 228 84L447 85H666V0H55",
  932: "36 608V688H644V608H518L392 609V0H288V609L162 608H36",
  933: "55 565Q59 625 105 670T219 716H222Q310 716 353 627Q376 583 386 524L389 510L393 532Q397 555 407 584T433 644T482 695T557 716Q621 716 669 673T722 565V555H629V563Q627 592 607 615T557 638Q530 638 511 629T479 598T459 553T447 488T442 411T441 319V202V0H337V202Q337 453 331 497Q313 634 226 638Q185 638 167 612T148 563V555H55V565",
  934: "666 347Q666 326 661 302T638 247T594 190T520 140T413 107H410V0H312V54Q312 107 311 107Q286 107 229 128T125 192Q55 260 55 347Q55 396 77 438T131 507T200 552T265 579T311 587Q312 587 312 641V694H410V587H413Q476 576 524 552T598 502T640 444T661 390T666 347ZM310 510Q305 510 291 507T252 492T208 464T172 416T157 347T171 279T204 233T247 205T286 190T310 184H312V347Q312 510 310 510ZM564 347Q564 385 549 416T514 463T470 491T433 505T414 509L410 510V184Q413 184 426 187T464 200T510 227T548 275T564 347",
  935: "14 0Q16 5 144 184T275 367L153 528Q121 571 88 615T42 674T28 694H150L228 584Q315 463 316 461L326 448L497 694H610L609 692Q606 689 492 528Q440 454 409 410T378 366Q378 365 515 182L652 0H531L326 292Q326 293 299 254T226 146L128 0H14",
  936: "340 187V694H438V187Q481 206 495 219Q518 239 533 267T553 332T560 386T562 435Q562 576 593 608Q608 621 637 621H670H722V545H719Q718 545 715 545T710 544Q679 536 666 487Q664 474 662 429T654 344T633 259T580 175T486 119Q450 109 438 108V0H340V108L326 110Q122 149 117 415Q116 460 111 487Q98 536 67 544Q65 544 62 544T58 545H55V621H107Q160 621 163 620Q191 613 202 573Q213 536 213 473T220 351T256 249Q262 239 270 230T285 216T301 205T316 197T329 192T340 187",
  937: "55 462Q55 561 141 638T359 716Q492 716 579 640T666 462Q666 407 642 347T579 222T529 126Q515 91 515 86Q517 85 528 85Q530 85 552 85T596 86H677V0H425V14Q429 79 465 168L492 228Q494 232 504 254T516 283T527 310T539 340T548 368T556 399T560 428T562 460Q562 531 510 585T361 639Q263 639 211 585T159 460Q159 422 170 378T192 309T229 228L256 168Q292 79 296 14V0H44V86H125Q146 86 168 86T193 85L206 86Q206 103 183 148T131 241T79 352T55 462",
  8211: "0 236V312H499V236H0",
  8212: "0 236V312H999V236H0",
  8213: "0 236V312H999V236H0",
  8215: "0 -114V-38H499V-114H0",
  8216: "90 568L140 694H189L174 633Q159 572 158 571Q158 569 173 569H188V471H90V568",
  8217: "90 596V694H188V597L139 471H89L104 532Q119 593 120 594Q120 596 105 596H90",
  8220: "174 568L224 694H273L258 633Q243 572 242 571Q242 569 257 569H272V471H174V568ZM368 568L418 694H467L452 633Q437 572 436 571Q436 569 451 569H466V471H368V568",
  8221: "33 596V694H131V597L82 471H32L47 532Q62 593 63 594Q63 596 48 596H33ZM227 596V694H325V597L276 471H226L241 532Q256 593 257 594Q257 596 242 596H227",
  8260: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
  8710: "203 348L362 694H470L629 348Q789 2 790 1Q790 0 416 0T42 1Q43 2 203 348ZM630 98Q630 100 584 198T481 422T407 603L405 610L403 600Q388 544 191 122L180 99L405 98H630"
}, {});
var ih = {}, Ki = {};
Object.defineProperty(Ki, "__esModule", { value: !0 });
Ki.scriptBold = void 0;
Ki.scriptBold = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.scriptBold = void 0;
  var t = Ki;
  Object.defineProperty(e, "scriptBold", { enumerable: !0, get: function() {
    return t.scriptBold;
  } });
})(ih);
var oh = {}, eo = {};
Object.defineProperty(eo, "__esModule", { value: !0 });
eo.script = void 0;
eo.script = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.script = void 0;
  var t = eo;
  Object.defineProperty(e, "script", { enumerable: !0, get: function() {
    return t.script;
  } });
})(oh);
var to = {}, ro = {};
Object.defineProperty(ro, "__esModule", { value: !0 });
ro.smallop = void 0;
ro.smallop = {
  40: [0.85, 0.349, 0.458],
  41: [0.85, 0.349, 0.458],
  47: [0.85, 0.349, 0.578],
  91: [0.85, 0.349, 0.417],
  92: [0.85, 0.349, 0.578],
  93: [0.85, 0.349, 0.417],
  123: [0.85, 0.349, 0.583],
  125: [0.85, 0.349, 0.583],
  710: [0.744, -0.551, 0.556],
  732: [0.722, -0.597, 0.556],
  770: [0.744, -0.551, 0],
  771: [0.722, -0.597, 0],
  8214: [0.602, 0, 0.778],
  8260: [0.85, 0.349, 0.578],
  8593: [0.6, 0, 0.667],
  8595: [0.6, 0, 0.667],
  8657: [0.599, 0, 0.778],
  8659: [0.6, 0, 0.778],
  8719: [0.75, 0.25, 0.944],
  8720: [0.75, 0.25, 0.944],
  8721: [0.75, 0.25, 1.056],
  8730: [0.85, 0.35, 1, { ic: 0.02 }],
  8739: [0.627, 0.015, 0.333],
  8741: [0.627, 0.015, 0.556],
  8747: [0.805, 0.306, 0.472, { ic: 0.138 }],
  8748: [0.805, 0.306, 0.819, { ic: 0.138 }],
  8749: [0.805, 0.306, 1.166, { ic: 0.138 }],
  8750: [0.805, 0.306, 0.472, { ic: 0.138 }],
  8896: [0.75, 0.249, 0.833],
  8897: [0.75, 0.249, 0.833],
  8898: [0.75, 0.249, 0.833],
  8899: [0.75, 0.249, 0.833],
  8968: [0.85, 0.349, 0.472],
  8969: [0.85, 0.349, 0.472],
  8970: [0.85, 0.349, 0.472],
  8971: [0.85, 0.349, 0.472],
  9001: [0.85, 0.35, 0.472],
  9002: [0.85, 0.35, 0.472],
  9168: [0.602, 0, 0.667],
  10072: [0.627, 0.015, 0.333],
  10216: [0.85, 0.35, 0.472],
  10217: [0.85, 0.35, 0.472],
  10752: [0.75, 0.25, 1.111],
  10753: [0.75, 0.25, 1.111],
  10754: [0.75, 0.25, 1.111],
  10756: [0.75, 0.249, 0.833],
  10758: [0.75, 0.249, 0.833],
  10764: [0.805, 0.306, 1.638, { ic: 0.138 }],
  12296: [0.85, 0.35, 0.472],
  12297: [0.85, 0.35, 0.472]
};
Object.defineProperty(to, "__esModule", { value: !0 });
to.smallop = void 0;
var $H = s3, ZH = ro;
to.smallop = (0, $H.AddPaths)(ZH.smallop, {
  40: "152 251Q152 646 388 850H416Q422 844 422 841Q422 837 403 816T357 753T302 649T255 482T236 250Q236 124 255 19T301 -147T356 -251T403 -315T422 -340Q422 -343 416 -349H388Q359 -325 332 -296T271 -213T212 -97T170 56T152 251",
  41: "305 251Q305 -145 69 -349H56Q43 -349 39 -347T35 -338Q37 -333 60 -307T108 -239T160 -136T204 27T221 250T204 473T160 636T108 740T60 807T35 839Q35 850 50 850H56H69Q197 743 256 566Q305 425 305 251",
  47: "481 838Q489 850 500 850Q508 850 515 844T522 827Q521 824 311 248T96 -337Q90 -349 77 -349Q68 -349 62 -343T55 -326Q56 -323 266 253T481 838",
  91: "202 -349V850H394V810H242V-309H394V-349H202",
  92: "522 -326Q522 -337 515 -343T500 -349Q487 -349 481 -337Q477 -328 267 248T55 827Q54 835 60 842T76 850Q89 850 96 838Q100 829 310 253T522 -326",
  93: "22 810V850H214V-349H22V-309H174V810H22",
  123: "477 -343L471 -349H458Q432 -349 367 -325T273 -263Q258 -245 250 -212L249 -51Q249 -27 249 12Q248 118 244 128Q243 129 243 130Q220 189 121 228Q109 232 107 235T105 250Q105 256 105 257T105 261T107 265T111 268T118 272T128 276T142 283T162 291Q224 324 243 371Q243 372 244 373Q248 384 249 469Q249 475 249 489Q249 528 249 552L250 714Q253 728 256 736T271 761T299 789T347 816T422 843Q440 849 441 849H443Q445 849 447 849T452 850T457 850H471L477 844V830Q477 820 476 817T470 811T459 807T437 801T404 785Q353 760 338 724Q333 710 333 550Q333 526 333 492T334 447Q334 393 327 368T295 318Q257 280 181 255L169 251L184 245Q318 198 332 112Q333 106 333 -49Q333 -209 338 -223Q351 -255 391 -277T469 -309Q477 -311 477 -329V-343",
  125: "110 849L115 850Q120 850 125 850Q151 850 215 826T309 764Q324 747 332 714L333 552Q333 528 333 489Q334 383 338 373Q339 372 339 371Q353 336 391 310T469 271Q477 268 477 251Q477 241 476 237T472 232T456 225T428 214Q357 179 339 130Q339 129 338 128Q334 117 333 32Q333 26 333 12Q333 -27 333 -51L332 -212Q328 -228 323 -240T302 -271T255 -307T175 -338Q139 -349 125 -349T108 -346T105 -329Q105 -314 107 -312T130 -304Q233 -271 248 -209Q249 -203 249 -49V57Q249 106 253 125T273 167Q307 213 398 245L413 251L401 255Q265 300 250 389Q249 395 249 550Q249 710 244 724Q224 774 112 811Q105 813 105 830Q105 845 110 849",
  710: "279 669Q273 669 142 610T9 551L0 569Q-8 585 -8 587Q-8 588 -7 588L12 598Q30 608 66 628T136 666L277 744L564 587L555 569Q549 556 547 554T544 552Q539 555 410 612T279 669",
  732: "374 597Q337 597 269 627T160 658Q101 658 34 606L24 597L12 611Q1 624 1 626Q1 627 27 648T55 671Q120 722 182 722Q219 722 286 692T395 661Q454 661 521 713L531 722L543 708Q554 695 554 693Q554 692 528 671T500 648Q434 597 374 597",
  770: "-277 669Q-283 669 -414 610T-547 551L-556 569Q-564 585 -564 587Q-564 588 -563 588L-544 598Q-526 608 -490 628T-420 666L-279 744L8 587L-1 569Q-7 556 -9 554T-12 552Q-17 555 -146 612T-277 669",
  771: "-182 597Q-219 597 -287 627T-396 658Q-455 658 -522 606L-532 597L-544 611Q-555 624 -555 626Q-555 627 -529 648T-501 671Q-436 722 -374 722Q-337 722 -270 692T-161 661Q-102 661 -35 713L-25 722L-13 708Q-2 695 -2 693Q-2 692 -28 671T-56 648Q-122 597 -182 597",
  8214: "257 0V602H300V0H257ZM478 0V602H521V0H478",
  8260: "481 838Q489 850 500 850Q508 850 515 844T522 827Q521 824 311 248T96 -337Q90 -349 77 -349Q68 -349 62 -343T55 -326Q56 -323 266 253T481 838",
  8593: "112 421L120 424Q127 427 136 430T161 441T191 458T224 481T260 510T295 546T328 591L333 600L340 589Q380 527 431 489T555 421V377L543 381Q445 418 368 492L355 504V0H312V504L299 492Q222 418 124 381L112 377V421",
  8595: "312 96V600H355V96L368 108Q445 182 543 219L555 223V179L546 176Q538 173 529 169T505 158T475 141T442 119T407 90T372 53T339 9L334 0L327 11Q287 73 236 111T112 179V223L124 219Q222 182 299 108L312 96",
  8657: "142 329Q300 419 389 599Q389 598 399 579T420 541T452 494T497 438T558 383T636 329T708 294L721 289V246Q718 246 694 256T623 293T532 356L522 364L521 182V0H478V405L466 417Q436 450 389 516Q388 515 378 500T352 463T312 417L300 405V0H257V364L247 356Q202 320 155 293T82 256L57 246V289L70 294Q101 305 142 329",
  8659: "257 236V600H300V195L312 183Q342 150 389 84Q390 85 400 100T426 137T466 183L478 195V600H521V418L522 236L532 244Q576 280 623 307T696 344L721 354V311L708 306Q677 295 636 271Q478 181 389 1Q389 2 379 21T358 59T326 106T281 162T220 217T142 271T70 306L57 311V354Q60 354 83 345T154 308T247 244L257 236",
  8719: "158 656Q147 684 131 694Q110 707 69 710H55V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H570V-210H584Q618 -208 638 -197T663 -178T673 -155V710H270V277L271 -155Q283 -206 359 -210H373V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
  8720: "158 656Q147 684 131 694Q110 707 69 710H55V750H373V710H359Q325 708 305 698T280 678T271 656L270 223V-210H673V656Q666 672 663 679T639 697T584 710H570V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
  8721: "61 748Q64 750 489 750H913L954 640Q965 609 976 579T993 533T999 516H979L959 517Q936 579 886 621T777 682Q724 700 655 705T436 710H319Q183 710 183 709Q186 706 348 484T511 259Q517 250 513 244L490 216Q466 188 420 134T330 27L149 -187Q149 -188 362 -188Q388 -188 436 -188T506 -189Q679 -189 778 -162T936 -43Q946 -27 959 6H999L913 -249L489 -250Q65 -250 62 -248Q56 -246 56 -239Q56 -234 118 -161Q186 -81 245 -11L428 206Q428 207 242 462L57 717L56 728Q56 744 61 748",
  8730: "263 249Q264 249 315 130T417 -108T470 -228L725 302Q981 837 982 839Q989 850 1001 850Q1008 850 1013 844T1020 832V826L741 243Q645 43 540 -176Q479 -303 469 -324T453 -348Q449 -350 436 -350L424 -349L315 -96Q206 156 205 156L171 130Q138 104 137 104L111 130L263 249",
  8739: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
  8741: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612ZM368 612Q373 627 388 627Q404 627 409 612Q410 610 410 306T409 0Q406 -15 389 -15Q371 -15 368 0V10Q368 19 368 35T368 73T368 122T367 179T367 241T367 306T367 370T367 433T367 489T368 538T368 576T368 602V612",
  8747: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244",
  8748: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244",
  8749: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244ZM807 -244Q807 -246 813 -251T833 -263T861 -269Q880 -269 893 -260Q914 -247 926 -218T945 -133T956 -15T970 155T991 367Q994 390 999 438T1008 512T1019 580T1034 647T1055 703T1084 751T1122 784T1173 804Q1175 804 1182 804T1195 805Q1246 802 1275 769T1304 695Q1304 669 1288 657T1255 645Q1236 645 1221 658T1206 694Q1206 705 1210 714T1220 729T1232 737T1242 742L1246 743Q1246 745 1239 751T1219 762T1192 768Q1169 768 1154 756T1128 716T1112 652T1101 559T1092 444T1081 300T1063 133Q1043 -38 1031 -102T997 -207Q950 -306 863 -306Q813 -306 781 -272T749 -196Q749 -170 765 -158T798 -146Q817 -146 832 -159T847 -195Q847 -206 843 -215T833 -230T821 -238T811 -242L807 -244",
  8750: "269 74L256 80Q244 85 227 97T191 128T161 179T148 250Q148 332 199 379T302 433L306 434L307 444Q309 456 313 495T321 553T331 607T345 664T365 712T393 756T431 785T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q471 768 454 752T427 693T414 626T406 536Q405 530 405 527L397 425L404 422Q410 419 421 413T445 399T470 376T494 345T511 303T518 250Q518 205 502 169T460 112T410 80T364 66L360 65L359 55Q357 38 353 4T346 -43T340 -81T333 -118T326 -148T316 -179T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q231 -241 242 -183T266 33L269 74ZM272 122Q272 156 300 391Q300 392 299 392Q287 392 263 379T213 331T187 249Q187 211 205 180T239 137T272 116V122ZM366 107Q378 107 402 119T453 167T479 249Q479 340 394 383V377Q394 375 394 374T393 371T393 366T392 357T391 342T389 321T386 291T382 251T377 199T369 133Q366 112 366 107",
  8896: "119 -249T97 -249T65 -235T55 -207Q55 -201 56 -198Q58 -190 218 268T380 729Q392 750 416 750Q438 750 451 732Q453 728 534 498T695 36L775 -194Q777 -204 777 -208Q777 -222 767 -235T735 -249Q713 -249 700 -231Q696 -225 557 177L416 579L276 177Q136 -226 132 -231Q119 -249 97 -249",
  8897: "55 708Q55 729 68 739T96 750Q119 750 132 731Q136 726 276 323L416 -79L557 323Q696 725 700 731Q713 749 735 749Q756 749 766 736T777 708Q777 700 696 466T533 1T451 -232Q436 -249 416 -249Q402 -249 391 -241Q384 -236 380 -226Q368 -198 219 230Q55 697 55 708",
  8898: "139 -217Q127 -241 114 -246Q106 -249 97 -249Q67 -249 57 -220Q55 -214 55 102Q55 152 55 221T54 312Q54 422 60 464T91 554Q120 612 165 654T257 714T337 741T392 749Q393 750 402 750Q414 750 422 749Q557 749 660 659T776 430Q777 422 777 102Q777 -214 775 -220Q765 -249 735 -249Q716 -249 708 -241T694 -217L692 428L690 441Q674 540 597 603T416 666H409Q388 666 364 662T294 638T212 581Q156 523 142 441L140 428L139 105V-217",
  8899: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750",
  8968: "202 -349V850H449V810H242V-349H202",
  8969: "22 810V850H269V-349H229V810H22",
  8970: "202 -349V850H242V-309H449V-349H202",
  8971: "229 -309V850H269V-349H22V-309H229",
  9001: "373 850Q392 850 394 832Q394 825 267 538L139 250L267 -38Q394 -325 394 -332Q392 -350 375 -350Q361 -350 356 -338Q354 -331 289 -186T161 103T97 250T160 397T289 685T356 838Q362 850 373 850",
  9002: "77 832Q77 837 82 843T98 850Q110 849 115 838Q117 831 182 686T310 397T374 250T311 103T182 -185T115 -338Q110 -350 96 -350Q79 -350 77 -332Q77 -325 204 -38L332 250L204 538Q77 825 77 832",
  9168: "312 0V602H355V0H312",
  10072: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
  10216: "373 850Q392 850 394 832Q394 825 267 538L139 250L267 -38Q394 -325 394 -332Q392 -350 375 -350Q361 -350 356 -338Q354 -331 289 -186T161 103T97 250T160 397T289 685T356 838Q362 850 373 850",
  10217: "77 832Q77 837 82 843T98 850Q110 849 115 838Q117 831 182 686T310 397T374 250T311 103T182 -185T115 -338Q110 -350 96 -350Q79 -350 77 -332Q77 -325 204 -38L332 250L204 538Q77 825 77 832",
  10752: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM555 -165Q672 -165 767 -108T916 44T970 250Q970 418 861 532T600 664Q591 665 548 665Q446 665 353 614T200 466T140 250V243Q140 88 248 -30Q262 -46 280 -62T338 -105T434 -148T555 -165ZM478 250Q478 288 503 307T551 326Q586 326 609 305T632 250Q632 217 610 196T555 174T500 196T478 250",
  10753: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM513 478Q513 664 512 664Q504 664 481 660T406 637T313 588Q281 564 255 537T211 483T181 431T161 382T150 342T144 310T141 292H513V478ZM798 588Q758 616 711 634T639 658T602 663L597 664V292H969Q969 293 967 309T960 341T949 381T930 430T900 482T856 537T798 588ZM513 -164V208H141Q142 205 144 189T149 160T158 125T173 83T196 39T229 -9Q249 -34 273 -55T318 -92T363 -119T405 -138T444 -150T475 -158T499 -162T513 -164ZM775 -103Q801 -87 823 -68T863 -30T894 10T919 49T937 88T950 123T959 154T964 180T968 198L969 208H597V-164Q599 -163 616 -161T647 -155T683 -145T728 -128T775 -103",
  10754: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM600 664Q591 665 548 665Q414 665 306 583L292 573L423 441L555 310L687 441L818 573L804 583Q714 650 600 664ZM364 118L495 250L364 382L232 513L223 500Q140 391 140 250Q140 107 223 0L232 -13L364 118ZM970 250Q970 389 887 501L878 512Q878 513 861 496T812 447T746 381L615 250L746 118L878 -13L887 0Q970 109 970 250ZM687 59L555 190L423 59L292 -73L306 -83Q416 -166 555 -166T804 -83L818 -73L687 59",
  10756: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750ZM223 276Q223 282 224 287T227 296T232 302T238 308T243 313T250 316L254 319H374V376V406Q374 438 382 454T418 470Q443 467 450 453T458 410V376V319H579Q580 319 583 317T589 313T594 308T600 302T604 295T608 287T609 276Q609 253 587 241Q577 235 513 235H458V178Q458 176 458 166T459 148Q459 84 415 84Q401 84 390 93T375 117Q374 120 374 178V235H319Q317 235 307 235T290 234Q223 234 223 276",
  10758: "777 -217Q766 -244 745 -249H88Q64 -242 57 -220Q55 -214 55 250T57 720Q60 734 70 740Q80 750 96 750Q127 750 137 720Q139 714 139 274V-166H693V274Q693 714 695 720Q705 749 735 749Q766 749 775 719Q777 713 777 248V-217",
  12296: "373 850Q392 850 394 832Q394 825 267 538L139 250L267 -38Q394 -325 394 -332Q392 -350 375 -350Q361 -350 356 -338Q354 -331 289 -186T161 103T97 250T160 397T289 685T356 838Q362 850 373 850",
  12297: "77 832Q77 837 82 843T98 850Q110 849 115 838Q117 831 182 686T310 397T374 250T311 103T182 -185T115 -338Q110 -350 96 -350Q79 -350 77 -332Q77 -325 204 -38L332 250L204 538Q77 825 77 832"
}, {
  10764: "∬∬"
});
var no = {}, io = {};
Object.defineProperty(io, "__esModule", { value: !0 });
io.texCalligraphicBold = void 0;
io.texCalligraphicBold = {
  65: [0.751, 0.049, 0.921, { ic: 0.068, sk: 0.224 }],
  66: [0.705, 0.017, 0.748, { sk: 0.16 }],
  67: [0.703, 0.02, 0.613, { sk: 0.16 }],
  68: [0.686, 0, 0.892, { sk: 0.0958 }],
  69: [0.703, 0.016, 0.607, { ic: 0.02, sk: 0.128 }],
  70: [0.686, 0.03, 0.814, { ic: 0.116, sk: 0.128 }],
  71: [0.703, 0.113, 0.682, { sk: 0.128 }],
  72: [0.686, 0.048, 0.987, { sk: 0.128 }],
  73: [0.686, 0, 0.642, { ic: 0.104, sk: 0.0319 }],
  74: [0.686, 0.114, 0.779, { ic: 0.158, sk: 0.192 }],
  75: [0.703, 0.017, 0.871, { sk: 0.0639 }],
  76: [0.703, 0.017, 0.788, { sk: 0.16 }],
  77: [0.703, 0.049, 1.378, { sk: 0.16 }],
  78: [0.84, 0.049, 0.937, { ic: 0.168, sk: 0.0958 }],
  79: [0.703, 0.017, 0.906, { sk: 0.128 }],
  80: [0.686, 0.067, 0.81, { ic: 0.036, sk: 0.0958 }],
  81: [0.703, 0.146, 0.939, { sk: 0.128 }],
  82: [0.686, 0.017, 0.99, { sk: 0.0958 }],
  83: [0.703, 0.016, 0.696, { ic: 0.025, sk: 0.16 }],
  84: [0.72, 0.069, 0.644, { ic: 0.303, sk: 0.0319 }],
  85: [0.686, 0.024, 0.715, { ic: 0.056, sk: 0.0958 }],
  86: [0.686, 0.077, 0.737, { ic: 0.037, sk: 0.0319 }],
  87: [0.686, 0.077, 1.169, { ic: 0.037, sk: 0.0958 }],
  88: [0.686, 0, 0.817, { ic: 0.089, sk: 0.16 }],
  89: [0.686, 0.164, 0.759, { ic: 0.038, sk: 0.0958 }],
  90: [0.686, 0, 0.818, { ic: 0.035, sk: 0.16 }],
  305: [0.452, 8e-3, 0.394, { sk: 0.0319 }],
  567: [0.451, 0.201, 0.439, { sk: 0.0958 }]
};
Object.defineProperty(no, "__esModule", { value: !0 });
no.texCalligraphicBold = void 0;
var WH = s3, GH = io;
no.texCalligraphicBold = (0, WH.AddPaths)(GH.texCalligraphicBold, {
  65: "761 751Q784 751 784 728V711Q784 570 795 417T820 191Q844 76 865 76Q868 76 902 93T962 112H973Q989 104 989 94Q989 92 987 86Q978 47 846 -11Q812 -25 779 -26Q722 -26 708 9Q688 47 669 161H524L379 162L359 136Q286 43 234 -3T142 -49T71 -19T39 55Q39 92 60 131T103 174Q113 174 117 167T124 149T136 128T166 110Q183 105 190 105Q230 105 341 246Q401 322 453 397T531 514T582 601T611 651H640V663Q640 692 676 718T745 750Q747 750 752 750T761 751ZM658 266Q653 312 649 377T644 489T641 541V556L557 415Q500 325 448 253Q467 261 524 261H568H658V266",
  66: "441 83Q571 83 571 195Q571 246 538 279T466 322T386 333Q378 333 357 330T329 327Q307 327 307 345Q307 354 313 365T347 396T419 430Q546 472 581 498Q594 508 594 535Q594 574 567 589T508 604Q469 604 442 583Q390 546 342 457T265 256Q237 148 186 60Q167 29 144 13Q105 -15 68 -17H65Q40 -17 40 1Q40 7 53 29T87 100T124 210Q162 373 190 575Q188 575 174 567T138 550T98 542Q75 542 75 560Q75 588 123 618Q135 625 203 659T281 696Q299 703 316 703Q339 703 339 685Q339 656 328 583L333 588Q338 592 346 599T367 615T394 634T428 654T467 674T511 690T559 701T611 705Q651 704 681 689Q739 659 739 598Q739 507 595 427L584 421Q585 420 595 416T610 410T626 402T644 392T660 380T677 365T691 347T703 325T710 299T715 268Q717 193 665 130Q622 73 531 28T348 -17Q275 -17 225 10Q206 19 200 24T193 36Q193 57 231 86T311 119H322Q386 83 441 83",
  67: "243 -20Q135 -20 78 48T20 218Q20 280 39 344T98 470T193 580T324 661T488 702H490Q491 702 493 702T498 703T507 703T518 702H526Q599 702 599 631Q599 597 577 550T541 486Q523 463 490 447T431 430Q423 430 419 433Q409 437 409 450Q410 456 432 499T454 567Q454 586 446 594T415 603Q316 603 254 532Q216 487 190 421T164 284Q164 228 181 186T226 122T282 90T340 80Q377 80 405 96T449 131T492 167T553 187H555Q580 187 580 168Q580 153 551 123T476 60T367 4T243 -20",
  68: "107 0Q92 5 92 18Q92 33 113 53T160 86Q170 91 182 94T197 100L206 120Q248 226 273 337T304 501T309 585Q278 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q281 686 447 686H480H517Q692 686 784 631Q885 571 885 450Q885 339 805 239T586 75T286 1Q276 0 187 0H107ZM741 391Q741 424 731 452T694 510T613 558T481 584Q476 584 468 584T457 585L449 586V579Q441 501 425 424T391 292T357 193T330 125T319 100H324Q511 100 628 175Q688 215 714 275T741 391",
  69: "495 516Q485 516 478 520T470 532Q470 537 476 550T482 570Q482 589 465 596T401 603Q344 603 319 582Q295 558 295 519Q295 493 312 474T355 445T407 432T455 427Q477 427 477 409Q477 395 453 371T389 333Q380 330 345 327T279 312T223 272Q181 223 181 176Q181 131 225 107T324 83Q366 83 395 98T448 136T487 167Q517 185 547 187H551Q574 187 574 170Q574 151 535 113T421 36T271 -15Q260 -16 226 -16Q181 -16 152 -9Q104 4 71 33T37 111Q37 140 50 176T106 263T216 356Q215 357 207 362T190 374T172 392T156 419T150 456Q150 521 208 580T341 670T474 702Q475 703 499 703Q528 703 547 701T586 693T615 673T627 637Q627 584 581 550T495 516",
  70: "812 567Q804 567 795 570T786 579Q786 586 647 586H559L558 582Q558 575 539 510T506 407L498 384H775Q788 378 790 368Q790 328 746 298T665 268Q646 268 642 284H457L447 261Q396 150 360 94Q329 46 270 8T149 -30Q123 -30 100 -24T63 -10T37 9T22 26T17 36Q17 59 56 88T135 119Q145 119 149 117T165 104Q187 78 227 72Q232 72 234 76Q245 93 273 145T350 323T424 570L428 586H276Q265 575 239 563T190 551Q180 551 174 556T167 569Q167 580 179 597T213 634T278 668T371 685Q374 686 624 686Q863 685 888 682Q917 678 927 663Q930 658 930 650Q930 624 888 596T812 567",
  71: "50 279Q50 361 88 438T190 570T335 661T503 702H514Q524 703 532 703Q671 703 671 626Q671 580 614 514T495 447Q472 447 472 465Q472 477 499 511T527 562Q527 582 507 592T433 602Q351 602 302 569Q252 535 223 469T194 344Q194 266 237 217T352 168Q401 168 442 205T505 316Q515 345 551 368T622 393H625Q649 393 649 376Q649 371 635 318T612 237Q580 129 540 62T442 -49Q353 -114 264 -114Q259 -114 252 -114L246 -113Q190 -113 142 -107T81 -96Q71 -90 71 -81Q71 -57 110 -30T187 2Q196 2 236 -4T338 -14Q371 -14 377 -9Q410 24 446 113L451 127Q353 68 253 68Q157 68 104 129T50 279",
  72: "42 447Q20 447 20 465Q20 481 47 515T119 589T239 657T392 686Q443 686 463 664T484 616Q484 570 473 506T452 401L441 360Q441 359 550 359H660L663 370Q684 435 716 522T758 624Q771 646 806 666T870 686Q894 686 894 668Q894 667 867 597T804 416T752 218Q737 135 737 93Q737 77 746 65T778 53Q799 53 803 54T814 63Q831 86 864 103T924 120Q946 120 946 100Q945 85 931 63T888 16T806 -27T684 -48H681Q625 -48 603 -10Q593 4 593 29Q593 71 603 131T624 230L634 269Q632 269 624 266Q610 261 600 261T507 259H411L399 222Q344 62 322 21Q301 -7 268 -24T209 -41H207Q187 -41 185 -25Q185 -17 192 2T220 71T261 184Q284 256 284 258Q284 259 227 259H170Q169 259 166 261T162 264T158 266T156 271T155 277Q155 296 184 320T250 356Q259 358 286 359Q312 359 312 360Q314 372 318 385Q332 450 339 526Q339 530 339 535T340 543Q340 586 296 586Q255 586 227 576T188 553T165 523T146 497Q127 476 97 462T42 447",
  73: "56 499Q32 499 32 516Q32 540 64 580T165 649Q241 682 365 685Q366 685 376 685T405 685T445 686T496 686T553 686H732Q746 677 746 668Q746 646 711 620T642 587L572 586H503Q479 546 458 479T424 352T383 224T318 111L309 101L412 100H514L523 109Q567 150 618 153Q644 153 644 135Q644 132 642 124Q629 86 581 52T476 6Q454 2 433 2T216 0Q-11 0 -15 2Q-27 6 -27 18Q-27 37 2 61T59 93Q77 100 142 100H198Q255 177 299 369Q337 513 382 574L391 586H348Q261 586 176 576Q163 543 124 521T56 499",
  74: "286 390Q263 390 263 407Q263 432 293 481T367 566Q511 687 724 687Q738 687 761 687T793 686H923Q937 677 937 668Q937 648 905 623T842 589Q829 587 817 586T802 585T795 583T788 578Q709 506 632 189Q622 153 615 134T588 81T537 17Q482 -39 404 -76T247 -114Q192 -114 158 -100Q53 -61 53 32Q53 59 58 73T79 102Q126 147 177 147Q200 147 200 128Q200 123 198 112T196 96Q196 47 238 17T345 -13Q362 -13 377 -9T404 0T426 16T444 34T459 55T470 76T478 97T483 116T488 132L490 141Q511 222 520 257T554 364T608 486T675 576L685 586H634H612Q532 586 484 564Q453 549 436 526T409 478T395 447Q378 424 345 407T286 390",
  75: "98 542Q75 542 75 560Q75 588 123 618Q132 624 199 657T275 694Q291 703 315 703Q327 703 332 699T338 690T339 670Q339 596 323 505T283 337T237 194T198 90L181 53Q170 31 136 8T68 -17H65Q40 -17 40 0L76 92Q112 185 150 322T194 564V578L168 565Q125 542 98 542ZM834 142Q834 125 819 100T774 48T692 3T576 -16H560Q540 -16 508 6Q469 33 422 108T342 267T309 398Q309 411 310 417T320 442T347 482Q401 542 517 615T710 702Q712 702 721 702T735 703Q772 703 791 690Q819 674 819 646T792 597T733 574H722Q704 584 704 599Q706 607 700 610T672 617L660 613Q609 595 524 538T423 450V440Q423 376 488 247T604 83Q621 70 640 70Q677 70 701 82Q713 87 718 101T737 132T783 160Q792 163 807 163Q834 163 834 142",
  76: "63 -17Q41 -17 41 0Q41 22 85 54Q101 68 113 92T133 141T154 219T182 315Q230 462 306 553Q345 599 391 632T478 678T543 697T582 703Q584 703 589 703T598 702Q643 702 666 676T689 613Q689 588 683 575Q674 551 632 524T552 496Q530 496 530 512Q530 517 531 525T533 538Q533 559 522 577T480 596H476Q462 596 451 588T415 544Q350 447 310 281Q284 181 261 136L255 124H285Q342 123 441 107T583 90L596 89Q603 116 647 144T729 173Q751 173 751 157Q751 118 685 60T523 -15Q514 -16 479 -16Q421 -16 320 0T171 18H155L142 10Q98 -17 63 -17",
  77: "38 20Q38 59 60 99T104 139Q106 139 126 125T176 106H181Q200 106 221 139T286 281Q322 370 342 451T368 581T376 634Q384 657 420 680T487 703Q502 703 507 696T522 649Q538 589 554 537Q579 453 609 372T660 248T686 202Q687 201 739 244T830 322L1166 642Q1225 700 1230 701Q1230 701 1237 703Q1258 703 1258 667L1253 637Q1248 607 1241 558T1227 451T1214 326T1209 202Q1209 77 1232 77Q1237 77 1269 94T1326 112H1329Q1353 112 1353 94Q1353 81 1334 60Q1311 37 1248 7T1150 -24H1141H1135Q1085 -24 1074 26Q1064 75 1064 134Q1064 239 1086 426Q1087 430 1087 434L1061 410Q871 227 783 149L694 76Q653 44 647 40T631 34Q620 34 616 37T594 63Q546 125 514 198Q467 307 423 449L418 466L412 444Q376 310 306 153Q278 88 251 45T201 -18T163 -43T131 -49Q102 -48 70 -31T38 20",
  78: "47 139Q81 105 122 105Q137 105 147 117Q159 134 182 199T234 381T274 610Q275 634 284 647Q297 666 327 684T389 703Q403 703 408 695T428 645Q480 490 567 298Q628 163 673 103Q674 102 674 102T675 106Q732 331 803 551Q842 674 875 725Q908 775 966 807T1081 840H1084Q1105 840 1105 803Q1105 768 1088 733T1051 689Q1045 686 1032 686Q986 683 948 663T901 624Q881 579 837 430T760 154L726 28Q725 28 725 28T723 25Q716 0 682 -24T611 -48Q600 -48 595 -45T576 -23Q522 44 480 124Q417 243 332 463L328 473L325 457Q291 293 227 124Q159 -49 72 -49Q38 -49 5 -28Q-24 -8 -24 21Q-24 58 -3 98T41 139H47",
  79: "433 703Q456 703 456 685Q456 672 441 655T407 627Q402 623 378 611T328 579T276 524Q207 434 207 324Q207 222 270 153T441 84Q566 84 651 177T737 400V405Q737 496 693 549T576 603Q542 603 510 560Q490 537 472 502T442 454Q397 412 346 409Q320 409 320 427Q320 430 322 436Q331 465 360 507T433 594T542 671T677 703Q776 703 829 636T882 468Q882 369 831 277T702 122T528 21T343 -17Q214 -17 139 61T63 257Q63 336 94 409T173 534T272 625T367 684T432 703H433",
  80: "170 -67Q147 -67 147 -49Q147 -42 162 -8T204 99T253 254Q274 332 288 415T305 542L308 585Q277 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H495H537Q622 686 678 677T784 637Q846 598 846 533Q846 452 776 375T597 252T378 206H366L358 181Q341 130 316 68T282 -7Q262 -33 230 -50T170 -67ZM701 468Q701 512 661 540T570 577T461 586H448V582Q446 576 443 545T428 447T395 301L389 280Q390 280 398 284T419 295T441 303Q443 304 484 306T572 321T651 359Q701 402 701 468",
  81: "874 453Q874 372 836 298T750 177T638 89T543 33T486 8L483 7Q485 5 523 -7T622 -32T726 -46Q741 -46 746 -45T755 -41T762 -27Q770 -1 806 23T878 50H890Q905 42 905 33Q905 -8 838 -68T670 -145Q662 -146 628 -146Q538 -146 389 -100T164 -50Q132 -50 132 -32T162 11T227 47Q231 48 286 51T394 62T518 100T641 180Q730 271 730 387Q730 478 673 540T520 602Q410 602 337 525T264 355Q264 284 310 244T420 203Q476 203 568 222Q594 222 594 204Q594 184 565 161T508 128Q433 103 316 103Q227 103 174 157T120 290Q120 382 182 471T343 620T548 697Q578 703 601 703Q604 703 611 703T623 702Q663 702 687 696Q760 679 817 618T874 453",
  82: "159 0Q159 5 172 34T205 114T245 229T284 386T309 575V585H304Q303 585 295 585T282 584Q233 579 207 570T175 553T165 531T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H505H582Q683 686 745 672T834 611Q842 594 842 565Q842 523 824 484T780 419T722 370T669 336T632 318L619 312L626 302Q640 279 667 227T696 172Q717 133 735 112T762 88T784 84Q824 84 872 118T957 153Q981 153 981 136Q981 114 937 78T820 13T684 -17Q646 -17 616 8T569 66T526 151T477 234Q461 256 446 265Q437 272 421 274Q400 274 400 291Q400 311 430 336T495 371Q496 371 543 374T627 392T681 436Q699 467 699 503Q699 550 644 568T471 586H449V582Q449 581 447 559T438 499T422 413T393 298T348 165Q313 73 296 45Q282 24 249 4T185 -17Q159 -17 159 0",
  83: "204 476Q204 525 248 577T372 666T539 703T674 683T721 612Q721 588 714 569Q704 547 669 524T601 499Q573 499 573 516Q573 521 575 527T577 543Q577 563 568 574T548 588L539 590Q490 603 444 603Q418 603 394 597T364 583Q348 567 348 533Q348 493 382 466T459 425T555 387T633 330Q662 292 662 249Q662 153 544 69T257 -16Q218 -16 208 -15Q118 1 64 46Q25 76 25 126Q25 185 82 235T203 290H207Q229 290 231 274Q231 243 180 213Q173 209 172 206T170 189T171 170T183 150T216 121Q273 83 356 83Q412 83 459 100Q493 111 507 141Q518 165 518 185Q518 208 506 228T478 262T437 288T398 306T360 320Q316 335 285 352T239 384T215 416T205 443T204 467V476",
  84: "61 462H59Q38 462 38 479Q38 528 109 594T289 683L304 685L837 687L846 693Q889 720 923 720Q947 720 947 702Q945 671 892 631T776 583Q774 583 772 583T769 582T766 582L764 581H758Q753 581 744 581T722 580T693 580T662 580H563L514 385Q507 355 493 299T475 225T460 172T443 119T426 76T402 24Q386 -11 355 -33T304 -61T266 -69Q242 -69 242 -50Q243 -45 253 -25T278 32T307 115L364 340Q405 511 413 538T436 580H207Q202 572 200 568T197 561T195 552T190 537Q176 511 135 487T61 462",
  85: "124 586Q107 586 74 569T15 552H13Q-10 552 -10 570Q-10 605 70 645T222 686Q283 686 283 631Q283 590 246 504T172 326T135 181Q135 130 157 107T205 83Q221 83 259 106Q347 165 453 301T604 548Q607 557 612 569T619 587T624 600T628 612T632 621T637 628T641 634T647 640T654 645T662 652Q706 686 748 686Q771 686 771 669Q771 656 754 614T700 467T630 229Q615 168 610 105Q610 88 617 78L641 90Q681 111 706 112Q733 112 733 95Q733 82 714 60Q694 40 633 10Q567 -23 532 -24Q507 -24 495 -17Q466 -4 466 32Q466 96 500 225Q277 -17 102 -17Q56 -17 23 17T-10 118Q-10 164 13 234T64 363T115 481T139 567Q139 586 124 586",
  86: "25 608Q25 628 60 657T148 686Q184 683 213 671T273 625T327 538T363 394T380 184L381 134L399 148Q503 226 574 302T667 415T689 467Q688 474 684 482T672 502T645 521T600 532Q576 532 576 567Q576 604 597 644T641 685H649Q701 685 737 648T774 545Q774 457 703 333T461 66Q397 13 332 -32T255 -77Q237 -77 237 -30V-23Q241 20 241 109Q241 483 115 569Q91 586 50 589Q25 589 25 608",
  87: "25 607Q25 629 62 657T142 686Q205 686 248 647T312 541T339 411T347 275Q347 249 345 203V189Q375 219 449 316T587 516Q629 584 629 587Q629 589 626 597T622 607Q622 629 658 656T732 686H744Q755 680 757 678Q757 677 769 649T799 577T835 475T874 339T904 183Q908 157 910 151L925 169Q997 252 1059 343T1121 474Q1120 498 1103 513T1059 532Q1036 532 1036 568Q1036 600 1053 636T1090 683L1097 686H1109Q1147 684 1176 652T1206 551Q1206 460 1131 320T897 7Q859 -33 840 -52T816 -74T804 -77Q788 -77 784 -32Q783 -28 783 -26Q774 108 744 239T691 436T665 501Q664 501 649 475T602 400T528 289T420 146T280 -15Q243 -56 231 -66T210 -77Q191 -77 191 -40Q191 -38 195 -4T204 91T209 217Q209 290 202 351T177 469T126 557T45 589Q25 589 25 607",
  88: "762 562Q762 579 737 584T711 604Q711 630 753 658T834 686Q864 686 885 669T906 627Q906 580 834 522T614 379L584 362V357Q585 354 589 315T597 233T603 183Q610 132 627 116T671 100Q678 100 704 113T754 126T778 107Q776 79 733 45T626 2Q615 1 578 1Q542 1 535 3Q521 7 510 15T491 31T477 54T467 78T460 108T456 137T452 170T449 201Q447 220 445 240T442 270L441 281Q435 281 357 233Q240 165 206 135Q200 128 200 124Q200 113 208 108T226 101T244 96T252 82Q252 61 214 31T129 1H120Q97 1 77 16T56 60Q56 105 133 168T414 345Q428 352 431 354T433 359Q422 493 414 522Q407 551 395 566T373 583T350 586H341L332 580Q290 560 265 560Q243 560 243 577Q243 585 248 596T269 624T306 653T365 676T447 686H456Q472 686 484 683T514 671T543 637T562 576Q565 557 570 501L577 437Q577 436 613 457T694 506T756 551Q762 558 762 562",
  89: "73 555Q49 555 49 573Q49 602 110 644T239 686Q319 686 376 624Q416 584 444 511T483 361T499 240T503 173Q503 165 504 165Q506 165 524 184T556 218Q631 297 674 377T718 485Q718 505 699 526Q673 552 628 552Q619 552 613 562T607 590Q607 617 621 645T658 685Q661 686 671 686Q718 686 757 652T797 545Q797 476 749 369T602 146Q500 29 371 -67T176 -164Q112 -164 74 -120T36 -29Q36 5 55 36T95 67Q104 67 108 59T115 39T128 12T154 -12Q183 -30 216 -30Q239 -30 305 7L361 44L367 49V54Q367 95 364 143T351 273T312 429T243 546Q206 581 156 588L146 581Q108 555 73 555",
  90: "622 574Q522 579 420 579H396Q373 579 364 574T351 550Q339 516 297 490T218 462Q195 462 195 479Q195 487 197 492Q218 565 313 625T509 685Q564 685 650 683T755 680Q787 680 807 683T831 686Q853 686 853 669Q853 657 826 626Q742 532 641 437L619 415L622 414Q626 414 631 414T642 414Q697 411 697 388Q697 367 670 345T607 323Q605 323 592 325T546 329H522L490 302Q457 274 400 226T289 136L260 113L318 112Q345 111 452 109T587 106H627Q650 143 656 170Q666 197 710 225T788 253Q811 253 811 237Q811 211 781 160T710 77Q619 0 515 0Q507 0 497 0T484 1Q434 1 319 3T177 6Q123 6 95 2Q83 2 71 0H68Q46 0 46 17Q46 28 58 44Q68 56 100 80T210 165T383 307L408 329H361L314 330Q297 338 297 350Q297 368 320 388T368 413Q375 415 441 415H506L647 555L664 574H622",
  305: "24 296Q24 305 34 328T63 380T115 430T187 452Q205 452 223 448T262 435T295 406T308 360Q308 345 287 290T240 170T207 87Q202 67 202 57Q202 42 215 42Q235 42 257 64Q288 92 302 140Q307 156 310 159T330 162H336H347Q367 162 367 148Q367 140 357 117T329 65T276 14T201 -8Q158 -8 121 15T83 84Q83 104 133 229T184 358Q189 376 189 388Q189 402 177 402Q156 402 134 380Q103 352 89 304Q84 288 81 285T61 282H55H44Q24 282 24 296",
  567: "297 360T297 373T294 392T288 400T278 401H276Q237 398 200 363Q181 343 170 325T156 299T149 287T129 282H123H116Q102 282 97 284T92 298Q93 303 98 315T118 349T151 390T201 427T267 451H279Q357 451 388 422T420 354V339L370 138Q321 -60 317 -69Q287 -157 163 -194Q133 -201 99 -201Q39 -201 14 -178T-12 -125Q-12 -94 11 -69T68 -43Q93 -43 108 -57T123 -95Q123 -121 100 -151H104Q131 -151 155 -125T193 -60Q195 -54 244 141T294 345Q297 360 297 373"
}, {});
var oo = {}, ao = {};
Object.defineProperty(ao, "__esModule", { value: !0 });
ao.texCalligraphic = void 0;
ao.texCalligraphic = {
  65: [0.728, 0.05, 0.798, { ic: 0.021, sk: 0.194 }],
  66: [0.705, 0.022, 0.657, { sk: 0.139 }],
  67: [0.705, 0.025, 0.527, { sk: 0.139 }],
  68: [0.683, 0, 0.771, { sk: 0.0833 }],
  69: [0.705, 0.022, 0.528, { ic: 0.036, sk: 0.111 }],
  70: [0.683, 0.032, 0.719, { ic: 0.11, sk: 0.111 }],
  71: [0.704, 0.119, 0.595, { sk: 0.111 }],
  72: [0.683, 0.048, 0.845, { sk: 0.111 }],
  73: [0.683, 0, 0.545, { ic: 0.097, sk: 0.0278 }],
  74: [0.683, 0.119, 0.678, { ic: 0.161, sk: 0.167 }],
  75: [0.705, 0.022, 0.762, { sk: 0.0556 }],
  76: [0.705, 0.022, 0.69, { sk: 0.139 }],
  77: [0.705, 0.05, 1.201, { sk: 0.139 }],
  78: [0.789, 0.05, 0.82, { ic: 0.159, sk: 0.0833 }],
  79: [0.705, 0.022, 0.796, { sk: 0.111 }],
  80: [0.683, 0.057, 0.696, { ic: 0.037, sk: 0.0833 }],
  81: [0.705, 0.131, 0.817, { sk: 0.111 }],
  82: [0.682, 0.022, 0.848, { sk: 0.0833 }],
  83: [0.705, 0.022, 0.606, { ic: 0.036, sk: 0.139 }],
  84: [0.717, 0.068, 0.545, { ic: 0.288, sk: 0.0278 }],
  85: [0.683, 0.028, 0.626, { ic: 0.061, sk: 0.0833 }],
  86: [0.683, 0.052, 0.613, { ic: 0.045, sk: 0.0278 }],
  87: [0.683, 0.053, 0.988, { ic: 0.046, sk: 0.0833 }],
  88: [0.683, 0, 0.713, { ic: 0.094, sk: 0.139 }],
  89: [0.683, 0.143, 0.668, { ic: 0.046, sk: 0.0833 }],
  90: [0.683, 0, 0.725, { ic: 0.042, sk: 0.139 }]
};
Object.defineProperty(oo, "__esModule", { value: !0 });
oo.texCalligraphic = void 0;
var zH = s3, UH = ao;
oo.texCalligraphic = (0, zH.AddPaths)(UH.texCalligraphic, {
  65: "576 668Q576 688 606 708T660 728Q676 728 675 712V571Q675 409 688 252Q696 122 720 57Q722 53 723 50T728 46T732 43T737 41T743 39L754 45Q788 61 803 61Q819 61 819 47Q818 43 814 35Q799 15 755 -7T675 -30Q659 -30 648 -25T630 -8T621 11T614 34Q603 77 599 106T594 146T591 160V163H460L329 164L316 145Q241 35 196 -7T119 -50T59 -24T30 43Q30 75 46 100T74 125Q81 125 83 120T88 104T96 84Q118 57 151 57Q189 57 277 182Q432 400 542 625L559 659H567Q574 659 575 660T576 668ZM584 249Q579 333 577 386T575 473T574 520V581L563 560Q497 426 412 290L372 228L370 224H371L383 228L393 232H586L584 249",
  66: "304 342Q292 342 292 353Q292 372 323 391Q331 396 417 428T533 487Q563 512 563 555V562Q563 575 557 589T530 618T475 636Q429 636 396 613T330 539Q263 446 210 238Q196 183 173 120Q135 31 121 16Q108 1 85 -10T47 -22T32 -10Q32 -5 44 18T77 93T112 206Q135 296 154 395T182 550T191 615Q191 616 190 616Q188 616 179 611T157 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 693Q295 686 288 635T278 575Q278 572 287 582Q336 635 402 669T540 704Q603 704 633 673T664 599Q664 559 638 523T580 462Q553 440 504 413L491 407L504 402Q566 381 596 338T627 244Q627 172 575 110T444 13T284 -22Q208 -22 158 28Q144 42 146 50Q150 67 178 85T230 103Q236 103 246 95T267 75T302 56T357 47Q436 47 486 93Q526 136 526 198V210Q526 228 518 249T491 292T436 330T350 345Q335 345 321 344T304 342",
  67: "201 -25Q167 -25 136 -14T75 23T29 94T12 202Q12 290 50 394T161 574Q227 642 303 673T433 704Q435 705 457 705Q533 701 533 640Q533 606 507 548T464 474Q431 444 396 444Q381 444 381 453Q381 459 388 473T407 513T428 563Q433 580 433 594Q433 636 381 636Q314 636 260 594T175 489T128 363T112 247Q112 157 153 101T273 44Q347 44 398 121Q413 144 437 157T481 171Q496 171 496 160Q496 150 476 123Q426 56 350 16T201 -25",
  68: "37 475Q19 475 19 487Q19 536 103 604T327 682H356Q386 683 408 683H419Q475 683 506 681T582 668T667 633Q766 571 766 450Q766 365 723 287T611 152T455 57T279 6Q248 1 160 0Q148 0 131 0T108 -1Q72 -1 72 11Q72 24 90 40T133 64L144 68L152 88Q247 328 272 587Q275 613 272 613Q272 613 269 613Q225 610 195 602T149 579T129 556T119 532Q118 530 116 525T113 518Q102 502 80 490T37 475ZM665 407Q665 596 412 613Q403 614 383 614Q370 614 370 612Q370 598 363 542T323 357T242 103L228 69H265Q391 73 481 119Q536 148 575 188T633 268T658 338T665 392V407",
  69: "144 470Q144 556 240 630T451 705Q564 705 564 637Q564 611 540 573Q529 559 505 547T464 534Q448 534 448 545Q448 552 455 562Q463 577 463 591Q463 600 462 604T456 616T436 627T400 635Q396 635 390 635T380 636Q291 636 258 568Q245 544 245 516Q245 463 290 438T391 410Q415 410 415 398Q415 392 407 380T376 356T326 341Q288 340 260 327Q218 311 187 276T143 208T130 151Q130 113 156 88T211 55T268 47Q349 47 403 125Q415 144 439 157T483 171Q499 171 499 160Q499 148 475 120T413 59T315 3T197 -22Q124 -22 77 14T30 105Q30 126 39 154T66 216T122 288T209 354L223 362Q144 400 144 470",
  70: "199 579Q181 579 181 590Q181 598 188 611T212 639T260 666T335 682Q336 682 349 682T383 682T431 682T493 683T561 683Q776 682 784 681Q826 673 829 647Q829 620 797 600T744 580Q728 580 728 595Q729 607 713 610Q698 613 598 614H500L499 610Q499 598 467 486T428 367Q428 365 551 365H674Q683 360 684 355Q687 346 677 329Q666 312 642 299T598 285Q586 285 582 296H402L394 277Q386 258 373 229T346 167T315 102T286 51Q265 22 225 -5T133 -32Q108 -32 87 -25T54 -7T33 15T21 35T18 47Q18 60 44 80T98 103Q108 103 111 101T119 88Q130 66 150 54T179 39T195 37Q199 37 203 43Q217 67 245 125T318 300T391 532Q393 543 398 564T406 598T409 613T339 614H269Q229 579 199 579",
  71: "216 68Q155 68 115 100T59 177T44 273Q44 299 50 333T73 421T133 533T239 632Q346 704 466 704Q508 704 515 703Q555 696 577 681T599 635Q599 605 570 560T523 496Q490 466 455 466Q440 466 440 475T469 526T499 589Q499 605 489 617Q460 636 403 636Q343 636 295 611T220 548T174 464T150 382T144 318Q144 241 180 189T287 137Q325 137 359 160Q428 205 466 322Q472 342 501 359T551 376Q557 376 560 373T564 368L565 365Q560 341 551 302T512 173T451 31Q359 -119 204 -119Q163 -118 127 -109T74 -91T53 -77Q52 -75 52 -71Q52 -54 79 -35T132 -14H140L151 -19Q210 -49 281 -49H289Q312 -49 329 -31Q351 -7 372 36T405 109T416 142L408 136Q401 131 392 125T369 111T338 96T303 82T261 72T216 68",
  72: "18 487Q18 496 29 517T67 566T127 621T216 665T330 683Q359 683 376 669T397 643T400 622Q400 584 382 488T348 343Q348 342 467 342H587L594 366Q615 440 648 534T690 641Q701 656 723 669T764 683Q783 683 783 672L750 578Q716 485 677 346T625 101Q624 92 623 82T622 65T621 56Q621 20 658 20Q666 20 701 25Q709 52 736 69T785 87Q803 87 803 75T791 44T754 3T685 -33T588 -48Q568 -48 562 -46Q522 -31 522 13V23Q531 129 562 250L569 281L565 280Q561 278 556 277T549 274L438 273H328L321 249Q307 202 275 107T232 0Q219 -16 196 -28T155 -41Q149 -41 145 -39T140 -34T139 -29Q139 -24 148 -3T181 86T233 247Q240 270 240 272Q240 273 194 273H169Q139 273 139 285Q139 295 153 308T187 332Q206 341 236 342L260 343L264 359Q278 414 289 482T300 578Q300 613 260 613H254Q198 613 169 592Q148 578 127 544T104 508Q72 478 37 475Q18 475 18 487",
  73: "174 0H31Q-13 0 -21 2T-30 12Q-30 23 -17 36Q9 60 42 68L155 70Q187 102 214 179T257 333T302 491T366 610L369 614H305Q221 611 188 607T145 596T128 569Q119 543 94 529T47 512Q28 512 28 524Q28 527 32 539Q56 614 159 654Q218 678 312 682Q314 682 339 682T404 682T481 683H632Q642 678 642 671Q642 657 621 641T577 617Q570 615 507 614H444Q427 592 406 542Q382 478 355 366T310 209Q280 123 238 78L230 69H330Q442 70 442 74Q443 74 443 77T447 87T460 105Q490 134 527 137Q545 137 545 125Q545 120 542 112Q531 78 491 49T399 7Q379 2 360 2T174 0",
  74: "148 78Q148 16 189 -17T286 -50Q319 -50 348 -33T396 10T426 59T444 101L471 204Q498 306 521 372Q575 532 649 605L659 614H591Q517 613 494 607Q433 591 400 550T360 477Q353 454 325 437T275 419Q256 419 260 435Q280 523 376 597T583 681Q603 683 713 683H830Q839 674 839 671Q839 654 810 634T754 614Q735 614 721 601Q688 571 654 495T600 351T561 209T541 132Q507 29 412 -45T213 -119Q141 -119 94 -77T47 33Q47 55 50 69T58 90T71 103Q105 131 135 131Q152 131 152 120Q152 119 151 114T149 99T148 78",
  75: "194 618Q193 618 182 613T156 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 691Q295 569 250 397Q225 306 197 217T151 81T128 25Q120 8 94 -7T47 -22Q32 -22 32 -10L64 76Q95 163 133 295T185 530Q198 611 194 618ZM331 429Q331 383 364 290T449 117T542 36Q574 36 607 51T652 103Q660 124 677 133T709 143Q727 143 727 128Q727 119 723 111Q704 56 639 17T497 -22H493Q463 -22 425 16Q401 40 382 71Q335 138 296 243T256 399Q256 434 288 473Q342 540 471 622T670 705Q691 704 703 696Q732 678 732 644Q732 613 714 600T677 586Q671 586 667 587T660 592T657 604V619Q657 647 629 647Q623 647 620 646Q576 635 495 583T365 482Q331 448 331 429",
  76: "62 -22T47 -22T32 -11Q32 -1 56 24T83 55Q113 96 138 172T180 320T234 473T323 609Q364 649 419 677T531 705Q559 705 578 696T604 671T615 645T618 623V611Q618 582 615 571T598 548Q581 531 558 520T518 509Q503 509 503 520Q503 523 505 536T507 560Q507 590 494 610T452 630Q423 630 410 617Q367 578 333 492T271 301T233 170Q211 123 204 112L198 103L224 102Q281 102 369 79T509 52H523Q535 64 544 87T579 128Q616 152 641 152Q656 152 656 142Q656 101 588 40T433 -22Q381 -22 289 1T156 28L141 29L131 20Q111 0 87 -11",
  77: "28 9Q28 37 43 63T73 90Q77 90 83 84T103 70T141 57H146Q162 57 178 79T222 167Q266 279 295 371T334 513T349 598T358 651T371 677Q397 705 432 705Q442 705 445 699T452 666Q453 661 453 659Q475 538 509 405T568 207L574 192Q581 178 587 164T594 150Q596 150 635 189T693 248Q765 324 863 438T1024 626T1089 701Q1093 705 1100 705Q1111 705 1111 682Q1111 675 1108 660T1099 611T1086 540Q1041 277 1041 144Q1041 98 1044 75T1050 48T1059 42Q1064 41 1075 46Q1102 61 1121 61Q1137 61 1137 50Q1137 28 1087 0T1000 -29Q983 -29 972 -23T955 -9T945 16T942 45T941 83V96Q941 158 952 256T974 422L985 489Q984 489 939 436T821 300T698 164Q665 128 620 85T568 37Q564 34 558 34Q550 34 546 37T535 54Q512 91 496 127T450 259T389 498L384 518Q349 367 294 223T198 15Q155 -50 117 -50Q87 -50 61 -35T30 -6Q28 2 28 9",
  78: "343 705Q358 705 358 698Q360 696 370 658T411 524T484 319Q536 174 590 82L595 73L615 152Q646 274 683 407Q729 571 752 637T799 727Q852 780 937 788Q939 788 947 788T958 789H962Q979 789 979 765Q979 722 951 692Q942 683 924 683Q888 681 859 672T818 654T803 639Q784 608 708 322T631 15Q631 14 630 15Q630 17 629 15Q628 14 628 12Q621 -4 601 -17T560 -31Q550 -31 546 -28T530 -7Q484 67 458 123T398 272Q352 392 314 514L306 535V534Q306 533 296 488T272 379T234 239T185 100T127 -7T61 -50Q34 -50 4 -34T-27 8Q-27 33 -12 61T18 90Q21 90 36 77T87 57H92Q109 57 123 78T162 173Q206 299 232 417T265 599T276 667Q284 681 304 693T343 705",
  79: "308 428Q289 428 289 438Q289 457 318 508T378 593Q417 638 475 671T599 705Q688 705 732 643T777 483Q777 380 733 285T620 123T464 18T293 -22Q188 -22 123 51T58 245Q58 327 87 403T159 533T249 626T333 685T388 705Q404 705 404 693Q404 674 363 649Q333 632 304 606T239 537T181 429T158 290Q158 179 214 114T364 48Q489 48 583 165T677 438Q677 473 670 505T648 568T601 617T528 636Q518 636 513 635Q486 629 460 600T419 544T392 490Q383 470 372 459Q341 430 308 428",
  80: "37 475Q19 475 19 487Q19 536 103 604T327 682Q329 682 344 682T380 682T421 683H463Q625 683 695 615Q718 591 726 564Q733 547 733 525Q733 412 607 312T321 205H312Q293 205 293 217Q293 224 302 236T333 260T385 274Q558 287 614 407Q633 445 633 477Q633 515 612 543T556 585T481 607T399 614H370L368 603Q352 463 312 312T242 82T202 -13Q190 -33 164 -45T121 -57Q108 -57 108 -45Q108 -40 120 -10T151 73T192 190T233 349T266 539Q267 546 269 565T272 598T274 613H270Q209 613 163 588Q131 572 113 518Q102 502 80 490T37 475",
  81: "114 286Q114 358 151 433T249 569T392 667T558 705Q653 705 713 641T774 460Q774 389 750 322T687 206T600 114T504 46T412 4L399 -2Q542 -62 636 -62Q660 -62 670 -54T686 -27T700 0Q734 34 770 34Q787 34 787 23Q787 -18 720 -74T563 -131Q485 -131 350 -83T145 -34Q127 -34 127 -22Q127 -12 144 5T190 31L200 34L237 35Q386 38 467 79Q550 120 612 210T675 416Q675 510 625 573T484 636Q410 636 346 587T248 469T214 333Q214 306 221 281T243 229T288 188T360 172Q403 172 441 188T490 205Q510 205 510 192Q505 162 432 132T287 102Q206 102 160 155T114 286",
  82: "37 475Q19 475 19 487Q19 503 35 530T83 589T180 647T327 682H374Q387 682 417 682T464 683Q519 683 559 679T642 663T708 625T731 557Q731 481 668 411T504 300Q506 296 512 286T528 257T553 202Q594 105 611 82Q635 47 665 47Q708 47 742 93Q758 113 786 128Q804 136 819 137Q837 137 837 125Q837 115 818 92T767 43T687 -2T589 -22Q549 -22 517 22T467 120T422 221T362 273Q346 273 346 287Q348 301 373 320T436 342Q437 342 446 343T462 345T481 348T504 353T527 362T553 375T577 393Q598 412 614 443T630 511Q630 545 613 566T541 600T393 614Q370 614 370 613L366 584Q349 446 311 307T243 96L213 25Q205 8 179 -7T132 -22Q125 -22 120 -18T117 -8Q117 -5 130 26T163 113T205 239T246 408T274 606V614Q273 614 259 613T231 609T198 602T163 588Q131 572 113 518Q102 502 80 490T37 475",
  83: "554 512Q536 512 536 522Q536 525 539 539T542 564Q542 588 528 604Q515 616 482 625T410 635Q374 635 349 624T312 594T295 561T290 532Q290 505 303 482T342 442T378 419T409 404Q435 391 451 383T494 357T535 323T562 282T574 231Q574 133 464 56T220 -22Q138 -22 78 21T18 123Q18 184 61 227T156 274Q178 274 178 263Q178 260 177 258Q172 247 164 239T151 227T136 218L127 213L124 202Q118 186 118 163Q120 124 165 86T292 48Q374 48 423 86T473 186V193Q473 267 347 327Q268 364 239 389Q191 431 191 486Q191 547 242 600T356 679T470 705Q472 705 478 705T489 704Q551 704 596 682T642 610Q642 566 621 545Q592 516 554 512",
  84: "49 475Q34 475 34 490Q34 552 106 611T261 681Q272 683 507 683H742Q790 717 816 717Q833 717 833 708Q833 682 795 653T714 615Q691 610 588 609Q490 609 490 607L483 580Q476 554 462 496T435 392Q410 289 395 231T363 116T335 34T309 -15T279 -47T242 -64Q231 -68 218 -68Q203 -68 203 -57Q203 -52 211 -38Q224 -7 234 20T251 66T268 123T283 179T304 261T328 360Q342 415 360 488Q380 567 384 582T397 605Q400 607 401 609H302H244Q200 609 188 607T167 596Q145 572 145 541Q145 520 109 498T49 475",
  85: "8 592Q8 616 70 649T193 683Q246 683 246 631Q246 587 205 492T124 297T83 143Q83 101 100 75T154 48Q202 48 287 135T450 342T560 553Q589 635 593 640Q603 656 626 668T669 683H670Q687 683 687 672T670 616T617 463T547 220Q525 137 521 68Q521 54 522 50T533 42L543 47Q573 61 588 61Q604 61 604 47Q599 16 506 -22Q486 -28 468 -28T436 -18T421 18Q421 92 468 258Q468 259 467 257T459 248Q426 206 391 167T303 81T194 6T83 -22Q66 -22 58 -20Q25 -11 4 19T-17 99Q-17 146 8 220T64 358T120 488T146 586Q146 604 141 608T123 613H120Q99 613 72 597T25 580Q8 580 8 592",
  86: "25 633Q25 647 47 665T100 683Q291 683 291 306Q291 264 288 213T282 132L279 102Q281 102 308 126T378 191T464 279T545 381T596 479Q600 490 600 502Q600 527 581 550T523 577Q505 577 505 601Q505 622 516 647T542 681Q546 683 558 683Q605 679 631 645T658 559Q658 423 487 215Q409 126 308 37T190 -52Q177 -52 177 -28Q177 -26 183 15T196 127T203 270Q203 356 192 421T165 523T126 583T83 613T41 620Q25 620 25 633",
  87: "25 633Q25 647 46 665T103 683Q168 683 207 632Q228 608 243 568Q269 485 269 374Q269 324 265 271T256 184L251 150L252 152Q254 153 257 157T264 167T274 180T286 197Q359 293 424 398T519 558T549 616Q549 618 547 624T545 638Q550 654 572 668T615 683Q626 683 632 672T657 595Q726 370 741 128L742 110Q752 122 767 142T823 217T894 321T950 424T976 511Q976 544 958 560T918 577Q906 577 906 602Q906 629 918 651T942 681Q948 683 954 683Q983 683 1008 658T1034 569T999 421T915 257T813 109T724 -3T681 -49Q666 -59 660 -45Q659 -41 657 35T639 233T591 477Q573 551 570 551Q569 551 554 523T507 439T433 315T323 155T182 -25Q160 -52 151 -53Q137 -53 137 -30Q137 -29 148 25T170 168T181 338Q181 424 168 483T131 571T87 609T40 620Q25 620 25 633",
  88: "324 614Q291 576 250 573Q231 573 231 584Q231 589 232 592Q235 601 244 614T271 643T324 671T400 683H403Q462 683 481 610Q485 594 490 545T498 454L501 413Q504 413 551 442T648 509T705 561Q707 565 707 578Q707 610 682 614Q667 614 667 626Q667 641 695 662T755 683Q765 683 775 680T796 662T807 623Q807 596 792 572T713 499T530 376L505 361V356Q508 346 511 278T524 148T557 75Q569 69 580 69Q585 69 593 77Q624 108 660 110Q667 110 670 110T676 106T678 94Q668 59 624 30T510 0Q487 0 471 9T445 32T430 71T422 117T417 173Q416 183 416 188Q413 214 411 244T407 286T405 299Q403 299 344 263T223 182T154 122Q152 118 152 105Q152 69 180 69Q183 69 187 66T191 60L192 58V56Q192 41 163 21T105 0Q94 0 84 3T63 21T52 60Q52 77 56 90T85 131T155 191Q197 223 259 263T362 327T402 352L391 489Q391 492 390 505T387 526T384 547T379 568T372 586T361 602T348 611Q346 612 341 613T333 614H324",
  89: "65 599Q65 618 107 650T204 683Q267 683 312 643T380 533T414 385T424 217Q424 186 423 160T422 123Q426 123 468 170T567 304T650 469Q661 503 661 519Q661 546 639 570Q615 591 583 591Q569 591 569 616Q569 640 582 661T613 683Q624 683 638 679T671 664T702 625T714 558Q714 472 639 329T426 45Q361 -21 282 -82T154 -143Q97 -143 64 -104T31 -20Q31 4 44 25T70 46Q78 46 81 39T87 16T97 -9Q127 -51 182 -51Q184 -51 187 -50H190Q233 -41 314 25Q330 36 330 40Q336 79 336 178Q336 508 223 594Q199 614 158 619L148 620L139 611Q111 586 83 586Q65 586 65 599",
  90: "694 220Q708 220 708 210Q708 195 695 167T658 105T593 42T502 3Q492 1 458 1Q400 1 293 11T150 22Q116 22 92 11T51 0Q37 0 37 10Q37 21 63 44T179 146T367 319L391 343H343L296 344Q285 350 285 358Q285 365 289 372T300 383T313 392T324 398L329 400H450L561 518Q597 558 607 571L621 587H596Q553 589 484 599T383 609Q342 609 326 596T301 555Q294 533 263 514T208 492Q189 492 189 503Q189 510 197 528T215 559Q249 607 318 645T466 683Q504 683 573 673T669 662L690 661Q734 682 748 683Q767 683 767 673Q767 666 746 640Q655 531 555 428L529 400Q529 399 543 399Q604 397 604 366Q604 350 587 337T551 322Q541 322 539 323Q529 328 529 334Q529 339 487 342L470 343L446 320Q272 153 200 96L235 95Q297 95 392 86T533 74H554Q586 116 597 159Q604 179 635 199T694 220"
}, {});
var Qo = {}, To = {};
Object.defineProperty(To, "__esModule", { value: !0 });
To.texMathit = void 0;
To.texMathit = {
  65: [0.716, 0, 0.743],
  66: [0.683, 0, 0.704],
  67: [0.705, 0.021, 0.716],
  68: [0.683, 0, 0.755],
  69: [0.68, 0, 0.678],
  70: [0.68, 0, 0.653],
  71: [0.705, 0.022, 0.774],
  72: [0.683, 0, 0.743],
  73: [0.683, 0, 0.386],
  74: [0.683, 0.021, 0.525],
  75: [0.683, 0, 0.769],
  76: [0.683, 0, 0.627],
  77: [0.683, 0, 0.897],
  78: [0.683, 0, 0.743],
  79: [0.704, 0.022, 0.767],
  80: [0.683, 0, 0.678],
  81: [0.704, 0.194, 0.767],
  82: [0.683, 0.022, 0.729],
  83: [0.705, 0.022, 0.562],
  84: [0.677, 0, 0.716],
  85: [0.683, 0.022, 0.743],
  86: [0.683, 0.022, 0.743],
  87: [0.683, 0.022, 0.999],
  88: [0.683, 0, 0.743],
  89: [0.683, 0, 0.743],
  90: [0.683, 0, 0.613],
  97: [0.442, 0.011, 0.511],
  98: [0.694, 0.011, 0.46],
  99: [0.441, 0.01, 0.46],
  100: [0.694, 0.011, 0.511],
  101: [0.442, 0.01, 0.46],
  102: [0.705, 0.204, 0.307],
  103: [0.442, 0.205, 0.46],
  104: [0.694, 0.011, 0.511],
  105: [0.656, 0.01, 0.307],
  106: [0.656, 0.204, 0.307],
  107: [0.694, 0.011, 0.46],
  108: [0.694, 0.011, 0.256],
  109: [0.442, 0.011, 0.818],
  110: [0.442, 0.011, 0.562],
  111: [0.442, 0.011, 0.511],
  112: [0.442, 0.194, 0.511],
  113: [0.442, 0.194, 0.46],
  114: [0.442, 0.011, 0.422],
  115: [0.442, 0.011, 0.409],
  116: [0.626, 0.011, 0.332],
  117: [0.441, 0.011, 0.537],
  118: [0.443, 0.01, 0.46],
  119: [0.443, 0.011, 0.664],
  120: [0.442, 0.011, 0.464],
  121: [0.441, 0.205, 0.486],
  122: [0.442, 0.011, 0.409]
};
Object.defineProperty(Qo, "__esModule", { value: !0 });
Qo.texMathit = void 0;
var XH = s3, qH = To;
Qo.texMathit = (0, XH.AddPaths)(qH.texMathit, {
  65: "85 46Q112 48 132 56T161 73T176 92T185 104Q185 106 353 407T524 709Q527 716 551 716Q568 716 572 712Q573 711 574 710Q576 708 594 384Q613 54 617 52H618Q626 46 672 46H689Q696 41 696 36Q696 13 683 0H670Q639 2 557 2Q526 2 500 2T459 2T441 1Q425 1 425 10Q425 12 427 24Q428 27 429 31T430 36T432 40T434 43T437 45T443 46T450 46Q514 46 514 69Q514 74 511 136L506 209H292L260 152Q222 84 222 74Q222 48 264 46Q280 46 280 35Q280 33 278 21Q275 7 272 4T259 0Q256 0 232 1T159 2Q135 2 109 1T78 0Q58 0 58 10Q58 14 61 26T66 40Q68 46 85 46ZM504 260Q503 263 496 407T486 553L466 520Q446 486 402 406L318 256Q318 255 411 255H504V260",
  66: "57 11Q57 38 69 45L74 46Q78 46 85 46T99 46Q134 47 145 50T162 62Q164 66 233 344T303 626Q303 627 302 629V631Q296 637 241 637H223Q217 642 217 645T219 664Q223 677 229 683H411L593 682L605 680Q616 678 628 675T660 662T694 639T720 601T732 547Q732 519 726 503Q710 452 662 414T556 360L545 357L556 355Q604 346 641 312T678 221Q678 155 622 92T482 8Q459 2 439 2T256 0H154H105Q74 0 66 2T57 11ZM629 549Q628 550 629 557T627 576T619 600T601 622T570 636Q564 637 490 637Q472 637 454 637T424 636T411 636Q399 635 395 622T364 500Q333 377 332 376Q332 374 408 374L485 375L495 377Q547 390 588 437T629 549ZM504 336Q500 337 410 337Q323 337 322 336Q322 334 305 263T270 122T252 51Q252 47 337 46Q346 46 361 46T384 45Q425 45 455 55T515 95Q574 156 574 235Q574 276 555 304T504 336",
  67: "395 -21Q279 -21 215 56T150 244Q150 402 265 543Q339 630 421 667T562 704Q596 704 604 703Q627 698 647 689T679 669T699 649T711 633T716 627L753 665Q790 704 792 704Q793 705 798 705Q812 705 812 698Q812 694 780 561Q744 422 744 421Q742 416 739 415T721 413H705Q699 419 699 426Q701 432 701 444Q705 464 705 493Q705 524 700 551T681 604T643 644T583 659Q480 659 387 570Q321 502 287 397T252 213Q252 123 297 74Q347 24 421 24Q500 24 564 89T653 240Q656 253 659 255T677 257Q700 257 700 248Q700 242 694 222Q681 183 656 143T593 65T504 3T395 -21",
  68: "56 11Q56 38 68 45L72 46Q77 46 84 46T98 46Q133 47 144 50T161 62Q163 66 232 344T302 626Q302 627 302 629L301 631Q295 637 240 637H222Q216 642 216 645T218 664Q222 677 228 683H403Q582 683 589 682Q672 674 723 608T775 440Q775 312 709 209T562 54Q502 14 432 2Q423 1 243 0H148H102Q72 0 64 2T56 11ZM254 51Q254 46 348 46Q395 46 422 50T484 71Q585 121 633 255Q679 396 679 477Q679 522 665 554T629 603T587 626T548 636Q547 636 536 636T510 636T480 637Q420 637 411 636T398 627Q396 623 325 339T254 51",
  69: "248 634Q216 634 214 638Q213 641 213 646Q213 674 224 678Q226 680 481 680H736Q743 676 743 669Q743 665 729 557T713 447Q711 440 690 440H675Q667 445 667 454Q667 455 671 481T675 536Q675 583 658 604T592 632Q574 634 475 634Q439 634 424 633T405 631T399 625Q397 622 367 501T336 377Q336 376 367 376H388Q451 376 477 389Q493 399 503 419T520 462T528 489Q531 493 549 493Q557 493 561 492T566 491T569 488T572 483L539 351Q507 221 503 216Q503 216 500 213H484Q468 213 465 216Q461 219 461 225Q461 228 466 250T472 290Q472 317 452 323T368 330H324Q323 326 289 191T255 51T331 46H360Q413 46 444 49T511 67T570 113Q589 137 608 175T638 242T652 272Q656 274 670 274Q693 274 693 262L648 148Q590 4 588 2Q585 0 323 0H61Q54 4 54 11Q54 27 61 41Q65 46 95 46Q131 47 142 50T159 62L194 200Q229 337 264 477T299 623Q299 630 292 631T248 634",
  70: "299 623Q299 630 292 631T247 634H219Q213 640 213 642T215 661Q218 673 225 680H724Q731 676 731 669Q731 665 717 557T701 447Q699 440 678 440H663Q656 444 656 452Q656 457 659 485T663 538Q663 586 644 607T566 633Q564 633 535 633T486 634H458Q404 634 399 625Q396 620 364 492L332 363H380Q446 365 464 373Q496 389 514 458Q518 477 523 479Q527 480 541 480H556Q563 475 563 470Q563 467 532 339T498 207Q496 200 475 200H460Q453 207 453 212Q454 213 456 225T461 254T464 278Q464 304 445 310T369 317H321L289 190Q257 66 257 59Q257 54 261 52T283 48T337 46Q348 46 352 46T360 45T366 42T368 37Q368 32 365 23Q360 4 355 2Q352 1 342 1Q336 1 297 1T199 2Q138 2 106 2T71 1H68Q54 1 54 11Q54 38 66 45L70 46Q75 46 82 46T96 46Q131 47 142 50T159 62L194 200Q229 337 264 477T299 623",
  71: "632 -1Q629 -1 622 5T604 25T583 53Q508 -22 394 -22Q287 -22 219 52T150 244Q150 402 265 543Q339 630 421 667T562 704Q596 704 604 703Q627 698 647 689T679 669T699 649T711 633T716 627L753 665Q790 704 792 704Q793 705 798 705Q812 705 812 698Q812 694 780 561Q744 422 744 421Q742 416 739 415T721 413H705Q699 419 699 426Q701 432 701 444Q705 464 705 493Q705 524 700 551T681 604T643 644T583 659Q480 659 387 570Q319 501 286 394T252 208Q252 156 269 118T314 61T369 33T425 24Q470 24 509 46T566 104Q571 116 583 162T595 214Q595 222 583 223Q561 227 517 227H495Q488 230 488 238Q488 254 495 268Q500 273 511 273Q515 273 532 273T581 272T649 271Q731 271 752 273H761Q767 267 767 264T765 246Q761 233 755 227H742Q698 227 693 213L639 4Q636 -1 632 -1",
  72: "61 0Q54 7 54 11Q54 27 61 41Q65 46 95 46Q131 47 142 50T159 62Q161 66 230 344T300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H239Q307 681 372 681Q480 681 486 683H496Q502 677 502 674T500 656Q496 643 490 637H472Q418 637 406 630Q400 627 396 612T367 500Q360 474 352 442T340 395L336 380Q336 378 466 378H596Q657 622 657 626Q657 627 656 629V631Q650 637 595 637H577Q571 642 571 645T573 664Q577 677 583 683H596Q664 681 729 681Q837 681 843 683H853Q860 676 860 672Q858 647 848 637H819Q783 636 772 634T756 623Q753 618 684 340T614 57Q614 50 621 49T666 46Q697 46 699 40Q701 37 698 21Q693 3 689 1Q686 0 677 0Q673 0 657 0T611 1T546 2Q453 2 428 0H418Q411 7 411 11Q411 27 418 41Q422 46 452 46Q488 47 499 50T516 62Q517 64 550 196T584 331Q584 332 454 332H324L291 197Q257 64 257 56Q257 50 265 49T309 46Q340 46 342 40Q344 37 341 21Q336 3 332 1Q329 0 320 0Q316 0 300 0T254 1T189 2Q96 2 71 0H61",
  73: "235 637Q217 637 213 638T209 649Q209 673 220 682Q222 683 237 683Q278 681 369 681Q404 681 441 682T483 683Q499 683 503 681T508 672Q508 670 505 658T500 643Q498 637 464 637Q425 635 415 633T398 621Q396 618 327 340T257 58T260 52T278 48T322 46Q349 46 349 36Q349 31 346 22Q342 4 337 1Q336 1 334 1T329 0Q325 0 307 0T258 1T190 2Q95 2 67 0H56Q49 7 49 11Q51 38 62 46H91Q129 47 141 50T159 62Q161 66 230 344T300 625Q300 637 235 637",
  74: "361 637Q333 637 331 641Q330 644 330 649Q330 673 341 682Q343 683 360 683Q405 681 500 681Q551 681 577 681T607 682Q622 682 622 673Q622 665 616 647Q614 640 610 639T587 637Q547 636 541 624Q538 618 477 374T413 124Q391 64 333 22T207 -21T109 12T78 86Q78 130 101 150T149 170Q193 170 196 129Q196 100 178 80T137 58L132 57Q134 52 138 46T160 28T205 16Q242 16 273 48T319 122Q322 129 383 371T444 627Q444 637 361 637",
  75: "668 621Q668 635 645 637Q629 637 629 648Q629 650 632 662T637 677Q640 682 653 682Q657 682 688 681T764 680Q786 680 810 681T839 682Q859 682 859 672Q859 655 852 643Q849 637 839 637Q804 637 768 621T717 595T697 578Q696 578 600 497L505 417L508 408Q543 311 574 227T618 106T632 69Q645 47 688 46H707Q713 38 713 37T710 19Q706 6 700 0H688Q659 2 587 2Q557 2 532 2T492 2T474 1Q458 1 458 10Q458 13 460 23Q464 39 466 42T480 46Q526 46 526 72Q526 75 476 213L427 350Q426 350 396 325T334 272T302 242Q302 241 299 230T290 194T279 150Q257 61 257 55Q257 50 265 49T309 46H337Q343 40 343 38T341 19Q337 6 331 0H316Q280 2 190 2Q158 2 131 2T89 2T70 1Q54 1 54 11Q54 38 66 45L70 46Q75 46 82 46T96 46Q131 47 142 50T159 62Q161 66 230 344T300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H239Q307 681 372 681Q386 681 414 681T464 682L487 683H496Q502 677 502 674T500 656Q495 641 491 637H462Q426 636 415 634T399 623Q396 618 358 467L320 314Q321 314 484 452Q510 474 552 509Q625 570 646 590T668 621",
  76: "61 0Q54 4 54 11Q54 27 61 41Q65 46 95 46Q131 47 142 50T159 62Q161 66 230 344T300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H240Q275 681 371 681Q407 681 438 681T487 682T509 682Q527 682 527 674Q527 670 524 659Q523 657 523 654T522 649T520 645T519 642T517 640T515 639T512 638T507 637T502 637T494 637H478Q433 636 417 633T396 617Q395 614 325 334T255 51Q255 47 319 47Q387 47 410 52Q459 65 494 98T543 163T570 229T589 273H622Q628 264 628 262Q628 259 584 133T539 5Q537 1 511 1Q482 0 296 0H61",
  77: "72 1Q58 1 58 11Q58 33 66 41Q68 46 87 46Q150 50 168 84Q172 91 238 356T304 626Q304 627 304 629L303 631Q297 637 242 637H224Q218 642 218 645T220 664Q224 677 230 683H326H394Q417 683 422 682T429 676L480 127L502 163Q523 199 560 262T642 400Q801 668 805 676L817 683H1003Q1010 678 1010 672Q1010 650 997 637H979Q915 637 906 623Q903 618 834 340T764 57Q764 50 771 49T817 46H845Q851 38 851 37T848 19Q845 7 838 0H824Q789 2 701 2Q670 2 644 2T603 2T584 1Q569 1 569 11Q569 13 571 25Q576 42 581 45L586 46Q590 46 597 46T611 46Q646 47 657 50T674 62L813 616L634 313Q453 7 452 7Q446 0 428 0Q409 0 407 6Q405 10 379 304T351 604L285 348Q220 83 220 82Q220 65 233 57T279 46H295Q301 38 301 37T298 19Q295 7 288 0H275Q244 2 171 2Q145 2 123 2T88 2T72 1",
  78: "633 637Q624 637 621 639T617 650Q617 670 630 683H641Q682 680 736 680Q836 680 845 683H853Q860 676 860 672Q858 647 848 637H832Q764 633 750 598Q746 590 673 300Q656 230 638 156T610 44L600 7Q598 0 576 0H559Q553 6 448 297L342 588Q341 588 279 336T216 81Q216 49 274 46Q293 46 295 40Q297 37 294 21Q293 19 292 16T291 11T290 7T289 4T287 2T284 1T280 1T275 0T263 0T229 1T167 2Q91 2 70 0H61Q54 7 54 11T57 27Q61 41 64 43T83 46Q146 50 164 84Q167 90 235 362L303 634Q300 635 253 637H220Q214 643 214 645T216 664Q220 677 226 683H314Q386 683 397 683T410 677Q412 675 501 428L591 179Q591 178 592 180T595 189T600 209T610 246T624 303T645 385Q698 595 698 606Q698 618 683 627T633 637",
  79: "149 237Q149 326 186 413T282 563T412 665T552 704Q619 704 667 678T741 611T777 528T788 444Q788 328 728 219T572 44T377 -22Q275 -22 212 50T149 237ZM688 487Q688 570 650 617T548 665Q467 665 398 592T291 413T253 203Q253 119 290 70T387 20Q440 20 489 52T573 135T635 249T675 373T688 487",
  80: "62 0Q55 7 55 11Q55 27 62 41Q66 46 96 46Q132 47 143 50T160 62Q162 66 231 344T301 626Q301 627 300 629V631Q294 637 239 637H221Q215 642 215 645T217 664Q221 677 227 683H404H431H502Q578 683 615 675T684 636Q729 595 729 531Q729 462 671 396T524 308Q499 302 404 301H318L288 182Q258 63 258 55T310 46Q341 46 343 40Q345 37 342 21Q337 3 333 1Q330 0 321 0Q317 0 301 0T255 1T190 2Q97 2 72 0H62ZM626 555V562Q626 620 552 635Q546 636 481 637Q466 637 450 637T423 636T412 636Q401 635 398 627Q396 622 361 484Q353 452 344 416T330 362L325 344Q325 342 390 342H427Q523 342 567 386Q596 415 611 473T626 555",
  81: "460 -107Q460 -72 464 -42T468 -7L457 -10Q446 -14 424 -18T379 -22Q276 -22 213 50T149 237Q149 326 186 413T282 563T412 665T552 704Q664 704 726 631T788 442Q788 305 703 180Q627 64 517 13L506 8Q506 7 508 -12T513 -38T522 -59T538 -79T565 -85Q604 -85 634 -59T672 0Q676 11 684 11Q693 11 695 2Q695 -1 690 -20T673 -69T644 -126T599 -174T538 -194Q464 -194 460 -110Q460 -108 460 -107ZM689 481Q689 578 646 621T551 665Q468 665 391 586Q321 512 285 399T249 202Q249 106 295 58Q310 41 314 41Q315 41 315 46Q315 83 344 118T420 154Q450 154 473 135Q493 114 500 69L502 58L512 65Q571 110 613 192T672 348T689 481ZM472 49Q472 118 415 118Q393 118 373 98T353 51Q353 18 386 18H387Q424 18 472 40V49",
  82: "62 0Q55 7 55 11Q55 27 62 41Q66 46 96 46Q132 47 143 50T160 62Q162 66 231 344T301 626Q301 627 300 629V631Q294 637 239 637H221Q215 642 215 645T217 664Q221 677 227 683H386Q554 682 569 679Q571 678 580 676Q643 662 680 623T717 533Q717 473 667 420T528 337L538 330Q563 314 578 286T594 228Q594 212 588 147T581 65Q581 36 589 26T616 16H618Q637 16 652 37Q668 57 677 94Q679 105 701 105T723 95Q723 89 717 72T698 33T662 -5T610 -22Q555 -22 513 3T471 88Q471 107 486 168T502 244Q502 303 452 320Q445 322 382 323H320L288 192Q255 63 255 55T307 46Q338 46 340 40Q342 37 339 21Q335 3 330 1Q326 0 320 0Q317 0 306 0T265 1T190 2Q99 2 73 0H62ZM612 558Q612 566 612 568T610 581T603 597T590 611T567 625T532 635Q526 636 470 637Q458 637 445 637T422 636T412 636Q402 635 397 627L390 598Q383 570 373 532T354 455T337 389T330 361Q356 360 384 360H415Q483 360 527 382Q557 399 574 424T604 498Q612 533 612 558",
  83: "198 460Q198 551 269 628T432 705Q516 705 557 644L583 673Q589 679 593 684T600 693T605 698T609 702T611 704T614 705T618 705H620Q633 705 633 698T605 577T573 459L570 456H554Q546 456 543 456T536 457T532 460T531 466Q531 469 533 489T536 532Q536 573 525 600T496 640T462 657T427 662Q369 662 325 612T281 503Q281 475 290 458T318 430T356 415T407 401T463 383Q506 360 522 323T538 258V244Q538 141 465 60T300 -22Q198 -22 152 41L143 31Q137 25 126 12T106 -10T95 -21L92 -22Q88 -22 86 -22Q81 -22 78 -20T74 -16V-14Q74 -11 132 221Q134 227 155 227H171Q177 221 177 215Q177 212 175 205T171 182T169 147Q171 99 195 70T246 33T306 25Q358 25 400 70T453 169Q455 180 455 203V210Q455 263 414 285Q409 288 347 305Q271 328 254 339Q239 350 224 371Q198 409 198 460",
  84: "178 437Q173 442 171 446Q171 451 238 654Q243 670 250 677H681H762Q792 677 799 676T806 667Q806 661 788 553T768 444Q768 437 746 437Q727 437 723 445Q723 450 729 492T736 562Q736 589 728 602T693 624Q675 630 622 630H595Q575 630 571 629T564 623Q562 621 492 342T422 59Q422 48 502 46H542Q548 38 548 37T545 19Q541 6 535 0H517Q475 2 357 2Q315 2 279 2T223 2T198 1Q179 1 179 9Q179 14 182 24Q187 42 190 44Q194 46 206 46H232Q289 47 301 49T326 65L395 344Q465 619 465 626Q465 629 462 629Q456 631 411 631Q364 631 336 625T288 597T255 549T224 467Q215 442 210 437H178",
  85: "636 637Q627 637 624 639T620 650Q620 670 633 683H644Q702 681 753 681Q760 681 772 681T796 681T820 682T838 683H845H853Q860 676 860 672Q858 647 848 637H832Q764 633 750 598Q745 588 698 400T648 204Q627 140 584 86Q484 -22 378 -22Q300 -22 247 31T194 167Q194 176 194 182T196 198T200 218T207 248T217 288T231 346T250 422Q300 618 300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H239Q307 681 372 681Q480 681 486 683H496Q502 677 502 674T500 656Q496 643 490 637H472Q418 637 406 630Q400 627 394 603T344 410Q299 232 292 198T284 135Q284 102 294 78T322 44T355 29T387 24Q455 24 515 74T604 211Q605 215 653 404T701 607Q701 618 686 627T636 637",
  86: "667 637Q657 637 654 639T650 650Q650 670 663 683H675Q704 681 772 681Q793 681 818 682T847 683Q868 683 868 672Q868 670 865 658T860 643Q857 637 848 637Q785 637 749 587L394 -15Q387 -22 366 -22Q346 -22 342 -16Q341 -13 313 303Q285 622 285 623Q283 631 273 634T229 637Q205 637 205 648Q205 654 208 666T217 682Q219 683 230 683Q276 680 329 680Q444 680 456 683H466Q472 677 472 674T470 656Q466 643 460 637H448Q384 637 384 615Q385 612 406 371T427 126Q427 125 495 240T632 473T704 596Q707 604 707 609Q707 633 667 637",
  87: "234 637H226Q205 637 205 648Q205 673 216 682Q218 683 231 683Q265 681 340 681Q371 681 404 682T443 683Q458 683 462 681T467 672Q467 670 464 658T459 643Q457 637 434 637Q407 636 394 632T378 623T376 613Q376 589 385 377T394 149L511 361Q542 419 596 519L613 551L612 585Q610 621 610 624Q608 637 559 637H555Q537 637 537 647Q537 654 540 664Q544 677 550 683H561Q600 680 656 680Q771 680 783 683H792Q798 677 798 675T796 658Q792 643 790 640T778 637H774Q721 637 708 620L717 385Q726 150 727 149Q727 148 752 193T812 303T882 433T942 546T969 596Q970 600 970 606Q970 610 969 613T966 620T961 625T955 628T949 631T941 633T934 634T927 636T920 637Q903 637 903 648Q903 650 905 664Q909 677 915 683H928Q960 681 1031 681Q1050 681 1073 681T1101 682Q1124 682 1124 672Q1124 655 1117 643Q1114 637 1104 637Q1085 637 1069 632T1043 618T1026 603T1014 588L1009 580L687 -16Q681 -22 660 -22Q643 -22 637 -16Q635 -14 627 223Q617 441 617 464L602 441Q578 397 487 228Q456 171 423 110T372 17T355 -15Q348 -22 328 -22Q312 -22 308 -20T303 -9Q303 -5 291 310T277 627Q273 636 234 637",
  88: "684 0Q670 0 634 1T569 2Q512 2 482 2T449 1Q433 1 433 10Q433 11 435 25Q437 34 438 37T442 43T448 45T459 46T476 49Q506 58 506 64Q506 65 467 179T426 295L382 244Q339 194 295 142T249 86Q245 79 245 72Q245 48 279 46Q293 46 293 32Q293 13 280 0H268Q206 2 151 2Q70 2 64 0Q50 0 50 11Q50 15 53 27Q57 41 60 43T78 46Q154 49 205 100Q207 103 312 225L411 341L407 353Q404 360 381 428T336 560T310 627Q301 636 255 637H229Q223 643 223 645T225 664Q229 677 235 683H246Q288 680 346 680Q462 680 477 683H487Q493 677 493 674T491 656Q488 644 485 641T471 637Q461 635 454 635Q419 626 421 619Q421 617 453 524T486 430T554 509T624 593Q631 604 631 611Q631 622 621 629T598 637Q583 637 583 648Q583 650 585 660Q589 676 591 679T602 683Q606 683 637 682T715 680Q742 680 771 681T804 682Q825 682 825 672Q825 650 817 642Q814 637 797 637Q739 634 700 608Q684 597 659 569T505 389L501 384L557 222Q612 61 616 57Q625 47 671 46Q691 46 697 45T704 36Q704 35 702 23Q701 19 700 14T699 7T696 3T692 1T684 0",
  89: "232 637Q198 637 198 647Q198 651 201 664T210 682Q212 683 223 683Q269 680 325 680Q443 680 455 683H465Q472 676 472 672Q472 656 465 642Q460 637 441 637Q395 634 395 623Q395 621 438 478T482 334T583 460T688 591Q688 593 694 601T700 617Q700 637 668 637H666Q655 637 655 648Q655 654 658 664Q660 672 660 673T663 678T668 682T677 683Q680 683 704 682T776 680Q801 680 828 681T858 682Q875 682 875 673Q875 669 872 657T867 643Q865 637 848 637Q788 634 749 597Q733 581 608 424L487 273L461 170Q454 145 448 118T438 76T434 60Q434 54 436 52T452 48T496 46H514Q520 41 520 38T518 19Q514 6 508 0H495Q427 2 364 2Q350 2 323 2T272 0H250H241Q234 7 234 11Q234 27 241 41Q245 46 275 46Q312 47 323 50T340 64Q340 65 344 79T355 120T368 171L393 274L341 448Q288 622 286 626Q278 636 232 637",
  90: "203 452Q203 455 236 565T270 677Q270 681 274 681Q276 683 488 683H699Q704 678 704 675Q704 663 697 649Q697 647 449 348L201 50L266 49H301Q442 49 495 116Q525 155 556 251Q563 274 565 278T579 282H585Q609 285 609 271Q609 270 570 142T528 8T518 1T466 0H303Q253 0 197 0T131 -1Q112 -1 102 -1T87 1T81 3T80 8Q80 30 89 39Q90 41 204 178T446 470T575 626L584 637H512H504H475Q446 637 426 635T378 624T330 597T289 546T254 467Q247 446 243 444Q239 442 226 442Q203 442 203 452",
  97: "418 53Q418 26 438 26Q466 26 494 131Q500 151 504 152Q507 153 516 153H521Q531 153 534 153T540 150T543 144Q543 141 540 126T529 88T509 43T477 5T434 -11Q404 -11 383 3T354 30T347 48H346Q345 47 342 45T337 40Q282 -11 228 -11Q172 -11 137 34T101 146Q101 260 177 351T333 442Q343 442 352 441T369 437T382 431T393 425T402 417T409 410T414 402T419 396Q423 406 436 414T461 422Q475 422 484 413T494 395Q494 384 459 244T420 88Q418 80 418 58V53ZM397 323Q397 344 382 374T333 405Q302 405 271 372Q249 349 235 316T203 215Q184 135 184 108V100V94Q184 54 207 35Q218 26 235 26Q279 26 330 91Q343 109 346 118T372 217Q397 317 397 323",
  98: "158 683Q163 683 223 688T300 694Q312 694 312 685T279 544Q243 405 243 403L256 412Q268 422 292 432T338 442Q395 442 431 398T467 284Q467 175 393 82T229 -11Q175 -11 142 32T108 142Q108 176 115 207T166 412Q177 458 190 510T209 588T216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683ZM178 109Q178 27 234 27Q247 27 254 29Q295 44 323 94Q343 129 363 208T384 332Q384 354 382 361Q369 405 332 405Q282 405 228 326L222 317L205 250Q178 142 178 109",
  99: "257 -10Q183 -10 143 37T103 155Q103 257 173 341T337 440Q341 441 348 441H358Q421 441 445 415T469 356Q469 320 450 305T410 289Q392 289 381 299T370 325Q370 362 404 378L414 383Q392 402 365 405Q322 405 285 375T227 294Q217 271 202 213T187 119Q187 27 263 27Q299 27 330 40Q361 51 386 71T424 106T440 121Q444 121 455 110T466 96Q466 92 458 81T432 54T390 24T331 0T257 -10",
  100: "418 54Q418 26 438 26Q466 26 494 131Q500 151 504 152Q507 153 516 153H521H526Q543 153 543 144Q543 143 541 129Q531 91 521 65T487 14T434 -11T383 3T354 30T347 48H346Q345 47 342 45T337 40Q282 -11 228 -11Q172 -11 137 34T101 146Q101 255 174 348T337 441Q354 441 368 437T390 427T404 414T413 404T417 400L471 616Q471 629 464 632T425 637H404Q398 643 398 645T400 664Q405 683 413 683Q418 683 478 688T555 694Q567 694 567 686Q567 676 495 389L419 86Q418 80 418 61V54ZM397 323Q397 329 394 340T385 367T365 394T333 405Q302 405 271 372Q249 349 235 316T203 215Q184 135 184 108V100Q184 71 191 56Q204 26 235 26Q267 26 300 57T344 112Q347 117 372 217T397 323",
  101: "107 166Q107 230 131 283T193 369T270 420T345 441Q346 441 352 441T361 442H364Q409 442 439 418T470 355Q470 270 366 239Q308 223 218 223H205Q189 164 189 125Q189 83 206 55T261 27Q309 27 353 50T426 109Q436 121 440 121T453 111T466 97Q469 92 455 77Q424 41 372 16T258 -10Q184 -10 146 41T107 166ZM416 333T416 354T401 390T360 405Q322 405 292 384T246 336T223 288T215 261Q215 260 240 260Q262 261 276 262T314 266T353 275T384 291T408 317",
  102: "351 608Q351 642 389 661Q368 668 365 668Q358 668 352 664Q349 663 347 661T342 654T337 647T333 637T330 627T327 614T324 601T321 587T318 571L291 432Q291 431 343 431H394Q400 426 400 423T398 404Q394 390 389 386L335 385H282L255 246Q212 20 189 -51Q136 -199 58 -204Q22 -204 0 -185T-23 -134Q-23 -100 -3 -85T37 -69Q54 -69 65 -80T76 -108Q76 -115 75 -119Q70 -134 61 -144T46 -158L39 -161Q39 -162 42 -163T50 -166T61 -168Q77 -168 91 -145Q98 -128 105 -95L125 -1Q145 90 146 98Q149 109 163 180T189 317T202 384T158 385H114Q108 390 108 393T110 412Q113 424 120 431H165Q211 431 211 433Q213 435 219 473T237 561T266 639Q282 667 310 686T367 705Q402 705 426 686T450 635Q450 600 430 585T390 569Q373 569 362 580T351 608",
  103: "103 163Q106 263 173 347T320 441Q322 441 329 441T341 442Q387 439 419 398Q420 399 420 400Q421 402 425 406T440 416T464 422Q476 421 485 413T494 396Q494 386 465 268T407 38T377 -77Q365 -123 310 -164T179 -205Q46 -205 46 -139Q46 -114 64 -97T106 -79Q127 -79 136 -91T146 -115Q146 -127 141 -138T130 -155T124 -162T125 -163Q133 -166 170 -168Q200 -168 217 -162Q242 -153 264 -130T297 -78Q298 -74 305 -46T320 10T327 38Q326 38 317 31T291 15T256 2Q249 1 231 1Q182 1 143 38T103 163ZM398 324Q398 330 395 346T375 383T332 405Q330 405 326 405T320 404Q291 396 263 365Q230 324 208 239T185 115Q185 38 238 38Q258 38 279 50T312 77T336 106L348 122Q349 125 373 223T398 324",
  104: "398 44Q398 26 414 26Q431 26 451 43Q477 71 496 136Q499 148 501 150T515 153H521Q531 153 534 153T541 150T544 143Q544 133 534 105T496 41T432 -8Q424 -10 408 -10Q370 -10 348 12T326 72Q326 93 342 135Q397 288 397 349Q397 367 396 372Q386 405 357 405Q283 405 228 310Q217 290 212 274T180 152Q153 42 148 26T135 3Q121 -11 102 -11Q89 -11 80 -3T69 19L216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683Q163 683 223 688T300 694Q312 694 312 685Q312 674 277 539Q241 395 241 393Q242 394 249 399T259 407T271 415T285 424T300 431T318 437T338 440T362 442Q423 442 449 410T475 338Q475 290 437 178T398 44",
  105: "234 599Q234 620 251 638T292 656Q306 656 319 647T332 617Q332 594 313 577T273 560Q260 560 247 569T234 599ZM75 287Q75 292 82 313T103 362T142 413T196 441H214Q248 441 270 419T293 357Q292 338 289 330T245 208Q193 72 193 46Q193 26 209 26Q228 26 247 43Q273 71 292 136Q295 148 297 150T311 153H317Q327 153 330 153T337 150T340 143Q340 133 330 105T292 41T228 -8Q220 -10 204 -10Q160 -10 141 15T122 71Q122 98 171 227T221 384Q221 396 218 400T203 405Q175 403 156 374T128 312T116 279Q115 278 97 278H81Q75 284 75 287",
  106: "266 600Q266 622 283 639T322 656Q340 656 352 645T364 616Q364 596 347 578T305 560Q291 560 279 569T266 600ZM75 287Q75 293 86 316T117 369T168 420T236 442Q282 442 304 415T327 358V332L278 134Q269 98 260 60T246 3T236 -36T227 -66T220 -85T213 -101T204 -114Q181 -150 139 -177T46 -204Q8 -204 -12 -186T-32 -140Q-32 -112 -14 -96T27 -79Q48 -79 57 -91T67 -114Q67 -146 38 -166Q42 -168 49 -168Q75 -168 98 -147T130 -108T146 -71Q150 -59 199 138T250 346Q253 359 253 373Q253 405 230 405Q206 405 184 386T149 345T126 301L117 280Q115 278 98 278H81Q75 284 75 287",
  107: "158 683Q163 683 223 688T300 694Q312 694 312 686Q312 679 262 478L211 273Q212 272 219 276T248 299T296 349Q317 371 328 382T360 410T399 434T439 442Q462 442 480 427T498 373Q498 329 479 313T437 296Q420 296 409 305T398 331Q398 357 413 372T445 391Q454 392 448 399Q445 405 431 405Q408 405 377 385Q351 368 314 327T250 261Q243 257 243 254Q249 254 279 243T328 220Q366 192 366 146Q366 131 361 109T355 62V54Q355 26 376 26Q379 26 387 28Q420 36 443 130Q449 151 454 152Q457 153 465 153H470Q484 153 488 152T492 144Q492 141 489 126T476 88T454 42T420 5T372 -11Q331 -11 306 17T280 88Q280 100 283 119T287 146Q287 172 265 190T221 215T198 220Q197 220 173 121Q152 37 148 24T135 3Q121 -11 102 -11Q89 -11 80 -3T69 19L216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683",
  108: "162 61Q162 26 183 26Q211 26 239 131Q245 151 249 152Q252 153 261 153H266H271Q288 153 288 144Q288 143 286 129Q276 91 266 65T232 14T179 -11Q144 -11 116 12T87 81Q87 96 88 102L216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683Q163 683 223 688T300 694Q312 694 312 686Q312 676 240 389L164 86Q162 74 162 61",
  109: "81 278Q75 284 75 289Q77 299 89 338Q101 373 114 396T142 428T166 439T186 442H189Q225 440 251 417Q266 401 271 384L275 374L286 386Q342 442 414 442Q428 442 440 440T461 435T479 427T493 418T503 407T511 397T516 387T520 378T523 370L524 366Q546 395 583 418T667 442Q729 442 755 411T782 338Q782 290 743 178T704 45Q704 26 720 26Q773 26 802 136Q805 148 807 150T822 153H828Q838 153 841 153T848 150T851 143Q851 137 843 115T821 63T778 12T715 -10Q671 -10 652 16T632 71Q632 88 668 191T704 349Q704 367 703 372Q693 405 664 405Q637 405 613 393T571 360T547 329T534 309Q523 290 518 274T487 151Q455 24 452 16Q438 -11 408 -11T376 18Q376 26 411 167T447 314Q449 325 449 346Q449 372 444 384Q431 405 408 405Q334 405 276 305Q266 289 262 273T231 151Q199 24 196 16Q182 -11 152 -11T120 18Q120 26 159 182T200 347Q202 361 202 372Q202 405 181 405Q168 405 159 391Q145 374 132 328T117 280T98 278H81",
  110: "449 44Q449 26 465 26Q482 26 502 43Q528 71 547 136Q550 148 552 150T566 153H572Q582 153 585 153T592 150T595 143Q595 133 585 105T547 41T483 -8Q475 -10 459 -10Q421 -10 399 12T377 72Q377 93 393 135Q448 288 448 349Q448 367 447 372Q437 405 408 405Q381 405 357 393T315 360T291 329T278 309Q267 290 262 274T231 151Q199 24 196 16Q182 -11 152 -11T120 18Q120 23 159 181Q199 343 199 346Q202 360 202 372Q202 406 183 406Q163 406 148 374Q142 360 135 338T124 299T117 280T98 278H81Q75 284 75 287Q76 293 78 303T90 341T110 388T141 425T184 442Q195 442 204 441T221 436T235 429T247 421T256 412T262 403T267 394T271 387T273 381L274 378V374L287 387Q342 442 414 442Q474 442 500 410T526 338Q526 290 488 178T449 44",
  111: "103 155Q103 266 185 354T366 442Q435 442 476 394T517 275Q517 169 436 79T255 -11Q194 -11 149 32T103 155ZM187 119Q187 67 209 47T260 26Q290 26 321 47Q354 68 380 113T426 260Q432 291 432 315Q432 361 408 385Q388 405 358 405Q319 405 283 374T227 294Q217 271 202 213T187 119",
  112: "81 278Q75 284 75 287Q93 379 131 417Q154 442 189 442Q222 440 243 423T272 382L280 390Q335 442 389 442Q446 442 482 398T518 284Q518 212 480 137T375 19Q321 -10 291 -10H282H278Q237 -10 204 28L202 32L181 -51Q160 -135 160 -139Q160 -147 205 -148H230Q236 -155 236 -157T233 -175Q230 -187 227 -190T214 -194Q211 -194 202 -194T169 -193T108 -192Q40 -192 21 -194H13Q6 -187 6 -183T9 -167Q13 -153 16 -151T39 -148Q73 -147 78 -136Q82 -128 139 104Q199 337 199 347Q202 362 202 372Q202 406 182 406Q169 406 159 391Q145 374 132 328T117 280T98 278H81ZM221 111Q234 26 286 26Q307 26 336 47T385 116Q398 147 416 217T435 332Q435 354 433 361Q420 405 383 405Q333 405 279 326L273 317L221 111",
  113: "228 -11Q172 -11 137 33T101 147Q101 205 125 266T201 377T318 441Q322 442 333 442Q388 442 420 394L429 403Q439 413 455 423T481 437T494 442Q498 442 501 439T504 434Q504 425 435 149Q364 -135 364 -139Q364 -147 409 -148H434Q440 -155 440 -157T437 -175Q433 -191 429 -193Q425 -194 418 -194Q416 -194 406 -194T372 -193T309 -192Q259 -192 233 -192T204 -193Q190 -193 190 -184Q190 -181 192 -169Q196 -153 199 -151T219 -148Q266 -148 277 -141Q283 -137 305 -51L325 29L316 22Q270 -11 228 -11ZM397 323Q397 329 394 340T385 367T365 394T333 405Q302 405 271 372Q249 349 235 316T203 215Q184 135 184 108V100Q184 71 191 56Q204 26 235 26Q267 26 300 57T344 112Q347 117 372 217T397 323",
  114: "81 278Q75 284 75 289Q77 301 89 339Q122 442 183 442Q219 442 241 425T271 384L283 396Q327 442 384 442Q424 442 454 421T484 362Q484 327 464 312T424 296Q407 296 396 305T385 331Q385 352 394 365T414 384T424 390Q409 405 378 405Q322 405 276 315L268 300L234 161Q200 25 196 16Q182 -11 152 -11T120 18Q120 23 159 181Q199 343 199 346Q202 360 202 372Q202 405 182 405Q164 405 150 377T128 316T117 280Q115 278 98 278H81",
  115: "153 285Q153 349 197 395T311 442Q355 442 386 420T418 356Q418 321 401 308T365 294Q336 294 331 326Q331 336 334 345T343 359T353 368T362 374L366 376Q365 379 362 383T344 396T308 404Q265 404 246 377T226 325T244 289T287 275T339 258T383 212Q395 188 395 163Q395 132 379 95T333 32Q279 -11 207 -11Q154 -11 115 13T76 86Q76 108 83 123T102 145T121 153T135 156Q154 156 164 145T175 117Q175 82 142 66L132 62Q131 62 131 61Q131 57 139 49T166 34T210 26Q250 26 277 44T312 83T321 123Q321 153 301 166T248 185T204 198Q176 211 162 241Q153 258 153 285",
  116: "94 385Q87 392 87 395Q87 399 90 411T95 425Q97 430 103 430T149 431H196L215 511Q218 521 222 539T228 565T234 585T242 603T251 615T264 623T281 626Q311 626 315 597Q315 591 296 513T275 433Q275 431 320 431H366Q373 424 373 420Q373 398 360 385H263L189 86Q188 80 188 61V54Q188 29 201 27Q213 23 229 30Q253 37 276 66T316 138Q321 149 324 151T342 153H347Q364 153 364 146T360 130Q331 63 290 26T202 -11Q158 -11 135 18T111 81Q111 93 129 168T166 314L184 383Q184 385 139 385H94",
  117: "75 287Q75 299 89 333T135 404T205 441Q246 441 269 420T293 357Q292 338 259 245T225 95Q225 26 274 26Q301 26 324 43T358 77T369 99Q369 102 406 249T446 404Q460 431 490 431T522 402Q522 394 485 245T446 89Q443 74 443 56Q443 28 461 26Q487 26 507 86Q524 130 524 146Q524 147 530 153H547Q570 153 570 144Q570 138 561 109T544 62Q530 29 512 12Q492 -11 454 -11Q429 -9 410 2T385 23T376 41L363 28Q350 16 325 3T269 -10Q204 -10 176 25T148 108Q148 161 184 262T221 383Q221 405 206 405Q178 405 158 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287",
  118: "387 386Q387 407 406 425T445 443Q466 443 479 423T492 371Q492 330 473 253Q411 18 307 -8Q298 -10 279 -10Q208 -10 179 26T149 114Q149 162 185 261T221 384Q221 405 206 405Q177 405 157 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287T79 304T93 342T119 388T158 425T210 441H218Q243 441 268 421T293 357Q292 337 259 245T226 102Q226 26 285 26Q328 26 360 72T422 237Q429 265 429 290Q428 324 408 349T387 386",
  119: "591 386Q591 407 610 425T649 443Q670 443 683 423T696 371Q696 327 672 232T621 85Q575 -11 493 -11Q469 -11 449 -6T418 8T398 24T386 38L382 43Q347 -10 293 -10H286Q221 -10 186 21T150 115Q150 164 185 262T221 384Q221 405 206 405Q177 405 157 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287T79 304T93 342T119 388T158 425T210 441H218Q243 441 268 421T293 357Q292 336 260 246T227 108Q227 26 292 26H295Q332 26 361 93L366 103V119Q366 122 367 133T369 150Q372 167 401 282T433 404Q446 431 477 431Q507 431 509 402Q509 396 500 358T474 254T446 140Q444 126 444 104V92Q444 66 459 46T502 26H505Q527 28 545 43T577 88T602 149T623 226Q633 265 633 290Q632 324 612 349T591 386",
  120: "275 356Q275 383 262 394T233 405Q196 405 166 371T121 289Q119 280 116 279T98 278H81Q77 282 76 283T75 288T78 300Q88 332 109 363T153 411Q195 442 235 442Q306 442 333 386Q373 442 427 442Q461 442 487 421T513 364T494 312T453 296Q436 296 425 305T414 331Q414 352 424 366T446 386L456 390Q448 404 421 404H418Q382 404 358 341Q355 332 328 227T298 105Q295 90 295 75Q295 26 339 26Q365 26 388 43T424 82T444 123T451 146L457 153H474Q490 153 493 152T496 144Q496 133 486 110T456 58T404 10T333 -11Q276 -11 237 45Q197 -11 146 -11Q108 -11 83 10T58 67Q58 99 76 117T119 135Q136 135 147 124T158 96Q158 89 157 85Q149 57 125 45L115 41Q125 26 151 26Q171 26 187 45T214 93Q217 102 244 210T273 330Q275 339 275 356",
  121: "75 287Q75 299 89 333T135 404T205 441Q246 441 269 420T293 357Q292 338 259 245T225 95Q225 26 274 26Q325 26 367 93L405 245Q442 393 446 404Q460 431 490 431T522 402Q522 400 416 -24Q389 -102 327 -153T196 -205Q152 -205 122 -181T91 -119Q91 -84 110 -67T152 -49Q170 -49 180 -60T191 -87Q191 -108 174 -128Q167 -134 157 -138T146 -144Q155 -153 159 -156T173 -163T199 -167Q229 -167 255 -149T297 -105T325 -52T342 -6T347 15Q315 -10 269 -10Q204 -10 176 25T148 108Q148 161 184 262T221 383Q221 405 206 405Q178 405 158 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287",
  122: "160 317Q158 317 155 317Q136 317 136 324Q136 351 171 396T260 442Q292 442 321 410T365 375H369Q384 375 404 408L425 441Q427 442 444 442H460Q466 436 466 434Q466 419 426 367Q387 314 294 222T178 105L170 95L181 94Q198 93 236 81T295 68Q328 68 356 89T395 141Q398 150 401 151T419 153Q441 153 441 144Q441 110 394 50T282 -11Q251 -11 221 23T171 57Q157 57 143 47T121 26T104 3T95 -10Q93 -11 76 -11H60Q54 -5 54 -2Q54 3 61 14Q103 88 233 215Q349 329 349 338L302 351Q269 362 247 362Q227 362 212 356T192 342T183 327T178 320Q175 317 160 317"
}, {});
var so = {}, lo = {};
Object.defineProperty(lo, "__esModule", { value: !0 });
lo.texOldstyleBold = void 0;
lo.texOldstyleBold = {
  48: [0.46, 0.017, 0.575],
  49: [0.461, 0, 0.575],
  50: [0.46, 0, 0.575],
  51: [0.461, 0.211, 0.575],
  52: [0.469, 0.194, 0.575],
  53: [0.461, 0.211, 0.575],
  54: [0.66, 0.017, 0.575],
  55: [0.476, 0.211, 0.575],
  56: [0.661, 0.017, 0.575],
  57: [0.461, 0.21, 0.575],
  65: [0.751, 0.049, 0.921, { ic: 0.068, sk: 0.224 }],
  66: [0.705, 0.017, 0.748, { sk: 0.16 }],
  67: [0.703, 0.02, 0.613, { sk: 0.16 }],
  68: [0.686, 0, 0.892, { sk: 0.0958 }],
  69: [0.703, 0.016, 0.607, { ic: 0.02, sk: 0.128 }],
  70: [0.686, 0.03, 0.814, { ic: 0.116, sk: 0.128 }],
  71: [0.703, 0.113, 0.682, { sk: 0.128 }],
  72: [0.686, 0.048, 0.987, { sk: 0.128 }],
  73: [0.686, 0, 0.642, { ic: 0.104, sk: 0.0319 }],
  74: [0.686, 0.114, 0.779, { ic: 0.158, sk: 0.192 }],
  75: [0.703, 0.017, 0.871, { sk: 0.0639 }],
  76: [0.703, 0.017, 0.788, { sk: 0.16 }],
  77: [0.703, 0.049, 1.378, { sk: 0.16 }],
  78: [0.84, 0.049, 0.937, { ic: 0.168, sk: 0.0958 }],
  79: [0.703, 0.017, 0.906, { sk: 0.128 }],
  80: [0.686, 0.067, 0.81, { ic: 0.036, sk: 0.0958 }],
  81: [0.703, 0.146, 0.939, { sk: 0.128 }],
  82: [0.686, 0.017, 0.99, { sk: 0.0958 }],
  83: [0.703, 0.016, 0.696, { ic: 0.025, sk: 0.16 }],
  84: [0.72, 0.069, 0.644, { ic: 0.303, sk: 0.0319 }],
  85: [0.686, 0.024, 0.715, { ic: 0.056, sk: 0.0958 }],
  86: [0.686, 0.077, 0.737, { ic: 0.037, sk: 0.0319 }],
  87: [0.686, 0.077, 1.169, { ic: 0.037, sk: 0.0958 }],
  88: [0.686, 0, 0.817, { ic: 0.089, sk: 0.16 }],
  89: [0.686, 0.164, 0.759, { ic: 0.038, sk: 0.0958 }],
  90: [0.686, 0, 0.818, { ic: 0.035, sk: 0.16 }]
};
Object.defineProperty(so, "__esModule", { value: !0 });
so.texOldstyleBold = void 0;
var JH = s3, YH = lo;
so.texOldstyleBold = (0, JH.AddPaths)(YH.texOldstyleBold, {
  48: "259 460H279Q352 460 403 444T491 378Q528 320 528 219Q528 100 475 45Q417 -17 287 -17Q152 -17 99 44T46 219Q46 246 47 265T57 318T82 376T131 422T210 454Q234 460 259 460ZM389 229V271Q389 351 371 380T280 409Q232 409 208 385Q194 371 190 345T185 229V210Q185 108 194 83Q208 35 287 35Q317 35 336 42Q372 55 380 85T389 204V229",
  49: "119 417Q191 417 240 428T310 450T338 461Q353 461 357 452T361 400Q361 389 361 342T360 254V62H420H456Q483 62 488 58T494 35V29Q494 13 491 7T473 0Q468 0 424 1T295 2T167 1T117 0Q114 0 111 0T107 1Q96 8 96 27V35Q96 54 102 58T140 62H170H229V213Q229 363 228 363Q220 360 196 358T150 356L130 355H93Q84 360 82 365T80 386Q80 404 81 407T95 417H119",
  50: "214 399Q202 399 191 398T175 395T170 392L171 390Q172 389 174 386T178 379T181 369T182 355Q182 328 165 312T123 296Q99 296 82 312T64 356Q64 397 105 428T253 460Q301 460 337 456T411 441T476 403T514 338Q516 328 516 310V304Q516 257 470 227Q456 217 427 205T376 184L354 176Q350 174 325 162T277 139L254 128Q414 129 428 130H439Q450 148 453 166T460 188T486 193H493Q515 193 517 178Q517 171 502 94T484 11Q481 3 472 2T410 0H269Q65 0 62 2Q55 5 53 10T51 32Q51 54 56 58Q60 62 173 131Q296 207 318 224Q368 264 368 308Q368 342 342 363T283 392T214 399",
  51: "80 309Q80 367 131 414T276 461Q388 461 441 417T494 313Q494 265 463 223T373 155L361 151L376 147Q436 132 480 92T525 -15T487 -127T393 -192T274 -211Q179 -211 114 -167T48 -53Q48 -18 69 5T128 29Q168 29 188 5T208 -50Q208 -59 207 -67T203 -81T197 -92T190 -101T183 -109T177 -114T170 -118L167 -121Q160 -125 164 -127Q167 -129 176 -133Q215 -152 268 -152H273Q337 -152 356 -92Q364 -69 364 -14Q364 45 352 74T303 120Q287 125 240 125H230Q201 125 196 127T191 146V152Q192 170 196 173T233 178Q234 178 241 178T252 179T262 181T274 183T285 188T297 195T308 205T319 218T328 235T337 257Q345 280 345 320V330Q345 345 343 355T335 379T312 399T270 407Q226 407 177 377Q226 356 226 310Q226 270 204 253T153 235Q123 235 102 253T80 309",
  52: "180 0Q155 0 124 0T84 -1Q48 -1 40 3T32 27V37Q32 59 34 63T204 265T377 465Q380 468 383 468H387Q391 468 398 468T411 469Q432 469 438 468T449 459Q451 455 451 258V62H489H498Q531 62 536 58T542 31Q542 9 537 5T504 0H489H451V-132H489H498Q530 -132 536 -136T542 -163Q542 -181 538 -187T522 -194Q518 -194 483 -193T378 -192Q281 -192 256 -193L217 -194Q203 -189 203 -169V-163V-158Q203 -140 209 -136T246 -132H265H314V0H180ZM325 62V320L105 63L215 62H325",
  53: "131 29Q159 26 175 12T194 -13T197 -35V-41Q197 -58 195 -66Q191 -76 185 -84T173 -97T161 -105T152 -109L148 -110Q148 -112 158 -121T195 -141T252 -152Q274 -152 280 -151Q335 -137 349 -104T363 9Q363 85 356 114T322 157Q305 166 286 166Q251 166 223 154T182 131T162 109Q154 98 150 96T130 93Q107 93 102 104Q100 107 100 279V371V424Q100 461 110 461Q114 461 123 458T149 450T183 441Q234 429 286 429Q313 429 340 432T387 440T422 449T447 457T458 461Q472 461 472 435Q472 420 470 418Q464 405 438 379T352 325T226 297Q189 297 171 301H168V182Q169 182 174 185T190 194T213 205T248 213T292 217Q391 217 454 159T517 5Q517 -92 444 -151T255 -211Q167 -211 112 -160T57 -44Q57 -12 76 8T131 29",
  54: "48 316Q48 398 70 462T124 562T198 621T274 652T339 660Q377 660 384 659Q497 632 497 532Q497 507 482 487T431 466Q397 466 381 486T365 530Q365 569 405 593Q382 603 381 603Q361 607 350 607Q316 607 279 589T221 533Q199 489 196 385L195 370Q196 371 203 379T217 395T237 410T263 424Q283 431 313 431Q409 431 468 368Q526 310 526 208Q526 131 492 81T405 5Q359 -17 289 -17Q256 -17 227 -11T163 17T105 73T65 170T48 316ZM293 380Q244 380 220 331T196 212Q196 104 216 80Q240 41 292 41Q295 41 301 41T309 42Q338 46 355 62Q372 81 375 108T379 230Q378 314 372 333Q358 375 299 380H293",
  55: "95 210H88Q66 210 64 225Q64 229 82 345T102 465Q106 476 125 476H131Q162 476 162 458Q162 451 213 448Q221 448 238 447T260 446Q261 446 410 444Q436 444 468 444T509 445Q544 445 551 440T558 413V404Q558 395 547 380T478 301L392 202Q354 150 339 81T321 -104V-132Q321 -187 286 -203Q273 -211 255 -211Q236 -211 217 -199T190 -160Q189 -153 189 -130Q194 17 282 156Q309 200 370 270Q404 307 400 307H293Q151 306 146 303Q140 300 132 259T120 215Q115 210 95 210",
  56: "48 164Q48 199 59 228T92 277T128 307T163 329Q159 332 155 336Q135 346 110 382Q80 427 80 477Q80 564 147 620Q202 660 264 660Q266 660 275 660T290 661Q384 661 439 619T494 506Q494 486 489 468T477 437T459 413T440 395T421 380T406 370L410 368Q414 365 421 361T437 351T456 335T476 316T495 291T511 262T522 228T526 189Q526 93 460 38T282 -17Q242 -17 205 -9T130 19T71 75T48 164ZM406 506Q406 545 379 576T283 607Q218 606 193 585T168 536Q168 522 172 513T195 490T224 471T275 443L346 403Q406 446 406 506ZM291 42Q365 42 395 70T425 134V141Q425 170 401 190T319 242Q308 248 302 251Q286 260 266 271T235 288L225 294Q222 292 217 289T198 274T175 249T157 212T148 163Q148 116 179 79T291 42",
  57: "175 -140Q198 -152 236 -152Q294 -152 332 -116Q356 -91 366 -54T379 62V78L376 74Q372 70 366 64T352 50T333 35T308 23Q289 17 262 17Q168 17 108 77T48 235Q48 273 59 317Q81 381 141 421T276 461Q279 461 285 461T295 460Q326 460 354 454T415 426T471 371T510 277T526 136Q526 42 501 -28T432 -136T341 -192T240 -210Q199 -210 169 -201T121 -178T94 -146T80 -112T77 -82Q77 -51 95 -33T143 -15Q170 -15 189 -33T209 -81Q209 -116 175 -140ZM377 244V274Q377 300 376 316T368 352T348 384T312 405Q307 406 283 406Q257 406 238 396T213 376T205 361Q196 341 196 259V233V181Q196 122 211 96T278 69H298Q330 82 345 104Q367 134 376 190Q377 200 377 244",
  65: "761 751Q784 751 784 728V711Q784 570 795 417T820 191Q844 76 865 76Q868 76 902 93T962 112H973Q989 104 989 94Q989 92 987 86Q978 47 846 -11Q812 -25 779 -26Q722 -26 708 9Q688 47 669 161H524L379 162L359 136Q286 43 234 -3T142 -49T71 -19T39 55Q39 92 60 131T103 174Q113 174 117 167T124 149T136 128T166 110Q183 105 190 105Q230 105 341 246Q401 322 453 397T531 514T582 601T611 651H640V663Q640 692 676 718T745 750Q747 750 752 750T761 751ZM658 266Q653 312 649 377T644 489T641 541V556L557 415Q500 325 448 253Q467 261 524 261H568H658V266",
  66: "441 83Q571 83 571 195Q571 246 538 279T466 322T386 333Q378 333 357 330T329 327Q307 327 307 345Q307 354 313 365T347 396T419 430Q546 472 581 498Q594 508 594 535Q594 574 567 589T508 604Q469 604 442 583Q390 546 342 457T265 256Q237 148 186 60Q167 29 144 13Q105 -15 68 -17H65Q40 -17 40 1Q40 7 53 29T87 100T124 210Q162 373 190 575Q188 575 174 567T138 550T98 542Q75 542 75 560Q75 588 123 618Q135 625 203 659T281 696Q299 703 316 703Q339 703 339 685Q339 656 328 583L333 588Q338 592 346 599T367 615T394 634T428 654T467 674T511 690T559 701T611 705Q651 704 681 689Q739 659 739 598Q739 507 595 427L584 421Q585 420 595 416T610 410T626 402T644 392T660 380T677 365T691 347T703 325T710 299T715 268Q717 193 665 130Q622 73 531 28T348 -17Q275 -17 225 10Q206 19 200 24T193 36Q193 57 231 86T311 119H322Q386 83 441 83",
  67: "243 -20Q135 -20 78 48T20 218Q20 280 39 344T98 470T193 580T324 661T488 702H490Q491 702 493 702T498 703T507 703T518 702H526Q599 702 599 631Q599 597 577 550T541 486Q523 463 490 447T431 430Q423 430 419 433Q409 437 409 450Q410 456 432 499T454 567Q454 586 446 594T415 603Q316 603 254 532Q216 487 190 421T164 284Q164 228 181 186T226 122T282 90T340 80Q377 80 405 96T449 131T492 167T553 187H555Q580 187 580 168Q580 153 551 123T476 60T367 4T243 -20",
  68: "107 0Q92 5 92 18Q92 33 113 53T160 86Q170 91 182 94T197 100L206 120Q248 226 273 337T304 501T309 585Q278 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q281 686 447 686H480H517Q692 686 784 631Q885 571 885 450Q885 339 805 239T586 75T286 1Q276 0 187 0H107ZM741 391Q741 424 731 452T694 510T613 558T481 584Q476 584 468 584T457 585L449 586V579Q441 501 425 424T391 292T357 193T330 125T319 100H324Q511 100 628 175Q688 215 714 275T741 391",
  69: "495 516Q485 516 478 520T470 532Q470 537 476 550T482 570Q482 589 465 596T401 603Q344 603 319 582Q295 558 295 519Q295 493 312 474T355 445T407 432T455 427Q477 427 477 409Q477 395 453 371T389 333Q380 330 345 327T279 312T223 272Q181 223 181 176Q181 131 225 107T324 83Q366 83 395 98T448 136T487 167Q517 185 547 187H551Q574 187 574 170Q574 151 535 113T421 36T271 -15Q260 -16 226 -16Q181 -16 152 -9Q104 4 71 33T37 111Q37 140 50 176T106 263T216 356Q215 357 207 362T190 374T172 392T156 419T150 456Q150 521 208 580T341 670T474 702Q475 703 499 703Q528 703 547 701T586 693T615 673T627 637Q627 584 581 550T495 516",
  70: "812 567Q804 567 795 570T786 579Q786 586 647 586H559L558 582Q558 575 539 510T506 407L498 384H775Q788 378 790 368Q790 328 746 298T665 268Q646 268 642 284H457L447 261Q396 150 360 94Q329 46 270 8T149 -30Q123 -30 100 -24T63 -10T37 9T22 26T17 36Q17 59 56 88T135 119Q145 119 149 117T165 104Q187 78 227 72Q232 72 234 76Q245 93 273 145T350 323T424 570L428 586H276Q265 575 239 563T190 551Q180 551 174 556T167 569Q167 580 179 597T213 634T278 668T371 685Q374 686 624 686Q863 685 888 682Q917 678 927 663Q930 658 930 650Q930 624 888 596T812 567",
  71: "50 279Q50 361 88 438T190 570T335 661T503 702H514Q524 703 532 703Q671 703 671 626Q671 580 614 514T495 447Q472 447 472 465Q472 477 499 511T527 562Q527 582 507 592T433 602Q351 602 302 569Q252 535 223 469T194 344Q194 266 237 217T352 168Q401 168 442 205T505 316Q515 345 551 368T622 393H625Q649 393 649 376Q649 371 635 318T612 237Q580 129 540 62T442 -49Q353 -114 264 -114Q259 -114 252 -114L246 -113Q190 -113 142 -107T81 -96Q71 -90 71 -81Q71 -57 110 -30T187 2Q196 2 236 -4T338 -14Q371 -14 377 -9Q410 24 446 113L451 127Q353 68 253 68Q157 68 104 129T50 279",
  72: "42 447Q20 447 20 465Q20 481 47 515T119 589T239 657T392 686Q443 686 463 664T484 616Q484 570 473 506T452 401L441 360Q441 359 550 359H660L663 370Q684 435 716 522T758 624Q771 646 806 666T870 686Q894 686 894 668Q894 667 867 597T804 416T752 218Q737 135 737 93Q737 77 746 65T778 53Q799 53 803 54T814 63Q831 86 864 103T924 120Q946 120 946 100Q945 85 931 63T888 16T806 -27T684 -48H681Q625 -48 603 -10Q593 4 593 29Q593 71 603 131T624 230L634 269Q632 269 624 266Q610 261 600 261T507 259H411L399 222Q344 62 322 21Q301 -7 268 -24T209 -41H207Q187 -41 185 -25Q185 -17 192 2T220 71T261 184Q284 256 284 258Q284 259 227 259H170Q169 259 166 261T162 264T158 266T156 271T155 277Q155 296 184 320T250 356Q259 358 286 359Q312 359 312 360Q314 372 318 385Q332 450 339 526Q339 530 339 535T340 543Q340 586 296 586Q255 586 227 576T188 553T165 523T146 497Q127 476 97 462T42 447",
  73: "56 499Q32 499 32 516Q32 540 64 580T165 649Q241 682 365 685Q366 685 376 685T405 685T445 686T496 686T553 686H732Q746 677 746 668Q746 646 711 620T642 587L572 586H503Q479 546 458 479T424 352T383 224T318 111L309 101L412 100H514L523 109Q567 150 618 153Q644 153 644 135Q644 132 642 124Q629 86 581 52T476 6Q454 2 433 2T216 0Q-11 0 -15 2Q-27 6 -27 18Q-27 37 2 61T59 93Q77 100 142 100H198Q255 177 299 369Q337 513 382 574L391 586H348Q261 586 176 576Q163 543 124 521T56 499",
  74: "286 390Q263 390 263 407Q263 432 293 481T367 566Q511 687 724 687Q738 687 761 687T793 686H923Q937 677 937 668Q937 648 905 623T842 589Q829 587 817 586T802 585T795 583T788 578Q709 506 632 189Q622 153 615 134T588 81T537 17Q482 -39 404 -76T247 -114Q192 -114 158 -100Q53 -61 53 32Q53 59 58 73T79 102Q126 147 177 147Q200 147 200 128Q200 123 198 112T196 96Q196 47 238 17T345 -13Q362 -13 377 -9T404 0T426 16T444 34T459 55T470 76T478 97T483 116T488 132L490 141Q511 222 520 257T554 364T608 486T675 576L685 586H634H612Q532 586 484 564Q453 549 436 526T409 478T395 447Q378 424 345 407T286 390",
  75: "98 542Q75 542 75 560Q75 588 123 618Q132 624 199 657T275 694Q291 703 315 703Q327 703 332 699T338 690T339 670Q339 596 323 505T283 337T237 194T198 90L181 53Q170 31 136 8T68 -17H65Q40 -17 40 0L76 92Q112 185 150 322T194 564V578L168 565Q125 542 98 542ZM834 142Q834 125 819 100T774 48T692 3T576 -16H560Q540 -16 508 6Q469 33 422 108T342 267T309 398Q309 411 310 417T320 442T347 482Q401 542 517 615T710 702Q712 702 721 702T735 703Q772 703 791 690Q819 674 819 646T792 597T733 574H722Q704 584 704 599Q706 607 700 610T672 617L660 613Q609 595 524 538T423 450V440Q423 376 488 247T604 83Q621 70 640 70Q677 70 701 82Q713 87 718 101T737 132T783 160Q792 163 807 163Q834 163 834 142",
  76: "63 -17Q41 -17 41 0Q41 22 85 54Q101 68 113 92T133 141T154 219T182 315Q230 462 306 553Q345 599 391 632T478 678T543 697T582 703Q584 703 589 703T598 702Q643 702 666 676T689 613Q689 588 683 575Q674 551 632 524T552 496Q530 496 530 512Q530 517 531 525T533 538Q533 559 522 577T480 596H476Q462 596 451 588T415 544Q350 447 310 281Q284 181 261 136L255 124H285Q342 123 441 107T583 90L596 89Q603 116 647 144T729 173Q751 173 751 157Q751 118 685 60T523 -15Q514 -16 479 -16Q421 -16 320 0T171 18H155L142 10Q98 -17 63 -17",
  77: "38 20Q38 59 60 99T104 139Q106 139 126 125T176 106H181Q200 106 221 139T286 281Q322 370 342 451T368 581T376 634Q384 657 420 680T487 703Q502 703 507 696T522 649Q538 589 554 537Q579 453 609 372T660 248T686 202Q687 201 739 244T830 322L1166 642Q1225 700 1230 701Q1230 701 1237 703Q1258 703 1258 667L1253 637Q1248 607 1241 558T1227 451T1214 326T1209 202Q1209 77 1232 77Q1237 77 1269 94T1326 112H1329Q1353 112 1353 94Q1353 81 1334 60Q1311 37 1248 7T1150 -24H1141H1135Q1085 -24 1074 26Q1064 75 1064 134Q1064 239 1086 426Q1087 430 1087 434L1061 410Q871 227 783 149L694 76Q653 44 647 40T631 34Q620 34 616 37T594 63Q546 125 514 198Q467 307 423 449L418 466L412 444Q376 310 306 153Q278 88 251 45T201 -18T163 -43T131 -49Q102 -48 70 -31T38 20",
  78: "47 139Q81 105 122 105Q137 105 147 117Q159 134 182 199T234 381T274 610Q275 634 284 647Q297 666 327 684T389 703Q403 703 408 695T428 645Q480 490 567 298Q628 163 673 103Q674 102 674 102T675 106Q732 331 803 551Q842 674 875 725Q908 775 966 807T1081 840H1084Q1105 840 1105 803Q1105 768 1088 733T1051 689Q1045 686 1032 686Q986 683 948 663T901 624Q881 579 837 430T760 154L726 28Q725 28 725 28T723 25Q716 0 682 -24T611 -48Q600 -48 595 -45T576 -23Q522 44 480 124Q417 243 332 463L328 473L325 457Q291 293 227 124Q159 -49 72 -49Q38 -49 5 -28Q-24 -8 -24 21Q-24 58 -3 98T41 139H47",
  79: "433 703Q456 703 456 685Q456 672 441 655T407 627Q402 623 378 611T328 579T276 524Q207 434 207 324Q207 222 270 153T441 84Q566 84 651 177T737 400V405Q737 496 693 549T576 603Q542 603 510 560Q490 537 472 502T442 454Q397 412 346 409Q320 409 320 427Q320 430 322 436Q331 465 360 507T433 594T542 671T677 703Q776 703 829 636T882 468Q882 369 831 277T702 122T528 21T343 -17Q214 -17 139 61T63 257Q63 336 94 409T173 534T272 625T367 684T432 703H433",
  80: "170 -67Q147 -67 147 -49Q147 -42 162 -8T204 99T253 254Q274 332 288 415T305 542L308 585Q277 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H495H537Q622 686 678 677T784 637Q846 598 846 533Q846 452 776 375T597 252T378 206H366L358 181Q341 130 316 68T282 -7Q262 -33 230 -50T170 -67ZM701 468Q701 512 661 540T570 577T461 586H448V582Q446 576 443 545T428 447T395 301L389 280Q390 280 398 284T419 295T441 303Q443 304 484 306T572 321T651 359Q701 402 701 468",
  81: "874 453Q874 372 836 298T750 177T638 89T543 33T486 8L483 7Q485 5 523 -7T622 -32T726 -46Q741 -46 746 -45T755 -41T762 -27Q770 -1 806 23T878 50H890Q905 42 905 33Q905 -8 838 -68T670 -145Q662 -146 628 -146Q538 -146 389 -100T164 -50Q132 -50 132 -32T162 11T227 47Q231 48 286 51T394 62T518 100T641 180Q730 271 730 387Q730 478 673 540T520 602Q410 602 337 525T264 355Q264 284 310 244T420 203Q476 203 568 222Q594 222 594 204Q594 184 565 161T508 128Q433 103 316 103Q227 103 174 157T120 290Q120 382 182 471T343 620T548 697Q578 703 601 703Q604 703 611 703T623 702Q663 702 687 696Q760 679 817 618T874 453",
  82: "159 0Q159 5 172 34T205 114T245 229T284 386T309 575V585H304Q303 585 295 585T282 584Q233 579 207 570T175 553T165 531T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H505H582Q683 686 745 672T834 611Q842 594 842 565Q842 523 824 484T780 419T722 370T669 336T632 318L619 312L626 302Q640 279 667 227T696 172Q717 133 735 112T762 88T784 84Q824 84 872 118T957 153Q981 153 981 136Q981 114 937 78T820 13T684 -17Q646 -17 616 8T569 66T526 151T477 234Q461 256 446 265Q437 272 421 274Q400 274 400 291Q400 311 430 336T495 371Q496 371 543 374T627 392T681 436Q699 467 699 503Q699 550 644 568T471 586H449V582Q449 581 447 559T438 499T422 413T393 298T348 165Q313 73 296 45Q282 24 249 4T185 -17Q159 -17 159 0",
  83: "204 476Q204 525 248 577T372 666T539 703T674 683T721 612Q721 588 714 569Q704 547 669 524T601 499Q573 499 573 516Q573 521 575 527T577 543Q577 563 568 574T548 588L539 590Q490 603 444 603Q418 603 394 597T364 583Q348 567 348 533Q348 493 382 466T459 425T555 387T633 330Q662 292 662 249Q662 153 544 69T257 -16Q218 -16 208 -15Q118 1 64 46Q25 76 25 126Q25 185 82 235T203 290H207Q229 290 231 274Q231 243 180 213Q173 209 172 206T170 189T171 170T183 150T216 121Q273 83 356 83Q412 83 459 100Q493 111 507 141Q518 165 518 185Q518 208 506 228T478 262T437 288T398 306T360 320Q316 335 285 352T239 384T215 416T205 443T204 467V476",
  84: "61 462H59Q38 462 38 479Q38 528 109 594T289 683L304 685L837 687L846 693Q889 720 923 720Q947 720 947 702Q945 671 892 631T776 583Q774 583 772 583T769 582T766 582L764 581H758Q753 581 744 581T722 580T693 580T662 580H563L514 385Q507 355 493 299T475 225T460 172T443 119T426 76T402 24Q386 -11 355 -33T304 -61T266 -69Q242 -69 242 -50Q243 -45 253 -25T278 32T307 115L364 340Q405 511 413 538T436 580H207Q202 572 200 568T197 561T195 552T190 537Q176 511 135 487T61 462",
  85: "124 586Q107 586 74 569T15 552H13Q-10 552 -10 570Q-10 605 70 645T222 686Q283 686 283 631Q283 590 246 504T172 326T135 181Q135 130 157 107T205 83Q221 83 259 106Q347 165 453 301T604 548Q607 557 612 569T619 587T624 600T628 612T632 621T637 628T641 634T647 640T654 645T662 652Q706 686 748 686Q771 686 771 669Q771 656 754 614T700 467T630 229Q615 168 610 105Q610 88 617 78L641 90Q681 111 706 112Q733 112 733 95Q733 82 714 60Q694 40 633 10Q567 -23 532 -24Q507 -24 495 -17Q466 -4 466 32Q466 96 500 225Q277 -17 102 -17Q56 -17 23 17T-10 118Q-10 164 13 234T64 363T115 481T139 567Q139 586 124 586",
  86: "25 608Q25 628 60 657T148 686Q184 683 213 671T273 625T327 538T363 394T380 184L381 134L399 148Q503 226 574 302T667 415T689 467Q688 474 684 482T672 502T645 521T600 532Q576 532 576 567Q576 604 597 644T641 685H649Q701 685 737 648T774 545Q774 457 703 333T461 66Q397 13 332 -32T255 -77Q237 -77 237 -30V-23Q241 20 241 109Q241 483 115 569Q91 586 50 589Q25 589 25 608",
  87: "25 607Q25 629 62 657T142 686Q205 686 248 647T312 541T339 411T347 275Q347 249 345 203V189Q375 219 449 316T587 516Q629 584 629 587Q629 589 626 597T622 607Q622 629 658 656T732 686H744Q755 680 757 678Q757 677 769 649T799 577T835 475T874 339T904 183Q908 157 910 151L925 169Q997 252 1059 343T1121 474Q1120 498 1103 513T1059 532Q1036 532 1036 568Q1036 600 1053 636T1090 683L1097 686H1109Q1147 684 1176 652T1206 551Q1206 460 1131 320T897 7Q859 -33 840 -52T816 -74T804 -77Q788 -77 784 -32Q783 -28 783 -26Q774 108 744 239T691 436T665 501Q664 501 649 475T602 400T528 289T420 146T280 -15Q243 -56 231 -66T210 -77Q191 -77 191 -40Q191 -38 195 -4T204 91T209 217Q209 290 202 351T177 469T126 557T45 589Q25 589 25 607",
  88: "762 562Q762 579 737 584T711 604Q711 630 753 658T834 686Q864 686 885 669T906 627Q906 580 834 522T614 379L584 362V357Q585 354 589 315T597 233T603 183Q610 132 627 116T671 100Q678 100 704 113T754 126T778 107Q776 79 733 45T626 2Q615 1 578 1Q542 1 535 3Q521 7 510 15T491 31T477 54T467 78T460 108T456 137T452 170T449 201Q447 220 445 240T442 270L441 281Q435 281 357 233Q240 165 206 135Q200 128 200 124Q200 113 208 108T226 101T244 96T252 82Q252 61 214 31T129 1H120Q97 1 77 16T56 60Q56 105 133 168T414 345Q428 352 431 354T433 359Q422 493 414 522Q407 551 395 566T373 583T350 586H341L332 580Q290 560 265 560Q243 560 243 577Q243 585 248 596T269 624T306 653T365 676T447 686H456Q472 686 484 683T514 671T543 637T562 576Q565 557 570 501L577 437Q577 436 613 457T694 506T756 551Q762 558 762 562",
  89: "73 555Q49 555 49 573Q49 602 110 644T239 686Q319 686 376 624Q416 584 444 511T483 361T499 240T503 173Q503 165 504 165Q506 165 524 184T556 218Q631 297 674 377T718 485Q718 505 699 526Q673 552 628 552Q619 552 613 562T607 590Q607 617 621 645T658 685Q661 686 671 686Q718 686 757 652T797 545Q797 476 749 369T602 146Q500 29 371 -67T176 -164Q112 -164 74 -120T36 -29Q36 5 55 36T95 67Q104 67 108 59T115 39T128 12T154 -12Q183 -30 216 -30Q239 -30 305 7L361 44L367 49V54Q367 95 364 143T351 273T312 429T243 546Q206 581 156 588L146 581Q108 555 73 555",
  90: "622 574Q522 579 420 579H396Q373 579 364 574T351 550Q339 516 297 490T218 462Q195 462 195 479Q195 487 197 492Q218 565 313 625T509 685Q564 685 650 683T755 680Q787 680 807 683T831 686Q853 686 853 669Q853 657 826 626Q742 532 641 437L619 415L622 414Q626 414 631 414T642 414Q697 411 697 388Q697 367 670 345T607 323Q605 323 592 325T546 329H522L490 302Q457 274 400 226T289 136L260 113L318 112Q345 111 452 109T587 106H627Q650 143 656 170Q666 197 710 225T788 253Q811 253 811 237Q811 211 781 160T710 77Q619 0 515 0Q507 0 497 0T484 1Q434 1 319 3T177 6Q123 6 95 2Q83 2 71 0H68Q46 0 46 17Q46 28 58 44Q68 56 100 80T210 165T383 307L408 329H361L314 330Q297 338 297 350Q297 368 320 388T368 413Q375 415 441 415H506L647 555L664 574H622"
}, {});
var uo = {}, co = {};
Object.defineProperty(co, "__esModule", { value: !0 });
co.texOldstyle = void 0;
co.texOldstyle = {
  48: [0.452, 0.022, 0.5],
  49: [0.453, 0, 0.5],
  50: [0.453, 0, 0.5],
  51: [0.452, 0.216, 0.5],
  52: [0.464, 0.194, 0.5],
  53: [0.453, 0.216, 0.5],
  54: [0.665, 0.022, 0.5],
  55: [0.463, 0.216, 0.5],
  56: [0.666, 0.021, 0.5],
  57: [0.453, 0.216, 0.5],
  65: [0.728, 0.05, 0.798, { ic: 0.021, sk: 0.194 }],
  66: [0.705, 0.022, 0.657, { sk: 0.139 }],
  67: [0.705, 0.025, 0.527, { sk: 0.139 }],
  68: [0.683, 0, 0.771, { sk: 0.0833 }],
  69: [0.705, 0.022, 0.528, { ic: 0.036, sk: 0.111 }],
  70: [0.683, 0.032, 0.719, { ic: 0.11, sk: 0.111 }],
  71: [0.704, 0.119, 0.595, { sk: 0.111 }],
  72: [0.683, 0.048, 0.845, { sk: 0.111 }],
  73: [0.683, 0, 0.545, { ic: 0.097, sk: 0.0278 }],
  74: [0.683, 0.119, 0.678, { ic: 0.161, sk: 0.167 }],
  75: [0.705, 0.022, 0.762, { sk: 0.0556 }],
  76: [0.705, 0.022, 0.69, { sk: 0.139 }],
  77: [0.705, 0.05, 1.201, { sk: 0.139 }],
  78: [0.789, 0.05, 0.82, { ic: 0.159, sk: 0.0833 }],
  79: [0.705, 0.022, 0.796, { sk: 0.111 }],
  80: [0.683, 0.057, 0.696, { ic: 0.037, sk: 0.0833 }],
  81: [0.705, 0.131, 0.817, { sk: 0.111 }],
  82: [0.682, 0.022, 0.848, { sk: 0.0833 }],
  83: [0.705, 0.022, 0.606, { ic: 0.036, sk: 0.139 }],
  84: [0.717, 0.068, 0.545, { ic: 0.288, sk: 0.0278 }],
  85: [0.683, 0.028, 0.626, { ic: 0.061, sk: 0.0833 }],
  86: [0.683, 0.052, 0.613, { ic: 0.045, sk: 0.0278 }],
  87: [0.683, 0.053, 0.988, { ic: 0.046, sk: 0.0833 }],
  88: [0.683, 0, 0.713, { ic: 0.094, sk: 0.139 }],
  89: [0.683, 0.143, 0.668, { ic: 0.046, sk: 0.0833 }],
  90: [0.683, 0, 0.725, { ic: 0.042, sk: 0.139 }]
};
Object.defineProperty(uo, "__esModule", { value: !0 });
uo.texOldstyle = void 0;
var KH = s3, eE = co;
uo.texOldstyle = (0, KH.AddPaths)(eE.texOldstyle, {
  48: "39 213Q39 274 53 319T89 389T139 429T192 448T242 452Q347 452 400 400Q460 335 460 213Q460 -22 250 -22Q39 -22 39 213ZM364 242Q364 279 363 301T355 348T338 385T306 406T254 415Q250 415 245 415T238 416Q217 416 190 404T150 368Q136 339 136 221Q136 114 146 78T200 23Q219 16 250 16Q280 16 299 23Q341 41 352 77T364 221V242",
  49: "116 410Q176 412 215 423T269 443T288 453H291Q293 453 301 447V254Q301 62 303 60Q307 52 322 49T394 46Q418 46 422 43T426 23Q426 8 424 4T411 0Q407 0 369 1T258 2T148 1T106 0Q96 0 94 4T91 23Q91 40 95 43T123 46Q180 46 195 49T215 61Q216 63 216 220V376Q192 367 119 364H93L86 371V403L92 410H116",
  50: "55 334Q55 386 105 419T236 453Q333 453 390 413T448 307Q448 278 437 256T406 218T365 193T318 172T277 151L248 134Q219 118 191 102T163 84T267 83L382 85H391Q399 99 406 126Q410 143 413 145T429 148Q440 148 442 147T449 139Q449 137 435 73T420 7Q420 6 414 0H233Q94 0 71 0T46 5Q46 5 46 6Q44 8 44 24Q44 39 46 41Q47 44 98 78T212 155T294 212Q347 257 347 304Q347 354 306 380T203 407Q150 407 120 377Q118 375 123 373Q146 362 146 332Q146 315 133 302T101 288Q85 288 70 298T55 334",
  51: "69 312Q69 377 122 414T233 452Q333 452 381 409T430 313Q430 268 402 223T311 149L301 144Q307 143 317 140T355 123T402 92T439 44T456 -25Q456 -101 396 -158T241 -216Q154 -216 98 -173T42 -68Q42 -58 44 -50T50 -35T57 -25T66 -17T75 -13T82 -10L87 -8Q92 -7 102 -7Q132 -7 147 -25T162 -66Q162 -112 118 -125L113 -126Q113 -129 127 -140T173 -162T239 -173Q268 -173 292 -158Q345 -124 345 -24Q345 33 329 67Q298 125 229 125H210H172Q166 131 166 142Q166 159 172 161Q178 161 208 164T244 169Q251 169 263 176T291 199T316 245T327 314Q327 413 238 413Q182 413 130 369Q177 350 181 312Q181 289 166 273T125 257Q102 257 86 272T69 312",
  52: "163 0Q139 0 109 0T71 -1Q43 -1 36 2T28 15V27V46L190 270Q325 457 330 462Q333 464 352 464H371L377 458V46H464L471 40V6L464 0H377V-65V-108Q377 -131 379 -137T391 -144Q409 -148 446 -148H464Q468 -151 471 -155V-187L464 -194H453Q395 -192 325 -192Q222 -192 210 -194H199L193 -188V-154L199 -148H228Q241 -148 250 -148T265 -146T275 -145T281 -143T284 -141T286 -138T289 -134V0H163ZM295 46V350L75 46H295",
  53: "159 -44Q159 -66 145 -80T109 -96H102L107 -105Q148 -173 228 -173Q255 -173 280 -162Q351 -128 351 -6V8Q351 67 344 98T316 151Q288 176 255 176Q175 176 136 109Q129 100 114 100Q97 100 95 106Q93 110 93 277V403Q93 451 98 451Q100 452 103 452Q105 452 124 445T177 431T251 423Q294 423 328 430T380 445T401 453Q410 453 410 435V422Q332 331 203 331Q152 331 140 339Q139 339 139 254V168Q194 214 256 214Q332 214 390 154T448 0Q448 -95 381 -155T229 -216Q153 -216 104 -166T50 -49Q50 -15 66 -1T105 13Q128 13 143 -3T159 -44",
  54: "42 313Q42 401 68 472T133 583T215 644T296 665H304Q317 665 329 664T360 657T393 640T418 608T432 557Q432 533 422 519T401 502T380 498Q358 498 343 512T328 550Q328 591 367 601L372 602Q372 604 365 609T341 620T307 626Q260 626 226 600T174 537Q147 483 143 376V356Q192 434 266 434Q317 434 357 409Q406 375 435 317Q456 268 456 210V192Q456 169 451 149Q440 90 387 34T253 -22Q225 -22 199 -14T143 16T92 75T56 172T42 313ZM251 396Q211 396 178 354T145 217Q145 159 152 122T166 73T187 47Q216 21 252 21Q294 21 321 47Q342 68 349 99T356 203V232Q356 264 354 285T345 331T322 373T280 395Q274 396 251 396",
  55: "75 246Q64 246 62 247T55 255Q55 259 72 357T90 458L94 462H99Q104 463 109 463H121Q128 460 128 452Q128 445 134 441T165 435T233 432T356 431H478L485 425V392L414 298Q408 290 385 260T358 223T337 191T317 154T302 116T289 68T282 14T275 -55T274 -137Q274 -173 272 -177Q262 -216 223 -216Q170 -216 170 -157V-148Q172 -78 189 -12T237 109T288 196T338 266Q345 275 348 279Q395 340 395 342Q396 343 376 343T274 343Q122 342 117 339T103 294T90 248Q88 246 75 246",
  56: "69 496Q69 570 124 618T247 666Q321 666 375 624T429 515Q429 468 405 433T320 361L346 344Q385 320 403 301T439 250Q456 212 456 181V172V160Q456 141 449 119T426 71T386 26T326 -8T246 -21Q160 -21 102 30T43 155Q43 265 167 332L176 337L161 347Q105 384 87 423Q69 458 69 496ZM371 513Q371 567 334 596T249 626Q198 626 163 598T127 532Q127 521 129 511T138 492T150 476T167 460T185 447T207 433T228 420L284 384L294 391Q346 424 363 469Q371 486 371 513ZM190 21T250 21T351 56T393 140Q393 180 362 213Q354 221 317 246T246 292L212 313Q210 313 200 307T173 287T142 256T117 212T106 157Q106 100 148 61",
  57: "171 -101Q171 -118 163 -130T146 -146T134 -151Q132 -151 132 -152Q132 -154 140 -159T167 -168T206 -173Q274 -173 317 -108Q356 -50 356 79V86L350 77Q308 9 231 9Q150 9 92 81Q42 141 42 228Q42 289 64 333Q93 390 142 421T235 452Q237 452 244 452T255 453Q289 453 321 439T386 391T437 290T457 128Q457 -29 381 -122T206 -216Q148 -216 108 -187T67 -104Q67 -75 84 -62T119 -49Q141 -49 156 -63T171 -101ZM242 46Q293 46 324 94T355 223Q355 323 337 356Q316 401 275 410Q267 412 248 412Q206 412 179 386Q155 360 149 328T143 224Q143 120 163 88Q192 46 242 46",
  65: "576 668Q576 688 606 708T660 728Q676 728 675 712V571Q675 409 688 252Q696 122 720 57Q722 53 723 50T728 46T732 43T737 41T743 39L754 45Q788 61 803 61Q819 61 819 47Q818 43 814 35Q799 15 755 -7T675 -30Q659 -30 648 -25T630 -8T621 11T614 34Q603 77 599 106T594 146T591 160V163H460L329 164L316 145Q241 35 196 -7T119 -50T59 -24T30 43Q30 75 46 100T74 125Q81 125 83 120T88 104T96 84Q118 57 151 57Q189 57 277 182Q432 400 542 625L559 659H567Q574 659 575 660T576 668ZM584 249Q579 333 577 386T575 473T574 520V581L563 560Q497 426 412 290L372 228L370 224H371L383 228L393 232H586L584 249",
  66: "304 342Q292 342 292 353Q292 372 323 391Q331 396 417 428T533 487Q563 512 563 555V562Q563 575 557 589T530 618T475 636Q429 636 396 613T330 539Q263 446 210 238Q196 183 173 120Q135 31 121 16Q108 1 85 -10T47 -22T32 -10Q32 -5 44 18T77 93T112 206Q135 296 154 395T182 550T191 615Q191 616 190 616Q188 616 179 611T157 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 693Q295 686 288 635T278 575Q278 572 287 582Q336 635 402 669T540 704Q603 704 633 673T664 599Q664 559 638 523T580 462Q553 440 504 413L491 407L504 402Q566 381 596 338T627 244Q627 172 575 110T444 13T284 -22Q208 -22 158 28Q144 42 146 50Q150 67 178 85T230 103Q236 103 246 95T267 75T302 56T357 47Q436 47 486 93Q526 136 526 198V210Q526 228 518 249T491 292T436 330T350 345Q335 345 321 344T304 342",
  67: "201 -25Q167 -25 136 -14T75 23T29 94T12 202Q12 290 50 394T161 574Q227 642 303 673T433 704Q435 705 457 705Q533 701 533 640Q533 606 507 548T464 474Q431 444 396 444Q381 444 381 453Q381 459 388 473T407 513T428 563Q433 580 433 594Q433 636 381 636Q314 636 260 594T175 489T128 363T112 247Q112 157 153 101T273 44Q347 44 398 121Q413 144 437 157T481 171Q496 171 496 160Q496 150 476 123Q426 56 350 16T201 -25",
  68: "37 475Q19 475 19 487Q19 536 103 604T327 682H356Q386 683 408 683H419Q475 683 506 681T582 668T667 633Q766 571 766 450Q766 365 723 287T611 152T455 57T279 6Q248 1 160 0Q148 0 131 0T108 -1Q72 -1 72 11Q72 24 90 40T133 64L144 68L152 88Q247 328 272 587Q275 613 272 613Q272 613 269 613Q225 610 195 602T149 579T129 556T119 532Q118 530 116 525T113 518Q102 502 80 490T37 475ZM665 407Q665 596 412 613Q403 614 383 614Q370 614 370 612Q370 598 363 542T323 357T242 103L228 69H265Q391 73 481 119Q536 148 575 188T633 268T658 338T665 392V407",
  69: "144 470Q144 556 240 630T451 705Q564 705 564 637Q564 611 540 573Q529 559 505 547T464 534Q448 534 448 545Q448 552 455 562Q463 577 463 591Q463 600 462 604T456 616T436 627T400 635Q396 635 390 635T380 636Q291 636 258 568Q245 544 245 516Q245 463 290 438T391 410Q415 410 415 398Q415 392 407 380T376 356T326 341Q288 340 260 327Q218 311 187 276T143 208T130 151Q130 113 156 88T211 55T268 47Q349 47 403 125Q415 144 439 157T483 171Q499 171 499 160Q499 148 475 120T413 59T315 3T197 -22Q124 -22 77 14T30 105Q30 126 39 154T66 216T122 288T209 354L223 362Q144 400 144 470",
  70: "199 579Q181 579 181 590Q181 598 188 611T212 639T260 666T335 682Q336 682 349 682T383 682T431 682T493 683T561 683Q776 682 784 681Q826 673 829 647Q829 620 797 600T744 580Q728 580 728 595Q729 607 713 610Q698 613 598 614H500L499 610Q499 598 467 486T428 367Q428 365 551 365H674Q683 360 684 355Q687 346 677 329Q666 312 642 299T598 285Q586 285 582 296H402L394 277Q386 258 373 229T346 167T315 102T286 51Q265 22 225 -5T133 -32Q108 -32 87 -25T54 -7T33 15T21 35T18 47Q18 60 44 80T98 103Q108 103 111 101T119 88Q130 66 150 54T179 39T195 37Q199 37 203 43Q217 67 245 125T318 300T391 532Q393 543 398 564T406 598T409 613T339 614H269Q229 579 199 579",
  71: "216 68Q155 68 115 100T59 177T44 273Q44 299 50 333T73 421T133 533T239 632Q346 704 466 704Q508 704 515 703Q555 696 577 681T599 635Q599 605 570 560T523 496Q490 466 455 466Q440 466 440 475T469 526T499 589Q499 605 489 617Q460 636 403 636Q343 636 295 611T220 548T174 464T150 382T144 318Q144 241 180 189T287 137Q325 137 359 160Q428 205 466 322Q472 342 501 359T551 376Q557 376 560 373T564 368L565 365Q560 341 551 302T512 173T451 31Q359 -119 204 -119Q163 -118 127 -109T74 -91T53 -77Q52 -75 52 -71Q52 -54 79 -35T132 -14H140L151 -19Q210 -49 281 -49H289Q312 -49 329 -31Q351 -7 372 36T405 109T416 142L408 136Q401 131 392 125T369 111T338 96T303 82T261 72T216 68",
  72: "18 487Q18 496 29 517T67 566T127 621T216 665T330 683Q359 683 376 669T397 643T400 622Q400 584 382 488T348 343Q348 342 467 342H587L594 366Q615 440 648 534T690 641Q701 656 723 669T764 683Q783 683 783 672L750 578Q716 485 677 346T625 101Q624 92 623 82T622 65T621 56Q621 20 658 20Q666 20 701 25Q709 52 736 69T785 87Q803 87 803 75T791 44T754 3T685 -33T588 -48Q568 -48 562 -46Q522 -31 522 13V23Q531 129 562 250L569 281L565 280Q561 278 556 277T549 274L438 273H328L321 249Q307 202 275 107T232 0Q219 -16 196 -28T155 -41Q149 -41 145 -39T140 -34T139 -29Q139 -24 148 -3T181 86T233 247Q240 270 240 272Q240 273 194 273H169Q139 273 139 285Q139 295 153 308T187 332Q206 341 236 342L260 343L264 359Q278 414 289 482T300 578Q300 613 260 613H254Q198 613 169 592Q148 578 127 544T104 508Q72 478 37 475Q18 475 18 487",
  73: "174 0H31Q-13 0 -21 2T-30 12Q-30 23 -17 36Q9 60 42 68L155 70Q187 102 214 179T257 333T302 491T366 610L369 614H305Q221 611 188 607T145 596T128 569Q119 543 94 529T47 512Q28 512 28 524Q28 527 32 539Q56 614 159 654Q218 678 312 682Q314 682 339 682T404 682T481 683H632Q642 678 642 671Q642 657 621 641T577 617Q570 615 507 614H444Q427 592 406 542Q382 478 355 366T310 209Q280 123 238 78L230 69H330Q442 70 442 74Q443 74 443 77T447 87T460 105Q490 134 527 137Q545 137 545 125Q545 120 542 112Q531 78 491 49T399 7Q379 2 360 2T174 0",
  74: "148 78Q148 16 189 -17T286 -50Q319 -50 348 -33T396 10T426 59T444 101L471 204Q498 306 521 372Q575 532 649 605L659 614H591Q517 613 494 607Q433 591 400 550T360 477Q353 454 325 437T275 419Q256 419 260 435Q280 523 376 597T583 681Q603 683 713 683H830Q839 674 839 671Q839 654 810 634T754 614Q735 614 721 601Q688 571 654 495T600 351T561 209T541 132Q507 29 412 -45T213 -119Q141 -119 94 -77T47 33Q47 55 50 69T58 90T71 103Q105 131 135 131Q152 131 152 120Q152 119 151 114T149 99T148 78",
  75: "194 618Q193 618 182 613T156 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 691Q295 569 250 397Q225 306 197 217T151 81T128 25Q120 8 94 -7T47 -22Q32 -22 32 -10L64 76Q95 163 133 295T185 530Q198 611 194 618ZM331 429Q331 383 364 290T449 117T542 36Q574 36 607 51T652 103Q660 124 677 133T709 143Q727 143 727 128Q727 119 723 111Q704 56 639 17T497 -22H493Q463 -22 425 16Q401 40 382 71Q335 138 296 243T256 399Q256 434 288 473Q342 540 471 622T670 705Q691 704 703 696Q732 678 732 644Q732 613 714 600T677 586Q671 586 667 587T660 592T657 604V619Q657 647 629 647Q623 647 620 646Q576 635 495 583T365 482Q331 448 331 429",
  76: "62 -22T47 -22T32 -11Q32 -1 56 24T83 55Q113 96 138 172T180 320T234 473T323 609Q364 649 419 677T531 705Q559 705 578 696T604 671T615 645T618 623V611Q618 582 615 571T598 548Q581 531 558 520T518 509Q503 509 503 520Q503 523 505 536T507 560Q507 590 494 610T452 630Q423 630 410 617Q367 578 333 492T271 301T233 170Q211 123 204 112L198 103L224 102Q281 102 369 79T509 52H523Q535 64 544 87T579 128Q616 152 641 152Q656 152 656 142Q656 101 588 40T433 -22Q381 -22 289 1T156 28L141 29L131 20Q111 0 87 -11",
  77: "28 9Q28 37 43 63T73 90Q77 90 83 84T103 70T141 57H146Q162 57 178 79T222 167Q266 279 295 371T334 513T349 598T358 651T371 677Q397 705 432 705Q442 705 445 699T452 666Q453 661 453 659Q475 538 509 405T568 207L574 192Q581 178 587 164T594 150Q596 150 635 189T693 248Q765 324 863 438T1024 626T1089 701Q1093 705 1100 705Q1111 705 1111 682Q1111 675 1108 660T1099 611T1086 540Q1041 277 1041 144Q1041 98 1044 75T1050 48T1059 42Q1064 41 1075 46Q1102 61 1121 61Q1137 61 1137 50Q1137 28 1087 0T1000 -29Q983 -29 972 -23T955 -9T945 16T942 45T941 83V96Q941 158 952 256T974 422L985 489Q984 489 939 436T821 300T698 164Q665 128 620 85T568 37Q564 34 558 34Q550 34 546 37T535 54Q512 91 496 127T450 259T389 498L384 518Q349 367 294 223T198 15Q155 -50 117 -50Q87 -50 61 -35T30 -6Q28 2 28 9",
  78: "343 705Q358 705 358 698Q360 696 370 658T411 524T484 319Q536 174 590 82L595 73L615 152Q646 274 683 407Q729 571 752 637T799 727Q852 780 937 788Q939 788 947 788T958 789H962Q979 789 979 765Q979 722 951 692Q942 683 924 683Q888 681 859 672T818 654T803 639Q784 608 708 322T631 15Q631 14 630 15Q630 17 629 15Q628 14 628 12Q621 -4 601 -17T560 -31Q550 -31 546 -28T530 -7Q484 67 458 123T398 272Q352 392 314 514L306 535V534Q306 533 296 488T272 379T234 239T185 100T127 -7T61 -50Q34 -50 4 -34T-27 8Q-27 33 -12 61T18 90Q21 90 36 77T87 57H92Q109 57 123 78T162 173Q206 299 232 417T265 599T276 667Q284 681 304 693T343 705",
  79: "308 428Q289 428 289 438Q289 457 318 508T378 593Q417 638 475 671T599 705Q688 705 732 643T777 483Q777 380 733 285T620 123T464 18T293 -22Q188 -22 123 51T58 245Q58 327 87 403T159 533T249 626T333 685T388 705Q404 705 404 693Q404 674 363 649Q333 632 304 606T239 537T181 429T158 290Q158 179 214 114T364 48Q489 48 583 165T677 438Q677 473 670 505T648 568T601 617T528 636Q518 636 513 635Q486 629 460 600T419 544T392 490Q383 470 372 459Q341 430 308 428",
  80: "37 475Q19 475 19 487Q19 536 103 604T327 682Q329 682 344 682T380 682T421 683H463Q625 683 695 615Q718 591 726 564Q733 547 733 525Q733 412 607 312T321 205H312Q293 205 293 217Q293 224 302 236T333 260T385 274Q558 287 614 407Q633 445 633 477Q633 515 612 543T556 585T481 607T399 614H370L368 603Q352 463 312 312T242 82T202 -13Q190 -33 164 -45T121 -57Q108 -57 108 -45Q108 -40 120 -10T151 73T192 190T233 349T266 539Q267 546 269 565T272 598T274 613H270Q209 613 163 588Q131 572 113 518Q102 502 80 490T37 475",
  81: "114 286Q114 358 151 433T249 569T392 667T558 705Q653 705 713 641T774 460Q774 389 750 322T687 206T600 114T504 46T412 4L399 -2Q542 -62 636 -62Q660 -62 670 -54T686 -27T700 0Q734 34 770 34Q787 34 787 23Q787 -18 720 -74T563 -131Q485 -131 350 -83T145 -34Q127 -34 127 -22Q127 -12 144 5T190 31L200 34L237 35Q386 38 467 79Q550 120 612 210T675 416Q675 510 625 573T484 636Q410 636 346 587T248 469T214 333Q214 306 221 281T243 229T288 188T360 172Q403 172 441 188T490 205Q510 205 510 192Q505 162 432 132T287 102Q206 102 160 155T114 286",
  82: "37 475Q19 475 19 487Q19 503 35 530T83 589T180 647T327 682H374Q387 682 417 682T464 683Q519 683 559 679T642 663T708 625T731 557Q731 481 668 411T504 300Q506 296 512 286T528 257T553 202Q594 105 611 82Q635 47 665 47Q708 47 742 93Q758 113 786 128Q804 136 819 137Q837 137 837 125Q837 115 818 92T767 43T687 -2T589 -22Q549 -22 517 22T467 120T422 221T362 273Q346 273 346 287Q348 301 373 320T436 342Q437 342 446 343T462 345T481 348T504 353T527 362T553 375T577 393Q598 412 614 443T630 511Q630 545 613 566T541 600T393 614Q370 614 370 613L366 584Q349 446 311 307T243 96L213 25Q205 8 179 -7T132 -22Q125 -22 120 -18T117 -8Q117 -5 130 26T163 113T205 239T246 408T274 606V614Q273 614 259 613T231 609T198 602T163 588Q131 572 113 518Q102 502 80 490T37 475",
  83: "554 512Q536 512 536 522Q536 525 539 539T542 564Q542 588 528 604Q515 616 482 625T410 635Q374 635 349 624T312 594T295 561T290 532Q290 505 303 482T342 442T378 419T409 404Q435 391 451 383T494 357T535 323T562 282T574 231Q574 133 464 56T220 -22Q138 -22 78 21T18 123Q18 184 61 227T156 274Q178 274 178 263Q178 260 177 258Q172 247 164 239T151 227T136 218L127 213L124 202Q118 186 118 163Q120 124 165 86T292 48Q374 48 423 86T473 186V193Q473 267 347 327Q268 364 239 389Q191 431 191 486Q191 547 242 600T356 679T470 705Q472 705 478 705T489 704Q551 704 596 682T642 610Q642 566 621 545Q592 516 554 512",
  84: "49 475Q34 475 34 490Q34 552 106 611T261 681Q272 683 507 683H742Q790 717 816 717Q833 717 833 708Q833 682 795 653T714 615Q691 610 588 609Q490 609 490 607L483 580Q476 554 462 496T435 392Q410 289 395 231T363 116T335 34T309 -15T279 -47T242 -64Q231 -68 218 -68Q203 -68 203 -57Q203 -52 211 -38Q224 -7 234 20T251 66T268 123T283 179T304 261T328 360Q342 415 360 488Q380 567 384 582T397 605Q400 607 401 609H302H244Q200 609 188 607T167 596Q145 572 145 541Q145 520 109 498T49 475",
  85: "8 592Q8 616 70 649T193 683Q246 683 246 631Q246 587 205 492T124 297T83 143Q83 101 100 75T154 48Q202 48 287 135T450 342T560 553Q589 635 593 640Q603 656 626 668T669 683H670Q687 683 687 672T670 616T617 463T547 220Q525 137 521 68Q521 54 522 50T533 42L543 47Q573 61 588 61Q604 61 604 47Q599 16 506 -22Q486 -28 468 -28T436 -18T421 18Q421 92 468 258Q468 259 467 257T459 248Q426 206 391 167T303 81T194 6T83 -22Q66 -22 58 -20Q25 -11 4 19T-17 99Q-17 146 8 220T64 358T120 488T146 586Q146 604 141 608T123 613H120Q99 613 72 597T25 580Q8 580 8 592",
  86: "25 633Q25 647 47 665T100 683Q291 683 291 306Q291 264 288 213T282 132L279 102Q281 102 308 126T378 191T464 279T545 381T596 479Q600 490 600 502Q600 527 581 550T523 577Q505 577 505 601Q505 622 516 647T542 681Q546 683 558 683Q605 679 631 645T658 559Q658 423 487 215Q409 126 308 37T190 -52Q177 -52 177 -28Q177 -26 183 15T196 127T203 270Q203 356 192 421T165 523T126 583T83 613T41 620Q25 620 25 633",
  87: "25 633Q25 647 46 665T103 683Q168 683 207 632Q228 608 243 568Q269 485 269 374Q269 324 265 271T256 184L251 150L252 152Q254 153 257 157T264 167T274 180T286 197Q359 293 424 398T519 558T549 616Q549 618 547 624T545 638Q550 654 572 668T615 683Q626 683 632 672T657 595Q726 370 741 128L742 110Q752 122 767 142T823 217T894 321T950 424T976 511Q976 544 958 560T918 577Q906 577 906 602Q906 629 918 651T942 681Q948 683 954 683Q983 683 1008 658T1034 569T999 421T915 257T813 109T724 -3T681 -49Q666 -59 660 -45Q659 -41 657 35T639 233T591 477Q573 551 570 551Q569 551 554 523T507 439T433 315T323 155T182 -25Q160 -52 151 -53Q137 -53 137 -30Q137 -29 148 25T170 168T181 338Q181 424 168 483T131 571T87 609T40 620Q25 620 25 633",
  88: "324 614Q291 576 250 573Q231 573 231 584Q231 589 232 592Q235 601 244 614T271 643T324 671T400 683H403Q462 683 481 610Q485 594 490 545T498 454L501 413Q504 413 551 442T648 509T705 561Q707 565 707 578Q707 610 682 614Q667 614 667 626Q667 641 695 662T755 683Q765 683 775 680T796 662T807 623Q807 596 792 572T713 499T530 376L505 361V356Q508 346 511 278T524 148T557 75Q569 69 580 69Q585 69 593 77Q624 108 660 110Q667 110 670 110T676 106T678 94Q668 59 624 30T510 0Q487 0 471 9T445 32T430 71T422 117T417 173Q416 183 416 188Q413 214 411 244T407 286T405 299Q403 299 344 263T223 182T154 122Q152 118 152 105Q152 69 180 69Q183 69 187 66T191 60L192 58V56Q192 41 163 21T105 0Q94 0 84 3T63 21T52 60Q52 77 56 90T85 131T155 191Q197 223 259 263T362 327T402 352L391 489Q391 492 390 505T387 526T384 547T379 568T372 586T361 602T348 611Q346 612 341 613T333 614H324",
  89: "65 599Q65 618 107 650T204 683Q267 683 312 643T380 533T414 385T424 217Q424 186 423 160T422 123Q426 123 468 170T567 304T650 469Q661 503 661 519Q661 546 639 570Q615 591 583 591Q569 591 569 616Q569 640 582 661T613 683Q624 683 638 679T671 664T702 625T714 558Q714 472 639 329T426 45Q361 -21 282 -82T154 -143Q97 -143 64 -104T31 -20Q31 4 44 25T70 46Q78 46 81 39T87 16T97 -9Q127 -51 182 -51Q184 -51 187 -50H190Q233 -41 314 25Q330 36 330 40Q336 79 336 178Q336 508 223 594Q199 614 158 619L148 620L139 611Q111 586 83 586Q65 586 65 599",
  90: "694 220Q708 220 708 210Q708 195 695 167T658 105T593 42T502 3Q492 1 458 1Q400 1 293 11T150 22Q116 22 92 11T51 0Q37 0 37 10Q37 21 63 44T179 146T367 319L391 343H343L296 344Q285 350 285 358Q285 365 289 372T300 383T313 392T324 398L329 400H450L561 518Q597 558 607 571L621 587H596Q553 589 484 599T383 609Q342 609 326 596T301 555Q294 533 263 514T208 492Q189 492 189 503Q189 510 197 528T215 559Q249 607 318 645T466 683Q504 683 573 673T669 662L690 661Q734 682 748 683Q767 683 767 673Q767 666 746 640Q655 531 555 428L529 400Q529 399 543 399Q604 397 604 366Q604 350 587 337T551 322Q541 322 539 323Q529 328 529 334Q529 339 487 342L470 343L446 320Q272 153 200 96L235 95Q297 95 392 86T533 74H554Q586 116 597 159Q604 179 635 199T694 220"
}, {});
var fo = {}, ho = {};
Object.defineProperty(ho, "__esModule", { value: !0 });
ho.texSize3 = void 0;
ho.texSize3 = {
  40: [1.45, 0.949, 0.736],
  41: [1.45, 0.949, 0.736],
  47: [1.45, 0.949, 1.044],
  91: [1.45, 0.949, 0.528],
  92: [1.45, 0.949, 1.044],
  93: [1.45, 0.949, 0.528],
  123: [1.45, 0.949, 0.75],
  125: [1.45, 0.949, 0.75],
  710: [0.772, -0.564, 1.444],
  732: [0.749, -0.61, 1.444],
  770: [0.772, -0.564, 0],
  771: [0.749, -0.61, 0],
  8260: [1.45, 0.949, 1.044],
  8730: [1.45, 0.95, 1, { ic: 0.02 }],
  8968: [1.45, 0.949, 0.583],
  8969: [1.45, 0.949, 0.583],
  8970: [1.45, 0.949, 0.583],
  8971: [1.45, 0.949, 0.583],
  9001: [1.45, 0.95, 0.75],
  9002: [1.45, 0.949, 0.75],
  10216: [1.45, 0.95, 0.75],
  10217: [1.45, 0.949, 0.75],
  12296: [1.45, 0.95, 0.75],
  12297: [1.45, 0.949, 0.75]
};
Object.defineProperty(fo, "__esModule", { value: !0 });
fo.texSize3 = void 0;
var tE = s3, rE = ho;
fo.texSize3 = (0, tE.AddPaths)(rE.texSize3, {
  40: "701 -940Q701 -943 695 -949H664Q662 -947 636 -922T591 -879T537 -818T475 -737T412 -636T350 -511T295 -362T250 -186T221 17T209 251Q209 962 573 1361Q596 1386 616 1405T649 1437T664 1450H695Q701 1444 701 1441Q701 1436 681 1415T629 1356T557 1261T476 1118T400 927T340 675T308 359Q306 321 306 250Q306 -139 400 -430T690 -924Q701 -936 701 -940",
  41: "34 1438Q34 1446 37 1448T50 1450H56H71Q73 1448 99 1423T144 1380T198 1319T260 1238T323 1137T385 1013T440 864T485 688T514 485T526 251Q526 134 519 53Q472 -519 162 -860Q139 -885 119 -904T86 -936T71 -949H56Q43 -949 39 -947T34 -937Q88 -883 140 -813Q428 -430 428 251Q428 453 402 628T338 922T245 1146T145 1309T46 1425Q44 1427 42 1429T39 1433T36 1436L34 1438",
  47: "81 -949Q71 -949 63 -941T55 -921Q55 -917 56 -915Q59 -906 498 264T939 1438Q945 1450 960 1450Q972 1450 980 1441T988 1421Q982 1403 839 1020L398 -155Q107 -934 103 -938Q96 -949 81 -949",
  91: "247 -949V1450H516V1388H309V-887H516V-949H247",
  92: "988 -922Q988 -933 980 -941T962 -949Q947 -949 940 -938Q936 -934 645 -155L204 1020Q56 1416 56 1424Q56 1433 62 1441T84 1450Q97 1448 103 1439Q107 1435 398 656L839 -519Q988 -918 988 -922",
  93: "11 1388V1450H280V-949H11V-887H218V1388H11",
  123: "618 -943L612 -949H582L568 -943Q472 -903 411 -841T332 -703Q327 -682 327 -653T325 -350Q324 -28 323 -18Q317 24 301 61T264 124T221 171T179 205T147 225T132 234Q130 238 130 250Q130 255 130 258T131 264T132 267T134 269T139 272T144 275Q207 308 256 367Q310 436 323 519Q324 529 325 851Q326 1124 326 1154T332 1205Q369 1358 566 1443L582 1450H612L618 1444V1429Q618 1413 616 1411L608 1406Q599 1402 585 1393T552 1372T515 1343T479 1305T449 1257T429 1200Q425 1180 425 1152T423 851Q422 579 422 549T416 498Q407 459 388 424T346 364T297 318T250 284T214 264T197 254L188 251L205 242Q290 200 345 138T416 3Q421 -18 421 -48T423 -349Q423 -397 423 -472Q424 -677 428 -694Q429 -697 429 -699Q434 -722 443 -743T465 -782T491 -816T519 -845T548 -868T574 -886T595 -899T610 -908L616 -910Q618 -912 618 -928V-943",
  125: "131 1414T131 1429T133 1447T148 1450H153H167L182 1444Q276 1404 336 1343T415 1207Q421 1184 421 1154T423 851L424 531L426 517Q434 462 460 415T518 339T571 296T608 274Q615 270 616 267T618 251Q618 241 618 238T615 232T608 227Q542 194 491 132T426 -15L424 -29L423 -350Q422 -622 422 -652T415 -706Q397 -780 337 -841T182 -943L167 -949H153Q137 -949 134 -946T131 -928Q131 -914 132 -911T144 -904Q146 -903 148 -902Q299 -820 323 -680Q324 -663 325 -349T327 -19Q355 145 541 241L561 250L541 260Q356 355 327 520Q326 537 325 850T323 1181Q315 1227 293 1267T244 1332T193 1374T151 1401T132 1413Q131 1414 131 1429",
  710: "1439 564Q1434 564 1080 631T722 698Q719 698 362 631Q7 564 4 564L0 583Q-4 602 -4 603L720 772L1083 688Q1446 603 1447 603Q1447 602 1443 583L1439 564",
  732: "1 643Q1 646 76 671T271 722T476 749Q555 749 626 736T742 706T856 676T999 662Q1088 662 1192 684T1363 727T1432 749Q1432 745 1437 731T1442 716Q1442 714 1381 693T1212 645T1012 611Q1000 610 955 610Q851 610 701 653T444 697Q355 697 251 676T80 632T11 610Q11 614 6 628T1 643",
  770: "-5 564Q-9 564 -363 631T-722 698Q-725 698 -1082 631Q-1437 564 -1440 564L-1444 583Q-1448 602 -1448 603L-724 772L-361 688Q2 603 3 603Q3 602 -1 583L-5 564",
  771: "-1443 643Q-1443 646 -1368 671T-1173 722T-968 749Q-889 749 -818 736T-702 706T-588 676T-445 662Q-356 662 -252 684T-81 727T-12 749Q-12 745 -7 731T-2 716Q-2 714 -63 693T-232 645T-432 611Q-444 610 -489 610Q-593 610 -743 653T-1000 697Q-1089 697 -1193 676T-1364 632T-1433 610Q-1433 614 -1438 628T-1443 643",
  8260: "81 -949Q71 -949 63 -941T55 -921Q55 -917 56 -915Q59 -906 498 264T939 1438Q945 1450 960 1450Q972 1450 980 1441T988 1421Q982 1403 839 1020L398 -155Q107 -934 103 -938Q96 -949 81 -949",
  8730: "424 -948Q422 -947 313 -434T202 80L170 31Q165 24 157 10Q137 -21 137 -21Q131 -16 124 -8L111 5L264 248L473 -720Q473 -717 727 359T983 1440Q989 1450 1001 1450Q1007 1450 1013 1445T1020 1433Q1020 1425 742 244T460 -941Q458 -950 439 -950H436Q424 -950 424 -948",
  8968: "246 -949V1450H571V1388H308V-949H246",
  8969: "11 1388V1450H336V-949H274V1388H11",
  8970: "246 -949V1450H308V-887H571V-949H246",
  8971: "274 -887V1450H336V-949H11V-887H274",
  9001: "126 242V259L361 845Q595 1431 597 1435Q610 1450 624 1450Q634 1450 644 1443T654 1419V1411L422 831Q190 253 190 250T422 -331L654 -910V-919Q654 -936 644 -943T624 -950Q612 -950 597 -935Q595 -931 361 -345L126 242",
  9002: "94 1424Q94 1426 97 1432T107 1444T124 1450Q141 1450 152 1435Q154 1431 388 845L623 259V242L388 -345Q153 -933 152 -934Q142 -949 127 -949H125Q95 -949 95 -919V-910L327 -331Q559 247 559 250T327 831Q94 1411 94 1424",
  10216: "126 242V259L361 845Q595 1431 597 1435Q610 1450 624 1450Q634 1450 644 1443T654 1419V1411L422 831Q190 253 190 250T422 -331L654 -910V-919Q654 -936 644 -943T624 -950Q612 -950 597 -935Q595 -931 361 -345L126 242",
  10217: "94 1424Q94 1426 97 1432T107 1444T124 1450Q141 1450 152 1435Q154 1431 388 845L623 259V242L388 -345Q153 -933 152 -934Q142 -949 127 -949H125Q95 -949 95 -919V-910L327 -331Q559 247 559 250T327 831Q94 1411 94 1424",
  12296: "126 242V259L361 845Q595 1431 597 1435Q610 1450 624 1450Q634 1450 644 1443T654 1419V1411L422 831Q190 253 190 250T422 -331L654 -910V-919Q654 -936 644 -943T624 -950Q612 -950 597 -935Q595 -931 361 -345L126 242",
  12297: "94 1424Q94 1426 97 1432T107 1444T124 1450Q141 1450 152 1435Q154 1431 388 845L623 259V242L388 -345Q153 -933 152 -934Q142 -949 127 -949H125Q95 -949 95 -919V-910L327 -331Q559 247 559 250T327 831Q94 1411 94 1424"
}, {});
var po = {}, mo = {};
Object.defineProperty(mo, "__esModule", { value: !0 });
mo.texSize4 = void 0;
mo.texSize4 = {
  40: [1.75, 1.249, 0.792],
  41: [1.75, 1.249, 0.792],
  47: [1.75, 1.249, 1.278],
  91: [1.75, 1.249, 0.583],
  92: [1.75, 1.249, 1.278],
  93: [1.75, 1.249, 0.583],
  123: [1.75, 1.249, 0.806],
  125: [1.75, 1.249, 0.806],
  710: [0.845, -0.561, 1.889, { ic: 0.013 }],
  732: [0.823, -0.583, 1.889],
  770: [0.845, -0.561, 0, { ic: 0.013 }],
  771: [0.823, -0.583, 0],
  8260: [1.75, 1.249, 1.278],
  8730: [1.75, 1.25, 1, { ic: 0.02 }],
  8968: [1.75, 1.249, 0.639],
  8969: [1.75, 1.249, 0.639],
  8970: [1.75, 1.249, 0.639],
  8971: [1.75, 1.249, 0.639],
  9001: [1.75, 1.248, 0.806],
  9002: [1.75, 1.248, 0.806],
  9115: [1.154, 0.655, 0.875],
  9116: [0.61, 0.01, 0.875],
  9117: [1.165, 0.644, 0.875],
  9118: [1.154, 0.655, 0.875],
  9119: [0.61, 0.01, 0.875],
  9120: [1.165, 0.644, 0.875],
  9121: [1.154, 0.645, 0.667],
  9122: [0.602, 0, 0.667],
  9123: [1.155, 0.644, 0.667],
  9124: [1.154, 0.645, 0.667],
  9125: [0.602, 0, 0.667],
  9126: [1.155, 0.644, 0.667],
  9127: [0.899, 0.01, 0.889],
  9128: [1.16, 0.66, 0.889],
  9129: [0.01, 0.899, 0.889],
  9130: [0.29, 0.015, 0.889],
  9131: [0.899, 0.01, 0.889],
  9132: [1.16, 0.66, 0.889],
  9133: [0.01, 0.899, 0.889],
  9143: [0.935, 0.885, 1.056],
  10216: [1.75, 1.248, 0.806],
  10217: [1.75, 1.248, 0.806],
  12296: [1.75, 1.248, 0.806],
  12297: [1.75, 1.248, 0.806],
  57344: [0.625, 0.014, 1.056],
  57345: [0.605, 0.014, 1.056, { ic: 0.02 }],
  57680: [0.12, 0.213, 0.45, { ic: 0.01 }],
  57681: [0.12, 0.213, 0.45, { ic: 0.024 }],
  57682: [0.333, 0, 0.45, { ic: 0.01 }],
  57683: [0.333, 0, 0.45, { ic: 0.024 }],
  57684: [0.32, 0.2, 0.4, { ic: 0.01 }],
  57685: [0.333, 0, 0.9, { ic: 0.01 }],
  57686: [0.12, 0.213, 0.9, { ic: 0.01 }]
};
Object.defineProperty(po, "__esModule", { value: !0 });
po.texSize4 = void 0;
var nE = s3, iE = mo;
po.texSize4 = (0, nE.AddPaths)(iE.texSize4, {
  40: "758 -1237T758 -1240T752 -1249H736Q718 -1249 717 -1248Q711 -1245 672 -1199Q237 -706 237 251T672 1700Q697 1730 716 1749Q718 1750 735 1750H752Q758 1744 758 1741Q758 1737 740 1713T689 1644T619 1537T540 1380T463 1176Q348 802 348 251Q348 -242 441 -599T744 -1218Q758 -1237 758 -1240",
  41: "33 1741Q33 1750 51 1750H60H65Q73 1750 81 1743T119 1700Q554 1207 554 251Q554 -707 119 -1199Q76 -1250 66 -1250Q65 -1250 62 -1250T56 -1249Q55 -1249 53 -1249T49 -1250Q33 -1250 33 -1239Q33 -1236 50 -1214T98 -1150T163 -1052T238 -910T311 -727Q443 -335 443 251Q443 402 436 532T405 831T339 1142T224 1438T50 1716Q33 1737 33 1741",
  47: "1166 1738Q1176 1750 1189 1750T1211 1742T1221 1721Q1221 1720 1221 1718T1220 1715Q1219 1708 666 238T111 -1237Q102 -1249 86 -1249Q74 -1249 65 -1240T56 -1220Q56 -1219 56 -1217T57 -1214Q58 -1207 611 263T1166 1738",
  91: "269 -1249V1750H577V1677H342V-1176H577V-1249H269",
  92: "56 1720Q56 1732 64 1741T85 1750Q104 1750 111 1738Q113 1734 666 264T1220 -1214Q1220 -1215 1220 -1217T1221 -1220Q1221 -1231 1212 -1240T1191 -1249Q1175 -1249 1166 -1237Q1164 -1233 611 237T57 1715Q57 1716 56 1718V1720",
  93: "5 1677V1750H313V-1249H5V-1176H240V1677H5",
  123: "661 -1243L655 -1249H622L604 -1240Q503 -1190 434 -1107T348 -909Q346 -897 346 -499L345 -98L343 -82Q335 3 287 87T157 223Q146 232 145 236Q144 240 144 250Q144 265 145 268T157 278Q242 333 288 417T343 583L345 600L346 1001Q346 1398 348 1410Q379 1622 600 1739L622 1750H655L661 1744V1727V1721Q661 1712 661 1710T657 1705T648 1700T630 1690T602 1668Q589 1659 574 1643T531 1593T484 1508T459 1398Q458 1389 458 1001Q458 614 457 605Q441 435 301 316Q254 277 202 251L250 222Q260 216 301 185Q443 66 457 -104Q458 -113 458 -501Q458 -888 459 -897Q463 -944 478 -988T509 -1060T548 -1114T580 -1149T602 -1167Q620 -1183 634 -1192T653 -1202T659 -1207T661 -1220V-1226V-1243",
  125: "144 1727Q144 1743 146 1746T162 1750H167H183L203 1740Q274 1705 325 1658T403 1562T440 1478T456 1410Q458 1398 458 1001Q459 661 459 624T465 558Q470 526 480 496T502 441T529 395T559 356T588 325T615 301T637 284T654 273L660 269V266Q660 263 660 259T661 250V239Q661 236 661 234T660 232T656 229T649 224Q577 179 528 105T465 -57Q460 -86 460 -123T458 -499V-661Q458 -857 457 -893T447 -955Q425 -1048 359 -1120T203 -1239L183 -1249H168Q150 -1249 147 -1246T144 -1226Q144 -1213 145 -1210T153 -1202Q169 -1193 186 -1181T232 -1140T282 -1081T322 -1000T345 -897Q346 -888 346 -501Q346 -113 347 -104Q359 58 503 184Q554 226 603 250Q504 299 430 393T347 605Q346 614 346 1002Q346 1389 345 1398Q338 1493 288 1573T153 1703Q146 1707 145 1710T144 1727",
  710: "5 561Q-4 561 -9 582T-14 618Q-14 623 -13 625Q-11 628 461 736T943 845Q945 845 1417 738T1896 628Q1902 628 1902 618Q1902 607 1897 584T1883 561Q1881 561 1412 654L945 750L476 654Q6 561 5 561",
  732: "1212 583Q1124 583 1048 603T923 647T799 691T635 711Q524 711 375 679T120 615L16 583Q14 584 12 587T9 592Q-2 650 2 659Q2 669 38 687Q54 696 146 723T309 767Q527 823 666 823Q759 823 837 803T964 759T1088 715T1252 695Q1363 695 1512 727T1764 791T1871 823Q1872 822 1874 819T1878 814Q1885 783 1885 753Q1885 748 1884 747Q1884 738 1849 719Q1836 712 1740 682T1484 617T1212 583",
  770: "-1884 561Q-1893 561 -1898 582T-1903 618Q-1903 623 -1902 625Q-1900 628 -1428 736T-946 845Q-944 845 -472 738T7 628Q13 628 13 618Q13 607 8 584T-6 561Q-8 561 -477 654L-944 750L-1413 654Q-1883 561 -1884 561",
  771: "-677 583Q-765 583 -841 603T-966 647T-1090 691T-1254 711Q-1365 711 -1514 679T-1768 615L-1873 583Q-1875 584 -1877 587T-1880 592Q-1891 650 -1887 659Q-1887 669 -1851 687Q-1835 696 -1743 723T-1580 767Q-1362 823 -1223 823Q-1130 823 -1052 803T-925 759T-801 715T-637 695Q-526 695 -377 727T-125 791T-18 823Q-17 822 -15 819T-11 814Q-4 782 -4 753Q-4 748 -5 747Q-5 738 -40 719Q-53 712 -149 682T-405 617T-677 583",
  8260: "1166 1738Q1176 1750 1189 1750T1211 1742T1221 1721Q1221 1720 1221 1718T1220 1715Q1219 1708 666 238T111 -1237Q102 -1249 86 -1249Q74 -1249 65 -1240T56 -1220Q56 -1219 56 -1217T57 -1214Q58 -1207 611 263T1166 1738",
  8730: "983 1739Q988 1750 1001 1750Q1008 1750 1013 1745T1020 1733Q1020 1726 742 244T460 -1241Q458 -1250 439 -1250H436Q424 -1250 424 -1248L410 -1166Q395 -1083 367 -920T312 -601L201 44L137 -83L111 -57L187 96L264 247Q265 246 369 -357Q470 -958 473 -963L727 384Q979 1729 983 1739",
  8968: "269 -1249V1750H633V1677H342V-1249H269",
  8969: "5 1677V1750H369V-1249H296V1677H5",
  8970: "269 -1249V1750H342V-1176H633V-1249H269",
  8971: "296 -1176V1750H369V-1249H5V-1176H296",
  9001: "140 242V260L386 994Q633 1729 635 1732Q643 1745 657 1749Q658 1749 662 1749T668 1750Q682 1749 692 1740T702 1714V1705L214 251L703 -1204L702 -1213Q702 -1230 692 -1239T667 -1248H664Q647 -1248 635 -1231Q633 -1228 386 -493L140 242",
  9002: "103 1714Q103 1732 114 1741T137 1750Q157 1750 170 1732Q172 1729 419 994L665 260V242L419 -493Q172 -1228 170 -1231Q158 -1248 141 -1248H138Q123 -1248 113 -1239T103 -1213V-1204L591 251L103 1705V1714",
  9115: "837 1154Q843 1148 843 1145Q843 1141 818 1106T753 1002T667 841T574 604T494 299Q417 -84 417 -609Q417 -641 416 -647T411 -654Q409 -655 366 -655Q299 -655 297 -654Q292 -652 292 -643T291 -583Q293 -400 304 -242T347 110T432 470T574 813T785 1136Q787 1139 790 1142T794 1147T796 1150T799 1152T802 1153T807 1154T813 1154H819H837",
  9116: "413 -9Q412 -9 407 -9T388 -10T354 -10Q300 -10 297 -9Q294 -8 293 -5Q291 5 291 127V300Q291 602 292 605L296 609Q298 610 366 610Q382 610 392 610T407 610T412 609Q416 609 416 592T417 473V127Q417 -9 413 -9",
  9117: "843 -635Q843 -638 837 -644H820Q801 -644 800 -643Q792 -635 785 -626Q684 -503 605 -363T473 -75T385 216T330 518T302 809T291 1093Q291 1144 291 1153T296 1164Q298 1165 366 1165Q409 1165 411 1164Q415 1163 416 1157T417 1119Q417 529 517 109T833 -617Q843 -631 843 -635",
  9118: "31 1143Q31 1154 49 1154H59Q72 1154 75 1152T89 1136Q190 1013 269 873T401 585T489 294T544 -8T572 -299T583 -583Q583 -634 583 -643T577 -654Q575 -655 508 -655Q465 -655 463 -654Q459 -653 458 -647T457 -609Q457 -58 371 340T100 1037Q87 1059 61 1098T31 1143",
  9119: "579 -9Q578 -9 573 -9T554 -10T520 -10Q466 -10 463 -9Q460 -8 459 -5Q457 5 457 127V300Q457 602 458 605L462 609Q464 610 532 610Q548 610 558 610T573 610T578 609Q582 609 582 592T583 473V127Q583 -9 579 -9",
  9120: "56 -644H50Q31 -644 31 -635Q31 -632 37 -622Q69 -579 100 -527Q286 -228 371 170T457 1119Q457 1161 462 1164Q464 1165 520 1165Q575 1165 577 1164Q582 1162 582 1153T583 1093Q581 910 570 752T527 400T442 40T300 -303T89 -626Q78 -640 75 -642T61 -644H56",
  9121: "319 -645V1154H666V1070H403V-645H319",
  9122: "319 0V602H403V0H319",
  9123: "319 -644V1155H403V-560H666V-644H319",
  9124: "0 1070V1154H347V-645H263V1070H0",
  9125: "263 0V602H347V0H263",
  9126: "263 -560V1155H347V-644H0V-560H263",
  9127: "712 899L718 893V876V865Q718 854 704 846Q627 793 577 710T510 525Q510 524 509 521Q505 493 504 349Q504 345 504 334Q504 277 504 240Q504 -2 503 -4Q502 -8 494 -9T444 -10Q392 -10 390 -9Q387 -8 386 -5Q384 5 384 230Q384 262 384 312T383 382Q383 481 392 535T434 656Q510 806 664 892L677 899H712",
  9128: "389 1159Q391 1160 455 1160Q496 1160 498 1159Q501 1158 502 1155Q504 1145 504 924Q504 691 503 682Q494 549 425 439T243 259L229 250L243 241Q349 175 421 66T503 -182Q504 -191 504 -424Q504 -600 504 -629T499 -659H498Q496 -660 444 -660T390 -659Q387 -658 386 -655Q384 -645 384 -425V-282Q384 -176 377 -116T342 10Q325 54 301 92T255 155T214 196T183 222T171 232Q170 233 170 250T171 268Q171 269 191 284T240 331T300 407T354 524T383 679Q384 691 384 925Q384 1152 385 1155L389 1159",
  9129: "718 -893L712 -899H677L666 -893Q542 -825 468 -714T385 -476Q384 -466 384 -282Q384 3 385 5L389 9Q392 10 444 10Q486 10 494 9T503 4Q504 2 504 -239V-310V-366Q504 -470 508 -513T530 -609Q546 -657 569 -698T617 -767T661 -812T699 -843T717 -856T718 -876V-893",
  9130: "384 150V266Q384 304 389 309Q391 310 455 310Q496 310 498 309Q502 308 503 298Q504 283 504 150Q504 32 504 12T499 -9H498Q496 -10 444 -10T390 -9Q386 -8 385 2Q384 17 384 150",
  9131: "170 875Q170 892 172 895T189 899H194H211L222 893Q345 826 420 715T503 476Q504 467 504 230Q504 51 504 21T499 -9H498Q496 -10 444 -10Q402 -10 394 -9T385 -4Q384 -2 384 240V311V366Q384 469 380 513T358 609Q342 657 319 698T271 767T227 812T189 843T171 856T170 875",
  9132: "389 1159Q391 1160 455 1160Q496 1160 498 1159Q501 1158 502 1155Q504 1145 504 925V782Q504 676 511 616T546 490Q563 446 587 408T633 345T674 304T705 278T717 268Q718 267 718 250T717 232Q717 231 697 216T648 169T588 93T534 -24T505 -179Q504 -191 504 -425Q504 -600 504 -629T499 -659H498Q496 -660 444 -660T390 -659Q387 -658 386 -655Q384 -645 384 -424Q384 -191 385 -182Q394 -49 463 61T645 241L659 250L645 259Q539 325 467 434T385 682Q384 692 384 873Q384 1153 385 1155L389 1159",
  9133: "384 -239V-57Q384 4 389 9Q391 10 455 10Q496 10 498 9Q501 8 502 5Q504 -5 504 -230Q504 -261 504 -311T505 -381Q505 -486 492 -551T435 -691Q357 -820 222 -893L211 -899H195Q176 -899 173 -896T170 -874Q170 -858 171 -855T184 -846Q262 -793 312 -709T378 -525Q378 -524 379 -522Q383 -493 384 -351Q384 -345 384 -334Q384 -276 384 -239",
  9143: "742 -871Q740 -873 737 -876T733 -880T730 -882T724 -884T714 -885H702L222 569L180 484Q138 399 137 399Q131 404 124 412L111 425L265 736L702 -586V168L703 922Q713 935 722 935Q734 935 742 920V-871",
  10216: "140 242V260L386 994Q633 1729 635 1732Q643 1745 657 1749Q658 1749 662 1749T668 1750Q682 1749 692 1740T702 1714V1705L214 251L703 -1204L702 -1213Q702 -1230 692 -1239T667 -1248H664Q647 -1248 635 -1231Q633 -1228 386 -493L140 242",
  10217: "103 1714Q103 1732 114 1741T137 1750Q157 1750 170 1732Q172 1729 419 994L665 260V242L419 -493Q172 -1228 170 -1231Q158 -1248 141 -1248H138Q123 -1248 113 -1239T103 -1213V-1204L591 251L103 1705V1714",
  12296: "140 242V260L386 994Q633 1729 635 1732Q643 1745 657 1749Q658 1749 662 1749T668 1750Q682 1749 692 1740T702 1714V1705L214 251L703 -1204L702 -1213Q702 -1230 692 -1239T667 -1248H664Q647 -1248 635 -1231Q633 -1228 386 -493L140 242",
  12297: "103 1714Q103 1732 114 1741T137 1750Q157 1750 170 1732Q172 1729 419 994L665 260V242L419 -493Q172 -1228 170 -1231Q158 -1248 141 -1248H138Q123 -1248 113 -1239T103 -1213V-1204L591 251L103 1705V1714",
  57344: "722 -14H720Q708 -14 702 0V306L703 612Q713 625 722 625Q734 625 742 610V0Q734 -14 724 -14H722",
  57345: "702 589Q706 601 718 605H1061Q1076 597 1076 585Q1076 572 1061 565H742V0Q734 -14 724 -14H722H720Q708 -14 702 0V589",
  57680: "-18 -213L-24 -207V-172L-16 -158Q75 2 260 84Q334 113 415 119Q418 119 427 119T440 120Q454 120 457 117T460 98V60V25Q460 7 457 4T441 0Q308 0 193 -55T25 -205Q21 -211 18 -212T-1 -213H-18",
  57681: "-10 60Q-10 104 -10 111T-5 118Q-1 120 10 120Q96 120 190 84Q375 2 466 -158L474 -172V-207L468 -213H451H447Q437 -213 434 -213T428 -209T423 -202T414 -187T396 -163Q331 -82 224 -41T9 0Q-4 0 -7 3T-10 25V60",
  57682: "-24 327L-18 333H-1Q11 333 15 333T22 329T27 322T35 308T54 284Q115 203 225 162T441 120Q454 120 457 117T460 95V60V28Q460 8 457 4T442 0Q355 0 260 36Q75 118 -16 278L-24 292V327",
  57683: "-10 60V95Q-10 113 -7 116T9 120Q151 120 250 171T396 284Q404 293 412 305T424 324T431 331Q433 333 451 333H468L474 327V292L466 278Q375 118 190 36Q95 0 8 0Q-5 0 -7 3T-10 24V60",
  57684: "-10 0V120H410V0H-10"
}, {
  57685: "",
  57686: ""
});
var vo = {}, Lo = {};
Object.defineProperty(Lo, "__esModule", { value: !0 });
Lo.texVariant = void 0;
Lo.texVariant = {
  710: [0.845, -0.561, 2.333, { ic: 0.013 }],
  732: [0.899, -0.628, 2.333],
  770: [0.845, -0.561, 0, { ic: 0.013 }],
  771: [0.899, -0.628, 0],
  1008: [0.434, 6e-3, 0.667, { ic: 0.067 }],
  8463: [0.695, 0.013, 0.54, { ic: 0.022 }],
  8592: [0.437, -0.064, 0.5],
  8594: [0.437, -0.064, 0.5],
  8652: [0.514, 0.014, 1],
  8708: [0.86, 0.166, 0.556],
  8709: [0.587, 0, 0.778],
  8722: [0.27, -0.23, 0.5],
  8726: [0.43, 0.023, 0.778],
  8733: [0.472, -0.028, 0.778],
  8739: [0.43, 0.023, 0.222],
  8740: [0.43, 0.023, 0.222, { ic: 0.018 }],
  8741: [0.431, 0.023, 0.389],
  8742: [0.431, 0.024, 0.389, { ic: 0.018 }],
  8764: [0.365, -0.132, 0.778],
  8776: [0.481, -0.05, 0.778],
  8808: [0.752, 0.284, 0.778],
  8809: [0.752, 0.284, 0.778],
  8816: [0.919, 0.421, 0.778],
  8817: [0.919, 0.421, 0.778],
  8840: [0.828, 0.33, 0.778],
  8841: [0.828, 0.33, 0.778],
  8842: [0.634, 0.255, 0.778],
  8843: [0.634, 0.254, 0.778],
  8872: [0.694, 0, 0.611],
  8901: [0.189, 0, 0.278],
  8994: [0.378, -0.122, 0.778],
  8995: [0.378, -0.143, 0.778],
  9651: [0.575, 0.02, 0.722],
  9661: [0.576, 0.019, 0.722],
  10887: [0.801, 0.303, 0.778],
  10888: [0.801, 0.303, 0.778],
  10955: [0.752, 0.332, 0.778],
  10956: [0.752, 0.333, 0.778]
};
Object.defineProperty(vo, "__esModule", { value: !0 });
vo.texVariant = void 0;
var oE = s3, aE = Lo;
vo.texVariant = (0, oE.AddPaths)(aE.texVariant, {
  710: "1 561Q-3 563 -6 577T-12 604L-14 618Q-14 625 -7 628T23 635Q31 636 36 637Q63 641 621 745Q1148 845 1165 845Q1167 845 1752 739L2338 630Q2346 630 2346 618Q2340 565 2332 561Q2329 561 1749 654Q1617 675 1466 699T1241 736T1167 748Q1165 748 1093 737T867 700T583 654Q3 561 1 561",
  732: "804 788Q717 788 606 772T397 732T213 685T75 645T18 628Q11 628 11 632Q8 637 4 668T2 704Q2 713 36 732Q55 739 242 795Q622 898 826 898Q893 898 947 895Q1009 887 1056 872T1187 819Q1286 776 1356 758T1527 739Q1614 739 1725 755T1934 795T2118 842T2256 882T2313 899Q2320 899 2320 895Q2323 890 2327 860T2329 824Q2329 818 2296 795Q2273 787 2089 732Q1810 657 1598 632Q1562 629 1492 629Q1389 629 1320 644T1144 708Q1048 751 977 769T804 788",
  770: "-2332 561Q-2336 563 -2340 577T-2346 604L-2347 618Q-2347 625 -2340 628T-2310 635Q-2302 636 -2297 637Q-2270 641 -1712 745Q-1185 845 -1168 845Q-1166 845 -581 739L5 630Q13 630 13 618Q7 565 -1 561Q-4 561 -584 654Q-716 675 -867 699T-1092 736T-1166 748Q-1168 748 -1240 737T-1466 700T-1750 654Q-2330 561 -2332 561",
  771: "-1529 788Q-1616 788 -1727 772T-1936 732T-2120 685T-2258 645T-2315 628Q-2322 628 -2322 632Q-2325 637 -2329 668T-2331 704Q-2331 713 -2297 732Q-2278 739 -2091 795Q-1711 898 -1507 898Q-1440 898 -1386 895Q-1324 887 -1277 872T-1146 819Q-1047 776 -977 758T-806 739Q-719 739 -608 755T-399 795T-215 842T-77 882T-20 899Q-13 899 -13 895Q-10 890 -6 860T-4 824Q-4 818 -37 795Q-60 787 -244 732Q-523 657 -735 632Q-771 629 -841 629Q-944 629 -1013 644T-1189 708Q-1285 751 -1356 769T-1529 788",
  1008: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
  8463: "182 599Q182 611 174 615T133 619Q118 619 114 621T109 630Q109 636 114 656T122 681Q125 685 202 688Q272 695 286 695Q304 695 304 684Q304 682 295 644T282 597Q282 592 360 592H399Q430 592 445 587T460 563Q460 552 451 541L442 535H266L251 468Q247 453 243 436T236 409T233 399Q233 395 244 404Q295 441 357 441Q405 441 445 417T485 333Q485 284 449 178T412 58T426 44Q447 44 466 68Q485 87 500 130L509 152H531H543Q562 152 562 144Q562 128 546 93T494 23T415 -13Q385 -13 359 3T322 44Q318 52 318 77Q318 99 352 196T386 337Q386 386 346 386Q318 386 286 370Q267 361 245 338T211 292Q207 287 193 235T162 113T138 21Q128 7 122 4Q105 -12 83 -12Q66 -12 54 -2T42 26L166 530Q166 534 161 534T129 535Q127 535 122 535T112 534Q74 534 74 562Q74 570 77 576T84 585T96 589T109 591T124 592T138 592L182 595V599",
  8592: "292 419Q292 400 261 347T211 275H306Q319 275 338 275T364 276Q399 276 410 271T422 250T411 230T366 225H306H211Q214 222 232 197T271 136T292 82Q292 71 285 68T262 64H250H241Q221 64 216 67T205 83Q186 127 153 167T78 230Q64 238 64 250Q64 258 69 263T82 272T106 288T139 318Q162 342 177 365T198 402T209 425T223 436Q224 437 252 437H258Q292 437 292 419",
  8594: "188 417Q188 437 221 437H233Q256 437 263 434T275 417Q294 373 327 333T402 270Q417 261 417 250Q417 241 410 236T382 217T341 182Q315 155 299 128T275 85T263 66Q259 64 231 64H219Q197 64 191 72T193 100Q202 124 215 147T239 185T257 210T267 223L269 225H174H116Q80 225 69 229T58 250T70 271T114 276Q121 276 140 276T174 275H269L267 277Q266 280 257 291T233 325T205 374Q188 408 188 417",
  8652: "755 512Q755 514 778 514H801L804 503Q805 501 812 486T824 462T839 437T862 408T892 381T932 354L944 347V327H507Q70 327 67 329Q55 335 55 347T67 365Q70 367 454 367H837L828 376Q803 403 785 437T761 489T755 512ZM55 153V173H492Q928 173 932 171Q944 166 944 153T932 135Q928 133 545 133H162L171 124Q198 95 216 61T239 8L244 -12Q244 -14 221 -14H198L195 -4Q160 95 67 146L55 153",
  8708: "55 676Q55 688 66 694H199L333 696L351 772Q364 827 370 843T386 860Q393 860 399 854T406 841Q406 836 391 765L375 696Q375 694 431 694H484Q491 688 497 681V12L493 5L486 1L353 -1H219L202 -79Q184 -153 180 -159Q175 -166 165 -166Q146 -166 146 -148Q146 -141 161 -76T177 -4Q177 -1 122 -1H68Q55 12 55 20T66 39H126L186 41L219 181Q226 215 234 251T246 305T251 325Q251 328 166 328H79Q68 345 68 347Q68 352 75 359L82 368H262L291 505Q298 539 306 575T319 630T324 650V654H68Q55 669 55 676ZM457 368V654H411Q366 654 366 652Q365 651 361 634T349 580T333 514Q303 373 302 372V368H457ZM457 39V328H375Q293 328 293 325Q292 322 260 183T228 41T344 39H457",
  8709: "624 470Q624 468 639 446T668 382T683 291Q683 181 612 99T437 -1Q425 -2 387 -2T337 -1Q245 18 193 70L179 81L131 39Q96 8 89 3T75 -3Q55 -3 55 17Q55 24 61 30T111 73Q154 113 151 113Q151 114 140 130T115 177T95 241Q94 253 94 291T95 341Q112 431 173 495Q265 587 385 587Q410 587 437 581Q522 571 582 513L595 501L642 541Q689 586 695 586Q696 586 697 586T699 587Q706 587 713 583T720 568Q720 560 711 551T664 510Q651 499 642 490T628 475T624 470ZM564 477Q517 522 448 539Q428 546 375 546Q290 546 229 492T144 370Q133 332 133 279Q136 228 151 195Q157 179 168 160T184 141Q186 141 375 307T564 477ZM642 290Q642 318 637 343T625 386T611 416T598 436T593 444Q590 444 402 277T213 108Q213 104 231 89T293 55T392 37Q495 37 568 111T642 290",
  8722: "84 237T84 250T98 270H402Q417 262 417 250T402 230H98Q84 237 84 250",
  8726: "91 404T91 410T97 423T111 430Q117 430 395 224Q676 13 678 10Q685 3 685 -3T678 -16T664 -23Q658 -23 380 184T98 397Q91 404 91 410",
  8733: "56 250Q56 346 122 409T276 472Q349 472 407 430T486 326L489 316Q490 317 493 326T501 345T514 367T531 393Q557 425 602 448T698 472Q722 472 722 452Q722 437 702 435T642 421T571 377Q520 323 520 250Q520 179 568 126T693 68Q722 66 722 48Q722 28 698 28Q636 28 576 67T493 174L490 184Q489 181 483 167T475 150T468 136T458 120T447 107T432 90T412 73Q350 28 277 28Q188 28 122 91T56 250ZM199 68T278 68T408 122T459 250Q459 322 414 370T308 430Q302 431 273 431Q204 431 150 380T96 250Q96 176 147 122",
  8739: "91 417Q104 430 111 430T131 417V-10Q116 -23 111 -23T91 -10V417",
  8740: "91 417Q104 430 111 430T131 417V301L171 341Q201 373 207 378T220 384Q227 384 233 377T240 366Q240 357 187 299L131 244V-10Q116 -23 111 -23T91 -10V201L49 157Q20 127 14 121T0 115Q-8 115 -14 121T-20 132Q-20 139 17 178Q29 191 36 199L91 257V417",
  8741: "55 417Q69 431 76 431T95 419V-12Q84 -23 76 -23Q72 -23 69 -22T62 -16T55 -10V417ZM293 419Q300 431 310 431L324 424L331 417V-10Q316 -23 309 -23L297 -19L293 -12V419",
  8742: "56 417Q68 431 76 431L89 426L96 419V317L98 215L193 273L291 330V375L293 419Q301 431 311 431Q331 431 331 388L333 355L356 370Q381 384 388 384Q394 384 400 377T407 363Q407 354 367 328L331 308V-10Q316 -23 310 -23Q300 -23 293 -12L291 135V284L98 168L96 77V-12Q84 -24 76 -24L62 -19L58 -12L56 66V144L31 128Q5 114 -2 114Q-8 114 -14 121T-20 136Q-20 142 -14 147T20 170L56 190V417",
  8764: "73 132Q55 132 55 172Q55 220 79 272Q95 301 111 319Q148 353 195 363Q199 364 212 364Q262 364 294 350T408 272Q472 222 522 212Q537 208 555 208Q606 208 646 243Q671 268 680 296T691 342T702 365Q713 365 716 354T719 314Q714 236 664 179L660 176Q657 173 654 170T644 163T631 154T615 146T596 139T574 134T549 132Q510 132 465 156T386 211T307 265T223 290Q162 290 124 249T86 165Q86 155 82 144T73 132",
  8776: "55 326Q55 394 101 437T226 481Q268 479 313 460T392 419T469 379T555 361Q622 361 662 401Q686 423 688 450Q693 479 702 479H705Q719 479 719 442Q719 367 670 327T554 286Q512 286 466 304T386 345T307 385T220 404Q184 404 157 394T120 374L111 363Q86 339 86 317Q86 288 71 288Q55 288 55 326ZM55 90Q55 164 105 205T226 246Q269 243 314 224T392 183T470 144T558 126Q622 126 662 166Q686 187 688 214Q693 244 704 244Q716 244 719 210Q719 165 702 132T658 82T605 58T552 50T498 58T447 77T384 110Q322 146 302 152Q263 168 220 168Q179 168 144 152Q128 147 107 125T86 81Q86 52 71 52Q55 52 55 90",
  8808: "86 472Q93 477 381 614T673 752Q680 752 686 746T693 732T689 721Q686 715 418 590L151 461L418 332Q684 207 689 201Q693 195 693 190Q693 183 687 177T675 170Q668 170 380 307T86 450Q82 454 82 461Q82 467 86 472ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
  8809: "89 745Q95 752 100 752Q106 752 394 615T689 472Q693 468 693 461T689 450Q684 445 396 308T100 170Q95 170 89 176T82 190Q82 195 86 201Q91 208 358 332L624 461L358 590Q90 715 86 721Q82 725 82 731Q82 739 89 745ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
  8816: "82 34Q82 44 93 55H198L300 57L342 179Q351 207 362 238T378 286T384 303T238 377Q109 435 86 450Q82 454 82 460T86 472Q90 476 302 579L511 679Q512 679 553 795Q569 842 577 866T592 903T600 917T608 919Q615 919 622 912T629 901Q629 899 595 799Q589 777 581 753T569 717T564 703L618 728Q666 752 673 752T686 746T693 732Q693 723 683 717T615 683L546 650L491 488Q464 410 450 368T438 326Q493 297 562 266Q660 219 677 209T694 190Q694 183 690 177T678 171Q664 171 546 228L424 286Q422 286 382 172L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34ZM495 623Q495 626 493 626T321 544T151 461L398 343Q399 343 405 360T423 415T446 483Q457 513 469 551T488 606T495 623",
  8817: "97 172Q82 172 82 190Q82 197 86 201Q94 209 173 246T327 319T402 357Q405 360 434 448T462 539L278 628Q96 713 86 721Q82 725 82 732T88 745T102 752Q103 752 125 742T198 709T293 666Q342 642 385 622T453 590T478 579Q479 579 506 659T562 824T598 915Q602 919 609 919T622 913T629 901Q629 898 571 728Q546 656 531 608T518 559Q555 539 602 519Q664 488 679 479T694 461Q694 457 689 450Q680 443 616 413T494 356T435 326L389 190L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34Q82 44 93 55H198L300 57L342 179Q350 204 361 238T378 286T382 301L246 237Q111 172 97 172ZM624 461Q621 464 560 492Q512 518 503 518Q500 518 500 517Q499 513 488 479T465 413T453 379L624 461",
  8840: "82 -6Q82 1 95 14H262L295 94Q331 171 331 174Q324 175 312 178T267 194T206 227T146 283T98 368Q84 406 84 461T98 554Q126 632 194 685T349 750Q360 752 480 752H591L604 783Q620 819 624 821Q631 828 640 828Q653 825 658 810Q658 808 646 781L635 754Q635 752 658 752Q680 752 686 746Q693 739 693 732Q693 728 692 726T686 719T680 712H615L506 466Q479 407 451 344T408 248T393 214Q393 210 535 210H680Q693 194 693 190T680 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6ZM571 710Q571 712 469 712Q443 712 416 712T371 711T351 710Q279 700 221 656T138 548Q124 508 124 461T138 374Q186 245 351 212L460 459Q571 709 571 710",
  8841: "82 732Q82 739 95 752H251H348Q420 752 460 744T551 708Q566 697 566 701Q618 815 624 821Q631 828 640 828Q653 825 658 810L600 677Q600 671 615 656T653 605T689 517Q692 496 692 461T689 406Q668 325 615 266Q572 221 513 196T391 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6Q82 1 95 14H262L295 92L331 170H95Q93 172 91 175T87 180T84 185T82 191Q82 199 93 210H220L349 212L549 659Q507 692 462 702T338 712H249H95Q82 727 82 732ZM652 473Q652 513 636 552T603 611T582 632Q581 632 487 422T393 210Q424 210 460 220T535 253T605 316T649 410Q652 427 652 461V473",
  8842: "693 -115T693 -122T680 -144H315L269 -199Q221 -255 213 -255H212Q203 -255 197 -248T193 -231Q195 -225 229 -184L262 -144H186L113 -142L106 -137Q102 -130 102 -125Q102 -119 115 -104H298L426 52H386Q342 54 309 63Q236 79 180 129T98 249Q84 289 84 343Q84 398 98 436Q126 514 193 567T346 632Q347 632 373 632T440 633T520 634H680Q682 631 686 627T691 621T693 614T680 594H526Q364 594 353 592Q268 581 207 528T126 394Q123 378 123 343T126 292Q141 231 181 185T280 114Q329 92 415 92H462L506 147Q554 203 562 203H563Q572 203 578 196T582 178Q579 173 546 132L513 94L598 92H682Q693 81 693 73T680 52H480L349 -102L515 -104H682Q693 -115 693 -122",
  8843: "82 610T82 614T83 620T89 627T95 634H251Q378 634 409 633T469 623Q540 604 596 554T678 436Q691 397 691 343T678 249Q653 181 597 131T469 63Q427 52 362 52H315L213 -102L438 -104H662Q673 -115 673 -123Q673 -129 660 -144H186L151 -197Q114 -250 109 -253Q106 -254 104 -254Q100 -254 98 -253Q91 -253 87 -248T82 -235Q82 -230 109 -186L138 -144H115Q82 -144 82 -125Q82 -119 95 -104H166L266 49Q266 52 182 52H95Q82 65 82 72Q82 76 83 78T89 85T95 92H295L329 143Q365 195 369 198Q372 203 380 203Q385 203 391 197T398 185Q398 184 398 184L399 182Q399 175 369 129L344 94Q344 92 376 92Q402 92 422 94Q496 104 554 147T638 256Q651 295 651 343Q651 390 638 429Q613 494 555 537T422 592Q411 594 249 594H95Q82 610 82 614",
  8872: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V464H540Q554 456 555 446Q555 442 554 439T552 434T549 430T546 428T542 426T539 424H95V270H539Q540 270 542 269T545 267T549 264T552 260T554 255T555 248Q554 238 540 230H95V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678",
  8901: "71 0Q59 4 55 16V96L56 176Q59 180 66 187L70 189H209Q219 181 222 174V15Q219 10 209 1L140 0H71",
  8994: "77 122Q68 122 63 126T57 135T55 142Q55 151 68 176T111 235T177 302T271 356T388 378Q451 378 508 355T602 300T668 233T709 174T722 142Q722 124 704 122Q692 122 685 134T658 179T606 243Q511 338 390 338Q354 338 320 329Q251 312 193 263T97 141Q87 123 77 122",
  8995: "389 143Q324 143 266 164T171 215T107 277T67 330T55 358T60 371T77 378Q85 377 92 367T116 331T158 280Q256 182 389 182Q475 182 552 227T675 351Q688 378 704 378Q722 376 722 358Q722 352 710 330T670 276T605 215T511 164T389 143",
  9651: "99 -20Q84 -11 84 0Q84 5 148 145T278 424L342 563Q347 575 360 575Q368 575 375 570Q376 569 441 430T571 148T637 0Q637 -11 622 -20H99ZM476 260L360 509L248 266Q137 24 135 22Q135 20 360 20Q586 20 586 21L476 260",
  9661: "84 556Q84 567 99 576H622Q637 567 637 556Q637 551 572 409T441 127T375 -14Q368 -19 360 -19H358Q349 -19 342 -7T296 92Q249 193 211 275Q84 550 84 556ZM586 534Q586 536 361 536Q135 536 135 535L358 52L361 47L473 290Q584 532 586 534",
  10887: "102 168Q103 168 151 146T247 102T295 81Q299 85 322 144T344 206L218 268Q153 297 123 313T87 333T82 344T86 355Q104 369 291 455Q491 552 491 553L542 673Q581 767 590 784T609 801Q616 801 622 795T629 781Q629 773 586 677Q546 581 546 577L609 606Q669 635 673 635Q680 635 686 629T693 615Q693 610 692 608T670 593T604 561L524 521L400 226L542 157Q617 123 649 107T687 85T694 72Q694 66 690 60T679 54Q665 54 526 119Q394 186 386 186Q385 186 342 88L331 61L509 -23Q680 -105 688 -111Q693 -115 693 -122T688 -135T675 -141H673Q664 -141 491 -59Q320 21 316 21H315L249 -136Q183 -293 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 154 -261T181 -197T213 -119L280 41Q280 46 186 86Q157 101 121 119Q92 133 87 136T82 148Q82 155 88 161T102 168ZM418 370L466 495Q464 495 308 420T151 344T204 317T311 267T364 244Q364 247 418 370",
  10888: "97 54Q82 54 82 72Q82 79 86 84Q95 91 222 153L351 215L398 324L442 433L258 519Q95 597 87 604Q82 608 82 615T88 628T102 635Q107 635 424 484L458 468L524 630Q593 789 597 795Q601 801 609 801Q616 801 622 795T629 781L562 615L493 450L589 406Q665 371 679 362T694 344Q694 339 693 337T677 326T631 302T538 257Q504 241 465 223T406 195T386 186Q383 185 344 92T306 -3L486 81Q662 168 673 168Q680 168 686 162T693 148T689 137Q688 136 482 35L280 -59L233 -176Q184 -291 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -279 185 -186T224 -90Q225 -88 223 -88Q219 -88 193 -101Q109 -143 98 -143Q82 -138 82 -122Q82 -116 85 -113T108 -98T171 -67L249 -30L289 61Q297 81 307 107T321 144T326 157L218 106Q109 54 97 54ZM553 379Q480 412 480 415Q479 415 460 372T423 285T406 241Q408 240 516 291T624 344L553 379",
  10955: "82 -14T82 -7T95 15H431L529 170H435Q341 170 333 175Q149 218 98 368Q84 406 84 461Q84 515 98 555Q126 633 193 686T346 750Q347 750 373 750T440 751T520 752H680Q693 739 693 732Q693 727 680 712H526Q364 712 353 710Q268 700 207 646T126 512Q123 496 123 461T126 410Q141 350 180 304T280 232Q312 217 344 214T464 210H555L589 261Q613 301 620 311T635 321Q644 321 650 315T657 301Q657 296 651 286T630 252T604 212Q604 210 642 210H680Q693 197 693 190Q693 186 692 184T686 177T680 170H578L526 92L478 17L580 15H682Q693 4 693 -4T680 -25H451L353 -179L518 -181H682Q694 -193 694 -201Q694 -211 682 -219L504 -221H326L293 -272Q257 -332 246 -332Q238 -332 232 -326T225 -313Q225 -310 226 -308Q226 -305 251 -265T278 -223Q278 -221 186 -221H95Q93 -218 89 -214T84 -208T82 -201T95 -181H306L404 -25H249L93 -23L86 -19Q82 -14 82 -7",
  10956: "82 732Q82 739 95 752H251Q415 752 426 750Q539 736 615 657Q667 599 689 517Q692 496 692 461T689 406Q668 325 615 266Q522 170 382 170H355L326 95Q319 80 311 59T298 28T293 17Q293 15 486 15H680Q693 0 693 -6T680 -25H275L213 -179L449 -181H682Q693 -192 693 -199T680 -221H198L178 -270Q153 -333 139 -333Q132 -333 126 -327T119 -314T135 -266T153 -223Q153 -221 124 -221H95Q82 -207 82 -201T95 -181H171L233 -25H162L93 -23L86 -19Q82 -14 82 -7T95 15H251L313 170H202L93 172L86 177Q82 182 82 190Q82 199 93 210H211L329 212L349 261Q366 301 372 311T386 321Q392 321 399 315T407 302Q407 295 390 254T373 210Q374 209 377 209Q412 209 444 217Q512 231 564 273T638 377Q651 414 651 461Q651 509 638 548Q613 613 555 656T422 710Q411 712 249 712H95Q82 727 82 732"
}, {});
var ah = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.delimiters = e.VSIZES = e.HDW3 = e.HDW2 = e.HDW1 = void 0;
  var t = p4;
  e.HDW1 = [0.75, 0.25, 0.875], e.HDW2 = [0.85, 0.349, 0.667], e.HDW3 = [0.583, 0.082, 0.5], e.VSIZES = [1, 1.2, 1.8, 2.4, 3];
  var r = { c: 47, dir: t.V, sizes: e.VSIZES }, n = { c: 175, dir: t.H, sizes: [0.5], stretch: [0, 175], HDW: [0.59, -0.544, 0.5] }, i = { c: 710, dir: t.H, sizes: [0.5, 0.556, 1, 1.444, 1.889] }, o = { c: 732, dir: t.H, sizes: [0.5, 0.556, 1, 1.444, 1.889] }, a = { c: 8211, dir: t.H, sizes: [0.5], stretch: [0, 8211], HDW: [0.285, -0.248, 0.5] }, T = { c: 8592, dir: t.H, sizes: [1], stretch: [8592, 8722], HDW: e.HDW3 }, s = { c: 8594, dir: t.H, sizes: [1], stretch: [0, 8722, 8594], HDW: e.HDW3 }, Q = { c: 8596, dir: t.H, sizes: [1], stretch: [8592, 8722, 8594], HDW: e.HDW3 }, u = { c: 8612, dir: t.H, stretch: [8592, 8722, 8739], HDW: e.HDW3, min: 1.278 }, l = { c: 8614, dir: t.H, sizes: [1], stretch: [8739, 8722, 8594], HDW: e.HDW3 }, c = { c: 8656, dir: t.H, sizes: [1], stretch: [8656, 61], HDW: e.HDW3 }, f = { c: 8658, dir: t.H, sizes: [1], stretch: [0, 61, 8658], HDW: e.HDW3 }, d = { c: 8660, dir: t.H, sizes: [1], stretch: [8656, 61, 8658], HDW: e.HDW3 }, m = { c: 8722, dir: t.H, sizes: [0.778], stretch: [0, 8722], HDW: e.HDW3 }, p = { c: 8739, dir: t.V, sizes: [1], stretch: [0, 8739], HDW: [0.627, 0.015, 0.333] }, v = {
    c: 9180,
    dir: t.H,
    sizes: [0.778, 1],
    schar: [8994, 8994],
    variants: [5, 0],
    stretch: [57680, 57684, 57681],
    HDW: [0.32, 0.2, 0.5]
  }, H = {
    c: 9181,
    dir: t.H,
    sizes: [0.778, 1],
    schar: [8995, 8995],
    variants: [5, 0],
    stretch: [57682, 57684, 57683],
    HDW: [0.32, 0.2, 0.5]
  }, E = { c: 9182, dir: t.H, stretch: [57680, 57684, 57681, 57685], HDW: [0.32, 0.2, 0.5], min: 1.8 }, M = { c: 9183, dir: t.H, stretch: [57682, 57684, 57683, 57686], HDW: [0.32, 0.2, 0.5], min: 1.8 }, C = { c: 10216, dir: t.V, sizes: e.VSIZES }, w = { c: 10217, dir: t.V, sizes: e.VSIZES }, S = { c: 10502, dir: t.H, stretch: [8656, 61, 8739], HDW: e.HDW3, min: 1.278 }, D = { c: 10503, dir: t.H, stretch: [8872, 61, 8658], HDW: e.HDW3, min: 1.278 };
  e.delimiters = {
    40: { dir: t.V, sizes: e.VSIZES, stretch: [9115, 9116, 9117], HDW: [0.85, 0.349, 0.875] },
    41: { dir: t.V, sizes: e.VSIZES, stretch: [9118, 9119, 9120], HDW: [0.85, 0.349, 0.875] },
    45: m,
    47: r,
    61: { dir: t.H, sizes: [0.778], stretch: [0, 61], HDW: e.HDW3 },
    91: { dir: t.V, sizes: e.VSIZES, stretch: [9121, 9122, 9123], HDW: e.HDW2 },
    92: { dir: t.V, sizes: e.VSIZES },
    93: { dir: t.V, sizes: e.VSIZES, stretch: [9124, 9125, 9126], HDW: e.HDW2 },
    94: i,
    95: a,
    123: { dir: t.V, sizes: e.VSIZES, stretch: [9127, 9130, 9129, 9128], HDW: [0.85, 0.349, 0.889] },
    124: { dir: t.V, sizes: [1], stretch: [0, 8739], HDW: [0.75, 0.25, 0.333] },
    125: { dir: t.V, sizes: e.VSIZES, stretch: [9131, 9130, 9133, 9132], HDW: [0.85, 0.349, 0.889] },
    126: o,
    175: n,
    710: i,
    713: n,
    732: o,
    770: i,
    771: o,
    818: a,
    8211: a,
    8212: a,
    8213: a,
    8214: { dir: t.V, sizes: [0.602, 1], schar: [0, 8741], variants: [1, 0], stretch: [0, 8741], HDW: [0.602, 0, 0.556] },
    8215: a,
    8254: n,
    8407: s,
    8592: T,
    8593: { dir: t.V, sizes: [0.888], stretch: [8593, 9168], HDW: [0.6, 0, 0.667] },
    8594: s,
    8595: { dir: t.V, sizes: [0.888], stretch: [0, 9168, 8595], HDW: [0.6, 0, 0.667] },
    8596: Q,
    8597: { dir: t.V, sizes: [1.044], stretch: [8593, 9168, 8595], HDW: e.HDW1 },
    8606: { dir: t.H, sizes: [1], stretch: [8606, 8722], HDW: e.HDW3 },
    8608: { dir: t.H, sizes: [1], stretch: [0, 8722, 8608], HDW: e.HDW3 },
    8612: u,
    8613: { dir: t.V, stretch: [8593, 9168, 8869], HDW: e.HDW1, min: 1.555 },
    8614: l,
    8615: { dir: t.V, stretch: [8868, 9168, 8595], HDW: e.HDW1, min: 1.555 },
    8624: { dir: t.V, sizes: [0.722], stretch: [8624, 9168], HDW: e.HDW1 },
    8625: { dir: t.V, sizes: [0.722], stretch: [8625, 9168], HDW: e.HDW1 },
    8636: { dir: t.H, sizes: [1], stretch: [8636, 8722], HDW: e.HDW3 },
    8637: { dir: t.H, sizes: [1], stretch: [8637, 8722], HDW: e.HDW3 },
    8638: { dir: t.V, sizes: [0.888], stretch: [8638, 9168], HDW: e.HDW1 },
    8639: { dir: t.V, sizes: [0.888], stretch: [8639, 9168], HDW: e.HDW1 },
    8640: { dir: t.H, sizes: [1], stretch: [0, 8722, 8640], HDW: e.HDW3 },
    8641: { dir: t.H, sizes: [1], stretch: [0, 8722, 8641], HDW: e.HDW3 },
    8642: { dir: t.V, sizes: [0.888], stretch: [0, 9168, 8642], HDW: e.HDW1 },
    8643: { dir: t.V, sizes: [0.888], stretch: [0, 9168, 8643], HDW: e.HDW1 },
    8656: c,
    8657: { dir: t.V, sizes: [0.888], stretch: [8657, 8214], HDW: [0.599, 0, 0.778] },
    8658: f,
    8659: { dir: t.V, sizes: [0.888], stretch: [0, 8214, 8659], HDW: [0.6, 0, 0.778] },
    8660: d,
    8661: { dir: t.V, sizes: [1.044], stretch: [8657, 8214, 8659], HDW: [0.75, 0.25, 0.778] },
    8666: { dir: t.H, sizes: [1], stretch: [8666, 8801], HDW: [0.464, -0.036, 0.5] },
    8667: { dir: t.H, sizes: [1], stretch: [0, 8801, 8667], HDW: [0.464, -0.036, 0.5] },
    8722: m,
    8725: r,
    8730: { dir: t.V, sizes: e.VSIZES, stretch: [57345, 57344, 9143], fullExt: [0.65, 2.3], HDW: [0.85, 0.35, 1.056] },
    8739: p,
    8741: { dir: t.V, sizes: [1], stretch: [0, 8741], HDW: [0.627, 0.015, 0.556] },
    8968: { dir: t.V, sizes: e.VSIZES, stretch: [9121, 9122], HDW: e.HDW2 },
    8969: { dir: t.V, sizes: e.VSIZES, stretch: [9124, 9125], HDW: e.HDW2 },
    8970: { dir: t.V, sizes: e.VSIZES, stretch: [0, 9122, 9123], HDW: e.HDW2 },
    8971: { dir: t.V, sizes: e.VSIZES, stretch: [0, 9125, 9126], HDW: e.HDW2 },
    8978: v,
    8994: v,
    8995: H,
    9001: C,
    9002: w,
    9130: { dir: t.V, sizes: [0.32], stretch: [9130, 9130, 9130], HDW: [0.29, 0.015, 0.889] },
    9135: a,
    9136: { dir: t.V, sizes: [0.989], stretch: [9127, 9130, 9133], HDW: [0.75, 0.25, 0.889] },
    9137: { dir: t.V, sizes: [0.989], stretch: [9131, 9130, 9129], HDW: [0.75, 0.25, 0.889] },
    9140: { dir: t.H, stretch: [9484, 8722, 9488], HDW: e.HDW3, min: 1 },
    9141: { dir: t.H, stretch: [9492, 8722, 9496], HDW: e.HDW3, min: 1 },
    9168: { dir: t.V, sizes: [0.602, 1], schar: [0, 8739], variants: [1, 0], stretch: [0, 8739], HDW: [0.602, 0, 0.333] },
    9180: v,
    9181: H,
    9182: E,
    9183: M,
    9184: { dir: t.H, stretch: [714, 713, 715], HDW: [0.59, -0.544, 0.5], min: 1 },
    9185: { dir: t.H, stretch: [715, 713, 714], HDW: [0.59, -0.544, 0.5], min: 1 },
    9472: a,
    10072: p,
    10216: C,
    10217: w,
    10222: { dir: t.V, sizes: [0.989], stretch: [9127, 9130, 9129], HDW: [0.75, 0.25, 0.889] },
    10223: { dir: t.V, sizes: [0.989], stretch: [9131, 9130, 9133], HDW: [0.75, 0.25, 0.889] },
    10229: T,
    10230: s,
    10231: Q,
    10232: c,
    10233: f,
    10234: d,
    10235: u,
    10236: l,
    10237: S,
    10238: D,
    10502: S,
    10503: D,
    10574: { dir: t.H, stretch: [8636, 8722, 8640], HDW: e.HDW3, min: 2 },
    10575: { dir: t.V, stretch: [8638, 9168, 8642], HDW: e.HDW1, min: 1.776 },
    10576: { dir: t.H, stretch: [8637, 8722, 8641], HDW: e.HDW3, min: 2 },
    10577: { dir: t.V, stretch: [8639, 9168, 8643], HDW: e.HDW1, min: 0.5 },
    10586: { dir: t.H, stretch: [8636, 8722, 8739], HDW: e.HDW3, min: 1.278 },
    10587: { dir: t.H, stretch: [8739, 8722, 8640], HDW: e.HDW3, min: 1.278 },
    10588: { dir: t.V, stretch: [8638, 9168, 8869], HDW: e.HDW1, min: 1.556 },
    10589: { dir: t.V, stretch: [8868, 9168, 8642], HDW: e.HDW1, min: 1.556 },
    10590: { dir: t.H, stretch: [8637, 8722, 8739], HDW: e.HDW3, min: 1.278 },
    10591: { dir: t.H, stretch: [8739, 8722, 8641], HDW: e.HDW3, min: 1.278 },
    10592: { dir: t.V, stretch: [8639, 9168, 8869], HDW: e.HDW1, min: 1.776 },
    10593: { dir: t.V, stretch: [8868, 9168, 8643], HDW: e.HDW1, min: 1.776 },
    12296: C,
    12297: w,
    65079: E,
    65080: M
  };
})(ah);
var QE = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), TE = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(Mi, "__esModule", { value: !0 });
Mi.TeXFont = void 0;
var sE = s3, lE = wi, uE = Si, cE = Vi, fE = nh, dE = Ai, hE = ki, pE = Ri, mE = Pi, vE = Fi, LE = $i, yE = Wi, gE = zi, xE = Xi, HE = Ji, EE = ih, bE = oh, ME = to, wE = no, SE = oo, CE = Qo, VE = so, _E = uo, OE = fo, AE = po, DE = vo, kE = ah, IE = function(e) {
  QE(t, e);
  function t(r) {
    var n, i;
    r === void 0 && (r = null);
    var o = e.call(this, r) || this, a = o.constructor;
    try {
      for (var T = TE(Object.keys(a.variantCacheIds)), s = T.next(); !s.done; s = T.next()) {
        var Q = s.value;
        o.variant[Q].cacheID = "TEX-" + a.variantCacheIds[Q];
      }
    } catch (u) {
      n = { error: u };
    } finally {
      try {
        s && !s.done && (i = T.return) && i.call(T);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return o;
  }
  return t.defaultDelimiters = kE.delimiters, t.defaultChars = {
    normal: LE.normal,
    bold: cE.bold,
    italic: pE.italic,
    "bold-italic": uE.boldItalic,
    "double-struck": fE.doubleStruck,
    fraktur: hE.fraktur,
    "bold-fraktur": dE.frakturBold,
    script: bE.script,
    "bold-script": EE.scriptBold,
    "sans-serif": HE.sansSerif,
    "bold-sans-serif": gE.sansSerifBold,
    "sans-serif-italic": xE.sansSerifItalic,
    "sans-serif-bold-italic": yE.sansSerifBoldItalic,
    monospace: vE.monospace,
    "-smallop": ME.smallop,
    "-largeop": mE.largeop,
    "-size3": OE.texSize3,
    "-size4": AE.texSize4,
    "-tex-calligraphic": SE.texCalligraphic,
    "-tex-bold-calligraphic": wE.texCalligraphicBold,
    "-tex-mathit": CE.texMathit,
    "-tex-oldstyle": _E.texOldstyle,
    "-tex-bold-oldstyle": VE.texOldstyleBold,
    "-tex-variant": DE.texVariant
  }, t.variantCacheIds = {
    normal: "N",
    bold: "B",
    italic: "I",
    "bold-italic": "BI",
    "double-struck": "D",
    fraktur: "F",
    "bold-fraktur": "BF",
    script: "S",
    "bold-script": "BS",
    "sans-serif": "SS",
    "bold-sans-serif": "BSS",
    "sans-serif-italic": "SSI",
    "sans-serif-bold-italic": "SSBI",
    monospace: "M",
    "-smallop": "SO",
    "-largeop": "LO",
    "-size3": "S3",
    "-size4": "S4",
    "-tex-calligraphic": "C",
    "-tex-bold-calligraphic": "BC",
    "-tex-mathit": "MI",
    "-tex-oldstyle": "OS",
    "-tex-bold-oldstyle": "BOS",
    "-tex-variant": "V"
  }, t;
}((0, lE.CommonTeXFontMixin)(sE.SVGFontData));
Mi.TeXFont = IE;
var yo = {};
Object.defineProperty(yo, "__esModule", { value: !0 });
yo.FontCache = void 0;
var RE = function() {
  function e(t) {
    this.cache = /* @__PURE__ */ new Map(), this.defs = null, this.localID = "", this.nextID = 0, this.jax = t;
  }
  return e.prototype.cachePath = function(t, r, n) {
    var i = "MJX-" + this.localID + (this.jax.font.getVariant(t).cacheID || "") + "-" + r;
    return this.cache.has(i) || (this.cache.set(i, n), this.jax.adaptor.append(this.defs, this.jax.svg("path", { id: i, d: n }))), i;
  }, e.prototype.clearLocalID = function() {
    this.localID = "";
  }, e.prototype.useLocalID = function(t) {
    t === void 0 && (t = null), this.localID = (t ?? ++this.nextID) + (t === "" ? "" : "-");
  }, e.prototype.clearCache = function() {
    this.cache = /* @__PURE__ */ new Map(), this.defs = this.jax.svg("defs");
  }, e.prototype.getCache = function() {
    return this.defs;
  }, e;
}();
yo.FontCache = RE;
var nc;
function Qh() {
  return nc || (nc = 1, function(e) {
    var t = b && b.__extends || /* @__PURE__ */ function() {
      var l = function(c, f) {
        return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
          d.__proto__ = m;
        } || function(d, m) {
          for (var p in m)
            Object.prototype.hasOwnProperty.call(m, p) && (d[p] = m[p]);
        }, l(c, f);
      };
      return function(c, f) {
        if (typeof f != "function" && f !== null)
          throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
        l(c, f);
        function d() {
          this.constructor = c;
        }
        c.prototype = f === null ? Object.create(f) : (d.prototype = f.prototype, new d());
      };
    }(), r = b && b.__assign || function() {
      return r = Object.assign || function(l) {
        for (var c, f = 1, d = arguments.length; f < d; f++) {
          c = arguments[f];
          for (var m in c)
            Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
        }
        return l;
      }, r.apply(this, arguments);
    }, n = b && b.__read || function(l, c) {
      var f = typeof Symbol == "function" && l[Symbol.iterator];
      if (!f)
        return l;
      var d = f.call(l), m, p = [], v;
      try {
        for (; (c === void 0 || c-- > 0) && !(m = d.next()).done; )
          p.push(m.value);
      } catch (H) {
        v = { error: H };
      } finally {
        try {
          m && !m.done && (f = d.return) && f.call(d);
        } finally {
          if (v)
            throw v.error;
        }
      }
      return p;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SVG = e.XLINKNS = e.SVGNS = void 0;
    var i = ti, o = hH(), a = Mi, T = yo, s = Q3, Q = it;
    e.SVGNS = "http://www.w3.org/2000/svg", e.XLINKNS = "http://www.w3.org/1999/xlink";
    var u = function(l) {
      t(c, l);
      function c(f) {
        f === void 0 && (f = null);
        var d = l.call(this, f, o.SVGWrapperFactory, a.TeXFont) || this;
        return d.minwidth = 0, d.shift = 0, d.container = null, d.svgStyles = null, d.fontCache = new T.FontCache(d), d;
      }
      return c.prototype.initialize = function() {
        this.options.fontCache === "global" && this.fontCache.clearCache();
      }, c.prototype.clearFontCache = function() {
        this.fontCache.clearCache();
      }, c.prototype.reset = function() {
        this.clearFontCache();
      }, c.prototype.setScale = function(f) {
        this.options.scale !== 1 && this.adaptor.setStyle(f, "fontSize", (0, Q.percent)(this.options.scale));
      }, c.prototype.escaped = function(f, d) {
        return this.setDocument(d), this.html("span", {}, [this.text(f.math)]);
      }, c.prototype.styleSheet = function(f) {
        if (this.svgStyles)
          return this.svgStyles;
        var d = this.svgStyles = l.prototype.styleSheet.call(this, f);
        return this.adaptor.setAttribute(d, "id", c.STYLESHEETID), d;
      }, c.prototype.pageElements = function(f) {
        return this.options.fontCache === "global" && !this.findCache(f) ? this.svg("svg", { id: c.FONTCACHEID, style: { display: "none" } }, [this.fontCache.getCache()]) : null;
      }, c.prototype.findCache = function(f) {
        for (var d = this.adaptor, m = d.tags(d.body(f.document), "svg"), p = m.length - 1; p >= 0; p--)
          if (this.adaptor.getAttribute(m[p], "id") === c.FONTCACHEID)
            return !0;
        return !1;
      }, c.prototype.processMath = function(f, d) {
        var m = this.container;
        this.container = d;
        var p = this.factory.wrap(f), v = n(this.createRoot(p), 2), H = v[0], E = v[1];
        this.typesetSVG(p, H, E), this.container = m;
      }, c.prototype.createRoot = function(f) {
        var d = f.getOuterBBox(), m = d.w, p = d.h, v = d.d, H = d.pwidth, E = f.metrics.em / 1e3, M = Math.max(m, E), C = Math.max(p + v, E), w = this.svg("g", {
          stroke: "currentColor",
          fill: "currentColor",
          "stroke-width": 0,
          transform: "scale(1,-1)"
        }), S = this.adaptor, D = S.append(this.container, this.svg("svg", {
          xmlns: e.SVGNS,
          width: this.ex(M),
          height: this.ex(C),
          role: "img",
          focusable: !1,
          style: { "vertical-align": this.ex(-v) },
          viewBox: [0, this.fixed(-p * 1e3, 1), this.fixed(M * 1e3, 1), this.fixed(C * 1e3, 1)].join(" ")
        }, [w]));
        if (M === 1e-3 && (S.setAttribute(D, "preserveAspectRatio", "xMidYMid slice"), m < 0 && S.setStyle(this.container, "margin-right", this.ex(m))), H) {
          S.setStyle(D, "min-width", this.ex(M)), S.setAttribute(D, "width", H), S.removeAttribute(D, "viewBox");
          var k = this.fixed(f.metrics.ex / (this.font.params.x_height * 1e3), 6);
          S.setAttribute(w, "transform", "scale(".concat(k, ",-").concat(k, ") translate(0, ").concat(this.fixed(-p * 1e3, 1), ")"));
        }
        return this.options.fontCache !== "none" && S.setAttribute(D, "xmlns:xlink", e.XLINKNS), [D, w];
      }, c.prototype.typesetSVG = function(f, d, m) {
        var p = this.adaptor;
        if (this.minwidth = this.shift = 0, this.options.fontCache === "local" && (this.fontCache.clearCache(), this.fontCache.useLocalID(this.options.localID), p.insert(this.fontCache.getCache(), m)), f.toSVG(m), this.fontCache.clearLocalID(), this.minwidth)
          p.setStyle(d, "minWidth", this.ex(this.minwidth)), p.setStyle(this.container, "minWidth", this.ex(this.minwidth));
        else if (this.shift) {
          var v = p.getAttribute(this.container, "justify") || "center";
          this.setIndent(d, v, this.shift);
        }
      }, c.prototype.setIndent = function(f, d, m) {
        (d === "center" || d === "left") && this.adaptor.setStyle(f, "margin-left", this.ex(m)), (d === "center" || d === "right") && this.adaptor.setStyle(f, "margin-right", this.ex(-m));
      }, c.prototype.ex = function(f) {
        return f /= this.font.params.x_height, Math.abs(f) < 1e-3 ? "0" : f.toFixed(3).replace(/\.?0+$/, "") + "ex";
      }, c.prototype.svg = function(f, d, m) {
        return d === void 0 && (d = {}), m === void 0 && (m = []), this.html(f, d, m, e.SVGNS);
      }, c.prototype.unknownText = function(f, d) {
        var m = this.math.metrics, p = this.font.params.x_height / m.ex * m.em * 1e3, v = this.svg("text", {
          "data-variant": d,
          transform: "scale(1,-1)",
          "font-size": this.fixed(p, 1) + "px"
        }, [this.text(f)]), H = this.adaptor;
        if (d !== "-explicitFont") {
          var E = (0, s.unicodeChars)(f);
          if (E.length !== 1 || E[0] < 119808 || E[0] > 120831) {
            var M = n(this.font.getCssFont(d), 3), C = M[0], w = M[1], S = M[2];
            H.setAttribute(v, "font-family", C), w && H.setAttribute(v, "font-style", "italic"), S && H.setAttribute(v, "font-weight", "bold");
          }
        }
        return v;
      }, c.prototype.measureTextNode = function(f) {
        var d = this.adaptor;
        f = d.clone(f), d.removeAttribute(f, "transform");
        var m = this.fixed(this.font.params.x_height * 1e3, 1), p = this.svg("svg", {
          position: "absolute",
          visibility: "hidden",
          width: "1ex",
          height: "1ex",
          viewBox: [0, 0, m, m].join(" ")
        }, [f]);
        d.append(d.body(d.document), p);
        var v = d.nodeSize(f, 1e3, !0)[0];
        return d.remove(p), { w: v, h: 0.75, d: 0.2 };
      }, c.NAME = "SVG", c.OPTIONS = r(r({}, i.CommonOutputJax.OPTIONS), { internalSpeechTitles: !0, titleID: 0, fontCache: "local", localID: null }), c.commonStyles = {
        'mjx-container[jax="SVG"]': {
          direction: "ltr"
        },
        'mjx-container[jax="SVG"] > svg': {
          overflow: "visible",
          "min-height": "1px",
          "min-width": "1px"
        },
        'mjx-container[jax="SVG"] > svg a': {
          fill: "blue",
          stroke: "blue"
        }
      }, c.FONTCACHEID = "MJX-SVG-global-cache", c.STYLESHEETID = "MJX-SVG-styles", c;
    }(i.CommonOutputJax);
    e.SVG = u;
  }(lQ)), lQ;
}
var NE = Qh(), Is = {}, go = {}, xo = {}, wn = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(xo, "__esModule", { value: !0 });
xo.AbstractDOMAdaptor = void 0;
var PE = function() {
  function e(t) {
    t === void 0 && (t = null), this.document = t;
  }
  return e.prototype.node = function(t, r, n, i) {
    var o, a;
    r === void 0 && (r = {}), n === void 0 && (n = []);
    var T = this.create(t, i);
    this.setAttributes(T, r);
    try {
      for (var s = wn(n), Q = s.next(); !Q.done; Q = s.next()) {
        var u = Q.value;
        this.append(T, u);
      }
    } catch (l) {
      o = { error: l };
    } finally {
      try {
        Q && !Q.done && (a = s.return) && a.call(s);
      } finally {
        if (o)
          throw o.error;
      }
    }
    return T;
  }, e.prototype.setAttributes = function(t, r) {
    var n, i, o, a, T, s;
    if (r.style && typeof r.style != "string")
      try {
        for (var Q = wn(Object.keys(r.style)), u = Q.next(); !u.done; u = Q.next()) {
          var l = u.value;
          this.setStyle(t, l.replace(/-([a-z])/g, function(p, v) {
            return v.toUpperCase();
          }), r.style[l]);
        }
      } catch (p) {
        n = { error: p };
      } finally {
        try {
          u && !u.done && (i = Q.return) && i.call(Q);
        } finally {
          if (n)
            throw n.error;
        }
      }
    if (r.properties)
      try {
        for (var c = wn(Object.keys(r.properties)), f = c.next(); !f.done; f = c.next()) {
          var l = f.value;
          t[l] = r.properties[l];
        }
      } catch (p) {
        o = { error: p };
      } finally {
        try {
          f && !f.done && (a = c.return) && a.call(c);
        } finally {
          if (o)
            throw o.error;
        }
      }
    try {
      for (var d = wn(Object.keys(r)), m = d.next(); !m.done; m = d.next()) {
        var l = m.value;
        (l !== "style" || typeof r.style == "string") && l !== "properties" && this.setAttribute(t, l, r[l]);
      }
    } catch (p) {
      T = { error: p };
    } finally {
      try {
        m && !m.done && (s = d.return) && s.call(d);
      } finally {
        if (T)
          throw T.error;
      }
    }
  }, e.prototype.replace = function(t, r) {
    return this.insert(t, r), this.remove(r), r;
  }, e.prototype.childNode = function(t, r) {
    return this.childNodes(t)[r];
  }, e.prototype.allClasses = function(t) {
    var r = this.getAttribute(t, "class");
    return r ? r.replace(/  +/g, " ").replace(/^ /, "").replace(/ $/, "").split(/ /) : [];
  }, e;
}();
xo.AbstractDOMAdaptor = PE;
var BE = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ic = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(go, "__esModule", { value: !0 });
go.HTMLAdaptor = void 0;
var FE = xo, jE = function(e) {
  BE(t, e);
  function t(r) {
    var n = e.call(this, r.document) || this;
    return n.window = r, n.parser = new r.DOMParser(), n;
  }
  return t.prototype.parse = function(r, n) {
    return n === void 0 && (n = "text/html"), this.parser.parseFromString(r, n);
  }, t.prototype.create = function(r, n) {
    return n ? this.document.createElementNS(n, r) : this.document.createElement(r);
  }, t.prototype.text = function(r) {
    return this.document.createTextNode(r);
  }, t.prototype.head = function(r) {
    return r.head || r;
  }, t.prototype.body = function(r) {
    return r.body || r;
  }, t.prototype.root = function(r) {
    return r.documentElement || r;
  }, t.prototype.doctype = function(r) {
    return r.doctype ? "<!DOCTYPE ".concat(r.doctype.name, ">") : "";
  }, t.prototype.tags = function(r, n, i) {
    i === void 0 && (i = null);
    var o = i ? r.getElementsByTagNameNS(i, n) : r.getElementsByTagName(n);
    return Array.from(o);
  }, t.prototype.getElements = function(r, n) {
    var i, o, a = [];
    try {
      for (var T = ic(r), s = T.next(); !s.done; s = T.next()) {
        var Q = s.value;
        typeof Q == "string" ? a = a.concat(Array.from(this.document.querySelectorAll(Q))) : Array.isArray(Q) || Q instanceof this.window.NodeList || Q instanceof this.window.HTMLCollection ? a = a.concat(Array.from(Q)) : a.push(Q);
      }
    } catch (u) {
      i = { error: u };
    } finally {
      try {
        s && !s.done && (o = T.return) && o.call(T);
      } finally {
        if (i)
          throw i.error;
      }
    }
    return a;
  }, t.prototype.contains = function(r, n) {
    return r.contains(n);
  }, t.prototype.parent = function(r) {
    return r.parentNode;
  }, t.prototype.append = function(r, n) {
    return r.appendChild(n);
  }, t.prototype.insert = function(r, n) {
    return this.parent(n).insertBefore(r, n);
  }, t.prototype.remove = function(r) {
    return this.parent(r).removeChild(r);
  }, t.prototype.replace = function(r, n) {
    return this.parent(n).replaceChild(r, n);
  }, t.prototype.clone = function(r) {
    return r.cloneNode(!0);
  }, t.prototype.split = function(r, n) {
    return r.splitText(n);
  }, t.prototype.next = function(r) {
    return r.nextSibling;
  }, t.prototype.previous = function(r) {
    return r.previousSibling;
  }, t.prototype.firstChild = function(r) {
    return r.firstChild;
  }, t.prototype.lastChild = function(r) {
    return r.lastChild;
  }, t.prototype.childNodes = function(r) {
    return Array.from(r.childNodes);
  }, t.prototype.childNode = function(r, n) {
    return r.childNodes[n];
  }, t.prototype.kind = function(r) {
    var n = r.nodeType;
    return n === 1 || n === 3 || n === 8 ? r.nodeName.toLowerCase() : "";
  }, t.prototype.value = function(r) {
    return r.nodeValue || "";
  }, t.prototype.textContent = function(r) {
    return r.textContent;
  }, t.prototype.innerHTML = function(r) {
    return r.innerHTML;
  }, t.prototype.outerHTML = function(r) {
    return r.outerHTML;
  }, t.prototype.serializeXML = function(r) {
    var n = new this.window.XMLSerializer();
    return n.serializeToString(r);
  }, t.prototype.setAttribute = function(r, n, i, o) {
    return o === void 0 && (o = null), o ? (n = o.replace(/.*\//, "") + ":" + n.replace(/^.*:/, ""), r.setAttributeNS(o, n, i)) : r.setAttribute(n, i);
  }, t.prototype.getAttribute = function(r, n) {
    return r.getAttribute(n);
  }, t.prototype.removeAttribute = function(r, n) {
    return r.removeAttribute(n);
  }, t.prototype.hasAttribute = function(r, n) {
    return r.hasAttribute(n);
  }, t.prototype.allAttributes = function(r) {
    return Array.from(r.attributes).map(function(n) {
      return { name: n.name, value: n.value };
    });
  }, t.prototype.addClass = function(r, n) {
    r.classList ? r.classList.add(n) : r.className = (r.className + " " + n).trim();
  }, t.prototype.removeClass = function(r, n) {
    r.classList ? r.classList.remove(n) : r.className = r.className.split(/ /).filter(function(i) {
      return i !== n;
    }).join(" ");
  }, t.prototype.hasClass = function(r, n) {
    return r.classList ? r.classList.contains(n) : r.className.split(/ /).indexOf(n) >= 0;
  }, t.prototype.setStyle = function(r, n, i) {
    r.style[n] = i;
  }, t.prototype.getStyle = function(r, n) {
    return r.style[n];
  }, t.prototype.allStyles = function(r) {
    return r.style.cssText;
  }, t.prototype.insertRules = function(r, n) {
    var i, o;
    try {
      for (var a = ic(n.reverse()), T = a.next(); !T.done; T = a.next()) {
        var s = T.value;
        try {
          r.sheet.insertRule(s, 0);
        } catch (Q) {
          console.warn("MathJax: can't insert css rule '".concat(s, "': ").concat(Q.message));
        }
      }
    } catch (Q) {
      i = { error: Q };
    } finally {
      try {
        T && !T.done && (o = a.return) && o.call(a);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, t.prototype.fontSize = function(r) {
    var n = this.window.getComputedStyle(r);
    return parseFloat(n.fontSize);
  }, t.prototype.fontFamily = function(r) {
    var n = this.window.getComputedStyle(r);
    return n.fontFamily || "";
  }, t.prototype.nodeSize = function(r, n, i) {
    if (n === void 0 && (n = 1), i === void 0 && (i = !1), i && r.getBBox) {
      var o = r.getBBox(), a = o.width, T = o.height;
      return [a / n, T / n];
    }
    return [r.offsetWidth / n, r.offsetHeight / n];
  }, t.prototype.nodeBBox = function(r) {
    var n = r.getBoundingClientRect(), i = n.left, o = n.right, a = n.top, T = n.bottom;
    return { left: i, right: o, top: a, bottom: T };
  }, t;
}(FE.AbstractDOMAdaptor);
go.HTMLAdaptor = jE;
Object.defineProperty(Is, "__esModule", { value: !0 });
var Th = Is.browserAdaptor = void 0, $E = go;
function ZE() {
  return new $E.HTMLAdaptor(window);
}
Th = Is.browserAdaptor = ZE;
var Rs = {}, Ho = {}, Eo = {}, Ns = {}, u8 = {}, sh = {};
(function(e) {
  var t = b && b.__generator || function(T, s) {
    var Q = { label: 0, sent: function() {
      if (c[0] & 1)
        throw c[1];
      return c[1];
    }, trys: [], ops: [] }, u, l, c, f;
    return f = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
      return this;
    }), f;
    function d(p) {
      return function(v) {
        return m([p, v]);
      };
    }
    function m(p) {
      if (u)
        throw new TypeError("Generator is already executing.");
      for (; Q; )
        try {
          if (u = 1, l && (c = p[0] & 2 ? l.return : p[0] ? l.throw || ((c = l.return) && c.call(l), 0) : l.next) && !(c = c.call(l, p[1])).done)
            return c;
          switch (l = 0, c && (p = [p[0] & 2, c.value]), p[0]) {
            case 0:
            case 1:
              c = p;
              break;
            case 4:
              return Q.label++, { value: p[1], done: !1 };
            case 5:
              Q.label++, l = p[1], p = [0];
              continue;
            case 7:
              p = Q.ops.pop(), Q.trys.pop();
              continue;
            default:
              if (c = Q.trys, !(c = c.length > 0 && c[c.length - 1]) && (p[0] === 6 || p[0] === 2)) {
                Q = 0;
                continue;
              }
              if (p[0] === 3 && (!c || p[1] > c[0] && p[1] < c[3])) {
                Q.label = p[1];
                break;
              }
              if (p[0] === 6 && Q.label < c[1]) {
                Q.label = c[1], c = p;
                break;
              }
              if (c && Q.label < c[2]) {
                Q.label = c[2], Q.ops.push(p);
                break;
              }
              c[2] && Q.ops.pop(), Q.trys.pop();
              continue;
          }
          p = s.call(T, Q);
        } catch (v) {
          p = [6, v], l = 0;
        } finally {
          u = c = 0;
        }
      if (p[0] & 5)
        throw p[1];
      return { value: p[0] ? p[1] : void 0, done: !0 };
    }
  }, r = b && b.__read || function(T, s) {
    var Q = typeof Symbol == "function" && T[Symbol.iterator];
    if (!Q)
      return T;
    var u = Q.call(T), l, c = [], f;
    try {
      for (; (s === void 0 || s-- > 0) && !(l = u.next()).done; )
        c.push(l.value);
    } catch (d) {
      f = { error: d };
    } finally {
      try {
        l && !l.done && (Q = u.return) && Q.call(u);
      } finally {
        if (f)
          throw f.error;
      }
    }
    return c;
  }, n = b && b.__spreadArray || function(T, s, Q) {
    if (Q || arguments.length === 2)
      for (var u = 0, l = s.length, c; u < l; u++)
        (c || !(u in s)) && (c || (c = Array.prototype.slice.call(s, 0, u)), c[u] = s[u]);
    return T.concat(c || Array.prototype.slice.call(s));
  }, i = b && b.__values || function(T) {
    var s = typeof Symbol == "function" && Symbol.iterator, Q = s && T[s], u = 0;
    if (Q)
      return Q.call(T);
    if (T && typeof T.length == "number")
      return {
        next: function() {
          return T && u >= T.length && (T = void 0), { value: T && T[u++], done: !T };
        }
      };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.LinkedList = e.ListItem = e.END = void 0, e.END = Symbol();
  var o = /* @__PURE__ */ function() {
    function T(s) {
      s === void 0 && (s = null), this.next = null, this.prev = null, this.data = s;
    }
    return T;
  }();
  e.ListItem = o;
  var a = function() {
    function T() {
      for (var s = [], Q = 0; Q < arguments.length; Q++)
        s[Q] = arguments[Q];
      this.list = new o(e.END), this.list.next = this.list.prev = this.list, this.push.apply(this, n([], r(s), !1));
    }
    return T.prototype.isBefore = function(s, Q) {
      return s < Q;
    }, T.prototype.push = function() {
      for (var s, Q, u = [], l = 0; l < arguments.length; l++)
        u[l] = arguments[l];
      try {
        for (var c = i(u), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, m = new o(d);
          m.next = this.list, m.prev = this.list.prev, this.list.prev = m, m.prev.next = m;
        }
      } catch (p) {
        s = { error: p };
      } finally {
        try {
          f && !f.done && (Q = c.return) && Q.call(c);
        } finally {
          if (s)
            throw s.error;
        }
      }
      return this;
    }, T.prototype.pop = function() {
      var s = this.list.prev;
      return s.data === e.END ? null : (this.list.prev = s.prev, s.prev.next = this.list, s.next = s.prev = null, s.data);
    }, T.prototype.unshift = function() {
      for (var s, Q, u = [], l = 0; l < arguments.length; l++)
        u[l] = arguments[l];
      try {
        for (var c = i(u.slice(0).reverse()), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, m = new o(d);
          m.next = this.list.next, m.prev = this.list, this.list.next = m, m.next.prev = m;
        }
      } catch (p) {
        s = { error: p };
      } finally {
        try {
          f && !f.done && (Q = c.return) && Q.call(c);
        } finally {
          if (s)
            throw s.error;
        }
      }
      return this;
    }, T.prototype.shift = function() {
      var s = this.list.next;
      return s.data === e.END ? null : (this.list.next = s.next, s.next.prev = this.list, s.next = s.prev = null, s.data);
    }, T.prototype.remove = function() {
      for (var s, Q, u = [], l = 0; l < arguments.length; l++)
        u[l] = arguments[l];
      var c = /* @__PURE__ */ new Map();
      try {
        for (var f = i(u), d = f.next(); !d.done; d = f.next()) {
          var m = d.value;
          c.set(m, !0);
        }
      } catch (H) {
        s = { error: H };
      } finally {
        try {
          d && !d.done && (Q = f.return) && Q.call(f);
        } finally {
          if (s)
            throw s.error;
        }
      }
      for (var p = this.list.next; p.data !== e.END; ) {
        var v = p.next;
        c.has(p.data) && (p.prev.next = p.next, p.next.prev = p.prev, p.next = p.prev = null), p = v;
      }
    }, T.prototype.clear = function() {
      return this.list.next.prev = this.list.prev.next = null, this.list.next = this.list.prev = this.list, this;
    }, T.prototype[Symbol.iterator] = function() {
      var s;
      return t(this, function(Q) {
        switch (Q.label) {
          case 0:
            s = this.list.next, Q.label = 1;
          case 1:
            return s.data === e.END ? [3, 3] : [4, s.data];
          case 2:
            return Q.sent(), s = s.next, [3, 1];
          case 3:
            return [2];
        }
      });
    }, T.prototype.reversed = function() {
      var s;
      return t(this, function(Q) {
        switch (Q.label) {
          case 0:
            s = this.list.prev, Q.label = 1;
          case 1:
            return s.data === e.END ? [3, 3] : [4, s.data];
          case 2:
            return Q.sent(), s = s.prev, [3, 1];
          case 3:
            return [2];
        }
      });
    }, T.prototype.insert = function(s, Q) {
      Q === void 0 && (Q = null), Q === null && (Q = this.isBefore.bind(this));
      for (var u = new o(s), l = this.list.next; l.data !== e.END && Q(l.data, u.data); )
        l = l.next;
      return u.prev = l.prev, u.next = l, l.prev.next = l.prev = u, this;
    }, T.prototype.sort = function(s) {
      var Q, u;
      s === void 0 && (s = null), s === null && (s = this.isBefore.bind(this));
      var l = [];
      try {
        for (var c = i(this), f = c.next(); !f.done; f = c.next()) {
          var d = f.value;
          l.push(new T(d));
        }
      } catch (v) {
        Q = { error: v };
      } finally {
        try {
          f && !f.done && (u = c.return) && u.call(c);
        } finally {
          if (Q)
            throw Q.error;
        }
      }
      for (this.list.next = this.list.prev = this.list; l.length > 1; ) {
        var m = l.shift(), p = l.shift();
        m.merge(p, s), l.push(m);
      }
      return l.length && (this.list = l[0].list), this;
    }, T.prototype.merge = function(s, Q) {
      var u, l, c, f, d;
      Q === void 0 && (Q = null), Q === null && (Q = this.isBefore.bind(this));
      for (var m = this.list.next, p = s.list.next; m.data !== e.END && p.data !== e.END; )
        Q(p.data, m.data) ? (u = r([m, p], 2), p.prev.next = u[0], m.prev.next = u[1], l = r([m.prev, p.prev], 2), p.prev = l[0], m.prev = l[1], c = r([s.list, this.list], 2), this.list.prev.next = c[0], s.list.prev.next = c[1], f = r([s.list.prev, this.list.prev], 2), this.list.prev = f[0], s.list.prev = f[1], d = r([p.next, m], 2), m = d[0], p = d[1]) : m = m.next;
      return p.data !== e.END && (this.list.prev.next = s.list.next, s.list.next.prev = this.list.prev, s.list.prev.next = this.list, this.list.prev = s.list.prev, s.list.next = s.list.prev = s.list), this;
    }, T;
  }();
  e.LinkedList = a;
})(sh);
var WE = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(u8, "__esModule", { value: !0 });
u8.AbstractMathList = void 0;
var GE = sh, zE = function(e) {
  WE(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.isBefore = function(r, n) {
    return r.start.i < n.start.i || r.start.i === n.start.i && r.start.n < n.start.n;
  }, t;
}(GE.LinkedList);
u8.AbstractMathList = zE;
var bo = {}, Mo = {}, UE = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Mo, "__esModule", { value: !0 });
Mo.AbstractNodeFactory = void 0;
var XE = I0, qE = function(e) {
  UE(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.create = function(r, n, i) {
    return n === void 0 && (n = {}), i === void 0 && (i = []), this.node[r](n, i);
  }, t;
}(XE.AbstractFactory);
Mo.AbstractNodeFactory = qE;
var wo = {}, So = {}, JE = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), b9 = b && b.__assign || function() {
  return b9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, b9.apply(this, arguments);
};
Object.defineProperty(So, "__esModule", { value: !0 });
So.MmlMstyle = void 0;
var oc = T2, mr = k0, YE = function(e) {
  JE(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "mstyle";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "notParent", {
    get: function() {
      return this.childNodes[0] && this.childNodes[0].childNodes.length === 1;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    var a = this.attributes.getExplicit("scriptlevel");
    a != null && (a = a.toString(), a.match(/^\s*[-+]/) ? i += parseInt(a) : i = parseInt(a), o = !1);
    var T = this.attributes.getExplicit("displaystyle");
    T != null && (n = T === !0, o = !1);
    var s = this.attributes.getExplicit("data-cramped");
    s != null && (o = s), r = this.addInheritedAttributes(r, this.attributes.getAllAttributes()), this.childNodes[0].setInheritedAttributes(r, n, i, o);
  }, t.defaults = b9(b9({}, oc.AbstractMmlLayoutNode.defaults), { scriptlevel: mr.INHERIT, displaystyle: mr.INHERIT, scriptsizemultiplier: 1 / Math.sqrt(2), scriptminsize: "8px", mathbackground: mr.INHERIT, mathcolor: mr.INHERIT, dir: mr.INHERIT, infixlinebreakstyle: "before" }), t;
}(oc.AbstractMmlLayoutNode);
So.MmlMstyle = YE;
var Co = {}, KE = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), M9 = b && b.__assign || function() {
  return M9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, M9.apply(this, arguments);
};
Object.defineProperty(Co, "__esModule", { value: !0 });
Co.MmlMaligngroup = void 0;
var ac = T2, eb = k0, tb = function(e) {
  KE(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "maligngroup";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isSpacelike", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setChildInheritedAttributes = function(r, n, i, o) {
    r = this.addInheritedAttributes(r, this.attributes.getAllAttributes()), e.prototype.setChildInheritedAttributes.call(this, r, n, i, o);
  }, t.defaults = M9(M9({}, ac.AbstractMmlLayoutNode.defaults), { groupalign: eb.INHERIT }), t;
}(ac.AbstractMmlLayoutNode);
Co.MmlMaligngroup = tb;
var Vo = {}, rb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), w9 = b && b.__assign || function() {
  return w9 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, w9.apply(this, arguments);
};
Object.defineProperty(Vo, "__esModule", { value: !0 });
Vo.MmlMalignmark = void 0;
var Qc = T2, nb = function(e) {
  rb(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "malignmark";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isSpacelike", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaults = w9(w9({}, Qc.AbstractMmlNode.defaults), { edge: "left" }), t;
}(Qc.AbstractMmlNode);
Vo.MmlMalignmark = nb;
var _o = {}, ib = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), MT = b && b.__assign || function() {
  return MT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, MT.apply(this, arguments);
};
Object.defineProperty(_o, "__esModule", { value: !0 });
_o.MathChoice = void 0;
var Tc = T2, ob = function(e) {
  ib(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "kind", {
    get: function() {
      return "MathChoice";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "arity", {
    get: function() {
      return 4;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "notParent", {
    get: function() {
      return !0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.setInheritedAttributes = function(r, n, i, o) {
    var a = n ? 0 : Math.max(0, Math.min(i, 2)) + 1, T = this.childNodes[a] || this.factory.create("mrow");
    this.parent.replaceChild(T, this), T.setInheritedAttributes(r, n, i, o);
  }, t.defaults = MT({}, Tc.AbstractMmlBaseNode.defaults), t;
}(Tc.AbstractMmlBaseNode);
_o.MathChoice = ob;
var f2;
Object.defineProperty(wo, "__esModule", { value: !0 });
wo.MML = void 0;
var Sn = T2, sc = Gr, lc = zr, uc = Ur, cc = rt, fc = qr, dc = Yr, hc = Xr, Cn = Ue, pc = t8, mc = r8, vc = n8, Lc = So, yc = Jr, gc = Kr, xc = e8, Hc = i8, Ec = T8, bc = Q8, T0 = E6, s0 = e5, l0 = t5, Mc = o8, Vn = qe, wc = a8, Sc = Co, Cc = Vo, Vc = s8, u0 = r5, _c = l8, Oc = _o;
wo.MML = (f2 = {}, f2[sc.MmlMath.prototype.kind] = sc.MmlMath, f2[lc.MmlMi.prototype.kind] = lc.MmlMi, f2[uc.MmlMn.prototype.kind] = uc.MmlMn, f2[cc.MmlMo.prototype.kind] = cc.MmlMo, f2[fc.MmlMtext.prototype.kind] = fc.MmlMtext, f2[dc.MmlMspace.prototype.kind] = dc.MmlMspace, f2[hc.MmlMs.prototype.kind] = hc.MmlMs, f2[Cn.MmlMrow.prototype.kind] = Cn.MmlMrow, f2[Cn.MmlInferredMrow.prototype.kind] = Cn.MmlInferredMrow, f2[pc.MmlMfrac.prototype.kind] = pc.MmlMfrac, f2[mc.MmlMsqrt.prototype.kind] = mc.MmlMsqrt, f2[vc.MmlMroot.prototype.kind] = vc.MmlMroot, f2[Lc.MmlMstyle.prototype.kind] = Lc.MmlMstyle, f2[yc.MmlMerror.prototype.kind] = yc.MmlMerror, f2[gc.MmlMpadded.prototype.kind] = gc.MmlMpadded, f2[xc.MmlMphantom.prototype.kind] = xc.MmlMphantom, f2[Hc.MmlMfenced.prototype.kind] = Hc.MmlMfenced, f2[Ec.MmlMenclose.prototype.kind] = Ec.MmlMenclose, f2[bc.MmlMaction.prototype.kind] = bc.MmlMaction, f2[T0.MmlMsub.prototype.kind] = T0.MmlMsub, f2[T0.MmlMsup.prototype.kind] = T0.MmlMsup, f2[T0.MmlMsubsup.prototype.kind] = T0.MmlMsubsup, f2[s0.MmlMunder.prototype.kind] = s0.MmlMunder, f2[s0.MmlMover.prototype.kind] = s0.MmlMover, f2[s0.MmlMunderover.prototype.kind] = s0.MmlMunderover, f2[l0.MmlMmultiscripts.prototype.kind] = l0.MmlMmultiscripts, f2[l0.MmlMprescripts.prototype.kind] = l0.MmlMprescripts, f2[l0.MmlNone.prototype.kind] = l0.MmlNone, f2[Mc.MmlMtable.prototype.kind] = Mc.MmlMtable, f2[Vn.MmlMlabeledtr.prototype.kind] = Vn.MmlMlabeledtr, f2[Vn.MmlMtr.prototype.kind] = Vn.MmlMtr, f2[wc.MmlMtd.prototype.kind] = wc.MmlMtd, f2[Sc.MmlMaligngroup.prototype.kind] = Sc.MmlMaligngroup, f2[Cc.MmlMalignmark.prototype.kind] = Cc.MmlMalignmark, f2[Vc.MmlMglyph.prototype.kind] = Vc.MmlMglyph, f2[u0.MmlSemantics.prototype.kind] = u0.MmlSemantics, f2[u0.MmlAnnotation.prototype.kind] = u0.MmlAnnotation, f2[u0.MmlAnnotationXML.prototype.kind] = u0.MmlAnnotationXML, f2[_c.TeXAtom.prototype.kind] = _c.TeXAtom, f2[Oc.MathChoice.prototype.kind] = Oc.MathChoice, f2[Sn.TextNode.prototype.kind] = Sn.TextNode, f2[Sn.XMLNode.prototype.kind] = Sn.XMLNode, f2);
var ab = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(bo, "__esModule", { value: !0 });
bo.MmlFactory = void 0;
var Qb = Mo, Tb = wo, sb = function(e) {
  ab(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Object.defineProperty(t.prototype, "MML", {
    get: function() {
      return this.node;
    },
    enumerable: !1,
    configurable: !0
  }), t.defaultNodes = Tb.MML, t;
}(Qb.AbstractNodeFactory);
bo.MmlFactory = sb;
var O0 = {}, lb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ub = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, cb = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, fb = b && b.__spreadArray || function(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(O0, "__esModule", { value: !0 });
O0.BitFieldClass = O0.BitField = void 0;
var lh = function() {
  function e() {
    this.bits = 0;
  }
  return e.allocate = function() {
    for (var t, r, n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    try {
      for (var o = ub(n), a = o.next(); !a.done; a = o.next()) {
        var T = a.value;
        if (this.has(T))
          throw new Error("Bit already allocated for " + T);
        if (this.next === e.MAXBIT)
          throw new Error("Maximum number of bits already allocated");
        this.names.set(T, this.next), this.next <<= 1;
      }
    } catch (s) {
      t = { error: s };
    } finally {
      try {
        a && !a.done && (r = o.return) && r.call(o);
      } finally {
        if (t)
          throw t.error;
      }
    }
  }, e.has = function(t) {
    return this.names.has(t);
  }, e.prototype.set = function(t) {
    this.bits |= this.getBit(t);
  }, e.prototype.clear = function(t) {
    this.bits &= ~this.getBit(t);
  }, e.prototype.isSet = function(t) {
    return !!(this.bits & this.getBit(t));
  }, e.prototype.reset = function() {
    this.bits = 0;
  }, e.prototype.getBit = function(t) {
    var r = this.constructor.names.get(t);
    if (!r)
      throw new Error("Unknown bit-field name: " + t);
    return r;
  }, e.MAXBIT = 1 << 31, e.next = 1, e.names = /* @__PURE__ */ new Map(), e;
}();
O0.BitField = lh;
function db() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = function(n) {
    lb(i, n);
    function i() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return i;
  }(lh);
  return r.allocate.apply(r, fb([], cb(e), !1)), r;
}
O0.BitFieldClass = db;
(function(e) {
  var t = b && b.__extends || /* @__PURE__ */ function() {
    var E = function(M, C) {
      return E = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, S) {
        w.__proto__ = S;
      } || function(w, S) {
        for (var D in S)
          Object.prototype.hasOwnProperty.call(S, D) && (w[D] = S[D]);
      }, E(M, C);
    };
    return function(M, C) {
      if (typeof C != "function" && C !== null)
        throw new TypeError("Class extends value " + String(C) + " is not a constructor or null");
      E(M, C);
      function w() {
        this.constructor = M;
      }
      M.prototype = C === null ? Object.create(C) : (w.prototype = C.prototype, new w());
    };
  }(), r = b && b.__values || function(E) {
    var M = typeof Symbol == "function" && Symbol.iterator, C = M && E[M], w = 0;
    if (C)
      return C.call(E);
    if (E && typeof E.length == "number")
      return {
        next: function() {
          return E && w >= E.length && (E = void 0), { value: E && E[w++], done: !E };
        }
      };
    throw new TypeError(M ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, n = b && b.__read || function(E, M) {
    var C = typeof Symbol == "function" && E[Symbol.iterator];
    if (!C)
      return E;
    var w = C.call(E), S, D = [], k;
    try {
      for (; (M === void 0 || M-- > 0) && !(S = w.next()).done; )
        D.push(S.value);
    } catch ($) {
      k = { error: $ };
    } finally {
      try {
        S && !S.done && (C = w.return) && C.call(w);
      } finally {
        if (k)
          throw k.error;
      }
    }
    return D;
  }, i = b && b.__spreadArray || function(E, M, C) {
    if (C || arguments.length === 2)
      for (var w = 0, S = M.length, D; w < S; w++)
        (D || !(w in M)) && (D || (D = Array.prototype.slice.call(M, 0, w)), D[w] = M[w]);
    return E.concat(D || Array.prototype.slice.call(M));
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AbstractMathDocument = e.resetAllOptions = e.resetOptions = e.RenderList = void 0;
  var o = r4, a = D0, T = Zr, s = u8, Q = tt, u = bo, l = O0, c = F5, f = function(E) {
    t(M, E);
    function M() {
      return E !== null && E.apply(this, arguments) || this;
    }
    return M.create = function(C) {
      var w, S, D = new this();
      try {
        for (var k = r(Object.keys(C)), $ = k.next(); !$.done; $ = k.next()) {
          var z = $.value, j = n(this.action(z, C[z]), 2), J = j[0], i1 = j[1];
          i1 && D.add(J, i1);
        }
      } catch (t1) {
        w = { error: t1 };
      } finally {
        try {
          $ && !$.done && (S = k.return) && S.call(k);
        } finally {
          if (w)
            throw w.error;
        }
      }
      return D;
    }, M.action = function(C, w) {
      var S, D, k, $, z, j, J = !0, i1 = w[0];
      if (w.length === 1 || typeof w[1] == "boolean")
        w.length === 2 && (J = w[1]), S = n(this.methodActions(C), 2), z = S[0], j = S[1];
      else if (typeof w[1] == "string")
        if (typeof w[2] == "string") {
          w.length === 4 && (J = w[3]);
          var t1 = n(w.slice(1), 2), T1 = t1[0], X = t1[1];
          D = n(this.methodActions(T1, X), 2), z = D[0], j = D[1];
        } else
          w.length === 3 && (J = w[2]), k = n(this.methodActions(w[1]), 2), z = k[0], j = k[1];
      else
        w.length === 4 && (J = w[3]), $ = n(w.slice(1), 2), z = $[0], j = $[1];
      return [{ id: C, renderDoc: z, renderMath: j, convert: J }, i1];
    }, M.methodActions = function(C, w) {
      return w === void 0 && (w = C), [
        function(S) {
          return C && S[C](), !1;
        },
        function(S, D) {
          return w && S[w](D), !1;
        }
      ];
    }, M.prototype.renderDoc = function(C, w) {
      var S, D;
      w === void 0 && (w = Q.STATE.UNPROCESSED);
      try {
        for (var k = r(this.items), $ = k.next(); !$.done; $ = k.next()) {
          var z = $.value;
          if (z.priority >= w && z.item.renderDoc(C))
            return;
        }
      } catch (j) {
        S = { error: j };
      } finally {
        try {
          $ && !$.done && (D = k.return) && D.call(k);
        } finally {
          if (S)
            throw S.error;
        }
      }
    }, M.prototype.renderMath = function(C, w, S) {
      var D, k;
      S === void 0 && (S = Q.STATE.UNPROCESSED);
      try {
        for (var $ = r(this.items), z = $.next(); !z.done; z = $.next()) {
          var j = z.value;
          if (j.priority >= S && j.item.renderMath(C, w))
            return;
        }
      } catch (J) {
        D = { error: J };
      } finally {
        try {
          z && !z.done && (k = $.return) && k.call($);
        } finally {
          if (D)
            throw D.error;
        }
      }
    }, M.prototype.renderConvert = function(C, w, S) {
      var D, k;
      S === void 0 && (S = Q.STATE.LAST);
      try {
        for (var $ = r(this.items), z = $.next(); !z.done; z = $.next()) {
          var j = z.value;
          if (j.priority > S || j.item.convert && j.item.renderMath(C, w))
            return;
        }
      } catch (J) {
        D = { error: J };
      } finally {
        try {
          z && !z.done && (k = $.return) && k.call($);
        } finally {
          if (D)
            throw D.error;
        }
      }
    }, M.prototype.findID = function(C) {
      var w, S;
      try {
        for (var D = r(this.items), k = D.next(); !k.done; k = D.next()) {
          var $ = k.value;
          if ($.item.id === C)
            return $.item;
        }
      } catch (z) {
        w = { error: z };
      } finally {
        try {
          k && !k.done && (S = D.return) && S.call(D);
        } finally {
          if (w)
            throw w.error;
        }
      }
      return null;
    }, M;
  }(c.PrioritizedList);
  e.RenderList = f, e.resetOptions = {
    all: !1,
    processed: !1,
    inputJax: null,
    outputJax: null
  }, e.resetAllOptions = {
    all: !0,
    processed: !0,
    inputJax: [],
    outputJax: []
  };
  var d = function(E) {
    t(M, E);
    function M() {
      return E !== null && E.apply(this, arguments) || this;
    }
    return M.prototype.compile = function(C) {
      return null;
    }, M;
  }(a.AbstractInputJax), m = function(E) {
    t(M, E);
    function M() {
      return E !== null && E.apply(this, arguments) || this;
    }
    return M.prototype.typeset = function(C, w) {
      return null;
    }, M.prototype.escaped = function(C, w) {
      return null;
    }, M;
  }(T.AbstractOutputJax), p = function(E) {
    t(M, E);
    function M() {
      return E !== null && E.apply(this, arguments) || this;
    }
    return M;
  }(s.AbstractMathList), v = function(E) {
    t(M, E);
    function M() {
      return E !== null && E.apply(this, arguments) || this;
    }
    return M;
  }(Q.AbstractMathItem), H = function() {
    function E(M, C, w) {
      var S = this, D = this.constructor;
      this.document = M, this.options = (0, o.userOptions)((0, o.defaultOptions)({}, D.OPTIONS), w), this.math = new (this.options.MathList || p)(), this.renderActions = f.create(this.options.renderActions), this.processed = new E.ProcessBits(), this.outputJax = this.options.OutputJax || new m();
      var k = this.options.InputJax || [new d()];
      Array.isArray(k) || (k = [k]), this.inputJax = k, this.adaptor = C, this.outputJax.setAdaptor(C), this.inputJax.map(function($) {
        return $.setAdaptor(C);
      }), this.mmlFactory = this.options.MmlFactory || new u.MmlFactory(), this.inputJax.map(function($) {
        return $.setMmlFactory(S.mmlFactory);
      }), this.outputJax.initialize(), this.inputJax.map(function($) {
        return $.initialize();
      });
    }
    return Object.defineProperty(E.prototype, "kind", {
      get: function() {
        return this.constructor.KIND;
      },
      enumerable: !1,
      configurable: !0
    }), E.prototype.addRenderAction = function(M) {
      for (var C = [], w = 1; w < arguments.length; w++)
        C[w - 1] = arguments[w];
      var S = n(f.action(M, C), 2), D = S[0], k = S[1];
      this.renderActions.add(D, k);
    }, E.prototype.removeRenderAction = function(M) {
      var C = this.renderActions.findID(M);
      C && this.renderActions.remove(C);
    }, E.prototype.render = function() {
      return this.renderActions.renderDoc(this), this;
    }, E.prototype.rerender = function(M) {
      return M === void 0 && (M = Q.STATE.RERENDER), this.state(M - 1), this.render(), this;
    }, E.prototype.convert = function(M, C) {
      C === void 0 && (C = {});
      var w = (0, o.userOptions)({
        format: this.inputJax[0].name,
        display: !0,
        end: Q.STATE.LAST,
        em: 16,
        ex: 8,
        containerWidth: null,
        lineWidth: 1e6,
        scale: 1,
        family: ""
      }, C), S = w.format, D = w.display, k = w.end, $ = w.ex, z = w.em, j = w.containerWidth, J = w.lineWidth, i1 = w.scale, t1 = w.family;
      j === null && (j = 80 * $);
      var T1 = this.inputJax.reduce(function(f1, s1) {
        return s1.name === S ? s1 : f1;
      }, null), X = new this.options.MathItem(M, T1, D);
      return X.start.node = this.adaptor.body(this.document), X.setMetrics(z, $, j, J, i1), this.outputJax.options.mtextInheritFont && (X.outputData.mtextFamily = t1), this.outputJax.options.merrorInheritFont && (X.outputData.merrorFamily = t1), X.convert(this, k), X.typesetRoot || X.root;
    }, E.prototype.findMath = function(M) {
      return this.processed.set("findMath"), this;
    }, E.prototype.compile = function() {
      var M, C, w, S;
      if (!this.processed.isSet("compile")) {
        var D = [];
        try {
          for (var k = r(this.math), $ = k.next(); !$.done; $ = k.next()) {
            var z = $.value;
            this.compileMath(z), z.inputData.recompile !== void 0 && D.push(z);
          }
        } catch (t1) {
          M = { error: t1 };
        } finally {
          try {
            $ && !$.done && (C = k.return) && C.call(k);
          } finally {
            if (M)
              throw M.error;
          }
        }
        try {
          for (var j = r(D), J = j.next(); !J.done; J = j.next()) {
            var z = J.value, i1 = z.inputData.recompile;
            z.state(i1.state), z.inputData.recompile = i1, this.compileMath(z);
          }
        } catch (t1) {
          w = { error: t1 };
        } finally {
          try {
            J && !J.done && (S = j.return) && S.call(j);
          } finally {
            if (w)
              throw w.error;
          }
        }
        this.processed.set("compile");
      }
      return this;
    }, E.prototype.compileMath = function(M) {
      try {
        M.compile(this);
      } catch (C) {
        if (C.retry || C.restart)
          throw C;
        this.options.compileError(this, M, C), M.inputData.error = C;
      }
    }, E.prototype.compileError = function(M, C) {
      M.root = this.mmlFactory.create("math", null, [
        this.mmlFactory.create("merror", { "data-mjx-error": C.message, title: C.message }, [
          this.mmlFactory.create("mtext", null, [
            this.mmlFactory.create("text").setText("Math input error")
          ])
        ])
      ]), M.display && M.root.attributes.set("display", "block"), M.inputData.error = C.message;
    }, E.prototype.typeset = function() {
      var M, C;
      if (!this.processed.isSet("typeset")) {
        try {
          for (var w = r(this.math), S = w.next(); !S.done; S = w.next()) {
            var D = S.value;
            try {
              D.typeset(this);
            } catch (k) {
              if (k.retry || k.restart)
                throw k;
              this.options.typesetError(this, D, k), D.outputData.error = k;
            }
          }
        } catch (k) {
          M = { error: k };
        } finally {
          try {
            S && !S.done && (C = w.return) && C.call(w);
          } finally {
            if (M)
              throw M.error;
          }
        }
        this.processed.set("typeset");
      }
      return this;
    }, E.prototype.typesetError = function(M, C) {
      M.typesetRoot = this.adaptor.node("mjx-container", {
        class: "MathJax mjx-output-error",
        jax: this.outputJax.name
      }, [
        this.adaptor.node("span", {
          "data-mjx-error": C.message,
          title: C.message,
          style: {
            color: "red",
            "background-color": "yellow",
            "line-height": "normal"
          }
        }, [
          this.adaptor.text("Math output error")
        ])
      ]), M.display && this.adaptor.setAttributes(M.typesetRoot, {
        style: {
          display: "block",
          margin: "1em 0",
          "text-align": "center"
        }
      }), M.outputData.error = C.message;
    }, E.prototype.getMetrics = function() {
      return this.processed.isSet("getMetrics") || (this.outputJax.getMetrics(this), this.processed.set("getMetrics")), this;
    }, E.prototype.updateDocument = function() {
      var M, C;
      if (!this.processed.isSet("updateDocument")) {
        try {
          for (var w = r(this.math.reversed()), S = w.next(); !S.done; S = w.next()) {
            var D = S.value;
            D.updateDocument(this);
          }
        } catch (k) {
          M = { error: k };
        } finally {
          try {
            S && !S.done && (C = w.return) && C.call(w);
          } finally {
            if (M)
              throw M.error;
          }
        }
        this.processed.set("updateDocument");
      }
      return this;
    }, E.prototype.removeFromDocument = function(M) {
      return this;
    }, E.prototype.state = function(M, C) {
      var w, S;
      C === void 0 && (C = !1);
      try {
        for (var D = r(this.math), k = D.next(); !k.done; k = D.next()) {
          var $ = k.value;
          $.state(M, C);
        }
      } catch (z) {
        w = { error: z };
      } finally {
        try {
          k && !k.done && (S = D.return) && S.call(D);
        } finally {
          if (w)
            throw w.error;
        }
      }
      return M < Q.STATE.INSERTED && this.processed.clear("updateDocument"), M < Q.STATE.TYPESET && (this.processed.clear("typeset"), this.processed.clear("getMetrics")), M < Q.STATE.COMPILED && this.processed.clear("compile"), this;
    }, E.prototype.reset = function(M) {
      var C;
      return M === void 0 && (M = { processed: !0 }), M = (0, o.userOptions)(Object.assign({}, e.resetOptions), M), M.all && Object.assign(M, e.resetAllOptions), M.processed && this.processed.reset(), M.inputJax && this.inputJax.forEach(function(w) {
        return w.reset.apply(w, i([], n(M.inputJax), !1));
      }), M.outputJax && (C = this.outputJax).reset.apply(C, i([], n(M.outputJax), !1)), this;
    }, E.prototype.clear = function() {
      return this.reset(), this.math.clear(), this;
    }, E.prototype.concat = function(M) {
      return this.math.merge(M), this;
    }, E.prototype.clearMathItemsWithin = function(M) {
      var C, w = this.getMathItemsWithin(M);
      return (C = this.math).remove.apply(C, i([], n(w), !1)), w;
    }, E.prototype.getMathItemsWithin = function(M) {
      var C, w, S, D;
      Array.isArray(M) || (M = [M]);
      var k = this.adaptor, $ = [], z = k.getElements(M, this.document);
      try {
        e:
          for (var j = r(this.math), J = j.next(); !J.done; J = j.next()) {
            var i1 = J.value;
            try {
              for (var t1 = (S = void 0, r(z)), T1 = t1.next(); !T1.done; T1 = t1.next()) {
                var X = T1.value;
                if (i1.start.node && k.contains(X, i1.start.node)) {
                  $.push(i1);
                  continue e;
                }
              }
            } catch (f1) {
              S = { error: f1 };
            } finally {
              try {
                T1 && !T1.done && (D = t1.return) && D.call(t1);
              } finally {
                if (S)
                  throw S.error;
              }
            }
          }
      } catch (f1) {
        C = { error: f1 };
      } finally {
        try {
          J && !J.done && (w = j.return) && w.call(j);
        } finally {
          if (C)
            throw C.error;
        }
      }
      return $;
    }, E.KIND = "MathDocument", E.OPTIONS = {
      OutputJax: null,
      InputJax: null,
      MmlFactory: null,
      MathList: p,
      MathItem: v,
      compileError: function(M, C, w) {
        M.compileError(C, w);
      },
      typesetError: function(M, C, w) {
        M.typesetError(C, w);
      },
      renderActions: (0, o.expandable)({
        find: [Q.STATE.FINDMATH, "findMath", "", !1],
        compile: [Q.STATE.COMPILED],
        metrics: [Q.STATE.METRICS, "getMetrics", "", !1],
        typeset: [Q.STATE.TYPESET],
        update: [Q.STATE.INSERTED, "updateDocument", !1]
      })
    }, E.ProcessBits = (0, l.BitFieldClass)("findMath", "compile", "getMetrics", "typeset", "updateDocument"), E;
  }();
  e.AbstractMathDocument = H;
})(Ns);
var hb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Eo, "__esModule", { value: !0 });
Eo.AbstractHandler = void 0;
var pb = Ns, mb = function(e) {
  hb(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t;
}(pb.AbstractMathDocument), vb = function() {
  function e(t, r) {
    r === void 0 && (r = 5), this.documentClass = mb, this.adaptor = t, this.priority = r;
  }
  return Object.defineProperty(e.prototype, "name", {
    get: function() {
      return this.constructor.NAME;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.handlesDocument = function(t) {
    return !1;
  }, e.prototype.create = function(t, r) {
    return new this.documentClass(t, this.adaptor, r);
  }, e.NAME = "generic", e;
}();
Eo.AbstractHandler = vb;
var Oo = {}, Ao = {}, Lb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Ao, "__esModule", { value: !0 });
Ao.HTMLMathItem = void 0;
var _n = tt, yb = function(e) {
  Lb(t, e);
  function t(r, n, i, o, a) {
    return i === void 0 && (i = !0), o === void 0 && (o = { node: null, n: 0, delim: "" }), a === void 0 && (a = { node: null, n: 0, delim: "" }), e.call(this, r, n, i, o, a) || this;
  }
  return Object.defineProperty(t.prototype, "adaptor", {
    get: function() {
      return this.inputJax.adaptor;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.updateDocument = function(r) {
    if (this.state() < _n.STATE.INSERTED) {
      if (this.inputJax.processStrings) {
        var n = this.start.node;
        if (n === this.end.node)
          this.end.n && this.end.n < this.adaptor.value(this.end.node).length && this.adaptor.split(this.end.node, this.end.n), this.start.n && (n = this.adaptor.split(this.start.node, this.start.n)), this.adaptor.replace(this.typesetRoot, n);
        else {
          for (this.start.n && (n = this.adaptor.split(n, this.start.n)); n !== this.end.node; ) {
            var i = this.adaptor.next(n);
            this.adaptor.remove(n), n = i;
          }
          this.adaptor.insert(this.typesetRoot, n), this.end.n < this.adaptor.value(n).length && this.adaptor.split(n, this.end.n), this.adaptor.remove(n);
        }
      } else
        this.adaptor.replace(this.typesetRoot, this.start.node);
      this.start.node = this.end.node = this.typesetRoot, this.start.n = this.end.n = 0, this.state(_n.STATE.INSERTED);
    }
  }, t.prototype.updateStyleSheet = function(r) {
    r.addStyleSheet();
  }, t.prototype.removeFromDocument = function(r) {
    if (r === void 0 && (r = !1), this.state() >= _n.STATE.TYPESET) {
      var n = this.adaptor, i = this.start.node, o = n.text("");
      if (r) {
        var a = this.start.delim + this.math + this.end.delim;
        if (this.inputJax.processStrings)
          o = n.text(a);
        else {
          var T = n.parse(a, "text/html");
          o = n.firstChild(n.body(T));
        }
      }
      n.parent(i) && n.replace(o, i), this.start.node = this.end.node = o, this.start.n = this.end.n = 0;
    }
  }, t;
}(_n.AbstractMathItem);
Ao.HTMLMathItem = yb;
var Do = {}, gb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Do, "__esModule", { value: !0 });
Do.HTMLMathList = void 0;
var xb = u8, Hb = function(e) {
  gb(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t;
}(xb.AbstractMathList);
Do.HTMLMathList = Hb;
var ko = {}, Ac = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
};
Object.defineProperty(ko, "__esModule", { value: !0 });
ko.HTMLDomStrings = void 0;
var vr = r4, Eb = function() {
  function e(t) {
    t === void 0 && (t = null);
    var r = this.constructor;
    this.options = (0, vr.userOptions)((0, vr.defaultOptions)({}, r.OPTIONS), t), this.init(), this.getPatterns();
  }
  return e.prototype.init = function() {
    this.strings = [], this.string = "", this.snodes = [], this.nodes = [], this.stack = [];
  }, e.prototype.getPatterns = function() {
    var t = (0, vr.makeArray)(this.options.skipHtmlTags), r = (0, vr.makeArray)(this.options.ignoreHtmlClass), n = (0, vr.makeArray)(this.options.processHtmlClass);
    this.skipHtmlTags = new RegExp("^(?:" + t.join("|") + ")$", "i"), this.ignoreHtmlClass = new RegExp("(?:^| )(?:" + r.join("|") + ")(?: |$)"), this.processHtmlClass = new RegExp("(?:^| )(?:" + n + ")(?: |$)");
  }, e.prototype.pushString = function() {
    this.string.match(/\S/) && (this.strings.push(this.string), this.nodes.push(this.snodes)), this.string = "", this.snodes = [];
  }, e.prototype.extendString = function(t, r) {
    this.snodes.push([t, r.length]), this.string += r;
  }, e.prototype.handleText = function(t, r) {
    return r || this.extendString(t, this.adaptor.value(t)), this.adaptor.next(t);
  }, e.prototype.handleTag = function(t, r) {
    if (!r) {
      var n = this.options.includeHtmlTags[this.adaptor.kind(t)];
      this.extendString(t, n);
    }
    return this.adaptor.next(t);
  }, e.prototype.handleContainer = function(t, r) {
    this.pushString();
    var n = this.adaptor.getAttribute(t, "class") || "", i = this.adaptor.kind(t) || "", o = this.processHtmlClass.exec(n), a = t;
    return this.adaptor.firstChild(t) && !this.adaptor.getAttribute(t, "data-MJX") && (o || !this.skipHtmlTags.exec(i)) ? (this.adaptor.next(t) && this.stack.push([this.adaptor.next(t), r]), a = this.adaptor.firstChild(t), r = (r || this.ignoreHtmlClass.exec(n)) && !o) : a = this.adaptor.next(t), [a, r];
  }, e.prototype.handleOther = function(t, r) {
    return this.pushString(), this.adaptor.next(t);
  }, e.prototype.find = function(t) {
    var r, n;
    this.init();
    for (var i = this.adaptor.next(t), o = !1, a = this.options.includeHtmlTags; t && t !== i; ) {
      var T = this.adaptor.kind(t);
      T === "#text" ? t = this.handleText(t, o) : a.hasOwnProperty(T) ? t = this.handleTag(t, o) : T ? (r = Ac(this.handleContainer(t, o), 2), t = r[0], o = r[1]) : t = this.handleOther(t, o), !t && this.stack.length && (this.pushString(), n = Ac(this.stack.pop(), 2), t = n[0], o = n[1]);
    }
    this.pushString();
    var s = [this.strings, this.nodes];
    return this.init(), s;
  }, e.OPTIONS = {
    skipHtmlTags: ["script", "noscript", "style", "textarea", "pre", "code", "annotation", "annotation-xml"],
    includeHtmlTags: { br: `
`, wbr: "", "#comment": "" },
    ignoreHtmlClass: "mathjax_ignore",
    processHtmlClass: "mathjax_process"
  }, e;
}();
ko.HTMLDomStrings = Eb;
var bb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), p0 = b && b.__assign || function() {
  return p0 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, p0.apply(this, arguments);
}, On = b && b.__read || function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (T) {
    a = { error: T };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, _e = b && b.__values || function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(Oo, "__esModule", { value: !0 });
Oo.HTMLDocument = void 0;
var _Q = Ns, OQ = r4, Mb = Ao, wb = Do, Dc = ko, AQ = tt, Sb = function(e) {
  bb(t, e);
  function t(r, n, i) {
    var o = this, a = On((0, OQ.separateOptions)(i, Dc.HTMLDomStrings.OPTIONS), 2), T = a[0], s = a[1];
    return o = e.call(this, r, n, T) || this, o.domStrings = o.options.DomStrings || new Dc.HTMLDomStrings(s), o.domStrings.adaptor = n, o.styles = [], o;
  }
  return t.prototype.findPosition = function(r, n, i, o) {
    var a, T, s = this.adaptor;
    try {
      for (var Q = _e(o[r]), u = Q.next(); !u.done; u = Q.next()) {
        var l = u.value, c = On(l, 2), f = c[0], d = c[1];
        if (n <= d && s.kind(f) === "#text")
          return { node: f, n: Math.max(n, 0), delim: i };
        n -= d;
      }
    } catch (m) {
      a = { error: m };
    } finally {
      try {
        u && !u.done && (T = Q.return) && T.call(Q);
      } finally {
        if (a)
          throw a.error;
      }
    }
    return { node: null, n: 0, delim: i };
  }, t.prototype.mathItem = function(r, n, i) {
    var o = r.math, a = this.findPosition(r.n, r.start.n, r.open, i), T = this.findPosition(r.n, r.end.n, r.close, i);
    return new this.options.MathItem(o, n, r.display, a, T);
  }, t.prototype.findMath = function(r) {
    var n, i, o, a, T, s, Q, u, l;
    if (!this.processed.isSet("findMath")) {
      this.adaptor.document = this.document, r = (0, OQ.userOptions)({ elements: this.options.elements || [this.adaptor.body(this.document)] }, r);
      try {
        for (var c = _e(this.adaptor.getElements(r.elements, this.document)), f = c.next(); !f.done; f = c.next()) {
          var d = f.value, m = On([null, null], 2), p = m[0], v = m[1];
          try {
            for (var H = (o = void 0, _e(this.inputJax)), E = H.next(); !E.done; E = H.next()) {
              var M = E.value, C = new this.options.MathList();
              if (M.processStrings) {
                p === null && (T = On(this.domStrings.find(d), 2), p = T[0], v = T[1]);
                try {
                  for (var w = (s = void 0, _e(M.findMath(p))), S = w.next(); !S.done; S = w.next()) {
                    var D = S.value;
                    C.push(this.mathItem(D, M, v));
                  }
                } catch (j) {
                  s = { error: j };
                } finally {
                  try {
                    S && !S.done && (Q = w.return) && Q.call(w);
                  } finally {
                    if (s)
                      throw s.error;
                  }
                }
              } else
                try {
                  for (var k = (u = void 0, _e(M.findMath(d))), $ = k.next(); !$.done; $ = k.next()) {
                    var D = $.value, z = new this.options.MathItem(D.math, M, D.display, D.start, D.end);
                    C.push(z);
                  }
                } catch (j) {
                  u = { error: j };
                } finally {
                  try {
                    $ && !$.done && (l = k.return) && l.call(k);
                  } finally {
                    if (u)
                      throw u.error;
                  }
                }
              this.math.merge(C);
            }
          } catch (j) {
            o = { error: j };
          } finally {
            try {
              E && !E.done && (a = H.return) && a.call(H);
            } finally {
              if (o)
                throw o.error;
            }
          }
        }
      } catch (j) {
        n = { error: j };
      } finally {
        try {
          f && !f.done && (i = c.return) && i.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this.processed.set("findMath");
    }
    return this;
  }, t.prototype.updateDocument = function() {
    return this.processed.isSet("updateDocument") || (this.addPageElements(), this.addStyleSheet(), e.prototype.updateDocument.call(this), this.processed.set("updateDocument")), this;
  }, t.prototype.addPageElements = function() {
    var r = this.adaptor.body(this.document), n = this.documentPageElements();
    n && this.adaptor.append(r, n);
  }, t.prototype.addStyleSheet = function() {
    var r = this.documentStyleSheet(), n = this.adaptor;
    if (r && !n.parent(r)) {
      var i = n.head(this.document), o = this.findSheet(i, n.getAttribute(r, "id"));
      o ? n.replace(r, o) : n.append(i, r);
    }
  }, t.prototype.findSheet = function(r, n) {
    var i, o;
    if (n)
      try {
        for (var a = _e(this.adaptor.tags(r, "style")), T = a.next(); !T.done; T = a.next()) {
          var s = T.value;
          if (this.adaptor.getAttribute(s, "id") === n)
            return s;
        }
      } catch (Q) {
        i = { error: Q };
      } finally {
        try {
          T && !T.done && (o = a.return) && o.call(a);
        } finally {
          if (i)
            throw i.error;
        }
      }
    return null;
  }, t.prototype.removeFromDocument = function(r) {
    var n, i;
    if (r === void 0 && (r = !1), this.processed.isSet("updateDocument"))
      try {
        for (var o = _e(this.math), a = o.next(); !a.done; a = o.next()) {
          var T = a.value;
          T.state() >= AQ.STATE.INSERTED && T.state(AQ.STATE.TYPESET, r);
        }
      } catch (s) {
        n = { error: s };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n)
            throw n.error;
        }
      }
    return this.processed.clear("updateDocument"), this;
  }, t.prototype.documentStyleSheet = function() {
    return this.outputJax.styleSheet(this);
  }, t.prototype.documentPageElements = function() {
    return this.outputJax.pageElements(this);
  }, t.prototype.addStyles = function(r) {
    this.styles.push(r);
  }, t.prototype.getStyles = function() {
    return this.styles;
  }, t.KIND = "HTML", t.OPTIONS = p0(p0({}, _Q.AbstractMathDocument.OPTIONS), { renderActions: (0, OQ.expandable)(p0(p0({}, _Q.AbstractMathDocument.OPTIONS.renderActions), { styles: [AQ.STATE.INSERTED + 1, "", "updateStyleSheet", !1] })), MathList: wb.HTMLMathList, MathItem: Mb.HTMLMathItem, DomStrings: null }), t;
}(_Q.AbstractMathDocument);
Oo.HTMLDocument = Sb;
var Cb = b && b.__extends || /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}();
Object.defineProperty(Ho, "__esModule", { value: !0 });
Ho.HTMLHandler = void 0;
var Vb = Eo, _b = Oo, Ob = function(e) {
  Cb(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.documentClass = _b.HTMLDocument, r;
  }
  return t.prototype.handlesDocument = function(r) {
    var n = this.adaptor;
    if (typeof r == "string")
      try {
        r = n.parse(r, "text/html");
      } catch {
      }
    return r instanceof n.window.Document || r instanceof n.window.HTMLElement || r instanceof n.window.DocumentFragment;
  }, t.prototype.create = function(r, n) {
    var i = this.adaptor;
    if (typeof r == "string")
      r = i.parse(r, "text/html");
    else if (r instanceof i.window.HTMLElement || r instanceof i.window.DocumentFragment) {
      var o = r;
      r = i.parse("", "text/html"), i.append(i.body(r), o);
    }
    return e.prototype.create.call(this, r, n);
  }, t;
}(Vb.AbstractHandler);
Ho.HTMLHandler = Ob;
Object.defineProperty(Rs, "__esModule", { value: !0 });
var uh = Rs.RegisterHTMLHandler = void 0, Ab = A0, Db = Ho;
function kb(e) {
  var t = new Db.HTMLHandler(e);
  return Ab.mathjax.handlers.register(t), t;
}
uh = Rs.RegisterHTMLHandler = kb;
var y0 = function() {
  return y0 = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, y0.apply(this, arguments);
}, S9 = Th();
uh(S9);
var Ib = new Gd({ packages: ["base", "ams"] }), Rb = new zd({}), Ps = new NE.SVG({ fontCache: "none" }), ch = [tt.STATE.TYPESET + 1, null, Bb], Nb = A0.mathjax.document("", {
  InputJax: Ib,
  OutputJax: Ps,
  renderActions: {
    markErrors: ch
  }
}), Pb = A0.mathjax.document("", {
  InputJax: Rb,
  OutputJax: Ps,
  renderActions: {
    markErrors: ch
  }
});
function Bb(e) {
  var t = e.root, r = e.typesetRoot;
  if (t.toString().substr(0, 14) === "math([merror([") {
    var n = t.childNodes[0].childNodes[0], i = n.attributes.get("data-mjx-error") || n.childNodes[0].childNodes[0].getText();
    S9.setAttribute(r, "data-mjx-error", i);
  }
}
function Fb(e, t) {
  var r = document.getElementById(e);
  r === null && (r = document.createElement("style"), r.setAttribute("id", e), document.head.appendChild(r)), r.innerHTML = t;
}
var kc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
);
function jb(e, t, r, n) {
  var i = e.src, o = e.lang;
  if (!t)
    throw new Error();
  var a = Nb;
  o == "MathML" && (a = Pb);
  var T = i.trim(), s = !1, Q = function() {
    return s = !0;
  }, u = A0.mathjax.handleRetriesFor(function() {
    if (s)
      throw new kc();
    var l = a.convert(T, y0({ display: r }, n));
    return l;
  }).then(function(l) {
    a.updateDocument(), Fb("MATHJAX-SVG-STYLESHEET", Ps.cssStyles.cssText);
    var c = S9.getAttribute(l, "data-mjx-error");
    if (c)
      throw c;
    return S9.outerHTML(l);
  }).catch(function(l) {
    if (l instanceof kc)
      console.log("cancelled render!");
    else
      throw l;
  });
  return { promise: u.then(function(l) {
    return l || "";
  }), cancel: Q };
}
function $b(e) {
  var t = e.src, r = e.lang, n = e.display, i = e.settings, o = W1(null), a = o[0], T = o[1], s = W1(null), Q = s[0], u = s[1], l = W1(null), c = l[0], f = l[1];
  return G3(function() {
    if (!Q)
      return function() {
      };
    var d = jb({ src: t, lang: r }, Q, n, i), m = d.promise, p = d.cancel;
    return m.then(T, f), function() {
      f(null), p();
    };
  }, [Q, t, r, n, i]), {
    renderedHTML: a,
    error: c,
    getProps: function() {
      return {
        ref: u,
        dangerouslySetInnerHTML: a !== null ? { __html: a } : void 0
      };
    }
  };
}
function Zb(e) {
  return e.mathml !== void 0 ? {
    lang: "MathML",
    src: e.mathml
  } : {
    lang: "TeX",
    src: e.tex
  };
}
function Wb(e) {
  var t = e.display, r = t === void 0 ? !0 : t, n = e.settings, i = $b(y0({
    display: r,
    settings: n
  }, Zb(e))).getProps;
  return r ? W3.createElement("div", y0({}, i())) : W3.createElement("span", y0({}, i()));
}
var Gb = Object.defineProperty, zb = (e, t, r) => t in e ? Gb(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ub = (e, t, r) => zb(e, typeof t != "symbol" ? t + "" : t, r);
const g2 = {
  MATCH_TYPE: {
    WORD: "WORD"
  },
  GRADING: {
    PASS_FAIL: "PASS_FAIL",
    NONE: "NONE",
    PARTIAL_CREDIT: "PARTIAL_CREDIT"
  },
  ANNOTATION_TOOL: {
    HIGHLIGHT: "HIGHLIGHT",
    UNDERLINE: "UNDERLINE",
    STRIKE_THROUGH: "STRIKE_THROUGH"
  },
  COLOR: {
    BLUE: "BLUE",
    GREEN: "GREEN",
    YELLOW: "YELLOW",
    PURPLE: "PURPLE",
    ORANGE: "ORANGE",
    PINK: "PINK",
    BLACK: "BLACK"
  }
};
function fh(e) {
  return new e({
    type: _2(String, { enum: js }),
    url: _2(String)
  });
}
function _2(e, t = {}) {
  return {
    type: e,
    required: !0,
    ...t
  };
}
function Lr(e, t, r = {}) {
  return _2([e], {
    validate: {
      validator: function(n) {
        return Array.isArray(n) && (n == null ? void 0 : n.length) > 0;
      },
      message: t
    },
    ...r
  });
}
function Xb(e, t) {
  if (!e.length)
    return null;
  let r = null, n = !1, i = e.length - 1, o = 0;
  for (; o <= i; ) {
    const a = o + Math.floor((i - o + 1) / 2), T = t(e[a]);
    T < 0 ? o = a + 1 : T > 0 ? (n || (r = a), i = a - 1) : T === 0 && (r = a, n = !0, o = a + 1);
  }
  return r;
}
function qb(e, t) {
  if (!e.length)
    return null;
  let r = null, n = !1, i = e.length - 1, o = 0;
  for (; o <= i; ) {
    const a = o + Math.floor((i - o + 1) / 2), T = t(e[a]);
    T < 0 ? (n || (r = a), o = a + 1) : T > 0 ? i = a - 1 : T === 0 && (r = a, n = !0, i = a - 1);
  }
  return r;
}
const Jb = /* @__PURE__ */ new Set([
  "paragraph",
  "root",
  "list",
  "listItem",
  "blockquote",
  "heading",
  "strong",
  "emphasis",
  "delete",
  "mdxJsxFlowElement",
  "mdxJsxTextElement"
]);
function Yb(e, t) {
  var r, n, i, o, a;
  const T = [e];
  let s;
  for (; s = T.pop(); ) {
    if (Jb.has(s.type)) {
      T.push(...s.children);
      continue;
    }
    if (s.type === "text") {
      const Q = s, u = (r = Q.position) == null ? void 0 : r.start.offset, l = (n = Q.position) == null ? void 0 : n.end.offset;
      u != null && l != null && t.push({
        range: {
          start: u,
          end: l
        },
        text: Q.value
      });
      continue;
    }
    if (s.type === "code") {
      const Q = s;
      if (!(Q.lang === null || Q.lang === "code"))
        continue;
      const u = (i = Q.position) == null ? void 0 : i.start.offset, l = (o = Q.position) == null ? void 0 : o.end.offset;
      u != null && l != null && t.push({
        range: {
          start: u + 3 + (((a = Q.lang) == null ? void 0 : a.length) ?? 0) + 1,
          // +3 to ignore the triple ticks ```, +1 to ignore the new line after the language
          end: l
        },
        text: Q.value
      });
      continue;
    }
    if (s.type === "inlineCode") {
      const Q = s, {
        language: u,
        codeSnippet: l,
        codeSnippetRange: c
      } = Kb(Q.value, s.position ?? null);
      if (u !== "code" || !c)
        return;
      t.push({
        range: {
          start: c.start,
          end: c.end
        },
        text: l
      });
    }
  }
}
function dh(e) {
  const t = [];
  Yb(e, t);
  const r = [];
  for (const n of t)
    for (const i of n.text.matchAll(/\w+/g)) {
      const o = i[0];
      r.push({
        range: {
          start: n.range.start + (i.index || 0),
          end: n.range.start + (i.index || 0) + o.length
        },
        text: o
      });
    }
  return r.sort((n, i) => n.range.start - i.range.start);
}
function Kb(e, t) {
  let r = "code", n = e, i = (t == null ? void 0 : t.start.offset) != null && t != null && t.end.offset ? {
    start: t.start.offset + 1,
    // +1 to ignore the starting tick `
    end: t.end.offset
  } : null;
  if (typeof e == "string" && e.startsWith("lang-")) {
    const o = e.match(/^lang-[^\s]*\s/);
    if (o != null && o.length) {
      const a = o[0];
      r = a.slice(
        0,
        // remove tailing space
        a.length - 1
      ), n = e.slice(
        // ignore text describing the language to use
        r.length + 1,
        e.length
      ), i && (i = {
        start: i.start + r.length + 1,
        end: i.end
      });
    }
  }
  return {
    language: r == null ? void 0 : r.replace("lang-", ""),
    codeSnippet: n,
    codeSnippetRange: i
  };
}
function eM(e) {
  return hh(dh(e));
}
function hh(e) {
  return (t) => {
    const r = Io(
      t,
      e
    );
    if (r == null)
      return null;
    const { firstElementIndex: n, lastElementIndex: i } = r, o = e[n], a = e[i];
    if (!o || !a)
      throw new Error(
        "firstTextElement or lastTextElement is undefined. This should be impossible"
      );
    return {
      range: {
        start: o.range.start,
        end: a.range.end
      },
      rangeOverlappingNextSelectableElement: {
        start: n === 0 ? o.range.start : (
          // we just checked that firstElementIndex is not 0, so we can safely access the previous element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[n - 1].range.end - 1
        ),
        end: i === e.length - 1 ? a.range.end : (
          // we just checked that lastElementIndex is not the last index, so we can safely access the next element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[i + 1].range.start + 1
        )
      },
      extendedRangeToNextSelectableElements: {
        start: n === 0 ? o.range.start : (
          // we just checked that firstElementIndex is not 0, so we can safely access the previous element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[n - 1].range.end
        ),
        end: i === e.length - 1 ? a.range.end : (
          // we just checked that lastElementIndex is not the last index, so we can safely access the next element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[i + 1].range.start
        )
      }
    };
  };
}
function tM(e) {
  return (t) => {
    const r = Io(
      t,
      e
    );
    if (r == null)
      return null;
    const { firstElementIndex: n, lastElementIndex: i } = r, o = {
      start: Math.max(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        e[n].range.start,
        t.start
      ),
      end: Math.min(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        e[i].range.end,
        t.end
      )
    };
    return {
      range: o,
      rangeOverlappingNextSelectableElement: {
        start: (
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          o.start - 1 >= e[n].range.start ? o.start - 1 : n === 0 ? o.start : (
            // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
            e[n - 1].range.end - 1
          )
        ),
        end: (
          // NOTE: < is used as .end is exclusive
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          o.end + 1 < e[i].range.end ? o.end + 1 : i === e.length - 1 ? o.end : (
            // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
            e[i + 1].range.start + 1
          )
        )
      },
      extendedRangeToNextSelectableElements: {
        start: o.start - 1 >= // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        e[n].range.start || n === 0 ? o.start : (
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          e[n - 1].range.end
        ),
        end: (
          // NOTE: < is used as .end is exclusive
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          o.end + 1 < e[i].range.end || i === e.length - 1 ? o.end : (
            // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
            e[i + 1].range.start
          )
        )
      }
    };
  };
}
function Io(e, t) {
  const r = Xb(
    t,
    (i) => Ic(i.range, e.start) ? 0 : i.range.end - 1 - e.start
  ), n = qb(
    t,
    (i) => Ic(
      i.range,
      e.end - 1
      // -1 since end is exclusive
    ) ? 0 : i.range.start - (e.end - 1)
  );
  return n == null || r == null || n < r || n === r && rM(
    e,
    // we assume that firstElementIndex is a valid index
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    t[r].range
  ) == null ? null : {
    firstElementIndex: r,
    lastElementIndex: n
  };
}
function Ic(e, t) {
  return e.start <= t && t < e.end;
}
function rM(e, t) {
  const r = Math.max(e.start, t.start), n = Math.min(e.end, t.end);
  return r >= n ? null : { start: r, end: n };
}
function ph(e, t, r) {
  var n, i, o, a, T;
  const s = /* @__PURE__ */ new Map();
  for (const f of e) {
    const d = f.style.tool ?? null, m = s.get(d) ?? /* @__PURE__ */ new Map();
    s.set(d, m);
    const p = f.style.color ?? null, v = m.get(p) ?? [];
    m.set(p, v), v.push(f);
  }
  const Q = /* @__PURE__ */ new Map();
  for (const [f, d] of s.entries())
    for (const [m, p] of d.entries()) {
      const v = [];
      for (const E of p) {
        const M = r(E.buffer), C = r(E.range);
        M && v.push(M), C && v.push(C);
      }
      const H = Q.get(f) ?? /* @__PURE__ */ new Map();
      Q.set(f, H), H.set(m, {
        unsatisfiedTargets: p.sort(
          (E, M) => E.range.start - M.range.end
        ),
        buffers: iM(v)
      });
    }
  const u = /* @__PURE__ */ new Map();
  let l = 0;
  for (const f of t) {
    const d = [];
    let m = 0;
    for (const H of [
      // this is a list of all the possible target annotation data which could apply to this annotation
      (n = Q.get(f.style.tool)) == null ? void 0 : n.get(f.style.color),
      (i = Q.get(null)) == null ? void 0 : i.get(f.style.color),
      (o = Q.get(f.style.tool)) == null ? void 0 : o.get(null),
      (a = Q.get(null)) == null ? void 0 : a.get(null)
    ])
      H && (d.push(H), m += H.unsatisfiedTargets.length);
    if (!d.length || m === 0)
      continue;
    const p = (T = u.get(f.style.tool)) == null ? void 0 : T.get(f.style.color);
    let v;
    if (p)
      v = p;
    else {
      v = [];
      for (const E of d)
        v = oM(
          v,
          E.buffers
        );
      const H = u.get(f.style.tool) ?? /* @__PURE__ */ new Map();
      u.set(f.style.tool, H), H.set(f.style.color, v);
    }
    if (Rc(f.range, v))
      for (const H of d)
        for (let E = 0; E < H.unsatisfiedTargets.length; E++) {
          const M = H.unsatisfiedTargets[E];
          if (!M)
            throw new Error(
              "targetAnnotation is undefined. This should be impossible"
            );
          Rc(M.range, [
            f
          ]) && (l += M.score, nM(H.unsatisfiedTargets, E), E -= 1);
        }
  }
  let c = 0;
  for (const f of Q.values())
    for (const { unsatisfiedTargets: d } of f.values())
      for (const m of d)
        m.required && (c += 1);
  return {
    score: l,
    allRequiredTargetsSatisfied: c === 0
  };
}
function nM(e, t) {
  e.length !== 0 && (e[t] = e[e.length - 1], e.length = e.length - 1);
}
function Rc(e, t) {
  const r = Io(e, t);
  if (!r || r.firstElementIndex !== r.lastElementIndex)
    return !1;
  const n = t[r.firstElementIndex], i = t[r.lastElementIndex];
  if (!n || !i)
    throw new Error(
      "firstRange or lastRange is undefined. This should be impossible"
    );
  return !(e.start < n.range.start || i.range.end < e.end);
}
function iM(e) {
  const t = [];
  if (!e.length)
    return t;
  if (e.length === 1)
    return e;
  e.sort((o, a) => o.range.start - a.range.start);
  let r = {
    startIndex: 0,
    endIndex: 0,
    rangeData: {
      // we just checked that ranges.length is not 0, so we can safely access the first element
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...e[0].range
    }
  };
  for (let o = 1; o < e.length; o++) {
    const a = e[o];
    if (r.rangeData.end < a.rangeOverlappingNextSelectableElement.start) {
      const T = e[r.startIndex], s = e[r.endIndex];
      if (!T || !s)
        throw new Error(
          "startingRangeData or endingRangeData is undefined. This should be impossible"
        );
      t.push({
        range: r.rangeData,
        extendedRangeToNextSelectableElements: {
          start: T.extendedRangeToNextSelectableElements.start,
          end: s.extendedRangeToNextSelectableElements.end
        },
        rangeOverlappingNextSelectableElement: {
          start: T.rangeOverlappingNextSelectableElement.start,
          end: s.rangeOverlappingNextSelectableElement.end
        }
      }), r = {
        rangeData: { ...a.range },
        startIndex: o,
        endIndex: o
      };
      continue;
    }
    r.rangeData.end < a.range.end && (r.rangeData.end = a.range.end, r.endIndex = o);
  }
  const n = e[r.startIndex], i = e[r.endIndex];
  if (!n || !i)
    throw new Error(
      "startingRangeData or endingRangeData is undefined. This should be impossible"
    );
  return t.push({
    range: r.rangeData,
    extendedRangeToNextSelectableElements: {
      start: n.extendedRangeToNextSelectableElements.start,
      end: i.extendedRangeToNextSelectableElements.end
    },
    rangeOverlappingNextSelectableElement: {
      start: n.rangeOverlappingNextSelectableElement.start,
      end: i.rangeOverlappingNextSelectableElement.end
    }
  }), t;
}
function oM(e, t) {
  if (e.length === 0)
    return t;
  if (t.length === 0)
    return e;
  const r = [], n = e[0], i = t[0];
  let o = n.range.start < i.range.start ? n : i, a = 0, T = 0;
  for (; a < e.length || T < t.length; ) {
    const s = e[a];
    if (s && s.rangeOverlappingNextSelectableElement.start < o.range.end) {
      o = Nc(s, o), a += 1;
      continue;
    }
    const Q = t[T];
    if (Q && Q.rangeOverlappingNextSelectableElement.start < o.range.end) {
      o = Nc(Q, o), T += 1;
      continue;
    }
    if (r.push(o), s && Q && s.range.start < Q.range.start) {
      a += 1, o = s;
      continue;
    }
    if (s) {
      a += 1, o = s;
      continue;
    }
    if (Q) {
      T += 1, o = Q;
      continue;
    }
    break;
  }
  return r.push(o), r;
}
function DQ(e, t) {
  return {
    start: Math.min(e.start, t.start),
    end: Math.max(e.end, t.end)
  };
}
function Nc(e, t) {
  return {
    range: DQ(e.range, t.range),
    rangeOverlappingNextSelectableElement: DQ(
      e.rangeOverlappingNextSelectableElement,
      t.rangeOverlappingNextSelectableElement
    ),
    extendedRangeToNextSelectableElements: DQ(
      e.extendedRangeToNextSelectableElements,
      t.extendedRangeToNextSelectableElements
    )
  };
}
const aM = {};
function QM(e, t) {
  const r = aM, n = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, i = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return mh(e, n, i);
}
function mh(e, t, r) {
  if (TM(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Pc(e.children, t, r);
  }
  return Array.isArray(e) ? Pc(e, t, r) : "";
}
function Pc(e, t, r) {
  const n = [];
  let i = -1;
  for (; ++i < e.length; )
    n[i] = mh(e[i], t, r);
  return n.join("");
}
function TM(e) {
  return !!(e && typeof e == "object");
}
const Bc = {
  AElig: "Æ",
  AMP: "&",
  Aacute: "Á",
  Abreve: "Ă",
  Acirc: "Â",
  Acy: "А",
  Afr: "𝔄",
  Agrave: "À",
  Alpha: "Α",
  Amacr: "Ā",
  And: "⩓",
  Aogon: "Ą",
  Aopf: "𝔸",
  ApplyFunction: "⁡",
  Aring: "Å",
  Ascr: "𝒜",
  Assign: "≔",
  Atilde: "Ã",
  Auml: "Ä",
  Backslash: "∖",
  Barv: "⫧",
  Barwed: "⌆",
  Bcy: "Б",
  Because: "∵",
  Bernoullis: "ℬ",
  Beta: "Β",
  Bfr: "𝔅",
  Bopf: "𝔹",
  Breve: "˘",
  Bscr: "ℬ",
  Bumpeq: "≎",
  CHcy: "Ч",
  COPY: "©",
  Cacute: "Ć",
  Cap: "⋒",
  CapitalDifferentialD: "ⅅ",
  Cayleys: "ℭ",
  Ccaron: "Č",
  Ccedil: "Ç",
  Ccirc: "Ĉ",
  Cconint: "∰",
  Cdot: "Ċ",
  Cedilla: "¸",
  CenterDot: "·",
  Cfr: "ℭ",
  Chi: "Χ",
  CircleDot: "⊙",
  CircleMinus: "⊖",
  CirclePlus: "⊕",
  CircleTimes: "⊗",
  ClockwiseContourIntegral: "∲",
  CloseCurlyDoubleQuote: "”",
  CloseCurlyQuote: "’",
  Colon: "∷",
  Colone: "⩴",
  Congruent: "≡",
  Conint: "∯",
  ContourIntegral: "∮",
  Copf: "ℂ",
  Coproduct: "∐",
  CounterClockwiseContourIntegral: "∳",
  Cross: "⨯",
  Cscr: "𝒞",
  Cup: "⋓",
  CupCap: "≍",
  DD: "ⅅ",
  DDotrahd: "⤑",
  DJcy: "Ђ",
  DScy: "Ѕ",
  DZcy: "Џ",
  Dagger: "‡",
  Darr: "↡",
  Dashv: "⫤",
  Dcaron: "Ď",
  Dcy: "Д",
  Del: "∇",
  Delta: "Δ",
  Dfr: "𝔇",
  DiacriticalAcute: "´",
  DiacriticalDot: "˙",
  DiacriticalDoubleAcute: "˝",
  DiacriticalGrave: "`",
  DiacriticalTilde: "˜",
  Diamond: "⋄",
  DifferentialD: "ⅆ",
  Dopf: "𝔻",
  Dot: "¨",
  DotDot: "⃜",
  DotEqual: "≐",
  DoubleContourIntegral: "∯",
  DoubleDot: "¨",
  DoubleDownArrow: "⇓",
  DoubleLeftArrow: "⇐",
  DoubleLeftRightArrow: "⇔",
  DoubleLeftTee: "⫤",
  DoubleLongLeftArrow: "⟸",
  DoubleLongLeftRightArrow: "⟺",
  DoubleLongRightArrow: "⟹",
  DoubleRightArrow: "⇒",
  DoubleRightTee: "⊨",
  DoubleUpArrow: "⇑",
  DoubleUpDownArrow: "⇕",
  DoubleVerticalBar: "∥",
  DownArrow: "↓",
  DownArrowBar: "⤓",
  DownArrowUpArrow: "⇵",
  DownBreve: "̑",
  DownLeftRightVector: "⥐",
  DownLeftTeeVector: "⥞",
  DownLeftVector: "↽",
  DownLeftVectorBar: "⥖",
  DownRightTeeVector: "⥟",
  DownRightVector: "⇁",
  DownRightVectorBar: "⥗",
  DownTee: "⊤",
  DownTeeArrow: "↧",
  Downarrow: "⇓",
  Dscr: "𝒟",
  Dstrok: "Đ",
  ENG: "Ŋ",
  ETH: "Ð",
  Eacute: "É",
  Ecaron: "Ě",
  Ecirc: "Ê",
  Ecy: "Э",
  Edot: "Ė",
  Efr: "𝔈",
  Egrave: "È",
  Element: "∈",
  Emacr: "Ē",
  EmptySmallSquare: "◻",
  EmptyVerySmallSquare: "▫",
  Eogon: "Ę",
  Eopf: "𝔼",
  Epsilon: "Ε",
  Equal: "⩵",
  EqualTilde: "≂",
  Equilibrium: "⇌",
  Escr: "ℰ",
  Esim: "⩳",
  Eta: "Η",
  Euml: "Ë",
  Exists: "∃",
  ExponentialE: "ⅇ",
  Fcy: "Ф",
  Ffr: "𝔉",
  FilledSmallSquare: "◼",
  FilledVerySmallSquare: "▪",
  Fopf: "𝔽",
  ForAll: "∀",
  Fouriertrf: "ℱ",
  Fscr: "ℱ",
  GJcy: "Ѓ",
  GT: ">",
  Gamma: "Γ",
  Gammad: "Ϝ",
  Gbreve: "Ğ",
  Gcedil: "Ģ",
  Gcirc: "Ĝ",
  Gcy: "Г",
  Gdot: "Ġ",
  Gfr: "𝔊",
  Gg: "⋙",
  Gopf: "𝔾",
  GreaterEqual: "≥",
  GreaterEqualLess: "⋛",
  GreaterFullEqual: "≧",
  GreaterGreater: "⪢",
  GreaterLess: "≷",
  GreaterSlantEqual: "⩾",
  GreaterTilde: "≳",
  Gscr: "𝒢",
  Gt: "≫",
  HARDcy: "Ъ",
  Hacek: "ˇ",
  Hat: "^",
  Hcirc: "Ĥ",
  Hfr: "ℌ",
  HilbertSpace: "ℋ",
  Hopf: "ℍ",
  HorizontalLine: "─",
  Hscr: "ℋ",
  Hstrok: "Ħ",
  HumpDownHump: "≎",
  HumpEqual: "≏",
  IEcy: "Е",
  IJlig: "Ĳ",
  IOcy: "Ё",
  Iacute: "Í",
  Icirc: "Î",
  Icy: "И",
  Idot: "İ",
  Ifr: "ℑ",
  Igrave: "Ì",
  Im: "ℑ",
  Imacr: "Ī",
  ImaginaryI: "ⅈ",
  Implies: "⇒",
  Int: "∬",
  Integral: "∫",
  Intersection: "⋂",
  InvisibleComma: "⁣",
  InvisibleTimes: "⁢",
  Iogon: "Į",
  Iopf: "𝕀",
  Iota: "Ι",
  Iscr: "ℐ",
  Itilde: "Ĩ",
  Iukcy: "І",
  Iuml: "Ï",
  Jcirc: "Ĵ",
  Jcy: "Й",
  Jfr: "𝔍",
  Jopf: "𝕁",
  Jscr: "𝒥",
  Jsercy: "Ј",
  Jukcy: "Є",
  KHcy: "Х",
  KJcy: "Ќ",
  Kappa: "Κ",
  Kcedil: "Ķ",
  Kcy: "К",
  Kfr: "𝔎",
  Kopf: "𝕂",
  Kscr: "𝒦",
  LJcy: "Љ",
  LT: "<",
  Lacute: "Ĺ",
  Lambda: "Λ",
  Lang: "⟪",
  Laplacetrf: "ℒ",
  Larr: "↞",
  Lcaron: "Ľ",
  Lcedil: "Ļ",
  Lcy: "Л",
  LeftAngleBracket: "⟨",
  LeftArrow: "←",
  LeftArrowBar: "⇤",
  LeftArrowRightArrow: "⇆",
  LeftCeiling: "⌈",
  LeftDoubleBracket: "⟦",
  LeftDownTeeVector: "⥡",
  LeftDownVector: "⇃",
  LeftDownVectorBar: "⥙",
  LeftFloor: "⌊",
  LeftRightArrow: "↔",
  LeftRightVector: "⥎",
  LeftTee: "⊣",
  LeftTeeArrow: "↤",
  LeftTeeVector: "⥚",
  LeftTriangle: "⊲",
  LeftTriangleBar: "⧏",
  LeftTriangleEqual: "⊴",
  LeftUpDownVector: "⥑",
  LeftUpTeeVector: "⥠",
  LeftUpVector: "↿",
  LeftUpVectorBar: "⥘",
  LeftVector: "↼",
  LeftVectorBar: "⥒",
  Leftarrow: "⇐",
  Leftrightarrow: "⇔",
  LessEqualGreater: "⋚",
  LessFullEqual: "≦",
  LessGreater: "≶",
  LessLess: "⪡",
  LessSlantEqual: "⩽",
  LessTilde: "≲",
  Lfr: "𝔏",
  Ll: "⋘",
  Lleftarrow: "⇚",
  Lmidot: "Ŀ",
  LongLeftArrow: "⟵",
  LongLeftRightArrow: "⟷",
  LongRightArrow: "⟶",
  Longleftarrow: "⟸",
  Longleftrightarrow: "⟺",
  Longrightarrow: "⟹",
  Lopf: "𝕃",
  LowerLeftArrow: "↙",
  LowerRightArrow: "↘",
  Lscr: "ℒ",
  Lsh: "↰",
  Lstrok: "Ł",
  Lt: "≪",
  Map: "⤅",
  Mcy: "М",
  MediumSpace: " ",
  Mellintrf: "ℳ",
  Mfr: "𝔐",
  MinusPlus: "∓",
  Mopf: "𝕄",
  Mscr: "ℳ",
  Mu: "Μ",
  NJcy: "Њ",
  Nacute: "Ń",
  Ncaron: "Ň",
  Ncedil: "Ņ",
  Ncy: "Н",
  NegativeMediumSpace: "​",
  NegativeThickSpace: "​",
  NegativeThinSpace: "​",
  NegativeVeryThinSpace: "​",
  NestedGreaterGreater: "≫",
  NestedLessLess: "≪",
  NewLine: `
`,
  Nfr: "𝔑",
  NoBreak: "⁠",
  NonBreakingSpace: " ",
  Nopf: "ℕ",
  Not: "⫬",
  NotCongruent: "≢",
  NotCupCap: "≭",
  NotDoubleVerticalBar: "∦",
  NotElement: "∉",
  NotEqual: "≠",
  NotEqualTilde: "≂̸",
  NotExists: "∄",
  NotGreater: "≯",
  NotGreaterEqual: "≱",
  NotGreaterFullEqual: "≧̸",
  NotGreaterGreater: "≫̸",
  NotGreaterLess: "≹",
  NotGreaterSlantEqual: "⩾̸",
  NotGreaterTilde: "≵",
  NotHumpDownHump: "≎̸",
  NotHumpEqual: "≏̸",
  NotLeftTriangle: "⋪",
  NotLeftTriangleBar: "⧏̸",
  NotLeftTriangleEqual: "⋬",
  NotLess: "≮",
  NotLessEqual: "≰",
  NotLessGreater: "≸",
  NotLessLess: "≪̸",
  NotLessSlantEqual: "⩽̸",
  NotLessTilde: "≴",
  NotNestedGreaterGreater: "⪢̸",
  NotNestedLessLess: "⪡̸",
  NotPrecedes: "⊀",
  NotPrecedesEqual: "⪯̸",
  NotPrecedesSlantEqual: "⋠",
  NotReverseElement: "∌",
  NotRightTriangle: "⋫",
  NotRightTriangleBar: "⧐̸",
  NotRightTriangleEqual: "⋭",
  NotSquareSubset: "⊏̸",
  NotSquareSubsetEqual: "⋢",
  NotSquareSuperset: "⊐̸",
  NotSquareSupersetEqual: "⋣",
  NotSubset: "⊂⃒",
  NotSubsetEqual: "⊈",
  NotSucceeds: "⊁",
  NotSucceedsEqual: "⪰̸",
  NotSucceedsSlantEqual: "⋡",
  NotSucceedsTilde: "≿̸",
  NotSuperset: "⊃⃒",
  NotSupersetEqual: "⊉",
  NotTilde: "≁",
  NotTildeEqual: "≄",
  NotTildeFullEqual: "≇",
  NotTildeTilde: "≉",
  NotVerticalBar: "∤",
  Nscr: "𝒩",
  Ntilde: "Ñ",
  Nu: "Ν",
  OElig: "Œ",
  Oacute: "Ó",
  Ocirc: "Ô",
  Ocy: "О",
  Odblac: "Ő",
  Ofr: "𝔒",
  Ograve: "Ò",
  Omacr: "Ō",
  Omega: "Ω",
  Omicron: "Ο",
  Oopf: "𝕆",
  OpenCurlyDoubleQuote: "“",
  OpenCurlyQuote: "‘",
  Or: "⩔",
  Oscr: "𝒪",
  Oslash: "Ø",
  Otilde: "Õ",
  Otimes: "⨷",
  Ouml: "Ö",
  OverBar: "‾",
  OverBrace: "⏞",
  OverBracket: "⎴",
  OverParenthesis: "⏜",
  PartialD: "∂",
  Pcy: "П",
  Pfr: "𝔓",
  Phi: "Φ",
  Pi: "Π",
  PlusMinus: "±",
  Poincareplane: "ℌ",
  Popf: "ℙ",
  Pr: "⪻",
  Precedes: "≺",
  PrecedesEqual: "⪯",
  PrecedesSlantEqual: "≼",
  PrecedesTilde: "≾",
  Prime: "″",
  Product: "∏",
  Proportion: "∷",
  Proportional: "∝",
  Pscr: "𝒫",
  Psi: "Ψ",
  QUOT: '"',
  Qfr: "𝔔",
  Qopf: "ℚ",
  Qscr: "𝒬",
  RBarr: "⤐",
  REG: "®",
  Racute: "Ŕ",
  Rang: "⟫",
  Rarr: "↠",
  Rarrtl: "⤖",
  Rcaron: "Ř",
  Rcedil: "Ŗ",
  Rcy: "Р",
  Re: "ℜ",
  ReverseElement: "∋",
  ReverseEquilibrium: "⇋",
  ReverseUpEquilibrium: "⥯",
  Rfr: "ℜ",
  Rho: "Ρ",
  RightAngleBracket: "⟩",
  RightArrow: "→",
  RightArrowBar: "⇥",
  RightArrowLeftArrow: "⇄",
  RightCeiling: "⌉",
  RightDoubleBracket: "⟧",
  RightDownTeeVector: "⥝",
  RightDownVector: "⇂",
  RightDownVectorBar: "⥕",
  RightFloor: "⌋",
  RightTee: "⊢",
  RightTeeArrow: "↦",
  RightTeeVector: "⥛",
  RightTriangle: "⊳",
  RightTriangleBar: "⧐",
  RightTriangleEqual: "⊵",
  RightUpDownVector: "⥏",
  RightUpTeeVector: "⥜",
  RightUpVector: "↾",
  RightUpVectorBar: "⥔",
  RightVector: "⇀",
  RightVectorBar: "⥓",
  Rightarrow: "⇒",
  Ropf: "ℝ",
  RoundImplies: "⥰",
  Rrightarrow: "⇛",
  Rscr: "ℛ",
  Rsh: "↱",
  RuleDelayed: "⧴",
  SHCHcy: "Щ",
  SHcy: "Ш",
  SOFTcy: "Ь",
  Sacute: "Ś",
  Sc: "⪼",
  Scaron: "Š",
  Scedil: "Ş",
  Scirc: "Ŝ",
  Scy: "С",
  Sfr: "𝔖",
  ShortDownArrow: "↓",
  ShortLeftArrow: "←",
  ShortRightArrow: "→",
  ShortUpArrow: "↑",
  Sigma: "Σ",
  SmallCircle: "∘",
  Sopf: "𝕊",
  Sqrt: "√",
  Square: "□",
  SquareIntersection: "⊓",
  SquareSubset: "⊏",
  SquareSubsetEqual: "⊑",
  SquareSuperset: "⊐",
  SquareSupersetEqual: "⊒",
  SquareUnion: "⊔",
  Sscr: "𝒮",
  Star: "⋆",
  Sub: "⋐",
  Subset: "⋐",
  SubsetEqual: "⊆",
  Succeeds: "≻",
  SucceedsEqual: "⪰",
  SucceedsSlantEqual: "≽",
  SucceedsTilde: "≿",
  SuchThat: "∋",
  Sum: "∑",
  Sup: "⋑",
  Superset: "⊃",
  SupersetEqual: "⊇",
  Supset: "⋑",
  THORN: "Þ",
  TRADE: "™",
  TSHcy: "Ћ",
  TScy: "Ц",
  Tab: "	",
  Tau: "Τ",
  Tcaron: "Ť",
  Tcedil: "Ţ",
  Tcy: "Т",
  Tfr: "𝔗",
  Therefore: "∴",
  Theta: "Θ",
  ThickSpace: "  ",
  ThinSpace: " ",
  Tilde: "∼",
  TildeEqual: "≃",
  TildeFullEqual: "≅",
  TildeTilde: "≈",
  Topf: "𝕋",
  TripleDot: "⃛",
  Tscr: "𝒯",
  Tstrok: "Ŧ",
  Uacute: "Ú",
  Uarr: "↟",
  Uarrocir: "⥉",
  Ubrcy: "Ў",
  Ubreve: "Ŭ",
  Ucirc: "Û",
  Ucy: "У",
  Udblac: "Ű",
  Ufr: "𝔘",
  Ugrave: "Ù",
  Umacr: "Ū",
  UnderBar: "_",
  UnderBrace: "⏟",
  UnderBracket: "⎵",
  UnderParenthesis: "⏝",
  Union: "⋃",
  UnionPlus: "⊎",
  Uogon: "Ų",
  Uopf: "𝕌",
  UpArrow: "↑",
  UpArrowBar: "⤒",
  UpArrowDownArrow: "⇅",
  UpDownArrow: "↕",
  UpEquilibrium: "⥮",
  UpTee: "⊥",
  UpTeeArrow: "↥",
  Uparrow: "⇑",
  Updownarrow: "⇕",
  UpperLeftArrow: "↖",
  UpperRightArrow: "↗",
  Upsi: "ϒ",
  Upsilon: "Υ",
  Uring: "Ů",
  Uscr: "𝒰",
  Utilde: "Ũ",
  Uuml: "Ü",
  VDash: "⊫",
  Vbar: "⫫",
  Vcy: "В",
  Vdash: "⊩",
  Vdashl: "⫦",
  Vee: "⋁",
  Verbar: "‖",
  Vert: "‖",
  VerticalBar: "∣",
  VerticalLine: "|",
  VerticalSeparator: "❘",
  VerticalTilde: "≀",
  VeryThinSpace: " ",
  Vfr: "𝔙",
  Vopf: "𝕍",
  Vscr: "𝒱",
  Vvdash: "⊪",
  Wcirc: "Ŵ",
  Wedge: "⋀",
  Wfr: "𝔚",
  Wopf: "𝕎",
  Wscr: "𝒲",
  Xfr: "𝔛",
  Xi: "Ξ",
  Xopf: "𝕏",
  Xscr: "𝒳",
  YAcy: "Я",
  YIcy: "Ї",
  YUcy: "Ю",
  Yacute: "Ý",
  Ycirc: "Ŷ",
  Ycy: "Ы",
  Yfr: "𝔜",
  Yopf: "𝕐",
  Yscr: "𝒴",
  Yuml: "Ÿ",
  ZHcy: "Ж",
  Zacute: "Ź",
  Zcaron: "Ž",
  Zcy: "З",
  Zdot: "Ż",
  ZeroWidthSpace: "​",
  Zeta: "Ζ",
  Zfr: "ℨ",
  Zopf: "ℤ",
  Zscr: "𝒵",
  aacute: "á",
  abreve: "ă",
  ac: "∾",
  acE: "∾̳",
  acd: "∿",
  acirc: "â",
  acute: "´",
  acy: "а",
  aelig: "æ",
  af: "⁡",
  afr: "𝔞",
  agrave: "à",
  alefsym: "ℵ",
  aleph: "ℵ",
  alpha: "α",
  amacr: "ā",
  amalg: "⨿",
  amp: "&",
  and: "∧",
  andand: "⩕",
  andd: "⩜",
  andslope: "⩘",
  andv: "⩚",
  ang: "∠",
  ange: "⦤",
  angle: "∠",
  angmsd: "∡",
  angmsdaa: "⦨",
  angmsdab: "⦩",
  angmsdac: "⦪",
  angmsdad: "⦫",
  angmsdae: "⦬",
  angmsdaf: "⦭",
  angmsdag: "⦮",
  angmsdah: "⦯",
  angrt: "∟",
  angrtvb: "⊾",
  angrtvbd: "⦝",
  angsph: "∢",
  angst: "Å",
  angzarr: "⍼",
  aogon: "ą",
  aopf: "𝕒",
  ap: "≈",
  apE: "⩰",
  apacir: "⩯",
  ape: "≊",
  apid: "≋",
  apos: "'",
  approx: "≈",
  approxeq: "≊",
  aring: "å",
  ascr: "𝒶",
  ast: "*",
  asymp: "≈",
  asympeq: "≍",
  atilde: "ã",
  auml: "ä",
  awconint: "∳",
  awint: "⨑",
  bNot: "⫭",
  backcong: "≌",
  backepsilon: "϶",
  backprime: "‵",
  backsim: "∽",
  backsimeq: "⋍",
  barvee: "⊽",
  barwed: "⌅",
  barwedge: "⌅",
  bbrk: "⎵",
  bbrktbrk: "⎶",
  bcong: "≌",
  bcy: "б",
  bdquo: "„",
  becaus: "∵",
  because: "∵",
  bemptyv: "⦰",
  bepsi: "϶",
  bernou: "ℬ",
  beta: "β",
  beth: "ℶ",
  between: "≬",
  bfr: "𝔟",
  bigcap: "⋂",
  bigcirc: "◯",
  bigcup: "⋃",
  bigodot: "⨀",
  bigoplus: "⨁",
  bigotimes: "⨂",
  bigsqcup: "⨆",
  bigstar: "★",
  bigtriangledown: "▽",
  bigtriangleup: "△",
  biguplus: "⨄",
  bigvee: "⋁",
  bigwedge: "⋀",
  bkarow: "⤍",
  blacklozenge: "⧫",
  blacksquare: "▪",
  blacktriangle: "▴",
  blacktriangledown: "▾",
  blacktriangleleft: "◂",
  blacktriangleright: "▸",
  blank: "␣",
  blk12: "▒",
  blk14: "░",
  blk34: "▓",
  block: "█",
  bne: "=⃥",
  bnequiv: "≡⃥",
  bnot: "⌐",
  bopf: "𝕓",
  bot: "⊥",
  bottom: "⊥",
  bowtie: "⋈",
  boxDL: "╗",
  boxDR: "╔",
  boxDl: "╖",
  boxDr: "╓",
  boxH: "═",
  boxHD: "╦",
  boxHU: "╩",
  boxHd: "╤",
  boxHu: "╧",
  boxUL: "╝",
  boxUR: "╚",
  boxUl: "╜",
  boxUr: "╙",
  boxV: "║",
  boxVH: "╬",
  boxVL: "╣",
  boxVR: "╠",
  boxVh: "╫",
  boxVl: "╢",
  boxVr: "╟",
  boxbox: "⧉",
  boxdL: "╕",
  boxdR: "╒",
  boxdl: "┐",
  boxdr: "┌",
  boxh: "─",
  boxhD: "╥",
  boxhU: "╨",
  boxhd: "┬",
  boxhu: "┴",
  boxminus: "⊟",
  boxplus: "⊞",
  boxtimes: "⊠",
  boxuL: "╛",
  boxuR: "╘",
  boxul: "┘",
  boxur: "└",
  boxv: "│",
  boxvH: "╪",
  boxvL: "╡",
  boxvR: "╞",
  boxvh: "┼",
  boxvl: "┤",
  boxvr: "├",
  bprime: "‵",
  breve: "˘",
  brvbar: "¦",
  bscr: "𝒷",
  bsemi: "⁏",
  bsim: "∽",
  bsime: "⋍",
  bsol: "\\",
  bsolb: "⧅",
  bsolhsub: "⟈",
  bull: "•",
  bullet: "•",
  bump: "≎",
  bumpE: "⪮",
  bumpe: "≏",
  bumpeq: "≏",
  cacute: "ć",
  cap: "∩",
  capand: "⩄",
  capbrcup: "⩉",
  capcap: "⩋",
  capcup: "⩇",
  capdot: "⩀",
  caps: "∩︀",
  caret: "⁁",
  caron: "ˇ",
  ccaps: "⩍",
  ccaron: "č",
  ccedil: "ç",
  ccirc: "ĉ",
  ccups: "⩌",
  ccupssm: "⩐",
  cdot: "ċ",
  cedil: "¸",
  cemptyv: "⦲",
  cent: "¢",
  centerdot: "·",
  cfr: "𝔠",
  chcy: "ч",
  check: "✓",
  checkmark: "✓",
  chi: "χ",
  cir: "○",
  cirE: "⧃",
  circ: "ˆ",
  circeq: "≗",
  circlearrowleft: "↺",
  circlearrowright: "↻",
  circledR: "®",
  circledS: "Ⓢ",
  circledast: "⊛",
  circledcirc: "⊚",
  circleddash: "⊝",
  cire: "≗",
  cirfnint: "⨐",
  cirmid: "⫯",
  cirscir: "⧂",
  clubs: "♣",
  clubsuit: "♣",
  colon: ":",
  colone: "≔",
  coloneq: "≔",
  comma: ",",
  commat: "@",
  comp: "∁",
  compfn: "∘",
  complement: "∁",
  complexes: "ℂ",
  cong: "≅",
  congdot: "⩭",
  conint: "∮",
  copf: "𝕔",
  coprod: "∐",
  copy: "©",
  copysr: "℗",
  crarr: "↵",
  cross: "✗",
  cscr: "𝒸",
  csub: "⫏",
  csube: "⫑",
  csup: "⫐",
  csupe: "⫒",
  ctdot: "⋯",
  cudarrl: "⤸",
  cudarrr: "⤵",
  cuepr: "⋞",
  cuesc: "⋟",
  cularr: "↶",
  cularrp: "⤽",
  cup: "∪",
  cupbrcap: "⩈",
  cupcap: "⩆",
  cupcup: "⩊",
  cupdot: "⊍",
  cupor: "⩅",
  cups: "∪︀",
  curarr: "↷",
  curarrm: "⤼",
  curlyeqprec: "⋞",
  curlyeqsucc: "⋟",
  curlyvee: "⋎",
  curlywedge: "⋏",
  curren: "¤",
  curvearrowleft: "↶",
  curvearrowright: "↷",
  cuvee: "⋎",
  cuwed: "⋏",
  cwconint: "∲",
  cwint: "∱",
  cylcty: "⌭",
  dArr: "⇓",
  dHar: "⥥",
  dagger: "†",
  daleth: "ℸ",
  darr: "↓",
  dash: "‐",
  dashv: "⊣",
  dbkarow: "⤏",
  dblac: "˝",
  dcaron: "ď",
  dcy: "д",
  dd: "ⅆ",
  ddagger: "‡",
  ddarr: "⇊",
  ddotseq: "⩷",
  deg: "°",
  delta: "δ",
  demptyv: "⦱",
  dfisht: "⥿",
  dfr: "𝔡",
  dharl: "⇃",
  dharr: "⇂",
  diam: "⋄",
  diamond: "⋄",
  diamondsuit: "♦",
  diams: "♦",
  die: "¨",
  digamma: "ϝ",
  disin: "⋲",
  div: "÷",
  divide: "÷",
  divideontimes: "⋇",
  divonx: "⋇",
  djcy: "ђ",
  dlcorn: "⌞",
  dlcrop: "⌍",
  dollar: "$",
  dopf: "𝕕",
  dot: "˙",
  doteq: "≐",
  doteqdot: "≑",
  dotminus: "∸",
  dotplus: "∔",
  dotsquare: "⊡",
  doublebarwedge: "⌆",
  downarrow: "↓",
  downdownarrows: "⇊",
  downharpoonleft: "⇃",
  downharpoonright: "⇂",
  drbkarow: "⤐",
  drcorn: "⌟",
  drcrop: "⌌",
  dscr: "𝒹",
  dscy: "ѕ",
  dsol: "⧶",
  dstrok: "đ",
  dtdot: "⋱",
  dtri: "▿",
  dtrif: "▾",
  duarr: "⇵",
  duhar: "⥯",
  dwangle: "⦦",
  dzcy: "џ",
  dzigrarr: "⟿",
  eDDot: "⩷",
  eDot: "≑",
  eacute: "é",
  easter: "⩮",
  ecaron: "ě",
  ecir: "≖",
  ecirc: "ê",
  ecolon: "≕",
  ecy: "э",
  edot: "ė",
  ee: "ⅇ",
  efDot: "≒",
  efr: "𝔢",
  eg: "⪚",
  egrave: "è",
  egs: "⪖",
  egsdot: "⪘",
  el: "⪙",
  elinters: "⏧",
  ell: "ℓ",
  els: "⪕",
  elsdot: "⪗",
  emacr: "ē",
  empty: "∅",
  emptyset: "∅",
  emptyv: "∅",
  emsp13: " ",
  emsp14: " ",
  emsp: " ",
  eng: "ŋ",
  ensp: " ",
  eogon: "ę",
  eopf: "𝕖",
  epar: "⋕",
  eparsl: "⧣",
  eplus: "⩱",
  epsi: "ε",
  epsilon: "ε",
  epsiv: "ϵ",
  eqcirc: "≖",
  eqcolon: "≕",
  eqsim: "≂",
  eqslantgtr: "⪖",
  eqslantless: "⪕",
  equals: "=",
  equest: "≟",
  equiv: "≡",
  equivDD: "⩸",
  eqvparsl: "⧥",
  erDot: "≓",
  erarr: "⥱",
  escr: "ℯ",
  esdot: "≐",
  esim: "≂",
  eta: "η",
  eth: "ð",
  euml: "ë",
  euro: "€",
  excl: "!",
  exist: "∃",
  expectation: "ℰ",
  exponentiale: "ⅇ",
  fallingdotseq: "≒",
  fcy: "ф",
  female: "♀",
  ffilig: "ﬃ",
  fflig: "ﬀ",
  ffllig: "ﬄ",
  ffr: "𝔣",
  filig: "ﬁ",
  fjlig: "fj",
  flat: "♭",
  fllig: "ﬂ",
  fltns: "▱",
  fnof: "ƒ",
  fopf: "𝕗",
  forall: "∀",
  fork: "⋔",
  forkv: "⫙",
  fpartint: "⨍",
  frac12: "½",
  frac13: "⅓",
  frac14: "¼",
  frac15: "⅕",
  frac16: "⅙",
  frac18: "⅛",
  frac23: "⅔",
  frac25: "⅖",
  frac34: "¾",
  frac35: "⅗",
  frac38: "⅜",
  frac45: "⅘",
  frac56: "⅚",
  frac58: "⅝",
  frac78: "⅞",
  frasl: "⁄",
  frown: "⌢",
  fscr: "𝒻",
  gE: "≧",
  gEl: "⪌",
  gacute: "ǵ",
  gamma: "γ",
  gammad: "ϝ",
  gap: "⪆",
  gbreve: "ğ",
  gcirc: "ĝ",
  gcy: "г",
  gdot: "ġ",
  ge: "≥",
  gel: "⋛",
  geq: "≥",
  geqq: "≧",
  geqslant: "⩾",
  ges: "⩾",
  gescc: "⪩",
  gesdot: "⪀",
  gesdoto: "⪂",
  gesdotol: "⪄",
  gesl: "⋛︀",
  gesles: "⪔",
  gfr: "𝔤",
  gg: "≫",
  ggg: "⋙",
  gimel: "ℷ",
  gjcy: "ѓ",
  gl: "≷",
  glE: "⪒",
  gla: "⪥",
  glj: "⪤",
  gnE: "≩",
  gnap: "⪊",
  gnapprox: "⪊",
  gne: "⪈",
  gneq: "⪈",
  gneqq: "≩",
  gnsim: "⋧",
  gopf: "𝕘",
  grave: "`",
  gscr: "ℊ",
  gsim: "≳",
  gsime: "⪎",
  gsiml: "⪐",
  gt: ">",
  gtcc: "⪧",
  gtcir: "⩺",
  gtdot: "⋗",
  gtlPar: "⦕",
  gtquest: "⩼",
  gtrapprox: "⪆",
  gtrarr: "⥸",
  gtrdot: "⋗",
  gtreqless: "⋛",
  gtreqqless: "⪌",
  gtrless: "≷",
  gtrsim: "≳",
  gvertneqq: "≩︀",
  gvnE: "≩︀",
  hArr: "⇔",
  hairsp: " ",
  half: "½",
  hamilt: "ℋ",
  hardcy: "ъ",
  harr: "↔",
  harrcir: "⥈",
  harrw: "↭",
  hbar: "ℏ",
  hcirc: "ĥ",
  hearts: "♥",
  heartsuit: "♥",
  hellip: "…",
  hercon: "⊹",
  hfr: "𝔥",
  hksearow: "⤥",
  hkswarow: "⤦",
  hoarr: "⇿",
  homtht: "∻",
  hookleftarrow: "↩",
  hookrightarrow: "↪",
  hopf: "𝕙",
  horbar: "―",
  hscr: "𝒽",
  hslash: "ℏ",
  hstrok: "ħ",
  hybull: "⁃",
  hyphen: "‐",
  iacute: "í",
  ic: "⁣",
  icirc: "î",
  icy: "и",
  iecy: "е",
  iexcl: "¡",
  iff: "⇔",
  ifr: "𝔦",
  igrave: "ì",
  ii: "ⅈ",
  iiiint: "⨌",
  iiint: "∭",
  iinfin: "⧜",
  iiota: "℩",
  ijlig: "ĳ",
  imacr: "ī",
  image: "ℑ",
  imagline: "ℐ",
  imagpart: "ℑ",
  imath: "ı",
  imof: "⊷",
  imped: "Ƶ",
  in: "∈",
  incare: "℅",
  infin: "∞",
  infintie: "⧝",
  inodot: "ı",
  int: "∫",
  intcal: "⊺",
  integers: "ℤ",
  intercal: "⊺",
  intlarhk: "⨗",
  intprod: "⨼",
  iocy: "ё",
  iogon: "į",
  iopf: "𝕚",
  iota: "ι",
  iprod: "⨼",
  iquest: "¿",
  iscr: "𝒾",
  isin: "∈",
  isinE: "⋹",
  isindot: "⋵",
  isins: "⋴",
  isinsv: "⋳",
  isinv: "∈",
  it: "⁢",
  itilde: "ĩ",
  iukcy: "і",
  iuml: "ï",
  jcirc: "ĵ",
  jcy: "й",
  jfr: "𝔧",
  jmath: "ȷ",
  jopf: "𝕛",
  jscr: "𝒿",
  jsercy: "ј",
  jukcy: "є",
  kappa: "κ",
  kappav: "ϰ",
  kcedil: "ķ",
  kcy: "к",
  kfr: "𝔨",
  kgreen: "ĸ",
  khcy: "х",
  kjcy: "ќ",
  kopf: "𝕜",
  kscr: "𝓀",
  lAarr: "⇚",
  lArr: "⇐",
  lAtail: "⤛",
  lBarr: "⤎",
  lE: "≦",
  lEg: "⪋",
  lHar: "⥢",
  lacute: "ĺ",
  laemptyv: "⦴",
  lagran: "ℒ",
  lambda: "λ",
  lang: "⟨",
  langd: "⦑",
  langle: "⟨",
  lap: "⪅",
  laquo: "«",
  larr: "←",
  larrb: "⇤",
  larrbfs: "⤟",
  larrfs: "⤝",
  larrhk: "↩",
  larrlp: "↫",
  larrpl: "⤹",
  larrsim: "⥳",
  larrtl: "↢",
  lat: "⪫",
  latail: "⤙",
  late: "⪭",
  lates: "⪭︀",
  lbarr: "⤌",
  lbbrk: "❲",
  lbrace: "{",
  lbrack: "[",
  lbrke: "⦋",
  lbrksld: "⦏",
  lbrkslu: "⦍",
  lcaron: "ľ",
  lcedil: "ļ",
  lceil: "⌈",
  lcub: "{",
  lcy: "л",
  ldca: "⤶",
  ldquo: "“",
  ldquor: "„",
  ldrdhar: "⥧",
  ldrushar: "⥋",
  ldsh: "↲",
  le: "≤",
  leftarrow: "←",
  leftarrowtail: "↢",
  leftharpoondown: "↽",
  leftharpoonup: "↼",
  leftleftarrows: "⇇",
  leftrightarrow: "↔",
  leftrightarrows: "⇆",
  leftrightharpoons: "⇋",
  leftrightsquigarrow: "↭",
  leftthreetimes: "⋋",
  leg: "⋚",
  leq: "≤",
  leqq: "≦",
  leqslant: "⩽",
  les: "⩽",
  lescc: "⪨",
  lesdot: "⩿",
  lesdoto: "⪁",
  lesdotor: "⪃",
  lesg: "⋚︀",
  lesges: "⪓",
  lessapprox: "⪅",
  lessdot: "⋖",
  lesseqgtr: "⋚",
  lesseqqgtr: "⪋",
  lessgtr: "≶",
  lesssim: "≲",
  lfisht: "⥼",
  lfloor: "⌊",
  lfr: "𝔩",
  lg: "≶",
  lgE: "⪑",
  lhard: "↽",
  lharu: "↼",
  lharul: "⥪",
  lhblk: "▄",
  ljcy: "љ",
  ll: "≪",
  llarr: "⇇",
  llcorner: "⌞",
  llhard: "⥫",
  lltri: "◺",
  lmidot: "ŀ",
  lmoust: "⎰",
  lmoustache: "⎰",
  lnE: "≨",
  lnap: "⪉",
  lnapprox: "⪉",
  lne: "⪇",
  lneq: "⪇",
  lneqq: "≨",
  lnsim: "⋦",
  loang: "⟬",
  loarr: "⇽",
  lobrk: "⟦",
  longleftarrow: "⟵",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  longrightarrow: "⟶",
  looparrowleft: "↫",
  looparrowright: "↬",
  lopar: "⦅",
  lopf: "𝕝",
  loplus: "⨭",
  lotimes: "⨴",
  lowast: "∗",
  lowbar: "_",
  loz: "◊",
  lozenge: "◊",
  lozf: "⧫",
  lpar: "(",
  lparlt: "⦓",
  lrarr: "⇆",
  lrcorner: "⌟",
  lrhar: "⇋",
  lrhard: "⥭",
  lrm: "‎",
  lrtri: "⊿",
  lsaquo: "‹",
  lscr: "𝓁",
  lsh: "↰",
  lsim: "≲",
  lsime: "⪍",
  lsimg: "⪏",
  lsqb: "[",
  lsquo: "‘",
  lsquor: "‚",
  lstrok: "ł",
  lt: "<",
  ltcc: "⪦",
  ltcir: "⩹",
  ltdot: "⋖",
  lthree: "⋋",
  ltimes: "⋉",
  ltlarr: "⥶",
  ltquest: "⩻",
  ltrPar: "⦖",
  ltri: "◃",
  ltrie: "⊴",
  ltrif: "◂",
  lurdshar: "⥊",
  luruhar: "⥦",
  lvertneqq: "≨︀",
  lvnE: "≨︀",
  mDDot: "∺",
  macr: "¯",
  male: "♂",
  malt: "✠",
  maltese: "✠",
  map: "↦",
  mapsto: "↦",
  mapstodown: "↧",
  mapstoleft: "↤",
  mapstoup: "↥",
  marker: "▮",
  mcomma: "⨩",
  mcy: "м",
  mdash: "—",
  measuredangle: "∡",
  mfr: "𝔪",
  mho: "℧",
  micro: "µ",
  mid: "∣",
  midast: "*",
  midcir: "⫰",
  middot: "·",
  minus: "−",
  minusb: "⊟",
  minusd: "∸",
  minusdu: "⨪",
  mlcp: "⫛",
  mldr: "…",
  mnplus: "∓",
  models: "⊧",
  mopf: "𝕞",
  mp: "∓",
  mscr: "𝓂",
  mstpos: "∾",
  mu: "μ",
  multimap: "⊸",
  mumap: "⊸",
  nGg: "⋙̸",
  nGt: "≫⃒",
  nGtv: "≫̸",
  nLeftarrow: "⇍",
  nLeftrightarrow: "⇎",
  nLl: "⋘̸",
  nLt: "≪⃒",
  nLtv: "≪̸",
  nRightarrow: "⇏",
  nVDash: "⊯",
  nVdash: "⊮",
  nabla: "∇",
  nacute: "ń",
  nang: "∠⃒",
  nap: "≉",
  napE: "⩰̸",
  napid: "≋̸",
  napos: "ŉ",
  napprox: "≉",
  natur: "♮",
  natural: "♮",
  naturals: "ℕ",
  nbsp: " ",
  nbump: "≎̸",
  nbumpe: "≏̸",
  ncap: "⩃",
  ncaron: "ň",
  ncedil: "ņ",
  ncong: "≇",
  ncongdot: "⩭̸",
  ncup: "⩂",
  ncy: "н",
  ndash: "–",
  ne: "≠",
  neArr: "⇗",
  nearhk: "⤤",
  nearr: "↗",
  nearrow: "↗",
  nedot: "≐̸",
  nequiv: "≢",
  nesear: "⤨",
  nesim: "≂̸",
  nexist: "∄",
  nexists: "∄",
  nfr: "𝔫",
  ngE: "≧̸",
  nge: "≱",
  ngeq: "≱",
  ngeqq: "≧̸",
  ngeqslant: "⩾̸",
  nges: "⩾̸",
  ngsim: "≵",
  ngt: "≯",
  ngtr: "≯",
  nhArr: "⇎",
  nharr: "↮",
  nhpar: "⫲",
  ni: "∋",
  nis: "⋼",
  nisd: "⋺",
  niv: "∋",
  njcy: "њ",
  nlArr: "⇍",
  nlE: "≦̸",
  nlarr: "↚",
  nldr: "‥",
  nle: "≰",
  nleftarrow: "↚",
  nleftrightarrow: "↮",
  nleq: "≰",
  nleqq: "≦̸",
  nleqslant: "⩽̸",
  nles: "⩽̸",
  nless: "≮",
  nlsim: "≴",
  nlt: "≮",
  nltri: "⋪",
  nltrie: "⋬",
  nmid: "∤",
  nopf: "𝕟",
  not: "¬",
  notin: "∉",
  notinE: "⋹̸",
  notindot: "⋵̸",
  notinva: "∉",
  notinvb: "⋷",
  notinvc: "⋶",
  notni: "∌",
  notniva: "∌",
  notnivb: "⋾",
  notnivc: "⋽",
  npar: "∦",
  nparallel: "∦",
  nparsl: "⫽⃥",
  npart: "∂̸",
  npolint: "⨔",
  npr: "⊀",
  nprcue: "⋠",
  npre: "⪯̸",
  nprec: "⊀",
  npreceq: "⪯̸",
  nrArr: "⇏",
  nrarr: "↛",
  nrarrc: "⤳̸",
  nrarrw: "↝̸",
  nrightarrow: "↛",
  nrtri: "⋫",
  nrtrie: "⋭",
  nsc: "⊁",
  nsccue: "⋡",
  nsce: "⪰̸",
  nscr: "𝓃",
  nshortmid: "∤",
  nshortparallel: "∦",
  nsim: "≁",
  nsime: "≄",
  nsimeq: "≄",
  nsmid: "∤",
  nspar: "∦",
  nsqsube: "⋢",
  nsqsupe: "⋣",
  nsub: "⊄",
  nsubE: "⫅̸",
  nsube: "⊈",
  nsubset: "⊂⃒",
  nsubseteq: "⊈",
  nsubseteqq: "⫅̸",
  nsucc: "⊁",
  nsucceq: "⪰̸",
  nsup: "⊅",
  nsupE: "⫆̸",
  nsupe: "⊉",
  nsupset: "⊃⃒",
  nsupseteq: "⊉",
  nsupseteqq: "⫆̸",
  ntgl: "≹",
  ntilde: "ñ",
  ntlg: "≸",
  ntriangleleft: "⋪",
  ntrianglelefteq: "⋬",
  ntriangleright: "⋫",
  ntrianglerighteq: "⋭",
  nu: "ν",
  num: "#",
  numero: "№",
  numsp: " ",
  nvDash: "⊭",
  nvHarr: "⤄",
  nvap: "≍⃒",
  nvdash: "⊬",
  nvge: "≥⃒",
  nvgt: ">⃒",
  nvinfin: "⧞",
  nvlArr: "⤂",
  nvle: "≤⃒",
  nvlt: "<⃒",
  nvltrie: "⊴⃒",
  nvrArr: "⤃",
  nvrtrie: "⊵⃒",
  nvsim: "∼⃒",
  nwArr: "⇖",
  nwarhk: "⤣",
  nwarr: "↖",
  nwarrow: "↖",
  nwnear: "⤧",
  oS: "Ⓢ",
  oacute: "ó",
  oast: "⊛",
  ocir: "⊚",
  ocirc: "ô",
  ocy: "о",
  odash: "⊝",
  odblac: "ő",
  odiv: "⨸",
  odot: "⊙",
  odsold: "⦼",
  oelig: "œ",
  ofcir: "⦿",
  ofr: "𝔬",
  ogon: "˛",
  ograve: "ò",
  ogt: "⧁",
  ohbar: "⦵",
  ohm: "Ω",
  oint: "∮",
  olarr: "↺",
  olcir: "⦾",
  olcross: "⦻",
  oline: "‾",
  olt: "⧀",
  omacr: "ō",
  omega: "ω",
  omicron: "ο",
  omid: "⦶",
  ominus: "⊖",
  oopf: "𝕠",
  opar: "⦷",
  operp: "⦹",
  oplus: "⊕",
  or: "∨",
  orarr: "↻",
  ord: "⩝",
  order: "ℴ",
  orderof: "ℴ",
  ordf: "ª",
  ordm: "º",
  origof: "⊶",
  oror: "⩖",
  orslope: "⩗",
  orv: "⩛",
  oscr: "ℴ",
  oslash: "ø",
  osol: "⊘",
  otilde: "õ",
  otimes: "⊗",
  otimesas: "⨶",
  ouml: "ö",
  ovbar: "⌽",
  par: "∥",
  para: "¶",
  parallel: "∥",
  parsim: "⫳",
  parsl: "⫽",
  part: "∂",
  pcy: "п",
  percnt: "%",
  period: ".",
  permil: "‰",
  perp: "⊥",
  pertenk: "‱",
  pfr: "𝔭",
  phi: "φ",
  phiv: "ϕ",
  phmmat: "ℳ",
  phone: "☎",
  pi: "π",
  pitchfork: "⋔",
  piv: "ϖ",
  planck: "ℏ",
  planckh: "ℎ",
  plankv: "ℏ",
  plus: "+",
  plusacir: "⨣",
  plusb: "⊞",
  pluscir: "⨢",
  plusdo: "∔",
  plusdu: "⨥",
  pluse: "⩲",
  plusmn: "±",
  plussim: "⨦",
  plustwo: "⨧",
  pm: "±",
  pointint: "⨕",
  popf: "𝕡",
  pound: "£",
  pr: "≺",
  prE: "⪳",
  prap: "⪷",
  prcue: "≼",
  pre: "⪯",
  prec: "≺",
  precapprox: "⪷",
  preccurlyeq: "≼",
  preceq: "⪯",
  precnapprox: "⪹",
  precneqq: "⪵",
  precnsim: "⋨",
  precsim: "≾",
  prime: "′",
  primes: "ℙ",
  prnE: "⪵",
  prnap: "⪹",
  prnsim: "⋨",
  prod: "∏",
  profalar: "⌮",
  profline: "⌒",
  profsurf: "⌓",
  prop: "∝",
  propto: "∝",
  prsim: "≾",
  prurel: "⊰",
  pscr: "𝓅",
  psi: "ψ",
  puncsp: " ",
  qfr: "𝔮",
  qint: "⨌",
  qopf: "𝕢",
  qprime: "⁗",
  qscr: "𝓆",
  quaternions: "ℍ",
  quatint: "⨖",
  quest: "?",
  questeq: "≟",
  quot: '"',
  rAarr: "⇛",
  rArr: "⇒",
  rAtail: "⤜",
  rBarr: "⤏",
  rHar: "⥤",
  race: "∽̱",
  racute: "ŕ",
  radic: "√",
  raemptyv: "⦳",
  rang: "⟩",
  rangd: "⦒",
  range: "⦥",
  rangle: "⟩",
  raquo: "»",
  rarr: "→",
  rarrap: "⥵",
  rarrb: "⇥",
  rarrbfs: "⤠",
  rarrc: "⤳",
  rarrfs: "⤞",
  rarrhk: "↪",
  rarrlp: "↬",
  rarrpl: "⥅",
  rarrsim: "⥴",
  rarrtl: "↣",
  rarrw: "↝",
  ratail: "⤚",
  ratio: "∶",
  rationals: "ℚ",
  rbarr: "⤍",
  rbbrk: "❳",
  rbrace: "}",
  rbrack: "]",
  rbrke: "⦌",
  rbrksld: "⦎",
  rbrkslu: "⦐",
  rcaron: "ř",
  rcedil: "ŗ",
  rceil: "⌉",
  rcub: "}",
  rcy: "р",
  rdca: "⤷",
  rdldhar: "⥩",
  rdquo: "”",
  rdquor: "”",
  rdsh: "↳",
  real: "ℜ",
  realine: "ℛ",
  realpart: "ℜ",
  reals: "ℝ",
  rect: "▭",
  reg: "®",
  rfisht: "⥽",
  rfloor: "⌋",
  rfr: "𝔯",
  rhard: "⇁",
  rharu: "⇀",
  rharul: "⥬",
  rho: "ρ",
  rhov: "ϱ",
  rightarrow: "→",
  rightarrowtail: "↣",
  rightharpoondown: "⇁",
  rightharpoonup: "⇀",
  rightleftarrows: "⇄",
  rightleftharpoons: "⇌",
  rightrightarrows: "⇉",
  rightsquigarrow: "↝",
  rightthreetimes: "⋌",
  ring: "˚",
  risingdotseq: "≓",
  rlarr: "⇄",
  rlhar: "⇌",
  rlm: "‏",
  rmoust: "⎱",
  rmoustache: "⎱",
  rnmid: "⫮",
  roang: "⟭",
  roarr: "⇾",
  robrk: "⟧",
  ropar: "⦆",
  ropf: "𝕣",
  roplus: "⨮",
  rotimes: "⨵",
  rpar: ")",
  rpargt: "⦔",
  rppolint: "⨒",
  rrarr: "⇉",
  rsaquo: "›",
  rscr: "𝓇",
  rsh: "↱",
  rsqb: "]",
  rsquo: "’",
  rsquor: "’",
  rthree: "⋌",
  rtimes: "⋊",
  rtri: "▹",
  rtrie: "⊵",
  rtrif: "▸",
  rtriltri: "⧎",
  ruluhar: "⥨",
  rx: "℞",
  sacute: "ś",
  sbquo: "‚",
  sc: "≻",
  scE: "⪴",
  scap: "⪸",
  scaron: "š",
  sccue: "≽",
  sce: "⪰",
  scedil: "ş",
  scirc: "ŝ",
  scnE: "⪶",
  scnap: "⪺",
  scnsim: "⋩",
  scpolint: "⨓",
  scsim: "≿",
  scy: "с",
  sdot: "⋅",
  sdotb: "⊡",
  sdote: "⩦",
  seArr: "⇘",
  searhk: "⤥",
  searr: "↘",
  searrow: "↘",
  sect: "§",
  semi: ";",
  seswar: "⤩",
  setminus: "∖",
  setmn: "∖",
  sext: "✶",
  sfr: "𝔰",
  sfrown: "⌢",
  sharp: "♯",
  shchcy: "щ",
  shcy: "ш",
  shortmid: "∣",
  shortparallel: "∥",
  shy: "­",
  sigma: "σ",
  sigmaf: "ς",
  sigmav: "ς",
  sim: "∼",
  simdot: "⩪",
  sime: "≃",
  simeq: "≃",
  simg: "⪞",
  simgE: "⪠",
  siml: "⪝",
  simlE: "⪟",
  simne: "≆",
  simplus: "⨤",
  simrarr: "⥲",
  slarr: "←",
  smallsetminus: "∖",
  smashp: "⨳",
  smeparsl: "⧤",
  smid: "∣",
  smile: "⌣",
  smt: "⪪",
  smte: "⪬",
  smtes: "⪬︀",
  softcy: "ь",
  sol: "/",
  solb: "⧄",
  solbar: "⌿",
  sopf: "𝕤",
  spades: "♠",
  spadesuit: "♠",
  spar: "∥",
  sqcap: "⊓",
  sqcaps: "⊓︀",
  sqcup: "⊔",
  sqcups: "⊔︀",
  sqsub: "⊏",
  sqsube: "⊑",
  sqsubset: "⊏",
  sqsubseteq: "⊑",
  sqsup: "⊐",
  sqsupe: "⊒",
  sqsupset: "⊐",
  sqsupseteq: "⊒",
  squ: "□",
  square: "□",
  squarf: "▪",
  squf: "▪",
  srarr: "→",
  sscr: "𝓈",
  ssetmn: "∖",
  ssmile: "⌣",
  sstarf: "⋆",
  star: "☆",
  starf: "★",
  straightepsilon: "ϵ",
  straightphi: "ϕ",
  strns: "¯",
  sub: "⊂",
  subE: "⫅",
  subdot: "⪽",
  sube: "⊆",
  subedot: "⫃",
  submult: "⫁",
  subnE: "⫋",
  subne: "⊊",
  subplus: "⪿",
  subrarr: "⥹",
  subset: "⊂",
  subseteq: "⊆",
  subseteqq: "⫅",
  subsetneq: "⊊",
  subsetneqq: "⫋",
  subsim: "⫇",
  subsub: "⫕",
  subsup: "⫓",
  succ: "≻",
  succapprox: "⪸",
  succcurlyeq: "≽",
  succeq: "⪰",
  succnapprox: "⪺",
  succneqq: "⪶",
  succnsim: "⋩",
  succsim: "≿",
  sum: "∑",
  sung: "♪",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  sup: "⊃",
  supE: "⫆",
  supdot: "⪾",
  supdsub: "⫘",
  supe: "⊇",
  supedot: "⫄",
  suphsol: "⟉",
  suphsub: "⫗",
  suplarr: "⥻",
  supmult: "⫂",
  supnE: "⫌",
  supne: "⊋",
  supplus: "⫀",
  supset: "⊃",
  supseteq: "⊇",
  supseteqq: "⫆",
  supsetneq: "⊋",
  supsetneqq: "⫌",
  supsim: "⫈",
  supsub: "⫔",
  supsup: "⫖",
  swArr: "⇙",
  swarhk: "⤦",
  swarr: "↙",
  swarrow: "↙",
  swnwar: "⤪",
  szlig: "ß",
  target: "⌖",
  tau: "τ",
  tbrk: "⎴",
  tcaron: "ť",
  tcedil: "ţ",
  tcy: "т",
  tdot: "⃛",
  telrec: "⌕",
  tfr: "𝔱",
  there4: "∴",
  therefore: "∴",
  theta: "θ",
  thetasym: "ϑ",
  thetav: "ϑ",
  thickapprox: "≈",
  thicksim: "∼",
  thinsp: " ",
  thkap: "≈",
  thksim: "∼",
  thorn: "þ",
  tilde: "˜",
  times: "×",
  timesb: "⊠",
  timesbar: "⨱",
  timesd: "⨰",
  tint: "∭",
  toea: "⤨",
  top: "⊤",
  topbot: "⌶",
  topcir: "⫱",
  topf: "𝕥",
  topfork: "⫚",
  tosa: "⤩",
  tprime: "‴",
  trade: "™",
  triangle: "▵",
  triangledown: "▿",
  triangleleft: "◃",
  trianglelefteq: "⊴",
  triangleq: "≜",
  triangleright: "▹",
  trianglerighteq: "⊵",
  tridot: "◬",
  trie: "≜",
  triminus: "⨺",
  triplus: "⨹",
  trisb: "⧍",
  tritime: "⨻",
  trpezium: "⏢",
  tscr: "𝓉",
  tscy: "ц",
  tshcy: "ћ",
  tstrok: "ŧ",
  twixt: "≬",
  twoheadleftarrow: "↞",
  twoheadrightarrow: "↠",
  uArr: "⇑",
  uHar: "⥣",
  uacute: "ú",
  uarr: "↑",
  ubrcy: "ў",
  ubreve: "ŭ",
  ucirc: "û",
  ucy: "у",
  udarr: "⇅",
  udblac: "ű",
  udhar: "⥮",
  ufisht: "⥾",
  ufr: "𝔲",
  ugrave: "ù",
  uharl: "↿",
  uharr: "↾",
  uhblk: "▀",
  ulcorn: "⌜",
  ulcorner: "⌜",
  ulcrop: "⌏",
  ultri: "◸",
  umacr: "ū",
  uml: "¨",
  uogon: "ų",
  uopf: "𝕦",
  uparrow: "↑",
  updownarrow: "↕",
  upharpoonleft: "↿",
  upharpoonright: "↾",
  uplus: "⊎",
  upsi: "υ",
  upsih: "ϒ",
  upsilon: "υ",
  upuparrows: "⇈",
  urcorn: "⌝",
  urcorner: "⌝",
  urcrop: "⌎",
  uring: "ů",
  urtri: "◹",
  uscr: "𝓊",
  utdot: "⋰",
  utilde: "ũ",
  utri: "▵",
  utrif: "▴",
  uuarr: "⇈",
  uuml: "ü",
  uwangle: "⦧",
  vArr: "⇕",
  vBar: "⫨",
  vBarv: "⫩",
  vDash: "⊨",
  vangrt: "⦜",
  varepsilon: "ϵ",
  varkappa: "ϰ",
  varnothing: "∅",
  varphi: "ϕ",
  varpi: "ϖ",
  varpropto: "∝",
  varr: "↕",
  varrho: "ϱ",
  varsigma: "ς",
  varsubsetneq: "⊊︀",
  varsubsetneqq: "⫋︀",
  varsupsetneq: "⊋︀",
  varsupsetneqq: "⫌︀",
  vartheta: "ϑ",
  vartriangleleft: "⊲",
  vartriangleright: "⊳",
  vcy: "в",
  vdash: "⊢",
  vee: "∨",
  veebar: "⊻",
  veeeq: "≚",
  vellip: "⋮",
  verbar: "|",
  vert: "|",
  vfr: "𝔳",
  vltri: "⊲",
  vnsub: "⊂⃒",
  vnsup: "⊃⃒",
  vopf: "𝕧",
  vprop: "∝",
  vrtri: "⊳",
  vscr: "𝓋",
  vsubnE: "⫋︀",
  vsubne: "⊊︀",
  vsupnE: "⫌︀",
  vsupne: "⊋︀",
  vzigzag: "⦚",
  wcirc: "ŵ",
  wedbar: "⩟",
  wedge: "∧",
  wedgeq: "≙",
  weierp: "℘",
  wfr: "𝔴",
  wopf: "𝕨",
  wp: "℘",
  wr: "≀",
  wreath: "≀",
  wscr: "𝓌",
  xcap: "⋂",
  xcirc: "◯",
  xcup: "⋃",
  xdtri: "▽",
  xfr: "𝔵",
  xhArr: "⟺",
  xharr: "⟷",
  xi: "ξ",
  xlArr: "⟸",
  xlarr: "⟵",
  xmap: "⟼",
  xnis: "⋻",
  xodot: "⨀",
  xopf: "𝕩",
  xoplus: "⨁",
  xotime: "⨂",
  xrArr: "⟹",
  xrarr: "⟶",
  xscr: "𝓍",
  xsqcup: "⨆",
  xuplus: "⨄",
  xutri: "△",
  xvee: "⋁",
  xwedge: "⋀",
  yacute: "ý",
  yacy: "я",
  ycirc: "ŷ",
  ycy: "ы",
  yen: "¥",
  yfr: "𝔶",
  yicy: "ї",
  yopf: "𝕪",
  yscr: "𝓎",
  yucy: "ю",
  yuml: "ÿ",
  zacute: "ź",
  zcaron: "ž",
  zcy: "з",
  zdot: "ż",
  zeetrf: "ℨ",
  zeta: "ζ",
  zfr: "𝔷",
  zhcy: "ж",
  zigrarr: "⇝",
  zopf: "𝕫",
  zscr: "𝓏",
  zwj: "‍",
  zwnj: "‌"
}, sM = {}.hasOwnProperty;
function _r(e) {
  return sM.call(Bc, e) ? Bc[e] : !1;
}
function M4(e, t, r, n) {
  const i = e.length;
  let o = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, r = r > 0 ? r : 0, n.length < 1e4)
    a = Array.from(n), a.unshift(t, r), e.splice(...a);
  else
    for (r && e.splice(t, r); o < n.length; )
      a = n.slice(o, o + 1e4), a.unshift(t, 0), e.splice(...a), o += 1e4, t += 1e4;
}
function P4(e, t) {
  return e.length > 0 ? (M4(e, e.length, 0, t), e) : t;
}
const Fc = {}.hasOwnProperty;
function lM(e) {
  const t = {};
  let r = -1;
  for (; ++r < e.length; )
    uM(t, e[r]);
  return t;
}
function uM(e, t) {
  let r;
  for (r in t) {
    const n = (Fc.call(e, r) ? e[r] : void 0) || (e[r] = {}), i = t[r];
    let o;
    if (i)
      for (o in i) {
        Fc.call(n, o) || (n[o] = []);
        const a = i[o];
        cM(
          // @ts-expect-error Looks like a list.
          n[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function cM(e, t) {
  let r = -1;
  const n = [];
  for (; ++r < t.length; )
    (t[r].add === "after" ? e : n).push(t[r]);
  M4(e, 0, 0, n);
}
function vh(e, t) {
  const r = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function g0(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const x6 = W5(/[A-Za-z]/), r6 = W5(/[\dA-Za-z]/), fM = W5(/[#-'*+\--9=?A-Z^-~]/);
function wT(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ST = W5(/\d/), dM = W5(/[\dA-Fa-f]/), hM = W5(/[!-/:-@[-`{-~]/);
function Y1(e) {
  return e !== null && e < -2;
}
function p3(e) {
  return e !== null && (e < 0 || e === 32);
}
function M2(e) {
  return e === -2 || e === -1 || e === 32;
}
const pM = W5(new RegExp("\\p{P}|\\p{S}", "u")), q6 = W5(/\s/);
function W5(e) {
  return t;
  function t(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function z2(e, t, r, n) {
  const i = n ? n - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(s) {
    return M2(s) ? (e.enter(r), T(s)) : t(s);
  }
  function T(s) {
    return M2(s) && o++ < i ? (e.consume(s), T) : (e.exit(r), t(s));
  }
}
const mM = {
  tokenize: vM
};
function vM(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, n, i);
  let r;
  return t;
  function n(T) {
    if (T === null) {
      e.consume(T);
      return;
    }
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), z2(e, t, "linePrefix");
  }
  function i(T) {
    return e.enter("paragraph"), o(T);
  }
  function o(T) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = s), r = s, a(T);
  }
  function a(T) {
    if (T === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(T);
      return;
    }
    return Y1(T) ? (e.consume(T), e.exit("chunkText"), o) : (e.consume(T), a);
  }
}
const LM = {
  tokenize: yM
}, jc = {
  tokenize: gM
};
function yM(e) {
  const t = this, r = [];
  let n = 0, i, o, a;
  return T;
  function T(E) {
    if (n < r.length) {
      const M = r[n];
      return t.containerState = M[1], e.attempt(M[0].continuation, s, Q)(E);
    }
    return Q(E);
  }
  function s(E) {
    if (n++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && H();
      const M = t.events.length;
      let C = M, w;
      for (; C--; )
        if (t.events[C][0] === "exit" && t.events[C][1].type === "chunkFlow") {
          w = t.events[C][1].end;
          break;
        }
      v(n);
      let S = M;
      for (; S < t.events.length; )
        t.events[S][1].end = {
          ...w
        }, S++;
      return M4(t.events, C + 1, 0, t.events.slice(M)), t.events.length = S, Q(E);
    }
    return T(E);
  }
  function Q(E) {
    if (n === r.length) {
      if (!i)
        return c(E);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return d(E);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(jc, u, l)(E);
  }
  function u(E) {
    return i && H(), v(n), c(E);
  }
  function l(E) {
    return t.parser.lazy[t.now().line] = n !== r.length, a = t.now().offset, d(E);
  }
  function c(E) {
    return t.containerState = {}, e.attempt(jc, f, d)(E);
  }
  function f(E) {
    return n++, r.push([t.currentConstruct, t.containerState]), c(E);
  }
  function d(E) {
    if (E === null) {
      i && H(), v(0), e.consume(E);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: o
    }), m(E);
  }
  function m(E) {
    if (E === null) {
      p(e.exit("chunkFlow"), !0), v(0), e.consume(E);
      return;
    }
    return Y1(E) ? (e.consume(E), p(e.exit("chunkFlow")), n = 0, t.interrupt = void 0, T) : (e.consume(E), m);
  }
  function p(E, M) {
    const C = t.sliceStream(E);
    if (M && C.push(null), E.previous = o, o && (o.next = E), o = E, i.defineSkip(E.start), i.write(C), t.parser.lazy[E.start.line]) {
      let w = i.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          i.events[w][1].start.offset < a && // …and either is not ended yet…
          (!i.events[w][1].end || // …or ends after it.
          i.events[w][1].end.offset > a)
        )
          return;
      const S = t.events.length;
      let D = S, k, $;
      for (; D--; )
        if (t.events[D][0] === "exit" && t.events[D][1].type === "chunkFlow") {
          if (k) {
            $ = t.events[D][1].end;
            break;
          }
          k = !0;
        }
      for (v(n), w = S; w < t.events.length; )
        t.events[w][1].end = {
          ...$
        }, w++;
      M4(t.events, D + 1, 0, t.events.slice(S)), t.events.length = w;
    }
  }
  function v(E) {
    let M = r.length;
    for (; M-- > E; ) {
      const C = r[M];
      t.containerState = C[1], C[0].exit.call(t, e);
    }
    r.length = E;
  }
  function H() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function gM(e, t, r) {
  return z2(e, e.attempt(this.parser.constructs.document, t, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function C9(e) {
  if (e === null || p3(e) || q6(e))
    return 1;
  if (pM(e))
    return 2;
}
function Ro(e, t, r) {
  const n = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !n.includes(o) && (t = o(t, r), n.push(o));
  }
  return t;
}
const CT = {
  name: "attention",
  resolveAll: xM,
  tokenize: HM
};
function xM(e, t) {
  let r = -1, n, i, o, a, T, s, Q, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (n = r; n--; )
        if (e[n][0] === "exit" && e[n][1].type === "attentionSequence" && e[n][1]._open && // If the markers are the same:
        t.sliceSerialize(e[n][1]).charCodeAt(0) === t.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[n][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[n][1].end.offset - e[n][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          s = e[n][1].end.offset - e[n][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const l = {
            ...e[n][1].end
          }, c = {
            ...e[r][1].start
          };
          $c(l, -s), $c(c, s), a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: l,
            end: {
              ...e[n][1].end
            }
          }, T = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: c
          }, o = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[n][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: {
              ...a.start
            },
            end: {
              ...T.end
            }
          }, e[n][1].end = {
            ...a.start
          }, e[r][1].start = {
            ...T.end
          }, Q = [], e[n][1].end.offset - e[n][1].start.offset && (Q = P4(Q, [["enter", e[n][1], t], ["exit", e[n][1], t]])), Q = P4(Q, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["enter", o, t]]), Q = P4(Q, Ro(t.parser.constructs.insideSpan.null, e.slice(n + 1, r), t)), Q = P4(Q, [["exit", o, t], ["enter", T, t], ["exit", T, t], ["exit", i, t]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, Q = P4(Q, [["enter", e[r][1], t], ["exit", e[r][1], t]])) : u = 0, M4(e, n - 1, r - n + 3, Q), r = n + Q.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function HM(e, t) {
  const r = this.parser.constructs.attentionMarkers.null, n = this.previous, i = C9(n);
  let o;
  return a;
  function a(s) {
    return o = s, e.enter("attentionSequence"), T(s);
  }
  function T(s) {
    if (s === o)
      return e.consume(s), T;
    const Q = e.exit("attentionSequence"), u = C9(s), l = !u || u === 2 && i || r.includes(s), c = !i || i === 2 && u || r.includes(n);
    return Q._open = !!(o === 42 ? l : l && (i || !c)), Q._close = !!(o === 42 ? c : c && (u || !l)), t(s);
  }
}
function $c(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const EM = {
  name: "autolink",
  tokenize: bM
};
function bM(e, t, r) {
  let n = 0;
  return i;
  function i(f) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(f) {
    return x6(f) ? (e.consume(f), a) : f === 64 ? r(f) : Q(f);
  }
  function a(f) {
    return f === 43 || f === 45 || f === 46 || r6(f) ? (n = 1, T(f)) : Q(f);
  }
  function T(f) {
    return f === 58 ? (e.consume(f), n = 0, s) : (f === 43 || f === 45 || f === 46 || r6(f)) && n++ < 32 ? (e.consume(f), T) : (n = 0, Q(f));
  }
  function s(f) {
    return f === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : f === null || f === 32 || f === 60 || wT(f) ? r(f) : (e.consume(f), s);
  }
  function Q(f) {
    return f === 64 ? (e.consume(f), u) : fM(f) ? (e.consume(f), Q) : r(f);
  }
  function u(f) {
    return r6(f) ? l(f) : r(f);
  }
  function l(f) {
    return f === 46 ? (e.consume(f), n = 0, u) : f === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : c(f);
  }
  function c(f) {
    if ((f === 45 || r6(f)) && n++ < 63) {
      const d = f === 45 ? c : l;
      return e.consume(f), d;
    }
    return r(f);
  }
}
const No = {
  partial: !0,
  tokenize: MM
};
function MM(e, t, r) {
  return n;
  function n(o) {
    return M2(o) ? z2(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Y1(o) ? t(o) : r(o);
  }
}
const Lh = {
  continuation: {
    tokenize: SM
  },
  exit: CM,
  name: "blockQuote",
  tokenize: wM
};
function wM(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    if (a === 62) {
      const T = n.containerState;
      return T.open || (e.enter("blockQuote", {
        _container: !0
      }), T.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), o;
    }
    return r(a);
  }
  function o(a) {
    return M2(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function SM(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return M2(a) ? z2(e, o, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a) : o(a);
  }
  function o(a) {
    return e.attempt(Lh, t, r)(a);
  }
}
function CM(e) {
  e.exit("blockQuote");
}
const yh = {
  name: "characterEscape",
  tokenize: VM
};
function VM(e, t, r) {
  return n;
  function n(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return hM(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : r(o);
  }
}
const gh = {
  name: "characterReference",
  tokenize: _M
};
function _M(e, t, r) {
  const n = this;
  let i = 0, o, a;
  return T;
  function T(l) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(l), e.exit("characterReferenceMarker"), s;
  }
  function s(l) {
    return l === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(l), e.exit("characterReferenceMarkerNumeric"), Q) : (e.enter("characterReferenceValue"), o = 31, a = r6, u(l));
  }
  function Q(l) {
    return l === 88 || l === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(l), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, a = dM, u) : (e.enter("characterReferenceValue"), o = 7, a = ST, u(l));
  }
  function u(l) {
    if (l === 59 && i) {
      const c = e.exit("characterReferenceValue");
      return a === r6 && !_r(n.sliceSerialize(c)) ? r(l) : (e.enter("characterReferenceMarker"), e.consume(l), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(l) && i++ < o ? (e.consume(l), u) : r(l);
  }
}
const Zc = {
  partial: !0,
  tokenize: AM
}, Wc = {
  concrete: !0,
  name: "codeFenced",
  tokenize: OM
};
function OM(e, t, r) {
  const n = this, i = {
    partial: !0,
    tokenize: C
  };
  let o = 0, a = 0, T;
  return s;
  function s(w) {
    return Q(w);
  }
  function Q(w) {
    const S = n.events[n.events.length - 1];
    return o = S && S[1].type === "linePrefix" ? S[2].sliceSerialize(S[1], !0).length : 0, T = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(w);
  }
  function u(w) {
    return w === T ? (a++, e.consume(w), u) : a < 3 ? r(w) : (e.exit("codeFencedFenceSequence"), M2(w) ? z2(e, l, "whitespace")(w) : l(w));
  }
  function l(w) {
    return w === null || Y1(w) ? (e.exit("codeFencedFence"), n.interrupt ? t(w) : e.check(Zc, m, M)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), c(w));
  }
  function c(w) {
    return w === null || Y1(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), l(w)) : M2(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), z2(e, f, "whitespace")(w)) : w === 96 && w === T ? r(w) : (e.consume(w), c);
  }
  function f(w) {
    return w === null || Y1(w) ? l(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), d(w));
  }
  function d(w) {
    return w === null || Y1(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), l(w)) : w === 96 && w === T ? r(w) : (e.consume(w), d);
  }
  function m(w) {
    return e.attempt(i, M, p)(w);
  }
  function p(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), v;
  }
  function v(w) {
    return o > 0 && M2(w) ? z2(e, H, "linePrefix", o + 1)(w) : H(w);
  }
  function H(w) {
    return w === null || Y1(w) ? e.check(Zc, m, M)(w) : (e.enter("codeFlowValue"), E(w));
  }
  function E(w) {
    return w === null || Y1(w) ? (e.exit("codeFlowValue"), H(w)) : (e.consume(w), E);
  }
  function M(w) {
    return e.exit("codeFenced"), t(w);
  }
  function C(w, S, D) {
    let k = 0;
    return $;
    function $(t1) {
      return w.enter("lineEnding"), w.consume(t1), w.exit("lineEnding"), z;
    }
    function z(t1) {
      return w.enter("codeFencedFence"), M2(t1) ? z2(w, j, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t1) : j(t1);
    }
    function j(t1) {
      return t1 === T ? (w.enter("codeFencedFenceSequence"), J(t1)) : D(t1);
    }
    function J(t1) {
      return t1 === T ? (k++, w.consume(t1), J) : k >= a ? (w.exit("codeFencedFenceSequence"), M2(t1) ? z2(w, i1, "whitespace")(t1) : i1(t1)) : D(t1);
    }
    function i1(t1) {
      return t1 === null || Y1(t1) ? (w.exit("codeFencedFence"), S(t1)) : D(t1);
    }
  }
}
function AM(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return a === null ? r(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o);
  }
  function o(a) {
    return n.parser.lazy[n.now().line] ? r(a) : t(a);
  }
}
const kQ = {
  name: "codeIndented",
  tokenize: kM
}, DM = {
  partial: !0,
  tokenize: IM
};
function kM(e, t, r) {
  const n = this;
  return i;
  function i(Q) {
    return e.enter("codeIndented"), z2(e, o, "linePrefix", 5)(Q);
  }
  function o(Q) {
    const u = n.events[n.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? a(Q) : r(Q);
  }
  function a(Q) {
    return Q === null ? s(Q) : Y1(Q) ? e.attempt(DM, a, s)(Q) : (e.enter("codeFlowValue"), T(Q));
  }
  function T(Q) {
    return Q === null || Y1(Q) ? (e.exit("codeFlowValue"), a(Q)) : (e.consume(Q), T);
  }
  function s(Q) {
    return e.exit("codeIndented"), t(Q);
  }
}
function IM(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return n.parser.lazy[n.now().line] ? r(a) : Y1(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : z2(e, o, "linePrefix", 5)(a);
  }
  function o(a) {
    const T = n.events[n.events.length - 1];
    return T && T[1].type === "linePrefix" && T[2].sliceSerialize(T[1], !0).length >= 4 ? t(a) : Y1(a) ? i(a) : r(a);
  }
}
const RM = {
  name: "codeText",
  previous: PM,
  resolve: NM,
  tokenize: BM
};
function NM(e) {
  let t = e.length - 4, r = 3, n, i;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (n = r; ++n < t; )
      if (e[n][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", r += 2, t -= 2;
        break;
      }
  }
  for (n = r - 1, t++; ++n <= t; )
    i === void 0 ? n !== t && e[n][1].type !== "lineEnding" && (i = n) : (n === t || e[n][1].type === "lineEnding") && (e[i][1].type = "codeTextData", n !== i + 2 && (e[i][1].end = e[n - 1][1].end, e.splice(i + 2, n - i - 2), t -= n - i - 2, n = i + 2), i = void 0);
  return e;
}
function PM(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function BM(e, t, r) {
  let n = 0, i, o;
  return a;
  function a(l) {
    return e.enter("codeText"), e.enter("codeTextSequence"), T(l);
  }
  function T(l) {
    return l === 96 ? (e.consume(l), n++, T) : (e.exit("codeTextSequence"), s(l));
  }
  function s(l) {
    return l === null ? r(l) : l === 32 ? (e.enter("space"), e.consume(l), e.exit("space"), s) : l === 96 ? (o = e.enter("codeTextSequence"), i = 0, u(l)) : Y1(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), s) : (e.enter("codeTextData"), Q(l));
  }
  function Q(l) {
    return l === null || l === 32 || l === 96 || Y1(l) ? (e.exit("codeTextData"), s(l)) : (e.consume(l), Q);
  }
  function u(l) {
    return l === 96 ? (e.consume(l), i++, u) : i === n ? (e.exit("codeTextSequence"), e.exit("codeText"), t(l)) : (o.type = "codeTextData", Q(l));
  }
}
class FM {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, r) {
    const n = r ?? Number.POSITIVE_INFINITY;
    return n < this.left.length ? this.left.slice(t, n) : t > this.left.length ? this.right.slice(this.right.length - n + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - n + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, r, n) {
    const i = r || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return n && yr(this.left, n), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), yr(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), yr(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const r = this.left.splice(t, Number.POSITIVE_INFINITY);
        yr(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        yr(this.left, r.reverse());
      }
  }
}
function yr(e, t) {
  let r = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; r < t.length; )
      e.push(...t.slice(r, r + 1e4)), r += 1e4;
}
function xh(e) {
  const t = {};
  let r = -1, n, i, o, a, T, s, Q;
  const u = new FM(e);
  for (; ++r < u.length; ) {
    for (; r in t; )
      r = t[r];
    if (n = u.get(r), r && n[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (s = n[1]._tokenizer.events, o = 0, o < s.length && s[o][1].type === "lineEndingBlank" && (o += 2), o < s.length && s[o][1].type === "content"))
      for (; ++o < s.length && s[o][1].type !== "content"; )
        s[o][1].type === "chunkText" && (s[o][1]._isInFirstContentOfListItem = !0, o++);
    if (n[0] === "enter")
      n[1].contentType && (Object.assign(t, jM(u, r)), r = t[r], Q = !0);
    else if (n[1]._container) {
      for (o = r, i = void 0; o-- && (a = u.get(o), a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (n[1].end = {
        ...u.get(i)[1].start
      }, T = u.slice(i, r), T.unshift(n), u.splice(i, r - i + 1, T));
    }
  }
  return M4(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !Q;
}
function jM(e, t) {
  const r = e.get(t)[1], n = e.get(t)[2];
  let i = t - 1;
  const o = [], a = r._tokenizer || n.parser[r.contentType](r.start), T = a.events, s = [], Q = {};
  let u, l, c = -1, f = r, d = 0, m = 0;
  const p = [m];
  for (; f; ) {
    for (; e.get(++i)[1] !== f; )
      ;
    o.push(i), f._tokenizer || (u = n.sliceStream(f), f.next || u.push(null), l && a.defineSkip(f.start), f._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(u), f._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), l = f, f = f.next;
  }
  for (f = r; ++c < T.length; )
    T[c][0] === "exit" && T[c - 1][0] === "enter" && T[c][1].type === T[c - 1][1].type && T[c][1].start.line !== T[c][1].end.line && (m = c + 1, p.push(m), f._tokenizer = void 0, f.previous = void 0, f = f.next);
  for (a.events = [], f ? (f._tokenizer = void 0, f.previous = void 0) : p.pop(), c = p.length; c--; ) {
    const v = T.slice(p[c], p[c + 1]), H = o.pop();
    s.push([H, H + v.length - 1]), e.splice(H, 2, v);
  }
  for (s.reverse(), c = -1; ++c < s.length; )
    Q[d + s[c][0]] = d + s[c][1], d += s[c][1] - s[c][0] - 1;
  return Q;
}
const $M = {
  resolve: WM,
  tokenize: GM
}, ZM = {
  partial: !0,
  tokenize: zM
};
function WM(e) {
  return xh(e), e;
}
function GM(e, t) {
  let r;
  return n;
  function n(T) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), i(T);
  }
  function i(T) {
    return T === null ? o(T) : Y1(T) ? e.check(ZM, a, o)(T) : (e.consume(T), i);
  }
  function o(T) {
    return e.exit("chunkContent"), e.exit("content"), t(T);
  }
  function a(T) {
    return e.consume(T), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, i;
  }
}
function zM(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), z2(e, o, "linePrefix");
  }
  function o(a) {
    if (a === null || Y1(a))
      return r(a);
    const T = n.events[n.events.length - 1];
    return !n.parser.constructs.disable.null.includes("codeIndented") && T && T[1].type === "linePrefix" && T[2].sliceSerialize(T[1], !0).length >= 4 ? t(a) : e.interrupt(n.parser.constructs.flow, r, t)(a);
  }
}
function Hh(e, t, r, n, i, o, a, T, s) {
  const Q = s || Number.POSITIVE_INFINITY;
  let u = 0;
  return l;
  function l(v) {
    return v === 60 ? (e.enter(n), e.enter(i), e.enter(o), e.consume(v), e.exit(o), c) : v === null || v === 32 || v === 41 || wT(v) ? r(v) : (e.enter(n), e.enter(a), e.enter(T), e.enter("chunkString", {
      contentType: "string"
    }), m(v));
  }
  function c(v) {
    return v === 62 ? (e.enter(o), e.consume(v), e.exit(o), e.exit(i), e.exit(n), t) : (e.enter(T), e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === 62 ? (e.exit("chunkString"), e.exit(T), c(v)) : v === null || v === 60 || Y1(v) ? r(v) : (e.consume(v), v === 92 ? d : f);
  }
  function d(v) {
    return v === 60 || v === 62 || v === 92 ? (e.consume(v), f) : f(v);
  }
  function m(v) {
    return !u && (v === null || v === 41 || p3(v)) ? (e.exit("chunkString"), e.exit(T), e.exit(a), e.exit(n), t(v)) : u < Q && v === 40 ? (e.consume(v), u++, m) : v === 41 ? (e.consume(v), u--, m) : v === null || v === 32 || v === 40 || wT(v) ? r(v) : (e.consume(v), v === 92 ? p : m);
  }
  function p(v) {
    return v === 40 || v === 41 || v === 92 ? (e.consume(v), m) : m(v);
  }
}
function Eh(e, t, r, n, i, o) {
  const a = this;
  let T = 0, s;
  return Q;
  function Q(f) {
    return e.enter(n), e.enter(i), e.consume(f), e.exit(i), e.enter(o), u;
  }
  function u(f) {
    return T > 999 || f === null || f === 91 || f === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    f === 94 && !T && "_hiddenFootnoteSupport" in a.parser.constructs ? r(f) : f === 93 ? (e.exit(o), e.enter(i), e.consume(f), e.exit(i), e.exit(n), t) : Y1(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), l(f));
  }
  function l(f) {
    return f === null || f === 91 || f === 93 || Y1(f) || T++ > 999 ? (e.exit("chunkString"), u(f)) : (e.consume(f), s || (s = !M2(f)), f === 92 ? c : l);
  }
  function c(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), T++, l) : l(f);
  }
}
function bh(e, t, r, n, i, o) {
  let a;
  return T;
  function T(c) {
    return c === 34 || c === 39 || c === 40 ? (e.enter(n), e.enter(i), e.consume(c), e.exit(i), a = c === 40 ? 41 : c, s) : r(c);
  }
  function s(c) {
    return c === a ? (e.enter(i), e.consume(c), e.exit(i), e.exit(n), t) : (e.enter(o), Q(c));
  }
  function Q(c) {
    return c === a ? (e.exit(o), s(a)) : c === null ? r(c) : Y1(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), z2(e, Q, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(c));
  }
  function u(c) {
    return c === a || c === null || Y1(c) ? (e.exit("chunkString"), Q(c)) : (e.consume(c), c === 92 ? l : u);
  }
  function l(c) {
    return c === a || c === 92 ? (e.consume(c), u) : u(c);
  }
}
function Mr(e, t) {
  let r;
  return n;
  function n(i) {
    return Y1(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), r = !0, n) : M2(i) ? z2(e, n, r ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const UM = {
  name: "definition",
  tokenize: qM
}, XM = {
  partial: !0,
  tokenize: JM
};
function qM(e, t, r) {
  const n = this;
  let i;
  return o;
  function o(f) {
    return e.enter("definition"), a(f);
  }
  function a(f) {
    return Eh.call(
      n,
      e,
      T,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(f);
  }
  function T(f) {
    return i = g0(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1)), f === 58 ? (e.enter("definitionMarker"), e.consume(f), e.exit("definitionMarker"), s) : r(f);
  }
  function s(f) {
    return p3(f) ? Mr(e, Q)(f) : Q(f);
  }
  function Q(f) {
    return Hh(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(f);
  }
  function u(f) {
    return e.attempt(XM, l, l)(f);
  }
  function l(f) {
    return M2(f) ? z2(e, c, "whitespace")(f) : c(f);
  }
  function c(f) {
    return f === null || Y1(f) ? (e.exit("definition"), n.parser.defined.push(i), t(f)) : r(f);
  }
}
function JM(e, t, r) {
  return n;
  function n(T) {
    return p3(T) ? Mr(e, i)(T) : r(T);
  }
  function i(T) {
    return bh(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(T);
  }
  function o(T) {
    return M2(T) ? z2(e, a, "whitespace")(T) : a(T);
  }
  function a(T) {
    return T === null || Y1(T) ? t(T) : r(T);
  }
}
const YM = {
  name: "hardBreakEscape",
  tokenize: KM
};
function KM(e, t, r) {
  return n;
  function n(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return Y1(o) ? (e.exit("hardBreakEscape"), t(o)) : r(o);
  }
}
const ew = {
  name: "headingAtx",
  resolve: tw,
  tokenize: rw
};
function tw(e, t) {
  let r = e.length - 2, n = 3, i, o;
  return e[n][1].type === "whitespace" && (n += 2), r - 2 > n && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (n === r - 1 || r - 4 > n && e[r - 2][1].type === "whitespace") && (r -= n + 1 === r ? 2 : 4), r > n && (i = {
    type: "atxHeadingText",
    start: e[n][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[n][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, M4(e, n, r - n + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function rw(e, t, r) {
  let n = 0;
  return i;
  function i(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), a(u);
  }
  function a(u) {
    return u === 35 && n++ < 6 ? (e.consume(u), a) : u === null || p3(u) ? (e.exit("atxHeadingSequence"), T(u)) : r(u);
  }
  function T(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), s(u)) : u === null || Y1(u) ? (e.exit("atxHeading"), t(u)) : M2(u) ? z2(e, T, "whitespace")(u) : (e.enter("atxHeadingText"), Q(u));
  }
  function s(u) {
    return u === 35 ? (e.consume(u), s) : (e.exit("atxHeadingSequence"), T(u));
  }
  function Q(u) {
    return u === null || u === 35 || p3(u) ? (e.exit("atxHeadingText"), T(u)) : (e.consume(u), Q);
  }
}
const nw = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Gc = ["pre", "script", "style", "textarea"], iw = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Qw,
  tokenize: Tw
}, ow = {
  partial: !0,
  tokenize: lw
}, aw = {
  partial: !0,
  tokenize: sw
};
function Qw(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Tw(e, t, r) {
  const n = this;
  let i, o, a, T, s;
  return Q;
  function Q(q) {
    return u(q);
  }
  function u(q) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(q), l;
  }
  function l(q) {
    return q === 33 ? (e.consume(q), c) : q === 47 ? (e.consume(q), o = !0, m) : q === 63 ? (e.consume(q), i = 3, n.interrupt ? t : Z) : x6(q) ? (e.consume(q), a = String.fromCharCode(q), p) : r(q);
  }
  function c(q) {
    return q === 45 ? (e.consume(q), i = 2, f) : q === 91 ? (e.consume(q), i = 5, T = 0, d) : x6(q) ? (e.consume(q), i = 4, n.interrupt ? t : Z) : r(q);
  }
  function f(q) {
    return q === 45 ? (e.consume(q), n.interrupt ? t : Z) : r(q);
  }
  function d(q) {
    const N1 = "CDATA[";
    return q === N1.charCodeAt(T++) ? (e.consume(q), T === N1.length ? n.interrupt ? t : j : d) : r(q);
  }
  function m(q) {
    return x6(q) ? (e.consume(q), a = String.fromCharCode(q), p) : r(q);
  }
  function p(q) {
    if (q === null || q === 47 || q === 62 || p3(q)) {
      const N1 = q === 47, O1 = a.toLowerCase();
      return !N1 && !o && Gc.includes(O1) ? (i = 1, n.interrupt ? t(q) : j(q)) : nw.includes(a.toLowerCase()) ? (i = 6, N1 ? (e.consume(q), v) : n.interrupt ? t(q) : j(q)) : (i = 7, n.interrupt && !n.parser.lazy[n.now().line] ? r(q) : o ? H(q) : E(q));
    }
    return q === 45 || r6(q) ? (e.consume(q), a += String.fromCharCode(q), p) : r(q);
  }
  function v(q) {
    return q === 62 ? (e.consume(q), n.interrupt ? t : j) : r(q);
  }
  function H(q) {
    return M2(q) ? (e.consume(q), H) : $(q);
  }
  function E(q) {
    return q === 47 ? (e.consume(q), $) : q === 58 || q === 95 || x6(q) ? (e.consume(q), M) : M2(q) ? (e.consume(q), E) : $(q);
  }
  function M(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || r6(q) ? (e.consume(q), M) : C(q);
  }
  function C(q) {
    return q === 61 ? (e.consume(q), w) : M2(q) ? (e.consume(q), C) : E(q);
  }
  function w(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? r(q) : q === 34 || q === 39 ? (e.consume(q), s = q, S) : M2(q) ? (e.consume(q), w) : D(q);
  }
  function S(q) {
    return q === s ? (e.consume(q), s = null, k) : q === null || Y1(q) ? r(q) : (e.consume(q), S);
  }
  function D(q) {
    return q === null || q === 34 || q === 39 || q === 47 || q === 60 || q === 61 || q === 62 || q === 96 || p3(q) ? C(q) : (e.consume(q), D);
  }
  function k(q) {
    return q === 47 || q === 62 || M2(q) ? E(q) : r(q);
  }
  function $(q) {
    return q === 62 ? (e.consume(q), z) : r(q);
  }
  function z(q) {
    return q === null || Y1(q) ? j(q) : M2(q) ? (e.consume(q), z) : r(q);
  }
  function j(q) {
    return q === 45 && i === 2 ? (e.consume(q), T1) : q === 60 && i === 1 ? (e.consume(q), X) : q === 62 && i === 4 ? (e.consume(q), L1) : q === 63 && i === 3 ? (e.consume(q), Z) : q === 93 && i === 5 ? (e.consume(q), s1) : Y1(q) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(ow, C1, J)(q)) : q === null || Y1(q) ? (e.exit("htmlFlowData"), J(q)) : (e.consume(q), j);
  }
  function J(q) {
    return e.check(aw, i1, C1)(q);
  }
  function i1(q) {
    return e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), t1;
  }
  function t1(q) {
    return q === null || Y1(q) ? J(q) : (e.enter("htmlFlowData"), j(q));
  }
  function T1(q) {
    return q === 45 ? (e.consume(q), Z) : j(q);
  }
  function X(q) {
    return q === 47 ? (e.consume(q), a = "", f1) : j(q);
  }
  function f1(q) {
    if (q === 62) {
      const N1 = a.toLowerCase();
      return Gc.includes(N1) ? (e.consume(q), L1) : j(q);
    }
    return x6(q) && a.length < 8 ? (e.consume(q), a += String.fromCharCode(q), f1) : j(q);
  }
  function s1(q) {
    return q === 93 ? (e.consume(q), Z) : j(q);
  }
  function Z(q) {
    return q === 62 ? (e.consume(q), L1) : q === 45 && i === 2 ? (e.consume(q), Z) : j(q);
  }
  function L1(q) {
    return q === null || Y1(q) ? (e.exit("htmlFlowData"), C1(q)) : (e.consume(q), L1);
  }
  function C1(q) {
    return e.exit("htmlFlow"), t(q);
  }
}
function sw(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return Y1(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o) : r(a);
  }
  function o(a) {
    return n.parser.lazy[n.now().line] ? r(a) : t(a);
  }
}
function lw(e, t, r) {
  return n;
  function n(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(No, t, r);
  }
}
const uw = {
  name: "htmlText",
  tokenize: cw
};
function cw(e, t, r) {
  const n = this;
  let i, o, a;
  return T;
  function T(Z) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(Z), s;
  }
  function s(Z) {
    return Z === 33 ? (e.consume(Z), Q) : Z === 47 ? (e.consume(Z), C) : Z === 63 ? (e.consume(Z), E) : x6(Z) ? (e.consume(Z), D) : r(Z);
  }
  function Q(Z) {
    return Z === 45 ? (e.consume(Z), u) : Z === 91 ? (e.consume(Z), o = 0, d) : x6(Z) ? (e.consume(Z), H) : r(Z);
  }
  function u(Z) {
    return Z === 45 ? (e.consume(Z), f) : r(Z);
  }
  function l(Z) {
    return Z === null ? r(Z) : Z === 45 ? (e.consume(Z), c) : Y1(Z) ? (a = l, X(Z)) : (e.consume(Z), l);
  }
  function c(Z) {
    return Z === 45 ? (e.consume(Z), f) : l(Z);
  }
  function f(Z) {
    return Z === 62 ? T1(Z) : Z === 45 ? c(Z) : l(Z);
  }
  function d(Z) {
    const L1 = "CDATA[";
    return Z === L1.charCodeAt(o++) ? (e.consume(Z), o === L1.length ? m : d) : r(Z);
  }
  function m(Z) {
    return Z === null ? r(Z) : Z === 93 ? (e.consume(Z), p) : Y1(Z) ? (a = m, X(Z)) : (e.consume(Z), m);
  }
  function p(Z) {
    return Z === 93 ? (e.consume(Z), v) : m(Z);
  }
  function v(Z) {
    return Z === 62 ? T1(Z) : Z === 93 ? (e.consume(Z), v) : m(Z);
  }
  function H(Z) {
    return Z === null || Z === 62 ? T1(Z) : Y1(Z) ? (a = H, X(Z)) : (e.consume(Z), H);
  }
  function E(Z) {
    return Z === null ? r(Z) : Z === 63 ? (e.consume(Z), M) : Y1(Z) ? (a = E, X(Z)) : (e.consume(Z), E);
  }
  function M(Z) {
    return Z === 62 ? T1(Z) : E(Z);
  }
  function C(Z) {
    return x6(Z) ? (e.consume(Z), w) : r(Z);
  }
  function w(Z) {
    return Z === 45 || r6(Z) ? (e.consume(Z), w) : S(Z);
  }
  function S(Z) {
    return Y1(Z) ? (a = S, X(Z)) : M2(Z) ? (e.consume(Z), S) : T1(Z);
  }
  function D(Z) {
    return Z === 45 || r6(Z) ? (e.consume(Z), D) : Z === 47 || Z === 62 || p3(Z) ? k(Z) : r(Z);
  }
  function k(Z) {
    return Z === 47 ? (e.consume(Z), T1) : Z === 58 || Z === 95 || x6(Z) ? (e.consume(Z), $) : Y1(Z) ? (a = k, X(Z)) : M2(Z) ? (e.consume(Z), k) : T1(Z);
  }
  function $(Z) {
    return Z === 45 || Z === 46 || Z === 58 || Z === 95 || r6(Z) ? (e.consume(Z), $) : z(Z);
  }
  function z(Z) {
    return Z === 61 ? (e.consume(Z), j) : Y1(Z) ? (a = z, X(Z)) : M2(Z) ? (e.consume(Z), z) : k(Z);
  }
  function j(Z) {
    return Z === null || Z === 60 || Z === 61 || Z === 62 || Z === 96 ? r(Z) : Z === 34 || Z === 39 ? (e.consume(Z), i = Z, J) : Y1(Z) ? (a = j, X(Z)) : M2(Z) ? (e.consume(Z), j) : (e.consume(Z), i1);
  }
  function J(Z) {
    return Z === i ? (e.consume(Z), i = void 0, t1) : Z === null ? r(Z) : Y1(Z) ? (a = J, X(Z)) : (e.consume(Z), J);
  }
  function i1(Z) {
    return Z === null || Z === 34 || Z === 39 || Z === 60 || Z === 61 || Z === 96 ? r(Z) : Z === 47 || Z === 62 || p3(Z) ? k(Z) : (e.consume(Z), i1);
  }
  function t1(Z) {
    return Z === 47 || Z === 62 || p3(Z) ? k(Z) : r(Z);
  }
  function T1(Z) {
    return Z === 62 ? (e.consume(Z), e.exit("htmlTextData"), e.exit("htmlText"), t) : r(Z);
  }
  function X(Z) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(Z), e.exit("lineEnding"), f1;
  }
  function f1(Z) {
    return M2(Z) ? z2(e, s1, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(Z) : s1(Z);
  }
  function s1(Z) {
    return e.enter("htmlTextData"), a(Z);
  }
}
const Bs = {
  name: "labelEnd",
  resolveAll: pw,
  resolveTo: mw,
  tokenize: vw
}, fw = {
  tokenize: Lw
}, dw = {
  tokenize: yw
}, hw = {
  tokenize: gw
};
function pw(e) {
  let t = -1;
  const r = [];
  for (; ++t < e.length; ) {
    const n = e[t][1];
    if (r.push(e[t]), n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") {
      const i = n.type === "labelImage" ? 4 : 2;
      n.type = "data", t += i;
    }
  }
  return e.length !== r.length && M4(e, 0, e.length, r), e;
}
function mw(e, t) {
  let r = e.length, n = 0, i, o, a, T;
  for (; r--; )
    if (i = e[r][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[r][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (e[r][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = r, i.type !== "labelLink")) {
        n = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = r);
  const s = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, Q = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[a][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + n + 2][1].end
    },
    end: {
      ...e[a - 2][1].start
    }
  };
  return T = [["enter", s, t], ["enter", Q, t]], T = P4(T, e.slice(o + 1, o + n + 3)), T = P4(T, [["enter", u, t]]), T = P4(T, Ro(t.parser.constructs.insideSpan.null, e.slice(o + n + 4, a - 3), t)), T = P4(T, [["exit", u, t], e[a - 2], e[a - 1], ["exit", Q, t]]), T = P4(T, e.slice(a + 1)), T = P4(T, [["exit", s, t]]), M4(e, o, e.length, T), e;
}
function vw(e, t, r) {
  const n = this;
  let i = n.events.length, o, a;
  for (; i--; )
    if ((n.events[i][1].type === "labelImage" || n.events[i][1].type === "labelLink") && !n.events[i][1]._balanced) {
      o = n.events[i][1];
      break;
    }
  return T;
  function T(c) {
    return o ? o._inactive ? l(c) : (a = n.parser.defined.includes(g0(n.sliceSerialize({
      start: o.end,
      end: n.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(c), e.exit("labelMarker"), e.exit("labelEnd"), s) : r(c);
  }
  function s(c) {
    return c === 40 ? e.attempt(fw, u, a ? u : l)(c) : c === 91 ? e.attempt(dw, u, a ? Q : l)(c) : a ? u(c) : l(c);
  }
  function Q(c) {
    return e.attempt(hw, u, l)(c);
  }
  function u(c) {
    return t(c);
  }
  function l(c) {
    return o._balanced = !0, r(c);
  }
}
function Lw(e, t, r) {
  return n;
  function n(l) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(l), e.exit("resourceMarker"), i;
  }
  function i(l) {
    return p3(l) ? Mr(e, o)(l) : o(l);
  }
  function o(l) {
    return l === 41 ? u(l) : Hh(e, a, T, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(l);
  }
  function a(l) {
    return p3(l) ? Mr(e, s)(l) : u(l);
  }
  function T(l) {
    return r(l);
  }
  function s(l) {
    return l === 34 || l === 39 || l === 40 ? bh(e, Q, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(l) : u(l);
  }
  function Q(l) {
    return p3(l) ? Mr(e, u)(l) : u(l);
  }
  function u(l) {
    return l === 41 ? (e.enter("resourceMarker"), e.consume(l), e.exit("resourceMarker"), e.exit("resource"), t) : r(l);
  }
}
function yw(e, t, r) {
  const n = this;
  return i;
  function i(T) {
    return Eh.call(n, e, o, a, "reference", "referenceMarker", "referenceString")(T);
  }
  function o(T) {
    return n.parser.defined.includes(g0(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1))) ? t(T) : r(T);
  }
  function a(T) {
    return r(T);
  }
}
function gw(e, t, r) {
  return n;
  function n(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : r(o);
  }
}
const xw = {
  name: "labelStartImage",
  resolveAll: Bs.resolveAll,
  tokenize: Hw
};
function Hw(e, t, r) {
  const n = this;
  return i;
  function i(T) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(T), e.exit("labelImageMarker"), o;
  }
  function o(T) {
    return T === 91 ? (e.enter("labelMarker"), e.consume(T), e.exit("labelMarker"), e.exit("labelImage"), a) : r(T);
  }
  function a(T) {
    return T === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? r(T) : t(T);
  }
}
const Ew = {
  name: "labelStartLink",
  resolveAll: Bs.resolveAll,
  tokenize: bw
};
function bw(e, t, r) {
  const n = this;
  return i;
  function i(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? r(a) : t(a);
  }
}
const IQ = {
  name: "lineEnding",
  tokenize: Mw
};
function Mw(e, t) {
  return r;
  function r(n) {
    return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), z2(e, t, "linePrefix");
  }
}
const zn = {
  name: "thematicBreak",
  tokenize: ww
};
function ww(e, t, r) {
  let n = 0, i;
  return o;
  function o(Q) {
    return e.enter("thematicBreak"), a(Q);
  }
  function a(Q) {
    return i = Q, T(Q);
  }
  function T(Q) {
    return Q === i ? (e.enter("thematicBreakSequence"), s(Q)) : n >= 3 && (Q === null || Y1(Q)) ? (e.exit("thematicBreak"), t(Q)) : r(Q);
  }
  function s(Q) {
    return Q === i ? (e.consume(Q), n++, s) : (e.exit("thematicBreakSequence"), M2(Q) ? z2(e, T, "whitespace")(Q) : T(Q));
  }
}
const f4 = {
  continuation: {
    tokenize: _w
  },
  exit: Aw,
  name: "list",
  tokenize: Vw
}, Sw = {
  partial: !0,
  tokenize: Dw
}, Cw = {
  partial: !0,
  tokenize: Ow
};
function Vw(e, t, r) {
  const n = this, i = n.events[n.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return T;
  function T(f) {
    const d = n.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (d === "listUnordered" ? !n.containerState.marker || f === n.containerState.marker : ST(f)) {
      if (n.containerState.type || (n.containerState.type = d, e.enter(d, {
        _container: !0
      })), d === "listUnordered")
        return e.enter("listItemPrefix"), f === 42 || f === 45 ? e.check(zn, r, Q)(f) : Q(f);
      if (!n.interrupt || f === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(f);
    }
    return r(f);
  }
  function s(f) {
    return ST(f) && ++a < 10 ? (e.consume(f), s) : (!n.interrupt || a < 2) && (n.containerState.marker ? f === n.containerState.marker : f === 41 || f === 46) ? (e.exit("listItemValue"), Q(f)) : r(f);
  }
  function Q(f) {
    return e.enter("listItemMarker"), e.consume(f), e.exit("listItemMarker"), n.containerState.marker = n.containerState.marker || f, e.check(
      No,
      // Can’t be empty when interrupting.
      n.interrupt ? r : u,
      e.attempt(Sw, c, l)
    );
  }
  function u(f) {
    return n.containerState.initialBlankLine = !0, o++, c(f);
  }
  function l(f) {
    return M2(f) ? (e.enter("listItemPrefixWhitespace"), e.consume(f), e.exit("listItemPrefixWhitespace"), c) : r(f);
  }
  function c(f) {
    return n.containerState.size = o + n.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(f);
  }
}
function _w(e, t, r) {
  const n = this;
  return n.containerState._closeFlow = void 0, e.check(No, i, o);
  function i(T) {
    return n.containerState.furtherBlankLines = n.containerState.furtherBlankLines || n.containerState.initialBlankLine, z2(e, t, "listItemIndent", n.containerState.size + 1)(T);
  }
  function o(T) {
    return n.containerState.furtherBlankLines || !M2(T) ? (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, a(T)) : (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, e.attempt(Cw, t, a)(T));
  }
  function a(T) {
    return n.containerState._closeFlow = !0, n.interrupt = void 0, z2(e, e.attempt(f4, t, r), "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(T);
  }
}
function Ow(e, t, r) {
  const n = this;
  return z2(e, i, "listItemIndent", n.containerState.size + 1);
  function i(o) {
    const a = n.events[n.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === n.containerState.size ? t(o) : r(o);
  }
}
function Aw(e) {
  e.exit(this.containerState.type);
}
function Dw(e, t, r) {
  const n = this;
  return z2(e, i, "listItemPrefixWhitespace", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const a = n.events[n.events.length - 1];
    return !M2(o) && a && a[1].type === "listItemPrefixWhitespace" ? t(o) : r(o);
  }
}
const zc = {
  name: "setextUnderline",
  resolveTo: kw,
  tokenize: Iw
};
function kw(e, t) {
  let r = e.length, n, i, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        n = r;
        break;
      }
      e[r][1].type === "paragraph" && (i = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const a = {
    type: "setextHeading",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", a, t]), e.splice(o + 1, 0, ["exit", e[n][1], t]), e[n][1].end = {
    ...e[o][1].end
  }) : e[n][1] = a, e.push(["exit", a, t]), e;
}
function Iw(e, t, r) {
  const n = this;
  let i;
  return o;
  function o(Q) {
    let u = n.events.length, l;
    for (; u--; )
      if (n.events[u][1].type !== "lineEnding" && n.events[u][1].type !== "linePrefix" && n.events[u][1].type !== "content") {
        l = n.events[u][1].type === "paragraph";
        break;
      }
    return !n.parser.lazy[n.now().line] && (n.interrupt || l) ? (e.enter("setextHeadingLine"), i = Q, a(Q)) : r(Q);
  }
  function a(Q) {
    return e.enter("setextHeadingLineSequence"), T(Q);
  }
  function T(Q) {
    return Q === i ? (e.consume(Q), T) : (e.exit("setextHeadingLineSequence"), M2(Q) ? z2(e, s, "lineSuffix")(Q) : s(Q));
  }
  function s(Q) {
    return Q === null || Y1(Q) ? (e.exit("setextHeadingLine"), t(Q)) : r(Q);
  }
}
const Rw = {
  tokenize: Nw
};
function Nw(e) {
  const t = this, r = e.attempt(
    // Try to parse a blank line.
    No,
    n,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, z2(e, e.attempt(this.parser.constructs.flow, i, e.attempt($M, i)), "linePrefix"))
  );
  return r;
  function n(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, r;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, r;
  }
}
const Pw = {
  resolveAll: wh()
}, Bw = Mh("string"), Fw = Mh("text");
function Mh(e) {
  return {
    resolveAll: wh(e === "text" ? jw : void 0),
    tokenize: t
  };
  function t(r) {
    const n = this, i = this.parser.constructs[e], o = r.attempt(i, a, T);
    return a;
    function a(u) {
      return Q(u) ? o(u) : T(u);
    }
    function T(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), s;
    }
    function s(u) {
      return Q(u) ? (r.exit("data"), o(u)) : (r.consume(u), s);
    }
    function Q(u) {
      if (u === null)
        return !0;
      const l = i[u];
      let c = -1;
      if (l)
        for (; ++c < l.length; ) {
          const f = l[c];
          if (!f.previous || f.previous.call(n, n.previous))
            return !0;
        }
      return !1;
    }
  }
}
function wh(e) {
  return t;
  function t(r, n) {
    let i = -1, o;
    for (; ++i <= r.length; )
      o === void 0 ? r[i] && r[i][1].type === "data" && (o = i, i++) : (!r[i] || r[i][1].type !== "data") && (i !== o + 2 && (r[o][1].end = r[i - 1][1].end, r.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(r, n) : r;
  }
}
function jw(e, t) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const n = e[r - 1][1], i = t.sliceStream(n);
      let o = i.length, a = -1, T = 0, s;
      for (; o--; ) {
        const Q = i[o];
        if (typeof Q == "string") {
          for (a = Q.length; Q.charCodeAt(a - 1) === 32; )
            T++, a--;
          if (a)
            break;
          a = -1;
        } else if (Q === -2)
          s = !0, T++;
        else if (Q !== -1) {
          o++;
          break;
        }
      }
      if (T) {
        const Q = {
          type: r === e.length || s || T < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? a : n.start._bufferIndex + a,
            _index: n.start._index + o,
            line: n.end.line,
            column: n.end.column - T,
            offset: n.end.offset - T
          },
          end: {
            ...n.end
          }
        };
        n.end = {
          ...Q.start
        }, n.start.offset === n.end.offset ? Object.assign(n, Q) : (e.splice(r, 0, ["enter", Q, t], ["exit", Q, t]), r += 2);
      }
      r++;
    }
  return e;
}
const $w = {
  42: f4,
  43: f4,
  45: f4,
  48: f4,
  49: f4,
  50: f4,
  51: f4,
  52: f4,
  53: f4,
  54: f4,
  55: f4,
  56: f4,
  57: f4,
  62: Lh
}, Zw = {
  91: UM
}, Ww = {
  [-2]: kQ,
  [-1]: kQ,
  32: kQ
}, Gw = {
  35: ew,
  42: zn,
  45: [zc, zn],
  60: iw,
  61: zc,
  95: zn,
  96: Wc,
  126: Wc
}, zw = {
  38: gh,
  92: yh
}, Uw = {
  [-5]: IQ,
  [-4]: IQ,
  [-3]: IQ,
  33: xw,
  38: gh,
  42: CT,
  60: [EM, uw],
  91: Ew,
  92: [YM, yh],
  93: Bs,
  95: CT,
  96: RM
}, Xw = {
  null: [CT, Pw]
}, qw = {
  null: [42, 95]
}, Jw = {
  null: []
}, Yw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: qw,
  contentInitial: Zw,
  disable: Jw,
  document: $w,
  flow: Gw,
  flowInitial: Ww,
  insideSpan: Xw,
  string: zw,
  text: Uw
}, Symbol.toStringTag, { value: "Module" }));
function Kw(e, t, r) {
  let n = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const i = {}, o = [];
  let a = [], T = [];
  const s = {
    attempt: S(C),
    check: S(w),
    consume: H,
    enter: E,
    exit: M,
    interrupt: S(w, {
      interrupt: !0
    })
  }, Q = {
    code: null,
    containerState: {},
    defineSkip: m,
    events: [],
    now: d,
    parser: e,
    previous: null,
    sliceSerialize: c,
    sliceStream: f,
    write: l
  };
  let u = t.tokenize.call(Q, s);
  return t.resolveAll && o.push(t), Q;
  function l(z) {
    return a = P4(a, z), p(), a[a.length - 1] !== null ? [] : (D(t, 0), Q.events = Ro(o, Q.events, Q), Q.events);
  }
  function c(z, j) {
    return tS(f(z), j);
  }
  function f(z) {
    return eS(a, z);
  }
  function d() {
    const {
      _bufferIndex: z,
      _index: j,
      line: J,
      column: i1,
      offset: t1
    } = n;
    return {
      _bufferIndex: z,
      _index: j,
      line: J,
      column: i1,
      offset: t1
    };
  }
  function m(z) {
    i[z.line] = z.column, $();
  }
  function p() {
    let z;
    for (; n._index < a.length; ) {
      const j = a[n._index];
      if (typeof j == "string")
        for (z = n._index, n._bufferIndex < 0 && (n._bufferIndex = 0); n._index === z && n._bufferIndex < j.length; )
          v(j.charCodeAt(n._bufferIndex));
      else
        v(j);
    }
  }
  function v(z) {
    u = u(z);
  }
  function H(z) {
    Y1(z) ? (n.line++, n.column = 1, n.offset += z === -3 ? 2 : 1, $()) : z !== -1 && (n.column++, n.offset++), n._bufferIndex < 0 ? n._index++ : (n._bufferIndex++, n._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    a[n._index].length && (n._bufferIndex = -1, n._index++)), Q.previous = z;
  }
  function E(z, j) {
    const J = j || {};
    return J.type = z, J.start = d(), Q.events.push(["enter", J, Q]), T.push(J), J;
  }
  function M(z) {
    const j = T.pop();
    return j.end = d(), Q.events.push(["exit", j, Q]), j;
  }
  function C(z, j) {
    D(z, j.from);
  }
  function w(z, j) {
    j.restore();
  }
  function S(z, j) {
    return J;
    function J(i1, t1, T1) {
      let X, f1, s1, Z;
      return Array.isArray(i1) ? (
        /* c8 ignore next 1 */
        C1(i1)
      ) : "tokenize" in i1 ? (
        // Looks like a construct.
        C1([
          /** @type {Construct} */
          i1
        ])
      ) : L1(i1);
      function L1(x1) {
        return l1;
        function l1(u1) {
          const H1 = u1 !== null && x1[u1], D1 = u1 !== null && x1.null, w1 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(H1) ? H1 : H1 ? [H1] : [],
            ...Array.isArray(D1) ? D1 : D1 ? [D1] : []
          ];
          return C1(w1)(u1);
        }
      }
      function C1(x1) {
        return X = x1, f1 = 0, x1.length === 0 ? T1 : q(x1[f1]);
      }
      function q(x1) {
        return l1;
        function l1(u1) {
          return Z = k(), s1 = x1, x1.partial || (Q.currentConstruct = x1), x1.name && Q.parser.constructs.disable.null.includes(x1.name) ? O1() : x1.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            j ? Object.assign(Object.create(Q), j) : Q,
            s,
            N1,
            O1
          )(u1);
        }
      }
      function N1(x1) {
        return z(s1, Z), t1;
      }
      function O1(x1) {
        return Z.restore(), ++f1 < X.length ? q(X[f1]) : T1;
      }
    }
  }
  function D(z, j) {
    z.resolveAll && !o.includes(z) && o.push(z), z.resolve && M4(Q.events, j, Q.events.length - j, z.resolve(Q.events.slice(j), Q)), z.resolveTo && (Q.events = z.resolveTo(Q.events, Q));
  }
  function k() {
    const z = d(), j = Q.previous, J = Q.currentConstruct, i1 = Q.events.length, t1 = Array.from(T);
    return {
      from: i1,
      restore: T1
    };
    function T1() {
      n = z, Q.previous = j, Q.currentConstruct = J, Q.events.length = i1, T = t1, $();
    }
  }
  function $() {
    n.line in i && n.column < 2 && (n.column = i[n.line], n.offset += i[n.line] - 1);
  }
}
function eS(e, t) {
  const r = t.start._index, n = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let a;
  if (r === i)
    a = [e[r].slice(n, o)];
  else {
    if (a = e.slice(r, i), n > -1) {
      const T = a[0];
      typeof T == "string" ? a[0] = T.slice(n) : a.shift();
    }
    o > 0 && a.push(e[i].slice(0, o));
  }
  return a;
}
function tS(e, t) {
  let r = -1;
  const n = [];
  let i;
  for (; ++r < e.length; ) {
    const o = e[r];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, n.push(a);
  }
  return n.join("");
}
function rS(e) {
  const t = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      lM([Yw, ...(e || {}).extensions || []])
    ),
    content: r(mM),
    defined: [],
    document: r(LM),
    flow: r(Rw),
    lazy: {},
    string: r(Bw),
    text: r(Fw)
  };
  return t;
  function r(n) {
    return i;
    function i(o) {
      return Kw(t, n, o);
    }
  }
}
function nS(e) {
  for (; !xh(e); )
    ;
  return e;
}
const Uc = /[\0\t\n\r]/g;
function iS() {
  let e = 1, t = "", r = !0, n;
  return i;
  function i(o, a, T) {
    const s = [];
    let Q, u, l, c, f;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(a || void 0).decode(o)), l = 0, t = "", r && (o.charCodeAt(0) === 65279 && l++, r = void 0); l < o.length; ) {
      if (Uc.lastIndex = l, Q = Uc.exec(o), c = Q && Q.index !== void 0 ? Q.index : o.length, f = o.charCodeAt(c), !Q) {
        t = o.slice(l);
        break;
      }
      if (f === 10 && l === c && n)
        s.push(-3), n = void 0;
      else
        switch (n && (s.push(-5), n = void 0), l < c && (s.push(o.slice(l, c)), e += c - l), f) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, s.push(-2); e++ < u; )
              s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            n = !0, e = 1;
        }
      l = c + 1;
    }
    return T && (n && s.push(-5), t && s.push(t), s.push(null)), s;
  }
}
const oS = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function aS(e) {
  return e.replace(oS, QS);
}
function QS(e, t, r) {
  if (t)
    return t;
  if (r.charCodeAt(0) === 35) {
    const n = r.charCodeAt(1), i = n === 120 || n === 88;
    return vh(r.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return _r(r) || e;
}
function Un(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Xc(e.position) : "start" in e || "end" in e ? Xc(e) : "line" in e || "column" in e ? VT(e) : "";
}
function VT(e) {
  return qc(e && e.line) + ":" + qc(e && e.column);
}
function Xc(e) {
  return VT(e && e.start) + "-" + VT(e && e.end);
}
function qc(e) {
  return e && typeof e == "number" ? e : 1;
}
const Sh = {}.hasOwnProperty;
function TS(e, t, r) {
  return typeof t != "string" && (r = t, t = void 0), sS(r)(nS(rS(r).document().write(iS()(e, t, !0))));
}
function sS(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(x2),
      autolinkProtocol: k,
      autolinkEmail: k,
      atxHeading: o(Z1),
      blockQuote: o(D1),
      characterEscape: k,
      characterReference: k,
      codeFenced: o(w1),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: o(w1, a),
      codeText: o(E1, a),
      codeTextData: k,
      data: k,
      codeFlowValue: k,
      definition: o(A1),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: o(R1),
      hardBreakEscape: o(r2),
      hardBreakTrailing: o(r2),
      htmlFlow: o(I2, a),
      htmlFlowData: k,
      htmlText: o(I2, a),
      htmlTextData: k,
      image: o(X1),
      label: a,
      link: o(x2),
      listItem: o(f3),
      listItemValue: c,
      listOrdered: o(R2, l),
      listUnordered: o(R2),
      paragraph: o(q2),
      reference: q,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: o(Z1),
      strong: o(V2),
      thematicBreak: o(A3)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: C,
      autolink: s(),
      autolinkEmail: H1,
      autolinkProtocol: u1,
      blockQuote: s(),
      characterEscapeValue: $,
      characterReferenceMarkerHexadecimal: O1,
      characterReferenceMarkerNumeric: O1,
      characterReferenceValue: x1,
      characterReference: l1,
      codeFenced: s(p),
      codeFencedFence: m,
      codeFencedFenceInfo: f,
      codeFencedFenceMeta: d,
      codeFlowValue: $,
      codeIndented: s(v),
      codeText: s(t1),
      codeTextData: $,
      data: $,
      definition: s(),
      definitionDestinationString: M,
      definitionLabelString: H,
      definitionTitleString: E,
      emphasis: s(),
      hardBreakEscape: s(j),
      hardBreakTrailing: s(j),
      htmlFlow: s(J),
      htmlFlowData: $,
      htmlText: s(i1),
      htmlTextData: $,
      image: s(X),
      label: s1,
      labelText: f1,
      lineEnding: z,
      link: s(T1),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: N1,
      resourceDestinationString: Z,
      resourceTitleString: L1,
      resource: C1,
      setextHeading: s(D),
      setextHeadingLineSequence: S,
      setextHeadingText: w,
      strong: s(),
      thematicBreak: s()
    }
  };
  Ch(t, (e || {}).mdastExtensions || []);
  const r = {};
  return n;
  function n(g1) {
    let S1 = {
      type: "root",
      children: []
    };
    const G = {
      stack: [S1],
      tokenStack: [],
      config: t,
      enter: T,
      exit: Q,
      buffer: a,
      resume: u,
      data: r
    }, u2 = [];
    let L2 = -1;
    for (; ++L2 < g1.length; )
      if (g1[L2][1].type === "listOrdered" || g1[L2][1].type === "listUnordered")
        if (g1[L2][0] === "enter")
          u2.push(L2);
        else {
          const J2 = u2.pop();
          L2 = i(g1, J2, L2);
        }
    for (L2 = -1; ++L2 < g1.length; ) {
      const J2 = t[g1[L2][0]];
      Sh.call(J2, g1[L2][1].type) && J2[g1[L2][1].type].call(Object.assign({
        sliceSerialize: g1[L2][2].sliceSerialize
      }, G), g1[L2][1]);
    }
    if (G.tokenStack.length > 0) {
      const J2 = G.tokenStack[G.tokenStack.length - 1];
      (J2[1] || Jc).call(G, void 0, J2[0]);
    }
    for (S1.position = {
      start: S5(g1.length > 0 ? g1[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: S5(g1.length > 0 ? g1[g1.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, L2 = -1; ++L2 < t.transforms.length; )
      S1 = t.transforms[L2](S1) || S1;
    return S1;
  }
  function i(g1, S1, G) {
    let u2 = S1 - 1, L2 = -1, J2 = !1, C3, l3, z3, D3;
    for (; ++u2 <= G; ) {
      const $2 = g1[u2];
      switch ($2[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          $2[0] === "enter" ? L2++ : L2--, D3 = void 0;
          break;
        }
        case "lineEndingBlank": {
          $2[0] === "enter" && (C3 && !D3 && !L2 && !z3 && (z3 = u2), D3 = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          D3 = void 0;
      }
      if (!L2 && $2[0] === "enter" && $2[1].type === "listItemPrefix" || L2 === -1 && $2[0] === "exit" && ($2[1].type === "listUnordered" || $2[1].type === "listOrdered")) {
        if (C3) {
          let V3 = u2;
          for (l3 = void 0; V3--; ) {
            const y3 = g1[V3];
            if (y3[1].type === "lineEnding" || y3[1].type === "lineEndingBlank") {
              if (y3[0] === "exit")
                continue;
              l3 && (g1[l3][1].type = "lineEndingBlank", J2 = !0), y3[1].type = "lineEnding", l3 = V3;
            } else if (!(y3[1].type === "linePrefix" || y3[1].type === "blockQuotePrefix" || y3[1].type === "blockQuotePrefixWhitespace" || y3[1].type === "blockQuoteMarker" || y3[1].type === "listItemIndent"))
              break;
          }
          z3 && (!l3 || z3 < l3) && (C3._spread = !0), C3.end = Object.assign({}, l3 ? g1[l3][1].start : $2[1].end), g1.splice(l3 || u2, 0, ["exit", C3, $2[2]]), u2++, G++;
        }
        if ($2[1].type === "listItemPrefix") {
          const V3 = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, $2[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          C3 = V3, g1.splice(u2, 0, ["enter", V3, $2[2]]), u2++, G++, z3 = void 0, D3 = !0;
        }
      }
    }
    return g1[S1][1]._spread = J2, G;
  }
  function o(g1, S1) {
    return G;
    function G(u2) {
      T.call(this, g1(u2), u2), S1 && S1.call(this, u2);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function T(g1, S1, G) {
    this.stack[this.stack.length - 1].children.push(g1), this.stack.push(g1), this.tokenStack.push([S1, G || void 0]), g1.position = {
      start: S5(S1.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(g1) {
    return S1;
    function S1(G) {
      g1 && g1.call(this, G), Q.call(this, G);
    }
  }
  function Q(g1, S1) {
    const G = this.stack.pop(), u2 = this.tokenStack.pop();
    if (u2)
      u2[0].type !== g1.type && (S1 ? S1.call(this, g1, u2[0]) : (u2[1] || Jc).call(this, g1, u2[0]));
    else
      throw new Error("Cannot close `" + g1.type + "` (" + Un({
        start: g1.start,
        end: g1.end
      }) + "): it’s not open");
    G.position.end = S5(g1.end);
  }
  function u() {
    return QM(this.stack.pop());
  }
  function l() {
    this.data.expectingFirstListItemValue = !0;
  }
  function c(g1) {
    if (this.data.expectingFirstListItemValue) {
      const S1 = this.stack[this.stack.length - 2];
      S1.start = Number.parseInt(this.sliceSerialize(g1), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function f() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.lang = g1;
  }
  function d() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.meta = g1;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function p() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.value = g1.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function v() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.value = g1.replace(/(\r?\n|\r)$/g, "");
  }
  function H(g1) {
    const S1 = this.resume(), G = this.stack[this.stack.length - 1];
    G.label = S1, G.identifier = g0(this.sliceSerialize(g1)).toLowerCase();
  }
  function E() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.title = g1;
  }
  function M() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.url = g1;
  }
  function C(g1) {
    const S1 = this.stack[this.stack.length - 1];
    if (!S1.depth) {
      const G = this.sliceSerialize(g1).length;
      S1.depth = G;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function S(g1) {
    const S1 = this.stack[this.stack.length - 1];
    S1.depth = this.sliceSerialize(g1).codePointAt(0) === 61 ? 1 : 2;
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function k(g1) {
    const S1 = this.stack[this.stack.length - 1].children;
    let G = S1[S1.length - 1];
    (!G || G.type !== "text") && (G = n2(), G.position = {
      start: S5(g1.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, S1.push(G)), this.stack.push(G);
  }
  function $(g1) {
    const S1 = this.stack.pop();
    S1.value += this.sliceSerialize(g1), S1.position.end = S5(g1.end);
  }
  function z(g1) {
    const S1 = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const G = S1.children[S1.children.length - 1];
      G.position.end = S5(g1.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(S1.type) && (k.call(this, g1), $.call(this, g1));
  }
  function j() {
    this.data.atHardBreak = !0;
  }
  function J() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.value = g1;
  }
  function i1() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.value = g1;
  }
  function t1() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.value = g1;
  }
  function T1() {
    const g1 = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const S1 = this.data.referenceType || "shortcut";
      g1.type += "Reference", g1.referenceType = S1, delete g1.url, delete g1.title;
    } else
      delete g1.identifier, delete g1.label;
    this.data.referenceType = void 0;
  }
  function X() {
    const g1 = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const S1 = this.data.referenceType || "shortcut";
      g1.type += "Reference", g1.referenceType = S1, delete g1.url, delete g1.title;
    } else
      delete g1.identifier, delete g1.label;
    this.data.referenceType = void 0;
  }
  function f1(g1) {
    const S1 = this.sliceSerialize(g1), G = this.stack[this.stack.length - 2];
    G.label = aS(S1), G.identifier = g0(S1).toLowerCase();
  }
  function s1() {
    const g1 = this.stack[this.stack.length - 1], S1 = this.resume(), G = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, G.type === "link") {
      const u2 = g1.children;
      G.children = u2;
    } else
      G.alt = S1;
  }
  function Z() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.url = g1;
  }
  function L1() {
    const g1 = this.resume(), S1 = this.stack[this.stack.length - 1];
    S1.title = g1;
  }
  function C1() {
    this.data.inReference = void 0;
  }
  function q() {
    this.data.referenceType = "collapsed";
  }
  function N1(g1) {
    const S1 = this.resume(), G = this.stack[this.stack.length - 1];
    G.label = S1, G.identifier = g0(this.sliceSerialize(g1)).toLowerCase(), this.data.referenceType = "full";
  }
  function O1(g1) {
    this.data.characterReferenceType = g1.type;
  }
  function x1(g1) {
    const S1 = this.sliceSerialize(g1), G = this.data.characterReferenceType;
    let u2;
    G ? (u2 = vh(S1, G === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : u2 = _r(S1);
    const L2 = this.stack[this.stack.length - 1];
    L2.value += u2;
  }
  function l1(g1) {
    const S1 = this.stack.pop();
    S1.position.end = S5(g1.end);
  }
  function u1(g1) {
    $.call(this, g1);
    const S1 = this.stack[this.stack.length - 1];
    S1.url = this.sliceSerialize(g1);
  }
  function H1(g1) {
    $.call(this, g1);
    const S1 = this.stack[this.stack.length - 1];
    S1.url = "mailto:" + this.sliceSerialize(g1);
  }
  function D1() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function w1() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function E1() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function A1() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function R1() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Z1() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function r2() {
    return {
      type: "break"
    };
  }
  function I2() {
    return {
      type: "html",
      value: ""
    };
  }
  function X1() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function x2() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function R2(g1) {
    return {
      type: "list",
      ordered: g1.type === "listOrdered",
      start: null,
      spread: g1._spread,
      children: []
    };
  }
  function f3(g1) {
    return {
      type: "listItem",
      spread: g1._spread,
      checked: null,
      children: []
    };
  }
  function q2() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function V2() {
    return {
      type: "strong",
      children: []
    };
  }
  function n2() {
    return {
      type: "text",
      value: ""
    };
  }
  function A3() {
    return {
      type: "thematicBreak"
    };
  }
}
function S5(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Ch(e, t) {
  let r = -1;
  for (; ++r < t.length; ) {
    const n = t[r];
    Array.isArray(n) ? Ch(e, n) : lS(e, n);
  }
}
function lS(e, t) {
  let r;
  for (r in t)
    if (Sh.call(t, r))
      switch (r) {
        case "canContainEols": {
          const n = t[r];
          n && e[r].push(...n);
          break;
        }
        case "transforms": {
          const n = t[r];
          n && e[r].push(...n);
          break;
        }
        case "enter":
        case "exit": {
          const n = t[r];
          n && Object.assign(e[r], n);
          break;
        }
      }
}
function Jc(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Un({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Un({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Un({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function uS(e) {
  let t = {}.singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: i,
    resolveAll: n
  };
  return t == null && (t = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function n(o, a) {
    let T = -1;
    for (; ++T < o.length; )
      if (o[T][0] === "enter" && o[T][1].type === "strikethroughSequenceTemporary" && o[T][1]._close) {
        let s = T;
        for (; s--; )
          if (o[s][0] === "exit" && o[s][1].type === "strikethroughSequenceTemporary" && o[s][1]._open && // If the sizes are the same:
          o[T][1].end.offset - o[T][1].start.offset === o[s][1].end.offset - o[s][1].start.offset) {
            o[T][1].type = "strikethroughSequence", o[s][1].type = "strikethroughSequence";
            const Q = {
              type: "strikethrough",
              start: Object.assign({}, o[s][1].start),
              end: Object.assign({}, o[T][1].end)
            }, u = {
              type: "strikethroughText",
              start: Object.assign({}, o[s][1].end),
              end: Object.assign({}, o[T][1].start)
            }, l = [["enter", Q, a], ["enter", o[s][1], a], ["exit", o[s][1], a], ["enter", u, a]], c = a.parser.constructs.insideSpan.null;
            c && M4(l, l.length, 0, Ro(c, o.slice(s + 1, T), a)), M4(l, l.length, 0, [["exit", u, a], ["enter", o[T][1], a], ["exit", o[T][1], a], ["exit", Q, a]]), M4(o, s - 1, T - s + 3, l), T = s + l.length - 2;
            break;
          }
      }
    for (T = -1; ++T < o.length; )
      o[T][1].type === "strikethroughSequenceTemporary" && (o[T][1].type = "data");
    return o;
  }
  function i(o, a, T) {
    const s = this.previous, Q = this.events;
    let u = 0;
    return l;
    function l(f) {
      return s === 126 && Q[Q.length - 1][1].type !== "characterEscape" ? T(f) : (o.enter("strikethroughSequenceTemporary"), c(f));
    }
    function c(f) {
      const d = C9(s);
      if (f === 126)
        return u > 1 ? T(f) : (o.consume(f), u++, c);
      if (u < 2 && !t)
        return T(f);
      const m = o.exit("strikethroughSequenceTemporary"), p = C9(f);
      return m._open = !p || p === 2 && !!d, m._close = !d || d === 2 && !!p, a(f);
    }
  }
}
function cS() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: fS },
    exit: { strikethrough: dS }
  };
}
function fS(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function dS(e) {
  this.exit(e);
}
const hS = /[$_\p{ID_Start}]/u, pS = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u, mS = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u, vS = {};
function e6(e) {
  return e ? hS.test(String.fromCodePoint(e)) : !1;
}
function gr(e, t) {
  const r = (t || vS).jsx ? mS : pS;
  return e ? r.test(String.fromCodePoint(e)) : !1;
}
function LS(e) {
  return "\x1B[33m" + e + "\x1B[39m";
}
const yS = {}.hasOwnProperty, gS = Symbol("continue"), RQ = Symbol("exit"), xS = Symbol("skip");
function HS(e, t) {
  let r, n;
  typeof t == "function" ? r = t : typeof t == "object" && (t.enter && (r = t.enter), t.leave && (n = t.leave)), i(e, void 0, void 0, [])();
  function i(o, a, T, s) {
    return NQ(o) && (Q.displayName = "node (" + LS(o.type) + ")"), Q;
    function Q() {
      const u = r ? Yc(r(o, a, T, s)) : [];
      if (u[0] === RQ)
        return u;
      if (u[0] !== xS) {
        let l;
        for (l in o)
          if (yS.call(o, l) && o[l] && typeof o[l] == "object" && // @ts-expect-error: custom esast extension.
          l !== "data" && // @ts-expect-error: custom esast extension.
          l !== "position") {
            const c = s.concat(o), f = o[l];
            if (Array.isArray(f)) {
              const d = (
                /** @type {Array<unknown>} */
                f
              );
              let m = 0;
              for (; m > -1 && m < d.length; ) {
                const p = d[m];
                if (NQ(p)) {
                  const v = i(
                    p,
                    l,
                    m,
                    c
                  )();
                  if (v[0] === RQ)
                    return v;
                  m = typeof v[1] == "number" ? v[1] : m + 1;
                } else
                  m++;
              }
            } else if (NQ(f)) {
              const d = i(f, l, void 0, c)();
              if (d[0] === RQ)
                return d;
            }
          }
      }
      return n ? Yc(n(o, a, T, s)) : u;
    }
  }
}
function Yc(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [gS, e] : [e];
}
function NQ(e) {
  return !!(e && typeof e == "object" && "type" in e && typeof e.type == "string" && e.type.length > 0);
}
function ES(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Kc(e.position) : "start" in e || "end" in e ? Kc(e) : "line" in e || "column" in e ? _T(e) : "";
}
function _T(e) {
  return ef(e && e.line) + ":" + ef(e && e.column);
}
function Kc(e) {
  return _T(e && e.start) + "-" + _T(e && e.end);
}
function ef(e) {
  return e && typeof e == "number" ? e : 1;
}
let G2 = class extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, r, n) {
    super(), typeof r == "string" && (n = r, r = void 0);
    let i = "", o = {}, a = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof t == "string" ? i = t : !o.cause && t && (a = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof n == "string") {
      const s = n.indexOf(":");
      s === -1 ? o.ruleId = n : (o.source = n.slice(0, s), o.ruleId = n.slice(s + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const s = o.ancestors[o.ancestors.length - 1];
      s && (o.place = s.position);
    }
    const T = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = T ? T.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = T ? T.line : void 0, this.name = ES(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = a && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
};
G2.prototype.file = "";
G2.prototype.name = "";
G2.prototype.reason = "";
G2.prototype.message = "";
G2.prototype.stack = "";
G2.prototype.column = void 0;
G2.prototype.line = void 0;
G2.prototype.ancestors = void 0;
G2.prototype.cause = void 0;
G2.prototype.fatal = void 0;
G2.prototype.place = void 0;
G2.prototype.ruleId = void 0;
G2.prototype.source = void 0;
function bS(e, t) {
  const r = t.prefix || "", n = t.suffix || "", i = Object.assign({}, t.acornOptions), o = [], a = [], T = i.onComment, s = i.onToken;
  let Q = !1, u, l;
  const c = Object.assign({}, i, {
    onComment: o,
    preserveParens: !0
  });
  s && (c.onToken = a);
  const f = MS(e, t.tokenTypes), d = f.value, m = r + d + n, p = tf(d);
  if (p && !t.allowEmpty)
    throw new G2("Unexpected empty expression", {
      place: H(0),
      ruleId: "unexpected-empty-expression",
      source: "micromark-extension-mdx-expression"
    });
  try {
    u = t.expression && !p ? t.acorn.parseExpressionAt(m, 0, c) : t.acorn.parse(m, c);
  } catch (E) {
    const M = (
      /** @type {AcornError} */
      E
    ), C = H(M.pos);
    M.message = String(M.message).replace(/ \(\d+:\d+\)$/, ""), M.pos = C.offset, M.loc = {
      line: C.line,
      column: C.column - 1
    }, l = M, Q = M.raisedAt >= r.length + d.length || // Broken comments are raised at their start, not their end.
    M.message === "Unterminated comment";
  }
  if (u && t.expression && !p)
    if (tf(m.slice(u.end, m.length - n.length)))
      u = {
        type: "Program",
        start: 0,
        end: r.length + d.length,
        // @ts-expect-error: It’s good.
        body: [{
          type: "ExpressionStatement",
          expression: u,
          start: 0,
          end: r.length + d.length
        }],
        sourceType: "module",
        comments: []
      };
    else {
      const E = H(u.end), M = (
        /** @type {AcornError} */
        new Error("Unexpected content after expression")
      );
      M.pos = E.offset, M.loc = {
        line: E.line,
        column: E.column - 1
      }, l = M, u = void 0;
    }
  if (u) {
    if (u.comments = o, HS(u, function(E, M, C, w) {
      let S = (
        /** @type {AcornNode | Array<AcornNode>} */
        w[w.length - 1]
      ), D = M;
      E.type === "ParenthesizedExpression" && S && D && (typeof C == "number" && (S = S[D], D = C), S[D] = E.expression), v(E);
    }), Array.isArray(T))
      T.push(...o);
    else if (typeof T == "function")
      for (const E of o)
        T(E.type === "Block", E.value, E.start, E.end, E.loc.start, E.loc.end);
    for (const E of a)
      E.end <= r.length || E.start - r.length >= d.length || (v(E), Array.isArray(s) ? s.push(E) : s(E));
  }
  return {
    estree: u,
    error: l,
    swallow: Q
  };
  function v(E) {
    const M = H(E.start), C = H(E.end);
    E.start = M.offset, E.end = C.offset, E.loc = {
      start: {
        line: M.line,
        column: M.column - 1,
        offset: M.offset
      },
      end: {
        line: C.line,
        column: C.column - 1,
        offset: C.offset
      }
    }, E.range = [E.start, E.end];
  }
  function H(E) {
    let M = E - r.length;
    M < 0 ? M = 0 : M > d.length && (M = d.length);
    let C = wS(f.stops, M);
    return C || (C = {
      line: t.start.line,
      column: t.start.column,
      offset: t.start.offset
    }), C;
  }
}
function tf(e) {
  return /^\s*$/.test(e.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/[^\r\n]*(\r\n|\n|\r)/g, ""));
}
function MS(e, t) {
  const r = {
    value: "",
    stops: []
  };
  let n = -1;
  for (; ++n < e.length; ) {
    const i = e[n];
    if (i[0] === "enter") {
      const o = i[1].type;
      if (o === "lineEnding" || t.includes(o)) {
        const a = i[2].sliceStream(i[1]);
        for (; a.length > 0 && a[0] === -1; )
          a.shift();
        const T = SS(a);
        r.stops.push([r.value.length, i[1].start]), r.value += T, r.stops.push([r.value.length, i[1].end]);
      }
    }
  }
  return r;
}
function wS(e, t) {
  let r = 0;
  for (; r < e.length && e[r][0] <= t; )
    r += 1;
  if (r === 0)
    return;
  const [n, i] = e[r - 1], o = t - n;
  return {
    line: i.line,
    column: i.column + o,
    offset: i.offset + o
  };
}
function SS(e) {
  let t = -1;
  const r = [];
  let n;
  for (; ++t < e.length; ) {
    const i = e[t];
    let o;
    if (typeof i == "string")
      o = i;
    else
      switch (i) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = "	";
          break;
        }
        case -1: {
          if (n)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(i);
      }
    n = i === -2, r.push(o);
  }
  return r.join("");
}
function PQ(e) {
  const t = e || {}, r = t.loc || {}, n = t.range || [void 0, void 0], i = rf(r.start, n[0] || t.start), o = rf(r.end, n[1] || t.end);
  if (i && o)
    return { start: i, end: o };
}
function rf(e, t) {
  if (e && typeof e == "object") {
    const r = "line" in e ? BQ(e.line) : void 0, n = "column" in e ? BQ(e.column) : void 0;
    if (r && n !== void 0)
      return {
        line: r,
        column: n + 1,
        offset: BQ(t)
      };
  }
}
function BQ(e) {
  return typeof e == "number" && e > -1 ? e : void 0;
}
const CS = 2, m0 = "https://github.com/micromark/micromark-extension-mdx-expression/tree/main/packages/micromark-extension-mdx-expression", VS = "#unexpected-end-of-file-in-expression-expected-a-corresponding-closing-brace-for-", _S = "#unexpected-lazy-line-in-expression-in-container-expected-line-to-be-prefixed", nf = "#unexpected-type-in-code-expected-an-object-spread-spread", OS = "#unexpected-extra-content-in-spread-only-a-single-spread-is-supported", AS = "#could-not-parse-expression-with-acorn";
function of(e, t, r, n, i, o, a, T, s, Q, u) {
  const l = this, c = this.events.length + 3;
  let f = 0, d, m;
  return p;
  function p(M) {
    return e.enter(r), e.enter(n), e.consume(M), e.exit(n), d = l.now(), v;
  }
  function v(M) {
    if (M === null) {
      if (m)
        throw m;
      const C = new G2("Unexpected end of file in expression, expected a corresponding closing brace for `{`", {
        place: l.now(),
        ruleId: "unexpected-eof",
        source: "micromark-extension-mdx-expression"
      });
      throw C.url = m0 + VS, C;
    }
    if (Y1(M))
      return e.enter("lineEnding"), e.consume(M), e.exit("lineEnding"), E;
    if (M === 125 && f === 0) {
      const C = o ? DS.call(l, o, a, i, c, d, Q || !1, s || !1) : {
        type: "ok",
        estree: void 0
      };
      if (C.type === "ok") {
        e.enter(n), e.consume(M), e.exit(n);
        const w = e.exit(r);
        return T && C.estree && Object.assign(w, {
          estree: C.estree
        }), t;
      }
      return m = C.message, e.enter(i), e.consume(M), H;
    }
    return e.enter(i), H(M);
  }
  function H(M) {
    return M === 125 && f === 0 || M === null || Y1(M) ? (e.exit(i), v(M)) : (M === 123 && !o ? f += 1 : M === 125 && (f -= 1), e.consume(M), H);
  }
  function E(M) {
    const C = l.now();
    if (C.line !== d.line && !u && l.parser.lazy[C.line]) {
      const w = new G2("Unexpected lazy line in expression in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", {
        place: l.now(),
        ruleId: "unexpected-lazy",
        source: "micromark-extension-mdx-expression"
      });
      throw w.url = m0 + _S, w;
    }
    return M2(M) ? z2(e, v, "linePrefix", CS + 1)(M) : v(M);
  }
}
function DS(e, t, r, n, i, o, a) {
  const T = bS(this.events.slice(n), {
    acorn: e,
    tokenTypes: [r],
    acornOptions: t,
    start: i,
    expression: !0,
    allowEmpty: o,
    prefix: a ? "({" : "",
    suffix: a ? "})" : ""
  }), s = T.estree;
  if (a && s) {
    const Q = s.body[0];
    if (Q.type !== "ExpressionStatement" || Q.expression.type !== "ObjectExpression") {
      const u = PQ(Q), l = new G2("Unexpected `" + Q.type + "` in code: expected an object spread (`{...spread}`)", {
        place: u.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw l.url = m0 + nf, l;
    }
    if (Q.expression.properties[1]) {
      const u = PQ(Q.expression.properties[1]), l = new G2("Unexpected extra content in spread: only a single spread is supported", {
        place: u.start,
        ruleId: "spread-extra",
        source: "micromark-extension-mdx-expression"
      });
      throw l.url = m0 + OS, l;
    }
    if (Q.expression.properties[0] && Q.expression.properties[0].type !== "SpreadElement") {
      const u = PQ(Q.expression.properties[0]), l = new G2("Unexpected `" + Q.expression.properties[0].type + "` in code: only spread elements are supported", {
        place: u.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw l.url = m0 + nf, l;
    }
  }
  if (T.error) {
    const Q = new G2("Could not parse expression with acorn", {
      cause: T.error,
      place: {
        line: T.error.loc.line,
        column: T.error.loc.column + 1,
        offset: T.error.pos
      },
      ruleId: "acorn",
      source: "micromark-extension-mdx-expression"
    });
    return Q.url = m0 + AS, {
      type: "nok",
      message: Q
    };
  }
  return {
    type: "ok",
    estree: s
  };
}
const af = "https://github.com/micromark/micromark-extension-mdx-jsx";
function Vh(e, t, r, n, i, o, a, T, s, Q, u, l, c, f, d, m, p, v, H, E, M, C, w, S, D, k, $, z, j, J, i1, t1) {
  const T1 = this;
  let X, f1;
  return s1;
  function s1(G) {
    return e.enter(T), e.enter(s), e.consume(G), e.exit(s), Z;
  }
  function Z(G) {
    return p3(G) ? r(G) : (X = L1, n2(G));
  }
  function L1(G) {
    if (G === 47)
      return e.enter(Q), e.consume(G), e.exit(Q), X = C1, n2;
    if (G === 62)
      return V2(G);
    if (G !== null && G >= 0 && e6(G))
      return e.enter(l), e.enter(c), e.consume(G), q;
    S1(G, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (G === 33 ? " (note: to create a comment in MDX, use `{/* text */}`)" : ""));
  }
  function C1(G) {
    if (G === 62)
      return V2(G);
    if (G !== null && G >= 0 && e6(G))
      return e.enter(l), e.enter(c), e.consume(G), q;
    S1(G, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (G === 42 || G === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function q(G) {
    if (G !== null && G >= 0 && gr(G, {
      jsx: !0
    }))
      return e.consume(G), q;
    if (G === 46 || G === 47 || G === 58 || G === 62 || G === 123 || p3(G) || q6(G))
      return e.exit(c), X = N1, n2(G);
    S1(G, "in name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (G === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function N1(G) {
    if (G === 46)
      return e.enter(f), e.consume(G), e.exit(f), X = O1, n2;
    if (G === 58)
      return e.enter(m), e.consume(G), e.exit(m), X = u1, n2;
    if (G === 47 || G === 62 || G === 123 || G !== null && G >= 0 && e6(G))
      return e.exit(l), w1(G);
    S1(G, "after name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function O1(G) {
    if (G !== null && G >= 0 && e6(G))
      return e.enter(d), e.consume(G), x1;
    S1(G, "before member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function x1(G) {
    if (G !== null && G >= 0 && gr(G, {
      jsx: !0
    }))
      return e.consume(G), x1;
    if (G === 46 || G === 47 || G === 62 || G === 123 || p3(G) || q6(G))
      return e.exit(d), X = l1, n2(G);
    S1(G, "in member name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (G === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function l1(G) {
    if (G === 46)
      return e.enter(f), e.consume(G), e.exit(f), X = O1, n2;
    if (G === 47 || G === 62 || G === 123 || G !== null && G >= 0 && e6(G))
      return e.exit(l), w1(G);
    S1(G, "after member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function u1(G) {
    if (G !== null && G >= 0 && e6(G))
      return e.enter(p), e.consume(G), H1;
    S1(G, "before local name", "a character that can start a name, such as a letter, `$`, or `_`" + (G === 43 || G !== null && G > 46 && G < 58 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function H1(G) {
    if (G !== null && G >= 0 && gr(G, {
      jsx: !0
    }))
      return e.consume(G), H1;
    if (G === 47 || G === 62 || G === 123 || p3(G) || q6(G))
      return e.exit(p), X = D1, n2(G);
    S1(G, "in local name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function D1(G) {
    if (G === 47 || G === 62 || G === 123 || G !== null && G >= 0 && e6(G))
      return e.exit(l), w1(G);
    S1(G, "after local name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function w1(G) {
    if (G === 47)
      return e.enter(u), e.consume(G), e.exit(u), X = q2, n2;
    if (G === 62)
      return V2(G);
    if (G === 123)
      return of.call(T1, e, E1, v, H, E, n, i, o, !0, !1, a)(G);
    if (G !== null && G >= 0 && e6(G))
      return e.enter(M), e.enter(C), e.enter(w), e.consume(G), A1;
    S1(G, "before attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function E1(G) {
    return X = w1, n2(G);
  }
  function A1(G) {
    if (G !== null && G >= 0 && gr(G, {
      jsx: !0
    }))
      return e.consume(G), A1;
    if (G === 47 || G === 58 || G === 61 || G === 62 || G === 123 || p3(G) || q6(G))
      return e.exit(w), X = R1, n2(G);
    S1(G, "in attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function R1(G) {
    if (G === 58)
      return e.enter(S), e.consume(G), e.exit(S), X = Z1, n2;
    if (G === 61)
      return e.exit(C), e.enter(k), e.consume(G), e.exit(k), X = X1, n2;
    if (G === 47 || G === 62 || G === 123 || p3(G) || q6(G) || G !== null && G >= 0 && e6(G))
      return e.exit(C), e.exit(M), X = w1, n2(G);
    S1(G, "after attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Z1(G) {
    if (G !== null && G >= 0 && e6(G))
      return e.enter(D), e.consume(G), r2;
    S1(G, "before local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function r2(G) {
    if (G !== null && G >= 0 && gr(G, {
      jsx: !0
    }))
      return e.consume(G), r2;
    if (G === 47 || G === 61 || G === 62 || G === 123 || p3(G) || q6(G))
      return e.exit(D), e.exit(C), X = I2, n2(G);
    S1(G, "in local attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function I2(G) {
    if (G === 61)
      return e.enter(k), e.consume(G), e.exit(k), X = X1, n2;
    if (G === 47 || G === 62 || G === 123 || G !== null && G >= 0 && e6(G))
      return e.exit(M), w1(G);
    S1(G, "after local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function X1(G) {
    if (G === 34 || G === 39)
      return e.enter($), e.enter(z), e.consume(G), e.exit(z), f1 = G, R2;
    if (G === 123)
      return of.call(T1, e, x2, J, i1, t1, n, i, o, !1, !1, a)(G);
    S1(G, "before attribute value", "a character that can start an attribute value, such as `\"`, `'`, or `{`" + (G === 60 ? " (note: to use an element or fragment as a prop value in MDX, use `{<element />}`)" : ""));
  }
  function x2(G) {
    return e.exit(M), X = w1, n2(G);
  }
  function R2(G) {
    return G === null && S1(G, "in attribute value", "a corresponding closing quote `" + String.fromCodePoint(f1) + "`"), G === f1 ? (e.enter(z), e.consume(G), e.exit(z), e.exit($), e.exit(M), f1 = void 0, X = w1, n2) : Y1(G) ? (X = R2, n2(G)) : (e.enter(j), f3(G));
  }
  function f3(G) {
    return G === null || G === f1 || Y1(G) ? (e.exit(j), R2(G)) : (e.consume(G), f3);
  }
  function q2(G) {
    if (G === 62)
      return V2(G);
    S1(G, "after self-closing slash", "`>` to end the tag" + (G === 42 || G === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function V2(G) {
    return e.enter(s), e.consume(G), e.exit(s), e.exit(T), t;
  }
  function n2(G) {
    return Y1(G) ? (e.enter("lineEnding"), e.consume(G), e.exit("lineEnding"), g1) : M2(G) || q6(G) ? (e.enter("esWhitespace"), A3(G)) : X(G);
  }
  function A3(G) {
    return Y1(G) ? (e.exit("esWhitespace"), n2(G)) : M2(G) || q6(G) ? (e.consume(G), A3) : (e.exit("esWhitespace"), X(G));
  }
  function g1(G) {
    if (!a && T1.parser.lazy[T1.now().line]) {
      const u2 = new G2("Unexpected lazy line in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", T1.now(), "micromark-extension-mdx-jsx:unexpected-lazy");
      throw u2.url = af + "#unexpected-lazy-line-in-container-expected-line-to-be", u2;
    }
    return n2(G);
  }
  function S1(G, u2, L2) {
    const J2 = new G2("Unexpected " + (G === null ? "end of file" : "character `" + (G === 96 ? "` ` `" : String.fromCodePoint(G)) + "` (" + kS(G) + ")") + " " + u2 + ", expected " + L2, T1.now(), "micromark-extension-mdx-jsx:unexpected-" + (G === null ? "eof" : "character"));
    throw J2.url = af + (G === null ? "#unexpected-end-of-file-at-expected-expect" : "#unexpected-character-at-expected-expect"), J2;
  }
}
function kS(e) {
  return "U+" + e.toString(16).toUpperCase().padStart(4, "0");
}
function IS(e, t) {
  return {
    name: "mdxJsxTextTag",
    tokenize: r
  };
  function r(n, i, o) {
    return Vh.call(this, n, i, o, e, t.acornOptions, t.addResult, !0, "mdxJsxTextTag", "mdxJsxTextTagMarker", "mdxJsxTextTagClosingMarker", "mdxJsxTextTagSelfClosingMarker", "mdxJsxTextTagName", "mdxJsxTextTagNamePrimary", "mdxJsxTextTagNameMemberMarker", "mdxJsxTextTagNameMember", "mdxJsxTextTagNamePrefixMarker", "mdxJsxTextTagNameLocal", "mdxJsxTextTagExpressionAttribute", "mdxJsxTextTagExpressionAttributeMarker", "mdxJsxTextTagExpressionAttributeValue", "mdxJsxTextTagAttribute", "mdxJsxTextTagAttributeName", "mdxJsxTextTagAttributeNamePrimary", "mdxJsxTextTagAttributeNamePrefixMarker", "mdxJsxTextTagAttributeNameLocal", "mdxJsxTextTagAttributeInitializerMarker", "mdxJsxTextTagAttributeValueLiteral", "mdxJsxTextTagAttributeValueLiteralMarker", "mdxJsxTextTagAttributeValueLiteralValue", "mdxJsxTextTagAttributeValueExpression", "mdxJsxTextTagAttributeValueExpressionMarker", "mdxJsxTextTagAttributeValueExpressionValue");
  }
}
function RS(e, t) {
  return {
    name: "mdxJsxFlowTag",
    tokenize: r,
    concrete: !0
  };
  function r(n, i, o) {
    const a = this;
    return T;
    function T(l) {
      return s(l);
    }
    function s(l) {
      return Vh.call(a, n, Q, o, e, t.acornOptions, t.addResult, !1, "mdxJsxFlowTag", "mdxJsxFlowTagMarker", "mdxJsxFlowTagClosingMarker", "mdxJsxFlowTagSelfClosingMarker", "mdxJsxFlowTagName", "mdxJsxFlowTagNamePrimary", "mdxJsxFlowTagNameMemberMarker", "mdxJsxFlowTagNameMember", "mdxJsxFlowTagNamePrefixMarker", "mdxJsxFlowTagNameLocal", "mdxJsxFlowTagExpressionAttribute", "mdxJsxFlowTagExpressionAttributeMarker", "mdxJsxFlowTagExpressionAttributeValue", "mdxJsxFlowTagAttribute", "mdxJsxFlowTagAttributeName", "mdxJsxFlowTagAttributeNamePrimary", "mdxJsxFlowTagAttributeNamePrefixMarker", "mdxJsxFlowTagAttributeNameLocal", "mdxJsxFlowTagAttributeInitializerMarker", "mdxJsxFlowTagAttributeValueLiteral", "mdxJsxFlowTagAttributeValueLiteralMarker", "mdxJsxFlowTagAttributeValueLiteralValue", "mdxJsxFlowTagAttributeValueExpression", "mdxJsxFlowTagAttributeValueExpressionMarker", "mdxJsxFlowTagAttributeValueExpressionValue")(l);
    }
    function Q(l) {
      return M2(l) ? z2(n, u, "whitespace")(l) : u(l);
    }
    function u(l) {
      const c = a.parser.constructs.flow[123], f = (Array.isArray(c) ? c : c ? [c] : []).find((d) => d.name === "mdxFlowExpression");
      return l === 60 ? (
        // We can’t just say: fine. Lines of blocks have to be parsed until an eol/eof.
        T(l)
      ) : l === 123 && f ? n.attempt(f, u, o)(l) : l === null || Y1(l) ? i(l) : o(l);
    }
  }
}
function NS(e) {
  const t = {}, r = t.acorn;
  let n;
  if (r) {
    if (!r.parse || !r.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    n = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, t.acornOptions, {
      locations: !0
    });
  } else if (t.acornOptions || t.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      60: RS(r || void 0, {
        acornOptions: n,
        addResult: t.addResult || void 0
      })
    },
    text: {
      60: IS(r || void 0, {
        acornOptions: n,
        addResult: t.addResult || void 0
      })
    }
  };
}
const PS = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], Qf = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function _h(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}
function BS(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
function FS(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function Tf(e) {
  return FS(e) || _h(e);
}
const jS = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function $S(e, t) {
  const r = t, n = typeof r.additional == "string" ? r.additional.charCodeAt(0) : r.additional, i = [];
  let o = 0, a = -1, T = "", s, Q;
  r.position && ("start" in r.position || "indent" in r.position ? (Q = r.position.indent, s = r.position.start) : s = r.position);
  let u = (s ? s.line : 0) || 1, l = (s ? s.column : 0) || 1, c = d(), f;
  for (o--; ++o <= e.length; )
    if (f === 10 && (l = (Q ? Q[a] : 0) || 1), f = e.charCodeAt(o), f === 38) {
      const v = e.charCodeAt(o + 1);
      if (v === 9 || v === 10 || v === 12 || v === 32 || v === 38 || v === 60 || Number.isNaN(v) || n && v === n) {
        T += String.fromCharCode(f), l++;
        continue;
      }
      const H = o + 1;
      let E = H, M = H, C;
      if (v === 35) {
        M = ++E;
        const J = e.charCodeAt(M);
        J === 88 || J === 120 ? (C = "hexadecimal", M = ++E) : C = "decimal";
      } else
        C = "named";
      let w = "", S = "", D = "";
      const k = C === "named" ? Tf : C === "decimal" ? _h : BS;
      for (M--; ++M <= e.length; ) {
        const J = e.charCodeAt(M);
        if (!k(J))
          break;
        D += String.fromCharCode(J), C === "named" && PS.includes(D) && (w = D, S = _r(D));
      }
      let $ = e.charCodeAt(M) === 59;
      if ($) {
        M++;
        const J = C === "named" ? _r(D) : !1;
        J && (w = D, S = J);
      }
      let z = 1 + M - H, j = "";
      if (!(!$ && r.nonTerminated === !1))
        if (!D)
          C !== "named" && m(4, z);
        else if (C === "named") {
          if ($ && !S)
            m(5, 1);
          else if (w !== D && (M = E + w.length, z = 1 + M - E, $ = !1), !$) {
            const J = w ? 1 : 3;
            if (r.attribute) {
              const i1 = e.charCodeAt(M);
              i1 === 61 ? (m(J, z), S = "") : Tf(i1) ? S = "" : m(J, z);
            } else
              m(J, z);
          }
          j = S;
        } else {
          $ || m(2, z);
          let J = Number.parseInt(
            D,
            C === "hexadecimal" ? 16 : 10
          );
          if (ZS(J))
            m(7, z), j = "�";
          else if (J in Qf)
            m(6, z), j = Qf[J];
          else {
            let i1 = "";
            WS(J) && m(6, z), J > 65535 && (J -= 65536, i1 += String.fromCharCode(
              J >>> 10 | 55296
            ), J = 56320 | J & 1023), j = i1 + String.fromCharCode(J);
          }
        }
      if (j) {
        p(), c = d(), o = M - 1, l += M - H + 1, i.push(j);
        const J = d();
        J.offset++, r.reference && r.reference.call(
          r.referenceContext || void 0,
          j,
          { start: c, end: J },
          e.slice(H - 1, M)
        ), c = J;
      } else
        D = e.slice(H - 1, M), T += D, l += D.length, o = M - 1;
    } else
      f === 10 && (u++, a++, l = 0), Number.isNaN(f) ? p() : (T += String.fromCharCode(f), l++);
  return i.join("");
  function d() {
    return {
      line: u,
      column: l,
      offset: o + ((s ? s.offset : 0) || 0)
    };
  }
  function m(v, H) {
    let E;
    r.warning && (E = d(), E.column += H, E.offset += H, r.warning.call(
      r.warningContext || void 0,
      jS[v],
      E,
      v
    ));
  }
  function p() {
    T && (i.push(T), r.text && r.text.call(r.textContext || void 0, T, {
      start: c,
      end: d()
    }), T = "");
  }
}
function ZS(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function WS(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
function An(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? sf(e.position) : "start" in e || "end" in e ? sf(e) : "line" in e || "column" in e ? OT(e) : "";
}
function OT(e) {
  return lf(e && e.line) + ":" + lf(e && e.column);
}
function sf(e) {
  return OT(e && e.start) + "-" + OT(e && e.end);
}
function lf(e) {
  return e && typeof e == "number" ? e : 1;
}
function GS() {
  return {
    canContainEols: ["mdxJsxTextElement"],
    enter: {
      mdxJsxFlowTag: n,
      mdxJsxFlowTagClosingMarker: i,
      mdxJsxFlowTagAttribute: l,
      mdxJsxFlowTagExpressionAttribute: c,
      mdxJsxFlowTagAttributeValueLiteral: e,
      mdxJsxFlowTagAttributeValueExpression: e,
      mdxJsxFlowTagSelfClosingMarker: a,
      mdxJsxTextTag: n,
      mdxJsxTextTagClosingMarker: i,
      mdxJsxTextTagAttribute: l,
      mdxJsxTextTagExpressionAttribute: c,
      mdxJsxTextTagAttributeValueLiteral: e,
      mdxJsxTextTagAttributeValueExpression: e,
      mdxJsxTextTagSelfClosingMarker: a
    },
    exit: {
      mdxJsxFlowTagClosingMarker: T,
      mdxJsxFlowTagNamePrimary: s,
      mdxJsxFlowTagNameMember: Q,
      mdxJsxFlowTagNameLocal: u,
      mdxJsxFlowTagExpressionAttribute: f,
      mdxJsxFlowTagExpressionAttributeValue: r,
      mdxJsxFlowTagAttributeNamePrimary: d,
      mdxJsxFlowTagAttributeNameLocal: m,
      mdxJsxFlowTagAttributeValueLiteral: p,
      mdxJsxFlowTagAttributeValueLiteralValue: r,
      mdxJsxFlowTagAttributeValueExpression: v,
      mdxJsxFlowTagAttributeValueExpressionValue: r,
      mdxJsxFlowTagSelfClosingMarker: H,
      mdxJsxFlowTag: E,
      mdxJsxTextTagClosingMarker: T,
      mdxJsxTextTagNamePrimary: s,
      mdxJsxTextTagNameMember: Q,
      mdxJsxTextTagNameLocal: u,
      mdxJsxTextTagExpressionAttribute: f,
      mdxJsxTextTagExpressionAttributeValue: r,
      mdxJsxTextTagAttributeNamePrimary: d,
      mdxJsxTextTagAttributeNameLocal: m,
      mdxJsxTextTagAttributeValueLiteral: p,
      mdxJsxTextTagAttributeValueLiteralValue: r,
      mdxJsxTextTagAttributeValueExpression: v,
      mdxJsxTextTagAttributeValueExpressionValue: r,
      mdxJsxTextTagSelfClosingMarker: H,
      mdxJsxTextTag: E
    }
  };
  function e() {
    this.buffer();
  }
  function t(S) {
    return { line: S.line, column: S.column, offset: S.offset };
  }
  function r(S) {
    this.config.enter.data.call(this, S), this.config.exit.data.call(this, S);
  }
  function n(S) {
    const D = {
      name: void 0,
      attributes: [],
      close: !1,
      selfClosing: !1,
      start: S.start,
      end: S.end
    };
    this.data.mdxJsxTagStack || (this.data.mdxJsxTagStack = []), this.data.mdxJsxTag = D, this.buffer();
  }
  function i(S) {
    if (this.data.mdxJsxTagStack.length === 0)
      throw new G2(
        "Unexpected closing slash `/` in tag, expected an open tag first",
        { start: S.start, end: S.end },
        "mdast-util-mdx-jsx:unexpected-closing-slash"
      );
  }
  function o(S) {
    if (this.data.mdxJsxTag.close)
      throw new G2(
        "Unexpected attribute in closing tag, expected the end of the tag",
        { start: S.start, end: S.end },
        "mdast-util-mdx-jsx:unexpected-attribute"
      );
  }
  function a(S) {
    if (this.data.mdxJsxTag.close)
      throw new G2(
        "Unexpected self-closing slash `/` in closing tag, expected the end of the tag",
        { start: S.start, end: S.end },
        "mdast-util-mdx-jsx:unexpected-self-closing-slash"
      );
  }
  function T() {
    const S = this.data.mdxJsxTag;
    S.close = !0;
  }
  function s(S) {
    const D = this.data.mdxJsxTag;
    D.name = this.sliceSerialize(S);
  }
  function Q(S) {
    const D = this.data.mdxJsxTag;
    D.name += "." + this.sliceSerialize(S);
  }
  function u(S) {
    const D = this.data.mdxJsxTag;
    D.name += ":" + this.sliceSerialize(S);
  }
  function l(S) {
    const D = this.data.mdxJsxTag;
    o.call(this, S), D.attributes.push({
      type: "mdxJsxAttribute",
      name: "",
      value: null,
      position: {
        start: t(S.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    });
  }
  function c(S) {
    const D = this.data.mdxJsxTag;
    o.call(this, S), D.attributes.push({
      type: "mdxJsxExpressionAttribute",
      value: "",
      position: {
        start: t(S.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    }), this.buffer();
  }
  function f(S) {
    const D = this.data.mdxJsxTag, k = D.attributes[D.attributes.length - 1];
    k.type;
    const $ = S.estree;
    k.value = this.resume(), k.position, k.position.end = t(S.end), $ && (k.data = { estree: $ });
  }
  function d(S) {
    const D = this.data.mdxJsxTag, k = D.attributes[D.attributes.length - 1];
    k.type, k.name = this.sliceSerialize(S), k.position, k.position.end = t(S.end);
  }
  function m(S) {
    const D = this.data.mdxJsxTag, k = D.attributes[D.attributes.length - 1];
    k.type, k.name += ":" + this.sliceSerialize(S), k.position, k.position.end = t(S.end);
  }
  function p(S) {
    const D = this.data.mdxJsxTag, k = D.attributes[D.attributes.length - 1];
    k.value = $S(this.resume(), { nonTerminated: !1 }), k.position, k.position.end = t(S.end);
  }
  function v(S) {
    const D = this.data.mdxJsxTag, k = D.attributes[D.attributes.length - 1];
    k.type;
    const $ = { type: "mdxJsxAttributeValueExpression", value: this.resume() }, z = S.estree;
    z && ($.data = { estree: z }), k.value = $, k.position, k.position.end = t(S.end);
  }
  function H() {
    const S = this.data.mdxJsxTag;
    S.selfClosing = !0;
  }
  function E(S) {
    const D = this.data.mdxJsxTag, k = this.data.mdxJsxTagStack, $ = k[k.length - 1];
    if (D.close && $.name !== D.name)
      throw new G2(
        "Unexpected closing tag `" + w(D) + "`, expected corresponding closing tag for `" + w($) + "` (" + An($) + ")",
        { start: S.start, end: S.end },
        "mdast-util-mdx-jsx:end-tag-mismatch"
      );
    this.resume(), D.close ? k.pop() : this.enter(
      {
        type: S.type === "mdxJsxTextTag" ? "mdxJsxTextElement" : "mdxJsxFlowElement",
        name: D.name || null,
        attributes: D.attributes,
        children: []
      },
      S,
      M
    ), D.selfClosing || D.close ? this.exit(S, C) : k.push(D);
  }
  function M(S, D) {
    const k = this.data.mdxJsxTagStack, $ = k[k.length - 1], z = S ? " before the end of `" + S.type + "`" : "", j = S ? { start: S.start, end: S.end } : void 0;
    throw new G2(
      "Expected a closing tag for `" + w($) + "` (" + An({ start: D.start, end: D.end }) + ")" + z,
      j,
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function C(S, D) {
    const k = this.data.mdxJsxTag;
    throw new G2(
      "Expected the closing tag `" + w(k) + "` either after the end of `" + D.type + "` (" + An(D.end) + ") or another opening tag after the start of `" + D.type + "` (" + An(D.start) + ")",
      { start: S.start, end: S.end },
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function w(S) {
    return "<" + (S.close ? "/" : "") + (S.name || "") + ">";
  }
}
function zS(e) {
  return TS(e, US);
}
const US = {
  extensions: [uS(), NS()],
  mdastExtensions: [cS(), GS()]
};
var Fs = /* @__PURE__ */ ((e) => (e.CLOSE_READING = "CLOSE_READING", e.CLOZE_DROPDOWN = "CLOZE_DROPDOWN", e.FREE_RESPONSE = "FREE_RESPONSE", e.IMAGE_LABELING = "IMAGE_LABELING", e.MULTIPLE_CHOICE = "MULTIPLE_CHOICE", e.MULTIPLE_SELECT = "MULTIPLE_SELECT", e))(Fs || {}), js = /* @__PURE__ */ ((e) => (e.IMAGE = "IMAGE", e))(js || {}), j2 = /* @__PURE__ */ ((e) => (e.Text = "Text", e.Input = "Input", e))(j2 || {});
function w4(e) {
  var t;
  const r = [];
  let n = 0;
  for (const i of e.matchAll(/\{\{response\[\d+\]\}\}/g)) {
    const o = i[0], a = i.index, T = e.substring(n, a);
    if (T && r.push({
      type: "Text",
      text: T
    }), o.length) {
      const s = (t = o.match(/\d+/)) == null ? void 0 : t[0];
      s != null && s.length && r.push({ type: "Input", inputId: s });
    }
    n = (a ?? 0) + o.length;
  }
  return n !== e.length && r.push({
    type: "Text",
    text: e.substring(n, e.length)
  }), r;
}
function Po(e) {
  return e.map((t) => t.type === "Text" ? t.text : t.type === "Input" ? `{{response[${t.inputId}]}}` : "").join("");
}
function $s(e) {
  const t = [];
  return w4(e).forEach((r) => {
    r.type === "Input" && t.push(r.inputId);
  }), t;
}
let Dn;
const AT = {
  CLOSE_READING: {
    getSchema: (e) => {
      if (Dn)
        return Dn;
      const t = new e(
        {
          type: _2(String, {
            enum: g2.ANNOTATION_TOOL
          }),
          colors: [{ type: String, enum: g2.COLOR }]
        },
        { _id: !1 }
      ), r = new e(
        {
          tool: {
            type: String,
            enum: [...Object.keys(g2.ANNOTATION_TOOL), null],
            required: !1
          },
          color: {
            type: String,
            enum: [...Object.keys(g2.COLOR), null],
            required: !1
          }
        },
        { _id: !1 }
      ), n = new e(
        {
          score: _2(Number),
          required: _2(Boolean),
          range: _2({
            start: _2(Number),
            end: _2(Number)
          }),
          buffer: _2({
            start: _2(Number),
            end: _2(Number)
          }),
          style: _2(r)
        },
        { _id: !1 }
      ), i = new e(
        {
          type: _2(String, { enum: g2.GRADING }),
          requiredScore: Number
        },
        { _id: !1 }
      );
      return Dn = new e(
        {
          phrase: _2(String),
          textBody: _2(String),
          annotationLimit: Number,
          requiredAnnotations: Number,
          grading: _2(i),
          matchType: _2(String, { enum: g2.MATCH_TYPE }),
          availableAnnotationTools: Lr(
            t,
            "Available annotation tools must be provided"
          ),
          targetAnnotations: [n]
        },
        { _id: !1 }
      ), Dn;
    },
    grade: (e, t, r) => {
      if (e.type !== "CLOSE_READING" || t.type !== "CLOSE_READING" || e.grading.type === g2.GRADING.NONE)
        return;
      const { annotations: n } = t.value;
      let i;
      if (e.matchType === g2.MATCH_TYPE.WORD) {
        if (!(r != null && r.markdownAST))
          throw new Error(
            "Missing markdownAST for word range transformer in close reading question"
          );
        i = eM(r.markdownAST);
      } else
        throw new Error("Unsupported match type for close reading question");
      if (e.requiredAnnotations && e.requiredAnnotations > n.length || e.annotationLimit && e.annotationLimit < n.length)
        return 0;
      const { score: o, allRequiredTargetsSatisfied: a } = ph(
        e.targetAnnotations,
        n,
        i
      );
      return !a || e.grading.type === g2.GRADING.PASS_FAIL && e.grading.requiredScore > o ? 0 : o;
    },
    getBestPossibleScore: (e) => e.grading.type === g2.GRADING.PARTIAL_CREDIT ? e.targetAnnotations.reduce(
      (t, r) => t += r.score,
      0
    ) : e.grading.type === g2.GRADING.PASS_FAIL ? e.grading.requiredScore : 1,
    // Validate a close reading question
    validate: (e) => {
      try {
        if (n3(e.phrase, "string", "phrase"), n3(e.textBody, "string", "textBody"), n3(e.grading, "object", "grading"), n3(e.matchType, g2.MATCH_TYPE, "matchType"), n3(
          e.availableAnnotationTools,
          "array-non-empty",
          "availableAnnotationTools"
        ), e.annotationLimit != null && n3(e.annotationLimit, "number", "annotationLimit"), e.requiredAnnotations != null) {
          n3(
            e.requiredAnnotations,
            "number",
            "requiredAnnotations"
          );
          const s = e.requiredAnnotations, Q = e.annotationLimit;
          if (Q != null && s > Q)
            throw new d4(
              "requiredAnnotations must be less than or equal to annotationLimit",
              "requiredAnnotations"
            );
        }
        const t = e.grading;
        n3(t.type, g2.GRADING, "grading.type");
        const r = t.type === g2.GRADING.NONE;
        n3(
          e.targetAnnotations,
          r ? "array" : "array-non-empty",
          "targetAnnotations"
        );
        const n = e.textBody, i = e.availableAnnotationTools;
        t.type === g2.GRADING.PASS_FAIL && n3(
          t.requiredScore,
          "number",
          "grading.requiredScore"
        );
        const o = e.targetAnnotations, a = {};
        i.forEach((s, Q) => {
          n3(s, "object", `availableAnnotationTools[${Q}]`), n3(
            s.type,
            g2.ANNOTATION_TOOL,
            `availableAnnotationTools[${Q}].type`
          );
          const u = s.type;
          if (s.colors) {
            n3(
              s.colors,
              "array-non-empty",
              `availableAnnotationTools[${Q}].colors`
            );
            const l = s.colors;
            l.map(
              (c, f) => n3(
                c,
                g2.COLOR,
                `availableAnnotationTools[${Q}].colors[${f}]`
              )
            ), a[u] = l;
          }
        });
        const T = new Set(
          Object.values(a).flat()
        );
        o.forEach((s, Q) => {
          n3(s, "object", `targetAnnotations[${Q}]`), n3(
            s.score,
            "number",
            `targetAnnotations[${Q}].score`
          ), n3(
            s.required,
            "boolean",
            `targetAnnotations[${Q}].required`
          ), n3(
            s.range,
            "object",
            `targetAnnotations[${Q}].range`
          ), n3(
            s.buffer,
            "object",
            `targetAnnotations[${Q}].buffer`
          ), n3(
            s.style,
            "object",
            `targetAnnotations[${Q}].style`
          );
          const u = s.range, l = s.buffer;
          n3(
            u.start,
            "number",
            `targetAnnotations[${Q}].range.start`
          ), n3(
            u.end,
            "number",
            `targetAnnotations[${Q}].range.end`
          ), n3(
            l.start,
            "number",
            `targetAnnotations[${Q}].range.start`
          ), n3(
            l.end,
            "number",
            `targetAnnotations[${Q}].range.end`
          );
          const c = u.start, f = u.end, d = l.start, m = l.end;
          if (n[c] == null || n[f] == null || n[d] == null || n[m] == null)
            throw new d4(
              "range values are out of bounds of text",
              `targetAnnotations[${Q}].range`
            );
          if (c >= f)
            throw new d4(
              "range start occurs after range end",
              `targetAnnotations[${Q}].range`
            );
          if (d >= m)
            throw new d4(
              "buffer start occurs after buffer end",
              `targetAnnotations[${Q}].buffer`
            );
          if (c < d || f > m)
            throw new d4(
              "range must be within buffer",
              `targetAnnotations[${Q}].range`
            );
          const p = s.style;
          if (p.tool)
            if (n3(
              p.tool,
              g2.ANNOTATION_TOOL,
              `targetAnnotations[${Q}].style.tool`
            ), a[p.tool]) {
              const v = a[p.tool];
              if (p.color && (!v || !v.includes(
                p.color
              )))
                throw new d4(
                  "color is not available for tool",
                  `targetAnnotations[${Q}].style.color`
                );
            } else
              throw new d4(
                "tool is not available",
                `targetAnnotations[${Q}].style.tool`
              );
          if (p.color && (n3(
            p.color,
            g2.COLOR,
            `targetAnnotations[${Q}].style.color`
          ), !T.has(
            p.color
          )))
            throw new d4(
              "target color is not available for annotation",
              `targetAnnotations[${Q}].style.color`
            );
        });
      } catch (t) {
        if (t instanceof d4)
          return { error: t.message, field: t.field };
        throw t;
      }
    },
    getClassScores: (e, t) => {
      e.type;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCorrectAnswer: (e) => {
    },
    updateMedia: (e) => e
  },
  CLOZE_DROPDOWN: {
    getSchema: (e) => {
      const t = new e(
        {
          templateResponseKey: _2(String),
          choices: _2([In(e)])
        },
        { _id: !1 }
      );
      return new e({
        template: _2(String),
        dropdowns: Lr(
          t,
          "Question must contain at least one drop-down"
        )
      });
    },
    getClassScores: (e, t) => {
      if (e.type === "CLOZE_DROPDOWN")
        return ff(e, t);
    },
    getCorrectAnswer: (e) => {
      if (e.type !== "CLOZE_DROPDOWN")
        return;
      const t = {};
      if (e.dropdowns.forEach((r) => {
        var n;
        const i = (n = r.choices.find((o) => o.answer)) == null ? void 0 : n._id;
        i && (t[r.templateResponseKey] = String(i));
      }), Object.keys(t).length === e.dropdowns.length)
        return {
          type: "CLOZE_DROPDOWN",
          value: t
        };
    },
    updateMedia: cf,
    validate: (e) => {
      if (!e.template)
        return { error: "missing text", field: "template" };
      if (!_5(e.template))
        return { error: "incorrect format", field: "template" };
      const t = e.template, r = new Set($s(t));
      if (!r.size)
        return { error: "at least one dropdown is required", field: "template" };
      if (!Array.isArray(e.dropdowns) || e.dropdowns.length === 0)
        return {
          error: "at least one dropdown is required",
          field: "dropdowns"
        };
      for (const n of e.dropdowns) {
        if (!n.templateResponseKey || !_5(n.templateResponseKey))
          return {
            error: "a dropdown key is badly formatted",
            field: "dropdowns"
          };
        if (!r.has(n.templateResponseKey))
          return {
            error: "a dropdown created is no longer in the phrase",
            field: "dropdowns"
          };
        r.delete(n.templateResponseKey);
        const i = kn(n.choices);
        if (i.error)
          return {
            error: `${i.error} for dropdown with key ${n.templateResponseKey}`,
            field: "dropdowns"
          };
        if (i.answerCount !== 1)
          return {
            error: `too many answers marked as correct for dropdown with key ${n.templateResponseKey}`,
            field: "dropdowns"
          };
      }
      if (r.size > 0)
        return {
          error: "phrase references a dropdown that does not exist",
          field: "template"
        };
    },
    grade: (e, t) => {
      if (t.type === "CLOZE_DROPDOWN" && A5(t.value) && e.type === "CLOZE_DROPDOWN")
        return uf(
          e.dropdowns,
          (r) => r.templateResponseKey,
          t
        );
    }
  },
  FREE_RESPONSE: {
    getSchema: (e) => new e({
      phrase: _2(String),
      answer: String
    }),
    grade: () => null,
    updateMedia: (e) => e,
    getClassScores: () => {
    },
    getCorrectAnswer: (e) => {
      if (e.type === "FREE_RESPONSE")
        return {
          type: "FREE_RESPONSE",
          value: e.answer || ""
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return {
          error: "missing text",
          field: "phrase"
        };
      if (!_5(e.phrase))
        return { error: "incorrectly formatted", field: "phrase" };
      if (e.answer != null && !_5(e.answer))
        return { error: "incorrectly formatted", field: "answer" };
    }
  },
  IMAGE_LABELING: {
    getSchema: (e) => {
      const t = new e(
        {
          x: _2(Number),
          y: _2(Number),
          choices: Lr(
            In(e),
            "A dropdown is missing options"
          )
        },
        { _id: !1 }
      );
      return new e({
        media: Lr(
          fh(e),
          "Question must contain an image"
        ),
        phrase: _2(String),
        imageProperties: _2(
          new e(
            {
              width: _2(Number),
              height: _2(Number)
            },
            { _id: !1 }
          ),
          { default: { width: 550, height: 250 } }
        ),
        dropdowns: Lr(
          t,
          "Question must contain at least one drop-down"
        )
      });
    },
    grade: (e, t) => {
      if (t.type === "IMAGE_LABELING" && A5(t.value) && e.type === "IMAGE_LABELING")
        return uf(e.dropdowns, v3, t);
    },
    getClassScores: (e, t) => {
      if (e.type === "IMAGE_LABELING")
        return ff(e, t);
    },
    updateMedia: cf,
    getCorrectAnswer: (e) => {
      if (e.type !== "IMAGE_LABELING")
        return;
      const t = {};
      if (e.dropdowns.forEach((r) => {
        var n;
        const i = (n = r.choices.find((o) => o.answer)) == null ? void 0 : n._id;
        i || (t[v3(r)] = String(i));
      }), Object.keys(t).length === e.dropdowns.length)
        return {
          type: "IMAGE_LABELING",
          value: t
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return {
          error: "missing text",
          field: "phrase"
        };
      if (!_5(e.phrase))
        return { error: "incorrectly formatted", field: "phrase" };
      if (e.media && (!Array.isArray(e.media) || e.media[0].type !== "IMAGE"))
        return { error: "unknown media format", field: "media" };
      if (!e.media || Array.isArray(e.media) && e.media.length === 0)
        return { error: "missing a valid image", field: "media" };
      if (Array.isArray(e.media) && e.media.length > 1)
        return {
          error: "only one media image is allowed",
          field: "media"
        };
      const t = e.imageProperties;
      if (!A5(t) || !t.hasOwnProperty("width") || !t.hasOwnProperty("height") || typeof t.width != "number" || typeof t.height != "number" || t.width <= 0 || t.height <= 0)
        return {
          error: "failed to validate image properties",
          field: "imageProperties"
        };
      const r = t;
      if (!Array.isArray(e.dropdowns) || e.dropdowns.length === 0)
        return {
          error: "at least one dropdown is required",
          field: "dropdowns"
        };
      const n = /* @__PURE__ */ new Set();
      let i = 0;
      for (const o of e.dropdowns) {
        if (i += 1, typeof o != "object" || !o)
          return {
            error: "a dropdown is incorrectly formatted",
            field: "dropdowns"
          };
        const a = v3(o);
        if (n.has(a))
          return {
            error: `dropdown ${i} is in the same location on the image as another dropdown`,
            field: "dropdowns"
          };
        if (typeof o.x != "number" || typeof o.y != "number" || // Check to make sure coordinates are within the imageProperty width and height
        !(o.x >= 0 && o.x <= r.width) || !(o.y >= 0 && o.y <= r.height))
          return {
            error: `the coordinates for dropdown ${i} are outside of the image`,
            field: "dropdowns"
          };
        n.add(a);
        const T = kn(o.choices);
        if (T.error)
          return {
            error: `${T.error} for dropdown ${i}`,
            field: "dropdowns"
          };
        if (T.answerCount !== 1)
          return {
            error: `too many answers marked as correct for dropdown ${i}`,
            field: "dropdowns"
          };
      }
    }
  },
  MULTIPLE_CHOICE: {
    getSchema: (e) => new e({
      phrase: _2(String),
      choices: _2([In(e)])
    }),
    grade: (e, t) => {
      if (e.type !== "MULTIPLE_CHOICE" || t.type !== "MULTIPLE_CHOICE")
        return;
      const r = e.choices.find((n) => String(n._id) === String(t.value));
      return r ? r.answer ? 1 : 0 : void 0;
    },
    updateMedia: (e, t) => (e.type !== "MULTIPLE_CHOICE" || (e.choices = DT(e.choices, t)), e),
    getClassScores: (e, t) => {
      if (e.type === "MULTIPLE_CHOICE")
        return df(e, t);
    },
    getCorrectAnswer: (e) => {
      var t;
      if (e.type !== "MULTIPLE_CHOICE")
        return;
      const r = (t = e.choices.find(({ answer: n }) => n)) == null ? void 0 : t._id;
      if (r)
        return {
          type: "MULTIPLE_CHOICE",
          value: String(r)
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return {
          error: "missing text",
          field: "phrase"
        };
      if (!_5(e.phrase))
        return {
          error: "incorrectly formatted",
          field: "phrase"
        };
      const t = kn(e.choices);
      if (t.error)
        return { error: t.error, field: "choices" };
      if (t.answerCount !== 1)
        return { error: "too many answers marked as correct", field: "choices" };
    }
  },
  MULTIPLE_SELECT: {
    getSchema: (e) => new e({
      phrase: _2(String),
      choices: _2([In(e)])
    }),
    grade: (e, t) => {
      if (t.type !== "MULTIPLE_SELECT" || !Array.isArray(t.value) || e.type !== "MULTIPLE_SELECT")
        return;
      const r = /* @__PURE__ */ new Set(), n = t.value, i = e.choices.reduce((o, a) => (a.answer === !0 && r.add(String(a._id)), { ...o, [String(a._id)]: a }), {});
      if (!(!Array.isArray(n) || n.some((o) => !i[String(o)]))) {
        for (const o of n) {
          const a = String(o);
          if (r.has(a))
            r.delete(a);
          else
            return 0;
        }
        return r.size === 0 ? 1 : 0;
      }
    },
    updateMedia: (e, t) => (e.type !== "MULTIPLE_SELECT" || (e.choices = DT(e.choices, t)), e),
    getClassScores: (e, t) => {
      if (e.type === "MULTIPLE_SELECT")
        return df(e, t);
    },
    getCorrectAnswer: (e) => {
      if (e.type !== "MULTIPLE_SELECT")
        return;
      const t = e.choices.filter(({ answer: r }) => r).map(({ _id: r }) => String(r));
      if (t.length)
        return {
          type: "MULTIPLE_SELECT",
          value: t
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return { error: "missing text", field: "phrase" };
      if (!_5(e.phrase))
        return { error: "incorrectly formatted", field: "phrase" };
      const t = kn(e.choices);
      if (t.error)
        return { error: t.error, field: "choices" };
    }
  }
};
function v3(e) {
  return `${e.x}-${e.y}`;
}
function uf(e, t, r) {
  const n = r.value, i = e.reduce(
    (o, a) => {
      if (o === void 0)
        return o;
      const T = n[t(a)];
      if (!T)
        return;
      const s = a.choices.find((Q) => String(Q._id) === String(T));
      if (s)
        return o + (s.answer ? 1 : 0);
    },
    0
  );
  if (!(i === void 0 || e.length === 0))
    return i / e.length;
}
function DT(e, t) {
  return e.map((r) => r.media ? {
    ...r,
    media: r.media.map((n) => t(n))
  } : r);
}
function cf(e, t) {
  return e.type !== "CLOZE_DROPDOWN" && e.type !== "IMAGE_LABELING" ? e : {
    ...e,
    dropdowns: e.dropdowns.map((r) => ({
      ...r,
      choices: DT(r.choices, t)
    }))
  };
}
function kn(e) {
  var t;
  let r = 0, n = 0;
  if (e && Array.isArray(e) && e.length > 0)
    for (const i of e) {
      if (n += 1, !i)
        return { error: `choice ${n} is undefined` };
      let o = !1;
      if (i.media && Array.isArray(i.media) && (o = (t = i.media) == null ? void 0 : t.find(Boolean)), o && !Oh(i.media))
        return { error: `media is badly formatted for choice ${n}` };
      if (!i.text && !o)
        return { error: `no media or text exists for choice ${n}` };
      if (i.text && !_5(i.text))
        return {
          error: `text for choice ${n} is incorrectly formatted`
        };
      i.answer && r++;
    }
  return n === 0 ? { error: "at least one choice is required" } : r ? { answerCount: r } : { error: "no choice was marked as correct" };
}
let d4 = class extends Error {
  constructor(t, r) {
    super(t), Ub(this, "field"), this.field = r;
  }
};
function n3(e, t, r) {
  if (e == null)
    throw new d4("missing field", r);
  if (typeof t == "string" && t.includes("array")) {
    if (!Array.isArray(e))
      throw new d4("expected array", r);
    if (t === "array-non-empty" && e.length == 0)
      throw new d4("array must not be empty", r);
  } else if (typeof t == "string") {
    if (typeof e !== t)
      throw new d4(`expected ${t}`, r);
    return;
  } else if (!Object.values(t).includes(e))
    throw new d4("wrong enum value", r);
}
let FQ = null;
function In(e) {
  return FQ || (FQ = new e({
    text: {
      type: String,
      required: function() {
        var t;
        return !this.media || ((t = this.media) == null ? void 0 : t.length) == 0;
      }
    },
    media: {
      type: [fh(e)],
      // only require media if there is no text
      required: function() {
        return !this.text;
      }
    },
    answer: _2(Boolean)
  }), FQ);
}
function ff(e, t) {
  if (t.some((o) => o.type !== e.type))
    return;
  const r = t, n = {}, i = {};
  return r.forEach((o) => {
    const a = o.value;
    typeof a != "object" || Array.isArray(a) || Object.keys(a).forEach((T) => {
      const s = a[T];
      i[T] = (i[T] || 0) + 1, n[T] = n[T] || {}, n[T][s] = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (n[T][s] || 0) + 1;
    });
  }), {
    type: e.type,
    optionScores: Object.keys(n).map((o) => ({
      templateResponsekey: o,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      choices: Object.keys(n[o]).map((a) => ({
        _id: a,
        score: (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          n[o][a] / (i[o] || 1)
        )
      }))
    }))
  };
}
function df(e, t) {
  const r = t.filter(
    (i) => i.type === e.type
  ), n = {};
  return r.forEach((i) => {
    const o = i.value;
    typeof o != "string" && !Array.isArray(o) || (Array.isArray(o) ? o : [o]).forEach((a) => {
      typeof a == "string" && (n[a] = (n[a] || 0) + 1);
    });
  }), {
    type: e.type,
    optionScores: Object.keys(n).map((i) => ({
      _id: i,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      score: n[i] / (t.length || 1)
    }))
  };
}
function A5(e) {
  return typeof e == "object" && e != null;
}
function _5(e) {
  return typeof e == "string";
}
function Oh(e) {
  return e ? Array.isArray(e) ? e.every((t) => {
    if ((A5(t) || A5(t)) && typeof t.type == "string" && t.type in js) {
      if (A5(t) && t.url)
        return typeof t.url == "string";
      if (A5(t) && t.file)
        return (typeof window < "u" ? t.file instanceof File : !0) && typeof t.localUrl == "string";
    }
  }) : !1 : !0;
}
function Ah(e) {
  return A5(e) ? Oh(e.media) ? typeof e.type != "string" || !(e.type in Fs) ? { error: "question type is not supported", field: "type" } : AT[e.type].validate(e) : { error: "unknown media format", field: "media" } : { error: "unknown format" };
}
const F1 = Fs;
function hf(e, t) {
  const r = { ...e };
  return r.media && (r.media = r.media.map((n) => t(n))), AT[r.type] ? AT[r.type].updateMedia(r, t) : r;
}
const J6 = {
  rangeTransformers: {
    selectWholeElementRangeTransformer: hh,
    selectWithinElementRangeTransformer: tM
  },
  gradeAnnotations: ph,
  selectableRangesGenerators: {
    getVisibleWordsFromAst: dh
  },
  parseMarkdownToAST: zS,
  getIndicesOfClosestSelectableElements: Io
}, Zs = Object.values(g2.COLOR), XS = {
  [g2.COLOR.BLUE]: "#95effd",
  // use accent-blue from mission.io/styles game theme.
  [g2.COLOR.GREEN]: "#39fdc1",
  // use accent-green from mission.io/styles game theme.
  [g2.COLOR.ORANGE]: "#f7931e",
  // use accent-orange from mission.io/styles game theme.
  [g2.COLOR.YELLOW]: "#f6d365",
  // use a lightened prose.gold from mission.io/styles game theme.
  [g2.COLOR.PURPLE]: "#d4d7f7",
  // use prose.lavender from mission.io/styles game theme.
  [g2.COLOR.PINK]: "#ffd6cc",
  // use prose.coral from mission.io/styles game theme.
  [g2.COLOR.BLACK]: "#000000"
  // mission.io/styles black
}, Dh = XS, kh = Object.values(g2.ANNOTATION_TOOL), qS = {
  r: 129,
  g: 50,
  b: 50
}, Ws = "#FFC0CB", JS = "SIM_CREATOR_ID_";
function Or(e, t) {
  const r = Math.max(e.start, t.start), n = Math.min(e.end, t.end);
  return r >= n ? null : {
    start: r,
    end: n
  };
}
function pf(e, t, r, n) {
  var Q, u, l, c;
  const i = [], o = [], a = r ?? {
    // allows combining with other annotation of the same type
    start: Math.max(t.range.start - 1, 0),
    end: Math.min(t.range.end + 1, n)
  };
  for (const f of e) {
    if (((Q = f.style) == null ? void 0 : Q.tool) === ((u = t.style) == null ? void 0 : u.tool) && ((l = f.style) == null ? void 0 : l.color) === ((c = t.style) == null ? void 0 : c.color) && Or(a, f.range) !== null) {
      o.push(f);
      continue;
    }
    i.push(f);
  }
  let T = t.range.start, s = t.range.end;
  for (const f of o)
    T = Math.min(T, f.range.start), s = Math.max(s, f.range.end);
  return i.push({
    ...t,
    range: {
      start: T,
      end: s
    }
  }), i;
}
function Xn(e, t) {
  var n, i, o, a, T, s;
  const r = [];
  for (const Q of e) {
    if ((!((n = t.style) != null && n.tool) || ((i = Q.style) == null ? void 0 : i.tool) === ((o = t.style) == null ? void 0 : o.tool)) && (!((a = t.style) != null && a.color) || ((T = Q.style) == null ? void 0 : T.color) === ((s = t.style) == null ? void 0 : s.color))) {
      const u = Or(t.range, Q.range);
      if (u == null) {
        r.push(Q);
        continue;
      }
      if (u.start === Q.range.start && u.end === Q.range.end)
        continue;
      if (u.start === Q.range.start) {
        r.push({
          ...Q,
          range: {
            ...Q.range,
            start: u.end
          }
        });
        continue;
      } else if (u.end === Q.range.end) {
        r.push({
          ...Q,
          range: {
            ...Q.range,
            end: u.start
          }
        });
        continue;
      }
      r.push({
        ...Q,
        range: {
          ...Q.range,
          end: u.start
        }
      }), r.push({
        ...Q,
        range: {
          ...Q.range,
          start: u.end
        }
      });
      continue;
    }
    r.push(Q);
  }
  return r;
}
function YS(e, t) {
  return e.filter(({
    range: r,
    style: n
  }) => {
    var i, o, a, T;
    return (
      // matches erasing tool
      (!((i = t.style) != null && i.tool) || (n == null ? void 0 : n.tool) === ((o = t.style) == null ? void 0 : o.tool)) && // matches erasing color
      (!((a = t.style) != null && a.color) || (n == null ? void 0 : n.color) === ((T = t.style) == null ? void 0 : T.color)) ? !Or(r, t.range) : !0
    );
  });
}
function mf(e) {
  const t = [];
  for (const i of e)
    t.push({
      type: "START",
      index: i.range.start,
      baseAnnotation: i
    }, {
      type: "END",
      index: i.range.end,
      baseAnnotation: i
    });
  t.sort((i, o) => i.index - o.index);
  const r = {
    startIndex: null,
    highlight: /* @__PURE__ */ new Map(),
    strikeThrough: /* @__PURE__ */ new Map(),
    underline: /* @__PURE__ */ new Map()
  }, n = [];
  for (let i = 0; i < t.length; i++) {
    const o = t[i], a = [o];
    for (let T = i + 1; T < t.length && t[T].index === o.index; T++)
      a.push(t[T]), i = T;
    r.startIndex != null && n.push({
      range: {
        start: r.startIndex,
        // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        end: o.index
      },
      styles: {
        highlight: wr(Array.from(r.highlight.keys())),
        strikeThrough: wr(Array.from(r.strikeThrough.keys())),
        underline: wr(Array.from(r.underline.keys()))
      }
    }), r.startIndex = o.index;
    for (const T of a) {
      let s = null;
      if (// @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      T.baseAnnotation.style.tool === g2.ANNOTATION_TOOL.HIGHLIGHT ? s = r.highlight : /* @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess */ T.baseAnnotation.style.tool === g2.ANNOTATION_TOOL.STRIKE_THROUGH ? s = r.strikeThrough : (
        // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        T.baseAnnotation.style.tool === g2.ANNOTATION_TOOL.UNDERLINE && (s = r.underline)
      ), s == null)
        continue;
      const Q = T.type === "START" ? 1 : -1, u = (
        // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        (s.get(T.baseAnnotation.style.color) ?? 0) + Q
      );
      if (u <= 0) {
        s.delete(T.baseAnnotation.style.color);
        continue;
      }
      s.set(T.baseAnnotation.style.color, u);
    }
  }
  return n.filter(
    // remove ranges which apply no styles
    (i) => i.styles.highlight != null || i.styles.strikeThrough != null || i.styles.underline != null
  );
}
function KS(e) {
  const t = /* @__PURE__ */ new Set();
  for (const i of e)
    t.add(i.id);
  let r = e.length, n = null;
  do
    r += 1, n = `${JS}${r}`;
  while (t.has(n));
  return n;
}
function eC(e) {
  try {
    return {
      r: parseInt(e.slice(1, 3), 16) || 0,
      // `|| 0` to handle NaN
      g: parseInt(e.slice(3, 5), 16) || 0,
      b: parseInt(e.slice(5, 7), 16) || 0
    };
  } catch {
    return qS;
  }
}
function wr(e) {
  if (!e.length)
    return null;
  const t = {
    r: 0,
    g: 0,
    b: 0
  };
  for (const n of e) {
    const i = eC(Dh[n] ?? n);
    t.r += i.r, t.g += i.g, t.b += i.b;
  }
  const r = {
    r: Math.max(Math.min(Math.floor(t.r / e.length), 255), 0),
    g: Math.max(Math.min(Math.floor(t.g / e.length), 255), 0),
    b: Math.max(Math.min(Math.floor(t.b / e.length), 255), 0)
  };
  return `#${r.r.toString(16).padStart(2, "0")}${r.g.toString(16).padStart(2, "0")}${r.b.toString(16).padStart(2, "0")}`;
}
function tC(e, t) {
  let r = "code", n = e, i = (t == null ? void 0 : t.start.offset) != null && (t != null && t.end.offset) ? {
    start: t.start.offset + 1,
    // +1 to ignore the starting tick `
    end: t.end.offset - 1
    // -1 to ignore the ending tick
  } : null;
  if (typeof e == "string" && e.startsWith("lang-")) {
    const a = e.match(/^lang-[^\s]*\s/);
    a != null && a.length && (r = a[0].slice(
      0,
      // remove tailing space
      a[0].length - 1
    ), n = e.slice(
      // ignore text describing the language to use
      r.length + 1,
      e.length
    ), i && (i = {
      start: i.start + r.length + 1,
      end: i.end
    }));
  }
  return {
    language: r == null ? void 0 : r.replace("lang-", ""),
    codeSnippet: n,
    codeSnippetRange: i
  };
}
function rC(e, t) {
  var r, n, i, o;
  for (const a of e)
    if (a.range.start <= t.range.start && t.range.end <= a.range.end && // only match style if a wanted style is given to match against
    (((r = t.style) == null ? void 0 : r.color) == null || t.style.color === ((n = a.style) == null ? void 0 : n.color)) && (((i = t.style) == null ? void 0 : i.tool) == null || t.style.tool === ((o = a.style) == null ? void 0 : o.tool)))
      return a;
  return null;
}
function vf(e, t, r) {
  let n = null;
  const i = [];
  for (const o of r) {
    if (o.id === e) {
      n = o;
      continue;
    }
    i.push(o);
  }
  return n ? {
    otherAnnotations: i,
    updatedAnnotation: {
      ...n,
      range: t.range
    }
  } : {
    otherAnnotations: i
  };
}
const V9 = "#aaaaaa";
function nC(e) {
  const t = e.styles.strikeThrough;
  return t ? {
    // this is split into multiple attributes so it can render properly on Safari
    textDecoration: "line-through",
    textDecorationStyle: "solid",
    textDecorationColor: t,
    textDecorationThickness: "2px"
  } : null;
}
function iC(e) {
  const t = {};
  let r = !1;
  const n = e.styles.highlight;
  n && (t.backgroundColor = n, r = !0);
  const i = e.styles.underline;
  return i && (t.textDecoration = "underline", t.textDecorationStyle = "solid", t.textDecorationColor = i, t.textDecorationThickness = "2px", r = !0), r ? t : null;
}
function Gs({
  style: e
}) {
  const t = (e.color ? Dh[e.color] ?? e.color : null) ?? V9;
  return e.tool === g2.ANNOTATION_TOOL.STRIKE_THROUGH ? {
    // this is split into multiple attributes so it can render properly on Safari
    textDecoration: "line-through",
    textDecorationStyle: "solid",
    textDecorationColor: t
  } : e.tool === g2.ANNOTATION_TOOL.UNDERLINE ? {
    // this is split into multiple attributes so it can render properly on Safari
    textDecoration: "underline",
    textDecorationStyle: "solid",
    textDecorationColor: t,
    textDecorationThickness: "2px"
  } : {
    backgroundColor: t
  };
}
function jQ(e, t) {
  const r = Math.max(t.left - e.x, 0, e.x - t.right), n = Math.max(t.top - e.y, 0, e.y - t.bottom);
  return Math.sqrt(r * r + n * n);
}
function oC(e, t, r, n) {
  const i = [{
    element: t,
    distance: jQ(e, t.getBoundingClientRect())
  }];
  let o = null;
  for (let a = Lf(i); a != null && !(o && a.distance > o.distance || a.distance > n); a = Lf(i)) {
    for (const T of a.element.childNodes)
      if (T.nodeType === Node.TEXT_NODE) {
        const s = T.textContent;
        if (s == null || s.length === 0)
          continue;
        const Q = QC(T);
        if (Q == null)
          continue;
        const u = {
          start: Q,
          end: Q + s.length
        }, l = J6.getIndicesOfClosestSelectableElements(u, r);
        if (l == null)
          continue;
        const c = document.createRange();
        for (let f = l.firstElementIndex; f <= l.lastElementIndex; f += 1) {
          const d = r[f];
          if (!d)
            break;
          for (let m = Math.max(
            d.range.start - u.start,
            // this translates the start of the selectable markdown range to an index in the textContent in the current html node
            0
          ); m < Math.min(
            d.range.end - u.start,
            // this translates the end of the selectable markdown range to an index in the textContent in the current html node
            s.length
            // make sure to stop checking before running out of characters in the current text node
          ); m += 1) {
            const p = s.charAt(m);
            if (p == null)
              continue;
            c.setStart(T, m), c.setEnd(T, m + 1);
            const v = jQ(e, c.getBoundingClientRect());
            if ((o == null || v <= o.distance) && (o = {
              character: p,
              distance: v,
              node: T,
              characterIndex: m,
              markdownIndex: u.start + m
            }, v === 0))
              return o;
          }
        }
      }
    for (const T of a.element.children) {
      const s = jQ(e, T.getBoundingClientRect());
      s > n || o && s > o.distance || i.push({
        element: T,
        distance: s
      });
    }
  }
  return o && o.distance < n ? o : null;
}
function Lf(e) {
  const t = e[0];
  if (!e.length || !t)
    return null;
  let r = {
    index: 0,
    item: t
  };
  return e.forEach((n, i) => {
    n.distance < r.item.distance && (r = {
      index: i,
      item: n
    });
  }), e.splice(r.index, 1), r.item;
}
function yf(e, t) {
  var o, a, T, s;
  const r = [e], n = [];
  let i;
  for (; i = n.pop() ?? r.pop(); )
    for (const Q of i.children) {
      const u = (a = (o = Q == null ? void 0 : Q.attributes) == null ? void 0 : o.getNamedItem("x-mission-io-annotation-start-index")) == null ? void 0 : a.nodeValue, l = (s = (T = Q == null ? void 0 : Q.attributes) == null ? void 0 : T.getNamedItem("x-mission-io-annotation-end-index")) == null ? void 0 : s.nodeValue;
      if (u == null || l == null) {
        r.push(Q);
        continue;
      }
      const c = Number.parseInt(u), f = Number.parseInt(l);
      if (Number.isNaN(c) || !Number.isFinite(c) || c < 0 || Number.isNaN(f) || !Number.isFinite(f) || f < 0) {
        r.push(Q);
        continue;
      }
      if (t < c || t > f)
        continue;
      if (Q.children.length) {
        n.push(Q);
        continue;
      }
      const d = Q.childNodes[0];
      if (!d || d.nodeType !== d.TEXT_NODE)
        continue;
      const m = t - c, p = d.textContent;
      if (!p || m >= p.length)
        continue;
      const v = document.createRange();
      return v.setStart(d, m), v.setEnd(d, m + 1), v.getBoundingClientRect();
    }
  return null;
}
function aC(e) {
  var t, r;
  for (let n = e; n != null; n = n == null ? void 0 : n.parentElement)
    if (((r = (t = n.attributes) == null ? void 0 : t.getNamedItem("x-mission-io-annotations-root")) == null ? void 0 : r.nodeValue) === "true")
      return n;
  return null;
}
function QC(e) {
  var i, o;
  let t = e, r = null;
  for (; t && r == null; )
    t instanceof Element && (r = (o = (i = t == null ? void 0 : t.attributes) == null ? void 0 : i.getNamedItem("x-mission-io-annotation-start-index")) == null ? void 0 : o.nodeValue), t = t.parentElement;
  if (r == null)
    return null;
  const n = parseInt(r);
  return Number.isNaN(n) ? null : n;
}
var Ih = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var T = arguments[a];
        T && (o = i(o, n(T)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var T in o)
        t.call(o, T) && o[T] && (a = i(a, T));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Ih);
var TC = Ih.exports;
const S3 = /* @__PURE__ */ Sd(TC);
function sC(e, t) {
  var n;
  const r = {};
  for (const i of e.attributes) {
    if (i.type !== "mdxJsxAttribute" || typeof i.value != "string")
      continue;
    const o = (n = t.get(i.name)) == null ? void 0 : n(i.value);
    o != null && (r[i.name] = o);
  }
  return r;
}
const lC = /* @__PURE__ */ new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen"]), uC = new Map(Object.entries({
  color: (e) => {
    const t = e.toLowerCase();
    return t.match(/^#(\d{3}|\d{6}|\d{8})$/) || lC.has(t) ? t : null;
  }
})), qn = {
  imageSrc: (e) => e,
  href: (e) => e,
  cite: (e) => e,
  style: (e) => {
    var r, n, i;
    const t = {};
    for (const o of e.split(";")) {
      const a = o.split(":");
      if (a.length !== 2)
        continue;
      const T = (r = a[0]) == null ? void 0 : r.trim(), s = (n = a[1]) == null ? void 0 : n.trim();
      if (!T || !s)
        continue;
      const Q = (i = uC.get(T)) == null ? void 0 : i(s);
      Q != null && (t[T] = Q);
    }
    return t;
  }
}, Jn = new Map(Object.entries({
  style: qn.style
})), $Q = 10, Rn = 32, gf = /* @__PURE__ */ y.createElement("div", null, "An error occurred displaying this text."), cC = ["a", "b", "blockquote", "br", "code", "del", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "mark", "ol", "p", "pre", "q", "s", "span", "strong", "sub", "sup", "u", "ul", "wbr"], xf = 400, fC = 20, dC = [], hC = "selectable-text";
function c8(e) {
  const {
    markdown: t,
    annotations: r = dC,
    onRangeSelection: n,
    onRangeSelectionPreview: i,
    onAnnotationRangeUpdatePreview: o,
    onAnnotationRangeUpdate: a,
    className: T,
    selectedAnnotationId: s,
    eventTrackerRef: Q,
    disabledHtmlTags: u,
    customJSXElements: l,
    rootClassName: c,
    selectableTextClassName: f = hC
  } = e, [d, m] = W1(null), p = m4(null), v = m4(null), {
    ast: H,
    rangeTransformer: E,
    getClosestSelectableCharacter: M
  } = m3(() => {
    try {
      const X = J6.parseMarkdownToAST(t), f1 = J6.selectableRangesGenerators.getVisibleWordsFromAst(X);
      return {
        ast: X,
        // select by word
        rangeTransformer: J6.rangeTransformers.selectWholeElementRangeTransformer(f1),
        getClosestSelectableCharacter: (s1, Z, L1) => oC(s1, Z, f1, L1)
      };
    } catch (X) {
      console.error(X);
    }
    return {
      ast: null,
      rangeTransformer: () => null,
      getClosestSelectableCharacter: () => null
    };
  }, [t]), C = m3(() => {
    const X = new Set(cC);
    return u == null || u.forEach((f1) => X.delete(f1)), X;
  }, [u]), w = m3(() => {
    try {
      return H == null ? gf : kT(H, {
        allowedHtmlElements: C,
        customJSXElements: l ?? {},
        annotations: mf(r),
        selectableTextClassName: f,
        rootClassName: c
      }, "root");
    } catch {
      return gf;
    }
  }, [H, r, C, l, f, c]), S = m3(() => {
    try {
      return H == null || d == null ? null : kT(H, {
        allowedHtmlElements: C,
        customJSXElements: l ?? {},
        annotations: mf(d.annotations),
        selectableTextClassName: f,
        rootClassName: c
      }, "root");
    } catch {
      return null;
    }
  }, [H, d, C, l, f, c]);
  function D(X) {
    return !n || !X ? null : k(X);
  }
  function k(X) {
    const f1 = v.current;
    if (!f1)
      return null;
    const s1 = M(X.start, f1, X.leniency), Z = X.start.x === X.end.x && X.start.y === X.end.y ? s1 : M(X.end, f1, X.leniency);
    return !s1 || !Z ? (m(null), null) : E({
      start: Math.min(s1.markdownIndex, Z.markdownIndex),
      end: Math.max(s1.markdownIndex, Z.markdownIndex) + 1
      // + 1 as end is exclusive
    });
  }
  function $(X) {
    var s1;
    const f1 = D(X);
    if ((s1 = window.getSelection()) == null || s1.removeAllRanges(), m(null), f1 == null || !n)
      return null;
    n(f1);
  }
  function z(X) {
    const f1 = D(X);
    if (f1 == null || !n || !i || f1.range.start === (d == null ? void 0 : d.previousSelectedRange.range.start) && f1.range.end === (d == null ? void 0 : d.previousSelectedRange.range.end))
      return null;
    m({
      annotations: i(f1),
      previousSelectedRange: f1
    });
  }
  const j = r.find(({
    id: X
  }) => X === s), J = (d == null ? void 0 : d.annotations.find(({
    id: X
  }) => X === s)) || j, i1 = m3(() => {
    if (!J)
      return null;
    const X = v.current, f1 = p.current;
    if (!X || !f1)
      return null;
    const s1 = f1.getBoundingClientRect(), Z = yf(X, J.range.start), L1 = yf(X, J.range.end - 1);
    return !Z || !L1 ? null : {
      start: {
        left: Z.left - s1.left,
        top: Z.top - s1.top,
        bottom: s1.bottom - Z.bottom,
        width: Z.width,
        height: Z.height
      },
      end: {
        left: L1.left - s1.left,
        top: L1.top - s1.top,
        bottom: s1.bottom - L1.bottom,
        width: L1.width,
        height: L1.height
      }
    };
  }, [J]);
  function t1(X, f1, s1) {
    if (!j || !i || !s)
      return null;
    const Z = document.elementFromPoint(f1.x, f1.y);
    if (!Z)
      return null;
    const L1 = aC(Z);
    if (!L1)
      return null;
    const C1 = M(f1, L1, s1 === "mouse" ? $Q : Rn);
    if (!C1)
      return null;
    const q = C1.markdownIndex;
    let N1, O1;
    if (X === "start" ? q >= j.range.end ? (N1 = j.range.end, O1 = q) : (N1 = q, O1 = j.range.end) : q < j.range.start ? (N1 = q, O1 = j.range.start) : (N1 = j.range.start, O1 = q), N1 === O1)
      return null;
    const l1 = E({
      start: N1,
      end: O1
    });
    return l1 ? {
      rangeSelection: l1,
      annotationId: s
    } : null;
  }
  const T1 = m3(() => new AbortController(), []);
  return /* @__PURE__ */ y.createElement(vC, { markdown: t }, /* @__PURE__ */ y.createElement("div", { className: T, onMouseDown: (X) => {
    if (!(Q != null && Q.current) || Q.current.firstEventTypeHandledInCurrentEvaluationLoop || // NOTE: due to event ordering, this means that a touch event occurred and this happened after
    s)
      return;
    Q.current.noteEventType(X.type);
    const f1 = new AbortController(), s1 = _9([f1.signal, T1.signal]);
    window.addEventListener("mousemove", (L1) => {
      var C1;
      (C1 = Q.current) == null || C1.noteEventType(L1.type), z({
        start: Z,
        end: {
          x: L1.clientX,
          y: L1.clientY
        },
        leniency: $Q
      });
    }, {
      signal: s1
    });
    const Z = {
      x: X.clientX,
      y: X.clientY
    };
    window.addEventListener("mouseup", (L1) => {
      var C1;
      (C1 = Q.current) == null || C1.noteEventType(L1.type), f1.abort(), $({
        start: Z,
        end: {
          x: L1.clientX,
          y: L1.clientY
        },
        leniency: $Q
      });
    }, {
      signal: s1
    });
  }, onTouchStart: (X) => {
    if (!(Q != null && Q.current) || Q.current.firstEventTypeHandledInCurrentEvaluationLoop || s)
      return;
    Q.current.noteEventType(X.type);
    const f1 = X.changedTouches[X.changedTouches.length - 1];
    if (!f1)
      return;
    const s1 = {
      x: f1.clientX,
      y: f1.clientY
    };
    X.preventDefault();
    const Z = new AbortController(), L1 = _9([Z.signal, T1.signal]), C1 = Date.now();
    let q = s1;
    const N1 = setTimeout(() => {
      L1.aborted || z({
        start: s1,
        end: q,
        leniency: Rn
      });
    }, xf);
    function O1() {
      Z.abort(), clearTimeout(N1);
    }
    X.preventDefault(), window.addEventListener("touchmove", (x1) => {
      var u1;
      (u1 = Q.current) == null || u1.noteEventType(x1.type);
      const l1 = x1.changedTouches[x1.changedTouches.length - 1];
      if (l1) {
        if (q = {
          x: l1.clientX,
          y: l1.clientY
        }, Date.now() <= C1 + xf) {
          Math.sqrt((s1.x - l1.clientX) ** 2 + (s1.y - l1.clientY) ** 2) >= fC && (m(null), O1());
          return;
        }
        x1.preventDefault(), z({
          start: s1,
          end: q,
          leniency: Rn
        });
      }
    }, {
      signal: L1,
      passive: !1
    }), window.addEventListener("touchend", (x1) => {
      var u1;
      (u1 = Q.current) == null || u1.noteEventType(x1.type), x1.preventDefault(), O1();
      const l1 = x1.changedTouches[x1.changedTouches.length - 1];
      l1 && $({
        start: s1,
        end: {
          x: l1.clientX,
          y: l1.clientY
        },
        leniency: Rn
      });
    }, {
      signal: L1,
      passive: !1
    });
  } }, /* @__PURE__ */ y.createElement("div", { className: S3("prose prose-img:max-w-full prose-markdown max-w-none relative p-0 m-0", T), ref: p }, /* @__PURE__ */ y.createElement("div", { className: "pt-[1px] -mt-[1px] p-[0px] m-[0px]" }, /* @__PURE__ */ y.createElement("div", { className: "selection:bg-transparent m-0 p-0 w-ful select-none", ref: v }, S ?? w), s && i1 && Q && o && a ? ["start", "end"].map((X) => /* @__PURE__ */ y.createElement(pC, { key: X, clickable: !d, position: X === "start" ? i1.start : i1.end, onPaddleMove: (f1, s1) => {
    const Z = t1(X, f1, s1), L1 = d == null ? void 0 : d.previousSelectedRange;
    !Z || // no visible change
    L1 && Z.rangeSelection.range.start === L1.range.start && Z.rangeSelection.range.end === L1.range.end || m({
      annotations: o(s, Z.rangeSelection),
      previousSelectedRange: Z.rangeSelection
    });
  }, onPaddleRelease: (f1) => {
    const s1 = d == null ? void 0 : d.previousSelectedRange;
    m(null), !(s1 == null || f1 == null) && a(s, s1);
  }, location: X, eventTrackerRef: Q })) : null))));
}
function pC({
  position: e,
  onPaddleMove: t,
  onPaddleRelease: r,
  clickable: n,
  location: i,
  eventTrackerRef: o
}) {
  const a = m4(t);
  a.current = t;
  const T = m4(r);
  T.current = r;
  const s = m3(() => new AbortController(), []);
  G3(() => () => s.abort(), []);
  const Q = 2, u = 1;
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("div", { className: "absolute bg-info opacity-50 pointer-events-none", style: {
    left: e.left + (i === "start" ? 0 : e.width) - Q / 2,
    height: e.height + u,
    width: Q,
    ...i === "start" ? {
      bottom: e.bottom
    } : {
      top: e.top
    }
  } }), /* @__PURE__ */ y.createElement("div", { className: S3("absolute w-4 h-4 -translate-x-2 bg-info rounded-full hover:brightness-125 cursor-grab", n ? "" : "pointer-events-none"), onTouchStart: (l) => {
    var m, p;
    if (((m = o.current) == null ? void 0 : m.firstEventTypeHandledInCurrentEvaluationLoop) != null)
      return;
    (p = o.current) == null || p.noteEventType(l.type);
    const c = new AbortController(), f = _9([c.signal, s.signal]);
    window.addEventListener("touchmove", (v) => {
      var E;
      (E = o.current) == null || E.noteEventType(v.type), v.preventDefault();
      const H = v.changedTouches[0];
      H && a.current({
        x: H.clientX,
        y: H.clientY
      }, "touch");
    }, {
      signal: f,
      passive: !1
    });
    const d = () => {
      T.current(null);
    };
    f.addEventListener("abort", d), window.addEventListener("touchend", (v) => {
      var H, E;
      (H = o.current) == null || H.noteEventType(v.type), f.removeEventListener("abort", d), c.abort(), T.current("touch"), (E = window.getSelection()) == null || E.removeAllRanges();
    }, {
      signal: f
    });
  }, onMouseDown: (l) => {
    var m, p;
    if (
      // this is to avoid some problems with touch screens. When a user taps quickly it fires the following series of events `touchUp`, `mouseDown`, `mouseUp`, `click` which as `mouseDown` is on that list, will cause this function to be called. (NOTE: it is not possible to avoid this even by using `preventDefault` and `stopPropagation`)
      ((m = o.current) == null ? void 0 : m.firstEventTypeHandledInCurrentEvaluationLoop) != null
    )
      return;
    (p = o.current) == null || p.noteEventType(l.type);
    const c = new AbortController(), f = _9([c.signal, s.signal]);
    window.addEventListener("mousemove", (v) => {
      var H;
      (H = o.current) == null || H.noteEventType(v.type), a.current({
        x: v.clientX,
        y: v.clientY
      }, "mouse");
    }, {
      signal: f
    });
    const d = () => {
      T.current(null);
    };
    f.addEventListener("abort", d), window.addEventListener("mouseup", (v) => {
      var H, E;
      (H = o.current) == null || H.noteEventType(v.type), f.removeEventListener("abort", d), c.abort(), T.current("mouse"), (E = window.getSelection()) == null || E.removeAllRanges();
    }, {
      signal: f
    });
  }, onClick: (l) => {
    var c;
    (c = o.current) == null || c.noteEventType(l.type);
  }, style: i === "start" ? {
    left: e.left,
    bottom: e.bottom + e.height + u
  } : {
    left: e.left + e.width,
    top: e.top + e.height + u
  } }));
}
function ZQ({
  node: e
}) {
  const t = e.type === "code", r = /* @__PURE__ */ y.createElement(Wb, { tex: e.value, display: t });
  return t ? r : /* @__PURE__ */ y.createElement("span", { className: "*:inline-block *:align-text-top" }, r);
}
const c0 = {
  math: ZQ,
  katex: ZQ,
  latex: ZQ,
  code: ({
    node: e,
    context: t
  }) => {
    var r, n, i;
    return /* @__PURE__ */ y.createElement("code", { "x-mission-io-annotation-start-index": (r = e.position) == null ? void 0 : r.start.offset, "x-mission-io-annotation-end-index": (n = e.position) == null ? void 0 : n.end.offset }, ((i = Yn.text) == null ? void 0 : i.call(Yn, {
      node: {
        type: "text",
        value: e.value,
        position: e.position
      },
      context: t
    })) ?? null);
  }
};
function De(e) {
  return ({
    node: t,
    context: r
  }) => {
    var i, o;
    const n = IT(e, r);
    return /* @__PURE__ */ y.createElement(n, { "x-mission-io-annotation-start-index": (i = t.position) == null ? void 0 : i.start.offset, "x-mission-io-annotation-end-index": (o = t.position) == null ? void 0 : o.end.offset }, Re(t.children, r));
  };
}
function mC(e) {
  return ({
    node: t,
    context: r
  }) => {
    var n, i;
    return r.allowedHtmlElements.has(e) ? /* @__PURE__ */ y.createElement(e, { "x-mission-io-annotation-start-index": (n = t.position) == null ? void 0 : n.start.offset, "x-mission-io-annotation-end-index": (i = t.position) == null ? void 0 : i.end.offset }) : null;
  };
}
const v0 = De("div");
function k2(e, {
  attributeSanitizers: t = Jn,
  isSelfClosing: r = !1,
  defaultHtmlAttributes: n
} = {}) {
  return ({
    node: i,
    context: o
  }) => {
    var Q, u;
    console.log({
      tag: e
    });
    const a = r ? null : Re(i.children, o);
    if (!o.allowedHtmlElements.has(e))
      return /* @__PURE__ */ y.createElement(y.Fragment, null, a);
    const T = e, s = (t && sC(i, t)) ?? {};
    return /* @__PURE__ */ y.createElement(T, { ...n, ...s, "x-mission-io-annotation-start-index": (Q = i.position) == null ? void 0 : Q.start.offset, "x-mission-io-annotation-end-index": (u = i.position) == null ? void 0 : u.end.offset }, a);
  };
}
const Hf = {
  a: k2("a", {
    attributeSanitizers: new Map([...Jn.entries(), ["href", qn.href]]),
    defaultHtmlAttributes: {
      target: "_blank"
    }
  }),
  b: k2("b"),
  blockquote: k2("blockquote", {
    attributeSanitizers: new Map([...Jn.entries(), ["cite", qn.cite]])
  }),
  br: k2("br", {
    isSelfClosing: !0
  }),
  code: k2("code"),
  del: k2("del"),
  div: k2("div"),
  em: k2("em"),
  h1: k2("h1"),
  h2: k2("h2"),
  h3: k2("h3"),
  h4: k2("h4"),
  h5: k2("h5"),
  h6: k2("h6"),
  hr: k2("hr", {
    isSelfClosing: !0
  }),
  i: k2("i"),
  img: k2("img", {
    attributeSanitizers: new Map([...Jn.entries(), ["src", qn.imageSrc]]),
    isSelfClosing: !0
  }),
  li: k2("li"),
  mark: k2("mark"),
  ol: k2("ol"),
  p: k2("p"),
  pre: k2("pre"),
  q: k2("q"),
  s: k2("s"),
  span: k2("span"),
  strong: k2("strong"),
  sub: k2("sub"),
  sup: k2("sup"),
  u: k2("u"),
  ul: k2("ul"),
  wbr: k2("wbr")
}, Yn = {
  paragraph: De("p"),
  root: function({
    node: t,
    context: r
  }) {
    var n, i;
    return /* @__PURE__ */ y.createElement("div", { "x-mission-io-annotation-start-index": (n = t.position) == null ? void 0 : n.start.offset, "x-mission-io-annotation-end-index": (i = t.position) == null ? void 0 : i.end.offset, "x-mission-io-annotations-root": "true", className: r.rootClassName ?? "" }, Re(t.children, r));
  },
  list: ({
    node: e,
    context: t
  }) => {
    var n, i;
    const r = IT(e.ordered ? "ol" : "ul", t);
    return /* @__PURE__ */ y.createElement(r, { start: e.start ?? void 0, className: "pl-8", "x-mission-io-annotation-start-index": (n = e.position) == null ? void 0 : n.start.offset, "x-mission-io-annotation-end-index": (i = e.position) == null ? void 0 : i.end.offset }, Re(e.children, t));
  },
  listItem: De("li"),
  blockquote: De("blockquote"),
  break: mC("br"),
  heading: ({
    node: e,
    context: t
  }) => {
    var n, i;
    const r = IT(`h${e.depth}`, t);
    return /* @__PURE__ */ y.createElement(r, { "x-mission-io-annotation-start-index": (n = e.position) == null ? void 0 : n.start.offset, "x-mission-io-annotation-end-index": (i = e.position) == null ? void 0 : i.end.offset }, Re(e.children, t));
  },
  strong: De("strong"),
  inlineCode: ({
    node: e,
    context: t
  }) => {
    var a;
    const {
      codeSnippet: r,
      language: n,
      codeSnippetRange: i
    } = tC(e.value, e.position ?? null), o = n && n in c0 ? c0[n] : c0.code;
    return /* @__PURE__ */ y.createElement(o, { context: t, node: {
      type: "inlineCode",
      value: r,
      position: {
        start: {
          offset: i == null ? void 0 : i.start
        },
        end: {
          offset: i == null ? void 0 : i.end
        },
        indent: (a = e.position) == null ? void 0 : a.indent
      }
    } });
  },
  code: ({
    node: e,
    context: t
  }) => {
    var o;
    const r = e.lang, n = r && r in c0 ? c0[r] : c0.code, i = ((o = e.position) == null ? void 0 : o.start.offset) != null ? e.position.start.offset + 3 + ((r == null ? void 0 : r.length) ?? 0) + 1 : void 0;
    return /* @__PURE__ */ y.createElement("pre", null, /* @__PURE__ */ y.createElement(n, { context: t, node: {
      type: "code",
      value: e.value,
      position: e.position != null ? {
        ...e.position,
        start: {
          ...e.position.start,
          offset: i
        },
        end: {
          ...e.position.end,
          offset: i ? i + e.value.length : void 0
        }
      } : void 0
    } }));
  },
  definition: v0,
  emphasis: De("i"),
  html: v0,
  image: ({
    node: e,
    context: t
  }) => t.allowedHtmlElements.has("img") ? /* @__PURE__ */ y.createElement("img", { src: e.url, title: e.title ?? void 0 }) : e.title ? /* @__PURE__ */ y.createElement("span", null, e.title) : null,
  link: ({
    node: e,
    context: t
  }) => t.allowedHtmlElements.has("a") ? /* @__PURE__ */ y.createElement("a", { href: e.url, title: e.title ?? void 0 }, Re(e.children, t)) : /* @__PURE__ */ y.createElement(y.Fragment, null, Re(e.children, t)),
  linkReference: v0,
  thematicBreak: v0,
  delete: De("del"),
  mdxJsxFlowElement: Ef,
  mdxJsxTextElement: Ef,
  text: ({
    node: e,
    context: t
  }) => {
    var Q, u;
    const r = (Q = e.position) == null ? void 0 : Q.start.offset, n = (u = e.position) == null ? void 0 : u.end.offset;
    if (r == null || n == null)
      return /* @__PURE__ */ y.createElement("span", null, e.type);
    const i = t.annotations, o = [];
    let a = 0;
    for (; a < i.length && i[a].range.end < r; a += 1)
      ;
    let T = i.length - 1;
    for (T; T >= 0 && i[T].range.start > n; T -= 1)
      ;
    if (T < a)
      return /* @__PURE__ */ y.createElement("span", { "x-mission-io-annotation-start-index": r, "x-mission-io-annotation-end-index": n, className: t.selectableTextClassName }, e.value);
    let s = 0;
    for (let l = a; l <= T; l += 1) {
      const c = i[l], f = Math.max(
        // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        c.range.start - r,
        0
      ), d = Math.min(
        // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        c.range.end - r,
        e.value.length
      );
      s < f && o.push(/* @__PURE__ */ y.createElement("span", { "x-mission-io-annotation-start-index": r + s, "x-mission-io-annotation-end-index": r + f, className: t.selectableTextClassName, key: String(o.length) }, e.value.slice(s, f))), s = d;
      const m = [], p = nC(c);
      p && m.push(p);
      const v = iC(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        c
      );
      v && m.push(v), o.push(m.reduce((H, E) => (
        // needed as strike-through and underline both use the css `text-decoration` property which can not have two different text decorations of different colors
        /* @__PURE__ */ y.createElement("span", { style: E, "x-mission-io-annotation-start-index": Math.max(
          // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          c.range.start,
          r
        ), "x-mission-io-annotation-end-index": Math.min(
          // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          c.range.end,
          n
        ), className: t.selectableTextClassName, key: String(o.length) }, H)
      ), /* @__PURE__ */ y.createElement(y.Fragment, null, e.value.slice(f, d))));
    }
    return s < e.value.length && o.push(/* @__PURE__ */ y.createElement("span", { "x-mission-io-annotation-start-index": r + s, "x-mission-io-annotation-end-index": n, className: t.selectableTextClassName, key: String(o.length) }, e.value.slice(s))), /* @__PURE__ */ y.createElement("span", { "x-mission-io-annotation-start-index": r, "x-mission-io-annotation-end-index": n, className: t.selectableTextClassName }, o);
  }
};
function Ef({
  node: e,
  context: t
}) {
  const r = (e.name ? t.customJSXElements[e.name] ?? (e.name in Hf ? Hf[e.name] : null) : null) ?? v0;
  return /* @__PURE__ */ y.createElement(r, { node: e, context: t });
}
function kT(e, t, r) {
  const n = Yn[e.type] ?? v0;
  return /* @__PURE__ */ y.createElement(
    n,
    {
      key: r,
      context: t,
      node: e
    }
  );
}
function Re(e, t) {
  if (!(e != null && e.length))
    return null;
  const r = [];
  for (let n = 0; n < e.length; n++)
    r.push(kT(
      // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      e[n],
      t,
      String(n)
    ));
  return r;
}
function IT(e, t) {
  return t.allowedHtmlElements.has(e) ? e : "div";
}
class vC extends y.Component {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(t, r) {
    console.error("Error rendering markdown: ", t, r, ` when rendering "${this.props.markdown}"`);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ y.createElement("div", { className: "text-error font-bold" }, "An error has occurred, please contact Mission.io support with the location of this error.") : this.props.children;
  }
}
function _9(e) {
  const t = new AbortController();
  return e.forEach((r) => r.addEventListener("abort", () => {
    t.abort();
  })), t.signal;
}
var RT = { exports: {} }, Ye = {}, NT = { exports: {} }, Nn = { exports: {} }, P2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bf;
function LC() {
  if (bf)
    return P2;
  bf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, T = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, Q = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, d = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, H = e ? Symbol.for("react.scope") : 60119;
  function E(C) {
    if (typeof C == "object" && C !== null) {
      var w = C.$$typeof;
      switch (w) {
        case t:
          switch (C = C.type, C) {
            case s:
            case Q:
            case n:
            case o:
            case i:
            case l:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case T:
                case u:
                case d:
                case f:
                case a:
                  return C;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  function M(C) {
    return E(C) === Q;
  }
  return P2.AsyncMode = s, P2.ConcurrentMode = Q, P2.ContextConsumer = T, P2.ContextProvider = a, P2.Element = t, P2.ForwardRef = u, P2.Fragment = n, P2.Lazy = d, P2.Memo = f, P2.Portal = r, P2.Profiler = o, P2.StrictMode = i, P2.Suspense = l, P2.isAsyncMode = function(C) {
    return M(C) || E(C) === s;
  }, P2.isConcurrentMode = M, P2.isContextConsumer = function(C) {
    return E(C) === T;
  }, P2.isContextProvider = function(C) {
    return E(C) === a;
  }, P2.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, P2.isForwardRef = function(C) {
    return E(C) === u;
  }, P2.isFragment = function(C) {
    return E(C) === n;
  }, P2.isLazy = function(C) {
    return E(C) === d;
  }, P2.isMemo = function(C) {
    return E(C) === f;
  }, P2.isPortal = function(C) {
    return E(C) === r;
  }, P2.isProfiler = function(C) {
    return E(C) === o;
  }, P2.isStrictMode = function(C) {
    return E(C) === i;
  }, P2.isSuspense = function(C) {
    return E(C) === l;
  }, P2.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === Q || C === o || C === i || C === l || C === c || typeof C == "object" && C !== null && (C.$$typeof === d || C.$$typeof === f || C.$$typeof === a || C.$$typeof === T || C.$$typeof === u || C.$$typeof === p || C.$$typeof === v || C.$$typeof === H || C.$$typeof === m);
  }, P2.typeOf = E, P2;
}
var B2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mf;
function yC() {
  return Mf || (Mf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, T = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, Q = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, d = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, H = e ? Symbol.for("react.scope") : 60119;
    function E(E1) {
      return typeof E1 == "string" || typeof E1 == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E1 === n || E1 === Q || E1 === o || E1 === i || E1 === l || E1 === c || typeof E1 == "object" && E1 !== null && (E1.$$typeof === d || E1.$$typeof === f || E1.$$typeof === a || E1.$$typeof === T || E1.$$typeof === u || E1.$$typeof === p || E1.$$typeof === v || E1.$$typeof === H || E1.$$typeof === m);
    }
    function M(E1) {
      if (typeof E1 == "object" && E1 !== null) {
        var A1 = E1.$$typeof;
        switch (A1) {
          case t:
            var R1 = E1.type;
            switch (R1) {
              case s:
              case Q:
              case n:
              case o:
              case i:
              case l:
                return R1;
              default:
                var Z1 = R1 && R1.$$typeof;
                switch (Z1) {
                  case T:
                  case u:
                  case d:
                  case f:
                  case a:
                    return Z1;
                  default:
                    return A1;
                }
            }
          case r:
            return A1;
        }
      }
    }
    var C = s, w = Q, S = T, D = a, k = t, $ = u, z = n, j = d, J = f, i1 = r, t1 = o, T1 = i, X = l, f1 = !1;
    function s1(E1) {
      return f1 || (f1 = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Z(E1) || M(E1) === s;
    }
    function Z(E1) {
      return M(E1) === Q;
    }
    function L1(E1) {
      return M(E1) === T;
    }
    function C1(E1) {
      return M(E1) === a;
    }
    function q(E1) {
      return typeof E1 == "object" && E1 !== null && E1.$$typeof === t;
    }
    function N1(E1) {
      return M(E1) === u;
    }
    function O1(E1) {
      return M(E1) === n;
    }
    function x1(E1) {
      return M(E1) === d;
    }
    function l1(E1) {
      return M(E1) === f;
    }
    function u1(E1) {
      return M(E1) === r;
    }
    function H1(E1) {
      return M(E1) === o;
    }
    function D1(E1) {
      return M(E1) === i;
    }
    function w1(E1) {
      return M(E1) === l;
    }
    B2.AsyncMode = C, B2.ConcurrentMode = w, B2.ContextConsumer = S, B2.ContextProvider = D, B2.Element = k, B2.ForwardRef = $, B2.Fragment = z, B2.Lazy = j, B2.Memo = J, B2.Portal = i1, B2.Profiler = t1, B2.StrictMode = T1, B2.Suspense = X, B2.isAsyncMode = s1, B2.isConcurrentMode = Z, B2.isContextConsumer = L1, B2.isContextProvider = C1, B2.isElement = q, B2.isForwardRef = N1, B2.isFragment = O1, B2.isLazy = x1, B2.isMemo = l1, B2.isPortal = u1, B2.isProfiler = H1, B2.isStrictMode = D1, B2.isSuspense = w1, B2.isValidElementType = E, B2.typeOf = M;
  }()), B2;
}
var wf;
function Rh() {
  return wf || (wf = 1, process.env.NODE_ENV === "production" ? Nn.exports = LC() : Nn.exports = yC()), Nn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var WQ, Sf;
function gC() {
  if (Sf)
    return WQ;
  Sf = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, T = 0; T < 10; T++)
        a["_" + String.fromCharCode(T)] = T;
      var s = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var Q = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        Q[u] = u;
      }), Object.keys(Object.assign({}, Q)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return WQ = i() ? Object.assign : function(o, a) {
    for (var T, s = n(o), Q, u = 1; u < arguments.length; u++) {
      T = Object(arguments[u]);
      for (var l in T)
        t.call(T, l) && (s[l] = T[l]);
      if (e) {
        Q = e(T);
        for (var c = 0; c < Q.length; c++)
          r.call(T, Q[c]) && (s[Q[c]] = T[Q[c]]);
      }
    }
    return s;
  }, WQ;
}
var GQ, Cf;
function zs() {
  if (Cf)
    return GQ;
  Cf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return GQ = e, GQ;
}
var zQ, Vf;
function xC() {
  if (Vf)
    return zQ;
  Vf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = zs(), r = {}, n = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, T, s, Q) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (n(o, u)) {
          var l;
          try {
            if (typeof o[u] != "function") {
              var c = Error(
                (s || "React class") + ": " + T + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`."
              );
              throw c.name = "Invariant Violation", c;
            }
            l = o[u](a, u, s, T, null, t);
          } catch (d) {
            l = d;
          }
          if (l && !(l instanceof Error) && e(
            (s || "React class") + ": type specification of " + T + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), l instanceof Error && !(l.message in r)) {
            r[l.message] = !0;
            var f = Q ? Q() : "";
            e(
              "Failed " + T + " type: " + l.message + (f ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, zQ = i, zQ;
}
var UQ, _f;
function HC() {
  if (_f)
    return UQ;
  _f = 1;
  var e = Rh(), t = gC(), r = zs(), n = xC(), i = Function.call.bind(Object.prototype.hasOwnProperty), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(T) {
    var s = "Warning: " + T;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return UQ = function(T, s) {
    var Q = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function l(s1) {
      var Z = s1 && (Q && s1[Q] || s1[u]);
      if (typeof Z == "function")
        return Z;
    }
    var c = "<<anonymous>>", f = {
      array: v("array"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: H(),
      arrayOf: E,
      element: M(),
      elementType: C(),
      instanceOf: w,
      node: $(),
      objectOf: D,
      oneOf: S,
      oneOfType: k,
      shape: z,
      exact: j
    };
    function d(s1, Z) {
      return s1 === Z ? s1 !== 0 || 1 / s1 === 1 / Z : s1 !== s1 && Z !== Z;
    }
    function m(s1) {
      this.message = s1, this.stack = "";
    }
    m.prototype = Error.prototype;
    function p(s1) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, L1 = 0;
      function C1(N1, O1, x1, l1, u1, H1, D1) {
        if (l1 = l1 || c, H1 = H1 || x1, D1 !== r) {
          if (s) {
            var w1 = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w1.name = "Invariant Violation", w1;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var E1 = l1 + ":" + x1;
            !Z[E1] && // Avoid spamming the console because they are often not actionable except for lib authors
            L1 < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + H1 + "` prop on `" + l1 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[E1] = !0, L1++);
          }
        }
        return O1[x1] == null ? N1 ? O1[x1] === null ? new m("The " + u1 + " `" + H1 + "` is marked as required " + ("in `" + l1 + "`, but its value is `null`.")) : new m("The " + u1 + " `" + H1 + "` is marked as required in " + ("`" + l1 + "`, but its value is `undefined`.")) : null : s1(O1, x1, l1, u1, H1);
      }
      var q = C1.bind(null, !1);
      return q.isRequired = C1.bind(null, !0), q;
    }
    function v(s1) {
      function Z(L1, C1, q, N1, O1, x1) {
        var l1 = L1[C1], u1 = t1(l1);
        if (u1 !== s1) {
          var H1 = T1(l1);
          return new m("Invalid " + N1 + " `" + O1 + "` of type " + ("`" + H1 + "` supplied to `" + q + "`, expected ") + ("`" + s1 + "`."));
        }
        return null;
      }
      return p(Z);
    }
    function H() {
      return p(a);
    }
    function E(s1) {
      function Z(L1, C1, q, N1, O1) {
        if (typeof s1 != "function")
          return new m("Property `" + O1 + "` of component `" + q + "` has invalid PropType notation inside arrayOf.");
        var x1 = L1[C1];
        if (!Array.isArray(x1)) {
          var l1 = t1(x1);
          return new m("Invalid " + N1 + " `" + O1 + "` of type " + ("`" + l1 + "` supplied to `" + q + "`, expected an array."));
        }
        for (var u1 = 0; u1 < x1.length; u1++) {
          var H1 = s1(x1, u1, q, N1, O1 + "[" + u1 + "]", r);
          if (H1 instanceof Error)
            return H1;
        }
        return null;
      }
      return p(Z);
    }
    function M() {
      function s1(Z, L1, C1, q, N1) {
        var O1 = Z[L1];
        if (!T(O1)) {
          var x1 = t1(O1);
          return new m("Invalid " + q + " `" + N1 + "` of type " + ("`" + x1 + "` supplied to `" + C1 + "`, expected a single ReactElement."));
        }
        return null;
      }
      return p(s1);
    }
    function C() {
      function s1(Z, L1, C1, q, N1) {
        var O1 = Z[L1];
        if (!e.isValidElementType(O1)) {
          var x1 = t1(O1);
          return new m("Invalid " + q + " `" + N1 + "` of type " + ("`" + x1 + "` supplied to `" + C1 + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return p(s1);
    }
    function w(s1) {
      function Z(L1, C1, q, N1, O1) {
        if (!(L1[C1] instanceof s1)) {
          var x1 = s1.name || c, l1 = f1(L1[C1]);
          return new m("Invalid " + N1 + " `" + O1 + "` of type " + ("`" + l1 + "` supplied to `" + q + "`, expected ") + ("instance of `" + x1 + "`."));
        }
        return null;
      }
      return p(Z);
    }
    function S(s1) {
      if (!Array.isArray(s1))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function Z(L1, C1, q, N1, O1) {
        for (var x1 = L1[C1], l1 = 0; l1 < s1.length; l1++)
          if (d(x1, s1[l1]))
            return null;
        var u1 = JSON.stringify(s1, function(D1, w1) {
          var E1 = T1(w1);
          return E1 === "symbol" ? String(w1) : w1;
        });
        return new m("Invalid " + N1 + " `" + O1 + "` of value `" + String(x1) + "` " + ("supplied to `" + q + "`, expected one of " + u1 + "."));
      }
      return p(Z);
    }
    function D(s1) {
      function Z(L1, C1, q, N1, O1) {
        if (typeof s1 != "function")
          return new m("Property `" + O1 + "` of component `" + q + "` has invalid PropType notation inside objectOf.");
        var x1 = L1[C1], l1 = t1(x1);
        if (l1 !== "object")
          return new m("Invalid " + N1 + " `" + O1 + "` of type " + ("`" + l1 + "` supplied to `" + q + "`, expected an object."));
        for (var u1 in x1)
          if (i(x1, u1)) {
            var H1 = s1(x1, u1, q, N1, O1 + "." + u1, r);
            if (H1 instanceof Error)
              return H1;
          }
        return null;
      }
      return p(Z);
    }
    function k(s1) {
      if (!Array.isArray(s1))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Z = 0; Z < s1.length; Z++) {
        var L1 = s1[Z];
        if (typeof L1 != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(L1) + " at index " + Z + "."
          ), a;
      }
      function C1(q, N1, O1, x1, l1) {
        for (var u1 = 0; u1 < s1.length; u1++) {
          var H1 = s1[u1];
          if (H1(q, N1, O1, x1, l1, r) == null)
            return null;
        }
        return new m("Invalid " + x1 + " `" + l1 + "` supplied to " + ("`" + O1 + "`."));
      }
      return p(C1);
    }
    function $() {
      function s1(Z, L1, C1, q, N1) {
        return J(Z[L1]) ? null : new m("Invalid " + q + " `" + N1 + "` supplied to " + ("`" + C1 + "`, expected a ReactNode."));
      }
      return p(s1);
    }
    function z(s1) {
      function Z(L1, C1, q, N1, O1) {
        var x1 = L1[C1], l1 = t1(x1);
        if (l1 !== "object")
          return new m("Invalid " + N1 + " `" + O1 + "` of type `" + l1 + "` " + ("supplied to `" + q + "`, expected `object`."));
        for (var u1 in s1) {
          var H1 = s1[u1];
          if (H1) {
            var D1 = H1(x1, u1, q, N1, O1 + "." + u1, r);
            if (D1)
              return D1;
          }
        }
        return null;
      }
      return p(Z);
    }
    function j(s1) {
      function Z(L1, C1, q, N1, O1) {
        var x1 = L1[C1], l1 = t1(x1);
        if (l1 !== "object")
          return new m("Invalid " + N1 + " `" + O1 + "` of type `" + l1 + "` " + ("supplied to `" + q + "`, expected `object`."));
        var u1 = t({}, L1[C1], s1);
        for (var H1 in u1) {
          var D1 = s1[H1];
          if (!D1)
            return new m(
              "Invalid " + N1 + " `" + O1 + "` key `" + H1 + "` supplied to `" + q + "`.\nBad object: " + JSON.stringify(L1[C1], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(s1), null, "  ")
            );
          var w1 = D1(x1, H1, q, N1, O1 + "." + H1, r);
          if (w1)
            return w1;
        }
        return null;
      }
      return p(Z);
    }
    function J(s1) {
      switch (typeof s1) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !s1;
        case "object":
          if (Array.isArray(s1))
            return s1.every(J);
          if (s1 === null || T(s1))
            return !0;
          var Z = l(s1);
          if (Z) {
            var L1 = Z.call(s1), C1;
            if (Z !== s1.entries) {
              for (; !(C1 = L1.next()).done; )
                if (!J(C1.value))
                  return !1;
            } else
              for (; !(C1 = L1.next()).done; ) {
                var q = C1.value;
                if (q && !J(q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function i1(s1, Z) {
      return s1 === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function t1(s1) {
      var Z = typeof s1;
      return Array.isArray(s1) ? "array" : s1 instanceof RegExp ? "object" : i1(Z, s1) ? "symbol" : Z;
    }
    function T1(s1) {
      if (typeof s1 > "u" || s1 === null)
        return "" + s1;
      var Z = t1(s1);
      if (Z === "object") {
        if (s1 instanceof Date)
          return "date";
        if (s1 instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function X(s1) {
      var Z = T1(s1);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function f1(s1) {
      return !s1.constructor || !s1.constructor.name ? c : s1.constructor.name;
    }
    return f.checkPropTypes = n, f.resetWarningCache = n.resetWarningCache, f.PropTypes = f, f;
  }, UQ;
}
var XQ, Of;
function EC() {
  if (Of)
    return XQ;
  Of = 1;
  var e = zs();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, XQ = function() {
    function n(a, T, s, Q, u, l) {
      if (l !== e) {
        var c = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw c.name = "Invariant Violation", c;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, XQ;
}
if (process.env.NODE_ENV !== "production") {
  var bC = Rh(), MC = !0;
  NT.exports = HC()(bC.isElement, MC);
} else
  NT.exports = EC()();
var Nh = NT.exports, PT = { exports: {} }, Q6 = {}, BT = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var r = "none", n = "contents", i = /input|select|textarea|button|object|iframe/;
  function o(l, c) {
    return c.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    l.scrollWidth <= 0 && l.scrollHeight <= 0;
  }
  function a(l) {
    var c = l.offsetWidth <= 0 && l.offsetHeight <= 0;
    if (c && !l.innerHTML)
      return !0;
    try {
      var f = window.getComputedStyle(l), d = f.getPropertyValue("display");
      return c ? d !== n && o(l, f) : d === r;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function T(l) {
    for (var c = l, f = l.getRootNode && l.getRootNode(); c && c !== document.body; ) {
      if (f && c === f && (c = f.host.parentNode), a(c))
        return !1;
      c = c.parentNode;
    }
    return !0;
  }
  function s(l, c) {
    var f = l.nodeName.toLowerCase(), d = i.test(f) && !l.disabled || f === "a" && l.href || c;
    return d && T(l);
  }
  function Q(l) {
    var c = l.getAttribute("tabindex");
    c === null && (c = void 0);
    var f = isNaN(c);
    return (f || c >= 0) && s(l, !f);
  }
  function u(l) {
    var c = [].slice.call(l.querySelectorAll("*"), 0).reduce(function(f, d) {
      return f.concat(d.shadowRoot ? u(d.shadowRoot) : [d]);
    }, []);
    return c.filter(Q);
  }
  e.exports = t.default;
})(BT, BT.exports);
var Ph = BT.exports;
Object.defineProperty(Q6, "__esModule", {
  value: !0
});
Q6.resetState = VC;
Q6.log = _C;
Q6.handleBlur = Ar;
Q6.handleFocus = Dr;
Q6.markForFocusLater = OC;
Q6.returnFocus = AC;
Q6.popWithoutFocus = DC;
Q6.setupScopedFocus = kC;
Q6.teardownScopedFocus = IC;
var wC = Ph, SC = CC(wC);
function CC(e) {
  return e && e.__esModule ? e : { default: e };
}
var Ke = [], L0 = null, FT = !1;
function VC() {
  Ke = [];
}
function _C() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), Ke.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function Ar() {
  FT = !0;
}
function Dr() {
  if (FT) {
    if (FT = !1, !L0)
      return;
    setTimeout(function() {
      if (!L0.contains(document.activeElement)) {
        var e = (0, SC.default)(L0)[0] || L0;
        e.focus();
      }
    }, 0);
  }
}
function OC() {
  Ke.push(document.activeElement);
}
function AC() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    Ke.length !== 0 && (t = Ke.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function DC() {
  Ke.length > 0 && Ke.pop();
}
function kC(e) {
  L0 = e, window.addEventListener ? (window.addEventListener("blur", Ar, !1), document.addEventListener("focus", Dr, !0)) : (window.attachEvent("onBlur", Ar), document.attachEvent("onFocus", Dr));
}
function IC() {
  L0 = null, window.addEventListener ? (window.removeEventListener("blur", Ar), document.removeEventListener("focus", Dr)) : (window.detachEvent("onBlur", Ar), document.detachEvent("onFocus", Dr));
}
var jT = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = Ph, n = i(r);
  function i(T) {
    return T && T.__esModule ? T : { default: T };
  }
  function o() {
    var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return T.activeElement.shadowRoot ? o(T.activeElement.shadowRoot) : T.activeElement;
  }
  function a(T, s) {
    var Q = (0, n.default)(T);
    if (!Q.length) {
      s.preventDefault();
      return;
    }
    var u = void 0, l = s.shiftKey, c = Q[0], f = Q[Q.length - 1], d = o();
    if (T === d) {
      if (!l)
        return;
      u = f;
    }
    if (f === d && !l && (u = c), c === d && l && (u = f), u) {
      s.preventDefault(), u.focus();
      return;
    }
    var m = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), p = m != null && m[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (p) {
      var v = Q.indexOf(d);
      if (v > -1 && (v += l ? -1 : 1), u = Q[v], typeof u > "u") {
        s.preventDefault(), u = l ? f : c, u.focus();
        return;
      }
      s.preventDefault(), u.focus();
    }
  }
  e.exports = t.default;
})(jT, jT.exports);
var RC = jT.exports, T6 = {}, NC = process.env.NODE_ENV !== "production", Bh = function() {
};
if (NC) {
  var PC = function(t, r) {
    var n = arguments.length;
    r = new Array(n > 1 ? n - 1 : 0);
    for (var i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    var o = 0, a = "Warning: " + t.replace(/%s/g, function() {
      return r[o++];
    });
    typeof console < "u" && console.error(a);
    try {
      throw new Error(a);
    } catch {
    }
  };
  Bh = function(e, t, r) {
    var n = arguments.length;
    r = new Array(n > 2 ? n - 2 : 0);
    for (var i = 2; i < n; i++)
      r[i - 2] = arguments[i];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || PC.apply(null, [t].concat(r));
  };
}
var BC = Bh, n6 = {}, Fh = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), r = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = r : window.ExecutionEnvironment = r;
  })();
})(Fh);
var FC = Fh.exports;
Object.defineProperty(n6, "__esModule", {
  value: !0
});
n6.canUseDOM = n6.SafeNodeList = n6.SafeHTMLCollection = void 0;
var jC = FC, $C = ZC(jC);
function ZC(e) {
  return e && e.__esModule ? e : { default: e };
}
var Bo = $C.default, WC = Bo.canUseDOM ? window.HTMLElement : {};
n6.SafeHTMLCollection = Bo.canUseDOM ? window.HTMLCollection : {};
n6.SafeNodeList = Bo.canUseDOM ? window.NodeList : {};
n6.canUseDOM = Bo.canUseDOM;
n6.default = WC;
Object.defineProperty(T6, "__esModule", {
  value: !0
});
T6.resetState = qC;
T6.log = JC;
T6.assertNodeList = jh;
T6.setElement = YC;
T6.validateElement = Us;
T6.hide = KC;
T6.show = eV;
T6.documentNotReadyOrSSRTesting = tV;
var GC = BC, zC = XC(GC), UC = n6;
function XC(e) {
  return e && e.__esModule ? e : { default: e };
}
var E4 = null;
function qC() {
  E4 && (E4.removeAttribute ? E4.removeAttribute("aria-hidden") : E4.length != null ? E4.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(E4).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), E4 = null;
}
function JC() {
  if (process.env.NODE_ENV !== "production") {
    var e = E4 || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function jh(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function YC(e) {
  var t = e;
  if (typeof t == "string" && UC.canUseDOM) {
    var r = document.querySelectorAll(t);
    jh(r, t), t = r;
  }
  return E4 = t || E4, E4;
}
function Us(e) {
  var t = e || E4;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, zC.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function KC(e) {
  var t = !0, r = !1, n = void 0;
  try {
    for (var i = Us(e)[Symbol.iterator](), o; !(t = (o = i.next()).done); t = !0) {
      var a = o.value;
      a.setAttribute("aria-hidden", "true");
    }
  } catch (T) {
    r = !0, n = T;
  } finally {
    try {
      !t && i.return && i.return();
    } finally {
      if (r)
        throw n;
    }
  }
}
function eV(e) {
  var t = !0, r = !1, n = void 0;
  try {
    for (var i = Us(e)[Symbol.iterator](), o; !(t = (o = i.next()).done); t = !0) {
      var a = o.value;
      a.removeAttribute("aria-hidden");
    }
  } catch (T) {
    r = !0, n = T;
  } finally {
    try {
      !t && i.return && i.return();
    } finally {
      if (r)
        throw n;
    }
  }
}
function tV() {
  E4 = null;
}
var N0 = {};
Object.defineProperty(N0, "__esModule", {
  value: !0
});
N0.resetState = rV;
N0.log = nV;
var je = {}, $e = {};
function Af(e, t) {
  e.classList.remove(t);
}
function rV() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in je)
    Af(e, je[t]);
  var r = document.body;
  for (var n in $e)
    Af(r, $e[n]);
  je = {}, $e = {};
}
function nV() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var r in je)
      t += "  " + r + " " + je[r] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var n in $e)
      t += "  " + n + " " + $e[n] + `
  `;
    t += `
`, console.log(t);
  }
}
var iV = function(t, r) {
  return t[r] || (t[r] = 0), t[r] += 1, r;
}, oV = function(t, r) {
  return t[r] && (t[r] -= 1), r;
}, aV = function(t, r, n) {
  n.forEach(function(i) {
    iV(r, i), t.add(i);
  });
}, QV = function(t, r, n) {
  n.forEach(function(i) {
    oV(r, i), r[i] === 0 && t.remove(i);
  });
};
N0.add = function(t, r) {
  return aV(t.classList, t.nodeName.toLowerCase() == "html" ? je : $e, r.split(" "));
};
N0.remove = function(t, r) {
  return QV(t.classList, t.nodeName.toLowerCase() == "html" ? je : $e, r.split(" "));
};
var P0 = {};
Object.defineProperty(P0, "__esModule", {
  value: !0
});
P0.log = sV;
P0.resetState = lV;
function TV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var $h = function e() {
  var t = this;
  TV(this, e), this.register = function(r) {
    if (t.openInstances.indexOf(r) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(r), t.emit("register");
  }, this.deregister = function(r) {
    var n = t.openInstances.indexOf(r);
    if (n === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + r + " as it was never registered");
      return;
    }
    t.openInstances.splice(n, 1), t.emit("deregister");
  }, this.subscribe = function(r) {
    t.subscribers.push(r);
  }, this.emit = function(r) {
    t.subscribers.forEach(function(n) {
      return n(
        r,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, O9 = new $h();
function sV() {
  console.log("portalOpenInstances ----------"), console.log(O9.openInstances.length), O9.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function lV() {
  O9 = new $h();
}
P0.default = O9;
var Xs = {};
Object.defineProperty(Xs, "__esModule", {
  value: !0
});
Xs.resetState = dV;
Xs.log = hV;
var uV = P0, cV = fV(uV);
function fV(e) {
  return e && e.__esModule ? e : { default: e };
}
var Z3 = void 0, t6 = void 0, Ze = [];
function dV() {
  for (var e = [Z3, t6], t = 0; t < e.length; t++) {
    var r = e[t];
    r && r.parentNode && r.parentNode.removeChild(r);
  }
  Z3 = t6 = null, Ze = [];
}
function hV() {
  console.log("bodyTrap ----------"), console.log(Ze.length);
  for (var e = [Z3, t6], t = 0; t < e.length; t++) {
    var r = e[t], n = r || {};
    console.log(n.nodeName, n.className, n.id);
  }
  console.log("edn bodyTrap ----------");
}
function Df() {
  if (Ze.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  Ze[Ze.length - 1].focusContent();
}
function pV(e, t) {
  !Z3 && !t6 && (Z3 = document.createElement("div"), Z3.setAttribute("data-react-modal-body-trap", ""), Z3.style.position = "absolute", Z3.style.opacity = "0", Z3.setAttribute("tabindex", "0"), Z3.addEventListener("focus", Df), t6 = Z3.cloneNode(), t6.addEventListener("focus", Df)), Ze = t, Ze.length > 0 ? (document.body.firstChild !== Z3 && document.body.insertBefore(Z3, document.body.firstChild), document.body.lastChild !== t6 && document.body.appendChild(t6)) : (Z3.parentElement && Z3.parentElement.removeChild(Z3), t6.parentElement && t6.parentElement.removeChild(t6));
}
cV.default.subscribe(pV);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = Object.assign || function(i1) {
    for (var t1 = 1; t1 < arguments.length; t1++) {
      var T1 = arguments[t1];
      for (var X in T1)
        Object.prototype.hasOwnProperty.call(T1, X) && (i1[X] = T1[X]);
    }
    return i1;
  }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i1) {
    return typeof i1;
  } : function(i1) {
    return i1 && typeof Symbol == "function" && i1.constructor === Symbol && i1 !== Symbol.prototype ? "symbol" : typeof i1;
  }, i = /* @__PURE__ */ function() {
    function i1(t1, T1) {
      for (var X = 0; X < T1.length; X++) {
        var f1 = T1[X];
        f1.enumerable = f1.enumerable || !1, f1.configurable = !0, "value" in f1 && (f1.writable = !0), Object.defineProperty(t1, f1.key, f1);
      }
    }
    return function(t1, T1, X) {
      return T1 && i1(t1.prototype, T1), X && i1(t1, X), t1;
    };
  }(), o = y, a = Nh, T = C(a), s = Q6, Q = M(s), u = RC, l = C(u), c = T6, f = M(c), d = N0, m = M(d), p = n6, v = C(p), H = P0, E = C(H);
  function M(i1) {
    if (i1 && i1.__esModule)
      return i1;
    var t1 = {};
    if (i1 != null)
      for (var T1 in i1)
        Object.prototype.hasOwnProperty.call(i1, T1) && (t1[T1] = i1[T1]);
    return t1.default = i1, t1;
  }
  function C(i1) {
    return i1 && i1.__esModule ? i1 : { default: i1 };
  }
  function w(i1, t1) {
    if (!(i1 instanceof t1))
      throw new TypeError("Cannot call a class as a function");
  }
  function S(i1, t1) {
    if (!i1)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t1 && (typeof t1 == "object" || typeof t1 == "function") ? t1 : i1;
  }
  function D(i1, t1) {
    if (typeof t1 != "function" && t1 !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t1);
    i1.prototype = Object.create(t1 && t1.prototype, { constructor: { value: i1, enumerable: !1, writable: !0, configurable: !0 } }), t1 && (Object.setPrototypeOf ? Object.setPrototypeOf(i1, t1) : i1.__proto__ = t1);
  }
  var k = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, $ = function(t1) {
    return t1.code === "Tab" || t1.keyCode === 9;
  }, z = function(t1) {
    return t1.code === "Escape" || t1.keyCode === 27;
  }, j = 0, J = function(i1) {
    D(t1, i1);
    function t1(T1) {
      w(this, t1);
      var X = S(this, (t1.__proto__ || Object.getPrototypeOf(t1)).call(this, T1));
      return X.setOverlayRef = function(f1) {
        X.overlay = f1, X.props.overlayRef && X.props.overlayRef(f1);
      }, X.setContentRef = function(f1) {
        X.content = f1, X.props.contentRef && X.props.contentRef(f1);
      }, X.afterClose = function() {
        var f1 = X.props, s1 = f1.appElement, Z = f1.ariaHideApp, L1 = f1.htmlOpenClassName, C1 = f1.bodyOpenClassName, q = f1.parentSelector, N1 = q && q().ownerDocument || document;
        C1 && m.remove(N1.body, C1), L1 && m.remove(N1.getElementsByTagName("html")[0], L1), Z && j > 0 && (j -= 1, j === 0 && f.show(s1)), X.props.shouldFocusAfterRender && (X.props.shouldReturnFocusAfterClose ? (Q.returnFocus(X.props.preventScroll), Q.teardownScopedFocus()) : Q.popWithoutFocus()), X.props.onAfterClose && X.props.onAfterClose(), E.default.deregister(X);
      }, X.open = function() {
        X.beforeOpen(), X.state.afterOpen && X.state.beforeClose ? (clearTimeout(X.closeTimer), X.setState({ beforeClose: !1 })) : (X.props.shouldFocusAfterRender && (Q.setupScopedFocus(X.node), Q.markForFocusLater()), X.setState({ isOpen: !0 }, function() {
          X.openAnimationFrame = requestAnimationFrame(function() {
            X.setState({ afterOpen: !0 }), X.props.isOpen && X.props.onAfterOpen && X.props.onAfterOpen({
              overlayEl: X.overlay,
              contentEl: X.content
            });
          });
        }));
      }, X.close = function() {
        X.props.closeTimeoutMS > 0 ? X.closeWithTimeout() : X.closeWithoutTimeout();
      }, X.focusContent = function() {
        return X.content && !X.contentHasFocus() && X.content.focus({ preventScroll: !0 });
      }, X.closeWithTimeout = function() {
        var f1 = Date.now() + X.props.closeTimeoutMS;
        X.setState({ beforeClose: !0, closesAt: f1 }, function() {
          X.closeTimer = setTimeout(X.closeWithoutTimeout, X.state.closesAt - Date.now());
        });
      }, X.closeWithoutTimeout = function() {
        X.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, X.afterClose);
      }, X.handleKeyDown = function(f1) {
        $(f1) && (0, l.default)(X.content, f1), X.props.shouldCloseOnEsc && z(f1) && (f1.stopPropagation(), X.requestClose(f1));
      }, X.handleOverlayOnClick = function(f1) {
        X.shouldClose === null && (X.shouldClose = !0), X.shouldClose && X.props.shouldCloseOnOverlayClick && (X.ownerHandlesClose() ? X.requestClose(f1) : X.focusContent()), X.shouldClose = null;
      }, X.handleContentOnMouseUp = function() {
        X.shouldClose = !1;
      }, X.handleOverlayOnMouseDown = function(f1) {
        !X.props.shouldCloseOnOverlayClick && f1.target == X.overlay && f1.preventDefault();
      }, X.handleContentOnClick = function() {
        X.shouldClose = !1;
      }, X.handleContentOnMouseDown = function() {
        X.shouldClose = !1;
      }, X.requestClose = function(f1) {
        return X.ownerHandlesClose() && X.props.onRequestClose(f1);
      }, X.ownerHandlesClose = function() {
        return X.props.onRequestClose;
      }, X.shouldBeClosed = function() {
        return !X.state.isOpen && !X.state.beforeClose;
      }, X.contentHasFocus = function() {
        return document.activeElement === X.content || X.content.contains(document.activeElement);
      }, X.buildClassName = function(f1, s1) {
        var Z = (typeof s1 > "u" ? "undefined" : n(s1)) === "object" ? s1 : {
          base: k[f1],
          afterOpen: k[f1] + "--after-open",
          beforeClose: k[f1] + "--before-close"
        }, L1 = Z.base;
        return X.state.afterOpen && (L1 = L1 + " " + Z.afterOpen), X.state.beforeClose && (L1 = L1 + " " + Z.beforeClose), typeof s1 == "string" && s1 ? L1 + " " + s1 : L1;
      }, X.attributesFromObject = function(f1, s1) {
        return Object.keys(s1).reduce(function(Z, L1) {
          return Z[f1 + "-" + L1] = s1[L1], Z;
        }, {});
      }, X.state = {
        afterOpen: !1,
        beforeClose: !1
      }, X.shouldClose = null, X.moveFromContentToOverlay = null, X;
    }
    return i(t1, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(X, f1) {
        process.env.NODE_ENV !== "production" && (X.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), X.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !X.isOpen ? this.open() : !this.props.isOpen && X.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !f1.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var X = this.props, f1 = X.appElement, s1 = X.ariaHideApp, Z = X.htmlOpenClassName, L1 = X.bodyOpenClassName, C1 = X.parentSelector, q = C1 && C1().ownerDocument || document;
        L1 && m.add(q.body, L1), Z && m.add(q.getElementsByTagName("html")[0], Z), s1 && (j += 1, f.hide(f1)), E.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var X = this.props, f1 = X.id, s1 = X.className, Z = X.overlayClassName, L1 = X.defaultStyles, C1 = X.children, q = s1 ? {} : L1.content, N1 = Z ? {} : L1.overlay;
        if (this.shouldBeClosed())
          return null;
        var O1 = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", Z),
          style: r({}, N1, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, x1 = r({
          id: f1,
          ref: this.setContentRef,
          style: r({}, q, this.props.style.content),
          className: this.buildClassName("content", s1),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", r({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), l1 = this.props.contentElement(x1, C1);
        return this.props.overlayElement(O1, l1);
      }
    }]), t1;
  }(o.Component);
  J.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, J.propTypes = {
    isOpen: T.default.bool.isRequired,
    defaultStyles: T.default.shape({
      content: T.default.object,
      overlay: T.default.object
    }),
    style: T.default.shape({
      content: T.default.object,
      overlay: T.default.object
    }),
    className: T.default.oneOfType([T.default.string, T.default.object]),
    overlayClassName: T.default.oneOfType([T.default.string, T.default.object]),
    parentSelector: T.default.func,
    bodyOpenClassName: T.default.string,
    htmlOpenClassName: T.default.string,
    ariaHideApp: T.default.bool,
    appElement: T.default.oneOfType([T.default.instanceOf(v.default), T.default.instanceOf(p.SafeHTMLCollection), T.default.instanceOf(p.SafeNodeList), T.default.arrayOf(T.default.instanceOf(v.default))]),
    onAfterOpen: T.default.func,
    onAfterClose: T.default.func,
    onRequestClose: T.default.func,
    closeTimeoutMS: T.default.number,
    shouldFocusAfterRender: T.default.bool,
    shouldCloseOnOverlayClick: T.default.bool,
    shouldReturnFocusAfterClose: T.default.bool,
    preventScroll: T.default.bool,
    role: T.default.string,
    contentLabel: T.default.string,
    aria: T.default.object,
    data: T.default.object,
    children: T.default.node,
    shouldCloseOnEsc: T.default.bool,
    overlayRef: T.default.func,
    contentRef: T.default.func,
    id: T.default.string,
    overlayElement: T.default.func,
    contentElement: T.default.func,
    testId: T.default.string
  }, t.default = J, e.exports = t.default;
})(PT, PT.exports);
var mV = PT.exports;
function Zh() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Wh(e) {
  function t(r) {
    var n = this.constructor.getDerivedStateFromProps(e, r);
    return n ?? null;
  }
  this.setState(t.bind(this));
}
function Gh(e, t) {
  try {
    var r = this.props, n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      r,
      n
    );
  } finally {
    this.props = r, this.state = n;
  }
}
Zh.__suppressDeprecationWarning = !0;
Wh.__suppressDeprecationWarning = !0;
Gh.__suppressDeprecationWarning = !0;
function vV(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var r = null, n = null, i = null;
  if (typeof t.componentWillMount == "function" ? r = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (r = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? i = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (i = "UNSAFE_componentWillUpdate"), r !== null || n !== null || i !== null) {
    var o = e.displayName || e.name, a = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + o + " uses " + a + " but also contains the following legacy lifecycles:" + (r !== null ? `
  ` + r : "") + (n !== null ? `
  ` + n : "") + (i !== null ? `
  ` + i : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = Zh, t.componentWillReceiveProps = Wh), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Gh;
    var T = t.componentDidUpdate;
    t.componentDidUpdate = function(Q, u, l) {
      var c = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : l;
      T.call(this, Q, u, c);
    };
  }
  return e;
}
const LV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: vV
}, Symbol.toStringTag, { value: "Module" })), yV = /* @__PURE__ */ Tm(LV);
Object.defineProperty(Ye, "__esModule", {
  value: !0
});
Ye.bodyOpenClassName = Ye.portalClassName = void 0;
var kf = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, gV = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var i = r[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}(), zh = y, A9 = f8(zh), xV = wd, D9 = f8(xV), HV = Nh, d2 = f8(HV), EV = mV, If = f8(EV), bV = T6, MV = SV(bV), D5 = n6, Rf = f8(D5), wV = yV;
function SV(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t.default = e, t;
}
function f8(e) {
  return e && e.__esModule ? e : { default: e };
}
function CV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nf(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function VV(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var _V = Ye.portalClassName = "ReactModalPortal", OV = Ye.bodyOpenClassName = "ReactModal__Body--open", ke = D5.canUseDOM && D9.default.createPortal !== void 0, $T = function(t) {
  return document.createElement(t);
}, Pf = function() {
  return ke ? D9.default.createPortal : D9.default.unstable_renderSubtreeIntoContainer;
};
function Pn(e) {
  return e();
}
var B0 = function(e) {
  VV(t, e);
  function t() {
    var r, n, i, o;
    CV(this, t);
    for (var a = arguments.length, T = Array(a), s = 0; s < a; s++)
      T[s] = arguments[s];
    return o = (n = (i = Nf(this, (r = t.__proto__ || Object.getPrototypeOf(t)).call.apply(r, [this].concat(T))), i), i.removePortal = function() {
      !ke && D9.default.unmountComponentAtNode(i.node);
      var Q = Pn(i.props.parentSelector);
      Q && Q.contains(i.node) ? Q.removeChild(i.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, i.portalRef = function(Q) {
      i.portal = Q;
    }, i.renderPortal = function(Q) {
      var u = Pf(), l = u(i, A9.default.createElement(If.default, kf({ defaultStyles: t.defaultStyles }, Q)), i.node);
      i.portalRef(l);
    }, n), Nf(i, o);
  }
  return gV(t, [{
    key: "componentDidMount",
    value: function() {
      if (D5.canUseDOM) {
        ke || (this.node = $T("div")), this.node.className = this.props.portalClassName;
        var n = Pn(this.props.parentSelector);
        n.appendChild(this.node), !ke && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(n) {
      var i = Pn(n.parentSelector), o = Pn(this.props.parentSelector);
      return { prevParent: i, nextParent: o };
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, i, o) {
      if (D5.canUseDOM) {
        var a = this.props, T = a.isOpen, s = a.portalClassName;
        n.portalClassName !== s && (this.node.className = s);
        var Q = o.prevParent, u = o.nextParent;
        u !== Q && (Q.removeChild(this.node), u.appendChild(this.node)), !(!n.isOpen && !T) && !ke && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!D5.canUseDOM || !this.node || !this.portal)) {
        var n = this.portal.state, i = Date.now(), o = n.isOpen && this.props.closeTimeoutMS && (n.closesAt || i + this.props.closeTimeoutMS);
        o ? (n.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, o - i)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!D5.canUseDOM || !ke)
        return null;
      !this.node && ke && (this.node = $T("div"));
      var n = Pf();
      return n(A9.default.createElement(If.default, kf({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(n) {
      MV.setElement(n);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(zh.Component);
B0.propTypes = {
  isOpen: d2.default.bool.isRequired,
  style: d2.default.shape({
    content: d2.default.object,
    overlay: d2.default.object
  }),
  portalClassName: d2.default.string,
  bodyOpenClassName: d2.default.string,
  htmlOpenClassName: d2.default.string,
  className: d2.default.oneOfType([d2.default.string, d2.default.shape({
    base: d2.default.string.isRequired,
    afterOpen: d2.default.string.isRequired,
    beforeClose: d2.default.string.isRequired
  })]),
  overlayClassName: d2.default.oneOfType([d2.default.string, d2.default.shape({
    base: d2.default.string.isRequired,
    afterOpen: d2.default.string.isRequired,
    beforeClose: d2.default.string.isRequired
  })]),
  appElement: d2.default.oneOfType([d2.default.instanceOf(Rf.default), d2.default.instanceOf(D5.SafeHTMLCollection), d2.default.instanceOf(D5.SafeNodeList), d2.default.arrayOf(d2.default.instanceOf(Rf.default))]),
  onAfterOpen: d2.default.func,
  onRequestClose: d2.default.func,
  closeTimeoutMS: d2.default.number,
  ariaHideApp: d2.default.bool,
  shouldFocusAfterRender: d2.default.bool,
  shouldCloseOnOverlayClick: d2.default.bool,
  shouldReturnFocusAfterClose: d2.default.bool,
  preventScroll: d2.default.bool,
  parentSelector: d2.default.func,
  aria: d2.default.object,
  data: d2.default.object,
  role: d2.default.string,
  contentLabel: d2.default.string,
  shouldCloseOnEsc: d2.default.bool,
  overlayRef: d2.default.func,
  contentRef: d2.default.func,
  id: d2.default.string,
  overlayElement: d2.default.func,
  contentElement: d2.default.func
};
B0.defaultProps = {
  isOpen: !1,
  portalClassName: _V,
  bodyOpenClassName: OV,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, r) {
    return A9.default.createElement(
      "div",
      t,
      r
    );
  },
  contentElement: function(t, r) {
    return A9.default.createElement(
      "div",
      t,
      r
    );
  }
};
B0.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, wV.polyfill)(B0);
process.env.NODE_ENV !== "production" && (B0.setCreateHTMLElement = function(e) {
  return $T = e;
});
Ye.default = B0;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = Ye, n = i(r);
  function i(o) {
    return o && o.__esModule ? o : { default: o };
  }
  t.default = n.default, e.exports = t.default;
})(RT, RT.exports);
var AV = RT.exports;
const Kn = /* @__PURE__ */ Sd(AV);
var Uh = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Bf = y.createContext && y.createContext(Uh), R5 = function() {
  return R5 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, R5.apply(this, arguments);
}, DV = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
};
function Xh(e) {
  return e && e.map(function(t, r) {
    return y.createElement(t.tag, R5({
      key: r
    }, t.attr), Xh(t.child));
  });
}
function g3(e) {
  return function(t) {
    return y.createElement(kV, R5({
      attr: R5({}, e.attr)
    }, t), Xh(e.child));
  };
}
function kV(e) {
  var t = function(r) {
    var n = e.attr, i = e.size, o = e.title, a = DV(e, ["attr", "size", "title"]), T = i || r.size || "1em", s;
    return r.className && (s = r.className), e.className && (s = (s ? s + " " : "") + e.className), y.createElement("svg", R5({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, a, {
      className: s,
      style: R5(R5({
        color: e.color || r.color
      }, r.style), e.style),
      height: T,
      width: T,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && y.createElement("title", null, o), e.children);
  };
  return Bf !== void 0 ? y.createElement(Bf.Consumer, null, function(r) {
    return t(r);
  }) : t(Uh);
}
function ZT(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] })(e);
}
function k9(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] })(e);
}
const a1 = {
  // spacing
  spacing1: "0.25rem",
  // previously theme.spacingHalf
  spacing2: "0.5rem",
  // previously theme.spacing
  spacing4: "1rem",
  // previously theme.spacing2x
  spacing6: "1.5rem",
  // previously theme.spacing3x
  spacing8: "2rem",
  // previously theme.spacing4x
  spacing10: "2.5rem",
  // previously theme.spacing5x
  spacing16: "4rem",
  // previously theme.spacing8x
  // font sizes
  text_xs: "0.75rem",
  // previously theme.fontxxxs
  text_sm: "0.875rem",
  // previously theme.fontxxs and theme.fontxs
  text_base: "1rem",
  // previously theme.fonts
  text_lg: "1.125rem",
  // previously theme.fontm
  text_2xl: "1.5rem",
  // previously theme.fontl
  text_3xl: "1.875rem",
  // previously theme.fontxl
  text_4xl: "2.25rem",
  // previously theme.fontxxl
  // font weights
  font_light: "300",
  // previously theme.fontLight
  font_normal: "400",
  // previously theme.fontRegular
  font_medium: "500",
  // previously theme.fontSlightBold
  font_semibold: "600",
  // previously theme.fontSemibold
  font_bold: "700"
  // previously theme.fontBold
}, Ff = 10;
Kn.defaultStyles = {
  overlay: {
    ...Kn.defaultStyles.overlay,
    zIndex: Ff
  },
  content: {
    ...Kn.defaultStyles.content,
    zIndex: Ff,
    top: "45%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    maxWidth: "80%",
    borderRadius: "4px",
    overflowY: "auto",
    padding: "0",
    transform: "translate(-50%, -50%)"
  }
};
function Fo({
  onClose: e,
  isOpen: t = !1,
  children: r,
  closeButton: n = !0,
  className: i = "",
  parentSelector: o,
  overlayClassName: a = ""
}) {
  return /* @__PURE__ */ y.createElement(RV, { ariaHideApp: !1, className: S3("text-brand-space-blue border-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg", i), overlayClassName: S3("fixed inset-0 bg-black/70 z-10", a), isOpen: t, onRequestClose: e, parentSelector: o ? () => o : void 0 }, r, n && /* @__PURE__ */ y.createElement(IV, { onClick: e, title: "Close Modal" }, /* @__PURE__ */ y.createElement(k9, null)));
}
const IV = M1.button.withConfig({
  displayName: "modal__CloseButton",
  componentId: "sc-oes13x-0"
})(["position:absolute;cursor:pointer;background-color:transparent;border:none;color:", ";margin:", ";font-weight:", ";font-size:", ";top:0;right:0;transition:transform 200ms ease-in-out;&:hover{transform:scale(1.25);}"], ({
  theme: e
}) => e.darkGreyColor, a1.spacing2, a1.font_bold, a1.text_lg);
var RV = M1(Kn).withConfig({
  displayName: "modal___StyledReactModal",
  componentId: "sc-oes13x-1"
})(["::-webkit-scrollbar{border-radius:4px;width:8px;height:8px;}::-webkit-scrollbar-track{border-radius:4px;background:#f1f1f1;}::-webkit-scrollbar-thumb{border-radius:4px;background:#888;}&:focus-visible{outline:none;}"]);
function qh({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ y.createElement("div", { className: S3("font-base text-lg font-semibold py-2 px-3 bg-primary-600 flex justify-between items-center bg-brand-primary-600 text-white", t) }, e);
}
function Jh({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ y.createElement("div", { className: S3("max-h-[80vh] overflow-y-auto p-6 bg-brand-deep-blue text-white", t) }, e);
}
const y2 = {
  // Row 1 from Brand Guide
  SPACE_BLUE: "#08002B",
  DEEP_BLUE: "#24176D",
  HORIZON_BLUE: "#501FFF",
  // Primary
  ULTRA_SOFT_VIOLET: "#6C54F0",
  DUSK: "#A497FF",
  NEBULA: "#E4DFFF",
  // Row 2 from Brand Guide
  SUN: "#EEAB38",
  STAR: "#F1C871",
  DAWN: "#F3DDA9",
  CELESTIAL_BLUE: "#3D7CF1",
  SKY_BLUE: "#6E9EFF",
  CLOUD_BLUE: "#DFE7F6",
  // Row 3 from Brand Guide
  BLACK: "#000000",
  GREY_A: "#80808A",
  GREY_B: "#BAB9C9",
  GREY_C: "#E4E3E9",
  WHITE: "#FFFFFF",
  // Not in Brand Guide
  ERROR: "#ED4245",
  WARNING: "#FEE75C",
  SUCCESS: "#00CC99"
}, b4 = {
  /* fonts */
  fontFamily: {
    headline: '"Ginto Nord"',
    body: '"Space Grotesk"',
    button: '"Space Mono"',
    subhead: '"Space Mono"',
    headlineFallback: "sans-serif",
    bodyFallback: "sans-serif",
    buttonFallback: "monospace",
    subheadFallback: "monospace"
  },
  /* colors */
  // semantic colors. These should be used where possible
  primary: y2.HORIZON_BLUE,
  primaryDark: y2.DEEP_BLUE,
  primary50: y2.NEBULA,
  primary100: "#dcd2ff",
  primary200: "#b9a5ff",
  primary250: "#a88fff",
  primary300: "#8562ff",
  primary400: y2.ULTRA_SOFT_VIOLET,
  // '#734cff',
  primary500: y2.HORIZON_BLUE,
  primary600: "#4019cc",
  primary700: "#301399",
  primary750: y2.DEEP_BLUE,
  primary800: "#18094c",
  primary900: "#100633",
  primary950: y2.SPACE_BLUE,
  secondary: y2.DUSK,
  secondaryDark: y2.ULTRA_SOFT_VIOLET,
  secondaryLight: y2.NEBULA,
  accent: y2.STAR,
  accentDark: y2.SUN,
  accentLight: y2.DAWN,
  // MAYBE REMOVE
  darkBackground: y2.SPACE_BLUE,
  black: y2.BLACK,
  neutralDark: y2.GREY_A,
  neutral: y2.GREY_B,
  neutralLight: y2.GREY_C,
  white: y2.WHITE,
  error: y2.ERROR,
  warning: y2.WARNING,
  success: y2.SUCCESS,
  info: y2.CELESTIAL_BLUE,
  // colors straight from color palette. These should be avoided where possible
  _spaceBlue: y2.SPACE_BLUE,
  _deepBlue: y2.DEEP_BLUE,
  _horizonBlue: y2.HORIZON_BLUE,
  _ultraSoftViolet: y2.ULTRA_SOFT_VIOLET,
  _dusk: y2.DUSK,
  _nebula: y2.NEBULA,
  _sun: y2.SUN,
  _star: y2.STAR,
  _dawn: y2.DAWN,
  _celestialBlue: y2.CELESTIAL_BLUE,
  _skyBlue: y2.SKY_BLUE,
  _cloudBlue: y2.CLOUD_BLUE,
  _greyA: y2.GREY_A,
  _greyB: y2.GREY_B,
  _greyC: y2.GREY_C
}, jf = {
  primary: {
    base: "",
    fill: "bg-gradient-to-r from-brand-horizon-blue to-brand-ultra-soft-violet text-brand-primary-50 bg-origin-border",
    outline: "border-brand-dusk text-brand-dusk"
  },
  secondary: {
    base: "",
    fill: "bg-brand-star text-brand-space-blue",
    outline: "border-brand-star text-brand-star"
  },
  danger: {
    base: "",
    fill: "bg-error text-white",
    outline: "border-error text-error"
  },
  warning: {
    base: "",
    fill: "bg-warning text-brand-space-blue",
    outline: "border-warning text-warning"
  }
};
function k5({
  children: e,
  variant: t = "primary",
  outline: r,
  className: n,
  as: i = "button",
  ...o
}) {
  const a = [
    // basic styles
    "rounded-lg font-button uppercase whitespace-nowrap font-medium py-1 px-2 text-sm border-2",
    // focus styles
    "outline-none outline-offset-0 focus-visible:outline-nebula",
    // disabled styles
    "disabled:bg-neutral-light disabled:text-brand-space-blue disabled:bg-none disabled:brightness-100 disabled:opacity-80"
  ], T = jf[t] || jf.primary;
  return a.push(T.base), r ? (a.push("bg-transparent hover:brightness-125 active:brightness-150"), a.push(T.outline)) : (a.push("border-transparent hover:brightness-90 active:brightness-75"), a.push(T.fill)), n && a.push(n), /* @__PURE__ */ W3.createElement(i, { ...o, className: a.join(" ") }, e);
}
function NV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" } }] })(e);
}
function PV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" } }] })(e);
}
function BV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z" } }] })(e);
}
function jo(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" } }] })(e);
}
function FV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z" } }] })(e);
}
function jV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" } }] })(e);
}
function $V(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" } }] })(e);
}
function Yh(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 352 512" }, child: [{ tag: "path", attr: { d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" } }] })(e);
}
function $o(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z" } }] })(e);
}
function ZV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z" } }] })(e);
}
function WV(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z" } }] })(e);
}
function qs({
  onCancel: e,
  onConfirm: t,
  isOpen: r,
  children: n,
  confirmText: i = "Ok",
  className: o,
  ...a
}) {
  return /* @__PURE__ */ y.createElement(Fo, { isOpen: r, onClose: e, ...a, className: S3(o, "overflow-hidden") }, /* @__PURE__ */ y.createElement("div", { className: "p-6 bg-brand-cloud-blue" }, n), /* @__PURE__ */ y.createElement("div", { className: "flex justify-end bg-brand-deep-blue p-2 gap-2" }, /* @__PURE__ */ y.createElement(k5, { outline: !0, onClick: e }, "Cancel"), /* @__PURE__ */ y.createElement(k5, { onClick: t }, i)));
}
const Js = "\\markdown ";
function Dk(e) {
  return d8(e) ? e : Js + e;
}
function Zo(e) {
  return d8(e) ? (
    // NOTE: a leading space is added due to a bug in markdown-to-jsx
    " " + e.substring(Js.length, e.length)
  ) : null;
}
function Kh(e) {
  return e.replaceAll("\\", "\\\\").replaceAll("*", "\\*").replaceAll("<", "\\<").replaceAll(">", "\\>").replaceAll("#", "\\#").replaceAll("-", "\\-").replaceAll("=", "\\=").replaceAll("`", "\\`").replaceAll("_", "\\_");
}
function ep(e) {
  return m3(() => Zo(e), [e]);
}
function d8(e) {
  return e.startsWith(Js);
}
function tp() {
  const e = m4({
    firstEventTypeHandledInCurrentEvaluationLoop: null,
    previouslyHandledEventTypes: [],
    noteEventType: (t) => {
      e.current.previouslyHandledEventTypes.push(t), e.current.firstEventTypeHandledInCurrentEvaluationLoop == null && (e.current.firstEventTypeHandledInCurrentEvaluationLoop = t, setTimeout(() => {
        e.current.firstEventTypeHandledInCurrentEvaluationLoop = null, e.current.previouslyHandledEventTypes = [];
      }, 0));
    }
  });
  return e;
}
const Be = {
  ANNOTATE: "ANNOTATE",
  ERASE_WHOLE_ANNOTATION: "ERASE_WHOLE_ANNOTATION",
  ERASE_RANGE: "ERASE_RANGE"
}, GV = {
  ANNOTATION_LIMIT_EXCEEDED: "ANNOTATION_LIMIT_EXCEEDED",
  UNKNOWN_ERROR: "UNKNOWN_ERROR"
};
function zV({
  markdown: e,
  annotations: t,
  annotationLimit: r,
  onError: n,
  readOnlyAnnotations: i,
  setAnnotations: o,
  annotationInformation: a,
  className: T,
  selectableTextClassName: s
}) {
  const Q = tp(), [u, l] = W1(null);
  G3(() => {
    if (!u)
      return;
    const d = new AbortController();
    return window.addEventListener("click", (m) => {
      var p, v;
      ((p = Q.current) == null ? void 0 : p.firstEventTypeHandledInCurrentEvaluationLoop) == null && ((v = Q.current) == null || v.noteEventType(m.type), l(null));
    }, {
      signal: d.signal
    }), () => d.abort();
  }, [u]);
  function c({
    range: d,
    rangeOverlappingNextSelectableElement: m,
    extendedRangeToNextSelectableElements: p
  }) {
    if (!a)
      return t;
    if (a.method === Be.ANNOTATE) {
      const v = {
        id: KS(t),
        range: d,
        style: {
          tool: a.tool,
          color: a.color
        }
      }, H = rC(t, v);
      if (H)
        return u !== H.id && l(H.id), t;
      const E = pf(t, v, m, e.length);
      return r != null && E.length > r ? (n == null || n(GV.ANNOTATION_LIMIT_EXCEEDED), t) : (l(v.id), E);
    }
    return a.method === Be.ERASE_RANGE ? Xn(t, {
      range: p,
      style: {
        tool: a.tool,
        color: a.color
      }
    }) : a.method === Be.ERASE_WHOLE_ANNOTATION ? YS(t, {
      range: p,
      style: {
        tool: a.tool,
        color: a.color
      }
    }) : t;
  }
  const f = m3(() => i != null ? [...i, ...t] : t, [i, t]);
  return /* @__PURE__ */ y.createElement(c8, { className: T, markdown: e, annotations: f, ...a ? {
    readOnly: !1,
    onRangeSelectionPreview: (d) => [...c(d), ...i ?? []],
    onRangeSelection: (d) => {
      o == null || o(c(d));
    },
    onAnnotationRangeUpdatePreview: (d, m) => {
      const {
        otherAnnotations: p,
        updatedAnnotation: v
      } = vf(d, m, t);
      return v && p.push(v), p;
    },
    onAnnotationRangeUpdate: (d, m) => {
      if (!o)
        return;
      const {
        otherAnnotations: p,
        updatedAnnotation: v
      } = vf(d, m, t);
      v && o(pf(p, v, m.rangeOverlappingNextSelectableElement, e.length));
    },
    selectedAnnotationId: u,
    eventTrackerRef: Q
  } : {
    readOnly: !0
  }, selectableTextClassName: s });
}
const Ys = {};
kh.forEach((e) => {
  Ys[e] = [...Zs];
});
function UV(e = Ys) {
  var s;
  const [t, r] = W1(
    // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    Object.keys(e)[0]
  ), [n, i] = W1(
    // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    t ? (s = e[t]) == null ? void 0 : s[0] : null
  ), [o, a] = W1("none");
  let T = null;
  return o === "none" && n != null && t != null ? T = {
    color: n,
    tool: t,
    method: Be.ANNOTATE
  } : o === Be.ERASE_WHOLE_ANNOTATION ? T = {
    color: null,
    tool: null,
    method: o
  } : o === Be.ERASE_RANGE && (T = {
    color: null,
    tool: null,
    method: o
  }), {
    currentAnnotationInformation: T,
    toolSelector: /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("div", { className: "flex flex-row gap-2 mb-2" }, "Color:", " ", /* @__PURE__ */ y.createElement("div", { className: "flex flex-row justify-center items-center gap-2" }, t && e[t].map((Q) => /* @__PURE__ */ y.createElement(x0, { disabled: o != "none", style: {
      backgroundColor: wr([Q]) ?? void 0
    }, onClick: () => {
      if (n === Q) {
        o != "none" && i(null);
        return;
      }
      i(Q);
    }, selected: n === Q, key: Q })))), /* @__PURE__ */ y.createElement("div", { className: "flex flex-row gap-2 mb-2" }, "Tools:", " ", /* @__PURE__ */ y.createElement("div", { className: "flex flex-row justify-center items-center gap-2" }, Object.keys(e).map((Q) => /* @__PURE__ */ y.createElement(x0, { disabled: o != "none", className: "flex flex-row items-center bg-gray-c justify-center text-xs text-black", onClick: () => {
      if (t === Q) {
        o != "none" && r(null);
        return;
      }
      r(Q);
    }, key: Q, selected: Q === t }, /* @__PURE__ */ y.createElement("div", { style: Gs({
      style: {
        tool: Q,
        color: n ?? Ws
      }
    }), className: "!decoration-2" }, " A "))))), /* @__PURE__ */ y.createElement("div", { className: "flex flex-row gap-2" }, [
      Be.ERASE_WHOLE_ANNOTATION
      /* 
      // This is commented out on purpose!
      We do not want to display this eraser to the creator since students do not have access to it! 
      If we every allow them to use the range eraser, then we can add this back in.
      ANNOTATION_INFORMATION_METHODS.ERASE_RANGE, 
      */
    ].map((Q) => /* @__PURE__ */ y.createElement(x0, { className: "flex flex-row items-center bg-gray-c justify-center text-xs text-black max-w-full px-2", onClick: () => {
      if (o === Q) {
        t === null && r(kh[0]), n === null && i(Zs[0]), a("none");
        return;
      }
      a(Q);
    }, selected: Q === o, key: Q }, /* @__PURE__ */ y.createElement(FV, null), "  Erase", " ", Q.split("_").slice(1).join(" ").toLowerCase()))))
  };
}
function kk({
  prompt: e,
  markdown: t,
  targetAnnotations: r,
  setTargetAnnotations: n,
  onWarn: i,
  parentRef: o,
  availableAnnotationStyles: a = Ys
}) {
  const [T, s] = W1(null), [Q, u] = W1(!1), [l, c] = W1(!1), f = T !== null ? r[T] : null, d = /* @__PURE__ */ y.createElement(c8, { markdown: t, annotations: r.map(({
    range: m,
    style: p
  }, v) => ({
    id: `r-${v}`,
    range: m,
    style: {
      color: p.color ?? V9,
      tool: p.tool ?? g2.ANNOTATION_TOOL.HIGHLIGHT
    }
  })), readOnly: !0 });
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("div", { className: "flex flex-row gap-2 items-center max-w-full justify-between w-full" }, /* @__PURE__ */ y.createElement("div", { className: "flex-1 flex flex-wrap gap-2 items-center overflow-x-auto" }, r.map((m, p) => /* @__PURE__ */ y.createElement(XV, { parentRef: o, key: `target-annotation-${p}`, onEdit: () => s(p), onDelete: () => n(r.filter((v, H) => H !== p)), className: m.style.tool != null && m.style.tool != g2.ANNOTATION_TOOL.HIGHLIGHT ? "border-1 border-r-0 border-black border rounded-l" : "", style: Gs(m) }, /* @__PURE__ */ y.createElement("div", { className: "divide-x space-x-2" }, /* @__PURE__ */ y.createElement("span", null, "Edit ", p + 1), /* @__PURE__ */ y.createElement("span", { className: "p-2 text-xs" }, m.score, "pt", m.score > 1 ? "s" : "", m.required ? " (required)" : ""))))), /* @__PURE__ */ y.createElement(k5, { className: "normal-case self-start", variant: "secondary", onClick: () => {
    u(!0);
  } }, "Add Annotation Target"), /* @__PURE__ */ y.createElement(k5, { className: "normal-case self-start", variant: "secondary", onClick: () => {
    c(!0);
  } }, "Test")), d, f || Q ? /* @__PURE__ */ y.createElement(
    qV,
    {
      prompt: e,
      annotationStyles: a,
      parentRef: o,
      startingData: Q ? null : f,
      onSave: (m) => {
        const p = Q ? r.length : T;
        if (p != null) {
          const v = [...r];
          v[p] = m, n(v);
        }
        s(null), Q && u(!1);
      },
      markdown: t,
      onWarn: i,
      onCancel: () => {
        u(!1), s(null);
      }
    }
  ) : null, l ? /* @__PURE__ */ y.createElement(JV, { prompt: e, availableAnnotationStyles: a, parentRef: o, onRequestClose: () => c(!1), markdown: t, targetAnnotations: r }) : null);
}
function XV({
  onEdit: e,
  onDelete: t,
  style: r,
  className: n,
  children: i,
  parentRef: o
}) {
  const [a, T] = W1(!1);
  return /* @__PURE__ */ y.createElement("div", { className: "flex items-stretch text-black rounded overflow-hidden" }, /* @__PURE__ */ y.createElement("button", { onClick: e, className: S3(n, "pl-2 hover:brightness-75"), style: r }, i), /* @__PURE__ */ y.createElement("button", { title: "Delete", onClick: () => T(!0), className: "bg-error p-1 flex items-center hover:brightness-75 text-white px-2" }, /* @__PURE__ */ y.createElement($o, { size: 12 })), /* @__PURE__ */ y.createElement(qs, { parentSelector: (o == null ? void 0 : o.current) || void 0, isOpen: !!a, confirmText: "Delete", onCancel: () => T(!1), onConfirm: () => {
    T(!1), t();
  } }, "Are you sure you want to delete this target annotation: ", i, "?"));
}
function qV({
  prompt: e,
  startingData: t,
  parentRef: r,
  onSave: n,
  onCancel: i,
  markdown: o,
  onWarn: a,
  annotationStyles: T
}) {
  const [s, Q] = W1((t == null ? void 0 : t.range) ?? null), [u, l] = W1((t == null ? void 0 : t.buffer) ?? null), [c, f] = W1(() => {
    var J;
    const j = Object.keys(T)[0];
    return (t == null ? void 0 : t.style) ?? {
      tool: j,
      color: ((J = T[j]) == null ? void 0 : J[0]) ?? null
    };
  }), [d, m] = W1("target"), [p, v] = W1((t == null ? void 0 : t.required) ?? !1), [H, E] = W1((t == null ? void 0 : t.score) ?? 1), M = tp(), [C, w] = W1(null), S = c.tool ? T[c.tool] : Zs, D = S.length > 1;
  G3(() => {
    const j = new AbortController();
    return window.addEventListener("click", () => {
      var J;
      ((J = M.current) == null ? void 0 : J.firstEventTypeHandledInCurrentEvaluationLoop) == null && w(null);
    }), () => j.abort();
  }, []);
  const k = /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("div", { className: "flex flex-row gap-2 my-2 items-center" }, "Color:", " ", /* @__PURE__ */ y.createElement("div", { className: "flex flex-row justify-center items-center gap-2" }, S.map((j) => /* @__PURE__ */ y.createElement(x0, { style: {
    backgroundColor: wr([j]) ?? void 0
  }, onClick: () => {
    c.color !== j && f((J) => ({
      ...J,
      color: j
    }));
  }, selected: c.color === j, key: j })), D && /* @__PURE__ */ y.createElement(x0, { className: "flex flex-row items-center bg-gray-b justify-center text-xs text-white", onClick: () => {
    c.color !== null && f((j) => ({
      ...j,
      color: null
    }));
  }, selected: c.color == null }, "Any"))), /* @__PURE__ */ y.createElement("div", { className: "flex flex-row gap-2 mb-2 items-center" }, "Tool:", " ", /* @__PURE__ */ y.createElement("div", { className: "flex flex-row justify-center items-center gap-2" }, Object.keys(T).map((j) => /* @__PURE__ */ y.createElement(x0, { className: "flex flex-row items-center bg-white justify-center text-xs text-black", onClick: () => {
    if (c.tool === j)
      return;
    const J = T[j].length > 1, i1 = c.color ? T[j].includes(c.color) : J;
    f({
      color: i1 ? c.color : J ? null : T[j][0],
      tool: j
    });
  }, key: j, selected: j === c.tool }, /* @__PURE__ */ y.createElement("div", { style: Gs({
    style: {
      tool: j,
      color: c.color ?? Ws
    }
  }), className: "!decoration-2" }, " A "))))));
  function $(j) {
    let J = s, i1 = u;
    const t1 = [];
    (j == null ? void 0 : j.forSection) === "target" ? (J = j.range, u && Or(J, u) ? i1 = {
      start: Math.min(j.range.start, u.start),
      end: Math.max(j.range.end, u.end)
    } : i1 = j.range) : (j == null ? void 0 : j.forSection) === "buffer" && (s ? (J = s, Or(j.range, J) ? i1 = {
      start: Math.min(j.range.start, s.start),
      end: Math.max(j.range.end, s.end)
    } : (i1 = s, t1.push("The buffer has to be continuous and contain the target range"))) : t1.push("You have to select a target range first"));
    const T1 = [];
    let X = null;
    J && (X = {
      id: "target",
      range: J,
      style: {
        tool: c.tool ?? g2.ANNOTATION_TOOL.HIGHLIGHT,
        color: c.color ?? V9
      }
    }, T1.push(X));
    let f1 = null;
    return i1 && J && (f1 = {
      id: "buffer",
      range: i1,
      style: qQ
    }, T1.push(...Xn([f1], {
      range: J
    }))), {
      annotations: T1,
      ranges: {
        target: J,
        buffer: i1
      },
      warnings: t1,
      bufferAnnotation: f1,
      targetAnnotation: X
    };
  }
  const z = $();
  return /* @__PURE__ */ y.createElement(Fo, { isOpen: !0, parentSelector: (r == null ? void 0 : r.current) || void 0, onClose: i, closeButton: !1, className: "overflow-hidden" }, /* @__PURE__ */ y.createElement(qh, { className: "flex justify-between" }, d === "target" ? /* @__PURE__ */ y.createElement(y.Fragment, null, "What is the minimum acceptable target annotation?", s && /* @__PURE__ */ y.createElement(k5, { variant: "secondary", onClick: (j) => {
    var J;
    if (!s) {
      a("You must select a minimum acceptable range before continuing.");
      return;
    }
    (J = M.current) == null || J.noteEventType(j.type), m("buffer"), w(null);
  } }, "Next")) : /* @__PURE__ */ y.createElement(y.Fragment, null, "What is the maximum acceptable target annotation?", /* @__PURE__ */ y.createElement(k5, { onClick: (j) => {
    var J;
    (J = M.current) == null || J.noteEventType(j.type), m("target"), w("target");
  } }, "Back"), /* @__PURE__ */ y.createElement(k5, { variant: "secondary", className: "ml-2", onClick: () => {
    if (!s || !u) {
      a("You must select a minimum and maximum acceptable range before continuing.");
      return;
    }
    w(null), n({
      score: H,
      required: p,
      range: s,
      buffer: u,
      style: c
    });
  } }, "Save"))), /* @__PURE__ */ y.createElement(Jh, { className: "flex flex-col justify-between py-2" }, /* @__PURE__ */ y.createElement("div", { className: "my-2" }, "Prompt: ", /* @__PURE__ */ y.createElement("span", { className: "my-2 bg-white/20 w-fit p-1 rounded text-base leading-8" }, e)), /* @__PURE__ */ y.createElement("div", { className: "flex flex-row justify-between py-2 items-center" }, /* @__PURE__ */ y.createElement(k5, { onClick: () => {
    if (d === "target") {
      Q(null), l(null);
      return;
    }
    l(s);
  } }, "Clear Selection"), /* @__PURE__ */ y.createElement("label", null, /* @__PURE__ */ y.createElement("input", { type: "checkbox", checked: p, onChange: (j) => v(j.target.checked) }), " ", "required"), /* @__PURE__ */ y.createElement("label", null, "Score", " ", /* @__PURE__ */ y.createElement("input", { type: "number", className: "text-black pl-2 rounded", value: H, onChange: (j) => {
    try {
      const J = Number(j.target.value);
      if (Number.isNaN(J) || !Number.isFinite(J))
        return;
      E(J);
    } catch {
      return;
    }
  } }))), /* @__PURE__ */ y.createElement(c8, { className: " max-h-[70%] p-4 px-10 overflow-y-auto rounded bg-white", readOnly: !1, onRangeSelection: ({
    range: j
  }) => {
    const J = $({
      forSection: d,
      range: j
    });
    J.warnings.forEach((i1) => a(i1)), Q(J.ranges.target), l(J.ranges.buffer), d === "target" && w(d);
  }, onRangeSelectionPreview: ({
    range: j
  }) => {
    if (d === "target") {
      const i1 = [{
        id: "preview-target-annotation",
        style: {
          tool: c.tool ?? g2.ANNOTATION_TOOL.HIGHLIGHT,
          color: c.color ?? V9
        },
        range: j
      }];
      return z.bufferAnnotation && i1.push(...Xn([z.bufferAnnotation], {
        range: j
      })), i1;
    }
    if (d === "buffer" && z.targetAnnotation) {
      const J = {
        id: "buffer",
        style: qQ,
        range: j
      };
      return s ? [z.targetAnnotation, ...Xn([J], {
        range: s
      })] : [J];
    }
    return [{
      id: "this-should-not-be-possible",
      range: j,
      style: qQ
    }];
  }, markdown: o, annotations: z.annotations, eventTrackerRef: M, onAnnotationRangeUpdate: (j, J) => {
    if (!(j === "buffer" || j === "target"))
      return;
    const i1 = $({
      forSection: j,
      range: J.range
    });
    Q(i1.ranges.target), l(i1.ranges.buffer), j === "target" && w(j);
  }, onAnnotationRangeUpdatePreview: (j, J) => $(j === "buffer" || j === "target" ? {
    forSection: j,
    range: J.range
  } : null).annotations, selectedAnnotationId: C }), /* @__PURE__ */ y.createElement("div", { className: "flex flex-row justify-between gap-4 p-2 items-baseline" }, k)));
}
function x0({
  className: e,
  selected: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ y.createElement("button", { className: S3(e, "min-w-6 max-w-6 min-h-6 max-h-6 rounded-full cursor-pointer relative disabled:!cursor-not-allowed"), ...n }, t ? /* @__PURE__ */ y.createElement("div", { className: "rounded-full bg-white absolute bottom-0 right-0 text-success p-[2px] text-xs translate-x-1/2 translate-y-1/4" }, /* @__PURE__ */ y.createElement(PV, null)) : null, r);
}
function JV({
  markdown: e,
  prompt: t,
  targetAnnotations: r,
  onRequestClose: n,
  parentRef: i,
  availableAnnotationStyles: o
}) {
  const [a, T] = W1([]), s = m3(() => r.reduce((f, d) => f += d.score, 0), [r]), Q = m3(() => J6.rangeTransformers.selectWholeElementRangeTransformer(J6.selectableRangesGenerators.getVisibleWordsFromAst(J6.parseMarkdownToAST(e))), [e]), u = m3(() => J6.gradeAnnotations(
    r,
    // @ts-expect-error ts(2345) the color type on annotations in `question-views` is a string, while in `question-toolkit` it is an Enum. This difference is to handle some transformation needed in the rendering step.
    a,
    Q
  ), [r, a, Q]), {
    currentAnnotationInformation: l,
    toolSelector: c
  } = UV(o);
  return /* @__PURE__ */ y.createElement(Fo, { isOpen: !0, onClose: n, closeButton: !1, parentSelector: (i == null ? void 0 : i.current) || void 0 }, /* @__PURE__ */ y.createElement(qh, { className: "flex justify-between" }, /* @__PURE__ */ y.createElement("div", null, "Grade: ", (u == null ? void 0 : u.score) ?? "NONE", " / ", s), /* @__PURE__ */ y.createElement("div", null, "All Required Targets Satisfied:", " ", u == null || u.allRequiredTargetsSatisfied ? "Yes" : "No")), /* @__PURE__ */ y.createElement(Jh, null, /* @__PURE__ */ y.createElement("div", { className: "my-2" }, "Prompt: ", /* @__PURE__ */ y.createElement("span", { className: "my-2 bg-white/20 w-fit p-1 rounded text-base leading-8" }, t)), /* @__PURE__ */ y.createElement("div", { className: "text-white mb-2" }, c), /* @__PURE__ */ y.createElement(zV, { markdown: e, setAnnotations: T, annotations: a, annotationInformation: l, className: "bg-white p-2" })));
}
const qQ = {
  tool: g2.ANNOTATION_TOOL.HIGHLIGHT,
  color: Ws
}, YV = ["a", "img"], KV = ["img"];
function Ik({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ y.createElement(c8, { markdown: e, readOnly: !0, disabledHtmlTags: KV, className: t });
}
const e_ = /* @__PURE__ */ new Set(["paragraph", "listItem", "blockquote", "break", "heading", "code", "break"]);
function t_(e, t) {
  var r;
  try {
    const n = J6.parseMarkdownToAST(e), i = [], o = [{
      type: "node",
      node: n
    }], a = (s) => {
      for (let Q = s.length - 1; Q >= 0; Q--) {
        const u = s[Q];
        u != null && o.push({
          type: "node",
          node: u
        });
      }
    };
    let T = null;
    for (; T = o.pop(); ) {
      if (T.type === "text") {
        i.push(T.text);
        continue;
      }
      const s = T.node;
      if (s.type === "text") {
        i.push(s.value);
        continue;
      }
      if (e_.has(s.type) && o.push({
        type: "text",
        text: `
`
      }), (s.type === "mdxJsxFlowElement" || s.type === "mdxJsxTextElement") && s.name && t.has(s.name)) {
        const Q = (r = t.get(s.name)) == null ? void 0 : r(s);
        if (!Q)
          continue;
        "text" in Q && i.push(Q.text), "children" in Q && a(Q.children);
        continue;
      }
      "children" in s && a(s.children);
    }
    return i.join("").trim();
  } catch (n) {
    return console.error(n), "";
  }
}
function r_({
  children: e,
  disabledComponents: t = YV,
  textToSpeech: r,
  overrides: n,
  className: i
}) {
  const {
    markdownOverrides: o,
    textToSpeechOverrides: a
  } = m3(() => {
    if (!n)
      return {};
    const s = {}, Q = /* @__PURE__ */ new Map();
    return Object.entries(n).forEach(([u, l]) => {
      s[u] = l.markdown, Q.set(u, l.textToSpeech);
    }), {
      markdownOverrides: s,
      textToSpeechOverrides: Q
    };
  }, [n]), T = m3(() => t_(e, a ?? /* @__PURE__ */ new Map()), [e, a]);
  return /* @__PURE__ */ W3.createElement(W3.Fragment, null, /* @__PURE__ */ W3.createElement(c8, { customJSXElements: o ?? void 0, disabledHtmlTags: t, className: i, markdown: e, readOnly: !0, rootClassName: "first:*:mt-0 last:*:mb-0" }), r ? /* @__PURE__ */ W3.createElement(i_, null, /* @__PURE__ */ W3.createElement(r, null, /* @__PURE__ */ W3.createElement(n_, null, T))) : null);
}
const n_ = M1.div`
	display: None;
`, i_ = M1.div`
	silent > * {
		display: none;
	}
	silent > speech-button {
		display: visible;
	}
	margin: ${a1.spacing2};
`, F0 = M1.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-12j39k1-0"
})(["text-align:center;border-radius:", ";font-family:", ";max-height:100%;display:flex;flex-direction:column;h3{margin:0;}"], a1.spacing1, ({
  theme: e
}) => e.fontFamily), o_ = M1.img.withConfig({
  displayName: "styles__ImageStyled",
  componentId: "sc-12j39k1-1"
})(["margin:", " auto;cursor:", ";display:flex;max-width:100%;max-height:500px;height:auto;width:auto;"], a1.spacing2, ({
  $clickable: e
}) => e ? "pointer" : "default"), a_ = M1.img.withConfig({
  displayName: "styles__ImageWithZoom",
  componentId: "sc-12j39k1-2"
})(["width:95%;height:95%;margin:auto;object-fit:contain;"]), Q_ = M1.div.withConfig({
  displayName: "styles__QuestionWrapper",
  componentId: "sc-12j39k1-3"
})(["padding:0px;.subtitle{font-style:normal;font-weight:", ";font-size:", ";line-height:", ";text-align:center;color:", ";margin:", " auto;}"], a1.font_normal, a1.text_base, ({
  theme: e
}) => e.titleFont, ({
  theme: e
}) => e.white, a1.spacing4), h8 = M1.div.withConfig({
  displayName: "styles__LabelInformation",
  componentId: "sc-12j39k1-4"
})(["font-family:", ";font-size:", ";color:", ";background:", ";padding:", ";border-radius:", ";margin:", " 0px;display:flex;justify-content:center;text-align:left;"], ({
  theme: e
}) => e.fontFamily, a1.text_lg, ({
  theme: e
}) => e.white, ({
  theme: e
}) => e.lightPrimaryColor, a1.spacing4, a1.spacing2, a1.spacing2), Ks = M1.div.withConfig({
  displayName: "styles__ChoiceWrapper",
  componentId: "sc-12j39k1-5"
})(["display:grid;grid-template-columns:1fr 1fr;grid-gap:", ";justify-content:center;width:100%;", ""], a1.spacing4, ({
  $withImage: e
}) => e && `
		grid-auto-rows: 1fr;
		margin-top: ${a1.spacing4};
	`), j0 = M1.div.withConfig({
  displayName: "styles__InputGroup",
  componentId: "sc-12j39k1-6"
})(["display:flex;flex-direction:row;&:not(:last-child){margin-bottom:", ";}"], a1.spacing2), rp = M1.div.withConfig({
  displayName: "styles__UploadedImgContainer",
  componentId: "sc-12j39k1-7"
})(["margin:auto ", ";color:", ";display:flex;pointer-events:", ";align-items:center;button{background:transparent;border:none;padding:0;height:18px;width:18px;}img{cursor:pointer;height:18px;width:18px;margin:0;}input[type='file']{position:absolute !important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);}label{height:18px;width:18px;}label.label-focus{outline:rgb(0,95,204) auto 1px;}"], a1.spacing2, ({
  theme: e
}) => e.primary, ({
  $disabled: e
}) => e && "none"), np = ({
  shape: e = "circle",
  checkmark: t
}) => /* @__PURE__ */ y.createElement("div", { className: S3("size-4 bg-neutral-light pointer-events-none flex items-center box-border justify-center mr-3", e === "square" ? "rounded" : "rounded-full") }, t && /* @__PURE__ */ y.createElement(jo, { "aria-label": "Correct answer", className: "w-3/4 text-success" })), ip = M1.li.withConfig({
  displayName: "styles__ReadOnlyFormInput",
  componentId: "sc-12j39k1-8"
})(["display:flex;align-items:center;pointer:cursor;background:", ";.question-choice{font-size:", ";color:", ";}"], ({
  theme: e
}) => e.baseLight, a1.text_sm, ({
  theme: e,
  $correct: t
}) => t ? e.success : e.onBase);
function op({
  selected: e,
  ...t
}) {
  return /* @__PURE__ */ y.createElement("button", { ...t, className: "border border-brand-horizon-blue rounded-lg flex justify-center items-center mr-2 self-center size-6 p-1" }, e && /* @__PURE__ */ y.createElement(jo, { className: "text-success", "aria-label": "Correct Choice" }));
}
function el({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ y.createElement("button", { ...t, className: "text-brand-horizon-blue hover:text-brand-deep-blue active:brightness-75 flex items-center gap-2" }, /* @__PURE__ */ y.createElement($V, null), e);
}
M1.div.withConfig({
  displayName: "styles__StudentAnswer",
  componentId: "sc-12j39k1-9"
})([".answer .icon{display:inline-block;}.student-response{font-style:italic;font-size:", ";}"], a1.text_sm);
const tl = ({
  children: e
}) => /* @__PURE__ */ y.createElement("div", { className: "font-sm flex items-start font-semibold text-start" }, e), Wo = M1.div.attrs({
  className: "font-brand-headline space-y-2"
}).withConfig({
  displayName: "styles__ReadOnly",
  componentId: "sc-12j39k1-10"
})(["font-weight:normal;.invalid-question-cover{background-color:black;position:absolute;top:0;left:0;bottom:0;right:0;text-align:center;opacity:0.7;}.template-wrapper{padding:", ";border:1px solid ", ";}.invalid-question-text{position:absolute;color:white;top:25%;text-align:center;margin:0 ", ";}.student-mark.wrong{color:", ";}.student-mark.right{color:", ";}.question-phrase{font-size:", ";flex:1;padding-left:", ";}"], a1.spacing4, ({
  theme: e
}) => e.boxShadow, a1.spacing4, ({
  theme: e
}) => e.error, ({
  theme: e
}) => e.success, a1.text_base, a1.spacing2), Go = M1.ul.withConfig({
  displayName: "styles__QuestionResponseStyled",
  componentId: "sc-12j39k1-11"
})(["padding:", " 0;ul{margin:0;padding:0;}"], a1.spacing2), zo = M1.li.withConfig({
  displayName: "styles__QuestionOption",
  componentId: "sc-12j39k1-12"
})(["list-style:none;font-family:", ";display:flex;align-items:center;text-align:left;padding:6px 0;color:", ";.square{background:", ";border:2px solid ", ";width:12px;height:12px;border-radius:2px;margin:auto ", " auto 0;}.selected{background:", ";}"], ({
  theme: e
}) => e.fontFamily, ({
  theme: e,
  $chosen: t,
  $correct: r
}) => r ? e.success : t ? e.error : "inherit", ({
  theme: e
}) => e.neutral, ({
  theme: e
}) => e.neutral, a1.spacing2, ({
  theme: e
}) => e.primary);
M1.hr.withConfig({
  displayName: "styles__Divider",
  componentId: "sc-12j39k1-13"
})(["background:", ";color:", ";height:2px;border:none;"], ({
  theme: e
}) => e.neutralVariant, ({
  theme: e
}) => e.neutralVariant);
M1.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-12j39k1-14"
})(["position:absolute;top:-9px;z-index:3;right:-", ";"], a1.spacing1);
const T_ = M1.img.withConfig({
  displayName: "styles__QuestionOptionImage",
  componentId: "sc-12j39k1-15"
})(["margin-left:", ";height:100px;width:auto;"], a1.spacing2), s_ = M1.div.withConfig({
  displayName: "styles__TitleBold",
  componentId: "sc-12j39k1-16"
})(["font-weight:", ";margin:", ";padding-left:", ";"], a1.font_bold, a1.spacing2, a1.spacing2), Uo = M1.div.withConfig({
  displayName: "styles__GeneralScoreTitle",
  componentId: "sc-12j39k1-17"
})(["font-family:", ";font-weight:", ";font-style:normal;font-weight:", ";font-size:", ";line-height:", ";text-align:center;color:", ";position:relative;.question-index{font-family:", ";position:absolute;font-size:", ";line-height:", ";}"], ({
  theme: e
}) => e.fontFamily, a1.font_bold, a1.font_semibold, a1.text_base, a1.text_2xl, ({
  theme: e
}) => e.white, ({
  theme: e
}) => e.fontFamily, a1.text_2xl, a1.text_2xl), l_ = M1.div.withConfig({
  displayName: "styles__ImageWrapper",
  componentId: "sc-12j39k1-18"
})(["max-width:", ";width:", ";"], ({
  $hasText: e,
  $isQuestionSlot: t
}) => e && !t ? "60px" : "100%", ({
  $isClassResponse: e,
  $hasImage: t
}) => e && t ? "100%" : "auto"), u_ = M1.div.withConfig({
  displayName: "styles__OptionContent",
  componentId: "sc-12j39k1-19"
})(["text-align:left;font-size:", ";"], a1.text_lg), rl = M1.img.withConfig({
  displayName: "styles__ImageViewer",
  componentId: "sc-12j39k1-20"
})(["max-width:300px;background:white;padding:", ";border-radius:", ";box-shadow:0px ", " ", " 0px #00000040;"], a1.spacing2, a1.spacing2, a1.spacing1, a1.spacing1), ap = M1.div.withConfig({
  displayName: "styles__UploadImageWrapper",
  componentId: "sc-12j39k1-21"
})(["margin-right:", ";margin-top:0.5em;"], ({
  $isTextInput: e
}) => e && "34px");
var c3 = /* @__PURE__ */ ((e) => (e.DELETE_QUESTION = "DELETE_QUESTION", e.DUPLICATE_QUESTION = "DUPLICATE_QUESTION", e.CHANGE_ANSWER = "CHANGE_ANSWER", e.CHANGE_QUESTION = "CHANGE_QUESTION", e.CHANGE_QUESTION_IMAGE = "CHANGE_QUESTION_IMAGE", e.CHANGE_MEDIA_CHOICE = "CHANGE_MEDIA_CHOICE", e.CHANGE_ANSWER_CHOICE = "CHANGE_ANSWER_CHOICE", e.DELETE_QUESTION_IMAGE = "DELETE_QUESTION_IMAGE", e.DELETE_IMG_CHOICE = "DELETE_IMG_CHOICE", e.CHANGE_CHOICE = "CHANGE_CHOICE", e.ADD_CHOICE = "ADD_CHOICE", e.DELETE_CHOICE = "DELETE_CHOICE", e.ADD_DROPDOWN = "ADD_DROPDOWN", e.DELETE_DROPDOWN = "DELETE_DROPDOWN", e.CHANGE_TEMPLATE = "CHANGE_TEMPLATE", e))(c3 || {});
function $f(e, t) {
  const r = e.findIndex((n) => n.type === "IMAGE");
  return r && r >= 0 ? e[r] = t : e = [...e, t], e;
}
function Qp(e, t) {
  const r = /* @__PURE__ */ new Set();
  e.forEach((s) => {
    s.type === j2.Input && r.add(s.inputId);
  });
  const n = {};
  t.forEach((s) => {
    if (s.type === j2.Input) {
      const Q = s.inputId;
      n[Q] || (n[Q] = 0), n[Q] += 1;
    }
  });
  let i = 0;
  const o = [], a = {}, T = Po(t.map((s) => {
    if (s.type === j2.Input) {
      const Q = s.inputId, u = String(++i);
      return r.has(Q) ? (r.delete(Q), a[Q] = u) : o.push(u), {
        ...s,
        inputId: u
      };
    }
    return s;
  }));
  return {
    insertedIds: o,
    renamedIds: a,
    deletedIds: Array.from(r),
    newTemplate: T
  };
}
function Zf(e, t) {
  if (e.type !== F1.CLOZE_DROPDOWN)
    return !1;
  const {
    deletedIds: r,
    renamedIds: n,
    insertedIds: i,
    newTemplate: o
  } = t, a = {};
  e.dropdowns.forEach(({
    templateResponseKey: s,
    choices: Q
  }) => a[s] = Q), r.forEach((s) => delete a[s]);
  const T = {};
  return Object.keys(n).forEach((s) => {
    const Q = n[s];
    T[Q] = a[s] ?? [];
  }), i.forEach((s) => T[s] = []), e.dropdowns = Object.keys(T).map((s) => ({
    templateResponseKey: s,
    choices: T[s]
  })), e.template = o, !0;
}
function c_(e, t) {
  var r, n;
  switch (t.type) {
    case "CHANGE_ANSWER": {
      const i = t.payload;
      if (e.type === "FREE_RESPONSE")
        return e.answer = i, !0;
      break;
    }
    case "CHANGE_ANSWER_CHOICE": {
      const {
        index: i,
        dropdownIndex: o = -1
      } = t.payload, a = Bn(e, o);
      let T = !1;
      return e.type === F1.MULTIPLE_SELECT ? a[i] && (a[i].answer = !a[i].answer, T = !0) : a[i] && (a.forEach((s, Q) => s.answer = Q === i), T = !0), T;
    }
    case "CHANGE_CHOICE": {
      const {
        index: i,
        value: o,
        dropdownIndex: a = -1
      } = t.payload, s = Bn(e, a)[i];
      return s ? (s.text = o, !0) : !1;
    }
    case "ADD_CHOICE": {
      const {
        choice: i,
        dropdownIndex: o = -1
      } = t.payload, a = Bn(e, o);
      return i.answer = a.length < 1, a.push(i), !0;
    }
    case "DELETE_CHOICE": {
      const {
        index: i,
        dropdownIndex: o = -1
      } = t.payload;
      return Bn(e, o).splice(i, 1), !0;
    }
    case "CHANGE_QUESTION": {
      const i = t.payload;
      return e.type === F1.CLOZE_DROPDOWN ? !1 : (e.phrase = i, !0);
    }
    case "CHANGE_TEMPLATE":
      return Zf(e, t.payload);
    case "CHANGE_QUESTION_IMAGE": {
      const i = t.payload;
      return e.media = (r = e.media) == null ? void 0 : r.filter((o) => o.type !== "IMAGE"), e.type === F1.IMAGE_LABELING && (e.dropdowns = [], e.imageProperties = {
        width: i.width || 0,
        height: i.height || 0
      }), e && i && (e.media = $f(e.media || [], i)), !0;
    }
    case "CHANGE_MEDIA_CHOICE": {
      const i = t.payload;
      if (e.type !== F1.MULTIPLE_CHOICE && e.type !== F1.MULTIPLE_SELECT)
        return !1;
      const {
        index: o,
        media: a
      } = i, T = e.choices[o];
      return T ? (e.choices[o].media = $f(T.media || [], a), !0) : !1;
    }
    case "DELETE_QUESTION_IMAGE":
      return e.media ? (e.media = e.media.filter((i) => i.type !== "IMAGE"), !0) : !1;
    case "DELETE_IMG_CHOICE": {
      if (e.type !== F1.MULTIPLE_CHOICE && e.type !== F1.MULTIPLE_SELECT)
        return !1;
      const {
        index: i
      } = t.payload;
      return e.choices[i].media && (e.choices[i].media = (n = e.choices[i].media) == null ? void 0 : n.filter((o) => o.type !== "IMAGE")), !0;
    }
    case "ADD_DROPDOWN":
      if (e.type === F1.CLOZE_DROPDOWN) {
        const i = e.template, o = typeof t.payload == "number" ? t.payload : 0, a = [];
        let T = 0, s = 0, Q = !1;
        const u = {};
        e.dropdowns.forEach((f) => u[f.templateResponseKey] = f.choices);
        const l = {}, c = (f) => {
          const d = `${++s}`;
          a.push({
            type: j2.Input,
            inputId: d
          }), f == null && (Q = !0, a.push({
            type: j2.Text,
            text: " "
          })), l[d] = f && u[f] ? u[f] : [];
        };
        return w4(i).forEach((f) => {
          if (!Q && T === o && c(), f.type == j2.Input) {
            T += 1, c(f.inputId);
            return;
          }
          if (Q) {
            a.push(f);
            return;
          }
          if (f.type === j2.Text) {
            const d = f.text, m = o - T;
            if (m < d.length - 1) {
              a.push({
                type: j2.Text,
                text: d.substring(0, m)
              }), c(), a.push({
                type: j2.Text,
                text: d.substring(m, d.length)
              });
              return;
            }
            T += d.length, a.push(f);
            return;
          }
          a.push(f);
        }), Q || c(), e.template = Po(a), e.dropdowns = Object.keys(l).map((f) => ({
          templateResponseKey: f,
          choices: l[f]
        })), !0;
      } else if (e.type === F1.IMAGE_LABELING) {
        const i = t.payload;
        return typeof i == "object" && !isNaN(i == null ? void 0 : i.x) && !isNaN(i == null ? void 0 : i.y) && e.dropdowns.push({
          x: i.x,
          y: i.y,
          choices: [{
            text: "",
            answer: !0
          }]
        }), !0;
      } else
        return !1;
    case "DELETE_DROPDOWN": {
      if (e.type === F1.CLOZE_DROPDOWN) {
        const i = t.payload, o = w4(e.template);
        return Zf(e, Qp(o, o.filter((a) => a.type === j2.Input ? a.inputId !== i : !0)));
      } else if (e.type === F1.IMAGE_LABELING) {
        const i = t.payload;
        return e.dropdowns = e.dropdowns.filter((o) => v3(o) !== i), !0;
      }
      return !1;
    }
    default:
      return !1;
  }
  return !1;
}
function Bn(e, t) {
  return e.type === F1.MULTIPLE_SELECT || e.type === F1.MULTIPLE_CHOICE ? e.choices : (e.type === F1.CLOZE_DROPDOWN || e.type === F1.IMAGE_LABELING) && t > -1 ? (
    // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    e.dropdowns[t].choices
  ) : [];
}
function f_(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" } }] })(e);
}
function Xo(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(e);
}
function O2({
  children: e,
  disabledComponents: t,
  textToSpeech: r,
  interpretAsMarkdown: n,
  overrides: i,
  className: o
}) {
  const a = ep(e);
  return n === !0 || a != null && n !== !1 ? /* @__PURE__ */ W3.createElement(r_, { className: o, textToSpeech: r, disabledComponents: t, overrides: i }, a ?? e) : r ? /* @__PURE__ */ W3.createElement(r, null, e) : /* @__PURE__ */ W3.createElement(W3.Fragment, null, e);
}
const qo = ({
  url: e,
  setClose: t,
  isOpen: r,
  minimal: n = !1,
  fullScreen: i = !1,
  text: o,
  infoText: a,
  ...T
}) => {
  const s = /* @__PURE__ */ y.createElement(m_, null, /* @__PURE__ */ y.createElement(v_, { src: e, alt: "preview" }));
  return r ? /* @__PURE__ */ y.createElement(Fo, { isOpen: r, overlayClassName: "z-[1000]", className: i ? "inset-10 bg-transparent border-0 max-w-full" : "absolute top-12 left-2/4 right-auto bottom-auto -translate-x-2/4 block translate-y-0 bg-white h-fit max-h-[80vh] overflow-auto shadow p-0 w-fit outline-none", onClose: t, closeButton: !1, lightTheme: !i, ...T }, i ? /* @__PURE__ */ y.createElement(L_, { onClick: t }, /* @__PURE__ */ y.createElement(a_, { alt: "Image", src: e })) : n ? s : /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(d_, null, /* @__PURE__ */ y.createElement(h_, null, /* @__PURE__ */ y.createElement("p", { className: "title" }, a, " "), /* @__PURE__ */ y.createElement("span", { className: "paragraph" }, o ? /* @__PURE__ */ y.createElement(O2, null, o) : "(No Text)")), /* @__PURE__ */ y.createElement(Xo, { style: {
    cursor: "pointer",
    transform: "scale(1.3)"
  }, onClick: () => t() })), /* @__PURE__ */ y.createElement(p_, null, s))) : /* @__PURE__ */ y.createElement(a2, null);
}, d_ = M1.div.withConfig({
  displayName: "ImageModal__ModalHeader",
  componentId: "sc-1rr65xj-0"
})(["display:flex;justify-content:space-between;align-items:center;text-align:start;", " .title{font-size:10px;margin-bottom:0.5rem;line-height:15px;}.paragraph{font-size:", ";line-height:", ";}"], ({
  theme: e
}) => `
		background-color: ${e.base};
		padding: ${a1.spacing4};
		color: ${e.onBase};
		font-size: ${a1.text_base};
		font-weight: ${a1.font_semibold};
	`, a1.text_base, a1.text_2xl), h_ = M1.div.withConfig({
  displayName: "ImageModal__TextContainer",
  componentId: "sc-1rr65xj-1"
})(["display:flex;flex-direction:column;justify-content:space-between;p{font-size:10px;margin-bottom:0.5rem;}"]), p_ = M1.div.withConfig({
  displayName: "ImageModal__ModalImageContainer",
  componentId: "sc-1rr65xj-2"
})(["position:relative;display:flex;justify-content:center;align-items:center;margin-bottom:", ";img{width:auto;max-width:80%;max-height:100%;object-fit:contain;}"], a1.spacing4);
var m_ = M1("div").withConfig({
  displayName: "ImageModal___StyledDiv",
  componentId: "sc-1rr65xj-3"
})(["width:fit-content;justify-content:center;display:flex;text-align:center;margin:auto;"]), v_ = M1("img").withConfig({
  displayName: "ImageModal___StyledImg",
  componentId: "sc-1rr65xj-4"
})(["max-width:100%;height:auto;"]), L_ = M1("div").withConfig({
  displayName: "ImageModal___StyledDiv2",
  componentId: "sc-1rr65xj-5"
})(["margin:auto;display:flex;height:100%;width:100%;"]);
function y_({
  media: e,
  expandable: t,
  className: r = "",
  parentRef: n
}, i) {
  const [o, a] = W1(!1), T = e && e.length > 0 ? e[0].url : "", s = () => {
    T && a(!0);
  };
  return T ? /* @__PURE__ */ y.createElement(y.Fragment, null, t && o && /* @__PURE__ */ y.createElement(qo, { isOpen: o, setClose: () => a(!1), url: T, parentSelector: n == null ? void 0 : n.current, fullScreen: !0 }), /* @__PURE__ */ y.createElement(o_, { $clickable: t, className: r, alt: "Image", src: T, ref: i, onClick: t ? s : void 0 })) : null;
}
const j4 = y.forwardRef(y_), nl = (e) => e.type === F1.FREE_RESPONSE && !0, kr = (e) => e.type === F1.MULTIPLE_CHOICE && !0, Jo = (e) => e.type === F1.MULTIPLE_SELECT && !0, i6 = (e) => (e.type === F1.IMAGE_LABELING || e.type === F1.CLOZE_DROPDOWN) && !0, il = (e) => e.type === F1.FREE_RESPONSE && !0, I5 = (e) => e.type === F1.MULTIPLE_CHOICE && !0, Ir = (e) => e.type === F1.MULTIPLE_SELECT && !0, P5 = (e) => e.type === F1.CLOZE_DROPDOWN && !0, Y6 = (e) => e.type === F1.IMAGE_LABELING && !0, Wf = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
function ot(e) {
  const t = Wf.length;
  return Wf[e % t];
}
function g_(e, t) {
  var n;
  const r = t == null ? void 0 : t.answer;
  if (!r)
    return "Question - Did not answer";
  if (il(e) && nl(r))
    return `Question - ${!t.score || t.score.score === null ? "Ungraded" : t.score.score >= t.score.perfectScore ? "Correct" : "Incorrect"}`;
  if (I5(e) && kr(r))
    return `Question - ${((n = e.choices.find((o) => String(o._id) === String(r.value))) == null ? void 0 : n.answer) ? "Correct" : "Incorrect"}`;
  if (i6(r)) {
    let i = 0, o = 0;
    return Y6(e) ? (e.dropdowns.forEach((a) => {
      const T = a.choices.find((s) => s.answer);
      return r.value[v3(a)] === String(T == null ? void 0 : T._id) && (i += 1), T;
    }), o = e.dropdowns.length) : P5(e) && (e.dropdowns.forEach((a) => {
      const T = a.choices.find((s) => s.answer);
      return r.value[a.templateResponseKey] === String(T == null ? void 0 : T._id) && (i += 1), T;
    }), o = e.dropdowns.length), `Question - ${i}/${o} Correct`;
  } else
    return Ir(e) && Jo(r) ? `Question - ${e.choices.find((o) => !o.answer && r.value.indexOf(String(o._id)) > -1 || o.answer && r.value.indexOf(String(o._id)) === -1) ? "Incorrect" : "Correct"}` : "Question - Correct";
}
function Tp() {
  return Math.random().toString(8).replace("0.", "");
}
const Yo = (e) => ({
  localUrl: URL.createObjectURL(e)
});
function x_(e) {
  const t = new FileReader(), r = new window.Image(), n = function() {
    const i = r.height, o = r.width;
    return {
      height: i,
      width: o
    };
  };
  return new Promise((i, o) => {
    t.onload = (a) => {
      r.onload = () => i(n()), r.onerror = o, r.src = a.target.result;
    }, t.readAsDataURL(e);
  });
}
function ol(e, t) {
  return {
    handleDeleteChoice: (s, Q) => {
      !t && e && e({
        type: c3.DELETE_CHOICE,
        payload: {
          index: s,
          dropdownIndex: Q
        }
      });
    },
    handleDeleteImageChoice: (s) => {
      !t && e && e({
        type: c3.DELETE_IMG_CHOICE,
        payload: {
          index: s
        }
      });
    },
    handleAnswerChange: (s, Q) => {
      !t && e && e({
        type: c3.CHANGE_ANSWER_CHOICE,
        payload: {
          index: s,
          dropdownIndex: Q
        }
      });
    },
    handleAddChoice: (s) => {
      !t && e && e({
        type: c3.ADD_CHOICE,
        payload: {
          choice: {
            text: "",
            answer: !1,
            // @ts-expect-error  We need a different type for media in Editable Question
            media: []
          },
          dropdownIndex: s
        }
      });
    },
    handleChange: (s, Q, u) => {
      !t && e && e({
        type: c3.CHANGE_CHOICE,
        payload: {
          index: s,
          value: Q,
          dropdownIndex: u
        }
      });
    },
    handleChangeChoiceImage: (s, Q) => {
      if (!t && e && Q > -1) {
        const {
          localUrl: u
        } = Yo(s);
        e({
          type: c3.CHANGE_MEDIA_CHOICE,
          payload: {
            index: Q,
            media: {
              type: "IMAGE",
              file: s,
              localUrl: u
            }
          }
        });
      }
    }
  };
}
function p8({
  correctOption: e,
  studentChoice: t
}) {
  let r = null;
  return e ? r = /* @__PURE__ */ y.createElement(jo, { "aria-label": "Correct Icon" }) : t ? r = /* @__PURE__ */ y.createElement(Yh, { "aria-label": "Incorrect Icon" }) : r = /* @__PURE__ */ y.createElement("div", { className: "mx-2" }), /* @__PURE__ */ y.createElement("div", { className: "mx-2" }, r);
}
function H_(e) {
  const [t, r] = W1(() => e != null && e.current ? {
    height: e.current.offsetHeight,
    width: e.current.offsetWidth
  } : {
    height: 0,
    width: 0
  });
  return G3(() => {
    const n = () => {
      e && e.current && r({
        height: e.current.offsetHeight,
        width: e.current.offsetWidth
      });
    };
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), t;
}
function sp(e, t) {
  var a;
  const [r, n] = W1(null), [i, o] = W1(((a = e == null ? void 0 : e.current) == null ? void 0 : a.complete) && e.current.naturalWidth !== 0);
  return G3(() => {
    if (i)
      return;
    const T = () => {
      o(!0);
    }, s = e == null ? void 0 : e.current;
    if (s)
      return s.addEventListener("load", T), () => s.removeEventListener("load", T);
  }, [e, i]), G3(() => {
    if (!i)
      return;
    const T = () => {
      if (e && e.current && t) {
        const s = e.current;
        n({
          height: s.offsetHeight,
          width: s.offsetWidth,
          src: t
        });
      }
    };
    return T(), window.addEventListener("resize", T), () => {
      window.removeEventListener("resize", T);
    };
  }, [i, t]), r;
}
function lp(e, t, r) {
  const n = e.choices.find((i) => i.answer);
  return String(n == null ? void 0 : n._id) === String(r == null ? void 0 : r.value[t]);
}
function up(e, t) {
  if (e && i6(e)) {
    let r = 0;
    return t.dropdowns.forEach((n, i) => {
      const o = n.choices.find((a) => a.answer);
      (Y6(t) && // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      e.value[v3(t.dropdowns[i])] === String(o == null ? void 0 : o._id) || P5(t) && // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      e.value[t.dropdowns[i].templateResponseKey] === String(o == null ? void 0 : o._id)) && (r += 1);
    }), {
      correct: r,
      total: t.dropdowns.length
    };
  }
}
const Ko = ({
  type: e = "text",
  placeholder: t,
  value: r,
  onChange: n,
  media: i,
  readOnly: o = !1,
  className: a,
  onDeleteImage: T,
  handleAddChoice: s,
  autoFocus: Q = !1
}) => {
  const [u, l] = W1(!1), [c, f] = W1(!1);
  let d;
  return i && i.length > 0 && (d = i[0].hasOwnProperty("localUrl") ? i[0].localUrl : (
    // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    i[0].hasOwnProperty("url") ? i[0].url : void 0
  )), /* @__PURE__ */ y.createElement("div", { className: "flex-1" }, /* @__PURE__ */ y.createElement(fp, { $focused: u, className: a }, c && /* @__PURE__ */ y.createElement(qo, { minimal: !0, isOpen: c, setClose: () => f(!1), url: d }), d && /* @__PURE__ */ y.createElement(cp, { $fixed: e === "textarea" }, /* @__PURE__ */ y.createElement("img", { src: d, alt: "image used to describe an input", onClick: () => {
    d && f(!0);
  } }), /* @__PURE__ */ y.createElement("div", { className: "icon-wrap" }, /* @__PURE__ */ y.createElement(dp, { "aria-label": "Delete icon", role: "button", onClick: T }))), e === "text" ? /* @__PURE__ */ y.createElement("input", { placeholder: t, value: r, type: e, onChange: n, className: `${o || ""}`, onFocus: () => l(!0), onBlur: () => l(!1), onKeyDown: (m) => {
    const {
      keyCode: p
    } = m;
    p === 13 && s && s();
  }, autoFocus: Q }) : /* @__PURE__ */ y.createElement(E_, { placeholder: t, value: r, onChange: n, className: `${o || ""}`, onFocus: () => l(!0), onBlur: () => l(!1), autoFocus: Q })), r && d8(r) ? /* @__PURE__ */ y.createElement(b_, null, /* @__PURE__ */ y.createElement(O2, null, r)) : null);
}, E_ = ({
  placeholder: e,
  value: t,
  onChange: r,
  onBlur: n,
  onFocus: i,
  className: o,
  autoFocus: a = !1
}) => {
  const [Q, u] = W1(2);
  return /* @__PURE__ */ y.createElement("textarea", { role: "input", className: o, rows: Q, value: t, placeholder: e, onChange: (l) => {
    const f = l.target.rows;
    l.target.rows = 2;
    const d = ~~(l.target.scrollHeight / 24);
    d === f && (l.target.rows = d), d >= 10 && (l.target.rows = 10, l.target.scrollTop = l.target.scrollHeight), u(d < 10 ? d : 10), r(l);
  }, onFocus: i, onBlur: n, autoFocus: a });
}, cp = M1.div.withConfig({
  displayName: "TextImageField__ImagePrepend",
  componentId: "sc-1mg824x-0"
})(["display:flex;position:relative;margin:", ";"], ({
  $fixed: e
}) => e ? "4px" : "auto 4px"), b_ = M1.div.withConfig({
  displayName: "TextImageField__MarkdownWrapper",
  componentId: "sc-1mg824x-1"
})(["max-width:100%;overflow-x:scroll;margin-top:", ";padding-bottom:", ";text-align:left;display:flex;justify-content:center;"], a1.spacing4, a1.spacing4), fp = M1.div.withConfig({
  displayName: "TextImageField__TextImageFieldContainer",
  componentId: "sc-1mg824x-2"
})(["display:inline-flex;box-sizing:border-box;align-items:flex-start;width:100%;overflow-x:hidden;color:", ";background-color:", ";background-clip:padding-box;border:1px solid ", ";border-radius:", ";padding:0;outline:0;box-shadow:", ";border-color:", ";div.icon-wrap{width:10px;border-radius:50%;position:absolute;right:-3px;top:-2px;svg{vertical-align:top;}}img{max-width:50px;width:100%;height:fit-content;object-fit:cover;border-radius:2px;cursor:pointer;max-height:", ";}input,textarea{font-size:", ";font-style:normal;font-family:", ";font-weight:normal;line-height:", ";padding:7px 0;border:0;box-sizing:content-box;background:none;margin:0 ", ";-webkit-tap-highlight-color:transparent;display:block;min-width:0;flex:1 1 0;-webkit-animation-name:mui-auto-fill-cancel;animation-name:mui-auto-fill-cancel;-webkit-animation-duration:10ms;animation-duration:10ms;}textarea{max-width:100%;resize:none;overflow:auto;height:auto;}input:focus,textarea:focus{background-color:transparent;outline:0;border:none;box-shadow:none;}"], ({
  theme: e
}) => e.neutralDarker, ({
  theme: e,
  $focused: t
}) => t ? "#fff" : e.neutralLightest, ({
  theme: e
}) => e.neutral, a1.spacing1, ({
  $focused: e
}) => e ? "0 0 0 0.2rem rgb(0 123 255 / 25%)" : "none", ({
  $focused: e
}) => e ? "#80bdff" : "none", a1.spacing6, a1.text_base, ({
  theme: e
}) => e.fontFamily, a1.text_base, a1.spacing2), dp = M1(jV).withConfig({
  displayName: "TextImageField__DeleteIcon",
  componentId: "sc-1mg824x-3"
})(["cursor:pointer;color:white;border-radius:50%;background:", ";padding:2px;height:100%;width:100%;"], ({
  theme: e
}) => e.error);
function I9(e, {
  onSuccess: t,
  onError: r
}) {
  if (!M_(e)) {
    r("Not an image");
    return;
  }
  w_(e) ? C_(e).then((n) => {
    t(n);
  }).catch((n) => {
    console.error(n), r("Failed to compress image");
  }) : t(e);
}
const M_ = (e) => !!e.type.match(/image.*/), w_ = (e) => e.size > S_, S_ = 2 * 1024 * 1024, f0 = 1800;
function C_(e) {
  const t = new FileReader(), r = new Image(), n = document.createElement("canvas"), i = (a) => {
    const T = (
      // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      a.split(",")[0].indexOf("base64") >= 0 ? (
        // @ts-expect-error TS2769 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        atob(a.split(",")[1])
      ) : (
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        unescape(a.split(",")[1])
      )
    ), s = a.split(",")[0].split(":")[1].split(";")[0], Q = T.length, u = new Uint8Array(Q);
    for (let l = 0; l < Q; l++)
      u[l] = T.charCodeAt(l);
    return new Blob([u], {
      type: s
    });
  }, o = () => {
    var Q;
    let a = r.width, T = r.height;
    a > T ? a > f0 && (T *= f0 / a, a = f0) : T > f0 && (a *= f0 / T, T = f0), n.width = a, n.height = T, (Q = n == null ? void 0 : n.getContext("2d")) == null || Q.drawImage(r, 0, 0, a, T);
    const s = n.toDataURL(e.type);
    return i(s);
  };
  return new Promise((a) => {
    t.onload = (T) => {
      r.onload = () => a(o()), r.src = T.target.result;
    }, t.readAsDataURL(e);
  });
}
const V_ = "https://resources-cdn.mission.io/public/question-library/free-response.png", __ = "https://resources-cdn.mission.io/public/question-library/multiple-choice.png", O_ = "https://resources-cdn.mission.io/public/question-library/cloze-dropdown.png", A_ = "https://resources-cdn.mission.io/public/question-library/multi-select.png", D_ = "https://resources-cdn.mission.io/public/question-library/image-labeling.png", al = "https://resources-cdn.mission.io/public/question-library/thumbnail-icon.png", WT = "https://resources-cdn.mission.io/public/question-library/thumbnail-icon--success.png", k_ = "https://resources-cdn.mission.io/public/question-library/thumbnail-icon--disabled.png";
function Ql(e) {
  const {
    disabled: t,
    onChange: r,
    index: n,
    readOnly: i
  } = e, [o, a] = W1(!1), T = Tp(), s = (Q) => {
    const u = Q.target.files;
    u.length > 0 && r && I9(u[0], {
      onSuccess: (l) => r(l, n),
      onError: alert
    });
  };
  return /* @__PURE__ */ y.createElement(rp, { $disabled: t }, /* @__PURE__ */ y.createElement("label", { htmlFor: T, className: o && !t ? "label-focus" : "" }, /* @__PURE__ */ y.createElement("img", { src: `${t ? k_ : WT}` })), !i && /* @__PURE__ */ y.createElement("input", { onFocus: () => a(!0), onBlur: () => a(!1), "aria-label": "Image Uploader", id: T, type: "file", disabled: t, onChange: (Q) => {
    a(!1), s(Q);
  }, accept: ".jpg,.png,.jpeg" }));
}
function I_(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none" }, child: [{ tag: "path", attr: { d: "M16.3394 9.32245C16.7434 8.94589 16.7657 8.31312 16.3891 7.90911C16.0126 7.50509 15.3798 7.48283 14.9758 7.85938L12.0497 10.5866L9.32245 7.66048C8.94589 7.25647 8.31312 7.23421 7.90911 7.61076C7.50509 7.98731 7.48283 8.62008 7.85938 9.0241L10.5866 11.9502L7.66048 14.6775C7.25647 15.054 7.23421 15.6868 7.61076 16.0908C7.98731 16.4948 8.62008 16.5171 9.0241 16.1405L11.9502 13.4133L14.6775 16.3394C15.054 16.7434 15.6868 16.7657 16.0908 16.3891C16.4948 16.0126 16.5171 15.3798 16.1405 14.9758L13.4133 12.0497L16.3394 9.32245Z", fill: "currentColor" } }, { tag: "path", attr: { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z", fill: "currentColor" } }] })(e);
}
function R9({
  darkMode: e = !1,
  readOnly: t,
  label: r = "Question",
  inputType: n = "text",
  question: i,
  questionIndex: o = 0,
  onChange: a,
  isValid: T,
  studentResponse: s,
  autoFocus: Q = !1
}) {
  var c, f, d;
  const l = !!((c = i.media) == null ? void 0 : c.find((m) => m.type === "IMAGE"));
  return t ? /* @__PURE__ */ y.createElement(a2, null, !T && /* @__PURE__ */ y.createElement(a2, null, /* @__PURE__ */ y.createElement("div", { className: "invalid-question-cover" }), /* @__PURE__ */ y.createElement("p", { className: "invalid-question-text" }, "This question is in an invalid format and is not available for use.", " ", i.default && "It will not be included in your mission. ", "Thank you for your patience while we fix this issue!")), /* @__PURE__ */ y.createElement(tl, null, /* @__PURE__ */ y.createElement("span", null, s ? s.answer.value && s.score && ((f = s.score) == null ? void 0 : f.score) === ((d = s.score) == null ? void 0 : d.perfectScore) ? /* @__PURE__ */ y.createElement(BV, { className: "student-mark right" }) : /* @__PURE__ */ y.createElement(I_, { className: "student-mark wrong" }) : /* @__PURE__ */ y.createElement("strong", null, `Q${o + 1}.`, "  ")), /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(O2, { className: e ? "prose-invert" : "" }, P5(i) ? i.template : i.phrase)))) : /* @__PURE__ */ y.createElement("div", { className: "bg-brand-cloud-blue text-brand-space-blue rounded-t-lg p-4" }, /* @__PURE__ */ y.createElement("div", { className: "font-semibold mb-4 text-start" }, r), /* @__PURE__ */ y.createElement(j0, null, /* @__PURE__ */ y.createElement(Tl, null, /* @__PURE__ */ y.createElement("span", null, `Q${o + 1}`)), /* @__PURE__ */ y.createElement(Ko, { className: S3("rounded-tl-none", n === "text" && "rounded-bl-none"), type: n, placeholder: "Type Question...", value: P5(i) ? i.template : i.phrase, onChange: (m) => a && a({
    type: c3.CHANGE_QUESTION,
    payload: m.target.value
  }), media: i.media, onDeleteImage: () => {
    !t && a && a({
      type: c3.DELETE_QUESTION_IMAGE
    });
  }, autoFocus: Q }), /* @__PURE__ */ y.createElement(ap, { $isTextInput: n === "text" }, /* @__PURE__ */ y.createElement(Ql, { disabled: l, onChange: (m) => {
    if (!t && a) {
      const {
        localUrl: p
      } = Yo(m);
      a({
        type: c3.CHANGE_QUESTION_IMAGE,
        payload: {
          type: "IMAGE",
          file: m,
          localUrl: p
        }
      });
    }
  }, readOnly: t }))));
}
const R_ = M1(Xo).withConfig({
  displayName: "TeacherHeader__CloseIcon",
  componentId: "sc-hq5oai-0"
})(["cursor:pointer;position:absolute;top:", ";right:", ";transform:scale(1.3);background:#e7eaf7;border-radius:50%;color:", ";padding:2px;"], a1.spacing4, a1.spacing4, ({
  theme: e
}) => e.primary), Tl = M1.div.withConfig({
  displayName: "TeacherHeader__QuestionLabel",
  componentId: "sc-hq5oai-1"
})(["background-color:", ";border-radius:", " 0 0 ", ";text-align:center;display:flex;align-items:center;justify-content:center;padding:0 ", ";max-height:36px;span{font-size:", ";line-height:19px;text-align:center;color:white;width:", ";}"], ({
  theme: e
}) => e.primary, a1.spacing1, a1.spacing1, a1.spacing2, a1.text_base, a1.spacing6);
var Oe = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gf;
function N_() {
  if (Gf)
    return Oe;
  Gf = 1;
  var e = y;
  function t(V) {
    for (var R = "https://reactjs.org/docs/error-decoder.html?invariant=" + V, W = 1; W < arguments.length; W++)
      R += "&args[]=" + encodeURIComponent(arguments[W]);
    return "Minified React error #" + V + "; visit " + R + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = Object.prototype.hasOwnProperty, n = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, i = {}, o = {};
  function a(V) {
    return r.call(o, V) ? !0 : r.call(i, V) ? !1 : n.test(V) ? o[V] = !0 : (i[V] = !0, !1);
  }
  function T(V, R, W, Y, h1, c1, y1) {
    this.acceptsBooleans = R === 2 || R === 3 || R === 4, this.attributeName = Y, this.attributeNamespace = h1, this.mustUseProperty = W, this.propertyName = V, this.type = R, this.sanitizeURL = c1, this.removeEmptyString = y1;
  }
  var s = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(V) {
    s[V] = new T(V, 0, !1, V, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(V) {
    var R = V[0];
    s[R] = new T(R, 1, !1, V[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(V) {
    s[V] = new T(V, 2, !1, V.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(V) {
    s[V] = new T(V, 2, !1, V, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(V) {
    s[V] = new T(V, 3, !1, V.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(V) {
    s[V] = new T(V, 3, !0, V, null, !1, !1);
  }), ["capture", "download"].forEach(function(V) {
    s[V] = new T(V, 4, !1, V, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(V) {
    s[V] = new T(V, 6, !1, V, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(V) {
    s[V] = new T(V, 5, !1, V.toLowerCase(), null, !1, !1);
  });
  var Q = /[\-:]([a-z])/g;
  function u(V) {
    return V[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(V) {
    var R = V.replace(
      Q,
      u
    );
    s[R] = new T(R, 1, !1, V, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(V) {
    var R = V.replace(Q, u);
    s[R] = new T(R, 1, !1, V, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(V) {
    var R = V.replace(Q, u);
    s[R] = new T(R, 1, !1, V, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(V) {
    s[V] = new T(V, 1, !1, V.toLowerCase(), null, !1, !1);
  }), s.xlinkHref = new T("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(V) {
    s[V] = new T(V, 1, !1, V.toLowerCase(), null, !0, !0);
  });
  var l = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, c = ["Webkit", "ms", "Moz", "O"];
  Object.keys(l).forEach(function(V) {
    c.forEach(function(R) {
      R = R + V.charAt(0).toUpperCase() + V.substring(1), l[R] = l[V];
    });
  });
  var f = /["'&<>]/;
  function d(V) {
    if (typeof V == "boolean" || typeof V == "number")
      return "" + V;
    V = "" + V;
    var R = f.exec(V);
    if (R) {
      var W = "", Y, h1 = 0;
      for (Y = R.index; Y < V.length; Y++) {
        switch (V.charCodeAt(Y)) {
          case 34:
            R = "&quot;";
            break;
          case 38:
            R = "&amp;";
            break;
          case 39:
            R = "&#x27;";
            break;
          case 60:
            R = "&lt;";
            break;
          case 62:
            R = "&gt;";
            break;
          default:
            continue;
        }
        h1 !== Y && (W += V.substring(h1, Y)), h1 = Y + 1, W += R;
      }
      V = h1 !== Y ? W + V.substring(h1, Y) : W;
    }
    return V;
  }
  var m = /([A-Z])/g, p = /^ms-/, v = Array.isArray;
  function H(V, R) {
    return { insertionMode: V, selectedValue: R };
  }
  function E(V, R, W) {
    switch (R) {
      case "select":
        return H(1, W.value != null ? W.value : W.defaultValue);
      case "svg":
        return H(2, null);
      case "math":
        return H(3, null);
      case "foreignObject":
        return H(1, null);
      case "table":
        return H(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return H(5, null);
      case "colgroup":
        return H(7, null);
      case "tr":
        return H(6, null);
    }
    return 4 <= V.insertionMode || V.insertionMode === 0 ? H(1, null) : V;
  }
  var M = /* @__PURE__ */ new Map();
  function C(V, R, W) {
    if (typeof W != "object")
      throw Error(t(62));
    R = !0;
    for (var Y in W)
      if (r.call(W, Y)) {
        var h1 = W[Y];
        if (h1 != null && typeof h1 != "boolean" && h1 !== "") {
          if (Y.indexOf("--") === 0) {
            var c1 = d(Y);
            h1 = d(("" + h1).trim());
          } else {
            c1 = Y;
            var y1 = M.get(c1);
            y1 !== void 0 || (y1 = d(c1.replace(m, "-$1").toLowerCase().replace(p, "-ms-")), M.set(c1, y1)), c1 = y1, h1 = typeof h1 == "number" ? h1 === 0 || r.call(l, Y) ? "" + h1 : h1 + "px" : d(("" + h1).trim());
          }
          R ? (R = !1, V.push(' style="', c1, ":", h1)) : V.push(";", c1, ":", h1);
        }
      }
    R || V.push('"');
  }
  function w(V, R, W, Y) {
    switch (W) {
      case "style":
        C(V, R, Y);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < W.length) || W[0] !== "o" && W[0] !== "O" || W[1] !== "n" && W[1] !== "N") {
      if (R = s.hasOwnProperty(W) ? s[W] : null, R !== null) {
        switch (typeof Y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!R.acceptsBooleans)
              return;
        }
        switch (W = R.attributeName, R.type) {
          case 3:
            Y && V.push(" ", W, '=""');
            break;
          case 4:
            Y === !0 ? V.push(" ", W, '=""') : Y !== !1 && V.push(" ", W, '="', d(Y), '"');
            break;
          case 5:
            isNaN(Y) || V.push(" ", W, '="', d(Y), '"');
            break;
          case 6:
            !isNaN(Y) && 1 <= Y && V.push(" ", W, '="', d(Y), '"');
            break;
          default:
            R.sanitizeURL && (Y = "" + Y), V.push(" ", W, '="', d(Y), '"');
        }
      } else if (a(W)) {
        switch (typeof Y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (R = W.toLowerCase().slice(0, 5), R !== "data-" && R !== "aria-")
              return;
        }
        V.push(" ", W, '="', d(Y), '"');
      }
    }
  }
  function S(V, R, W) {
    if (R != null) {
      if (W != null)
        throw Error(t(60));
      if (typeof R != "object" || !("__html" in R))
        throw Error(t(61));
      R = R.__html, R != null && V.push("" + R);
    }
  }
  function D(V) {
    var R = "";
    return e.Children.forEach(V, function(W) {
      W != null && (R += W);
    }), R;
  }
  function k(V, R, W, Y) {
    V.push(j(W));
    var h1 = W = null, c1;
    for (c1 in R)
      if (r.call(R, c1)) {
        var y1 = R[c1];
        if (y1 != null)
          switch (c1) {
            case "children":
              W = y1;
              break;
            case "dangerouslySetInnerHTML":
              h1 = y1;
              break;
            default:
              w(V, Y, c1, y1);
          }
      }
    return V.push(">"), S(V, h1, W), typeof W == "string" ? (V.push(d(W)), null) : W;
  }
  var $ = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, z = /* @__PURE__ */ new Map();
  function j(V) {
    var R = z.get(V);
    if (R === void 0) {
      if (!$.test(V))
        throw Error(t(65, V));
      R = "<" + V, z.set(V, R);
    }
    return R;
  }
  function J(V, R, W, Y, h1) {
    switch (R) {
      case "select":
        V.push(j("select"));
        var c1 = null, y1 = null;
        for (q1 in W)
          if (r.call(W, q1)) {
            var k1 = W[q1];
            if (k1 != null)
              switch (q1) {
                case "children":
                  c1 = k1;
                  break;
                case "dangerouslySetInnerHTML":
                  y1 = k1;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  w(V, Y, q1, k1);
              }
          }
        return V.push(">"), S(V, y1, c1), c1;
      case "option":
        y1 = h1.selectedValue, V.push(j("option"));
        var z1 = k1 = null, K1 = null, q1 = null;
        for (c1 in W)
          if (r.call(W, c1)) {
            var E2 = W[c1];
            if (E2 != null)
              switch (c1) {
                case "children":
                  k1 = E2;
                  break;
                case "selected":
                  K1 = E2;
                  break;
                case "dangerouslySetInnerHTML":
                  q1 = E2;
                  break;
                case "value":
                  z1 = E2;
                default:
                  w(V, Y, c1, E2);
              }
          }
        if (y1 != null)
          if (W = z1 !== null ? "" + z1 : D(k1), v(y1)) {
            for (Y = 0; Y < y1.length; Y++)
              if ("" + y1[Y] === W) {
                V.push(' selected=""');
                break;
              }
          } else
            "" + y1 === W && V.push(' selected=""');
        else
          K1 && V.push(' selected=""');
        return V.push(">"), S(V, q1, k1), k1;
      case "textarea":
        V.push(j("textarea")), q1 = y1 = c1 = null;
        for (k1 in W)
          if (r.call(W, k1) && (z1 = W[k1], z1 != null))
            switch (k1) {
              case "children":
                q1 = z1;
                break;
              case "value":
                c1 = z1;
                break;
              case "defaultValue":
                y1 = z1;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(91));
              default:
                w(
                  V,
                  Y,
                  k1,
                  z1
                );
            }
        if (c1 === null && y1 !== null && (c1 = y1), V.push(">"), q1 != null) {
          if (c1 != null)
            throw Error(t(92));
          if (v(q1) && 1 < q1.length)
            throw Error(t(93));
          c1 = "" + q1;
        }
        return typeof c1 == "string" && c1[0] === `
` && V.push(`
`), c1 !== null && V.push(d("" + c1)), null;
      case "input":
        V.push(j("input")), z1 = q1 = k1 = c1 = null;
        for (y1 in W)
          if (r.call(W, y1) && (K1 = W[y1], K1 != null))
            switch (y1) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, "input"));
              case "defaultChecked":
                z1 = K1;
                break;
              case "defaultValue":
                k1 = K1;
                break;
              case "checked":
                q1 = K1;
                break;
              case "value":
                c1 = K1;
                break;
              default:
                w(V, Y, y1, K1);
            }
        return q1 !== null ? w(V, Y, "checked", q1) : z1 !== null && w(V, Y, "checked", z1), c1 !== null ? w(V, Y, "value", c1) : k1 !== null && w(V, Y, "value", k1), V.push("/>"), null;
      case "menuitem":
        V.push(j("menuitem"));
        for (var R3 in W)
          if (r.call(W, R3) && (c1 = W[R3], c1 != null))
            switch (R3) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(400));
              default:
                w(V, Y, R3, c1);
            }
        return V.push(">"), null;
      case "title":
        V.push(j("title")), c1 = null;
        for (E2 in W)
          if (r.call(W, E2) && (y1 = W[E2], y1 != null))
            switch (E2) {
              case "children":
                c1 = y1;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(434));
              default:
                w(V, Y, E2, y1);
            }
        return V.push(">"), c1;
      case "listing":
      case "pre":
        V.push(j(R)), y1 = c1 = null;
        for (z1 in W)
          if (r.call(W, z1) && (k1 = W[z1], k1 != null))
            switch (z1) {
              case "children":
                c1 = k1;
                break;
              case "dangerouslySetInnerHTML":
                y1 = k1;
                break;
              default:
                w(V, Y, z1, k1);
            }
        if (V.push(">"), y1 != null) {
          if (c1 != null)
            throw Error(t(60));
          if (typeof y1 != "object" || !("__html" in y1))
            throw Error(t(61));
          W = y1.__html, W != null && (typeof W == "string" && 0 < W.length && W[0] === `
` ? V.push(`
`, W) : V.push("" + W));
        }
        return typeof c1 == "string" && c1[0] === `
` && V.push(`
`), c1;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        V.push(j(R));
        for (var H3 in W)
          if (r.call(W, H3) && (c1 = W[H3], c1 != null))
            switch (H3) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, R));
              default:
                w(V, Y, H3, c1);
            }
        return V.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return k(
          V,
          W,
          R,
          Y
        );
      case "html":
        return h1.insertionMode === 0 && V.push("<!DOCTYPE html>"), k(V, W, R, Y);
      default:
        if (R.indexOf("-") === -1 && typeof W.is != "string")
          return k(V, W, R, Y);
        V.push(j(R)), y1 = c1 = null;
        for (K1 in W)
          if (r.call(W, K1) && (k1 = W[K1], k1 != null))
            switch (K1) {
              case "children":
                c1 = k1;
                break;
              case "dangerouslySetInnerHTML":
                y1 = k1;
                break;
              case "style":
                C(V, Y, k1);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                a(K1) && typeof k1 != "function" && typeof k1 != "symbol" && V.push(" ", K1, '="', d(k1), '"');
            }
        return V.push(">"), S(V, y1, c1), c1;
    }
  }
  function i1(V, R, W) {
    if (V.push('<!--$?--><template id="'), W === null)
      throw Error(t(395));
    return V.push(W), V.push('"></template>');
  }
  function t1(V, R, W, Y) {
    switch (W.insertionMode) {
      case 0:
      case 1:
        return V.push('<div hidden id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      case 2:
        return V.push('<svg aria-hidden="true" style="display:none" id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      case 3:
        return V.push('<math aria-hidden="true" style="display:none" id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      case 4:
        return V.push('<table hidden id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      case 5:
        return V.push('<table hidden><tbody id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      case 6:
        return V.push('<table hidden><tr id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      case 7:
        return V.push('<table hidden><colgroup id="'), V.push(R.segmentPrefix), R = Y.toString(16), V.push(R), V.push('">');
      default:
        throw Error(t(397));
    }
  }
  function T1(V, R) {
    switch (R.insertionMode) {
      case 0:
      case 1:
        return V.push("</div>");
      case 2:
        return V.push("</svg>");
      case 3:
        return V.push("</math>");
      case 4:
        return V.push("</table>");
      case 5:
        return V.push("</tbody></table>");
      case 6:
        return V.push("</tr></table>");
      case 7:
        return V.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var X = /[<\u2028\u2029]/g;
  function f1(V) {
    return JSON.stringify(V).replace(X, function(R) {
      switch (R) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function s1(V, R) {
    return R = R === void 0 ? "" : R, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: R + "P:", segmentPrefix: R + "S:", boundaryPrefix: R + "B:", idPrefix: R, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: V };
  }
  function Z(V, R, W, Y) {
    return W.generateStaticMarkup ? (V.push(d(R)), !1) : (R === "" ? V = Y : (Y && V.push("<!-- -->"), V.push(d(R)), V = !0), V);
  }
  var L1 = Object.assign, C1 = Symbol.for("react.element"), q = Symbol.for("react.portal"), N1 = Symbol.for("react.fragment"), O1 = Symbol.for("react.strict_mode"), x1 = Symbol.for("react.profiler"), l1 = Symbol.for("react.provider"), u1 = Symbol.for("react.context"), H1 = Symbol.for("react.forward_ref"), D1 = Symbol.for("react.suspense"), w1 = Symbol.for("react.suspense_list"), E1 = Symbol.for("react.memo"), A1 = Symbol.for("react.lazy"), R1 = Symbol.for("react.scope"), Z1 = Symbol.for("react.debug_trace_mode"), r2 = Symbol.for("react.legacy_hidden"), I2 = Symbol.for("react.default_value"), X1 = Symbol.iterator;
  function x2(V) {
    if (V == null)
      return null;
    if (typeof V == "function")
      return V.displayName || V.name || null;
    if (typeof V == "string")
      return V;
    switch (V) {
      case N1:
        return "Fragment";
      case q:
        return "Portal";
      case x1:
        return "Profiler";
      case O1:
        return "StrictMode";
      case D1:
        return "Suspense";
      case w1:
        return "SuspenseList";
    }
    if (typeof V == "object")
      switch (V.$$typeof) {
        case u1:
          return (V.displayName || "Context") + ".Consumer";
        case l1:
          return (V._context.displayName || "Context") + ".Provider";
        case H1:
          var R = V.render;
          return V = V.displayName, V || (V = R.displayName || R.name || "", V = V !== "" ? "ForwardRef(" + V + ")" : "ForwardRef"), V;
        case E1:
          return R = V.displayName || null, R !== null ? R : x2(V.type) || "Memo";
        case A1:
          R = V._payload, V = V._init;
          try {
            return x2(V(R));
          } catch {
          }
      }
    return null;
  }
  var R2 = {};
  function f3(V, R) {
    if (V = V.contextTypes, !V)
      return R2;
    var W = {}, Y;
    for (Y in V)
      W[Y] = R[Y];
    return W;
  }
  var q2 = null;
  function V2(V, R) {
    if (V !== R) {
      V.context._currentValue2 = V.parentValue, V = V.parent;
      var W = R.parent;
      if (V === null) {
        if (W !== null)
          throw Error(t(401));
      } else {
        if (W === null)
          throw Error(t(401));
        V2(V, W);
      }
      R.context._currentValue2 = R.value;
    }
  }
  function n2(V) {
    V.context._currentValue2 = V.parentValue, V = V.parent, V !== null && n2(V);
  }
  function A3(V) {
    var R = V.parent;
    R !== null && A3(R), V.context._currentValue2 = V.value;
  }
  function g1(V, R) {
    if (V.context._currentValue2 = V.parentValue, V = V.parent, V === null)
      throw Error(t(402));
    V.depth === R.depth ? V2(V, R) : g1(V, R);
  }
  function S1(V, R) {
    var W = R.parent;
    if (W === null)
      throw Error(t(402));
    V.depth === W.depth ? V2(V, W) : S1(V, W), R.context._currentValue2 = R.value;
  }
  function G(V) {
    var R = q2;
    R !== V && (R === null ? A3(V) : V === null ? n2(R) : R.depth === V.depth ? V2(R, V) : R.depth > V.depth ? g1(R, V) : S1(R, V), q2 = V);
  }
  var u2 = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(V, R) {
    V = V._reactInternals, V.queue !== null && V.queue.push(R);
  }, enqueueReplaceState: function(V, R) {
    V = V._reactInternals, V.replace = !0, V.queue = [R];
  }, enqueueForceUpdate: function() {
  } };
  function L2(V, R, W, Y) {
    var h1 = V.state !== void 0 ? V.state : null;
    V.updater = u2, V.props = W, V.state = h1;
    var c1 = { queue: [], replace: !1 };
    V._reactInternals = c1;
    var y1 = R.contextType;
    if (V.context = typeof y1 == "object" && y1 !== null ? y1._currentValue2 : Y, y1 = R.getDerivedStateFromProps, typeof y1 == "function" && (y1 = y1(W, h1), h1 = y1 == null ? h1 : L1({}, h1, y1), V.state = h1), typeof R.getDerivedStateFromProps != "function" && typeof V.getSnapshotBeforeUpdate != "function" && (typeof V.UNSAFE_componentWillMount == "function" || typeof V.componentWillMount == "function"))
      if (R = V.state, typeof V.componentWillMount == "function" && V.componentWillMount(), typeof V.UNSAFE_componentWillMount == "function" && V.UNSAFE_componentWillMount(), R !== V.state && u2.enqueueReplaceState(V, V.state, null), c1.queue !== null && 0 < c1.queue.length)
        if (R = c1.queue, y1 = c1.replace, c1.queue = null, c1.replace = !1, y1 && R.length === 1)
          V.state = R[0];
        else {
          for (c1 = y1 ? R[0] : V.state, h1 = !0, y1 = y1 ? 1 : 0; y1 < R.length; y1++) {
            var k1 = R[y1];
            k1 = typeof k1 == "function" ? k1.call(V, c1, W, Y) : k1, k1 != null && (h1 ? (h1 = !1, c1 = L1({}, c1, k1)) : L1(c1, k1));
          }
          V.state = c1;
        }
      else
        c1.queue = null;
  }
  var J2 = { id: 1, overflow: "" };
  function C3(V, R, W) {
    var Y = V.id;
    V = V.overflow;
    var h1 = 32 - l3(Y) - 1;
    Y &= ~(1 << h1), W += 1;
    var c1 = 32 - l3(R) + h1;
    if (30 < c1) {
      var y1 = h1 - h1 % 5;
      return c1 = (Y & (1 << y1) - 1).toString(32), Y >>= y1, h1 -= y1, { id: 1 << 32 - l3(R) + h1 | W << h1 | Y, overflow: c1 + V };
    }
    return { id: 1 << c1 | W << h1 | Y, overflow: V };
  }
  var l3 = Math.clz32 ? Math.clz32 : $2, z3 = Math.log, D3 = Math.LN2;
  function $2(V) {
    return V >>>= 0, V === 0 ? 32 : 31 - (z3(V) / D3 | 0) | 0;
  }
  function V3(V, R) {
    return V === R && (V !== 0 || 1 / V === 1 / R) || V !== V && R !== R;
  }
  var y3 = typeof Object.is == "function" ? Object.is : V3, u3 = null, k3 = null, x3 = null, H2 = null, j3 = !1, v4 = !1, L4 = 0, I3 = null, S4 = 0;
  function $3() {
    if (u3 === null)
      throw Error(t(321));
    return u3;
  }
  function Z2() {
    if (0 < S4)
      throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function $4() {
    return H2 === null ? x3 === null ? (j3 = !1, x3 = H2 = Z2()) : (j3 = !0, H2 = x3) : H2.next === null ? (j3 = !1, H2 = H2.next = Z2()) : (j3 = !0, H2 = H2.next), H2;
  }
  function Z4() {
    k3 = u3 = null, v4 = !1, x3 = null, S4 = 0, H2 = I3 = null;
  }
  function W4(V, R) {
    return typeof R == "function" ? R(V) : R;
  }
  function Y2(V, R, W) {
    if (u3 = $3(), H2 = $4(), j3) {
      var Y = H2.queue;
      if (R = Y.dispatch, I3 !== null && (W = I3.get(Y), W !== void 0)) {
        I3.delete(Y), Y = H2.memoizedState;
        do
          Y = V(Y, W.action), W = W.next;
        while (W !== null);
        return H2.memoizedState = Y, [Y, R];
      }
      return [H2.memoizedState, R];
    }
    return V = V === W4 ? typeof R == "function" ? R() : R : W !== void 0 ? W(R) : R, H2.memoizedState = V, V = H2.queue = { last: null, dispatch: null }, V = V.dispatch = M6.bind(null, u3, V), [H2.memoizedState, V];
  }
  function G4(V, R) {
    if (u3 = $3(), H2 = $4(), R = R === void 0 ? null : R, H2 !== null) {
      var W = H2.memoizedState;
      if (W !== null && R !== null) {
        var Y = W[1];
        e:
          if (Y === null)
            Y = !1;
          else {
            for (var h1 = 0; h1 < Y.length && h1 < R.length; h1++)
              if (!y3(R[h1], Y[h1])) {
                Y = !1;
                break e;
              }
            Y = !0;
          }
        if (Y)
          return W[0];
      }
    }
    return V = V(), H2.memoizedState = [V, R], V;
  }
  function M6(V, R, W) {
    if (25 <= S4)
      throw Error(t(301));
    if (V === u3)
      if (v4 = !0, V = { action: W, next: null }, I3 === null && (I3 = /* @__PURE__ */ new Map()), W = I3.get(R), W === void 0)
        I3.set(R, V);
      else {
        for (R = W; R.next !== null; )
          R = R.next;
        R.next = V;
      }
  }
  function w6() {
    throw Error(t(394));
  }
  function n1() {
  }
  var _1 = { readContext: function(V) {
    return V._currentValue2;
  }, useContext: function(V) {
    return $3(), V._currentValue2;
  }, useMemo: G4, useReducer: Y2, useRef: function(V) {
    u3 = $3(), H2 = $4();
    var R = H2.memoizedState;
    return R === null ? (V = { current: V }, H2.memoizedState = V) : R;
  }, useState: function(V) {
    return Y2(W4, V);
  }, useInsertionEffect: n1, useLayoutEffect: function() {
  }, useCallback: function(V, R) {
    return G4(function() {
      return V;
    }, R);
  }, useImperativeHandle: n1, useEffect: n1, useDebugValue: n1, useDeferredValue: function(V) {
    return $3(), V;
  }, useTransition: function() {
    return $3(), [
      !1,
      w6
    ];
  }, useId: function() {
    var V = k3.treeContext, R = V.overflow;
    V = V.id, V = (V & ~(1 << 32 - l3(V) - 1)).toString(32) + R;
    var W = P1;
    if (W === null)
      throw Error(t(404));
    return R = L4++, V = ":" + W.idPrefix + "R" + V, 0 < R && (V += "H" + R.toString(32)), V + ":";
  }, useMutableSource: function(V, R) {
    return $3(), R(V._source);
  }, useSyncExternalStore: function(V, R, W) {
    if (W === void 0)
      throw Error(t(407));
    return W();
  } }, P1 = null, J1 = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function h2(V) {
    return console.error(V), null;
  }
  function v2() {
  }
  function m2(V, R, W, Y, h1, c1, y1, k1, z1) {
    var K1 = [], q1 = /* @__PURE__ */ new Set();
    return R = { destination: null, responseState: R, progressiveChunkSize: Y === void 0 ? 12800 : Y, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: q1, pingedTasks: K1, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: h1 === void 0 ? h2 : h1, onAllReady: c1 === void 0 ? v2 : c1, onShellReady: y1 === void 0 ? v2 : y1, onShellError: k1 === void 0 ? v2 : k1, onFatalError: z1 === void 0 ? v2 : z1 }, W = K2(R, 0, null, W, !1, !1), W.parentFlushed = !0, V = s2(R, V, null, W, q1, R2, null, J2), K1.push(V), R;
  }
  function s2(V, R, W, Y, h1, c1, y1, k1) {
    V.allPendingTasks++, W === null ? V.pendingRootTasks++ : W.pendingTasks++;
    var z1 = { node: R, ping: function() {
      var K1 = V.pingedTasks;
      K1.push(z1), K1.length === 1 && O3(V);
    }, blockedBoundary: W, blockedSegment: Y, abortSet: h1, legacyContext: c1, context: y1, treeContext: k1 };
    return h1.add(z1), z1;
  }
  function K2(V, R, W, Y, h1, c1) {
    return { status: 0, id: -1, index: R, parentFlushed: !1, chunks: [], children: [], formatContext: Y, boundary: W, lastPushedText: h1, textEmbedded: c1 };
  }
  function w2(V, R) {
    if (V = V.onError(R), V != null && typeof V != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof V + '" instead');
    return V;
  }
  function S2(V, R) {
    var W = V.onShellError;
    W(R), W = V.onFatalError, W(R), V.destination !== null ? (V.status = 2, V.destination.destroy(R)) : (V.status = 1, V.fatalError = R);
  }
  function U2(V, R, W, Y, h1) {
    for (u3 = {}, k3 = R, L4 = 0, V = W(Y, h1); v4; )
      v4 = !1, L4 = 0, S4 += 1, H2 = null, V = W(Y, h1);
    return Z4(), V;
  }
  function _3(V, R, W, Y) {
    var h1 = W.render(), c1 = Y.childContextTypes;
    if (c1 != null) {
      var y1 = R.legacyContext;
      if (typeof W.getChildContext != "function")
        Y = y1;
      else {
        W = W.getChildContext();
        for (var k1 in W)
          if (!(k1 in c1))
            throw Error(t(108, x2(Y) || "Unknown", k1));
        Y = L1({}, y1, W);
      }
      R.legacyContext = Y, t3(V, R, h1), R.legacyContext = y1;
    } else
      t3(V, R, h1);
  }
  function n4(V, R) {
    if (V && V.defaultProps) {
      R = L1({}, R), V = V.defaultProps;
      for (var W in V)
        R[W] === void 0 && (R[W] = V[W]);
      return R;
    }
    return R;
  }
  function e3(V, R, W, Y, h1) {
    if (typeof W == "function")
      if (W.prototype && W.prototype.isReactComponent) {
        h1 = f3(W, R.legacyContext);
        var c1 = W.contextType;
        c1 = new W(Y, typeof c1 == "object" && c1 !== null ? c1._currentValue2 : h1), L2(c1, W, Y, h1), _3(V, R, c1, W);
      } else {
        c1 = f3(W, R.legacyContext), h1 = U2(V, R, W, Y, c1);
        var y1 = L4 !== 0;
        if (typeof h1 == "object" && h1 !== null && typeof h1.render == "function" && h1.$$typeof === void 0)
          L2(h1, W, Y, c1), _3(V, R, h1, W);
        else if (y1) {
          Y = R.treeContext, R.treeContext = C3(Y, 1, 0);
          try {
            t3(V, R, h1);
          } finally {
            R.treeContext = Y;
          }
        } else
          t3(V, R, h1);
      }
    else if (typeof W == "string") {
      switch (h1 = R.blockedSegment, c1 = J(h1.chunks, W, Y, V.responseState, h1.formatContext), h1.lastPushedText = !1, y1 = h1.formatContext, h1.formatContext = E(y1, W, Y), U3(V, R, c1), h1.formatContext = y1, W) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          h1.chunks.push("</", W, ">");
      }
      h1.lastPushedText = !1;
    } else {
      switch (W) {
        case r2:
        case Z1:
        case O1:
        case x1:
        case N1:
          t3(V, R, Y.children);
          return;
        case w1:
          t3(V, R, Y.children);
          return;
        case R1:
          throw Error(t(343));
        case D1:
          e: {
            W = R.blockedBoundary, h1 = R.blockedSegment, c1 = Y.fallback, Y = Y.children, y1 = /* @__PURE__ */ new Set();
            var k1 = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: y1, errorDigest: null }, z1 = K2(V, h1.chunks.length, k1, h1.formatContext, !1, !1);
            h1.children.push(z1), h1.lastPushedText = !1;
            var K1 = K2(V, 0, null, h1.formatContext, !1, !1);
            K1.parentFlushed = !0, R.blockedBoundary = k1, R.blockedSegment = K1;
            try {
              if (U3(
                V,
                R,
                Y
              ), V.responseState.generateStaticMarkup || K1.lastPushedText && K1.textEmbedded && K1.chunks.push("<!-- -->"), K1.status = 1, o4(k1, K1), k1.pendingTasks === 0)
                break e;
            } catch (q1) {
              K1.status = 4, k1.forceClientRender = !0, k1.errorDigest = w2(V, q1);
            } finally {
              R.blockedBoundary = W, R.blockedSegment = h1;
            }
            R = s2(V, c1, W, z1, y1, R.legacyContext, R.context, R.treeContext), V.pingedTasks.push(R);
          }
          return;
      }
      if (typeof W == "object" && W !== null)
        switch (W.$$typeof) {
          case H1:
            if (Y = U2(V, R, W.render, Y, h1), L4 !== 0) {
              W = R.treeContext, R.treeContext = C3(W, 1, 0);
              try {
                t3(V, R, Y);
              } finally {
                R.treeContext = W;
              }
            } else
              t3(V, R, Y);
            return;
          case E1:
            W = W.type, Y = n4(W, Y), e3(V, R, W, Y, h1);
            return;
          case l1:
            if (h1 = Y.children, W = W._context, Y = Y.value, c1 = W._currentValue2, W._currentValue2 = Y, y1 = q2, q2 = Y = { parent: y1, depth: y1 === null ? 0 : y1.depth + 1, context: W, parentValue: c1, value: Y }, R.context = Y, t3(V, R, h1), V = q2, V === null)
              throw Error(t(403));
            Y = V.parentValue, V.context._currentValue2 = Y === I2 ? V.context._defaultValue : Y, V = q2 = V.parent, R.context = V;
            return;
          case u1:
            Y = Y.children, Y = Y(W._currentValue2), t3(V, R, Y);
            return;
          case A1:
            h1 = W._init, W = h1(W._payload), Y = n4(W, Y), e3(
              V,
              R,
              W,
              Y,
              void 0
            );
            return;
        }
      throw Error(t(130, W == null ? W : typeof W, ""));
    }
  }
  function t3(V, R, W) {
    if (R.node = W, typeof W == "object" && W !== null) {
      switch (W.$$typeof) {
        case C1:
          e3(V, R, W.type, W.props, W.ref);
          return;
        case q:
          throw Error(t(257));
        case A1:
          var Y = W._init;
          W = Y(W._payload), t3(V, R, W);
          return;
      }
      if (v(W)) {
        i4(V, R, W);
        return;
      }
      if (W === null || typeof W != "object" ? Y = null : (Y = X1 && W[X1] || W["@@iterator"], Y = typeof Y == "function" ? Y : null), Y && (Y = Y.call(W))) {
        if (W = Y.next(), !W.done) {
          var h1 = [];
          do
            h1.push(W.value), W = Y.next();
          while (!W.done);
          i4(V, R, h1);
        }
        return;
      }
      throw V = Object.prototype.toString.call(W), Error(t(31, V === "[object Object]" ? "object with keys {" + Object.keys(W).join(", ") + "}" : V));
    }
    typeof W == "string" ? (Y = R.blockedSegment, Y.lastPushedText = Z(R.blockedSegment.chunks, W, V.responseState, Y.lastPushedText)) : typeof W == "number" && (Y = R.blockedSegment, Y.lastPushedText = Z(R.blockedSegment.chunks, "" + W, V.responseState, Y.lastPushedText));
  }
  function i4(V, R, W) {
    for (var Y = W.length, h1 = 0; h1 < Y; h1++) {
      var c1 = R.treeContext;
      R.treeContext = C3(c1, Y, h1);
      try {
        U3(V, R, W[h1]);
      } finally {
        R.treeContext = c1;
      }
    }
  }
  function U3(V, R, W) {
    var Y = R.blockedSegment.formatContext, h1 = R.legacyContext, c1 = R.context;
    try {
      return t3(V, R, W);
    } catch (z1) {
      if (Z4(), typeof z1 == "object" && z1 !== null && typeof z1.then == "function") {
        W = z1;
        var y1 = R.blockedSegment, k1 = K2(V, y1.chunks.length, null, y1.formatContext, y1.lastPushedText, !0);
        y1.children.push(k1), y1.lastPushedText = !1, V = s2(V, R.node, R.blockedBoundary, k1, R.abortSet, R.legacyContext, R.context, R.treeContext).ping, W.then(V, V), R.blockedSegment.formatContext = Y, R.legacyContext = h1, R.context = c1, G(c1);
      } else
        throw R.blockedSegment.formatContext = Y, R.legacyContext = h1, R.context = c1, G(c1), z1;
    }
  }
  function d3(V) {
    var R = V.blockedBoundary;
    V = V.blockedSegment, V.status = 3, a4(this, R, V);
  }
  function s6(V, R, W) {
    var Y = V.blockedBoundary;
    V.blockedSegment.status = 3, Y === null ? (R.allPendingTasks--, R.status !== 2 && (R.status = 2, R.destination !== null && R.destination.push(null))) : (Y.pendingTasks--, Y.forceClientRender || (Y.forceClientRender = !0, V = W === void 0 ? Error(t(432)) : W, Y.errorDigest = R.onError(V), Y.parentFlushed && R.clientRenderedBoundaries.push(Y)), Y.fallbackAbortableTasks.forEach(function(h1) {
      return s6(h1, R, W);
    }), Y.fallbackAbortableTasks.clear(), R.allPendingTasks--, R.allPendingTasks === 0 && (Y = R.onAllReady, Y()));
  }
  function o4(V, R) {
    if (R.chunks.length === 0 && R.children.length === 1 && R.children[0].boundary === null) {
      var W = R.children[0];
      W.id = R.id, W.parentFlushed = !0, W.status === 1 && o4(V, W);
    } else
      V.completedSegments.push(R);
  }
  function a4(V, R, W) {
    if (R === null) {
      if (W.parentFlushed) {
        if (V.completedRootSegment !== null)
          throw Error(t(389));
        V.completedRootSegment = W;
      }
      V.pendingRootTasks--, V.pendingRootTasks === 0 && (V.onShellError = v2, R = V.onShellReady, R());
    } else
      R.pendingTasks--, R.forceClientRender || (R.pendingTasks === 0 ? (W.parentFlushed && W.status === 1 && o4(R, W), R.parentFlushed && V.completedBoundaries.push(R), R.fallbackAbortableTasks.forEach(d3, V), R.fallbackAbortableTasks.clear()) : W.parentFlushed && W.status === 1 && (o4(R, W), R.completedSegments.length === 1 && R.parentFlushed && V.partialBoundaries.push(R)));
    V.allPendingTasks--, V.allPendingTasks === 0 && (V = V.onAllReady, V());
  }
  function O3(V) {
    if (V.status !== 2) {
      var R = q2, W = J1.current;
      J1.current = _1;
      var Y = P1;
      P1 = V.responseState;
      try {
        var h1 = V.pingedTasks, c1;
        for (c1 = 0; c1 < h1.length; c1++) {
          var y1 = h1[c1], k1 = V, z1 = y1.blockedSegment;
          if (z1.status === 0) {
            G(y1.context);
            try {
              t3(k1, y1, y1.node), k1.responseState.generateStaticMarkup || z1.lastPushedText && z1.textEmbedded && z1.chunks.push("<!-- -->"), y1.abortSet.delete(y1), z1.status = 1, a4(k1, y1.blockedBoundary, z1);
            } catch (E3) {
              if (Z4(), typeof E3 == "object" && E3 !== null && typeof E3.then == "function") {
                var K1 = y1.ping;
                E3.then(K1, K1);
              } else {
                y1.abortSet.delete(y1), z1.status = 4;
                var q1 = y1.blockedBoundary, E2 = E3, R3 = w2(k1, E2);
                if (q1 === null ? S2(k1, E2) : (q1.pendingTasks--, q1.forceClientRender || (q1.forceClientRender = !0, q1.errorDigest = R3, q1.parentFlushed && k1.clientRenderedBoundaries.push(q1))), k1.allPendingTasks--, k1.allPendingTasks === 0) {
                  var H3 = k1.onAllReady;
                  H3();
                }
              }
            } finally {
            }
          }
        }
        h1.splice(0, c1), V.destination !== null && V4(V, V.destination);
      } catch (E3) {
        w2(V, E3), S2(V, E3);
      } finally {
        P1 = Y, J1.current = W, W === _1 && G(R);
      }
    }
  }
  function y4(V, R, W) {
    switch (W.parentFlushed = !0, W.status) {
      case 0:
        var Y = W.id = V.nextSegmentId++;
        return W.lastPushedText = !1, W.textEmbedded = !1, V = V.responseState, R.push('<template id="'), R.push(V.placeholderPrefix), V = Y.toString(16), R.push(V), R.push('"></template>');
      case 1:
        W.status = 2;
        var h1 = !0;
        Y = W.chunks;
        var c1 = 0;
        W = W.children;
        for (var y1 = 0; y1 < W.length; y1++) {
          for (h1 = W[y1]; c1 < h1.index; c1++)
            R.push(Y[c1]);
          h1 = C4(V, R, h1);
        }
        for (; c1 < Y.length - 1; c1++)
          R.push(Y[c1]);
        return c1 < Y.length && (h1 = R.push(Y[c1])), h1;
      default:
        throw Error(t(390));
    }
  }
  function C4(V, R, W) {
    var Y = W.boundary;
    if (Y === null)
      return y4(V, R, W);
    if (Y.parentFlushed = !0, Y.forceClientRender)
      return V.responseState.generateStaticMarkup || (Y = Y.errorDigest, R.push("<!--$!-->"), R.push("<template"), Y && (R.push(' data-dgst="'), Y = d(Y), R.push(Y), R.push('"')), R.push("></template>")), y4(V, R, W), V = V.responseState.generateStaticMarkup ? !0 : R.push("<!--/$-->"), V;
    if (0 < Y.pendingTasks) {
      Y.rootSegmentID = V.nextSegmentId++, 0 < Y.completedSegments.length && V.partialBoundaries.push(Y);
      var h1 = V.responseState, c1 = h1.nextSuspenseID++;
      return h1 = h1.boundaryPrefix + c1.toString(16), Y = Y.id = h1, i1(R, V.responseState, Y), y4(V, R, W), R.push("<!--/$-->");
    }
    if (Y.byteSize > V.progressiveChunkSize)
      return Y.rootSegmentID = V.nextSegmentId++, V.completedBoundaries.push(Y), i1(R, V.responseState, Y.id), y4(V, R, W), R.push("<!--/$-->");
    if (V.responseState.generateStaticMarkup || R.push("<!--$-->"), W = Y.completedSegments, W.length !== 1)
      throw Error(t(391));
    return C4(V, R, W[0]), V = V.responseState.generateStaticMarkup ? !0 : R.push("<!--/$-->"), V;
  }
  function S6(V, R, W) {
    return t1(R, V.responseState, W.formatContext, W.id), C4(V, R, W), T1(R, W.formatContext);
  }
  function C6(V, R, W) {
    for (var Y = W.completedSegments, h1 = 0; h1 < Y.length; h1++)
      l6(V, R, W, Y[h1]);
    if (Y.length = 0, V = V.responseState, Y = W.id, W = W.rootSegmentID, R.push(V.startInlineScript), V.sentCompleteBoundaryFunction ? R.push('$RC("') : (V.sentCompleteBoundaryFunction = !0, R.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), Y === null)
      throw Error(t(395));
    return W = W.toString(16), R.push(Y), R.push('","'), R.push(V.segmentPrefix), R.push(W), R.push('")<\/script>');
  }
  function l6(V, R, W, Y) {
    if (Y.status === 2)
      return !0;
    var h1 = Y.id;
    if (h1 === -1) {
      if ((Y.id = W.rootSegmentID) === -1)
        throw Error(t(392));
      return S6(V, R, Y);
    }
    return S6(V, R, Y), V = V.responseState, R.push(V.startInlineScript), V.sentCompleteSegmentFunction ? R.push('$RS("') : (V.sentCompleteSegmentFunction = !0, R.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), R.push(V.segmentPrefix), h1 = h1.toString(16), R.push(h1), R.push('","'), R.push(V.placeholderPrefix), R.push(h1), R.push('")<\/script>');
  }
  function V4(V, R) {
    try {
      var W = V.completedRootSegment;
      if (W !== null && V.pendingRootTasks === 0) {
        C4(V, R, W), V.completedRootSegment = null;
        var Y = V.responseState.bootstrapChunks;
        for (W = 0; W < Y.length - 1; W++)
          R.push(Y[W]);
        W < Y.length && R.push(Y[W]);
      }
      var h1 = V.clientRenderedBoundaries, c1;
      for (c1 = 0; c1 < h1.length; c1++) {
        var y1 = h1[c1];
        Y = R;
        var k1 = V.responseState, z1 = y1.id, K1 = y1.errorDigest, q1 = y1.errorMessage, E2 = y1.errorComponentStack;
        if (Y.push(k1.startInlineScript), k1.sentClientRenderFunction ? Y.push('$RX("') : (k1.sentClientRenderFunction = !0, Y.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), z1 === null)
          throw Error(t(395));
        if (Y.push(z1), Y.push('"'), K1 || q1 || E2) {
          Y.push(",");
          var R3 = f1(K1 || "");
          Y.push(R3);
        }
        if (q1 || E2) {
          Y.push(",");
          var H3 = f1(q1 || "");
          Y.push(H3);
        }
        if (E2) {
          Y.push(",");
          var E3 = f1(E2);
          Y.push(E3);
        }
        if (!Y.push(")<\/script>")) {
          V.destination = null, c1++, h1.splice(0, c1);
          return;
        }
      }
      h1.splice(0, c1);
      var g4 = V.completedBoundaries;
      for (c1 = 0; c1 < g4.length; c1++)
        if (!C6(V, R, g4[c1])) {
          V.destination = null, c1++, g4.splice(0, c1);
          return;
        }
      g4.splice(0, c1);
      var X3 = V.partialBoundaries;
      for (c1 = 0; c1 < X3.length; c1++) {
        var f6 = X3[c1];
        e: {
          h1 = V, y1 = R;
          var _4 = f6.completedSegments;
          for (k1 = 0; k1 < _4.length; k1++)
            if (!l6(h1, y1, f6, _4[k1])) {
              k1++, _4.splice(0, k1);
              var z4 = !1;
              break e;
            }
          _4.splice(0, k1), z4 = !0;
        }
        if (!z4) {
          V.destination = null, c1++, X3.splice(0, c1);
          return;
        }
      }
      X3.splice(0, c1);
      var x4 = V.completedBoundaries;
      for (c1 = 0; c1 < x4.length; c1++)
        if (!C6(V, R, x4[c1])) {
          V.destination = null, c1++, x4.splice(0, c1);
          return;
        }
      x4.splice(0, c1);
    } finally {
      V.allPendingTasks === 0 && V.pingedTasks.length === 0 && V.clientRenderedBoundaries.length === 0 && V.completedBoundaries.length === 0 && R.push(null);
    }
  }
  function V6(V, R) {
    try {
      var W = V.abortableTasks;
      W.forEach(function(Y) {
        return s6(Y, V, R);
      }), W.clear(), V.destination !== null && V4(V, V.destination);
    } catch (Y) {
      w2(V, Y), S2(V, Y);
    }
  }
  function u6() {
  }
  function c6(V, R, W, Y) {
    var h1 = !1, c1 = null, y1 = "", k1 = { push: function(K1) {
      return K1 !== null && (y1 += K1), !0;
    }, destroy: function(K1) {
      h1 = !0, c1 = K1;
    } }, z1 = !1;
    if (V = m2(V, s1(W, R ? R.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, u6, void 0, function() {
      z1 = !0;
    }, void 0, void 0), O3(V), V6(V, Y), V.status === 1)
      V.status = 2, k1.destroy(V.fatalError);
    else if (V.status !== 2 && V.destination === null) {
      V.destination = k1;
      try {
        V4(V, k1);
      } catch (K1) {
        w2(V, K1), S2(V, K1);
      }
    }
    if (h1)
      throw c1;
    if (!z1)
      throw Error(t(426));
    return y1;
  }
  return Oe.renderToNodeStream = function() {
    throw Error(t(207));
  }, Oe.renderToStaticMarkup = function(V, R) {
    return c6(V, R, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Oe.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, Oe.renderToString = function(V, R) {
    return c6(V, R, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Oe.version = "18.2.0", Oe;
}
var Fn = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zf;
function P_() {
  if (zf)
    return Fn;
  zf = 1;
  var e = y;
  function t(_) {
    for (var N = "https://reactjs.org/docs/error-decoder.html?invariant=" + _, F = 1; F < arguments.length; F++)
      N += "&args[]=" + encodeURIComponent(arguments[F]);
    return "Minified React error #" + _ + "; visit " + N + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = null, n = 0;
  function i(_, N) {
    if (N.length !== 0)
      if (512 < N.length)
        0 < n && (_.enqueue(new Uint8Array(r.buffer, 0, n)), r = new Uint8Array(512), n = 0), _.enqueue(N);
      else {
        var F = r.length - n;
        F < N.length && (F === 0 ? _.enqueue(r) : (r.set(N.subarray(0, F), n), _.enqueue(r), N = N.subarray(F)), r = new Uint8Array(512), n = 0), r.set(N, n), n += N.length;
      }
  }
  function o(_, N) {
    return i(_, N), !0;
  }
  function a(_) {
    r && 0 < n && (_.enqueue(new Uint8Array(r.buffer, 0, n)), r = null, n = 0);
  }
  var T = new TextEncoder();
  function s(_) {
    return T.encode(_);
  }
  function Q(_) {
    return T.encode(_);
  }
  function u(_, N) {
    typeof _.error == "function" ? _.error(N) : _.close();
  }
  var l = Object.prototype.hasOwnProperty, c = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, f = {}, d = {};
  function m(_) {
    return l.call(d, _) ? !0 : l.call(f, _) ? !1 : c.test(_) ? d[_] = !0 : (f[_] = !0, !1);
  }
  function p(_, N, F, K, p1, d1, b1) {
    this.acceptsBooleans = N === 2 || N === 3 || N === 4, this.attributeName = K, this.attributeNamespace = p1, this.mustUseProperty = F, this.propertyName = _, this.type = N, this.sanitizeURL = d1, this.removeEmptyString = b1;
  }
  var v = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(_) {
    v[_] = new p(_, 0, !1, _, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(_) {
    var N = _[0];
    v[N] = new p(N, 1, !1, _[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(_) {
    v[_] = new p(_, 2, !1, _.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(_) {
    v[_] = new p(_, 2, !1, _, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(_) {
    v[_] = new p(_, 3, !1, _.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(_) {
    v[_] = new p(_, 3, !0, _, null, !1, !1);
  }), ["capture", "download"].forEach(function(_) {
    v[_] = new p(_, 4, !1, _, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(_) {
    v[_] = new p(_, 6, !1, _, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(_) {
    v[_] = new p(_, 5, !1, _.toLowerCase(), null, !1, !1);
  });
  var H = /[\-:]([a-z])/g;
  function E(_) {
    return _[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(_) {
    var N = _.replace(
      H,
      E
    );
    v[N] = new p(N, 1, !1, _, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(_) {
    var N = _.replace(H, E);
    v[N] = new p(N, 1, !1, _, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(_) {
    var N = _.replace(H, E);
    v[N] = new p(N, 1, !1, _, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(_) {
    v[_] = new p(_, 1, !1, _.toLowerCase(), null, !1, !1);
  }), v.xlinkHref = new p("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(_) {
    v[_] = new p(_, 1, !1, _.toLowerCase(), null, !0, !0);
  });
  var M = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, C = ["Webkit", "ms", "Moz", "O"];
  Object.keys(M).forEach(function(_) {
    C.forEach(function(N) {
      N = N + _.charAt(0).toUpperCase() + _.substring(1), M[N] = M[_];
    });
  });
  var w = /["'&<>]/;
  function S(_) {
    if (typeof _ == "boolean" || typeof _ == "number")
      return "" + _;
    _ = "" + _;
    var N = w.exec(_);
    if (N) {
      var F = "", K, p1 = 0;
      for (K = N.index; K < _.length; K++) {
        switch (_.charCodeAt(K)) {
          case 34:
            N = "&quot;";
            break;
          case 38:
            N = "&amp;";
            break;
          case 39:
            N = "&#x27;";
            break;
          case 60:
            N = "&lt;";
            break;
          case 62:
            N = "&gt;";
            break;
          default:
            continue;
        }
        p1 !== K && (F += _.substring(p1, K)), p1 = K + 1, F += N;
      }
      _ = p1 !== K ? F + _.substring(p1, K) : F;
    }
    return _;
  }
  var D = /([A-Z])/g, k = /^ms-/, $ = Array.isArray, z = Q("<script>"), j = Q("<\/script>"), J = Q('<script src="'), i1 = Q('<script type="module" src="'), t1 = Q('" async=""><\/script>'), T1 = /(<\/|<)(s)(cript)/gi;
  function X(_, N, F, K) {
    return "" + N + (F === "s" ? "\\u0073" : "\\u0053") + K;
  }
  function f1(_, N, F, K, p1) {
    _ = _ === void 0 ? "" : _, N = N === void 0 ? z : Q('<script nonce="' + S(N) + '">');
    var d1 = [];
    if (F !== void 0 && d1.push(N, s(("" + F).replace(T1, X)), j), K !== void 0)
      for (F = 0; F < K.length; F++)
        d1.push(J, s(S(K[F])), t1);
    if (p1 !== void 0)
      for (K = 0; K < p1.length; K++)
        d1.push(i1, s(S(p1[K])), t1);
    return { bootstrapChunks: d1, startInlineScript: N, placeholderPrefix: Q(_ + "P:"), segmentPrefix: Q(_ + "S:"), boundaryPrefix: _ + "B:", idPrefix: _, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function s1(_, N) {
    return { insertionMode: _, selectedValue: N };
  }
  function Z(_) {
    return s1(_ === "http://www.w3.org/2000/svg" ? 2 : _ === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function L1(_, N, F) {
    switch (N) {
      case "select":
        return s1(1, F.value != null ? F.value : F.defaultValue);
      case "svg":
        return s1(2, null);
      case "math":
        return s1(3, null);
      case "foreignObject":
        return s1(1, null);
      case "table":
        return s1(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return s1(5, null);
      case "colgroup":
        return s1(7, null);
      case "tr":
        return s1(6, null);
    }
    return 4 <= _.insertionMode || _.insertionMode === 0 ? s1(1, null) : _;
  }
  var C1 = Q("<!-- -->");
  function q(_, N, F, K) {
    return N === "" ? K : (K && _.push(C1), _.push(s(S(N))), !0);
  }
  var N1 = /* @__PURE__ */ new Map(), O1 = Q(' style="'), x1 = Q(":"), l1 = Q(";");
  function u1(_, N, F) {
    if (typeof F != "object")
      throw Error(t(62));
    N = !0;
    for (var K in F)
      if (l.call(F, K)) {
        var p1 = F[K];
        if (p1 != null && typeof p1 != "boolean" && p1 !== "") {
          if (K.indexOf("--") === 0) {
            var d1 = s(S(K));
            p1 = s(S(("" + p1).trim()));
          } else {
            d1 = K;
            var b1 = N1.get(d1);
            b1 !== void 0 || (b1 = Q(S(d1.replace(D, "-$1").toLowerCase().replace(k, "-ms-"))), N1.set(d1, b1)), d1 = b1, p1 = typeof p1 == "number" ? p1 === 0 || l.call(M, K) ? s("" + p1) : s(p1 + "px") : s(S(("" + p1).trim()));
          }
          N ? (N = !1, _.push(O1, d1, x1, p1)) : _.push(l1, d1, x1, p1);
        }
      }
    N || _.push(w1);
  }
  var H1 = Q(" "), D1 = Q('="'), w1 = Q('"'), E1 = Q('=""');
  function A1(_, N, F, K) {
    switch (F) {
      case "style":
        u1(_, N, K);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < F.length) || F[0] !== "o" && F[0] !== "O" || F[1] !== "n" && F[1] !== "N") {
      if (N = v.hasOwnProperty(F) ? v[F] : null, N !== null) {
        switch (typeof K) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!N.acceptsBooleans)
              return;
        }
        switch (F = s(N.attributeName), N.type) {
          case 3:
            K && _.push(H1, F, E1);
            break;
          case 4:
            K === !0 ? _.push(H1, F, E1) : K !== !1 && _.push(H1, F, D1, s(S(K)), w1);
            break;
          case 5:
            isNaN(K) || _.push(H1, F, D1, s(S(K)), w1);
            break;
          case 6:
            !isNaN(K) && 1 <= K && _.push(H1, F, D1, s(S(K)), w1);
            break;
          default:
            N.sanitizeURL && (K = "" + K), _.push(H1, F, D1, s(S(K)), w1);
        }
      } else if (m(F)) {
        switch (typeof K) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (N = F.toLowerCase().slice(0, 5), N !== "data-" && N !== "aria-")
              return;
        }
        _.push(H1, s(F), D1, s(S(K)), w1);
      }
    }
  }
  var R1 = Q(">"), Z1 = Q("/>");
  function r2(_, N, F) {
    if (N != null) {
      if (F != null)
        throw Error(t(60));
      if (typeof N != "object" || !("__html" in N))
        throw Error(t(61));
      N = N.__html, N != null && _.push(s("" + N));
    }
  }
  function I2(_) {
    var N = "";
    return e.Children.forEach(_, function(F) {
      F != null && (N += F);
    }), N;
  }
  var X1 = Q(' selected=""');
  function x2(_, N, F, K) {
    _.push(V2(F));
    var p1 = F = null, d1;
    for (d1 in N)
      if (l.call(N, d1)) {
        var b1 = N[d1];
        if (b1 != null)
          switch (d1) {
            case "children":
              F = b1;
              break;
            case "dangerouslySetInnerHTML":
              p1 = b1;
              break;
            default:
              A1(_, K, d1, b1);
          }
      }
    return _.push(R1), r2(_, p1, F), typeof F == "string" ? (_.push(s(S(F))), null) : F;
  }
  var R2 = Q(`
`), f3 = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, q2 = /* @__PURE__ */ new Map();
  function V2(_) {
    var N = q2.get(_);
    if (N === void 0) {
      if (!f3.test(_))
        throw Error(t(65, _));
      N = Q("<" + _), q2.set(_, N);
    }
    return N;
  }
  var n2 = Q("<!DOCTYPE html>");
  function A3(_, N, F, K, p1) {
    switch (N) {
      case "select":
        _.push(V2("select"));
        var d1 = null, b1 = null;
        for (c2 in F)
          if (l.call(F, c2)) {
            var I1 = F[c2];
            if (I1 != null)
              switch (c2) {
                case "children":
                  d1 = I1;
                  break;
                case "dangerouslySetInnerHTML":
                  b1 = I1;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  A1(_, K, c2, I1);
              }
          }
        return _.push(R1), r2(_, b1, d1), d1;
      case "option":
        b1 = p1.selectedValue, _.push(V2("option"));
        var e2 = I1 = null, p2 = null, c2 = null;
        for (d1 in F)
          if (l.call(F, d1)) {
            var F2 = F[d1];
            if (F2 != null)
              switch (d1) {
                case "children":
                  I1 = F2;
                  break;
                case "selected":
                  p2 = F2;
                  break;
                case "dangerouslySetInnerHTML":
                  c2 = F2;
                  break;
                case "value":
                  e2 = F2;
                default:
                  A1(_, K, d1, F2);
              }
          }
        if (b1 != null)
          if (F = e2 !== null ? "" + e2 : I2(I1), $(b1)) {
            for (K = 0; K < b1.length; K++)
              if ("" + b1[K] === F) {
                _.push(X1);
                break;
              }
          } else
            "" + b1 === F && _.push(X1);
        else
          p2 && _.push(X1);
        return _.push(R1), r2(_, c2, I1), I1;
      case "textarea":
        _.push(V2("textarea")), c2 = b1 = d1 = null;
        for (I1 in F)
          if (l.call(F, I1) && (e2 = F[I1], e2 != null))
            switch (I1) {
              case "children":
                c2 = e2;
                break;
              case "value":
                d1 = e2;
                break;
              case "defaultValue":
                b1 = e2;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(91));
              default:
                A1(_, K, I1, e2);
            }
        if (d1 === null && b1 !== null && (d1 = b1), _.push(R1), c2 != null) {
          if (d1 != null)
            throw Error(t(92));
          if ($(c2) && 1 < c2.length)
            throw Error(t(93));
          d1 = "" + c2;
        }
        return typeof d1 == "string" && d1[0] === `
` && _.push(R2), d1 !== null && _.push(s(S("" + d1))), null;
      case "input":
        _.push(V2("input")), e2 = c2 = I1 = d1 = null;
        for (b1 in F)
          if (l.call(F, b1) && (p2 = F[b1], p2 != null))
            switch (b1) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, "input"));
              case "defaultChecked":
                e2 = p2;
                break;
              case "defaultValue":
                I1 = p2;
                break;
              case "checked":
                c2 = p2;
                break;
              case "value":
                d1 = p2;
                break;
              default:
                A1(_, K, b1, p2);
            }
        return c2 !== null ? A1(
          _,
          K,
          "checked",
          c2
        ) : e2 !== null && A1(_, K, "checked", e2), d1 !== null ? A1(_, K, "value", d1) : I1 !== null && A1(_, K, "value", I1), _.push(Z1), null;
      case "menuitem":
        _.push(V2("menuitem"));
        for (var B3 in F)
          if (l.call(F, B3) && (d1 = F[B3], d1 != null))
            switch (B3) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(400));
              default:
                A1(_, K, B3, d1);
            }
        return _.push(R1), null;
      case "title":
        _.push(V2("title")), d1 = null;
        for (F2 in F)
          if (l.call(F, F2) && (b1 = F[F2], b1 != null))
            switch (F2) {
              case "children":
                d1 = b1;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(t(434));
              default:
                A1(_, K, F2, b1);
            }
        return _.push(R1), d1;
      case "listing":
      case "pre":
        _.push(V2(N)), b1 = d1 = null;
        for (e2 in F)
          if (l.call(F, e2) && (I1 = F[e2], I1 != null))
            switch (e2) {
              case "children":
                d1 = I1;
                break;
              case "dangerouslySetInnerHTML":
                b1 = I1;
                break;
              default:
                A1(_, K, e2, I1);
            }
        if (_.push(R1), b1 != null) {
          if (d1 != null)
            throw Error(t(60));
          if (typeof b1 != "object" || !("__html" in b1))
            throw Error(t(61));
          F = b1.__html, F != null && (typeof F == "string" && 0 < F.length && F[0] === `
` ? _.push(R2, s(F)) : _.push(s("" + F)));
        }
        return typeof d1 == "string" && d1[0] === `
` && _.push(R2), d1;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        _.push(V2(N));
        for (var J3 in F)
          if (l.call(F, J3) && (d1 = F[J3], d1 != null))
            switch (J3) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(t(399, N));
              default:
                A1(_, K, J3, d1);
            }
        return _.push(Z1), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return x2(_, F, N, K);
      case "html":
        return p1.insertionMode === 0 && _.push(n2), x2(_, F, N, K);
      default:
        if (N.indexOf("-") === -1 && typeof F.is != "string")
          return x2(_, F, N, K);
        _.push(V2(N)), b1 = d1 = null;
        for (p2 in F)
          if (l.call(F, p2) && (I1 = F[p2], I1 != null))
            switch (p2) {
              case "children":
                d1 = I1;
                break;
              case "dangerouslySetInnerHTML":
                b1 = I1;
                break;
              case "style":
                u1(_, K, I1);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                m(p2) && typeof I1 != "function" && typeof I1 != "symbol" && _.push(H1, s(p2), D1, s(S(I1)), w1);
            }
        return _.push(R1), r2(_, b1, d1), d1;
    }
  }
  var g1 = Q("</"), S1 = Q(">"), G = Q('<template id="'), u2 = Q('"></template>'), L2 = Q("<!--$-->"), J2 = Q('<!--$?--><template id="'), C3 = Q('"></template>'), l3 = Q("<!--$!-->"), z3 = Q("<!--/$-->"), D3 = Q("<template"), $2 = Q('"'), V3 = Q(' data-dgst="');
  Q(' data-msg="'), Q(' data-stck="');
  var y3 = Q("></template>");
  function u3(_, N, F) {
    if (i(_, J2), F === null)
      throw Error(t(395));
    return i(_, F), o(_, C3);
  }
  var k3 = Q('<div hidden id="'), x3 = Q('">'), H2 = Q("</div>"), j3 = Q('<svg aria-hidden="true" style="display:none" id="'), v4 = Q('">'), L4 = Q("</svg>"), I3 = Q('<math aria-hidden="true" style="display:none" id="'), S4 = Q('">'), $3 = Q("</math>"), Z2 = Q('<table hidden id="'), $4 = Q('">'), Z4 = Q("</table>"), W4 = Q('<table hidden><tbody id="'), Y2 = Q('">'), G4 = Q("</tbody></table>"), M6 = Q('<table hidden><tr id="'), w6 = Q('">'), n1 = Q("</tr></table>"), _1 = Q('<table hidden><colgroup id="'), P1 = Q('">'), J1 = Q("</colgroup></table>");
  function h2(_, N, F, K) {
    switch (F.insertionMode) {
      case 0:
      case 1:
        return i(_, k3), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, x3);
      case 2:
        return i(_, j3), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, v4);
      case 3:
        return i(_, I3), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, S4);
      case 4:
        return i(_, Z2), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, $4);
      case 5:
        return i(_, W4), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, Y2);
      case 6:
        return i(_, M6), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, w6);
      case 7:
        return i(
          _,
          _1
        ), i(_, N.segmentPrefix), i(_, s(K.toString(16))), o(_, P1);
      default:
        throw Error(t(397));
    }
  }
  function v2(_, N) {
    switch (N.insertionMode) {
      case 0:
      case 1:
        return o(_, H2);
      case 2:
        return o(_, L4);
      case 3:
        return o(_, $3);
      case 4:
        return o(_, Z4);
      case 5:
        return o(_, G4);
      case 6:
        return o(_, n1);
      case 7:
        return o(_, J1);
      default:
        throw Error(t(397));
    }
  }
  var m2 = Q('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), s2 = Q('$RS("'), K2 = Q('","'), w2 = Q('")<\/script>'), S2 = Q('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), U2 = Q('$RC("'), _3 = Q('","'), n4 = Q('")<\/script>'), e3 = Q('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), t3 = Q('$RX("'), i4 = Q('"'), U3 = Q(")<\/script>"), d3 = Q(","), s6 = /[<\u2028\u2029]/g;
  function o4(_) {
    return JSON.stringify(_).replace(s6, function(N) {
      switch (N) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var a4 = Object.assign, O3 = Symbol.for("react.element"), y4 = Symbol.for("react.portal"), C4 = Symbol.for("react.fragment"), S6 = Symbol.for("react.strict_mode"), C6 = Symbol.for("react.profiler"), l6 = Symbol.for("react.provider"), V4 = Symbol.for("react.context"), V6 = Symbol.for("react.forward_ref"), u6 = Symbol.for("react.suspense"), c6 = Symbol.for("react.suspense_list"), V = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), W = Symbol.for("react.scope"), Y = Symbol.for("react.debug_trace_mode"), h1 = Symbol.for("react.legacy_hidden"), c1 = Symbol.for("react.default_value"), y1 = Symbol.iterator;
  function k1(_) {
    if (_ == null)
      return null;
    if (typeof _ == "function")
      return _.displayName || _.name || null;
    if (typeof _ == "string")
      return _;
    switch (_) {
      case C4:
        return "Fragment";
      case y4:
        return "Portal";
      case C6:
        return "Profiler";
      case S6:
        return "StrictMode";
      case u6:
        return "Suspense";
      case c6:
        return "SuspenseList";
    }
    if (typeof _ == "object")
      switch (_.$$typeof) {
        case V4:
          return (_.displayName || "Context") + ".Consumer";
        case l6:
          return (_._context.displayName || "Context") + ".Provider";
        case V6:
          var N = _.render;
          return _ = _.displayName, _ || (_ = N.displayName || N.name || "", _ = _ !== "" ? "ForwardRef(" + _ + ")" : "ForwardRef"), _;
        case V:
          return N = _.displayName || null, N !== null ? N : k1(_.type) || "Memo";
        case R:
          N = _._payload, _ = _._init;
          try {
            return k1(_(N));
          } catch {
          }
      }
    return null;
  }
  var z1 = {};
  function K1(_, N) {
    if (_ = _.contextTypes, !_)
      return z1;
    var F = {}, K;
    for (K in _)
      F[K] = N[K];
    return F;
  }
  var q1 = null;
  function E2(_, N) {
    if (_ !== N) {
      _.context._currentValue = _.parentValue, _ = _.parent;
      var F = N.parent;
      if (_ === null) {
        if (F !== null)
          throw Error(t(401));
      } else {
        if (F === null)
          throw Error(t(401));
        E2(_, F);
      }
      N.context._currentValue = N.value;
    }
  }
  function R3(_) {
    _.context._currentValue = _.parentValue, _ = _.parent, _ !== null && R3(_);
  }
  function H3(_) {
    var N = _.parent;
    N !== null && H3(N), _.context._currentValue = _.value;
  }
  function E3(_, N) {
    if (_.context._currentValue = _.parentValue, _ = _.parent, _ === null)
      throw Error(t(402));
    _.depth === N.depth ? E2(_, N) : E3(_, N);
  }
  function g4(_, N) {
    var F = N.parent;
    if (F === null)
      throw Error(t(402));
    _.depth === F.depth ? E2(_, F) : g4(_, F), N.context._currentValue = N.value;
  }
  function X3(_) {
    var N = q1;
    N !== _ && (N === null ? H3(_) : _ === null ? R3(N) : N.depth === _.depth ? E2(N, _) : N.depth > _.depth ? E3(N, _) : g4(N, _), q1 = _);
  }
  var f6 = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(_, N) {
    _ = _._reactInternals, _.queue !== null && _.queue.push(N);
  }, enqueueReplaceState: function(_, N) {
    _ = _._reactInternals, _.replace = !0, _.queue = [N];
  }, enqueueForceUpdate: function() {
  } };
  function _4(_, N, F, K) {
    var p1 = _.state !== void 0 ? _.state : null;
    _.updater = f6, _.props = F, _.state = p1;
    var d1 = { queue: [], replace: !1 };
    _._reactInternals = d1;
    var b1 = N.contextType;
    if (_.context = typeof b1 == "object" && b1 !== null ? b1._currentValue : K, b1 = N.getDerivedStateFromProps, typeof b1 == "function" && (b1 = b1(F, p1), p1 = b1 == null ? p1 : a4({}, p1, b1), _.state = p1), typeof N.getDerivedStateFromProps != "function" && typeof _.getSnapshotBeforeUpdate != "function" && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function"))
      if (N = _.state, typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount(), N !== _.state && f6.enqueueReplaceState(_, _.state, null), d1.queue !== null && 0 < d1.queue.length)
        if (N = d1.queue, b1 = d1.replace, d1.queue = null, d1.replace = !1, b1 && N.length === 1)
          _.state = N[0];
        else {
          for (d1 = b1 ? N[0] : _.state, p1 = !0, b1 = b1 ? 1 : 0; b1 < N.length; b1++) {
            var I1 = N[b1];
            I1 = typeof I1 == "function" ? I1.call(_, d1, F, K) : I1, I1 != null && (p1 ? (p1 = !1, d1 = a4({}, d1, I1)) : a4(d1, I1));
          }
          _.state = d1;
        }
      else
        d1.queue = null;
  }
  var z4 = { id: 1, overflow: "" };
  function x4(_, N, F) {
    var K = _.id;
    _ = _.overflow;
    var p1 = 32 - _6(K) - 1;
    K &= ~(1 << p1), F += 1;
    var d1 = 32 - _6(N) + p1;
    if (30 < d1) {
      var b1 = p1 - p1 % 5;
      return d1 = (K & (1 << b1) - 1).toString(32), K >>= b1, p1 -= b1, { id: 1 << 32 - _6(N) + p1 | F << p1 | K, overflow: d1 + _ };
    }
    return { id: 1 << d1 | F << p1 | K, overflow: _ };
  }
  var _6 = Math.clz32 ? Math.clz32 : G5, $0 = Math.log, Z0 = Math.LN2;
  function G5(_) {
    return _ >>>= 0, _ === 0 ? 32 : 31 - ($0(_) / Z0 | 0) | 0;
  }
  function W0(_, N) {
    return _ === N && (_ !== 0 || 1 / _ === 1 / N) || _ !== _ && N !== N;
  }
  var z5 = typeof Object.is == "function" ? Object.is : W0, H4 = null, O6 = null, o5 = null, N2 = null, O4 = !1, N3 = !1, U4 = 0, A4 = null, a5 = 0;
  function D4() {
    if (H4 === null)
      throw Error(t(321));
    return H4;
  }
  function q3() {
    if (0 < a5)
      throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function U5() {
    return N2 === null ? o5 === null ? (O4 = !1, o5 = N2 = q3()) : (O4 = !0, N2 = o5) : N2.next === null ? (O4 = !1, N2 = N2.next = q3()) : (O4 = !0, N2 = N2.next), N2;
  }
  function X5() {
    O6 = H4 = null, N3 = !1, o5 = null, a5 = 0, N2 = A4 = null;
  }
  function at(_, N) {
    return typeof N == "function" ? N(_) : N;
  }
  function Qt(_, N, F) {
    if (H4 = D4(), N2 = U5(), O4) {
      var K = N2.queue;
      if (N = K.dispatch, A4 !== null && (F = A4.get(K), F !== void 0)) {
        A4.delete(K), K = N2.memoizedState;
        do
          K = _(K, F.action), F = F.next;
        while (F !== null);
        return N2.memoizedState = K, [K, N];
      }
      return [N2.memoizedState, N];
    }
    return _ = _ === at ? typeof N == "function" ? N() : N : F !== void 0 ? F(N) : N, N2.memoizedState = _, _ = N2.queue = { last: null, dispatch: null }, _ = _.dispatch = G0.bind(null, H4, _), [N2.memoizedState, _];
  }
  function Tt(_, N) {
    if (H4 = D4(), N2 = U5(), N = N === void 0 ? null : N, N2 !== null) {
      var F = N2.memoizedState;
      if (F !== null && N !== null) {
        var K = F[1];
        e:
          if (K === null)
            K = !1;
          else {
            for (var p1 = 0; p1 < K.length && p1 < N.length; p1++)
              if (!z5(N[p1], K[p1])) {
                K = !1;
                break e;
              }
            K = !0;
          }
        if (K)
          return F[0];
      }
    }
    return _ = _(), N2.memoizedState = [_, N], _;
  }
  function G0(_, N, F) {
    if (25 <= a5)
      throw Error(t(301));
    if (_ === H4)
      if (N3 = !0, _ = { action: F, next: null }, A4 === null && (A4 = /* @__PURE__ */ new Map()), F = A4.get(N), F === void 0)
        A4.set(N, _);
      else {
        for (N = F; N.next !== null; )
          N = N.next;
        N.next = _;
      }
  }
  function z0() {
    throw Error(t(394));
  }
  function Q5() {
  }
  var T5 = { readContext: function(_) {
    return _._currentValue;
  }, useContext: function(_) {
    return D4(), _._currentValue;
  }, useMemo: Tt, useReducer: Qt, useRef: function(_) {
    H4 = D4(), N2 = U5();
    var N = N2.memoizedState;
    return N === null ? (_ = { current: _ }, N2.memoizedState = _) : N;
  }, useState: function(_) {
    return Qt(at, _);
  }, useInsertionEffect: Q5, useLayoutEffect: function() {
  }, useCallback: function(_, N) {
    return Tt(function() {
      return _;
    }, N);
  }, useImperativeHandle: Q5, useEffect: Q5, useDebugValue: Q5, useDeferredValue: function(_) {
    return D4(), _;
  }, useTransition: function() {
    return D4(), [!1, z0];
  }, useId: function() {
    var _ = O6.treeContext, N = _.overflow;
    _ = _.id, _ = (_ & ~(1 << 32 - _6(_) - 1)).toString(32) + N;
    var F = s5;
    if (F === null)
      throw Error(t(404));
    return N = U4++, _ = ":" + F.idPrefix + "R" + _, 0 < N && (_ += "H" + N.toString(32)), _ + ":";
  }, useMutableSource: function(_, N) {
    return D4(), N(_._source);
  }, useSyncExternalStore: function(_, N, F) {
    if (F === void 0)
      throw Error(t(407));
    return F();
  } }, s5 = null, A6 = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function U0(_) {
    return console.error(_), null;
  }
  function D6() {
  }
  function q5(_, N, F, K, p1, d1, b1, I1, e2) {
    var p2 = [], c2 = /* @__PURE__ */ new Set();
    return N = { destination: null, responseState: N, progressiveChunkSize: K === void 0 ? 12800 : K, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: c2, pingedTasks: p2, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: p1 === void 0 ? U0 : p1, onAllReady: d1 === void 0 ? D6 : d1, onShellReady: b1 === void 0 ? D6 : b1, onShellError: I1 === void 0 ? D6 : I1, onFatalError: e2 === void 0 ? D6 : e2 }, F = d6(N, 0, null, F, !1, !1), F.parentFlushed = !0, _ = J5(N, _, null, F, c2, z1, null, z4), p2.push(_), N;
  }
  function J5(_, N, F, K, p1, d1, b1, I1) {
    _.allPendingTasks++, F === null ? _.pendingRootTasks++ : F.pendingTasks++;
    var e2 = { node: N, ping: function() {
      var p2 = _.pingedTasks;
      p2.push(e2), p2.length === 1 && dt(_);
    }, blockedBoundary: F, blockedSegment: K, abortSet: p1, legacyContext: d1, context: b1, treeContext: I1 };
    return p1.add(e2), e2;
  }
  function d6(_, N, F, K, p1, d1) {
    return { status: 0, id: -1, index: N, parentFlushed: !1, chunks: [], children: [], formatContext: K, boundary: F, lastPushedText: p1, textEmbedded: d1 };
  }
  function h6(_, N) {
    if (_ = _.onError(N), _ != null && typeof _ != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof _ + '" instead');
    return _;
  }
  function l5(_, N) {
    var F = _.onShellError;
    F(N), F = _.onFatalError, F(N), _.destination !== null ? (_.status = 2, u(_.destination, N)) : (_.status = 1, _.fatalError = N);
  }
  function st(_, N, F, K, p1) {
    for (H4 = {}, O6 = N, U4 = 0, _ = F(K, p1); N3; )
      N3 = !1, U4 = 0, a5 += 1, N2 = null, _ = F(K, p1);
    return X5(), _;
  }
  function Y5(_, N, F, K) {
    var p1 = F.render(), d1 = K.childContextTypes;
    if (d1 != null) {
      var b1 = N.legacyContext;
      if (typeof F.getChildContext != "function")
        K = b1;
      else {
        F = F.getChildContext();
        for (var I1 in F)
          if (!(I1 in d1))
            throw Error(t(108, k1(K) || "Unknown", I1));
        K = a4({}, b1, F);
      }
      N.legacyContext = K, P3(_, N, p1), N.legacyContext = b1;
    } else
      P3(_, N, p1);
  }
  function lt(_, N) {
    if (_ && _.defaultProps) {
      N = a4({}, N), _ = _.defaultProps;
      for (var F in _)
        N[F] === void 0 && (N[F] = _[F]);
      return N;
    }
    return N;
  }
  function u5(_, N, F, K, p1) {
    if (typeof F == "function")
      if (F.prototype && F.prototype.isReactComponent) {
        p1 = K1(F, N.legacyContext);
        var d1 = F.contextType;
        d1 = new F(K, typeof d1 == "object" && d1 !== null ? d1._currentValue : p1), _4(d1, F, K, p1), Y5(_, N, d1, F);
      } else {
        d1 = K1(F, N.legacyContext), p1 = st(_, N, F, K, d1);
        var b1 = U4 !== 0;
        if (typeof p1 == "object" && p1 !== null && typeof p1.render == "function" && p1.$$typeof === void 0)
          _4(p1, F, K, d1), Y5(_, N, p1, F);
        else if (b1) {
          K = N.treeContext, N.treeContext = x4(K, 1, 0);
          try {
            P3(_, N, p1);
          } finally {
            N.treeContext = K;
          }
        } else
          P3(_, N, p1);
      }
    else if (typeof F == "string") {
      switch (p1 = N.blockedSegment, d1 = A3(p1.chunks, F, K, _.responseState, p1.formatContext), p1.lastPushedText = !1, b1 = p1.formatContext, p1.formatContext = L1(b1, F, K), c5(_, N, d1), p1.formatContext = b1, F) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          p1.chunks.push(g1, s(F), S1);
      }
      p1.lastPushedText = !1;
    } else {
      switch (F) {
        case h1:
        case Y:
        case S6:
        case C6:
        case C4:
          P3(_, N, K.children);
          return;
        case c6:
          P3(_, N, K.children);
          return;
        case W:
          throw Error(t(343));
        case u6:
          e: {
            F = N.blockedBoundary, p1 = N.blockedSegment, d1 = K.fallback, K = K.children, b1 = /* @__PURE__ */ new Set();
            var I1 = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: b1, errorDigest: null }, e2 = d6(_, p1.chunks.length, I1, p1.formatContext, !1, !1);
            p1.children.push(e2), p1.lastPushedText = !1;
            var p2 = d6(_, 0, null, p1.formatContext, !1, !1);
            p2.parentFlushed = !0, N.blockedBoundary = I1, N.blockedSegment = p2;
            try {
              if (c5(
                _,
                N,
                K
              ), p2.lastPushedText && p2.textEmbedded && p2.chunks.push(C1), p2.status = 1, f5(I1, p2), I1.pendingTasks === 0)
                break e;
            } catch (c2) {
              p2.status = 4, I1.forceClientRender = !0, I1.errorDigest = h6(_, c2);
            } finally {
              N.blockedBoundary = F, N.blockedSegment = p1;
            }
            N = J5(_, d1, F, e2, b1, N.legacyContext, N.context, N.treeContext), _.pingedTasks.push(N);
          }
          return;
      }
      if (typeof F == "object" && F !== null)
        switch (F.$$typeof) {
          case V6:
            if (K = st(_, N, F.render, K, p1), U4 !== 0) {
              F = N.treeContext, N.treeContext = x4(F, 1, 0);
              try {
                P3(_, N, K);
              } finally {
                N.treeContext = F;
              }
            } else
              P3(_, N, K);
            return;
          case V:
            F = F.type, K = lt(F, K), u5(_, N, F, K, p1);
            return;
          case l6:
            if (p1 = K.children, F = F._context, K = K.value, d1 = F._currentValue, F._currentValue = K, b1 = q1, q1 = K = { parent: b1, depth: b1 === null ? 0 : b1.depth + 1, context: F, parentValue: d1, value: K }, N.context = K, P3(_, N, p1), _ = q1, _ === null)
              throw Error(t(403));
            K = _.parentValue, _.context._currentValue = K === c1 ? _.context._defaultValue : K, _ = q1 = _.parent, N.context = _;
            return;
          case V4:
            K = K.children, K = K(F._currentValue), P3(_, N, K);
            return;
          case R:
            p1 = F._init, F = p1(F._payload), K = lt(F, K), u5(_, N, F, K, void 0);
            return;
        }
      throw Error(t(
        130,
        F == null ? F : typeof F,
        ""
      ));
    }
  }
  function P3(_, N, F) {
    if (N.node = F, typeof F == "object" && F !== null) {
      switch (F.$$typeof) {
        case O3:
          u5(_, N, F.type, F.props, F.ref);
          return;
        case y4:
          throw Error(t(257));
        case R:
          var K = F._init;
          F = K(F._payload), P3(_, N, F);
          return;
      }
      if ($(F)) {
        ut(_, N, F);
        return;
      }
      if (F === null || typeof F != "object" ? K = null : (K = y1 && F[y1] || F["@@iterator"], K = typeof K == "function" ? K : null), K && (K = K.call(F))) {
        if (F = K.next(), !F.done) {
          var p1 = [];
          do
            p1.push(F.value), F = K.next();
          while (!F.done);
          ut(_, N, p1);
        }
        return;
      }
      throw _ = Object.prototype.toString.call(F), Error(t(31, _ === "[object Object]" ? "object with keys {" + Object.keys(F).join(", ") + "}" : _));
    }
    typeof F == "string" ? (K = N.blockedSegment, K.lastPushedText = q(N.blockedSegment.chunks, F, _.responseState, K.lastPushedText)) : typeof F == "number" && (K = N.blockedSegment, K.lastPushedText = q(N.blockedSegment.chunks, "" + F, _.responseState, K.lastPushedText));
  }
  function ut(_, N, F) {
    for (var K = F.length, p1 = 0; p1 < K; p1++) {
      var d1 = N.treeContext;
      N.treeContext = x4(d1, K, p1);
      try {
        c5(_, N, F[p1]);
      } finally {
        N.treeContext = d1;
      }
    }
  }
  function c5(_, N, F) {
    var K = N.blockedSegment.formatContext, p1 = N.legacyContext, d1 = N.context;
    try {
      return P3(_, N, F);
    } catch (e2) {
      if (X5(), typeof e2 == "object" && e2 !== null && typeof e2.then == "function") {
        F = e2;
        var b1 = N.blockedSegment, I1 = d6(_, b1.chunks.length, null, b1.formatContext, b1.lastPushedText, !0);
        b1.children.push(I1), b1.lastPushedText = !1, _ = J5(_, N.node, N.blockedBoundary, I1, N.abortSet, N.legacyContext, N.context, N.treeContext).ping, F.then(_, _), N.blockedSegment.formatContext = K, N.legacyContext = p1, N.context = d1, X3(d1);
      } else
        throw N.blockedSegment.formatContext = K, N.legacyContext = p1, N.context = d1, X3(d1), e2;
    }
  }
  function X0(_) {
    var N = _.blockedBoundary;
    _ = _.blockedSegment, _.status = 3, ft(this, N, _);
  }
  function ct(_, N, F) {
    var K = _.blockedBoundary;
    _.blockedSegment.status = 3, K === null ? (N.allPendingTasks--, N.status !== 2 && (N.status = 2, N.destination !== null && N.destination.close())) : (K.pendingTasks--, K.forceClientRender || (K.forceClientRender = !0, _ = F === void 0 ? Error(t(432)) : F, K.errorDigest = N.onError(_), K.parentFlushed && N.clientRenderedBoundaries.push(K)), K.fallbackAbortableTasks.forEach(function(p1) {
      return ct(p1, N, F);
    }), K.fallbackAbortableTasks.clear(), N.allPendingTasks--, N.allPendingTasks === 0 && (K = N.onAllReady, K()));
  }
  function f5(_, N) {
    if (N.chunks.length === 0 && N.children.length === 1 && N.children[0].boundary === null) {
      var F = N.children[0];
      F.id = N.id, F.parentFlushed = !0, F.status === 1 && f5(_, F);
    } else
      _.completedSegments.push(N);
  }
  function ft(_, N, F) {
    if (N === null) {
      if (F.parentFlushed) {
        if (_.completedRootSegment !== null)
          throw Error(t(389));
        _.completedRootSegment = F;
      }
      _.pendingRootTasks--, _.pendingRootTasks === 0 && (_.onShellError = D6, N = _.onShellReady, N());
    } else
      N.pendingTasks--, N.forceClientRender || (N.pendingTasks === 0 ? (F.parentFlushed && F.status === 1 && f5(N, F), N.parentFlushed && _.completedBoundaries.push(N), N.fallbackAbortableTasks.forEach(X0, _), N.fallbackAbortableTasks.clear()) : F.parentFlushed && F.status === 1 && (f5(N, F), N.completedSegments.length === 1 && N.parentFlushed && _.partialBoundaries.push(N)));
    _.allPendingTasks--, _.allPendingTasks === 0 && (_ = _.onAllReady, _());
  }
  function dt(_) {
    if (_.status !== 2) {
      var N = q1, F = A6.current;
      A6.current = T5;
      var K = s5;
      s5 = _.responseState;
      try {
        var p1 = _.pingedTasks, d1;
        for (d1 = 0; d1 < p1.length; d1++) {
          var b1 = p1[d1], I1 = _, e2 = b1.blockedSegment;
          if (e2.status === 0) {
            X3(b1.context);
            try {
              P3(I1, b1, b1.node), e2.lastPushedText && e2.textEmbedded && e2.chunks.push(C1), b1.abortSet.delete(b1), e2.status = 1, ft(I1, b1.blockedBoundary, e2);
            } catch (Y3) {
              if (X5(), typeof Y3 == "object" && Y3 !== null && typeof Y3.then == "function") {
                var p2 = b1.ping;
                Y3.then(p2, p2);
              } else {
                b1.abortSet.delete(b1), e2.status = 4;
                var c2 = b1.blockedBoundary, F2 = Y3, B3 = h6(I1, F2);
                if (c2 === null ? l5(I1, F2) : (c2.pendingTasks--, c2.forceClientRender || (c2.forceClientRender = !0, c2.errorDigest = B3, c2.parentFlushed && I1.clientRenderedBoundaries.push(c2))), I1.allPendingTasks--, I1.allPendingTasks === 0) {
                  var J3 = I1.onAllReady;
                  J3();
                }
              }
            } finally {
            }
          }
        }
        p1.splice(0, d1), _.destination !== null && K5(_, _.destination);
      } catch (Y3) {
        h6(_, Y3), l5(_, Y3);
      } finally {
        s5 = K, A6.current = F, F === T5 && X3(N);
      }
    }
  }
  function d5(_, N, F) {
    switch (F.parentFlushed = !0, F.status) {
      case 0:
        var K = F.id = _.nextSegmentId++;
        return F.lastPushedText = !1, F.textEmbedded = !1, _ = _.responseState, i(N, G), i(N, _.placeholderPrefix), _ = s(K.toString(16)), i(N, _), o(N, u2);
      case 1:
        F.status = 2;
        var p1 = !0;
        K = F.chunks;
        var d1 = 0;
        F = F.children;
        for (var b1 = 0; b1 < F.length; b1++) {
          for (p1 = F[b1]; d1 < p1.index; d1++)
            i(N, K[d1]);
          p1 = h5(_, N, p1);
        }
        for (; d1 < K.length - 1; d1++)
          i(N, K[d1]);
        return d1 < K.length && (p1 = o(N, K[d1])), p1;
      default:
        throw Error(t(390));
    }
  }
  function h5(_, N, F) {
    var K = F.boundary;
    if (K === null)
      return d5(_, N, F);
    if (K.parentFlushed = !0, K.forceClientRender)
      K = K.errorDigest, o(N, l3), i(N, D3), K && (i(N, V3), i(N, s(S(K))), i(N, $2)), o(N, y3), d5(_, N, F);
    else if (0 < K.pendingTasks) {
      K.rootSegmentID = _.nextSegmentId++, 0 < K.completedSegments.length && _.partialBoundaries.push(K);
      var p1 = _.responseState, d1 = p1.nextSuspenseID++;
      p1 = Q(p1.boundaryPrefix + d1.toString(16)), K = K.id = p1, u3(N, _.responseState, K), d5(_, N, F);
    } else if (K.byteSize > _.progressiveChunkSize)
      K.rootSegmentID = _.nextSegmentId++, _.completedBoundaries.push(K), u3(N, _.responseState, K.id), d5(_, N, F);
    else {
      if (o(N, L2), F = K.completedSegments, F.length !== 1)
        throw Error(t(391));
      h5(_, N, F[0]);
    }
    return o(N, z3);
  }
  function ht(_, N, F) {
    return h2(N, _.responseState, F.formatContext, F.id), h5(_, N, F), v2(N, F.formatContext);
  }
  function pt(_, N, F) {
    for (var K = F.completedSegments, p1 = 0; p1 < K.length; p1++)
      mt(_, N, F, K[p1]);
    if (K.length = 0, _ = _.responseState, K = F.id, F = F.rootSegmentID, i(N, _.startInlineScript), _.sentCompleteBoundaryFunction ? i(N, U2) : (_.sentCompleteBoundaryFunction = !0, i(N, S2)), K === null)
      throw Error(t(395));
    return F = s(F.toString(16)), i(N, K), i(N, _3), i(N, _.segmentPrefix), i(N, F), o(N, n4);
  }
  function mt(_, N, F, K) {
    if (K.status === 2)
      return !0;
    var p1 = K.id;
    if (p1 === -1) {
      if ((K.id = F.rootSegmentID) === -1)
        throw Error(t(392));
      return ht(_, N, K);
    }
    return ht(_, N, K), _ = _.responseState, i(N, _.startInlineScript), _.sentCompleteSegmentFunction ? i(N, s2) : (_.sentCompleteSegmentFunction = !0, i(N, m2)), i(N, _.segmentPrefix), p1 = s(p1.toString(16)), i(N, p1), i(N, K2), i(N, _.placeholderPrefix), i(N, p1), o(N, w2);
  }
  function K5(_, N) {
    r = new Uint8Array(512), n = 0;
    try {
      var F = _.completedRootSegment;
      if (F !== null && _.pendingRootTasks === 0) {
        h5(_, N, F), _.completedRootSegment = null;
        var K = _.responseState.bootstrapChunks;
        for (F = 0; F < K.length - 1; F++)
          i(N, K[F]);
        F < K.length && o(N, K[F]);
      }
      var p1 = _.clientRenderedBoundaries, d1;
      for (d1 = 0; d1 < p1.length; d1++) {
        var b1 = p1[d1];
        K = N;
        var I1 = _.responseState, e2 = b1.id, p2 = b1.errorDigest, c2 = b1.errorMessage, F2 = b1.errorComponentStack;
        if (i(K, I1.startInlineScript), I1.sentClientRenderFunction ? i(K, t3) : (I1.sentClientRenderFunction = !0, i(
          K,
          e3
        )), e2 === null)
          throw Error(t(395));
        i(K, e2), i(K, i4), (p2 || c2 || F2) && (i(K, d3), i(K, s(o4(p2 || "")))), (c2 || F2) && (i(K, d3), i(K, s(o4(c2 || "")))), F2 && (i(K, d3), i(K, s(o4(F2)))), o(K, U3);
      }
      p1.splice(0, d1);
      var B3 = _.completedBoundaries;
      for (d1 = 0; d1 < B3.length; d1++)
        pt(_, N, B3[d1]);
      B3.splice(0, d1), a(N), r = new Uint8Array(512), n = 0;
      var J3 = _.partialBoundaries;
      for (d1 = 0; d1 < J3.length; d1++) {
        var Y3 = J3[d1];
        e: {
          p1 = _, b1 = N;
          var p5 = Y3.completedSegments;
          for (I1 = 0; I1 < p5.length; I1++)
            if (!mt(
              p1,
              b1,
              Y3,
              p5[I1]
            )) {
              I1++, p5.splice(0, I1);
              var Lt = !1;
              break e;
            }
          p5.splice(0, I1), Lt = !0;
        }
        if (!Lt) {
          _.destination = null, d1++, J3.splice(0, d1);
          return;
        }
      }
      J3.splice(0, d1);
      var ee = _.completedBoundaries;
      for (d1 = 0; d1 < ee.length; d1++)
        pt(_, N, ee[d1]);
      ee.splice(0, d1);
    } finally {
      a(N), _.allPendingTasks === 0 && _.pingedTasks.length === 0 && _.clientRenderedBoundaries.length === 0 && _.completedBoundaries.length === 0 && N.close();
    }
  }
  function vt(_, N) {
    try {
      var F = _.abortableTasks;
      F.forEach(function(K) {
        return ct(K, _, N);
      }), F.clear(), _.destination !== null && K5(_, _.destination);
    } catch (K) {
      h6(_, K), l5(_, K);
    }
  }
  return Fn.renderToReadableStream = function(_, N) {
    return new Promise(function(F, K) {
      var p1, d1, b1 = new Promise(function(c2, F2) {
        d1 = c2, p1 = F2;
      }), I1 = q5(_, f1(N ? N.identifierPrefix : void 0, N ? N.nonce : void 0, N ? N.bootstrapScriptContent : void 0, N ? N.bootstrapScripts : void 0, N ? N.bootstrapModules : void 0), Z(N ? N.namespaceURI : void 0), N ? N.progressiveChunkSize : void 0, N ? N.onError : void 0, d1, function() {
        var c2 = new ReadableStream({ type: "bytes", pull: function(F2) {
          if (I1.status === 1)
            I1.status = 2, u(F2, I1.fatalError);
          else if (I1.status !== 2 && I1.destination === null) {
            I1.destination = F2;
            try {
              K5(I1, F2);
            } catch (B3) {
              h6(I1, B3), l5(I1, B3);
            }
          }
        }, cancel: function() {
          vt(I1);
        } }, { highWaterMark: 0 });
        c2.allReady = b1, F(c2);
      }, function(c2) {
        b1.catch(function() {
        }), K(c2);
      }, p1);
      if (N && N.signal) {
        var e2 = N.signal, p2 = function() {
          vt(I1, e2.reason), e2.removeEventListener("abort", p2);
        };
        e2.addEventListener("abort", p2);
      }
      dt(I1);
    });
  }, Fn.version = "18.2.0", Fn;
}
var Ae = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uf;
function B_() {
  return Uf || (Uf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = y, t = "18.2.0", r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(h) {
      {
        for (var g = arguments.length, O = new Array(g > 1 ? g - 1 : 0), I = 1; I < g; I++)
          O[I - 1] = arguments[I];
        o("warn", h, O);
      }
    }
    function i(h) {
      {
        for (var g = arguments.length, O = new Array(g > 1 ? g - 1 : 0), I = 1; I < g; I++)
          O[I - 1] = arguments[I];
        o("error", h, O);
      }
    }
    function o(h, g, O) {
      {
        var I = r.ReactDebugCurrentFrame, B = I.getStackAddendum();
        B !== "" && (g += "%s", O = O.concat([B]));
        var e1 = O.map(function(o1) {
          return String(o1);
        });
        e1.unshift("Warning: " + g), Function.prototype.apply.call(console[h], console, e1);
      }
    }
    function a(h) {
      h();
    }
    function T(h) {
    }
    function s(h, g) {
      Q(h, g);
    }
    function Q(h, g) {
      return h.push(g);
    }
    function u(h) {
    }
    function l(h) {
      h.push(null);
    }
    function c(h) {
      return h;
    }
    function f(h) {
      return h;
    }
    function d(h, g) {
      h.destroy(g);
    }
    function m(h) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, O = g && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return O;
      }
    }
    function p(h) {
      try {
        return v(h), !1;
      } catch {
        return !0;
      }
    }
    function v(h) {
      return "" + h;
    }
    function H(h, g) {
      if (p(h))
        return i("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", g, m(h)), v(h);
    }
    function E(h, g) {
      if (p(h))
        return i("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", g, m(h)), v(h);
    }
    function M(h) {
      if (p(h))
        return i("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", m(h)), v(h);
    }
    var C = Object.prototype.hasOwnProperty, w = 0, S = 1, D = 2, k = 3, $ = 4, z = 5, j = 6, J = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", i1 = J + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", t1 = new RegExp("^[" + J + "][" + i1 + "]*$"), T1 = {}, X = {};
    function f1(h) {
      return C.call(X, h) ? !0 : C.call(T1, h) ? !1 : t1.test(h) ? (X[h] = !0, !0) : (T1[h] = !0, i("Invalid attribute name: `%s`", h), !1);
    }
    function s1(h, g, O, I) {
      if (O !== null && O.type === w)
        return !1;
      switch (typeof g) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (I)
            return !1;
          if (O !== null)
            return !O.acceptsBooleans;
          var B = h.toLowerCase().slice(0, 5);
          return B !== "data-" && B !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Z(h) {
      return C1.hasOwnProperty(h) ? C1[h] : null;
    }
    function L1(h, g, O, I, B, e1, o1) {
      this.acceptsBooleans = g === D || g === k || g === $, this.attributeName = I, this.attributeNamespace = B, this.mustUseProperty = O, this.propertyName = h, this.type = g, this.sanitizeURL = e1, this.removeEmptyString = o1;
    }
    var C1 = {}, q = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    q.forEach(function(h) {
      C1[h] = new L1(
        h,
        w,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(h) {
      var g = h[0], O = h[1];
      C1[g] = new L1(
        g,
        S,
        !1,
        // mustUseProperty
        O,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(h) {
      C1[h] = new L1(
        h,
        D,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(h) {
      C1[h] = new L1(
        h,
        D,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(h) {
      C1[h] = new L1(
        h,
        k,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      C1[h] = new L1(
        h,
        k,
        !0,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      C1[h] = new L1(
        h,
        $,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      C1[h] = new L1(
        h,
        j,
        !1,
        // mustUseProperty
        h,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(h) {
      C1[h] = new L1(
        h,
        z,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var N1 = /[\-\:]([a-z])/g, O1 = function(h) {
      return h[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      var g = h.replace(N1, O1);
      C1[g] = new L1(
        g,
        S,
        !1,
        // mustUseProperty
        h,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      var g = h.replace(N1, O1);
      C1[g] = new L1(
        g,
        S,
        !1,
        // mustUseProperty
        h,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(h) {
      var g = h.replace(N1, O1);
      C1[g] = new L1(
        g,
        S,
        !1,
        // mustUseProperty
        h,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(h) {
      C1[h] = new L1(
        h,
        S,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var x1 = "xlinkHref";
    C1[x1] = new L1(
      "xlinkHref",
      S,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(h) {
      C1[h] = new L1(
        h,
        S,
        !1,
        // mustUseProperty
        h.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var l1 = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function u1(h, g) {
      return h + g.charAt(0).toUpperCase() + g.substring(1);
    }
    var H1 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(l1).forEach(function(h) {
      H1.forEach(function(g) {
        l1[u1(g, h)] = l1[h];
      });
    });
    var D1 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function w1(h, g) {
      D1[g.type] || g.onChange || g.onInput || g.readOnly || g.disabled || g.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), g.onChange || g.readOnly || g.disabled || g.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function E1(h, g) {
      if (h.indexOf("-") === -1)
        return typeof g.is == "string";
      switch (h) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var A1 = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, R1 = {}, Z1 = new RegExp("^(aria)-[" + i1 + "]*$"), r2 = new RegExp("^(aria)[A-Z][" + i1 + "]*$");
    function I2(h, g) {
      {
        if (C.call(R1, g) && R1[g])
          return !0;
        if (r2.test(g)) {
          var O = "aria-" + g.slice(4).toLowerCase(), I = A1.hasOwnProperty(O) ? O : null;
          if (I == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", g), R1[g] = !0, !0;
          if (g !== I)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", g, I), R1[g] = !0, !0;
        }
        if (Z1.test(g)) {
          var B = g.toLowerCase(), e1 = A1.hasOwnProperty(B) ? B : null;
          if (e1 == null)
            return R1[g] = !0, !1;
          if (g !== e1)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", g, e1), R1[g] = !0, !0;
        }
      }
      return !0;
    }
    function X1(h, g) {
      {
        var O = [];
        for (var I in g) {
          var B = I2(h, I);
          B || O.push(I);
        }
        var e1 = O.map(function(o1) {
          return "`" + o1 + "`";
        }).join(", ");
        O.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", e1, h) : O.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", e1, h);
      }
    }
    function x2(h, g) {
      E1(h, g) || X1(h, g);
    }
    var R2 = !1;
    function f3(h, g) {
      {
        if (h !== "input" && h !== "textarea" && h !== "select")
          return;
        g != null && g.value === null && !R2 && (R2 = !0, h === "select" && g.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", h) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", h));
      }
    }
    var q2 = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, V2 = function() {
    };
    {
      var n2 = {}, A3 = /^on./, g1 = /^on[^A-Z]/, S1 = new RegExp("^(aria)-[" + i1 + "]*$"), G = new RegExp("^(aria)[A-Z][" + i1 + "]*$");
      V2 = function(h, g, O, I) {
        if (C.call(n2, g) && n2[g])
          return !0;
        var B = g.toLowerCase();
        if (B === "onfocusin" || B === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), n2[g] = !0, !0;
        if (I != null) {
          var e1 = I.registrationNameDependencies, o1 = I.possibleRegistrationNames;
          if (e1.hasOwnProperty(g))
            return !0;
          var m1 = o1.hasOwnProperty(B) ? o1[B] : null;
          if (m1 != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", g, m1), n2[g] = !0, !0;
          if (A3.test(g))
            return i("Unknown event handler property `%s`. It will be ignored.", g), n2[g] = !0, !0;
        } else if (A3.test(g))
          return g1.test(g) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", g), n2[g] = !0, !0;
        if (S1.test(g) || G.test(g))
          return !0;
        if (B === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), n2[g] = !0, !0;
        if (B === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), n2[g] = !0, !0;
        if (B === "is" && O !== null && O !== void 0 && typeof O != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof O), n2[g] = !0, !0;
        if (typeof O == "number" && isNaN(O))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", g), n2[g] = !0, !0;
        var V1 = Z(g), $1 = V1 !== null && V1.type === w;
        if (q2.hasOwnProperty(B)) {
          var U1 = q2[B];
          if (U1 !== g)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", g, U1), n2[g] = !0, !0;
        } else if (!$1 && g !== B)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", g, B), n2[g] = !0, !0;
        return typeof O == "boolean" && s1(g, O, V1, !1) ? (O ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', O, g, g, O, g) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', O, g, g, O, g, g, g), n2[g] = !0, !0) : $1 ? !0 : s1(g, O, V1, !1) ? (n2[g] = !0, !1) : ((O === "false" || O === "true") && V1 !== null && V1.type === k && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", O, g, O === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', g, O), n2[g] = !0), !0);
      };
    }
    var u2 = function(h, g, O) {
      {
        var I = [];
        for (var B in g) {
          var e1 = V2(h, B, g[B], O);
          e1 || I.push(B);
        }
        var o1 = I.map(function(m1) {
          return "`" + m1 + "`";
        }).join(", ");
        I.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", o1, h) : I.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", o1, h);
      }
    };
    function L2(h, g, O) {
      E1(h, g) || u2(h, g, O);
    }
    var J2 = function() {
    };
    {
      var C3 = /^(?:webkit|moz|o)[A-Z]/, l3 = /^-ms-/, z3 = /-(.)/g, D3 = /;\s*$/, $2 = {}, V3 = {}, y3 = !1, u3 = !1, k3 = function(h) {
        return h.replace(z3, function(g, O) {
          return O.toUpperCase();
        });
      }, x3 = function(h) {
        $2.hasOwnProperty(h) && $2[h] || ($2[h] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          h,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          k3(h.replace(l3, "ms-"))
        ));
      }, H2 = function(h) {
        $2.hasOwnProperty(h) && $2[h] || ($2[h] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", h, h.charAt(0).toUpperCase() + h.slice(1)));
      }, j3 = function(h, g) {
        V3.hasOwnProperty(g) && V3[g] || (V3[g] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, h, g.replace(D3, "")));
      }, v4 = function(h, g) {
        y3 || (y3 = !0, i("`NaN` is an invalid value for the `%s` css style property.", h));
      }, L4 = function(h, g) {
        u3 || (u3 = !0, i("`Infinity` is an invalid value for the `%s` css style property.", h));
      };
      J2 = function(h, g) {
        h.indexOf("-") > -1 ? x3(h) : C3.test(h) ? H2(h) : D3.test(g) && j3(h, g), typeof g == "number" && (isNaN(g) ? v4(h, g) : isFinite(g) || L4(h, g));
      };
    }
    var I3 = J2, S4 = /["'&<>]/;
    function $3(h) {
      M(h);
      var g = "" + h, O = S4.exec(g);
      if (!O)
        return g;
      var I, B = "", e1, o1 = 0;
      for (e1 = O.index; e1 < g.length; e1++) {
        switch (g.charCodeAt(e1)) {
          case 34:
            I = "&quot;";
            break;
          case 38:
            I = "&amp;";
            break;
          case 39:
            I = "&#x27;";
            break;
          case 60:
            I = "&lt;";
            break;
          case 62:
            I = "&gt;";
            break;
          default:
            continue;
        }
        o1 !== e1 && (B += g.substring(o1, e1)), o1 = e1 + 1, B += I;
      }
      return o1 !== e1 ? B + g.substring(o1, e1) : B;
    }
    function Z2(h) {
      return typeof h == "boolean" || typeof h == "number" ? "" + h : $3(h);
    }
    var $4 = /([A-Z])/g, Z4 = /^ms-/;
    function W4(h) {
      return h.replace($4, "-$1").toLowerCase().replace(Z4, "-ms-");
    }
    var Y2 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, G4 = !1;
    function M6(h) {
      !G4 && Y2.test(h) && (G4 = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(h)));
    }
    var w6 = Array.isArray;
    function n1(h) {
      return w6(h);
    }
    var _1 = "<script>", P1 = "<\/script>", J1 = '<script src="', h2 = '<script type="module" src="', v2 = '" async=""><\/script>';
    function m2(h) {
      return M(h), ("" + h).replace(s2, K2);
    }
    var s2 = /(<\/|<)(s)(cript)/gi, K2 = function(h, g, O, I) {
      return "" + g + (O === "s" ? "\\u0073" : "\\u0053") + I;
    };
    function w2(h, g, O, I, B) {
      var e1 = h === void 0 ? "" : h, o1 = g === void 0 ? _1 : '<script nonce="' + Z2(g) + '">', m1 = [];
      if (O !== void 0 && m1.push(o1, m2(O), P1), I !== void 0)
        for (var V1 = 0; V1 < I.length; V1++)
          m1.push(J1, Z2(I[V1]), v2);
      if (B !== void 0)
        for (var $1 = 0; $1 < B.length; $1++)
          m1.push(h2, Z2(B[$1]), v2);
      return {
        bootstrapChunks: m1,
        startInlineScript: o1,
        placeholderPrefix: e1 + "P:",
        segmentPrefix: e1 + "S:",
        boundaryPrefix: e1 + "B:",
        idPrefix: e1,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var S2 = 0, U2 = 1, _3 = 2, n4 = 3, e3 = 4, t3 = 5, i4 = 6, U3 = 7;
    function d3(h, g) {
      return {
        insertionMode: h,
        selectedValue: g
      };
    }
    function s6(h, g, O) {
      switch (g) {
        case "select":
          return d3(U2, O.value != null ? O.value : O.defaultValue);
        case "svg":
          return d3(_3, null);
        case "math":
          return d3(n4, null);
        case "foreignObject":
          return d3(U2, null);
        case "table":
          return d3(e3, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return d3(t3, null);
        case "colgroup":
          return d3(U3, null);
        case "tr":
          return d3(i4, null);
      }
      return h.insertionMode >= e3 || h.insertionMode === S2 ? d3(U2, null) : h;
    }
    var o4 = null;
    function a4(h) {
      var g = h.nextSuspenseID++;
      return h.boundaryPrefix + g.toString(16);
    }
    function O3(h, g, O) {
      var I = h.idPrefix, B = ":" + I + "R" + g;
      return O > 0 && (B += "H" + O.toString(32)), B + ":";
    }
    function y4(h) {
      return Z2(h);
    }
    var C4 = "<!-- -->";
    function S6(h, g, O, I) {
      return g === "" ? I : (I && h.push(C4), h.push(y4(g)), !0);
    }
    function C6(h, g, O, I) {
      O && I && h.push(C4);
    }
    var l6 = /* @__PURE__ */ new Map();
    function V4(h) {
      var g = l6.get(h);
      if (g !== void 0)
        return g;
      var O = Z2(W4(h));
      return l6.set(h, O), O;
    }
    var V6 = ' style="', u6 = ":", c6 = ";";
    function V(h, g, O) {
      if (typeof O != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var I = !0;
      for (var B in O)
        if (C.call(O, B)) {
          var e1 = O[B];
          if (!(e1 == null || typeof e1 == "boolean" || e1 === "")) {
            var o1 = void 0, m1 = void 0, V1 = B.indexOf("--") === 0;
            V1 ? (o1 = Z2(B), E(e1, B), m1 = Z2(("" + e1).trim())) : (I3(B, e1), o1 = V4(B), typeof e1 == "number" ? e1 !== 0 && !C.call(l1, B) ? m1 = e1 + "px" : m1 = "" + e1 : (E(e1, B), m1 = Z2(("" + e1).trim()))), I ? (I = !1, h.push(V6, o1, u6, m1)) : h.push(c6, o1, u6, m1);
          }
        }
      I || h.push(Y);
    }
    var R = " ", W = '="', Y = '"', h1 = '=""';
    function c1(h, g, O, I) {
      switch (O) {
        case "style": {
          V(h, g, I);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(O.length > 2 && (O[0] === "o" || O[0] === "O") && (O[1] === "n" || O[1] === "N"))
      ) {
        var B = Z(O);
        if (B !== null) {
          switch (typeof I) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!B.acceptsBooleans)
                return;
          }
          var e1 = B.attributeName, o1 = e1;
          switch (B.type) {
            case k:
              I && h.push(R, o1, h1);
              return;
            case $:
              I === !0 ? h.push(R, o1, h1) : I === !1 || h.push(R, o1, W, Z2(I), Y);
              return;
            case z:
              isNaN(I) || h.push(R, o1, W, Z2(I), Y);
              break;
            case j:
              !isNaN(I) && I >= 1 && h.push(R, o1, W, Z2(I), Y);
              break;
            default:
              B.sanitizeURL && (H(I, e1), I = "" + I, M6(I)), h.push(R, o1, W, Z2(I), Y);
          }
        } else if (f1(O)) {
          switch (typeof I) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var m1 = O.toLowerCase().slice(0, 5);
              if (m1 !== "data-" && m1 !== "aria-")
                return;
            }
          }
          h.push(R, O, W, Z2(I), Y);
        }
      }
    }
    var y1 = ">", k1 = "/>";
    function z1(h, g, O) {
      if (g != null) {
        if (O != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof g != "object" || !("__html" in g))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var I = g.__html;
        I != null && (M(I), h.push("" + I));
      }
    }
    var K1 = !1, q1 = !1, E2 = !1, R3 = !1, H3 = !1, E3 = !1, g4 = !1;
    function X3(h, g) {
      {
        var O = h[g];
        if (O != null) {
          var I = n1(O);
          h.multiple && !I ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", g) : !h.multiple && I && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", g);
        }
      }
    }
    function f6(h, g, O) {
      w1("select", g), X3(g, "value"), X3(g, "defaultValue"), g.value !== void 0 && g.defaultValue !== void 0 && !E2 && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), E2 = !0), h.push(N3("select"));
      var I = null, B = null;
      for (var e1 in g)
        if (C.call(g, e1)) {
          var o1 = g[e1];
          if (o1 == null)
            continue;
          switch (e1) {
            case "children":
              I = o1;
              break;
            case "dangerouslySetInnerHTML":
              B = o1;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              c1(h, O, e1, o1);
              break;
          }
        }
      return h.push(y1), z1(h, B, I), I;
    }
    function _4(h) {
      var g = "";
      return e.Children.forEach(h, function(O) {
        O != null && (g += O, !H3 && typeof O != "string" && typeof O != "number" && (H3 = !0, i("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), g;
    }
    var z4 = ' selected=""';
    function x4(h, g, O, I) {
      var B = I.selectedValue;
      h.push(N3("option"));
      var e1 = null, o1 = null, m1 = null, V1 = null;
      for (var $1 in g)
        if (C.call(g, $1)) {
          var U1 = g[$1];
          if (U1 == null)
            continue;
          switch ($1) {
            case "children":
              e1 = U1;
              break;
            case "selected":
              m1 = U1, g4 || (i("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), g4 = !0);
              break;
            case "dangerouslySetInnerHTML":
              V1 = U1;
              break;
            case "value":
              o1 = U1;
            default:
              c1(h, O, $1, U1);
              break;
          }
        }
      if (B != null) {
        var Q2;
        if (o1 !== null ? (H(o1, "value"), Q2 = "" + o1) : (V1 !== null && (E3 || (E3 = !0, i("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), Q2 = _4(e1)), n1(B))
          for (var X2 = 0; X2 < B.length; X2++) {
            H(B[X2], "value");
            var M3 = "" + B[X2];
            if (M3 === Q2) {
              h.push(z4);
              break;
            }
          }
        else
          H(B, "select.value"), "" + B === Q2 && h.push(z4);
      } else
        m1 && h.push(z4);
      return h.push(y1), z1(h, V1, e1), e1;
    }
    function _6(h, g, O) {
      w1("input", g), g.checked !== void 0 && g.defaultChecked !== void 0 && !q1 && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", g.type), q1 = !0), g.value !== void 0 && g.defaultValue !== void 0 && !K1 && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", g.type), K1 = !0), h.push(N3("input"));
      var I = null, B = null, e1 = null, o1 = null;
      for (var m1 in g)
        if (C.call(g, m1)) {
          var V1 = g[m1];
          if (V1 == null)
            continue;
          switch (m1) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              o1 = V1;
              break;
            case "defaultValue":
              B = V1;
              break;
            case "checked":
              e1 = V1;
              break;
            case "value":
              I = V1;
              break;
            default:
              c1(h, O, m1, V1);
              break;
          }
        }
      return e1 !== null ? c1(h, O, "checked", e1) : o1 !== null && c1(h, O, "checked", o1), I !== null ? c1(h, O, "value", I) : B !== null && c1(h, O, "value", B), h.push(k1), null;
    }
    function $0(h, g, O) {
      w1("textarea", g), g.value !== void 0 && g.defaultValue !== void 0 && !R3 && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), R3 = !0), h.push(N3("textarea"));
      var I = null, B = null, e1 = null;
      for (var o1 in g)
        if (C.call(g, o1)) {
          var m1 = g[o1];
          if (m1 == null)
            continue;
          switch (o1) {
            case "children":
              e1 = m1;
              break;
            case "value":
              I = m1;
              break;
            case "defaultValue":
              B = m1;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              c1(h, O, o1, m1);
              break;
          }
        }
      if (I === null && B !== null && (I = B), h.push(y1), e1 != null) {
        if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), I != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (n1(e1)) {
          if (e1.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          M(e1[0]), I = "" + e1[0];
        }
        M(e1), I = "" + e1;
      }
      return typeof I == "string" && I[0] === `
` && h.push(O6), I !== null && (H(I, "value"), h.push(y4("" + I))), null;
    }
    function Z0(h, g, O, I) {
      h.push(N3(O));
      for (var B in g)
        if (C.call(g, B)) {
          var e1 = g[B];
          if (e1 == null)
            continue;
          switch (B) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(O + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              c1(h, I, B, e1);
              break;
          }
        }
      return h.push(k1), null;
    }
    function G5(h, g, O) {
      h.push(N3("menuitem"));
      for (var I in g)
        if (C.call(g, I)) {
          var B = g[I];
          if (B == null)
            continue;
          switch (I) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              c1(h, O, I, B);
              break;
          }
        }
      return h.push(y1), null;
    }
    function W0(h, g, O) {
      h.push(N3("title"));
      var I = null;
      for (var B in g)
        if (C.call(g, B)) {
          var e1 = g[B];
          if (e1 == null)
            continue;
          switch (B) {
            case "children":
              I = e1;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              c1(h, O, B, e1);
              break;
          }
        }
      h.push(y1);
      {
        var o1 = Array.isArray(I) && I.length < 2 ? I[0] || null : I;
        Array.isArray(I) && I.length > 1 ? i("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : o1 != null && o1.$$typeof != null ? i("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : o1 != null && typeof o1 != "string" && typeof o1 != "number" && i("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return I;
    }
    function z5(h, g, O, I) {
      h.push(N3(O));
      var B = null, e1 = null;
      for (var o1 in g)
        if (C.call(g, o1)) {
          var m1 = g[o1];
          if (m1 == null)
            continue;
          switch (o1) {
            case "children":
              B = m1;
              break;
            case "dangerouslySetInnerHTML":
              e1 = m1;
              break;
            default:
              c1(h, I, o1, m1);
              break;
          }
        }
      return h.push(y1), z1(h, e1, B), typeof B == "string" ? (h.push(y4(B)), null) : B;
    }
    function H4(h, g, O, I) {
      h.push(N3(O));
      var B = null, e1 = null;
      for (var o1 in g)
        if (C.call(g, o1)) {
          var m1 = g[o1];
          if (m1 == null)
            continue;
          switch (o1) {
            case "children":
              B = m1;
              break;
            case "dangerouslySetInnerHTML":
              e1 = m1;
              break;
            case "style":
              V(h, I, m1);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              f1(o1) && typeof m1 != "function" && typeof m1 != "symbol" && h.push(R, o1, W, Z2(m1), Y);
              break;
          }
        }
      return h.push(y1), z1(h, e1, B), B;
    }
    var O6 = `
`;
    function o5(h, g, O, I) {
      h.push(N3(O));
      var B = null, e1 = null;
      for (var o1 in g)
        if (C.call(g, o1)) {
          var m1 = g[o1];
          if (m1 == null)
            continue;
          switch (o1) {
            case "children":
              B = m1;
              break;
            case "dangerouslySetInnerHTML":
              e1 = m1;
              break;
            default:
              c1(h, I, o1, m1);
              break;
          }
        }
      if (h.push(y1), e1 != null) {
        if (B != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof e1 != "object" || !("__html" in e1))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var V1 = e1.__html;
        V1 != null && (typeof V1 == "string" && V1.length > 0 && V1[0] === `
` ? h.push(O6, V1) : (M(V1), h.push("" + V1)));
      }
      return typeof B == "string" && B[0] === `
` && h.push(O6), B;
    }
    var N2 = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, O4 = /* @__PURE__ */ new Map();
    function N3(h) {
      var g = O4.get(h);
      if (g === void 0) {
        if (!N2.test(h))
          throw new Error("Invalid tag: " + h);
        g = "<" + h, O4.set(h, g);
      }
      return g;
    }
    var U4 = "<!DOCTYPE html>";
    function A4(h, g, O, I, B) {
      switch (x2(g, O), f3(g, O), L2(g, O, null), !O.suppressContentEditableWarning && O.contentEditable && O.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), B.insertionMode !== _3 && B.insertionMode !== n4 && g.indexOf("-") === -1 && typeof O.is != "string" && g.toLowerCase() !== g && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", g), g) {
        case "select":
          return f6(h, O, I);
        case "option":
          return x4(h, O, I, B);
        case "textarea":
          return $0(h, O, I);
        case "input":
          return _6(h, O, I);
        case "menuitem":
          return G5(h, O, I);
        case "title":
          return W0(h, O, I);
        case "listing":
        case "pre":
          return o5(h, O, g, I);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return Z0(h, O, g, I);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return z5(h, O, g, I);
        case "html":
          return B.insertionMode === S2 && h.push(U4), z5(h, O, g, I);
        default:
          return g.indexOf("-") === -1 && typeof O.is != "string" ? z5(h, O, g, I) : H4(h, O, g, I);
      }
    }
    var a5 = "</", D4 = ">";
    function q3(h, g, O) {
      switch (g) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          h.push(a5, g, D4);
      }
    }
    function U5(h, g) {
      for (var O = g.bootstrapChunks, I = 0; I < O.length - 1; I++)
        s(h, O[I]);
      return I < O.length ? Q(h, O[I]) : !0;
    }
    var X5 = '<template id="', at = '"></template>';
    function Qt(h, g, O) {
      s(h, X5), s(h, g.placeholderPrefix);
      var I = O.toString(16);
      return s(h, I), Q(h, at);
    }
    var Tt = "<!--$-->", G0 = '<!--$?--><template id="', z0 = '"></template>', Q5 = "<!--$!-->", T5 = "<!--/$-->", s5 = "<template", A6 = '"', U0 = ' data-dgst="', D6 = ' data-msg="', q5 = ' data-stck="', J5 = "></template>";
    function d6(h, g) {
      return Q(h, Tt);
    }
    function h6(h, g, O) {
      if (s(h, G0), O === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return s(h, O), Q(h, z0);
    }
    function l5(h, g, O, I, B) {
      var e1;
      return e1 = Q(h, Q5), s(h, s5), O && (s(h, U0), s(h, Z2(O)), s(h, A6)), I && (s(h, D6), s(h, Z2(I)), s(h, A6)), B && (s(h, q5), s(h, Z2(B)), s(h, A6)), e1 = Q(h, J5), e1;
    }
    function st(h, g) {
      return Q(h, T5);
    }
    function Y5(h, g) {
      return Q(h, T5);
    }
    function lt(h, g) {
      return Q(h, T5);
    }
    var u5 = '<div hidden id="', P3 = '">', ut = "</div>", c5 = '<svg aria-hidden="true" style="display:none" id="', X0 = '">', ct = "</svg>", f5 = '<math aria-hidden="true" style="display:none" id="', ft = '">', dt = "</math>", d5 = '<table hidden id="', h5 = '">', ht = "</table>", pt = '<table hidden><tbody id="', mt = '">', K5 = "</tbody></table>", vt = '<table hidden><tr id="', _ = '">', N = "</tr></table>", F = '<table hidden><colgroup id="', K = '">', p1 = "</colgroup></table>";
    function d1(h, g, O, I) {
      switch (O.insertionMode) {
        case S2:
        case U2:
          return s(h, u5), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, P3);
        case _3:
          return s(h, c5), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, X0);
        case n4:
          return s(h, f5), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, ft);
        case e3:
          return s(h, d5), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, h5);
        case t3:
          return s(h, pt), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, mt);
        case i4:
          return s(h, vt), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, _);
        case U3:
          return s(h, F), s(h, g.segmentPrefix), s(h, I.toString(16)), Q(h, K);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function b1(h, g) {
      switch (g.insertionMode) {
        case S2:
        case U2:
          return Q(h, ut);
        case _3:
          return Q(h, ct);
        case n4:
          return Q(h, dt);
        case e3:
          return Q(h, ht);
        case t3:
          return Q(h, K5);
        case i4:
          return Q(h, N);
        case U3:
          return Q(h, p1);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var I1 = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", e2 = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', p2 = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', c2 = I1 + ';$RS("', F2 = '$RS("', B3 = '","', J3 = '")<\/script>';
    function Y3(h, g, O) {
      s(h, g.startInlineScript), g.sentCompleteSegmentFunction ? s(h, F2) : (g.sentCompleteSegmentFunction = !0, s(h, c2)), s(h, g.segmentPrefix);
      var I = O.toString(16);
      return s(h, I), s(h, B3), s(h, g.placeholderPrefix), s(h, I), Q(h, J3);
    }
    var p5 = e2 + ';$RC("', Lt = '$RC("', ee = '","', ca = '")<\/script>';
    function fa(h, g, O, I) {
      if (s(h, g.startInlineScript), g.sentCompleteBoundaryFunction ? s(h, Lt) : (g.sentCompleteBoundaryFunction = !0, s(h, p5)), O === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var B = I.toString(16);
      return s(h, O), s(h, ee), s(h, g.segmentPrefix), s(h, B), Q(h, ca);
    }
    var da = p2 + ';$RX("', ha = '$RX("', pa = '"', ma = ")<\/script>", q0 = ",";
    function va(h, g, O, I, B, e1) {
      if (s(h, g.startInlineScript), g.sentClientRenderFunction ? s(h, ha) : (g.sentClientRenderFunction = !0, s(h, da)), O === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return s(h, O), s(h, pa), (I || B || e1) && (s(h, q0), s(h, J0(I || ""))), (B || e1) && (s(h, q0), s(h, J0(B || ""))), e1 && (s(h, q0), s(h, J0(e1))), Q(h, ma);
    }
    var La = /[<\u2028\u2029]/g;
    function J0(h) {
      var g = JSON.stringify(h);
      return g.replace(La, function(O) {
        switch (O) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function ya(h, g) {
      var O = w2(g, void 0);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: O.bootstrapChunks,
        startInlineScript: O.startInlineScript,
        placeholderPrefix: O.placeholderPrefix,
        segmentPrefix: O.segmentPrefix,
        boundaryPrefix: O.boundaryPrefix,
        idPrefix: O.idPrefix,
        nextSuspenseID: O.nextSuspenseID,
        sentCompleteSegmentFunction: O.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: O.sentCompleteBoundaryFunction,
        sentClientRenderFunction: O.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: h
      };
    }
    function Y0() {
      return {
        insertionMode: U2,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function y8(h, g, O, I) {
      return O.generateStaticMarkup ? (h.push(Z2(g)), !1) : S6(h, g, O, I);
    }
    function g8(h, g, O, I) {
      if (!g.generateStaticMarkup)
        return C6(h, g, O, I);
    }
    function K0(h, g) {
      return g.generateStaticMarkup ? !0 : d6(h);
    }
    function Q4(h, g, O, I, B) {
      return g.generateStaticMarkup ? !0 : l5(h, g, O, I, B);
    }
    function ga(h, g) {
      return g.generateStaticMarkup ? !0 : st(h);
    }
    function x8(h, g) {
      return g.generateStaticMarkup ? !0 : lt(h);
    }
    var K3 = Object.assign, H8 = Symbol.for("react.element"), e7 = Symbol.for("react.portal"), yt = Symbol.for("react.fragment"), gt = Symbol.for("react.strict_mode"), xt = Symbol.for("react.profiler"), te = Symbol.for("react.provider"), re = Symbol.for("react.context"), ne = Symbol.for("react.forward_ref"), m5 = Symbol.for("react.suspense"), t7 = Symbol.for("react.suspense_list"), r7 = Symbol.for("react.memo"), Ht = Symbol.for("react.lazy"), xa = Symbol.for("react.scope"), E8 = Symbol.for("react.debug_trace_mode"), Ha = Symbol.for("react.legacy_hidden"), Ea = Symbol.for("react.default_value"), b8 = Symbol.iterator, M8 = "@@iterator";
    function i3(h) {
      if (h === null || typeof h != "object")
        return null;
      var g = b8 && h[b8] || h[M8];
      return typeof g == "function" ? g : null;
    }
    function ie(h, g, O) {
      var I = h.displayName;
      if (I)
        return I;
      var B = g.displayName || g.name || "";
      return B !== "" ? O + "(" + B + ")" : O;
    }
    function n7(h) {
      return h.displayName || "Context";
    }
    function r3(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && i("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case yt:
          return "Fragment";
        case e7:
          return "Portal";
        case xt:
          return "Profiler";
        case gt:
          return "StrictMode";
        case m5:
          return "Suspense";
        case t7:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case re:
            var g = h;
            return n7(g) + ".Consumer";
          case te:
            var O = h;
            return n7(O._context) + ".Provider";
          case ne:
            return ie(h, h.render, "ForwardRef");
          case r7:
            var I = h.displayName || null;
            return I !== null ? I : r3(h.type) || "Memo";
          case Ht: {
            var B = h, e1 = B._payload, o1 = B._init;
            try {
              return r3(o1(e1));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var v5 = 0, i7, o7, a7, Q7, T7, w8, S8;
    function Et() {
    }
    Et.__reactDisabledLog = !0;
    function s7() {
      {
        if (v5 === 0) {
          i7 = console.log, o7 = console.info, a7 = console.warn, Q7 = console.error, T7 = console.group, w8 = console.groupCollapsed, S8 = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: Et,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        v5++;
      }
    }
    function oe() {
      {
        if (v5--, v5 === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K3({}, h, {
              value: i7
            }),
            info: K3({}, h, {
              value: o7
            }),
            warn: K3({}, h, {
              value: a7
            }),
            error: K3({}, h, {
              value: Q7
            }),
            group: K3({}, h, {
              value: T7
            }),
            groupCollapsed: K3({}, h, {
              value: w8
            }),
            groupEnd: K3({}, h, {
              value: S8
            })
          });
        }
        v5 < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ae = r.ReactCurrentDispatcher, L5;
    function Qe(h, g, O) {
      {
        if (L5 === void 0)
          try {
            throw Error();
          } catch (B) {
            var I = B.stack.trim().match(/\n( *(at )?)/);
            L5 = I && I[1] || "";
          }
        return `
` + L5 + h;
      }
    }
    var Te = !1, bt;
    {
      var C8 = typeof WeakMap == "function" ? WeakMap : Map;
      bt = new C8();
    }
    function l7(h, g) {
      if (!h || Te)
        return "";
      {
        var O = bt.get(h);
        if (O !== void 0)
          return O;
      }
      var I;
      Te = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var e1;
      e1 = ae.current, ae.current = null, s7();
      try {
        if (g) {
          var o1 = function() {
            throw Error();
          };
          if (Object.defineProperty(o1.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o1, []);
            } catch (u4) {
              I = u4;
            }
            Reflect.construct(h, [], o1);
          } else {
            try {
              o1.call();
            } catch (u4) {
              I = u4;
            }
            h.call(o1.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (u4) {
            I = u4;
          }
          h();
        }
      } catch (u4) {
        if (u4 && I && typeof u4.stack == "string") {
          for (var m1 = u4.stack.split(`
`), V1 = I.stack.split(`
`), $1 = m1.length - 1, U1 = V1.length - 1; $1 >= 1 && U1 >= 0 && m1[$1] !== V1[U1]; )
            U1--;
          for (; $1 >= 1 && U1 >= 0; $1--, U1--)
            if (m1[$1] !== V1[U1]) {
              if ($1 !== 1 || U1 !== 1)
                do
                  if ($1--, U1--, U1 < 0 || m1[$1] !== V1[U1]) {
                    var Q2 = `
` + m1[$1].replace(" at new ", " at ");
                    return h.displayName && Q2.includes("<anonymous>") && (Q2 = Q2.replace("<anonymous>", h.displayName)), typeof h == "function" && bt.set(h, Q2), Q2;
                  }
                while ($1 >= 1 && U1 >= 0);
              break;
            }
        }
      } finally {
        Te = !1, ae.current = e1, oe(), Error.prepareStackTrace = B;
      }
      var X2 = h ? h.displayName || h.name : "", M3 = X2 ? Qe(X2) : "";
      return typeof h == "function" && bt.set(h, M3), M3;
    }
    function u7(h, g, O) {
      return l7(h, !0);
    }
    function c7(h, g, O) {
      return l7(h, !1);
    }
    function V8(h) {
      var g = h.prototype;
      return !!(g && g.isReactComponent);
    }
    function y5(h, g, O) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return l7(h, V8(h));
      if (typeof h == "string")
        return Qe(h);
      switch (h) {
        case m5:
          return Qe("Suspense");
        case t7:
          return Qe("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case ne:
            return c7(h.render);
          case r7:
            return y5(h.type, g, O);
          case Ht: {
            var I = h, B = I._payload, e1 = I._init;
            try {
              return y5(e1(B), g, O);
            } catch {
            }
          }
        }
      return "";
    }
    var f7 = {}, Mt = r.ReactDebugCurrentFrame;
    function k6(h) {
      if (h) {
        var g = h._owner, O = y5(h.type, h._source, g ? g.type : null);
        Mt.setExtraStackFrame(O);
      } else
        Mt.setExtraStackFrame(null);
    }
    function d7(h, g, O, I, B) {
      {
        var e1 = Function.call.bind(C);
        for (var o1 in h)
          if (e1(h, o1)) {
            var m1 = void 0;
            try {
              if (typeof h[o1] != "function") {
                var V1 = Error((I || "React class") + ": " + O + " type `" + o1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[o1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V1.name = "Invariant Violation", V1;
              }
              m1 = h[o1](g, o1, I, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch ($1) {
              m1 = $1;
            }
            m1 && !(m1 instanceof Error) && (k6(B), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", O, o1, typeof m1), k6(null)), m1 instanceof Error && !(m1.message in f7) && (f7[m1.message] = !0, k6(B), i("Failed %s type: %s", O, m1.message), k6(null));
          }
      }
    }
    var h7;
    h7 = {};
    var p6 = {};
    Object.freeze(p6);
    function _8(h, g) {
      {
        var O = h.contextTypes;
        if (!O)
          return p6;
        var I = {};
        for (var B in O)
          I[B] = g[B];
        {
          var e1 = r3(h) || "Unknown";
          d7(O, I, "context", e1);
        }
        return I;
      }
    }
    function I6(h, g, O, I) {
      {
        if (typeof h.getChildContext != "function") {
          {
            var B = r3(g) || "Unknown";
            h7[B] || (h7[B] = !0, i("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", B, B));
          }
          return O;
        }
        var e1 = h.getChildContext();
        for (var o1 in e1)
          if (!(o1 in I))
            throw new Error((r3(g) || "Unknown") + '.getChildContext(): key "' + o1 + '" is not defined in childContextTypes.');
        {
          var m1 = r3(g) || "Unknown";
          d7(I, e1, "child context", m1);
        }
        return K3({}, O, e1);
      }
    }
    var R6;
    R6 = {};
    var p7 = null, k4 = null;
    function wt(h) {
      h.context._currentValue2 = h.parentValue;
    }
    function St(h) {
      h.context._currentValue2 = h.value;
    }
    function se(h, g) {
      if (h !== g) {
        wt(h);
        var O = h.parent, I = g.parent;
        if (O === null) {
          if (I !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (I === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          se(O, I);
        }
        St(g);
      }
    }
    function m7(h) {
      wt(h);
      var g = h.parent;
      g !== null && m7(g);
    }
    function le(h) {
      var g = h.parent;
      g !== null && le(g), St(h);
    }
    function O8(h, g) {
      wt(h);
      var O = h.parent;
      if (O === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      O.depth === g.depth ? se(O, g) : O8(O, g);
    }
    function A8(h, g) {
      var O = g.parent;
      if (O === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      h.depth === O.depth ? se(h, O) : A8(h, O), St(g);
    }
    function Ct(h) {
      var g = k4, O = h;
      g !== O && (g === null ? le(O) : O === null ? m7(g) : g.depth === O.depth ? se(g, O) : g.depth > O.depth ? O8(g, O) : A8(g, O), k4 = O);
    }
    function ue(h, g) {
      var O;
      O = h._currentValue2, h._currentValue2 = g, h._currentRenderer2 !== void 0 && h._currentRenderer2 !== null && h._currentRenderer2 !== R6 && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), h._currentRenderer2 = R6;
      var I = k4, B = {
        parent: I,
        depth: I === null ? 0 : I.depth + 1,
        context: h,
        parentValue: O,
        value: g
      };
      return k4 = B, B;
    }
    function v7(h) {
      var g = k4;
      if (g === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      g.context !== h && i("The parent context is not the expected context. This is probably a bug in React.");
      {
        var O = g.parentValue;
        O === Ea ? g.context._currentValue2 = g.context._defaultValue : g.context._currentValue2 = O, h._currentRenderer2 !== void 0 && h._currentRenderer2 !== null && h._currentRenderer2 !== R6 && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), h._currentRenderer2 = R6;
      }
      return k4 = g.parent;
    }
    function ba() {
      return k4;
    }
    function g5(h) {
      var g = h._currentValue2;
      return g;
    }
    function Vt(h) {
      return h._reactInternals;
    }
    function L7(h, g) {
      h._reactInternals = g;
    }
    var _t = {}, Ot = {}, ce, At, x5, fe, Dt, H5, kt, It, Rt;
    {
      ce = /* @__PURE__ */ new Set(), At = /* @__PURE__ */ new Set(), x5 = /* @__PURE__ */ new Set(), kt = /* @__PURE__ */ new Set(), fe = /* @__PURE__ */ new Set(), It = /* @__PURE__ */ new Set(), Rt = /* @__PURE__ */ new Set();
      var D8 = /* @__PURE__ */ new Set();
      H5 = function(h, g) {
        if (!(h === null || typeof h == "function")) {
          var O = g + "_" + h;
          D8.has(O) || (D8.add(O), i("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", g, h));
        }
      }, Dt = function(h, g) {
        if (g === void 0) {
          var O = r3(h) || "Component";
          fe.has(O) || (fe.add(O), i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", O));
        }
      };
    }
    function k8(h, g) {
      {
        var O = h.constructor, I = O && r3(O) || "ReactClass", B = I + "." + g;
        if (_t[B])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, g, g, I), _t[B] = !0;
      }
    }
    var I8 = {
      isMounted: function(h) {
        return !1;
      },
      enqueueSetState: function(h, g, O) {
        var I = Vt(h);
        I.queue === null ? k8(h, "setState") : (I.queue.push(g), O != null && H5(O, "setState"));
      },
      enqueueReplaceState: function(h, g, O) {
        var I = Vt(h);
        I.replace = !0, I.queue = [g], O != null && H5(O, "setState");
      },
      enqueueForceUpdate: function(h, g) {
        var O = Vt(h);
        O.queue === null ? k8(h, "forceUpdate") : g != null && H5(g, "setState");
      }
    };
    function Ma(h, g, O, I, B) {
      var e1 = O(B, I);
      Dt(g, e1);
      var o1 = e1 == null ? I : K3({}, I, e1);
      return o1;
    }
    function wa(h, g, O) {
      var I = p6, B = h.contextType;
      if ("contextType" in h) {
        var e1 = (
          // Allow null for conditional declaration
          B === null || B !== void 0 && B.$$typeof === re && B._context === void 0
        );
        if (!e1 && !Rt.has(h)) {
          Rt.add(h);
          var o1 = "";
          B === void 0 ? o1 = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof B != "object" ? o1 = " However, it is set to a " + typeof B + "." : B.$$typeof === te ? o1 = " Did you accidentally pass the Context.Provider instead?" : B._context !== void 0 ? o1 = " Did you accidentally pass the Context.Consumer instead?" : o1 = " However, it is set to an object with keys {" + Object.keys(B).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", r3(h) || "Component", o1);
        }
      }
      typeof B == "object" && B !== null ? I = g5(B) : I = O;
      var m1 = new h(g, I);
      {
        if (typeof h.getDerivedStateFromProps == "function" && (m1.state === null || m1.state === void 0)) {
          var V1 = r3(h) || "Component";
          ce.has(V1) || (ce.add(V1), i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", V1, m1.state === null ? "null" : "undefined", V1));
        }
        if (typeof h.getDerivedStateFromProps == "function" || typeof m1.getSnapshotBeforeUpdate == "function") {
          var $1 = null, U1 = null, Q2 = null;
          if (typeof m1.componentWillMount == "function" && m1.componentWillMount.__suppressDeprecationWarning !== !0 ? $1 = "componentWillMount" : typeof m1.UNSAFE_componentWillMount == "function" && ($1 = "UNSAFE_componentWillMount"), typeof m1.componentWillReceiveProps == "function" && m1.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? U1 = "componentWillReceiveProps" : typeof m1.UNSAFE_componentWillReceiveProps == "function" && (U1 = "UNSAFE_componentWillReceiveProps"), typeof m1.componentWillUpdate == "function" && m1.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Q2 = "componentWillUpdate" : typeof m1.UNSAFE_componentWillUpdate == "function" && (Q2 = "UNSAFE_componentWillUpdate"), $1 !== null || U1 !== null || Q2 !== null) {
            var X2 = r3(h) || "Component", M3 = typeof h.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            x5.has(X2) || (x5.add(X2), i(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, X2, M3, $1 !== null ? `
  ` + $1 : "", U1 !== null ? `
  ` + U1 : "", Q2 !== null ? `
  ` + Q2 : ""));
          }
        }
      }
      return m1;
    }
    function R8(h, g, O) {
      {
        var I = r3(g) || "Component", B = h.render;
        B || (g.prototype && typeof g.prototype.render == "function" ? i("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", I) : i("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", I)), h.getInitialState && !h.getInitialState.isReactClassApproved && !h.state && i("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", I), h.getDefaultProps && !h.getDefaultProps.isReactClassApproved && i("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", I), h.propTypes && i("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", I), h.contextType && i("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", I), h.contextTypes && i("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", I), g.contextType && g.contextTypes && !It.has(g) && (It.add(g), i("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", I)), typeof h.componentShouldUpdate == "function" && i("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", I), g.prototype && g.prototype.isPureReactComponent && typeof h.shouldComponentUpdate < "u" && i("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", r3(g) || "A pure component"), typeof h.componentDidUnmount == "function" && i("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", I), typeof h.componentDidReceiveProps == "function" && i("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", I), typeof h.componentWillRecieveProps == "function" && i("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", I), typeof h.UNSAFE_componentWillRecieveProps == "function" && i("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", I);
        var e1 = h.props !== O;
        h.props !== void 0 && e1 && i("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", I, I), h.defaultProps && i("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", I, I), typeof h.getSnapshotBeforeUpdate == "function" && typeof h.componentDidUpdate != "function" && !At.has(g) && (At.add(g), i("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", r3(g))), typeof h.getDerivedStateFromProps == "function" && i("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", I), typeof h.getDerivedStateFromError == "function" && i("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", I), typeof g.getSnapshotBeforeUpdate == "function" && i("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", I);
        var o1 = h.state;
        o1 && (typeof o1 != "object" || n1(o1)) && i("%s.state: must be set to an object or null", I), typeof h.getChildContext == "function" && typeof g.childContextTypes != "object" && i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", I);
      }
    }
    function Sa(h, g) {
      var O = g.state;
      if (typeof g.componentWillMount == "function") {
        if (g.componentWillMount.__suppressDeprecationWarning !== !0) {
          var I = r3(h) || "Unknown";
          Ot[I] || (n(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            I
          ), Ot[I] = !0);
        }
        g.componentWillMount();
      }
      typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount(), O !== g.state && (i("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", r3(h) || "Component"), I8.enqueueReplaceState(g, g.state, null));
    }
    function Ca(h, g, O, I) {
      if (h.queue !== null && h.queue.length > 0) {
        var B = h.queue, e1 = h.replace;
        if (h.queue = null, h.replace = !1, e1 && B.length === 1)
          g.state = B[0];
        else {
          for (var o1 = e1 ? B[0] : g.state, m1 = !0, V1 = e1 ? 1 : 0; V1 < B.length; V1++) {
            var $1 = B[V1], U1 = typeof $1 == "function" ? $1.call(g, o1, O, I) : $1;
            U1 != null && (m1 ? (m1 = !1, o1 = K3({}, o1, U1)) : K3(o1, U1));
          }
          g.state = o1;
        }
      } else
        h.queue = null;
    }
    function Nt(h, g, O, I) {
      R8(h, g, O);
      var B = h.state !== void 0 ? h.state : null;
      h.updater = I8, h.props = O, h.state = B;
      var e1 = {
        queue: [],
        replace: !1
      };
      L7(h, e1);
      var o1 = g.contextType;
      if (typeof o1 == "object" && o1 !== null ? h.context = g5(o1) : h.context = I, h.state === O) {
        var m1 = r3(g) || "Component";
        kt.has(m1) || (kt.add(m1), i("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", m1));
      }
      var V1 = g.getDerivedStateFromProps;
      typeof V1 == "function" && (h.state = Ma(h, g, V1, B, O)), typeof g.getDerivedStateFromProps != "function" && typeof h.getSnapshotBeforeUpdate != "function" && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (Sa(g, h), Ca(e1, h, O, I));
    }
    var Pt = {
      id: 1,
      overflow: ""
    };
    function Va(h) {
      var g = h.overflow, O = h.id, I = O & ~_a(O);
      return I.toString(32) + g;
    }
    function y7(h, g, O) {
      var I = h.id, B = h.overflow, e1 = Bt(I) - 1, o1 = I & ~(1 << e1), m1 = O + 1, V1 = Bt(g) + e1;
      if (V1 > 30) {
        var $1 = e1 - e1 % 5, U1 = (1 << $1) - 1, Q2 = (o1 & U1).toString(32), X2 = o1 >> $1, M3 = e1 - $1, u4 = Bt(g) + M3, an = m1 << M3, Qn = an | X2, Tn = Q2 + B;
        return {
          id: 1 << u4 | Qn,
          overflow: Tn
        };
      } else {
        var r0 = m1 << e1, im = r0 | o1, om = B;
        return {
          id: 1 << V1 | im,
          overflow: om
        };
      }
    }
    function Bt(h) {
      return 32 - Oa(h);
    }
    function _a(h) {
      return 1 << Bt(h) - 1;
    }
    var Oa = Math.clz32 ? Math.clz32 : X4, Aa = Math.log, Da = Math.LN2;
    function X4(h) {
      var g = h >>> 0;
      return g === 0 ? 32 : 31 - (Aa(g) / Da | 0) | 0;
    }
    function g7(h, g) {
      return h === g && (h !== 0 || 1 / h === 1 / g) || h !== h && g !== g;
    }
    var Ft = typeof Object.is == "function" ? Object.is : g7, b2 = null, N6 = null, P6 = null, D2 = null, T4 = !1, B6 = !1, jt = 0, b3 = null, q4 = 0, F6 = 25, I4 = !1, j6;
    function J4() {
      if (b2 === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return I4 && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), b2;
    }
    function ka(h, g) {
      if (g === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", j6), !1;
      h.length !== g.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, j6, "[" + h.join(", ") + "]", "[" + g.join(", ") + "]");
      for (var O = 0; O < g.length && O < h.length; O++)
        if (!Ft(h[O], g[O]))
          return !1;
      return !0;
    }
    function N8() {
      if (q4 > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function $t() {
      return D2 === null ? P6 === null ? (T4 = !1, P6 = D2 = N8()) : (T4 = !0, D2 = P6) : D2.next === null ? (T4 = !1, D2 = D2.next = N8()) : (T4 = !0, D2 = D2.next), D2;
    }
    function x7(h, g) {
      b2 = g, N6 = h, I4 = !1, jt = 0;
    }
    function Ia(h, g, O, I) {
      for (; B6; )
        B6 = !1, jt = 0, q4 += 1, D2 = null, O = h(g, I);
      return de(), O;
    }
    function P8() {
      var h = jt !== 0;
      return h;
    }
    function de() {
      I4 = !1, b2 = null, N6 = null, B6 = !1, P6 = null, q4 = 0, b3 = null, D2 = null;
    }
    function Ra(h) {
      return I4 && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), g5(h);
    }
    function B8(h) {
      return j6 = "useContext", J4(), g5(h);
    }
    function Zt(h, g) {
      return typeof g == "function" ? g(h) : g;
    }
    function Na(h) {
      return j6 = "useState", F8(
        Zt,
        // useReducer has a special case to support lazy useState initializers
        h
      );
    }
    function F8(h, g, O) {
      if (h !== Zt && (j6 = "useReducer"), b2 = J4(), D2 = $t(), T4) {
        var I = D2.queue, B = I.dispatch;
        if (b3 !== null) {
          var e1 = b3.get(I);
          if (e1 !== void 0) {
            b3.delete(I);
            var o1 = D2.memoizedState, m1 = e1;
            do {
              var V1 = m1.action;
              I4 = !0, o1 = h(o1, V1), I4 = !1, m1 = m1.next;
            } while (m1 !== null);
            return D2.memoizedState = o1, [o1, B];
          }
        }
        return [D2.memoizedState, B];
      } else {
        I4 = !0;
        var $1;
        h === Zt ? $1 = typeof g == "function" ? g() : g : $1 = O !== void 0 ? O(g) : g, I4 = !1, D2.memoizedState = $1;
        var U1 = D2.queue = {
          last: null,
          dispatch: null
        }, Q2 = U1.dispatch = Fa.bind(null, b2, U1);
        return [D2.memoizedState, Q2];
      }
    }
    function j8(h, g) {
      b2 = J4(), D2 = $t();
      var O = g === void 0 ? null : g;
      if (D2 !== null) {
        var I = D2.memoizedState;
        if (I !== null && O !== null) {
          var B = I[1];
          if (ka(O, B))
            return I[0];
        }
      }
      I4 = !0;
      var e1 = h();
      return I4 = !1, D2.memoizedState = [e1, O], e1;
    }
    function Pa(h) {
      b2 = J4(), D2 = $t();
      var g = D2.memoizedState;
      if (g === null) {
        var O = {
          current: h
        };
        return Object.seal(O), D2.memoizedState = O, O;
      } else
        return g;
    }
    function Ba(h, g) {
      j6 = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Fa(h, g, O) {
      if (q4 >= F6)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (h === b2) {
        B6 = !0;
        var I = {
          action: O,
          next: null
        };
        b3 === null && (b3 = /* @__PURE__ */ new Map());
        var B = b3.get(g);
        if (B === void 0)
          b3.set(g, I);
        else {
          for (var e1 = B; e1.next !== null; )
            e1 = e1.next;
          e1.next = I;
        }
      }
    }
    function ja(h, g) {
      return j8(function() {
        return h;
      }, g);
    }
    function $a(h, g, O) {
      return J4(), g(h._source);
    }
    function Za(h, g, O) {
      if (O === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return O();
    }
    function Wa(h) {
      return J4(), h;
    }
    function Wt() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function $8() {
      return J4(), [!1, Wt];
    }
    function H7() {
      var h = N6, g = Va(h.treeContext), O = pe;
      if (O === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var I = jt++;
      return O3(O, g, I);
    }
    function he() {
    }
    var Z8 = {
      readContext: Ra,
      useContext: B8,
      useMemo: j8,
      useReducer: F8,
      useRef: Pa,
      useState: Na,
      useInsertionEffect: he,
      useLayoutEffect: Ba,
      useCallback: ja,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: he,
      // Effects are not run in the server environment.
      useEffect: he,
      // Debugging effect
      useDebugValue: he,
      useDeferredValue: Wa,
      useTransition: $8,
      useId: H7,
      // Subscriptions are not setup in a server environment.
      useMutableSource: $a,
      useSyncExternalStore: Za
    }, pe = null;
    function Gt(h) {
      pe = h;
    }
    function E7(h) {
      try {
        var g = "", O = h;
        do {
          switch (O.tag) {
            case 0:
              g += Qe(O.type, null, null);
              break;
            case 1:
              g += c7(O.type, null, null);
              break;
            case 2:
              g += u7(O.type, null, null);
              break;
          }
          O = O.parent;
        } while (O);
        return g;
      } catch (I) {
        return `
Error generating stack: ` + I.message + `
` + I.stack;
      }
    }
    var m6 = r.ReactCurrentDispatcher, zt = r.ReactDebugCurrentFrame, Ut = 0, $6 = 1, W8 = 2, b7 = 3, Z6 = 4, Ga = 0, G8 = 1, R4 = 2, za = 12800;
    function Ua(h) {
      return console.error(h), null;
    }
    function me() {
    }
    function M7(h, g, O, I, B, e1, o1, m1, V1) {
      var $1 = [], U1 = /* @__PURE__ */ new Set(), Q2 = {
        destination: null,
        responseState: g,
        progressiveChunkSize: I === void 0 ? za : I,
        status: Ga,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: U1,
        pingedTasks: $1,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: B === void 0 ? Ua : B,
        onAllReady: e1 === void 0 ? me : e1,
        onShellReady: o1 === void 0 ? me : o1,
        onShellError: m1 === void 0 ? me : m1,
        onFatalError: V1 === void 0 ? me : V1
      }, X2 = v6(
        Q2,
        0,
        null,
        O,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      X2.parentFlushed = !0;
      var M3 = ve(Q2, h, null, X2, U1, p6, p7, Pt);
      return $1.push(M3), Q2;
    }
    function Xt(h, g) {
      var O = h.pingedTasks;
      O.push(g), O.length === 1 && a(function() {
        return nn(h);
      });
    }
    function Y4(h, g) {
      return {
        id: o4,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: g,
        errorDigest: null
      };
    }
    function ve(h, g, O, I, B, e1, o1, m1) {
      h.allPendingTasks++, O === null ? h.pendingRootTasks++ : O.pendingTasks++;
      var V1 = {
        node: g,
        ping: function() {
          return Xt(h, V1);
        },
        blockedBoundary: O,
        blockedSegment: I,
        abortSet: B,
        legacyContext: e1,
        context: o1,
        treeContext: m1
      };
      return V1.componentStack = null, B.add(V1), V1;
    }
    function v6(h, g, O, I, B, e1) {
      return {
        status: Ut,
        id: -1,
        // lazily assigned later
        index: g,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: I,
        boundary: O,
        lastPushedText: B,
        textEmbedded: e1
      };
    }
    var N4 = null;
    function w7() {
      return N4 === null || N4.componentStack === null ? "" : E7(N4.componentStack);
    }
    function s4(h, g) {
      h.componentStack = {
        tag: 0,
        parent: h.componentStack,
        type: g
      };
    }
    function E5(h, g) {
      h.componentStack = {
        tag: 1,
        parent: h.componentStack,
        type: g
      };
    }
    function S7(h, g) {
      h.componentStack = {
        tag: 2,
        parent: h.componentStack,
        type: g
      };
    }
    function l4(h) {
      h.componentStack === null ? i("Unexpectedly popped too many stack frames. This is a bug in React.") : h.componentStack = h.componentStack.parent;
    }
    var L6 = null;
    function C7(h, g) {
      {
        var O;
        typeof g == "string" ? O = g : g && typeof g.message == "string" ? O = g.message : O = String(g);
        var I = L6 || w7();
        L6 = null, h.errorMessage = O, h.errorComponentStack = I;
      }
    }
    function Le(h, g) {
      var O = h.onError(g);
      if (O != null && typeof O != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof O + '" instead');
      return O;
    }
    function qt(h, g) {
      var O = h.onShellError;
      O(g);
      var I = h.onFatalError;
      I(g), h.destination !== null ? (h.status = R4, d(h.destination, g)) : (h.status = G8, h.fatalError = g);
    }
    function z8(h, g, O) {
      s4(g, "Suspense");
      var I = g.blockedBoundary, B = g.blockedSegment, e1 = O.fallback, o1 = O.children, m1 = /* @__PURE__ */ new Set(), V1 = Y4(h, m1), $1 = B.chunks.length, U1 = v6(
        h,
        $1,
        V1,
        B.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      B.children.push(U1), B.lastPushedText = !1;
      var Q2 = v6(
        h,
        0,
        null,
        B.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      Q2.parentFlushed = !0, g.blockedBoundary = V1, g.blockedSegment = Q2;
      try {
        if (Jt(h, g, o1), g8(Q2.chunks, h.responseState, Q2.lastPushedText, Q2.textEmbedded), Q2.status = $6, xe(V1, Q2), V1.pendingTasks === 0) {
          l4(g);
          return;
        }
      } catch (M3) {
        Q2.status = Z6, V1.forceClientRender = !0, V1.errorDigest = Le(h, M3), C7(V1, M3);
      } finally {
        g.blockedBoundary = I, g.blockedSegment = B;
      }
      var X2 = ve(h, e1, I, U1, m1, g.legacyContext, g.context, g.treeContext);
      X2.componentStack = g.componentStack, h.pingedTasks.push(X2), l4(g);
    }
    function U8(h, g, O, I) {
      s4(g, O);
      var B = g.blockedSegment, e1 = A4(B.chunks, O, I, h.responseState, B.formatContext);
      B.lastPushedText = !1;
      var o1 = B.formatContext;
      B.formatContext = s6(o1, O, I), Jt(h, g, e1), B.formatContext = o1, q3(B.chunks, O), B.lastPushedText = !1, l4(g);
    }
    function Xa(h) {
      return h.prototype && h.prototype.isReactComponent;
    }
    function V7(h, g, O, I, B) {
      var e1 = {};
      x7(g, e1);
      var o1 = O(I, B);
      return Ia(O, I, o1, B);
    }
    function ye(h, g, O, I, B) {
      var e1 = O.render();
      O.props !== B && (D7 || i("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", r3(I) || "a component"), D7 = !0);
      {
        var o1 = I.childContextTypes;
        if (o1 != null) {
          var m1 = g.legacyContext, V1 = I6(O, I, m1, o1);
          g.legacyContext = V1, t4(h, g, e1), g.legacyContext = m1;
          return;
        }
      }
      t4(h, g, e1);
    }
    function X8(h, g, O, I) {
      S7(g, O);
      var B = _8(O, g.legacyContext), e1 = wa(O, I, B);
      Nt(e1, O, I, B), ye(h, g, e1, O, I), l4(g);
    }
    var _7 = {}, ge = {}, O7 = {}, A7 = {}, D7 = !1, q8 = !1, J8 = !1, k7 = !1;
    function qa(h, g, O, I) {
      var B;
      if (B = _8(O, g.legacyContext), E5(g, O), O.prototype && typeof O.prototype.render == "function") {
        var e1 = r3(O) || "Unknown";
        _7[e1] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", e1, e1), _7[e1] = !0);
      }
      var o1 = V7(h, g, O, I, B), m1 = P8();
      if (typeof o1 == "object" && o1 !== null && typeof o1.render == "function" && o1.$$typeof === void 0) {
        var V1 = r3(O) || "Unknown";
        ge[V1] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", V1, V1, V1), ge[V1] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof o1 == "object" && o1 !== null && typeof o1.render == "function" && o1.$$typeof === void 0
      ) {
        {
          var $1 = r3(O) || "Unknown";
          ge[$1] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", $1, $1, $1), ge[$1] = !0);
        }
        Nt(o1, O, I, B), ye(h, g, o1, O, I);
      } else if (Ja(O), m1) {
        var U1 = g.treeContext, Q2 = 1, X2 = 0;
        g.treeContext = y7(U1, Q2, X2);
        try {
          t4(h, g, o1);
        } finally {
          g.treeContext = U1;
        }
      } else
        t4(h, g, o1);
      l4(g);
    }
    function Ja(h) {
      {
        if (h && h.childContextTypes && i("%s(...): childContextTypes cannot be defined on a function component.", h.displayName || h.name || "Component"), typeof h.getDerivedStateFromProps == "function") {
          var g = r3(h) || "Unknown";
          A7[g] || (i("%s: Function components do not support getDerivedStateFromProps.", g), A7[g] = !0);
        }
        if (typeof h.contextType == "object" && h.contextType !== null) {
          var O = r3(h) || "Unknown";
          O7[O] || (i("%s: Function components do not support contextType.", O), O7[O] = !0);
        }
      }
    }
    function Y8(h, g) {
      if (h && h.defaultProps) {
        var O = K3({}, g), I = h.defaultProps;
        for (var B in I)
          O[B] === void 0 && (O[B] = I[B]);
        return O;
      }
      return g;
    }
    function Ya(h, g, O, I, B) {
      E5(g, O.render);
      var e1 = V7(h, g, O.render, I, B), o1 = P8();
      if (o1) {
        var m1 = g.treeContext, V1 = 1, $1 = 0;
        g.treeContext = y7(m1, V1, $1);
        try {
          t4(h, g, e1);
        } finally {
          g.treeContext = m1;
        }
      } else
        t4(h, g, e1);
      l4(g);
    }
    function Ka(h, g, O, I, B) {
      var e1 = O.type, o1 = Y8(e1, I);
      R7(h, g, e1, o1, B);
    }
    function I7(h, g, O, I) {
      O._context === void 0 ? O !== O.Consumer && (k7 || (k7 = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : O = O._context;
      var B = I.children;
      typeof B != "function" && i("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var e1 = g5(O), o1 = B(e1);
      t4(h, g, o1);
    }
    function eQ(h, g, O, I) {
      var B = O._context, e1 = I.value, o1 = I.children, m1;
      m1 = g.context, g.context = ue(B, e1), t4(h, g, o1), g.context = v7(B), m1 !== g.context && i("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function e4(h, g, O, I, B) {
      s4(g, "Lazy");
      var e1 = O._payload, o1 = O._init, m1 = o1(e1), V1 = Y8(m1, I);
      R7(h, g, m1, V1, B), l4(g);
    }
    function R7(h, g, O, I, B) {
      if (typeof O == "function")
        if (Xa(O)) {
          X8(h, g, O, I);
          return;
        } else {
          qa(h, g, O, I);
          return;
        }
      if (typeof O == "string") {
        U8(h, g, O, I);
        return;
      }
      switch (O) {
        case Ha:
        case E8:
        case gt:
        case xt:
        case yt: {
          t4(h, g, I.children);
          return;
        }
        case t7: {
          s4(g, "SuspenseList"), t4(h, g, I.children), l4(g);
          return;
        }
        case xa:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case m5: {
          z8(h, g, I);
          return;
        }
      }
      if (typeof O == "object" && O !== null)
        switch (O.$$typeof) {
          case ne: {
            Ya(h, g, O, I, B);
            return;
          }
          case r7: {
            Ka(h, g, O, I, B);
            return;
          }
          case te: {
            eQ(h, g, O, I);
            return;
          }
          case re: {
            I7(h, g, O, I);
            return;
          }
          case Ht: {
            e4(h, g, O, I);
            return;
          }
        }
      var e1 = "";
      throw (O === void 0 || typeof O == "object" && O !== null && Object.keys(O).length === 0) && (e1 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (O == null ? O : typeof O) + "." + e1));
    }
    function K8(h, g) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      h[Symbol.toStringTag] === "Generator" && (q8 || i("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), q8 = !0), h.entries === g && (J8 || i("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), J8 = !0);
    }
    function t4(h, g, O) {
      try {
        return N7(h, g, O);
      } catch (I) {
        throw typeof I == "object" && I !== null && typeof I.then == "function" || (L6 = L6 !== null ? L6 : w7()), I;
      }
    }
    function N7(h, g, O) {
      if (g.node = O, typeof O == "object" && O !== null) {
        switch (O.$$typeof) {
          case H8: {
            var I = O, B = I.type, e1 = I.props, o1 = I.ref;
            R7(h, g, B, e1, o1);
            return;
          }
          case e7:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case Ht: {
            var m1 = O, V1 = m1._payload, $1 = m1._init, U1;
            try {
              U1 = $1(V1);
            } catch (r0) {
              throw typeof r0 == "object" && r0 !== null && typeof r0.then == "function" && s4(g, "Lazy"), r0;
            }
            t4(h, g, U1);
            return;
          }
        }
        if (n1(O)) {
          en(h, g, O);
          return;
        }
        var Q2 = i3(O);
        if (Q2) {
          K8(O, Q2);
          var X2 = Q2.call(O);
          if (X2) {
            var M3 = X2.next();
            if (!M3.done) {
              var u4 = [];
              do
                u4.push(M3.value), M3 = X2.next();
              while (!M3.done);
              en(h, g, u4);
              return;
            }
            return;
          }
        }
        var an = Object.prototype.toString.call(O);
        throw new Error("Objects are not valid as a React child (found: " + (an === "[object Object]" ? "object with keys {" + Object.keys(O).join(", ") + "}" : an) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof O == "string") {
        var Qn = g.blockedSegment;
        Qn.lastPushedText = y8(g.blockedSegment.chunks, O, h.responseState, Qn.lastPushedText);
        return;
      }
      if (typeof O == "number") {
        var Tn = g.blockedSegment;
        Tn.lastPushedText = y8(g.blockedSegment.chunks, "" + O, h.responseState, Tn.lastPushedText);
        return;
      }
      typeof O == "function" && i("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function en(h, g, O) {
      for (var I = O.length, B = 0; B < I; B++) {
        var e1 = g.treeContext;
        g.treeContext = y7(e1, I, B);
        try {
          Jt(h, g, O[B]);
        } finally {
          g.treeContext = e1;
        }
      }
    }
    function tQ(h, g, O) {
      var I = g.blockedSegment, B = I.chunks.length, e1 = v6(
        h,
        B,
        null,
        I.formatContext,
        // Adopt the parent segment's leading text embed
        I.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      I.children.push(e1), I.lastPushedText = !1;
      var o1 = ve(h, g.node, g.blockedBoundary, e1, g.abortSet, g.legacyContext, g.context, g.treeContext);
      g.componentStack !== null && (o1.componentStack = g.componentStack.parent);
      var m1 = o1.ping;
      O.then(m1, m1);
    }
    function Jt(h, g, O) {
      var I = g.blockedSegment.formatContext, B = g.legacyContext, e1 = g.context, o1 = null;
      o1 = g.componentStack;
      try {
        return t4(h, g, O);
      } catch (m1) {
        if (de(), typeof m1 == "object" && m1 !== null && typeof m1.then == "function") {
          tQ(h, g, m1), g.blockedSegment.formatContext = I, g.legacyContext = B, g.context = e1, Ct(e1), g.componentStack = o1;
          return;
        } else
          throw g.blockedSegment.formatContext = I, g.legacyContext = B, g.context = e1, Ct(e1), g.componentStack = o1, m1;
      }
    }
    function Yt(h, g, O, I) {
      var B = Le(h, I);
      if (g === null ? qt(h, I) : (g.pendingTasks--, g.forceClientRender || (g.forceClientRender = !0, g.errorDigest = B, C7(g, I), g.parentFlushed && h.clientRenderedBoundaries.push(g))), h.allPendingTasks--, h.allPendingTasks === 0) {
        var e1 = h.onAllReady;
        e1();
      }
    }
    function tn(h) {
      var g = this, O = h.blockedBoundary, I = h.blockedSegment;
      I.status = b7, He(g, O, I);
    }
    function rn(h, g, O) {
      var I = h.blockedBoundary, B = h.blockedSegment;
      if (B.status = b7, I === null)
        g.allPendingTasks--, g.status !== R4 && (g.status = R4, g.destination !== null && l(g.destination));
      else {
        if (I.pendingTasks--, !I.forceClientRender) {
          I.forceClientRender = !0;
          var e1 = O === void 0 ? new Error("The render was aborted by the server without a reason.") : O;
          I.errorDigest = g.onError(e1);
          {
            var o1 = "The server did not finish this Suspense boundary: ";
            e1 && typeof e1.message == "string" ? e1 = o1 + e1.message : e1 = o1 + String(e1);
            var m1 = N4;
            N4 = h;
            try {
              C7(I, e1);
            } finally {
              N4 = m1;
            }
          }
          I.parentFlushed && g.clientRenderedBoundaries.push(I);
        }
        if (I.fallbackAbortableTasks.forEach(function($1) {
          return rn($1, g, O);
        }), I.fallbackAbortableTasks.clear(), g.allPendingTasks--, g.allPendingTasks === 0) {
          var V1 = g.onAllReady;
          V1();
        }
      }
    }
    function xe(h, g) {
      if (g.chunks.length === 0 && g.children.length === 1 && g.children[0].boundary === null) {
        var O = g.children[0];
        O.id = g.id, O.parentFlushed = !0, O.status === $6 && xe(h, O);
      } else {
        var I = h.completedSegments;
        I.push(g);
      }
    }
    function He(h, g, O) {
      if (g === null) {
        if (O.parentFlushed) {
          if (h.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          h.completedRootSegment = O;
        }
        if (h.pendingRootTasks--, h.pendingRootTasks === 0) {
          h.onShellError = me;
          var I = h.onShellReady;
          I();
        }
      } else if (g.pendingTasks--, !g.forceClientRender) {
        if (g.pendingTasks === 0)
          O.parentFlushed && O.status === $6 && xe(g, O), g.parentFlushed && h.completedBoundaries.push(g), g.fallbackAbortableTasks.forEach(tn, h), g.fallbackAbortableTasks.clear();
        else if (O.parentFlushed && O.status === $6) {
          xe(g, O);
          var B = g.completedSegments;
          B.length === 1 && g.parentFlushed && h.partialBoundaries.push(g);
        }
      }
      if (h.allPendingTasks--, h.allPendingTasks === 0) {
        var e1 = h.onAllReady;
        e1();
      }
    }
    function Kt(h, g) {
      var O = g.blockedSegment;
      if (O.status === Ut) {
        Ct(g.context);
        var I = null;
        I = N4, N4 = g;
        try {
          t4(h, g, g.node), g8(O.chunks, h.responseState, O.lastPushedText, O.textEmbedded), g.abortSet.delete(g), O.status = $6, He(h, g.blockedBoundary, O);
        } catch (e1) {
          if (de(), typeof e1 == "object" && e1 !== null && typeof e1.then == "function") {
            var B = g.ping;
            e1.then(B, B);
          } else
            g.abortSet.delete(g), O.status = Z6, Yt(h, g.blockedBoundary, O, e1);
        } finally {
          N4 = I;
        }
      }
    }
    function nn(h) {
      if (h.status !== R4) {
        var g = ba(), O = m6.current;
        m6.current = Z8;
        var I;
        I = zt.getCurrentStack, zt.getCurrentStack = w7;
        var B = pe;
        Gt(h.responseState);
        try {
          var e1 = h.pingedTasks, o1;
          for (o1 = 0; o1 < e1.length; o1++) {
            var m1 = e1[o1];
            Kt(h, m1);
          }
          e1.splice(0, o1), h.destination !== null && t0(h, h.destination);
        } catch (V1) {
          Le(h, V1), qt(h, V1);
        } finally {
          Gt(B), m6.current = O, zt.getCurrentStack = I, O === Z8 && Ct(g);
        }
      }
    }
    function Ee(h, g, O) {
      switch (O.parentFlushed = !0, O.status) {
        case Ut: {
          var I = O.id = h.nextSegmentId++;
          return O.lastPushedText = !1, O.textEmbedded = !1, Qt(g, h.responseState, I);
        }
        case $6: {
          O.status = W8;
          for (var B = !0, e1 = O.chunks, o1 = 0, m1 = O.children, V1 = 0; V1 < m1.length; V1++) {
            for (var $1 = m1[V1]; o1 < $1.index; o1++)
              s(g, e1[o1]);
            B = be(h, g, $1);
          }
          for (; o1 < e1.length - 1; o1++)
            s(g, e1[o1]);
          return o1 < e1.length && (B = Q(g, e1[o1])), B;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function be(h, g, O) {
      var I = O.boundary;
      if (I === null)
        return Ee(h, g, O);
      if (I.parentFlushed = !0, I.forceClientRender)
        return Q4(g, h.responseState, I.errorDigest, I.errorMessage, I.errorComponentStack), Ee(h, g, O), x8(g, h.responseState);
      if (I.pendingTasks > 0) {
        I.rootSegmentID = h.nextSegmentId++, I.completedSegments.length > 0 && h.partialBoundaries.push(I);
        var B = I.id = a4(h.responseState);
        return h6(g, h.responseState, B), Ee(h, g, O), Y5(g, h.responseState);
      } else {
        if (I.byteSize > h.progressiveChunkSize)
          return I.rootSegmentID = h.nextSegmentId++, h.completedBoundaries.push(I), h6(g, h.responseState, I.id), Ee(h, g, O), Y5(g, h.responseState);
        K0(g, h.responseState);
        var e1 = I.completedSegments;
        if (e1.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var o1 = e1[0];
        return be(h, g, o1), ga(g, h.responseState);
      }
    }
    function rQ(h, g, O) {
      return va(g, h.responseState, O.id, O.errorDigest, O.errorMessage, O.errorComponentStack);
    }
    function P7(h, g, O) {
      return d1(g, h.responseState, O.formatContext, O.id), be(h, g, O), b1(g, O.formatContext);
    }
    function e0(h, g, O) {
      for (var I = O.completedSegments, B = 0; B < I.length; B++) {
        var e1 = I[B];
        on(h, g, O, e1);
      }
      return I.length = 0, fa(g, h.responseState, O.id, O.rootSegmentID);
    }
    function nQ(h, g, O) {
      for (var I = O.completedSegments, B = 0; B < I.length; B++) {
        var e1 = I[B];
        if (!on(h, g, O, e1))
          return B++, I.splice(0, B), !1;
      }
      return I.splice(0, B), !0;
    }
    function on(h, g, O, I) {
      if (I.status === W8)
        return !0;
      var B = I.id;
      if (B === -1) {
        var e1 = I.id = O.rootSegmentID;
        if (e1 === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return P7(h, g, I);
      } else
        return P7(h, g, I), Y3(g, h.responseState, B);
    }
    function t0(h, g) {
      try {
        var O = h.completedRootSegment;
        O !== null && h.pendingRootTasks === 0 && (be(h, g, O), h.completedRootSegment = null, U5(g, h.responseState));
        var I = h.clientRenderedBoundaries, B;
        for (B = 0; B < I.length; B++) {
          var e1 = I[B];
          if (!rQ(h, g, e1)) {
            h.destination = null, B++, I.splice(0, B);
            return;
          }
        }
        I.splice(0, B);
        var o1 = h.completedBoundaries;
        for (B = 0; B < o1.length; B++) {
          var m1 = o1[B];
          if (!e0(h, g, m1)) {
            h.destination = null, B++, o1.splice(0, B);
            return;
          }
        }
        o1.splice(0, B);
        var V1 = h.partialBoundaries;
        for (B = 0; B < V1.length; B++) {
          var $1 = V1[B];
          if (!nQ(h, g, $1)) {
            h.destination = null, B++, V1.splice(0, B);
            return;
          }
        }
        V1.splice(0, B);
        var U1 = h.completedBoundaries;
        for (B = 0; B < U1.length; B++) {
          var Q2 = U1[B];
          if (!e0(h, g, Q2)) {
            h.destination = null, B++, U1.splice(0, B);
            return;
          }
        }
        U1.splice(0, B);
      } finally {
        h.allPendingTasks === 0 && h.pingedTasks.length === 0 && h.clientRenderedBoundaries.length === 0 && h.completedBoundaries.length === 0 && (h.abortableTasks.size !== 0 && i("There was still abortable task at the root when we closed. This is a bug in React."), l(g));
      }
    }
    function iQ(h) {
      a(function() {
        return nn(h);
      });
    }
    function L(h, g) {
      if (h.status === G8) {
        h.status = R4, d(g, h.fatalError);
        return;
      }
      if (h.status !== R4 && h.destination === null) {
        h.destination = g;
        try {
          t0(h, g);
        } catch (O) {
          Le(h, O), qt(h, O);
        }
      }
    }
    function x(h, g) {
      try {
        var O = h.abortableTasks;
        O.forEach(function(I) {
          return rn(I, h, g);
        }), O.clear(), h.destination !== null && t0(h, h.destination);
      } catch (I) {
        Le(h, I), qt(h, I);
      }
    }
    function A() {
    }
    function P(h, g, O, I) {
      var B = !1, e1 = null, o1 = "", m1 = {
        push: function(Q2) {
          return Q2 !== null && (o1 += Q2), !0;
        },
        destroy: function(Q2) {
          B = !0, e1 = Q2;
        }
      }, V1 = !1;
      function $1() {
        V1 = !0;
      }
      var U1 = M7(h, ya(O, g ? g.identifierPrefix : void 0), Y0(), 1 / 0, A, void 0, $1, void 0, void 0);
      if (iQ(U1), x(U1, I), L(U1, m1), B)
        throw e1;
      if (!V1)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return o1;
    }
    function U(h, g) {
      return P(h, g, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function r1(h, g) {
      return P(h, g, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function Q1() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function v1() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    Ae.renderToNodeStream = Q1, Ae.renderToStaticMarkup = r1, Ae.renderToStaticNodeStream = v1, Ae.renderToString = U, Ae.version = t;
  }()), Ae;
}
var jn = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xf;
function F_() {
  return Xf || (Xf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = y, t = "18.2.0", r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(L) {
      {
        for (var x = arguments.length, A = new Array(x > 1 ? x - 1 : 0), P = 1; P < x; P++)
          A[P - 1] = arguments[P];
        o("warn", L, A);
      }
    }
    function i(L) {
      {
        for (var x = arguments.length, A = new Array(x > 1 ? x - 1 : 0), P = 1; P < x; P++)
          A[P - 1] = arguments[P];
        o("error", L, A);
      }
    }
    function o(L, x, A) {
      {
        var P = r.ReactDebugCurrentFrame, U = P.getStackAddendum();
        U !== "" && (x += "%s", A = A.concat([U]));
        var r1 = A.map(function(Q1) {
          return String(Q1);
        });
        r1.unshift("Warning: " + x), Function.prototype.apply.call(console[L], console, r1);
      }
    }
    function a(L) {
      L();
    }
    var T = 512, s = null, Q = 0;
    function u(L) {
      s = new Uint8Array(T), Q = 0;
    }
    function l(L, x) {
      if (x.length !== 0) {
        if (x.length > T) {
          Q > 0 && (L.enqueue(new Uint8Array(s.buffer, 0, Q)), s = new Uint8Array(T), Q = 0), L.enqueue(x);
          return;
        }
        var A = x, P = s.length - Q;
        P < A.length && (P === 0 ? L.enqueue(s) : (s.set(A.subarray(0, P), Q), L.enqueue(s), A = A.subarray(P)), s = new Uint8Array(T), Q = 0), s.set(A, Q), Q += A.length;
      }
    }
    function c(L, x) {
      return l(L, x), !0;
    }
    function f(L) {
      s && Q > 0 && (L.enqueue(new Uint8Array(s.buffer, 0, Q)), s = null, Q = 0);
    }
    function d(L) {
      L.close();
    }
    var m = new TextEncoder();
    function p(L) {
      return m.encode(L);
    }
    function v(L) {
      return m.encode(L);
    }
    function H(L, x) {
      typeof L.error == "function" ? L.error(x) : L.close();
    }
    function E(L) {
      {
        var x = typeof Symbol == "function" && Symbol.toStringTag, A = x && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return A;
      }
    }
    function M(L) {
      try {
        return C(L), !1;
      } catch {
        return !0;
      }
    }
    function C(L) {
      return "" + L;
    }
    function w(L, x) {
      if (M(L))
        return i("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", x, E(L)), C(L);
    }
    function S(L, x) {
      if (M(L))
        return i("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", x, E(L)), C(L);
    }
    function D(L) {
      if (M(L))
        return i("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", E(L)), C(L);
    }
    var k = Object.prototype.hasOwnProperty, $ = 0, z = 1, j = 2, J = 3, i1 = 4, t1 = 5, T1 = 6, X = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", f1 = X + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", s1 = new RegExp("^[" + X + "][" + f1 + "]*$"), Z = {}, L1 = {};
    function C1(L) {
      return k.call(L1, L) ? !0 : k.call(Z, L) ? !1 : s1.test(L) ? (L1[L] = !0, !0) : (Z[L] = !0, i("Invalid attribute name: `%s`", L), !1);
    }
    function q(L, x, A, P) {
      if (A !== null && A.type === $)
        return !1;
      switch (typeof x) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (P)
            return !1;
          if (A !== null)
            return !A.acceptsBooleans;
          var U = L.toLowerCase().slice(0, 5);
          return U !== "data-" && U !== "aria-";
        }
        default:
          return !1;
      }
    }
    function N1(L) {
      return x1.hasOwnProperty(L) ? x1[L] : null;
    }
    function O1(L, x, A, P, U, r1, Q1) {
      this.acceptsBooleans = x === j || x === J || x === i1, this.attributeName = P, this.attributeNamespace = U, this.mustUseProperty = A, this.propertyName = L, this.type = x, this.sanitizeURL = r1, this.removeEmptyString = Q1;
    }
    var x1 = {}, l1 = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    l1.forEach(function(L) {
      x1[L] = new O1(
        L,
        $,
        !1,
        // mustUseProperty
        L,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(L) {
      var x = L[0], A = L[1];
      x1[x] = new O1(
        x,
        z,
        !1,
        // mustUseProperty
        A,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(L) {
      x1[L] = new O1(
        L,
        j,
        !1,
        // mustUseProperty
        L.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(L) {
      x1[L] = new O1(
        L,
        j,
        !1,
        // mustUseProperty
        L,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(L) {
      x1[L] = new O1(
        L,
        J,
        !1,
        // mustUseProperty
        L.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(L) {
      x1[L] = new O1(
        L,
        J,
        !0,
        // mustUseProperty
        L,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(L) {
      x1[L] = new O1(
        L,
        i1,
        !1,
        // mustUseProperty
        L,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(L) {
      x1[L] = new O1(
        L,
        T1,
        !1,
        // mustUseProperty
        L,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(L) {
      x1[L] = new O1(
        L,
        t1,
        !1,
        // mustUseProperty
        L.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var u1 = /[\-\:]([a-z])/g, H1 = function(L) {
      return L[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(L) {
      var x = L.replace(u1, H1);
      x1[x] = new O1(
        x,
        z,
        !1,
        // mustUseProperty
        L,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(L) {
      var x = L.replace(u1, H1);
      x1[x] = new O1(
        x,
        z,
        !1,
        // mustUseProperty
        L,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(L) {
      var x = L.replace(u1, H1);
      x1[x] = new O1(
        x,
        z,
        !1,
        // mustUseProperty
        L,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(L) {
      x1[L] = new O1(
        L,
        z,
        !1,
        // mustUseProperty
        L.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var D1 = "xlinkHref";
    x1[D1] = new O1(
      "xlinkHref",
      z,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(L) {
      x1[L] = new O1(
        L,
        z,
        !1,
        // mustUseProperty
        L.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var w1 = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function E1(L, x) {
      return L + x.charAt(0).toUpperCase() + x.substring(1);
    }
    var A1 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(w1).forEach(function(L) {
      A1.forEach(function(x) {
        w1[E1(x, L)] = w1[L];
      });
    });
    var R1 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Z1(L, x) {
      R1[x.type] || x.onChange || x.onInput || x.readOnly || x.disabled || x.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), x.onChange || x.readOnly || x.disabled || x.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function r2(L, x) {
      if (L.indexOf("-") === -1)
        return typeof x.is == "string";
      switch (L) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var I2 = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, X1 = {}, x2 = new RegExp("^(aria)-[" + f1 + "]*$"), R2 = new RegExp("^(aria)[A-Z][" + f1 + "]*$");
    function f3(L, x) {
      {
        if (k.call(X1, x) && X1[x])
          return !0;
        if (R2.test(x)) {
          var A = "aria-" + x.slice(4).toLowerCase(), P = I2.hasOwnProperty(A) ? A : null;
          if (P == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", x), X1[x] = !0, !0;
          if (x !== P)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", x, P), X1[x] = !0, !0;
        }
        if (x2.test(x)) {
          var U = x.toLowerCase(), r1 = I2.hasOwnProperty(U) ? U : null;
          if (r1 == null)
            return X1[x] = !0, !1;
          if (x !== r1)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", x, r1), X1[x] = !0, !0;
        }
      }
      return !0;
    }
    function q2(L, x) {
      {
        var A = [];
        for (var P in x) {
          var U = f3(L, P);
          U || A.push(P);
        }
        var r1 = A.map(function(Q1) {
          return "`" + Q1 + "`";
        }).join(", ");
        A.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", r1, L) : A.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", r1, L);
      }
    }
    function V2(L, x) {
      r2(L, x) || q2(L, x);
    }
    var n2 = !1;
    function A3(L, x) {
      {
        if (L !== "input" && L !== "textarea" && L !== "select")
          return;
        x != null && x.value === null && !n2 && (n2 = !0, L === "select" && x.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", L) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", L));
      }
    }
    var g1 = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, S1 = function() {
    };
    {
      var G = {}, u2 = /^on./, L2 = /^on[^A-Z]/, J2 = new RegExp("^(aria)-[" + f1 + "]*$"), C3 = new RegExp("^(aria)[A-Z][" + f1 + "]*$");
      S1 = function(L, x, A, P) {
        if (k.call(G, x) && G[x])
          return !0;
        var U = x.toLowerCase();
        if (U === "onfocusin" || U === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), G[x] = !0, !0;
        if (P != null) {
          var r1 = P.registrationNameDependencies, Q1 = P.possibleRegistrationNames;
          if (r1.hasOwnProperty(x))
            return !0;
          var v1 = Q1.hasOwnProperty(U) ? Q1[U] : null;
          if (v1 != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", x, v1), G[x] = !0, !0;
          if (u2.test(x))
            return i("Unknown event handler property `%s`. It will be ignored.", x), G[x] = !0, !0;
        } else if (u2.test(x))
          return L2.test(x) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", x), G[x] = !0, !0;
        if (J2.test(x) || C3.test(x))
          return !0;
        if (U === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), G[x] = !0, !0;
        if (U === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), G[x] = !0, !0;
        if (U === "is" && A !== null && A !== void 0 && typeof A != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof A), G[x] = !0, !0;
        if (typeof A == "number" && isNaN(A))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", x), G[x] = !0, !0;
        var h = N1(x), g = h !== null && h.type === $;
        if (g1.hasOwnProperty(U)) {
          var O = g1[U];
          if (O !== x)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", x, O), G[x] = !0, !0;
        } else if (!g && x !== U)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", x, U), G[x] = !0, !0;
        return typeof A == "boolean" && q(x, A, h, !1) ? (A ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', A, x, x, A, x) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', A, x, x, A, x, x, x), G[x] = !0, !0) : g ? !0 : q(x, A, h, !1) ? (G[x] = !0, !1) : ((A === "false" || A === "true") && h !== null && h.type === J && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", A, x, A === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', x, A), G[x] = !0), !0);
      };
    }
    var l3 = function(L, x, A) {
      {
        var P = [];
        for (var U in x) {
          var r1 = S1(L, U, x[U], A);
          r1 || P.push(U);
        }
        var Q1 = P.map(function(v1) {
          return "`" + v1 + "`";
        }).join(", ");
        P.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Q1, L) : P.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Q1, L);
      }
    };
    function z3(L, x, A) {
      r2(L, x) || l3(L, x, A);
    }
    var D3 = function() {
    };
    {
      var $2 = /^(?:webkit|moz|o)[A-Z]/, V3 = /^-ms-/, y3 = /-(.)/g, u3 = /;\s*$/, k3 = {}, x3 = {}, H2 = !1, j3 = !1, v4 = function(L) {
        return L.replace(y3, function(x, A) {
          return A.toUpperCase();
        });
      }, L4 = function(L) {
        k3.hasOwnProperty(L) && k3[L] || (k3[L] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          L,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          v4(L.replace(V3, "ms-"))
        ));
      }, I3 = function(L) {
        k3.hasOwnProperty(L) && k3[L] || (k3[L] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", L, L.charAt(0).toUpperCase() + L.slice(1)));
      }, S4 = function(L, x) {
        x3.hasOwnProperty(x) && x3[x] || (x3[x] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, L, x.replace(u3, "")));
      }, $3 = function(L, x) {
        H2 || (H2 = !0, i("`NaN` is an invalid value for the `%s` css style property.", L));
      }, Z2 = function(L, x) {
        j3 || (j3 = !0, i("`Infinity` is an invalid value for the `%s` css style property.", L));
      };
      D3 = function(L, x) {
        L.indexOf("-") > -1 ? L4(L) : $2.test(L) ? I3(L) : u3.test(x) && S4(L, x), typeof x == "number" && (isNaN(x) ? $3(L, x) : isFinite(x) || Z2(L, x));
      };
    }
    var $4 = D3, Z4 = /["'&<>]/;
    function W4(L) {
      D(L);
      var x = "" + L, A = Z4.exec(x);
      if (!A)
        return x;
      var P, U = "", r1, Q1 = 0;
      for (r1 = A.index; r1 < x.length; r1++) {
        switch (x.charCodeAt(r1)) {
          case 34:
            P = "&quot;";
            break;
          case 38:
            P = "&amp;";
            break;
          case 39:
            P = "&#x27;";
            break;
          case 60:
            P = "&lt;";
            break;
          case 62:
            P = "&gt;";
            break;
          default:
            continue;
        }
        Q1 !== r1 && (U += x.substring(Q1, r1)), Q1 = r1 + 1, U += P;
      }
      return Q1 !== r1 ? U + x.substring(Q1, r1) : U;
    }
    function Y2(L) {
      return typeof L == "boolean" || typeof L == "number" ? "" + L : W4(L);
    }
    var G4 = /([A-Z])/g, M6 = /^ms-/;
    function w6(L) {
      return L.replace(G4, "-$1").toLowerCase().replace(M6, "-ms-");
    }
    var n1 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, _1 = !1;
    function P1(L) {
      !_1 && n1.test(L) && (_1 = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(L)));
    }
    var J1 = Array.isArray;
    function h2(L) {
      return J1(L);
    }
    var v2 = v("<script>"), m2 = v("<\/script>"), s2 = v('<script src="'), K2 = v('<script type="module" src="'), w2 = v('" async=""><\/script>');
    function S2(L) {
      return D(L), ("" + L).replace(U2, _3);
    }
    var U2 = /(<\/|<)(s)(cript)/gi, _3 = function(L, x, A, P) {
      return "" + x + (A === "s" ? "\\u0073" : "\\u0053") + P;
    };
    function n4(L, x, A, P, U) {
      var r1 = L === void 0 ? "" : L, Q1 = x === void 0 ? v2 : v('<script nonce="' + Y2(x) + '">'), v1 = [];
      if (A !== void 0 && v1.push(Q1, p(S2(A)), m2), P !== void 0)
        for (var h = 0; h < P.length; h++)
          v1.push(s2, p(Y2(P[h])), w2);
      if (U !== void 0)
        for (var g = 0; g < U.length; g++)
          v1.push(K2, p(Y2(U[g])), w2);
      return {
        bootstrapChunks: v1,
        startInlineScript: Q1,
        placeholderPrefix: v(r1 + "P:"),
        segmentPrefix: v(r1 + "S:"),
        boundaryPrefix: r1 + "B:",
        idPrefix: r1,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var e3 = 0, t3 = 1, i4 = 2, U3 = 3, d3 = 4, s6 = 5, o4 = 6, a4 = 7;
    function O3(L, x) {
      return {
        insertionMode: L,
        selectedValue: x
      };
    }
    function y4(L) {
      var x = L === "http://www.w3.org/2000/svg" ? i4 : L === "http://www.w3.org/1998/Math/MathML" ? U3 : e3;
      return O3(x, null);
    }
    function C4(L, x, A) {
      switch (x) {
        case "select":
          return O3(t3, A.value != null ? A.value : A.defaultValue);
        case "svg":
          return O3(i4, null);
        case "math":
          return O3(U3, null);
        case "foreignObject":
          return O3(t3, null);
        case "table":
          return O3(d3, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return O3(s6, null);
        case "colgroup":
          return O3(a4, null);
        case "tr":
          return O3(o4, null);
      }
      return L.insertionMode >= d3 || L.insertionMode === e3 ? O3(t3, null) : L;
    }
    var S6 = null;
    function C6(L) {
      var x = L.nextSuspenseID++;
      return v(L.boundaryPrefix + x.toString(16));
    }
    function l6(L, x, A) {
      var P = L.idPrefix, U = ":" + P + "R" + x;
      return A > 0 && (U += "H" + A.toString(32)), U + ":";
    }
    function V4(L) {
      return Y2(L);
    }
    var V6 = v("<!-- -->");
    function u6(L, x, A, P) {
      return x === "" ? P : (P && L.push(V6), L.push(p(V4(x))), !0);
    }
    function c6(L, x, A, P) {
      A && P && L.push(V6);
    }
    var V = /* @__PURE__ */ new Map();
    function R(L) {
      var x = V.get(L);
      if (x !== void 0)
        return x;
      var A = v(Y2(w6(L)));
      return V.set(L, A), A;
    }
    var W = v(' style="'), Y = v(":"), h1 = v(";");
    function c1(L, x, A) {
      if (typeof A != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var P = !0;
      for (var U in A)
        if (k.call(A, U)) {
          var r1 = A[U];
          if (!(r1 == null || typeof r1 == "boolean" || r1 === "")) {
            var Q1 = void 0, v1 = void 0, h = U.indexOf("--") === 0;
            h ? (Q1 = p(Y2(U)), S(r1, U), v1 = p(Y2(("" + r1).trim()))) : ($4(U, r1), Q1 = R(U), typeof r1 == "number" ? r1 !== 0 && !k.call(w1, U) ? v1 = p(r1 + "px") : v1 = p("" + r1) : (S(r1, U), v1 = p(Y2(("" + r1).trim())))), P ? (P = !1, L.push(W, Q1, Y, v1)) : L.push(h1, Q1, Y, v1);
          }
        }
      P || L.push(z1);
    }
    var y1 = v(" "), k1 = v('="'), z1 = v('"'), K1 = v('=""');
    function q1(L, x, A, P) {
      switch (A) {
        case "style": {
          c1(L, x, P);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(A.length > 2 && (A[0] === "o" || A[0] === "O") && (A[1] === "n" || A[1] === "N"))
      ) {
        var U = N1(A);
        if (U !== null) {
          switch (typeof P) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!U.acceptsBooleans)
                return;
          }
          var r1 = U.attributeName, Q1 = p(r1);
          switch (U.type) {
            case J:
              P && L.push(y1, Q1, K1);
              return;
            case i1:
              P === !0 ? L.push(y1, Q1, K1) : P === !1 || L.push(y1, Q1, k1, p(Y2(P)), z1);
              return;
            case t1:
              isNaN(P) || L.push(y1, Q1, k1, p(Y2(P)), z1);
              break;
            case T1:
              !isNaN(P) && P >= 1 && L.push(y1, Q1, k1, p(Y2(P)), z1);
              break;
            default:
              U.sanitizeURL && (w(P, r1), P = "" + P, P1(P)), L.push(y1, Q1, k1, p(Y2(P)), z1);
          }
        } else if (C1(A)) {
          switch (typeof P) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var v1 = A.toLowerCase().slice(0, 5);
              if (v1 !== "data-" && v1 !== "aria-")
                return;
            }
          }
          L.push(y1, p(A), k1, p(Y2(P)), z1);
        }
      }
    }
    var E2 = v(">"), R3 = v("/>");
    function H3(L, x, A) {
      if (x != null) {
        if (A != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof x != "object" || !("__html" in x))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var P = x.__html;
        P != null && (D(P), L.push(p("" + P)));
      }
    }
    var E3 = !1, g4 = !1, X3 = !1, f6 = !1, _4 = !1, z4 = !1, x4 = !1;
    function _6(L, x) {
      {
        var A = L[x];
        if (A != null) {
          var P = h2(A);
          L.multiple && !P ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", x) : !L.multiple && P && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", x);
        }
      }
    }
    function $0(L, x, A) {
      Z1("select", x), _6(x, "value"), _6(x, "defaultValue"), x.value !== void 0 && x.defaultValue !== void 0 && !X3 && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), X3 = !0), L.push(q3("select"));
      var P = null, U = null;
      for (var r1 in x)
        if (k.call(x, r1)) {
          var Q1 = x[r1];
          if (Q1 == null)
            continue;
          switch (r1) {
            case "children":
              P = Q1;
              break;
            case "dangerouslySetInnerHTML":
              U = Q1;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              q1(L, A, r1, Q1);
              break;
          }
        }
      return L.push(E2), H3(L, U, P), P;
    }
    function Z0(L) {
      var x = "";
      return e.Children.forEach(L, function(A) {
        A != null && (x += A, !_4 && typeof A != "string" && typeof A != "number" && (_4 = !0, i("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), x;
    }
    var G5 = v(' selected=""');
    function W0(L, x, A, P) {
      var U = P.selectedValue;
      L.push(q3("option"));
      var r1 = null, Q1 = null, v1 = null, h = null;
      for (var g in x)
        if (k.call(x, g)) {
          var O = x[g];
          if (O == null)
            continue;
          switch (g) {
            case "children":
              r1 = O;
              break;
            case "selected":
              v1 = O, x4 || (i("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), x4 = !0);
              break;
            case "dangerouslySetInnerHTML":
              h = O;
              break;
            case "value":
              Q1 = O;
            default:
              q1(L, A, g, O);
              break;
          }
        }
      if (U != null) {
        var I;
        if (Q1 !== null ? (w(Q1, "value"), I = "" + Q1) : (h !== null && (z4 || (z4 = !0, i("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), I = Z0(r1)), h2(U))
          for (var B = 0; B < U.length; B++) {
            w(U[B], "value");
            var e1 = "" + U[B];
            if (e1 === I) {
              L.push(G5);
              break;
            }
          }
        else
          w(U, "select.value"), "" + U === I && L.push(G5);
      } else
        v1 && L.push(G5);
      return L.push(E2), H3(L, h, r1), r1;
    }
    function z5(L, x, A) {
      Z1("input", x), x.checked !== void 0 && x.defaultChecked !== void 0 && !g4 && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", x.type), g4 = !0), x.value !== void 0 && x.defaultValue !== void 0 && !E3 && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", x.type), E3 = !0), L.push(q3("input"));
      var P = null, U = null, r1 = null, Q1 = null;
      for (var v1 in x)
        if (k.call(x, v1)) {
          var h = x[v1];
          if (h == null)
            continue;
          switch (v1) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              Q1 = h;
              break;
            case "defaultValue":
              U = h;
              break;
            case "checked":
              r1 = h;
              break;
            case "value":
              P = h;
              break;
            default:
              q1(L, A, v1, h);
              break;
          }
        }
      return r1 !== null ? q1(L, A, "checked", r1) : Q1 !== null && q1(L, A, "checked", Q1), P !== null ? q1(L, A, "value", P) : U !== null && q1(L, A, "value", U), L.push(R3), null;
    }
    function H4(L, x, A) {
      Z1("textarea", x), x.value !== void 0 && x.defaultValue !== void 0 && !f6 && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), f6 = !0), L.push(q3("textarea"));
      var P = null, U = null, r1 = null;
      for (var Q1 in x)
        if (k.call(x, Q1)) {
          var v1 = x[Q1];
          if (v1 == null)
            continue;
          switch (Q1) {
            case "children":
              r1 = v1;
              break;
            case "value":
              P = v1;
              break;
            case "defaultValue":
              U = v1;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              q1(L, A, Q1, v1);
              break;
          }
        }
      if (P === null && U !== null && (P = U), L.push(E2), r1 != null) {
        if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), P != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (h2(r1)) {
          if (r1.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          D(r1[0]), P = "" + r1[0];
        }
        D(r1), P = "" + r1;
      }
      return typeof P == "string" && P[0] === `
` && L.push(U4), P !== null && (w(P, "value"), L.push(p(V4("" + P)))), null;
    }
    function O6(L, x, A, P) {
      L.push(q3(A));
      for (var U in x)
        if (k.call(x, U)) {
          var r1 = x[U];
          if (r1 == null)
            continue;
          switch (U) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(A + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              q1(L, P, U, r1);
              break;
          }
        }
      return L.push(R3), null;
    }
    function o5(L, x, A) {
      L.push(q3("menuitem"));
      for (var P in x)
        if (k.call(x, P)) {
          var U = x[P];
          if (U == null)
            continue;
          switch (P) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              q1(L, A, P, U);
              break;
          }
        }
      return L.push(E2), null;
    }
    function N2(L, x, A) {
      L.push(q3("title"));
      var P = null;
      for (var U in x)
        if (k.call(x, U)) {
          var r1 = x[U];
          if (r1 == null)
            continue;
          switch (U) {
            case "children":
              P = r1;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              q1(L, A, U, r1);
              break;
          }
        }
      L.push(E2);
      {
        var Q1 = Array.isArray(P) && P.length < 2 ? P[0] || null : P;
        Array.isArray(P) && P.length > 1 ? i("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : Q1 != null && Q1.$$typeof != null ? i("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : Q1 != null && typeof Q1 != "string" && typeof Q1 != "number" && i("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return P;
    }
    function O4(L, x, A, P) {
      L.push(q3(A));
      var U = null, r1 = null;
      for (var Q1 in x)
        if (k.call(x, Q1)) {
          var v1 = x[Q1];
          if (v1 == null)
            continue;
          switch (Q1) {
            case "children":
              U = v1;
              break;
            case "dangerouslySetInnerHTML":
              r1 = v1;
              break;
            default:
              q1(L, P, Q1, v1);
              break;
          }
        }
      return L.push(E2), H3(L, r1, U), typeof U == "string" ? (L.push(p(V4(U))), null) : U;
    }
    function N3(L, x, A, P) {
      L.push(q3(A));
      var U = null, r1 = null;
      for (var Q1 in x)
        if (k.call(x, Q1)) {
          var v1 = x[Q1];
          if (v1 == null)
            continue;
          switch (Q1) {
            case "children":
              U = v1;
              break;
            case "dangerouslySetInnerHTML":
              r1 = v1;
              break;
            case "style":
              c1(L, P, v1);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              C1(Q1) && typeof v1 != "function" && typeof v1 != "symbol" && L.push(y1, p(Q1), k1, p(Y2(v1)), z1);
              break;
          }
        }
      return L.push(E2), H3(L, r1, U), U;
    }
    var U4 = v(`
`);
    function A4(L, x, A, P) {
      L.push(q3(A));
      var U = null, r1 = null;
      for (var Q1 in x)
        if (k.call(x, Q1)) {
          var v1 = x[Q1];
          if (v1 == null)
            continue;
          switch (Q1) {
            case "children":
              U = v1;
              break;
            case "dangerouslySetInnerHTML":
              r1 = v1;
              break;
            default:
              q1(L, P, Q1, v1);
              break;
          }
        }
      if (L.push(E2), r1 != null) {
        if (U != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof r1 != "object" || !("__html" in r1))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var h = r1.__html;
        h != null && (typeof h == "string" && h.length > 0 && h[0] === `
` ? L.push(U4, p(h)) : (D(h), L.push(p("" + h))));
      }
      return typeof U == "string" && U[0] === `
` && L.push(U4), U;
    }
    var a5 = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, D4 = /* @__PURE__ */ new Map();
    function q3(L) {
      var x = D4.get(L);
      if (x === void 0) {
        if (!a5.test(L))
          throw new Error("Invalid tag: " + L);
        x = v("<" + L), D4.set(L, x);
      }
      return x;
    }
    var U5 = v("<!DOCTYPE html>");
    function X5(L, x, A, P, U) {
      switch (V2(x, A), A3(x, A), z3(x, A, null), !A.suppressContentEditableWarning && A.contentEditable && A.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), U.insertionMode !== i4 && U.insertionMode !== U3 && x.indexOf("-") === -1 && typeof A.is != "string" && x.toLowerCase() !== x && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", x), x) {
        case "select":
          return $0(L, A, P);
        case "option":
          return W0(L, A, P, U);
        case "textarea":
          return H4(L, A, P);
        case "input":
          return z5(L, A, P);
        case "menuitem":
          return o5(L, A, P);
        case "title":
          return N2(L, A, P);
        case "listing":
        case "pre":
          return A4(L, A, x, P);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return O6(L, A, x, P);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return O4(L, A, x, P);
        case "html":
          return U.insertionMode === e3 && L.push(U5), O4(L, A, x, P);
        default:
          return x.indexOf("-") === -1 && typeof A.is != "string" ? O4(L, A, x, P) : N3(L, A, x, P);
      }
    }
    var at = v("</"), Qt = v(">");
    function Tt(L, x, A) {
      switch (x) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          L.push(at, p(x), Qt);
      }
    }
    function G0(L, x) {
      for (var A = x.bootstrapChunks, P = 0; P < A.length - 1; P++)
        l(L, A[P]);
      return P < A.length ? c(L, A[P]) : !0;
    }
    var z0 = v('<template id="'), Q5 = v('"></template>');
    function T5(L, x, A) {
      l(L, z0), l(L, x.placeholderPrefix);
      var P = p(A.toString(16));
      return l(L, P), c(L, Q5);
    }
    var s5 = v("<!--$-->"), A6 = v('<!--$?--><template id="'), U0 = v('"></template>'), D6 = v("<!--$!-->"), q5 = v("<!--/$-->"), J5 = v("<template"), d6 = v('"'), h6 = v(' data-dgst="'), l5 = v(' data-msg="'), st = v(' data-stck="'), Y5 = v("></template>");
    function lt(L, x) {
      return c(L, s5);
    }
    function u5(L, x, A) {
      if (l(L, A6), A === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(L, A), c(L, U0);
    }
    function P3(L, x, A, P, U) {
      var r1;
      return r1 = c(L, D6), l(L, J5), A && (l(L, h6), l(L, p(Y2(A))), l(L, d6)), P && (l(L, l5), l(L, p(Y2(P))), l(L, d6)), U && (l(L, st), l(L, p(Y2(U))), l(L, d6)), r1 = c(L, Y5), r1;
    }
    function ut(L, x) {
      return c(L, q5);
    }
    function c5(L, x) {
      return c(L, q5);
    }
    function X0(L, x) {
      return c(L, q5);
    }
    var ct = v('<div hidden id="'), f5 = v('">'), ft = v("</div>"), dt = v('<svg aria-hidden="true" style="display:none" id="'), d5 = v('">'), h5 = v("</svg>"), ht = v('<math aria-hidden="true" style="display:none" id="'), pt = v('">'), mt = v("</math>"), K5 = v('<table hidden id="'), vt = v('">'), _ = v("</table>"), N = v('<table hidden><tbody id="'), F = v('">'), K = v("</tbody></table>"), p1 = v('<table hidden><tr id="'), d1 = v('">'), b1 = v("</tr></table>"), I1 = v('<table hidden><colgroup id="'), e2 = v('">'), p2 = v("</colgroup></table>");
    function c2(L, x, A, P) {
      switch (A.insertionMode) {
        case e3:
        case t3:
          return l(L, ct), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, f5);
        case i4:
          return l(L, dt), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, d5);
        case U3:
          return l(L, ht), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, pt);
        case d3:
          return l(L, K5), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, vt);
        case s6:
          return l(L, N), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, F);
        case o4:
          return l(L, p1), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, d1);
        case a4:
          return l(L, I1), l(L, x.segmentPrefix), l(L, p(P.toString(16))), c(L, e2);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function F2(L, x) {
      switch (x.insertionMode) {
        case e3:
        case t3:
          return c(L, ft);
        case i4:
          return c(L, h5);
        case U3:
          return c(L, mt);
        case d3:
          return c(L, _);
        case s6:
          return c(L, K);
        case o4:
          return c(L, b1);
        case a4:
          return c(L, p2);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var B3 = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", J3 = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', Y3 = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', p5 = v(B3 + ';$RS("'), Lt = v('$RS("'), ee = v('","'), ca = v('")<\/script>');
    function fa(L, x, A) {
      l(L, x.startInlineScript), x.sentCompleteSegmentFunction ? l(L, Lt) : (x.sentCompleteSegmentFunction = !0, l(L, p5)), l(L, x.segmentPrefix);
      var P = p(A.toString(16));
      return l(L, P), l(L, ee), l(L, x.placeholderPrefix), l(L, P), c(L, ca);
    }
    var da = v(J3 + ';$RC("'), ha = v('$RC("'), pa = v('","'), ma = v('")<\/script>');
    function q0(L, x, A, P) {
      if (l(L, x.startInlineScript), x.sentCompleteBoundaryFunction ? l(L, ha) : (x.sentCompleteBoundaryFunction = !0, l(L, da)), A === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var U = p(P.toString(16));
      return l(L, A), l(L, pa), l(L, x.segmentPrefix), l(L, U), c(L, ma);
    }
    var va = v(Y3 + ';$RX("'), La = v('$RX("'), J0 = v('"'), ya = v(")<\/script>"), Y0 = v(",");
    function y8(L, x, A, P, U, r1) {
      if (l(L, x.startInlineScript), x.sentClientRenderFunction ? l(L, La) : (x.sentClientRenderFunction = !0, l(L, va)), A === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return l(L, A), l(L, J0), (P || U || r1) && (l(L, Y0), l(L, p(K0(P || "")))), (U || r1) && (l(L, Y0), l(L, p(K0(U || "")))), r1 && (l(L, Y0), l(L, p(K0(r1)))), c(L, ya);
    }
    var g8 = /[<\u2028\u2029]/g;
    function K0(L) {
      var x = JSON.stringify(L);
      return x.replace(g8, function(A) {
        switch (A) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var Q4 = Object.assign, ga = Symbol.for("react.element"), x8 = Symbol.for("react.portal"), K3 = Symbol.for("react.fragment"), H8 = Symbol.for("react.strict_mode"), e7 = Symbol.for("react.profiler"), yt = Symbol.for("react.provider"), gt = Symbol.for("react.context"), xt = Symbol.for("react.forward_ref"), te = Symbol.for("react.suspense"), re = Symbol.for("react.suspense_list"), ne = Symbol.for("react.memo"), m5 = Symbol.for("react.lazy"), t7 = Symbol.for("react.scope"), r7 = Symbol.for("react.debug_trace_mode"), Ht = Symbol.for("react.legacy_hidden"), xa = Symbol.for("react.default_value"), E8 = Symbol.iterator, Ha = "@@iterator";
    function Ea(L) {
      if (L === null || typeof L != "object")
        return null;
      var x = E8 && L[E8] || L[Ha];
      return typeof x == "function" ? x : null;
    }
    function b8(L, x, A) {
      var P = L.displayName;
      if (P)
        return P;
      var U = x.displayName || x.name || "";
      return U !== "" ? A + "(" + U + ")" : A;
    }
    function M8(L) {
      return L.displayName || "Context";
    }
    function i3(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && i("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case K3:
          return "Fragment";
        case x8:
          return "Portal";
        case e7:
          return "Profiler";
        case H8:
          return "StrictMode";
        case te:
          return "Suspense";
        case re:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case gt:
            var x = L;
            return M8(x) + ".Consumer";
          case yt:
            var A = L;
            return M8(A._context) + ".Provider";
          case xt:
            return b8(L, L.render, "ForwardRef");
          case ne:
            var P = L.displayName || null;
            return P !== null ? P : i3(L.type) || "Memo";
          case m5: {
            var U = L, r1 = U._payload, Q1 = U._init;
            try {
              return i3(Q1(r1));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ie = 0, n7, r3, v5, i7, o7, a7, Q7;
    function T7() {
    }
    T7.__reactDisabledLog = !0;
    function w8() {
      {
        if (ie === 0) {
          n7 = console.log, r3 = console.info, v5 = console.warn, i7 = console.error, o7 = console.group, a7 = console.groupCollapsed, Q7 = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: T7,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        ie++;
      }
    }
    function S8() {
      {
        if (ie--, ie === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q4({}, L, {
              value: n7
            }),
            info: Q4({}, L, {
              value: r3
            }),
            warn: Q4({}, L, {
              value: v5
            }),
            error: Q4({}, L, {
              value: i7
            }),
            group: Q4({}, L, {
              value: o7
            }),
            groupCollapsed: Q4({}, L, {
              value: a7
            }),
            groupEnd: Q4({}, L, {
              value: Q7
            })
          });
        }
        ie < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Et = r.ReactCurrentDispatcher, s7;
    function oe(L, x, A) {
      {
        if (s7 === void 0)
          try {
            throw Error();
          } catch (U) {
            var P = U.stack.trim().match(/\n( *(at )?)/);
            s7 = P && P[1] || "";
          }
        return `
` + s7 + L;
      }
    }
    var ae = !1, L5;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      L5 = new Qe();
    }
    function Te(L, x) {
      if (!L || ae)
        return "";
      {
        var A = L5.get(L);
        if (A !== void 0)
          return A;
      }
      var P;
      ae = !0;
      var U = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var r1;
      r1 = Et.current, Et.current = null, w8();
      try {
        if (x) {
          var Q1 = function() {
            throw Error();
          };
          if (Object.defineProperty(Q1.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Q1, []);
            } catch (o1) {
              P = o1;
            }
            Reflect.construct(L, [], Q1);
          } else {
            try {
              Q1.call();
            } catch (o1) {
              P = o1;
            }
            L.call(Q1.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (o1) {
            P = o1;
          }
          L();
        }
      } catch (o1) {
        if (o1 && P && typeof o1.stack == "string") {
          for (var v1 = o1.stack.split(`
`), h = P.stack.split(`
`), g = v1.length - 1, O = h.length - 1; g >= 1 && O >= 0 && v1[g] !== h[O]; )
            O--;
          for (; g >= 1 && O >= 0; g--, O--)
            if (v1[g] !== h[O]) {
              if (g !== 1 || O !== 1)
                do
                  if (g--, O--, O < 0 || v1[g] !== h[O]) {
                    var I = `
` + v1[g].replace(" at new ", " at ");
                    return L.displayName && I.includes("<anonymous>") && (I = I.replace("<anonymous>", L.displayName)), typeof L == "function" && L5.set(L, I), I;
                  }
                while (g >= 1 && O >= 0);
              break;
            }
        }
      } finally {
        ae = !1, Et.current = r1, S8(), Error.prepareStackTrace = U;
      }
      var B = L ? L.displayName || L.name : "", e1 = B ? oe(B) : "";
      return typeof L == "function" && L5.set(L, e1), e1;
    }
    function bt(L, x, A) {
      return Te(L, !0);
    }
    function C8(L, x, A) {
      return Te(L, !1);
    }
    function l7(L) {
      var x = L.prototype;
      return !!(x && x.isReactComponent);
    }
    function u7(L, x, A) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return Te(L, l7(L));
      if (typeof L == "string")
        return oe(L);
      switch (L) {
        case te:
          return oe("Suspense");
        case re:
          return oe("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case xt:
            return C8(L.render);
          case ne:
            return u7(L.type, x, A);
          case m5: {
            var P = L, U = P._payload, r1 = P._init;
            try {
              return u7(r1(U), x, A);
            } catch {
            }
          }
        }
      return "";
    }
    var c7 = {}, V8 = r.ReactDebugCurrentFrame;
    function y5(L) {
      if (L) {
        var x = L._owner, A = u7(L.type, L._source, x ? x.type : null);
        V8.setExtraStackFrame(A);
      } else
        V8.setExtraStackFrame(null);
    }
    function f7(L, x, A, P, U) {
      {
        var r1 = Function.call.bind(k);
        for (var Q1 in L)
          if (r1(L, Q1)) {
            var v1 = void 0;
            try {
              if (typeof L[Q1] != "function") {
                var h = Error((P || "React class") + ": " + A + " type `" + Q1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[Q1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw h.name = "Invariant Violation", h;
              }
              v1 = L[Q1](x, Q1, P, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (g) {
              v1 = g;
            }
            v1 && !(v1 instanceof Error) && (y5(U), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", P || "React class", A, Q1, typeof v1), y5(null)), v1 instanceof Error && !(v1.message in c7) && (c7[v1.message] = !0, y5(U), i("Failed %s type: %s", A, v1.message), y5(null));
          }
      }
    }
    var Mt;
    Mt = {};
    var k6 = {};
    Object.freeze(k6);
    function d7(L, x) {
      {
        var A = L.contextTypes;
        if (!A)
          return k6;
        var P = {};
        for (var U in A)
          P[U] = x[U];
        {
          var r1 = i3(L) || "Unknown";
          f7(A, P, "context", r1);
        }
        return P;
      }
    }
    function h7(L, x, A, P) {
      {
        if (typeof L.getChildContext != "function") {
          {
            var U = i3(x) || "Unknown";
            Mt[U] || (Mt[U] = !0, i("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", U, U));
          }
          return A;
        }
        var r1 = L.getChildContext();
        for (var Q1 in r1)
          if (!(Q1 in P))
            throw new Error((i3(x) || "Unknown") + '.getChildContext(): key "' + Q1 + '" is not defined in childContextTypes.');
        {
          var v1 = i3(x) || "Unknown";
          f7(P, r1, "child context", v1);
        }
        return Q4({}, A, r1);
      }
    }
    var p6;
    p6 = {};
    var _8 = null, I6 = null;
    function R6(L) {
      L.context._currentValue = L.parentValue;
    }
    function p7(L) {
      L.context._currentValue = L.value;
    }
    function k4(L, x) {
      if (L !== x) {
        R6(L);
        var A = L.parent, P = x.parent;
        if (A === null) {
          if (P !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (P === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          k4(A, P);
        }
        p7(x);
      }
    }
    function wt(L) {
      R6(L);
      var x = L.parent;
      x !== null && wt(x);
    }
    function St(L) {
      var x = L.parent;
      x !== null && St(x), p7(L);
    }
    function se(L, x) {
      R6(L);
      var A = L.parent;
      if (A === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      A.depth === x.depth ? k4(A, x) : se(A, x);
    }
    function m7(L, x) {
      var A = x.parent;
      if (A === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      L.depth === A.depth ? k4(L, A) : m7(L, A), p7(x);
    }
    function le(L) {
      var x = I6, A = L;
      x !== A && (x === null ? St(A) : A === null ? wt(x) : x.depth === A.depth ? k4(x, A) : x.depth > A.depth ? se(x, A) : m7(x, A), I6 = A);
    }
    function O8(L, x) {
      var A;
      A = L._currentValue, L._currentValue = x, L._currentRenderer !== void 0 && L._currentRenderer !== null && L._currentRenderer !== p6 && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), L._currentRenderer = p6;
      var P = I6, U = {
        parent: P,
        depth: P === null ? 0 : P.depth + 1,
        context: L,
        parentValue: A,
        value: x
      };
      return I6 = U, U;
    }
    function A8(L) {
      var x = I6;
      if (x === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      x.context !== L && i("The parent context is not the expected context. This is probably a bug in React.");
      {
        var A = x.parentValue;
        A === xa ? x.context._currentValue = x.context._defaultValue : x.context._currentValue = A, L._currentRenderer !== void 0 && L._currentRenderer !== null && L._currentRenderer !== p6 && i("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), L._currentRenderer = p6;
      }
      return I6 = x.parent;
    }
    function Ct() {
      return I6;
    }
    function ue(L) {
      var x = L._currentValue;
      return x;
    }
    function v7(L) {
      return L._reactInternals;
    }
    function ba(L, x) {
      L._reactInternals = x;
    }
    var g5 = {}, Vt = {}, L7, _t, Ot, ce, At, x5, fe, Dt, H5;
    {
      L7 = /* @__PURE__ */ new Set(), _t = /* @__PURE__ */ new Set(), Ot = /* @__PURE__ */ new Set(), fe = /* @__PURE__ */ new Set(), ce = /* @__PURE__ */ new Set(), Dt = /* @__PURE__ */ new Set(), H5 = /* @__PURE__ */ new Set();
      var kt = /* @__PURE__ */ new Set();
      x5 = function(L, x) {
        if (!(L === null || typeof L == "function")) {
          var A = x + "_" + L;
          kt.has(A) || (kt.add(A), i("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", x, L));
        }
      }, At = function(L, x) {
        if (x === void 0) {
          var A = i3(L) || "Component";
          ce.has(A) || (ce.add(A), i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", A));
        }
      };
    }
    function It(L, x) {
      {
        var A = L.constructor, P = A && i3(A) || "ReactClass", U = P + "." + x;
        if (g5[U])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, x, x, P), g5[U] = !0;
      }
    }
    var Rt = {
      isMounted: function(L) {
        return !1;
      },
      enqueueSetState: function(L, x, A) {
        var P = v7(L);
        P.queue === null ? It(L, "setState") : (P.queue.push(x), A != null && x5(A, "setState"));
      },
      enqueueReplaceState: function(L, x, A) {
        var P = v7(L);
        P.replace = !0, P.queue = [x], A != null && x5(A, "setState");
      },
      enqueueForceUpdate: function(L, x) {
        var A = v7(L);
        A.queue === null ? It(L, "forceUpdate") : x != null && x5(x, "setState");
      }
    };
    function D8(L, x, A, P, U) {
      var r1 = A(U, P);
      At(x, r1);
      var Q1 = r1 == null ? P : Q4({}, P, r1);
      return Q1;
    }
    function k8(L, x, A) {
      var P = k6, U = L.contextType;
      if ("contextType" in L) {
        var r1 = (
          // Allow null for conditional declaration
          U === null || U !== void 0 && U.$$typeof === gt && U._context === void 0
        );
        if (!r1 && !H5.has(L)) {
          H5.add(L);
          var Q1 = "";
          U === void 0 ? Q1 = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof U != "object" ? Q1 = " However, it is set to a " + typeof U + "." : U.$$typeof === yt ? Q1 = " Did you accidentally pass the Context.Provider instead?" : U._context !== void 0 ? Q1 = " Did you accidentally pass the Context.Consumer instead?" : Q1 = " However, it is set to an object with keys {" + Object.keys(U).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", i3(L) || "Component", Q1);
        }
      }
      typeof U == "object" && U !== null ? P = ue(U) : P = A;
      var v1 = new L(x, P);
      {
        if (typeof L.getDerivedStateFromProps == "function" && (v1.state === null || v1.state === void 0)) {
          var h = i3(L) || "Component";
          L7.has(h) || (L7.add(h), i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", h, v1.state === null ? "null" : "undefined", h));
        }
        if (typeof L.getDerivedStateFromProps == "function" || typeof v1.getSnapshotBeforeUpdate == "function") {
          var g = null, O = null, I = null;
          if (typeof v1.componentWillMount == "function" && v1.componentWillMount.__suppressDeprecationWarning !== !0 ? g = "componentWillMount" : typeof v1.UNSAFE_componentWillMount == "function" && (g = "UNSAFE_componentWillMount"), typeof v1.componentWillReceiveProps == "function" && v1.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? O = "componentWillReceiveProps" : typeof v1.UNSAFE_componentWillReceiveProps == "function" && (O = "UNSAFE_componentWillReceiveProps"), typeof v1.componentWillUpdate == "function" && v1.componentWillUpdate.__suppressDeprecationWarning !== !0 ? I = "componentWillUpdate" : typeof v1.UNSAFE_componentWillUpdate == "function" && (I = "UNSAFE_componentWillUpdate"), g !== null || O !== null || I !== null) {
            var B = i3(L) || "Component", e1 = typeof L.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Ot.has(B) || (Ot.add(B), i(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, B, e1, g !== null ? `
  ` + g : "", O !== null ? `
  ` + O : "", I !== null ? `
  ` + I : ""));
          }
        }
      }
      return v1;
    }
    function I8(L, x, A) {
      {
        var P = i3(x) || "Component", U = L.render;
        U || (x.prototype && typeof x.prototype.render == "function" ? i("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", P) : i("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", P)), L.getInitialState && !L.getInitialState.isReactClassApproved && !L.state && i("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", P), L.getDefaultProps && !L.getDefaultProps.isReactClassApproved && i("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", P), L.propTypes && i("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", P), L.contextType && i("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", P), L.contextTypes && i("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", P), x.contextType && x.contextTypes && !Dt.has(x) && (Dt.add(x), i("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", P)), typeof L.componentShouldUpdate == "function" && i("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", P), x.prototype && x.prototype.isPureReactComponent && typeof L.shouldComponentUpdate < "u" && i("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", i3(x) || "A pure component"), typeof L.componentDidUnmount == "function" && i("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", P), typeof L.componentDidReceiveProps == "function" && i("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", P), typeof L.componentWillRecieveProps == "function" && i("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", P), typeof L.UNSAFE_componentWillRecieveProps == "function" && i("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", P);
        var r1 = L.props !== A;
        L.props !== void 0 && r1 && i("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", P, P), L.defaultProps && i("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", P, P), typeof L.getSnapshotBeforeUpdate == "function" && typeof L.componentDidUpdate != "function" && !_t.has(x) && (_t.add(x), i("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", i3(x))), typeof L.getDerivedStateFromProps == "function" && i("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", P), typeof L.getDerivedStateFromError == "function" && i("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", P), typeof x.getSnapshotBeforeUpdate == "function" && i("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", P);
        var Q1 = L.state;
        Q1 && (typeof Q1 != "object" || h2(Q1)) && i("%s.state: must be set to an object or null", P), typeof L.getChildContext == "function" && typeof x.childContextTypes != "object" && i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", P);
      }
    }
    function Ma(L, x) {
      var A = x.state;
      if (typeof x.componentWillMount == "function") {
        if (x.componentWillMount.__suppressDeprecationWarning !== !0) {
          var P = i3(L) || "Unknown";
          Vt[P] || (n(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            P
          ), Vt[P] = !0);
        }
        x.componentWillMount();
      }
      typeof x.UNSAFE_componentWillMount == "function" && x.UNSAFE_componentWillMount(), A !== x.state && (i("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", i3(L) || "Component"), Rt.enqueueReplaceState(x, x.state, null));
    }
    function wa(L, x, A, P) {
      if (L.queue !== null && L.queue.length > 0) {
        var U = L.queue, r1 = L.replace;
        if (L.queue = null, L.replace = !1, r1 && U.length === 1)
          x.state = U[0];
        else {
          for (var Q1 = r1 ? U[0] : x.state, v1 = !0, h = r1 ? 1 : 0; h < U.length; h++) {
            var g = U[h], O = typeof g == "function" ? g.call(x, Q1, A, P) : g;
            O != null && (v1 ? (v1 = !1, Q1 = Q4({}, Q1, O)) : Q4(Q1, O));
          }
          x.state = Q1;
        }
      } else
        L.queue = null;
    }
    function R8(L, x, A, P) {
      I8(L, x, A);
      var U = L.state !== void 0 ? L.state : null;
      L.updater = Rt, L.props = A, L.state = U;
      var r1 = {
        queue: [],
        replace: !1
      };
      ba(L, r1);
      var Q1 = x.contextType;
      if (typeof Q1 == "object" && Q1 !== null ? L.context = ue(Q1) : L.context = P, L.state === A) {
        var v1 = i3(x) || "Component";
        fe.has(v1) || (fe.add(v1), i("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", v1));
      }
      var h = x.getDerivedStateFromProps;
      typeof h == "function" && (L.state = D8(L, x, h, U, A)), typeof x.getDerivedStateFromProps != "function" && typeof L.getSnapshotBeforeUpdate != "function" && (typeof L.UNSAFE_componentWillMount == "function" || typeof L.componentWillMount == "function") && (Ma(x, L), wa(r1, L, A, P));
    }
    var Sa = {
      id: 1,
      overflow: ""
    };
    function Ca(L) {
      var x = L.overflow, A = L.id, P = A & ~Va(A);
      return P.toString(32) + x;
    }
    function Nt(L, x, A) {
      var P = L.id, U = L.overflow, r1 = Pt(P) - 1, Q1 = P & ~(1 << r1), v1 = A + 1, h = Pt(x) + r1;
      if (h > 30) {
        var g = r1 - r1 % 5, O = (1 << g) - 1, I = (Q1 & O).toString(32), B = Q1 >> g, e1 = r1 - g, o1 = Pt(x) + e1, m1 = v1 << e1, V1 = m1 | B, $1 = I + U;
        return {
          id: 1 << o1 | V1,
          overflow: $1
        };
      } else {
        var U1 = v1 << r1, Q2 = U1 | Q1, X2 = U;
        return {
          id: 1 << h | Q2,
          overflow: X2
        };
      }
    }
    function Pt(L) {
      return 32 - y7(L);
    }
    function Va(L) {
      return 1 << Pt(L) - 1;
    }
    var y7 = Math.clz32 ? Math.clz32 : Oa, Bt = Math.log, _a = Math.LN2;
    function Oa(L) {
      var x = L >>> 0;
      return x === 0 ? 32 : 31 - (Bt(x) / _a | 0) | 0;
    }
    function Aa(L, x) {
      return L === x && (L !== 0 || 1 / L === 1 / x) || L !== L && x !== x;
    }
    var Da = typeof Object.is == "function" ? Object.is : Aa, X4 = null, g7 = null, Ft = null, b2 = null, N6 = !1, P6 = !1, D2 = 0, T4 = null, B6 = 0, jt = 25, b3 = !1, q4;
    function F6() {
      if (X4 === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return b3 && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), X4;
    }
    function I4(L, x) {
      if (x === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", q4), !1;
      L.length !== x.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, q4, "[" + L.join(", ") + "]", "[" + x.join(", ") + "]");
      for (var A = 0; A < x.length && A < L.length; A++)
        if (!Da(L[A], x[A]))
          return !1;
      return !0;
    }
    function j6() {
      if (B6 > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function J4() {
      return b2 === null ? Ft === null ? (N6 = !1, Ft = b2 = j6()) : (N6 = !0, b2 = Ft) : b2.next === null ? (N6 = !1, b2 = b2.next = j6()) : (N6 = !0, b2 = b2.next), b2;
    }
    function ka(L, x) {
      X4 = x, g7 = L, b3 = !1, D2 = 0;
    }
    function N8(L, x, A, P) {
      for (; P6; )
        P6 = !1, D2 = 0, B6 += 1, b2 = null, A = L(x, P);
      return x7(), A;
    }
    function $t() {
      var L = D2 !== 0;
      return L;
    }
    function x7() {
      b3 = !1, X4 = null, g7 = null, P6 = !1, Ft = null, B6 = 0, T4 = null, b2 = null;
    }
    function Ia(L) {
      return b3 && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), ue(L);
    }
    function P8(L) {
      return q4 = "useContext", F6(), ue(L);
    }
    function de(L, x) {
      return typeof x == "function" ? x(L) : x;
    }
    function Ra(L) {
      return q4 = "useState", B8(
        de,
        // useReducer has a special case to support lazy useState initializers
        L
      );
    }
    function B8(L, x, A) {
      if (L !== de && (q4 = "useReducer"), X4 = F6(), b2 = J4(), N6) {
        var P = b2.queue, U = P.dispatch;
        if (T4 !== null) {
          var r1 = T4.get(P);
          if (r1 !== void 0) {
            T4.delete(P);
            var Q1 = b2.memoizedState, v1 = r1;
            do {
              var h = v1.action;
              b3 = !0, Q1 = L(Q1, h), b3 = !1, v1 = v1.next;
            } while (v1 !== null);
            return b2.memoizedState = Q1, [Q1, U];
          }
        }
        return [b2.memoizedState, U];
      } else {
        b3 = !0;
        var g;
        L === de ? g = typeof x == "function" ? x() : x : g = A !== void 0 ? A(x) : x, b3 = !1, b2.memoizedState = g;
        var O = b2.queue = {
          last: null,
          dispatch: null
        }, I = O.dispatch = j8.bind(null, X4, O);
        return [b2.memoizedState, I];
      }
    }
    function Zt(L, x) {
      X4 = F6(), b2 = J4();
      var A = x === void 0 ? null : x;
      if (b2 !== null) {
        var P = b2.memoizedState;
        if (P !== null && A !== null) {
          var U = P[1];
          if (I4(A, U))
            return P[0];
        }
      }
      b3 = !0;
      var r1 = L();
      return b3 = !1, b2.memoizedState = [r1, A], r1;
    }
    function Na(L) {
      X4 = F6(), b2 = J4();
      var x = b2.memoizedState;
      if (x === null) {
        var A = {
          current: L
        };
        return Object.seal(A), b2.memoizedState = A, A;
      } else
        return x;
    }
    function F8(L, x) {
      q4 = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function j8(L, x, A) {
      if (B6 >= jt)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (L === X4) {
        P6 = !0;
        var P = {
          action: A,
          next: null
        };
        T4 === null && (T4 = /* @__PURE__ */ new Map());
        var U = T4.get(x);
        if (U === void 0)
          T4.set(x, P);
        else {
          for (var r1 = U; r1.next !== null; )
            r1 = r1.next;
          r1.next = P;
        }
      }
    }
    function Pa(L, x) {
      return Zt(function() {
        return L;
      }, x);
    }
    function Ba(L, x, A) {
      return F6(), x(L._source);
    }
    function Fa(L, x, A) {
      if (A === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return A();
    }
    function ja(L) {
      return F6(), L;
    }
    function $a() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Za() {
      return F6(), [!1, $a];
    }
    function Wa() {
      var L = g7, x = Ca(L.treeContext), A = H7;
      if (A === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var P = D2++;
      return l6(A, x, P);
    }
    function Wt() {
    }
    var $8 = {
      readContext: Ia,
      useContext: P8,
      useMemo: Zt,
      useReducer: B8,
      useRef: Na,
      useState: Ra,
      useInsertionEffect: Wt,
      useLayoutEffect: F8,
      useCallback: Pa,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Wt,
      // Effects are not run in the server environment.
      useEffect: Wt,
      // Debugging effect
      useDebugValue: Wt,
      useDeferredValue: ja,
      useTransition: Za,
      useId: Wa,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Ba,
      useSyncExternalStore: Fa
    }, H7 = null;
    function he(L) {
      H7 = L;
    }
    function Z8(L) {
      try {
        var x = "", A = L;
        do {
          switch (A.tag) {
            case 0:
              x += oe(A.type, null, null);
              break;
            case 1:
              x += C8(A.type, null, null);
              break;
            case 2:
              x += bt(A.type, null, null);
              break;
          }
          A = A.parent;
        } while (A);
        return x;
      } catch (P) {
        return `
Error generating stack: ` + P.message + `
` + P.stack;
      }
    }
    var pe = r.ReactCurrentDispatcher, Gt = r.ReactDebugCurrentFrame, E7 = 0, m6 = 1, zt = 2, Ut = 3, $6 = 4, W8 = 0, b7 = 1, Z6 = 2, Ga = 12800;
    function G8(L) {
      return console.error(L), null;
    }
    function R4() {
    }
    function za(L, x, A, P, U, r1, Q1, v1, h) {
      var g = [], O = /* @__PURE__ */ new Set(), I = {
        destination: null,
        responseState: x,
        progressiveChunkSize: P === void 0 ? Ga : P,
        status: W8,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: O,
        pingedTasks: g,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: U === void 0 ? G8 : U,
        onAllReady: r1 === void 0 ? R4 : r1,
        onShellReady: Q1 === void 0 ? R4 : Q1,
        onShellError: v1 === void 0 ? R4 : v1,
        onFatalError: h === void 0 ? R4 : h
      }, B = Xt(
        I,
        0,
        null,
        A,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      B.parentFlushed = !0;
      var e1 = M7(I, L, null, B, O, k6, _8, Sa);
      return g.push(e1), I;
    }
    function Ua(L, x) {
      var A = L.pingedTasks;
      A.push(x), A.length === 1 && a(function() {
        return xe(L);
      });
    }
    function me(L, x) {
      return {
        id: S6,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: x,
        errorDigest: null
      };
    }
    function M7(L, x, A, P, U, r1, Q1, v1) {
      L.allPendingTasks++, A === null ? L.pendingRootTasks++ : A.pendingTasks++;
      var h = {
        node: x,
        ping: function() {
          return Ua(L, h);
        },
        blockedBoundary: A,
        blockedSegment: P,
        abortSet: U,
        legacyContext: r1,
        context: Q1,
        treeContext: v1
      };
      return h.componentStack = null, U.add(h), h;
    }
    function Xt(L, x, A, P, U, r1) {
      return {
        status: E7,
        id: -1,
        // lazily assigned later
        index: x,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: P,
        boundary: A,
        lastPushedText: U,
        textEmbedded: r1
      };
    }
    var Y4 = null;
    function ve() {
      return Y4 === null || Y4.componentStack === null ? "" : Z8(Y4.componentStack);
    }
    function v6(L, x) {
      L.componentStack = {
        tag: 0,
        parent: L.componentStack,
        type: x
      };
    }
    function N4(L, x) {
      L.componentStack = {
        tag: 1,
        parent: L.componentStack,
        type: x
      };
    }
    function w7(L, x) {
      L.componentStack = {
        tag: 2,
        parent: L.componentStack,
        type: x
      };
    }
    function s4(L) {
      L.componentStack === null ? i("Unexpectedly popped too many stack frames. This is a bug in React.") : L.componentStack = L.componentStack.parent;
    }
    var E5 = null;
    function S7(L, x) {
      {
        var A;
        typeof x == "string" ? A = x : x && typeof x.message == "string" ? A = x.message : A = String(x);
        var P = E5 || ve();
        E5 = null, L.errorMessage = A, L.errorComponentStack = P;
      }
    }
    function l4(L, x) {
      var A = L.onError(x);
      if (A != null && typeof A != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof A + '" instead');
      return A;
    }
    function L6(L, x) {
      var A = L.onShellError;
      A(x);
      var P = L.onFatalError;
      P(x), L.destination !== null ? (L.status = Z6, H(L.destination, x)) : (L.status = b7, L.fatalError = x);
    }
    function C7(L, x, A) {
      v6(x, "Suspense");
      var P = x.blockedBoundary, U = x.blockedSegment, r1 = A.fallback, Q1 = A.children, v1 = /* @__PURE__ */ new Set(), h = me(L, v1), g = U.chunks.length, O = Xt(
        L,
        g,
        h,
        U.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      U.children.push(O), U.lastPushedText = !1;
      var I = Xt(
        L,
        0,
        null,
        U.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      I.parentFlushed = !0, x.blockedBoundary = h, x.blockedSegment = I;
      try {
        if (N7(L, x, Q1), c6(I.chunks, L.responseState, I.lastPushedText, I.textEmbedded), I.status = m6, Yt(h, I), h.pendingTasks === 0) {
          s4(x);
          return;
        }
      } catch (e1) {
        I.status = $6, h.forceClientRender = !0, h.errorDigest = l4(L, e1), S7(h, e1);
      } finally {
        x.blockedBoundary = P, x.blockedSegment = U;
      }
      var B = M7(L, r1, P, O, v1, x.legacyContext, x.context, x.treeContext);
      B.componentStack = x.componentStack, L.pingedTasks.push(B), s4(x);
    }
    function Le(L, x, A, P) {
      v6(x, A);
      var U = x.blockedSegment, r1 = X5(U.chunks, A, P, L.responseState, U.formatContext);
      U.lastPushedText = !1;
      var Q1 = U.formatContext;
      U.formatContext = C4(Q1, A, P), N7(L, x, r1), U.formatContext = Q1, Tt(U.chunks, A), U.lastPushedText = !1, s4(x);
    }
    function qt(L) {
      return L.prototype && L.prototype.isReactComponent;
    }
    function z8(L, x, A, P, U) {
      var r1 = {};
      ka(x, r1);
      var Q1 = A(P, U);
      return N8(A, P, Q1, U);
    }
    function U8(L, x, A, P, U) {
      var r1 = A.render();
      A.props !== U && (ge || i("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", i3(P) || "a component"), ge = !0);
      {
        var Q1 = P.childContextTypes;
        if (Q1 != null) {
          var v1 = x.legacyContext, h = h7(A, P, v1, Q1);
          x.legacyContext = h, e4(L, x, r1), x.legacyContext = v1;
          return;
        }
      }
      e4(L, x, r1);
    }
    function Xa(L, x, A, P) {
      w7(x, A);
      var U = d7(A, x.legacyContext), r1 = k8(A, P, U);
      R8(r1, A, P, U), U8(L, x, r1, A, P), s4(x);
    }
    var V7 = {}, ye = {}, X8 = {}, _7 = {}, ge = !1, O7 = !1, A7 = !1, D7 = !1;
    function q8(L, x, A, P) {
      var U;
      if (U = d7(A, x.legacyContext), N4(x, A), A.prototype && typeof A.prototype.render == "function") {
        var r1 = i3(A) || "Unknown";
        V7[r1] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", r1, r1), V7[r1] = !0);
      }
      var Q1 = z8(L, x, A, P, U), v1 = $t();
      if (typeof Q1 == "object" && Q1 !== null && typeof Q1.render == "function" && Q1.$$typeof === void 0) {
        var h = i3(A) || "Unknown";
        ye[h] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", h, h, h), ye[h] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof Q1 == "object" && Q1 !== null && typeof Q1.render == "function" && Q1.$$typeof === void 0
      ) {
        {
          var g = i3(A) || "Unknown";
          ye[g] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", g, g, g), ye[g] = !0);
        }
        R8(Q1, A, P, U), U8(L, x, Q1, A, P);
      } else if (J8(A), v1) {
        var O = x.treeContext, I = 1, B = 0;
        x.treeContext = Nt(O, I, B);
        try {
          e4(L, x, Q1);
        } finally {
          x.treeContext = O;
        }
      } else
        e4(L, x, Q1);
      s4(x);
    }
    function J8(L) {
      {
        if (L && L.childContextTypes && i("%s(...): childContextTypes cannot be defined on a function component.", L.displayName || L.name || "Component"), typeof L.getDerivedStateFromProps == "function") {
          var x = i3(L) || "Unknown";
          _7[x] || (i("%s: Function components do not support getDerivedStateFromProps.", x), _7[x] = !0);
        }
        if (typeof L.contextType == "object" && L.contextType !== null) {
          var A = i3(L) || "Unknown";
          X8[A] || (i("%s: Function components do not support contextType.", A), X8[A] = !0);
        }
      }
    }
    function k7(L, x) {
      if (L && L.defaultProps) {
        var A = Q4({}, x), P = L.defaultProps;
        for (var U in P)
          A[U] === void 0 && (A[U] = P[U]);
        return A;
      }
      return x;
    }
    function qa(L, x, A, P, U) {
      N4(x, A.render);
      var r1 = z8(L, x, A.render, P, U), Q1 = $t();
      if (Q1) {
        var v1 = x.treeContext, h = 1, g = 0;
        x.treeContext = Nt(v1, h, g);
        try {
          e4(L, x, r1);
        } finally {
          x.treeContext = v1;
        }
      } else
        e4(L, x, r1);
      s4(x);
    }
    function Ja(L, x, A, P, U) {
      var r1 = A.type, Q1 = k7(r1, P);
      I7(L, x, r1, Q1, U);
    }
    function Y8(L, x, A, P) {
      A._context === void 0 ? A !== A.Consumer && (D7 || (D7 = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : A = A._context;
      var U = P.children;
      typeof U != "function" && i("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var r1 = ue(A), Q1 = U(r1);
      e4(L, x, Q1);
    }
    function Ya(L, x, A, P) {
      var U = A._context, r1 = P.value, Q1 = P.children, v1;
      v1 = x.context, x.context = O8(U, r1), e4(L, x, Q1), x.context = A8(U), v1 !== x.context && i("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Ka(L, x, A, P, U) {
      v6(x, "Lazy");
      var r1 = A._payload, Q1 = A._init, v1 = Q1(r1), h = k7(v1, P);
      I7(L, x, v1, h, U), s4(x);
    }
    function I7(L, x, A, P, U) {
      if (typeof A == "function")
        if (qt(A)) {
          Xa(L, x, A, P);
          return;
        } else {
          q8(L, x, A, P);
          return;
        }
      if (typeof A == "string") {
        Le(L, x, A, P);
        return;
      }
      switch (A) {
        case Ht:
        case r7:
        case H8:
        case e7:
        case K3: {
          e4(L, x, P.children);
          return;
        }
        case re: {
          v6(x, "SuspenseList"), e4(L, x, P.children), s4(x);
          return;
        }
        case t7:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case te: {
          C7(L, x, P);
          return;
        }
      }
      if (typeof A == "object" && A !== null)
        switch (A.$$typeof) {
          case xt: {
            qa(L, x, A, P, U);
            return;
          }
          case ne: {
            Ja(L, x, A, P, U);
            return;
          }
          case yt: {
            Ya(L, x, A, P);
            return;
          }
          case gt: {
            Y8(L, x, A, P);
            return;
          }
          case m5: {
            Ka(L, x, A, P);
            return;
          }
        }
      var r1 = "";
      throw (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (r1 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (A == null ? A : typeof A) + "." + r1));
    }
    function eQ(L, x) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      L[Symbol.toStringTag] === "Generator" && (O7 || i("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), O7 = !0), L.entries === x && (A7 || i("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), A7 = !0);
    }
    function e4(L, x, A) {
      try {
        return R7(L, x, A);
      } catch (P) {
        throw typeof P == "object" && P !== null && typeof P.then == "function" || (E5 = E5 !== null ? E5 : ve()), P;
      }
    }
    function R7(L, x, A) {
      if (x.node = A, typeof A == "object" && A !== null) {
        switch (A.$$typeof) {
          case ga: {
            var P = A, U = P.type, r1 = P.props, Q1 = P.ref;
            I7(L, x, U, r1, Q1);
            return;
          }
          case x8:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case m5: {
            var v1 = A, h = v1._payload, g = v1._init, O;
            try {
              O = g(h);
            } catch (U1) {
              throw typeof U1 == "object" && U1 !== null && typeof U1.then == "function" && v6(x, "Lazy"), U1;
            }
            e4(L, x, O);
            return;
          }
        }
        if (h2(A)) {
          K8(L, x, A);
          return;
        }
        var I = Ea(A);
        if (I) {
          eQ(A, I);
          var B = I.call(A);
          if (B) {
            var e1 = B.next();
            if (!e1.done) {
              var o1 = [];
              do
                o1.push(e1.value), e1 = B.next();
              while (!e1.done);
              K8(L, x, o1);
              return;
            }
            return;
          }
        }
        var m1 = Object.prototype.toString.call(A);
        throw new Error("Objects are not valid as a React child (found: " + (m1 === "[object Object]" ? "object with keys {" + Object.keys(A).join(", ") + "}" : m1) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof A == "string") {
        var V1 = x.blockedSegment;
        V1.lastPushedText = u6(x.blockedSegment.chunks, A, L.responseState, V1.lastPushedText);
        return;
      }
      if (typeof A == "number") {
        var $1 = x.blockedSegment;
        $1.lastPushedText = u6(x.blockedSegment.chunks, "" + A, L.responseState, $1.lastPushedText);
        return;
      }
      typeof A == "function" && i("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function K8(L, x, A) {
      for (var P = A.length, U = 0; U < P; U++) {
        var r1 = x.treeContext;
        x.treeContext = Nt(r1, P, U);
        try {
          N7(L, x, A[U]);
        } finally {
          x.treeContext = r1;
        }
      }
    }
    function t4(L, x, A) {
      var P = x.blockedSegment, U = P.chunks.length, r1 = Xt(
        L,
        U,
        null,
        P.formatContext,
        // Adopt the parent segment's leading text embed
        P.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      P.children.push(r1), P.lastPushedText = !1;
      var Q1 = M7(L, x.node, x.blockedBoundary, r1, x.abortSet, x.legacyContext, x.context, x.treeContext);
      x.componentStack !== null && (Q1.componentStack = x.componentStack.parent);
      var v1 = Q1.ping;
      A.then(v1, v1);
    }
    function N7(L, x, A) {
      var P = x.blockedSegment.formatContext, U = x.legacyContext, r1 = x.context, Q1 = null;
      Q1 = x.componentStack;
      try {
        return e4(L, x, A);
      } catch (v1) {
        if (x7(), typeof v1 == "object" && v1 !== null && typeof v1.then == "function") {
          t4(L, x, v1), x.blockedSegment.formatContext = P, x.legacyContext = U, x.context = r1, le(r1), x.componentStack = Q1;
          return;
        } else
          throw x.blockedSegment.formatContext = P, x.legacyContext = U, x.context = r1, le(r1), x.componentStack = Q1, v1;
      }
    }
    function en(L, x, A, P) {
      var U = l4(L, P);
      if (x === null ? L6(L, P) : (x.pendingTasks--, x.forceClientRender || (x.forceClientRender = !0, x.errorDigest = U, S7(x, P), x.parentFlushed && L.clientRenderedBoundaries.push(x))), L.allPendingTasks--, L.allPendingTasks === 0) {
        var r1 = L.onAllReady;
        r1();
      }
    }
    function tQ(L) {
      var x = this, A = L.blockedBoundary, P = L.blockedSegment;
      P.status = Ut, tn(x, A, P);
    }
    function Jt(L, x, A) {
      var P = L.blockedBoundary, U = L.blockedSegment;
      if (U.status = Ut, P === null)
        x.allPendingTasks--, x.status !== Z6 && (x.status = Z6, x.destination !== null && d(x.destination));
      else {
        if (P.pendingTasks--, !P.forceClientRender) {
          P.forceClientRender = !0;
          var r1 = A === void 0 ? new Error("The render was aborted by the server without a reason.") : A;
          P.errorDigest = x.onError(r1);
          {
            var Q1 = "The server did not finish this Suspense boundary: ";
            r1 && typeof r1.message == "string" ? r1 = Q1 + r1.message : r1 = Q1 + String(r1);
            var v1 = Y4;
            Y4 = L;
            try {
              S7(P, r1);
            } finally {
              Y4 = v1;
            }
          }
          P.parentFlushed && x.clientRenderedBoundaries.push(P);
        }
        if (P.fallbackAbortableTasks.forEach(function(g) {
          return Jt(g, x, A);
        }), P.fallbackAbortableTasks.clear(), x.allPendingTasks--, x.allPendingTasks === 0) {
          var h = x.onAllReady;
          h();
        }
      }
    }
    function Yt(L, x) {
      if (x.chunks.length === 0 && x.children.length === 1 && x.children[0].boundary === null) {
        var A = x.children[0];
        A.id = x.id, A.parentFlushed = !0, A.status === m6 && Yt(L, A);
      } else {
        var P = L.completedSegments;
        P.push(x);
      }
    }
    function tn(L, x, A) {
      if (x === null) {
        if (A.parentFlushed) {
          if (L.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          L.completedRootSegment = A;
        }
        if (L.pendingRootTasks--, L.pendingRootTasks === 0) {
          L.onShellError = R4;
          var P = L.onShellReady;
          P();
        }
      } else if (x.pendingTasks--, !x.forceClientRender) {
        if (x.pendingTasks === 0)
          A.parentFlushed && A.status === m6 && Yt(x, A), x.parentFlushed && L.completedBoundaries.push(x), x.fallbackAbortableTasks.forEach(tQ, L), x.fallbackAbortableTasks.clear();
        else if (A.parentFlushed && A.status === m6) {
          Yt(x, A);
          var U = x.completedSegments;
          U.length === 1 && x.parentFlushed && L.partialBoundaries.push(x);
        }
      }
      if (L.allPendingTasks--, L.allPendingTasks === 0) {
        var r1 = L.onAllReady;
        r1();
      }
    }
    function rn(L, x) {
      var A = x.blockedSegment;
      if (A.status === E7) {
        le(x.context);
        var P = null;
        P = Y4, Y4 = x;
        try {
          e4(L, x, x.node), c6(A.chunks, L.responseState, A.lastPushedText, A.textEmbedded), x.abortSet.delete(x), A.status = m6, tn(L, x.blockedBoundary, A);
        } catch (r1) {
          if (x7(), typeof r1 == "object" && r1 !== null && typeof r1.then == "function") {
            var U = x.ping;
            r1.then(U, U);
          } else
            x.abortSet.delete(x), A.status = $6, en(L, x.blockedBoundary, A, r1);
        } finally {
          Y4 = P;
        }
      }
    }
    function xe(L) {
      if (L.status !== Z6) {
        var x = Ct(), A = pe.current;
        pe.current = $8;
        var P;
        P = Gt.getCurrentStack, Gt.getCurrentStack = ve;
        var U = H7;
        he(L.responseState);
        try {
          var r1 = L.pingedTasks, Q1;
          for (Q1 = 0; Q1 < r1.length; Q1++) {
            var v1 = r1[Q1];
            rn(L, v1);
          }
          r1.splice(0, Q1), L.destination !== null && e0(L, L.destination);
        } catch (h) {
          l4(L, h), L6(L, h);
        } finally {
          he(U), pe.current = A, Gt.getCurrentStack = P, A === $8 && le(x);
        }
      }
    }
    function He(L, x, A) {
      switch (A.parentFlushed = !0, A.status) {
        case E7: {
          var P = A.id = L.nextSegmentId++;
          return A.lastPushedText = !1, A.textEmbedded = !1, T5(x, L.responseState, P);
        }
        case m6: {
          A.status = zt;
          for (var U = !0, r1 = A.chunks, Q1 = 0, v1 = A.children, h = 0; h < v1.length; h++) {
            for (var g = v1[h]; Q1 < g.index; Q1++)
              l(x, r1[Q1]);
            U = Kt(L, x, g);
          }
          for (; Q1 < r1.length - 1; Q1++)
            l(x, r1[Q1]);
          return Q1 < r1.length && (U = c(x, r1[Q1])), U;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Kt(L, x, A) {
      var P = A.boundary;
      if (P === null)
        return He(L, x, A);
      if (P.parentFlushed = !0, P.forceClientRender)
        return P3(x, L.responseState, P.errorDigest, P.errorMessage, P.errorComponentStack), He(L, x, A), X0(x, L.responseState);
      if (P.pendingTasks > 0) {
        P.rootSegmentID = L.nextSegmentId++, P.completedSegments.length > 0 && L.partialBoundaries.push(P);
        var U = P.id = C6(L.responseState);
        return u5(x, L.responseState, U), He(L, x, A), c5(x, L.responseState);
      } else {
        if (P.byteSize > L.progressiveChunkSize)
          return P.rootSegmentID = L.nextSegmentId++, L.completedBoundaries.push(P), u5(x, L.responseState, P.id), He(L, x, A), c5(x, L.responseState);
        lt(x, L.responseState);
        var r1 = P.completedSegments;
        if (r1.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var Q1 = r1[0];
        return Kt(L, x, Q1), ut(x, L.responseState);
      }
    }
    function nn(L, x, A) {
      return y8(x, L.responseState, A.id, A.errorDigest, A.errorMessage, A.errorComponentStack);
    }
    function Ee(L, x, A) {
      return c2(x, L.responseState, A.formatContext, A.id), Kt(L, x, A), F2(x, A.formatContext);
    }
    function be(L, x, A) {
      for (var P = A.completedSegments, U = 0; U < P.length; U++) {
        var r1 = P[U];
        P7(L, x, A, r1);
      }
      return P.length = 0, q0(x, L.responseState, A.id, A.rootSegmentID);
    }
    function rQ(L, x, A) {
      for (var P = A.completedSegments, U = 0; U < P.length; U++) {
        var r1 = P[U];
        if (!P7(L, x, A, r1))
          return U++, P.splice(0, U), !1;
      }
      return P.splice(0, U), !0;
    }
    function P7(L, x, A, P) {
      if (P.status === zt)
        return !0;
      var U = P.id;
      if (U === -1) {
        var r1 = P.id = A.rootSegmentID;
        if (r1 === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Ee(L, x, P);
      } else
        return Ee(L, x, P), fa(x, L.responseState, U);
    }
    function e0(L, x) {
      u();
      try {
        var A = L.completedRootSegment;
        A !== null && L.pendingRootTasks === 0 && (Kt(L, x, A), L.completedRootSegment = null, G0(x, L.responseState));
        var P = L.clientRenderedBoundaries, U;
        for (U = 0; U < P.length; U++) {
          var r1 = P[U];
          nn(L, x, r1);
        }
        P.splice(0, U);
        var Q1 = L.completedBoundaries;
        for (U = 0; U < Q1.length; U++) {
          var v1 = Q1[U];
          be(L, x, v1);
        }
        Q1.splice(0, U), f(x), u(x);
        var h = L.partialBoundaries;
        for (U = 0; U < h.length; U++) {
          var g = h[U];
          if (!rQ(L, x, g)) {
            L.destination = null, U++, h.splice(0, U);
            return;
          }
        }
        h.splice(0, U);
        var O = L.completedBoundaries;
        for (U = 0; U < O.length; U++) {
          var I = O[U];
          be(L, x, I);
        }
        O.splice(0, U);
      } finally {
        f(x), L.allPendingTasks === 0 && L.pingedTasks.length === 0 && L.clientRenderedBoundaries.length === 0 && L.completedBoundaries.length === 0 && (L.abortableTasks.size !== 0 && i("There was still abortable task at the root when we closed. This is a bug in React."), d(x));
      }
    }
    function nQ(L) {
      a(function() {
        return xe(L);
      });
    }
    function on(L, x) {
      if (L.status === b7) {
        L.status = Z6, H(x, L.fatalError);
        return;
      }
      if (L.status !== Z6 && L.destination === null) {
        L.destination = x;
        try {
          e0(L, x);
        } catch (A) {
          l4(L, A), L6(L, A);
        }
      }
    }
    function t0(L, x) {
      try {
        var A = L.abortableTasks;
        A.forEach(function(P) {
          return Jt(P, L, x);
        }), A.clear(), L.destination !== null && e0(L, L.destination);
      } catch (P) {
        l4(L, P), L6(L, P);
      }
    }
    function iQ(L, x) {
      return new Promise(function(A, P) {
        var U, r1, Q1 = new Promise(function(B, e1) {
          r1 = B, U = e1;
        });
        function v1() {
          var B = new ReadableStream(
            {
              type: "bytes",
              pull: function(e1) {
                on(g, e1);
              },
              cancel: function(e1) {
                t0(g);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          B.allReady = Q1, A(B);
        }
        function h(B) {
          Q1.catch(function() {
          }), P(B);
        }
        var g = za(L, n4(x ? x.identifierPrefix : void 0, x ? x.nonce : void 0, x ? x.bootstrapScriptContent : void 0, x ? x.bootstrapScripts : void 0, x ? x.bootstrapModules : void 0), y4(x ? x.namespaceURI : void 0), x ? x.progressiveChunkSize : void 0, x ? x.onError : void 0, r1, v1, h, U);
        if (x && x.signal) {
          var O = x.signal, I = function() {
            t0(g, O.reason), O.removeEventListener("abort", I);
          };
          O.addEventListener("abort", I);
        }
        nQ(g);
      });
    }
    jn.renderToReadableStream = iQ, jn.version = t;
  }()), jn;
}
var et, GT;
process.env.NODE_ENV === "production" ? (et = N_(), GT = P_()) : (et = B_(), GT = F_());
et.version;
et.renderToString;
var j_ = et.renderToStaticMarkup;
et.renderToNodeStream;
et.renderToStaticNodeStream;
GT.renderToReadableStream;
const $_ = (e) => {
  const {
    setCursorPosition: t,
    value: r,
    media: n,
    readOnly: i = !1,
    onSelectTab: o,
    onChange: a,
    onDeleteImage: T,
    templateUpdated: s,
    questionIndex: Q = 0,
    autoFocus: u = !1
  } = e, [l, c] = W1(!1), [f, d] = W1(!1);
  let m;
  n && n.length > 0 && (m = n[0].hasOwnProperty("localUrl") ? n[0].localUrl : (
    // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    n[0].hasOwnProperty("url") ? n[0].url : void 0
  ));
  const p = () => {
    m && d(!0);
  };
  return /* @__PURE__ */ y.createElement(Y_, { $focused: l }, f && /* @__PURE__ */ y.createElement(qo, { minimal: !0, isOpen: f, setClose: () => d(!1), url: m }), m && /* @__PURE__ */ y.createElement(cp, { $fixed: !0 }, /* @__PURE__ */ y.createElement("img", { src: m, alt: "image used to describe question", onClick: p }), /* @__PURE__ */ y.createElement("div", { className: "icon-wrap" }, /* @__PURE__ */ y.createElement(dp, { "aria-label": "Delete icon", role: "button", onClick: T }))), /* @__PURE__ */ y.createElement(W_, { setCursorPosition: t, value: r, className: `${i || ""}`, onFocus: () => c(!0), focused: l, onBlur: () => c(!1), onChange: a, onSelectTab: o, templateUpdated: s, questionIndex: Q, autoFocus: u }));
};
function e9(e, t) {
  e.forEach((r) => {
    var n;
    if (r.nodeType === Node.TEXT_NODE) {
      const i = r.nodeValue;
      i != null && typeof i == "string" && t.push({
        type: j2.Text,
        text: i.replaceAll(
          // replace none breaking space characters with spaces
          " ",
          " "
        )
      });
      return;
    }
    if (r.nodeType === Node.ELEMENT_NODE) {
      if (r instanceof HTMLElement) {
        const i = (n = r.dataset) == null ? void 0 : n.inputid;
        if (i != null && typeof i == "string") {
          t.push({
            type: j2.Input,
            inputId: i
          });
          return;
        }
      }
      if (r.nodeName === "DIV") {
        t.push({
          type: j2.Text,
          text: `
`
        }), e9(r.childNodes, t);
        return;
      }
      if (r.nodeName === "BR")
        return;
      if (r.nodeName === "SPAN") {
        e9(r.childNodes, t);
        return;
      }
      if (r.nodeName === "P") {
        e9(r.childNodes, t);
        return;
      }
      return;
    }
  });
}
function Z_(e) {
  const t = [];
  return e9(e.childNodes, t), Po(t);
}
const W_ = (e) => {
  const {
    setCursorPosition: t,
    value: r = "",
    onChange: n,
    onSelectTab: i,
    onBlur: o,
    onFocus: a,
    templateUpdated: T,
    questionIndex: s,
    focused: Q,
    autoFocus: u = !1
  } = e, [l, c] = W1(null), f = m4(null), [d, m] = W1(0), p = () => m((w) => w + 1), v = (w) => {
    n(w);
  }, H = () => {
    if (l) {
      p();
      return;
    }
    if (f.current) {
      const w = Z_(f.current), S = Qp(w4(r), w4(w));
      if (S.deletedIds.length) {
        c(S), p();
        return;
      }
      v(S);
    }
  }, E = (w) => {
    if (i && f.current) {
      f.current.innerHTML = X_(w, s);
      const S = document.getElementsByClassName("button-dropdown");
      if (S && S.length > 0)
        for (let D = 0; D < S.length; D++)
          S[D].addEventListener("click", () => {
            const k = S[D];
            if (k instanceof HTMLElement) {
              const $ = k.dataset.inputid;
              if (typeof $ != "string")
                return;
              let z = 0;
              try {
                z = Number($);
              } catch (j) {
                console.error(j);
              }
              i(z - 1);
            }
          }, !1);
    }
  };
  G3(() => {
    T && E(r);
  }, [T, d]), G3(() => (f.current && (document.addEventListener("keyup", () => C(f.current)), document.addEventListener("click", () => C(f.current)), f == null || f.current.addEventListener("paste", (w) => M(w))), () => {
    var w;
    document.removeEventListener("keyup", () => C(f.current)), document.removeEventListener("click", () => C(f.current)), (w = f == null ? void 0 : f.current) == null || w.removeEventListener("paste", (S) => M(S));
  }), []), os(() => {
    f.current && u && f.current.focus();
  }, [u]);
  const M = (w) => {
    w.preventDefault();
    let S = w.clipboardData.getData("text");
    S = Po(w4(S).filter(({
      type: k
    }) => k === j2.Text));
    const D = window.getSelection();
    return D != null && D.rangeCount && (D == null || D.deleteFromDocument(), D == null || D.getRangeAt(0).insertNode(document.createTextNode(S)), H()), !1;
  }, C = (w) => {
    if (w) {
      const S = G_(w);
      t && t(S.length);
    }
  };
  return /* @__PURE__ */ y.createElement(q_, null, /* @__PURE__ */ y.createElement(J_, { $isFocused: Q, $isEmpty: r.length === 0, role: "textbox", contentEditable: "true", suppressContentEditableWarning: !0, ref: f, onFocus: a, onBlur: o, onInput: H }), /* @__PURE__ */ y.createElement(qs, { isOpen: !!l, confirmText: "Delete", onCancel: () => c(null), onConfirm: () => {
    l && (c(null), v(l));
  } }, "Are you sure you want to delete dropdown", ((l == null ? void 0 : l.deletedIds.length) ?? 0) > 1 ? "s " : " ", l == null ? void 0 : l.deletedIds.map((w, S) => /* @__PURE__ */ y.createElement(y.Fragment, null, S > 0 && S === l.deletedIds.length - 1 && "and", /* @__PURE__ */ y.createElement("span", { key: S, className: "text-base font-semibold bg-brand-horizon-blue text-brand-cloud-blue px-3 mx-1 rounded-lg" }, w))), "?"));
};
function G_(e) {
  var i;
  const r = e.ownerDocument.defaultView;
  let n;
  if (r && r.getSelection && (n = r.getSelection(), n && n.rangeCount > 0)) {
    const o = (i = r.getSelection()) == null ? void 0 : i.getRangeAt(0);
    if (o) {
      const a = o.cloneRange();
      return a.selectNodeContents(e), a.setEnd(o.endContainer, o.endOffset), a.toString();
    }
  }
  return "";
}
const qf = () => /* @__PURE__ */ y.createElement("span", { contentEditable: "true", style: {
  minWidth: "1px",
  minHeight: "100%",
  lineHeight: "1rem"
} }), z_ = (e) => e ? e.type === j2.Text && e.text.trim() === "" : !1, U_ = (e) => e ? e.type === j2.Input : !1, X_ = (e, t) => {
  const r = w4(e);
  return j_(/* @__PURE__ */ y.createElement(y.Fragment, null, r.map((n, i) => {
    const o = `${t}-${i}`;
    if (n.type === j2.Input) {
      const {
        inputId: a
      } = n, T = U_(r[i + 1]);
      return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("button", { id: `${a}-${t}`, contentEditable: "false", suppressContentEditableWarning: !0, "data-inputid": a, key: o, className: "button-dropdown mr-1" }, a), T ? /* @__PURE__ */ y.createElement(qf, { key: `${o}-empty` }) : null);
    }
    return z_(n) ? /* @__PURE__ */ y.createElement(qf, { key: o }) : n.type === j2.Text ? /* @__PURE__ */ y.createElement(a2, { key: o }, n.text) : null;
  })));
}, q_ = M1.div.withConfig({
  displayName: "TemplateField__ClozeDropdownTextField",
  componentId: "sc-w1kkvx-0"
})(["width:100%;background-color:", ";button{cursor:pointer;background-color:", ";border:none;font-weight:normal;font-style:normal;font-family:", ";font-size:", ";line-height:", ";text-align:center;color:white;border-radius:", ";padding-left:", ";padding-right:", ";margin:0 0.8px;}button:focus{border:2px solid #2aecbd;outline:none !important;}"], ({
  theme: e
}) => e.baseLight, ({
  theme: e
}) => e.primary, ({
  theme: e
}) => e.fontFamily, a1.text_sm, a1.text_base, a1.spacing1, a1.text_xs, a1.text_xs), J_ = M1.div.withConfig({
  displayName: "TemplateField__Content",
  componentId: "sc-w1kkvx-1"
})(["white-space:pre-line;color:", ";text-align:start;font-size:", ";font-weight:normal;font-style:normal;font-family:", ";line-height:", ";padding:", " 0;border:0;box-sizing:content-box;background:none;margin-left:", ";display:block;min-width:0;animation-name:mui-auto-fill-cancel;animation-duration:10ms;button{cursor:pointer;background-color:", ";border:none;font-weight:normal;font-style:normal;font-family:", ";font-size:", ";line-height:", ";text-align:center;color:white;border-radius:", ";padding-left:", ";padding-right:", ";}button:focus{border:2px solid #2aecbd;}&:focus-visible{outline:none;}"], ({
  theme: e
}) => e.onBase, a1.text_sm, ({
  theme: e
}) => e.fontFamily, a1.text_2xl, a1.spacing2, a1.spacing2, ({
  theme: e
}) => e.primary, ({
  theme: e
}) => e.fontFamily, a1.text_sm, a1.text_base, a1.spacing1, a1.text_xs, a1.text_xs), Y_ = M1(fp).withConfig({
  displayName: "TemplateField__TextImageFieldWrapper",
  componentId: "sc-w1kkvx-2"
})(["border-top-left-radius:0 !important;border-bottom-left-radius:0px !important;.image-prepend{position:relative;margin-right:", ";}align-items:center;"], a1.spacing2);
var B5 = /* @__PURE__ */ ((e) => (e.FREE_RESPONSE = "FREE_RESPONSE", e.MULTIPLE_CHOICE = "MULTIPLE_CHOICE", e.MULTIPLE_SELECT = "MULTIPLE_SELECT", e.CLOZE_DROPDOWN = "CLOZE_DROPDOWN", e.IMAGE_LABELING = "IMAGE_LABELING", e))(B5 || {}), zT = {}, UT = { exports: {} }, xr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jf;
function K_() {
  if (Jf)
    return xr;
  Jf = 1;
  var e = y, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(T, s, Q) {
    var u, l = {}, c = null, f = null;
    Q !== void 0 && (c = "" + Q), s.key !== void 0 && (c = "" + s.key), s.ref !== void 0 && (f = s.ref);
    for (u in s)
      n.call(s, u) && !o.hasOwnProperty(u) && (l[u] = s[u]);
    if (T && T.defaultProps)
      for (u in s = T.defaultProps, s)
        l[u] === void 0 && (l[u] = s[u]);
    return { $$typeof: t, type: T, key: c, ref: f, props: l, _owner: i.current };
  }
  return xr.Fragment = r, xr.jsx = a, xr.jsxs = a, xr;
}
var Hr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yf;
function eO() {
  return Yf || (Yf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = y, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), T = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), Q = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), d = Symbol.iterator, m = "@@iterator";
    function p(n1) {
      if (n1 === null || typeof n1 != "object")
        return null;
      var _1 = d && n1[d] || n1[m];
      return typeof _1 == "function" ? _1 : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function H(n1) {
      {
        for (var _1 = arguments.length, P1 = new Array(_1 > 1 ? _1 - 1 : 0), J1 = 1; J1 < _1; J1++)
          P1[J1 - 1] = arguments[J1];
        E("error", n1, P1);
      }
    }
    function E(n1, _1, P1) {
      {
        var J1 = v.ReactDebugCurrentFrame, h2 = J1.getStackAddendum();
        h2 !== "" && (_1 += "%s", P1 = P1.concat([h2]));
        var v2 = P1.map(function(m2) {
          return String(m2);
        });
        v2.unshift("Warning: " + _1), Function.prototype.apply.call(console[n1], console, v2);
      }
    }
    var M = !1, C = !1, w = !1, S = !1, D = !1, k;
    k = Symbol.for("react.module.reference");
    function $(n1) {
      return !!(typeof n1 == "string" || typeof n1 == "function" || n1 === n || n1 === o || D || n1 === i || n1 === Q || n1 === u || S || n1 === f || M || C || w || typeof n1 == "object" && n1 !== null && (n1.$$typeof === c || n1.$$typeof === l || n1.$$typeof === a || n1.$$typeof === T || n1.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n1.$$typeof === k || n1.getModuleId !== void 0));
    }
    function z(n1, _1, P1) {
      var J1 = n1.displayName;
      if (J1)
        return J1;
      var h2 = _1.displayName || _1.name || "";
      return h2 !== "" ? P1 + "(" + h2 + ")" : P1;
    }
    function j(n1) {
      return n1.displayName || "Context";
    }
    function J(n1) {
      if (n1 == null)
        return null;
      if (typeof n1.tag == "number" && H("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n1 == "function")
        return n1.displayName || n1.name || null;
      if (typeof n1 == "string")
        return n1;
      switch (n1) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case Q:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof n1 == "object")
        switch (n1.$$typeof) {
          case T:
            var _1 = n1;
            return j(_1) + ".Consumer";
          case a:
            var P1 = n1;
            return j(P1._context) + ".Provider";
          case s:
            return z(n1, n1.render, "ForwardRef");
          case l:
            var J1 = n1.displayName || null;
            return J1 !== null ? J1 : J(n1.type) || "Memo";
          case c: {
            var h2 = n1, v2 = h2._payload, m2 = h2._init;
            try {
              return J(m2(v2));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var i1 = Object.assign, t1 = 0, T1, X, f1, s1, Z, L1, C1;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function N1() {
      {
        if (t1 === 0) {
          T1 = console.log, X = console.info, f1 = console.warn, s1 = console.error, Z = console.group, L1 = console.groupCollapsed, C1 = console.groupEnd;
          var n1 = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n1,
            log: n1,
            warn: n1,
            error: n1,
            group: n1,
            groupCollapsed: n1,
            groupEnd: n1
          });
        }
        t1++;
      }
    }
    function O1() {
      {
        if (t1--, t1 === 0) {
          var n1 = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: i1({}, n1, {
              value: T1
            }),
            info: i1({}, n1, {
              value: X
            }),
            warn: i1({}, n1, {
              value: f1
            }),
            error: i1({}, n1, {
              value: s1
            }),
            group: i1({}, n1, {
              value: Z
            }),
            groupCollapsed: i1({}, n1, {
              value: L1
            }),
            groupEnd: i1({}, n1, {
              value: C1
            })
          });
        }
        t1 < 0 && H("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var x1 = v.ReactCurrentDispatcher, l1;
    function u1(n1, _1, P1) {
      {
        if (l1 === void 0)
          try {
            throw Error();
          } catch (h2) {
            var J1 = h2.stack.trim().match(/\n( *(at )?)/);
            l1 = J1 && J1[1] || "";
          }
        return `
` + l1 + n1;
      }
    }
    var H1 = !1, D1;
    {
      var w1 = typeof WeakMap == "function" ? WeakMap : Map;
      D1 = new w1();
    }
    function E1(n1, _1) {
      if (!n1 || H1)
        return "";
      {
        var P1 = D1.get(n1);
        if (P1 !== void 0)
          return P1;
      }
      var J1;
      H1 = !0;
      var h2 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var v2;
      v2 = x1.current, x1.current = null, N1();
      try {
        if (_1) {
          var m2 = function() {
            throw Error();
          };
          if (Object.defineProperty(m2.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m2, []);
            } catch (e3) {
              J1 = e3;
            }
            Reflect.construct(n1, [], m2);
          } else {
            try {
              m2.call();
            } catch (e3) {
              J1 = e3;
            }
            n1.call(m2.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (e3) {
            J1 = e3;
          }
          n1();
        }
      } catch (e3) {
        if (e3 && J1 && typeof e3.stack == "string") {
          for (var s2 = e3.stack.split(`
`), K2 = J1.stack.split(`
`), w2 = s2.length - 1, S2 = K2.length - 1; w2 >= 1 && S2 >= 0 && s2[w2] !== K2[S2]; )
            S2--;
          for (; w2 >= 1 && S2 >= 0; w2--, S2--)
            if (s2[w2] !== K2[S2]) {
              if (w2 !== 1 || S2 !== 1)
                do
                  if (w2--, S2--, S2 < 0 || s2[w2] !== K2[S2]) {
                    var U2 = `
` + s2[w2].replace(" at new ", " at ");
                    return n1.displayName && U2.includes("<anonymous>") && (U2 = U2.replace("<anonymous>", n1.displayName)), typeof n1 == "function" && D1.set(n1, U2), U2;
                  }
                while (w2 >= 1 && S2 >= 0);
              break;
            }
        }
      } finally {
        H1 = !1, x1.current = v2, O1(), Error.prepareStackTrace = h2;
      }
      var _3 = n1 ? n1.displayName || n1.name : "", n4 = _3 ? u1(_3) : "";
      return typeof n1 == "function" && D1.set(n1, n4), n4;
    }
    function A1(n1, _1, P1) {
      return E1(n1, !1);
    }
    function R1(n1) {
      var _1 = n1.prototype;
      return !!(_1 && _1.isReactComponent);
    }
    function Z1(n1, _1, P1) {
      if (n1 == null)
        return "";
      if (typeof n1 == "function")
        return E1(n1, R1(n1));
      if (typeof n1 == "string")
        return u1(n1);
      switch (n1) {
        case Q:
          return u1("Suspense");
        case u:
          return u1("SuspenseList");
      }
      if (typeof n1 == "object")
        switch (n1.$$typeof) {
          case s:
            return A1(n1.render);
          case l:
            return Z1(n1.type, _1, P1);
          case c: {
            var J1 = n1, h2 = J1._payload, v2 = J1._init;
            try {
              return Z1(v2(h2), _1, P1);
            } catch {
            }
          }
        }
      return "";
    }
    var r2 = Object.prototype.hasOwnProperty, I2 = {}, X1 = v.ReactDebugCurrentFrame;
    function x2(n1) {
      if (n1) {
        var _1 = n1._owner, P1 = Z1(n1.type, n1._source, _1 ? _1.type : null);
        X1.setExtraStackFrame(P1);
      } else
        X1.setExtraStackFrame(null);
    }
    function R2(n1, _1, P1, J1, h2) {
      {
        var v2 = Function.call.bind(r2);
        for (var m2 in n1)
          if (v2(n1, m2)) {
            var s2 = void 0;
            try {
              if (typeof n1[m2] != "function") {
                var K2 = Error((J1 || "React class") + ": " + P1 + " type `" + m2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n1[m2] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K2.name = "Invariant Violation", K2;
              }
              s2 = n1[m2](_1, m2, J1, P1, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w2) {
              s2 = w2;
            }
            s2 && !(s2 instanceof Error) && (x2(h2), H("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", J1 || "React class", P1, m2, typeof s2), x2(null)), s2 instanceof Error && !(s2.message in I2) && (I2[s2.message] = !0, x2(h2), H("Failed %s type: %s", P1, s2.message), x2(null));
          }
      }
    }
    var f3 = Array.isArray;
    function q2(n1) {
      return f3(n1);
    }
    function V2(n1) {
      {
        var _1 = typeof Symbol == "function" && Symbol.toStringTag, P1 = _1 && n1[Symbol.toStringTag] || n1.constructor.name || "Object";
        return P1;
      }
    }
    function n2(n1) {
      try {
        return A3(n1), !1;
      } catch {
        return !0;
      }
    }
    function A3(n1) {
      return "" + n1;
    }
    function g1(n1) {
      if (n2(n1))
        return H("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", V2(n1)), A3(n1);
    }
    var S1 = v.ReactCurrentOwner, G = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, u2, L2, J2;
    J2 = {};
    function C3(n1) {
      if (r2.call(n1, "ref")) {
        var _1 = Object.getOwnPropertyDescriptor(n1, "ref").get;
        if (_1 && _1.isReactWarning)
          return !1;
      }
      return n1.ref !== void 0;
    }
    function l3(n1) {
      if (r2.call(n1, "key")) {
        var _1 = Object.getOwnPropertyDescriptor(n1, "key").get;
        if (_1 && _1.isReactWarning)
          return !1;
      }
      return n1.key !== void 0;
    }
    function z3(n1, _1) {
      if (typeof n1.ref == "string" && S1.current && _1 && S1.current.stateNode !== _1) {
        var P1 = J(S1.current.type);
        J2[P1] || (H('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', J(S1.current.type), n1.ref), J2[P1] = !0);
      }
    }
    function D3(n1, _1) {
      {
        var P1 = function() {
          u2 || (u2 = !0, H("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _1));
        };
        P1.isReactWarning = !0, Object.defineProperty(n1, "key", {
          get: P1,
          configurable: !0
        });
      }
    }
    function $2(n1, _1) {
      {
        var P1 = function() {
          L2 || (L2 = !0, H("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _1));
        };
        P1.isReactWarning = !0, Object.defineProperty(n1, "ref", {
          get: P1,
          configurable: !0
        });
      }
    }
    var V3 = function(n1, _1, P1, J1, h2, v2, m2) {
      var s2 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: n1,
        key: _1,
        ref: P1,
        props: m2,
        // Record the component responsible for creating this element.
        _owner: v2
      };
      return s2._store = {}, Object.defineProperty(s2._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(s2, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: J1
      }), Object.defineProperty(s2, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h2
      }), Object.freeze && (Object.freeze(s2.props), Object.freeze(s2)), s2;
    };
    function y3(n1, _1, P1, J1, h2) {
      {
        var v2, m2 = {}, s2 = null, K2 = null;
        P1 !== void 0 && (g1(P1), s2 = "" + P1), l3(_1) && (g1(_1.key), s2 = "" + _1.key), C3(_1) && (K2 = _1.ref, z3(_1, h2));
        for (v2 in _1)
          r2.call(_1, v2) && !G.hasOwnProperty(v2) && (m2[v2] = _1[v2]);
        if (n1 && n1.defaultProps) {
          var w2 = n1.defaultProps;
          for (v2 in w2)
            m2[v2] === void 0 && (m2[v2] = w2[v2]);
        }
        if (s2 || K2) {
          var S2 = typeof n1 == "function" ? n1.displayName || n1.name || "Unknown" : n1;
          s2 && D3(m2, S2), K2 && $2(m2, S2);
        }
        return V3(n1, s2, K2, h2, J1, S1.current, m2);
      }
    }
    var u3 = v.ReactCurrentOwner, k3 = v.ReactDebugCurrentFrame;
    function x3(n1) {
      if (n1) {
        var _1 = n1._owner, P1 = Z1(n1.type, n1._source, _1 ? _1.type : null);
        k3.setExtraStackFrame(P1);
      } else
        k3.setExtraStackFrame(null);
    }
    var H2;
    H2 = !1;
    function j3(n1) {
      return typeof n1 == "object" && n1 !== null && n1.$$typeof === t;
    }
    function v4() {
      {
        if (u3.current) {
          var n1 = J(u3.current.type);
          if (n1)
            return `

Check the render method of \`` + n1 + "`.";
        }
        return "";
      }
    }
    function L4(n1) {
      {
        if (n1 !== void 0) {
          var _1 = n1.fileName.replace(/^.*[\\\/]/, ""), P1 = n1.lineNumber;
          return `

Check your code at ` + _1 + ":" + P1 + ".";
        }
        return "";
      }
    }
    var I3 = {};
    function S4(n1) {
      {
        var _1 = v4();
        if (!_1) {
          var P1 = typeof n1 == "string" ? n1 : n1.displayName || n1.name;
          P1 && (_1 = `

Check the top-level render call using <` + P1 + ">.");
        }
        return _1;
      }
    }
    function $3(n1, _1) {
      {
        if (!n1._store || n1._store.validated || n1.key != null)
          return;
        n1._store.validated = !0;
        var P1 = S4(_1);
        if (I3[P1])
          return;
        I3[P1] = !0;
        var J1 = "";
        n1 && n1._owner && n1._owner !== u3.current && (J1 = " It was passed a child from " + J(n1._owner.type) + "."), x3(n1), H('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', P1, J1), x3(null);
      }
    }
    function Z2(n1, _1) {
      {
        if (typeof n1 != "object")
          return;
        if (q2(n1))
          for (var P1 = 0; P1 < n1.length; P1++) {
            var J1 = n1[P1];
            j3(J1) && $3(J1, _1);
          }
        else if (j3(n1))
          n1._store && (n1._store.validated = !0);
        else if (n1) {
          var h2 = p(n1);
          if (typeof h2 == "function" && h2 !== n1.entries)
            for (var v2 = h2.call(n1), m2; !(m2 = v2.next()).done; )
              j3(m2.value) && $3(m2.value, _1);
        }
      }
    }
    function $4(n1) {
      {
        var _1 = n1.type;
        if (_1 == null || typeof _1 == "string")
          return;
        var P1;
        if (typeof _1 == "function")
          P1 = _1.propTypes;
        else if (typeof _1 == "object" && (_1.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _1.$$typeof === l))
          P1 = _1.propTypes;
        else
          return;
        if (P1) {
          var J1 = J(_1);
          R2(P1, n1.props, "prop", J1, n1);
        } else if (_1.PropTypes !== void 0 && !H2) {
          H2 = !0;
          var h2 = J(_1);
          H("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", h2 || "Unknown");
        }
        typeof _1.getDefaultProps == "function" && !_1.getDefaultProps.isReactClassApproved && H("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Z4(n1) {
      {
        for (var _1 = Object.keys(n1.props), P1 = 0; P1 < _1.length; P1++) {
          var J1 = _1[P1];
          if (J1 !== "children" && J1 !== "key") {
            x3(n1), H("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", J1), x3(null);
            break;
          }
        }
        n1.ref !== null && (x3(n1), H("Invalid attribute `ref` supplied to `React.Fragment`."), x3(null));
      }
    }
    function W4(n1, _1, P1, J1, h2, v2) {
      {
        var m2 = $(n1);
        if (!m2) {
          var s2 = "";
          (n1 === void 0 || typeof n1 == "object" && n1 !== null && Object.keys(n1).length === 0) && (s2 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var K2 = L4(h2);
          K2 ? s2 += K2 : s2 += v4();
          var w2;
          n1 === null ? w2 = "null" : q2(n1) ? w2 = "array" : n1 !== void 0 && n1.$$typeof === t ? (w2 = "<" + (J(n1.type) || "Unknown") + " />", s2 = " Did you accidentally export a JSX literal instead of a component?") : w2 = typeof n1, H("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w2, s2);
        }
        var S2 = y3(n1, _1, P1, h2, v2);
        if (S2 == null)
          return S2;
        if (m2) {
          var U2 = _1.children;
          if (U2 !== void 0)
            if (J1)
              if (q2(U2)) {
                for (var _3 = 0; _3 < U2.length; _3++)
                  Z2(U2[_3], n1);
                Object.freeze && Object.freeze(U2);
              } else
                H("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Z2(U2, n1);
        }
        return n1 === n ? Z4(S2) : $4(S2), S2;
      }
    }
    function Y2(n1, _1, P1) {
      return W4(n1, _1, P1, !0);
    }
    function G4(n1, _1, P1) {
      return W4(n1, _1, P1, !1);
    }
    var M6 = G4, w6 = Y2;
    Hr.Fragment = n, Hr.jsx = M6, Hr.jsxs = w6;
  }()), Hr;
}
process.env.NODE_ENV === "production" ? UT.exports = K_() : UT.exports = eO();
var hp = UT.exports, ea = {};
Object.defineProperty(ea, "__esModule", { value: !0 });
ea.PopoverPortal = void 0;
var tO = y, rO = wd, nO = function(e) {
  var t = e.container, r = e.element, n = e.scoutElement, i = e.children;
  return tO.useLayoutEffect(function() {
    return t.appendChild(r), t.appendChild(n), function() {
      t.removeChild(r), t.removeChild(n);
    };
  }, [t, r]), rO.createPortal(i, r);
};
ea.PopoverPortal = nO;
var ta = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getNudgedPopoverRect = e.getNewPopoverRect = e.popoverRectForPosition = e.getBoundingRectNeglectingPositionalTransform = e.createContainer = e.targetPositionHasChanged = e.popoverStatesAreEqual = e.rectsAreEqual = e.arrayUnique = e.Constants = void 0, e.Constants = {
    POPOVER_CONTAINER_CLASS_NAME: "react-tiny-popover-container",
    DEFAULT_ALIGN: "center",
    OBSERVER_THRESHOLDS: Array(1e3).fill(null).map(function(u, l) {
      return l / 1e3;
    }).reverse(),
    DEFAULT_POSITIONS: ["top", "left", "right", "bottom"],
    EMPTY_CLIENT_RECT: {
      top: 0,
      left: 0,
      bottom: 0,
      height: 0,
      right: 0,
      width: 0
    }
  };
  var t = function(u) {
    return u.filter(function(l, c, f) {
      return f.indexOf(l) === c;
    });
  };
  e.arrayUnique = t;
  var r = function(u, l) {
    return u === l || (u == null ? void 0 : u.bottom) === (l == null ? void 0 : l.bottom) && (u == null ? void 0 : u.height) === (l == null ? void 0 : l.height) && (u == null ? void 0 : u.left) === (l == null ? void 0 : l.left) && (u == null ? void 0 : u.right) === (l == null ? void 0 : l.right) && (u == null ? void 0 : u.top) === (l == null ? void 0 : l.top) && (u == null ? void 0 : u.width) === (l == null ? void 0 : l.width);
  };
  e.rectsAreEqual = r;
  var n = function(u, l) {
    return u === l || (u == null ? void 0 : u.align) === (l == null ? void 0 : l.align) && (u == null ? void 0 : u.nudgedLeft) === (l == null ? void 0 : l.nudgedLeft) && (u == null ? void 0 : u.nudgedTop) === (l == null ? void 0 : l.nudgedTop) && u.padding === l.padding && e.rectsAreEqual(u == null ? void 0 : u.popoverRect, l == null ? void 0 : l.popoverRect) && e.rectsAreEqual(u == null ? void 0 : u.childRect, l == null ? void 0 : l.childRect) && (u == null ? void 0 : u.position) === (l == null ? void 0 : l.position);
  };
  e.popoverStatesAreEqual = n;
  var i = function(u, l) {
    return u === void 0 || u.left !== l.left || u.top !== l.top || u.width !== l.width || u.height !== l.height;
  };
  e.targetPositionHasChanged = i;
  var o = function(u, l) {
    var c = window.document.createElement("div");
    return l && (c.className = l), Object.assign(c.style, u), c;
  };
  e.createContainer = o;
  var a = function(u) {
    if (u != null) {
      var l = u, c = 0, f = 0;
      do
        c += l.offsetTop, f += l.offsetLeft, l = l.offsetParent;
      while (l != null);
      var d = 0, m = 0;
      l = u;
      do
        d += l.scrollTop, m += l.scrollLeft, l = l.parentElement;
      while (l != null);
      c -= d, f -= m;
      var p = u.getBoundingClientRect(), v = p.width, H = p.height;
      return { top: c, left: f, width: v, height: H, bottom: c + H, right: f + v };
    }
  };
  e.getBoundingRectNeglectingPositionalTransform = a;
  var T = function(u, l, c, f, d) {
    var m = l.left + l.width / 2, p = l.top + l.height / 2, v = c.width, H = c.height, E, M;
    switch (u) {
      case "left":
        E = p - H / 2, M = l.left - f - v, d === "start" && (E = l.top), d === "end" && (E = l.bottom - H);
        break;
      case "bottom":
        E = l.bottom + f, M = m - v / 2, d === "start" && (M = l.left), d === "end" && (M = l.right - v);
        break;
      case "right":
        E = p - H / 2, M = l.right + f, d === "start" && (E = l.top), d === "end" && (E = l.bottom - H);
        break;
      default:
        E = l.top - H - f, M = m - v / 2, d === "start" && (M = l.left), d === "end" && (M = l.right - v);
        break;
    }
    return { top: E, left: M, width: v, height: H, right: M + v, bottom: E + H };
  };
  e.popoverRectForPosition = T;
  var s = function(u, l) {
    var c = u.position, f = u.align, d = u.childRect, m = u.popoverRect, p = u.boundaryRect, v = u.padding, H = u.reposition, E = e.popoverRectForPosition(c, d, m, v, f), M = H && (c === "top" && E.top < p.top + l || c === "left" && E.left < p.left + l || c === "right" && E.right > p.right - l || c === "bottom" && E.bottom > p.bottom - l);
    return {
      rect: E,
      boundaryViolation: M
    };
  };
  e.getNewPopoverRect = s;
  var Q = function(u, l, c) {
    var f = l.top + c, d = l.left + c, m = l.right - c, p = l.bottom - c, v = u.top < f ? f : u.top;
    v = v + u.height > p ? p - u.height : v;
    var H = u.left < d ? d : u.left;
    return H = H + u.width > m ? m - u.width : H, {
      top: v,
      left: H,
      width: u.width,
      height: u.height,
      right: H + u.width,
      bottom: v + u.height
    };
  };
  e.getNudgedPopoverRect = Q;
})(ta);
var ra = {}, na = {};
Object.defineProperty(na, "__esModule", { value: !0 });
na.useElementRef = void 0;
var Kf = y, iO = ta, oO = function(e, t) {
  var r = Kf.useMemo(function() {
    return iO.createContainer(t, e);
  }, [e, t]);
  return Kf.useRef(r);
};
na.useElementRef = oO;
Object.defineProperty(ra, "__esModule", { value: !0 });
ra.usePopover = void 0;
var aO = y, ed = ta, td = na, QO = function(e) {
  var t = e.childRef, r = e.positions, n = e.containerClassName, i = e.parentElement, o = e.contentLocation, a = e.align, T = e.padding, s = e.reposition, Q = e.boundaryInset, u = e.boundaryElement, l = e.onPositionPopover, c = td.useElementRef(n, {
    position: "fixed",
    overflow: "visible",
    top: "0px",
    left: "0px"
  }), f = td.useElementRef("react-tiny-popover-scout", {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "0px",
    height: "0px",
    visibility: "hidden"
  }), d = aO.useCallback(function(m) {
    var p, v, H = m === void 0 ? {} : m, E = H.positionIndex, M = E === void 0 ? 0 : E, C = H.parentRect, w = C === void 0 ? i.getBoundingClientRect() : C, S = H.childRect, D = S === void 0 ? (p = t == null ? void 0 : t.current) === null || p === void 0 ? void 0 : p.getBoundingClientRect() : S, k = H.scoutRect, $ = k === void 0 ? (v = f == null ? void 0 : f.current) === null || v === void 0 ? void 0 : v.getBoundingClientRect() : k, z = H.popoverRect, j = z === void 0 ? c.current.getBoundingClientRect() : z, J = H.boundaryRect, i1 = J === void 0 ? u === i ? w : u.getBoundingClientRect() : J;
    if (!(!D || !w)) {
      if (o) {
        var t1 = typeof o == "function" ? o({
          childRect: D,
          popoverRect: j,
          parentRect: w,
          boundaryRect: i1,
          padding: T,
          nudgedTop: 0,
          nudgedLeft: 0,
          boundaryInset: Q
        }) : o, T1 = t1.top, X = t1.left, f1 = w.left + X, s1 = w.top + T1;
        c.current.style.transform = "translate(" + (f1 - $.left) + "px, " + (s1 - $.top) + "px)", l({
          childRect: D,
          popoverRect: j,
          parentRect: w,
          boundaryRect: i1,
          padding: T,
          nudgedTop: 0,
          nudgedLeft: 0,
          boundaryInset: Q
        });
        return;
      }
      var Z = M === r.length, L1 = Z ? r[0] : r[M], C1 = ed.getNewPopoverRect({
        childRect: D,
        popoverRect: j,
        boundaryRect: i1,
        position: L1,
        align: a,
        padding: T,
        reposition: s
      }, Q), q = C1.rect, N1 = C1.boundaryViolation;
      if (N1 && s && !Z) {
        d({
          positionIndex: M + 1,
          childRect: D,
          popoverRect: j,
          parentRect: w,
          boundaryRect: i1
        });
        return;
      }
      var O1 = q.top, x1 = q.left, l1 = q.width, u1 = q.height, H1 = s && !Z, D1 = ed.getNudgedPopoverRect(q, i1, Q), w1 = D1.left, E1 = D1.top, A1 = O1, R1 = x1;
      H1 && (A1 = E1, R1 = w1), c.current.style.transform = "translate(" + (R1 - $.left) + "px, " + (A1 - $.top) + "px)", l({
        childRect: D,
        popoverRect: {
          top: A1,
          left: R1,
          width: l1,
          height: u1,
          right: R1 + l1,
          bottom: A1 + u1
        },
        parentRect: w,
        boundaryRect: i1,
        position: L1,
        align: a,
        padding: T,
        nudgedTop: E1 - O1,
        nudgedLeft: w1 - x1,
        boundaryInset: Q
      });
    }
  }, [
    i,
    t,
    c,
    u,
    o,
    r,
    a,
    T,
    s,
    Q,
    l
  ]);
  return {
    positionPopover: d,
    popoverRef: c,
    scoutRef: f
  };
};
ra.usePopover = QO;
var ia = {};
Object.defineProperty(ia, "__esModule", { value: !0 });
ia.useMemoizedArray = void 0;
var rd = y, TO = function(e) {
  var t = rd.useRef(e), r = rd.useMemo(function() {
    if (t.current === e)
      return t.current;
    if (t.current.length !== e.length)
      return t.current = e, e;
    for (var n = 0; n < e.length; n += 1)
      if (e[n] !== t.current[n])
        return t.current = e, e;
    return t.current;
  }, [e]);
  return r;
};
ia.useMemoizedArray = TO;
var m8 = {}, XT = b && b.__assign || function() {
  return XT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, XT.apply(this, arguments);
};
Object.defineProperty(m8, "__esModule", { value: !0 });
m8.useArrowContainer = void 0;
var nd = y, sO = function(e) {
  var t = e.childRect, r = e.popoverRect, n = e.position, i = e.arrowSize, o = e.arrowColor, a = nd.useMemo(function() {
    return {
      padding: i
    };
  }, [i]), T = nd.useMemo(function() {
    return XT({ position: "absolute" }, function() {
      var s = i * 2, Q = t.top - r.top + t.height / 2 - s / 2, u = t.left - r.left + t.width / 2 - s / 2, l = i, c = r.width - i, f = r.height - i;
      switch (u = u < l ? l : u, u = u + s > c ? c - s : u, Q = Q < l ? l : Q, Q = Q + s > f ? f - s : Q, Q = Number.isNaN(Q) ? 0 : Q, u = Number.isNaN(u) ? 0 : u, n) {
        case "right":
          return {
            borderTop: i + "px solid transparent",
            borderBottom: i + "px solid transparent",
            borderRight: i + "px solid " + o,
            left: 0,
            top: Q
          };
        case "left":
          return {
            borderTop: i + "px solid transparent",
            borderBottom: i + "px solid transparent",
            borderLeft: i + "px solid " + o,
            right: 0,
            top: Q
          };
        case "bottom":
          return {
            borderLeft: i + "px solid transparent",
            borderRight: i + "px solid transparent",
            borderBottom: i + "px solid " + o,
            top: 0,
            left: u
          };
        case "top":
          return {
            borderLeft: i + "px solid transparent",
            borderRight: i + "px solid transparent",
            borderTop: i + "px solid " + o,
            bottom: 0,
            left: u
          };
        default:
          return {
            display: "hidden"
          };
      }
    }());
  }, [
    o,
    i,
    t.height,
    t.left,
    t.top,
    t.width,
    r.height,
    r.left,
    r.top,
    r.width,
    n
  ]);
  return {
    arrowContainerStyle: a,
    arrowStyle: T
  };
};
m8.useArrowContainer = sO;
var oa = {}, Ne = b && b.__assign || function() {
  return Ne = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ne.apply(this, arguments);
};
Object.defineProperty(oa, "__esModule", { value: !0 });
oa.ArrowContainer = void 0;
var id = hp, od = y, lO = m8, uO = function(e) {
  var t = e.childRect, r = e.popoverRect, n = e.position, i = e.arrowColor, o = e.arrowSize, a = e.arrowClassName, T = e.arrowStyle, s = e.className, Q = e.children, u = e.style, l = lO.useArrowContainer({
    childRect: t,
    popoverRect: r,
    position: n,
    arrowColor: i,
    arrowSize: o
  }), c = l.arrowContainerStyle, f = l.arrowStyle, d = od.useMemo(function() {
    return Ne(Ne({}, c), u);
  }, [c, u]), m = od.useMemo(function() {
    return Ne(Ne({}, f), T);
  }, [f, T]);
  return id.jsxs("div", Ne({ className: s, style: d }, { children: [id.jsx("div", { style: m, className: a }, void 0), Q] }), void 0);
};
oa.ArrowContainer = uO;
(function(e) {
  var t = b && b.__assign || function() {
    return t = Object.assign || function(l) {
      for (var c, f = 1, d = arguments.length; f < d; f++) {
        c = arguments[f];
        for (var m in c)
          Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
      }
      return l;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Popover = e.usePopover = e.ArrowContainer = e.useArrowContainer = void 0;
  var r = hp, n = y, i = ea, o = ta, a = ra;
  Object.defineProperty(e, "usePopover", { enumerable: !0, get: function() {
    return a.usePopover;
  } });
  var T = ia, s = m8;
  Object.defineProperty(e, "useArrowContainer", { enumerable: !0, get: function() {
    return s.useArrowContainer;
  } });
  var Q = oa;
  Object.defineProperty(e, "ArrowContainer", { enumerable: !0, get: function() {
    return Q.ArrowContainer;
  } });
  var u = n.forwardRef(function(l, c) {
    var f = l.isOpen, d = l.children, m = l.content, p = l.positions, v = p === void 0 ? o.Constants.DEFAULT_POSITIONS : p, H = l.align, E = H === void 0 ? o.Constants.DEFAULT_ALIGN : H, M = l.padding, C = M === void 0 ? 0 : M, w = l.reposition, S = w === void 0 ? !0 : w, D = l.parentElement, k = D === void 0 ? window.document.body : D, $ = l.boundaryElement, z = $ === void 0 ? k : $, j = l.containerClassName, J = j === void 0 ? "react-tiny-popover-container" : j, i1 = l.containerStyle, t1 = l.contentLocation, T1 = l.boundaryInset, X = T1 === void 0 ? 0 : T1, f1 = l.onClickOutside, s1 = T.useMemoizedArray(v), Z = n.useRef(!1), L1 = n.useRef(), C1 = n.useRef(), q = n.useRef(S), N1 = n.useRef(), O1 = n.useState({
      align: E,
      nudgedLeft: 0,
      nudgedTop: 0,
      position: s1[0],
      padding: C,
      childRect: o.Constants.EMPTY_CLIENT_RECT,
      popoverRect: o.Constants.EMPTY_CLIENT_RECT,
      parentRect: o.Constants.EMPTY_CLIENT_RECT,
      boundaryRect: o.Constants.EMPTY_CLIENT_RECT,
      boundaryInset: X
    }), x1 = O1[0], l1 = O1[1], u1 = n.useCallback(function(X1) {
      return l1(X1);
    }, []), H1 = a.usePopover({
      childRef: N1,
      containerClassName: J,
      parentElement: k,
      boundaryElement: z,
      contentLocation: t1,
      positions: s1,
      align: E,
      padding: C,
      boundaryInset: X,
      reposition: S,
      onPositionPopover: u1
    }), D1 = H1.positionPopover, w1 = H1.popoverRef, E1 = H1.scoutRef;
    n.useLayoutEffect(function() {
      var X1 = !0, x2 = function() {
        var R2, f3;
        if (f && X1) {
          var q2 = (R2 = N1 == null ? void 0 : N1.current) === null || R2 === void 0 ? void 0 : R2.getBoundingClientRect(), V2 = (f3 = w1 == null ? void 0 : w1.current) === null || f3 === void 0 ? void 0 : f3.getBoundingClientRect();
          q2 != null && V2 != null && (!o.rectsAreEqual(q2, {
            top: x1.childRect.top,
            left: x1.childRect.left,
            width: x1.childRect.width,
            height: x1.childRect.height,
            bottom: x1.childRect.top + x1.childRect.height,
            right: x1.childRect.left + x1.childRect.width
          }) || V2.width !== x1.popoverRect.width || V2.height !== x1.popoverRect.height || x1.padding !== C || x1.align !== E || s1 !== L1.current || t1 !== C1.current || S !== q.current) && D1(), s1 !== L1.current && (L1.current = s1), t1 !== C1.current && (C1.current = t1), S !== q.current && (q.current = S), X1 && window.requestAnimationFrame(x2);
        }
        Z.current = f;
      };
      return window.requestAnimationFrame(x2), function() {
        X1 = !1;
      };
    }, [
      E,
      t1,
      f,
      C,
      w1,
      x1.align,
      x1.childRect.height,
      x1.childRect.left,
      x1.childRect.top,
      x1.childRect.width,
      x1.padding,
      x1.popoverRect.height,
      x1.popoverRect.width,
      D1,
      s1,
      S
    ]), n.useEffect(function() {
      var X1 = w1.current;
      return Object.assign(X1.style, i1), function() {
        Object.keys(i1 ?? {}).forEach(function(x2) {
          return delete X1.style[x2];
        });
      };
    }, [i1, f, w1]);
    var A1 = n.useCallback(function(X1) {
      var x2, R2;
      f && !(!((x2 = w1.current) === null || x2 === void 0) && x2.contains(X1.target)) && !(!((R2 = N1.current) === null || R2 === void 0) && R2.contains(X1.target)) && (f1 == null || f1(X1));
    }, [f, f1, w1]), R1 = n.useCallback(function() {
      N1.current && window.requestAnimationFrame(function() {
        return D1();
      });
    }, [D1]);
    n.useEffect(function() {
      return window.addEventListener("click", A1), window.addEventListener("resize", R1), function() {
        window.removeEventListener("click", A1), window.removeEventListener("resize", R1);
      };
    }, [A1, R1]);
    var Z1 = n.useCallback(function(X1) {
      N1.current = X1, c != null && (typeof c == "object" ? c.current = X1 : typeof c == "function" && c(X1));
    }, [c]), r2 = function() {
      return n.cloneElement(d, {
        ref: Z1
      });
    }, I2 = function() {
      return f ? r.jsx(i.PopoverPortal, t({ element: w1.current, scoutElement: E1.current, container: k }, { children: typeof m == "function" ? m(x1) : m }), void 0) : null;
    };
    return r.jsxs(r.Fragment, { children: [r2(), I2()] }, void 0);
  });
  e.Popover = n.forwardRef(function(l, c) {
    return typeof window > "u" ? l.children : r.jsx(u, t({}, l, { ref: c }), void 0);
  });
})(zT);
function n5({
  trigger: e,
  children: t,
  positions: r = ["bottom", "top"],
  parentElement: n,
  triggerStyle: i = {},
  handleClickTrigger: o,
  ...a
}) {
  const [T, s] = W1(!1), Q = () => {
    s((c) => !c), o && o();
  }, u = () => {
    s(!1);
  }, l = $9();
  return /* @__PURE__ */ y.createElement(zT.Popover, { isOpen: T, parentElement: n, positions: r, padding: a.padding ? a.padding : l.spacingHalfValue, onClickOutside: u, reposition: !0, containerStyle: {
    zIndex: "1000"
  }, content: ({
    position: c,
    childRect: f,
    popoverRect: d
  }) => /* @__PURE__ */ y.createElement(fO, { ...a, onClick: Q, $show: T }, /* @__PURE__ */ y.createElement(zT.ArrowContainer, { position: c, childRect: f, popoverRect: d, arrowColor: a.arrowColor ? a.arrowColor : l.lightPrimaryColor, arrowSize: 10 }, /* @__PURE__ */ y.createElement(y.Fragment, null, t))) }, /* @__PURE__ */ y.createElement(cO, { style: i, onClick: Q }, e));
}
const cO = M1.button.withConfig({
  displayName: "popover__TriggerButton",
  componentId: "sc-1ai7nwg-0"
})(["border:none;background-image:none;background-color:transparent;box-shadow:none;padding:0;margin:0;display:flex;"]), fO = M1.div.withConfig({
  displayName: "popover__PopupView",
  componentId: "sc-1ai7nwg-1"
})(["", " text-align:center;border-radius:6px;width:fit-content;max-height:60%;min-width:100px;@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}"], ({
  $show: e
}) => e ? `
		animation: fadeIn 600ms cubic-bezier(0.390, 0.575, 0.565, 1.000); 
		visibility: visible;` : "visibility: hidden;");
function sl({
  choices: e,
  studentChoiceSelected: t,
  iconPrepend: r
}) {
  if (!e || e.length === 0)
    return /* @__PURE__ */ y.createElement(y.Fragment, null, "No question options to show");
  const n = e.some((i) => (i == null ? void 0 : i.text) !== "");
  return /* @__PURE__ */ y.createElement(Go, null, /* @__PURE__ */ y.createElement("ul", null, e.map((i, o) => {
    var s, Q;
    const a = Array.isArray(t) ? t.indexOf(String(i._id)) > -1 : String(i._id) === String(t), T = (Q = (s = i.media) == null ? void 0 : s[0]) == null ? void 0 : Q.url;
    return /* @__PURE__ */ y.createElement("li", { className: S3("flex items-center", i.answer ? "text-success" : a && "text-error"), key: String(i._id) || `${o}-question-option` }, /* @__PURE__ */ y.createElement(p8, { studentChoice: a, correctOption: i.answer }), r && /* @__PURE__ */ y.createElement("span", { className: `square ${a ? "selected" : ""}` }), /* @__PURE__ */ y.createElement("div", { className: "flex flex-row items-center" }, /* @__PURE__ */ y.createElement("div", null, ot(o) + ":"), /* @__PURE__ */ y.createElement("div", { className: "ml-2" }, n ? i.text ? /* @__PURE__ */ y.createElement(O2, null, i.text) : "(No text provided)" : "")), T && /* @__PURE__ */ y.createElement("img", { alt: `Choice Image ${o}`, src: T, className: "ml-2 h-[100px] w-auto" }));
  })));
}
function aa({
  onChange: e
}) {
  const t = () => {
    e && e({
      type: c3.DELETE_QUESTION
    });
  };
  return /* @__PURE__ */ y.createElement("div", { className: "flex p-2 bg-brand-deep-blue text-brand-cloud-blue rounded-b-lg" }, /* @__PURE__ */ y.createElement("button", { onClick: t, className: "flex items-center hover:brightness-90 active:brightness-75 px-2 space-x-1" }, /* @__PURE__ */ y.createElement($o, { size: 12 }), /* @__PURE__ */ y.createElement("span", null, "Delete")));
}
function dO(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 16l-6-6h12z" } }] }] })(e);
}
function Qa({
  expand: e,
  header: t,
  children: r,
  handleClick: n,
  buttonAction: i
}) {
  return /* @__PURE__ */ y.createElement("div", { className: "p-2 rounded-lg bg-brand-deep-blue" }, /* @__PURE__ */ y.createElement("div", { className: "flex justify-between" }, t, /* @__PURE__ */ y.createElement("div", { className: "flex items-center text-right" }, i && /* @__PURE__ */ y.createElement("div", { className: "mx-2" }, i), /* @__PURE__ */ y.createElement("button", { className: "border-l-2 h-full pl-2 ", onClick: n }, /* @__PURE__ */ y.createElement(dO, { className: `scale-150 ${e ? "rotate-180" : ""}` })))), e && /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("hr", { className: "mt-2" }), r));
}
function hO({
  onChange: e
}) {
  const [t, r] = W1(""), n = {
    onSuccess: (i) => {
      r(""), e && e(i);
    },
    onError: r
  };
  return /* @__PURE__ */ y.createElement("div", { className: "flex justify-center border border-dashed rounded-md p-1 relative flex-1" }, /* @__PURE__ */ y.createElement("div", { className: "py-4", onDragOver: (i) => i.preventDefault(), onDragEnter: (i) => i.preventDefault(), onDragLeave: (i) => i.preventDefault(), onDrop: (i) => {
    var a;
    i.preventDefault();
    const o = (a = i == null ? void 0 : i.dataTransfer) == null ? void 0 : a.files;
    o && o.length && I9(o[0], n);
  } }, /* @__PURE__ */ y.createElement("div", { className: "flex flex-col items-center text-brand-horizon-blue" }, /* @__PURE__ */ y.createElement(f_, null), /* @__PURE__ */ y.createElement("div", null, "Drag and drop image "))), /* @__PURE__ */ y.createElement("input", { type: "file", "aria-label": "img-drag-n-drop", id: Tp(), onChange: (i) => {
    const o = i.target.files;
    o && o.length && I9(o[0], n);
  }, accept: "image/*", className: "inset-0 cursor-pointer absolute opacity-0 [&::-webkit-file-upload-button]:cursor-pointer " }), t && /* @__PURE__ */ y.createElement("div", { className: "text-error" }, t));
}
function pO({
  questionMedia: e,
  readOnly: t,
  onChange: r,
  dropdowns: n,
  setDropdownIndexSelected: i,
  imageProperties: o
}) {
  const a = m4(null), [T, s] = W1(!1), Q = !!(e != null && e.length), u = m3(() => {
    if (e && e.length)
      return e[0].localUrl || e[0].url || void 0;
  }, [e]), l = sp(Q ? a : null, u), c = () => {
    var E;
    !t && r && (s(!1), (E = p.current) == null || E.click());
  }, f = (E) => {
    const {
      localUrl: M
    } = Yo(E);
    !t && r && x_(E).then(({
      width: C,
      height: w
    }) => {
      r({
        type: c3.CHANGE_QUESTION_IMAGE,
        payload: {
          type: "IMAGE",
          file: E,
          localUrl: M,
          width: C,
          height: w
        }
      });
    }).catch((C) => {
      console.error(C), alert("Failed to load image.");
    });
  }, d = (E, M) => {
    if (l) {
      const C = E / o.width * l.width, w = M / o.height * l.height;
      return {
        x: C,
        y: w
      };
    }
    return null;
  }, m = (E, M) => {
    if (l) {
      const C = E / l.width * o.width, w = M / l.height * o.height;
      return {
        x: C,
        y: w
      };
    }
    return null;
  }, p = m4(null), v = am(), H = /* @__PURE__ */ y.createElement(LO, null, /* @__PURE__ */ y.createElement(rp, { $disabled: !1 }, !n || n.length === 0 ? /* @__PURE__ */ y.createElement("label", { htmlFor: v }, /* @__PURE__ */ y.createElement("img", { src: WT })) : /* @__PURE__ */ y.createElement("button", { onClick: () => {
    Q && (n.length > 0 ? s(!0) : c());
  } }, /* @__PURE__ */ y.createElement("img", { src: WT })), /* @__PURE__ */ y.createElement(yO, { ref: p, id: v, type: "file", "aria-label": "Image Uploader", onChange: (E) => {
    E.stopPropagation();
    const M = E.target.files;
    M && M.length > 0 && r && I9(M[0], {
      onSuccess: f,
      onError: alert
    });
  }, accept: ".jpg,.png,.jpeg", $_css: Q ? "display: none;" : "" })));
  return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(gO, null, Q ? /* @__PURE__ */ y.createElement(mO, null, /* @__PURE__ */ y.createElement("img", { "aria-label": "canvas-image", src: u, ref: a, onMouseUp: (E) => {
    let M;
    if (a.current) {
      const C = a.current.getBoundingClientRect(), w = E.clientX - C.left, S = E.clientY - C.top;
      M = m(w, S);
    }
    !t && r && M && (r({
      type: c3.ADD_DROPDOWN,
      payload: M
    }), n && i(n.length));
  } }), l && n && n.map((E, M) => {
    const C = d(E.x, E.y);
    if (!C)
      return null;
    const {
      x: w,
      y: S
    } = C;
    return /* @__PURE__ */ y.createElement(vO, { id: v3(E), key: `item-${M}`, style: {
      left: `${w}px`,
      top: `${S}px`
    }, onClick: () => i(M) }, M + 1);
  })) : /* @__PURE__ */ y.createElement(hO, { onChange: f }), H), /* @__PURE__ */ y.createElement(qs, { isOpen: T, confirmText: "Delete dropdowns", onCancel: () => s(!1), onConfirm: c }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement("p", null, "If you change the image, all of its dropdowns will be deleted. Are you sure you want to change the image?"))));
}
const mO = M1.div.withConfig({
  displayName: "ImageCanvas__ImageCanvasWrapper",
  componentId: "sc-1oz2uzs-0"
})(["max-width:min(100%,500px);height:auto;margin:auto;position:relative;box-sizing:border-box;img{max-height:500px;width:100%;height:100%;cursor:pointer;}button:focus{border:1px solid #ffffff;}"]), vO = M1.button.withConfig({
  displayName: "ImageCanvas__CircleButton",
  componentId: "sc-1oz2uzs-1"
})(["position:absolute;color:", ";padding:", ";border-radius:50%;width:", ";height:", ";background:", ";box-sizing:border-box;font-style:normal;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";transform:translate(-50%,-50%);border:none;cursor:pointer;"], ({
  theme: e
}) => e.white, a1.spacing1, a1.spacing6, a1.spacing6, ({
  theme: e
}) => e.primary, ({
  theme: e
}) => e.fontFamily, a1.font_semibold, a1.text_xs, a1.text_sm);
var LO = M1("div").withConfig({
  displayName: "ImageCanvas___StyledDiv",
  componentId: "sc-1oz2uzs-2"
})(["display:flex;"]), yO = M1("input").withConfig({
  displayName: "ImageCanvas___StyledInput",
  componentId: "sc-1oz2uzs-3"
})(["", ""], (e) => e.$_css), gO = M1(j0).withConfig({
  displayName: "ImageCanvas___StyledInputGroup",
  componentId: "sc-1oz2uzs-4"
})(["align-items:flex-start;"]);
function pp(e) {
  const {
    choices: t,
    index: r
  } = e;
  return /* @__PURE__ */ y.createElement(xO, { role: "section", className: "w-[calc(50%-theme(spacing.1))]" }, /* @__PURE__ */ y.createElement("div", { className: "content" }, /* @__PURE__ */ y.createElement("div", { className: "header-card" }, `Q${r + 1}:`), /* @__PURE__ */ y.createElement("ul", null, t.map((n, i) => {
    const o = n.answer ? "answer-correct" : "";
    return /* @__PURE__ */ y.createElement(HO, { key: String(n._id) }, /* @__PURE__ */ y.createElement(JQ, { className: `index ${o} ` }, `${ot(i)}.`, " "), /* @__PURE__ */ y.createElement(JQ, { className: `answer ${o}` }, /* @__PURE__ */ y.createElement(O2, null, n.text)), /* @__PURE__ */ y.createElement(JQ, { className: `answer ${o}` }, " ", `${o ? "- (Correct) " : ""}`));
  }))));
}
const JQ = M1.div.withConfig({
  displayName: "choices-readonly__InlineDiv",
  componentId: "sc-1i0r5cg-0"
})(["display:inline-block;"]), xO = M1.div.withConfig({
  displayName: "choices-readonly__DropdownWrapper",
  componentId: "sc-1i0r5cg-1"
})(["text-align:left;box-sizing:border-box;.content{padding:1rem;border:1px solid ", ";box-sizing:border-box;height:100%;}.header-card{font-family:", ";font-style:normal;font-weight:", ";font-size:", ";line-height:", ";}ul,li{margin:0;padding:", " 0;}"], ({
  theme: e
}) => e.boxShadow, ({
  theme: e
}) => e.fontFamily, a1.font_semibold, a1.text_sm, a1.text_base, a1.spacing1), HO = M1.li.withConfig({
  displayName: "choices-readonly__Option",
  componentId: "sc-1i0r5cg-2"
})(["display:block;font-family:", ";.index{font-style:normal;font-weight:", ";font-size:", ";line-height:", ";color:", ";}.answer-correct{color:", " !important;}.answer{font-style:normal;font-weight:normal;font-size:", ";line-height:", ";color:", ";}"], ({
  theme: e
}) => e.fontFamily, a1.font_semibold, a1.text_sm, a1.text_base, ({
  theme: e
}) => e.onBase, ({
  theme: e
}) => e.success, a1.text_sm, a1.text_sm, ({
  theme: e
}) => e.onBase), mp = "__________";
function t9(e) {
  const {
    color: t = "default",
    opacity: r = "1",
    width: n = 49,
    height: i = 59,
    ratio: o = 1
  } = e;
  return /* @__PURE__ */ y.createElement(EO, { width: n / o, height: i / o, viewBox: `0 0 ${n} ${i}`, fill: "none", $color: t, xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ y.createElement("g", { filter: "url(#filter0_d_121_4)" }, /* @__PURE__ */ y.createElement("path", { className: "path-icon", d: "M13.2486 4.66114C8.94437 7.75772 6.01992 12.4014 5.11679 17.5735C4.21367 22.7456 5.40561 28.0239 8.43116 32.2504C10.9026 35.7051 14.462 38.2371 18.5632 39.4582C18.5632 39.4582 19.4168 39.7121 19.5484 39.7427L42.3461 45.2056L44.4686 21.8473C44.4785 21.7239 44.5137 20.8343 44.5137 20.8343L44.5121 20.8289C44.6679 16.5546 43.4089 12.3739 40.9284 8.9282C37.8927 4.70896 33.2737 1.89021 28.0846 1.09027C22.8955 0.290334 17.5601 1.57452 13.2486 4.66114Z", opacity: r }), /* @__PURE__ */ y.createElement("path", { d: "M10.0578 31.0867L10.0574 31.0863C7.3477 27.3009 6.27509 22.5672 7.08698 17.9175C7.89907 13.2668 10.5311 9.0807 14.4147 6.286C18.3055 3.50127 23.1139 2.34762 27.7799 3.06693C32.4448 3.78606 36.5861 6.31746 39.3049 10.0963L39.3052 10.0967C41.5241 13.179 42.6531 16.9222 42.5134 20.756L42.5012 21.0902L42.5016 21.0916C42.5 21.13 42.4984 21.1699 42.4967 21.2102C42.4917 21.3281 42.4865 21.4475 42.482 21.5439C42.4778 21.635 42.4754 21.6783 42.4749 21.6871L40.5635 42.7218L20.0145 37.7977L20.0145 37.7977L20.0012 37.7946C20.0027 37.795 19.9909 37.7916 19.9673 37.7848C19.9055 37.7672 19.763 37.7265 19.5685 37.6695C19.4559 37.6366 19.347 37.6044 19.266 37.5805L19.1692 37.5518L19.1425 37.5439L19.1356 37.5418L19.1339 37.5413L19.1339 37.5413C15.4551 36.446 12.2686 34.1771 10.0578 31.0867Z", stroke: "white", strokeWidth: "4" })), /* @__PURE__ */ y.createElement("defs", null, /* @__PURE__ */ y.createElement("filter", { id: "filter0_d_121_4", x: "0.822137", y: "0.85791", width: "47.7028", height: "52.3477", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ y.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), /* @__PURE__ */ y.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ y.createElement("feOffset", { dy: "4" }), /* @__PURE__ */ y.createElement("feGaussianBlur", { stdDeviation: "2" }), /* @__PURE__ */ y.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ y.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }), /* @__PURE__ */ y.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_121_4" }), /* @__PURE__ */ y.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_121_4", result: "shape" }))));
}
const EO = M1.svg.withConfig({
  displayName: "Position__PositionSvg",
  componentId: "sc-7u3baw-0"
})(["overflow:visible;pointer-events:none;.path-icon{fill:", ""], ({
  $color: e,
  theme: t
}) => e === "success" ? t.success : e === "error" ? t.error : "#AB0586"), bO = mp;
function N9(e) {
  var T;
  const {
    question: t,
    className: r,
    ...n
  } = e, i = m4(null), o = sp(i, (T = t.media[0]) == null ? void 0 : T.url), a = t.imageProperties.width > t.imageProperties.height ? `width: ${t.imageProperties.width}px; max-width: min(60vw, 100%);` : `height: ${t.imageProperties.height}px; max-height: 60vh;`;
  return /* @__PURE__ */ y.createElement(SO, { className: r, "aria-label": "Image wrapper" }, /* @__PURE__ */ y.createElement("div", { className: "content-wrapper" }, /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(VO, { ref: i, media: t.media, $_css: a }), /* @__PURE__ */ y.createElement(vp, { question: t, dimensions: o, ...n }))));
}
function vp({
  question: e,
  dimensions: t,
  handleSelectOption: r,
  studentAnswer: n,
  isReview: i = !1,
  optionsWrapper: o,
  isQuestionSlot: a = !1,
  isReadonly: T = !1,
  parentRef: s,
  classResponse: Q,
  optionsStats: u,
  dropdownIndexSelected: l
}) {
  const [c, f] = W1(null);
  return G3(() => {
    var d;
    e && t && ((d = e.media[0]) == null ? void 0 : d.url) === t.src ? f({
      x: e.imageProperties.width / t.width,
      y: e.imageProperties.height / t.height
    }) : f(null);
  }, [t, e]), c ? /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(MO, null, e.dropdowns.map((d, m) => {
    var H;
    const p = d.choices.find((E) => E.answer), v = Q && Q.scores.type === F1.IMAGE_LABELING && Q.scores.optionScores.find((E) => E.templateResponsekey === v3(d));
    return /* @__PURE__ */ y.createElement(wO, { key: `dropdown-option-${m}`, handleClick: () => r && r(m), value: n && i6(n) ? (H = d.choices.find((E) => String(E._id) === n.value[v3(d)])) == null ? void 0 : H.text : null, x: d.x, y: d.y, ratios: c, choiceCorrect: p, isReview: i, optionsWrapper: o, isCorrect: n && i6(n) && String(p == null ? void 0 : p._id) === n.value[v3(d)], index: m, isReadonly: T, isQuestionSlot: a, parentRef: s, classResponseOptions: v ? v.choices : [], dropdownIndexSelected: l });
  })), u) : null;
}
const MO = M1.ul.withConfig({
  displayName: "ImageWrapper__UlNoStyle",
  componentId: "sc-asjw5p-0"
})(["padding-inline-start:0;margin-block-end:0;margin-block-start:0;"]);
function wO(e) {
  const {
    x: t,
    y: r,
    value: n,
    handleClick: i,
    isReview: o = !1,
    isCorrect: a = !1,
    ratios: T,
    optionsWrapper: s,
    isQuestionSlot: Q = !1,
    choiceCorrect: u,
    parentRef: l,
    isReadonly: c = !1,
    index: f,
    classResponseOptions: d,
    dropdownIndexSelected: m
  } = e;
  let p = n;
  p || (o ? p = (u == null ? void 0 : u.text) ?? "" : p = bO);
  const v = (p.length < 7 ? 15 : -15) / 16, H = $9();
  if (c)
    return /* @__PURE__ */ y.createElement(
      ad,
      {
        style: {
          left: `${t / T.x}px`,
          top: `${r / T.y}px`
        }
      },
      /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(CO, null, f + 1))
    );
  const E = d.find((S) => S._id === String(u == null ? void 0 : u._id)), M = m4(null), [C, w] = W1({
    height: 0,
    width: 0
  });
  return G3(() => {
    M.current && w({
      width: M.current.clientWidth + 10,
      height: M.current.clientHeight + 16
    });
  }, [M]), /* @__PURE__ */ y.createElement(ad, { style: {
    left: `calc(${t / T.x}px - 42px)`,
    top: `calc(${r / T.y}px - 45px)`
  } }, /* @__PURE__ */ y.createElement("div", null, d.length ? /* @__PURE__ */ y.createElement("div", { onClick: i }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(YQ, { $offsetLeft: v, $status: "REVIEWED", $isReview: !0, $isSelected: m === f }, /* @__PURE__ */ y.createElement(Er, { className: "text-value" }, /* @__PURE__ */ y.createElement(O2, null, (u == null ? void 0 : u.text) ?? "")))), /* @__PURE__ */ y.createElement($n, { ref: M }, /* @__PURE__ */ y.createElement("span", { className: "icon text-value" }, `${E ? (E.score * 100).toFixed() : 0}%`), /* @__PURE__ */ y.createElement(t9, { color: "success", opacity: "1", width: C.width, height: C.height }))) : Q ? /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(qT, { className: "value", style: {
    cursor: "default"
  }, $offsetLeft: v, $isQuestionSlot: Q, $isReview: !1 }, /* @__PURE__ */ y.createElement(Er, { className: "text-value" }, /* @__PURE__ */ y.createElement(O2, null, p))), /* @__PURE__ */ y.createElement($n, { ref: M, style: {
    cursor: "default"
  }, $isReview: !1 }, o ? a ? /* @__PURE__ */ y.createElement(ZT, { className: "icon" }) : /* @__PURE__ */ y.createElement(k9, { className: "icon" }) : null, /* @__PURE__ */ y.createElement(_O, { opacity: "0.5", color: "default", width: C.width, height: C.height }))) : o ? /* @__PURE__ */ y.createElement(n5, { padding: H.spacing2xValue, handleClickTrigger: i, parentElement: l == null ? void 0 : l.current, trigger: /* @__PURE__ */ y.createElement(OO, { $_css2: a ? "" : `padding-bottom: ${a1.spacing6};` }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(YQ, { $offsetLeft: v, $status: n ? a ? "CORRECT" : "INCORRECT" : "NO_ANSWER", $isReview: !0 }, /* @__PURE__ */ y.createElement(Er, { className: "text-value" }, /* @__PURE__ */ y.createElement(O2, null, p))), !a && /* @__PURE__ */ y.createElement(YQ, { $status: "CORRECT", $offsetLeft: v, $isReview: !0 }, /* @__PURE__ */ y.createElement(Er, { className: "text-value" }, /* @__PURE__ */ y.createElement(O2, null, (u == null ? void 0 : u.text) ?? "")))), /* @__PURE__ */ y.createElement($n, { ref: M }, a ? /* @__PURE__ */ y.createElement(ZT, { className: "icon" }) : /* @__PURE__ */ y.createElement(k9, { className: "icon" }), /* @__PURE__ */ y.createElement(t9, { color: a ? "success" : "error", width: C.width, height: C.height, opacity: "1" }))) }, s) : /* @__PURE__ */ y.createElement(n5, { padding: H.spacing2xValue, handleClickTrigger: i, parentElement: l == null ? void 0 : l.current, trigger: /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(qT, { $offsetLeft: v, $isReview: !1 }, /* @__PURE__ */ y.createElement(Er, { className: "text-value" }, /* @__PURE__ */ y.createElement(O2, null, p))), /* @__PURE__ */ y.createElement($n, { ref: M, $isReview: !1 }, /* @__PURE__ */ y.createElement(t9, { color: "default", opacity: "0.5", width: C.width, height: C.height }))) }, s)));
}
const Er = M1.div.withConfig({
  displayName: "ImageWrapper__OptionalMarkdownWrapper",
  componentId: "sc-asjw5p-1"
})(["display:inline;"]), $n = M1.div.withConfig({
  displayName: "ImageWrapper__IconWrapper",
  componentId: "sc-asjw5p-2"
})(["width:2.5em;height:3em;cursor:pointer;display:flex;justify-content:center;background-color:transparent;margin:0;position:relative;border-radius:", ";.text-value{margin-left:-6px;font-size:", ";}}"], a1.spacing6, a1.text_xs), qT = M1.div.withConfig({
  displayName: "ImageWrapper__Input",
  componentId: "sc-asjw5p-3"
})(["position:absolute;cursor:pointer;transform:rotate(355deg) translate(", "em,3.2em);top:5%;width:max-content;background:rgb( 5,171,167,", " );border-radius:", ";font-style:normal;font-weight:", ";font-size:", ";font-family:", ";color:", ";line-height:", ";text-align:center;padding:2px 6px;max-width:100px;display:inline-block;.text-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}display:", ";&:hover{", "}"], ({
  $offsetLeft: e
}) => e, ({
  $isReview: e
}) => e ? "1" : "0.5", a1.spacing1, a1.font_bold, a1.text_sm, ({
  theme: e
}) => e.fontFamily, ({
  theme: e
}) => e.white, a1.text_lg, ({
  $isQuestionSlot: e
}) => e ? "none" : "flex", ({
  $isQuestionSlot: e
}) => !e && `
		background:   rgb(5, 171, 167, 1);
		`), SO = M1.div.withConfig({
  displayName: "ImageWrapper__ImageWrapperStyled",
  componentId: "sc-asjw5p-4"
})([".content-wrapper{max-width:min(100%,500px);height:auto;max-height:100%;margin:auto;position:relative;}max-height:100%;background:", ";box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;"], ({
  theme: e
}) => e.base), ad = M1.li.withConfig({
  displayName: "ImageWrapper__Option",
  componentId: "sc-asjw5p-5"
})(["position:absolute;display:block;margin:auto;.icon{left:", ";position:absolute;top:", ";color:", ";stroke-width:", ";}.value{background-color:", ";}"], a1.spacing4, a1.spacing4, ({
  theme: e
}) => e.white, a1.spacing16, ({
  theme: e
}) => e.success), YQ = M1(qT).withConfig({
  displayName: "ImageWrapper__Answer",
  componentId: "sc-asjw5p-6"
})(["&:last-of-type:not(:first-of-type){left:-45%;top:40%;}&:first-of-type:not(:last-of-type){left:-65%;top:2%;}", ""], ({
  $status: e,
  $isSelected: t,
  theme: r
}) => {
  const n = e === "CORRECT" ? r.success : e === "REVIEWED" ? "#05ABA7" : r.error;
  return `
		background-color: ${n};
		text-decoration: ${e === "INCORRECT" ? "line-through" : "inherit"};
		&:hover {
			filter: brightness(75%);
			background-color: ${n};
		}
		border: ${`${a1.spacing1} solid ${t ? r.lightSuccess : n}`};
		`;
}), CO = M1.div.withConfig({
  displayName: "ImageWrapper__CircleIcon",
  componentId: "sc-asjw5p-7"
})(["background:", ";color:", ";cursor:default;border-radius:50%;display:flex;justify-content:center;align-items:center;width:", ";height:", ";"], ({
  theme: e
}) => e.primary, ({
  theme: e
}) => e.neutralLightest, a1.spacing6, a1.spacing6);
var VO = M1(j4).withConfig({
  displayName: "ImageWrapper___StyledImage",
  componentId: "sc-asjw5p-8"
})(["", ""], (e) => e.$_css), _O = M1(t9).withConfig({
  displayName: "ImageWrapper___StyledPosition",
  componentId: "sc-asjw5p-9"
})(["cursor:default;"]), OO = M1("div").withConfig({
  displayName: "ImageWrapper___StyledDiv",
  componentId: "sc-asjw5p-10"
})(["", ""], (e) => e.$_css2);
function AO(e) {
  const {
    question: t,
    questionIndex: r = 0,
    onChange: n,
    readOnly: i,
    isQuestionAnalytics: o,
    studentName: a,
    studentResponse: T,
    onRequestClose: s,
    isCollapsibleQuestion: Q,
    buttonAction: u,
    autoFocus: l = !1
  } = e;
  if (!t || !Y6(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const {
    handleDeleteChoice: c,
    handleAddChoice: f,
    handleAnswerChange: d,
    handleChange: m
  } = ol(n, i), p = (S) => {
    !i && n && (n({
      type: c3.DELETE_DROPDOWN,
      payload: S
    }), E(0));
  }, [v, H] = W1(0), E = (S) => {
    var D;
    H(S), t.dropdowns[S] && ((D = document.getElementById(v3(t.dropdowns[S]))) == null || D.focus());
  };
  if (G3(() => {
    var S;
    t.dropdowns.length > 0 && v > -1 && t.dropdowns[v] && ((S = document.getElementById(v3(t.dropdowns[v]))) == null || S.focus());
  }, [t.dropdowns.length]), o)
    return s ? /* @__PURE__ */ y.createElement(Ta, { question: t, title: "Modeling Question", studentResponse: T, onRequestClose: s, studentName: a }, /* @__PURE__ */ y.createElement(DO, { question: t, studentAnswer: T == null ? void 0 : T.answer })) : /* @__PURE__ */ y.createElement(a2, null);
  const [M, C] = W1(!1), w = (S) => {
    var D;
    H(S), (D = document.getElementById(String(S + 1))) == null || D.focus();
  };
  return Q ? /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(Qa, { handleClick: () => C((S) => !S), expand: M, header: /* @__PURE__ */ y.createElement(ll, null, /* @__PURE__ */ y.createElement("span", null, "Q: Image Labeling"), /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(j4, { media: t.media, expandable: !0 }))), buttonAction: u }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(P9, { indexSelected: v, question: t, handleChange: w }), /* @__PURE__ */ y.createElement(B9, { indexSelected: v, dropdowns: t.dropdowns, readOnly: !0 })))) : i ? /* @__PURE__ */ y.createElement(Wo, { className: "Question" }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(tl, null, /* @__PURE__ */ y.createElement("span", null, /* @__PURE__ */ y.createElement("strong", null, `Q${r + 1}.`, "  ")), "Curriculum Questions - Image Labeling"), /* @__PURE__ */ y.createElement(N9, { question: t, isReadonly: !0, className: "max-w-72 m-auto" })), /* @__PURE__ */ y.createElement("div", { className: "flex flex-wrap gap-2" }, t.dropdowns.map((S, D) => /* @__PURE__ */ y.createElement(pp, { key: `dropdown-${D}`, choices: S.choices, index: D })))) : /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement("div", { className: "bg-brand-cloud-blue text-brand-space-blue rounded-t-lg p-4" }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement("div", { className: "font-semibold text-start mb-4" }, "Image Labeling"), /* @__PURE__ */ y.createElement(j0, { className: "my-2" }, /* @__PURE__ */ y.createElement(Tl, null, /* @__PURE__ */ y.createElement("span", null, `Q${r + 1}`)), /* @__PURE__ */ y.createElement(kO, { value: t.phrase, onChange: (S) => {
    var D;
    return n && n({
      type: c3.CHANGE_QUESTION,
      payload: (D = S.target) == null ? void 0 : D.value
    });
  }, autoFocus: l })), /* @__PURE__ */ y.createElement("span", { className: "font-light text-sm" }, "Click on the image where you want to add your question")), /* @__PURE__ */ y.createElement(pO, { questionMedia: t.media, onChange: n, readOnly: !!i, dropdowns: t.dropdowns, setDropdownIndexSelected: (S) => E(S), imageProperties: t.imageProperties }), t.dropdowns.length > 0 && /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(P9, { indexSelected: v, question: t, handleChange: E, handleClose: p }), /* @__PURE__ */ y.createElement(B9, { dropdowns: t.dropdowns, indexSelected: v, handleAddChoice: f, handleAnswerChange: d, handleDeleteChoice: c, handleChange: m }))), /* @__PURE__ */ y.createElement(aa, { onChange: n }));
}
function DO({
  question: e,
  studentAnswer: t
}) {
  return t && !i6(t) ? /* @__PURE__ */ y.createElement(a2, null) : /* @__PURE__ */ y.createElement(IO, null, e.dropdowns.map((r, n) => {
    const i = lp(r, v3(r), t);
    return /* @__PURE__ */ y.createElement("li", { className: "dropdown-wrapper", key: n }, /* @__PURE__ */ y.createElement(s_, null, `${n + 1}. ${i ? "Correct" : "Incorrect"}`), /* @__PURE__ */ y.createElement(sl, { choices: r.choices, studentChoiceSelected: String(t == null ? void 0 : t.value[v3(r)]) }));
  }));
}
const ll = M1.div.withConfig({
  displayName: "Teacher__HeaderContent",
  componentId: "sc-d4sci2-0"
})(["display:flex;align-items:center;width:100%;text-align:left;justify-content:space-between;margin-right:", ";img{max-width:50px;}"], a1.spacing2);
var kO = M1(Ko).withConfig({
  displayName: "Teacher___StyledTextImageField",
  componentId: "sc-d4sci2-1"
})(["margin-right:34px;border-top-left-radius:0px;border-bottom-left-radius:0px;"]), IO = M1(Go).withConfig({
  displayName: "Teacher___StyledQuestionResponseStyled",
  componentId: "sc-d4sci2-2"
})(["background:transparent;"]);
function Lp(e) {
  var J, i1;
  const {
    question: t,
    onChange: r,
    questionIndex: n,
    readOnly: i,
    studentResponse: o,
    isQuestionAnalytics: a,
    studentName: T,
    onRequestClose: s,
    isCollapsibleQuestion: Q,
    buttonAction: u,
    autoFocus: l = !1
  } = e, [c, f] = W1(null);
  if (!t || !(Ir(t) || I5(t)))
    return /* @__PURE__ */ y.createElement(a2, null);
  const d = t._id || "new-question-" + String(n ?? "unknownIndex"), {
    handleDeleteChoice: m,
    handleDeleteImageChoice: p,
    handleAddChoice: v,
    handleAnswerChange: H,
    handleChange: E,
    handleChangeChoiceImage: M
  } = ol(r, i), C = c !== null ? t.choices[c] : null, w = (J = C == null ? void 0 : C.media) == null ? void 0 : J.find((t1) => t1.type === "IMAGE"), S = (w == null ? void 0 : w.url) || "", D = !((i1 = Ah(t)) != null && i1.error);
  if (a) {
    const t1 = o == null ? void 0 : o.answer, T1 = t1 && (kr(t1) || Jo(t1)) ? t1.value : "";
    return s ? /* @__PURE__ */ y.createElement(Ta, { title: I5(t) ? "Multiple Choice Question" : "Multiselect Question", studentResponse: o, studentName: T, onRequestClose: s, question: t }, /* @__PURE__ */ y.createElement(sl, { choices: t.choices, studentChoiceSelected: T1, iconPrepend: Ir(t) })) : /* @__PURE__ */ y.createElement(a2, null);
  }
  const [k, $] = W1(!1), z = !!(t != null && t.choices.find((t1) => (t1 == null ? void 0 : t1.text) !== "")), j = (t1, T1) => {
    var X;
    return /* @__PURE__ */ y.createElement(n5, { arrowColor: "white", trigger: /* @__PURE__ */ y.createElement(RO, { alt: `Icon for choice ${T1 + 1}`, src: al, $_css: a1.spacing4, $_css2: a1.spacing4, $_css3: a1.spacing2 }) }, /* @__PURE__ */ y.createElement(
      rl,
      {
        alt: `Media for choice ${T1 + 1}`,
        src: (X = t1.media) == null ? void 0 : X[0].url
      }
    ));
  };
  return Q ? /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(Qa, { handleClick: () => $((t1) => !t1), expand: k, header: /* @__PURE__ */ y.createElement(ll, null, /* @__PURE__ */ y.createElement(d0, null, /* @__PURE__ */ y.createElement(d0, null, "Q: "), /* @__PURE__ */ y.createElement(d0, null, /* @__PURE__ */ y.createElement(O2, { className: "prose-invert" }, t.phrase))), /* @__PURE__ */ y.createElement(d0, null, /* @__PURE__ */ y.createElement(j4, { media: t.media, expandable: !0 }))), buttonAction: u }, /* @__PURE__ */ y.createElement("div", null, t == null ? void 0 : t.choices.map((t1, T1) => {
    var f1, s1;
    const X = (s1 = (f1 = t1.media) == null ? void 0 : f1[0]) == null ? void 0 : s1.url;
    return /* @__PURE__ */ y.createElement(zo, { key: String(t1._id) || `${T1}-question-option`, $isReadOnly: !0, $chosen: !1, $correct: t1.answer }, /* @__PURE__ */ y.createElement(p8, { studentChoice: !1, correctOption: t1.answer }), /* @__PURE__ */ y.createElement(NO, null, /* @__PURE__ */ y.createElement(d0, null, ot(T1) + ":", " "), /* @__PURE__ */ y.createElement(d0, null, z ? t1.text ? /* @__PURE__ */ y.createElement(O2, { className: "prose-invert" }, t1.text) : "(No text provided)" : null)), X && j(t1, T1));
  })))) : i ? /* @__PURE__ */ y.createElement(Wo, { className: "Question" }, /* @__PURE__ */ y.createElement(R9, { darkMode: !0, questionIndex: n, isValid: D, question: t, studentResponse: o, readOnly: i }), t.choices.map((t1, T1) => {
    var f1, s1;
    const X = !!((s1 = (f1 = t1 == null ? void 0 : t1.media) == null ? void 0 : f1.find((Z) => Z.type === "IMAGE")) != null && s1.type);
    return /* @__PURE__ */ y.createElement(ip, { $correct: !!t1.answer, key: `id-${T1}` }, /* @__PURE__ */ y.createElement(np, { shape: I5(t) ? "circle" : "square", checkmark: t1.answer }), /* @__PURE__ */ y.createElement("div", { className: "question-choice" }, /* @__PURE__ */ y.createElement(O2, { className: "prose-invert" }, t1.text)), o && o.answer.value === String(t1._id) && /* @__PURE__ */ y.createElement("div", { className: "question-choice" }, /* @__PURE__ */ y.createElement(NV, null), "Student's answer"), X && j(t1, T1));
  })) : /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(R9, { label: I5(t) ? "Multiple Choice" : "Multiple Select", readOnly: i, question: t, questionIndex: n, isValid: D, onChange: r, autoFocus: l, studentResponse: o }), /* @__PURE__ */ y.createElement("div", { className: "bg-brand-cloud-blue text-brand-space-blue p-4" }, t.choices.map((t1, T1) => {
    var s1, Z;
    const X = d + "-" + T1, f1 = !!((Z = (s1 = t1 == null ? void 0 : t1.media) == null ? void 0 : s1.find((L1) => L1.type === "IMAGE")) != null && Z.type);
    return /* @__PURE__ */ y.createElement(j0, { key: X, role: "listitem" }, /* @__PURE__ */ y.createElement(op, { "aria-label": "Mark Correct", onClick: () => H(T1), selected: t1.answer }), /* @__PURE__ */ y.createElement(Ko, { type: "text", placeholder: "Type Answer...", value: t1.text, onChange: (L1) => E(T1, L1.currentTarget.value), media: t1.media, onDeleteImage: () => p(T1), handleAddChoice: T1 + 1 === t.choices.length ? v : void 0, autoFocus: !1 }), /* @__PURE__ */ y.createElement(PO, null, /* @__PURE__ */ y.createElement(Ql, { disabled: f1, onChange: M, index: T1, readOnly: i }), /* @__PURE__ */ y.createElement(yp, { "aria-label": "Delete Choice", onClick: () => m(T1) }, /* @__PURE__ */ y.createElement($o, { size: 18 }))));
  }), /* @__PURE__ */ y.createElement(el, { onClick: v }, "Add Another Answer")), typeof c == "number" && C && /* @__PURE__ */ y.createElement(qo, { isOpen: !0, url: S, infoText: `Answer ${c + 1} ${C.answer ? "(Correct)" : ""}`, text: C.text, setClose: () => f(null) }), /* @__PURE__ */ y.createElement(aa, { onChange: r }));
}
const d0 = M1.div.withConfig({
  displayName: "Teacher__InlineDiv",
  componentId: "sc-l7hklc-0"
})(["display:inline-block;"]), yp = M1.button.withConfig({
  displayName: "Teacher__DeleteChoice",
  componentId: "sc-l7hklc-1"
})(["color:", ";cursor:pointer;border:none;background:transparent;padding:0;height:18px;width:18px;margin:", ";svg{margin:0;}"], ({
  theme: e
}) => e.primary, a1.spacing2);
var RO = M1("img").withConfig({
  displayName: "Teacher___StyledImg",
  componentId: "sc-l7hklc-2"
})(["width:", ";height:", ";margin:0 ", ";transform:translateY(1px);cursor:pointer;display:flex;"], (e) => e.$_css, (e) => e.$_css2, (e) => e.$_css3), NO = M1("div").withConfig({
  displayName: "Teacher___StyledDiv",
  componentId: "sc-l7hklc-3"
})(["text-align:left;"]), PO = M1("div").withConfig({
  displayName: "Teacher___StyledDiv2",
  componentId: "sc-l7hklc-4"
})(["& > *{display:inline-block;}"]);
function P9({
  question: e,
  indexSelected: t,
  handleChange: r,
  handleClose: n
}) {
  if (!e)
    return null;
  let i = [];
  return e.type === B5.CLOZE_DROPDOWN ? i = e.dropdowns.map(({
    templateResponseKey: o
  }) => o) : e.type === B5.IMAGE_LABELING && (i = e.dropdowns.map((o) => v3(o))), /* @__PURE__ */ y.createElement("div", { role: "tablist", className: "my-2 flex max-w-full overflow-x-auto" }, i.map((o, a) => {
    const T = t === a;
    return /* @__PURE__ */ y.createElement("button", { role: "tab", className: S3("top-1 right-1 w-full p-2 rounded-t-lg", T && "font-semibold border-b-2 border-b-brand-horizon-blue bg-brand-nebula text-brand-space-blue"), key: `dropdown-${a}`, onClick: () => r(a) }, /* @__PURE__ */ y.createElement(jO, null, /* @__PURE__ */ y.createElement("div", { role: "tab" }, a + 1), T && n && /* @__PURE__ */ y.createElement(BO, null, /* @__PURE__ */ y.createElement(FO, { role: "icon", "aria-label": "CloseIcon", onClick: (s) => {
      s.stopPropagation(), n(o);
    } }))));
  }));
}
function B9({
  readOnly: e = !1,
  autoFocus: t = !1,
  indexSelected: r,
  dropdowns: n,
  handleAddChoice: i,
  handleAnswerChange: o,
  handleDeleteChoice: a,
  handleChange: T
}) {
  var Q, u, l;
  const s = !!((Q = n[r]) != null && Q.choices.find((c) => (c == null ? void 0 : c.text) !== ""));
  return e ? /* @__PURE__ */ y.createElement("div", null, (u = n[r]) == null ? void 0 : u.choices.map((c, f) => {
    var m, p;
    const d = (p = (m = c.media) == null ? void 0 : m[0]) == null ? void 0 : p.url;
    return /* @__PURE__ */ y.createElement(zo, { key: String(c._id) || `${f}-question-option`, $isReadOnly: !0, $chosen: !1, $correct: c.answer }, /* @__PURE__ */ y.createElement(p8, { studentChoice: !1, correctOption: c.answer }), ot(f) + ":", " ", s ? c.text ? /* @__PURE__ */ y.createElement(O2, null, c.text) : "(No text provided)" : null, d && /* @__PURE__ */ y.createElement(T_, { alt: `Choice ${f + 1} Image`, src: d }));
  })) : r > -1 && /* @__PURE__ */ y.createElement("div", null, (l = n[r]) == null ? void 0 : l.choices.map((c, f) => {
    var d, m;
    return /* @__PURE__ */ y.createElement(j0, { key: `id-${f}` }, /* @__PURE__ */ y.createElement(op, { onClick: () => o && o(f, r), selected: c.answer }), /* @__PURE__ */ y.createElement(Ko, { type: "text", placeholder: "Type Answer...", value: c.text, handleAddChoice: f + 1 === ((d = n[r]) == null ? void 0 : d.choices.length) ? () => i && i(r) : void 0, autoFocus: t && f + 1 === ((m = n[r]) == null ? void 0 : m.choices.length), onChange: (p) => T && T(f, p.target.value, r), media: c.media }), /* @__PURE__ */ y.createElement($O, null, /* @__PURE__ */ y.createElement(yp, { "aria-label": "DeleteChoiceIcon", onClick: () => a && a(f, r) }, /* @__PURE__ */ y.createElement($o, { size: 18 }))));
  }), n[r] && /* @__PURE__ */ y.createElement(el, { onClick: () => i && i(r) }, "Add Another Answer"));
}
const BO = M1.div.withConfig({
  displayName: "dropdown-tabs__IconWrapper",
  componentId: "sc-cf5o7t-0"
})(["border:none;z-index:3;top:0;background:transparent;position:absolute;padding:0;border-radius:50%;right:0;height:fit-content;display:flex;"]), FO = M1(R_).withConfig({
  displayName: "dropdown-tabs__CloseIconTab",
  componentId: "sc-cf5o7t-1"
})(["background:#b9bed6;color:", ";transform:scale(1);position:initial;"], ({
  theme: e
}) => e.primary);
var jO = M1("div").withConfig({
  displayName: "dropdown-tabs___StyledDiv",
  componentId: "sc-cf5o7t-2"
})(["position:relative;min-width:3em;"]), $O = M1("div").withConfig({
  displayName: "dropdown-tabs___StyledDiv2",
  componentId: "sc-cf5o7t-3"
})(["display:flex;"]);
function v8(e) {
  switch (e.question.type) {
    case F1.CLOZE_DROPDOWN: {
      const t = e.question;
      return /* @__PURE__ */ y.createElement(Qd, { ...e, question: t });
    }
    case F1.IMAGE_LABELING: {
      const t = e.question;
      return /* @__PURE__ */ y.createElement(Qd, { ...e, question: t });
    }
    default:
      return /* @__PURE__ */ y.createElement(ZO, { error: e.error, onClickSubmit: e.onClickSubmit, isReview: e.isReview });
  }
}
function Qd({
  studentAnswer: e,
  question: t,
  isReview: r,
  error: n,
  onClickSubmit: i
}) {
  let o = "N/A";
  if (r) {
    const a = up(e, t);
    a && (o = `${a.correct}/${a.total}`);
  } else
    e && (o = `${Object.keys(e.value).length}/${t.dropdowns.length}`);
  return /* @__PURE__ */ y.createElement(xp, null, /* @__PURE__ */ y.createElement(Hp, { className: "error" }, n), /* @__PURE__ */ y.createElement("div", { className: "content" }, /* @__PURE__ */ y.createElement("div", { className: "item-selected" }, o), /* @__PURE__ */ y.createElement(gp, { onClick: i, $isReview: r }, "Submit")));
}
function ZO({
  error: e,
  onClickSubmit: t,
  isReview: r
}) {
  return /* @__PURE__ */ y.createElement(xp, null, /* @__PURE__ */ y.createElement(Hp, { className: "error" }, e), /* @__PURE__ */ y.createElement(gp, { onClick: t, $isReview: r }, "Submit"));
}
const gp = M1.button.withConfig({
  displayName: "studentPromptFooter__ButtonFooter",
  componentId: "sc-wkh60m-0"
})(["padding:", " ", ";background-color:", ";color:white;font-family:Orbitron;font-weight:", ";font-size:", ";line-height:23px;cursor:pointer;border:none;width:fit-content;margin:auto;margin-top:", ";border-radius:", ";", " ", ""], a1.spacing2, a1.spacing10, ({
  theme: e
}) => `${e.secondaryColor}`, a1.font_bold, a1.text_lg, a1.spacing8, a1.spacing1, ({
  $isReview: e
}) => e && "visibility: hidden;", ({
  disabled: e
}) => e && "opacity: 0.5; "), xp = M1.div.withConfig({
  displayName: "studentPromptFooter__FooterRow",
  componentId: "sc-wkh60m-1"
})(["align-items:center;margin:auto;background:", ";position:relative;.error{color:", ";position:absolute;width:100%;left:0px;}.content{width:100%;position:relative;}div.item-selected{position:absolute;left:0px;margin-top:", ";color:", ";font-family:Orbitron;font-style:normal;font-weight:", ";font-size:", ";line-height:30px;}"], ({
  theme: e
}) => e.darkPrimary, ({
  theme: e
}) => e.errorColor, a1.spacing1, ({
  theme: e
}) => e.white, a1.font_semibold, a1.text_2xl), Hp = M1.div.withConfig({
  displayName: "studentPromptFooter__ChooseAnswer",
  componentId: "sc-wkh60m-2"
})(["margin:auto;"]);
function WO(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" } }] })(e);
}
function GO(e) {
  return g3({ tag: "svg", attr: { viewBox: "0 0 12 16" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5L12 5z" } }] })(e);
}
const F9 = (e) => {
  const {
    options: t,
    handleClick: r,
    index: n = -1,
    studentResponse: i,
    dropdownKey: o,
    isReview: a
  } = e, T = n > -1;
  return /* @__PURE__ */ y.createElement("div", { role: "dialog" }, T && /* @__PURE__ */ y.createElement(UO, null, n + 1), /* @__PURE__ */ y.createElement(zO, { $haveIndex: T }, t && t.map((s, Q) => {
    const u = s.answer, l = o && i && i6(i.answer) && !s.answer && i.answer.value[o] === String(s._id);
    return i ? /* @__PURE__ */ y.createElement("button", { key: `option-${Q}`, className: `no-button ${u ? "is-correct" : l ? "is-incorrect" : "no-border"}`, disabled: !0 }, /* @__PURE__ */ y.createElement("div", { className: "button-content" }, /* @__PURE__ */ y.createElement(O2, null, s.text), u ? /* @__PURE__ */ y.createElement(GO, { className: "icon-success" }) : l ? /* @__PURE__ */ y.createElement(WO, { className: "icon-error" }) : null)) : /* @__PURE__ */ y.createElement("button", { key: `option-${Q}`, onClick: () => r(Q), disabled: a }, /* @__PURE__ */ y.createElement(O2, null, s.text));
  })));
}, zO = M1.div.withConfig({
  displayName: "options-wrapper__ModalContent",
  componentId: "sc-120dpfh-0"
})(["display:flex;flex-direction:column;background-color:", ";box-shadow:2px 4px 4px rgba(0,0,0,0.45);border-radius:", ";padding:", " ", ";button{width:100%;cursor:pointer;white-space:normal;padding:", ";border:none;margin:", " auto;background:", ";border-radius:", ";font-weight:", ";font-size:", ";line-height:19px;color:#3a3333;text-align:start;&:hover:enabled{background-color:", ";border-color:", ";color:", ";}&:focus{background-color:", ";border-color:", ";color:", ";}}button.no-button{&:disabled{color:#3a3333 !important;background:#ddddf6 !important;cursor:default !important;}}button.is-correct{border:4px solid ", " !important;}button.is-incorrect{border:4px solid ", " !important;}button.no-border{border:none !important;}.button-content{display:flex;justify-content:space-between;align-item:center;}.icon-success{color:", ";}.icon-error{color:", ";}"], ({
  theme: e
}) => e.lightPrimaryColor, ({
  $haveIndex: e,
  theme: t
}) => `${e ? "0" : t.spacing} ${a1.spacing2} ${a1.spacing2} ${a1.spacing2}`, a1.spacing1, a1.spacing2, a1.spacing2, a1.spacing1, ({
  theme: e
}) => e.lightestPrimaryColor, a1.spacing1, a1.font_normal, a1.text_lg, ({
  theme: e
}) => e.primaryButton.hover, ({
  theme: e
}) => e.primaryButton.hover, ({
  theme: e
}) => e.white, ({
  theme: e
}) => e.primaryButton.pressed, ({
  theme: e
}) => e.primaryButton.pressed, ({
  theme: e
}) => e.white, ({
  theme: e
}) => e.success, ({
  theme: e
}) => e.error, ({
  theme: e
}) => e.success, ({
  theme: e
}) => e.error), UO = M1.div.withConfig({
  displayName: "options-wrapper__IndexChoice",
  componentId: "sc-120dpfh-1"
})(["background:#272455;border-radius:", " 8px 0 0 ", ";color:", ";padding:12px;"], a1.spacing2, a1.spacing2, ({
  theme: e
}) => e.white);
function ul(e) {
  var a, T;
  const {
    index: t,
    children: r,
    prompt: n
  } = e, i = t ?? !1, o = $9();
  return /* @__PURE__ */ y.createElement(XO, null, i !== !1 && /* @__PURE__ */ y.createElement(Td, { style: {
    marginRight: ".5em"
  } }, i + 1, "."), /* @__PURE__ */ y.createElement("div", { className: "body" }, /* @__PURE__ */ y.createElement(Td, null, /* @__PURE__ */ y.createElement(O2, { className: "prose-on-game-light-purple" }, n), ((a = e.media) == null ? void 0 : a[0]) && /* @__PURE__ */ y.createElement(n5, { arrowColor: o.white, triggerStyle: {
    display: "inline-flex"
  }, trigger: /* @__PURE__ */ y.createElement(qO, { alt: `Media for question prompt: ${n}.`, src: al, $_css: a1.spacing4, $_css2: a1.spacing4, $_css3: a1.spacing2 }) }, /* @__PURE__ */ y.createElement(rl, { alt: `Media for question: ${n}`, src: (T = e.media) == null ? void 0 : T[0].url }))), r));
}
const XO = M1.div.withConfig({
  displayName: "student-review__ReviewWrapper",
  componentId: "sc-1yfrzk4-0"
})(["background-color:transparent;display:flex;.body{flex:1;text-align:left;}"]), Td = M1.span.withConfig({
  displayName: "student-review__BoldSpan",
  componentId: "sc-1yfrzk4-1"
})(["font-weight:", ";"], a1.font_bold);
var qO = M1("img").withConfig({
  displayName: "student-review___StyledImg",
  componentId: "sc-1yfrzk4-2"
})(["width:", ";height:", ";transform:translateY(2px);cursor:pointer;margin-left:", ";"], (e) => e.$_css, (e) => e.$_css2, (e) => e.$_css3);
const Ep = ({
  children: e,
  title: t,
  index: r,
  studentAnswer: n,
  question: i
}) => {
  const o = up(n, i);
  return /* @__PURE__ */ y.createElement(a2, null, /* @__PURE__ */ y.createElement(ul, { index: r, prompt: t }, /* @__PURE__ */ y.createElement(JO, null, o ? `${o.correct}/${o.total} Correct` : "Did not answer", e)));
}, JO = M1.div.withConfig({
  displayName: "DropdownReviewResponse__ScoreWrapper",
  componentId: "sc-1x2qhkq-0"
})(["margin-top:", ";font-family:", ";font-style:normal;font-weight:", ";line-height:", ";color:", ";text-align:center;background:#ececff;border-radius:", ";padding:", " ", ";"], a1.spacing2, ({
  theme: e
}) => e.fontFamily, a1.font_semibold, a1.text_lg, ({
  theme: e
}) => e.black, a1.spacing1, a1.spacing8, a1.spacing4);
function YO(e) {
  return g3({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" } }] })(e);
}
const L8 = ({
  footerContent: e,
  topContent: t,
  instantReview: r
}) => r ? /* @__PURE__ */ y.createElement(y.Fragment, null, t, /* @__PURE__ */ y.createElement(eA, { $_css: a1.spacing4 }, e)) : /* @__PURE__ */ y.createElement(KO, null, /* @__PURE__ */ y.createElement("div", { className: "top-tile " }, /* @__PURE__ */ y.createElement("div", null, t, /* @__PURE__ */ y.createElement("br", null))), /* @__PURE__ */ y.createElement("div", { className: "bottom-tile" }, e)), KO = M1(Q_).withConfig({
  displayName: "FooterStickyContainer__Wrapper",
  componentId: "sc-1x4s0dh-0"
})(["overflow:auto;height:100%;width:100%;display:flex;flex-direction:column;.bottom-tile{position:sticky;bottom:0;height:", "px;background-color:", ";z-index:999;}.top-tile{position:relative;}"], ({
  theme: e
}) => e.spacingValue * 9, ({
  theme: e
}) => e.darkPrimary);
var eA = M1("div").withConfig({
  displayName: "FooterStickyContainer___StyledDiv",
  componentId: "sc-1x4s0dh-1"
})(["padding-top:", ";"], (e) => e.$_css);
const tA = (e) => {
  var v;
  const {
    question: t,
    textToSpeech: r,
    requestId: n,
    review: i,
    sendMessage: o,
    studentResponse: a,
    parentRef: T,
    classResponse: s
  } = e;
  if (!t || !I5(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [Q, u] = W1(""), [l, c] = W1(""), f = !!(t != null && t.choices.some((H) => {
    var E;
    return !!((E = H.media) != null && E[0]);
  })), d = () => {
    if (!Q) {
      c("Please Make a Choice");
      return;
    }
    c(""), o && o({
      type: B5.MULTIPLE_CHOICE,
      value: Q
    });
  };
  let m = Q;
  const p = i === "INSTANT";
  return p && (!a || !kr(a.answer) ? m = void 0 : m = a == null ? void 0 : a.answer.value), t ? p || !i && n ? /* @__PURE__ */ y.createElement(L8, { instantReview: p, footerContent: /* @__PURE__ */ y.createElement(v8, { isReview: p, error: l, onClickSubmit: d, question: t }), topContent: /* @__PURE__ */ y.createElement(y.Fragment, null, s && /* @__PURE__ */ y.createElement(Uo, null, /* @__PURE__ */ y.createElement("div", { className: "question-index" }, `${e.questionIndex}.`), `${(s.generalScore * 100).toFixed()}% Answered Correctly`), /* @__PURE__ */ y.createElement(h8, null, /* @__PURE__ */ y.createElement(O2, { textToSpeech: r, className: "prose-on-game-light-purple" }, t.phrase)), /* @__PURE__ */ y.createElement(j4, { media: t.media, expandable: !0, parentRef: T, className: "!max-h-64" }), /* @__PURE__ */ y.createElement(Ks, { $withImage: f }, t.choices.map((H, E) => {
    var w;
    const M = m === String(H._id), C = s && s.scores.type === F1.MULTIPLE_CHOICE && ((w = s.scores.optionScores.find((S) => S._id === String(H._id))) == null ? void 0 : w.score);
    return /* @__PURE__ */ y.createElement(cl, { key: String(H._id), isReview: p, selected: M, onClick: () => {
      u(String(H._id)), c("");
    }, choice: H, textToSpeech: r, classResponse: s, parentRef: T, type: "MULTIPLE_CHOICE", optionScore: C || 0, index: E });
  }))) }) : i === "OVERVIEW" ? /* @__PURE__ */ y.createElement(bp, { index: e.questionIndex, studentAnswer: (v = e.studentResponse) == null ? void 0 : v.answer, question: t }) : /* @__PURE__ */ y.createElement(a2, null) : /* @__PURE__ */ y.createElement(a2, null);
}, rA = ({
  selected: e,
  correct: t,
  type: r,
  parentRef: n
}) => {
  const i = {
    parentElement: n == null ? void 0 : n.current,
    padding: 4,
    arrowColor: "black",
    positions: ["top"]
  }, o = r === "MULTIPLE_CHOICE" ? "The correct choice" : "This choice was correct, but you did not select it.", a = r === "MULTIPLE_CHOICE" ? "The choice you selected (wrong)" : "This choice is incorrect, but you selected it.", T = !e && t ? /* @__PURE__ */ y.createElement(n5, { ...i, trigger: /* @__PURE__ */ y.createElement(ZV, { size: 20, color: "white" }) }, /* @__PURE__ */ y.createElement(sd, null, o)) : e && !t ? /* @__PURE__ */ y.createElement(n5, { ...i, trigger: /* @__PURE__ */ y.createElement(WV, { size: 20, color: "white" }) }, /* @__PURE__ */ y.createElement(sd, null, a)) : null;
  return T ? /* @__PURE__ */ y.createElement("div", { className: "tag" }, T) : null;
}, sd = M1.span.withConfig({
  displayName: "Student__ReviewTagSpan",
  componentId: "sc-1jhb7pt-0"
})(["background-color:black;color:white;border-radius:4px;padding:4px;font-family:", ";"], ({
  theme: e
}) => e.fontFamily);
function bp({
  question: e,
  studentAnswer: t,
  index: r
}) {
  if (t && !(kr(t) || Jo(t)))
    return /* @__PURE__ */ y.createElement(a2, null);
  const n = $9();
  return /* @__PURE__ */ y.createElement(ul, { index: r, prompt: e.phrase, media: e.media }, /* @__PURE__ */ y.createElement(oA, null, e.choices.map((i) => {
    var T, s;
    const o = t ? kr(t) ? (t == null ? void 0 : t.value) === String(i._id) : t.value.indexOf(String(i._id)) > -1 : !1, a = i.answer;
    return /* @__PURE__ */ y.createElement(iA, { key: String(i._id), $chosen: o, $correct: a }, /* @__PURE__ */ y.createElement(nA, { $correct: a, $chosen: o, $isMultipleChoice: I5(e) }, a ? /* @__PURE__ */ y.createElement(YO, { "aria-label": "Correct Choice", className: "icon-success" }) : o ? /* @__PURE__ */ y.createElement(Xo, { "aria-label": "Incorrect Choice", className: "icon-wrong" }) : /* @__PURE__ */ y.createElement("div", { className: "no-icon" })), /* @__PURE__ */ y.createElement("div", { style: {
      display: "inline-flex"
    } }, ((T = i.media) == null ? void 0 : T[0]) && /* @__PURE__ */ y.createElement(n5, { arrowColor: n.white, trigger: /* @__PURE__ */ y.createElement(aA, { alt: `Media for option: ${i.text}`, src: al, $_css: a1.spacing4, $_css2: a1.spacing4, $_css3: a1.spacing2 }) }, /* @__PURE__ */ y.createElement(rl, { alt: `Media for question: ${e.phrase}`, src: (s = i.media) == null ? void 0 : s[0].url })), /* @__PURE__ */ y.createElement(O2, { className: "prose-on-game-light-purple" }, i.text), !t && a && /* @__PURE__ */ y.createElement(QA, { $_css4: a1.spacing2 }, "- Did not answer")));
  })));
}
const nA = M1.div.withConfig({
  displayName: "Student__Bullet",
  componentId: "sc-1jhb7pt-1"
})(["margin:0 ", ";transform:translateY(1px);border-radius:", ";background-color:transparent;display:flex;", " .icon-success{color:", ";}.icon-wrong{color:", ";}.no-icon{height:", ";width:", ";}"], a1.spacing2, ({
  theme: e,
  $isMultipleChoice: t
}) => t ? "50%" : e.spacingHalf, ({
  theme: e,
  $correct: t,
  $chosen: r,
  $isMultipleChoice: n
}) => n ? t ? `background-color: ${e.success};` : r && !t ? `background-color: ${e.error};` : `background-color: ${e.lighterGreyColor};` : t ? `border: 3px solid ${e.success};` : r && !t ? `border: 3px solid ${e.error};` : `border: 3px solid  ${e.lighterGreyColor};`, ({
  theme: e,
  $isMultipleChoice: t
}) => t ? e.white : e.success, ({
  theme: e,
  $isMultipleChoice: t
}) => t ? e.white : e.error, a1.spacing4, a1.spacing4), iA = M1.li.withConfig({
  displayName: "Student__Option",
  componentId: "sc-1jhb7pt-2"
})(["padding:1px 0;margin-top:2px;display:flex;align-items:center;border-radius:", ";&:not(:last-child){margin-bottom:2px;}", ""], a1.spacing1, ({
  $correct: e,
  $chosen: t
}) => {
  if (t && e)
    return "background-color: rgba(111, 211, 127, 0.61);";
  if (t && !e)
    return "background-color: rgba(255, 143, 143, 0.61);";
});
var oA = M1("div").withConfig({
  displayName: "Student___StyledDiv",
  componentId: "sc-1jhb7pt-3"
})(["flex:1;text-align:left;margin-top:8px;transform:translateX(-8px);"]), aA = M1("img").withConfig({
  displayName: "Student___StyledImg",
  componentId: "sc-1jhb7pt-4"
})(["width:", ";height:", ";margin-right:", ";transform:translateY(1px);cursor:pointer;"], (e) => e.$_css, (e) => e.$_css2, (e) => e.$_css3), QA = M1("i").withConfig({
  displayName: "Student___StyledI",
  componentId: "sc-1jhb7pt-5"
})(["margin-left:", ";"], (e) => e.$_css4);
function cl(e) {
  var m, p;
  const {
    isReview: t = !1,
    selected: r = !1,
    onClick: n,
    choice: i,
    textToSpeech: o,
    classResponse: a,
    parentRef: T,
    optionScore: s,
    children: Q,
    isRow: u = !1,
    type: l = "MULTIPLE_CHOICE",
    index: c,
    showOptionIndicator: f = !0
  } = e, d = i.answer;
  return /* @__PURE__ */ y.createElement(TA, { "data-testid": "choice-box", $correct: d, $isReview: t, selected: r, onClick: n, $isRow: u }, t && /* @__PURE__ */ y.createElement(rA, { parentRef: T, selected: r, correct: d, type: l }), f && /* @__PURE__ */ y.createElement(lA, null, ot(c)), /* @__PURE__ */ y.createElement(Mp, { $hasText: !!i.text, $hasImage: !!((m = i.media) != null && m.length), $isRow: u, $extraPadding: t && !f }, /* @__PURE__ */ y.createElement(l_, { $hasText: !!i.text, $isClassResponse: !!a, $hasImage: !!((p = i.media) != null && p.length) }, /* @__PURE__ */ y.createElement(j4, { media: i.media, className: "max-h-40" })), /* @__PURE__ */ y.createElement(u_, { className: i.media ? "ml-2" : "w-full" }, /* @__PURE__ */ y.createElement(O2, { textToSpeech: o }, i.text)), Q, a && /* @__PURE__ */ y.createElement(sA, null, /* @__PURE__ */ y.createElement("div", { className: "content" }, `${Math.trunc(s * 100)}%`))));
}
const Mp = M1.div.withConfig({
  displayName: "choice-box__SelectedOption",
  componentId: "sc-gz8rrq-0"
})(["flex:1;box-sizing:border-box;height:100%;display:flex;align-items:center;border-radius:", ";justify-content:", ";", ";.option{margin:", ";width:23px;height:23px;min-width:23px !important;box-sizing:border-box;border-radius:", ";display:flex;}.selected{background:", ";}"], a1.spacing1, ({
  $hasText: e,
  $hasImage: t,
  $isRow: r
}) => r ? "space-between" : t && e ? "flex-start" : "center", ({
  $hasImage: e,
  $isRow: t,
  $extraPadding: r
}) => {
  let n = `padding: ${e || t ? a1.spacing2 : a1.spacing4};`;
  return r && (n += `padding-left: ${e || t ? a1.spacing8 : a1.spacing10};`), n;
}, a1.spacing2, a1.spacing1, ({
  theme: e
}) => e.white), TA = M1.li.withConfig({
  displayName: "choice-box__ChoiceBoxWrapper",
  componentId: "sc-gz8rrq-1"
})(["display:flex;position:relative;color:", ";text-align:center;list-style-type:none;border-radius:", ";cursor:pointer;break-inside:avoid;overflow:hidden;&:not(:last-child){margin-bottom:", ";}.tag{box-sizing:border-box;position:absolute;color:", ";padding:4px;z-index:1;width:fit-content;height:fit-content;border-bottom-right-radius:50%;svg{cursor:pointer;}}", ""], ({
  theme: e
}) => e.black, a1.spacing1, ({
  $isRow: e,
  theme: t
}) => e && t.spacing, ({
  theme: e
}) => e.white, ({
  selected: e,
  $isReview: t,
  $correct: r,
  theme: n
}) => {
  let i, o = n.lightestPrimaryColor;
  return e && t && !r && (i = n.error), e && !t && (i = n.secondaryColor, o = n.lighterPrimaryColor), t && r && (i = n.success), `
		background-color: ${o};
		${i ? `
					&:after {
						content: '';
						position: absolute;
						top: 0;
						right: 0;
						left: 0;
						bottom: 0;
						border: 4px solid ${i};
						border-radius: ${a1.spacing1}
						z-index: -1;
						pointer-events: none;
					}
					.tag {
						background-color: ${i};
					}
				` : ""}
		${Mp} .option {
			border: 3px solid ${t && e ? i : n.primaryColor};
			color: ${t && e ? i : n.primaryColor};	
		}
	
		`;
}), sA = M1.div.withConfig({
  displayName: "choice-box__ScoreWrapper",
  componentId: "sc-gz8rrq-2"
})(["color:", ";height:100%;display:flex;align-items:center;display:flex;justify-content:center;margin-left:", ";.content{height:fit-content;min-width:2.2em;margin:auto;border-radius:", ";padding:", ";background:", ";}"], ({
  theme: e
}) => e.white, a1.spacing2, a1.spacing1, a1.spacing2, ({
  theme: e
}) => e.success), lA = M1.div.withConfig({
  displayName: "choice-box__OptionIndicator",
  componentId: "sc-gz8rrq-3"
})(["background-color:", ";color:", ";padding:", ";font-family:", ";font-size:1.25em;display:flex;justify-content:center;align-items:center;border-radius:", " 0 0 ", ";"], ({
  theme: e
}) => e.lightSecondaryColor, ({
  theme: e
}) => e.white, a1.spacing2, ({
  theme: e
}) => e.headerFontFamily, a1.spacing1, a1.spacing1);
function uA(e) {
  var M, C;
  const {
    question: t,
    textToSpeech: r,
    review: n,
    requestId: i,
    sendMessage: o,
    studentResponse: a,
    questionIndex: T,
    parentRef: s,
    classResponse: Q
  } = e;
  if (!t || !Y6(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [u, l] = W1(""), [c, f] = W1(0), [d, m] = W1({
    type: B5.IMAGE_LABELING,
    value: {}
  }), p = (w) => {
    var k;
    const S = t.dropdowns[c], D = (k = S == null ? void 0 : S.choices[w]) == null ? void 0 : k._id;
    m(($) => ({
      ...$,
      value: {
        ...$.value,
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        [v3(S)]: String(D || "")
      }
    })), l("");
  }, v = () => {
    if (Object.keys(d.value).length !== t.dropdowns.length) {
      l("Please Complete All Options");
      return;
    }
    l(""), o && o(d);
  }, H = (w) => {
    f(w);
  }, E = n === "INSTANT";
  if (t) {
    if (E || !n && i) {
      const w = /* @__PURE__ */ y.createElement(F9, { options: (M = t.dropdowns[c]) == null ? void 0 : M.choices, studentResponse: a, dropdownKey: v3(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        t.dropdowns[c]
      ), handleClick: p, isReview: E }), S = Q && Q.scores.type === F1.IMAGE_LABELING && Q.scores.optionScores.find(($) => $.templateResponsekey === // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      v3(t.dropdowns[c])), D = Q && S && /* @__PURE__ */ y.createElement(
        wp,
        {
          dropdown: t.dropdowns[c],
          classResponseScores: S,
          classResponse: Q,
          textToSpeech: r,
          review: n
        }
      );
      let k = d;
      return E && (!a || !i6(a.answer) ? k = void 0 : k = a == null ? void 0 : a.answer), /* @__PURE__ */ y.createElement(L8, { instantReview: E, footerContent: /* @__PURE__ */ y.createElement(y.Fragment, null, !Q && /* @__PURE__ */ y.createElement(v8, { studentAnswer: k, isReview: E, question: t, error: u, onClickSubmit: v })), topContent: /* @__PURE__ */ y.createElement(y.Fragment, null, Q ? /* @__PURE__ */ y.createElement(Uo, null, /* @__PURE__ */ y.createElement("div", { className: "question-index" }, `${e.questionIndex}.`), `${(Q.generalScore * 100).toFixed()}% Answered Correctly`) : /* @__PURE__ */ y.createElement(h8, null, /* @__PURE__ */ y.createElement(O2, { className: "prose-on-game-light-purple", textToSpeech: r }, t.phrase)), /* @__PURE__ */ y.createElement(N9, { isReview: E, parentRef: s, handleSelectOption: H, question: t, studentAnswer: k, optionsWrapper: w, classResponse: Q, optionsStats: D, dropdownIndexSelected: c })) });
    } else if (n === "OVERVIEW") {
      const w = /* @__PURE__ */ y.createElement(F9, { options: (C = t.dropdowns[c]) == null ? void 0 : C.choices, studentResponse: a, dropdownKey: v3(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        t.dropdowns[c]
      ), handleClick: p, isReview: !0 });
      return /* @__PURE__ */ y.createElement(Ep, { title: t.phrase, studentAnswer: a == null ? void 0 : a.answer, index: T || 0, question: t }, /* @__PURE__ */ y.createElement(N9, { parentRef: s, handleSelectOption: H, studentAnswer: a == null ? void 0 : a.answer, question: t, isReview: !0, optionsWrapper: w }));
    }
  }
  return /* @__PURE__ */ y.createElement(a2, null);
}
const wp = ({
  dropdown: e,
  classResponseScores: t,
  classResponse: r,
  textToSpeech: n,
  review: i
}) => {
  const o = i === "INSTANT";
  return /* @__PURE__ */ y.createElement(cA, { role: "list" }, e.choices.map((a, T) => {
    var Q;
    const s = t && ((Q = t.choices.find((u) => u._id === String(a._id))) == null ? void 0 : Q.score);
    return /* @__PURE__ */ y.createElement(cl, { key: String(a._id), isReview: o, choice: a, textToSpeech: n, classResponse: r, optionScore: s || 0, isRow: !0, showOptionIndicator: !1, index: T });
  }));
}, cA = M1.div.withConfig({
  displayName: "Student__ListOptionsStatsStyled",
  componentId: "sc-1cj8sse-0"
})(["border:", ";padding:", " ", ";border-radius:", ";background:", ";"], ({
  theme: e
}) => `${a1.spacing1} solid ${e.lightSuccess}`, a1.spacing2, a1.spacing4, a1.spacing2, ({
  theme: e
}) => e.lightPrimaryColor), fl = "TemplateDropdownButton", Sp = y.createContext({
  dropDowns: {}
});
function dl({
  state: e,
  children: t
}) {
  return /* @__PURE__ */ y.createElement(Sp.Provider, { value: e }, t);
}
function Cp(e) {
  const t = as(Sp);
  return typeof e != "string" || !t ? null : t.dropDowns[e] ?? null;
}
function fA({
  dropdownId: e
}) {
  return Cp(e) ?? null;
}
const dA = {
  [fl]: fA
};
function Vp({
  node: e
}) {
  var r;
  const t = (r = e.attributes.find((n) => n.type === "mdxJsxAttribute" && n.name === "dropdownId")) == null ? void 0 : r.value;
  return Cp(t) ?? null;
}
function hA(e) {
  var r;
  const t = (r = e.attributes.find((n) => n.type === "mdxJsxAttribute" && n.name === "dropdownId")) == null ? void 0 : r.value;
  return t == null ? null : {
    text: `dropdown ${t}`
  };
}
function hl(e) {
  const t = Zo(e);
  return t == null ? null : w4(t).map((r) => r.type === j2.Input ? `<${fl} dropdownId="${r.inputId}" />` : r.type === j2.Text ? r.text : "").join("");
}
const _p = {
  [fl]: {
    markdown: Vp,
    textToSpeech: hA
  }
}, ld = mp, pA = (e) => {
  var M;
  const {
    question: t,
    textToSpeech: r,
    requestId: n,
    review: i,
    sendMessage: o,
    studentResponse: a,
    questionIndex: T,
    parentRef: s,
    classResponse: Q
  } = e;
  if (!t || !P5(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [u, l] = W1(""), [c, f] = W1(
    // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    t.dropdowns.length ? t.dropdowns[0].templateResponseKey : ""
  ), [d, m] = W1({
    type: B5.CLOZE_DROPDOWN,
    value: {}
  }), p = (C) => {
    f(C);
  }, v = (C) => {
    var S, D;
    const w = (D = (S = t.dropdowns.find((k) => k.templateResponseKey === c)) == null ? void 0 : S.choices[C]) == null ? void 0 : D._id;
    m((k) => ({
      ...k,
      value: {
        ...k.value,
        [c]: String(w || "")
      }
    })), l("");
  }, H = () => {
    if (Object.keys(d.value).length !== t.dropdowns.length) {
      l("Please Complete All Options");
      return;
    }
    l(""), o && o(d);
  }, E = i === "INSTANT";
  if (t) {
    if (E || !i && n) {
      const C = t.dropdowns.find(($) => $.templateResponseKey === c), w = /* @__PURE__ */ y.createElement(F9, { options: C == null ? void 0 : C.choices, studentResponse: a, dropdownKey: c, handleClick: v, isReview: E }), S = "Please select the correct options from the phrase below";
      let D = d;
      E && (!a || !i6(a.answer) ? D = void 0 : D = a == null ? void 0 : a.answer);
      const k = Q && Q.scores.type === F1.CLOZE_DROPDOWN && Q.scores.optionScores.find(($) => $.templateResponsekey === c);
      return /* @__PURE__ */ y.createElement(L8, { instantReview: E, footerContent: /* @__PURE__ */ y.createElement(y.Fragment, null, Q ? k && C && /* @__PURE__ */ y.createElement(wp, { classResponse: Q, dropdown: C, classResponseScores: k, textToSpeech: r, review: i }) : /* @__PURE__ */ y.createElement(v8, { studentAnswer: D, isReview: E, question: t, error: u, onClickSubmit: H })), topContent: /* @__PURE__ */ y.createElement(y.Fragment, null, Q ? /* @__PURE__ */ y.createElement(Uo, null, /* @__PURE__ */ y.createElement("div", { className: "question-index" }, `${e.questionIndex}.`), `${(Q.generalScore * 100).toFixed()}% Answered Correctly`) : /* @__PURE__ */ y.createElement(h8, null, r ? /* @__PURE__ */ y.createElement(r, null, S) : /* @__PURE__ */ y.createElement("span", null, S)), /* @__PURE__ */ y.createElement(j4, { media: t.media, expandable: !0, parentRef: s }), /* @__PURE__ */ y.createElement(JT, null, j9({
        template: t.template,
        onClick: p,
        studentAnswer: D,
        dropdowns: t.dropdowns,
        isReview: E,
        TextToSpeech: r,
        optionSection: w,
        parentRef: s,
        classResponse: Q,
        templateKeySelected: c
      }))) });
    } else if (i === "OVERVIEW") {
      const C = /* @__PURE__ */ y.createElement(F9, { options: (M = t.dropdowns.find((w) => w.templateResponseKey === c)) == null ? void 0 : M.choices, studentResponse: a, dropdownKey: c, handleClick: v, isReview: !0 });
      return /* @__PURE__ */ y.createElement(Ep, { title: "Please select the correct options from the phrase below", studentAnswer: a == null ? void 0 : a.answer, index: T || 0, question: t }, /* @__PURE__ */ y.createElement(mA, null, /* @__PURE__ */ y.createElement(JT, null, j9({
        template: t.template,
        onClick: p,
        studentAnswer: a == null ? void 0 : a.answer,
        dropdowns: t.dropdowns,
        isReview: !0,
        TextToSpeech: r,
        optionSection: C,
        parentRef: s
      }))));
    }
  }
  return /* @__PURE__ */ y.createElement(a2, null);
}, mA = M1.div.withConfig({
  displayName: "Student__Wrapper",
  componentId: "sc-10x2d1w-0"
})(["background-color:", ";box-shadow:0px ", " ", " rgba(0,0,0,0.25);border-radius:", ";margin-top:", ";padding:", ";"], ({
  theme: e
}) => e.primaryColor, a1.spacing1, a1.spacing1, a1.spacing2, a1.spacing4, a1.spacing4), j9 = ({
  template: e,
  onClick: t,
  studentAnswer: r,
  dropdowns: n,
  isReview: i,
  TextToSpeech: o,
  optionSection: a,
  isQuestionSlot: T,
  renderDropdownButton: s,
  parentRef: Q,
  classResponse: u,
  templateKeySelected: l
}) => {
  if (r && !i6(r))
    return null;
  const c = {};
  n && n.forEach((d) => {
    const m = {};
    d.choices.forEach((p) => {
      p._id && (m[String(p._id)] = p);
    }), c[d.templateResponseKey] = m;
  });
  function f({
    dropdownId: d
  }) {
    var p, v, H;
    if (s)
      return s({
        dropdownId: d
      });
    let m;
    if (n) {
      const E = r && i6(r) ? r.value[d] : null;
      E != null && (m = (p = c[d]) == null ? void 0 : p[E]);
    }
    if (i) {
      const E = (v = n == null ? void 0 : n.find((C) => C.templateResponseKey === d)) == null ? void 0 : v.choices, M = E == null ? void 0 : E.find((C) => C.answer);
      if (u) {
        const C = u.scores.type === F1.CLOZE_DROPDOWN && ((H = u.scores.optionScores.find((w) => w.templateResponsekey === d)) == null ? void 0 : H.choices.find((w) => w._id === String(M == null ? void 0 : M._id)));
        return /* @__PURE__ */ y.createElement(vA, null, /* @__PURE__ */ y.createElement(ud, { onClick: () => t && t(d), role: "option", $isCorrect: !0, $isClassResponse: !0, $isSelected: d === l }, /* @__PURE__ */ y.createElement("small", null, `${C ? (C.score * 100).toFixed() : 0}%`), /* @__PURE__ */ y.createElement("div", { className: "text" }, /* @__PURE__ */ y.createElement(LA, null, !(m != null && m.answer) && /* @__PURE__ */ y.createElement("div", { className: "class-response-text" }, M ? /* @__PURE__ */ y.createElement(O2, null, M.text) : "")))));
      } else
        return /* @__PURE__ */ y.createElement(n5, { handleClickTrigger: () => t && t(d), parentElement: Q == null ? void 0 : Q.current, key: d, trigger: /* @__PURE__ */ y.createElement(ud, { role: "option", $isCorrect: !!(m != null && m.answer) }, m != null && m.answer ? /* @__PURE__ */ y.createElement(ZT, { className: "icon", "aria-label": "Correct Icon" }) : /* @__PURE__ */ y.createElement(k9, { className: "icon", "aria-label": "Incorrect Icon" }), /* @__PURE__ */ y.createElement("div", { className: "text" }, /* @__PURE__ */ y.createElement(yA, null, /* @__PURE__ */ y.createElement("div", { className: r ? m != null && m.answer ? "answer" : "incorrect-text" : "no-answer" }, /* @__PURE__ */ y.createElement(O2, null, m ? m.text : ld)), !(m != null && m.answer) && /* @__PURE__ */ y.createElement("div", { className: "correct-text" }, M ? /* @__PURE__ */ y.createElement(O2, null, M.text) : "")))), triggerStyle: {
          display: "inline-block"
        } }, a);
    }
    return T ? /* @__PURE__ */ y.createElement(cd, { style: {
      cursor: "default"
    }, $isAnswered: !1 }, d) : /* @__PURE__ */ y.createElement(n5, { handleClickTrigger: () => t && t(d), parentElement: Q == null ? void 0 : Q.current, key: d, trigger: /* @__PURE__ */ y.createElement(cd, { $isAnswered: !!m }, /* @__PURE__ */ y.createElement(O2, null, m ? m.text : ld)), triggerStyle: {
      display: "inline-block"
    } }, a);
  }
  if (d8(e)) {
    const d = {};
    return w4(e).forEach((m) => {
      m.type === j2.Input && (d[m.inputId] = f({
        dropdownId: m.inputId
      }));
    }), /* @__PURE__ */ y.createElement(dl, { state: {
      dropDowns: d
    } }, /* @__PURE__ */ y.createElement(O2, { className: "prose-on-game-light-purple", textToSpeech: o, interpretAsMarkdown: !0, overrides: _p }, hl(e) ?? e));
  }
  return w4(e).map((d, m) => {
    const p = `segment-${m}`;
    if (d.type === j2.Text) {
      const v = d.text;
      return /* @__PURE__ */ y.createElement(a2, { key: p }, o ? /* @__PURE__ */ y.createElement(o, null, v) : /* @__PURE__ */ y.createElement(y.Fragment, null, v));
    }
    return d.type === j2.Input ? /* @__PURE__ */ y.createElement(a2, { key: p }, f({
      dropdownId: d.inputId
    })) : /* @__PURE__ */ y.createElement(a2, { key: p });
  });
}, vA = M1.button.withConfig({
  displayName: "Student__ButtonNoStyle",
  componentId: "sc-10x2d1w-1"
})(["border:none;padding:0px;margin:0px;background:transparent;width:fit-content;"]), ud = M1.div.withConfig({
  displayName: "Student__ButtonReview",
  componentId: "sc-10x2d1w-2"
})(["line-height:20px;cursor:pointer;margin:", ";font-weight:", ";font-size:", ";color:", ";padding:", ";background:", " !important;border:none;box-sizing:border-box;border-radius:", ";border:", ";.icon{margin-right:", ";vertical-align:middle;display:inline-block;padding:2px;}div.text{border-left:2px solid ", ";display:inline-block;}.answer{padding:2px ", ";}.no-answer{background:", ";padding:2px ", ";}.incorrect-text{background:", ";padding:2px ", ";text-decoration:line-through;}.correct-text{padding:0 ", ";margin-right:-", ";background:", ";border-radius:0 ", " ", " 0;padding:2px ", ";}.class-response-text{padding:0 ", ";background:#05aba7;border-radius:0 ", " ", " 0;}small{padding:0 ", ";}"], a1.spacing1, a1.font_semibold, a1.text_base, ({
  theme: e
}) => e.white, ({
  $isClassResponse: e
}) => e ? "0" : `0 ${a1.spacing2}`, ({
  $isCorrect: e,
  theme: t
}) => e ? t.success : t.error, a1.spacing1, ({
  theme: e,
  $isSelected: t
}) => t && `${a1.spacing1} solid ${e.lightSuccess}`, a1.spacing1, ({
  theme: e
}) => e.white, a1.spacing2, ({
  theme: e
}) => e.error, a1.spacing2, ({
  theme: e
}) => e.error, a1.spacing2, a1.spacing2, a1.spacing2, ({
  theme: e
}) => e.success, a1.spacing1, a1.spacing1, a1.spacing2, a1.spacing2, a1.spacing1, a1.spacing1, a1.spacing1), cd = M1.div.withConfig({
  displayName: "Student__ButtonPrompt",
  componentId: "sc-10x2d1w-3"
})(["line-height:1em;margin:", ";font-weight:", ";font-size:", ";color:", ";padding:2px ", ";background:#05aba7;box-sizing:border-box;display:inline-block;border-radius:", ";cursor:pointer;border:", ";"], a1.spacing1, a1.font_semibold, a1.text_lg, ({
  theme: e
}) => e.white, a1.spacing2, a1.spacing1, ({
  $isAnswered: e,
  theme: t
}) => e ? `4px solid ${t.secondaryColor}` : `2px solid ${t.white}`), JT = M1.div.withConfig({
  displayName: "Student__TemplatePhrase",
  componentId: "sc-10x2d1w-4"
})(["font-family:", ";font-style:normal;font-weight:", ";font-size:", ";text-align:start;border-radius:", ";color:", ";margin:", " auto;span{line-height:", ";color:", ";}"], ({
  theme: e
}) => e.fontFamily, a1.font_semibold, a1.text_lg, a1.spacing1, ({
  theme: e
}) => e.white, a1.spacing4, a1.text_4xl, ({
  theme: e
}) => e.white);
var LA = M1("div").withConfig({
  displayName: "Student___StyledDiv",
  componentId: "sc-10x2d1w-5"
})(["display:flex;"]), yA = M1("div").withConfig({
  displayName: "Student___StyledDiv2",
  componentId: "sc-10x2d1w-6"
})(["display:flex;"]);
function gA({
  isCollapsibleQuestion: e,
  question: t,
  onChange: r,
  questionIndex: n = 0,
  readOnly: i,
  isQuestionAnalytics: o,
  studentName: a,
  studentResponse: T,
  onRequestClose: s,
  buttonAction: Q,
  autoFocus: u = !1
}) {
  var t1;
  if (!t || !P5(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [l, c] = W1(0), [f, d] = W1(1), [m, p] = W1(-1), H = !!((t1 = t.media) == null ? void 0 : t1.find((T1) => T1.type === "IMAGE")), {
    handleDeleteChoice: E,
    handleAddChoice: M,
    handleAnswerChange: C,
    handleChange: w
  } = ol(r, i), S = (T1) => {
    !i && r && (r({
      type: c3.ADD_DROPDOWN,
      payload: T1 && !isNaN(T1) ? T1 : l
    }), d(f * -1));
  }, D = (T1) => {
    !i && r && (r({
      type: c3.DELETE_DROPDOWN,
      payload: T1
    }), d(f * -1), k(0));
  };
  G3(() => {
    m === -1 && t.dropdowns.length > 0 && p(0);
  }, [m, t.dropdowns]);
  const k = (T1) => {
    var X;
    p(T1), (X = document.getElementById(`${T1 + 1}-${n}`)) == null || X.focus();
  }, $ = (T1) => {
    if (!i && r) {
      const {
        localUrl: X
      } = Yo(T1);
      r({
        type: c3.CHANGE_QUESTION_IMAGE,
        payload: {
          type: "IMAGE",
          file: T1,
          localUrl: X
        }
      });
    }
  }, z = () => {
    !i && r && r({
      type: c3.DELETE_QUESTION_IMAGE
    });
  }, j = (T1) => {
    r && (r({
      type: c3.CHANGE_TEMPLATE,
      payload: T1
    }), EA(T1.newTemplate, t) && d(f * -1));
  };
  if (o)
    return s ? /* @__PURE__ */ y.createElement(Ta, { question: t, title: "Modeling Question", studentResponse: T, onRequestClose: s, studentName: a }, /* @__PURE__ */ y.createElement(xA, { question: t, studentAnswer: T == null ? void 0 : T.answer })) : null;
  const [J, i1] = W1(!1);
  return e ? /* @__PURE__ */ y.createElement(Qa, { expand: J, header: /* @__PURE__ */ y.createElement("div", { className: "font-medium" }, "Q:", " ", j9({
    template: t.template,
    dropdowns: t.dropdowns,
    renderDropdownButton({
      dropdownId: T1
    }) {
      return /* @__PURE__ */ y.createElement("span", { className: "bg-brand-dusk text-brand-deep-blue rounded-lg inline-flex justify-center w-6 font-semibold leading-[1.35rem]" }, T1);
    }
  })), buttonAction: Q, handleClick: () => i1((T1) => !T1) }, /* @__PURE__ */ y.createElement(P9, { indexSelected: m, question: t, handleChange: k }), /* @__PURE__ */ y.createElement(B9, { indexSelected: m, dropdowns: t.dropdowns, readOnly: !0 })) : i ? /* @__PURE__ */ y.createElement(Wo, { className: "Question" }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(tl, null, /* @__PURE__ */ y.createElement("span", null, /* @__PURE__ */ y.createElement("strong", null, `Q${n + 1}.`, "  ")), "Curriculum Questions - Cloze Dropdown")), /* @__PURE__ */ y.createElement("div", { className: "template-wrapper" }, /* @__PURE__ */ y.createElement(YT, { template: t.template })), /* @__PURE__ */ y.createElement("div", { className: "flex flex-wrap gap-2" }, t.dropdowns.map((T1, X) => /* @__PURE__ */ y.createElement(pp, { key: `dropdown-${X}`, choices: T1.choices, index: X })))) : /* @__PURE__ */ y.createElement("div", { className: "bg-brand-cloud-blue text-brand-space-blue rounded-lg" }, /* @__PURE__ */ y.createElement("div", { className: "p-4" }, /* @__PURE__ */ y.createElement("div", { className: "text-start" }, /* @__PURE__ */ y.createElement("div", { className: "font-semibold mb-2" }, "Cloze Dropdown"), /* @__PURE__ */ y.createElement("div", { className: "text-sm mb-2" }, "Click “Add Dropdown” to insert a dropdown into your question.")), /* @__PURE__ */ y.createElement(j0, null, /* @__PURE__ */ y.createElement(Tl, null, /* @__PURE__ */ y.createElement("span", null, `Q${n + 1}`)), /* @__PURE__ */ y.createElement($_, { setCursorPosition: c, onSelectTab: k, onDeleteImage: z, value: t.template, media: t.media, onChange: j, templateUpdated: f, questionIndex: n, autoFocus: u }), /* @__PURE__ */ y.createElement(ap, null, /* @__PURE__ */ y.createElement(Ql, { disabled: H, onChange: $, readOnly: i }))), /* @__PURE__ */ y.createElement("div", null, d8(t.template) ? /* @__PURE__ */ y.createElement(YT, { template: t.template }) : null), /* @__PURE__ */ y.createElement(el, { onClick: () => S() }, "Add Dropdown"), t.dropdowns.length > 0 && /* @__PURE__ */ y.createElement("div", { className: "mt-4" }, /* @__PURE__ */ y.createElement(P9, { indexSelected: m, question: t, handleClose: D, handleChange: k }), /* @__PURE__ */ y.createElement(B9, { indexSelected: m, dropdowns: t.dropdowns, handleAddChoice: M, handleAnswerChange: C, handleDeleteChoice: E, handleChange: w, autoFocus: u }))), /* @__PURE__ */ y.createElement(aa, { onChange: r }));
}
function xA({
  question: e,
  studentAnswer: t
}) {
  return t && !i6(t) ? /* @__PURE__ */ y.createElement(a2, null) : /* @__PURE__ */ y.createElement(bA, null, /* @__PURE__ */ y.createElement("ul", null, e.dropdowns.map((r, n) => {
    const i = lp(r, r.templateResponseKey, t);
    return /* @__PURE__ */ y.createElement("li", { role: "option", className: "list-none p-2 bg-brand-ultra-soft-violet my-2 rounded-lg", key: n }, /* @__PURE__ */ y.createElement("div", { className: "font-bold m-2 pl-2" }, /* @__PURE__ */ y.createElement(HA, null, `${n + 1}.`), `${i ? "Correct" : "Incorrect"}`), /* @__PURE__ */ y.createElement(sl, { choices: r.choices, studentChoiceSelected: String(t == null ? void 0 : t.value[r.templateResponseKey]) }));
  })));
}
const HA = M1.div.withConfig({
  displayName: "Teacher__IndexQuestion",
  componentId: "sc-804xvp-0"
})(["display:inline-block;margin:auto 8px auto 0;width:16px;"]);
function EA(e, t) {
  const r = $s(e);
  return !!(r && r.length !== t.dropdowns.length);
}
function YT({
  template: e
}) {
  function t({
    dropdownId: n
  }) {
    return /* @__PURE__ */ y.createElement("button", { disabled: !0, className: "rounded-lg px-2 bg-brand-horizon-blue text-brand-cloud-blue" }, n);
  }
  const r = hl(e);
  if (r != null) {
    const n = {};
    return w4(e).forEach((i) => {
      i.type === j2.Input && (n[i.inputId] = t({
        dropdownId: i.inputId
      }));
    }), /* @__PURE__ */ y.createElement("div", { "aria-label": "Template Content", className: "text-left" }, /* @__PURE__ */ y.createElement(dl, { state: {
      dropDowns: n
    } }, /* @__PURE__ */ y.createElement(O2, { interpretAsMarkdown: !0, overrides: _p }, r)));
  }
  return /* @__PURE__ */ y.createElement("div", { "aria-label": "Template Content", className: "text-left" }, w4(e).map((n, i) => {
    const o = `segment-${i}`;
    if (n.type === j2.Text) {
      const a = n.text;
      return /* @__PURE__ */ y.createElement(a2, { key: o }, a);
    }
    return n.type === j2.Input ? /* @__PURE__ */ y.createElement(a2, { key: o }, t({
      dropdownId: n.inputId
    })) : /* @__PURE__ */ y.createElement(a2, { key: o });
  }));
}
var bA = M1(Go).withConfig({
  displayName: "Teacher___StyledQuestionResponseStyled",
  componentId: "sc-804xvp-1"
})(["background:transparent;"]);
function Ta(e) {
  const {
    question: t,
    onRequestClose: r,
    studentResponse: n,
    studentName: i = "Unknown Student",
    title: o,
    children: a
  } = e, T = P5(t) ? /* @__PURE__ */ y.createElement(YT, { template: t.template }) : Y6(t) ? "" : /* @__PURE__ */ y.createElement(O2, null, t.phrase), [s, Q] = W1(!0), u = !Y6(t);
  return /* @__PURE__ */ y.createElement("div", { className: "rounded-lg overflow-hidden" }, /* @__PURE__ */ y.createElement("div", { className: "flex justify-between items-center bg-brand-deep-blue p-4 text-base font-semibold" }, o, " - ", i, /* @__PURE__ */ y.createElement(MA, { onClick: r })), /* @__PURE__ */ y.createElement("div", { className: "flex flex-col p-4 bg-brand-cloud-blue text-brand-space-blue text-start" }, /* @__PURE__ */ y.createElement("div", { className: "flex justify-between font-semibold" }, /* @__PURE__ */ y.createElement("span", { className: "font-semibold" }, g_(t, n)), Y6(t) ? /* @__PURE__ */ y.createElement("button", { onClick: () => Q(!s), className: "hover:underline text-brand-horizon-blue" }, s ? "See Image" : "Hide Image") : ""), T && /* @__PURE__ */ y.createElement("div", { className: "text-base font-normal mb-2" }, T), Y6(t) && !s ? /* @__PURE__ */ y.createElement(N9, { question: t, isReadonly: !0 }) : u && /* @__PURE__ */ y.createElement(j4, { media: t.media }), a));
}
const MA = M1(Xo).withConfig({
  displayName: "AnalyticsSingleStudent__ExitX",
  componentId: "sc-5alt8f-0"
})(["cursor:pointer;font-size:1.4em;text-align:center;color:", ";&:hover{transform:scale(1.25);}"], ({
  theme: e
}) => e.neutralDarker), wA = ({
  question: e,
  readOnly: t = !1,
  onChange: r,
  studentResponse: n,
  questionIndex: i = 0,
  isQuestionAnalytics: o,
  studentName: a,
  onRequestClose: T,
  isCollapsibleQuestion: s,
  buttonAction: Q,
  autoFocus: u = !1
}) => {
  var d;
  if (!e || !il(e))
    return /* @__PURE__ */ y.createElement(a2, null);
  const l = !((d = Ah(e)) != null && d.error);
  if (o)
    return T ? /* @__PURE__ */ y.createElement(Ta, { question: e, title: "Free Response Question", studentResponse: n, onRequestClose: T, studentName: a }, /* @__PURE__ */ y.createElement(SA, { studentResponse: n })) : /* @__PURE__ */ y.createElement(a2, null);
  const [c, f] = W1(!1);
  return s ? /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(Qa, { handleClick: () => f((m) => !m), expand: c, header: /* @__PURE__ */ y.createElement(ll, null, /* @__PURE__ */ y.createElement(CA, null, /* @__PURE__ */ y.createElement("span", null, "Q: "), /* @__PURE__ */ y.createElement(O2, { className: "prose-invert" }, e.phrase)), /* @__PURE__ */ y.createElement(j4, { media: e.media, expandable: !0 })), buttonAction: Q }, /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(zo, { $isReadOnly: !0, $chosen: !1, $correct: !0 }, /* @__PURE__ */ y.createElement(p8, { studentChoice: !1, correctOption: !0 }), /* @__PURE__ */ y.createElement("span", null, "Free Response Answer"))))) : t ? /* @__PURE__ */ y.createElement(Wo, { className: "Question" }, e && /* @__PURE__ */ y.createElement(R9, { darkMode: !0, questionIndex: i, isValid: l, question: e, studentResponse: n, readOnly: t }), /* @__PURE__ */ y.createElement(ip, null, /* @__PURE__ */ y.createElement(np, null), /* @__PURE__ */ y.createElement(VA, { className: "question-choice" }, "No answer: This is a free response"))) : /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(R9, { readOnly: t, label: "Free Response", question: e, questionIndex: i, onChange: r, autoFocus: u, inputType: "textarea" }), /* @__PURE__ */ y.createElement(aa, { onChange: r }));
};
function SA({
  studentResponse: e
}) {
  var n, i, o, a;
  if (e && !nl(e.answer))
    return /* @__PURE__ */ y.createElement(a2, null);
  const t = ((n = e == null ? void 0 : e.answer) == null ? void 0 : n.value) || null, r = ((i = e == null ? void 0 : e.score) == null ? void 0 : i.score) == null ? null : ((o = e == null ? void 0 : e.score) == null ? void 0 : o.score) === ((a = e == null ? void 0 : e.score) == null ? void 0 : a.perfectScore);
  return /* @__PURE__ */ y.createElement(Go, null, /* @__PURE__ */ y.createElement(zo, { $correct: r, $chosen: r === !1 }, /* @__PURE__ */ y.createElement(p8, { correctOption: !!r, studentChoice: r === !1 }), e != null && e.answer ? t : "Did not answer"));
}
var CA = M1("div").withConfig({
  displayName: "Teacher___StyledDiv",
  componentId: "sc-wl6e9k-0"
})(["display:inline-block;flex:1;"]), VA = M1("div").withConfig({
  displayName: "Teacher___StyledDiv2",
  componentId: "sc-wl6e9k-1"
})(["font-style:italic"]);
const _A = ({
  question: e,
  requestId: t,
  review: r,
  textToSpeech: n,
  sendMessage: i,
  questionIndex: o,
  studentResponse: a,
  parentRef: T
}) => {
  var d;
  if (!e || !il(e))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [s, Q] = W1(""), [u, l] = W1(""), c = () => {
    if (!s) {
      l("Please enter an answer");
      return;
    }
    l(""), i && i({
      type: B5.FREE_RESPONSE,
      value: s
    });
  }, f = r === "INSTANT";
  return f || !r && t ? /* @__PURE__ */ y.createElement(L8, { instantReview: f, footerContent: !f && /* @__PURE__ */ y.createElement(v8, { error: u, onClickSubmit: c, question: e, isReview: f }), topContent: /* @__PURE__ */ y.createElement("div", null, /* @__PURE__ */ y.createElement(h8, null, /* @__PURE__ */ y.createElement(O2, { className: "prose-on-game-light-purple", textToSpeech: n }, e.phrase)), /* @__PURE__ */ y.createElement(j4, { media: e.media, expandable: !0, parentRef: T }), /* @__PURE__ */ y.createElement("br", null), f ? /* @__PURE__ */ y.createElement(DA, null, ((d = a == null ? void 0 : a.answer) == null ? void 0 : d.value) || /* @__PURE__ */ y.createElement("i", null, "No answer")) : /* @__PURE__ */ y.createElement(AA, { "aria-label": "Free response input", placeholder: "Write your response here", value: s, onChange: (m) => {
    Q(m.currentTarget.value), m.currentTarget.value && l("");
  } }), /* @__PURE__ */ y.createElement(kA, { $_css: a1.spacing2 })) }) : r === "OVERVIEW" ? /* @__PURE__ */ y.createElement(OA, { index: o, studentAnswer: a == null ? void 0 : a.answer, question: e }) : /* @__PURE__ */ y.createElement(a2, null);
};
function OA({
  question: e,
  studentAnswer: t,
  index: r
}) {
  if (t && !nl(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const n = t == null ? void 0 : t.value;
  return /* @__PURE__ */ y.createElement(ul, { index: r, prompt: e.phrase }, /* @__PURE__ */ y.createElement(j4, { media: e.media }), /* @__PURE__ */ y.createElement("p", null, n || /* @__PURE__ */ y.createElement("i", null, "No answer")));
}
const AA = M1.input.withConfig({
  displayName: "Student__FRQuestionInput",
  componentId: "sc-14e70f5-0"
})(["width:75%;margin:0 0 ", ";padding:", ";font-size:inherit;border-radius:", ";"], a1.spacing1, a1.spacing2, a1.spacing1);
var DA = M1("div").withConfig({
  displayName: "Student___StyledDiv",
  componentId: "sc-14e70f5-1"
})(["background-color:white;padding:8px;border-radius:4px;color:black;width:fit-content;margin:0 auto;"]), kA = M1("div").withConfig({
  displayName: "Student___StyledDiv2",
  componentId: "sc-14e70f5-2"
})(["margin-top:", ";"], (e) => e.$_css);
const IA = ({
  question: e,
  requestId: t,
  review: r,
  textToSpeech: n,
  sendMessage: i,
  teacherQuestion: o = !1,
  readOnly: a = !1,
  onChange: T,
  ...s
}) => {
  if (!e || s.studentResponse && s.studentResponse.answer.type !== F1.FREE_RESPONSE)
    return null;
  const Q = s.studentResponse;
  return /* @__PURE__ */ y.createElement(F0, { className: s.className }, o ? /* @__PURE__ */ y.createElement(wA, { onChange: T, readOnly: a, question: e, studentResponse: Q, questionIndex: s.questionIndex, isQuestionAnalytics: s.isQuestionAnalytics, studentName: s.studentName, onRequestClose: s.onRequestClose, isCollapsibleQuestion: s.isCollapsibleQuestion, buttonAction: s.buttonAction, autoFocus: s.autoFocus }) : /* @__PURE__ */ y.createElement(_A, { review: r, requestId: t, question: e, studentResponse: Q, questionIndex: s.questionIndex, parentRef: s.parentRef, textToSpeech: n, sendMessage: i }));
}, RA = ({
  question: e,
  textToSpeech: t,
  requestId: r,
  review: n,
  sendMessage: i,
  teacherQuestion: o,
  readOnly: a,
  ...T
}) => e ? /* @__PURE__ */ y.createElement(F0, { className: T.className }, o ? /* @__PURE__ */ y.createElement(Lp, { questionIndex: T.questionIndex, onChange: T.onChange, readOnly: a, question: e, studentResponse: T.studentResponse, isQuestionAnalytics: T.isQuestionAnalytics, studentName: T.studentName, onRequestClose: T.onRequestClose, isCollapsibleQuestion: T.isCollapsibleQuestion, buttonAction: T.buttonAction, autoFocus: T.autoFocus }) : /* @__PURE__ */ y.createElement(tA, { review: n, requestId: r, question: e, questionIndex: T.questionIndex, studentResponse: T.studentResponse, classResponse: T.classResponse, parentRef: T.parentRef, sendMessage: i, textToSpeech: t })) : /* @__PURE__ */ y.createElement(a2, null), NA = (e) => {
  const {
    question: t,
    textToSpeech: r,
    requestId: n,
    review: i,
    studentResponse: o,
    parentRef: a,
    sendMessage: T,
    classResponse: s
  } = e;
  if (!t || !Ir(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [Q, u] = W1([]), [l, c] = W1(""), f = !!(t != null && t.choices.some((E) => {
    var M;
    return !!((M = E.media) != null && M[0]);
  })), d = () => {
    if (Q.length === 0) {
      c("Please Make a Choice");
      return;
    }
    c(""), T && T({
      type: B5.MULTIPLE_SELECT,
      value: Q
    });
  }, m = (E) => {
    c(""), u((M) => {
      const C = M.indexOf(E), w = [...M];
      return w.splice(C, 1), C > -1 ? w : [E, ...M];
    });
  }, p = i === "INSTANT";
  let v = Q;
  p && (!o || !Jo(o.answer) ? v = [] : v = o == null ? void 0 : o.answer.value);
  const H = (E) => !!v.find((M) => M === E);
  return t ? p || !i && n ? /* @__PURE__ */ y.createElement(L8, { instantReview: p, footerContent: /* @__PURE__ */ y.createElement(v8, { question: t, error: l, onClickSubmit: d, isReview: p }), topContent: /* @__PURE__ */ y.createElement(y.Fragment, null, s && /* @__PURE__ */ y.createElement(Uo, null, /* @__PURE__ */ y.createElement("div", { className: "question-index" }, `${e.questionIndex}.`), `${(s.generalScore * 100).toFixed()}% Answered Correctly`), /* @__PURE__ */ y.createElement(h8, null, /* @__PURE__ */ y.createElement(O2, { className: "prose-on-game-light-purple", textToSpeech: r }, t.phrase)), !p && /* @__PURE__ */ y.createElement("div", { className: "subtitle" }, "Select all that apply"), /* @__PURE__ */ y.createElement(j4, { media: t.media, expandable: !0, parentRef: a }), /* @__PURE__ */ y.createElement(Ks, { $withImage: f }, t.choices.map((E, M) => {
    var k;
    const C = H(String(E._id)), w = E.answer, S = C && p && !w, D = s && s.scores.type === F1.MULTIPLE_SELECT && ((k = s.scores.optionScores.find(($) => $._id === String(E._id))) == null ? void 0 : k.score);
    return /* @__PURE__ */ y.createElement(cl, { key: String(E._id), isReview: p, selected: C, onClick: () => m(String(E._id)), choice: E, textToSpeech: r, classResponse: s, parentRef: a, type: "MULTIPLE_SELECT", optionScore: D || 0, index: M }, s ? /* @__PURE__ */ y.createElement(y.Fragment, null) : /* @__PURE__ */ y.createElement("div", { className: `option ${C ? "selected" : ""}` }, S ? /* @__PURE__ */ y.createElement(Yh, null) : C ? /* @__PURE__ */ y.createElement(jo, null) : /* @__PURE__ */ y.createElement(y.Fragment, null)));
  }))) }) : i === "OVERVIEW" ? /* @__PURE__ */ y.createElement(bp, { index: e.questionIndex, studentAnswer: o == null ? void 0 : o.answer, question: t }) : /* @__PURE__ */ y.createElement(a2, null) : /* @__PURE__ */ y.createElement(a2, null);
}, PA = ({
  question: e,
  teacherQuestion: t,
  readOnly: r,
  questionIndex: n = -1,
  textToSpeech: i,
  requestId: o,
  review: a,
  sendMessage: T,
  autoFocus: s = !1,
  ...Q
}) => e ? /* @__PURE__ */ y.createElement(F0, { className: Q.className }, t ? /* @__PURE__ */ y.createElement(Lp, { onChange: Q.onChange, readOnly: r, question: e, questionIndex: n, studentResponse: Q.studentResponse, isQuestionAnalytics: Q.isQuestionAnalytics, studentName: Q.studentName, onRequestClose: Q.onRequestClose, isCollapsibleQuestion: Q.isCollapsibleQuestion, buttonAction: Q.buttonAction, autoFocus: s }) : /* @__PURE__ */ y.createElement(NA, { review: a, requestId: o, question: e, questionIndex: n, studentResponse: Q.studentResponse, classResponse: Q.classResponse, parentRef: Q.parentRef, sendMessage: T, textToSpeech: i })) : /* @__PURE__ */ y.createElement(a2, null), BA = ({
  question: e,
  teacherQuestion: t,
  readOnly: r,
  questionIndex: n = -1,
  ...i
}) => e ? t ? /* @__PURE__ */ y.createElement(gA, { onChange: i.onChange, readOnly: r, question: e, questionIndex: n, studentResponse: i.studentResponse, onRequestClose: i.onRequestClose, isQuestionAnalytics: i.isQuestionAnalytics, studentName: i.studentName, isCollapsibleQuestion: i.isCollapsibleQuestion, buttonAction: i.buttonAction, autoFocus: i.autoFocus }) : /* @__PURE__ */ y.createElement(F0, { className: i.className }, /* @__PURE__ */ y.createElement(pA, { question: e, questionIndex: n, textToSpeech: i.textToSpeech, requestId: i.requestId, review: i.review, studentResponse: i.studentResponse, sendMessage: i.sendMessage, parentRef: i.parentRef, classResponse: i.classResponse })) : null, FA = ({
  question: e,
  teacherQuestion: t,
  readOnly: r,
  ...n
}) => e ? /* @__PURE__ */ y.createElement(F0, { className: n.className }, t ? /* @__PURE__ */ y.createElement(AO, { questionIndex: n.questionIndex, onChange: n.onChange, readOnly: r, question: e, studentResponse: n.studentResponse, onRequestClose: n.onRequestClose, isQuestionAnalytics: n.isQuestionAnalytics, studentName: n.studentName, isCollapsibleQuestion: n.isCollapsibleQuestion, buttonAction: n.buttonAction, autoFocus: n.autoFocus }) : /* @__PURE__ */ y.createElement(uA, { question: e, questionIndex: n.questionIndex, textToSpeech: n.textToSpeech, requestId: n.requestId, review: n.review, sendMessage: n.sendMessage, studentResponse: n.studentResponse, parentRef: n.parentRef, classResponse: n.classResponse })) : /* @__PURE__ */ y.createElement(a2, null), jA = (e) => {
  const {
    question: t
  } = e, r = (n) => {
    const {
      sendMessage: i,
      requestId: o
    } = e;
    i && t && i({
      questionId: String(t._id),
      requestId: o,
      answer: n
    });
  };
  if (t)
    switch (t.type) {
      case F1.FREE_RESPONSE:
        return /* @__PURE__ */ y.createElement(IA, { ...e, question: t, sendMessage: r });
      case F1.MULTIPLE_CHOICE:
        return /* @__PURE__ */ y.createElement(RA, { ...e, question: t, sendMessage: r });
      case F1.MULTIPLE_SELECT:
        return /* @__PURE__ */ y.createElement(PA, { ...e, question: t, sendMessage: r });
      case F1.CLOZE_DROPDOWN:
        return /* @__PURE__ */ y.createElement(BA, { ...e, question: t, sendMessage: r });
      case F1.IMAGE_LABELING:
        return /* @__PURE__ */ y.createElement(FA, { ...e, question: t, sendMessage: r });
      default:
        return /* @__PURE__ */ y.createElement(a2, null);
    }
  else
    return /* @__PURE__ */ y.createElement(a2, null);
}, $A = (e) => {
  const t = {
    phrase: "",
    media: [],
    version: 1
  };
  return e === F1.MULTIPLE_CHOICE ? {
    ...t,
    type: F1.MULTIPLE_CHOICE,
    choices: [{
      text: "",
      answer: !0,
      // @ts-expect-error  We need a different type for media in Editable Question
      media: []
    }]
  } : e === F1.MULTIPLE_SELECT ? {
    ...t,
    type: F1.MULTIPLE_SELECT,
    choices: [{
      text: "",
      answer: !0,
      // @ts-expect-error We need a different type for media in Editable Question
      media: []
    }]
  } : e === F1.CLOZE_DROPDOWN ? {
    type: F1.CLOZE_DROPDOWN,
    dropdowns: [],
    template: "",
    media: []
  } : e === F1.FREE_RESPONSE ? {
    ...t,
    type: F1.FREE_RESPONSE,
    answer: "",
    media: []
  } : {
    type: F1.IMAGE_LABELING,
    phrase: "Please select the correct options on the image below",
    dropdowns: [],
    imageProperties: {
      width: 0,
      height: 0
    },
    media: []
  };
}, ZA = [{
  type: F1.MULTIPLE_CHOICE,
  label: "Multiple Choice",
  icon: __
}, {
  type: F1.FREE_RESPONSE,
  label: "Free Response",
  icon: V_
}, {
  type: F1.MULTIPLE_SELECT,
  label: "Multiple Select",
  icon: A_
}, {
  type: F1.IMAGE_LABELING,
  label: "Modeling",
  icon: D_
}, {
  type: F1.CLOZE_DROPDOWN,
  label: "Cloze Dropdown",
  icon: O_
}];
function WA(e) {
  const t = {};
  hf(e, (n) => (n.file && n.localUrl && (t[n.localUrl] = n.file), n));
  const r = JSON.parse(JSON.stringify(e));
  return Object.keys(t).length === 0 || hf(r, (n) => (n.file && t[n.localUrl] && (n.file = t[n.localUrl]), n)), r;
}
const fd = (e) => `q-id-${e}`, Rk = (e) => {
  const {
    questions: t,
    add: r,
    remove: n,
    update: i,
    className: o,
    headerClassName: a,
    sideNavClassName: T
  } = e, [s, Q] = W1(0), [u, l] = W1(null);
  os(() => {
    u != null && l(null);
  }, [u]);
  const c = (p) => {
    const v = t.length;
    r($A(p)), l(v), Q(v);
  }, f = (p, v) => {
    if (t[p]) {
      if (v.type === c3.DELETE_QUESTION) {
        n(p);
        return;
      }
      const H = WA(t[p]);
      if (v.type === c3.DUPLICATE_QUESTION) {
        r({
          ...H,
          _id: void 0
        });
        return;
      }
      c_(H, v) && (H.updated = !0, i(H, p));
    }
  }, d = m4(null), m = H_(d).height;
  return G3(() => {
    if (s != null) {
      const p = document.getElementById(fd(s));
      if (p) {
        const v = p.getBoundingClientRect().top + window.scrollY - m;
        window.scrollTo({
          top: v,
          behavior: "smooth"
        });
      }
    }
  }, [s]), /* @__PURE__ */ y.createElement(F0, { className: o }, /* @__PURE__ */ y.createElement("div", { ref: d, className: S3("w-full flex mb-2 bg-brand-deep-blue rounded-lg justify-evenly p-2", a) }, ZA.map((p, v) => /* @__PURE__ */ y.createElement("button", { key: `button-${v}`, onClick: () => c(p.type), className: "flex flex-col gap-1 items-center p-1 rounded-lg hover:brightness-90 active:brightness-75" }, /* @__PURE__ */ y.createElement("img", { src: p.icon }), /* @__PURE__ */ y.createElement("span", { className: "font-semibold text-sm" }, p.label)))), /* @__PURE__ */ y.createElement(zA, null, /* @__PURE__ */ y.createElement("div", { className: S3("side-margin h-fit", T) }, t.map((p, v) => (
    // const TabQuestion = styled.div<ITabQuestion>`
    // 	text-align: left;
    // 	position: sticky;
    // 	top: ${({ theme }) => getAbsoluteQuestionPickerHeight(theme)}px;
    // 	font-style: normal;
    // 	font-weight: normal;
    // 	text-transform: capitalize;
    // 	cursor: pointer;
    // 	font-size: ${_tempTheme.text_base};
    // 	line-height: 19px;
    // 	display: flex;
    // 	padding-top: ${_tempTheme.spacing2};
    // 	padding-bottom: ${_tempTheme.spacing2};
    // 	border-left: ${({ $selected, theme }) =>
    // 		$selected && `${_tempTheme.spacing1} solid ${theme.primary}`};
    // 	padding-left: ${({ $selected, theme }) =>
    // 		$selected
    // 			? theme.spacing
    // 			: `${theme.spacingValue + theme.spacingHalfValue}px`};
    // `
    /* @__PURE__ */ y.createElement("button", { key: `q-label-${v}`, className: S3("sticky capitalize cursor-pointer flex py-2 pl-2 border-l-2", v === s ? "border-l-brand-horizon-blue" : "border-l-transparent"), onClick: () => {
      Q(v);
    } }, "Question ", v + 1)
  ))), /* @__PURE__ */ y.createElement("div", { id: "questions-list-content" }, t.map((p, v) => /* @__PURE__ */ y.createElement(GA, { $selected: v === s, key: `q-${v}`, id: fd(v), onClick: () => Q(v) }, /* @__PURE__ */ y.createElement(
    jA,
    {
      question: p,
      teacherQuestion: !0,
      onChange: (H) => f(v, H),
      questionIndex: v,
      autoFocus: v === u
    }
  )))), /* @__PURE__ */ y.createElement("div", { className: "side-margin" })));
}, GA = M1.div.withConfig({
  displayName: "EditQuestions__QuestionWrapper",
  componentId: "sc-1tvaon6-0"
})(["box-shadow:", ";border-radius:", ";background:", ";&:not(:last-child){margin-bottom:", ";}"], ({
  $selected: e
}) => e ? "0px 3px 10px 6px rgba(0, 0, 0, 0.09)" : "0px 2px 4px 2px rgba(0, 0, 0, 0.07)", a1.spacing1, ({
  theme: e
}) => e.baseLight, a1.spacing4), zA = M1.div.withConfig({
  displayName: "EditQuestions__QuestionGroupContent",
  componentId: "sc-1tvaon6-1"
})(["display:flex;.side-margin{flex:1;}div#questions-list-content{position:relative;padding:", ";width:60%;.extra-space{height:20vh;}}"], a1.spacing2), UA = 310, XA = (e) => {
  var m;
  const {
    question: t
  } = e, r = m4(null), [n, i] = W1(0);
  if (!t || !(Ir(t) || I5(t)))
    return /* @__PURE__ */ y.createElement(a2, null);
  const o = !!(t != null && t.choices.some((p) => {
    var v;
    return !!((v = p.media) != null && v[0]);
  })), a = !!(t != null && t.choices.some((p) => !!p.text)), T = t == null ? void 0 : t.choices.every((p) => !p.media || p.media.length === 0), s = t.media && ((m = t.media) == null ? void 0 : m.length) > 0;
  os(() => {
    r.current && i(r.current.clientHeight);
  }, [r.current]);
  const Q = n !== 0 && n < UA, [u, l] = W1(0), c = u > 1, f = (
    // @ts-expect-error TS2532 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    t.media && t.media.length > 0 ? t.media[0].url : null
  ), d = !c && !!f && T;
  return t ? /* @__PURE__ */ y.createElement("div", { style: c ? {
    gridTemplateRows: "1fr auto"
  } : {
    gridTemplateColumns: "auto 1fr"
  }, className: `grid gap-4 py-4 h-full ${d ? "w-[75%] ml-auto mr-auto" : ""}` }, /* @__PURE__ */ y.createElement("div", { className: "relative min-h-72", style: c ? {} : {
    aspectRatio: `${u} / 1`
  } }, f ? /* @__PURE__ */ y.createElement("img", { className: S3("absolute max-w-full max-h-full", c ? "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" : ""), onLoad: (p) => {
    if (!(p != null && p.target))
      return;
    const v = p.target;
    l(Math.ceil(100 * (v.naturalWidth / v.naturalHeight)) / 100);
  }, src: f, alt: t.phrase }) : null), /* @__PURE__ */ y.createElement(KA, { className: "!gap-4", ref: r, $withImage: o, $choicesHaveText: a, $hasQuestionImage: s, $isPortraitAndOnlyText: d }, t.choices.map((p, v) => {
    const H = !!(p.media && p.media.length > 0), E = !!p.text;
    return /* @__PURE__ */ y.createElement(YA, { key: String(p._id), $isSmall: Q, $isImageLandscape: c, $hasQuestionImage: s, $choicesHaveImage: o, $hasText: E }, H && /* @__PURE__ */ y.createElement("div", { className: "mx-auto" }, /* @__PURE__ */ y.createElement(eD, { className: "min-w-24", media: p.media, $_css: Q ? "width: auto;" : "", $_css2: Q && o && a ? "margin-right: 0px;" : "" })), (E || !H) && /* @__PURE__ */ y.createElement(JA, { $hasMedia: H }, E ? /* @__PURE__ */ y.createElement(O2, null, p.text) : /* @__PURE__ */ y.createElement("span", null, "No Image")), /* @__PURE__ */ y.createElement(qA, null, ot(v)));
  }))) : /* @__PURE__ */ y.createElement(a2, null);
}, qA = M1.div.withConfig({
  displayName: "multiple-select__Index",
  componentId: "sc-1e0kq0o-0"
})(["background-color:", ";color:", ";padding:", ";font-family:", ";font-size:2em;min-height:1.8em;display:flex;justify-content:center;align-items:center;"], ({
  theme: e
}) => e.lightSecondaryColor, ({
  theme: e
}) => e.white, a1.spacing2, ({
  theme: e
}) => e.headerFontFamily), JA = M1.div.withConfig({
  displayName: "multiple-select__ChoiceText",
  componentId: "sc-1e0kq0o-1"
})(["text-align:center;font-size:", ";padding:", ";flex:", " display:flex;flex-direction:column;justify-content:center;span{align-self:center;}"], a1.text_3xl, a1.spacing2, ({
  $hasMedia: e
}) => e ? "initial;" : "1;"), YA = M1.div.withConfig({
  displayName: "multiple-select__ChoiceBox",
  componentId: "sc-1e0kq0o-2"
})(["overflow:hidden;display:flex;height:100%;max-height:100%;width:100%;cursor:default;flex-direction:", ";", " .image-wrapper{overflow:hidden;width:100%;height:100%;margin:auto;}"], ({
  $choicesHaveImage: e,
  $hasQuestionImage: t,
  $isSmall: r,
  $isImageLandscape: n
}) => r && t || e || !n ? "row-reverse" : "column", ({
  theme: e
}) => `
		border-radius: ${a1.spacing1};
		background-color: ${e.lighterSecondaryColor};
		color: ${e.lightSecondaryColor};
	`), KA = M1(Ks).withConfig({
  displayName: "multiple-select__ChoiceWrapperStyled",
  componentId: "sc-1e0kq0o-3"
})(["margin:0 auto;height:100%;overflow:hidden;width:100%;", ""], ({
  $withImage: e,
  $hasQuestionImage: t,
  $isPortraitAndOnlyText: r
}) => `
		height: ${e ? "100%" : "fit-content"};
		flex: ${e && t ? "1" : "initial"};
		grid-template-columns: ${r ? "1fr" : "1fr 1fr"};
	
	`);
var eD = M1(j4).withConfig({
  displayName: "multiple-select___StyledImage",
  componentId: "sc-1e0kq0o-4"
})(["margin:auto;height:100%;object-fit:contain;", " ", ""], (e) => e.$_css, (e) => e.$_css2);
const tD = (e) => {
  var a;
  const {
    question: t
  } = e, [r, n] = y.useState(0), i = r > 1, o = t.media && t.media.length > 0;
  return !t || !P5(t) ? /* @__PURE__ */ y.createElement(a2, null) : t ? /* @__PURE__ */ y.createElement("div", { className: S3("p-4 bg-game-primary-400/40 rounded", o ? "grid gap-4 h-full" : ""), style: o ? i ? {
    gridTemplateRows: "1fr auto"
  } : {
    gridTemplateColumns: "auto 1fr"
  } : {} }, o && /* @__PURE__ */ y.createElement("div", { className: "relative", style: i ? {} : {
    aspectRatio: `${r} / 1`
  } }, /* @__PURE__ */ y.createElement(
    "img",
    {
      className: S3("absolute max-w-full max-h-full", i ? "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" : ""),
      onLoad: (T) => {
        if (!(T != null && T.target))
          return;
        const s = T.target;
        n(Math.ceil(100 * (s.naturalWidth / s.naturalHeight)) / 100);
      },
      src: ((a = t.media) == null ? void 0 : a[0].url) || "",
      alt: "Cloze dropdown image hint"
    }
  )), /* @__PURE__ */ y.createElement(JT, { className: "!text-2xl" }, j9({
    template: t.template,
    dropdowns: t.dropdowns,
    isQuestionSlot: !0
  }))) : /* @__PURE__ */ y.createElement(a2, null);
}, rD = (e) => {
  const {
    question: t
  } = e;
  if (!t || !Y6(t))
    return /* @__PURE__ */ y.createElement(a2, null);
  const [r, n] = y.useState(null);
  return t ? /* @__PURE__ */ y.createElement("div", { className: "rounded p-4 bg-game-primary-400/40 h-full" }, /* @__PURE__ */ y.createElement("div", { className: "relative h-full mx-auto w-fit" }, /* @__PURE__ */ y.createElement(
    "img",
    {
      onLoad: (i) => {
        if (!(i != null && i.target))
          return;
        const o = i.target;
        n({
          width: o.width,
          height: o.height,
          src: o.src
        });
      },
      className: "h-full",
      src: t.media[0].url,
      alt: "Label the image for the question slot"
    }
  ), r && /* @__PURE__ */ y.createElement(vp, { question: t, dimensions: r, isQuestionSlot: !0 }))) : /* @__PURE__ */ y.createElement(a2, null);
}, Nk = (e) => {
  const {
    question: t
  } = e;
  if (t)
    switch (t.type) {
      case F1.MULTIPLE_CHOICE:
      case F1.MULTIPLE_SELECT:
        return /* @__PURE__ */ y.createElement(XA, { ...e, question: t });
      case F1.CLOZE_DROPDOWN:
        return /* @__PURE__ */ y.createElement(tD, { ...e, question: t });
      case F1.IMAGE_LABELING:
        return /* @__PURE__ */ y.createElement(rD, { ...e, question: t });
      default:
        return /* @__PURE__ */ y.createElement(a2, null);
    }
  else
    return /* @__PURE__ */ y.createElement(a2, null);
}, nD = "4", h0 = "8", KQ = "16", iD = "32";
function Op(e, {
  fontSize: t = 9
} = {}) {
  const r = {
    marginBottom: 12,
    width: "49%",
    boxSizing: "border-box"
  };
  return e.create({
    page: {
      fontFamily: "default"
    },
    pageHeader: {
      width: "100%",
      backgroundColor: b4.neutralLight,
      padding: `${h0} ${iD}`,
      alignItems: "center",
      marginBottom: KQ
    },
    tag: {
      fontWeight: "bold",
      color: b4.white
    },
    tagWrapper: {
      height: "14px",
      width: "14px",
      backgroundColor: b4.primaryDark,
      borderRadius: 15,
      textAlign: "center",
      fontSize: "9px"
    },
    h5: {
      marginTop: KQ,
      marginBottom: KQ,
      fontWeight: "bold"
    },
    bordered: {
      border: `1.5pt solid ${b4.primaryDark}`
    },
    b: {
      fontWeight: "bold"
    },
    grid: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      fontSize: "8pt",
      alignItems: "stretch"
    },
    flexColumn: {
      flex: 1,
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      marginRight: h0,
      marginBottom: h0
    },
    gridColumn1: {
      ...r,
      marginRight: h0
    },
    gridColumn2: r,
    textSize: {
      fontSize: t
    },
    roundedSm: {
      borderRadius: nD
    },
    tr: {
      display: "flex",
      flexDirection: "row"
    },
    image: {
      marginTop: h0,
      marginBottom: h0,
      maxHeight: "120px",
      maxWidth: "120px"
    }
  });
}
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
const t2 = { blockQuote: "0", breakLine: "1", breakThematic: "2", codeBlock: "3", codeFenced: "4", codeInline: "5", footnote: "6", footnoteReference: "7", gfmTask: "8", heading: "9", headingSetext: "10", htmlBlock: "11", htmlComment: "12", htmlSelfClosing: "13", image: "14", link: "15", linkAngleBraceStyleDetector: "16", linkBareUrlDetector: "17", linkMailtoDetector: "18", newlineCoalescer: "19", orderedList: "20", paragraph: "21", ref: "22", refImage: "23", refLink: "24", table: "25", tableSeparator: "26", text: "27", textBolded: "28", textEmphasized: "29", textEscaped: "30", textMarked: "31", textStrikethroughed: "32", unorderedList: "33" };
var dd;
(function(e) {
  e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
})(dd || (dd = {}));
const hd = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((e, t) => (e[t.toLowerCase()] = t, e), { for: "htmlFor" }), pd = { amp: "&", apos: "'", gt: ">", lt: "<", nbsp: " ", quot: "“" }, oD = ["style", "script"], aD = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, QD = /mailto:/i, TD = /\n{2,}$/, Ap = /^(\s*>[\s\S]*?)(?=\n{2,})/, sD = /^ *> ?/gm, lD = /^ {2,}\n/, uD = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, Dp = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, kp = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, cD = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, fD = /^(?:\n *)*\n/, dD = /\r\n?/g, hD = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, pD = /^\[\^([^\]]+)]/, mD = /\f/g, vD = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, LD = /^\s*?\[(x|\s)\]/, Ip = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, Rp = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, Np = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, KT = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, yD = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, Pp = /^<!--[\s\S]*?(?:-->)/, gD = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, es = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, xD = /^\{.*\}$/, HD = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, ED = /^<([^ >]+@[^ >]+)>/, bD = /^<([^ >]+:\/[^ >]+)>/, MD = /-([a-z])?/gi, Bp = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, wD = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, SD = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, CD = /^\[([^\]]*)\] ?\[([^\]]*)\]/, VD = /(\[|\])/g, _D = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, OD = /\t/g, AD = /(^ *\||\| *$)/g, DD = /^ *:-+: *$/, kD = /^ *:-+ *$/, ID = /^ *-+: *$/, sa = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", RD = new RegExp(`^([*_])\\1${sa}\\1\\1(?!\\1)`), ND = new RegExp(`^([*_])${sa}\\1(?!\\1|\\w)`), PD = new RegExp(`^==${sa}==`), BD = new RegExp(`^~~${sa}~~`), FD = /^\\([^0-9A-Za-z\s])/, jD = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $D = /^\n+/, ZD = /^([ \t]*)/, WD = /\\([^\\])/g, md = / *\n+$/, GD = /(?:^|\n)( *)$/, pl = "(?:\\d+\\.)", ml = "(?:[*+-])";
function Fp(e) {
  return "( *)(" + (e === 1 ? pl : ml) + ") +";
}
const jp = Fp(1), $p = Fp(2);
function Zp(e) {
  return new RegExp("^" + (e === 1 ? jp : $p));
}
const zD = Zp(1), UD = Zp(2);
function Wp(e) {
  return new RegExp("^" + (e === 1 ? jp : $p) + "[^\\n]*(?:\\n(?!\\1" + (e === 1 ? pl : ml) + " )[^\\n]*)*(\\n|$)", "gm");
}
const Gp = Wp(1), zp = Wp(2);
function Up(e) {
  const t = e === 1 ? pl : ml;
  return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const Xp = Up(1), qp = Up(2);
function vd(e, t) {
  const r = t === 1, n = r ? Xp : qp, i = r ? Gp : zp, o = r ? zD : UD;
  return { match(a, T, s) {
    const Q = GD.exec(s);
    return Q && (T.list || !T.inline && !T.simple) ? n.exec(a = Q[1] + a) : null;
  }, order: 1, parse(a, T, s) {
    const Q = r ? +a[2] : void 0, u = a[0].replace(TD, `
`).match(i);
    let l = !1;
    return { items: u.map(function(c, f) {
      const d = o.exec(c)[0].length, m = new RegExp("^ {1," + d + "}", "gm"), p = c.replace(m, "").replace(o, ""), v = f === u.length - 1, H = p.indexOf(`

`) !== -1 || v && l;
      l = H;
      const E = s.inline, M = s.list;
      let C;
      s.list = !0, H ? (s.inline = !1, C = p.replace(md, `

`)) : (s.inline = !0, C = p.replace(md, ""));
      const w = T(C, s);
      return s.inline = E, s.list = M, w;
    }), ordered: r, start: Q };
  }, render: (a, T, s) => e(a.ordered ? "ol" : "ul", { key: s.key, start: a.type === t2.orderedList ? a.start : void 0 }, a.items.map(function(Q, u) {
    return e("li", { key: u }, T(Q, s));
  })) };
}
const XD = new RegExp(`^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['"]([\\s\\S]*?)['"])?\\s*\\)`), qD = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, Jp = [Ap, Dp, kp, Ip, Np, Rp, Pp, Bp, Gp, Xp, zp, qp], JD = [...Jp, /^[^\n]+(?:  \n|\n{2,})/, KT, es];
function Zn(e) {
  return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function YD(e) {
  return ID.test(e) ? "right" : DD.test(e) ? "center" : kD.test(e) ? "left" : null;
}
function Ld(e, t, r, n) {
  const i = r.inTable;
  r.inTable = !0;
  let o = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((T, s) => (s.trim() === "|" ? T.push(n ? { type: t2.tableSeparator } : { type: t2.text, text: s }) : s !== "" && T.push.apply(T, t(s, r)), T), []);
  r.inTable = i;
  let a = [[]];
  return o.forEach(function(T, s) {
    T.type === t2.tableSeparator ? s !== 0 && s !== o.length - 1 && a.push([]) : (T.type !== t2.text || o[s + 1] != null && o[s + 1].type !== t2.tableSeparator || (T.text = T.text.trimEnd()), a[a.length - 1].push(T));
  }), a;
}
function KD(e, t, r) {
  r.inline = !0;
  const n = e[2] ? e[2].replace(AD, "").split("|").map(YD) : [], i = e[3] ? function(a, T, s) {
    return a.trim().split(`
`).map(function(Q) {
      return Ld(Q, T, s, !0);
    });
  }(e[3], t, r) : [], o = Ld(e[1], t, r, !!i.length);
  return r.inline = !1, i.length ? { align: n, cells: i, header: o, type: t2.table } : { children: o, type: t2.paragraph };
}
function yd(e, t) {
  return e.align[t] == null ? {} : { textAlign: e.align[t] };
}
function C5(e) {
  return function(t, r) {
    return r.inline ? e.exec(t) : null;
  };
}
function V5(e) {
  return function(t, r) {
    return r.inline || r.simple ? e.exec(t) : null;
  };
}
function X6(e) {
  return function(t, r) {
    return r.inline || r.simple ? null : e.exec(t);
  };
}
function br(e) {
  return function(t) {
    return e.exec(t);
  };
}
function ek(e, t, r) {
  if (t.inline || t.simple || r && !r.endsWith(`
`))
    return null;
  let n = "";
  e.split(`
`).every((o) => !Jp.some((a) => a.test(o)) && (n += o + `
`, o.trim()));
  const i = n.trimEnd();
  return i == "" ? null : [n, i];
}
function tk(e) {
  try {
    if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i))
      return null;
  } catch {
    return null;
  }
  return e;
}
function gd(e) {
  return e.replace(WD, "$1");
}
function r9(e, t, r) {
  const n = r.inline || !1, i = r.simple || !1;
  r.inline = !0, r.simple = !0;
  const o = e(t, r);
  return r.inline = n, r.simple = i, o;
}
function rk(e, t, r) {
  const n = r.inline || !1, i = r.simple || !1;
  r.inline = !1, r.simple = !0;
  const o = e(t, r);
  return r.inline = n, r.simple = i, o;
}
function nk(e, t, r) {
  const n = r.inline || !1;
  r.inline = !1;
  const i = e(t, r);
  return r.inline = n, i;
}
const eT = (e, t, r) => ({ children: r9(t, e[1], r) });
function tT() {
  return {};
}
function rT() {
  return null;
}
function ik(...e) {
  return e.filter(Boolean).join(" ");
}
function nT(e, t, r) {
  let n = e;
  const i = t.split(".");
  for (; i.length && (n = n[i[0]], n !== void 0); )
    i.shift();
  return n || r;
}
function ok(e = "", t = {}) {
  function r(c, f, ...d) {
    const m = nT(t.overrides, `${c}.props`, {});
    return t.createElement(function(p, v) {
      const H = nT(v, p);
      return H ? typeof H == "function" || typeof H == "object" && "render" in H ? H : nT(v, `${p}.component`, p) : p;
    }(c, t.overrides), Pe({}, f, m, { className: ik(f == null ? void 0 : f.className, m.className) || void 0 }), ...d);
  }
  function n(c) {
    c = c.replace(vD, "");
    let f = !1;
    t.forceInline ? f = !0 : t.forceBlock || (f = _D.test(c) === !1);
    const d = Q(s(f ? c : `${c.trimEnd().replace($D, "")}

`, { inline: f }));
    for (; typeof d[d.length - 1] == "string" && !d[d.length - 1].trim(); )
      d.pop();
    if (t.wrapper === null)
      return d;
    const m = t.wrapper || (f ? "span" : "div");
    let p;
    if (d.length > 1 || t.forceWrapper)
      p = d;
    else {
      if (d.length === 1)
        return p = d[0], typeof p == "string" ? r("span", { key: "outer" }, p) : p;
      p = null;
    }
    return W3.createElement(m, { key: "outer" }, p);
  }
  function i(c, f) {
    const d = f.match(aD);
    return d ? d.reduce(function(m, p, v) {
      const H = p.indexOf("=");
      if (H !== -1) {
        const E = function(S) {
          return S.indexOf("-") !== -1 && S.match(gD) === null && (S = S.replace(MD, function(D, k) {
            return k.toUpperCase();
          })), S;
        }(p.slice(0, H)).trim(), M = function(S) {
          const D = S[0];
          return (D === '"' || D === "'") && S.length >= 2 && S[S.length - 1] === D ? S.slice(1, -1) : S;
        }(p.slice(H + 1).trim()), C = hd[E] || E, w = m[C] = function(S, D, k, $) {
          return D === "style" ? k.split(/;\s?/).reduce(function(z, j) {
            const J = j.slice(0, j.indexOf(":"));
            return z[J.trim().replace(/(-[a-z])/g, (i1) => i1[1].toUpperCase())] = j.slice(J.length + 1).trim(), z;
          }, {}) : D === "href" || D === "src" ? $(k, S, D) : (k.match(xD) && (k = k.slice(1, k.length - 1)), k === "true" || k !== "false" && k);
        }(c, E, M, t.sanitizer);
        typeof w == "string" && (KT.test(w) || es.test(w)) && (m[C] = W3.cloneElement(n(w.trim()), { key: v }));
      } else
        p !== "style" && (m[hd[p] || p] = !0);
      return m;
    }, {}) : null;
  }
  t.overrides = t.overrides || {}, t.sanitizer = t.sanitizer || tk, t.slugify = t.slugify || Zn, t.namedCodesToUnicode = t.namedCodesToUnicode ? Pe({}, pd, t.namedCodesToUnicode) : pd, t.createElement = t.createElement || W3.createElement;
  const o = [], a = {}, T = { [t2.blockQuote]: { match: X6(Ap), order: 1, parse: (c, f, d) => ({ children: f(c[0].replace(sD, ""), d) }), render: (c, f, d) => r("blockquote", { key: d.key }, f(c.children, d)) }, [t2.breakLine]: { match: br(lD), order: 1, parse: tT, render: (c, f, d) => r("br", { key: d.key }) }, [t2.breakThematic]: { match: X6(uD), order: 1, parse: tT, render: (c, f, d) => r("hr", { key: d.key }) }, [t2.codeBlock]: { match: X6(kp), order: 0, parse: (c) => ({ lang: void 0, text: c[0].replace(/^ {4}/gm, "").replace(/\n+$/, "") }), render: (c, f, d) => r("pre", { key: d.key }, r("code", Pe({}, c.attrs, { className: c.lang ? `lang-${c.lang}` : "" }), c.text)) }, [t2.codeFenced]: { match: X6(Dp), order: 0, parse: (c) => ({ attrs: i("code", c[3] || ""), lang: c[2] || void 0, text: c[4], type: t2.codeBlock }) }, [t2.codeInline]: { match: V5(cD), order: 3, parse: (c) => ({ text: c[2] }), render: (c, f, d) => r("code", { key: d.key }, c.text) }, [t2.footnote]: { match: X6(hD), order: 0, parse: (c) => (o.push({ footnote: c[2], identifier: c[1] }), {}), render: rT }, [t2.footnoteReference]: { match: C5(pD), order: 1, parse: (c) => ({ target: `#${t.slugify(c[1], Zn)}`, text: c[1] }), render: (c, f, d) => r("a", { key: d.key, href: t.sanitizer(c.target, "a", "href") }, r("sup", { key: d.key }, c.text)) }, [t2.gfmTask]: { match: C5(LD), order: 1, parse: (c) => ({ completed: c[1].toLowerCase() === "x" }), render: (c, f, d) => r("input", { checked: c.completed, key: d.key, readOnly: !0, type: "checkbox" }) }, [t2.heading]: { match: X6(t.enforceAtxHeadings ? Rp : Ip), order: 1, parse: (c, f, d) => ({ children: r9(f, c[2], d), id: t.slugify(c[2], Zn), level: c[1].length }), render: (c, f, d) => r(`h${c.level}`, { id: c.id, key: d.key }, f(c.children, d)) }, [t2.headingSetext]: { match: X6(Np), order: 0, parse: (c, f, d) => ({ children: r9(f, c[1], d), level: c[2] === "=" ? 1 : 2, type: t2.heading }) }, [t2.htmlBlock]: { match: br(KT), order: 1, parse(c, f, d) {
    const [, m] = c[3].match(ZD), p = new RegExp(`^${m}`, "gm"), v = c[3].replace(p, ""), H = (E = v, JD.some((D) => D.test(E)) ? nk : r9);
    var E;
    const M = c[1].toLowerCase(), C = oD.indexOf(M) !== -1, w = (C ? M : c[1]).trim(), S = { attrs: i(w, c[2]), noInnerParse: C, tag: w };
    return d.inAnchor = d.inAnchor || M === "a", C ? S.text = c[3] : S.children = H(f, v, d), d.inAnchor = !1, S;
  }, render: (c, f, d) => r(c.tag, Pe({ key: d.key }, c.attrs), c.text || f(c.children, d)) }, [t2.htmlSelfClosing]: { match: br(es), order: 1, parse(c) {
    const f = c[1].trim();
    return { attrs: i(f, c[2] || ""), tag: f };
  }, render: (c, f, d) => r(c.tag, Pe({}, c.attrs, { key: d.key })) }, [t2.htmlComment]: { match: br(Pp), order: 1, parse: () => ({}), render: rT }, [t2.image]: { match: V5(qD), order: 1, parse: (c) => ({ alt: c[1], target: gd(c[2]), title: c[3] }), render: (c, f, d) => r("img", { key: d.key, alt: c.alt || void 0, title: c.title || void 0, src: t.sanitizer(c.target, "img", "src") }) }, [t2.link]: { match: C5(XD), order: 3, parse: (c, f, d) => ({ children: rk(f, c[1], d), target: gd(c[2]), title: c[3] }), render: (c, f, d) => r("a", { key: d.key, href: t.sanitizer(c.target, "a", "href"), title: c.title }, f(c.children, d)) }, [t2.linkAngleBraceStyleDetector]: { match: C5(bD), order: 0, parse: (c) => ({ children: [{ text: c[1], type: t2.text }], target: c[1], type: t2.link }) }, [t2.linkBareUrlDetector]: { match: (c, f) => f.inAnchor ? null : C5(HD)(c, f), order: 0, parse: (c) => ({ children: [{ text: c[1], type: t2.text }], target: c[1], title: void 0, type: t2.link }) }, [t2.linkMailtoDetector]: { match: C5(ED), order: 0, parse(c) {
    let f = c[1], d = c[1];
    return QD.test(d) || (d = "mailto:" + d), { children: [{ text: f.replace("mailto:", ""), type: t2.text }], target: d, type: t2.link };
  } }, [t2.orderedList]: vd(r, 1), [t2.unorderedList]: vd(r, 2), [t2.newlineCoalescer]: { match: X6(fD), order: 3, parse: tT, render: () => `
` }, [t2.paragraph]: { match: ek, order: 3, parse: eT, render: (c, f, d) => r("p", { key: d.key }, f(c.children, d)) }, [t2.ref]: { match: C5(wD), order: 0, parse: (c) => (a[c[1]] = { target: c[2], title: c[4] }, {}), render: rT }, [t2.refImage]: { match: V5(SD), order: 0, parse: (c) => ({ alt: c[1] || void 0, ref: c[2] }), render: (c, f, d) => a[c.ref] ? r("img", { key: d.key, alt: c.alt, src: t.sanitizer(a[c.ref].target, "img", "src"), title: a[c.ref].title }) : null }, [t2.refLink]: { match: C5(CD), order: 0, parse: (c, f, d) => ({ children: f(c[1], d), fallbackChildren: f(c[0].replace(VD, "\\$1"), d), ref: c[2] }), render: (c, f, d) => a[c.ref] ? r("a", { key: d.key, href: t.sanitizer(a[c.ref].target, "a", "href"), title: a[c.ref].title }, f(c.children, d)) : r("span", { key: d.key }, f(c.fallbackChildren, d)) }, [t2.table]: { match: X6(Bp), order: 1, parse: KD, render(c, f, d) {
    const m = c;
    return r("table", { key: d.key }, r("thead", null, r("tr", null, m.header.map(function(p, v) {
      return r("th", { key: v, style: yd(m, v) }, f(p, d));
    }))), r("tbody", null, m.cells.map(function(p, v) {
      return r("tr", { key: v }, p.map(function(H, E) {
        return r("td", { key: E, style: yd(m, E) }, f(H, d));
      }));
    })));
  } }, [t2.text]: { match: br(jD), order: 4, parse: (c) => ({ text: c[0].replace(yD, (f, d) => t.namedCodesToUnicode[d] ? t.namedCodesToUnicode[d] : f) }), render: (c) => c.text }, [t2.textBolded]: { match: V5(RD), order: 2, parse: (c, f, d) => ({ children: f(c[2], d) }), render: (c, f, d) => r("strong", { key: d.key }, f(c.children, d)) }, [t2.textEmphasized]: { match: V5(ND), order: 3, parse: (c, f, d) => ({ children: f(c[2], d) }), render: (c, f, d) => r("em", { key: d.key }, f(c.children, d)) }, [t2.textEscaped]: { match: V5(FD), order: 1, parse: (c) => ({ text: c[1], type: t2.text }) }, [t2.textMarked]: { match: V5(PD), order: 3, parse: eT, render: (c, f, d) => r("mark", { key: d.key }, f(c.children, d)) }, [t2.textStrikethroughed]: { match: V5(BD), order: 3, parse: eT, render: (c, f, d) => r("del", { key: d.key }, f(c.children, d)) } };
  t.disableParsingRawHTML === !0 && (delete T[t2.htmlBlock], delete T[t2.htmlSelfClosing]);
  const s = function(c) {
    let f = Object.keys(c);
    function d(m, p) {
      let v = [], H = "";
      for (; m; ) {
        let E = 0;
        for (; E < f.length; ) {
          const M = f[E], C = c[M], w = C.match(m, p, H);
          if (w) {
            const S = w[0];
            m = m.substring(S.length);
            const D = C.parse(w, d, p);
            D.type == null && (D.type = M), v.push(D), H = S;
            break;
          }
          E++;
        }
      }
      return v;
    }
    return f.sort(function(m, p) {
      let v = c[m].order, H = c[p].order;
      return v !== H ? v - H : m < p ? -1 : 1;
    }), function(m, p) {
      return d(function(v) {
        return v.replace(dD, `
`).replace(mD, "").replace(OD, "    ");
      }(m), p);
    };
  }(T), Q = (u = /* @__PURE__ */ function(c, f) {
    return function(d, m, p) {
      const v = c[d.type].render;
      return f ? f(() => v(d, m, p), d, m, p) : v(d, m, p);
    };
  }(T, t.renderRule), function c(f, d = {}) {
    if (Array.isArray(f)) {
      const m = d.key, p = [];
      let v = !1;
      for (let H = 0; H < f.length; H++) {
        d.key = H;
        const E = c(f[H], d), M = typeof E == "string";
        M && v ? p[p.length - 1] += E : E !== null && p.push(E), v = M;
      }
      return d.key = m, p;
    }
    return u(f, c, d);
  });
  var u;
  const l = n(e);
  return o.length ? r("div", null, l, r("footer", { key: "footer" }, o.map(function(c) {
    return r("div", { id: t.slugify(c.identifier, Zn), key: c.identifier }, c.identifier, Q(s(c.footnote, { inline: !0 })));
  }))) : l;
}
var ts = /* @__PURE__ */ ((e) => (e.ORDERED = "ORDERED", e.UNORDERED = "UNORDERED", e))(ts || {});
const rs = Qm({
  type: "ORDERED",
  level: -1,
  value: {
    current: 1
  }
}), ak = {
  ORDERED: [(e) => `${e}.`, (e) => lk(e, !0), sk],
  UNORDERED: [() => "•", () => "◦", () => "■"]
};
function Qk(e, t, r) {
  const n = ak[e];
  return n[Math.min(Math.max(0, t), n.length)](r);
}
const iT = "abcdefghijklmnopqrstuvwxyz".split(""), Tk = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
function sk(e) {
  return Math.abs(e - 1).toString(iT.length).split("").map((r) => iT[parseInt(r, iT.length)]).join("") + ".";
}
function lk(e, t) {
  const r = String(e).split("");
  let n = "", i = 3;
  for (; i--; ) {
    const a = r.pop();
    if (a == null)
      break;
    n = (Tk[+a + i * 10] || "") + n;
  }
  const o = Array(+r.join("") + 1).join("M") + n;
  return t ? o.toLocaleLowerCase() + "." : o;
}
function Yp({
  children: e,
  markdownContext: t,
  style: r
}) {
  const {
    View: n
  } = t.ReactPdf;
  return /* @__PURE__ */ y.createElement(n, null, /* @__PURE__ */ y.createElement(h4, { style: r, markdownContext: t }, e));
}
function ns({
  children: e,
  markdownContext: t,
  type: r,
  start: n
}) {
  const {
    View: i
  } = t.ReactPdf, o = as(rs);
  return /* @__PURE__ */ y.createElement(rs.Provider, { value: {
    type: r,
    level: o.type === r ? o.level + 1 : 0,
    value: {
      current: n
    }
  } }, /* @__PURE__ */ y.createElement(i, { style: t.pdfStyles.list }, e));
}
function uk({
  children: e,
  markdownContext: t
}) {
  const {
    View: r,
    Text: n
  } = t.ReactPdf, i = as(rs), o = i.value.current;
  return i.value.current += 1, /* @__PURE__ */ y.createElement(r, { style: t.pdfStyles.listItem }, /* @__PURE__ */ y.createElement(r, { style: {
    flexGrow: 0,
    alignSelf: "baseline"
  } }, /* @__PURE__ */ y.createElement(n, null, Qk(i.type, i.level, o), " ")), /* @__PURE__ */ y.createElement(r, { style: {
    flex: 1,
    alignSelf: "baseline"
  } }, /* @__PURE__ */ y.createElement(h4, { markdownContext: t }, e)));
}
function ck({
  src: e,
  markdownContext: t
}) {
  const {
    View: r,
    Image: n
  } = t.ReactPdf;
  return /* @__PURE__ */ y.createElement(r, { style: t.pdfStyles.imageWrapper }, /* @__PURE__ */ y.createElement(n, { src: e, style: t.pdfStyles.image }));
}
function is(e, t) {
  var n, i;
  const r = y.Children.toArray(e);
  for (const o of r)
    if (!(!o || typeof o == "string" || typeof o == "number" || !Object.keys(o).length || o.type === Vp) && (typeof o == "function" || Array.isArray(o) && !is(o, t) || o.type === t.ReactPdf.View || o.type === t.ReactPdf.Image || o.type === Yp || o.type === ns || o.type === Ie || o.type !== t.ReactPdf.Text && !((i = (n = o.props) == null ? void 0 : n.children) != null && i.length && is(o.props.children, t))))
      return !1;
  return !0;
}
function Kp(e, t, r, n, i) {
  y.Children.forEach(e, (o, a) => {
    let T = `${t.length}-${r.length}-${a}`;
    if (typeof o == "string") {
      r.push(o);
      return;
    }
    if (Array.isArray(o)) {
      Kp(o, t, r, n, i);
      return;
    }
    if (T = `${t.length}-${r.length}-${a}`, is([o], i)) {
      r.push(o);
      return;
    }
    r.length && (t.push(/* @__PURE__ */ y.createElement(i.ReactPdf.Text, { ...n, key: T }, [...r])), r.length = 0), t.push(/* @__PURE__ */ y.createElement(i.ReactPdf.View, { ...n, key: `wrapper-${T}` }, o));
  });
}
function fk(e, t, r) {
  const n = [], i = [];
  return Kp(e, n, i, t, r), i.length && n.push(/* @__PURE__ */ y.createElement(r.ReactPdf.Text, { ...t, key: n.length }, i)), n;
}
function h4({
  children: e,
  markdownContext: t,
  ...r
}) {
  try {
    return /* @__PURE__ */ y.createElement(y.Fragment, null, fk(e, r, t));
  } catch (n) {
    console.error(n);
  }
  return null;
}
function Ie({
  children: e,
  markdownContext: t,
  style: r
}) {
  return /* @__PURE__ */ y.createElement(t.ReactPdf.View, null, /* @__PURE__ */ y.createElement(h4, { style: r, markdownContext: t }, e));
}
var em = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(b, function() {
    return function(r) {
      var n = {};
      function i(o) {
        if (n[o])
          return n[o].exports;
        var a = n[o] = { i: o, l: !1, exports: {} };
        return r[o].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
      }
      return i.m = r, i.c = n, i.d = function(o, a, T) {
        i.o(o, a) || Object.defineProperty(o, a, { enumerable: !0, get: T });
      }, i.r = function(o) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
      }, i.t = function(o, a) {
        if (1 & a && (o = i(o)), 8 & a || 4 & a && typeof o == "object" && o && o.__esModule)
          return o;
        var T = /* @__PURE__ */ Object.create(null);
        if (i.r(T), Object.defineProperty(T, "default", { enumerable: !0, value: o }), 2 & a && typeof o != "string")
          for (var s in o)
            i.d(T, s, (function(Q) {
              return o[Q];
            }).bind(null, s));
        return T;
      }, i.n = function(o) {
        var a = o && o.__esModule ? function() {
          return o.default;
        } : function() {
          return o;
        };
        return i.d(a, "a", a), a;
      }, i.o = function(o, a) {
        return Object.prototype.hasOwnProperty.call(o, a);
      }, i.p = "", i(i.s = 0);
    }([function(r, n, i) {
      var o;
      function a(w) {
        return ["image/png", "image/jpeg", "image/gif"].some((S) => S === w);
      }
      i.r(n), i.d(n, "canvastoDataURL", function() {
        return s;
      }), i.d(n, "canvastoFile", function() {
        return Q;
      }), i.d(n, "dataURLtoFile", function() {
        return l;
      }), i.d(n, "dataURLtoImage", function() {
        return c;
      }), i.d(n, "downloadFile", function() {
        return f;
      }), i.d(n, "filetoDataURL", function() {
        return d;
      }), i.d(n, "imagetoCanvas", function() {
        return p;
      }), i.d(n, "urltoBlob", function() {
        return v;
      }), i.d(n, "urltoImage", function() {
        return H;
      }), i.d(n, "compress", function() {
        return M;
      }), i.d(n, "compressAccurately", function() {
        return C;
      }), i.d(n, "EImageType", function() {
        return o;
      }), function(w) {
        w.PNG = "image/png", w.JPEG = "image/jpeg", w.GIF = "image/gif";
      }(o || (o = {}));
      var T = function(w, S, D, k) {
        return new (D || (D = Promise))(function($, z) {
          function j(t1) {
            try {
              i1(k.next(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function J(t1) {
            try {
              i1(k.throw(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function i1(t1) {
            var T1;
            t1.done ? $(t1.value) : (T1 = t1.value, T1 instanceof D ? T1 : new D(function(X) {
              X(T1);
            })).then(j, J);
          }
          i1((k = k.apply(w, S || [])).next());
        });
      };
      function s(w, S = 0.92, D = o.JPEG) {
        return T(this, void 0, void 0, function* () {
          return a(D) || (D = o.JPEG), w.toDataURL(D, S);
        });
      }
      function Q(w, S = 0.92, D = o.JPEG) {
        return new Promise((k) => w.toBlob(($) => k($), D, S));
      }
      var u = function(w, S, D, k) {
        return new (D || (D = Promise))(function($, z) {
          function j(t1) {
            try {
              i1(k.next(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function J(t1) {
            try {
              i1(k.throw(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function i1(t1) {
            var T1;
            t1.done ? $(t1.value) : (T1 = t1.value, T1 instanceof D ? T1 : new D(function(X) {
              X(T1);
            })).then(j, J);
          }
          i1((k = k.apply(w, S || [])).next());
        });
      };
      function l(w, S) {
        return u(this, void 0, void 0, function* () {
          const D = w.split(",");
          let k = D[0].match(/:(.*?);/)[1];
          const $ = atob(D[1]);
          let z = $.length;
          const j = new Uint8Array(z);
          for (; z--; )
            j[z] = $.charCodeAt(z);
          return a(S) && (k = S), new Blob([j], { type: k });
        });
      }
      function c(w) {
        return new Promise((S, D) => {
          const k = new Image();
          k.onload = () => S(k), k.onerror = () => D(new Error("dataURLtoImage(): dataURL is illegal")), k.src = w;
        });
      }
      function f(w, S) {
        const D = document.createElement("a");
        D.href = window.URL.createObjectURL(w), D.download = S || Date.now().toString(36), document.body.appendChild(D);
        const k = document.createEvent("MouseEvents");
        k.initEvent("click", !1, !1), D.dispatchEvent(k), document.body.removeChild(D);
      }
      function d(w) {
        return new Promise((S) => {
          const D = new FileReader();
          D.onloadend = (k) => S(k.target.result), D.readAsDataURL(w);
        });
      }
      var m = function(w, S, D, k) {
        return new (D || (D = Promise))(function($, z) {
          function j(t1) {
            try {
              i1(k.next(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function J(t1) {
            try {
              i1(k.throw(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function i1(t1) {
            var T1;
            t1.done ? $(t1.value) : (T1 = t1.value, T1 instanceof D ? T1 : new D(function(X) {
              X(T1);
            })).then(j, J);
          }
          i1((k = k.apply(w, S || [])).next());
        });
      };
      function p(w, S = {}) {
        return m(this, void 0, void 0, function* () {
          const D = Object.assign({}, S), k = document.createElement("canvas"), $ = k.getContext("2d");
          let z, j;
          for (const J in D)
            Object.prototype.hasOwnProperty.call(D, J) && (D[J] = Number(D[J]));
          if (D.scale) {
            const J = D.scale > 0 && D.scale < 10 ? D.scale : 1;
            j = w.width * J, z = w.height * J;
          } else
            j = D.width || D.height * w.width / w.height || w.width, z = D.height || D.width * w.height / w.width || w.height;
          switch ([5, 6, 7, 8].some((J) => J === D.orientation) ? (k.height = j, k.width = z) : (k.height = z, k.width = j), D.orientation) {
            case 3:
              $.rotate(180 * Math.PI / 180), $.drawImage(w, -k.width, -k.height, k.width, k.height);
              break;
            case 6:
              $.rotate(90 * Math.PI / 180), $.drawImage(w, 0, -k.width, k.height, k.width);
              break;
            case 8:
              $.rotate(270 * Math.PI / 180), $.drawImage(w, -k.height, 0, k.height, k.width);
              break;
            case 2:
              $.translate(k.width, 0), $.scale(-1, 1), $.drawImage(w, 0, 0, k.width, k.height);
              break;
            case 4:
              $.translate(k.width, 0), $.scale(-1, 1), $.rotate(180 * Math.PI / 180), $.drawImage(w, -k.width, -k.height, k.width, k.height);
              break;
            case 5:
              $.translate(k.width, 0), $.scale(-1, 1), $.rotate(90 * Math.PI / 180), $.drawImage(w, 0, -k.width, k.height, k.width);
              break;
            case 7:
              $.translate(k.width, 0), $.scale(-1, 1), $.rotate(270 * Math.PI / 180), $.drawImage(w, -k.height, 0, k.height, k.width);
              break;
            default:
              $.drawImage(w, 0, 0, k.width, k.height);
          }
          return k;
        });
      }
      function v(w) {
        return fetch(w).then((S) => S.blob());
      }
      function H(w) {
        return new Promise((S, D) => {
          const k = new Image();
          k.onload = () => S(k), k.onerror = () => D(new Error("urltoImage(): Image failed to load, please check the image URL")), k.src = w;
        });
      }
      var E = function(w, S, D, k) {
        return new (D || (D = Promise))(function($, z) {
          function j(t1) {
            try {
              i1(k.next(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function J(t1) {
            try {
              i1(k.throw(t1));
            } catch (T1) {
              z(T1);
            }
          }
          function i1(t1) {
            var T1;
            t1.done ? $(t1.value) : (T1 = t1.value, T1 instanceof D ? T1 : new D(function(X) {
              X(T1);
            })).then(j, J);
          }
          i1((k = k.apply(w, S || [])).next());
        });
      };
      function M(w, S = {}) {
        return E(this, void 0, void 0, function* () {
          if (!(w instanceof Blob))
            throw new Error("compress(): First arg must be a Blob object or a File object.");
          if (typeof S != "object" && (S = Object.assign({ quality: S })), S.quality = Number(S.quality), Number.isNaN(S.quality))
            return w;
          const D = yield d(w);
          let k = D.split(",")[0].match(/:(.*?);/)[1], $ = o.JPEG;
          a(S.type) && ($ = S.type, k = S.type);
          const z = yield c(D), j = yield p(z, Object.assign({}, S)), J = yield s(j, S.quality, $), i1 = yield l(J, k);
          return i1.size > w.size ? w : i1;
        });
      }
      function C(w, S = {}) {
        return E(this, void 0, void 0, function* () {
          if (!(w instanceof Blob))
            throw new Error("compressAccurately(): First arg must be a Blob object or a File object.");
          if (typeof S != "object" && (S = Object.assign({ size: S })), S.size = Number(S.size), Number.isNaN(S.size) || 1024 * S.size > w.size)
            return w;
          S.accuracy = Number(S.accuracy), (!S.accuracy || S.accuracy < 0.8 || S.accuracy > 0.99) && (S.accuracy = 0.95);
          const D = S.size * (2 - S.accuracy) * 1024, k = 1024 * S.size, $ = S.size * S.accuracy * 1024, z = yield d(w);
          let j = z.split(",")[0].match(/:(.*?);/)[1], J = o.JPEG;
          a(S.type) && (J = S.type, j = S.type);
          const i1 = yield c(z), t1 = yield p(i1, Object.assign({}, S));
          let T1, X = 0.5;
          const f1 = [null, null];
          for (let Z = 1; Z <= 7; Z++) {
            T1 = yield s(t1, X, J);
            const L1 = 0.75 * T1.length;
            if (Z === 7) {
              (D < L1 || $ > L1) && (T1 = [T1, ...f1].filter((C1) => C1).sort((C1, q) => Math.abs(0.75 * C1.length - k) - Math.abs(0.75 * q.length - k))[0]);
              break;
            }
            if (D < L1)
              f1[1] = T1, X -= Math.pow(0.5, Z + 1);
            else {
              if (!($ > L1))
                break;
              f1[0] = T1, X += Math.pow(0.5, Z + 1);
            }
          }
          const s1 = yield l(T1, j);
          return s1.size > w.size ? w : s1;
        });
      }
    }]);
  });
})(em);
var dk = em.exports, Wn = dk;
const xd = 2 / 3;
function hk({
  children: e,
  markdownContext: t
}) {
  const {
    View: r
  } = t.ReactPdf;
  return /* @__PURE__ */ y.createElement(r, null, /* @__PURE__ */ y.createElement(h4, { markdownContext: t }, e));
}
function oT({
  children: e,
  markdownContext: t
}) {
  const {
    Image: r
  } = t.ReactPdf, n = typeof e == "string" ? e : "", i = m4(null), o = m4(0), a = typeof t.styleOverrides.color == "string" ? t.styleOverrides.color : "currentColor", [T, s] = m3(() => {
    var u;
    o.current += 1;
    const Q = o.current;
    if (!n || typeof n != "string")
      return [{
        width: 0,
        height: 0
      }, null];
    try {
      if (!((u = window.MathJax) != null && u.tex2svg))
        throw new Error("Mathjax is either not loaded or did not load the tex2svg function");
      const l = window.MathJax.tex2svg(n).getElementsByTagName("svg")[0];
      l.querySelectorAll('[stroke="currentColor"]').forEach((f) => f.setAttribute("stroke", a)), l.querySelectorAll('[fill="currentColor"]').forEach((f) => f.setAttribute("fill", a));
      const c = "data:image/svg+xml;base64," + // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
      window.btoa(unescape(encodeURIComponent(l.outerHTML)));
      return [{
        width: (
          // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          l.width.baseVal.valueInSpecifiedUnits * // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          l.width.baseVal.unitType * xd
        ),
        height: (
          // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          l.height.baseVal.valueInSpecifiedUnits * // @ts-expect-error TS18048 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          l.height.baseVal.unitType * xd
        )
      }, () => Wn.urltoImage(c).then((f) => Wn.imagetoCanvas(f)).then((f) => Wn.canvastoFile(f, void 0, Wn.EImageType.PNG)).then((f) => {
        if (Q === o.current) {
          const d = i.current;
          return d && URL.revokeObjectURL(d), i.current = URL.createObjectURL(f), i.current;
        }
        return "";
      })];
    } catch (l) {
      return console.error(l), [{
        width: 0,
        height: 0
      }, null];
    }
  }, [n, a]);
  return G3(() => () => {
    const Q = i.current;
    Q && URL.revokeObjectURL(Q), o.current = 1 / 0;
  }, []), !n || typeof n != "string" ? null : /* @__PURE__ */ y.createElement(y.Fragment, null, s ? /* @__PURE__ */ y.createElement(r, { src: s, style: {
    width: `${T.width}pt`,
    height: `${T.height}pt`
  } }) : /* @__PURE__ */ y.createElement(h4, { markdownContext: t }, n));
}
function pk({
  children: e,
  markdownContext: t
}) {
  return /* @__PURE__ */ y.createElement(h4, { style: t.pdfStyles.codeHighlight, markdownContext: t }, e ?? "");
}
const mk = {
  math: oT,
  katex: oT,
  latex: oT
};
function vk({
  children: e,
  className: t,
  markdownContext: r
}) {
  const {
    View: n
  } = r.ReactPdf;
  let i = t, o = e;
  const a = (t == null ? void 0 : t.startsWith("lang-")) || !1;
  if (!i && typeof e == "string" && e.startsWith("lang-")) {
    const Q = e.match(/^lang-[^\s]*\s/);
    Q != null && Q.length && (i = Q[0].slice(0, Q[0].length - 1), o = e.slice(i.length + 1, e.length));
  }
  const T = i == null ? void 0 : i.replace("lang-", ""), s = mk[T] ?? pk;
  return a ? /* @__PURE__ */ y.createElement(n, null, /* @__PURE__ */ y.createElement(s, { markdownContext: r }, o)) : /* @__PURE__ */ y.createElement(s, { markdownContext: r }, o);
}
function Lk({
  children: e,
  markdownContext: t
}) {
  return /* @__PURE__ */ y.createElement(h4, { markdownContext: t }, e);
}
const Hd = 10;
function yk({
  markdown: e,
  ReactPdf: t,
  color: r,
  overrides: n
}) {
  const [i, o] = m3(() => {
    const Q = {};
    return r && (Q.color = r), [t.StyleSheet.create({
      section: {
        ...Q,
        margin: 10,
        padding: 10,
        flexGrow: 1
      },
      link: {
        ...Q,
        color: "rgb(69, 88, 222)"
      },
      list: {
        ...Q,
        marginLeft: "5%",
        marginBottom: `${Hd}pt`
      },
      listItem: {
        ...Q,
        flexDirection: "row"
      },
      italics: {
        ...Q,
        fontStyle: "italic"
      },
      bold: {
        ...Q,
        fontWeight: "bold"
      },
      paragraph: {
        ...Q,
        marginBottom: `${Hd}pt`
      },
      imageWrapper: {
        ...Q,
        maxWidth: "25vw",
        maxHeight: "25vh"
      },
      strikeThrough: {
        textDecoration: "line-through"
      },
      underline: {
        textDecoration: "underline"
      },
      image: {
        ...Q,
        objectFit: "contain"
      },
      codeHighlight: {
        ...Q,
        color: b4.primary
      },
      h1: {
        ...Q,
        fontWeight: "bold",
        fontSize: "36px"
      },
      h2: {
        ...Q,
        fontWeight: "bold",
        fontSize: "24px"
      },
      h3: {
        ...Q,
        fontWeight: "bold",
        fontSize: "20px"
      },
      h4: {
        ...Q,
        fontWeight: "bold",
        fontSize: "16px"
      },
      h5: {
        ...Q,
        fontSize: "16px"
      },
      h6: {
        ...Q,
        fontSize: "14px"
      }
    }), Q];
  }, [t, r]), [a, T] = m3(() => {
    const Q = {
      ReactPdf: t,
      pdfStyles: i,
      styleOverrides: o
    }, u = {
      p: {
        component: Yp,
        props: {
          style: i.paragraph,
          markdownContext: Q
        }
      },
      span: {
        component: h4,
        props: {
          markdownContext: Q
        }
      },
      em: {
        // italics
        component: h4,
        props: {
          style: i.italics,
          markdownContext: Q
        }
      },
      strong: {
        // bold
        component: h4,
        props: {
          style: i.bold,
          markdownContext: Q
        }
      },
      link: {
        component: h4,
        props: {
          markdownContext: Q
        }
      },
      img: {
        component: ck,
        props: {
          markdownContext: Q
        }
      },
      ul: {
        component: ns,
        props: {
          type: ts.UNORDERED,
          markdownContext: Q
        }
      },
      ol: {
        component: ns,
        props: {
          type: ts.ORDERED,
          markdownContext: Q
        }
      },
      li: {
        component: uk,
        props: {
          markdownContext: Q
        }
      },
      code: {
        component: vk,
        props: {
          markdownContext: Q
        }
      },
      pre: {
        component: h4,
        props: {
          markdownContext: Q
        }
      },
      del: {
        component: h4,
        props: {
          style: i.strikeThrough,
          markdownContext: Q
        }
      },
      u: {
        component: h4,
        props: {
          style: i.underline,
          markdownContext: Q
        }
      },
      div: {
        component: t.View
      },
      h1: {
        component: Ie,
        props: {
          style: i.h1,
          markdownContext: Q
        }
      },
      h2: {
        component: Ie,
        props: {
          style: i.h2,
          markdownContext: Q
        }
      },
      h3: {
        component: Ie,
        props: {
          style: i.h3,
          markdownContext: Q
        }
      },
      h4: {
        component: Ie,
        props: {
          style: i.h4,
          markdownContext: Q
        }
      },
      h5: {
        component: Ie,
        props: {
          style: i.h5,
          markdownContext: Q
        }
      },
      h6: {
        component: Ie,
        props: {
          style: i.h6,
          markdownContext: Q
        }
      }
    };
    return n && Object.keys(n).forEach((l) => {
      u[l] = {
        // @ts-expect-error TS2322 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        component: n[l],
        props: {
          markdownContext: Q
        }
      };
    }), [new Proxy({}, {
      get: function(l, c) {
        return u[c] || {
          component: Lk,
          props: {
            name: c,
            markdownContext: Q
          }
        };
      }
    }), Q];
  }, [t, i, o, n]), s = m3(() => function({
    children: u
  }) {
    return /* @__PURE__ */ y.createElement(hk, { markdownContext: T }, u);
  }, [T]);
  return m3(() => ok(e, {
    overrides: a,
    wrapper: s
  }), [e, a, s]);
}
function la({
  children: e,
  ReactPdf: t,
  pdfStyles: r,
  interpretAsMarkdown: n,
  color: i,
  overrides: o
}) {
  const a = ep(e);
  return n === !0 || a != null && n !== !1 ? /* @__PURE__ */ y.createElement(yk, { markdown: a ?? e, ReactPdf: t, pdfStyles: r, color: i, overrides: o }) : /* @__PURE__ */ y.createElement(t.Text, null, e);
}
const gk = {
  [F1.MULTIPLE_CHOICE]: Ed,
  [F1.MULTIPLE_SELECT]: Ed,
  [F1.FREE_RESPONSE]: Hk,
  [F1.CLOZE_DROPDOWN]: Ek,
  [F1.IMAGE_LABELING]: bk,
  // TODO: add close reading question support to PDFs
  [F1.CLOSE_READING]: (e) => {
    const t = e.ReactPdf.Text;
    return /* @__PURE__ */ y.createElement(t, null, "Close reading questions are not supported in pdfs.");
  }
};
function xk(e) {
  const t = gk[e.question.type];
  if (!t)
    throw new Error("Invalid question provided");
  const r = (() => {
    const n = Array.isArray(e.style) ? e.style : [e.style || {}];
    let i;
    for (const o of n)
      o.fontSize && (i = o.fontSize);
    return i;
  })();
  return /* @__PURE__ */ y.createElement(t, { ...e, pdfStyles: e.pdfStyles || Op(e.ReactPdf.StyleSheet, {
    fontSize: r
  }) });
}
function Pk({
  questions: e,
  anchorPrefix: t = "pdf-question",
  ReactPdf: r,
  questionPrefix: n
}) {
  const i = Op(r.StyleSheet);
  return /* @__PURE__ */ y.createElement(r.View, { style: i.grid }, e.map((o, a) => /* @__PURE__ */ y.createElement(xk, { ReactPdf: r, pdfStyles: i, id: `${t}${a}`, question: o, key: String(o._id), questionPrefix: n ? n + (a + 1) : void 0, style: [
    // @ts-expect-error TS2322 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
    a % 2 === 0 ? i.gridColumn1 : i.gridColumn2,
    {
      padding: "8 16",
      border: `3 solid ${b4.primaryDark}`,
      borderRadius: "8"
    }
  ] })));
}
function ua({
  ReactPdf: e,
  pdfStyles: t,
  questionPrefix: r,
  children: n,
  imageUrl: i,
  ...o
}) {
  const a = t.textSize.fontSize;
  return /* @__PURE__ */ y.createElement(e.View, { ...o, wrap: !1 }, /* @__PURE__ */ y.createElement(e.View, { style: {
    marginBottom: n ? typeof a == "number" ? a * 0.75 : 8 : 0
  } }, /* @__PURE__ */ y.createElement(e.View, { style: [t.textSize] }, "formattedPrompt" in o ? o.formattedPrompt : /* @__PURE__ */ y.createElement(la, { interpretAsMarkdown: !0, ReactPdf: e, pdfStyles: t }, tm(o.prompt, r))), i && /* @__PURE__ */ y.createElement(e.Image, { src: i, style: t.image })), n);
}
function Hk(e) {
  var n;
  const {
    question: t
  } = e;
  if (t.type !== F1.FREE_RESPONSE)
    return null;
  const r = (n = t.media) != null && n.length ? t.media[0].url : null;
  return /* @__PURE__ */ y.createElement(ua, { ...e, prompt: t.phrase, imageUrl: r });
}
function Ed(e) {
  var o;
  const {
    question: t,
    ReactPdf: r,
    pdfStyles: n
  } = e;
  if (t.type !== F1.MULTIPLE_CHOICE && t.type !== F1.MULTIPLE_SELECT)
    return null;
  const i = (o = t.media) != null && o.length ? t.media[0].url : null;
  return /* @__PURE__ */ y.createElement(ua, { ...e, prompt: t.phrase, imageUrl: i }, t.choices.map((a, T) => {
    var s, Q, u;
    return /* @__PURE__ */ y.createElement(nm, { key: String(a._id), pdfStyles: n, ReactPdf: r, answer: a.text, isCorrect: a.answer, image: (s = a.media) != null && s.length ? (u = (Q = a.media) == null ? void 0 : Q[0]) == null ? void 0 : u.url : null, index: T });
  }));
}
function Ek(e) {
  var u;
  const {
    question: t,
    ReactPdf: r,
    pdfStyles: n,
    questionPrefix: i
  } = e;
  if (t.type !== F1.CLOZE_DROPDOWN)
    return null;
  const o = `\\markdown ${tm(t.template, i)}`, a = hl(o);
  function T({
    dropdownId: l
  }) {
    return /* @__PURE__ */ y.createElement(r.Text, { style: [n.tag, {
      backgroundColor: b4.primary
    }] }, " ", l, " ");
  }
  const s = (u = t.media) != null && u.length ? t.media[0].url : null, Q = () => {
    if (a != null) {
      const l = {};
      return $s(o).forEach((c) => {
        l[c] = T({
          dropdownId: c
        });
      }), /* @__PURE__ */ y.createElement(dl, { state: {
        dropDowns: l
      } }, /* @__PURE__ */ y.createElement(r.Text, { style: {
        lineHeight: 1.3
      } }, /* @__PURE__ */ y.createElement(la, { interpretAsMarkdown: !0, pdfStyles: n, ReactPdf: r, overrides: dA }, a)));
    }
    return /* @__PURE__ */ y.createElement(r.Text, null, w4(o).map((l, c) => l.type === j2.Input ? /* @__PURE__ */ y.createElement(r.Text, { key: `${c}`, style: n.tagWrapper }, T({
      dropdownId: l.inputId
    })) : l.type === j2.Text ? /* @__PURE__ */ y.createElement(r.Text, { key: `${c}` }, l.text) : null));
  };
  return /* @__PURE__ */ y.createElement(ua, { ...e, formattedPrompt: Q(), imageUrl: s }, /* @__PURE__ */ y.createElement(rm, { pdfStyles: n, ReactPdf: r, dropdowns: t.dropdowns }));
}
function bk(e) {
  var a;
  const {
    question: t,
    ReactPdf: r,
    pdfStyles: n
  } = e;
  if (t.type !== F1.IMAGE_LABELING)
    return null;
  const i = (a = t.media[0]) == null ? void 0 : a.url, o = Math.floor(0.038 * t.imageProperties.width);
  return /* @__PURE__ */ y.createElement(ua, { ...e, prompt: t.phrase }, /* @__PURE__ */ y.createElement(r.View, { style: {
    textAlign: "center",
    paddingBottom: 8
  } }, /* @__PURE__ */ y.createElement(r.Svg, { viewBox: `0 0 ${t.imageProperties.width} ${t.imageProperties.height}` }, /* @__PURE__ */ y.createElement(r.Image, { src: i, x: 0, y: 0, style: {
    width: t.imageProperties.width,
    height: t.imageProperties.height
  } }), t.dropdowns.map((T, s) => {
    const Q = T.x, u = T.y, l = String(s + 1);
    return /* @__PURE__ */ y.createElement(a2, { key: `item-${s}` }, /* @__PURE__ */ y.createElement(r.Circle, { cx: Q, cy: u, r: o, fill: b4.primary, strokeWidth: 1, stroke: b4._cloudBlue }), /* @__PURE__ */ y.createElement(r.Text, { x: Q, y: u + Math.floor(0.01 * t.imageProperties.width), style: {
      fontSize: o + 1
    }, fill: b4._cloudBlue, strokeWidth: 1, textAnchor: "middle" }, l));
  }))), /* @__PURE__ */ y.createElement(rm, { pdfStyles: n, ReactPdf: r, dropdowns: t.dropdowns }));
}
function tm(e, t) {
  return (t ? `**${t}:** ` : "") + (Zo(e) ?? Kh(e));
}
function rm({
  ReactPdf: e,
  pdfStyles: t,
  dropdowns: r
}) {
  return /* @__PURE__ */ y.createElement(e.View, { style: t.grid }, r.map((n, i) => /* @__PURE__ */ y.createElement(e.View, { key: `${i}-dropdown`, style: [t.bordered, i % 2 === 0 ? t.gridColumn1 : t.gridColumn2, t.tr, t.roundedSm, {
    width: "47%",
    marginBottom: 15
  }] }, /* @__PURE__ */ y.createElement(e.View, { style: [t.tagWrapper, {
    marginLeft: -7,
    marginTop: -6
  }] }, /* @__PURE__ */ y.createElement(e.Text, { style: t.tag }, i + 1)), /* @__PURE__ */ y.createElement(e.View, { style: {
    padding: "8 2",
    flex: 1
  } }, n.choices.map((o, a) => /* @__PURE__ */ y.createElement(nm, { pdfStyles: t, ReactPdf: e, key: String(o._id), answer: o.text, isCorrect: o.answer, index: a }))))));
}
const bd = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
function nm({
  pdfStyles: e,
  ReactPdf: t,
  answer: r,
  image: n,
  isCorrect: i,
  index: o
}) {
  const a = {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    lineHeight: 1.3
  };
  return i && (a.color = b4.success), /* @__PURE__ */ y.createElement(t.View, null, /* @__PURE__ */ y.createElement(t.View, { style: [a, e.textSize] }, /* @__PURE__ */ y.createElement(la, { ReactPdf: t, pdfStyles: e, interpretAsMarkdown: !0, color: a.color }, `**${bd[o % bd.length]} -** ${Zo(r) ?? Kh(r)} ${i ? "(Correct)" : ""}`)), n && /* @__PURE__ */ y.createElement(t.Image, { src: n, style: e.image }));
}
function Bk() {
  const [e, t] = W1(!1), [r, n] = W1(null);
  return G3(() => {
    if (typeof window > "u" || typeof document > "u")
      throw new Error("Unsupported: You will need to add support for mathJax in markdown if you are rendering on a server");
    window.MathJaxLoadingPromise || (window.MathJaxLoadingPromise = new Promise((i, o) => {
      window.MathJax = {
        jax: [
          // allow converting MathJax to svg
          "input/TeX",
          "output/SVG"
        ],
        extensions: [
          // allow converting from latex to MathJax (which in turn allows converting to svg)
          "tex2jax.js",
          // dependencies of `tex2jax`
          "MathMenu.js",
          "MathZoom.js"
        ],
        // specific to MathJax, since we are going from latex we can turn this off
        showMathMenu: !1,
        // we do not need to see these updates
        showProcessingMessages: !1,
        // we are not getting any messages so there is no need to style
        messageStyle: "none",
        SVG: {
          // setting to `true` broke how conversion to svg works
          useGlobalCache: !1
        },
        TeX: {
          extensions: [
            // handles formatting of math
            "AMSmath.js",
            // adds support for math symbols
            "AMSsymbols.js",
            // helps with loading the extensions
            "autoload-all.js"
          ],
          packages: {
            "[+]": ["mhchem"]
          }
        },
        loader: {
          load: ["[tex]/mhchem"]
        },
        startup: {
          ready: () => {
            if (window.MathJax.startup.defaultReady && window.MathJax.startup.defaultReady(), !window.MathJax.startup.promise)
              return o(new Error("MathJax did not spawn a startup promise"));
            window.MathJax.startup.promise.then(i).catch(o);
          }
        }
      };
      const a = document.createElement("script");
      a.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js", a.async = !0, a.onerror = (T) => {
        o(T);
      }, document.head.appendChild(a);
    })), window.MathJaxLoadingPromise.then(() => {
      t(!0), n(null);
    }).catch((i) => {
      console.error("Error loading mathJax library", i), n(new Error("Error Loading MathJax To SVG Script"));
    });
  }, []), {
    loaded: e,
    error: r
  };
}
function Fk({
  questions: e,
  studentAnswerLookup: t,
  nameLookup: r,
  anchorPrefix: n,
  ReactPdf: i,
  header: o,
  questionPrefix: a
}) {
  const T = i.StyleSheet, s = m3(() => T.create({
    pageH5: {
      marginTop: 0,
      marginBottom: 16
      // fontWeight: 'bold',
    },
    grid: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      fontSize: "8pt"
    },
    bordered: {
      border: `1pt solid ${b4.neutral}`
    },
    gridColumn: {
      marginRight: 8,
      marginBottom: 8,
      width: "48%",
      boxSizing: "border-box"
    },
    wrapper: {
      fontFamily: "default"
    }
  }), [T]);
  return /* @__PURE__ */ y.createElement(i.View, { style: s.wrapper }, /* @__PURE__ */ y.createElement(i.Text, { style: [s.pageH5] }, o), Object.keys(t).map((Q) => {
    const u = t[Q];
    return u ? /* @__PURE__ */ y.createElement(i.View, { key: Q, wrap: !1 }, /* @__PURE__ */ y.createElement(i.Text, { style: {
      margin: "8px 0"
    } }, r[Q]), /* @__PURE__ */ y.createElement(i.View, { style: s.grid }, e.map((l, c) => {
      const f = u[String(l._id)];
      return !f || !l ? null : f.map((d, m) => {
        const p = Mk(d.answer, l, i), v = wk(l.type);
        return !p || !v ? null : /* @__PURE__ */ y.createElement(i.View, { key: `questionKey-${String(m)}`, style: [s.bordered, s.gridColumn, {
          display: "flex",
          flexDirection: "row"
        }] }, /* @__PURE__ */ y.createElement(i.View, { style: {
          padding: "8px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        } }, /* @__PURE__ */ y.createElement(Sk, { score: d.score, ReactPdf: i })), /* @__PURE__ */ y.createElement(i.View, { style: {
          height: "100%",
          borderRight: "1pt solid #cbcbcb"
        } }), /* @__PURE__ */ y.createElement(i.View, { style: {
          flex: 1,
          display: "flex",
          flexDirection: "row",
          padding: "8px",
          alignItems: "flex-start"
        } }, /* @__PURE__ */ y.createElement(i.View, { style: {
          marginRight: "8px",
          width: 72
        } }, /* @__PURE__ */ y.createElement(i.Text, null, /* @__PURE__ */ y.createElement(i.Link, { style: {
          color: b4.primary
        }, src: `#${n}${m}` }, a, c + 1), f.length > 1 ? /* @__PURE__ */ y.createElement(i.Text, null, " ", "Attempt ", m + 1) : null), /* @__PURE__ */ y.createElement(i.Text, null, v)), /* @__PURE__ */ y.createElement(i.Text, { style: {
          flex: 1,
          flexDirection: "row"
        } }, p)));
      });
    }))) : null;
  }));
}
function Mk(e, t, r) {
  switch (e.type) {
    case F1.CLOZE_DROPDOWN:
      return t.type !== F1.CLOZE_DROPDOWN ? null : Md((i) => Gn({
        choices: i.choices,
        // @ts-expect-error TS2322 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        chosenId: e.value[i.templateResponseKey],
        useAlphabetLetter: !1,
        showCorrect: !0,
        ReactPdf: r
      }), t.dropdowns, r);
    case F1.IMAGE_LABELING:
      return t.type !== F1.IMAGE_LABELING ? null : Md((i) => {
        const o = e.value[v3(i)];
        return Gn({
          choices: i.choices,
          // @ts-expect-error TS2322 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          chosenId: o,
          useAlphabetLetter: !1,
          showCorrect: !0,
          ReactPdf: r
        });
      }, t.dropdowns, r);
    case F1.MULTIPLE_CHOICE:
      return t.type !== F1.MULTIPLE_CHOICE ? null : Gn({
        choices: t.choices,
        chosenId: e.value,
        ReactPdf: r
      });
    case F1.MULTIPLE_SELECT:
      return t.type !== F1.MULTIPLE_SELECT ? null : e.value.map((n, i) => /* @__PURE__ */ y.createElement(r.Text, { key: n }, Gn({
        choices: t.choices,
        chosenId: n,
        ReactPdf: r
      }), i + 1 === e.value.length ? "" : `
`));
    case F1.FREE_RESPONSE:
      return /* @__PURE__ */ y.createElement(r.Text, { style: {
        fontStyle: "italic"
      } }, e.value);
    default:
      return null;
  }
}
function wk(e) {
  switch (e) {
    case F1.CLOZE_DROPDOWN:
      return "Cloze Dropdown";
    case F1.IMAGE_LABELING:
      return "Image Labeling";
    case F1.MULTIPLE_CHOICE:
      return "Multiple Choice";
    case F1.MULTIPLE_SELECT:
      return "Multiple Select";
    case F1.FREE_RESPONSE:
      return "Free Response";
    default:
      return null;
  }
}
function Sk({
  score: e,
  ReactPdf: t
}) {
  return e && e.score === e.perfectScore ? /* @__PURE__ */ y.createElement(t.View, { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  } }, /* @__PURE__ */ y.createElement(t.Image, { src: "https://resources-cdn.mission.io/public/pdf-resources/images/checkmark.png", style: {
    height: "8pt",
    width: "8pt"
  } })) : e && e.score !== null && e.score < e.perfectScore ? /* @__PURE__ */ y.createElement(t.Text, null, /* @__PURE__ */ y.createElement(t.Text, { style: {
    color: "red",
    fontSize: "10pt",
    fontWeight: "bold"
  } }, "X")) : /* @__PURE__ */ y.createElement(t.Text, null, /* @__PURE__ */ y.createElement(t.Text, { style: {
    fontSize: "10pt",
    fontWeight: "bold",
    color: "black"
  } }, "?"));
}
const Gn = ({
  choices: e,
  chosenId: t,
  ReactPdf: r,
  useAlphabetLetter: n = !0,
  showCorrect: i = !1
}) => {
  const o = e.findIndex(({
    _id: a
  }) => String(a) === t);
  return o < 0 ? null : /* @__PURE__ */ y.createElement(r.Text, { key: t }, n && /* @__PURE__ */ y.createElement(r.Text, { style: {
    fontWeight: "bold"
  } }, ot(o), ") "), /* @__PURE__ */ y.createElement(la, { ReactPdf: r, pdfStyles: {} }, e[o].text), i && /* @__PURE__ */ y.createElement(y.Fragment, null, " ", e[o].answer ? /* @__PURE__ */ y.createElement(r.Image, { src: "https://resources-cdn.mission.io/public/pdf-resources/images/checkmark.png" }) : /* @__PURE__ */ y.createElement(r.Text, { style: {
    color: "red",
    fontWeight: "bold"
  } }, "X")));
};
function Md(e, t, r) {
  return t.map((n, i) => {
    const o = e(n);
    return /* @__PURE__ */ y.createElement(r.Text, { key: `dropdown-${i}` }, i + 1, ".", " ", o || /* @__PURE__ */ y.createElement(r.Text, { style: {
      fontStyle: "italic"
    } }, "No Answer"), i + 1 === t.length ? "" : `
`);
  });
}
export {
  Be as ANNOTATION_INFORMATION_METHODS,
  GV as CLOSE_ANNOTATION_ERROR_MESSAGE_TYPES,
  Ik as DashboardMarkdown,
  Rk as EditQuestions,
  r_ as JrControlsMarkdown,
  O2 as OptionalMarkdown,
  xk as PdfQuestion,
  Pk as PdfQuestionGrid,
  Fk as PdfStudentResponses,
  jA as Question,
  Nk as QuestionSlot,
  zV as StudentAnnotatableMarkdown,
  kk as TargetAnnotationCreator,
  Dk as convertToMarkdownString,
  jA as default,
  Zo as getMarkdownString,
  Bk as useLoadPdfDependencies
};
//# sourceMappingURL=index.js.map
